var DC = Object.defineProperty;
var MC = (e, n, t) => n in e ? DC(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var m = (e, n, t) => MC(e, typeof n != "symbol" ? n + "" : n, t);
import * as qt from "react";
import Hi, { memo as BC, forwardRef as Cf, useRef as O_, useEffect as N_, useContext as FC } from "react";
var cl = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function kf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function R_(e) {
  if (e.__esModule) return e;
  var n = e.default;
  if (typeof n == "function") {
    var t = function i() {
      return this instanceof i ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments);
    };
    t.prototype = n.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(e).forEach(function(i) {
    var r = Object.getOwnPropertyDescriptor(e, i);
    Object.defineProperty(t, i, r.get ? r : {
      enumerable: !0,
      get: function() {
        return e[i];
      }
    });
  }), t;
}
var dh = { exports: {} }, Io = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var p0;
function UC() {
  if (p0) return Io;
  p0 = 1;
  var e = Hi, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, u, l) {
    var c, d = {}, p = null, g = null;
    l !== void 0 && (p = "" + l), u.key !== void 0 && (p = "" + u.key), u.ref !== void 0 && (g = u.ref);
    for (c in u) i.call(u, c) && !s.hasOwnProperty(c) && (d[c] = u[c]);
    if (a && a.defaultProps) for (c in u = a.defaultProps, u) d[c] === void 0 && (d[c] = u[c]);
    return { $$typeof: n, type: a, key: p, ref: g, props: d, _owner: r.current };
  }
  return Io.Fragment = t, Io.jsx = o, Io.jsxs = o, Io;
}
var xo = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g0;
function HC() {
  return g0 || (g0 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Hi, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), b = Symbol.iterator, _ = "@@iterator";
    function k(P) {
      if (P === null || typeof P != "object")
        return null;
      var Q = b && P[b] || P[_];
      return typeof Q == "function" ? Q : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function D(P) {
      {
        for (var Q = arguments.length, oe = new Array(Q > 1 ? Q - 1 : 0), _e = 1; _e < Q; _e++)
          oe[_e - 1] = arguments[_e];
        M("error", P, oe);
      }
    }
    function M(P, Q, oe) {
      {
        var _e = C.ReactDebugCurrentFrame, Ye = _e.getStackAddendum();
        Ye !== "" && (Q += "%s", oe = oe.concat([Ye]));
        var Ze = oe.map(function(Be) {
          return String(Be);
        });
        Ze.unshift("Warning: " + Q), Function.prototype.apply.call(console[P], console, Ze);
      }
    }
    var j = !1, F = !1, O = !1, V = !1, ie = !1, W;
    W = Symbol.for("react.module.reference");
    function N(P) {
      return !!(typeof P == "string" || typeof P == "function" || P === i || P === s || ie || P === r || P === l || P === c || V || P === g || j || F || O || typeof P == "object" && P !== null && (P.$$typeof === p || P.$$typeof === d || P.$$typeof === o || P.$$typeof === a || P.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      P.$$typeof === W || P.getModuleId !== void 0));
    }
    function Z(P, Q, oe) {
      var _e = P.displayName;
      if (_e)
        return _e;
      var Ye = Q.displayName || Q.name || "";
      return Ye !== "" ? oe + "(" + Ye + ")" : oe;
    }
    function ee(P) {
      return P.displayName || "Context";
    }
    function Ae(P) {
      if (P == null)
        return null;
      if (typeof P.tag == "number" && D("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof P == "function")
        return P.displayName || P.name || null;
      if (typeof P == "string")
        return P;
      switch (P) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case s:
          return "Profiler";
        case r:
          return "StrictMode";
        case l:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof P == "object")
        switch (P.$$typeof) {
          case a:
            var Q = P;
            return ee(Q) + ".Consumer";
          case o:
            var oe = P;
            return ee(oe._context) + ".Provider";
          case u:
            return Z(P, P.render, "ForwardRef");
          case d:
            var _e = P.displayName || null;
            return _e !== null ? _e : Ae(P.type) || "Memo";
          case p: {
            var Ye = P, Ze = Ye._payload, Be = Ye._init;
            try {
              return Ae(Be(Ze));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Ie = Object.assign, we = 0, ze, Qe, Nt, jt, y, re, pe;
    function S() {
    }
    S.__reactDisabledLog = !0;
    function de() {
      {
        if (we === 0) {
          ze = console.log, Qe = console.info, Nt = console.warn, jt = console.error, y = console.group, re = console.groupCollapsed, pe = console.groupEnd;
          var P = {
            configurable: !0,
            enumerable: !0,
            value: S,
            writable: !0
          };
          Object.defineProperties(console, {
            info: P,
            log: P,
            warn: P,
            error: P,
            group: P,
            groupCollapsed: P,
            groupEnd: P
          });
        }
        we++;
      }
    }
    function Ce() {
      {
        if (we--, we === 0) {
          var P = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Ie({}, P, {
              value: ze
            }),
            info: Ie({}, P, {
              value: Qe
            }),
            warn: Ie({}, P, {
              value: Nt
            }),
            error: Ie({}, P, {
              value: jt
            }),
            group: Ie({}, P, {
              value: y
            }),
            groupCollapsed: Ie({}, P, {
              value: re
            }),
            groupEnd: Ie({}, P, {
              value: pe
            })
          });
        }
        we < 0 && D("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var le = C.ReactCurrentDispatcher, ge;
    function be(P, Q, oe) {
      {
        if (ge === void 0)
          try {
            throw Error();
          } catch (Ye) {
            var _e = Ye.stack.trim().match(/\n( *(at )?)/);
            ge = _e && _e[1] || "";
          }
        return `
` + ge + P;
      }
    }
    var ve = !1, Te;
    {
      var Tt = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new Tt();
    }
    function se(P, Q) {
      if (!P || ve)
        return "";
      {
        var oe = Te.get(P);
        if (oe !== void 0)
          return oe;
      }
      var _e;
      ve = !0;
      var Ye = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ze;
      Ze = le.current, le.current = null, de();
      try {
        if (Q) {
          var Be = function() {
            throw Error();
          };
          if (Object.defineProperty(Be.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Be, []);
            } catch (cn) {
              _e = cn;
            }
            Reflect.construct(P, [], Be);
          } else {
            try {
              Be.call();
            } catch (cn) {
              _e = cn;
            }
            P.call(Be.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (cn) {
            _e = cn;
          }
          P();
        }
      } catch (cn) {
        if (cn && _e && typeof cn.stack == "string") {
          for (var Me = cn.stack.split(`
`), nn = _e.stack.split(`
`), yt = Me.length - 1, St = nn.length - 1; yt >= 1 && St >= 0 && Me[yt] !== nn[St]; )
            St--;
          for (; yt >= 1 && St >= 0; yt--, St--)
            if (Me[yt] !== nn[St]) {
              if (yt !== 1 || St !== 1)
                do
                  if (yt--, St--, St < 0 || Me[yt] !== nn[St]) {
                    var Mn = `
` + Me[yt].replace(" at new ", " at ");
                    return P.displayName && Mn.includes("<anonymous>") && (Mn = Mn.replace("<anonymous>", P.displayName)), typeof P == "function" && Te.set(P, Mn), Mn;
                  }
                while (yt >= 1 && St >= 0);
              break;
            }
        }
      } finally {
        ve = !1, le.current = Ze, Ce(), Error.prepareStackTrace = Ye;
      }
      var Ts = P ? P.displayName || P.name : "", Dr = Ts ? be(Ts) : "";
      return typeof P == "function" && Te.set(P, Dr), Dr;
    }
    function ln(P, Q, oe) {
      return se(P, !1);
    }
    function er(P) {
      var Q = P.prototype;
      return !!(Q && Q.isReactComponent);
    }
    function fi(P, Q, oe) {
      if (P == null)
        return "";
      if (typeof P == "function")
        return se(P, er(P));
      if (typeof P == "string")
        return be(P);
      switch (P) {
        case l:
          return be("Suspense");
        case c:
          return be("SuspenseList");
      }
      if (typeof P == "object")
        switch (P.$$typeof) {
          case u:
            return ln(P.render);
          case d:
            return fi(P.type, Q, oe);
          case p: {
            var _e = P, Ye = _e._payload, Ze = _e._init;
            try {
              return fi(Ze(Ye), Q, oe);
            } catch {
            }
          }
        }
      return "";
    }
    var tr = Object.prototype.hasOwnProperty, ko = {}, Tu = C.ReactDebugCurrentFrame;
    function Nr(P) {
      if (P) {
        var Q = P._owner, oe = fi(P.type, P._source, Q ? Q.type : null);
        Tu.setExtraStackFrame(oe);
      } else
        Tu.setExtraStackFrame(null);
    }
    function yu(P, Q, oe, _e, Ye) {
      {
        var Ze = Function.call.bind(tr);
        for (var Be in P)
          if (Ze(P, Be)) {
            var Me = void 0;
            try {
              if (typeof P[Be] != "function") {
                var nn = Error((_e || "React class") + ": " + oe + " type `" + Be + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof P[Be] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw nn.name = "Invariant Violation", nn;
              }
              Me = P[Be](Q, Be, _e, oe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (yt) {
              Me = yt;
            }
            Me && !(Me instanceof Error) && (Nr(Ye), D("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", _e || "React class", oe, Be, typeof Me), Nr(null)), Me instanceof Error && !(Me.message in ko) && (ko[Me.message] = !0, Nr(Ye), D("Failed %s type: %s", oe, Me.message), Nr(null));
          }
      }
    }
    var zc = Array.isArray;
    function So(P) {
      return zc(P);
    }
    function qc(P) {
      {
        var Q = typeof Symbol == "function" && Symbol.toStringTag, oe = Q && P[Symbol.toStringTag] || P.constructor.name || "Object";
        return oe;
      }
    }
    function Yc(P) {
      try {
        return wu(P), !1;
      } catch {
        return !0;
      }
    }
    function wu(P) {
      return "" + P;
    }
    function $(P) {
      if (Yc(P))
        return D("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", qc(P)), wu(P);
    }
    var te = C.ReactCurrentOwner, Ee = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Pe, qe;
    function Tn(P) {
      if (tr.call(P, "ref")) {
        var Q = Object.getOwnPropertyDescriptor(P, "ref").get;
        if (Q && Q.isReactWarning)
          return !1;
      }
      return P.ref !== void 0;
    }
    function Pi(P) {
      if (tr.call(P, "key")) {
        var Q = Object.getOwnPropertyDescriptor(P, "key").get;
        if (Q && Q.isReactWarning)
          return !1;
      }
      return P.key !== void 0;
    }
    function Qn(P, Q) {
      typeof P.ref == "string" && te.current;
    }
    function Rr(P, Q) {
      {
        var oe = function() {
          Pe || (Pe = !0, D("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Q));
        };
        oe.isReactWarning = !0, Object.defineProperty(P, "key", {
          get: oe,
          configurable: !0
        });
      }
    }
    function Lr(P, Q) {
      {
        var oe = function() {
          qe || (qe = !0, D("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Q));
        };
        oe.isReactWarning = !0, Object.defineProperty(P, "ref", {
          get: oe,
          configurable: !0
        });
      }
    }
    var tn = function(P, Q, oe, _e, Ye, Ze, Be) {
      var Me = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: P,
        key: Q,
        ref: oe,
        props: Be,
        // Record the component responsible for creating this element.
        _owner: Ze
      };
      return Me._store = {}, Object.defineProperty(Me._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Me, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: _e
      }), Object.defineProperty(Me, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ye
      }), Object.freeze && (Object.freeze(Me.props), Object.freeze(Me)), Me;
    };
    function nr(P, Q, oe, _e, Ye) {
      {
        var Ze, Be = {}, Me = null, nn = null;
        oe !== void 0 && ($(oe), Me = "" + oe), Pi(Q) && ($(Q.key), Me = "" + Q.key), Tn(Q) && (nn = Q.ref, Qn(Q, Ye));
        for (Ze in Q)
          tr.call(Q, Ze) && !Ee.hasOwnProperty(Ze) && (Be[Ze] = Q[Ze]);
        if (P && P.defaultProps) {
          var yt = P.defaultProps;
          for (Ze in yt)
            Be[Ze] === void 0 && (Be[Ze] = yt[Ze]);
        }
        if (Me || nn) {
          var St = typeof P == "function" ? P.displayName || P.name || "Unknown" : P;
          Me && Rr(Be, St), nn && Lr(Be, St);
        }
        return tn(P, Me, nn, Ye, _e, te.current, Be);
      }
    }
    var yn = C.ReactCurrentOwner, u0 = C.ReactDebugCurrentFrame;
    function Es(P) {
      if (P) {
        var Q = P._owner, oe = fi(P.type, P._source, Q ? Q.type : null);
        u0.setExtraStackFrame(oe);
      } else
        u0.setExtraStackFrame(null);
    }
    var jc;
    jc = !1;
    function Kc(P) {
      return typeof P == "object" && P !== null && P.$$typeof === n;
    }
    function l0() {
      {
        if (yn.current) {
          var P = Ae(yn.current.type);
          if (P)
            return `

Check the render method of \`` + P + "`.";
        }
        return "";
      }
    }
    function kC(P) {
      return "";
    }
    var c0 = {};
    function SC(P) {
      {
        var Q = l0();
        if (!Q) {
          var oe = typeof P == "string" ? P : P.displayName || P.name;
          oe && (Q = `

Check the top-level render call using <` + oe + ">.");
        }
        return Q;
      }
    }
    function d0(P, Q) {
      {
        if (!P._store || P._store.validated || P.key != null)
          return;
        P._store.validated = !0;
        var oe = SC(Q);
        if (c0[oe])
          return;
        c0[oe] = !0;
        var _e = "";
        P && P._owner && P._owner !== yn.current && (_e = " It was passed a child from " + Ae(P._owner.type) + "."), Es(P), D('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', oe, _e), Es(null);
      }
    }
    function h0(P, Q) {
      {
        if (typeof P != "object")
          return;
        if (So(P))
          for (var oe = 0; oe < P.length; oe++) {
            var _e = P[oe];
            Kc(_e) && d0(_e, Q);
          }
        else if (Kc(P))
          P._store && (P._store.validated = !0);
        else if (P) {
          var Ye = k(P);
          if (typeof Ye == "function" && Ye !== P.entries)
            for (var Ze = Ye.call(P), Be; !(Be = Ze.next()).done; )
              Kc(Be.value) && d0(Be.value, Q);
        }
      }
    }
    function IC(P) {
      {
        var Q = P.type;
        if (Q == null || typeof Q == "string")
          return;
        var oe;
        if (typeof Q == "function")
          oe = Q.propTypes;
        else if (typeof Q == "object" && (Q.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Q.$$typeof === d))
          oe = Q.propTypes;
        else
          return;
        if (oe) {
          var _e = Ae(Q);
          yu(oe, P.props, "prop", _e, P);
        } else if (Q.PropTypes !== void 0 && !jc) {
          jc = !0;
          var Ye = Ae(Q);
          D("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ye || "Unknown");
        }
        typeof Q.getDefaultProps == "function" && !Q.getDefaultProps.isReactClassApproved && D("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function xC(P) {
      {
        for (var Q = Object.keys(P.props), oe = 0; oe < Q.length; oe++) {
          var _e = Q[oe];
          if (_e !== "children" && _e !== "key") {
            Es(P), D("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", _e), Es(null);
            break;
          }
        }
        P.ref !== null && (Es(P), D("Invalid attribute `ref` supplied to `React.Fragment`."), Es(null));
      }
    }
    var f0 = {};
    function m0(P, Q, oe, _e, Ye, Ze) {
      {
        var Be = N(P);
        if (!Be) {
          var Me = "";
          (P === void 0 || typeof P == "object" && P !== null && Object.keys(P).length === 0) && (Me += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var nn = kC();
          nn ? Me += nn : Me += l0();
          var yt;
          P === null ? yt = "null" : So(P) ? yt = "array" : P !== void 0 && P.$$typeof === n ? (yt = "<" + (Ae(P.type) || "Unknown") + " />", Me = " Did you accidentally export a JSX literal instead of a component?") : yt = typeof P, D("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", yt, Me);
        }
        var St = nr(P, Q, oe, Ye, Ze);
        if (St == null)
          return St;
        if (Be) {
          var Mn = Q.children;
          if (Mn !== void 0)
            if (_e)
              if (So(Mn)) {
                for (var Ts = 0; Ts < Mn.length; Ts++)
                  h0(Mn[Ts], P);
                Object.freeze && Object.freeze(Mn);
              } else
                D("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              h0(Mn, P);
        }
        if (tr.call(Q, "key")) {
          var Dr = Ae(P), cn = Object.keys(Q).filter(function(LC) {
            return LC !== "key";
          }), Gc = cn.length > 0 ? "{key: someKey, " + cn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!f0[Dr + Gc]) {
            var RC = cn.length > 0 ? "{" + cn.join(": ..., ") + ": ...}" : "{}";
            D(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Gc, Dr, RC, Dr), f0[Dr + Gc] = !0;
          }
        }
        return P === i ? xC(St) : IC(St), St;
      }
    }
    function vC(P, Q, oe) {
      return m0(P, Q, oe, !0);
    }
    function PC(P, Q, oe) {
      return m0(P, Q, oe, !1);
    }
    var OC = PC, NC = vC;
    xo.Fragment = i, xo.jsx = OC, xo.jsxs = NC;
  }()), xo;
}
process.env.NODE_ENV === "production" ? dh.exports = UC() : dh.exports = HC();
var Qr = dh.exports, L_ = typeof global == "object" && global && global.Object === Object && global, VC = typeof self == "object" && self && self.Object === Object && self, ai = L_ || VC || Function("return this")(), ki = ai.Symbol, D_ = Object.prototype, $C = D_.hasOwnProperty, WC = D_.toString, vo = ki ? ki.toStringTag : void 0;
function zC(e) {
  var n = $C.call(e, vo), t = e[vo];
  try {
    e[vo] = void 0;
    var i = !0;
  } catch {
  }
  var r = WC.call(e);
  return i && (n ? e[vo] = t : delete e[vo]), r;
}
var qC = Object.prototype, YC = qC.toString;
function jC(e) {
  return YC.call(e);
}
var KC = "[object Null]", GC = "[object Undefined]", b0 = ki ? ki.toStringTag : void 0;
function kr(e) {
  return e == null ? e === void 0 ? GC : KC : b0 && b0 in Object(e) ? zC(e) : jC(e);
}
function Wn(e) {
  return e != null && typeof e == "object";
}
var QC = "[object Symbol]";
function Kl(e) {
  return typeof e == "symbol" || Wn(e) && kr(e) == QC;
}
function XC(e, n) {
  for (var t = -1, i = e == null ? 0 : e.length, r = Array(i); ++t < i; )
    r[t] = n(e[t], t, e);
  return r;
}
var On = Array.isArray, _0 = ki ? ki.prototype : void 0, E0 = _0 ? _0.toString : void 0;
function M_(e) {
  if (typeof e == "string")
    return e;
  if (On(e))
    return XC(e, M_) + "";
  if (Kl(e))
    return E0 ? E0.call(e) : "";
  var n = e + "";
  return n == "0" && 1 / e == -1 / 0 ? "-0" : n;
}
var JC = /\s/;
function ZC(e) {
  for (var n = e.length; n-- && JC.test(e.charAt(n)); )
    ;
  return n;
}
var ek = /^\s+/;
function tk(e) {
  return e && e.slice(0, ZC(e) + 1).replace(ek, "");
}
function ft(e) {
  var n = typeof e;
  return e != null && (n == "object" || n == "function");
}
var T0 = NaN, nk = /^[-+]0x[0-9a-f]+$/i, ik = /^0b[01]+$/i, rk = /^0o[0-7]+$/i, sk = parseInt;
function y0(e) {
  if (typeof e == "number")
    return e;
  if (Kl(e))
    return T0;
  if (ft(e)) {
    var n = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = ft(n) ? n + "" : n;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = tk(e);
  var t = ik.test(e);
  return t || rk.test(e) ? sk(e.slice(2), t ? 2 : 8) : nk.test(e) ? T0 : +e;
}
function Sf(e) {
  return e;
}
var ok = "[object AsyncFunction]", ak = "[object Function]", uk = "[object GeneratorFunction]", lk = "[object Proxy]";
function ts(e) {
  if (!ft(e))
    return !1;
  var n = kr(e);
  return n == ak || n == uk || n == ok || n == lk;
}
var Qc = ai["__core-js_shared__"], w0 = function() {
  var e = /[^.]+$/.exec(Qc && Qc.keys && Qc.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function ck(e) {
  return !!w0 && w0 in e;
}
var dk = Function.prototype, hk = dk.toString;
function os(e) {
  if (e != null) {
    try {
      return hk.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var fk = /[\\^$.*+?()[\]{}|]/g, mk = /^\[object .+?Constructor\]$/, pk = Function.prototype, gk = Object.prototype, bk = pk.toString, _k = gk.hasOwnProperty, Ek = RegExp(
  "^" + bk.call(_k).replace(fk, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Tk(e) {
  if (!ft(e) || ck(e))
    return !1;
  var n = ts(e) ? Ek : mk;
  return n.test(os(e));
}
function yk(e, n) {
  return e == null ? void 0 : e[n];
}
function as(e, n) {
  var t = yk(e, n);
  return Tk(t) ? t : void 0;
}
var hh = as(ai, "WeakMap"), A0 = Object.create, wk = /* @__PURE__ */ function() {
  function e() {
  }
  return function(n) {
    if (!ft(n))
      return {};
    if (A0)
      return A0(n);
    e.prototype = n;
    var t = new e();
    return e.prototype = void 0, t;
  };
}();
function Ak(e, n, t) {
  switch (t.length) {
    case 0:
      return e.call(n);
    case 1:
      return e.call(n, t[0]);
    case 2:
      return e.call(n, t[0], t[1]);
    case 3:
      return e.call(n, t[0], t[1], t[2]);
  }
  return e.apply(n, t);
}
function B_(e, n) {
  var t = -1, i = e.length;
  for (n || (n = Array(i)); ++t < i; )
    n[t] = e[t];
  return n;
}
var Ck = 800, kk = 16, Sk = Date.now;
function Ik(e) {
  var n = 0, t = 0;
  return function() {
    var i = Sk(), r = kk - (i - t);
    if (t = i, r > 0) {
      if (++n >= Ck)
        return arguments[0];
    } else
      n = 0;
    return e.apply(void 0, arguments);
  };
}
function xk(e) {
  return function() {
    return e;
  };
}
var dl = function() {
  try {
    var e = as(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), vk = dl ? function(e, n) {
  return dl(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: xk(n),
    writable: !0
  });
} : Sf, Pk = Ik(vk);
function Ok(e, n) {
  for (var t = -1, i = e == null ? 0 : e.length; ++t < i && n(e[t], t, e) !== !1; )
    ;
  return e;
}
var Nk = 9007199254740991, Rk = /^(?:0|[1-9]\d*)$/;
function Gl(e, n) {
  var t = typeof e;
  return n = n ?? Nk, !!n && (t == "number" || t != "symbol" && Rk.test(e)) && e > -1 && e % 1 == 0 && e < n;
}
function Ql(e, n, t) {
  n == "__proto__" && dl ? dl(e, n, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : e[n] = t;
}
function Za(e, n) {
  return e === n || e !== e && n !== n;
}
var Lk = Object.prototype, Dk = Lk.hasOwnProperty;
function If(e, n, t) {
  var i = e[n];
  (!(Dk.call(e, n) && Za(i, t)) || t === void 0 && !(n in e)) && Ql(e, n, t);
}
function lo(e, n, t, i) {
  var r = !t;
  t || (t = {});
  for (var s = -1, o = n.length; ++s < o; ) {
    var a = n[s], u = void 0;
    u === void 0 && (u = e[a]), r ? Ql(t, a, u) : If(t, a, u);
  }
  return t;
}
var C0 = Math.max;
function Mk(e, n, t) {
  return n = C0(n === void 0 ? e.length - 1 : n, 0), function() {
    for (var i = arguments, r = -1, s = C0(i.length - n, 0), o = Array(s); ++r < s; )
      o[r] = i[n + r];
    r = -1;
    for (var a = Array(n + 1); ++r < n; )
      a[r] = i[r];
    return a[n] = t(o), Ak(e, this, a);
  };
}
function Bk(e, n) {
  return Pk(Mk(e, n, Sf), e + "");
}
var Fk = 9007199254740991;
function xf(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Fk;
}
function Xl(e) {
  return e != null && xf(e.length) && !ts(e);
}
function Uk(e, n, t) {
  if (!ft(t))
    return !1;
  var i = typeof n;
  return (i == "number" ? Xl(t) && Gl(n, t.length) : i == "string" && n in t) ? Za(t[n], e) : !1;
}
function F_(e) {
  return Bk(function(n, t) {
    var i = -1, r = t.length, s = r > 1 ? t[r - 1] : void 0, o = r > 2 ? t[2] : void 0;
    for (s = e.length > 3 && typeof s == "function" ? (r--, s) : void 0, o && Uk(t[0], t[1], o) && (s = r < 3 ? void 0 : s, r = 1), n = Object(n); ++i < r; ) {
      var a = t[i];
      a && e(n, a, i, s);
    }
    return n;
  });
}
var Hk = Object.prototype;
function vf(e) {
  var n = e && e.constructor, t = typeof n == "function" && n.prototype || Hk;
  return e === t;
}
function Vk(e, n) {
  for (var t = -1, i = Array(e); ++t < e; )
    i[t] = n(t);
  return i;
}
var $k = "[object Arguments]";
function k0(e) {
  return Wn(e) && kr(e) == $k;
}
var U_ = Object.prototype, Wk = U_.hasOwnProperty, zk = U_.propertyIsEnumerable, hl = k0(/* @__PURE__ */ function() {
  return arguments;
}()) ? k0 : function(e) {
  return Wn(e) && Wk.call(e, "callee") && !zk.call(e, "callee");
};
function qk() {
  return !1;
}
var H_ = typeof exports == "object" && exports && !exports.nodeType && exports, S0 = H_ && typeof module == "object" && module && !module.nodeType && module, Yk = S0 && S0.exports === H_, I0 = Yk ? ai.Buffer : void 0, jk = I0 ? I0.isBuffer : void 0, Sa = jk || qk, Kk = "[object Arguments]", Gk = "[object Array]", Qk = "[object Boolean]", Xk = "[object Date]", Jk = "[object Error]", Zk = "[object Function]", eS = "[object Map]", tS = "[object Number]", nS = "[object Object]", iS = "[object RegExp]", rS = "[object Set]", sS = "[object String]", oS = "[object WeakMap]", aS = "[object ArrayBuffer]", uS = "[object DataView]", lS = "[object Float32Array]", cS = "[object Float64Array]", dS = "[object Int8Array]", hS = "[object Int16Array]", fS = "[object Int32Array]", mS = "[object Uint8Array]", pS = "[object Uint8ClampedArray]", gS = "[object Uint16Array]", bS = "[object Uint32Array]", ot = {};
ot[lS] = ot[cS] = ot[dS] = ot[hS] = ot[fS] = ot[mS] = ot[pS] = ot[gS] = ot[bS] = !0;
ot[Kk] = ot[Gk] = ot[aS] = ot[Qk] = ot[uS] = ot[Xk] = ot[Jk] = ot[Zk] = ot[eS] = ot[tS] = ot[nS] = ot[iS] = ot[rS] = ot[sS] = ot[oS] = !1;
function _S(e) {
  return Wn(e) && xf(e.length) && !!ot[kr(e)];
}
function Pf(e) {
  return function(n) {
    return e(n);
  };
}
var V_ = typeof exports == "object" && exports && !exports.nodeType && exports, ta = V_ && typeof module == "object" && module && !module.nodeType && module, ES = ta && ta.exports === V_, Xc = ES && L_.process, Xs = function() {
  try {
    var e = ta && ta.require && ta.require("util").types;
    return e || Xc && Xc.binding && Xc.binding("util");
  } catch {
  }
}(), x0 = Xs && Xs.isTypedArray, Of = x0 ? Pf(x0) : _S, TS = Object.prototype, yS = TS.hasOwnProperty;
function $_(e, n) {
  var t = On(e), i = !t && hl(e), r = !t && !i && Sa(e), s = !t && !i && !r && Of(e), o = t || i || r || s, a = o ? Vk(e.length, String) : [], u = a.length;
  for (var l in e)
    (n || yS.call(e, l)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    Gl(l, u))) && a.push(l);
  return a;
}
function W_(e, n) {
  return function(t) {
    return e(n(t));
  };
}
var wS = W_(Object.keys, Object), AS = Object.prototype, CS = AS.hasOwnProperty;
function kS(e) {
  if (!vf(e))
    return wS(e);
  var n = [];
  for (var t in Object(e))
    CS.call(e, t) && t != "constructor" && n.push(t);
  return n;
}
function eu(e) {
  return Xl(e) ? $_(e) : kS(e);
}
function SS(e) {
  var n = [];
  if (e != null)
    for (var t in Object(e))
      n.push(t);
  return n;
}
var IS = Object.prototype, xS = IS.hasOwnProperty;
function vS(e) {
  if (!ft(e))
    return SS(e);
  var n = vf(e), t = [];
  for (var i in e)
    i == "constructor" && (n || !xS.call(e, i)) || t.push(i);
  return t;
}
function co(e) {
  return Xl(e) ? $_(e, !0) : vS(e);
}
var z_ = F_(function(e, n) {
  lo(n, co(n), e);
}), PS = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, OS = /^\w*$/;
function Nf(e, n) {
  if (On(e))
    return !1;
  var t = typeof e;
  return t == "number" || t == "symbol" || t == "boolean" || e == null || Kl(e) ? !0 : OS.test(e) || !PS.test(e) || n != null && e in Object(n);
}
var Ia = as(Object, "create");
function NS() {
  this.__data__ = Ia ? Ia(null) : {}, this.size = 0;
}
function RS(e) {
  var n = this.has(e) && delete this.__data__[e];
  return this.size -= n ? 1 : 0, n;
}
var LS = "__lodash_hash_undefined__", DS = Object.prototype, MS = DS.hasOwnProperty;
function BS(e) {
  var n = this.__data__;
  if (Ia) {
    var t = n[e];
    return t === LS ? void 0 : t;
  }
  return MS.call(n, e) ? n[e] : void 0;
}
var FS = Object.prototype, US = FS.hasOwnProperty;
function HS(e) {
  var n = this.__data__;
  return Ia ? n[e] !== void 0 : US.call(n, e);
}
var VS = "__lodash_hash_undefined__";
function $S(e, n) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = Ia && n === void 0 ? VS : n, this;
}
function ns(e) {
  var n = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++n < t; ) {
    var i = e[n];
    this.set(i[0], i[1]);
  }
}
ns.prototype.clear = NS;
ns.prototype.delete = RS;
ns.prototype.get = BS;
ns.prototype.has = HS;
ns.prototype.set = $S;
function WS() {
  this.__data__ = [], this.size = 0;
}
function Jl(e, n) {
  for (var t = e.length; t--; )
    if (Za(e[t][0], n))
      return t;
  return -1;
}
var zS = Array.prototype, qS = zS.splice;
function YS(e) {
  var n = this.__data__, t = Jl(n, e);
  if (t < 0)
    return !1;
  var i = n.length - 1;
  return t == i ? n.pop() : qS.call(n, t, 1), --this.size, !0;
}
function jS(e) {
  var n = this.__data__, t = Jl(n, e);
  return t < 0 ? void 0 : n[t][1];
}
function KS(e) {
  return Jl(this.__data__, e) > -1;
}
function GS(e, n) {
  var t = this.__data__, i = Jl(t, e);
  return i < 0 ? (++this.size, t.push([e, n])) : t[i][1] = n, this;
}
function Ki(e) {
  var n = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++n < t; ) {
    var i = e[n];
    this.set(i[0], i[1]);
  }
}
Ki.prototype.clear = WS;
Ki.prototype.delete = YS;
Ki.prototype.get = jS;
Ki.prototype.has = KS;
Ki.prototype.set = GS;
var xa = as(ai, "Map");
function QS() {
  this.size = 0, this.__data__ = {
    hash: new ns(),
    map: new (xa || Ki)(),
    string: new ns()
  };
}
function XS(e) {
  var n = typeof e;
  return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
}
function Zl(e, n) {
  var t = e.__data__;
  return XS(n) ? t[typeof n == "string" ? "string" : "hash"] : t.map;
}
function JS(e) {
  var n = Zl(this, e).delete(e);
  return this.size -= n ? 1 : 0, n;
}
function ZS(e) {
  return Zl(this, e).get(e);
}
function eI(e) {
  return Zl(this, e).has(e);
}
function tI(e, n) {
  var t = Zl(this, e), i = t.size;
  return t.set(e, n), this.size += t.size == i ? 0 : 1, this;
}
function Gi(e) {
  var n = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++n < t; ) {
    var i = e[n];
    this.set(i[0], i[1]);
  }
}
Gi.prototype.clear = QS;
Gi.prototype.delete = JS;
Gi.prototype.get = ZS;
Gi.prototype.has = eI;
Gi.prototype.set = tI;
var nI = "Expected a function";
function Rf(e, n) {
  if (typeof e != "function" || n != null && typeof n != "function")
    throw new TypeError(nI);
  var t = function() {
    var i = arguments, r = n ? n.apply(this, i) : i[0], s = t.cache;
    if (s.has(r))
      return s.get(r);
    var o = e.apply(this, i);
    return t.cache = s.set(r, o) || s, o;
  };
  return t.cache = new (Rf.Cache || Gi)(), t;
}
Rf.Cache = Gi;
var iI = 500;
function rI(e) {
  var n = Rf(e, function(i) {
    return t.size === iI && t.clear(), i;
  }), t = n.cache;
  return n;
}
var sI = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, oI = /\\(\\)?/g, aI = rI(function(e) {
  var n = [];
  return e.charCodeAt(0) === 46 && n.push(""), e.replace(sI, function(t, i, r, s) {
    n.push(r ? s.replace(oI, "$1") : i || t);
  }), n;
});
function q_(e) {
  return e == null ? "" : M_(e);
}
function ec(e, n) {
  return On(e) ? e : Nf(e, n) ? [e] : aI(q_(e));
}
function ho(e) {
  if (typeof e == "string" || Kl(e))
    return e;
  var n = e + "";
  return n == "0" && 1 / e == -1 / 0 ? "-0" : n;
}
function Lf(e, n) {
  n = ec(n, e);
  for (var t = 0, i = n.length; e != null && t < i; )
    e = e[ho(n[t++])];
  return t && t == i ? e : void 0;
}
function Js(e, n, t) {
  var i = e == null ? void 0 : Lf(e, n);
  return i === void 0 ? t : i;
}
function Y_(e, n) {
  for (var t = -1, i = n.length, r = e.length; ++t < i; )
    e[r + t] = n[t];
  return e;
}
var Df = W_(Object.getPrototypeOf, Object), uI = "[object Object]", lI = Function.prototype, cI = Object.prototype, j_ = lI.toString, dI = cI.hasOwnProperty, hI = j_.call(Object);
function Mi(e) {
  if (!Wn(e) || kr(e) != uI)
    return !1;
  var n = Df(e);
  if (n === null)
    return !0;
  var t = dI.call(n, "constructor") && n.constructor;
  return typeof t == "function" && t instanceof t && j_.call(t) == hI;
}
function K_(e, n, t) {
  var i = -1, r = e.length;
  n < 0 && (n = -n > r ? 0 : r + n), t = t > r ? r : t, t < 0 && (t += r), r = n > t ? 0 : t - n >>> 0, n >>>= 0;
  for (var s = Array(r); ++i < r; )
    s[i] = e[i + n];
  return s;
}
function fI(e, n, t) {
  var i = e.length;
  return t = t === void 0 ? i : t, !n && t >= i ? e : K_(e, n, t);
}
var mI = "\\ud800-\\udfff", pI = "\\u0300-\\u036f", gI = "\\ufe20-\\ufe2f", bI = "\\u20d0-\\u20ff", _I = pI + gI + bI, EI = "\\ufe0e\\ufe0f", TI = "\\u200d", yI = RegExp("[" + TI + mI + _I + EI + "]");
function G_(e) {
  return yI.test(e);
}
function wI(e) {
  return e.split("");
}
var Q_ = "\\ud800-\\udfff", AI = "\\u0300-\\u036f", CI = "\\ufe20-\\ufe2f", kI = "\\u20d0-\\u20ff", SI = AI + CI + kI, II = "\\ufe0e\\ufe0f", xI = "[" + Q_ + "]", fh = "[" + SI + "]", mh = "\\ud83c[\\udffb-\\udfff]", vI = "(?:" + fh + "|" + mh + ")", X_ = "[^" + Q_ + "]", J_ = "(?:\\ud83c[\\udde6-\\uddff]){2}", Z_ = "[\\ud800-\\udbff][\\udc00-\\udfff]", PI = "\\u200d", eE = vI + "?", tE = "[" + II + "]?", OI = "(?:" + PI + "(?:" + [X_, J_, Z_].join("|") + ")" + tE + eE + ")*", NI = tE + eE + OI, RI = "(?:" + [X_ + fh + "?", fh, J_, Z_, xI].join("|") + ")", LI = RegExp(mh + "(?=" + mh + ")|" + RI + NI, "g");
function DI(e) {
  return e.match(LI) || [];
}
function MI(e) {
  return G_(e) ? DI(e) : wI(e);
}
function BI(e) {
  return function(n) {
    n = q_(n);
    var t = G_(n) ? MI(n) : void 0, i = t ? t[0] : n.charAt(0), r = t ? fI(t, 1).join("") : n.slice(1);
    return i[e]() + r;
  };
}
var FI = BI("toUpperCase");
function UI() {
  this.__data__ = new Ki(), this.size = 0;
}
function HI(e) {
  var n = this.__data__, t = n.delete(e);
  return this.size = n.size, t;
}
function VI(e) {
  return this.__data__.get(e);
}
function $I(e) {
  return this.__data__.has(e);
}
var WI = 200;
function zI(e, n) {
  var t = this.__data__;
  if (t instanceof Ki) {
    var i = t.__data__;
    if (!xa || i.length < WI - 1)
      return i.push([e, n]), this.size = ++t.size, this;
    t = this.__data__ = new Gi(i);
  }
  return t.set(e, n), this.size = t.size, this;
}
function ri(e) {
  var n = this.__data__ = new Ki(e);
  this.size = n.size;
}
ri.prototype.clear = UI;
ri.prototype.delete = HI;
ri.prototype.get = VI;
ri.prototype.has = $I;
ri.prototype.set = zI;
function qI(e, n) {
  return e && lo(n, eu(n), e);
}
function YI(e, n) {
  return e && lo(n, co(n), e);
}
var nE = typeof exports == "object" && exports && !exports.nodeType && exports, v0 = nE && typeof module == "object" && module && !module.nodeType && module, jI = v0 && v0.exports === nE, P0 = jI ? ai.Buffer : void 0, O0 = P0 ? P0.allocUnsafe : void 0;
function iE(e, n) {
  if (n)
    return e.slice();
  var t = e.length, i = O0 ? O0(t) : new e.constructor(t);
  return e.copy(i), i;
}
function KI(e, n) {
  for (var t = -1, i = e == null ? 0 : e.length, r = 0, s = []; ++t < i; ) {
    var o = e[t];
    n(o, t, e) && (s[r++] = o);
  }
  return s;
}
function rE() {
  return [];
}
var GI = Object.prototype, QI = GI.propertyIsEnumerable, N0 = Object.getOwnPropertySymbols, Mf = N0 ? function(e) {
  return e == null ? [] : (e = Object(e), KI(N0(e), function(n) {
    return QI.call(e, n);
  }));
} : rE;
function XI(e, n) {
  return lo(e, Mf(e), n);
}
var JI = Object.getOwnPropertySymbols, sE = JI ? function(e) {
  for (var n = []; e; )
    Y_(n, Mf(e)), e = Df(e);
  return n;
} : rE;
function ZI(e, n) {
  return lo(e, sE(e), n);
}
function oE(e, n, t) {
  var i = n(e);
  return On(e) ? i : Y_(i, t(e));
}
function ph(e) {
  return oE(e, eu, Mf);
}
function e3(e) {
  return oE(e, co, sE);
}
var gh = as(ai, "DataView"), bh = as(ai, "Promise"), _h = as(ai, "Set"), R0 = "[object Map]", t3 = "[object Object]", L0 = "[object Promise]", D0 = "[object Set]", M0 = "[object WeakMap]", B0 = "[object DataView]", n3 = os(gh), i3 = os(xa), r3 = os(bh), s3 = os(_h), o3 = os(hh), ei = kr;
(gh && ei(new gh(new ArrayBuffer(1))) != B0 || xa && ei(new xa()) != R0 || bh && ei(bh.resolve()) != L0 || _h && ei(new _h()) != D0 || hh && ei(new hh()) != M0) && (ei = function(e) {
  var n = kr(e), t = n == t3 ? e.constructor : void 0, i = t ? os(t) : "";
  if (i)
    switch (i) {
      case n3:
        return B0;
      case i3:
        return R0;
      case r3:
        return L0;
      case s3:
        return D0;
      case o3:
        return M0;
    }
  return n;
});
var a3 = Object.prototype, u3 = a3.hasOwnProperty;
function l3(e) {
  var n = e.length, t = new e.constructor(n);
  return n && typeof e[0] == "string" && u3.call(e, "index") && (t.index = e.index, t.input = e.input), t;
}
var fl = ai.Uint8Array;
function Bf(e) {
  var n = new e.constructor(e.byteLength);
  return new fl(n).set(new fl(e)), n;
}
function c3(e, n) {
  var t = n ? Bf(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.byteLength);
}
var d3 = /\w*$/;
function h3(e) {
  var n = new e.constructor(e.source, d3.exec(e));
  return n.lastIndex = e.lastIndex, n;
}
var F0 = ki ? ki.prototype : void 0, U0 = F0 ? F0.valueOf : void 0;
function f3(e) {
  return U0 ? Object(U0.call(e)) : {};
}
function aE(e, n) {
  var t = n ? Bf(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.length);
}
var m3 = "[object Boolean]", p3 = "[object Date]", g3 = "[object Map]", b3 = "[object Number]", _3 = "[object RegExp]", E3 = "[object Set]", T3 = "[object String]", y3 = "[object Symbol]", w3 = "[object ArrayBuffer]", A3 = "[object DataView]", C3 = "[object Float32Array]", k3 = "[object Float64Array]", S3 = "[object Int8Array]", I3 = "[object Int16Array]", x3 = "[object Int32Array]", v3 = "[object Uint8Array]", P3 = "[object Uint8ClampedArray]", O3 = "[object Uint16Array]", N3 = "[object Uint32Array]";
function R3(e, n, t) {
  var i = e.constructor;
  switch (n) {
    case w3:
      return Bf(e);
    case m3:
    case p3:
      return new i(+e);
    case A3:
      return c3(e, t);
    case C3:
    case k3:
    case S3:
    case I3:
    case x3:
    case v3:
    case P3:
    case O3:
    case N3:
      return aE(e, t);
    case g3:
      return new i();
    case b3:
    case T3:
      return new i(e);
    case _3:
      return h3(e);
    case E3:
      return new i();
    case y3:
      return f3(e);
  }
}
function uE(e) {
  return typeof e.constructor == "function" && !vf(e) ? wk(Df(e)) : {};
}
var L3 = "[object Map]";
function D3(e) {
  return Wn(e) && ei(e) == L3;
}
var H0 = Xs && Xs.isMap, M3 = H0 ? Pf(H0) : D3, B3 = "[object Set]";
function F3(e) {
  return Wn(e) && ei(e) == B3;
}
var V0 = Xs && Xs.isSet, U3 = V0 ? Pf(V0) : F3, H3 = 1, V3 = 2, $3 = 4, lE = "[object Arguments]", W3 = "[object Array]", z3 = "[object Boolean]", q3 = "[object Date]", Y3 = "[object Error]", cE = "[object Function]", j3 = "[object GeneratorFunction]", K3 = "[object Map]", G3 = "[object Number]", dE = "[object Object]", Q3 = "[object RegExp]", X3 = "[object Set]", J3 = "[object String]", Z3 = "[object Symbol]", ex = "[object WeakMap]", tx = "[object ArrayBuffer]", nx = "[object DataView]", ix = "[object Float32Array]", rx = "[object Float64Array]", sx = "[object Int8Array]", ox = "[object Int16Array]", ax = "[object Int32Array]", ux = "[object Uint8Array]", lx = "[object Uint8ClampedArray]", cx = "[object Uint16Array]", dx = "[object Uint32Array]", tt = {};
tt[lE] = tt[W3] = tt[tx] = tt[nx] = tt[z3] = tt[q3] = tt[ix] = tt[rx] = tt[sx] = tt[ox] = tt[ax] = tt[K3] = tt[G3] = tt[dE] = tt[Q3] = tt[X3] = tt[J3] = tt[Z3] = tt[ux] = tt[lx] = tt[cx] = tt[dx] = !0;
tt[Y3] = tt[cE] = tt[ex] = !1;
function zs(e, n, t, i, r, s) {
  var o, a = n & H3, u = n & V3, l = n & $3;
  if (t && (o = r ? t(e, i, r, s) : t(e)), o !== void 0)
    return o;
  if (!ft(e))
    return e;
  var c = On(e);
  if (c) {
    if (o = l3(e), !a)
      return B_(e, o);
  } else {
    var d = ei(e), p = d == cE || d == j3;
    if (Sa(e))
      return iE(e, a);
    if (d == dE || d == lE || p && !r) {
      if (o = u || p ? {} : uE(e), !a)
        return u ? ZI(e, YI(o, e)) : XI(e, qI(o, e));
    } else {
      if (!tt[d])
        return r ? e : {};
      o = R3(e, d, a);
    }
  }
  s || (s = new ri());
  var g = s.get(e);
  if (g)
    return g;
  s.set(e, o), U3(e) ? e.forEach(function(k) {
    o.add(zs(k, n, t, k, e, s));
  }) : M3(e) && e.forEach(function(k, C) {
    o.set(C, zs(k, n, t, C, e, s));
  });
  var b = l ? u ? e3 : ph : u ? co : eu, _ = c ? void 0 : b(e);
  return Ok(_ || e, function(k, C) {
    _ && (C = k, k = e[C]), If(o, C, zs(k, n, t, C, e, s));
  }), o;
}
var hx = 4;
function hE(e) {
  return zs(e, hx);
}
var fx = 1, mx = 4;
function ui(e) {
  return zs(e, fx | mx);
}
var px = 1, gx = 4;
function Ff(e, n) {
  return n = typeof n == "function" ? n : void 0, zs(e, px | gx, n);
}
var bx = "__lodash_hash_undefined__";
function _x(e) {
  return this.__data__.set(e, bx), this;
}
function Ex(e) {
  return this.__data__.has(e);
}
function ml(e) {
  var n = -1, t = e == null ? 0 : e.length;
  for (this.__data__ = new Gi(); ++n < t; )
    this.add(e[n]);
}
ml.prototype.add = ml.prototype.push = _x;
ml.prototype.has = Ex;
function Tx(e, n) {
  for (var t = -1, i = e == null ? 0 : e.length; ++t < i; )
    if (n(e[t], t, e))
      return !0;
  return !1;
}
function yx(e, n) {
  return e.has(n);
}
var wx = 1, Ax = 2;
function fE(e, n, t, i, r, s) {
  var o = t & wx, a = e.length, u = n.length;
  if (a != u && !(o && u > a))
    return !1;
  var l = s.get(e), c = s.get(n);
  if (l && c)
    return l == n && c == e;
  var d = -1, p = !0, g = t & Ax ? new ml() : void 0;
  for (s.set(e, n), s.set(n, e); ++d < a; ) {
    var b = e[d], _ = n[d];
    if (i)
      var k = o ? i(_, b, d, n, e, s) : i(b, _, d, e, n, s);
    if (k !== void 0) {
      if (k)
        continue;
      p = !1;
      break;
    }
    if (g) {
      if (!Tx(n, function(C, D) {
        if (!yx(g, D) && (b === C || r(b, C, t, i, s)))
          return g.push(D);
      })) {
        p = !1;
        break;
      }
    } else if (!(b === _ || r(b, _, t, i, s))) {
      p = !1;
      break;
    }
  }
  return s.delete(e), s.delete(n), p;
}
function Cx(e) {
  var n = -1, t = Array(e.size);
  return e.forEach(function(i, r) {
    t[++n] = [r, i];
  }), t;
}
function kx(e) {
  var n = -1, t = Array(e.size);
  return e.forEach(function(i) {
    t[++n] = i;
  }), t;
}
var Sx = 1, Ix = 2, xx = "[object Boolean]", vx = "[object Date]", Px = "[object Error]", Ox = "[object Map]", Nx = "[object Number]", Rx = "[object RegExp]", Lx = "[object Set]", Dx = "[object String]", Mx = "[object Symbol]", Bx = "[object ArrayBuffer]", Fx = "[object DataView]", $0 = ki ? ki.prototype : void 0, Jc = $0 ? $0.valueOf : void 0;
function Ux(e, n, t, i, r, s, o) {
  switch (t) {
    case Fx:
      if (e.byteLength != n.byteLength || e.byteOffset != n.byteOffset)
        return !1;
      e = e.buffer, n = n.buffer;
    case Bx:
      return !(e.byteLength != n.byteLength || !s(new fl(e), new fl(n)));
    case xx:
    case vx:
    case Nx:
      return Za(+e, +n);
    case Px:
      return e.name == n.name && e.message == n.message;
    case Rx:
    case Dx:
      return e == n + "";
    case Ox:
      var a = Cx;
    case Lx:
      var u = i & Sx;
      if (a || (a = kx), e.size != n.size && !u)
        return !1;
      var l = o.get(e);
      if (l)
        return l == n;
      i |= Ix, o.set(e, n);
      var c = fE(a(e), a(n), i, r, s, o);
      return o.delete(e), c;
    case Mx:
      if (Jc)
        return Jc.call(e) == Jc.call(n);
  }
  return !1;
}
var Hx = 1, Vx = Object.prototype, $x = Vx.hasOwnProperty;
function Wx(e, n, t, i, r, s) {
  var o = t & Hx, a = ph(e), u = a.length, l = ph(n), c = l.length;
  if (u != c && !o)
    return !1;
  for (var d = u; d--; ) {
    var p = a[d];
    if (!(o ? p in n : $x.call(n, p)))
      return !1;
  }
  var g = s.get(e), b = s.get(n);
  if (g && b)
    return g == n && b == e;
  var _ = !0;
  s.set(e, n), s.set(n, e);
  for (var k = o; ++d < u; ) {
    p = a[d];
    var C = e[p], D = n[p];
    if (i)
      var M = o ? i(D, C, p, n, e, s) : i(C, D, p, e, n, s);
    if (!(M === void 0 ? C === D || r(C, D, t, i, s) : M)) {
      _ = !1;
      break;
    }
    k || (k = p == "constructor");
  }
  if (_ && !k) {
    var j = e.constructor, F = n.constructor;
    j != F && "constructor" in e && "constructor" in n && !(typeof j == "function" && j instanceof j && typeof F == "function" && F instanceof F) && (_ = !1);
  }
  return s.delete(e), s.delete(n), _;
}
var zx = 1, W0 = "[object Arguments]", z0 = "[object Array]", Au = "[object Object]", qx = Object.prototype, q0 = qx.hasOwnProperty;
function Yx(e, n, t, i, r, s) {
  var o = On(e), a = On(n), u = o ? z0 : ei(e), l = a ? z0 : ei(n);
  u = u == W0 ? Au : u, l = l == W0 ? Au : l;
  var c = u == Au, d = l == Au, p = u == l;
  if (p && Sa(e)) {
    if (!Sa(n))
      return !1;
    o = !0, c = !1;
  }
  if (p && !c)
    return s || (s = new ri()), o || Of(e) ? fE(e, n, t, i, r, s) : Ux(e, n, u, t, i, r, s);
  if (!(t & zx)) {
    var g = c && q0.call(e, "__wrapped__"), b = d && q0.call(n, "__wrapped__");
    if (g || b) {
      var _ = g ? e.value() : e, k = b ? n.value() : n;
      return s || (s = new ri()), r(_, k, t, i, s);
    }
  }
  return p ? (s || (s = new ri()), Wx(e, n, t, i, r, s)) : !1;
}
function tu(e, n, t, i, r) {
  return e === n ? !0 : e == null || n == null || !Wn(e) && !Wn(n) ? e !== e && n !== n : Yx(e, n, t, i, tu, r);
}
var jx = 1, Kx = 2;
function Gx(e, n, t, i) {
  var r = t.length, s = r;
  if (e == null)
    return !s;
  for (e = Object(e); r--; ) {
    var o = t[r];
    if (o[2] ? o[1] !== e[o[0]] : !(o[0] in e))
      return !1;
  }
  for (; ++r < s; ) {
    o = t[r];
    var a = o[0], u = e[a], l = o[1];
    if (o[2]) {
      if (u === void 0 && !(a in e))
        return !1;
    } else {
      var c = new ri(), d;
      if (!(d === void 0 ? tu(l, u, jx | Kx, i, c) : d))
        return !1;
    }
  }
  return !0;
}
function mE(e) {
  return e === e && !ft(e);
}
function Qx(e) {
  for (var n = eu(e), t = n.length; t--; ) {
    var i = n[t], r = e[i];
    n[t] = [i, r, mE(r)];
  }
  return n;
}
function pE(e, n) {
  return function(t) {
    return t == null ? !1 : t[e] === n && (n !== void 0 || e in Object(t));
  };
}
function Xx(e) {
  var n = Qx(e);
  return n.length == 1 && n[0][2] ? pE(n[0][0], n[0][1]) : function(t) {
    return t === e || Gx(t, e, n);
  };
}
function Jx(e, n) {
  return e != null && n in Object(e);
}
function Zx(e, n, t) {
  n = ec(n, e);
  for (var i = -1, r = n.length, s = !1; ++i < r; ) {
    var o = ho(n[i]);
    if (!(s = e != null && t(e, o)))
      break;
    e = e[o];
  }
  return s || ++i != r ? s : (r = e == null ? 0 : e.length, !!r && xf(r) && Gl(o, r) && (On(e) || hl(e)));
}
function ev(e, n) {
  return e != null && Zx(e, n, Jx);
}
var tv = 1, nv = 2;
function iv(e, n) {
  return Nf(e) && mE(n) ? pE(ho(e), n) : function(t) {
    var i = Js(t, e);
    return i === void 0 && i === n ? ev(t, e) : tu(n, i, tv | nv);
  };
}
function rv(e) {
  return function(n) {
    return n == null ? void 0 : n[e];
  };
}
function sv(e) {
  return function(n) {
    return Lf(n, e);
  };
}
function ov(e) {
  return Nf(e) ? rv(ho(e)) : sv(e);
}
function av(e) {
  return typeof e == "function" ? e : e == null ? Sf : typeof e == "object" ? On(e) ? iv(e[0], e[1]) : Xx(e) : ov(e);
}
function uv(e) {
  return function(n, t, i) {
    for (var r = -1, s = Object(n), o = i(n), a = o.length; a--; ) {
      var u = o[++r];
      if (t(s[u], u, s) === !1)
        break;
    }
    return n;
  };
}
var gE = uv();
function lv(e, n) {
  return e && gE(e, n, eu);
}
var Zc = function() {
  return ai.Date.now();
}, cv = "Expected a function", dv = Math.max, hv = Math.min;
function _r(e, n, t) {
  var i, r, s, o, a, u, l = 0, c = !1, d = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(cv);
  n = y0(n) || 0, ft(t) && (c = !!t.leading, d = "maxWait" in t, s = d ? dv(y0(t.maxWait) || 0, n) : s, p = "trailing" in t ? !!t.trailing : p);
  function g(O) {
    var V = i, ie = r;
    return i = r = void 0, l = O, o = e.apply(ie, V), o;
  }
  function b(O) {
    return l = O, a = setTimeout(C, n), c ? g(O) : o;
  }
  function _(O) {
    var V = O - u, ie = O - l, W = n - V;
    return d ? hv(W, s - ie) : W;
  }
  function k(O) {
    var V = O - u, ie = O - l;
    return u === void 0 || V >= n || V < 0 || d && ie >= s;
  }
  function C() {
    var O = Zc();
    if (k(O))
      return D(O);
    a = setTimeout(C, _(O));
  }
  function D(O) {
    return a = void 0, p && i ? g(O) : (i = r = void 0, o);
  }
  function M() {
    a !== void 0 && clearTimeout(a), l = 0, i = u = r = a = void 0;
  }
  function j() {
    return a === void 0 ? o : D(Zc());
  }
  function F() {
    var O = Zc(), V = k(O);
    if (i = arguments, r = this, u = O, V) {
      if (a === void 0)
        return b(u);
      if (d)
        return clearTimeout(a), a = setTimeout(C, n), g(u);
    }
    return a === void 0 && (a = setTimeout(C, n)), o;
  }
  return F.cancel = M, F.flush = j, F;
}
function Eh(e, n, t) {
  (t !== void 0 && !Za(e[n], t) || t === void 0 && !(n in e)) && Ql(e, n, t);
}
function fv(e) {
  return Wn(e) && Xl(e);
}
function Th(e, n) {
  if (!(n === "constructor" && typeof e[n] == "function") && n != "__proto__")
    return e[n];
}
function mv(e) {
  return lo(e, co(e));
}
function pv(e, n, t, i, r, s, o) {
  var a = Th(e, t), u = Th(n, t), l = o.get(u);
  if (l) {
    Eh(e, t, l);
    return;
  }
  var c = s ? s(a, u, t + "", e, n, o) : void 0, d = c === void 0;
  if (d) {
    var p = On(u), g = !p && Sa(u), b = !p && !g && Of(u);
    c = u, p || g || b ? On(a) ? c = a : fv(a) ? c = B_(a) : g ? (d = !1, c = iE(u, !0)) : b ? (d = !1, c = aE(u, !0)) : c = [] : Mi(u) || hl(u) ? (c = a, hl(a) ? c = mv(a) : (!ft(a) || ts(a)) && (c = uE(u))) : d = !1;
  }
  d && (o.set(u, c), r(c, u, i, s, o), o.delete(u)), Eh(e, t, c);
}
function bE(e, n, t, i, r) {
  e !== n && gE(n, function(s, o) {
    if (r || (r = new ri()), ft(s))
      pv(e, n, o, t, bE, i, r);
    else {
      var a = i ? i(Th(e, o), s, o + "", e, n, r) : void 0;
      a === void 0 && (a = s), Eh(e, o, a);
    }
  }, co);
}
function gv(e) {
  var n = e == null ? 0 : e.length;
  return n ? e[n - 1] : void 0;
}
var bv = "[object String]";
function Y0(e) {
  return typeof e == "string" || !On(e) && Wn(e) && kr(e) == bv;
}
function _v(e, n) {
  return n.length < 2 ? e : Lf(e, K_(n, 0, -1));
}
function Er(e) {
  return Wn(e) && e.nodeType === 1 && !Mi(e);
}
function j0(e, n) {
  return tu(e, n);
}
function Ev(e, n, t) {
  t = typeof t == "function" ? t : void 0;
  var i = t ? t(e, n) : void 0;
  return i === void 0 ? tu(e, n, void 0, t) : !!i;
}
function Tv(e, n) {
  var t = {};
  return n = av(n), lv(e, function(i, r, s) {
    Ql(t, r, n(i, r, s));
  }), t;
}
var Uf = F_(function(e, n, t) {
  bE(e, n, t);
});
function yv(e, n) {
  return n = ec(n, e), e = _v(e, n), e == null || delete e[ho(gv(n))];
}
function wv(e, n, t, i) {
  if (!ft(e))
    return e;
  n = ec(n, e);
  for (var r = -1, s = n.length, o = s - 1, a = e; a != null && ++r < s; ) {
    var u = ho(n[r]), l = t;
    if (u === "__proto__" || u === "constructor" || u === "prototype")
      return e;
    if (r != o) {
      var c = a[u];
      l = void 0, l === void 0 && (l = ft(c) ? c : Gl(n[r + 1]) ? [] : {});
    }
    If(a, u, l), a = a[u];
  }
  return e;
}
function _E(e, n, t) {
  return e == null ? e : wv(e, n, t);
}
var Av = "Expected a function";
function pl(e, n, t) {
  var i = !0, r = !0;
  if (typeof e != "function")
    throw new TypeError(Av);
  return ft(t) && (i = "leading" in t ? !!t.leading : i, r = "trailing" in t ? !!t.trailing : r), _r(e, n, {
    leading: i,
    maxWait: n,
    trailing: r
  });
}
function Cv(e, n) {
  return e == null ? !0 : yv(e, n);
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
let yh;
try {
  yh = {
    window,
    document
  };
} catch {
  /* istanbul ignore next -- @preserve */
  yh = {
    window: {},
    document: {}
  };
}
var ue = yh;
function kv() {
  try {
    return navigator.userAgent.toLowerCase();
  } catch {
    return "";
  }
}
const Mr = /* @__PURE__ */ kv(), he = {
  isMac: /* @__PURE__ */ EE(Mr),
  isWindows: /* @__PURE__ */ Sv(Mr),
  isGecko: /* @__PURE__ */ Iv(Mr),
  isSafari: /* @__PURE__ */ xv(Mr),
  isiOS: /* @__PURE__ */ vv(Mr),
  isAndroid: /* @__PURE__ */ Pv(Mr),
  isBlink: /* @__PURE__ */ Ov(Mr),
  features: {
    isRegExpUnicodePropertySupported: /* @__PURE__ */ Nv()
  }
};
function EE(e) {
  return e.indexOf("macintosh") > -1;
}
function Sv(e) {
  return e.indexOf("windows") > -1;
}
function Iv(e) {
  return !!e.match(/gecko\/\d+/);
}
function xv(e) {
  return e.indexOf(" applewebkit/") > -1 && e.indexOf("chrome") === -1;
}
function vv(e) {
  return !!e.match(/iphone|ipad/i) || EE(e) && navigator.maxTouchPoints > 0;
}
function Pv(e) {
  return e.indexOf("android") > -1;
}
function Ov(e) {
  return e.indexOf("chrome/") > -1 && e.indexOf("edge/") < 0;
}
function Nv() {
  let e = !1;
  try {
    e = "ć".search(new RegExp("[\\p{L}]", "u")) === 0;
  } catch {
  }
  return e;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function TE(e, n, t, i) {
  t = t || function(u, l) {
    return u === l;
  };
  const r = Array.isArray(e) ? e : Array.prototype.slice.call(e), s = Array.isArray(n) ? n : Array.prototype.slice.call(n), o = Rv(r, s, t);
  return i ? Dv(o, s.length) : Lv(s, o);
}
function Rv(e, n, t) {
  const i = K0(e, n, t);
  if (i === -1)
    return {
      firstIndex: -1,
      lastIndexOld: -1,
      lastIndexNew: -1
    };
  const r = G0(e, i), s = G0(n, i), o = K0(r, s, t), a = e.length - o, u = n.length - o;
  return {
    firstIndex: i,
    lastIndexOld: a,
    lastIndexNew: u
  };
}
function K0(e, n, t) {
  for (let i = 0; i < Math.max(e.length, n.length); i++)
    if (e[i] === void 0 || n[i] === void 0 || !t(e[i], n[i]))
      return i;
  return -1;
}
function G0(e, n) {
  return e.slice(n).reverse();
}
function Lv(e, n) {
  const t = [], { firstIndex: i, lastIndexOld: r, lastIndexNew: s } = n;
  return s - i > 0 && t.push({
    index: i,
    type: "insert",
    values: e.slice(i, s)
  }), r - i > 0 && t.push({
    index: i + (s - i),
    type: "delete",
    howMany: r - i
  }), t;
}
function Dv(e, n) {
  const { firstIndex: t, lastIndexOld: i, lastIndexNew: r } = e;
  if (t === -1)
    return Array(n).fill("equal");
  let s = [];
  return t > 0 && (s = s.concat(Array(t).fill("equal"))), r - t > 0 && (s = s.concat(Array(r - t).fill("insert"))), i - t > 0 && (s = s.concat(Array(i - t).fill("delete"))), r < n && (s = s.concat(Array(n - r).fill("equal"))), s;
}
function na(e, n, t) {
  t = t || function(_, k) {
    return _ === k;
  };
  const i = e.length, r = n.length;
  if (i > 200 || r > 200 || i + r > 300)
    return na.fastDiff(e, n, t, !0);
  let s, o;
  if (r < i) {
    const _ = e;
    e = n, n = _, s = "delete", o = "insert";
  } else
    s = "insert", o = "delete";
  const a = e.length, u = n.length, l = u - a, c = {}, d = {};
  function p(_) {
    const k = (d[_ - 1] !== void 0 ? d[_ - 1] : -1) + 1, C = d[_ + 1] !== void 0 ? d[_ + 1] : -1, D = k > C ? -1 : 1;
    c[_ + D] && (c[_] = c[_ + D].slice(0)), c[_] || (c[_] = []), c[_].push(k > C ? s : o);
    let M = Math.max(k, C), j = M - _;
    for (; j < a && M < u && t(e[j], n[M]); )
      j++, M++, c[_].push("equal");
    return M;
  }
  let g = 0, b;
  do {
    for (b = -g; b < l; b++)
      d[b] = p(b);
    for (b = l + g; b > l; b--)
      d[b] = p(b);
    d[l] = p(l), g++;
  } while (d[l] !== u);
  return c[l].slice(1);
}
na.fastDiff = TE;
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function Q0() {
  return function e() {
    e.called = !0;
  };
}
class Wi {
  /**
  * @param source The emitter.
  * @param name The event name.
  */
  constructor(n, t) {
    /**
    * The object that fired the event.
    */
    m(this, "source");
    /**
    * The event name.
    */
    m(this, "name");
    /**
    * Path this event has followed. See {@link module:utils/emittermixin~Emitter#delegate}.
    */
    m(this, "path");
    /**
    * Stops the event emitter to call further callbacks for this event interaction.
    */
    m(this, "stop");
    /**
    * Removes the current callback from future interactions of this event.
    */
    m(this, "off");
    /**
    * The value which will be returned by {@link module:utils/emittermixin~Emitter#fire}.
    *
    * It's `undefined` by default and can be changed by an event listener:
    *
    * ```ts
    * dataController.fire( 'getSelectedContent', ( evt ) => {
    * 	// This listener will make `dataController.fire( 'getSelectedContent' )`
    * 	// always return an empty DocumentFragment.
    * 	evt.return = new DocumentFragment();
    *
    * 	// Make sure no other listeners are executed.
    * 	evt.stop();
    * } );
    * ```
    */
    m(this, "return");
    this.source = n, this.name = t, this.path = [], this.stop = Q0(), this.off = Q0();
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const Kt = new Array(256).fill("").map((e, n) => ("0" + n.toString(16)).slice(-2));
function un() {
  const [e, n, t, i] = crypto.getRandomValues(new Uint32Array(4));
  return "e" + Kt[e >> 0 & 255] + Kt[e >> 8 & 255] + Kt[e >> 16 & 255] + Kt[e >> 24 & 255] + Kt[n >> 0 & 255] + Kt[n >> 8 & 255] + Kt[n >> 16 & 255] + Kt[n >> 24 & 255] + Kt[t >> 0 & 255] + Kt[t >> 8 & 255] + Kt[t >> 16 & 255] + Kt[t >> 24 & 255] + Kt[i >> 0 & 255] + Kt[i >> 8 & 255] + Kt[i >> 16 & 255] + Kt[i >> 24 & 255];
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const pr = {
  get(e = "normal") {
    return typeof e != "number" ? this[e] || this.normal : e;
  },
  highest: 1e5,
  high: 1e3,
  normal: 0,
  low: -1e3,
  lowest: -1e5
};
function Mv(e, n) {
  const t = pr.get(n.priority);
  let i = 0, r = e.length;
  for (; i < r; ) {
    const s = i + r >> 1;
    pr.get(e[s].priority) < t ? r = s : i = s + 1;
  }
  e.splice(i, 0, n);
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const Bv = "https://ckeditor.com/docs/ckeditor5/latest/support/error-codes.html";
class v extends Error {
  /**
  * Creates an instance of the CKEditorError class.
  *
  * @param errorName The error id in an `error-name` format. A link to this error documentation page will be added
  * to the thrown error's `message`.
  * @param context A context of the error by which the {@link module:watchdog/watchdog~Watchdog watchdog}
  * is able to determine which editor crashed. It should be an editor instance or a property connected to it. It can be also
  * a `null` value if the editor should not be restarted in case of the error (e.g. during the editor initialization).
  * The error context should be checked using the `areConnectedThroughProperties( editor, context )` utility
  * to check if the object works as the context.
  * @param data Additional data describing the error. A stringified version of this object
  * will be appended to the error message, so the data are quickly visible in the console. The original
  * data object will also be later available under the {@link #data} property.
  */
  constructor(t, i, r) {
    super(Uv(t, r));
    /**
    * A context of the error by which the Watchdog is able to determine which editor crashed.
    */
    m(this, "context");
    /**
    * The additional error data passed to the constructor. Undefined if none was passed.
    */
    m(this, "data");
    this.name = "CKEditorError", this.context = i, this.data = r;
  }
  /**
  * Checks if the error is of the `CKEditorError` type.
  */
  is(t) {
    return t === "CKEditorError";
  }
  /**
  * A utility that ensures that the thrown error is a {@link module:utils/ckeditorerror~CKEditorError} one.
  * It is useful when combined with the {@link module:watchdog/watchdog~Watchdog} feature, which can restart the editor in case
  * of a {@link module:utils/ckeditorerror~CKEditorError} error.
  *
  * @param err The error to rethrow.
  * @param context An object connected through properties with the editor instance. This context will be used
  * by the watchdog to verify which editor should be restarted.
  */
  static rethrowUnexpectedError(t, i) {
    if (t.is && t.is("CKEditorError"))
      throw t;
    const r = new v(t.message, i);
    throw r.stack = t.stack, r;
  }
}
function at(e, n) {
  console.warn(...wE(e, n));
}
function Fv(e, n) {
  console.error(...wE(e, n));
}
function yE(e) {
  return `
Read more: ${Bv}#error-${e}`;
}
function Uv(e, n) {
  const t = /* @__PURE__ */ new WeakSet(), r = n ? ` ${JSON.stringify(n, (o, a) => {
    if (typeof a == "object" && a !== null) {
      if (t.has(a))
        return `[object ${a.constructor.name}]`;
      t.add(a);
    }
    return a;
  })}` : "", s = yE(e);
  return e + r + s;
}
function wE(e, n) {
  const t = yE(e);
  return n ? [
    e,
    n,
    t
  ] : [
    e,
    t
  ];
}
const Hv = "44.3.0", Vv = new Date(2025, 2, 5);
/* istanbul ignore next -- @preserve */
if (globalThis.CKEDITOR_VERSION)
  throw new v("ckeditor-duplicated-modules", null);
globalThis.CKEDITOR_VERSION = Hv;
const Ms = Symbol("listeningTo"), wh = Symbol("emitterId"), Oi = Symbol("delegations"), AE = /* @__PURE__ */ Je(Object);
function Je(e) {
  if (!e)
    return AE;
  class n extends e {
    on(i, r, s) {
      this.listenTo(this, i, r, s);
    }
    once(i, r, s) {
      let o = !1;
      const a = (u, ...l) => {
        o || (o = !0, u.off(), r.call(this, u, ...l));
      };
      this.listenTo(this, i, a, s);
    }
    off(i, r) {
      this.stopListening(this, i, r);
    }
    listenTo(i, r, s, o = {}) {
      let a, u;
      this[Ms] || (this[Ms] = {});
      const l = this[Ms];
      ed(i) || CE(i);
      const c = ed(i);
      (a = l[c]) || (a = l[c] = {
        emitter: i,
        callbacks: {}
      }), (u = a.callbacks[r]) || (u = a.callbacks[r] = []), u.push(s), Yv(this, i, r, s, o);
    }
    stopListening(i, r, s) {
      const o = this[Ms];
      let a = i && ed(i);
      const u = o && a ? o[a] : void 0, l = u && r ? u.callbacks[r] : void 0;
      if (!(!o || i && !u || r && !l))
        if (s)
          td(this, i, r, s), l.indexOf(s) !== -1 && (l.length === 1 ? delete u.callbacks[r] : td(this, i, r, s));
        else if (l) {
          for (; s = l.pop(); )
            td(this, i, r, s);
          delete u.callbacks[r];
        } else if (u) {
          for (r in u.callbacks)
            this.stopListening(i, r);
          delete o[a];
        } else {
          for (a in o)
            this.stopListening(o[a].emitter);
          delete this[Ms];
        }
    }
    fire(i, ...r) {
      try {
        const s = i instanceof Wi ? i : new Wi(this, i), o = s.name;
        let a = qv(this, o);
        if (s.path.push(this), a) {
          a = a.slice();
          for (let l = 0; l < a.length; l++) {
            const c = a[l].callback;
            if (c.call(this, s, ...r), s.off.called && (delete s.off.called, this._removeEventListener(o, c)), s.stop.called)
              break;
          }
        }
        const u = this[Oi];
        if (u) {
          const l = u.get(o), c = u.get("*");
          l && X0(l, s, r), c && X0(c, s, r);
        }
        return s.return;
      } catch (s) {
        /* istanbul ignore next -- @preserve */
        v.rethrowUnexpectedError(s, this);
      }
    }
    delegate(...i) {
      return {
        to: (r, s) => {
          this[Oi] || (this[Oi] = /* @__PURE__ */ new Map()), i.forEach((o) => {
            const a = this[Oi].get(o);
            a ? a.set(r, s) : this[Oi].set(o, /* @__PURE__ */ new Map([
              [
                r,
                s
              ]
            ]));
          });
        }
      };
    }
    stopDelegating(i, r) {
      if (this[Oi])
        if (!i)
          this[Oi].clear();
        else if (!r)
          this[Oi].delete(i);
        else {
          const s = this[Oi].get(i);
          s && s.delete(r);
        }
    }
    _addEventListener(i, r, s) {
      zv(this, i);
      const o = Ah(this, i), a = pr.get(s.priority), u = {
        callback: r,
        priority: a
      };
      for (const l of o)
        Mv(l, u);
    }
    _removeEventListener(i, r) {
      const s = Ah(this, i);
      for (const o of s)
        for (let a = 0; a < o.length; a++)
          o[a].callback == r && (o.splice(a, 1), a--);
    }
  }
  return n;
}
[
  "on",
  "once",
  "off",
  "listenTo",
  "stopListening",
  "fire",
  "delegate",
  "stopDelegating",
  "_addEventListener",
  "_removeEventListener"
].forEach((e) => {
  Je[e] = AE.prototype[e];
});
function $v(e, n) {
  const t = e[Ms];
  return t && t[n] ? t[n].emitter : null;
}
function CE(e, n) {
  e[wh] || (e[wh] = n || un());
}
function ed(e) {
  return e[wh];
}
function kE(e) {
  return e._events || Object.defineProperty(e, "_events", {
    value: {}
  }), e._events;
}
function Wv() {
  return {
    callbacks: [],
    childEvents: []
  };
}
function zv(e, n) {
  const t = kE(e);
  if (t[n])
    return;
  let i = n, r = null;
  const s = [];
  for (; i !== "" && !t[i]; )
    t[i] = Wv(), s.push(t[i]), r && t[i].childEvents.push(r), r = i, i = i.substr(0, i.lastIndexOf(":"));
  if (i !== "") {
    for (const o of s)
      o.callbacks = t[i].callbacks.slice();
    t[i].childEvents.push(r);
  }
}
function Ah(e, n) {
  const t = kE(e)[n];
  if (!t)
    return [];
  let i = [
    t.callbacks
  ];
  for (let r = 0; r < t.childEvents.length; r++) {
    const s = Ah(e, t.childEvents[r]);
    i = i.concat(s);
  }
  return i;
}
function qv(e, n) {
  if (!e._events)
    return null;
  let t = n;
  do {
    const i = e._events[t];
    if (i && i.callbacks && i.callbacks.length)
      return i.callbacks;
    const r = t.lastIndexOf(":");
    t = r > -1 ? t.substring(0, r) : "";
  } while (t);
  return null;
}
function X0(e, n, t) {
  for (let [i, r] of e) {
    r ? typeof r == "function" && (r = r(n.name)) : r = n.name;
    const s = new Wi(n.source, r);
    s.path = [
      ...n.path
    ], i.fire(s, ...t);
  }
}
function Yv(e, n, t, i, r) {
  n._addEventListener ? n._addEventListener(t, i, r) : e._addEventListener.call(n, t, i, r);
}
function td(e, n, t, i) {
  n._removeEventListener ? n._removeEventListener(t, i) : e._removeEventListener.call(n, t, i);
}
const ia = Symbol("observableProperties"), va = Symbol("boundObservables"), ra = Symbol("boundProperties"), Br = Symbol("decoratedMethods"), J0 = Symbol("decoratedOriginal"), SE = /* @__PURE__ */ pt(/* @__PURE__ */ Je());
function pt(e) {
  var t, i, r, s, o;
  if (!e)
    return SE;
  class n extends (o = e, s = ia, r = Br, i = ra, t = va, o) {
    constructor() {
      super(...arguments);
      m(this, s);
      m(this, r);
      m(this, i);
      m(this, t);
    }
    set(l, c) {
      if (ft(l)) {
        Object.keys(l).forEach((p) => {
          this.set(p, l[p]);
        }, this);
        return;
      }
      nd(this);
      const d = this[ia];
      if (l in this && !d.has(l))
        throw new v("observable-set-cannot-override", this);
      Object.defineProperty(this, l, {
        enumerable: !0,
        configurable: !0,
        get() {
          return d.get(l);
        },
        set(p) {
          const g = d.get(l);
          let b = this.fire(`set:${l}`, l, p, g);
          b === void 0 && (b = p), (g !== b || !d.has(l)) && (d.set(l, b), this.fire(`change:${l}`, l, b, g));
        }
      }), this[l] = c;
    }
    bind(...l) {
      if (!l.length || !Z0(l))
        throw new v("observable-bind-wrong-properties", this);
      if (new Set(l).size !== l.length)
        throw new v("observable-bind-duplicate-properties", this);
      nd(this);
      const c = this[ra];
      l.forEach((p) => {
        if (c.has(p))
          throw new v("observable-bind-rebind", this);
      });
      const d = /* @__PURE__ */ new Map();
      return l.forEach((p) => {
        const g = {
          property: p,
          to: []
        };
        c.set(p, g), d.set(p, g);
      }), {
        to: jv,
        toMany: Kv,
        _observable: this,
        _bindProperties: l,
        _to: [],
        _bindings: d
      };
    }
    unbind(...l) {
      if (!this[ia])
        return;
      const c = this[ra], d = this[va];
      if (l.length) {
        if (!Z0(l))
          throw new v("observable-unbind-wrong-properties", this);
        l.forEach((p) => {
          const g = c.get(p);
          g && (g.to.forEach(([b, _]) => {
            const k = d.get(b), C = k[_];
            C.delete(g), C.size || delete k[_], Object.keys(k).length || (d.delete(b), this.stopListening(b, "change"));
          }), c.delete(p));
        });
      } else
        d.forEach((p, g) => {
          this.stopListening(g, "change");
        }), d.clear(), c.clear();
    }
    decorate(l) {
      nd(this);
      const c = this[l];
      if (!c)
        throw new v("observablemixin-cannot-decorate-undefined", this, {
          object: this,
          methodName: l
        });
      this.on(l, (d, p) => {
        d.return = c.apply(this, p);
      }), this[l] = function(...d) {
        return this.fire(l, d);
      }, this[l][J0] = c, this[Br] || (this[Br] = []), this[Br].push(l);
    }
    // Override the EmitterMixin stopListening method to be able to clean (and restore) decorated methods.
    // This is needed in case of:
    //  1. Have x.foo() decorated.
    //  2. Call x.stopListening()
    //  3. Call x.foo(). Problem: nothing happens (the original foo() method is not executed)
    stopListening(l, c, d) {
      if (!l && this[Br]) {
        for (const p of this[Br])
          this[p] = this[p][J0];
        delete this[Br];
      }
      super.stopListening(l, c, d);
    }
  }
  return n;
}
[
  "set",
  "bind",
  "unbind",
  "decorate",
  "on",
  "once",
  "off",
  "listenTo",
  "stopListening",
  "fire",
  "delegate",
  "stopDelegating",
  "_addEventListener",
  "_removeEventListener"
].forEach((e) => {
  pt[e] = SE.prototype[e];
});
function nd(e) {
  e[ia] || (Object.defineProperty(e, ia, {
    value: /* @__PURE__ */ new Map()
  }), Object.defineProperty(e, va, {
    value: /* @__PURE__ */ new Map()
  }), Object.defineProperty(e, ra, {
    value: /* @__PURE__ */ new Map()
  }));
}
function jv(...e) {
  const n = Qv(...e), t = Array.from(this._bindings.keys()), i = t.length;
  if (!n.callback && n.to.length > 1)
    throw new v("observable-bind-to-no-callback", this);
  if (i > 1 && n.callback)
    throw new v("observable-bind-to-extra-callback", this);
  n.to.forEach((r) => {
    if (r.properties.length && r.properties.length !== i)
      throw new v("observable-bind-to-properties-length", this);
    r.properties.length || (r.properties = this._bindProperties);
  }), this._to = n.to, n.callback && (this._bindings.get(t[0]).callback = n.callback), Zv(this._observable, this._to), Jv(this), this._bindProperties.forEach((r) => {
    IE(this._observable, r);
  });
}
function Kv(e, n, t) {
  if (this._bindings.size > 1)
    throw new v("observable-bind-to-many-not-one-binding", this);
  this.to(
    ...Gv(e, n),
    // ...using given callback to parse attribute values.
    t
  );
}
function Gv(e, n) {
  const t = e.map((i) => [
    i,
    n
  ]);
  return Array.prototype.concat.apply([], t);
}
function Z0(e) {
  return e.every((n) => typeof n == "string");
}
function Qv(...e) {
  if (!e.length)
    throw new v("observable-bind-to-parse-error", null);
  const n = {
    to: []
  };
  let t;
  return typeof e[e.length - 1] == "function" && (n.callback = e.pop()), e.forEach((i) => {
    if (typeof i == "string")
      t.properties.push(i);
    else if (typeof i == "object")
      t = {
        observable: i,
        properties: []
      }, n.to.push(t);
    else
      throw new v("observable-bind-to-parse-error", null);
  }), n;
}
function Xv(e, n, t, i) {
  const r = e[va], s = r.get(t), o = s || {};
  o[i] || (o[i] = /* @__PURE__ */ new Set()), o[i].add(n), s || r.set(t, o);
}
function Jv(e) {
  let n;
  e._bindings.forEach((t, i) => {
    e._to.forEach((r) => {
      n = r.properties[t.callback ? 0 : e._bindProperties.indexOf(i)], t.to.push([
        r.observable,
        n
      ]), Xv(e._observable, t, r.observable, n);
    });
  });
}
function IE(e, n) {
  const i = e[ra].get(n);
  let r;
  i.callback ? r = i.callback.apply(e, i.to.map((s) => s[0][s[1]])) : (r = i.to[0], r = r[0][r[1]]), Object.prototype.hasOwnProperty.call(e, n) ? e[n] = r : e.set(n, r);
}
function Zv(e, n) {
  n.forEach((t) => {
    const i = e[va];
    let r;
    i.get(t.observable) || e.listenTo(t.observable, "change", (s, o) => {
      r = i.get(t.observable)[o], r && r.forEach((a) => {
        IE(e, a.property);
      });
    });
  });
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class eP {
  constructor() {
    /**
    * The elements replaced by {@link #replace} and their replacements.
    */
    m(this, "_replacedElements");
    this._replacedElements = [];
  }
  /**
  * Hides the `element` and, if specified, inserts the the given element next to it.
  *
  * The effect of this method can be reverted by {@link #restore}.
  *
  * @param element The element to replace.
  * @param newElement The replacement element. If not passed, then the `element` will just be hidden.
  */
  replace(n, t) {
    this._replacedElements.push({
      element: n,
      newElement: t
    }), n.style.display = "none", t && n.parentNode.insertBefore(t, n.nextSibling);
  }
  /**
  * Restores what {@link #replace} did.
  */
  restore() {
    this._replacedElements.forEach(({ element: n, newElement: t }) => {
      n.style.display = "", t && t.remove();
    }), this._replacedElements = [];
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function Ch(e) {
  let n = 0;
  for (const t of e)
    n++;
  return n;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function sn(e, n) {
  const t = Math.min(e.length, n.length);
  for (let i = 0; i < t; i++)
    if (e[i] != n[i])
      return i;
  return e.length == n.length ? "same" : e.length < n.length ? "prefix" : "extension";
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function Nn(e) {
  return !!(e && e[Symbol.iterator]);
}
function Zn(e, n, t = {}, i = []) {
  const r = t && t.xmlns, s = r ? e.createElementNS(r, n) : e.createElement(n);
  for (const o in t)
    s.setAttribute(o, t[o]);
  (Y0(i) || !Nn(i)) && (i = [
    i
  ]);
  for (let o of i)
    Y0(o) && (o = e.createTextNode(o)), s.appendChild(o);
  return s;
}
class xE {
  /**
  * Creates an instance of the {@link ~Config} class.
  *
  * @param configurations The initial configurations to be set. Usually, provided by the user.
  * @param defaultConfigurations The default configurations. Usually, provided by the system.
  */
  constructor(n, t) {
    /**
    * Store for the whole configuration.
    */
    m(this, "_config");
    this._config = /* @__PURE__ */ Object.create(null), t && this.define(ep(t)), n && this._setObjectToTarget(this._config, n);
  }
  set(n, t) {
    this._setToTarget(this._config, n, t);
  }
  define(n, t) {
    this._setToTarget(this._config, n, t, !0);
  }
  /**
  * Gets the value for a configuration entry.
  *
  * ```ts
  * config.get( 'name' );
  * ```
  *
  * Deep configurations can be retrieved by separating each part with a dot.
  *
  * ```ts
  * config.get( 'toolbar.collapsed' );
  * ```
  *
  * @param name The configuration name. Configuration names are case-sensitive.
  * @returns The configuration value or `undefined` if the configuration entry was not found.
  */
  get(n) {
    return this._getFromSource(this._config, n);
  }
  /**
  * Iterates over all top level configuration names.
  */
  *names() {
    for (const n of Object.keys(this._config))
      yield n;
  }
  /**
  * Saves passed configuration to the specified target (nested object).
  *
  * @param target Nested config object.
  * @param name The configuration name or an object from which take properties as
  * configuration entries. Configuration names are case-sensitive.
  * @param value The configuration value. Used if a name is passed.
  * @param isDefine Define if passed configuration should overwrite existing one.
  */
  _setToTarget(n, t, i, r = !1) {
    if (Mi(t)) {
      this._setObjectToTarget(n, t, r);
      return;
    }
    const s = t.split(".");
    t = s.pop();
    for (const o of s)
      Mi(n[o]) || (n[o] = /* @__PURE__ */ Object.create(null)), n = n[o];
    if (Mi(i)) {
      Mi(n[t]) || (n[t] = /* @__PURE__ */ Object.create(null)), n = n[t], this._setObjectToTarget(n, i, r);
      return;
    }
    r && typeof n[t] < "u" || (n[t] = i);
  }
  /**
  * Get specified configuration from specified source (nested object).
  *
  * @param source level of nested object.
  * @param name The configuration name. Configuration names are case-sensitive.
  * @returns The configuration value or `undefined` if the configuration entry was not found.
  */
  _getFromSource(n, t) {
    const i = t.split(".");
    t = i.pop();
    for (const r of i) {
      if (!Mi(n[r])) {
        n = null;
        break;
      }
      n = n[r];
    }
    return n ? ep(n[t]) : void 0;
  }
  /**
  * Iterates through passed object and calls {@link #_setToTarget} method with object key and value for each property.
  *
  * @param target Nested config object.
  * @param configuration Configuration data set
  * @param isDefine Defines if passed configuration is default configuration or not.
  */
  _setObjectToTarget(n, t, i) {
    Object.keys(t).forEach((r) => {
      this._setToTarget(n, r, t[r], i);
    });
  }
}
function ep(e) {
  return Ff(e, tP);
}
function tP(e) {
  return Er(e) || typeof e == "function" ? e : void 0;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function Tr(e) {
  if (e) {
    if (e.defaultView)
      return e instanceof e.defaultView.Document;
    if (e.ownerDocument && e.ownerDocument.defaultView)
      return e instanceof e.ownerDocument.defaultView.Node;
  }
  return !1;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function gl(e) {
  const n = Object.prototype.toString.apply(e);
  return n == "[object Window]" || n == "[object global]";
}
const vE = /* @__PURE__ */ li(/* @__PURE__ */ Je());
function li(e) {
  if (!e)
    return vE;
  class n extends e {
    listenTo(i, r, s, o = {}) {
      if (Tr(i) || gl(i)) {
        const a = {
          capture: !!o.useCapture,
          passive: !!o.usePassive
        }, u = this._getProxyEmitter(i, a) || new nP(i, a);
        this.listenTo(u, r, s, o);
      } else
        super.listenTo(i, r, s, o);
    }
    stopListening(i, r, s) {
      if (Tr(i) || gl(i)) {
        const o = this._getAllProxyEmitters(i);
        for (const a of o)
          this.stopListening(a, r, s);
      } else
        super.stopListening(i, r, s);
    }
    /**
    * Retrieves ProxyEmitter instance for given DOM Node residing in this Host and given options.
    *
    * @param node DOM Node of the ProxyEmitter.
    * @param options Additional options.
    * @param options.useCapture Indicates that events of this type will be dispatched to the registered
    * listener before being dispatched to any EventTarget beneath it in the DOM tree.
    * @param options.usePassive Indicates that the function specified by listener will never call preventDefault()
    * and prevents blocking browser's main thread by this event handler.
    * @returns ProxyEmitter instance bound to the DOM Node.
    */
    _getProxyEmitter(i, r) {
      return $v(this, PE(i, r));
    }
    /**
    * Retrieves all the ProxyEmitter instances for given DOM Node residing in this Host.
    *
    * @param node DOM Node of the ProxyEmitter.
    */
    _getAllProxyEmitters(i) {
      return [
        {
          capture: !1,
          passive: !1
        },
        {
          capture: !1,
          passive: !0
        },
        {
          capture: !0,
          passive: !1
        },
        {
          capture: !0,
          passive: !0
        }
      ].map((r) => this._getProxyEmitter(i, r)).filter((r) => !!r);
    }
  }
  return n;
}
[
  "_getProxyEmitter",
  "_getAllProxyEmitters",
  "on",
  "once",
  "off",
  "listenTo",
  "stopListening",
  "fire",
  "delegate",
  "stopDelegating",
  "_addEventListener",
  "_removeEventListener"
].forEach((e) => {
  li[e] = vE.prototype[e];
});
class nP extends (/* @__PURE__ */ Je()) {
  /**
  * @param node DOM Node that fires events.
  * @param options Additional options.
  * @param options.useCapture Indicates that events of this type will be dispatched to the registered
  * listener before being dispatched to any EventTarget beneath it in the DOM tree.
  * @param options.usePassive Indicates that the function specified by listener will never call preventDefault()
  * and prevents blocking browser's main thread by this event handler.
  */
  constructor(t, i) {
    super();
    m(this, "_domNode");
    m(this, "_options");
    /**
    * Collection of native DOM listeners.
    */
    m(this, "_domListeners");
    CE(this, PE(t, i)), this._domNode = t, this._options = i;
  }
  /**
  * Registers a callback function to be executed when an event is fired.
  *
  * It attaches a native DOM listener to the DOM Node. When fired,
  * a corresponding Emitter event will also fire with DOM Event object as an argument.
  *
  * **Note**: This is automatically called by the
  * {@link module:utils/emittermixin~Emitter#listenTo `Emitter#listenTo()`}.
  *
  * @param event The name of the event.
  */
  attach(t) {
    if (this._domListeners && this._domListeners[t])
      return;
    const i = this._createDomListener(t);
    this._domNode.addEventListener(t, i, this._options), this._domListeners || (this._domListeners = {}), this._domListeners[t] = i;
  }
  /**
  * Stops executing the callback on the given event.
  *
  * **Note**: This is automatically called by the
  * {@link module:utils/emittermixin~Emitter#stopListening `Emitter#stopListening()`}.
  *
  * @param event The name of the event.
  */
  detach(t) {
    let i;
    this._domListeners[t] && (!(i = this._events[t]) || !i.callbacks.length) && this._domListeners[t].removeListener();
  }
  /**
  * Adds callback to emitter for given event.
  *
  * @internal
  * @param event The name of the event.
  * @param callback The function to be called on event.
  * @param options Additional options.
  */
  _addEventListener(t, i, r) {
    this.attach(t), Je().prototype._addEventListener.call(this, t, i, r);
  }
  /**
  * Removes callback from emitter for given event.
  *
  * @internal
  * @param event The name of the event.
  * @param callback The function to stop being called.
  */
  _removeEventListener(t, i) {
    Je().prototype._removeEventListener.call(this, t, i), this.detach(t);
  }
  /**
  * Creates a native DOM listener callback. When the native DOM event
  * is fired it will fire corresponding event on this ProxyEmitter.
  * Note: A native DOM Event is passed as an argument.
  *
  * @param event The name of the event.
  * @returns The DOM listener callback.
  */
  _createDomListener(t) {
    const i = (r) => {
      this.fire(t, r);
    };
    return i.removeListener = () => {
      this._domNode.removeEventListener(t, i, this._options), delete this._domListeners[t];
    }, i;
  }
}
function iP(e) {
  return e["data-ck-expando"] || (e["data-ck-expando"] = un());
}
function PE(e, n) {
  let t = iP(e);
  for (const i of Object.keys(n).sort())
    n[i] && (t += "-" + i);
  return t;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function rP(e) {
  const n = [];
  let t = e;
  for (; t && t.nodeType != Node.DOCUMENT_NODE; )
    n.unshift(t), t = t.parentNode;
  return n;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function sP(e) {
  return e instanceof HTMLTextAreaElement ? e.value : e.innerHTML;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function OE(e) {
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return {
    top: parseInt(n.borderTopWidth, 10),
    right: parseInt(n.borderRightWidth, 10),
    bottom: parseInt(n.borderBottomWidth, 10),
    left: parseInt(n.borderLeftWidth, 10)
  };
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function NE(e) {
  if (!e.target)
    return null;
  const n = e.target.ownerDocument, t = e.clientX, i = e.clientY;
  let r = null;
  return n.caretRangeFromPoint && n.caretRangeFromPoint(t, i) ? r = n.caretRangeFromPoint(t, i) : e.rangeParent && (r = n.createRange(), r.setStart(e.rangeParent, e.rangeOffset), r.collapse(!0)), r;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function mt(e) {
  return Object.prototype.toString.call(e) == "[object Text]";
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function tc(e) {
  return Object.prototype.toString.apply(e) == "[object Range]";
}
function RE(e) {
  return !e || !e.parentNode || e.offsetParent === ue.document.body ? null : e.offsetParent;
}
const LE = [
  "top",
  "right",
  "bottom",
  "left",
  "width",
  "height"
];
class Se {
  /**
  * Creates an instance of rect.
  *
  * ```ts
  * // Rect of an HTMLElement.
  * const rectA = new Rect( document.body );
  *
  * // Rect of a DOM Range.
  * const rectB = new Rect( document.getSelection().getRangeAt( 0 ) );
  *
  * // Rect of a window (web browser viewport).
  * const rectC = new Rect( window );
  *
  * // Rect out of an object.
  * const rectD = new Rect( { top: 0, right: 10, bottom: 10, left: 0, width: 10, height: 10 } );
  *
  * // Rect out of another Rect instance.
  * const rectE = new Rect( rectD );
  *
  * // Rect out of a ClientRect.
  * const rectF = new Rect( document.body.getClientRects().item( 0 ) );
  * ```
  *
  * **Note**: By default a rect of an HTML element includes its CSS borders and scrollbars (if any)
  * ant the rect of a `window` includes scrollbars too. Use {@link #excludeScrollbarsAndBorders}
  * to get the inner part of the rect.
  *
  * @param source A source object to create the rect.
  */
  constructor(n) {
    /**
    * The "top" value of the rect.
    *
    * @readonly
    */
    m(this, "top");
    /**
    * The "right" value of the rect.
    *
    * @readonly
    */
    m(this, "right");
    /**
    * The "bottom" value of the rect.
    *
    * @readonly
    */
    m(this, "bottom");
    /**
    * The "left" value of the rect.
    *
    * @readonly
    */
    m(this, "left");
    /**
    * The "width" value of the rect.
    *
    * @readonly
    */
    m(this, "width");
    /**
    * The "height" value of the rect.
    *
    * @readonly
    */
    m(this, "height");
    /**
    * The object this rect is for.
    *
    * @readonly
    */
    m(this, "_source");
    const t = tc(n);
    if (Object.defineProperty(this, "_source", {
      // If the source is a Rect instance, copy it's #_source.
      value: n._source || n,
      writable: !0,
      enumerable: !1
    }), kh(n) || t)
      if (t) {
        const i = Se.getDomRangeRects(n);
        Cu(this, Se.getBoundingRect(i));
      } else
        Cu(this, n.getBoundingClientRect());
    else if (gl(n)) {
      const { innerWidth: i, innerHeight: r } = n;
      Cu(this, {
        top: 0,
        right: i,
        bottom: r,
        left: 0,
        width: i,
        height: r
      });
    } else
      Cu(this, n);
  }
  /**
  * Returns a clone of the rect.
  *
  * @returns A cloned rect.
  */
  clone() {
    return new Se(this);
  }
  /**
  * Moves the rect so that its upper–left corner lands in desired `[ x, y ]` location.
  *
  * @param x Desired horizontal location.
  * @param y Desired vertical location.
  * @returns A rect which has been moved.
  */
  moveTo(n, t) {
    return this.top = t, this.right = n + this.width, this.bottom = t + this.height, this.left = n, this;
  }
  /**
  * Moves the rect in–place by a dedicated offset.
  *
  * @param x A horizontal offset.
  * @param y A vertical offset
  * @returns A rect which has been moved.
  */
  moveBy(n, t) {
    return this.top += t, this.right += n, this.left += n, this.bottom += t, this;
  }
  /**
  * Returns a new rect a a result of intersection with another rect.
  */
  getIntersection(n) {
    const t = {
      top: Math.max(this.top, n.top),
      right: Math.min(this.right, n.right),
      bottom: Math.min(this.bottom, n.bottom),
      left: Math.max(this.left, n.left),
      width: 0,
      height: 0
    };
    if (t.width = t.right - t.left, t.height = t.bottom - t.top, t.width < 0 || t.height < 0)
      return null;
    {
      const i = new Se(t);
      return i._source = this._source, i;
    }
  }
  /**
  * Returns the area of intersection with another rect.
  *
  * @returns Area of intersection.
  */
  getIntersectionArea(n) {
    const t = this.getIntersection(n);
    return t ? t.getArea() : 0;
  }
  /**
  * Returns the area of the rect.
  */
  getArea() {
    return this.width * this.height;
  }
  /**
  * Returns a new rect, a part of the original rect, which is actually visible to the user and is relative to the,`body`,
  * e.g. an original rect cropped by parent element rects which have `overflow` set in CSS
  * other than `"visible"`.
  *
  * If there's no such visible rect, which is when the rect is limited by one or many of
  * the ancestors, `null` is returned.
  *
  * **Note**: This method does not consider the boundaries of the viewport (window).
  * To get a rect cropped by all ancestors and the viewport, use an intersection such as:
  *
  * ```ts
  * const visibleInViewportRect = new Rect( window ).getIntersection( new Rect( source ).getVisible() );
  * ```
  *
  * @returns A visible rect instance or `null`, if there's none.
  */
  getVisible() {
    const n = this._source;
    let t = this.clone();
    if (tp(n))
      return t;
    let i = n, r = n.parentNode || n.commonAncestorContainer, s;
    for (; r && !tp(r); ) {
      const o = oP(r) === "visible";
      i instanceof HTMLElement && np(i) === "absolute" && (s = i);
      const a = np(r);
      if (o || s && (a === "relative" && o || a !== "relative")) {
        i = r, r = r.parentNode;
        continue;
      }
      const u = new Se(r), l = t.getIntersection(u);
      if (l)
        l.getArea() < t.getArea() && (t = l);
      else
        return null;
      i = r, r = r.parentNode;
    }
    return t;
  }
  /**
  * Checks if all property values ({@link #top}, {@link #left}, {@link #right},
  * {@link #bottom}, {@link #width} and {@link #height}) are the equal in both rect
  * instances.
  *
  * @param anotherRect A rect instance to compare with.
  * @returns `true` when Rects are equal. `false` otherwise.
  */
  isEqual(n) {
    for (const t of LE)
      if (this[t] !== n[t])
        return !1;
    return !0;
  }
  /**
  * Checks whether a rect fully contains another rect instance.
  *
  * @param anotherRect
  * @returns `true` if contains, `false` otherwise.
  */
  contains(n) {
    const t = this.getIntersection(n);
    return !!(t && t.isEqual(n));
  }
  /**
  * Recalculates screen coordinates to coordinates relative to the positioned ancestor offset.
  */
  toAbsoluteRect() {
    const { scrollX: n, scrollY: t } = ue.window, i = this.clone().moveBy(n, t);
    if (kh(i._source)) {
      const r = RE(i._source);
      r && aP(i, r);
    }
    return i;
  }
  /**
  * Excludes scrollbars and CSS borders from the rect.
  *
  * * Borders are removed when {@link #_source} is an HTML element.
  * * Scrollbars are excluded from HTML elements and the `window`.
  *
  * @returns A rect which has been updated.
  */
  excludeScrollbarsAndBorders() {
    const n = this._source;
    let t, i, r;
    if (gl(n))
      t = n.innerWidth - n.document.documentElement.clientWidth, i = n.innerHeight - n.document.documentElement.clientHeight, r = n.getComputedStyle(n.document.documentElement).direction;
    else {
      const s = OE(n);
      t = n.offsetWidth - n.clientWidth - s.left - s.right, i = n.offsetHeight - n.clientHeight - s.top - s.bottom, r = n.ownerDocument.defaultView.getComputedStyle(n).direction, this.left += s.left, this.top += s.top, this.right -= s.right, this.bottom -= s.bottom, this.width = this.right - this.left, this.height = this.bottom - this.top;
    }
    return this.width -= t, r === "ltr" ? this.right -= t : this.left += t, this.height -= i, this.bottom -= i, this;
  }
  /**
  * Returns an array of rects of the given native DOM Range.
  *
  * @param range A native DOM range.
  * @returns DOM Range rects.
  */
  static getDomRangeRects(n) {
    const t = [], i = Array.from(n.getClientRects());
    if (i.length)
      for (const r of i)
        t.push(new Se(r));
    else {
      let r = n.startContainer;
      mt(r) && (r = r.parentNode);
      const s = new Se(r.getBoundingClientRect());
      s.right = s.left, s.width = 0, t.push(s);
    }
    return t;
  }
  /**
  * Returns a bounding rectangle that contains all the given `rects`.
  *
  * @param rects A list of rectangles that should be contained in the result rectangle.
  * @returns Bounding rectangle or `null` if no `rects` were given.
  */
  static getBoundingRect(n) {
    const t = {
      left: Number.POSITIVE_INFINITY,
      top: Number.POSITIVE_INFINITY,
      right: Number.NEGATIVE_INFINITY,
      bottom: Number.NEGATIVE_INFINITY,
      width: 0,
      height: 0
    };
    let i = 0;
    for (const r of n)
      i++, t.left = Math.min(t.left, r.left), t.top = Math.min(t.top, r.top), t.right = Math.max(t.right, r.right), t.bottom = Math.max(t.bottom, r.bottom);
    return i == 0 ? null : (t.width = t.right - t.left, t.height = t.bottom - t.top, new Se(t));
  }
}
function Cu(e, n) {
  for (const t of LE)
    e[t] = n[t];
}
function tp(e) {
  return kh(e) ? e === e.ownerDocument.body : !1;
}
function kh(e) {
  return e !== null && typeof e == "object" && e.nodeType === 1 && typeof e.getBoundingClientRect == "function";
}
function np(e) {
  return e instanceof HTMLElement ? e.ownerDocument.defaultView.getComputedStyle(e).position : "static";
}
function oP(e) {
  return e instanceof HTMLElement ? e.ownerDocument.defaultView.getComputedStyle(e).overflow : "visible";
}
function aP(e, n) {
  const t = new Se(n), i = OE(n);
  let r = 0, s = 0;
  r -= t.left, s -= t.top, r += n.scrollLeft, s += n.scrollTop, r -= i.left, s -= i.top, e.moveBy(r, s);
}
const dt = class dt {
  /**
  * Creates an instance of the `ResizeObserver` class.
  *
  * @param element A DOM element that is to be observed for resizing. Note that
  * the element must be visible (i.e. not detached from DOM) for the observer to work.
  * @param callback A function called when the observed element was resized. It passes
  * the [`ResizeObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry)
  * object with information about the resize event.
  */
  constructor(n, t) {
    /**
    * The element observed by this observer.
    */
    m(this, "_element");
    /**
    * The callback executed each time {@link #_element} is resized.
    */
    m(this, "_callback");
    dt._observerInstance || dt._createObserver(), this._element = n, this._callback = t, dt._addElementCallback(n, t), dt._observerInstance.observe(n);
  }
  /**
  * The element observed by this observer.
  */
  get element() {
    return this._element;
  }
  /**
  * Destroys the observer which disables the `callback` passed to the {@link #constructor}.
  */
  destroy() {
    dt._deleteElementCallback(this._element, this._callback);
  }
  /**
  * Registers a new resize callback for the DOM element.
  */
  static _addElementCallback(n, t) {
    dt._elementCallbacks || (dt._elementCallbacks = /* @__PURE__ */ new Map());
    let i = dt._elementCallbacks.get(n);
    i || (i = /* @__PURE__ */ new Set(), dt._elementCallbacks.set(n, i)), i.add(t);
  }
  /**
  * Removes a resize callback from the DOM element. If no callbacks are left
  * for the element, it removes the element from the native observer.
  */
  static _deleteElementCallback(n, t) {
    const i = dt._getElementCallbacks(n);
    i && (i.delete(t), i.size || (dt._elementCallbacks.delete(n), dt._observerInstance.unobserve(n))), dt._elementCallbacks && !dt._elementCallbacks.size && (dt._observerInstance = null, dt._elementCallbacks = null);
  }
  /**
  * Returns are registered resize callbacks for the DOM element.
  */
  static _getElementCallbacks(n) {
    return dt._elementCallbacks ? dt._elementCallbacks.get(n) : null;
  }
  /**
  * Creates the single native observer shared across all `ResizeObserver` instances.
  */
  static _createObserver() {
    dt._observerInstance = new ue.window.ResizeObserver((n) => {
      for (const t of n) {
        const i = dt._getElementCallbacks(t.target);
        if (i)
          for (const r of i)
            r(t);
      }
    });
  }
};
/**
* The single native observer instance shared across all {@link module:utils/dom/resizeobserver~ResizeObserver} instances.
*/
m(dt, "_observerInstance", null), /**
* A mapping of native DOM elements and their callbacks shared across all
* {@link module:utils/dom/resizeobserver~ResizeObserver} instances.
*/
m(dt, "_elementCallbacks", null);
let Pa = dt;
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function ip(e, n) {
  e instanceof HTMLTextAreaElement && (e.value = n), e.innerHTML = n;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function nu(e) {
  return (n) => n + e;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function Qo(e) {
  let n = 0;
  for (; e.previousSibling; )
    e = e.previousSibling, n++;
  return n;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function DE(e, n, t) {
  e.insertBefore(t, e.childNodes[n] || null);
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function sa(e) {
  return e && e.nodeType === Node.COMMENT_NODE;
}
function uP(e) {
  try {
    ue.document.createAttribute(e);
  } catch {
    return !1;
  }
  return !0;
}
function zi(e) {
  return e ? mt(e) ? zi(e.parentElement) : e.getClientRects ? !!e.getClientRects().length : !1 : !1;
}
function Hf({ element: e, target: n, positions: t, limiter: i, fitInViewport: r, viewportOffsetConfig: s }) {
  ts(n) && (n = n()), ts(i) && (i = i());
  const o = RE(e), a = lP(s), u = new Se(e), l = rp(n, a);
  let c;
  if (!l || !a.getIntersection(l))
    return null;
  const d = {
    targetRect: l,
    elementRect: u,
    positionedElementAncestor: o,
    viewportRect: a
  };
  if (!i && !r)
    c = new ME(t[0], d);
  else {
    if (i) {
      const p = rp(i, a);
      p && (d.limiterRect = p);
    }
    c = cP(t, d);
  }
  return c;
}
function rp(e, n) {
  const t = new Se(e).getVisible();
  return t ? t.getIntersection(n) : null;
}
function lP(e) {
  e = Object.assign({
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  }, e);
  const n = new Se(ue.window);
  return n.top += e.top, n.height -= e.top, n.bottom -= e.bottom, n.height -= e.bottom, n;
}
function cP(e, n) {
  const { elementRect: t } = n, i = t.getArea(), r = e.map((a) => new ME(a, n)).filter((a) => !!a.name);
  let s = 0, o = null;
  for (const a of r) {
    const { limiterIntersectionArea: u, viewportIntersectionArea: l } = a;
    if (u === i)
      return a;
    const c = l ** 2 + u ** 2;
    c > s && (s = c, o = a);
  }
  return o;
}
class ME {
  /**
  * Creates an instance of the {@link module:utils/dom/position~PositionObject} class.
  *
  * @param positioningFunction function The function that defines the expected
  * coordinates the positioned element should move to.
  * @param options options object.
  * @param options.elementRect The positioned element rect.
  * @param options.targetRect The target element rect.
  * @param options.viewportRect The viewport rect.
  * @param options.limiterRect The limiter rect.
  * @param options.positionedElementAncestor Nearest element ancestor element which CSS position is not "static".
  */
  constructor(n, t) {
    m(this, "name");
    m(this, "config");
    m(this, "_positioningFunctionCoordinates");
    m(this, "_options");
    m(this, "_cachedRect");
    m(this, "_cachedAbsoluteRect");
    const i = n(t.targetRect, t.elementRect, t.viewportRect, t.limiterRect);
    if (!i)
      return;
    const { left: r, top: s, name: o, config: a } = i;
    this.name = o, this.config = a, this._positioningFunctionCoordinates = {
      left: r,
      top: s
    }, this._options = t;
  }
  /**
  * The left value in pixels in the CSS `position: absolute` coordinate system.
  * Set it on the positioned element in DOM to move it to the position.
  */
  get left() {
    return this._absoluteRect.left;
  }
  /**
  * The top value in pixels in the CSS `position: absolute` coordinate system.
  * Set it on the positioned element in DOM to move it to the position.
  */
  get top() {
    return this._absoluteRect.top;
  }
  /**
  * An intersection area between positioned element and limiter within viewport constraints.
  */
  get limiterIntersectionArea() {
    const n = this._options.limiterRect;
    return n ? n.getIntersectionArea(this._rect) : 0;
  }
  /**
  * An intersection area between positioned element and viewport.
  */
  get viewportIntersectionArea() {
    return this._options.viewportRect.getIntersectionArea(this._rect);
  }
  /**
  * An already positioned element rect. A clone of the element rect passed to the constructor
  * but placed in the viewport according to the positioning function.
  */
  get _rect() {
    return this._cachedRect ? this._cachedRect : (this._cachedRect = this._options.elementRect.clone().moveTo(this._positioningFunctionCoordinates.left, this._positioningFunctionCoordinates.top), this._cachedRect);
  }
  /**
  * An already absolutely positioned element rect. See ({@link #_rect}).
  */
  get _absoluteRect() {
    return this._cachedAbsoluteRect ? this._cachedAbsoluteRect : (this._cachedAbsoluteRect = this._rect.toAbsoluteRect(), this._cachedAbsoluteRect);
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function sp(e) {
  const n = e.parentNode;
  n && n.removeChild(e);
}
function dP({ target: e, viewportOffset: n = 0, ancestorOffset: t = 0, alignToTop: i, forceScroll: r }) {
  const s = Vf(e);
  let o = s, a = null;
  for (n = mP(n); o; ) {
    let u;
    o == s ? u = op(e) : u = op(a), fP({
      parent: u,
      getRect: () => id(e, o),
      alignToTop: i,
      ancestorOffset: t,
      forceScroll: r
    });
    let l = id(e, o);
    const c = id(u, o);
    if (l.height > c.height) {
      const d = l.getIntersection(c);
      d && (l = d);
    }
    if (hP({
      window: o,
      rect: l,
      viewportOffset: n,
      alignToTop: i,
      forceScroll: r
    }), o.parent != o) {
      if (a = o.frameElement, o = o.parent, !a)
        return;
    } else
      o = null;
  }
}
function hP({ window: e, rect: n, alignToTop: t, forceScroll: i, viewportOffset: r }) {
  const s = n.clone().moveBy(0, r.bottom), o = n.clone().moveBy(0, -r.top), a = new Se(e).excludeScrollbarsAndBorders(), u = [
    o,
    s
  ], l = t && i, c = u.every((_) => a.contains(_));
  let { scrollX: d, scrollY: p } = e;
  const g = d, b = p;
  l ? p -= a.top - n.top + r.top : c || (FE(o, a) ? p -= a.top - n.top + r.top : BE(s, a) && (t ? p += n.top - a.top - r.top : p += n.bottom - a.bottom + r.bottom)), c || (UE(n, a) ? d -= a.left - n.left + r.left : HE(n, a) && (d += n.right - a.right + r.right)), (d != g || p !== b) && e.scrollTo(d, p);
}
function fP({ parent: e, getRect: n, alignToTop: t, forceScroll: i, ancestorOffset: r = 0, limiterElement: s }) {
  const o = Vf(e), a = t && i;
  let u, l, c;
  const d = s || o.document.body;
  for (; e != d; )
    l = n(), u = new Se(e).excludeScrollbarsAndBorders(), c = u.contains(l), a ? e.scrollTop -= u.top - l.top + r : c || (FE(l, u) ? e.scrollTop -= u.top - l.top + r : BE(l, u) && (t ? e.scrollTop += l.top - u.top - r : e.scrollTop += l.bottom - u.bottom + r)), c || (UE(l, u) ? e.scrollLeft -= u.left - l.left + r : HE(l, u) && (e.scrollLeft += l.right - u.right + r)), e = e.parentNode;
}
function BE(e, n) {
  return e.bottom > n.bottom;
}
function FE(e, n) {
  return e.top < n.top;
}
function UE(e, n) {
  return e.left < n.left;
}
function HE(e, n) {
  return e.right > n.right;
}
function Vf(e) {
  return tc(e) ? e.startContainer.ownerDocument.defaultView : e.ownerDocument.defaultView;
}
function op(e) {
  if (tc(e)) {
    let n = e.commonAncestorContainer;
    return mt(n) && (n = n.parentNode), n;
  } else
    return e.parentNode;
}
function id(e, n) {
  const t = Vf(e), i = new Se(e);
  if (t === n)
    return i;
  {
    let r = t;
    for (; r != n; ) {
      const s = r.frameElement, o = new Se(s).excludeScrollbarsAndBorders();
      i.moveBy(o.left, o.top), r = r.parent;
    }
  }
  return i;
}
function mP(e) {
  return typeof e == "number" ? {
    top: e,
    bottom: e,
    left: e,
    right: e
  } : e;
}
const pP = {
  ctrl: "⌃",
  cmd: "⌘",
  alt: "⌥",
  shift: "⇧"
}, gP = {
  ctrl: "Ctrl+",
  alt: "Alt+",
  shift: "Shift+"
}, ap = {
  37: "←",
  38: "↑",
  39: "→",
  40: "↓",
  9: "⇥",
  33: "Page Up",
  34: "Page Down"
}, ye = /* @__PURE__ */ yP(), bP = /* @__PURE__ */ Object.fromEntries(/* @__PURE__ */ Object.entries(ye).map(([e, n]) => {
  let t;
  return n in ap ? t = ap[n] : t = e.charAt(0).toUpperCase() + e.slice(1), [
    n,
    t
  ];
}));
function Zs(e) {
  let n;
  if (typeof e == "string") {
    if (n = ye[e.toLowerCase()], !n)
      throw new v("keyboard-unknown-key", null, {
        key: e
      });
  } else
    n = e.keyCode + (e.altKey ? ye.alt : 0) + (e.ctrlKey ? ye.ctrl : 0) + (e.shiftKey ? ye.shift : 0) + (e.metaKey ? ye.cmd : 0);
  return n;
}
function $f(e) {
  return typeof e == "string" && (e = wP(e)), e.map((n) => typeof n == "string" ? EP(n) : n).reduce((n, t) => t + n, 0);
}
function bl(e, n) {
  let t = $f(e);
  const i = he.isMac || he.isiOS;
  return Object.entries(i ? pP : gP).reduce((o, [a, u]) => (t & ye[a] && (t &= ~ye[a], o += u), o), "") + (t ? bP[t] : "");
}
function _P(e) {
  return e == ye.arrowright || e == ye.arrowleft || e == ye.arrowup || e == ye.arrowdown;
}
function VE(e, n) {
  const t = n === "ltr";
  switch (e) {
    case ye.arrowleft:
      return t ? "left" : "right";
    case ye.arrowright:
      return t ? "right" : "left";
    case ye.arrowup:
      return "up";
    case ye.arrowdown:
      return "down";
  }
}
function EP(e) {
  if (e.endsWith("!"))
    return Zs(e.slice(0, -1));
  const n = Zs(e);
  return (he.isMac || he.isiOS) && n == ye.ctrl ? ye.cmd : n;
}
function TP(e, n) {
  const t = VE(e, n);
  return t === "down" || t === "right";
}
function yP() {
  const e = {
    pageup: 33,
    pagedown: 34,
    end: 35,
    home: 36,
    arrowleft: 37,
    arrowup: 38,
    arrowright: 39,
    arrowdown: 40,
    backspace: 8,
    delete: 46,
    enter: 13,
    space: 32,
    esc: 27,
    tab: 9,
    // The idea about these numbers is that they do not collide with any real key codes, so we can use them
    // like bit masks.
    ctrl: 1114112,
    shift: 2228224,
    alt: 4456448,
    cmd: 8912896
  };
  for (let n = 65; n <= 90; n++) {
    const t = String.fromCharCode(n);
    e[t.toLowerCase()] = n;
  }
  for (let n = 48; n <= 57; n++)
    e[n - 48] = n;
  for (let n = 112; n <= 123; n++)
    e["f" + (n - 111)] = n;
  return Object.assign(e, {
    "'": 222,
    ",": 108,
    "-": 109,
    ".": 110,
    "/": 111,
    ";": 186,
    "=": 187,
    "[": 219,
    "\\": 220,
    "]": 221,
    "`": 223
  }), e;
}
function wP(e) {
  return e.split("+").map((n) => n.trim());
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const AP = [
  "ar",
  "ara",
  "dv",
  "div",
  "fa",
  "per",
  "fas",
  "he",
  "heb",
  "ku",
  "kur",
  "ug",
  "uig"
  // Uighur, Uyghur
];
function up(e) {
  return AP.includes(e) ? "rtl" : "ltr";
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function Dt(e) {
  return Array.isArray(e) ? e : [
    e
  ];
}
/* istanbul ignore else -- @preserve */
ue.window.CKEDITOR_TRANSLATIONS || (ue.window.CKEDITOR_TRANSLATIONS = {});
function CP(e, n, t = 1, i) {
  if (typeof t != "number")
    throw new v("translation-service-quantity-not-a-number", null, {
      quantity: t
    });
  const r = i || ue.window.CKEDITOR_TRANSLATIONS, s = IP(r);
  s === 1 && (e = Object.keys(r)[0]);
  const o = n.id || n.string;
  if (s === 0 || !SP(e, o, r))
    return t !== 1 ? n.plural : n.string;
  const a = r[e].dictionary, u = r[e].getPluralForm || ((d) => d === 1 ? 0 : 1), l = a[o];
  if (typeof l == "string")
    return l;
  const c = Number(u(t));
  return l[c];
}
function kP(e) {
  return Array.isArray(e) ? e.reduce((n, t) => Uf(n, t)) : e;
}
function SP(e, n, t) {
  return !!t[e] && !!t[e].dictionary[n];
}
function IP(e) {
  return Object.keys(e).length;
}
class xP {
  /**
  * Creates a new instance of the locale class. Learn more about
  * {@glink getting-started/setup/ui-language configuring the language of the editor}.
  *
  * @param options Locale configuration.
  * @param options.uiLanguage The editor UI language code in the
  * [ISO 639-1](https://en.wikipedia.org/wiki/ISO_639-1) format. See {@link #uiLanguage}.
  * @param options.contentLanguage The editor content language code in the
  * [ISO 639-1](https://en.wikipedia.org/wiki/ISO_639-1) format. If not specified, the same as `options.language`.
  * See {@link #contentLanguage}.
  * @param translations Translations passed as a editor config parameter.
  */
  constructor({ uiLanguage: n = "en", contentLanguage: t, translations: i } = {}) {
    /**
    * The editor UI language code in the [ISO 639-1](https://en.wikipedia.org/wiki/ISO_639-1) format.
    *
    * If the {@link #contentLanguage content language} was not specified in the `Locale` constructor,
    * it also defines the language of the content.
    */
    m(this, "uiLanguage");
    /**
    * Text direction of the {@link #uiLanguage editor UI language}. Either `'ltr'` or `'rtl'`.
    */
    m(this, "uiLanguageDirection");
    /**
    * The editor content language code in the [ISO 639-1](https://en.wikipedia.org/wiki/ISO_639-1) format.
    *
    * Usually the same as the {@link #uiLanguage editor language}, it can be customized by passing an optional
    * argument to the `Locale` constructor.
    */
    m(this, "contentLanguage");
    /**
    * Text direction of the {@link #contentLanguage editor content language}.
    *
    * If the content language was passed directly to the `Locale` constructor, this property represents the
    * direction of that language.
    *
    * If the {@link #contentLanguage editor content language} was derived from the {@link #uiLanguage editor language},
    * the content language direction is the same as the {@link #uiLanguageDirection UI language direction}.
    *
    * The value is either `'ltr'` or `'rtl'`.
    */
    m(this, "contentLanguageDirection");
    /**
    * Translates the given message to the {@link #uiLanguage}. This method is also available in
    * {@link module:core/editor/editor~Editor#t `Editor`} and {@link module:ui/view~View#t `View`}.
    *
    * This method's context is statically bound to the `Locale` instance and **should always be called as a function**:
    *
    * ```ts
    * const t = locale.t;
    * t( 'Label' );
    * ```
    *
    * The message can be either a string or an object implementing the {@link module:utils/translation-service~Message} interface.
    *
    * The message may contain placeholders (`%<index>`) for value(s) that are passed as a `values` parameter.
    * For an array of values, the `%<index>` will be changed to an element of that array at the given index.
    * For a single value passed as the second argument, only the `%0` placeholders will be changed to the provided value.
    *
    * ```ts
    * t( 'Created file "%0" in %1ms.', [ fileName, timeTaken ] );
    * t( 'Created file "%0", fileName );
    * ```
    *
    * The message supports plural forms. To specify the plural form, use the `plural` property. Singular or plural form
    * will be chosen depending on the first value from the passed `values`. The value of the `plural` property is used
    * as a default plural translation when the translation for the target language is missing.
    *
    * ```ts
    * t( { string: 'Add a space', plural: 'Add %0 spaces' }, 1 ); // 'Add a space' for the English language.
    * t( { string: 'Add a space', plural: 'Add %0 spaces' }, 5 ); // 'Add 5 spaces' for the English language.
    * t( { string: '%1 a space', plural: '%1 %0 spaces' }, [ 2, 'Add' ] ); // 'Add 2 spaces' for the English language.
    *
    * t( { string: 'Add a space', plural: 'Add %0 spaces' }, 1 ); // 'Dodaj spację' for the Polish language.
    * t( { string: 'Add a space', plural: 'Add %0 spaces' }, 5 ); // 'Dodaj 5 spacji' for the Polish language.
    * t( { string: '%1 a space', plural: '%1 %0 spaces' }, [ 2, 'Add' ] ); // 'Dodaj 2 spacje' for the Polish language.
    * ```
    *
    *  * The message should provide an ID using the `id` property when the message strings are not unique and their
    * translations should be different.
    *
    * ```ts
    * translate( 'en', { string: 'image', id: 'ADD_IMAGE' } );
    * translate( 'en', { string: 'image', id: 'AN_IMAGE' } );
    * ```
    */
    m(this, "t");
    /**
    * Object that contains translations.
    */
    m(this, "translations");
    this.uiLanguage = n, this.contentLanguage = t || this.uiLanguage, this.uiLanguageDirection = up(this.uiLanguage), this.contentLanguageDirection = up(this.contentLanguage), this.translations = kP(i), this.t = (r, s) => this._t(r, s);
  }
  /**
  * The editor UI language code in the [ISO 639-1](https://en.wikipedia.org/wiki/ISO_639-1) format.
  *
  * **Note**: This property was deprecated. Please use {@link #uiLanguage} and {@link #contentLanguage}
  * properties instead.
  *
  * @deprecated
  */
  get language() {
    return console.warn("locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."), this.uiLanguage;
  }
  /**
  * An unbound version of the {@link #t} method.
  */
  _t(n, t = []) {
    t = Dt(t), typeof n == "string" && (n = {
      string: n
    });
    const r = !!n.plural ? t[0] : 1, s = CP(this.uiLanguage, n, r, this.translations);
    return vP(s, t);
  }
}
function vP(e, n) {
  return e.replace(/%(\d+)/g, (t, i) => i < n.length ? n[i] : t);
}
class Qi extends (/* @__PURE__ */ Je()) {
  constructor(t = {}, i = {}) {
    super();
    /**
    * The internal list of items in the collection.
    */
    m(this, "_items");
    /**
    * The internal map of items in the collection.
    */
    m(this, "_itemMap");
    /**
    * The name of the property which is considered to identify an item.
    */
    m(this, "_idProperty");
    /**
    * A collection instance this collection is bound to as a result
    * of calling {@link #bindTo} method.
    */
    m(this, "_bindToCollection");
    /**
    * A helper mapping external items of a bound collection ({@link #bindTo})
    * and actual items of this collection. It provides information
    * necessary to properly remove items bound to another collection.
    *
    * See {@link #_bindToInternalToExternalMap}.
    */
    m(this, "_bindToExternalToInternalMap");
    /**
    * A helper mapping items of this collection to external items of a bound collection
    * ({@link #bindTo}). It provides information necessary to manage the bindings, e.g.
    * to avoid loops in two–way bindings.
    *
    * See {@link #_bindToExternalToInternalMap}.
    */
    m(this, "_bindToInternalToExternalMap");
    /**
    * Stores indexes of skipped items from bound external collection.
    */
    m(this, "_skippedIndexesFromExternal");
    const r = Nn(t);
    if (r || (i = t), this._items = [], this._itemMap = /* @__PURE__ */ new Map(), this._idProperty = i.idProperty || "id", this._bindToExternalToInternalMap = /* @__PURE__ */ new WeakMap(), this._bindToInternalToExternalMap = /* @__PURE__ */ new WeakMap(), this._skippedIndexesFromExternal = [], r)
      for (const s of t)
        this._items.push(s), this._itemMap.set(this._getItemIdBeforeAdding(s), s);
  }
  /**
  * The number of items available in the collection.
  */
  get length() {
    return this._items.length;
  }
  /**
  * Returns the first item from the collection or null when collection is empty.
  */
  get first() {
    return this._items[0] || null;
  }
  /**
  * Returns the last item from the collection or null when collection is empty.
  */
  get last() {
    return this._items[this.length - 1] || null;
  }
  /**
  * Adds an item into the collection.
  *
  * If the item does not have an id, then it will be automatically generated and set on the item.
  *
  * @param item
  * @param index The position of the item in the collection. The item
  * is pushed to the collection when `index` not specified.
  * @fires add
  * @fires change
  */
  add(t, i) {
    return this.addMany([
      t
    ], i);
  }
  /**
  * Adds multiple items into the collection.
  *
  * Any item not containing an id will get an automatically generated one.
  *
  * @param items
  * @param index The position of the insertion. Items will be appended if no `index` is specified.
  * @fires add
  * @fires change
  */
  addMany(t, i) {
    if (i === void 0)
      i = this._items.length;
    else if (i > this._items.length || i < 0)
      throw new v("collection-add-item-invalid-index", this);
    let r = 0;
    for (const s of t) {
      const o = this._getItemIdBeforeAdding(s), a = i + r;
      this._items.splice(a, 0, s), this._itemMap.set(o, s), this.fire("add", s, a), r++;
    }
    return this.fire("change", {
      added: t,
      removed: [],
      index: i
    }), this;
  }
  /**
  * Gets an item by its ID or index.
  *
  * @param idOrIndex The item ID or index in the collection.
  * @returns The requested item or `null` if such item does not exist.
  */
  get(t) {
    let i;
    if (typeof t == "string")
      i = this._itemMap.get(t);
    else if (typeof t == "number")
      i = this._items[t];
    else
      throw new v("collection-get-invalid-arg", this);
    return i || null;
  }
  /**
  * Returns a Boolean indicating whether the collection contains an item.
  *
  * @param itemOrId The item or its ID in the collection.
  * @returns `true` if the collection contains the item, `false` otherwise.
  */
  has(t) {
    if (typeof t == "string")
      return this._itemMap.has(t);
    {
      const i = this._idProperty, r = t[i];
      return r && this._itemMap.has(r);
    }
  }
  /**
  * Gets an index of an item in the collection.
  * When an item is not defined in the collection, the index will equal -1.
  *
  * @param itemOrId The item or its ID in the collection.
  * @returns The index of a given item.
  */
  getIndex(t) {
    let i;
    return typeof t == "string" ? i = this._itemMap.get(t) : i = t, i ? this._items.indexOf(i) : -1;
  }
  /**
  * Removes an item from the collection.
  *
  * @param subject The item to remove, its ID or index in the collection.
  * @returns The removed item.
  * @fires remove
  * @fires change
  */
  remove(t) {
    const [i, r] = this._remove(t);
    return this.fire("change", {
      added: [],
      removed: [
        i
      ],
      index: r
    }), i;
  }
  /**
  * Executes the callback for each item in the collection and composes an array or values returned by this callback.
  *
  * @typeParam U The result type of the callback.
  * @param callback
  * @param ctx Context in which the `callback` will be called.
  * @returns The result of mapping.
  */
  map(t, i) {
    return this._items.map(t, i);
  }
  /**
  * Performs the specified action for each item in the collection.
  *
  * @param ctx Context in which the `callback` will be called.
  */
  forEach(t, i) {
    this._items.forEach(t, i);
  }
  /**
  * Finds the first item in the collection for which the `callback` returns a true value.
  *
  * @param callback
  * @param ctx Context in which the `callback` will be called.
  * @returns The item for which `callback` returned a true value.
  */
  find(t, i) {
    return this._items.find(t, i);
  }
  /**
  * Returns an array with items for which the `callback` returned a true value.
  *
  * @param callback
  * @param ctx Context in which the `callback` will be called.
  * @returns The array with matching items.
  */
  filter(t, i) {
    return this._items.filter(t, i);
  }
  /**
  * Removes all items from the collection and destroys the binding created using
  * {@link #bindTo}.
  *
  * @fires remove
  * @fires change
  */
  clear() {
    this._bindToCollection && (this.stopListening(this._bindToCollection), this._bindToCollection = null);
    const t = Array.from(this._items);
    for (; this.length; )
      this._remove(0);
    this.fire("change", {
      added: [],
      removed: t,
      index: 0
    });
  }
  /**
  * Binds and synchronizes the collection with another one.
  *
  * The binding can be a simple factory:
  *
  * ```ts
  * class FactoryClass {
  * 	public label: string;
  *
  * 	constructor( data: { label: string } ) {
  * 		this.label = data.label;
  * 	}
  * }
  *
  * const source = new Collection<{ label: string }>( { idProperty: 'label' } );
  * const target = new Collection<FactoryClass>();
  *
  * target.bindTo( source ).as( FactoryClass );
  *
  * source.add( { label: 'foo' } );
  * source.add( { label: 'bar' } );
  *
  * console.log( target.length ); // 2
  * console.log( target.get( 1 ).label ); // 'bar'
  *
  * source.remove( 0 );
  * console.log( target.length ); // 1
  * console.log( target.get( 0 ).label ); // 'bar'
  * ```
  *
  * or the factory driven by a custom callback:
  *
  * ```ts
  * class FooClass {
  * 	public label: string;
  *
  * 	constructor( data: { label: string } ) {
  * 		this.label = data.label;
  * 	}
  * }
  *
  * class BarClass {
  * 	public label: string;
  *
  * 	constructor( data: { label: string } ) {
  * 		this.label = data.label;
  * 	}
  * }
  *
  * const source = new Collection<{ label: string }>( { idProperty: 'label' } );
  * const target = new Collection<FooClass | BarClass>();
  *
  * target.bindTo( source ).using( ( item ) => {
  * 	if ( item.label == 'foo' ) {
  * 		return new FooClass( item );
  * 	} else {
  * 		return new BarClass( item );
  * 	}
  * } );
  *
  * source.add( { label: 'foo' } );
  * source.add( { label: 'bar' } );
  *
  * console.log( target.length ); // 2
  * console.log( target.get( 0 ) instanceof FooClass ); // true
  * console.log( target.get( 1 ) instanceof BarClass ); // true
  * ```
  *
  * or the factory out of property name:
  *
  * ```ts
  * const source = new Collection<{ nested: { value: string } }>();
  * const target = new Collection<{ value: string }>();
  *
  * target.bindTo( source ).using( 'nested' );
  *
  * source.add( { nested: { value: 'foo' } } );
  * source.add( { nested: { value: 'bar' } } );
  *
  * console.log( target.length ); // 2
  * console.log( target.get( 0 ).value ); // 'foo'
  * console.log( target.get( 1 ).value ); // 'bar'
  * ```
  *
  * It's possible to skip specified items by returning null value:
  *
  * ```ts
  * const source = new Collection<{ hidden: boolean }>();
  * const target = new Collection<{ hidden: boolean }>();
  *
  * target.bindTo( source ).using( item => {
  * 	if ( item.hidden ) {
  * 		return null;
  * 	}
  *
  * 	return item;
  * } );
  *
  * source.add( { hidden: true } );
  * source.add( { hidden: false } );
  *
  * console.log( source.length ); // 2
  * console.log( target.length ); // 1
  * ```
  *
  * **Note**: {@link #clear} can be used to break the binding.
  *
  * @typeParam S The type of `externalCollection` element.
  * @param externalCollection A collection to be bound.
  * @returns The binding chain object.
  */
  bindTo(t) {
    if (this._bindToCollection)
      throw new v("collection-bind-to-rebind", this);
    return this._bindToCollection = t, {
      as: (i) => {
        this._setUpBindToBinding((r) => new i(r));
      },
      using: (i) => {
        typeof i == "function" ? this._setUpBindToBinding(i) : this._setUpBindToBinding((r) => r[i]);
      }
    };
  }
  /**
  * Finalizes and activates a binding initiated by {@link #bindTo}.
  *
  * @param factory A function which produces collection items.
  */
  _setUpBindToBinding(t) {
    const i = this._bindToCollection, r = (s, o, a) => {
      const u = i._bindToCollection == this, l = i._bindToInternalToExternalMap.get(o);
      if (u && l)
        this._bindToExternalToInternalMap.set(o, l), this._bindToInternalToExternalMap.set(l, o);
      else {
        const c = t(o);
        if (!c) {
          this._skippedIndexesFromExternal.push(a);
          return;
        }
        let d = a;
        for (const p of this._skippedIndexesFromExternal)
          a > p && d--;
        for (const p of i._skippedIndexesFromExternal)
          d >= p && d++;
        this._bindToExternalToInternalMap.set(o, c), this._bindToInternalToExternalMap.set(c, o), this.add(c, d);
        for (let p = 0; p < i._skippedIndexesFromExternal.length; p++)
          d <= i._skippedIndexesFromExternal[p] && i._skippedIndexesFromExternal[p]++;
      }
    };
    for (const s of i)
      r(null, s, i.getIndex(s));
    this.listenTo(i, "add", r), this.listenTo(i, "remove", (s, o, a) => {
      const u = this._bindToExternalToInternalMap.get(o);
      u && this.remove(u), this._skippedIndexesFromExternal = this._skippedIndexesFromExternal.reduce((l, c) => (a < c && l.push(c - 1), a > c && l.push(c), l), []);
    });
  }
  /**
  * Returns an unique id property for a given `item`.
  *
  * The method will generate new id and assign it to the `item` if it doesn't have any.
  *
  * @param item Item to be added.
  */
  _getItemIdBeforeAdding(t) {
    const i = this._idProperty;
    let r;
    if (i in t) {
      if (r = t[i], typeof r != "string")
        throw new v("collection-add-invalid-id", this);
      if (this.get(r))
        throw new v("collection-add-item-already-exists", this);
    } else
      t[i] = r = un();
    return r;
  }
  /**
  * Core {@link #remove} method implementation shared in other functions.
  *
  * In contrast this method **does not** fire the {@link #event:change} event.
  *
  * @param subject The item to remove, its id or index in the collection.
  * @returns Returns an array with the removed item and its index.
  * @fires remove
  */
  _remove(t) {
    let i, r, s, o = !1;
    const a = this._idProperty;
    if (typeof t == "string" ? (r = t, s = this._itemMap.get(r), o = !s, s && (i = this._items.indexOf(s))) : typeof t == "number" ? (i = t, s = this._items[i], o = !s, s && (r = s[a])) : (s = t, r = s[a], i = this._items.indexOf(s), o = i == -1 || !this._itemMap.get(r)), o)
      throw new v("collection-remove-404", this);
    this._items.splice(i, 1), this._itemMap.delete(r);
    const u = this._bindToInternalToExternalMap.get(s);
    return this._bindToInternalToExternalMap.delete(s), this._bindToExternalToInternalMap.delete(u), this.fire("remove", s, i), [
      s,
      i
    ];
  }
  /**
  * Iterable interface.
  */
  [Symbol.iterator]() {
    return this._items[Symbol.iterator]();
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function zn(e) {
  const n = e.next();
  return n.done ? null : n.value;
}
class Ln extends (/* @__PURE__ */ li(/* @__PURE__ */ pt())) {
  // @if CK_DEBUG_FOCUSTRACKER // public _label?: string;
  constructor() {
    super();
    /**
    * List of registered DOM elements.
    *
    * @internal
    */
    m(this, "_elements", /* @__PURE__ */ new Set());
    /**
    * List of views with external focus trackers that contribute to the state of this focus tracker.
    *
    * @internal
    */
    m(this, "_externalViews", /* @__PURE__ */ new Set());
    /**
    * Asynchronous blur event timeout.
    */
    m(this, "_blurTimeout", null);
    this.set("isFocused", !1), this.set("focusedElement", null);
  }
  /**
  * List of registered DOM elements.
  *
  * **Note**: The list does do not include elements from {@link #externalViews}.
  */
  get elements() {
    return Array.from(this._elements.values());
  }
  /**
  * List of external focusable views that contribute to the state of this focus tracker. See {@link #add} to learn more.
  */
  get externalViews() {
    return Array.from(this._externalViews.values());
  }
  /**
  * Starts tracking a specified DOM element or a {@link module:ui/view~View} instance.
  *
  * * If a DOM element is passed, the focus tracker listens to the `focus` and `blur` events on this element.
  * Tracked elements are listed in {@link #elements}.
  * * If a {@link module:ui/view~View} instance is passed that has a `FocusTracker` instance ({@link ~ViewWithFocusTracker}),
  * the external focus tracker's state ({@link #isFocused}, {@link #focusedElement}) starts contributing to the current tracker instance.
  * This allows for increasing the "reach" of a focus tracker instance, by connecting two or more focus trackers together when DOM
  * elements they track are located in different subtrees in DOM. External focus trackers are listed in {@link #externalViews}.
  * * If a {@link module:ui/view~View} instance is passed that has no `FocusTracker` (**not** a {@link ~ViewWithFocusTracker}),
  * its {@link module:ui/view~View#element} is used to track focus like any other DOM element.
  */
  add(t) {
    if (cp(t))
      this._addElement(t);
    else if (lp(t))
      this._addView(t);
    else {
      if (!t.element)
        throw new v("focustracker-add-view-missing-element", {
          focusTracker: this,
          view: t
        });
      this._addElement(t.element);
    }
  }
  /**
  * Stops tracking focus in the specified DOM element or a {@link module:ui/view~View view instance}. See {@link #add} to learn more.
  */
  remove(t) {
    cp(t) ? this._removeElement(t) : lp(t) ? this._removeView(t) : this._removeElement(t.element);
  }
  /**
  * Adds a DOM element to the focus tracker and starts listening to the `focus` and `blur` events on it.
  */
  _addElement(t) {
    if (this._elements.has(t))
      throw new v("focustracker-add-element-already-exist", this);
    this.listenTo(t, "focus", () => {
      const i = this.externalViews.find((r) => PP(t, r));
      i ? this._focus(i.element) : this._focus(t);
    }, {
      useCapture: !0
    }), this.listenTo(t, "blur", () => {
      this._blur();
    }, {
      useCapture: !0
    }), this._elements.add(t);
  }
  /**
  * Removes a DOM element from the focus tracker.
  */
  _removeElement(t) {
    this._elements.has(t) && (this.stopListening(t), this._elements.delete(t)), t === this.focusedElement && this._blur();
  }
  /**
  * Adds an external {@link module:ui/view~View view instance} to this focus tracker and makes it contribute to this focus tracker's
  * state either by its `View#element` or by its `View#focusTracker` instance.
  */
  _addView(t) {
    t.element && this._addElement(t.element), this.listenTo(t.focusTracker, "change:focusedElement", () => {
      t.focusTracker.focusedElement ? t.element && this._focus(t.element) : this._blur();
    }), this._externalViews.add(t);
  }
  /**
  * Removes an external {@link module:ui/view~View view instance} from this focus tracker.
  */
  _removeView(t) {
    t.element && this._removeElement(t.element), this.stopListening(t.focusTracker), this._externalViews.delete(t);
  }
  /**
  * Destroys the focus tracker by:
  * - Disabling all event listeners attached to tracked elements or external views.
  * - Removing all tracked elements and views that were previously added.
  */
  destroy() {
    this.stopListening(), this._elements.clear(), this._externalViews.clear(), this.isFocused = !1, this.focusedElement = null;
  }
  /**
  * Stores currently focused element as {@link #focusedElement} and sets {@link #isFocused} `true`.
  */
  _focus(t) {
    this._clearBlurTimeout(), this.focusedElement = t, this.isFocused = !0;
  }
  /**
  * Clears currently {@link #focusedElement} and sets {@link #isFocused} `false`.
  *
  * This method uses `setTimeout()` to change order of `blur` and `focus` events calls, ensuring that moving focus between
  * two elements within a single focus tracker's scope, will not cause `[ blurA, focusB ]` sequence but just `[ focusB ]`.
  * The former would cause a momentary change of `#isFocused` to `false` which is not desired because any logic listening to
  * a focus tracker state would experience UI flashes and glitches as the user focus travels across the UI.
  */
  _blur() {
    this.elements.find((r) => r.contains(document.activeElement)) || this.externalViews.find((r) => r.focusTracker.isFocused && !r.focusTracker._blurTimeout) || (this._clearBlurTimeout(), this._blurTimeout = setTimeout(() => {
      this.focusedElement = null, this.isFocused = !1;
    }, 0));
  }
  /**
  * Clears the asynchronous blur event timeout on demand. See {@link #_blur} to learn more.
  */
  _clearBlurTimeout() {
    clearTimeout(this._blurTimeout), this._blurTimeout = null;
  }
}
function lp(e) {
  return "focusTracker" in e && e.focusTracker instanceof Ln;
}
function cp(e) {
  return Er(e);
}
function PP(e, n) {
  return dp(e, n) ? !0 : !!n.focusTracker.externalViews.find((t) => dp(e, t));
}
function dp(e, n) {
  return !!n.element && n.element.contains(document.activeElement) && e.contains(n.element);
}
class Ii {
  /**
  * Creates an instance of the keystroke handler.
  */
  constructor() {
    /**
    * Listener used to listen to events for easier keystroke handler destruction.
    */
    m(this, "_listener");
    this._listener = new (li())();
  }
  /**
  * Starts listening for `keydown` events from a given emitter.
  */
  listenTo(n) {
    this._listener.listenTo(n, "keydown", (t, i) => {
      this._listener.fire("_keydown:" + Zs(i), i);
    });
  }
  /**
  * Registers a handler for the specified keystroke.
  *
  * @param keystroke Keystroke defined in a format accepted by
  * the {@link module:utils/keyboard~parseKeystroke} function.
  * @param callback A function called with the
  * {@link module:engine/view/observer/keyobserver~KeyEventData key event data} object and
  * a helper function to call both `preventDefault()` and `stopPropagation()` on the underlying event.
  * @param options Additional options.
  */
  set(n, t, i = {}) {
    const r = $f(n), s = i.priority;
    this._listener.listenTo(this._listener, "_keydown:" + r, (o, a) => {
      i.filter && !i.filter(a) || (t(a, () => {
        a.preventDefault(), a.stopPropagation(), o.stop();
      }), o.return = !0);
    }, {
      priority: s
    });
  }
  /**
  * Triggers a keystroke handler for a specified key combination, if such a keystroke was {@link #set defined}.
  *
  * @param keyEvtData Key event data.
  * @returns Whether the keystroke was handled.
  */
  press(n) {
    return !!this._listener.fire("_keydown:" + Zs(n), n);
  }
  /**
  * Stops listening to `keydown` events from the given emitter.
  */
  stopListening(n) {
    this._listener.stopListening(n);
  }
  /**
  * Destroys the keystroke handler.
  */
  destroy() {
    this.stopListening();
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function OP(e) {
  const n = /* @__PURE__ */ new Map();
  for (const t in e)
    n.set(t, e[t]);
  return n;
}
function Si(e) {
  return Nn(e) ? new Map(e) : OP(e);
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function hp(e, n, t) {
  const i = e.length, r = n.length;
  for (let s = i - 1; s >= t; s--)
    e[s + r] = e[s];
  for (let s = 0; s < r; s++)
    e[t + s] = n[s];
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function Wf(e, n) {
  let t;
  function i(...r) {
    i.cancel(), t = setTimeout(() => e(...r), n);
  }
  return i.cancel = () => {
    clearTimeout(t);
  }, i;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function zf(e) {
  try {
    if (!e.startsWith("ey"))
      return null;
    const n = atob(e.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(n);
  } catch {
    return null;
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function NP() {
  const e = [];
  for (let n = 0; n < 256; n++) {
    let t = n;
    for (let i = 0; i < 8; i++)
      t & 1 ? t = 3988292384 ^ t >>> 1 : t = t >>> 1;
    e[n] = t;
  }
  return e;
}
function RP(e) {
  const n = Array.isArray(e) ? e : [
    e
  ], t = NP();
  let i = -1;
  const r = n.map((s) => Array.isArray(s) ? s.join("") : String(s)).join("");
  for (let s = 0; s < r.length; s++) {
    const o = r.charCodeAt(s);
    i = i >>> 8 ^ t[(i ^ o) & 255];
  }
  return i = (i ^ -1) >>> 0, i.toString(16).padStart(8, "0");
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function LP(e) {
  return !!e && e.length == 1 && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(e);
}
function DP(e) {
  return !!e && e.length == 1 && /[\ud800-\udbff]/.test(e);
}
function MP(e) {
  return !!e && e.length == 1 && /[\udc00-\udfff]/.test(e);
}
function qf(e, n) {
  return DP(e.charAt(n - 1)) && MP(e.charAt(n));
}
function Yf(e, n) {
  return LP(e.charAt(n));
}
const BP = /* @__PURE__ */ FP();
function $E(e, n) {
  const t = String(e).matchAll(BP);
  return Array.from(t).some((i) => i.index < n && n < i.index + i[0].length);
}
function FP() {
  const e = [
    // Emoji Tag Sequence (ETS)
    new RegExp("\\p{Emoji}[\\u{E0020}-\\u{E007E}]+\\u{E007F}", "u"),
    // Emoji Keycap Sequence
    new RegExp("\\p{Emoji}\\u{FE0F}?\\u{20E3}", "u"),
    // Emoji Presentation Sequence
    new RegExp("\\p{Emoji}\\u{FE0F}", "u"),
    // Single-Character Emoji / Emoji Modifier Sequence
    new RegExp("(?=\\p{General_Category=Other_Symbol})\\p{Emoji}\\p{Emoji_Modifier}*", "u")
  ], n = new RegExp("\\p{Regional_Indicator}{2}", "u").source, t = "(?:" + e.map((r) => r.source).join("|") + ")", i = `${n}|${t}(?:‍${t})*`;
  return new RegExp(i, "ug");
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const Po = /* @__PURE__ */ new WeakMap();
let fp = !1;
function UP({ view: e, element: n, text: t, isDirectHost: i = !0, keepOnFocus: r = !1 }) {
  const s = e.document;
  Po.has(s) || (Po.set(s, /* @__PURE__ */ new Map()), s.registerPostFixer((a) => rd(Po.get(s), a)), s.on("change:isComposing", () => {
    e.change((a) => rd(Po.get(s), a));
  }, {
    priority: "high"
  })), n.is("editableElement") && n.on("change:placeholder", (a, u, l) => o(l)), n.placeholder ? o(n.placeholder) : t && o(t), t && qP();
  function o(a) {
    const u = {
      text: a,
      isDirectHost: i,
      keepOnFocus: r,
      hostElement: i ? n : null
    };
    Po.get(s).set(n, u), e.change((l) => rd([
      [
        n,
        u
      ]
    ], l));
  }
}
function HP(e, n) {
  return n.hasClass("ck-placeholder") ? !1 : (e.addClass("ck-placeholder", n), !0);
}
function VP(e, n) {
  return n.hasClass("ck-placeholder") ? (e.removeClass("ck-placeholder", n), !0) : !1;
}
function $P(e, n) {
  if (!e.isAttached() || WP(e))
    return !1;
  const t = e.document, r = t.selection.anchor;
  return t.isComposing && r && r.parent === e ? !1 : n || !t.isFocused ? !0 : !!r && r.parent !== e;
}
function WP(e) {
  for (const n of e.getChildren())
    if (!n.is("uiElement"))
      return !0;
  return !1;
}
function rd(e, n) {
  const t = [];
  let i = !1;
  for (const [r, s] of e)
    s.isDirectHost && (t.push(r), mp(n, r, s) && (i = !0));
  for (const [r, s] of e) {
    if (s.isDirectHost)
      continue;
    const o = zP(r);
    o && (t.includes(o) || (s.hostElement = o, mp(n, r, s) && (i = !0)));
  }
  return i;
}
function mp(e, n, t) {
  const { text: i, isDirectHost: r, hostElement: s } = t;
  let o = !1;
  return s.getAttribute("data-placeholder") !== i && (e.setAttribute("data-placeholder", i, s), o = !0), (r || n.childCount == 1) && $P(s, t.keepOnFocus) ? HP(e, s) && (o = !0) : VP(e, s) && (o = !0), o;
}
function zP(e) {
  if (e.childCount) {
    const n = e.getChild(0);
    if (n.is("element") && !n.is("uiElement") && !n.is("attributeElement"))
      return n;
  }
  return null;
}
function qP() {
  fp || at("enableplaceholder-deprecated-text-option"), fp = !0;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
let us = class {
  /* istanbul ignore next -- @preserve */
  is() {
    throw new Error("is() method is abstract");
  }
}, ls = class extends (/* @__PURE__ */ Je(us)) {
  /**
  * Creates a tree view node.
  *
  * @param document The document instance to which this node belongs.
  */
  constructor(t) {
    super();
    /**
    * The document instance to which this node belongs.
    */
    m(this, "document");
    /**
    * Parent element. Null by default. Set by {@link module:engine/view/element~Element#_insertChild}.
    */
    m(this, "parent");
    this.document = t, this.parent = null;
  }
  /**
  * Index of the node in the parent element or null if the node has no parent.
  *
  * Accessing this property throws an error if this node's parent element does not contain it.
  * This means that view tree got broken.
  */
  get index() {
    let t;
    if (!this.parent)
      return null;
    if ((t = this.parent.getChildIndex(this)) == -1)
      throw new v("view-node-not-found-in-parent", this);
    return t;
  }
  /**
  * Node's next sibling, or `null` if it is the last child.
  */
  get nextSibling() {
    const t = this.index;
    return t !== null && this.parent.getChild(t + 1) || null;
  }
  /**
  * Node's previous sibling, or `null` if it is the first child.
  */
  get previousSibling() {
    const t = this.index;
    return t !== null && this.parent.getChild(t - 1) || null;
  }
  /**
  * Top-most ancestor of the node. If the node has no parent it is the root itself.
  */
  get root() {
    let t = this;
    for (; t.parent; )
      t = t.parent;
    return t;
  }
  /**
  * Returns true if the node is in a tree rooted in the document (is a descendant of one of its roots).
  */
  isAttached() {
    return this.root.is("rootElement");
  }
  /**
  * Gets a path to the node. The path is an array containing indices of consecutive ancestors of this node,
  * beginning from {@link module:engine/view/node~Node#root root}, down to this node's index.
  *
  * ```ts
  * const abc = downcastWriter.createText( 'abc' );
  * const foo = downcastWriter.createText( 'foo' );
  * const h1 = downcastWriter.createElement( 'h1', null, downcastWriter.createText( 'header' ) );
  * const p = downcastWriter.createElement( 'p', null, [ abc, foo ] );
  * const div = downcastWriter.createElement( 'div', null, [ h1, p ] );
  * foo.getPath(); // Returns [ 1, 3 ]. `foo` is in `p` which is in `div`. `p` starts at offset 1, while `foo` at 3.
  * h1.getPath(); // Returns [ 0 ].
  * div.getPath(); // Returns [].
  * ```
  *
  * @returns The path.
  */
  getPath() {
    const t = [];
    let i = this;
    for (; i.parent; )
      t.unshift(i.index), i = i.parent;
    return t;
  }
  /**
  * Returns ancestors array of this node.
  *
  * @param options Options object.
  * @param options.includeSelf When set to `true` this node will be also included in parent's array.
  * @param options.parentFirst When set to `true`, array will be sorted from node's parent to root element,
  * otherwise root element will be the first item in the array.
  * @returns Array with ancestors.
  */
  getAncestors(t = {}) {
    const i = [];
    let r = t.includeSelf ? this : this.parent;
    for (; r; )
      i[t.parentFirst ? "push" : "unshift"](r), r = r.parent;
    return i;
  }
  /**
  * Returns a {@link module:engine/view/element~Element} or {@link module:engine/view/documentfragment~DocumentFragment}
  * which is a common ancestor of both nodes.
  *
  * @param node The second node.
  * @param options Options object.
  * @param options.includeSelf When set to `true` both nodes will be considered "ancestors" too.
  * Which means that if e.g. node A is inside B, then their common ancestor will be B.
  */
  getCommonAncestor(t, i = {}) {
    const r = this.getAncestors(i), s = t.getAncestors(i);
    let o = 0;
    for (; r[o] == s[o] && r[o]; )
      o++;
    return o === 0 ? null : r[o - 1];
  }
  /**
  * Returns whether this node is before given node. `false` is returned if nodes are in different trees (for example,
  * in different {@link module:engine/view/documentfragment~DocumentFragment}s).
  *
  * @param node Node to compare with.
  */
  isBefore(t) {
    if (this == t || this.root !== t.root)
      return !1;
    const i = this.getPath(), r = t.getPath(), s = sn(i, r);
    switch (s) {
      case "prefix":
        return !0;
      case "extension":
        return !1;
      default:
        return i[s] < r[s];
    }
  }
  /**
  * Returns whether this node is after given node. `false` is returned if nodes are in different trees (for example,
  * in different {@link module:engine/view/documentfragment~DocumentFragment}s).
  *
  * @param node Node to compare with.
  */
  isAfter(t) {
    return this == t || this.root !== t.root ? !1 : !this.isBefore(t);
  }
  /**
  * Removes node from parent.
  *
  * @internal
  */
  _remove() {
    this.parent._removeChildren(this.index);
  }
  /**
  * @internal
  * @param type Type of the change.
  * @param node Changed node.
  * @param data Additional data.
  * @fires change
  */
  _fireChange(t, i, r) {
    this.fire(`change:${t}`, i, r), this.parent && this.parent._fireChange(t, i, r);
  }
  /**
  * Custom toJSON method to solve child-parent circular dependencies.
  *
  * @returns Clone of this object with the parent property removed.
  */
  toJSON() {
    const t = hE(this);
    return delete t.parent, t;
  }
};
ls.prototype.is = function(e) {
  return e === "node" || e === "view:node";
};
let Jt = class Sh extends ls {
  /**
  * Creates a tree view text node.
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#createText
  * @internal
  * @param document The document instance to which this text node belongs.
  * @param data The text's data.
  */
  constructor(t, i) {
    super(t);
    /**
    * The text content.
    *
    * Setting the data fires the {@link module:engine/view/node~Node#event:change:text change event}.
    */
    m(this, "_textData");
    this._textData = i;
  }
  /**
  * The text content.
  */
  get data() {
    return this._textData;
  }
  /**
  * The `_data` property is controlled by a getter and a setter.
  *
  * The getter is required when using the addition assignment operator on protected property:
  *
  * ```ts
  * const foo = downcastWriter.createText( 'foo' );
  * const bar = downcastWriter.createText( 'bar' );
  *
  * foo._data += bar.data;   // executes: `foo._data = foo._data + bar.data`
  * console.log( foo.data ); // prints: 'foobar'
  * ```
  *
  * If the protected getter didn't exist, `foo._data` will return `undefined` and result of the merge will be invalid.
  *
  * The setter sets data and fires the {@link module:engine/view/node~Node#event:change:text change event}.
  *
  * @internal
  */
  get _data() {
    return this.data;
  }
  set _data(t) {
    this._fireChange("text", this), this._textData = t;
  }
  /**
  * Checks if this text node is similar to other text node.
  * Both nodes should have the same data to be considered as similar.
  *
  * @param otherNode Node to check if it is same as this node.
  */
  isSimilar(t) {
    return t instanceof Sh ? this === t || this.data === t.data : !1;
  }
  /**
  * Clones this node.
  *
  * @internal
  * @returns Text node that is a clone of this node.
  */
  _clone() {
    return new Sh(this.document, this.data);
  }
};
Jt.prototype.is = function(e) {
  return e === "$text" || e === "view:$text" || // This are legacy values kept for backward compatibility.
  e === "text" || e === "view:text" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === "node" || e === "view:node";
};
let Di = class extends us {
  /**
  * Creates a text proxy.
  *
  * @internal
  * @param textNode Text node which part is represented by this text proxy.
  * @param offsetInText Offset in {@link module:engine/view/textproxy~TextProxy#textNode text node}
  * from which the text proxy starts.
  * @param length Text proxy length, that is how many text node's characters, starting from `offsetInText` it represents.
  * @constructor
  */
  constructor(t, i, r) {
    super();
    /**
    * Reference to the {@link module:engine/view/text~Text} element which TextProxy is a substring.
    */
    m(this, "textNode");
    /**
    * Text data represented by this text proxy.
    */
    m(this, "data");
    /**
    * Offset in the `textNode` where this `TextProxy` instance starts.
    */
    m(this, "offsetInText");
    if (this.textNode = t, i < 0 || i > t.data.length)
      throw new v("view-textproxy-wrong-offsetintext", this);
    if (r < 0 || i + r > t.data.length)
      throw new v("view-textproxy-wrong-length", this);
    this.data = t.data.substring(i, i + r), this.offsetInText = i;
  }
  /**
  * Offset size of this node.
  */
  get offsetSize() {
    return this.data.length;
  }
  /**
  * Flag indicating whether `TextProxy` instance covers only part of the original {@link module:engine/view/text~Text text node}
  * (`true`) or the whole text node (`false`).
  *
  * This is `false` when text proxy starts at the very beginning of {@link module:engine/view/textproxy~TextProxy#textNode textNode}
  * ({@link module:engine/view/textproxy~TextProxy#offsetInText offsetInText} equals `0`) and text proxy sizes is equal to
  * text node size.
  */
  get isPartial() {
    return this.data.length !== this.textNode.data.length;
  }
  /**
  * Parent of this text proxy, which is same as parent of text node represented by this text proxy.
  */
  get parent() {
    return this.textNode.parent;
  }
  /**
  * Root of this text proxy, which is same as root of text node represented by this text proxy.
  */
  get root() {
    return this.textNode.root;
  }
  /**
  * {@link module:engine/view/document~Document View document} that owns this text proxy, or `null` if the text proxy is inside
  * {@link module:engine/view/documentfragment~DocumentFragment document fragment}.
  */
  get document() {
    return this.textNode.document;
  }
  /**
  * Returns ancestors array of this text proxy.
  *
  * @param options Options object.
  * @param options.includeSelf When set to `true`, textNode will be also included in parent's array.
  * @param options.parentFirst When set to `true`, array will be sorted from text proxy parent to
  * root element, otherwise root element will be the first item in the array.
  * @returns Array with ancestors.
  */
  getAncestors(t = {}) {
    const i = [];
    let r = t.includeSelf ? this.textNode : this.parent;
    for (; r !== null; )
      i[t.parentFirst ? "push" : "unshift"](r), r = r.parent;
    return i;
  }
};
Di.prototype.is = function(e) {
  return e === "$textProxy" || e === "view:$textProxy" || // This are legacy values kept for backward compatibility.
  e === "textProxy" || e === "view:textProxy";
};
class _l {
  constructor() {
    /**
    * Map of consumable elements. If {@link module:engine/view/element~Element element} is used as a key,
    * {@link module:engine/conversion/viewconsumable~ViewElementConsumables ViewElementConsumables} instance is stored as value.
    * For {@link module:engine/view/text~Text text nodes} and
    * {@link module:engine/view/documentfragment~DocumentFragment document fragments} boolean value is stored as value.
    */
    m(this, "_consumables", /* @__PURE__ */ new Map());
  }
  /**
  * Adds view {@link module:engine/view/element~Element element}, {@link module:engine/view/text~Text text node} or
  * {@link module:engine/view/documentfragment~DocumentFragment document fragment} as ready to be consumed.
  *
  * ```ts
  * viewConsumable.add( p, { name: true } ); // Adds element's name to consume.
  * viewConsumable.add( p, { attributes: 'name' } ); // Adds element's attribute.
  * viewConsumable.add( p, { classes: 'foobar' } ); // Adds element's class.
  * viewConsumable.add( p, { styles: 'color' } ); // Adds element's style
  * viewConsumable.add( p, { attributes: 'name', styles: 'color' } ); // Adds attribute and style.
  * viewConsumable.add( p, { classes: [ 'baz', 'bar' ] } ); // Multiple consumables can be provided.
  * viewConsumable.add( textNode ); // Adds text node to consume.
  * viewConsumable.add( docFragment ); // Adds document fragment to consume.
  * ```
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `viewconsumable-invalid-attribute` when `class` or `style`
  * attribute is provided - it should be handled separately by providing actual style/class.
  *
  * ```ts
  * viewConsumable.add( p, { attributes: 'style' } ); // This call will throw an exception.
  * viewConsumable.add( p, { styles: 'color' } ); // This is properly handled style.
  * ```
  *
  * @param consumables Used only if first parameter is {@link module:engine/view/element~Element view element} instance.
  * @param consumables.name If set to true element's name will be included.
  * @param consumables.attributes Attribute name or array of attribute names.
  * @param consumables.classes Class name or array of class names.
  * @param consumables.styles Style name or array of style names.
  */
  add(n, t) {
    let i;
    if (n.is("$text") || n.is("documentFragment")) {
      this._consumables.set(n, !0);
      return;
    }
    this._consumables.has(n) ? i = this._consumables.get(n) : (i = new YP(n), this._consumables.set(n, i)), i.add(t ? Xo(t) : n._getConsumables());
  }
  /**
  * Tests if {@link module:engine/view/element~Element view element}, {@link module:engine/view/text~Text text node} or
  * {@link module:engine/view/documentfragment~DocumentFragment document fragment} can be consumed.
  * It returns `true` when all items included in method's call can be consumed. Returns `false` when
  * first already consumed item is found and `null` when first non-consumable item is found.
  *
  * ```ts
  * viewConsumable.test( p, { name: true } ); // Tests element's name.
  * viewConsumable.test( p, { attributes: 'name' } ); // Tests attribute.
  * viewConsumable.test( p, { classes: 'foobar' } ); // Tests class.
  * viewConsumable.test( p, { styles: 'color' } ); // Tests style.
  * viewConsumable.test( p, { attributes: 'name', styles: 'color' } ); // Tests attribute and style.
  * viewConsumable.test( p, { classes: [ 'baz', 'bar' ] } ); // Multiple consumables can be tested.
  * viewConsumable.test( textNode ); // Tests text node.
  * viewConsumable.test( docFragment ); // Tests document fragment.
  * ```
  *
  * Testing classes and styles as attribute will test if all added classes/styles can be consumed.
  *
  * ```ts
  * viewConsumable.test( p, { attributes: 'class' } ); // Tests if all added classes can be consumed.
  * viewConsumable.test( p, { attributes: 'style' } ); // Tests if all added styles can be consumed.
  * ```
  *
  * @param consumables Used only if first parameter is {@link module:engine/view/element~Element view element} instance.
  * @param consumables.name If set to true element's name will be included.
  * @param consumables.attributes Attribute name or array of attribute names.
  * @param consumables.classes Class name or array of class names.
  * @param consumables.styles Style name or array of style names.
  * @returns Returns `true` when all items included in method's call can be consumed. Returns `false`
  * when first already consumed item is found and `null` when first non-consumable item is found.
  */
  test(n, t) {
    const i = this._consumables.get(n);
    return i === void 0 ? null : n.is("$text") || n.is("documentFragment") ? i : i.test(Xo(t));
  }
  /**
  * Consumes {@link module:engine/view/element~Element view element}, {@link module:engine/view/text~Text text node} or
  * {@link module:engine/view/documentfragment~DocumentFragment document fragment}.
  * It returns `true` when all items included in method's call can be consumed, otherwise returns `false`.
  *
  * ```ts
  * viewConsumable.consume( p, { name: true } ); // Consumes element's name.
  * viewConsumable.consume( p, { attributes: 'name' } ); // Consumes element's attribute.
  * viewConsumable.consume( p, { classes: 'foobar' } ); // Consumes element's class.
  * viewConsumable.consume( p, { styles: 'color' } ); // Consumes element's style.
  * viewConsumable.consume( p, { attributes: 'name', styles: 'color' } ); // Consumes attribute and style.
  * viewConsumable.consume( p, { classes: [ 'baz', 'bar' ] } ); // Multiple consumables can be consumed.
  * viewConsumable.consume( textNode ); // Consumes text node.
  * viewConsumable.consume( docFragment ); // Consumes document fragment.
  * ```
  *
  * Consuming classes and styles as attribute will test if all added classes/styles can be consumed.
  *
  * ```ts
  * viewConsumable.consume( p, { attributes: 'class' } ); // Consume only if all added classes can be consumed.
  * viewConsumable.consume( p, { attributes: 'style' } ); // Consume only if all added styles can be consumed.
  * ```
  *
  * @param consumables Used only if first parameter is {@link module:engine/view/element~Element view element} instance.
  * @param consumables.name If set to true element's name will be included.
  * @param consumables.attributes Attribute name or array of attribute names.
  * @param consumables.classes Class name or array of class names.
  * @param consumables.styles Style name or array of style names.
  * @returns Returns `true` when all items included in method's call can be consumed,
  * otherwise returns `false`.
  */
  consume(n, t) {
    if (n.is("$text") || n.is("documentFragment"))
      return this.test(n, t) ? (this._consumables.set(n, !1), !0) : !1;
    const i = this._consumables.get(n);
    return i === void 0 ? !1 : i.consume(Xo(t));
  }
  /**
  * Reverts {@link module:engine/view/element~Element view element}, {@link module:engine/view/text~Text text node} or
  * {@link module:engine/view/documentfragment~DocumentFragment document fragment} so they can be consumed once again.
  * Method does not revert items that were never previously added for consumption, even if they are included in
  * method's call.
  *
  * ```ts
  * viewConsumable.revert( p, { name: true } ); // Reverts element's name.
  * viewConsumable.revert( p, { attributes: 'name' } ); // Reverts element's attribute.
  * viewConsumable.revert( p, { classes: 'foobar' } ); // Reverts element's class.
  * viewConsumable.revert( p, { styles: 'color' } ); // Reverts element's style.
  * viewConsumable.revert( p, { attributes: 'name', styles: 'color' } ); // Reverts attribute and style.
  * viewConsumable.revert( p, { classes: [ 'baz', 'bar' ] } ); // Multiple names can be reverted.
  * viewConsumable.revert( textNode ); // Reverts text node.
  * viewConsumable.revert( docFragment ); // Reverts document fragment.
  * ```
  *
  * Reverting classes and styles as attribute will revert all classes/styles that were previously added for
  * consumption.
  *
  * ```ts
  * viewConsumable.revert( p, { attributes: 'class' } ); // Reverts all classes added for consumption.
  * viewConsumable.revert( p, { attributes: 'style' } ); // Reverts all styles added for consumption.
  * ```
  *
  * @param consumables Used only if first parameter is {@link module:engine/view/element~Element view element} instance.
  * @param consumables.name If set to true element's name will be included.
  * @param consumables.attributes Attribute name or array of attribute names.
  * @param consumables.classes Class name or array of class names.
  * @param consumables.styles Style name or array of style names.
  */
  revert(n, t) {
    const i = this._consumables.get(n);
    i !== void 0 && (n.is("$text") || n.is("documentFragment") ? this._consumables.set(n, !0) : i.revert(Xo(t)));
  }
  /**
  * Creates {@link module:engine/conversion/viewconsumable~ViewConsumable ViewConsumable} instance from
  * {@link module:engine/view/node~Node node} or {@link module:engine/view/documentfragment~DocumentFragment document fragment}.
  * Instance will contain all elements, child nodes, attributes, styles and classes added for consumption.
  *
  * @param from View node or document fragment from which `ViewConsumable` will be created.
  * @param instance If provided, given `ViewConsumable` instance will be used
  * to add all consumables. It will be returned instead of a new instance.
  */
  static createFrom(n, t) {
    if (t || (t = new _l()), n.is("$text"))
      t.add(n);
    else if (n.is("element") || n.is("documentFragment")) {
      t.add(n);
      for (const i of n.getChildren())
        _l.createFrom(i, t);
    }
    return t;
  }
}
class YP {
  /**
  * Creates ViewElementConsumables instance.
  *
  * @param from View element from which `ViewElementConsumables` is being created.
  */
  constructor(n) {
    m(this, "element");
    /**
    * Flag indicating if name of the element can be consumed.
    */
    m(this, "_canConsumeName", null);
    /**
    * A map of element's consumables.
    * * For plain attributes the value is a boolean indicating whether the attribute is available to consume.
    * * For token based attributes (like class list and style) the value is a map of tokens to booleans
    * indicating whether the token is available to consume on the given attribute.
    */
    m(this, "_attributes", /* @__PURE__ */ new Map());
    this.element = n;
  }
  /**
  * Adds consumable parts of the {@link module:engine/view/element~Element view element}.
  * Element's name itself can be marked to be consumed (when element's name is consumed its attributes, classes and
  * styles still could be consumed):
  *
  * ```ts
  * consumables.add( { name: true } );
  * ```
  *
  * Attributes classes and styles:
  *
  * ```ts
  * consumables.add( { attributes: [ [ 'title' ], [ 'class', 'foo' ], [ 'style', 'color'] ] } );
  * consumables.add( { attributes: [ [ 'title' ], [ 'name' ], [ 'class', 'foo' ], [ 'class', 'bar' ] ] } );
  * ```
  *
  * Note: This method accepts only {@link module:engine/view/element~NormalizedConsumables}.
  * You can use {@link module:engine/conversion/viewconsumable~normalizeConsumables} helper to convert from
  * {@link module:engine/conversion/viewconsumable~Consumables} to `NormalizedConsumables`.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `viewconsumable-invalid-attribute` when `class` or `style`
  * attribute is provided - it should be handled separately by providing `style` and `class` in consumables object.
  *
  * @param consumables Object describing which parts of the element can be consumed.
  */
  add(n) {
    n.name && (this._canConsumeName = !0);
    for (const [t, i] of n.attributes)
      if (i) {
        let r = this._attributes.get(t);
        (!r || typeof r == "boolean") && (r = /* @__PURE__ */ new Map(), this._attributes.set(t, r)), r.set(i, !0);
      } else {
        if (t == "style" || t == "class")
          throw new v("viewconsumable-invalid-attribute", this);
        this._attributes.set(t, !0);
      }
  }
  /**
  * Tests if parts of the {@link module:engine/view/element~Element view element} can be consumed.
  *
  * Element's name can be tested:
  *
  * ```ts
  * consumables.test( { name: true } );
  * ```
  *
  * Attributes classes and styles:
  *
  * ```ts
  * consumables.test( { attributes: [ [ 'title' ], [ 'class', 'foo' ], [ 'style', 'color' ] ] } );
  * consumables.test( { attributes: [ [ 'title' ], [ 'name' ], [ 'class', 'foo' ], [ 'class', 'bar' ] ] } );
  * ```
  *
  * @param consumables Object describing which parts of the element should be tested.
  * @returns `true` when all tested items can be consumed, `null` when even one of the items
  * was never marked for consumption and `false` when even one of the items was already consumed.
  */
  test(n) {
    if (n.name && !this._canConsumeName)
      return this._canConsumeName;
    for (const [t, i] of n.attributes) {
      const r = this._attributes.get(t);
      if (r === void 0)
        return null;
      if (r === !1)
        return !1;
      if (r !== !0) {
        if (i) {
          const s = r.get(i);
          if (s === void 0)
            return null;
          if (!s)
            return !1;
        } else
          for (const s of r.values())
            if (!s)
              return !1;
      }
    }
    return !0;
  }
  /**
  * Tests if parts of the {@link module:engine/view/element~Element view element} can be consumed and consumes them if available.
  * It returns `true` when all items included in method's call can be consumed, otherwise returns `false`.
  *
  * Element's name can be consumed:
  *
  * ```ts
  * consumables.consume( { name: true } );
  * ```
  *
  * Attributes classes and styles:
  *
  * ```ts
  * consumables.consume( { attributes: [ [ 'title' ], [ 'class', 'foo' ], [ 'style', 'color' ] ] } );
  * consumables.consume( { attributes: [ [ 'title' ], [ 'name' ], [ 'class', 'foo' ], [ 'class', 'bar' ] ] } );
  * ```
  *
  * @param consumables Object describing which parts of the element should be consumed.
  * @returns `true` when all tested items can be consumed and `false` when even one of the items could not be consumed.
  */
  consume(n) {
    if (!this.test(n))
      return !1;
    n.name && (this._canConsumeName = !1);
    for (const [t, i] of n.attributes) {
      const r = this._attributes.get(t);
      if (typeof r == "boolean")
        for (const [s] of this.element._getConsumables(t, i).attributes)
          this._attributes.set(s, !1);
      else if (i)
        for (const [, s] of this.element._getConsumables(t, i).attributes)
          r.set(s, !1);
      else
        for (const s of r.keys())
          r.set(s, !1);
    }
    return !0;
  }
  /**
  * Revert already consumed parts of {@link module:engine/view/element~Element view Element}, so they can be consumed once again.
  * Element's name can be reverted:
  *
  * ```ts
  * consumables.revert( { name: true } );
  * ```
  *
  * Attributes classes and styles:
  *
  * ```ts
  * consumables.revert( { attributes: [ [ 'title' ], [ 'class', 'foo' ], [ 'style', 'color' ] ] } );
  * consumables.revert( { attributes: [ [ 'title' ], [ 'name' ], [ 'class', 'foo' ], [ 'class', 'bar' ] ] } );
  * ```
  *
  * @param consumables Object describing which parts of the element should be reverted.
  */
  revert(n) {
    n.name && (this._canConsumeName = !0);
    for (const [t, i] of n.attributes) {
      const r = this._attributes.get(t);
      if (r === !1) {
        this._attributes.set(t, !0);
        continue;
      }
      if (!(r === void 0 || r === !0))
        if (i)
          r.get(i) === !1 && r.set(i, !0);
        else
          for (const s of r.keys())
            r.set(s, !0);
    }
  }
}
function Xo(e) {
  const n = [];
  return "attributes" in e && e.attributes && sd(n, e.attributes), "classes" in e && e.classes && sd(n, e.classes, "class"), "styles" in e && e.styles && sd(n, e.styles, "style"), {
    name: e.name || !1,
    attributes: n
  };
}
function sd(e, n, t) {
  if (typeof n == "string") {
    e.push(t ? [
      t,
      n
    ] : [
      n
    ]);
    return;
  }
  for (const i of n)
    Array.isArray(i) ? e.push(i) : e.push(t ? [
      t,
      i
    ] : [
      i
    ]);
}
class Oa {
  /**
  * Creates new instance of Matcher.
  *
  * @param pattern Match patterns. See {@link module:engine/view/matcher~Matcher#add add method} for more information.
  */
  constructor(...n) {
    m(this, "_patterns", []);
    this.add(...n);
  }
  /**
  * Adds pattern or patterns to matcher instance.
  *
  * ```ts
  * // String.
  * matcher.add( 'div' );
  *
  * // Regular expression.
  * matcher.add( /^\w/ );
  *
  * // Single class.
  * matcher.add( {
  * 	classes: 'foobar'
  * } );
  * ```
  *
  * See {@link module:engine/view/matcher~MatcherPattern} for more examples.
  *
  * Multiple patterns can be added in one call:
  *
  * ```ts
  * matcher.add( 'div', { classes: 'foobar' } );
  * ```
  *
  * @param pattern Object describing pattern details. If string or regular expression
  * is provided it will be used to match element's name. Pattern can be also provided in a form
  * of a function - then this function will be called with each {@link module:engine/view/element~Element element} as a parameter.
  * Function's return value will be stored under `match` key of the object returned from
  * {@link module:engine/view/matcher~Matcher#match match} or {@link module:engine/view/matcher~Matcher#matchAll matchAll} methods.
  */
  add(...n) {
    for (let t of n)
      (typeof t == "string" || t instanceof RegExp) && (t = {
        name: t
      }), this._patterns.push(t);
  }
  /**
  * Matches elements for currently stored patterns. Returns match information about first found
  * {@link module:engine/view/element~Element element}, otherwise returns `null`.
  *
  * Example of returned object:
  *
  * ```ts
  * {
  * 	element: <instance of found element>,
  * 	pattern: <pattern used to match found element>,
  * 	match: {
  * 		name: true,
  * 		attributes: [
  * 			[ 'title' ],
  * 			[ 'href' ],
  * 			[ 'class', 'foo' ],
  * 			[ 'style', 'color' ],
  * 			[ 'style', 'position' ]
  * 		]
  * 	}
  * }
  * ```
  *
  * You could use the `match` field from the above returned object as an input for the
  * {@link module:engine/conversion/viewconsumable~ViewConsumable#test `ViewConsumable#test()`} and
  * {@link module:engine/conversion/viewconsumable~ViewConsumable#consume `ViewConsumable#consume()`} methods.
  *
  * @see module:engine/view/matcher~Matcher#add
  * @see module:engine/view/matcher~Matcher#matchAll
  * @param element View element to match against stored patterns.
  * @returns The match information about found element or `null`.
  */
  match(...n) {
    for (const t of n)
      for (const i of this._patterns) {
        const r = this._isElementMatching(t, i);
        if (r)
          return {
            element: t,
            pattern: i,
            match: r
          };
      }
    return null;
  }
  /**
  * Matches elements for currently stored patterns. Returns array of match information with all found
  * {@link module:engine/view/element~Element elements}. If no element is found - returns `null`.
  *
  * @see module:engine/view/matcher~Matcher#add
  * @see module:engine/view/matcher~Matcher#match
  * @param element View element to match against stored patterns.
  * @returns Array with match information about found elements or `null`. For more information
  * see {@link module:engine/view/matcher~Matcher#match match method} description.
  */
  matchAll(...n) {
    const t = [];
    for (const i of n)
      for (const r of this._patterns) {
        const s = this._isElementMatching(i, r);
        s && t.push({
          element: i,
          pattern: r,
          match: s
        });
      }
    return t.length > 0 ? t : null;
  }
  /**
  * Returns the name of the element to match if there is exactly one pattern added to the matcher instance
  * and it matches element name defined by `string` (not `RegExp`). Otherwise, returns `null`.
  *
  * @returns Element name trying to match.
  */
  getElementName() {
    if (this._patterns.length !== 1)
      return null;
    const n = this._patterns[0], t = n.name;
    return typeof n != "function" && t && !(t instanceof RegExp) ? t : null;
  }
  /**
  * Returns match information if {@link module:engine/view/element~Element element} is matching provided pattern.
  * If element cannot be matched to provided pattern - returns `null`.
  *
  * @returns Returns object with match information or null if element is not matching.
  */
  _isElementMatching(n, t) {
    if (typeof t == "function") {
      const s = t(n);
      return !s || typeof s != "object" ? s : Xo(s);
    }
    const i = {};
    if (t.name && (i.name = jP(t.name, n.name), !i.name))
      return null;
    const r = [];
    return t.attributes && !KP(t.attributes, n, r) || t.classes && !GP(t.classes, n, r) || t.styles && !QP(t.styles, n, r) ? null : (r.length && (i.attributes = r), i);
  }
}
function El(e, n) {
  return e === !0 || e === n || e instanceof RegExp && !!String(n).match(e);
}
function jP(e, n) {
  return e instanceof RegExp ? !!n.match(e) : e === n;
}
function jf(e, n) {
  if (Array.isArray(e))
    return e.map((i) => typeof i != "object" || i instanceof RegExp ? n ? [
      n,
      i,
      !0
    ] : [
      i,
      !0
    ] : ((i.key === void 0 || i.value === void 0) && at("matcher-pattern-missing-key-or-value", i), n ? [
      n,
      i.key,
      i.value
    ] : [
      i.key,
      i.value
    ]));
  if (typeof e != "object" || e instanceof RegExp)
    return [
      n ? [
        n,
        e,
        !0
      ] : [
        e,
        !0
      ]
    ];
  const t = [];
  for (const i in e)
    Object.prototype.hasOwnProperty.call(e, i) && t.push(n ? [
      n,
      i,
      e[i]
    ] : [
      i,
      e[i]
    ]);
  return t;
}
function KP(e, n, t) {
  let i;
  return typeof e == "object" && !(e instanceof RegExp) && !Array.isArray(e) ? (e.style !== void 0 && at("matcher-pattern-deprecated-attributes-style-key", e), e.class !== void 0 && at("matcher-pattern-deprecated-attributes-class-key", e)) : i = [
    "class",
    "style"
  ], n._collectAttributesMatch(jf(e), t, i);
}
function GP(e, n, t) {
  return n._collectAttributesMatch(jf(e, "class"), t);
}
function QP(e, n, t) {
  return n._collectAttributesMatch(jf(e, "style"), t);
}
class oa {
  /**
  * Creates Styles instance.
  */
  constructor(n) {
    /**
    * Keeps an internal representation of styles map. Normalized styles are kept as object tree to allow unified modification and
    * value access model using lodash's get, set, unset, etc methods.
    *
    * When no style processor rules are defined it acts as simple key-value storage.
    */
    m(this, "_styles");
    /**
    * Cached list of style names for faster access.
    */
    m(this, "_cachedStyleNames", null);
    /**
    * Cached list of expanded style names for faster access.
    */
    m(this, "_cachedExpandedStyleNames", null);
    /**
    * An instance of the {@link module:engine/view/stylesmap~StylesProcessor}.
    */
    m(this, "_styleProcessor");
    this._styles = {}, this._styleProcessor = n;
  }
  /**
  * Returns true if style map has no styles set.
  */
  get isEmpty() {
    return !Object.entries(this._styles).length;
  }
  /**
  * Number of styles defined.
  */
  get size() {
    return this.isEmpty ? 0 : this.getStyleNames().length;
  }
  /**
  * Set styles map to a new value.
  *
  * ```ts
  * styles.setTo( 'border:1px solid blue;margin-top:1px;' );
  * ```
  */
  setTo(n) {
    this.clear();
    const t = JP(n);
    for (const [i, r] of t)
      this._styleProcessor.toNormalizedForm(i, r, this._styles);
    return this;
  }
  /**
  * Checks if a given style is set.
  *
  * ```ts
  * styles.setTo( 'margin-left:1px;' );
  *
  * styles.has( 'margin-left' );    // -> true
  * styles.has( 'padding' );        // -> false
  * ```
  *
  * **Note**: This check supports normalized style names.
  *
  * ```ts
  * // Enable 'margin' shorthand processing:
  * editor.data.addStyleProcessorRules( addMarginRules );
  *
  * styles.setTo( 'margin:2px;' );
  *
  * styles.has( 'margin' );         // -> true
  * styles.has( 'margin-top' );     // -> true
  * styles.has( 'margin-left' );    // -> true
  *
  * styles.remove( 'margin-top' );
  *
  * styles.has( 'margin' );         // -> false
  * styles.has( 'margin-top' );     // -> false
  * styles.has( 'margin-left' );    // -> true
  * ```
  *
  * @param name Style name.
  */
  has(n) {
    if (this.isEmpty)
      return !1;
    const i = this._styleProcessor.getReducedForm(n, this._styles).find(([r]) => r === n);
    return Array.isArray(i);
  }
  set(n, t) {
    if (this._cachedStyleNames = null, this._cachedExpandedStyleNames = null, ft(n))
      for (const [i, r] of Object.entries(n))
        this._styleProcessor.toNormalizedForm(i, r, this._styles);
    else
      this._styleProcessor.toNormalizedForm(n, t, this._styles);
  }
  /**
  * Removes given style.
  *
  * ```ts
  * styles.setTo( 'background:#f00;margin-right:2px;' );
  *
  * styles.remove( 'background' );
  *
  * styles.toString();   // -> 'margin-right:2px;'
  * ```
  *
  * ***Note**:* This method uses {@link module:engine/controller/datacontroller~DataController#addStyleProcessorRules
  * enabled style processor rules} to normalize passed values.
  *
  * ```ts
  * // Enable 'margin' shorthand processing:
  * editor.data.addStyleProcessorRules( addMarginRules );
  *
  * styles.setTo( 'margin:1px' );
  *
  * styles.remove( 'margin-top' );
  * styles.remove( 'margin-right' );
  *
  * styles.toString(); // -> 'margin-bottom:1px;margin-left:1px;'
  * ```
  *
  * @param names Style name or an array of names.
  */
  remove(n) {
    for (const t of Dt(n)) {
      this._cachedStyleNames = null, this._cachedExpandedStyleNames = null;
      const i = Ih(t);
      Cv(this._styles, i), delete this._styles[t], this._cleanEmptyObjectsOnPath(i);
    }
  }
  /**
  * Returns a normalized style object or a single value.
  *
  * ```ts
  * // Enable 'margin' shorthand processing:
  * editor.data.addStyleProcessorRules( addMarginRules );
  *
  * const styles = new Styles();
  * styles.setTo( 'margin:1px 2px 3em;' );
  *
  * styles.getNormalized( 'margin' );
  * // will log:
  * // {
  * //     top: '1px',
  * //     right: '2px',
  * //     bottom: '3em',
  * //     left: '2px'     // normalized value from margin shorthand
  * // }
  *
  * styles.getNormalized( 'margin-left' ); // -> '2px'
  * ```
  *
  * **Note**: This method will only return normalized styles if a style processor was defined.
  *
  * @param name Style name.
  */
  getNormalized(n) {
    return this._styleProcessor.getNormalized(n, this._styles);
  }
  /**
  * Returns a normalized style string. Styles are sorted by name.
  *
  * ```ts
  * styles.set( 'margin' , '1px' );
  * styles.set( 'background', '#f00' );
  *
  * styles.toString(); // -> 'background:#f00;margin:1px;'
  * ```
  *
  * **Note**: This method supports normalized styles if defined.
  *
  * ```ts
  * // Enable 'margin' shorthand processing:
  * editor.data.addStyleProcessorRules( addMarginRules );
  *
  * styles.set( 'margin' , '1px' );
  * styles.set( 'background', '#f00' );
  * styles.remove( 'margin-top' );
  * styles.remove( 'margin-right' );
  *
  * styles.toString(); // -> 'background:#f00;margin-bottom:1px;margin-left:1px;'
  * ```
  */
  toString() {
    return this.isEmpty ? "" : this.getStylesEntries().map((n) => n.join(":")).sort().join(";") + ";";
  }
  /**
  * Returns property as a value string or undefined if property is not set.
  *
  * ```ts
  * // Enable 'margin' shorthand processing:
  * editor.data.addStyleProcessorRules( addMarginRules );
  *
  * const styles = new Styles();
  * styles.setTo( 'margin:1px;' );
  * styles.set( 'margin-bottom', '3em' );
  *
  * styles.getAsString( 'margin' ); // -> 'margin: 1px 1px 3em;'
  * ```
  *
  * Note, however, that all sub-values must be set for the longhand property name to return a value:
  *
  * ```ts
  * const styles = new Styles();
  * styles.setTo( 'margin:1px;' );
  * styles.remove( 'margin-bottom' );
  *
  * styles.getAsString( 'margin' ); // -> undefined
  * ```
  *
  * In the above scenario, it is not possible to return a `margin` value, so `undefined` is returned.
  * Instead, you should use:
  *
  * ```ts
  * const styles = new Styles();
  * styles.setTo( 'margin:1px;' );
  * styles.remove( 'margin-bottom' );
  *
  * for ( const styleName of styles.getStyleNames() ) {
  * 	console.log( styleName, styles.getAsString( styleName ) );
  * }
  * // 'margin-top', '1px'
  * // 'margin-right', '1px'
  * // 'margin-left', '1px'
  * ```
  *
  * In general, it is recommend to iterate over style names like in the example above. This way, you will always get all
  * the currently set style values. So, if all the 4 margin values would be set
  * the for-of loop above would yield only `'margin'`, `'1px'`:
  *
  * ```ts
  * const styles = new Styles();
  * styles.setTo( 'margin:1px;' );
  *
  * for ( const styleName of styles.getStyleNames() ) {
  * 	console.log( styleName, styles.getAsString( styleName ) );
  * }
  * // 'margin', '1px'
  * ```
  *
  * **Note**: To get a normalized version of a longhand property use the {@link #getNormalized `#getNormalized()`} method.
  */
  getAsString(n) {
    if (this.isEmpty)
      return;
    if (this._styles[n] && !ft(this._styles[n]))
      return this._styles[n];
    const i = this._styleProcessor.getReducedForm(n, this._styles).find(([r]) => r === n);
    if (Array.isArray(i))
      return i[1];
  }
  /**
  * Returns all style properties names as they would appear when using {@link #toString `#toString()`}.
  *
  * When `expand` is set to true and there's a shorthand style property set, it will also return all equivalent styles:
  *
  * ```ts
  * stylesMap.setTo( 'margin: 1em' )
  * ```
  *
  * will be expanded to:
  *
  * ```ts
  * [ 'margin', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left' ]
  * ```
  *
  * @param expand Expand shorthand style properties and all return equivalent style representations.
  */
  getStyleNames(n = !1) {
    return this.isEmpty ? [] : n ? (this._cachedExpandedStyleNames = this._cachedExpandedStyleNames || this._styleProcessor.getStyleNames(this._styles), this._cachedExpandedStyleNames) : (this._cachedStyleNames = this._cachedStyleNames || this.getStylesEntries().map(([t]) => t), this._cachedStyleNames);
  }
  /**
  * Alias for {@link #getStyleNames}.
  */
  keys() {
    return this.getStyleNames();
  }
  /**
  * Removes all styles.
  */
  clear() {
    this._styles = {}, this._cachedStyleNames = null, this._cachedExpandedStyleNames = null;
  }
  /**
  * Returns `true` if both attributes have the same styles.
  */
  isSimilar(n) {
    if (this.size !== n.size)
      return !1;
    for (const t of this.getStyleNames())
      if (!n.has(t) || n.getAsString(t) !== this.getAsString(t))
        return !1;
    return !0;
  }
  /**
  * Returns normalized styles entries for further processing.
  */
  getStylesEntries() {
    const n = [], t = Object.keys(this._styles);
    for (const i of t)
      n.push(...this._styleProcessor.getReducedForm(i, this._styles));
    return n;
  }
  /**
  * Clones the attribute value.
  *
  * @internal
  */
  _clone() {
    const n = new this.constructor(this._styleProcessor);
    return n.set(this.getNormalized()), n;
  }
  /**
  * Used by the {@link module:engine/view/matcher~Matcher Matcher} to collect matching styles.
  *
  * @internal
  * @param tokenPattern The matched style name pattern.
  * @param valuePattern The matched style value pattern.
  * @returns An array of matching tokens (style names).
  */
  _getTokensMatch(n, t) {
    const i = [];
    for (const r of this.getStyleNames(!0))
      if (El(n, r)) {
        if (t === !0) {
          i.push(r);
          continue;
        }
        const s = this.getAsString(r);
        El(t, s) && i.push(r);
      }
    return i.length ? i : void 0;
  }
  /**
  * Returns a list of consumables for the attribute. This includes related styles.
  *
  * Could be filtered by the given style name.
  *
  * @internal
  */
  _getConsumables(n) {
    const t = [];
    if (n) {
      t.push(n);
      for (const i of this._styleProcessor.getRelatedStyles(n))
        t.push(i);
    } else
      for (const i of this.getStyleNames()) {
        for (const r of this._styleProcessor.getRelatedStyles(i))
          t.push(r);
        t.push(i);
      }
    return t;
  }
  /**
  * Used by {@link module:engine/view/element~Element#_canMergeAttributesFrom} to verify if the given attribute can be merged without
  * conflicts into the attribute.
  *
  * This method is indirectly used by the {@link module:engine/view/downcastwriter~DowncastWriter} while down-casting
  * an {@link module:engine/view/attributeelement~AttributeElement} to merge it with other AttributeElement.
  *
  * @internal
  */
  _canMergeFrom(n) {
    for (const t of n.getStyleNames())
      if (this.has(t) && this.getAsString(t) !== n.getAsString(t))
        return !1;
    return !0;
  }
  /**
  * Used by {@link module:engine/view/element~Element#_mergeAttributesFrom} to merge a given attribute into the attribute.
  *
  * This method is indirectly used by the {@link module:engine/view/downcastwriter~DowncastWriter} while down-casting
  * an {@link module:engine/view/attributeelement~AttributeElement} to merge it with other AttributeElement.
  *
  * @internal
  */
  _mergeFrom(n) {
    for (const t of n.getStyleNames())
      this.has(t) || this.set(t, n.getAsString(t));
  }
  /**
  * Used by {@link module:engine/view/element~Element#_canSubtractAttributesOf} to verify if the given attribute can be fully
  * subtracted from the attribute.
  *
  * This method is indirectly used by the {@link module:engine/view/downcastwriter~DowncastWriter} while down-casting
  * an {@link module:engine/view/attributeelement~AttributeElement} to unwrap the AttributeElement.
  *
  * @internal
  */
  _isMatching(n) {
    for (const t of n.getStyleNames())
      if (!this.has(t) || this.getAsString(t) !== n.getAsString(t))
        return !1;
    return !0;
  }
  /**
  * Removes empty objects upon removing an entry from internal object.
  */
  _cleanEmptyObjectsOnPath(n) {
    const t = n.split(".");
    if (!(t.length > 1))
      return;
    const r = t.splice(0, t.length - 1).join("."), s = Js(this._styles, r);
    if (!s)
      return;
    !Object.keys(s).length && this.remove(r);
  }
}
class XP {
  /**
  * Creates StylesProcessor instance.
  *
  * @internal
  */
  constructor() {
    m(this, "_normalizers");
    m(this, "_extractors");
    m(this, "_reducers");
    m(this, "_consumables");
    this._normalizers = /* @__PURE__ */ new Map(), this._extractors = /* @__PURE__ */ new Map(), this._reducers = /* @__PURE__ */ new Map(), this._consumables = /* @__PURE__ */ new Map();
  }
  /**
  * Parse style string value to a normalized object and appends it to styles object.
  *
  * ```ts
  * const styles = {};
  *
  * stylesProcessor.toNormalizedForm( 'margin', '1px', styles );
  *
  * // styles will consist: { margin: { top: '1px', right: '1px', bottom: '1px', left: '1px; } }
  * ```
  *
  * **Note**: To define normalizer callbacks use {@link #setNormalizer}.
  *
  * @param name Name of style property.
  * @param propertyValue Value of style property.
  * @param styles Object holding normalized styles.
  */
  toNormalizedForm(n, t, i) {
    if (ft(t)) {
      od(i, Ih(n), t);
      return;
    }
    if (this._normalizers.has(n)) {
      const r = this._normalizers.get(n), { path: s, value: o } = r(t);
      od(i, s, o);
    } else
      od(i, n, t);
  }
  /**
  * Returns a normalized version of a style property.
  *
  * ```ts
  * const styles = {
  * 	margin: { top: '1px', right: '1px', bottom: '1px', left: '1px; },
  * 	background: { color: '#f00' }
  * };
  *
  * stylesProcessor.getNormalized( 'background' );
  * // will return: { color: '#f00' }
  *
  * stylesProcessor.getNormalized( 'margin-top' );
  * // will return: '1px'
  * ```
  *
  * **Note**: In some cases extracting single value requires defining an extractor callback {@link #setExtractor}.
  *
  * @param name Name of style property.
  * @param styles Object holding normalized styles.
  */
  getNormalized(n, t) {
    if (!n)
      return Uf({}, t);
    if (t[n] !== void 0)
      return t[n];
    if (this._extractors.has(n)) {
      const i = this._extractors.get(n);
      if (typeof i == "string")
        return Js(t, i);
      const r = i(n, t);
      if (r)
        return r;
    }
    return Js(t, Ih(n));
  }
  /**
  * Returns a reduced form of style property form normalized object.
  *
  * For default margin reducer, the below code:
  *
  * ```ts
  * stylesProcessor.getReducedForm( 'margin', {
  * 	margin: { top: '1px', right: '1px', bottom: '2px', left: '1px; }
  * } );
  * ```
  *
  * will return:
  *
  * ```ts
  * [
  * 	[ 'margin', '1px 1px 2px' ]
  * ]
  * ```
  *
  * because it might be represented as a shorthand 'margin' value. However if one of margin long hand values is missing it should return:
  *
  * ```ts
  * [
  * 	[ 'margin-top', '1px' ],
  * 	[ 'margin-right', '1px' ],
  * 	[ 'margin-bottom', '2px' ]
  * 	// the 'left' value is missing - cannot use 'margin' shorthand.
  * ]
  * ```
  *
  * **Note**: To define reducer callbacks use {@link #setReducer}.
  *
  * @param name Name of style property.
  */
  getReducedForm(n, t) {
    const i = this.getNormalized(n, t);
    return i === void 0 ? [] : this._reducers.has(n) ? this._reducers.get(n)(i) : [
      [
        n,
        i
      ]
    ];
  }
  /**
  * Return all style properties. Also expand shorthand properties (e.g. `margin`, `background`) if respective extractor is available.
  *
  * @param styles Object holding normalized styles.
  */
  getStyleNames(n) {
    const t = /* @__PURE__ */ new Set();
    for (const i of this._consumables.keys()) {
      const r = this.getNormalized(i, n);
      r && (typeof r != "object" || Object.keys(r).length) && t.add(i);
    }
    for (const i of Object.keys(n))
      t.add(i);
    return Array.from(t);
  }
  /**
  * Returns related style names.
  *
  * ```ts
  * stylesProcessor.getRelatedStyles( 'margin' );
  * // will return: [ 'margin-top', 'margin-right', 'margin-bottom', 'margin-left' ];
  *
  * stylesProcessor.getRelatedStyles( 'margin-top' );
  * // will return: [ 'margin' ];
  * ```
  *
  * **Note**: To define new style relations load an existing style processor or use
  * {@link module:engine/view/stylesmap~StylesProcessor#setStyleRelation `StylesProcessor.setStyleRelation()`}.
  */
  getRelatedStyles(n) {
    return this._consumables.get(n) || [];
  }
  /**
  * Adds a normalizer method for a style property.
  *
  * A normalizer returns describing how the value should be normalized.
  *
  * For instance 'margin' style is a shorthand for four margin values:
  *
  * - 'margin-top'
  * - 'margin-right'
  * - 'margin-bottom'
  * - 'margin-left'
  *
  * and can be written in various ways if some values are equal to others. For instance `'margin: 1px 2em;'` is a shorthand for
  * `'margin-top: 1px;margin-right: 2em;margin-bottom: 1px;margin-left: 2em'`.
  *
  * A normalizer should parse various margin notations as a single object:
  *
  * ```ts
  * const styles = {
  * 	margin: {
  * 		top: '1px',
  * 		right: '2em',
  * 		bottom: '1px',
  * 		left: '2em'
  * 	}
  * };
  * ```
  *
  * Thus a normalizer for 'margin' style should return an object defining style path and value to store:
  *
  * ```ts
  * const returnValue = {
  * 	path: 'margin',
  * 	value: {
  * 		top: '1px',
  * 		right: '2em',
  * 		bottom: '1px',
  * 		left: '2em'
  * 	}
  * };
  * ```
  *
  * Additionally to fully support all margin notations there should be also defined 4 normalizers for longhand margin notations. Below
  * is an example for 'margin-top' style property normalizer:
  *
  * ```ts
  * stylesProcessor.setNormalizer( 'margin-top', valueString => {
  * 	return {
  * 		path: 'margin.top',
  * 		value: valueString
  * 	}
  * } );
  * ```
  */
  setNormalizer(n, t) {
    this._normalizers.set(n, t);
  }
  /**
  * Adds a extractor callback for a style property.
  *
  * Most normalized style values are stored as one level objects. It is assumed that `'margin-top'` style will be stored as:
  *
  * ```ts
  * const styles = {
  * 	margin: {
  * 		top: 'value'
  * 	}
  * }
  * ```
  *
  * However, some styles can have conflicting notations and thus it might be harder to extract a style value from shorthand. For instance
  * the 'border-top-style' can be defined using `'border-top:solid'`, `'border-style:solid none none none'` or by `'border:solid'`
  * shorthands. The default border styles processors stores styles as:
  *
  * ```ts
  * const styles = {
  * 	border: {
  * 		style: {
  * 			top: 'solid'
  * 		}
  * 	}
  * }
  * ```
  *
  * as it is better to modify border style independently from other values. On the other part the output of the border might be
  * desired as `border-top`, `border-left`, etc notation.
  *
  * In the above example an extractor should return a side border value that combines style, color and width:
  *
  * ```ts
  * styleProcessor.setExtractor( 'border-top', styles => {
  * 	return {
  * 		color: styles.border.color.top,
  * 		style: styles.border.style.top,
  * 		width: styles.border.width.top
  * 	}
  * } );
  * ```
  *
  * @param callbackOrPath Callback that return a requested value or path string for single values.
  */
  setExtractor(n, t) {
    this._extractors.set(n, t);
  }
  /**
  * Adds a reducer callback for a style property.
  *
  * Reducer returns a minimal notation for given style name. For longhand properties it is not required to write a reducer as
  * by default the direct value from style path is taken.
  *
  * For shorthand styles a reducer should return minimal style notation either by returning single name-value tuple or multiple tuples
  * if a shorthand cannot be used. For instance for a margin shorthand a reducer might return:
  *
  * ```ts
  * const marginShortHandTuple = [
  * 	[ 'margin', '1px 1px 2px' ]
  * ];
  * ```
  *
  * or a longhand tuples for defined values:
  *
  * ```ts
  * // Considering margin.bottom and margin.left are undefined.
  * const marginLonghandsTuples = [
  * 	[ 'margin-top', '1px' ],
  * 	[ 'margin-right', '1px' ]
  * ];
  * ```
  *
  * A reducer obtains a normalized style value:
  *
  * ```ts
  * // Simplified reducer that always outputs 4 values which are always present:
  * stylesProcessor.setReducer( 'margin', margin => {
  * 	return [
  * 		[ 'margin', `${ margin.top } ${ margin.right } ${ margin.bottom } ${ margin.left }` ]
  * 	]
  * } );
  * ```
  */
  setReducer(n, t) {
    this._reducers.set(n, t);
  }
  /**
  * Defines a style shorthand relation to other style notations.
  *
  * ```ts
  * stylesProcessor.setStyleRelation( 'margin', [
  * 	'margin-top',
  * 	'margin-right',
  * 	'margin-bottom',
  * 	'margin-left'
  * ] );
  * ```
  *
  * This enables expanding of style names for shorthands. For instance, if defined,
  * {@link module:engine/conversion/viewconsumable~ViewConsumable view consumable} items are automatically created
  * for long-hand margin style notation alongside the `'margin'` item.
  *
  * This means that when an element being converted has a style `margin`, a converter for `margin-left` will work just
  * fine since the view consumable will contain a consumable `margin-left` item (thanks to the relation) and
  * `element.getStyle( 'margin-left' )` will work as well assuming that the style processor was correctly configured.
  * However, once `margin-left` is consumed, `margin` will not be consumable anymore.
  */
  setStyleRelation(n, t) {
    this._mapStyleNames(n, t);
    for (const i of t)
      this._mapStyleNames(i, [
        n
      ]);
  }
  /**
  * Set two-way binding of style names.
  */
  _mapStyleNames(n, t) {
    this._consumables.has(n) || this._consumables.set(n, []), this._consumables.get(n).push(...t);
  }
}
function JP(e) {
  let n = null, t = 0, i = 0, r = null;
  const s = /* @__PURE__ */ new Map();
  if (e === "")
    return s;
  e.charAt(e.length - 1) != ";" && (e = e + ";");
  for (let o = 0; o < e.length; o++) {
    const a = e.charAt(o);
    if (n === null)
      switch (a) {
        case ":":
          r || (r = e.substr(t, o - t), i = o + 1);
          break;
        case '"':
        case "'":
          n = a;
          break;
        case ";": {
          const u = e.substr(i, o - i);
          r && s.set(r.trim(), u.trim()), r = null, t = o + 1;
          break;
        }
      }
    else a === n && (n = null);
  }
  return s;
}
function Ih(e) {
  return e.replace("-", ".");
}
function od(e, n, t) {
  let i = t;
  ft(t) && (i = Uf({}, Js(e, n), t)), _E(e, n, i);
}
class ad {
  constructor() {
    /**
    * The set of tokens.
    */
    m(this, "_set", /* @__PURE__ */ new Set());
  }
  /**
  * Returns true if token list has no tokens set.
  */
  get isEmpty() {
    return this._set.size == 0;
  }
  /**
  * Number of tokens.
  */
  get size() {
    return this._set.size;
  }
  /**
  * Checks if a given token is set.
  */
  has(n) {
    return this._set.has(n);
  }
  /**
  * Returns all tokens.
  */
  keys() {
    return Array.from(this._set.keys());
  }
  /**
  * Resets the value to the given one.
  */
  setTo(n) {
    this.clear();
    for (const t of n.split(/\s+/))
      t && this._set.add(t);
    return this;
  }
  /**
  * Sets a given token without affecting other tokens.
  */
  set(n) {
    for (const t of Dt(n))
      t && this._set.add(t);
  }
  /**
  * Removes given token.
  */
  remove(n) {
    for (const t of Dt(n))
      this._set.delete(t);
  }
  /**
  * Removes all tokens.
  */
  clear() {
    this._set.clear();
  }
  /**
  * Returns a normalized tokens string.
  */
  toString() {
    return Array.from(this._set).join(" ");
  }
  /**
  * Returns `true` if both attributes have the same tokens.
  */
  isSimilar(n) {
    if (this.size !== n.size)
      return !1;
    for (const t of this.keys())
      if (!n.has(t))
        return !1;
    return !0;
  }
  /**
  * Clones the attribute value.
  *
  * @internal
  */
  _clone() {
    const n = new this.constructor();
    return n._set = new Set(this._set), n;
  }
  /**
  * Used by the {@link module:engine/view/matcher~Matcher Matcher} to collect matching attribute tokens.
  *
  * @internal
  * @param tokenPattern The matched token name pattern.
  * @returns An array of matching tokens.
  */
  _getTokensMatch(n) {
    const t = [];
    if (n === !0) {
      for (const i of this._set.keys())
        t.push(i);
      return t;
    }
    if (typeof n == "string") {
      for (const i of n.split(/\s+/))
        if (this._set.has(i))
          t.push(i);
        else
          return;
      return t;
    }
    for (const i of this._set.keys())
      i.match(n) && t.push(i);
    return t.length ? t : void 0;
  }
  /**
  * Returns a list of consumables for the attribute.
  *
  * Could be filtered by the given token name.
  *
  * @internal
  */
  _getConsumables(n) {
    return n ? [
      n
    ] : this.keys();
  }
  /**
  * Used by {@link module:engine/view/element~Element#_canMergeAttributesFrom} to verify if the given attribute
  * can be merged without conflicts into the attribute.
  *
  * This method is indirectly used by the {@link module:engine/view/downcastwriter~DowncastWriter} while downcasting
  * an {@link module:engine/view/attributeelement~AttributeElement} to merge it with other `AttributeElement`.
  *
  * @internal
  */
  _canMergeFrom() {
    return !0;
  }
  /**
  * Used by {@link module:engine/view/element~Element#_mergeAttributesFrom} to merge a given attribute into the attribute.
  *
  * This method is indirectly used by the {@link module:engine/view/downcastwriter~DowncastWriter} while down-casting
  * an {@link module:engine/view/attributeelement~AttributeElement} to merge it with other AttributeElement.
  *
  * @internal
  */
  _mergeFrom(n) {
    for (const t of n._set.keys())
      this._set.has(t) || this._set.add(t);
  }
  /**
  * Used by {@link module:engine/view/element~Element#_canSubtractAttributesOf} to verify if the given attribute
  * can be fully subtracted from the attribute.
  *
  * This method is indirectly used by the {@link module:engine/view/downcastwriter~DowncastWriter} while down-casting
  * an {@link module:engine/view/attributeelement~AttributeElement} to unwrap the AttributeElement.
  *
  * @internal
  */
  _isMatching(n) {
    for (const t of n._set.keys())
      if (!this._set.has(t))
        return !1;
    return !0;
  }
}
let cs = class WE extends ls {
  /**
  * Creates a view element.
  *
  * Attributes can be passed in various formats:
  *
  * ```ts
  * new Element( viewDocument, 'div', { class: 'editor', contentEditable: 'true' } ); // object
  * new Element( viewDocument, 'div', [ [ 'class', 'editor' ], [ 'contentEditable', 'true' ] ] ); // map-like iterator
  * new Element( viewDocument, 'div', mapOfAttributes ); // map
  * ```
  *
  * @internal
  * @param document The document instance to which this element belongs.
  * @param name Node name.
  * @param attrs Collection of attributes.
  * @param children A list of nodes to be inserted into created element.
  */
  constructor(t, i, r, s) {
    super(t);
    /**
    * Name of the element.
    */
    m(this, "name");
    /**
    * A list of attribute names that should be rendered in the editing pipeline even though filtering mechanisms
    * implemented in the {@link module:engine/view/domconverter~DomConverter} (for instance,
    * {@link module:engine/view/domconverter~DomConverter#shouldRenderAttribute}) would filter them out.
    *
    * These attributes can be specified as an option when the element is created by
    * the {@link module:engine/view/downcastwriter~DowncastWriter}. To check whether an unsafe an attribute should
    * be permitted, use the {@link #shouldRenderUnsafeAttribute} method.
    *
    * @internal
    */
    m(this, "_unsafeAttributesToRender", []);
    /**
    * Map of attributes, where attributes names are keys and attributes values are values.
    */
    m(this, "_attrs");
    /**
    * Array of child nodes.
    */
    m(this, "_children");
    /**
    * Map of custom properties.
    * Custom properties can be added to element instance, will be cloned but not rendered into DOM.
    */
    m(this, "_customProperties", /* @__PURE__ */ new Map());
    this.name = i, this._attrs = this._parseAttributes(r), this._children = [], s && this._insertChild(0, s);
  }
  /**
  * Set of classes associated with element instance.
  *
  * Note that this is just an alias for `this._attrs.get( 'class' );`
  */
  get _classes() {
    return this._attrs.get("class");
  }
  /**
  * Normalized styles.
  *
  * Note that this is just an alias for `this._attrs.get( 'style' );`
  */
  get _styles() {
    return this._attrs.get("style");
  }
  /**
  * Number of element's children.
  */
  get childCount() {
    return this._children.length;
  }
  /**
  * Is `true` if there are no nodes inside this element, `false` otherwise.
  */
  get isEmpty() {
    return this._children.length === 0;
  }
  /**
  * Gets child at the given index.
  *
  * @param index Index of child.
  * @returns Child node.
  */
  getChild(t) {
    return this._children[t];
  }
  /**
  * Gets index of the given child node. Returns `-1` if child node is not found.
  *
  * @param node Child node.
  * @returns Index of the child node.
  */
  getChildIndex(t) {
    return this._children.indexOf(t);
  }
  /**
  * Gets child nodes iterator.
  *
  * @returns Child nodes iterator.
  */
  getChildren() {
    return this._children[Symbol.iterator]();
  }
  /**
  * Returns an iterator that contains the keys for attributes. Order of inserting attributes is not preserved.
  *
  * @returns Keys for attributes.
  */
  *getAttributeKeys() {
    this._classes && (yield "class"), this._styles && (yield "style");
    for (const t of this._attrs.keys())
      t != "class" && t != "style" && (yield t);
  }
  /**
  * Returns iterator that iterates over this element's attributes.
  *
  * Attributes are returned as arrays containing two items. First one is attribute key and second is attribute value.
  * This format is accepted by native `Map` object and also can be passed in `Node` constructor.
  */
  *getAttributes() {
    for (const [t, i] of this._attrs.entries())
      yield [
        t,
        String(i)
      ];
  }
  /**
  * Gets attribute by key. If attribute is not present - returns undefined.
  *
  * @param key Attribute key.
  * @returns Attribute value.
  */
  getAttribute(t) {
    return this._attrs.has(t) ? String(this._attrs.get(t)) : void 0;
  }
  /**
  * Returns a boolean indicating whether an attribute with the specified key exists in the element.
  *
  * @param key Attribute key.
  * @returns `true` if attribute with the specified key exists in the element, `false` otherwise.
  */
  hasAttribute(t, i) {
    return this._attrs.has(t) ? i !== void 0 ? ys(this.name, t) || Oo(this.name, t) ? this._attrs.get(t).has(i) : this._attrs.get(t) === i : !0 : !1;
  }
  /**
  * Checks if this element is similar to other element.
  * Both elements should have the same name and attributes to be considered as similar. Two similar elements
  * can contain different set of children nodes.
  */
  isSimilar(t) {
    if (!(t instanceof WE))
      return !1;
    if (this === t)
      return !0;
    if (this.name != t.name || this._attrs.size !== t._attrs.size)
      return !1;
    for (const [i, r] of this._attrs) {
      const s = t._attrs.get(i);
      if (s === void 0)
        return !1;
      if (typeof r == "string" || typeof s == "string") {
        if (s !== r)
          return !1;
      } else if (!r.isSimilar(s))
        return !1;
    }
    return !0;
  }
  /**
  * Returns true if class is present.
  * If more then one class is provided - returns true only when all classes are present.
  *
  * ```ts
  * element.hasClass( 'foo' ); // Returns true if 'foo' class is present.
  * element.hasClass( 'foo', 'bar' ); // Returns true if 'foo' and 'bar' classes are both present.
  * ```
  */
  hasClass(...t) {
    for (const i of t)
      if (!this._classes || !this._classes.has(i))
        return !1;
    return !0;
  }
  /**
  * Returns iterator that contains all class names.
  */
  getClassNames() {
    const t = this._classes ? this._classes.keys() : [], i = t[Symbol.iterator]();
    return Object.assign(t, {
      next: i.next.bind(i)
    });
  }
  /**
  * Returns style value for the given property name.
  * If the style does not exist `undefined` is returned.
  *
  * **Note**: This method can work with normalized style names if
  * {@link module:engine/controller/datacontroller~DataController#addStyleProcessorRules a particular style processor rule is enabled}.
  * See {@link module:engine/view/stylesmap~StylesMap#getAsString `StylesMap#getAsString()`} for details.
  *
  * For an element with style set to `'margin:1px'`:
  *
  * ```ts
  * // Enable 'margin' shorthand processing:
  * editor.data.addStyleProcessorRules( addMarginRules );
  *
  * const element = view.change( writer => {
  * 	const element = writer.createElement();
  * 	writer.setStyle( 'margin', '1px' );
  * 	writer.setStyle( 'margin-bottom', '3em' );
  *
  * 	return element;
  * } );
  *
  * element.getStyle( 'margin' ); // -> 'margin: 1px 1px 3em;'
  * ```
  */
  getStyle(t) {
    return this._styles && this._styles.getAsString(t);
  }
  /**
  * Returns a normalized style object or single style value.
  *
  * For an element with style set to: margin:1px 2px 3em;
  *
  * ```ts
  * element.getNormalizedStyle( 'margin' ) );
  * ```
  *
  * will return:
  *
  * ```ts
  * {
  * 	top: '1px',
  * 	right: '2px',
  * 	bottom: '3em',
  * 	left: '2px'    // a normalized value from margin shorthand
  * }
  * ```
  *
  * and reading for single style value:
  *
  * ```ts
  * styles.getNormalizedStyle( 'margin-left' );
  * ```
  *
  * Will return a `2px` string.
  *
  * **Note**: This method will return normalized values only if
  * {@link module:engine/controller/datacontroller~DataController#addStyleProcessorRules a particular style processor rule is enabled}.
  * See {@link module:engine/view/stylesmap~StylesMap#getNormalized `StylesMap#getNormalized()`} for details.
  *
  * @param property Name of CSS property
  */
  getNormalizedStyle(t) {
    return this._styles && this._styles.getNormalized(t);
  }
  /**
  * Returns an array that contains all style names.
  *
  * @param expand Expand shorthand style properties and return all equivalent style representations.
  */
  getStyleNames(t) {
    return this._styles ? this._styles.getStyleNames(t) : [];
  }
  /**
  * Returns true if style keys are present.
  * If more then one style property is provided - returns true only when all properties are present.
  *
  * ```ts
  * element.hasStyle( 'color' ); // Returns true if 'border-top' style is present.
  * element.hasStyle( 'color', 'border-top' ); // Returns true if 'color' and 'border-top' styles are both present.
  * ```
  */
  hasStyle(...t) {
    for (const i of t)
      if (!this._styles || !this._styles.has(i))
        return !1;
    return !0;
  }
  /**
  * Returns ancestor element that match specified pattern.
  * Provided patterns should be compatible with {@link module:engine/view/matcher~Matcher Matcher} as it is used internally.
  *
  * @see module:engine/view/matcher~Matcher
  * @param patterns Patterns used to match correct ancestor. See {@link module:engine/view/matcher~Matcher}.
  * @returns Found element or `null` if no matching ancestor was found.
  */
  findAncestor(...t) {
    const i = new Oa(...t);
    let r = this.parent;
    for (; r && !r.is("documentFragment"); ) {
      if (i.match(r))
        return r;
      r = r.parent;
    }
    return null;
  }
  /**
  * Returns the custom property value for the given key.
  */
  getCustomProperty(t) {
    return this._customProperties.get(t);
  }
  /**
  * Returns an iterator which iterates over this element's custom properties.
  * Iterator provides `[ key, value ]` pairs for each stored property.
  */
  *getCustomProperties() {
    yield* this._customProperties.entries();
  }
  /**
  * Returns identity string based on element's name, styles, classes and other attributes.
  * Two elements that {@link #isSimilar are similar} will have same identity string.
  * It has the following format:
  *
  * ```ts
  * 'name class="class1,class2" style="style1:value1;style2:value2" attr1="val1" attr2="val2"'
  * ```
   *
  * For example:
  *
  * ```ts
  * const element = writer.createContainerElement( 'foo', {
  * 	banana: '10',
  * 	apple: '20',
  * 	style: 'color: red; border-color: white;',
  * 	class: 'baz'
  * } );
  *
  * // returns 'foo class="baz" style="border-color:white;color:red" apple="20" banana="10"'
  * element.getIdentity();
  * ```
  *
  * **Note**: Classes, styles and other attributes are sorted alphabetically.
  */
  getIdentity() {
    const t = this._classes ? this._classes.keys().sort().join(",") : "", i = this._styles && String(this._styles), r = Array.from(this._attrs).filter(([s]) => s != "style" && s != "class").map((s) => `${s[0]}="${s[1]}"`).sort().join(" ");
    return this.name + (t == "" ? "" : ` class="${t}"`) + (i ? ` style="${i}"` : "") + (r == "" ? "" : ` ${r}`);
  }
  /**
  * Decides whether an unsafe attribute is whitelisted and should be rendered in the editing pipeline even though filtering mechanisms
  * like {@link module:engine/view/domconverter~DomConverter#shouldRenderAttribute} say it should not.
  *
  * Unsafe attribute names can be specified when creating an element via {@link module:engine/view/downcastwriter~DowncastWriter}.
  *
  * @param attributeName The name of the attribute to be checked.
  */
  shouldRenderUnsafeAttribute(t) {
    return this._unsafeAttributesToRender.includes(t);
  }
  /**
  * Clones provided element.
  *
  * @internal
  * @param deep If set to `true` clones element and all its children recursively. When set to `false`,
  * element will be cloned without any children.
  * @returns Clone of this element.
  */
  _clone(t = !1) {
    const i = [];
    if (t)
      for (const s of this.getChildren())
        i.push(s._clone(t));
    const r = new this.constructor(this.document, this.name, this._attrs, i);
    return r._customProperties = new Map(this._customProperties), r.getFillerOffset = this.getFillerOffset, r._unsafeAttributesToRender = this._unsafeAttributesToRender, r;
  }
  /**
  * {@link module:engine/view/element~Element#_insertChild Insert} a child node or a list of child nodes at the end of this node
  * and sets the parent of these nodes to this element.
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#insert
  * @internal
  * @param items Items to be inserted.
  * @fires change
  * @returns Number of appended nodes.
  */
  _appendChild(t) {
    return this._insertChild(this.childCount, t);
  }
  /**
  * Inserts a child node or a list of child nodes on the given index and sets the parent of these nodes to
  * this element.
  *
  * @internal
  * @see module:engine/view/downcastwriter~DowncastWriter#insert
  * @param index Position where nodes should be inserted.
  * @param items Items to be inserted.
  * @fires change
  * @returns Number of inserted nodes.
  */
  _insertChild(t, i) {
    this._fireChange("children", this, {
      index: t
    });
    let r = 0;
    const s = ZP(this.document, i);
    for (const o of s)
      o.parent !== null && o._remove(), o.parent = this, o.document = this.document, this._children.splice(t, 0, o), t++, r++;
    return r;
  }
  /**
  * Removes number of child nodes starting at the given index and set the parent of these nodes to `null`.
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#remove
  * @internal
  * @param index Number of the first node to remove.
  * @param howMany Number of nodes to remove.
  * @fires change
  * @returns The array of removed nodes.
  */
  _removeChildren(t, i = 1) {
    this._fireChange("children", this, {
      index: t
    });
    for (let r = t; r < t + i; r++)
      this._children[r].parent = null;
    return this._children.splice(t, i);
  }
  /**
  * Adds or overwrite attribute with a specified key and value.
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#setAttribute
  * @internal
  * @param key Attribute key.
  * @param value Attribute value.
  * @param overwrite Whether tokenized attribute should override the attribute value or just add a token.
  * @fires change
  */
  _setAttribute(t, i, r = !0) {
    if (this._fireChange("attributes", this), ys(this.name, t) || Oo(this.name, t)) {
      let s = this._attrs.get(t);
      s || (s = ys(this.name, t) ? new oa(this.document.stylesProcessor) : new ad(), this._attrs.set(t, s)), r ? s.setTo(String(i)) : ys(this.name, t) ? Array.isArray(i) ? s.set(i[0], i[1]) : s.set(i) : s.set(typeof i == "string" ? i.split(/\s+/) : i);
    } else
      this._attrs.set(t, String(i));
  }
  /**
  * Removes attribute from the element.
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#removeAttribute
  * @internal
  * @param key Attribute key.
  * @param tokens Attribute value tokens to remove. The whole attribute is removed if not specified.
  * @returns Returns true if an attribute existed and has been removed.
  * @fires change
  */
  _removeAttribute(t, i) {
    if (this._fireChange("attributes", this), i !== void 0 && (ys(this.name, t) || Oo(this.name, t))) {
      const r = this._attrs.get(t);
      return r ? (Oo(this.name, t) && typeof i == "string" && (i = i.split(/\s+/)), r.remove(i), r.isEmpty ? this._attrs.delete(t) : !1) : !1;
    }
    return this._attrs.delete(t);
  }
  /**
  * Adds specified class.
  *
  * ```ts
  * element._addClass( 'foo' ); // Adds 'foo' class.
  * element._addClass( [ 'foo', 'bar' ] ); // Adds 'foo' and 'bar' classes.
  * ```
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#addClass
  * @internal
  * @fires change
  */
  _addClass(t) {
    this._setAttribute("class", t, !1);
  }
  /**
  * Removes specified class.
  *
  * ```ts
  * element._removeClass( 'foo' );  // Removes 'foo' class.
  * element._removeClass( [ 'foo', 'bar' ] ); // Removes both 'foo' and 'bar' classes.
  * ```
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#removeClass
  * @internal
  * @fires change
  */
  _removeClass(t) {
    this._removeAttribute("class", t);
  }
  _setStyle(t, i) {
    typeof t != "string" ? this._setAttribute("style", t, !1) : this._setAttribute("style", [
      t,
      i
    ], !1);
  }
  /**
  * Removes specified style.
  *
  * ```ts
  * element._removeStyle( 'color' );  // Removes 'color' style.
  * element._removeStyle( [ 'color', 'border-top' ] ); // Removes both 'color' and 'border-top' styles.
  * ```
  *
  * **Note**: This method can work with normalized style names if
  * {@link module:engine/controller/datacontroller~DataController#addStyleProcessorRules a particular style processor rule is enabled}.
  * See {@link module:engine/view/stylesmap~StylesMap#remove `StylesMap#remove()`} for details.
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#removeStyle
  * @internal
  * @fires change
  */
  _removeStyle(t) {
    this._removeAttribute("style", t);
  }
  /**
  * Used by the {@link module:engine/view/matcher~Matcher Matcher} to collect matching attribute tuples
  * (attribute name and optional token).
  *
  * Normalized patterns can be used in following ways:
  * - to match any attribute name with any or no value:
  *
  * ```ts
  * patterns: [
  * 	[ true, true ]
  * ]
  * ```
  *
  * - to match a specific attribute with any value:
  *
  * ```ts
  * patterns: [
  * 	[ 'required', true ]
  * ]
  * ```
  *
  * - to match an attribute name with a RegExp with any value:
  *
  * ```ts
  * patterns: [
  * 	[ /h[1-6]/, true ]
  * ]
  * ```
  *
  * 	- to match a specific attribute with the exact value:
  *
  * ```ts
  * patterns: [
  * 	[ 'rel', 'nofollow' ]
  * ]
  * ```
  *
  * 	- to match a specific attribute with a value matching a RegExp:
  *
  * ```ts
  * patterns: [
  * 	[ 'src', /^https/ ]
  * ]
  * ```
  *
  * 	- to match an attribute name with a RegExp and the exact value:
  *
  * ```ts
  * patterns: [
  * 	[ /^data-property-/, 'foobar' ],
  * ]
  * ```
  *
  * 	- to match an attribute name with a RegExp and match a value with another RegExp:
  *
  * ```ts
  * patterns: [
  * 	[ /^data-property-/, /^foo/ ]
  * ]
  * ```
  *
  * 	- to match a specific style property with the value matching a RegExp:
  *
  * ```ts
  * patterns: [
  * 	[ 'style', 'font-size', /px$/ ]
  * ]
  * ```
  *
  * 	- to match a specific class (class attribute is tokenized so it matches tokens individually):
  *
  * ```ts
  * patterns: [
  * 	[ 'class', 'foo' ]
  * ]
  * ```
  *
  * @internal
  * @param patterns An array of normalized patterns (tuples of 2 or 3 items depending on if tokenized attribute value match is needed).
  * @param match An array to populate with matching tuples.
  * @param exclude Array of attribute names to exclude from match.
  * @returns `true` if element matches all patterns. The matching tuples are pushed to the `match` array.
  */
  _collectAttributesMatch(t, i, r) {
    for (const [s, o, a] of t) {
      let u = !1, l = !1;
      for (const [c, d] of this._attrs)
        if (!(r && r.includes(c) || !El(s, c)))
          if (u = !0, typeof d == "string") {
            if (El(o, d))
              i.push([
                c
              ]), l = !0;
            else if (!(s instanceof RegExp))
              return !1;
          } else {
            const p = d._getTokensMatch(o, a || !0);
            if (p) {
              l = !0;
              for (const g of p)
                i.push([
                  c,
                  g
                ]);
            } else if (!(s instanceof RegExp))
              return !1;
          }
      if (!u || !l)
        return !1;
    }
    return !0;
  }
  /**
  * Used by the {@link module:engine/conversion/viewconsumable~ViewConsumable} to collect the
  * {@link module:engine/view/element~NormalizedConsumables} for the element.
  *
  * When `key` and `token` parameters are provided the output is filtered for the specified attribute and it's tokens and related tokens.
  *
  * @internal
  * @param key Attribute name.
  * @param token Reference token to collect all related tokens.
  */
  _getConsumables(t, i) {
    const r = [];
    if (t) {
      const s = this._attrs.get(t);
      if (s !== void 0)
        if (typeof s == "string")
          r.push([
            t
          ]);
        else
          for (const o of s._getConsumables(i))
            r.push([
              t,
              o
            ]);
    } else
      for (const [s, o] of this._attrs)
        if (typeof o == "string")
          r.push([
            s
          ]);
        else
          for (const a of o._getConsumables())
            r.push([
              s,
              a
            ]);
    return {
      name: !t,
      attributes: r
    };
  }
  /**
  * Verify if the given element can be merged without conflicts into the element.
  *
  * Note that this method is extended by the {@link module:engine/view/attributeelement~AttributeElement} implementation.
  *
  * This method is used by the {@link module:engine/view/downcastwriter~DowncastWriter} while down-casting
  * an {@link module:engine/view/attributeelement~AttributeElement} to merge it with other AttributeElement.
  *
  * @internal
  * @returns Returns `true` if elements can be merged.
  */
  _canMergeAttributesFrom(t) {
    if (this.name != t.name)
      return !1;
    for (const [i, r] of t._attrs) {
      const s = this._attrs.get(i);
      if (s !== void 0) {
        if (typeof s == "string" || typeof r == "string") {
          if (s !== r)
            return !1;
        } else if (!s._canMergeFrom(r))
          return !1;
      }
    }
    return !0;
  }
  /**
  * Merges attributes of a given element into the element.
  * This includes also tokenized attributes like style and class.
  *
  * Note that you should make sure there are no conflicts before merging (see {@link #_canMergeAttributesFrom}).
  *
  * This method is used by the {@link module:engine/view/downcastwriter~DowncastWriter} while down-casting
  * an {@link module:engine/view/attributeelement~AttributeElement} to merge it with other AttributeElement.
  *
  * @internal
  */
  _mergeAttributesFrom(t) {
    this._fireChange("attributes", this);
    for (const [i, r] of t._attrs) {
      const s = this._attrs.get(i);
      s === void 0 || typeof s == "string" || typeof r == "string" ? this._setAttribute(i, r) : s._mergeFrom(r);
    }
  }
  /**
  * Verify if the given element attributes can be fully subtracted from the element.
  *
  * Note that this method is extended by the {@link module:engine/view/attributeelement~AttributeElement} implementation.
  *
  * This method is used by the {@link module:engine/view/downcastwriter~DowncastWriter} while down-casting
  * an {@link module:engine/view/attributeelement~AttributeElement} to unwrap the AttributeElement.
  *
  * @internal
  * @returns Returns `true` if elements attributes can be fully subtracted.
  */
  _canSubtractAttributesOf(t) {
    if (this.name != t.name)
      return !1;
    for (const [i, r] of t._attrs) {
      const s = this._attrs.get(i);
      if (s === void 0)
        return !1;
      if (typeof s == "string" || typeof r == "string") {
        if (s !== r)
          return !1;
      } else if (!s._isMatching(r))
        return !1;
    }
    return !0;
  }
  /**
  * Removes (subtracts) corresponding attributes of the given element from the element.
  * This includes also tokenized attributes like style and class.
  * All attributes, classes and styles from given element should be present inside the element being unwrapped.
  *
  * Note that you should make sure all attributes could be subtracted before subtracting them (see {@link #_canSubtractAttributesOf}).
  *
  * This method is used by the {@link module:engine/view/downcastwriter~DowncastWriter} while down-casting
  * an {@link module:engine/view/attributeelement~AttributeElement} to unwrap the AttributeElement.
  *
  * @internal
  */
  _subtractAttributesOf(t) {
    this._fireChange("attributes", this);
    for (const [i, r] of t._attrs) {
      const s = this._attrs.get(i);
      typeof s == "string" || typeof r == "string" ? this._attrs.delete(i) : (s.remove(r.keys()), s.isEmpty && this._attrs.delete(i));
    }
  }
  /**
  * Sets a custom property. Unlike attributes, custom properties are not rendered to the DOM,
  * so they can be used to add special data to elements.
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#setCustomProperty
  * @internal
  */
  _setCustomProperty(t, i) {
    this._customProperties.set(t, i);
  }
  /**
  * Removes the custom property stored under the given key.
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#removeCustomProperty
  * @internal
  * @returns Returns true if property was removed.
  */
  _removeCustomProperty(t) {
    return this._customProperties.delete(t);
  }
  /**
  * Parses attributes provided to the element constructor before they are applied to an element. If attributes are passed
  * as an object (instead of `Iterable`), the object is transformed to the map. Attributes with `null` value are removed.
  * Attributes with non-`String` value are converted to `String`.
  *
  * @param attrs Attributes to parse.
  * @returns Parsed attributes.
  */
  _parseAttributes(t) {
    const i = Si(t);
    for (const [r, s] of i)
      if (s === null)
        i.delete(r);
      else if (ys(this.name, r)) {
        const o = s instanceof oa ? s._clone() : new oa(this.document.stylesProcessor).setTo(String(s));
        i.set(r, o);
      } else if (Oo(this.name, r)) {
        const o = s instanceof ad ? s._clone() : new ad().setTo(String(s));
        i.set(r, o);
      } else typeof s != "string" && i.set(r, String(s));
    return i;
  }
};
cs.prototype.is = function(e, n) {
  return n ? n === this.name && (e === "element" || e === "view:element") : e === "element" || e === "view:element" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === "node" || e === "view:node";
};
function ZP(e, n) {
  if (typeof n == "string")
    return [
      new Jt(e, n)
    ];
  Nn(n) || (n = [
    n
  ]);
  const t = [];
  for (const i of n)
    typeof i == "string" ? t.push(new Jt(e, i)) : i instanceof Di ? t.push(new Jt(e, i.data)) : t.push(i);
  return t;
}
function Oo(e, n) {
  return n == "class" || e == "a" && n == "rel";
}
function ys(e, n) {
  return n == "style";
}
class Na extends cs {
  /**
  * Creates a container element.
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#createContainerElement
  * @see module:engine/view/element~Element
  * @internal
  * @param document The document instance to which this element belongs.
  * @param name Node name.
  * @param attrs Collection of attributes.
  * @param children A list of nodes to be inserted into created element.
  */
  constructor(n, t, i, r) {
    super(n, t, i, r), this.getFillerOffset = eO;
  }
}
Na.prototype.is = function(e, n) {
  return n ? n === this.name && (e === "containerElement" || e === "view:containerElement" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === "element" || e === "view:element") : e === "containerElement" || e === "view:containerElement" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === "element" || e === "view:element" || e === "node" || e === "view:node";
};
function eO() {
  const e = [
    ...this.getChildren()
  ], n = e[this.childCount - 1];
  if (n && n.is("element", "br"))
    return this.childCount;
  for (const t of e)
    if (!t.is("uiElement"))
      return null;
  return this.childCount;
}
class nc extends (/* @__PURE__ */ pt(Na)) {
  /**
  * Creates an editable element.
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#createEditableElement
  * @internal
  * @param document The document instance to which this element belongs.
  * @param name Node name.
  * @param attrs Collection of attributes.
  * @param children A list of nodes to be inserted into created element.
  */
  constructor(n, t, i, r) {
    super(n, t, i, r), this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("placeholder", void 0), this.bind("isReadOnly").to(n), this.bind("isFocused").to(n, "isFocused", (s) => s && n.selection.editableElement == this), this.listenTo(n.selection, "change", () => {
      this.isFocused = n.isFocused && n.selection.editableElement == this;
    });
  }
  destroy() {
    this.stopListening();
  }
}
nc.prototype.is = function(e, n) {
  return n ? n === this.name && (e === "editableElement" || e === "view:editableElement" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === "containerElement" || e === "view:containerElement" || e === "element" || e === "view:element") : e === "editableElement" || e === "view:editableElement" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === "containerElement" || e === "view:containerElement" || e === "element" || e === "view:element" || e === "node" || e === "view:node";
};
const pp = Symbol("rootName");
class zE extends nc {
  /**
  * Creates root editable element.
  *
  * @param document The document instance to which this element belongs.
  * @param name Node name.
  */
  constructor(n, t) {
    super(n, t), this.rootName = "main";
  }
  /**
  * Name of this root inside {@link module:engine/view/document~Document} that is an owner of this root. If no
  * other name is set, `main` name is used.
  *
  * @readonly
  */
  get rootName() {
    return this.getCustomProperty(pp);
  }
  set rootName(n) {
    this._setCustomProperty(pp, n);
  }
  /**
  * Overrides old element name and sets new one.
  * This is needed because view roots are created before they are attached to the DOM.
  * The name of the root element is temporary at this stage. It has to be changed when the
  * view root element is attached to the DOM element.
  *
  * @internal
  * @param name The new name of element.
  */
  set _name(n) {
    this.name = n;
  }
}
zE.prototype.is = function(e, n) {
  return n ? n === this.name && (e === "rootElement" || e === "view:rootElement" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === "editableElement" || e === "view:editableElement" || e === "containerElement" || e === "view:containerElement" || e === "element" || e === "view:element") : e === "rootElement" || e === "view:rootElement" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === "editableElement" || e === "view:editableElement" || e === "containerElement" || e === "view:containerElement" || e === "element" || e === "view:element" || e === "node" || e === "view:node";
};
let Kr = class {
  /**
  * Creates a range iterator. All parameters are optional, but you have to specify either `boundaries` or `startPosition`.
  *
  * @param options Object with configuration.
  */
  constructor(n = {}) {
    /**
    * Walking direction. Defaults `'forward'`.
    */
    m(this, "direction");
    /**
    * Iterator boundaries.
    *
    * When the iterator is walking `'forward'` on the end of boundary or is walking `'backward'`
    * on the start of boundary, then `{ done: true }` is returned.
    *
    * If boundaries are not defined they are set before first and after last child of the root node.
    */
    m(this, "boundaries");
    /**
    * Flag indicating whether all characters from {@link module:engine/view/text~Text} should be returned as one
    * {@link module:engine/view/text~Text} or one by one as {@link module:engine/view/textproxy~TextProxy}.
    */
    m(this, "singleCharacters");
    /**
    * Flag indicating whether iterator should enter elements or not. If the iterator is shallow child nodes of any
    * iterated node will not be returned along with `elementEnd` tag.
    */
    m(this, "shallow");
    /**
    * Flag indicating whether iterator should ignore `elementEnd` tags. If set to `true`, walker will not
    * return a parent node of the start position. Each {@link module:engine/view/element~Element} will be returned once.
    * When set to `false` each element might be returned twice: for `'elementStart'` and `'elementEnd'`.
    */
    m(this, "ignoreElementEnd");
    /**
    * Iterator position. If start position is not defined then position depends on {@link #direction}. If direction is
    * `'forward'` position starts form the beginning, when direction is `'backward'` position starts from the end.
    */
    m(this, "_position");
    /**
    * Start boundary parent.
    */
    m(this, "_boundaryStartParent");
    /**
    * End boundary parent.
    */
    m(this, "_boundaryEndParent");
    if (!n.boundaries && !n.startPosition)
      throw new v("view-tree-walker-no-start-position", null);
    if (n.direction && n.direction != "forward" && n.direction != "backward")
      throw new v("view-tree-walker-unknown-direction", n.startPosition, {
        direction: n.direction
      });
    this.boundaries = n.boundaries || null, n.startPosition ? this._position = ne._createAt(n.startPosition) : this._position = ne._createAt(n.boundaries[n.direction == "backward" ? "end" : "start"]), this.direction = n.direction || "forward", this.singleCharacters = !!n.singleCharacters, this.shallow = !!n.shallow, this.ignoreElementEnd = !!n.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
  }
  /**
  * Iterable interface.
  */
  [Symbol.iterator]() {
    return this;
  }
  /**
  * Iterator position. If start position is not defined then position depends on {@link #direction}. If direction is
  * `'forward'` position starts form the beginning, when direction is `'backward'` position starts from the end.
  */
  get position() {
    return this._position;
  }
  /**
  * Moves {@link #position} in the {@link #direction} skipping values as long as the callback function returns `true`.
  *
  * For example:
  *
  * ```ts
  * walker.skip( value => value.type == 'text' ); // <p>{}foo</p> -> <p>foo[]</p>
  * walker.skip( value => true ); // Move the position to the end: <p>{}foo</p> -> <p>foo</p>[]
  * walker.skip( value => false ); // Do not move the position.
  * ```
  *
  * @param skip Callback function. Gets {@link module:engine/view/treewalker~TreeWalkerValue} and should
  * return `true` if the value should be skipped or `false` if not.
  */
  skip(n) {
    let t, i;
    do
      i = this.position, t = this.next();
    while (!t.done && n(t.value));
    t.done || (this._position = i);
  }
  /**
  * Moves tree walker {@link #position} to provided `position`. Tree walker will
  * continue traversing from that position.
  *
  * Note: in contrary to {@link ~TreeWalker#skip}, this method does not iterate over the nodes along the way.
  * It simply sets the current tree walker position to a new one.
  * From the performance standpoint, it is better to use {@link ~TreeWalker#jumpTo} rather than {@link ~TreeWalker#skip}.
  *
  * If the provided position is before the start boundary, the position will be
  * set to the start boundary. If the provided position is after the end boundary,
  * the position will be set to the end boundary.
  * This is done to prevent the treewalker from traversing outside the boundaries.
  *
  * @param position Position to jump to.
  */
  jumpTo(n) {
    this._boundaryStartParent && n.isBefore(this.boundaries.start) ? n = this.boundaries.start : this._boundaryEndParent && n.isAfter(this.boundaries.end) && (n = this.boundaries.end), this._position = n.clone();
  }
  /**
  * Gets the next tree walker's value.
  *
  * @returns Object implementing iterator interface, returning
  * information about taken step.
  */
  next() {
    return this.direction == "forward" ? this._next() : this._previous();
  }
  /**
  * Makes a step forward in view. Moves the {@link #position} to the next position and returns the encountered value.
  */
  _next() {
    let n = this.position.clone();
    const t = this.position, i = n.parent;
    if (i.parent === null && n.offset === i.childCount)
      return {
        done: !0,
        value: void 0
      };
    if (i === this._boundaryEndParent && n.offset == this.boundaries.end.offset)
      return {
        done: !0,
        value: void 0
      };
    let r;
    if (i && i.is("view:$text")) {
      if (n.isAtEnd)
        return this._position = ne._createAfter(i), this._next();
      r = i.data[n.offset];
    } else
      r = i.getChild(n.offset);
    if (typeof r == "string") {
      let s;
      this.singleCharacters ? s = 1 : s = (i === this._boundaryEndParent ? this.boundaries.end.offset : i.data.length) - n.offset;
      const o = new Di(i, n.offset, s);
      return n.offset += s, this._position = n, this._formatReturnValue("text", o, t, n, s);
    }
    if (r && r.is("view:element")) {
      if (!this.shallow)
        n = new ne(r, 0);
      else {
        if (this.boundaries && this.boundaries.end.isBefore(n))
          return {
            done: !0,
            value: void 0
          };
        n.offset++;
      }
      return this._position = n, this._formatReturnValue("elementStart", r, t, n, 1);
    }
    if (r && r.is("view:$text")) {
      if (this.singleCharacters)
        return n = new ne(r, 0), this._position = n, this._next();
      let s = r.data.length, o;
      return r == this._boundaryEndParent ? (s = this.boundaries.end.offset, o = new Di(r, 0, s), n = ne._createAfter(o)) : (o = new Di(r, 0, r.data.length), n.offset++), this._position = n, this._formatReturnValue("text", o, t, n, s);
    }
    return n = ne._createAfter(i), this._position = n, this.ignoreElementEnd ? this._next() : this._formatReturnValue("elementEnd", i, t, n);
  }
  /**
  * Makes a step backward in view. Moves the {@link #position} to the previous position and returns the encountered value.
  */
  _previous() {
    let n = this.position.clone();
    const t = this.position, i = n.parent;
    if (i.parent === null && n.offset === 0)
      return {
        done: !0,
        value: void 0
      };
    if (i == this._boundaryStartParent && n.offset == this.boundaries.start.offset)
      return {
        done: !0,
        value: void 0
      };
    let r;
    if (i.is("view:$text")) {
      if (n.isAtStart)
        return this._position = ne._createBefore(i), this._previous();
      r = i.data[n.offset - 1];
    } else
      r = i.getChild(n.offset - 1);
    if (typeof r == "string") {
      let s;
      if (this.singleCharacters)
        s = 1;
      else {
        const a = i === this._boundaryStartParent ? this.boundaries.start.offset : 0;
        s = n.offset - a;
      }
      n.offset -= s;
      const o = new Di(i, n.offset, s);
      return this._position = n, this._formatReturnValue("text", o, t, n, s);
    }
    if (r && r.is("view:element"))
      return this.shallow ? (n.offset--, this._position = n, this._formatReturnValue("elementStart", r, t, n, 1)) : (n = new ne(r, r.childCount), this._position = n, this.ignoreElementEnd ? this._previous() : this._formatReturnValue("elementEnd", r, t, n));
    if (r && r.is("view:$text")) {
      if (this.singleCharacters)
        return n = new ne(r, r.data.length), this._position = n, this._previous();
      let s = r.data.length, o;
      if (r == this._boundaryStartParent) {
        const a = this.boundaries.start.offset;
        o = new Di(r, a, r.data.length - a), s = o.data.length, n = ne._createBefore(o);
      } else
        o = new Di(r, 0, r.data.length), n.offset--;
      return this._position = n, this._formatReturnValue("text", o, t, n, s);
    }
    return n = ne._createBefore(i), this._position = n, this._formatReturnValue("elementStart", i, t, n, 1);
  }
  /**
  * Format returned data and adjust `previousPosition` and `nextPosition` if reach the bound of the {@link module:engine/view/text~Text}.
  *
  * @param type Type of step.
  * @param item Item between old and new position.
  * @param previousPosition Previous position of iterator.
  * @param nextPosition Next position of iterator.
  * @param length Length of the item.
  */
  _formatReturnValue(n, t, i, r, s) {
    return t.is("view:$textProxy") && (t.offsetInText + t.data.length == t.textNode.data.length && (this.direction == "forward" && !(this.boundaries && this.boundaries.end.isEqual(this.position)) ? (r = ne._createAfter(t.textNode), this._position = r) : i = ne._createAfter(t.textNode)), t.offsetInText === 0 && (this.direction == "backward" && !(this.boundaries && this.boundaries.start.isEqual(this.position)) ? (r = ne._createBefore(t.textNode), this._position = r) : i = ne._createBefore(t.textNode))), {
      done: !1,
      value: {
        type: n,
        item: t,
        previousPosition: i,
        nextPosition: r,
        length: s
      }
    };
  }
}, ne = class Ri extends us {
  /**
  * Creates a position.
  *
  * @param parent Position parent.
  * @param offset Position offset.
  */
  constructor(t, i) {
    super();
    /**
    * Position parent.
    */
    m(this, "parent");
    /**
    * Position offset.
    */
    m(this, "offset");
    this.parent = t, this.offset = i;
  }
  /**
  * Node directly after the position. Equals `null` when there is no node after position or position is located
  * inside text node.
  */
  get nodeAfter() {
    return this.parent.is("$text") ? null : this.parent.getChild(this.offset) || null;
  }
  /**
  * Node directly before the position. Equals `null` when there is no node before position or position is located
  * inside text node.
  */
  get nodeBefore() {
    return this.parent.is("$text") ? null : this.parent.getChild(this.offset - 1) || null;
  }
  /**
  * Is `true` if position is at the beginning of its {@link module:engine/view/position~Position#parent parent}, `false` otherwise.
  */
  get isAtStart() {
    return this.offset === 0;
  }
  /**
  * Is `true` if position is at the end of its {@link module:engine/view/position~Position#parent parent}, `false` otherwise.
  */
  get isAtEnd() {
    const t = this.parent.is("$text") ? this.parent.data.length : this.parent.childCount;
    return this.offset === t;
  }
  /**
  * Position's root, that is the root of the position's parent element.
  */
  get root() {
    return this.parent.root;
  }
  /**
  * {@link module:engine/view/editableelement~EditableElement EditableElement} instance that contains this position, or `null` if
  * position is not inside an editable element.
  */
  get editableElement() {
    let t = this.parent;
    for (; !(t instanceof nc); )
      if (t.parent)
        t = t.parent;
      else
        return null;
    return t;
  }
  /**
  * Returns a new instance of Position with offset incremented by `shift` value.
  *
  * @param shift How position offset should get changed. Accepts negative values.
  * @returns Shifted position.
  */
  getShiftedBy(t) {
    const i = Ri._createAt(this), r = i.offset + t;
    return i.offset = r < 0 ? 0 : r, i;
  }
  /**
  * Gets the farthest position which matches the callback using
  * {@link module:engine/view/treewalker~TreeWalker TreeWalker}.
  *
  * For example:
  *
  * ```ts
  * getLastMatchingPosition( value => value.type == 'text' ); // <p>{}foo</p> -> <p>foo[]</p>
  * getLastMatchingPosition( value => value.type == 'text', { direction: 'backward' } ); // <p>foo[]</p> -> <p>{}foo</p>
  * getLastMatchingPosition( value => false ); // Do not move the position.
  * ```
  *
  * @param skip Callback function. Gets {@link module:engine/view/treewalker~TreeWalkerValue} and should
  * return `true` if the value should be skipped or `false` if not.
  * @param options Object with configuration options. See {@link module:engine/view/treewalker~TreeWalker}.
  * @returns The position after the last item which matches the `skip` callback test.
  */
  getLastMatchingPosition(t, i = {}) {
    i.startPosition = this;
    const r = new Kr(i);
    return r.skip(t), r.position;
  }
  /**
  * Returns ancestors array of this position, that is this position's parent and it's ancestors.
  *
  * @returns Array with ancestors.
  */
  getAncestors() {
    return this.parent.is("documentFragment") ? [
      this.parent
    ] : this.parent.getAncestors({
      includeSelf: !0
    });
  }
  /**
  * Returns a {@link module:engine/view/node~Node} or {@link module:engine/view/documentfragment~DocumentFragment}
  * which is a common ancestor of both positions.
  */
  getCommonAncestor(t) {
    const i = this.getAncestors(), r = t.getAncestors();
    let s = 0;
    for (; i[s] == r[s] && i[s]; )
      s++;
    return s === 0 ? null : i[s - 1];
  }
  /**
  * Checks whether this position equals given position.
  *
  * @param otherPosition Position to compare with.
  * @returns True if positions are same.
  */
  isEqual(t) {
    return this.parent == t.parent && this.offset == t.offset;
  }
  /**
  * Checks whether this position is located before given position. When method returns `false` it does not mean that
  * this position is after give one. Two positions may be located inside separate roots and in that situation this
  * method will still return `false`.
  *
  * @see module:engine/view/position~Position#isAfter
  * @see module:engine/view/position~Position#compareWith
  * @param otherPosition Position to compare with.
  * @returns Returns `true` if this position is before given position.
  */
  isBefore(t) {
    return this.compareWith(t) == "before";
  }
  /**
  * Checks whether this position is located after given position. When method returns `false` it does not mean that
  * this position is before give one. Two positions may be located inside separate roots and in that situation this
  * method will still return `false`.
  *
  * @see module:engine/view/position~Position#isBefore
  * @see module:engine/view/position~Position#compareWith
  * @param otherPosition Position to compare with.
  * @returns Returns `true` if this position is after given position.
  */
  isAfter(t) {
    return this.compareWith(t) == "after";
  }
  /**
  * Checks whether this position is before, after or in same position that other position. Two positions may be also
  * different when they are located in separate roots.
  *
  * @param otherPosition Position to compare with.
  */
  compareWith(t) {
    if (this.root !== t.root)
      return "different";
    if (this.isEqual(t))
      return "same";
    const i = this.parent.is("node") ? this.parent.getPath() : [], r = t.parent.is("node") ? t.parent.getPath() : [];
    i.push(this.offset), r.push(t.offset);
    const s = sn(i, r);
    switch (s) {
      case "prefix":
        return "before";
      case "extension":
        return "after";
      default:
        return i[s] < r[s] ? "before" : "after";
    }
  }
  /**
  * Creates a {@link module:engine/view/treewalker~TreeWalker TreeWalker} instance with this positions as a start position.
  *
  * @param options Object with configuration options. See {@link module:engine/view/treewalker~TreeWalker}
  */
  getWalker(t = {}) {
    return t.startPosition = this, new Kr(t);
  }
  /**
  * Clones this position.
  */
  clone() {
    return new Ri(this.parent, this.offset);
  }
  /**
  * Creates position at the given location. The location can be specified as:
  *
  * * a {@link module:engine/view/position~Position position},
  * * parent element and offset (offset defaults to `0`),
  * * parent element and `'end'` (sets position at the end of that element),
  * * {@link module:engine/view/item~Item view item} and `'before'` or `'after'` (sets position before or after given view item).
  *
  * This method is a shortcut to other constructors such as:
  *
  * * {@link module:engine/view/position~Position._createBefore},
  * * {@link module:engine/view/position~Position._createAfter}.
  *
  * @internal
  * @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/view/item~Item view item}.
  */
  static _createAt(t, i) {
    if (t instanceof Ri)
      return new this(t.parent, t.offset);
    {
      const r = t;
      if (i == "end")
        i = r.is("$text") ? r.data.length : r.childCount;
      else {
        if (i == "before")
          return this._createBefore(r);
        if (i == "after")
          return this._createAfter(r);
        if (i !== 0 && !i)
          throw new v("view-createpositionat-offset-required", r);
      }
      return new Ri(r, i);
    }
  }
  /**
  * Creates a new position after given view item.
  *
  * @internal
  * @param item View item after which the position should be located.
  */
  static _createAfter(t) {
    if (t.is("$textProxy"))
      return new Ri(t.textNode, t.offsetInText + t.data.length);
    if (!t.parent)
      throw new v("view-position-after-root", t, {
        root: t
      });
    return new Ri(t.parent, t.index + 1);
  }
  /**
  * Creates a new position before given view item.
  *
  * @internal
  * @param item View item before which the position should be located.
  */
  static _createBefore(t) {
    if (t.is("$textProxy"))
      return new Ri(t.textNode, t.offsetInText);
    if (!t.parent)
      throw new v("view-position-before-root", t, {
        root: t
      });
    return new Ri(t.parent, t.index);
  }
};
ne.prototype.is = function(e) {
  return e === "position" || e === "view:position";
};
let Re = class or extends us {
  /**
  * Creates a range spanning from `start` position to `end` position.
  *
  * **Note:** Constructor creates it's own {@link module:engine/view/position~Position} instances basing on passed values.
  *
  * @param start Start position.
  * @param end End position. If not set, range will be collapsed at the `start` position.
  */
  constructor(t, i = null) {
    super();
    /**
    * Start position.
    */
    m(this, "start");
    /**
    * End position.
    */
    m(this, "end");
    this.start = t.clone(), this.end = i ? i.clone() : t.clone();
  }
  /**
  * Iterable interface.
  *
  * Iterates over all {@link module:engine/view/item~Item view items} that are in this range and returns
  * them together with additional information like length or {@link module:engine/view/position~Position positions},
  * grouped as {@link module:engine/view/treewalker~TreeWalkerValue}.
  *
  * This iterator uses {@link module:engine/view/treewalker~TreeWalker TreeWalker} with `boundaries` set to this range and
  * `ignoreElementEnd` option
  * set to `true`.
  */
  *[Symbol.iterator]() {
    yield* new Kr({
      boundaries: this,
      ignoreElementEnd: !0
    });
  }
  /**
  * Returns whether the range is collapsed, that is it start and end positions are equal.
  */
  get isCollapsed() {
    return this.start.isEqual(this.end);
  }
  /**
  * Returns whether this range is flat, that is if {@link module:engine/view/range~Range#start start} position and
  * {@link module:engine/view/range~Range#end end} position are in the same {@link module:engine/view/position~Position#parent parent}.
  */
  get isFlat() {
    return this.start.parent === this.end.parent;
  }
  /**
  * Range root element.
  */
  get root() {
    return this.start.root;
  }
  /**
  * Creates a maximal range that has the same content as this range but is expanded in both ways (at the beginning
  * and at the end).
  *
  * For example:
  *
  * ```html
  * <p>Foo</p><p><b>{Bar}</b></p> -> <p>Foo</p>[<p><b>Bar</b>]</p>
  * <p><b>foo</b>{bar}<span></span></p> -> <p><b>foo[</b>bar<span></span>]</p>
  * ```
  *
  * Note that in the sample above:
  *
  * - `<p>` have type of {@link module:engine/view/containerelement~ContainerElement},
  * - `<b>` have type of {@link module:engine/view/attributeelement~AttributeElement},
  * - `<span>` have type of {@link module:engine/view/uielement~UIElement}.
  *
  * @returns Enlarged range.
  */
  getEnlarged() {
    let t = this.start.getLastMatchingPosition(ku, {
      direction: "backward"
    }), i = this.end.getLastMatchingPosition(ku);
    return t.parent.is("$text") && t.isAtStart && (t = ne._createBefore(t.parent)), i.parent.is("$text") && i.isAtEnd && (i = ne._createAfter(i.parent)), new or(t, i);
  }
  /**
  * Creates a minimum range that has the same content as this range but is trimmed in both ways (at the beginning
  * and at the end).
  *
  * For example:
  *
  * ```html
  * <p>Foo</p>[<p><b>Bar</b>]</p> -> <p>Foo</p><p><b>{Bar}</b></p>
  * <p><b>foo[</b>bar<span></span>]</p> -> <p><b>foo</b>{bar}<span></span></p>
  * ```
  *
  * Note that in the sample above:
  *
  * - `<p>` have type of {@link module:engine/view/containerelement~ContainerElement},
  * - `<b>` have type of {@link module:engine/view/attributeelement~AttributeElement},
  * - `<span>` have type of {@link module:engine/view/uielement~UIElement}.
  *
  * @returns Shrunk range.
  */
  getTrimmed() {
    let t = this.start.getLastMatchingPosition(ku);
    if (t.isAfter(this.end) || t.isEqual(this.end))
      return new or(t, t);
    let i = this.end.getLastMatchingPosition(ku, {
      direction: "backward"
    });
    const r = t.nodeAfter, s = i.nodeBefore;
    return r && r.is("$text") && (t = new ne(r, 0)), s && s.is("$text") && (i = new ne(s, s.data.length)), new or(t, i);
  }
  /**
  * Two ranges are equal if their start and end positions are equal.
  *
  * @param otherRange Range to compare with.
  * @returns `true` if ranges are equal, `false` otherwise
  */
  isEqual(t) {
    return this == t || this.start.isEqual(t.start) && this.end.isEqual(t.end);
  }
  /**
  * Checks whether this range contains given {@link module:engine/view/position~Position position}.
  *
  * @param position Position to check.
  * @returns `true` if given {@link module:engine/view/position~Position position} is contained in this range, `false` otherwise.
  */
  containsPosition(t) {
    return t.isAfter(this.start) && t.isBefore(this.end);
  }
  /**
  * Checks whether this range contains given {@link module:engine/view/range~Range range}.
  *
  * @param otherRange Range to check.
  * @param loose Whether the check is loose or strict. If the check is strict (`false`), compared range cannot
  * start or end at the same position as this range boundaries. If the check is loose (`true`), compared range can start, end or
  * even be equal to this range. Note that collapsed ranges are always compared in strict mode.
  * @returns `true` if given {@link module:engine/view/range~Range range} boundaries are contained by this range, `false`
  * otherwise.
  */
  containsRange(t, i = !1) {
    t.isCollapsed && (i = !1);
    const r = this.containsPosition(t.start) || i && this.start.isEqual(t.start), s = this.containsPosition(t.end) || i && this.end.isEqual(t.end);
    return r && s;
  }
  /**
  * Computes which part(s) of this {@link module:engine/view/range~Range range} is not a part of given
  * {@link module:engine/view/range~Range range}.
  * Returned array contains zero, one or two {@link module:engine/view/range~Range ranges}.
  *
  * Examples:
  *
  * ```ts
  * let foo = downcastWriter.createText( 'foo' );
  * let img = downcastWriter.createContainerElement( 'img' );
  * let bar = downcastWriter.createText( 'bar' );
  * let p = downcastWriter.createContainerElement( 'p', null, [ foo, img, bar ] );
  *
  * let range = view.createRange( view.createPositionAt( foo, 2 ), view.createPositionAt( bar, 1 ); // "o", img, "b" are in range.
  * let otherRange = view.createRange( // "oo", img, "ba" are in range.
  * 	view.createPositionAt( foo, 1 ),
  * 	view.createPositionAt( bar, 2 )
  * );
  * let transformed = range.getDifference( otherRange );
  * // transformed array has no ranges because `otherRange` contains `range`
  *
  * otherRange = view.createRange( view.createPositionAt( foo, 1 ), view.createPositionAt( p, 2 ); // "oo", img are in range.
  * transformed = range.getDifference( otherRange );
  * // transformed array has one range: from ( p, 2 ) to ( bar, 1 )
  *
  * otherRange = view.createRange( view.createPositionAt( p, 1 ), view.createPositionAt( p, 2 ) ); // img is in range.
  * transformed = range.getDifference( otherRange );
  * // transformed array has two ranges: from ( foo, 1 ) to ( p, 1 ) and from ( p, 2 ) to ( bar, 1 )
  * ```
  *
  * @param otherRange Range to differentiate against.
  * @returns The difference between ranges.
  */
  getDifference(t) {
    const i = [];
    return this.isIntersecting(t) ? (this.containsPosition(t.start) && i.push(new or(this.start, t.start)), this.containsPosition(t.end) && i.push(new or(t.end, this.end))) : i.push(this.clone()), i;
  }
  /**
  * Returns an intersection of this {@link module:engine/view/range~Range range} and given {@link module:engine/view/range~Range range}.
  * Intersection is a common part of both of those ranges. If ranges has no common part, returns `null`.
  *
  * Examples:
  *
  * ```ts
  * let foo = downcastWriter.createText( 'foo' );
  * let img = downcastWriter.createContainerElement( 'img' );
  * let bar = downcastWriter.createText( 'bar' );
  * let p = downcastWriter.createContainerElement( 'p', null, [ foo, img, bar ] );
  *
  * let range = view.createRange( view.createPositionAt( foo, 2 ), view.createPositionAt( bar, 1 ); // "o", img, "b" are in range.
  * let otherRange = view.createRange( view.createPositionAt( foo, 1 ), view.createPositionAt( p, 2 ); // "oo", img are in range.
  * let transformed = range.getIntersection( otherRange ); // range from ( foo, 1 ) to ( p, 2 ).
  *
  * otherRange = view.createRange( view.createPositionAt( bar, 1 ), view.createPositionAt( bar, 3 ); "ar" is in range.
  * transformed = range.getIntersection( otherRange ); // null - no common part.
  * ```
  *
  * @param otherRange Range to check for intersection.
  * @returns A common part of given ranges or `null` if ranges have no common part.
  */
  getIntersection(t) {
    if (this.isIntersecting(t)) {
      let i = this.start, r = this.end;
      return this.containsPosition(t.start) && (i = t.start), this.containsPosition(t.end) && (r = t.end), new or(i, r);
    }
    return null;
  }
  /**
  * Creates a {@link module:engine/view/treewalker~TreeWalker TreeWalker} instance with this range as a boundary.
  *
  * @param options Object with configuration options. See {@link module:engine/view/treewalker~TreeWalker}.
  */
  getWalker(t = {}) {
    return t.boundaries = this, new Kr(t);
  }
  /**
  * Returns a {@link module:engine/view/node~Node} or {@link module:engine/view/documentfragment~DocumentFragment}
  * which is a common ancestor of range's both ends (in which the entire range is contained).
  */
  getCommonAncestor() {
    return this.start.getCommonAncestor(this.end);
  }
  /**
  * Returns an {@link module:engine/view/element~Element Element} contained by the range.
  * The element will be returned when it is the **only** node within the range and **fully–contained**
  * at the same time.
  */
  getContainedElement() {
    if (this.isCollapsed)
      return null;
    let t = this.start.nodeAfter, i = this.end.nodeBefore;
    return this.start.parent.is("$text") && this.start.isAtEnd && this.start.parent.nextSibling && (t = this.start.parent.nextSibling), this.end.parent.is("$text") && this.end.isAtStart && this.end.parent.previousSibling && (i = this.end.parent.previousSibling), t && t.is("element") && t === i ? t : null;
  }
  /**
  * Clones this range.
  */
  clone() {
    return new or(this.start, this.end);
  }
  /**
  * Returns an iterator that iterates over all {@link module:engine/view/item~Item view items} that are in this range and returns
  * them.
  *
  * This method uses {@link module:engine/view/treewalker~TreeWalker} with `boundaries` set to this range and `ignoreElementEnd` option
  * set to `true`. However it returns only {@link module:engine/view/item~Item items},
  * not {@link module:engine/view/treewalker~TreeWalkerValue}.
  *
  * You may specify additional options for the tree walker. See {@link module:engine/view/treewalker~TreeWalker} for
  * a full list of available options.
  *
  * @param options Object with configuration options. See {@link module:engine/view/treewalker~TreeWalker}.
  */
  *getItems(t = {}) {
    t.boundaries = this, t.ignoreElementEnd = !0;
    const i = new Kr(t);
    for (const r of i)
      yield r.item;
  }
  /**
  * Returns an iterator that iterates over all {@link module:engine/view/position~Position positions} that are boundaries or
  * contained in this range.
  *
  * This method uses {@link module:engine/view/treewalker~TreeWalker} with `boundaries` set to this range. However it returns only
  * {@link module:engine/view/position~Position positions}, not {@link module:engine/view/treewalker~TreeWalkerValue}.
  *
  * You may specify additional options for the tree walker. See {@link module:engine/view/treewalker~TreeWalker} for
  * a full list of available options.
  *
  * @param options Object with configuration options. See {@link module:engine/view/treewalker~TreeWalker}.
  */
  *getPositions(t = {}) {
    t.boundaries = this;
    const i = new Kr(t);
    yield i.position;
    for (const r of i)
      yield r.nextPosition;
  }
  /**
  * Checks and returns whether this range intersects with the given range.
  *
  * @param otherRange Range to compare with.
  * @returns True if ranges intersect.
  */
  isIntersecting(t) {
    return this.start.isBefore(t.end) && this.end.isAfter(t.start);
  }
  /**
  * Creates a range from the given parents and offsets.
  *
  * @internal
  * @param startElement Start position parent element.
  * @param startOffset Start position offset.
  * @param endElement End position parent element.
  * @param endOffset End position offset.
  * @returns Created range.
  */
  static _createFromParentsAndOffsets(t, i, r, s) {
    return new this(new ne(t, i), new ne(r, s));
  }
  /**
  * Creates a new range, spreading from specified {@link module:engine/view/position~Position position} to a position moved by
  * given `shift`. If `shift` is a negative value, shifted position is treated as the beginning of the range.
  *
  * @internal
  * @param position Beginning of the range.
  * @param shift How long the range should be.
  */
  static _createFromPositionAndShift(t, i) {
    const r = t, s = t.getShiftedBy(i);
    return i > 0 ? new this(r, s) : new this(s, r);
  }
  /**
  * Creates a range inside an {@link module:engine/view/element~Element element} which starts before the first child of
  * that element and ends after the last child of that element.
  *
  * @internal
  * @param element Element which is a parent for the range.
  */
  static _createIn(t) {
    return this._createFromParentsAndOffsets(t, 0, t, t.childCount);
  }
  /**
  * Creates a range that starts before given {@link module:engine/view/item~Item view item} and ends after it.
  *
  * @internal
  */
  static _createOn(t) {
    const i = t.is("$textProxy") ? t.offsetSize : 1;
    return this._createFromPositionAndShift(ne._createBefore(t), i);
  }
};
Re.prototype.is = function(e) {
  return e === "range" || e === "view:range";
};
function ku(e) {
  return !!(e.item.is("attributeElement") || e.item.is("uiElement"));
}
let gr = class qE extends (/* @__PURE__ */ Je(us)) {
  /**
  * Creates new selection instance.
  *
  * **Note**: The selection constructor is available as a factory method:
  *
  * * {@link module:engine/view/view~View#createSelection `View#createSelection()`},
  * * {@link module:engine/view/upcastwriter~UpcastWriter#createSelection `UpcastWriter#createSelection()`}.
  *
  * ```ts
  * // Creates empty selection without ranges.
  * const selection = writer.createSelection();
  *
  * // Creates selection at the given range.
  * const range = writer.createRange( start, end );
  * const selection = writer.createSelection( range );
  *
  * // Creates selection at the given ranges
  * const ranges = [ writer.createRange( start1, end2 ), writer.createRange( star2, end2 ) ];
  * const selection = writer.createSelection( ranges );
  *
  * // Creates selection from the other selection.
  * const otherSelection = writer.createSelection();
  * const selection = writer.createSelection( otherSelection );
  *
  * // Creates selection from the document selection.
  * const selection = writer.createSelection( editor.editing.view.document.selection );
  *
  * // Creates selection at the given position.
  * const position = writer.createPositionFromPath( root, path );
  * const selection = writer.createSelection( position );
  *
  * // Creates collapsed selection at the position of given item and offset.
  * const paragraph = writer.createContainerElement( 'paragraph' );
  * const selection = writer.createSelection( paragraph, offset );
  *
  * // Creates a range inside an {@link module:engine/view/element~Element element} which starts before the
  * // first child of that element and ends after the last child of that element.
  * const selection = writer.createSelection( paragraph, 'in' );
  *
  * // Creates a range on an {@link module:engine/view/item~Item item} which starts before the item and ends
  * // just after the item.
  * const selection = writer.createSelection( paragraph, 'on' );
  * ```
  *
  * `Selection`'s constructor allow passing additional options (`backward`, `fake` and `label`) as the last argument.
  *
  * ```ts
  * // Creates backward selection.
  * const selection = writer.createSelection( range, { backward: true } );
  * ```
  *
  * Fake selection does not render as browser native selection over selected elements and is hidden to the user.
  * This way, no native selection UI artifacts are displayed to the user and selection over elements can be
  * represented in other way, for example by applying proper CSS class.
  *
  * Additionally fake's selection label can be provided. It will be used to describe fake selection in DOM
  * (and be  properly handled by screen readers).
  *
  * ```ts
  * // Creates fake selection with label.
  * const selection = writer.createSelection( range, { fake: true, label: 'foo' } );
  * ```
  *
  * @internal
  */
  constructor(...t) {
    super();
    /**
    * Stores all ranges that are selected.
    */
    m(this, "_ranges");
    /**
    * Specifies whether the last added range was added as a backward or forward range.
    */
    m(this, "_lastRangeBackward");
    /**
    * Specifies whether selection instance is fake.
    */
    m(this, "_isFake");
    /**
    * Fake selection's label.
    */
    m(this, "_fakeSelectionLabel");
    this._ranges = [], this._lastRangeBackward = !1, this._isFake = !1, this._fakeSelectionLabel = "", t.length && this.setTo(...t);
  }
  /**
  * Returns true if selection instance is marked as `fake`.
  *
  * @see #setTo
  */
  get isFake() {
    return this._isFake;
  }
  /**
  * Returns fake selection label.
  *
  * @see #setTo
  */
  get fakeSelectionLabel() {
    return this._fakeSelectionLabel;
  }
  /**
  * Selection anchor. Anchor may be described as a position where the selection starts. Together with
  * {@link #focus focus} they define the direction of selection, which is important
  * when expanding/shrinking selection. Anchor is always the start or end of the most recent added range.
  * It may be a bit unintuitive when there are multiple ranges in selection.
  *
  * @see #focus
  */
  get anchor() {
    if (!this._ranges.length)
      return null;
    const t = this._ranges[this._ranges.length - 1];
    return (this._lastRangeBackward ? t.end : t.start).clone();
  }
  /**
  * Selection focus. Focus is a position where the selection ends.
  *
  * @see #anchor
  */
  get focus() {
    if (!this._ranges.length)
      return null;
    const t = this._ranges[this._ranges.length - 1];
    return (this._lastRangeBackward ? t.start : t.end).clone();
  }
  /**
  * Returns whether the selection is collapsed. Selection is collapsed when there is exactly one range which is
  * collapsed.
  */
  get isCollapsed() {
    return this.rangeCount === 1 && this._ranges[0].isCollapsed;
  }
  /**
  * Returns number of ranges in selection.
  */
  get rangeCount() {
    return this._ranges.length;
  }
  /**
  * Specifies whether the {@link #focus} precedes {@link #anchor}.
  */
  get isBackward() {
    return !this.isCollapsed && this._lastRangeBackward;
  }
  /**
  * {@link module:engine/view/editableelement~EditableElement EditableElement} instance that contains this selection, or `null`
  * if the selection is not inside an editable element.
  */
  get editableElement() {
    return this.anchor ? this.anchor.editableElement : null;
  }
  /**
  * Returns an iterable that contains copies of all ranges added to the selection.
  */
  *getRanges() {
    for (const t of this._ranges)
      yield t.clone();
  }
  /**
  * Returns copy of the first range in the selection. First range is the one which
  * {@link module:engine/view/range~Range#start start} position {@link module:engine/view/position~Position#isBefore is before} start
  * position of all other ranges (not to confuse with the first range added to the selection).
  * Returns `null` if no ranges are added to selection.
  */
  getFirstRange() {
    let t = null;
    for (const i of this._ranges)
      (!t || i.start.isBefore(t.start)) && (t = i);
    return t ? t.clone() : null;
  }
  /**
  * Returns copy of the last range in the selection. Last range is the one which {@link module:engine/view/range~Range#end end}
  * position {@link module:engine/view/position~Position#isAfter is after} end position of all other ranges (not to confuse
  * with the last range added to the selection). Returns `null` if no ranges are added to selection.
  */
  getLastRange() {
    let t = null;
    for (const i of this._ranges)
      (!t || i.end.isAfter(t.end)) && (t = i);
    return t ? t.clone() : null;
  }
  /**
  * Returns copy of the first position in the selection. First position is the position that
  * {@link module:engine/view/position~Position#isBefore is before} any other position in the selection ranges.
  * Returns `null` if no ranges are added to selection.
  */
  getFirstPosition() {
    const t = this.getFirstRange();
    return t ? t.start.clone() : null;
  }
  /**
  * Returns copy of the last position in the selection. Last position is the position that
  * {@link module:engine/view/position~Position#isAfter is after} any other position in the selection ranges.
  * Returns `null` if no ranges are added to selection.
  */
  getLastPosition() {
    const t = this.getLastRange();
    return t ? t.end.clone() : null;
  }
  /**
  * Checks whether, this selection is equal to given selection. Selections are equal if they have same directions,
  * same number of ranges and all ranges from one selection equal to a range from other selection.
  *
  * @param otherSelection Selection to compare with.
  * @returns `true` if selections are equal, `false` otherwise.
  */
  isEqual(t) {
    if (this.isFake != t.isFake || this.isFake && this.fakeSelectionLabel != t.fakeSelectionLabel || this.rangeCount != t.rangeCount)
      return !1;
    if (this.rangeCount === 0)
      return !0;
    if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus))
      return !1;
    for (const i of this._ranges) {
      let r = !1;
      for (const s of t._ranges)
        if (i.isEqual(s)) {
          r = !0;
          break;
        }
      if (!r)
        return !1;
    }
    return !0;
  }
  /**
  * Checks whether this selection is similar to given selection. Selections are similar if they have same directions, same
  * number of ranges, and all {@link module:engine/view/range~Range#getTrimmed trimmed} ranges from one selection are
  * equal to any trimmed range from other selection.
  *
  * @param otherSelection Selection to compare with.
  * @returns `true` if selections are similar, `false` otherwise.
  */
  isSimilar(t) {
    if (this.isBackward != t.isBackward)
      return !1;
    const i = Ch(this.getRanges()), r = Ch(t.getRanges());
    if (i != r)
      return !1;
    if (i == 0)
      return !0;
    for (let s of this.getRanges()) {
      s = s.getTrimmed();
      let o = !1;
      for (let a of t.getRanges())
        if (a = a.getTrimmed(), s.start.isEqual(a.start) && s.end.isEqual(a.end)) {
          o = !0;
          break;
        }
      if (!o)
        return !1;
    }
    return !0;
  }
  /**
  * Returns the selected element. {@link module:engine/view/element~Element Element} is considered as selected if there is only
  * one range in the selection, and that range contains exactly one element.
  * Returns `null` if there is no selected element.
  */
  getSelectedElement() {
    return this.rangeCount !== 1 ? null : this.getFirstRange().getContainedElement();
  }
  /**
  * Sets this selection's ranges and direction to the specified location based on the given
  * {@link module:engine/view/selection~Selectable selectable}.
  *
  * ```ts
  * // Sets selection to the given range.
  * const range = writer.createRange( start, end );
  * selection.setTo( range );
  *
  * // Sets selection to given ranges.
  * const ranges = [ writer.createRange( start1, end2 ), writer.createRange( star2, end2 ) ];
  * selection.setTo( range );
  *
  * // Sets selection to the other selection.
  * const otherSelection = writer.createSelection();
  * selection.setTo( otherSelection );
  *
  * // Sets selection to contents of DocumentSelection.
  * selection.setTo( editor.editing.view.document.selection );
  *
  * // Sets collapsed selection at the given position.
  * const position = writer.createPositionAt( root, path );
  * selection.setTo( position );
  *
  * // Sets collapsed selection at the position of given item and offset.
  * selection.setTo( paragraph, offset );
  * ```
  *
  * Creates a range inside an {@link module:engine/view/element~Element element} which starts before the first child of
  * that element and ends after the last child of that element.
  *
  * ```ts
  * selection.setTo( paragraph, 'in' );
  * ```
  *
  * Creates a range on an {@link module:engine/view/item~Item item} which starts before the item and ends just after the item.
  *
  * ```ts
  * selection.setTo( paragraph, 'on' );
  *
  * // Clears selection. Removes all ranges.
  * selection.setTo( null );
  * ```
  *
  * `Selection#setTo()` method allow passing additional options (`backward`, `fake` and `label`) as the last argument.
  *
  * ```ts
  * // Sets selection as backward.
  * selection.setTo( range, { backward: true } );
  * ```
  *
  * Fake selection does not render as browser native selection over selected elements and is hidden to the user.
  * This way, no native selection UI artifacts are displayed to the user and selection over elements can be
  * represented in other way, for example by applying proper CSS class.
  *
  * Additionally fake's selection label can be provided. It will be used to describe fake selection in DOM
  * (and be  properly handled by screen readers).
  *
  * ```ts
  * // Creates fake selection with label.
  * selection.setTo( range, { fake: true, label: 'foo' } );
  * ```
  *
  * @fires change
  */
  setTo(...t) {
    let [i, r, s] = t;
    if (typeof r == "object" && (s = r, r = void 0), i === null)
      this._setRanges([]), this._setFakeOptions(s);
    else if (i instanceof qE || i instanceof Kf)
      this._setRanges(i.getRanges(), i.isBackward), this._setFakeOptions({
        fake: i.isFake,
        label: i.fakeSelectionLabel
      });
    else if (i instanceof Re)
      this._setRanges([
        i
      ], s && s.backward), this._setFakeOptions(s);
    else if (i instanceof ne)
      this._setRanges([
        new Re(i)
      ]), this._setFakeOptions(s);
    else if (i instanceof ls) {
      const o = !!s && !!s.backward;
      let a;
      if (r === void 0)
        throw new v("view-selection-setto-required-second-parameter", this);
      r == "in" ? a = Re._createIn(i) : r == "on" ? a = Re._createOn(i) : a = new Re(ne._createAt(i, r)), this._setRanges([
        a
      ], o), this._setFakeOptions(s);
    } else if (Nn(i))
      this._setRanges(i, s && s.backward), this._setFakeOptions(s);
    else
      throw new v("view-selection-setto-not-selectable", this);
    this.fire("change");
  }
  /**
  * Moves {@link #focus} to the specified location.
  *
  * The location can be specified in the same form as {@link module:engine/view/view~View#createPositionAt view.createPositionAt()}
  * parameters.
  *
  * @fires change
  * @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/view/item~Item view item}.
  */
  setFocus(t, i) {
    if (this.anchor === null)
      throw new v("view-selection-setfocus-no-ranges", this);
    const r = ne._createAt(t, i);
    if (r.compareWith(this.focus) == "same")
      return;
    const s = this.anchor;
    this._ranges.pop(), r.compareWith(s) == "before" ? this._addRange(new Re(r, s), !0) : this._addRange(new Re(s, r)), this.fire("change");
  }
  /**
  * Replaces all ranges that were added to the selection with given array of ranges. Last range of the array
  * is treated like the last added range and is used to set {@link #anchor anchor} and {@link #focus focus}.
  * Accepts a flag describing in which way the selection is made.
  *
  * @param newRanges Iterable object of ranges to set.
  * @param isLastBackward Flag describing if last added range was selected forward - from start to end
  * (`false`) or backward - from end to start (`true`). Defaults to `false`.
  */
  _setRanges(t, i = !1) {
    t = Array.from(t), this._ranges = [];
    for (const r of t)
      this._addRange(r);
    this._lastRangeBackward = !!i;
  }
  /**
  * Sets this selection instance to be marked as `fake`. A fake selection does not render as browser native selection
  * over selected elements and is hidden to the user. This way, no native selection UI artifacts are displayed to
  * the user and selection over elements can be represented in other way, for example by applying proper CSS class.
  *
  * Additionally fake's selection label can be provided. It will be used to describe fake selection in DOM (and be
  * properly handled by screen readers).
  */
  _setFakeOptions(t = {}) {
    this._isFake = !!t.fake, this._fakeSelectionLabel = t.fake && t.label || "";
  }
  /**
  * Adds a range to the selection. Added range is copied. This means that passed range is not saved in the
  * selection instance and you can safely operate on it.
  *
  * Accepts a flag describing in which way the selection is made - passed range might be selected from
  * {@link module:engine/view/range~Range#start start} to {@link module:engine/view/range~Range#end end}
  * or from {@link module:engine/view/range~Range#end end} to {@link module:engine/view/range~Range#start start}.
  * The flag is used to set {@link #anchor anchor} and {@link #focus focus} properties.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-selection-range-intersects` if added range intersects
  * with ranges already stored in Selection instance.
  */
  _addRange(t, i = !1) {
    if (!(t instanceof Re))
      throw new v("view-selection-add-range-not-range", this);
    this._pushRange(t), this._lastRangeBackward = !!i;
  }
  /**
  * Adds range to selection - creates copy of given range so it can be safely used and modified.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-selection-range-intersects` if added range intersects
  * with ranges already stored in selection instance.
  */
  _pushRange(t) {
    for (const i of this._ranges)
      if (t.isIntersecting(i))
        throw new v("view-selection-range-intersects", this, {
          addedRange: t,
          intersectingRange: i
        });
    this._ranges.push(new Re(t.start, t.end));
  }
};
gr.prototype.is = function(e) {
  return e === "selection" || e === "view:selection";
};
let Kf = class extends (/* @__PURE__ */ Je(us)) {
  constructor(...t) {
    super();
    /**
    * Selection is used internally (`DocumentSelection` is a proxy to that selection).
    */
    m(this, "_selection");
    this._selection = new gr(), this._selection.delegate("change").to(this), t.length && this._selection.setTo(...t);
  }
  /**
  * Returns true if selection instance is marked as `fake`.
  *
  * @see #_setTo
  */
  get isFake() {
    return this._selection.isFake;
  }
  /**
  * Returns fake selection label.
  *
  * @see #_setTo
  */
  get fakeSelectionLabel() {
    return this._selection.fakeSelectionLabel;
  }
  /**
  * Selection anchor. Anchor may be described as a position where the selection starts. Together with
  * {@link #focus focus} they define the direction of selection, which is important
  * when expanding/shrinking selection. Anchor is always the start or end of the most recent added range.
  * It may be a bit unintuitive when there are multiple ranges in selection.
  *
  * @see #focus
  */
  get anchor() {
    return this._selection.anchor;
  }
  /**
  * Selection focus. Focus is a position where the selection ends.
  *
  * @see #anchor
  */
  get focus() {
    return this._selection.focus;
  }
  /**
  * Returns whether the selection is collapsed. Selection is collapsed when there is exactly one range which is
  * collapsed.
  */
  get isCollapsed() {
    return this._selection.isCollapsed;
  }
  /**
  * Returns number of ranges in selection.
  */
  get rangeCount() {
    return this._selection.rangeCount;
  }
  /**
  * Specifies whether the {@link #focus} precedes {@link #anchor}.
  */
  get isBackward() {
    return this._selection.isBackward;
  }
  /**
  * {@link module:engine/view/editableelement~EditableElement EditableElement} instance that contains this selection, or `null`
  * if the selection is not inside an editable element.
  */
  get editableElement() {
    return this._selection.editableElement;
  }
  /**
  * Used for the compatibility with the {@link module:engine/view/selection~Selection#isEqual} method.
  *
  * @internal
  */
  get _ranges() {
    return this._selection._ranges;
  }
  /**
  * Returns an iterable that contains copies of all ranges added to the selection.
  */
  *getRanges() {
    yield* this._selection.getRanges();
  }
  /**
  * Returns copy of the first range in the selection. First range is the one which
  * {@link module:engine/view/range~Range#start start} position {@link module:engine/view/position~Position#isBefore is before} start
  * position of all other ranges (not to confuse with the first range added to the selection).
  * Returns `null` if no ranges are added to selection.
  */
  getFirstRange() {
    return this._selection.getFirstRange();
  }
  /**
  * Returns copy of the last range in the selection. Last range is the one which {@link module:engine/view/range~Range#end end}
  * position {@link module:engine/view/position~Position#isAfter is after} end position of all other ranges (not to confuse
  * with the last range added to the selection). Returns `null` if no ranges are added to selection.
  */
  getLastRange() {
    return this._selection.getLastRange();
  }
  /**
  * Returns copy of the first position in the selection. First position is the position that
  * {@link module:engine/view/position~Position#isBefore is before} any other position in the selection ranges.
  * Returns `null` if no ranges are added to selection.
  */
  getFirstPosition() {
    return this._selection.getFirstPosition();
  }
  /**
  * Returns copy of the last position in the selection. Last position is the position that
  * {@link module:engine/view/position~Position#isAfter is after} any other position in the selection ranges.
  * Returns `null` if no ranges are added to selection.
  */
  getLastPosition() {
    return this._selection.getLastPosition();
  }
  /**
  * Returns the selected element. {@link module:engine/view/element~Element Element} is considered as selected if there is only
  * one range in the selection, and that range contains exactly one element.
  * Returns `null` if there is no selected element.
  */
  getSelectedElement() {
    return this._selection.getSelectedElement();
  }
  /**
  * Checks whether, this selection is equal to given selection. Selections are equal if they have same directions,
  * same number of ranges and all ranges from one selection equal to a range from other selection.
  *
  * @param otherSelection Selection to compare with.
  * @returns `true` if selections are equal, `false` otherwise.
  */
  isEqual(t) {
    return this._selection.isEqual(t);
  }
  /**
  * Checks whether this selection is similar to given selection. Selections are similar if they have same directions, same
  * number of ranges, and all {@link module:engine/view/range~Range#getTrimmed trimmed} ranges from one selection are
  * equal to any trimmed range from other selection.
  *
  * @param otherSelection Selection to compare with.
  * @returns `true` if selections are similar, `false` otherwise.
  */
  isSimilar(t) {
    return this._selection.isSimilar(t);
  }
  /**
  * Sets this selection's ranges and direction to the specified location based on the given
  * {@link module:engine/view/selection~Selectable selectable}.
  *
  * ```ts
  * // Sets selection to the given range.
  * const range = writer.createRange( start, end );
  * documentSelection._setTo( range );
  *
  * // Sets selection to given ranges.
  * const ranges = [ writer.createRange( start1, end2 ), writer.createRange( start2, end2 ) ];
  * documentSelection._setTo( range );
  *
  * // Sets selection to the other selection.
  * const otherSelection = writer.createSelection();
  * documentSelection._setTo( otherSelection );
  *
  * // Sets collapsed selection at the given position.
  * const position = writer.createPositionAt( root, offset );
  * documentSelection._setTo( position );
  *
  * // Sets collapsed selection at the position of given item and offset.
  * documentSelection._setTo( paragraph, offset );
  * ```
  *
  * Creates a range inside an {@link module:engine/view/element~Element element} which starts before the first child of
  * that element and ends after the last child of that element.
  *
  * ```ts
  * documentSelection._setTo( paragraph, 'in' );
  * ```
  *
  * Creates a range on an {@link module:engine/view/item~Item item} which starts before the item and ends just after the item.
  *
  * ```ts
  * documentSelection._setTo( paragraph, 'on' );
  *
  * // Clears selection. Removes all ranges.
  * documentSelection._setTo( null );
  * ```
  *
  * `Selection#_setTo()` method allow passing additional options (`backward`, `fake` and `label`) as the last argument.
  *
  * ```ts
  * // Sets selection as backward.
  * documentSelection._setTo( range, { backward: true } );
  * ```
  *
  * Fake selection does not render as browser native selection over selected elements and is hidden to the user.
  * This way, no native selection UI artifacts are displayed to the user and selection over elements can be
  * represented in other way, for example by applying proper CSS class.
  *
  * Additionally fake's selection label can be provided. It will be used to des cribe fake selection in DOM
  * (and be  properly handled by screen readers).
  *
  * ```ts
  * // Creates fake selection with label.
  * documentSelection._setTo( range, { fake: true, label: 'foo' } );
  * ```
  *
  * @internal
  * @fires change
  */
  _setTo(...t) {
    this._selection.setTo(...t);
  }
  /**
  * Moves {@link #focus} to the specified location.
  *
  * The location can be specified in the same form as {@link module:engine/view/view~View#createPositionAt view.createPositionAt()}
  * parameters.
  *
  * @internal
  * @fires change
  * @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/view/item~Item view item}.
  */
  _setFocus(t, i) {
    this._selection.setFocus(t, i);
  }
};
Kf.prototype.is = function(e) {
  return e === "selection" || e == "documentSelection" || e == "view:selection" || e == "view:documentSelection";
};
class fo extends Wi {
  /**
  * @param source The emitter.
  * @param name The event name.
  * @param startRange The view range that the bubbling should start from.
  */
  constructor(t, i, r) {
    super(t, i);
    /**
    * The view range that the bubbling should start from.
    */
    m(this, "startRange");
    /**
    * The current event phase.
    */
    m(this, "_eventPhase");
    /**
    * The current bubbling target.
    */
    m(this, "_currentTarget");
    this.startRange = r, this._eventPhase = "none", this._currentTarget = null;
  }
  /**
  * The current event phase.
  */
  get eventPhase() {
    return this._eventPhase;
  }
  /**
  * The current bubbling target.
  */
  get currentTarget() {
    return this._currentTarget;
  }
}
const ud = Symbol("bubbling contexts");
function xh(e) {
  class n extends e {
    fire(i, ...r) {
      try {
        const s = i instanceof Wi ? i : new Wi(this, i), o = ld(this);
        if (!o.size)
          return;
        if (No(s, "capturing", this), ws(o, "$capture", s, ...r))
          return s.return;
        const a = s.startRange || this.selection.getFirstRange(), u = a ? a.getContainedElement() : null, l = u ? !!YE(o, u) : !1;
        let c = u || tO(a);
        if (No(s, "atTarget", c), !l) {
          if (ws(o, "$text", s, ...r))
            return s.return;
          No(s, "bubbling", c);
        }
        for (; c; ) {
          if (c.is("rootElement")) {
            if (ws(o, "$root", s, ...r))
              return s.return;
          } else if (c.is("element") && ws(o, c.name, s, ...r))
            return s.return;
          if (ws(o, c, s, ...r))
            return s.return;
          c = c.parent, No(s, "bubbling", c);
        }
        return No(s, "bubbling", this), ws(o, "$document", s, ...r), s.return;
      } catch (s) {
        /* istanbul ignore next -- @preserve */
        v.rethrowUnexpectedError(s, this);
      }
    }
    _addEventListener(i, r, s) {
      const o = Dt(s.context || "$document"), a = ld(this);
      for (const u of o) {
        let l = a.get(u);
        l || (l = new (Je())(), a.set(u, l)), this.listenTo(l, i, r, s);
      }
    }
    _removeEventListener(i, r) {
      const s = ld(this);
      for (const o of s.values())
        this.stopListening(o, i, r);
    }
  }
  return n;
}
{
  const e = xh(Object);
  [
    "fire",
    "_addEventListener",
    "_removeEventListener"
  ].forEach((n) => {
    xh[n] = e.prototype[n];
  });
}
function No(e, n, t) {
  e instanceof fo && (e._eventPhase = n, e._currentTarget = t);
}
function ws(e, n, t, ...i) {
  const r = typeof n == "string" ? e.get(n) : YE(e, n);
  return r ? (r.fire(t, ...i), t.stop.called) : !1;
}
function YE(e, n) {
  for (const [t, i] of e)
    if (typeof t == "function" && t(n))
      return i;
  return null;
}
function ld(e) {
  return e[ud] || (e[ud] = /* @__PURE__ */ new Map()), e[ud];
}
function tO(e) {
  if (!e)
    return null;
  const n = e.start.parent, t = e.end.parent, i = n.getPath(), r = t.getPath();
  return i.length > r.length ? n : t;
}
let jE = class extends (/* @__PURE__ */ xh(/* @__PURE__ */ pt())) {
  /**
  * Creates a Document instance.
  *
  * @param stylesProcessor The styles processor instance.
  */
  constructor(t) {
    super();
    /**
    * Selection done on this document.
    */
    m(this, "selection");
    /**
    * Roots of the view tree. Collection of the {@link module:engine/view/element~Element view elements}.
    *
    * View roots are created as a result of binding between {@link module:engine/view/document~Document#roots} and
    * {@link module:engine/model/document~Document#roots} and this is handled by
    * {@link module:engine/controller/editingcontroller~EditingController}, so to create view root we need to create
    * model root using {@link module:engine/model/document~Document#createRoot}.
    */
    m(this, "roots");
    /**
    * The styles processor instance used by this document when normalizing styles.
    */
    m(this, "stylesProcessor");
    /**
    * Post-fixer callbacks registered to the view document.
    */
    m(this, "_postFixers", /* @__PURE__ */ new Set());
    this.selection = new Kf(), this.roots = new Qi({
      idProperty: "rootName"
    }), this.stylesProcessor = t, this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("isSelecting", !1), this.set("isComposing", !1);
  }
  /**
  * Gets a {@link module:engine/view/document~Document#roots view root element} with the specified name. If the name is not
  * specific "main" root is returned.
  *
  * @param name Name of the root.
  * @returns The view root element with the specified name or null when there is no root of given name.
  */
  getRoot(t = "main") {
    return this.roots.get(t);
  }
  /**
  * Allows registering post-fixer callbacks. A post-fixers mechanism allows to update the view tree just before it is rendered
  * to the DOM.
  *
  * Post-fixers are executed right after all changes from the outermost change block were applied but
  * before the {@link module:engine/view/view~View#event:render render event} is fired. If a post-fixer callback made
  * a change, it should return `true`. When this happens, all post-fixers are fired again to check if something else should
  * not be fixed in the new document tree state.
  *
  * View post-fixers are useful when you want to apply some fixes whenever the view structure changes. Keep in mind that
  * changes executed in a view post-fixer should not break model-view mapping.
  *
  * The types of changes which should be safe:
  *
  * * adding or removing attribute from elements,
  * * changes inside of {@link module:engine/view/uielement~UIElement UI elements},
  * * {@link module:engine/controller/editingcontroller~EditingController#reconvertItem marking some of the model elements to be
  * re-converted}.
  *
  * Try to avoid changes which touch view structure:
  *
  * * you should not add or remove nor wrap or unwrap any view elements,
  * * you should not change the editor data model in a view post-fixer.
  *
  * As a parameter, a post-fixer callback receives a {@link module:engine/view/downcastwriter~DowncastWriter downcast writer}.
  *
  * Typically, a post-fixer will look like this:
  *
  * ```ts
  * editor.editing.view.document.registerPostFixer( writer => {
  * 	if ( checkSomeCondition() ) {
  * 		writer.doSomething();
  *
  * 		// Let other post-fixers know that something changed.
  * 		return true;
  * 	}
  *
  * 	return false;
  * } );
  * ```
  *
  * Note that nothing happens right after you register a post-fixer (e.g. execute such a code in the console).
  * That is because adding a post-fixer does not execute it.
  * The post-fixer will be executed as soon as any change in the document needs to cause its rendering.
  * If you want to re-render the editor's view after registering the post-fixer then you should do it manually by calling
  * {@link module:engine/view/view~View#forceRender `view.forceRender()`}.
  *
  * If you need to register a callback which is executed when DOM elements are already updated,
  * use {@link module:engine/view/view~View#event:render render event}.
  */
  registerPostFixer(t) {
    this._postFixers.add(t);
  }
  /**
  * Destroys this instance. Makes sure that all observers are destroyed and listeners removed.
  */
  destroy() {
    this.roots.forEach((t) => t.destroy()), this.stopListening();
  }
  /**
  * Performs post-fixer loops. Executes post-fixer callbacks as long as none of them has done any changes to the model.
  *
  * @internal
  */
  _callPostFixers(t) {
    let i = !1;
    do
      for (const r of this._postFixers)
        if (i = r(t), i)
          break;
    while (i);
  }
};
const gp = 10;
class Xr extends cs {
  /**
  * Creates an attribute element.
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#createAttributeElement
  * @see module:engine/view/element~Element
  * @protected
  * @param document The document instance to which this element belongs.
  * @param name Node name.
  * @param attrs Collection of attributes.
  * @param children A list of nodes to be inserted into created element.
  */
  constructor(t, i, r, s) {
    super(t, i, r, s);
    /**
    * Element priority. Decides in what order elements are wrapped by {@link module:engine/view/downcastwriter~DowncastWriter}.
    *
    * @internal
    * @readonly
    */
    m(this, "_priority", gp);
    /**
    * Element identifier. If set, it is used by {@link module:engine/view/element~Element#isSimilar},
    * and then two elements are considered similar if, and only if they have the same `_id`.
    *
    * @internal
    * @readonly
    */
    m(this, "_id", null);
    /**
    * Keeps all the attribute elements that have the same {@link module:engine/view/attributeelement~AttributeElement#id ids}
    * and still exist in the view tree.
    *
    * This property is managed by {@link module:engine/view/downcastwriter~DowncastWriter}.
    */
    m(this, "_clonesGroup", null);
    this.getFillerOffset = nO;
  }
  /**
  * Element priority. Decides in what order elements are wrapped by {@link module:engine/view/downcastwriter~DowncastWriter}.
  */
  get priority() {
    return this._priority;
  }
  /**
  * Element identifier. If set, it is used by {@link module:engine/view/element~Element#isSimilar},
  * and then two elements are considered similar if, and only if they have the same `id`.
  */
  get id() {
    return this._id;
  }
  /**
  * Returns all {@link module:engine/view/attributeelement~AttributeElement attribute elements} that has the
  * same {@link module:engine/view/attributeelement~AttributeElement#id id} and are in the view tree (were not removed).
  *
  * Note: If this element has been removed from the tree, returned set will not include it.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError attribute-element-get-elements-with-same-id-no-id}
  * if this element has no `id`.
  *
  * @returns Set containing all the attribute elements
  * with the same `id` that were added and not removed from the view tree.
  */
  getElementsWithSameId() {
    if (this.id === null)
      throw new v("attribute-element-get-elements-with-same-id-no-id", this);
    return new Set(this._clonesGroup);
  }
  /**
  * Checks if this element is similar to other element.
  *
  * If none of elements has set {@link module:engine/view/attributeelement~AttributeElement#id}, then both elements
  * should have the same name, attributes and priority to be considered as similar. Two similar elements can contain
  * different set of children nodes.
  *
  * If at least one element has {@link module:engine/view/attributeelement~AttributeElement#id} set, then both
  * elements have to have the same {@link module:engine/view/attributeelement~AttributeElement#id} value to be
  * considered similar.
  *
  * Similarity is important for {@link module:engine/view/downcastwriter~DowncastWriter}. For example:
  *
  * * two following similar elements can be merged together into one, longer element,
  * * {@link module:engine/view/downcastwriter~DowncastWriter#unwrap} checks similarity of passed element and processed element to
  * decide whether processed element should be unwrapped,
  * * etc.
  */
  isSimilar(t) {
    return this.id !== null || t.id !== null ? this.id === t.id : super.isSimilar(t) && this.priority == t.priority;
  }
  /**
  * Clones provided element with priority.
  *
  * @internal
  * @param deep If set to `true` clones element and all its children recursively. When set to `false`,
  * element will be cloned without any children.
  * @returns Clone of this element.
  */
  _clone(t = !1) {
    const i = super._clone(t);
    return i._priority = this._priority, i._id = this._id, i;
  }
  /**
  * Used by {@link module:engine/view/element~Element#_mergeAttributesFrom} to verify if the given element can be merged without
  * conflicts into this element.
  *
  * @internal
  */
  _canMergeAttributesFrom(t) {
    return this.id !== null || t.id !== null || this.priority !== t.priority ? !1 : super._canMergeAttributesFrom(t);
  }
  /**
  * Used by {@link module:engine/view/element~Element#_subtractAttributesOf} to verify if the given element attributes
  * can be fully subtracted from this element.
  *
  * @internal
  */
  _canSubtractAttributesOf(t) {
    return this.id !== null || t.id !== null || this.priority !== t.priority ? !1 : super._canSubtractAttributesOf(t);
  }
}
m(Xr, "DEFAULT_PRIORITY", gp);
Xr.prototype.is = function(e, n) {
  return n ? n === this.name && (e === "attributeElement" || e === "view:attributeElement" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === "element" || e === "view:element") : e === "attributeElement" || e === "view:attributeElement" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === "element" || e === "view:element" || e === "node" || e === "view:node";
};
function nO() {
  if (cd(this))
    return null;
  let e = this.parent;
  for (; e && e.is("attributeElement"); ) {
    if (cd(e) > 1)
      return null;
    e = e.parent;
  }
  return !e || cd(e) > 1 ? null : this.childCount;
}
function cd(e) {
  return Array.from(e.getChildren()).filter((n) => !n.is("uiElement")).length;
}
class Gf extends cs {
  /**
  * Creates new instance of EmptyElement.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-emptyelement-cannot-add` when third parameter is passed,
  * to inform that usage of EmptyElement is incorrect (adding child nodes to EmptyElement is forbidden).
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#createEmptyElement
  * @internal
  * @param document The document instance to which this element belongs.
  * @param name Node name.
  * @param attrs Collection of attributes.
  * @param children A list of nodes to be inserted into created element.
  */
  constructor(n, t, i, r) {
    super(n, t, i, r), this.getFillerOffset = iO;
  }
  /**
  * Overrides {@link module:engine/view/element~Element#_insertChild} method.
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-emptyelement-cannot-add` to prevent
  * adding any child nodes to EmptyElement.
  *
  * @internal
  */
  _insertChild(n, t) {
    if (t && (t instanceof ls || Array.from(t).length > 0))
      throw new v("view-emptyelement-cannot-add", [
        this,
        t
      ]);
    return 0;
  }
}
Gf.prototype.is = function(e, n) {
  return n ? n === this.name && (e === "emptyElement" || e === "view:emptyElement" || e === "element" || e === "view:element") : e === "emptyElement" || e === "view:emptyElement" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === "element" || e === "view:element" || e === "node" || e === "view:node";
};
function iO() {
  return null;
}
class ic extends cs {
  /**
  * Creates new instance of UIElement.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-uielement-cannot-add` when third parameter is passed,
  * to inform that usage of UIElement is incorrect (adding child nodes to UIElement is forbidden).
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#createUIElement
  * @internal
  * @param document The document instance to which this element belongs.
  * @param name Node name.
  * @param attrs Collection of attributes.
  * @param children A list of nodes to be inserted into created element.
  */
  constructor(n, t, i, r) {
    super(n, t, i, r), this.getFillerOffset = sO;
  }
  /**
  * Overrides {@link module:engine/view/element~Element#_insertChild} method.
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-uielement-cannot-add` to prevent adding any child nodes
  * to UIElement.
  *
  * @internal
  */
  _insertChild(n, t) {
    if (t && (t instanceof ls || Array.from(t).length > 0))
      throw new v("view-uielement-cannot-add", [
        this,
        t
      ]);
    return 0;
  }
  /**
  * Renders this {@link module:engine/view/uielement~UIElement} to DOM. This method is called by
  * {@link module:engine/view/domconverter~DomConverter}.
  * Do not use inheritance to create custom rendering method, replace `render()` method instead:
  *
  * ```ts
  * const myUIElement = downcastWriter.createUIElement( 'span' );
  * myUIElement.render = function( domDocument, domConverter ) {
  * 	const domElement = this.toDomElement( domDocument );
  *
  * 	domConverter.setContentOf( domElement, '<b>this is ui element</b>' );
  *
  * 	return domElement;
  * };
  * ```
  *
  * If changes in your UI element should trigger some editor UI update you should call
  * the {@link module:ui/editorui/editorui~EditorUI#update `editor.ui.update()`} method
  * after rendering your UI element.
  *
  * @param domConverter Instance of the DomConverter used to optimize the output.
  */
  render(n, t) {
    return this.toDomElement(n);
  }
  /**
  * Creates DOM element based on this view UIElement.
  * Note that each time this method is called new DOM element is created.
  */
  toDomElement(n) {
    const t = n.createElement(this.name);
    for (const i of this.getAttributeKeys())
      t.setAttribute(i, this.getAttribute(i));
    return t;
  }
}
ic.prototype.is = function(e, n) {
  return n ? n === this.name && (e === "uiElement" || e === "view:uiElement" || e === "element" || e === "view:element") : e === "uiElement" || e === "view:uiElement" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === "element" || e === "view:element" || e === "node" || e === "view:node";
};
function rO(e) {
  e.document.on("arrowKey", (n, t) => oO(n, t, e.domConverter), {
    priority: "low"
  });
}
function sO() {
  return null;
}
function oO(e, n, t) {
  if (n.keyCode == ye.arrowright) {
    const i = n.domTarget.ownerDocument.defaultView.getSelection(), r = i.rangeCount == 1 && i.getRangeAt(0).collapsed;
    if (r || n.shiftKey) {
      const s = i.focusNode, o = i.focusOffset, a = t.domPositionToView(s, o);
      if (a === null)
        return;
      let u = !1;
      const l = a.getLastMatchingPosition((c) => (c.item.is("uiElement") && (u = !0), !!(c.item.is("uiElement") || c.item.is("attributeElement"))));
      if (u) {
        const c = t.viewPositionToDom(l);
        r ? i.collapse(c.parent, c.offset) : i.extend(c.parent, c.offset);
      }
    }
  }
}
class Qf extends cs {
  /**
  * Creates a new instance of a raw element.
  *
  * Throws the `view-rawelement-cannot-add` {@link module:utils/ckeditorerror~CKEditorError CKEditorError} when the `children`
  * parameter is passed to inform that the usage of `RawElement` is incorrect (adding child nodes to `RawElement` is forbidden).
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#createRawElement
  * @internal
  * @param document The document instance to which this element belongs.
  * @param name Node name.
  * @param attrs Collection of attributes.
  * @param children A list of nodes to be inserted into created element.
  */
  constructor(n, t, i, r) {
    super(n, t, i, r), this.getFillerOffset = aO;
  }
  /**
  * Overrides the {@link module:engine/view/element~Element#_insertChild} method.
  * Throws the `view-rawelement-cannot-add` {@link module:utils/ckeditorerror~CKEditorError CKEditorError} to prevent
  * adding any child nodes to a raw element.
  *
  * @internal
  */
  _insertChild(n, t) {
    if (t && (t instanceof ls || Array.from(t).length > 0))
      throw new v("view-rawelement-cannot-add", [
        this,
        t
      ]);
    return 0;
  }
  /**
  * This allows rendering the children of a {@link module:engine/view/rawelement~RawElement} on the DOM level.
  * This method is called by the {@link module:engine/view/domconverter~DomConverter} with the raw DOM element
  * passed as an argument, leaving the number and shape of the children up to the integrator.
  *
  * This method **must be defined** for the raw element to work:
  *
  * ```ts
  * const myRawElement = downcastWriter.createRawElement( 'div' );
  *
  * myRawElement.render = function( domElement, domConverter ) {
  * 	domConverter.setContentOf( domElement, '<b>This is the raw content of myRawElement.</b>' );
  * };
  * ```
  *
  * @param domElement The native DOM element representing the raw view element.
  * @param domConverter Instance of the DomConverter used to optimize the output.
  */
  render(n, t) {
  }
}
Qf.prototype.is = function(e, n) {
  return n ? n === this.name && (e === "rawElement" || e === "view:rawElement" || e === "element" || e === "view:element") : e === "rawElement" || e === "view:rawElement" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === this.name || e === "view:" + this.name || e === "element" || e === "view:element" || e === "node" || e === "view:node";
};
function aO() {
  return null;
}
let qs = class extends (/* @__PURE__ */ Je(us)) {
  /**
  * Creates new DocumentFragment instance.
  *
  * @internal
  * @param document The document to which this document fragment belongs.
  * @param children A list of nodes to be inserted into the created document fragment.
  */
  constructor(t, i) {
    super();
    /**
    * The document to which this document fragment belongs.
    */
    m(this, "document");
    /**
    * Array of child nodes.
    */
    m(this, "_children", []);
    /**
    * Map of custom properties.
    * Custom properties can be added to document fragment instance.
    */
    m(this, "_customProperties", /* @__PURE__ */ new Map());
    this.document = t, i && this._insertChild(0, i);
  }
  /**
  * Iterable interface.
  *
  * Iterates over nodes added to this document fragment.
  */
  [Symbol.iterator]() {
    return this._children[Symbol.iterator]();
  }
  /**
  * Number of child nodes in this document fragment.
  */
  get childCount() {
    return this._children.length;
  }
  /**
  * Is `true` if there are no nodes inside this document fragment, `false` otherwise.
  */
  get isEmpty() {
    return this.childCount === 0;
  }
  /**
  * Artificial root of `DocumentFragment`. Returns itself. Added for compatibility reasons.
  */
  get root() {
    return this;
  }
  /**
  * Artificial parent of `DocumentFragment`. Returns `null`. Added for compatibility reasons.
  */
  get parent() {
    return null;
  }
  /**
  * Artificial element name. Returns `undefined`. Added for compatibility reasons.
  */
  get name() {
  }
  /**
  * Artificial element getFillerOffset. Returns `undefined`. Added for compatibility reasons.
  */
  get getFillerOffset() {
  }
  /**
  * Returns the custom property value for the given key.
  */
  getCustomProperty(t) {
    return this._customProperties.get(t);
  }
  /**
  * Returns an iterator which iterates over this document fragment's custom properties.
  * Iterator provides `[ key, value ]` pairs for each stored property.
  */
  *getCustomProperties() {
    yield* this._customProperties.entries();
  }
  /**
  * {@link module:engine/view/documentfragment~DocumentFragment#_insertChild Insert} a child node or a list of child nodes at the end
  * and sets the parent of these nodes to this fragment.
  *
  * @internal
  * @param items Items to be inserted.
  * @returns Number of appended nodes.
  */
  _appendChild(t) {
    return this._insertChild(this.childCount, t);
  }
  /**
  * Gets child at the given index.
  *
  * @param index Index of child.
  * @returns Child node.
  */
  getChild(t) {
    return this._children[t];
  }
  /**
  * Gets index of the given child node. Returns `-1` if child node is not found.
  *
  * @param node Child node.
  * @returns Index of the child node.
  */
  getChildIndex(t) {
    return this._children.indexOf(t);
  }
  /**
  * Gets child nodes iterator.
  *
  * @returns Child nodes iterator.
  */
  getChildren() {
    return this._children[Symbol.iterator]();
  }
  /**
  * Inserts a child node or a list of child nodes on the given index and sets the parent of these nodes to
  * this fragment.
  *
  * @internal
  * @param index Position where nodes should be inserted.
  * @param items Items to be inserted.
  * @returns Number of inserted nodes.
  */
  _insertChild(t, i) {
    this._fireChange("children", this, {
      index: t
    });
    let r = 0;
    const s = uO(this.document, i);
    for (const o of s)
      o.parent !== null && o._remove(), o.parent = this, this._children.splice(t, 0, o), t++, r++;
    return r;
  }
  /**
  * Removes number of child nodes starting at the given index and set the parent of these nodes to `null`.
  *
  * @internal
  * @param index Number of the first node to remove.
  * @param howMany Number of nodes to remove.
  * @returns The array of removed nodes.
  */
  _removeChildren(t, i = 1) {
    this._fireChange("children", this, {
      index: t
    });
    for (let r = t; r < t + i; r++)
      this._children[r].parent = null;
    return this._children.splice(t, i);
  }
  /**
  * @internal
  * @param type Type of the change.
  * @param node Changed node.
  * @param data Additional data.
  * @fires module:engine/view/node~Node#event:change
  */
  _fireChange(t, i, r) {
    this.fire(`change:${t}`, i, r);
  }
  /**
  * Sets a custom property. They can be used to add special data to elements.
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#setCustomProperty
  * @internal
  */
  _setCustomProperty(t, i) {
    this._customProperties.set(t, i);
  }
  /**
  * Removes the custom property stored under the given key.
  *
  * @see module:engine/view/downcastwriter~DowncastWriter#removeCustomProperty
  * @internal
  * @returns Returns true if property was removed.
  */
  _removeCustomProperty(t) {
    return this._customProperties.delete(t);
  }
};
qs.prototype.is = function(e) {
  return e === "documentFragment" || e === "view:documentFragment";
};
function uO(e, n) {
  return typeof n == "string" ? [
    new Jt(e, n)
  ] : (Nn(n) || (n = [
    n
  ]), Array.from(n).map((t) => typeof t == "string" ? new Jt(e, t) : t instanceof Di ? new Jt(e, t.data) : t));
}
class KE {
  /**
  * @param document The view document instance.
  */
  constructor(n) {
    /**
    * The view document instance in which this writer operates.
    */
    m(this, "document");
    /**
    * Holds references to the attribute groups that share the same {@link module:engine/view/attributeelement~AttributeElement#id id}.
    * The keys are `id`s, the values are `Set`s holding {@link module:engine/view/attributeelement~AttributeElement}s.
    */
    m(this, "_cloneGroups", /* @__PURE__ */ new Map());
    /**
    * The slot factory used by the `elementToStructure` downcast helper.
    */
    m(this, "_slotFactory", null);
    this.document = n;
  }
  setSelection(...n) {
    this.document.selection._setTo(...n);
  }
  /**
  * Moves {@link module:engine/view/documentselection~DocumentSelection#focus selection's focus} to the specified location.
  *
  * The location can be specified in the same form as {@link module:engine/view/view~View#createPositionAt view.createPositionAt()}
  * parameters.
  *
  * @param Offset or one of the flags. Used only when the first parameter is a {@link module:engine/view/item~Item view item}.
  */
  setSelectionFocus(n, t) {
    this.document.selection._setFocus(n, t);
  }
  /**
  * Creates a new {@link module:engine/view/documentfragment~DocumentFragment} instance.
  *
  * @param children A list of nodes to be inserted into the created document fragment.
  * @returns The created document fragment.
  */
  createDocumentFragment(n) {
    return new qs(this.document, n);
  }
  /**
  * Creates a new {@link module:engine/view/text~Text text node}.
  *
  * ```ts
  * writer.createText( 'foo' );
  * ```
  *
  * @param data The text's data.
  * @returns The created text node.
  */
  createText(n) {
    return new Jt(this.document, n);
  }
  /**
  * Creates a new {@link module:engine/view/attributeelement~AttributeElement}.
  *
  * ```ts
  * writer.createAttributeElement( 'strong' );
  * writer.createAttributeElement( 'a', { href: 'foo.bar' } );
  *
  * // Make `<a>` element contain other attributes element so the `<a>` element is not broken.
  * writer.createAttributeElement( 'a', { href: 'foo.bar' }, { priority: 5 } );
  *
  * // Set `id` of a marker element so it is not joined or merged with "normal" elements.
  * writer.createAttributeElement( 'span', { class: 'my-marker' }, { id: 'marker:my' } );
  * ```
  *
  * @param name Name of the element.
  * @param attributes Element's attributes.
  * @param options Element's options.
  * @param options.priority Element's {@link module:engine/view/attributeelement~AttributeElement#priority priority}.
  * @param options.id Element's {@link module:engine/view/attributeelement~AttributeElement#id id}.
  * @param options.renderUnsafeAttributes A list of attribute names that should be rendered in the editing
  * pipeline even though they would normally be filtered out by unsafe attribute detection mechanisms.
  * @returns Created element.
  */
  createAttributeElement(n, t, i = {}) {
    const r = new Xr(this.document, n, t);
    return typeof i.priority == "number" && (r._priority = i.priority), i.id && (r._id = i.id), i.renderUnsafeAttributes && r._unsafeAttributesToRender.push(...i.renderUnsafeAttributes), r;
  }
  createContainerElement(n, t, i = {}, r = {}) {
    let s = null;
    Mi(i) ? r = i : s = i;
    const o = new Na(this.document, n, t, s);
    return r.renderUnsafeAttributes && o._unsafeAttributesToRender.push(...r.renderUnsafeAttributes), o;
  }
  /**
  * Creates a new {@link module:engine/view/editableelement~EditableElement}.
  *
  * ```ts
  * writer.createEditableElement( 'div' );
  * writer.createEditableElement( 'div', { id: 'foo-1234' } );
  * ```
  *
  * Note: The editable element is to be used in the editing pipeline. Usually, together with
  * {@link module:widget/utils~toWidgetEditable `toWidgetEditable()`}.
  *
  * @param name Name of the element.
  * @param attributes Elements attributes.
  * @param options Element's options.
  * @param options.renderUnsafeAttributes A list of attribute names that should be rendered in the editing
  * pipeline even though they would normally be filtered out by unsafe attribute detection mechanisms.
  * @returns Created element.
  */
  createEditableElement(n, t, i = {}) {
    const r = new nc(this.document, n, t);
    return i.renderUnsafeAttributes && r._unsafeAttributesToRender.push(...i.renderUnsafeAttributes), r;
  }
  /**
  * Creates a new {@link module:engine/view/emptyelement~EmptyElement}.
  *
  * ```ts
  * writer.createEmptyElement( 'img' );
  * writer.createEmptyElement( 'img', { id: 'foo-1234' } );
  * ```
  *
  * @param name Name of the element.
  * @param attributes Elements attributes.
  * @param options Element's options.
  * @param options.renderUnsafeAttributes A list of attribute names that should be rendered in the editing
  * pipeline even though they would normally be filtered out by unsafe attribute detection mechanisms.
  * @returns Created element.
  */
  createEmptyElement(n, t, i = {}) {
    const r = new Gf(this.document, n, t);
    return i.renderUnsafeAttributes && r._unsafeAttributesToRender.push(...i.renderUnsafeAttributes), r;
  }
  /**
  * Creates a new {@link module:engine/view/uielement~UIElement}.
  *
  * ```ts
  * writer.createUIElement( 'span' );
  * writer.createUIElement( 'span', { id: 'foo-1234' } );
  * ```
  *
  * A custom render function can be provided as the third parameter:
  *
  * ```ts
  * writer.createUIElement( 'span', null, function( domDocument ) {
  * 	const domElement = this.toDomElement( domDocument );
  * 	domElement.innerHTML = '<b>this is ui element</b>';
  *
  * 	return domElement;
  * } );
  * ```
  *
  * Unlike {@link #createRawElement raw elements}, UI elements are by no means editor content, for instance,
  * they are ignored by the editor selection system.
  *
  * You should not use UI elements as data containers. Check out {@link #createRawElement} instead.
  *
  * @param name The name of the element.
  * @param attributes Element attributes.
  * @param renderFunction A custom render function.
  * @returns The created element.
  */
  createUIElement(n, t, i) {
    const r = new ic(this.document, n, t);
    return i && (r.render = i), r;
  }
  /**
  * Creates a new {@link module:engine/view/rawelement~RawElement}.
  *
  * ```ts
  * writer.createRawElement( 'span', { id: 'foo-1234' }, function( domElement ) {
  * 	domElement.innerHTML = '<b>This is the raw content of the raw element.</b>';
  * } );
  * ```
  *
  * Raw elements work as data containers ("wrappers", "sandboxes") but their children are not managed or
  * even recognized by the editor. This encapsulation allows integrations to maintain custom DOM structures
  * in the editor content without, for instance, worrying about compatibility with other editor features.
  * Raw elements are a perfect tool for integration with external frameworks and data sources.
  *
  * Unlike {@link #createUIElement UI elements}, raw elements act like "real" editor content (similar to
  * {@link module:engine/view/containerelement~ContainerElement} or {@link module:engine/view/emptyelement~EmptyElement}),
  * and they are considered by the editor selection.
  *
  * You should not use raw elements to render the UI in the editor content. Check out {@link #createUIElement `#createUIElement()`}
  * instead.
  *
  * @param name The name of the element.
  * @param attributes Element attributes.
  * @param renderFunction A custom render function.
  * @param options Element's options.
  * @param options.renderUnsafeAttributes A list of attribute names that should be rendered in the editing
  * pipeline even though they would normally be filtered out by unsafe attribute detection mechanisms.
  * @returns The created element.
  */
  createRawElement(n, t, i, r = {}) {
    const s = new Qf(this.document, n, t);
    return i && (s.render = i), r.renderUnsafeAttributes && s._unsafeAttributesToRender.push(...r.renderUnsafeAttributes), s;
  }
  setAttribute(n, t, i, r) {
    r !== void 0 ? r._setAttribute(n, t, i) : i._setAttribute(n, t);
  }
  removeAttribute(n, t, i) {
    i !== void 0 ? i._removeAttribute(n, t) : t._removeAttribute(n);
  }
  /**
  * Adds specified class to the element.
  *
  * ```ts
  * writer.addClass( 'foo', linkElement );
  * writer.addClass( [ 'foo', 'bar' ], linkElement );
  * ```
  */
  addClass(n, t) {
    t._addClass(n);
  }
  /**
  * Removes specified class from the element.
  *
  * ```ts
  * writer.removeClass( 'foo', linkElement );
  * writer.removeClass( [ 'foo', 'bar' ], linkElement );
  * ```
  */
  removeClass(n, t) {
    t._removeClass(n);
  }
  setStyle(n, t, i) {
    Mi(n) && i === void 0 ? t._setStyle(n) : i._setStyle(n, t);
  }
  /**
  * Removes specified style from the element.
  *
  * ```ts
  * writer.removeStyle( 'color', element ); // Removes 'color' style.
  * writer.removeStyle( [ 'color', 'border-top' ], element ); // Removes both 'color' and 'border-top' styles.
  * ```
  *
  * **Note**: This method can work with normalized style names if
  * {@link module:engine/controller/datacontroller~DataController#addStyleProcessorRules a particular style processor rule is enabled}.
  * See {@link module:engine/view/stylesmap~StylesMap#remove `StylesMap#remove()`} for details.
  */
  removeStyle(n, t) {
    t._removeStyle(n);
  }
  /**
  * Sets a custom property on element. Unlike attributes, custom properties are not rendered to the DOM,
  * so they can be used to add special data to elements.
  */
  setCustomProperty(n, t, i) {
    i._setCustomProperty(n, t);
  }
  /**
  * Removes a custom property stored under the given key.
  *
  * @returns Returns true if property was removed.
  */
  removeCustomProperty(n, t) {
    return t._removeCustomProperty(n);
  }
  /**
  * Breaks attribute elements at the provided position or at the boundaries of a provided range. It breaks attribute elements
  * up to their first ancestor that is a container element.
  *
  * In following examples `<p>` is a container, `<b>` and `<u>` are attribute elements:
  *
  * ```html
  * <p>foo<b><u>bar{}</u></b></p> -> <p>foo<b><u>bar</u></b>[]</p>
  * <p>foo<b><u>{}bar</u></b></p> -> <p>foo{}<b><u>bar</u></b></p>
  * <p>foo<b><u>b{}ar</u></b></p> -> <p>foo<b><u>b</u></b>[]<b><u>ar</u></b></p>
  * <p><b>fo{o</b><u>ba}r</u></p> -> <p><b>fo</b><b>o</b><u>ba</u><u>r</u></b></p>
  * ```
  *
  * **Note:** {@link module:engine/view/documentfragment~DocumentFragment DocumentFragment} is treated like a container.
  *
  * **Note:** The difference between {@link module:engine/view/downcastwriter~DowncastWriter#breakAttributes breakAttributes()} and
  * {@link module:engine/view/downcastwriter~DowncastWriter#breakContainer breakContainer()} is that `breakAttributes()` breaks all
  * {@link module:engine/view/attributeelement~AttributeElement attribute elements} that are ancestors of a given `position`,
  * up to the first encountered {@link module:engine/view/containerelement~ContainerElement container element}.
  * `breakContainer()` assumes that a given `position` is directly in the container element and breaks that container element.
  *
  * Throws the `view-writer-invalid-range-container` {@link module:utils/ckeditorerror~CKEditorError CKEditorError}
  * when the {@link module:engine/view/range~Range#start start}
  * and {@link module:engine/view/range~Range#end end} positions of a passed range are not placed inside same parent container.
  *
  * Throws the `view-writer-cannot-break-empty-element` {@link module:utils/ckeditorerror~CKEditorError CKEditorError}
  * when trying to break attributes inside an {@link module:engine/view/emptyelement~EmptyElement EmptyElement}.
  *
  * Throws the `view-writer-cannot-break-ui-element` {@link module:utils/ckeditorerror~CKEditorError CKEditorError}
  * when trying to break attributes inside a {@link module:engine/view/uielement~UIElement UIElement}.
  *
  * @see module:engine/view/attributeelement~AttributeElement
  * @see module:engine/view/containerelement~ContainerElement
  * @see module:engine/view/downcastwriter~DowncastWriter#breakContainer
  * @param positionOrRange The position where to break attribute elements.
  * @returns The new position or range, after breaking the attribute elements.
  */
  breakAttributes(n) {
    return n instanceof ne ? this._breakAttributes(n) : this._breakAttributesRange(n);
  }
  /**
  * Breaks a {@link module:engine/view/containerelement~ContainerElement container view element} into two, at the given position.
  * The position has to be directly inside the container element and cannot be in the root. It does not break the conrainer view element
  * if the position is at the beginning or at the end of its parent element.
  *
  * ```html
  * <p>foo^bar</p> -> <p>foo</p><p>bar</p>
  * <div><p>foo</p>^<p>bar</p></div> -> <div><p>foo</p></div><div><p>bar</p></div>
  * <p>^foobar</p> -> ^<p>foobar</p>
  * <p>foobar^</p> -> <p>foobar</p>^
  * ```
  *
  * **Note:** The difference between {@link module:engine/view/downcastwriter~DowncastWriter#breakAttributes breakAttributes()} and
  * {@link module:engine/view/downcastwriter~DowncastWriter#breakContainer breakContainer()} is that `breakAttributes()` breaks all
  * {@link module:engine/view/attributeelement~AttributeElement attribute elements} that are ancestors of a given `position`,
  * up to the first encountered {@link module:engine/view/containerelement~ContainerElement container element}.
  * `breakContainer()` assumes that the given `position` is directly in the container element and breaks that container element.
  *
  * @see module:engine/view/attributeelement~AttributeElement
  * @see module:engine/view/containerelement~ContainerElement
  * @see module:engine/view/downcastwriter~DowncastWriter#breakAttributes
  * @param position The position where to break the element.
  * @returns The position between broken elements. If an element has not been broken,
  * the returned position is placed either before or after it.
  */
  breakContainer(n) {
    const t = n.parent;
    if (!t.is("containerElement"))
      throw new v("view-writer-break-non-container-element", this.document);
    if (!t.parent)
      throw new v("view-writer-break-root", this.document);
    if (n.isAtStart)
      return ne._createBefore(t);
    if (!n.isAtEnd) {
      const i = t._clone(!1);
      this.insert(ne._createAfter(t), i);
      const r = new Re(n, ne._createAt(t, "end")), s = new ne(i, 0);
      this.move(r, s);
    }
    return ne._createAfter(t);
  }
  /**
  * Merges {@link module:engine/view/attributeelement~AttributeElement attribute elements}. It also merges text nodes if needed.
  * Only {@link module:engine/view/attributeelement~AttributeElement#isSimilar similar} attribute elements can be merged.
  *
  * In following examples `<p>` is a container and `<b>` is an attribute element:
  *
  * ```html
  * <p>foo[]bar</p> -> <p>foo{}bar</p>
  * <p><b>foo</b>[]<b>bar</b></p> -> <p><b>foo{}bar</b></p>
  * <p><b foo="bar">a</b>[]<b foo="baz">b</b></p> -> <p><b foo="bar">a</b>[]<b foo="baz">b</b></p>
  * ```
  *
  * It will also take care about empty attributes when merging:
  *
  * ```html
  * <p><b>[]</b></p> -> <p>[]</p>
  * <p><b>foo</b><i>[]</i><b>bar</b></p> -> <p><b>foo{}bar</b></p>
  * ```
  *
  * **Note:** Difference between {@link module:engine/view/downcastwriter~DowncastWriter#mergeAttributes mergeAttributes} and
  * {@link module:engine/view/downcastwriter~DowncastWriter#mergeContainers mergeContainers} is that `mergeAttributes` merges two
  * {@link module:engine/view/attributeelement~AttributeElement attribute elements} or {@link module:engine/view/text~Text text nodes}
  * while `mergeContainer` merges two {@link module:engine/view/containerelement~ContainerElement container elements}.
  *
  * @see module:engine/view/attributeelement~AttributeElement
  * @see module:engine/view/containerelement~ContainerElement
  * @see module:engine/view/downcastwriter~DowncastWriter#mergeContainers
  * @param position Merge position.
  * @returns Position after merge.
  */
  mergeAttributes(n) {
    const t = n.offset, i = n.parent;
    if (i.is("$text"))
      return n;
    if (i.is("attributeElement") && i.childCount === 0) {
      const o = i.parent, a = i.index;
      return i._remove(), this._removeFromClonedElementsGroup(i), this.mergeAttributes(new ne(o, a));
    }
    const r = i.getChild(t - 1), s = i.getChild(t);
    if (!r || !s)
      return n;
    if (r.is("$text") && s.is("$text"))
      return _p(r, s);
    if (r.is("attributeElement") && s.is("attributeElement") && r.isSimilar(s)) {
      const o = r.childCount;
      return r._appendChild(s.getChildren()), s._remove(), this._removeFromClonedElementsGroup(s), this.mergeAttributes(new ne(r, o));
    }
    return n;
  }
  /**
  * Merges two {@link module:engine/view/containerelement~ContainerElement container elements} that are before and after given position.
  * Precisely, the element after the position is removed and it's contents are moved to element before the position.
  *
  * ```html
  * <p>foo</p>^<p>bar</p> -> <p>foo^bar</p>
  * <div>foo</div>^<p>bar</p> -> <div>foo^bar</div>
  * ```
  *
  * **Note:** Difference between {@link module:engine/view/downcastwriter~DowncastWriter#mergeAttributes mergeAttributes} and
  * {@link module:engine/view/downcastwriter~DowncastWriter#mergeContainers mergeContainers} is that `mergeAttributes` merges two
  * {@link module:engine/view/attributeelement~AttributeElement attribute elements} or {@link module:engine/view/text~Text text nodes}
  * while `mergeContainer` merges two {@link module:engine/view/containerelement~ContainerElement container elements}.
  *
  * @see module:engine/view/attributeelement~AttributeElement
  * @see module:engine/view/containerelement~ContainerElement
  * @see module:engine/view/downcastwriter~DowncastWriter#mergeAttributes
  * @param position Merge position.
  * @returns Position after merge.
  */
  mergeContainers(n) {
    const t = n.nodeBefore, i = n.nodeAfter;
    if (!t || !i || !t.is("containerElement") || !i.is("containerElement"))
      throw new v("view-writer-merge-containers-invalid-position", this.document);
    const r = t.getChild(t.childCount - 1), s = r instanceof Jt ? ne._createAt(r, "end") : ne._createAt(t, "end");
    return this.move(Re._createIn(i), ne._createAt(t, "end")), this.remove(Re._createOn(i)), s;
  }
  /**
  * Inserts a node or nodes at specified position. Takes care about breaking attributes before insertion
  * and merging them afterwards.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-writer-insert-invalid-node` when nodes to insert
  * contains instances that are not {@link module:engine/view/text~Text Texts},
  * {@link module:engine/view/attributeelement~AttributeElement AttributeElements},
  * {@link module:engine/view/containerelement~ContainerElement ContainerElements},
  * {@link module:engine/view/emptyelement~EmptyElement EmptyElements},
  * {@link module:engine/view/rawelement~RawElement RawElements} or
  * {@link module:engine/view/uielement~UIElement UIElements}.
  *
  * @param position Insertion position.
  * @param nodes Node or nodes to insert.
  * @returns Range around inserted nodes.
  */
  insert(n, t) {
    t = Nn(t) ? [
      ...t
    ] : [
      t
    ], GE(t, this.document);
    const i = t.reduce((o, a) => {
      const u = o[o.length - 1], l = !a.is("uiElement");
      return !u || u.breakAttributes != l ? o.push({
        breakAttributes: l,
        nodes: [
          a
        ]
      }) : u.nodes.push(a), o;
    }, []);
    let r = null, s = n;
    for (const { nodes: o, breakAttributes: a } of i) {
      const u = this._insertNodes(s, o, a);
      r || (r = u.start), s = u.end;
    }
    return r ? new Re(r, s) : new Re(n);
  }
  /**
  * Removes provided range from the container.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-writer-invalid-range-container` when
  * {@link module:engine/view/range~Range#start start} and {@link module:engine/view/range~Range#end end} positions are not placed inside
  * same parent container.
  *
  * @param rangeOrItem Range to remove from container
  * or an {@link module:engine/view/item~Item item} to remove. If range is provided, after removing, it will be updated
  * to a collapsed range showing the new position.
  * @returns Document fragment containing removed nodes.
  */
  remove(n) {
    const t = n instanceof Re ? n : Re._createOn(n);
    if (Ro(t, this.document), t.isCollapsed)
      return new qs(this.document);
    const { start: i, end: r } = this._breakAttributesRange(t, !0), s = i.parent, o = r.offset - i.offset, a = s._removeChildren(i.offset, o);
    for (const l of a)
      this._removeFromClonedElementsGroup(l);
    const u = this.mergeAttributes(i);
    return t.start = u, t.end = u.clone(), new qs(this.document, a);
  }
  /**
  * Removes matching elements from given range.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-writer-invalid-range-container` when
  * {@link module:engine/view/range~Range#start start} and {@link module:engine/view/range~Range#end end} positions are not placed inside
  * same parent container.
  *
  * @param range Range to clear.
  * @param element Element to remove.
  */
  clear(n, t) {
    Ro(n, this.document);
    const i = n.getWalker({
      direction: "backward",
      ignoreElementEnd: !0
    });
    for (const r of i) {
      const s = r.item;
      let o;
      if (s.is("element") && t.isSimilar(s))
        o = Re._createOn(s);
      else if (!r.nextPosition.isAfter(n.start) && s.is("$textProxy")) {
        const a = s.getAncestors().find((u) => u.is("element") && t.isSimilar(u));
        a && (o = Re._createIn(a));
      }
      o && (o.end.isAfter(n.end) && (o.end = n.end), o.start.isBefore(n.start) && (o.start = n.start), this.remove(o));
    }
  }
  /**
  * Moves nodes from provided range to target position.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-writer-invalid-range-container` when
  * {@link module:engine/view/range~Range#start start} and {@link module:engine/view/range~Range#end end} positions are not placed inside
  * same parent container.
  *
  * @param sourceRange Range containing nodes to move.
  * @param targetPosition Position to insert.
  * @returns Range in target container. Inserted nodes are placed between
  * {@link module:engine/view/range~Range#start start} and {@link module:engine/view/range~Range#end end} positions.
  */
  move(n, t) {
    let i;
    if (t.isAfter(n.end)) {
      t = this._breakAttributes(t, !0);
      const r = t.parent, s = r.childCount;
      n = this._breakAttributesRange(n, !0), i = this.remove(n), t.offset += r.childCount - s;
    } else
      i = this.remove(n);
    return this.insert(t, i);
  }
  /**
  * Wraps elements within range with provided {@link module:engine/view/attributeelement~AttributeElement AttributeElement}.
  * If a collapsed range is provided, it will be wrapped only if it is equal to view selection.
  *
  * If a collapsed range was passed and is same as selection, the selection
  * will be moved to the inside of the wrapped attribute element.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError} `view-writer-invalid-range-container`
  * when {@link module:engine/view/range~Range#start}
  * and {@link module:engine/view/range~Range#end} positions are not placed inside same parent container.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError} `view-writer-wrap-invalid-attribute` when passed attribute element is not
  * an instance of {@link module:engine/view/attributeelement~AttributeElement AttributeElement}.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError} `view-writer-wrap-nonselection-collapsed-range` when passed range
  * is collapsed and different than view selection.
  *
  * @param range Range to wrap.
  * @param attribute Attribute element to use as wrapper.
  * @returns range Range after wrapping, spanning over wrapping attribute element.
  */
  wrap(n, t) {
    if (!(t instanceof Xr))
      throw new v("view-writer-wrap-invalid-attribute", this.document);
    if (Ro(n, this.document), n.isCollapsed) {
      let i = n.start;
      i.parent.is("element") && !lO(i.parent) && (i = i.getLastMatchingPosition((s) => s.item.is("uiElement"))), i = this._wrapPosition(i, t);
      const r = this.document.selection;
      return r.isCollapsed && r.getFirstPosition().isEqual(n.start) && this.setSelection(i), new Re(i);
    } else
      return this._wrapRange(n, t);
  }
  /**
  * Unwraps nodes within provided range from attribute element.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-writer-invalid-range-container` when
  * {@link module:engine/view/range~Range#start start} and {@link module:engine/view/range~Range#end end} positions are not placed inside
  * same parent container.
  */
  unwrap(n, t) {
    if (!(t instanceof Xr))
      throw new v("view-writer-unwrap-invalid-attribute", this.document);
    if (Ro(n, this.document), n.isCollapsed)
      return n;
    const { start: i, end: r } = this._breakAttributesRange(n, !0), s = i.parent, o = this._unwrapChildren(s, i.offset, r.offset, t), a = this.mergeAttributes(o.start);
    a.isEqual(o.start) || o.end.offset--;
    const u = this.mergeAttributes(o.end);
    return new Re(a, u);
  }
  /**
  * Renames element by creating a copy of renamed element but with changed name and then moving contents of the
  * old element to the new one. Keep in mind that this will invalidate all {@link module:engine/view/position~Position positions} which
  * has renamed element as {@link module:engine/view/position~Position#parent a parent}.
  *
  * New element has to be created because `Element#tagName` property in DOM is readonly.
  *
  * Since this function creates a new element and removes the given one, the new element is returned to keep reference.
  *
  * @param newName New name for element.
  * @param viewElement Element to be renamed.
  * @returns Element created due to rename.
  */
  rename(n, t) {
    const i = new Na(this.document, n, t.getAttributes());
    return this.insert(ne._createAfter(t), i), this.move(Re._createIn(t), ne._createAt(i, 0)), this.remove(Re._createOn(t)), i;
  }
  /**
  * Cleans up memory by removing obsolete cloned elements group from the writer.
  *
  * Should be used whenever all {@link module:engine/view/attributeelement~AttributeElement attribute elements}
  * with the same {@link module:engine/view/attributeelement~AttributeElement#id id} are going to be removed from the view and
  * the group will no longer be needed.
  *
  * Cloned elements group are not removed automatically in case if the group is still needed after all its elements
  * were removed from the view.
  *
  * Keep in mind that group names are equal to the `id` property of the attribute element.
  *
  * @param groupName Name of the group to clear.
  */
  clearClonedElementsGroup(n) {
    this._cloneGroups.delete(n);
  }
  /**
  * Creates position at the given location. The location can be specified as:
  *
  * * a {@link module:engine/view/position~Position position},
  * * parent element and offset (offset defaults to `0`),
  * * parent element and `'end'` (sets position at the end of that element),
  * * {@link module:engine/view/item~Item view item} and `'before'` or `'after'` (sets position before or after given view item).
  *
  * This method is a shortcut to other constructors such as:
  *
  * * {@link #createPositionBefore},
  * * {@link #createPositionAfter},
  *
  * @param offset Offset or one of the flags. Used only when the first parameter is a {@link module:engine/view/item~Item view item}.
  */
  createPositionAt(n, t) {
    return ne._createAt(n, t);
  }
  /**
  * Creates a new position after given view item.
  *
  * @param item View item after which the position should be located.
  */
  createPositionAfter(n) {
    return ne._createAfter(n);
  }
  /**
  * Creates a new position before given view item.
  *
  * @param item View item before which the position should be located.
  */
  createPositionBefore(n) {
    return ne._createBefore(n);
  }
  /**
  * Creates a range spanning from `start` position to `end` position.
  *
  * **Note:** This factory method creates its own {@link module:engine/view/position~Position} instances basing on passed values.
  *
  * @param start Start position.
  * @param end End position. If not set, range will be collapsed at `start` position.
  */
  createRange(n, t) {
    return new Re(n, t);
  }
  /**
  * Creates a range that starts before given {@link module:engine/view/item~Item view item} and ends after it.
  */
  createRangeOn(n) {
    return Re._createOn(n);
  }
  /**
  * Creates a range inside an {@link module:engine/view/element~Element element} which starts before the first child of
  * that element and ends after the last child of that element.
  *
  * @param element Element which is a parent for the range.
  */
  createRangeIn(n) {
    return Re._createIn(n);
  }
  createSelection(...n) {
    return new gr(...n);
  }
  /**
  * Creates placeholders for child elements of the {@link module:engine/conversion/downcasthelpers~DowncastHelpers#elementToStructure
  * `elementToStructure()`} conversion helper.
  *
  * ```ts
  * const viewSlot = conversionApi.writer.createSlot();
  * const viewPosition = conversionApi.writer.createPositionAt( viewElement, 0 );
  *
  * conversionApi.writer.insert( viewPosition, viewSlot );
  * ```
  *
  * It could be filtered down to a specific subset of children (only `<foo>` model elements in this case):
  *
  * ```ts
  * const viewSlot = conversionApi.writer.createSlot( node => node.is( 'element', 'foo' ) );
  * const viewPosition = conversionApi.writer.createPositionAt( viewElement, 0 );
  *
  * conversionApi.writer.insert( viewPosition, viewSlot );
  * ```
  *
  * While providing a filtered slot, make sure to provide slots for all child nodes. A single node can not be downcasted into
  * multiple slots.
  *
  * **Note**: You should not change the order of nodes. View elements should be in the same order as model nodes.
  *
  * @param modeOrFilter The filter for child nodes.
  * @returns The slot element to be placed in to the view structure while processing
  * {@link module:engine/conversion/downcasthelpers~DowncastHelpers#elementToStructure `elementToStructure()`}.
  */
  createSlot(n = "children") {
    if (!this._slotFactory)
      throw new v("view-writer-invalid-create-slot-context", this.document);
    return this._slotFactory(this, n);
  }
  /**
  * Registers a slot factory.
  *
  * @internal
  * @param slotFactory The slot factory.
  */
  _registerSlotFactory(n) {
    this._slotFactory = n;
  }
  /**
  * Clears the registered slot factory.
  *
  * @internal
  */
  _clearSlotFactory() {
    this._slotFactory = null;
  }
  /**
  * Inserts a node or nodes at the specified position. Takes care of breaking attributes before insertion
  * and merging them afterwards if requested by the breakAttributes param.
  *
  * @param position Insertion position.
  * @param nodes Node or nodes to insert.
  * @param breakAttributes Whether attributes should be broken.
  * @returns Range around inserted nodes.
  */
  _insertNodes(n, t, i) {
    let r;
    if (i ? r = vh(n) : r = n.parent.is("$text") ? n.parent.parent : n.parent, !r)
      throw new v("view-writer-invalid-position-container", this.document);
    let s;
    i ? s = this._breakAttributes(n, !0) : s = n.parent.is("$text") ? dd(n) : n;
    const o = r._insertChild(s.offset, t);
    for (const c of t)
      this._addToClonedElementsGroup(c);
    const a = s.getShiftedBy(o), u = this.mergeAttributes(s);
    u.isEqual(s) || a.offset--;
    const l = this.mergeAttributes(a);
    return new Re(u, l);
  }
  /**
  * Wraps children with provided `wrapElement`. Only children contained in `parent` element between
  * `startOffset` and `endOffset` will be wrapped.
  */
  _wrapChildren(n, t, i, r) {
    let s = t;
    const o = [];
    for (; s < i; ) {
      const u = n.getChild(s), l = u.is("$text"), c = u.is("attributeElement");
      if (c && u._canMergeAttributesFrom(r))
        u._mergeAttributesFrom(r), o.push(new ne(n, s));
      else if (l || !c || cO(r, u)) {
        const d = r._clone();
        u._remove(), d._appendChild(u), n._insertChild(s, d), this._addToClonedElementsGroup(d), o.push(new ne(n, s));
      } else
        this._wrapChildren(u, 0, u.childCount, r);
      s++;
    }
    let a = 0;
    for (const u of o) {
      if (u.offset -= a, u.offset == t)
        continue;
      this.mergeAttributes(u).isEqual(u) || (a++, i--);
    }
    return Re._createFromParentsAndOffsets(n, t, n, i);
  }
  /**
  * Unwraps children from provided `unwrapElement`. Only children contained in `parent` element between
  * `startOffset` and `endOffset` will be unwrapped.
  */
  _unwrapChildren(n, t, i, r) {
    let s = t;
    const o = [];
    for (; s < i; ) {
      const u = n.getChild(s);
      if (!u.is("attributeElement")) {
        s++;
        continue;
      }
      if (u.isSimilar(r)) {
        const l = u.getChildren(), c = u.childCount;
        u._remove(), n._insertChild(s, l), this._removeFromClonedElementsGroup(u), o.push(new ne(n, s), new ne(n, s + c)), s += c, i += c - 1;
        continue;
      }
      if (u._canSubtractAttributesOf(r)) {
        u._subtractAttributesOf(r), o.push(new ne(n, s), new ne(n, s + 1)), s++;
        continue;
      }
      this._unwrapChildren(u, 0, u.childCount, r), s++;
    }
    let a = 0;
    for (const u of o) {
      if (u.offset -= a, u.offset == t || u.offset == i)
        continue;
      this.mergeAttributes(u).isEqual(u) || (a++, i--);
    }
    return Re._createFromParentsAndOffsets(n, t, n, i);
  }
  /**
  * Helper function for `view.writer.wrap`. Wraps range with provided attribute element.
  * This method will also merge newly added attribute element with its siblings whenever possible.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError} `view-writer-wrap-invalid-attribute` when passed attribute element is not
  * an instance of {@link module:engine/view/attributeelement~AttributeElement AttributeElement}.
  *
  * @returns New range after wrapping, spanning over wrapping attribute element.
  */
  _wrapRange(n, t) {
    const { start: i, end: r } = this._breakAttributesRange(n, !0), s = i.parent, o = this._wrapChildren(s, i.offset, r.offset, t), a = this.mergeAttributes(o.start);
    a.isEqual(o.start) || o.end.offset--;
    const u = this.mergeAttributes(o.end);
    return new Re(a, u);
  }
  /**
  * Helper function for {@link #wrap}. Wraps position with provided attribute element.
  * This method will also merge newly added attribute element with its siblings whenever possible.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError} `view-writer-wrap-invalid-attribute` when passed attribute element is not
  * an instance of {@link module:engine/view/attributeelement~AttributeElement AttributeElement}.
  *
  * @returns New position after wrapping.
  */
  _wrapPosition(n, t) {
    if (t.isSimilar(n.parent))
      return bp(n.clone());
    n.parent.is("$text") && (n = dd(n));
    const i = this.createAttributeElement("_wrapPosition-fake-element");
    i._priority = Number.POSITIVE_INFINITY, i.isSimilar = () => !1, n.parent._insertChild(n.offset, i);
    const r = new Re(n, n.getShiftedBy(1));
    this.wrap(r, t);
    const s = new ne(i.parent, i.index);
    i._remove();
    const o = s.nodeBefore, a = s.nodeAfter;
    return o && o.is("view:$text") && a && a.is("view:$text") ? _p(o, a) : bp(s);
  }
  /**
  * Helper function used by other `DowncastWriter` methods. Breaks attribute elements at the boundaries of given range.
  *
  * @param range Range which `start` and `end` positions will be used to break attributes.
  * @param forceSplitText If set to `true`, will break text nodes even if they are directly in container element.
  * This behavior will result in incorrect view state, but is needed by other view writing methods which then fixes view state.
  * @returns New range with located at break positions.
  */
  _breakAttributesRange(n, t = !1) {
    const i = n.start, r = n.end;
    if (Ro(n, this.document), n.isCollapsed) {
      const u = this._breakAttributes(n.start, t);
      return new Re(u, u);
    }
    const s = this._breakAttributes(r, t), o = s.parent.childCount, a = this._breakAttributes(i, t);
    return s.offset += s.parent.childCount - o, new Re(a, s);
  }
  /**
  * Helper function used by other `DowncastWriter` methods. Breaks attribute elements at given position.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-writer-cannot-break-empty-element` when break position
  * is placed inside {@link module:engine/view/emptyelement~EmptyElement EmptyElement}.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-writer-cannot-break-ui-element` when break position
  * is placed inside {@link module:engine/view/uielement~UIElement UIElement}.
  *
  * @param position Position where to break attributes.
  * @param forceSplitText If set to `true`, will break text nodes even if they are directly in container element.
  * This behavior will result in incorrect view state, but is needed by other view writing methods which then fixes view state.
  * @returns New position after breaking the attributes.
  */
  _breakAttributes(n, t = !1) {
    const i = n.offset, r = n.parent;
    if (n.parent.is("emptyElement"))
      throw new v("view-writer-cannot-break-empty-element", this.document);
    if (n.parent.is("uiElement"))
      throw new v("view-writer-cannot-break-ui-element", this.document);
    if (n.parent.is("rawElement"))
      throw new v("view-writer-cannot-break-raw-element", this.document);
    if (!t && r.is("$text") && Ph(r.parent) || Ph(r))
      return n.clone();
    if (r.is("$text"))
      return this._breakAttributes(dd(n), t);
    const s = r.childCount;
    if (i == s) {
      const o = new ne(r.parent, r.index + 1);
      return this._breakAttributes(o, t);
    } else if (i === 0) {
      const o = new ne(r.parent, r.index);
      return this._breakAttributes(o, t);
    } else {
      const o = r.index + 1, a = r._clone();
      r.parent._insertChild(o, a), this._addToClonedElementsGroup(a);
      const u = r.childCount - i, l = r._removeChildren(i, u);
      a._appendChild(l);
      const c = new ne(r.parent, o);
      return this._breakAttributes(c, t);
    }
  }
  /**
  * Stores the information that an {@link module:engine/view/attributeelement~AttributeElement attribute element} was
  * added to the tree. Saves the reference to the group in the given element and updates the group, so other elements
  * from the group now keep a reference to the given attribute element.
  *
  * The clones group can be obtained using {@link module:engine/view/attributeelement~AttributeElement#getElementsWithSameId}.
  *
  * Does nothing if added element has no {@link module:engine/view/attributeelement~AttributeElement#id id}.
  *
  * @param element Attribute element to save.
  */
  _addToClonedElementsGroup(n) {
    if (!n.root.is("rootElement"))
      return;
    if (n.is("element"))
      for (const r of n.getChildren())
        this._addToClonedElementsGroup(r);
    const t = n.id;
    if (!t)
      return;
    let i = this._cloneGroups.get(t);
    i || (i = /* @__PURE__ */ new Set(), this._cloneGroups.set(t, i)), i.add(n), n._clonesGroup = i;
  }
  /**
  * Removes all the information about the given {@link module:engine/view/attributeelement~AttributeElement attribute element}
  * from its clones group.
  *
  * Keep in mind, that the element will still keep a reference to the group (but the group will not keep a reference to it).
  * This allows to reference the whole group even if the element was already removed from the tree.
  *
  * Does nothing if the element has no {@link module:engine/view/attributeelement~AttributeElement#id id}.
  *
  * @param element Attribute element to remove.
  */
  _removeFromClonedElementsGroup(n) {
    if (n.is("element"))
      for (const r of n.getChildren())
        this._removeFromClonedElementsGroup(r);
    const t = n.id;
    if (!t)
      return;
    const i = this._cloneGroups.get(t);
    i && i.delete(n);
  }
}
function lO(e) {
  return Array.from(e.getChildren()).some((n) => !n.is("uiElement"));
}
function vh(e) {
  let n = e.parent;
  for (; !Ph(n); ) {
    if (!n)
      return;
    n = n.parent;
  }
  return n;
}
function cO(e, n) {
  return e.priority < n.priority ? !0 : e.priority > n.priority ? !1 : e.getIdentity() < n.getIdentity();
}
function bp(e) {
  const n = e.nodeBefore;
  if (n && n.is("$text"))
    return new ne(n, n.data.length);
  const t = e.nodeAfter;
  return t && t.is("$text") ? new ne(t, 0) : e;
}
function dd(e) {
  if (e.offset == e.parent.data.length)
    return new ne(e.parent.parent, e.parent.index + 1);
  if (e.offset === 0)
    return new ne(e.parent.parent, e.parent.index);
  const n = e.parent.data.slice(e.offset);
  return e.parent._data = e.parent.data.slice(0, e.offset), e.parent.parent._insertChild(e.parent.index + 1, new Jt(e.root.document, n)), new ne(e.parent.parent, e.parent.index + 1);
}
function _p(e, n) {
  const t = e.data.length;
  return e._data += n.data, n._remove(), new ne(e, t);
}
const dO = [
  Jt,
  Xr,
  Na,
  Gf,
  Qf,
  ic
];
function GE(e, n) {
  for (const t of e) {
    if (!dO.some((i) => t instanceof i))
      throw new v("view-writer-insert-invalid-node-type", n);
    t.is("$text") || GE(t.getChildren(), n);
  }
}
function Ph(e) {
  return e && (e.is("containerElement") || e.is("documentFragment"));
}
function Ro(e, n) {
  const t = vh(e.start), i = vh(e.end);
  if (!t || !i || t !== i)
    throw new v("view-writer-invalid-range-container", n);
}
const QE = (e) => e.createTextNode(" "), XE = (e) => {
  const n = e.createElement("span");
  return n.dataset.ckeFiller = "true", n.innerText = " ", n;
}, JE = (e) => {
  const n = e.createElement("br");
  return n.dataset.ckeFiller = "true", n;
}, ni = 7, Ra = "⁠".repeat(ni);
function kn(e) {
  return typeof e == "string" ? e.substr(0, ni) === Ra : mt(e) && e.data.substr(0, ni) === Ra;
}
function Hs(e) {
  return e.data.length == ni && kn(e);
}
function Ep(e) {
  const n = typeof e == "string" ? e : e.data;
  return kn(e) ? n.slice(ni) : n;
}
function hO(e) {
  e.document.on("arrowKey", fO, {
    priority: "low"
  });
}
function fO(e, n) {
  if (n.keyCode == ye.arrowleft) {
    const t = n.domTarget.ownerDocument.defaultView.getSelection();
    if (t.rangeCount == 1 && t.getRangeAt(0).collapsed) {
      const i = t.getRangeAt(0).startContainer, r = t.getRangeAt(0).startOffset;
      kn(i) && r <= ni && t.collapse(i, 0);
    }
  }
}
class mO extends (/* @__PURE__ */ pt()) {
  /**
  * Creates a renderer instance.
  *
  * @param domConverter Converter instance.
  * @param selection View selection.
  */
  constructor(t, i) {
    super();
    /**
    * Set of DOM Documents instances.
    */
    m(this, "domDocuments", /* @__PURE__ */ new Set());
    /**
    * Converter instance.
    */
    m(this, "domConverter");
    /**
    * Set of nodes which attributes changed and may need to be rendered.
    */
    m(this, "markedAttributes", /* @__PURE__ */ new Set());
    /**
    * Set of elements which child lists changed and may need to be rendered.
    */
    m(this, "markedChildren", /* @__PURE__ */ new Set());
    /**
    * Set of text nodes which text data changed and may need to be rendered.
    */
    m(this, "markedTexts", /* @__PURE__ */ new Set());
    /**
    * View selection. Renderer updates DOM selection based on the view selection.
    */
    m(this, "selection");
    /**
    * The text node in which the inline filler was rendered.
    */
    m(this, "_inlineFiller", null);
    /**
    * DOM element containing fake selection.
    */
    m(this, "_fakeSelectionContainer", null);
    this.domConverter = t, this.selection = i, this.set("isFocused", !1), this.set("isSelecting", !1), this.set("isComposing", !1), he.isBlink && !he.isAndroid && this.on("change:isSelecting", () => {
      this.isSelecting || this.render();
    });
  }
  /**
  * Marks a view node to be updated in the DOM by {@link #render `render()`}.
  *
  * Note that only view nodes whose parents have corresponding DOM elements need to be marked to be synchronized.
  *
  * @see #markedAttributes
  * @see #markedChildren
  * @see #markedTexts
  *
  * @param type Type of the change.
  * @param node ViewNode to be marked.
  */
  markToSync(t, i) {
    if (t === "text")
      this.domConverter.mapViewToDom(i.parent) && this.markedTexts.add(i);
    else {
      if (!this.domConverter.mapViewToDom(i))
        return;
      if (t === "attributes")
        this.markedAttributes.add(i);
      else if (t === "children")
        this.markedChildren.add(i);
      else
        throw new v("view-renderer-unknown-type", this);
    }
  }
  /**
  * Renders all buffered changes ({@link #markedAttributes}, {@link #markedChildren} and {@link #markedTexts}) and
  * the current view selection (if needed) to the DOM by applying a minimal set of changes to it.
  *
  * Renderer tries not to break the text composition (e.g. IME) and x-index of the selection,
  * so it does as little as it is needed to update the DOM.
  *
  * Renderer also handles {@link module:engine/view/filler fillers}. Especially, it checks if the inline filler is needed
  * at the selection position and adds or removes it. To prevent breaking text composition inline filler will not be
  * removed as long as the selection is in the text node which needed it at first.
  */
  render() {
    if (this.isComposing && !he.isAndroid)
      return;
    let t = null;
    const i = he.isBlink && !he.isAndroid ? !this.isSelecting : !0;
    for (const r of this.markedChildren)
      this._updateChildrenMappings(r);
    i ? (this._inlineFiller && !this._isSelectionInInlineFiller() && this._removeInlineFiller(), this._inlineFiller ? t = this._getInlineFillerPosition() : this._needsInlineFillerAtSelection() && (t = this.selection.getFirstPosition(), this.markedChildren.add(t.parent))) : this._inlineFiller && this._inlineFiller.parentNode && (t = this.domConverter.domPositionToView(this._inlineFiller), t && t.parent.is("$text") && (t = ne._createBefore(t.parent)));
    for (const r of this.markedAttributes)
      this._updateAttrs(r);
    for (const r of this.markedChildren)
      this._updateChildren(r, {
        inlineFillerPosition: t
      });
    for (const r of this.markedTexts)
      !this.markedChildren.has(r.parent) && this.domConverter.mapViewToDom(r.parent) && this._updateText(r, {
        inlineFillerPosition: t
      });
    if (i)
      if (t) {
        const r = this.domConverter.viewPositionToDom(t), s = r.parent.ownerDocument;
        kn(r.parent) ? this._inlineFiller = r.parent : this._inlineFiller = Tp(s, r.parent, r.offset);
      } else
        this._inlineFiller = null;
    this._updateFocus(), this._updateSelection(), this.domConverter._clearTemporaryCustomProperties(), this.markedTexts.clear(), this.markedAttributes.clear(), this.markedChildren.clear();
  }
  /**
  * Updates mappings of view element's children.
  *
  * Children that were replaced in the view structure by similar elements (same tag name) are treated as 'replaced'.
  * This means that their mappings can be updated so the new view elements are mapped to the existing DOM elements.
  * Thanks to that these elements do not need to be re-rendered completely.
  *
  * @param viewElement The view element whose children mappings will be updated.
  */
  _updateChildrenMappings(t) {
    const i = this.domConverter.mapViewToDom(t);
    if (!i)
      return;
    const r = Array.from(i.childNodes), s = Array.from(this.domConverter.viewChildrenToDom(t, {
      withChildren: !1
    })), o = this._diffNodeLists(r, s), a = this._findUpdateActions(o, r, s, gO);
    if (a.indexOf("update") !== -1) {
      const u = {
        equal: 0,
        insert: 0,
        delete: 0
      };
      for (const l of a)
        if (l === "update") {
          const c = u.equal + u.insert, d = u.equal + u.delete, p = t.getChild(c);
          p && !p.is("uiElement") && !p.is("rawElement") && this._updateElementMappings(p, r[d]), sp(s[c]), u.equal++;
        } else
          u[l]++;
    }
  }
  /**
  * Updates mappings of a given view element.
  *
  * @param viewElement The view element whose mappings will be updated.
  * @param domElement The DOM element representing the given view element.
  */
  _updateElementMappings(t, i) {
    this.domConverter.unbindDomElement(i), this.domConverter.bindElements(i, t), this.markedChildren.add(t), this.markedAttributes.add(t);
  }
  /**
  * Gets the position of the inline filler based on the current selection.
  * Here, we assume that we know that the filler is needed and
  * {@link #_isSelectionInInlineFiller is at the selection position}, and, since it is needed,
  * it is somewhere at the selection position.
  *
  * Note: The filler position cannot be restored based on the filler's DOM text node, because
  * when this method is called (before rendering), the bindings will often be broken. View-to-DOM
  * bindings are only dependable after rendering.
  */
  _getInlineFillerPosition() {
    const t = this.selection.getFirstPosition();
    return t.parent.is("$text") ? ne._createBefore(t.parent) : t;
  }
  /**
  * Returns `true` if the selection has not left the inline filler's text node.
  * If it is `true`, it means that the filler had been added for a reason and the selection did not
  * leave the filler's text node. For example, the user can be in the middle of a composition so it should not be touched.
  *
  * @returns `true` if the inline filler and selection are in the same place.
  */
  _isSelectionInInlineFiller() {
    if (this.selection.rangeCount != 1 || !this.selection.isCollapsed)
      return !1;
    const t = this.selection.getFirstPosition(), i = this.domConverter.viewPositionToDom(t);
    return !!(i && mt(i.parent) && kn(i.parent));
  }
  /**
  * Removes the inline filler.
  */
  _removeInlineFiller() {
    const t = this._inlineFiller;
    if (!kn(t))
      throw new v("view-renderer-filler-was-lost", this);
    Hs(t) ? t.remove() : t.data = t.data.substr(ni), this._inlineFiller = null;
  }
  /**
  * Checks if the inline {@link module:engine/view/filler filler} should be added.
  *
  * @returns `true` if the inline filler should be added.
  */
  _needsInlineFillerAtSelection() {
    if (this.selection.rangeCount != 1 || !this.selection.isCollapsed)
      return !1;
    const t = this.selection.getFirstPosition(), i = t.parent, r = t.offset;
    if (!this.domConverter.mapViewToDom(i.root) || !i.is("element") || !pO(i))
      return !1;
    const s = t.nodeBefore, o = t.nodeAfter;
    return !(s instanceof Jt || o instanceof Jt || r === i.getFillerOffset() && (!s || !s.is("element", "br")) || he.isAndroid && (s || o));
  }
  /**
  * Checks if text needs to be updated and possibly updates it.
  *
  * @param viewText View text to update.
  * @param options.inlineFillerPosition The position where the inline filler should be rendered.
  */
  _updateText(t, i) {
    const r = this.domConverter.findCorrespondingDomText(t);
    let o = this.domConverter.viewToDom(t).data;
    const a = i.inlineFillerPosition;
    a && a.parent == t.parent && a.offset == t.index && (o = Ra + o), this._updateTextNode(r, o);
  }
  /**
  * Checks if attribute list needs to be updated and possibly updates it.
  *
  * @param viewElement The view element to update.
  */
  _updateAttrs(t) {
    const i = this.domConverter.mapViewToDom(t);
    if (i) {
      for (const r of Array.from(i.attributes)) {
        const s = r.name;
        t.hasAttribute(s) || this.domConverter.removeDomElementAttribute(i, s);
      }
      for (const r of t.getAttributeKeys())
        this.domConverter.setDomElementAttribute(i, r, t.getAttribute(r), t);
    }
  }
  /**
  * Checks if elements child list needs to be updated and possibly updates it.
  *
  * Note that on Android, to reduce the risk of composition breaks, it tries to update data of an existing
  * child text nodes instead of replacing them completely.
  *
  * @param viewElement View element to update.
  * @param options.inlineFillerPosition The position where the inline filler should be rendered.
  */
  _updateChildren(t, i) {
    const r = this.domConverter.mapViewToDom(t);
    if (!r)
      return;
    if (he.isAndroid) {
      let p = null;
      for (const g of Array.from(r.childNodes)) {
        if (p && mt(p) && mt(g)) {
          r.normalize();
          break;
        }
        p = g;
      }
    }
    const s = i.inlineFillerPosition, o = r.childNodes, a = Array.from(this.domConverter.viewChildrenToDom(t, {
      bind: !0
    }));
    s && s.parent === t && Tp(r.ownerDocument, a, s.offset);
    const u = this._diffNodeLists(o, a), l = this._findUpdateActions(u, o, a, bO);
    let c = 0;
    const d = /* @__PURE__ */ new Set();
    for (const p of l)
      p === "delete" ? (d.add(o[c]), sp(o[c])) : (p === "equal" || p === "update") && c++;
    c = 0;
    for (const p of l)
      p === "insert" ? (DE(r, c, a[c]), c++) : p === "update" ? (this._updateTextNode(o[c], a[c].data), c++) : p === "equal" && (this._markDescendantTextToSync(this.domConverter.domToView(a[c])), c++);
    for (const p of d)
      p.parentNode || this.domConverter.unbindDomElement(p);
  }
  /**
  * Shorthand for diffing two arrays or node lists of DOM nodes.
  *
  * @param actualDomChildren Actual DOM children
  * @param expectedDomChildren Expected DOM children.
  * @returns The list of actions based on the {@link module:utils/diff~diff} function.
  */
  _diffNodeLists(t, i) {
    return t = TO(t, this._fakeSelectionContainer), na(t, i, _O.bind(null, this.domConverter));
  }
  /**
  * Finds DOM nodes that were replaced with the similar nodes (same tag name) in the view. All nodes are compared
  * within one `insert`/`delete` action group, for example:
  *
  * ```
  * Actual DOM:		<p><b>Foo</b>Bar<i>Baz</i><b>Bax</b></p>
  * Expected DOM:	<p>Bar<b>123</b><i>Baz</i><b>456</b></p>
  * Input actions:	[ insert, insert, delete, delete, equal, insert, delete ]
  * Output actions:	[ insert, replace, delete, equal, replace ]
  * ```
  *
  * @param actions Actions array which is a result of the {@link module:utils/diff~diff} function.
  * @param actualDom Actual DOM children
  * @param expectedDom Expected DOM children.
  * @param comparator A comparator function that should return `true` if the given node should be reused
  * (either by the update of a text node data or an element children list for similar elements).
  * @returns Actions array modified with the `update` actions.
  */
  _findUpdateActions(t, i, r, s) {
    if (t.indexOf("insert") === -1 || t.indexOf("delete") === -1)
      return t;
    let o = [], a = [], u = [];
    const l = {
      equal: 0,
      insert: 0,
      delete: 0
    };
    for (const c of t)
      c === "insert" ? u.push(r[l.equal + l.insert]) : c === "delete" ? a.push(i[l.equal + l.delete]) : (o = o.concat(na(a, u, s).map((d) => d === "equal" ? "update" : d)), o.push("equal"), a = [], u = []), l[c]++;
    return o.concat(na(a, u, s).map((c) => c === "equal" ? "update" : c));
  }
  /**
  * Checks if text needs to be updated and possibly updates it by removing and inserting only parts
  * of the data from the existing text node to reduce impact on the IME composition.
  *
  * @param domText DOM text node to update.
  * @param expectedText The expected data of a text node.
  */
  _updateTextNode(t, i) {
    const r = t.data;
    r != i && (he.isAndroid && this.isComposing && r.replace(/\u00A0/g, " ") == i.replace(/\u00A0/g, " ") || this._updateTextNodeInternal(t, i));
  }
  /**
  * Part of the `_updateTextNode` method extracted for easier testing.
  */
  _updateTextNodeInternal(t, i) {
    const r = TE(t.data, i);
    for (const s of r)
      s.type === "insert" ? t.insertData(s.index, s.values.join("")) : t.deleteData(s.index, s.howMany);
  }
  /**
  * Marks text nodes to be synchronized.
  *
  * If a text node is passed, it will be marked. If an element is passed, all descendant text nodes inside it will be marked.
  *
  * @param viewNode View node to sync.
  */
  _markDescendantTextToSync(t) {
    if (t) {
      if (t.is("$text"))
        this.markedTexts.add(t);
      else if (t.is("element"))
        for (const i of t.getChildren())
          this._markDescendantTextToSync(i);
    }
  }
  /**
  * Checks if the selection needs to be updated and possibly updates it.
  */
  _updateSelection() {
    if (he.isBlink && !he.isAndroid && this.isSelecting && !this.markedChildren.size)
      return;
    if (this.selection.rangeCount === 0) {
      this._removeDomSelection(), this._removeFakeSelection();
      return;
    }
    const t = this.domConverter.mapViewToDom(this.selection.editableElement);
    !this.isFocused || !t || (this.selection.isFake ? this._updateFakeSelection(t) : this._fakeSelectionContainer && this._fakeSelectionContainer.isConnected ? (this._removeFakeSelection(), this._updateDomSelection(t)) : this.isComposing && he.isAndroid || this._updateDomSelection(t));
  }
  /**
  * Updates the fake selection.
  *
  * @param domRoot A valid DOM root where the fake selection container should be added.
  */
  _updateFakeSelection(t) {
    const i = t.ownerDocument;
    this._fakeSelectionContainer || (this._fakeSelectionContainer = yO(i));
    const r = this._fakeSelectionContainer;
    if (this.domConverter.bindFakeSelection(r, this.selection), !this._fakeSelectionNeedsUpdate(t))
      return;
    (!r.parentElement || r.parentElement != t) && t.appendChild(r), r.textContent = this.selection.fakeSelectionLabel || " ";
    const s = i.getSelection(), o = i.createRange();
    s.removeAllRanges(), o.selectNodeContents(r), s.addRange(o);
  }
  /**
  * Updates the DOM selection.
  *
  * @param domRoot A valid DOM root where the DOM selection should be rendered.
  */
  _updateDomSelection(t) {
    const i = t.ownerDocument.defaultView.getSelection();
    if (!this._domSelectionNeedsUpdate(i))
      return;
    const r = this.domConverter.viewPositionToDom(this.selection.anchor), s = this.domConverter.viewPositionToDom(this.selection.focus);
    i.setBaseAndExtent(r.parent, r.offset, s.parent, s.offset), he.isGecko && EO(s, i);
  }
  /**
  * Checks whether a given DOM selection needs to be updated.
  *
  * @param domSelection The DOM selection to check.
  */
  _domSelectionNeedsUpdate(t) {
    if (!this.domConverter.isDomSelectionCorrect(t))
      return !0;
    const i = t && this.domConverter.domSelectionToView(t);
    return !(i && this.selection.isEqual(i) || !this.selection.isCollapsed && this.selection.isSimilar(i));
  }
  /**
  * Checks whether the fake selection needs to be updated.
  *
  * @param domRoot A valid DOM root where a new fake selection container should be added.
  */
  _fakeSelectionNeedsUpdate(t) {
    const i = this._fakeSelectionContainer, r = t.ownerDocument.getSelection();
    return !i || i.parentElement !== t || r.anchorNode !== i && !i.contains(r.anchorNode) ? !0 : i.textContent !== this.selection.fakeSelectionLabel;
  }
  /**
  * Removes the DOM selection.
  */
  _removeDomSelection() {
    for (const t of this.domDocuments) {
      const i = t.getSelection();
      if (i.rangeCount) {
        const r = t.activeElement, s = this.domConverter.mapDomToView(r);
        r && s && i.removeAllRanges();
      }
    }
  }
  /**
  * Removes the fake selection.
  */
  _removeFakeSelection() {
    const t = this._fakeSelectionContainer;
    t && t.remove();
  }
  /**
  * Checks if focus needs to be updated and possibly updates it.
  */
  _updateFocus() {
    if (this.isFocused) {
      const t = this.selection.editableElement;
      t && this.domConverter.focus(t);
    }
  }
}
function pO(e) {
  if (e.getAttribute("contenteditable") == "false")
    return !1;
  const n = e.findAncestor((t) => t.hasAttribute("contenteditable"));
  return !n || n.getAttribute("contenteditable") == "true";
}
function Tp(e, n, t) {
  const i = n instanceof Array ? n : n.childNodes, r = i[t];
  if (mt(r))
    return r.data = Ra + r.data, r;
  {
    const s = e.createTextNode(Ra);
    return Array.isArray(n) ? i.splice(t, 0, s) : DE(n, t, s), s;
  }
}
function gO(e, n) {
  return Tr(e) && Tr(n) && !mt(e) && !mt(n) && !sa(e) && !sa(n) && e.tagName.toLowerCase() === n.tagName.toLowerCase();
}
function bO(e, n) {
  return Tr(e) && Tr(n) && mt(e) && mt(n);
}
function _O(e, n, t) {
  return n === t ? !0 : mt(n) && mt(t) ? n.data === t.data : !!(e.isBlockFiller(n) && e.isBlockFiller(t));
}
function EO(e, n) {
  let t = e.parent, i = e.offset;
  if (mt(t) && Hs(t) && (i = Qo(t) + 1, t = t.parentNode), t.nodeType != Node.ELEMENT_NODE || i != t.childNodes.length - 1)
    return;
  const r = t.childNodes[i];
  r && r.tagName == "BR" && n.addRange(n.getRangeAt(0));
}
function TO(e, n) {
  const t = Array.from(e);
  return t.length == 0 || !n || t[t.length - 1] == n && t.pop(), t;
}
function yO(e) {
  const n = e.createElement("div");
  return n.className = "ck-fake-selection-container", Object.assign(n.style, {
    position: "fixed",
    top: 0,
    left: "-9999px",
    // See https://github.com/ckeditor/ckeditor5/issues/752.
    width: "42px"
  }), n.textContent = " ", n;
}
const wO = JE(ue.document), AO = QE(ue.document), CO = XE(ue.document), Su = "data-ck-unsafe-attribute-", yp = "data-ck-unsafe-element";
class ZE {
  /**
  * Creates a DOM converter.
  *
  * @param document The view document instance.
  * @param options An object with configuration options.
  * @param options.blockFillerMode The type of the block filler to use.
  * Default value depends on the options.renderingMode:
  *  'nbsp' when options.renderingMode == 'data',
  *  'br' when options.renderingMode == 'editing'.
  * @param options.renderingMode Whether to leave the View-to-DOM conversion result unchanged
  * or improve editing experience by filtering out interactive data.
  */
  constructor(n, { blockFillerMode: t, renderingMode: i = "editing" } = {}) {
    m(this, "document");
    /**
    * Whether to leave the View-to-DOM conversion result unchanged or improve editing experience by filtering out interactive data.
    */
    m(this, "renderingMode");
    /**
    * The mode of a block filler used by the DOM converter.
    */
    m(this, "blockFillerMode");
    /**
    * Elements which are considered pre-formatted elements.
    */
    m(this, "preElements");
    /**
    * Elements which are considered block elements (and hence should be filled with a
    * {@link #isBlockFiller block filler}).
    *
    * Whether an element is considered a block element also affects handling of trailing whitespaces.
    *
    * You can extend this array if you introduce support for block elements which are not yet recognized here.
    */
    m(this, "blockElements");
    /**
    * A list of elements that exist inline (in text) but their inner structure cannot be edited because
    * of the way they are rendered by the browser. They are mostly HTML form elements but there are other
    * elements such as `<img>` or `<iframe>` that also have non-editable children or no children whatsoever.
    *
    * Whether an element is considered an inline object has an impact on white space rendering (trimming)
    * around (and inside of it). In short, white spaces in text nodes next to inline objects are not trimmed.
    *
    * You can extend this array if you introduce support for inline object elements which are not yet recognized here.
    */
    m(this, "inlineObjectElements");
    /**
    * A list of elements which may affect the editing experience. To avoid this, those elements are replaced with
    * `<span data-ck-unsafe-element="[element name]"></span>` while rendering in the editing mode.
    */
    m(this, "unsafeElements");
    /**
    * The DOM Document used to create DOM nodes.
    */
    m(this, "_domDocument");
    /**
    * The DOM-to-view mapping.
    */
    m(this, "_domToViewMapping", /* @__PURE__ */ new WeakMap());
    /**
    * The view-to-DOM mapping.
    */
    m(this, "_viewToDomMapping", /* @__PURE__ */ new WeakMap());
    /**
    * Holds the mapping between fake selection containers and corresponding view selections.
    */
    m(this, "_fakeSelectionMapping", /* @__PURE__ */ new WeakMap());
    /**
    * Matcher for view elements whose content should be treated as raw data
    * and not processed during the conversion from DOM nodes to view elements.
    */
    m(this, "_rawContentElementMatcher", new Oa());
    /**
    * Matcher for inline object view elements. This is an extension of a simple {@link #inlineObjectElements} array of element names.
    */
    m(this, "_inlineObjectElementMatcher", new Oa());
    /**
    * Set of elements with temporary custom properties that require clearing after render.
    */
    m(this, "_elementsWithTemporaryCustomProperties", /* @__PURE__ */ new Set());
    this.document = n, this.renderingMode = i, this.blockFillerMode = t || (i === "editing" ? "br" : "nbsp"), this.preElements = [
      "pre",
      "textarea"
    ], this.blockElements = [
      "address",
      "article",
      "aside",
      "blockquote",
      "caption",
      "center",
      "dd",
      "details",
      "dir",
      "div",
      "dl",
      "dt",
      "fieldset",
      "figcaption",
      "figure",
      "footer",
      "form",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "header",
      "hgroup",
      "legend",
      "li",
      "main",
      "menu",
      "nav",
      "ol",
      "p",
      "pre",
      "section",
      "summary",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr",
      "ul"
    ], this.inlineObjectElements = [
      "object",
      "iframe",
      "input",
      "button",
      "textarea",
      "select",
      "option",
      "video",
      "embed",
      "audio",
      "img",
      "canvas"
    ], this.unsafeElements = [
      "script",
      "style"
    ], this._domDocument = this.renderingMode === "editing" ? ue.document : ue.document.implementation.createHTMLDocument("");
  }
  /**
  * Binds a given DOM element that represents fake selection to a **position** of a
  * {@link module:engine/view/documentselection~DocumentSelection document selection}.
  * Document selection copy is stored and can be retrieved by the
  * {@link module:engine/view/domconverter~DomConverter#fakeSelectionToView} method.
  */
  bindFakeSelection(n, t) {
    this._fakeSelectionMapping.set(n, new gr(t));
  }
  /**
  * Returns a {@link module:engine/view/selection~Selection view selection} instance corresponding to a given
  * DOM element that represents fake selection. Returns `undefined` if binding to the given DOM element does not exist.
  */
  fakeSelectionToView(n) {
    return this._fakeSelectionMapping.get(n);
  }
  /**
  * Binds DOM and view elements, so it will be possible to get corresponding elements using
  * {@link module:engine/view/domconverter~DomConverter#mapDomToView} and
  * {@link module:engine/view/domconverter~DomConverter#mapViewToDom}.
  *
  * @param domElement The DOM element to bind.
  * @param viewElement The view element to bind.
  */
  bindElements(n, t) {
    this._domToViewMapping.set(n, t), this._viewToDomMapping.set(t, n);
  }
  /**
  * Unbinds a given DOM element from the view element it was bound to. Unbinding is deep, meaning that all children of
  * the DOM element will be unbound too.
  *
  * @param domElement The DOM element to unbind.
  */
  unbindDomElement(n) {
    const t = this._domToViewMapping.get(n);
    if (t) {
      this._domToViewMapping.delete(n), this._viewToDomMapping.delete(t);
      for (const i of n.children)
        this.unbindDomElement(i);
    }
  }
  /**
  * Binds DOM and view document fragments, so it will be possible to get corresponding document fragments using
  * {@link module:engine/view/domconverter~DomConverter#mapDomToView} and
  * {@link module:engine/view/domconverter~DomConverter#mapViewToDom}.
  *
  * @param domFragment The DOM document fragment to bind.
  * @param viewFragment The view document fragment to bind.
  */
  bindDocumentFragments(n, t) {
    this._domToViewMapping.set(n, t), this._viewToDomMapping.set(t, n);
  }
  /**
  * Decides whether a given pair of attribute key and value should be passed further down the pipeline.
  *
  * @param elementName Element name in lower case.
  */
  shouldRenderAttribute(n, t, i) {
    return this.renderingMode === "data" ? !0 : (n = n.toLowerCase(), n.startsWith("on") || n === "srcdoc" && t.match(/\bon\S+\s*=|javascript:|<\s*\/*script/i) ? !1 : i === "img" && (n === "src" || n === "srcset") || i === "source" && n === "srcset" ? !0 : !t.match(/^\s*(javascript:|data:(image\/svg|text\/x?html))/i));
  }
  /**
  * Set `domElement`'s content using provided `html` argument. Apply necessary filtering for the editing pipeline.
  *
  * @param domElement DOM element that should have `html` set as its content.
  * @param html Textual representation of the HTML that will be set on `domElement`.
  */
  setContentOf(n, t) {
    if (this.renderingMode === "data") {
      n.innerHTML = t;
      return;
    }
    const i = new DOMParser().parseFromString(t, "text/html"), r = i.createDocumentFragment(), s = i.body.childNodes;
    for (; s.length > 0; )
      r.appendChild(s[0]);
    const o = i.createTreeWalker(r, NodeFilter.SHOW_ELEMENT), a = [];
    let u;
    for (; u = o.nextNode(); )
      a.push(u);
    for (const l of a) {
      for (const d of l.getAttributeNames())
        this.setDomElementAttribute(l, d, l.getAttribute(d));
      const c = l.tagName.toLowerCase();
      this._shouldRenameElement(c) && (kp(c), l.replaceWith(this._createReplacementDomElement(c, l)));
    }
    for (; n.firstChild; )
      n.firstChild.remove();
    n.append(r);
  }
  /**
  * Converts the view to the DOM. For all text nodes, not bound elements and document fragments new items will
  * be created. For bound elements and document fragments the method will return corresponding items.
  *
  * @param viewNode View node or document fragment to transform.
  * @param options Conversion options.
  * @param options.bind Determines whether new elements will be bound.
  * @param options.withChildren If `false`, node's and document fragment's children will not be converted.
  * @returns Converted node or DocumentFragment.
  */
  viewToDom(n, t = {}) {
    if (n.is("$text")) {
      const i = this._processDataFromViewText(n);
      return this._domDocument.createTextNode(i);
    } else {
      const i = n;
      if (this.mapViewToDom(i))
        if (i.getCustomProperty("editingPipeline:doNotReuseOnce"))
          this._elementsWithTemporaryCustomProperties.add(i);
        else
          return this.mapViewToDom(i);
      let r;
      if (i.is("documentFragment"))
        r = this._domDocument.createDocumentFragment(), t.bind && this.bindDocumentFragments(r, i);
      else {
        if (i.is("uiElement"))
          return i.name === "$comment" ? r = this._domDocument.createComment(i.getCustomProperty("$rawContent")) : r = i.render(this._domDocument, this), t.bind && this.bindElements(r, i), r;
        this._shouldRenameElement(i.name) ? (kp(i.name), r = this._createReplacementDomElement(i.name)) : i.hasAttribute("xmlns") ? r = this._domDocument.createElementNS(i.getAttribute("xmlns"), i.name) : r = this._domDocument.createElement(i.name), i.is("rawElement") && i.render(r, this), t.bind && this.bindElements(r, i);
        for (const s of i.getAttributeKeys())
          this.setDomElementAttribute(r, s, i.getAttribute(s), i);
      }
      if (t.withChildren !== !1)
        for (const s of this.viewChildrenToDom(i, t))
          r instanceof HTMLTemplateElement ? r.content.appendChild(s) : r.appendChild(s);
      return r;
    }
  }
  /**
  * Sets the attribute on a DOM element.
  *
  * **Note**: To remove the attribute, use {@link #removeDomElementAttribute}.
  *
  * @param domElement The DOM element the attribute should be set on.
  * @param key The name of the attribute.
  * @param value The value of the attribute.
  * @param relatedViewElement The view element related to the `domElement` (if there is any).
  * It helps decide whether the attribute set is unsafe. For instance, view elements created via the
  * {@link module:engine/view/downcastwriter~DowncastWriter} methods can allow certain attributes that would normally be filtered out.
  */
  setDomElementAttribute(n, t, i, r) {
    const s = this.shouldRenderAttribute(t, i, n.tagName.toLowerCase()) || r && r.shouldRenderUnsafeAttribute(t);
    if (s || at("domconverter-unsafe-attribute-detected", {
      domElement: n,
      key: t,
      value: i
    }), !uP(t)) {
      at("domconverter-invalid-attribute-detected", {
        domElement: n,
        key: t,
        value: i
      });
      return;
    }
    n.hasAttribute(t) && !s ? n.removeAttribute(t) : n.hasAttribute(Su + t) && s && n.removeAttribute(Su + t), n.setAttribute(s ? t : Su + t, i);
  }
  /**
  * Removes an attribute from a DOM element.
  *
  * **Note**: To set the attribute, use {@link #setDomElementAttribute}.
  *
  * @param domElement The DOM element the attribute should be removed from.
  * @param key The name of the attribute.
  */
  removeDomElementAttribute(n, t) {
    t != yp && (n.removeAttribute(t), n.removeAttribute(Su + t));
  }
  /**
  * Converts children of the view element to DOM using the
  * {@link module:engine/view/domconverter~DomConverter#viewToDom} method.
  * Additionally, this method adds block {@link module:engine/view/filler filler} to the list of children, if needed.
  *
  * @param viewElement Parent view element.
  * @param options See {@link module:engine/view/domconverter~DomConverter#viewToDom} options parameter.
  * @returns DOM nodes.
  */
  *viewChildrenToDom(n, t = {}) {
    const i = n.getFillerOffset && n.getFillerOffset();
    let r = 0;
    for (const s of n.getChildren()) {
      i === r && (yield this._getBlockFiller());
      const o = s.is("element") && !!s.getCustomProperty("dataPipeline:transparentRendering") && !zn(s.getAttributes());
      if (o && this.renderingMode == "data")
        if (s.is("rawElement")) {
          const a = this._domDocument.createElement(s.name);
          s.render(a, this), yield* [
            ...a.childNodes
          ];
        } else
          yield* this.viewChildrenToDom(s, t);
      else
        o && at("domconverter-transparent-rendering-unsupported-in-editing-pipeline", {
          viewElement: s
        }), yield this.viewToDom(s, t);
      r++;
    }
    i === r && (yield this._getBlockFiller());
  }
  /**
  * Converts view {@link module:engine/view/range~Range} to DOM range.
  * Inline and block {@link module:engine/view/filler fillers} are handled during the conversion.
  *
  * @param viewRange View range.
  * @returns DOM range.
  */
  viewRangeToDom(n) {
    const t = this.viewPositionToDom(n.start), i = this.viewPositionToDom(n.end), r = this._domDocument.createRange();
    return r.setStart(t.parent, t.offset), r.setEnd(i.parent, i.offset), r;
  }
  /**
  * Converts view {@link module:engine/view/position~Position} to DOM parent and offset.
  *
  * Inline and block {@link module:engine/view/filler fillers} are handled during the conversion.
  * If the converted position is directly before inline filler it is moved inside the filler.
  *
  * @param viewPosition View position.
  * @returns DOM position or `null` if view position could not be converted to DOM.
  * DOM position has two properties:
  * * `parent` - DOM position parent.
  * * `offset` - DOM position offset.
  */
  viewPositionToDom(n) {
    const t = n.parent;
    if (t.is("$text")) {
      const i = this.findCorrespondingDomText(t);
      if (!i)
        return null;
      let r = n.offset;
      return kn(i) && (r += ni), {
        parent: i,
        offset: r
      };
    } else {
      let i, r, s;
      if (n.offset === 0) {
        if (i = this.mapViewToDom(t), !i)
          return null;
        s = i.childNodes[0];
      } else {
        const a = n.nodeBefore;
        if (r = a.is("$text") ? this.findCorrespondingDomText(a) : this.mapViewToDom(a), !r)
          return null;
        i = r.parentNode, s = r.nextSibling;
      }
      if (mt(s) && kn(s))
        return {
          parent: s,
          offset: ni
        };
      const o = r ? Qo(r) + 1 : 0;
      return {
        parent: i,
        offset: o
      };
    }
  }
  /**
  * Converts DOM to view. For all text nodes, not bound elements and document fragments new items will
  * be created. For bound elements and document fragments function will return corresponding items. For
  * {@link module:engine/view/filler fillers} `null` will be returned.
  * For all DOM elements rendered by {@link module:engine/view/uielement~UIElement} that UIElement will be returned.
  *
  * @param domNode DOM node or document fragment to transform.
  * @param options Conversion options.
  * @param options.bind Determines whether new elements will be bound. False by default.
  * @param options.withChildren If `true`, node's and document fragment's children will be converted too. True by default.
  * @param options.keepOriginalCase If `false`, node's tag name will be converted to lower case. False by default.
  * @param options.skipComments If `false`, comment nodes will be converted to `$comment`
  * {@link module:engine/view/uielement~UIElement view UI elements}. False by default.
  * @returns Converted node or document fragment or `null` if DOM node is a {@link module:engine/view/filler filler}
  * or the given node is an empty text node.
  */
  domToView(n, t = {}) {
    const i = [], r = this._domToView(n, t, i), s = r.next().value;
    return !s || (r.next(), this._processDomInlineNodes(null, i, t), this.blockFillerMode == "br" && Ap(s)) || s.is("$text") && s.data.length == 0 ? null : s;
  }
  /**
  * Converts children of the DOM element to view nodes using
  * the {@link module:engine/view/domconverter~DomConverter#domToView} method.
  * Additionally this method omits block {@link module:engine/view/filler filler}, if it exists in the DOM parent.
  *
  * @param domElement Parent DOM element.
  * @param options See {@link module:engine/view/domconverter~DomConverter#domToView} options parameter.
  * @param inlineNodes An array that will be populated with inline nodes. It's used internally for whitespace processing.
  * @returns View nodes.
  */
  *domChildrenToView(n, t = {}, i = []) {
    let r = [];
    n instanceof HTMLTemplateElement ? r = [
      ...n.content.childNodes
    ] : r = [
      ...n.childNodes
    ];
    for (let s = 0; s < r.length; s++) {
      const o = r[s], a = this._domToView(o, t, i), u = a.next().value;
      u !== null && (this._isBlockViewElement(u) && this._processDomInlineNodes(n, i, t), this.blockFillerMode == "br" && Ap(u) || (yield u), a.next());
    }
    this._processDomInlineNodes(n, i, t);
  }
  /**
  * Converts DOM selection to view {@link module:engine/view/selection~Selection}.
  * Ranges which cannot be converted will be omitted.
  *
  * @param domSelection DOM selection.
  * @returns View selection.
  */
  domSelectionToView(n) {
    if (vO(n))
      return new gr([]);
    if (n.rangeCount === 1) {
      let r = n.getRangeAt(0).startContainer;
      mt(r) && (r = r.parentNode);
      const s = this.fakeSelectionToView(r);
      if (s)
        return s;
    }
    const t = this.isDomSelectionBackward(n), i = [];
    for (let r = 0; r < n.rangeCount; r++) {
      const s = n.getRangeAt(r), o = this.domRangeToView(s);
      o && i.push(o);
    }
    return new gr(i, {
      backward: t
    });
  }
  /**
  * Converts DOM Range to view {@link module:engine/view/range~Range}.
  * If the start or end position can not be converted `null` is returned.
  *
  * @param domRange DOM range.
  * @returns View range.
  */
  domRangeToView(n) {
    const t = this.domPositionToView(n.startContainer, n.startOffset), i = this.domPositionToView(n.endContainer, n.endOffset);
    return t && i ? new Re(t, i) : null;
  }
  /**
  * Converts DOM parent and offset to view {@link module:engine/view/position~Position}.
  *
  * If the position is inside a {@link module:engine/view/filler filler} which has no corresponding view node,
  * position of the filler will be converted and returned.
  *
  * If the position is inside DOM element rendered by {@link module:engine/view/uielement~UIElement}
  * that position will be converted to view position before that UIElement.
  *
  * If structures are too different and it is not possible to find corresponding position then `null` will be returned.
  *
  * @param domParent DOM position parent.
  * @param domOffset DOM position offset. You can skip it when converting the inline filler node.
  * @returns View position.
  */
  domPositionToView(n, t = 0) {
    if (this.isBlockFiller(n))
      return this.domPositionToView(n.parentNode, Qo(n));
    const i = this.mapDomToView(n);
    if (i && (i.is("uiElement") || i.is("rawElement")))
      return ne._createBefore(i);
    if (mt(n)) {
      if (Hs(n))
        return this.domPositionToView(n.parentNode, Qo(n));
      const r = this.findCorrespondingViewText(n);
      let s = t;
      return r ? (kn(n) && (s -= ni, s = s < 0 ? 0 : s), new ne(r, s)) : null;
    } else {
      if (t === 0) {
        const r = this.mapDomToView(n);
        if (r)
          return new ne(r, 0);
      } else {
        const r = n.childNodes[t - 1];
        if (mt(r) && Hs(r) || r && this.isBlockFiller(r))
          return this.domPositionToView(r.parentNode, Qo(r));
        const s = mt(r) ? this.findCorrespondingViewText(r) : this.mapDomToView(r);
        if (s && s.parent)
          return new ne(s.parent, s.index + 1);
      }
      return null;
    }
  }
  /**
  * Returns corresponding view {@link module:engine/view/element~Element Element} or
  * {@link module:engine/view/documentfragment~DocumentFragment} for provided DOM element or
  * document fragment. If there is no view item {@link module:engine/view/domconverter~DomConverter#bindElements bound}
  * to the given DOM - `undefined` is returned.
  *
  * For all DOM elements rendered by a {@link module:engine/view/uielement~UIElement} or
  * a {@link module:engine/view/rawelement~RawElement}, the parent `UIElement` or `RawElement` will be returned.
  *
  * @param domElementOrDocumentFragment DOM element or document fragment.
  * @returns Corresponding view element, document fragment or `undefined` if no element was bound.
  */
  mapDomToView(n) {
    return this.getHostViewElement(n) || this._domToViewMapping.get(n);
  }
  /**
  * Finds corresponding text node. Text nodes are not {@link module:engine/view/domconverter~DomConverter#bindElements bound},
  * corresponding text node is returned based on the sibling or parent.
  *
  * If the directly previous sibling is a {@link module:engine/view/domconverter~DomConverter#bindElements bound} element, it is used
  * to find the corresponding text node.
  *
  * If this is a first child in the parent and the parent is a {@link module:engine/view/domconverter~DomConverter#bindElements bound}
  * element, it is used to find the corresponding text node.
  *
  * For all text nodes rendered by a {@link module:engine/view/uielement~UIElement} or
  * a {@link module:engine/view/rawelement~RawElement}, the parent `UIElement` or `RawElement` will be returned.
  *
  * Otherwise `null` is returned.
  *
  * Note that for the block or inline {@link module:engine/view/filler filler} this method returns `null`.
  *
  * @param domText DOM text node.
  * @returns Corresponding view text node or `null`, if it was not possible to find a corresponding node.
  */
  findCorrespondingViewText(n) {
    if (Hs(n))
      return null;
    const t = this.getHostViewElement(n);
    if (t)
      return t;
    const i = n.previousSibling;
    if (i) {
      if (!this.isElement(i))
        return null;
      const r = this.mapDomToView(i);
      if (r) {
        const s = r.nextSibling;
        return s instanceof Jt ? s : null;
      }
    } else {
      const r = this.mapDomToView(n.parentNode);
      if (r) {
        const s = r.getChild(0);
        return s instanceof Jt ? s : null;
      }
    }
    return null;
  }
  mapViewToDom(n) {
    return this._viewToDomMapping.get(n);
  }
  /**
  * Finds corresponding text node. Text nodes are not {@link module:engine/view/domconverter~DomConverter#bindElements bound},
  * corresponding text node is returned based on the sibling or parent.
  *
  * If the directly previous sibling is a {@link module:engine/view/domconverter~DomConverter#bindElements bound} element, it is used
  * to find the corresponding text node.
  *
  * If this is a first child in the parent and the parent is a {@link module:engine/view/domconverter~DomConverter#bindElements bound}
  * element, it is used to find the corresponding text node.
  *
  * Otherwise `null` is returned.
  *
  * @param viewText View text node.
  * @returns Corresponding DOM text node or `null`, if it was not possible to find a corresponding node.
  */
  findCorrespondingDomText(n) {
    const t = n.previousSibling;
    return t && this.mapViewToDom(t) ? this.mapViewToDom(t).nextSibling : !t && n.parent && this.mapViewToDom(n.parent) ? this.mapViewToDom(n.parent).childNodes[0] : null;
  }
  /**
  * Focuses DOM editable that is corresponding to provided {@link module:engine/view/editableelement~EditableElement}.
  */
  focus(n) {
    const t = this.mapViewToDom(n);
    if (t && t.ownerDocument.activeElement !== t) {
      const { scrollX: i, scrollY: r } = ue.window, s = [];
      wp(t, (o) => {
        const { scrollLeft: a, scrollTop: u } = o;
        s.push([
          a,
          u
        ]);
      }), t.focus(), wp(t, (o) => {
        const [a, u] = s.shift();
        o.scrollLeft = a, o.scrollTop = u;
      }), ue.window.scrollTo(i, r);
    }
  }
  /**
  * Remove DOM selection from blurred editable, so it won't interfere with clicking on dropdowns (especially on iOS).
  *
  * @internal
  */
  _clearDomSelection() {
    const n = this.mapViewToDom(this.document.selection.editableElement);
    if (!n)
      return;
    const t = n.ownerDocument.defaultView.getSelection(), i = this.domSelectionToView(t);
    i && i.rangeCount > 0 && t.removeAllRanges();
  }
  /**
  * Returns `true` when `node.nodeType` equals `Node.ELEMENT_NODE`.
  *
  * @param node Node to check.
  */
  isElement(n) {
    return n && n.nodeType == Node.ELEMENT_NODE;
  }
  /**
  * Returns `true` when `node.nodeType` equals `Node.DOCUMENT_FRAGMENT_NODE`.
  *
  * @param node Node to check.
  */
  isDocumentFragment(n) {
    return n && n.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
  }
  /**
  * Checks if the node is an instance of the block filler for this DOM converter.
  *
  * ```ts
  * const converter = new DomConverter( viewDocument, { blockFillerMode: 'br' } );
  *
  * converter.isBlockFiller( BR_FILLER( document ) ); // true
  * converter.isBlockFiller( NBSP_FILLER( document ) ); // false
  * ```
  *
  * **Note:**: For the `'nbsp'` mode the method also checks context of a node so it cannot be a detached node.
  *
  * **Note:** A special case in the `'nbsp'` mode exists where the `<br>` in `<p><br></p>` is treated as a block filler.
  *
  * @param domNode DOM node to check.
  * @returns True if a node is considered a block filler for given mode.
  */
  isBlockFiller(n) {
    return this.blockFillerMode == "br" ? n.isEqualNode(wO) : Cp(n, this.blockElements) ? !0 : n.isEqualNode(CO) || SO(n, this.blockElements);
  }
  /**
  * Returns `true` if given selection is a backward selection, that is, if it's `focus` is before `anchor`.
  *
  * @param DOM Selection instance to check.
  */
  isDomSelectionBackward(n) {
    if (n.isCollapsed)
      return !1;
    const t = this._domDocument.createRange();
    try {
      t.setStart(n.anchorNode, n.anchorOffset), t.setEnd(n.focusNode, n.focusOffset);
    } catch {
      return !1;
    }
    const i = t.collapsed;
    return t.detach(), i;
  }
  /**
  * Returns a parent {@link module:engine/view/uielement~UIElement} or {@link module:engine/view/rawelement~RawElement}
  * that hosts the provided DOM node. Returns `null` if there is no such parent.
  */
  getHostViewElement(n) {
    const t = rP(n);
    for (t.pop(); t.length; ) {
      const i = t.pop(), r = this._domToViewMapping.get(i);
      if (r && (r.is("uiElement") || r.is("rawElement")))
        return r;
    }
    return null;
  }
  /**
  * Checks if the given selection's boundaries are at correct places.
  *
  * The following places are considered as incorrect for selection boundaries:
  *
  * * before or in the middle of an inline filler sequence,
  * * inside a DOM element which represents {@link module:engine/view/uielement~UIElement a view UI element},
  * * inside a DOM element which represents {@link module:engine/view/rawelement~RawElement a view raw element}.
  *
  * @param domSelection The DOM selection object to be checked.
  * @returns `true` if the given selection is at a correct place, `false` otherwise.
  */
  isDomSelectionCorrect(n) {
    return this._isDomSelectionPositionCorrect(n.anchorNode, n.anchorOffset) && this._isDomSelectionPositionCorrect(n.focusNode, n.focusOffset);
  }
  /**
  * Registers a {@link module:engine/view/matcher~MatcherPattern} for view elements whose content should be treated as raw data
  * and not processed during the conversion from DOM nodes to view elements.
  *
  * This is affecting how {@link module:engine/view/domconverter~DomConverter#domToView} and
  * {@link module:engine/view/domconverter~DomConverter#domChildrenToView} process DOM nodes.
  *
  * The raw data can be later accessed by a
  * {@link module:engine/view/element~Element#getCustomProperty custom property of a view element} called `"$rawContent"`.
  *
  * @param pattern Pattern matching a view element whose content should
  * be treated as raw data.
  */
  registerRawContentMatcher(n) {
    this._rawContentElementMatcher.add(n);
  }
  /**
  * Registers a {@link module:engine/view/matcher~MatcherPattern} for inline object view elements.
  *
  * This is affecting how {@link module:engine/view/domconverter~DomConverter#domToView} and
  * {@link module:engine/view/domconverter~DomConverter#domChildrenToView} process DOM nodes.
  *
  * This is an extension of a simple {@link #inlineObjectElements} array of element names.
  *
  * @param pattern Pattern matching a view element which should be treated as an inline object.
  */
  registerInlineObjectMatcher(n) {
    this._inlineObjectElementMatcher.add(n);
  }
  /**
  * Clear temporary custom properties.
  *
  * @internal
  */
  _clearTemporaryCustomProperties() {
    for (const n of this._elementsWithTemporaryCustomProperties)
      n._removeCustomProperty("editingPipeline:doNotReuseOnce");
    this._elementsWithTemporaryCustomProperties.clear();
  }
  /**
  * Returns the block {@link module:engine/view/filler filler} node based on the current {@link #blockFillerMode} setting.
  */
  _getBlockFiller() {
    switch (this.blockFillerMode) {
      case "nbsp":
        return QE(this._domDocument);
      case "markedNbsp":
        return XE(this._domDocument);
      case "br":
        return JE(this._domDocument);
    }
  }
  /**
  * Checks if the given DOM position is a correct place for selection boundary. See {@link #isDomSelectionCorrect}.
  *
  * @param domParent Position parent.
  * @param offset Position offset.
  * @returns `true` if given position is at a correct place for selection boundary, `false` otherwise.
  */
  _isDomSelectionPositionCorrect(n, t) {
    if (mt(n) && kn(n) && t < ni || this.isElement(n) && kn(n.childNodes[t]))
      return !1;
    const i = this.mapDomToView(n);
    return !(i && (i.is("uiElement") || i.is("rawElement")));
  }
  /**
  * Internal generator for {@link #domToView}. Also used by {@link #domChildrenToView}.
  * Separates DOM nodes conversion from whitespaces processing.
  *
  * @param domNode DOM node or document fragment to transform.
  * @param inlineNodes An array of recently encountered inline nodes truncated to the block element boundaries.
  * Used later to process whitespaces.
  */
  *_domToView(n, t, i) {
    if (this.blockFillerMode != "br" && Cp(n, this.blockElements))
      return null;
    const r = this.getHostViewElement(n);
    if (r)
      return r;
    if (sa(n) && t.skipComments)
      return null;
    if (mt(n)) {
      if (Hs(n))
        return null;
      {
        const s = n.data;
        if (s === "")
          return null;
        const o = new Jt(this.document, s);
        return i.push(o), o;
      }
    } else {
      let s = this.mapDomToView(n);
      if (s)
        return this._isInlineObjectElement(s) && i.push(s), s;
      if (this.isDocumentFragment(n))
        s = new qs(this.document), t.bind && this.bindDocumentFragments(n, s);
      else {
        s = this._createViewElement(n, t), t.bind && this.bindElements(n, s);
        const a = n.attributes;
        if (a)
          for (let u = a.length, l = 0; l < u; l++)
            s._setAttribute(a[l].name, a[l].value);
        if (this._isViewElementWithRawContent(s, t))
          return s._setCustomProperty("$rawContent", n.innerHTML), this._isBlockViewElement(s) || i.push(s), s;
        if (sa(n))
          return s._setCustomProperty("$rawContent", n.data), s;
      }
      yield s;
      const o = [];
      if (t.withChildren !== !1)
        for (const a of this.domChildrenToView(n, t, o))
          s._appendChild(a);
      if (this._isInlineObjectElement(s))
        i.push(s), this._processDomInlineNodes(null, o, t);
      else
        for (const a of o)
          i.push(a);
    }
  }
  /**
  * Internal helper that walks the list of inline view nodes already generated from DOM nodes
  * and handles whitespaces and NBSPs.
  *
  * @param domParent The DOM parent of the given inline nodes. This should be a document fragment or
  * a block element to whitespace processing start cleaning.
  * @param inlineNodes An array of recently encountered inline nodes truncated to the block element boundaries.
  */
  _processDomInlineNodes(n, t, i) {
    if (!t.length || n && !this.isDocumentFragment(n) && !this._isBlockDomElement(n))
      return;
    let r = !1;
    for (let s = 0; s < t.length; s++) {
      const o = t[s];
      if (!o.is("$text")) {
        r = !1;
        continue;
      }
      let a, u = !1;
      if (this._isPreFormatted(o))
        a = Ep(o.data);
      else {
        a = o.data.replace(/[ \n\t\r]{1,}/g, " "), u = /[^\S\u00A0]/.test(a.charAt(a.length - 1));
        const l = s > 0 ? t[s - 1] : null, c = s + 1 < t.length ? t[s + 1] : null, d = !l || l.is("element") && l.name == "br" || r, p = c ? !1 : !kn(o.data);
        i.withChildren !== !1 && (d && (a = a.replace(/^ /, "")), p && (a = a.replace(/ $/, ""))), a = Ep(a), this.blockFillerMode != "br" && o.parent && (xO(o.parent, a) ? (a = "", o.parent.parent && (o.parent.parent._setCustomProperty("$hasBlockFiller", !0), o.parent._remove())) : IO(o.parent, a, this.blockElements) && (a = "", o.parent._setCustomProperty("$hasBlockFiller", !0))), a = a.replace(/ \u00A0/g, "  ");
        const g = c && c.is("element") && c.name != "br", b = c && c.is("$text") && c.data.charAt(0) == " ";
        (/[ \u00A0]\u00A0$/.test(a) || !c || g || b) && (a = a.replace(/\u00A0$/, " ")), (d || l && l.is("element") && l.name != "br") && (a = a.replace(/^\u00A0/, " "));
      }
      a.length == 0 && o.parent ? (o._remove(), t.splice(s, 1), s--) : (o._data = a, r = u);
    }
    t.length = 0;
  }
  /**
  * Takes text data from a given {@link module:engine/view/text~Text#data} and processes it so
  * it is correctly displayed in the DOM.
  *
  * Following changes are done:
  *
  * * a space at the beginning is changed to `&nbsp;` if this is the first text node in its container
  * element or if a previous text node ends with a space character,
  * * space at the end of the text node is changed to `&nbsp;` if there are two spaces at the end of a node or if next node
  * starts with a space or if it is the last text node in its container,
  * * remaining spaces are replaced to a chain of spaces and `&nbsp;` (e.g. `'x   x'` becomes `'x &nbsp; x'`).
  *
  * Content of {@link #preElements} is not processed.
  *
  * @param node View text node to process.
  * @returns Processed text data.
  */
  _processDataFromViewText(n) {
    let t = n.data;
    if (this._isPreFormatted(n))
      return t;
    if (t.charAt(0) == " ") {
      const i = this._getTouchingInlineViewNode(n, !1);
      (i && i.is("$textProxy") && this._nodeEndsWithSpace(i) || !i) && (t = " " + t.substr(1));
    }
    if (t.charAt(t.length - 1) == " ") {
      const i = this._getTouchingInlineViewNode(n, !0), r = i && i.is("$textProxy") && i.data.charAt(0) == " ";
      (t.charAt(t.length - 2) == " " || !i || r) && (t = t.substr(0, t.length - 1) + " ");
    }
    return t.replace(/ {2}/g, "  ");
  }
  /**
  * Checks whether given node ends with a space character after changing appropriate space characters to `&nbsp;`s.
  *
  * @param  node Node to check.
  * @returns `true` if given `node` ends with space, `false` otherwise.
  */
  _nodeEndsWithSpace(n) {
    if (this._isPreFormatted(n))
      return !1;
    const t = this._processDataFromViewText(n);
    return t.charAt(t.length - 1) == " ";
  }
  /**
  * Checks whether given text contains preformatted white space. This is the case if
  * * any of node ancestors has a name which is in `preElements` array, or
  * * the closest ancestor that has the `white-space` CSS property sets it to a value that preserves spaces
  *
  * @param node Node to check
  * @returns `true` if given node contains preformatted white space, `false` otherwise.
  */
  _isPreFormatted(n) {
    if (kO(n, this.preElements))
      return !0;
    for (const t of n.getAncestors({
      parentFirst: !0
    }))
      if (!(!t.is("element") || !t.hasStyle("white-space") || t.getStyle("white-space") === "inherit"))
        return [
          "pre",
          "pre-wrap",
          "break-spaces"
        ].includes(t.getStyle("white-space"));
    return !1;
  }
  /**
  * Helper function. For given {@link module:engine/view/text~Text view text node}, it finds previous or next sibling
  * that is contained in the same container element. If there is no such sibling, `null` is returned.
  *
  * @param node Reference node.
  * @returns Touching text node, an inline object
  * or `null` if there is no next or previous touching text node.
  */
  _getTouchingInlineViewNode(n, t) {
    const i = new Kr({
      startPosition: t ? ne._createAfter(n) : ne._createBefore(n),
      direction: t ? "forward" : "backward"
    });
    for (const { item: r } of i) {
      if (r.is("$textProxy"))
        return r;
      if (r.is("element") && r.getCustomProperty("dataPipeline:transparentRendering"))
        continue;
      if (r.is("element", "br"))
        return null;
      if (this._isInlineObjectElement(r))
        return r;
      if (r.is("containerElement"))
        return null;
    }
    return null;
  }
  /**
  * Returns `true` if a DOM node belongs to {@link #blockElements}. `false` otherwise.
  */
  _isBlockDomElement(n) {
    return this.isElement(n) && this.blockElements.includes(n.tagName.toLowerCase());
  }
  /**
  * Returns `true` if a view node belongs to {@link #blockElements}. `false` otherwise.
  */
  _isBlockViewElement(n) {
    return n.is("element") && this.blockElements.includes(n.name);
  }
  /**
  * Returns `true` if a DOM node belongs to {@link #inlineObjectElements}. `false` otherwise.
  */
  _isInlineObjectElement(n) {
    return n.is("element") ? n.name == "br" || this.inlineObjectElements.includes(n.name) || !!this._inlineObjectElementMatcher.match(n) : !1;
  }
  /**
  * Creates view element basing on the node type.
  *
  * @param node DOM node to check.
  * @param options Conversion options. See {@link module:engine/view/domconverter~DomConverter#domToView} options parameter.
  */
  _createViewElement(n, t) {
    if (sa(n))
      return new ic(this.document, "$comment");
    const i = t.keepOriginalCase ? n.tagName : n.tagName.toLowerCase();
    return new cs(this.document, i);
  }
  /**
  * Checks if view element's content should be treated as a raw data.
  *
  * @param viewElement View element to check.
  * @param options Conversion options. See {@link module:engine/view/domconverter~DomConverter#domToView} options parameter.
  */
  _isViewElementWithRawContent(n, t) {
    return t.withChildren !== !1 && n.is("element") && !!this._rawContentElementMatcher.match(n);
  }
  /**
  * Checks whether a given element name should be renamed in a current rendering mode.
  *
  * @param elementName The name of view element.
  */
  _shouldRenameElement(n) {
    const t = n.toLowerCase();
    return this.renderingMode === "editing" && this.unsafeElements.includes(t);
  }
  /**
  * Return a <span> element with a special attribute holding the name of the original element.
  * Optionally, copy all the attributes of the original element if that element is provided.
  *
  * @param elementName The name of view element.
  * @param originalDomElement The original DOM element to copy attributes and content from.
  */
  _createReplacementDomElement(n, t) {
    const i = this._domDocument.createElement("span");
    if (i.setAttribute(yp, n), t) {
      for (; t.firstChild; )
        i.appendChild(t.firstChild);
      for (const r of t.getAttributeNames())
        i.setAttribute(r, t.getAttribute(r));
    }
    return i;
  }
}
function kO(e, n) {
  return e.getAncestors().some((t) => t.is("element") && n.includes(t.name));
}
function wp(e, n) {
  let t = e;
  for (; t; )
    n(t), t = t.parentElement;
}
function SO(e, n) {
  return e.isEqualNode(AO) && eT(e, n) && e.parentNode.childNodes.length === 1;
}
function eT(e, n) {
  const t = e.parentNode;
  return !!t && !!t.tagName && n.includes(t.tagName.toLowerCase());
}
function IO(e, n, t) {
  return n == " " && e && e.is("element") && e.childCount == 1 && t.includes(e.name);
}
function xO(e, n) {
  return n == " " && e && e.is("element", "span") && e.childCount == 1 && e.hasAttribute("data-cke-filler");
}
function Ap(e) {
  return e.is("element", "br") && e.hasAttribute("data-cke-filler");
}
function Cp(e, n) {
  return e.tagName === "BR" && eT(e, n) && e.parentNode.childNodes.length === 1;
}
function kp(e) {
  e === "script" && at("domconverter-unsafe-script-element-detected"), e === "style" && at("domconverter-unsafe-style-element-detected");
}
function vO(e) {
  if (!he.isGecko || !e.rangeCount)
    return !1;
  const n = e.getRangeAt(0).startContainer;
  try {
    Object.prototype.toString.call(n);
  } catch {
    return !0;
  }
  return !1;
}
class Xi extends (/* @__PURE__ */ li()) {
  /**
  * Creates an instance of the observer.
  */
  constructor(t) {
    super();
    /**
    * An instance of the view controller.
    */
    m(this, "view");
    /**
    * A reference to the {@link module:engine/view/document~Document} object.
    */
    m(this, "document");
    /**
    * The state of the observer. If it is disabled, no events will be fired.
    */
    m(this, "_isEnabled", !1);
    this.view = t, this.document = t.document;
  }
  /**
  * The state of the observer. If it is disabled, no events will be fired.
  */
  get isEnabled() {
    return this._isEnabled;
  }
  /**
  * Enables the observer. This method is called when the observer is registered to the
  * {@link module:engine/view/view~View} and after {@link module:engine/view/view~View#forceRender rendering}
  * (all observers are {@link #disable disabled} before rendering).
  *
  * A typical use case for disabling observers is that mutation observers need to be disabled for the rendering.
  * However, a child class may not need to be disabled, so it can implement an empty method.
  *
  * @see module:engine/view/observer/observer~Observer#disable
  */
  enable() {
    this._isEnabled = !0;
  }
  /**
  * Disables the observer. This method is called before
  * {@link module:engine/view/view~View#forceRender rendering} to prevent firing events during rendering.
  *
  * @see module:engine/view/observer/observer~Observer#enable
  */
  disable() {
    this._isEnabled = !1;
  }
  /**
  * Disables and destroys the observer, among others removes event listeners created by the observer.
  */
  destroy() {
    this.disable(), this.stopListening();
  }
  /**
  * Checks whether a given DOM event should be ignored (should not be turned into a synthetic view document event).
  *
  * Currently, an event will be ignored only if its target or any of its ancestors has the `data-cke-ignore-events` attribute.
  * This attribute can be used inside the structures generated by
  * {@link module:engine/view/downcastwriter~DowncastWriter#createUIElement `DowncastWriter#createUIElement()`} to ignore events
  * fired within a UI that should be excluded from CKEditor 5's realms.
  *
  * @param domTarget The DOM event target to check (usually an element, sometimes a text node and
  * potentially sometimes a document, too).
  * @returns Whether this event should be ignored by the observer.
  */
  checkShouldIgnoreEventFromTarget(t) {
    return t && t.nodeType === 3 && (t = t.parentNode), !t || t.nodeType !== 1 ? !1 : t.matches("[data-cke-ignore-events], [data-cke-ignore-events] *");
  }
}
class eo {
  /**
  * @param view The instance of the view controller.
  * @param domEvent The DOM event.
  * @param additionalData Additional properties that the instance should contain.
  */
  constructor(n, t, i) {
    /**
    * Instance of the view controller.
    */
    m(this, "view");
    /**
    * The instance of the document.
    */
    m(this, "document");
    /**
    * The DOM event.
    */
    m(this, "domEvent");
    /**
    * The DOM target.
    */
    m(this, "domTarget");
    this.view = n, this.document = n.document, this.domEvent = t, this.domTarget = t.target, z_(this, i);
  }
  /**
  * The tree view element representing the target.
  */
  get target() {
    return this.view.domConverter.mapDomToView(this.domTarget);
  }
  /**
  * Prevents the native's event default action.
  */
  preventDefault() {
    this.domEvent.preventDefault();
  }
  /**
  * Stops native event propagation.
  */
  stopPropagation() {
    this.domEvent.stopPropagation();
  }
}
class Sr extends Xi {
  constructor() {
    super(...arguments);
    /**
    * If set to `true` DOM events will be listened on the capturing phase.
    * Default value is `false`.
    */
    m(this, "useCapture", !1);
    /**
    * If set to `true`, indicates that the function specified by listener will never call `preventDefault()`.
    * Default value is `false`.
    */
    m(this, "usePassive", !1);
  }
  /**
  * @inheritDoc
  */
  observe(t) {
    (typeof this.domEventType == "string" ? [
      this.domEventType
    ] : this.domEventType).forEach((r) => {
      this.listenTo(t, r, (s, o) => {
        this.isEnabled && !this.checkShouldIgnoreEventFromTarget(o.target) && this.onDomEvent(o);
      }, {
        useCapture: this.useCapture,
        usePassive: this.usePassive
      });
    });
  }
  /**
  * @inheritDoc
  */
  stopObserving(t) {
    this.stopListening(t);
  }
  /**
  * Calls `Document#fire()` if observer {@link #isEnabled is enabled}.
  *
  * @see module:utils/emittermixin~Emitter#fire
  * @param eventType The event type (name).
  * @param domEvent The DOM event.
  * @param additionalData The additional data which should extend the
  * {@link module:engine/view/observer/domeventdata~DomEventData event data} object.
  */
  fire(t, i, r) {
    this.isEnabled && this.document.fire(t, new eo(this.view, i, r));
  }
}
class PO extends Sr {
  constructor() {
    super(...arguments);
    /**
    * @inheritDoc
    */
    m(this, "domEventType", [
      "keydown",
      "keyup"
    ]);
  }
  /**
  * @inheritDoc
  */
  onDomEvent(t) {
    const i = {
      keyCode: t.keyCode,
      altKey: t.altKey,
      ctrlKey: t.ctrlKey,
      shiftKey: t.shiftKey,
      metaKey: t.metaKey,
      get keystroke() {
        return Zs(this);
      }
    };
    this.fire(t.type, t, i);
  }
}
class OO extends Xi {
  /**
  * Creates new FakeSelectionObserver instance.
  */
  constructor(t) {
    super(t);
    /**
    * Fires debounced event `selectionChangeDone`. It uses `lodash#debounce` method to delay function call.
    */
    m(this, "_fireSelectionChangeDoneDebounced");
    this._fireSelectionChangeDoneDebounced = _r((i) => {
      this.document.fire("selectionChangeDone", i);
    }, 200);
  }
  /**
  * @inheritDoc
  */
  observe() {
    const t = this.document;
    t.on("arrowKey", (i, r) => {
      t.selection.isFake && this.isEnabled && r.preventDefault();
    }, {
      context: "$capture"
    }), t.on("arrowKey", (i, r) => {
      t.selection.isFake && this.isEnabled && this._handleSelectionMove(r.keyCode);
    }, {
      priority: "lowest"
    });
  }
  /**
  * @inheritDoc
  */
  stopObserving() {
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy(), this._fireSelectionChangeDoneDebounced.cancel();
  }
  /**
  * Handles collapsing view selection according to given key code. If left or up key is provided - new selection will be
  * collapsed to left. If right or down key is pressed - new selection will be collapsed to right.
  *
  * This method fires {@link module:engine/view/document~Document#event:selectionChange} and
  * {@link module:engine/view/document~Document#event:selectionChangeDone} events imitating behaviour of
  * {@link module:engine/view/observer/selectionobserver~SelectionObserver}.
  */
  _handleSelectionMove(t) {
    const i = this.document.selection, r = new gr(i.getRanges(), {
      backward: i.isBackward,
      fake: !1
    });
    (t == ye.arrowleft || t == ye.arrowup) && r.setTo(r.getFirstPosition()), (t == ye.arrowright || t == ye.arrowdown) && r.setTo(r.getLastPosition());
    const s = {
      oldSelection: i,
      newSelection: r,
      domSelection: null
    };
    this.document.fire("selectionChange", s), this._fireSelectionChangeDoneDebounced(s);
  }
}
let tT = class extends Xi {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * Reference to the {@link module:engine/view/view~View#domConverter}.
    */
    m(this, "domConverter");
    /**
    * Native mutation observer config.
    */
    m(this, "_config");
    /**
    * Observed DOM elements.
    */
    m(this, "_domElements");
    /**
    * Native mutation observer.
    */
    m(this, "_mutationObserver");
    this._config = {
      childList: !0,
      characterData: !0,
      subtree: !0
    }, this.domConverter = t.domConverter, this._domElements = /* @__PURE__ */ new Set(), this._mutationObserver = new window.MutationObserver(this._onMutations.bind(this));
  }
  /**
  * Synchronously handles mutations and empties the queue.
  */
  flush() {
    this._onMutations(this._mutationObserver.takeRecords());
  }
  /**
  * @inheritDoc
  */
  observe(t) {
    this._domElements.add(t), this.isEnabled && this._mutationObserver.observe(t, this._config);
  }
  /**
  * @inheritDoc
  */
  stopObserving(t) {
    if (this._domElements.delete(t), this.isEnabled) {
      this._mutationObserver.disconnect();
      for (const i of this._domElements)
        this._mutationObserver.observe(i, this._config);
    }
  }
  /**
  * @inheritDoc
  */
  enable() {
    super.enable();
    for (const t of this._domElements)
      this._mutationObserver.observe(t, this._config);
  }
  /**
  * @inheritDoc
  */
  disable() {
    super.disable(), this._mutationObserver.disconnect();
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy(), this._mutationObserver.disconnect();
  }
  /**
  * Handles mutations. Mark view elements to sync and call render.
  *
  * @param domMutations Array of native mutations.
  */
  _onMutations(t) {
    if (t.length === 0)
      return;
    const i = this.domConverter, r = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set();
    for (const a of t) {
      const u = i.mapDomToView(a.target);
      u && (u.is("uiElement") || u.is("rawElement") || a.type === "childList" && !this._isBogusBrMutation(a) && s.add(u));
    }
    for (const a of t) {
      const u = i.mapDomToView(a.target);
      if (!(u && (u.is("uiElement") || u.is("rawElement"))) && a.type === "characterData") {
        const l = i.findCorrespondingViewText(a.target);
        l && !s.has(l.parent) ? r.add(l) : !l && kn(a.target) && s.add(i.mapDomToView(a.target.parentNode));
      }
    }
    const o = [];
    for (const a of r)
      o.push({
        type: "text",
        node: a
      });
    for (const a of s) {
      const u = i.mapViewToDom(a), l = Array.from(a.getChildren()), c = Array.from(i.domChildrenToView(u, {
        withChildren: !1
      }));
      Ev(l, c, NO) || o.push({
        type: "children",
        node: a
      });
    }
    o.length && this.document.fire("mutations", {
      mutations: o
    });
  }
  /**
  * Checks if mutation was generated by the browser inserting bogus br on the end of the block element.
  * Such mutations are generated while pressing space or performing native spellchecker correction
  * on the end of the block element in Firefox browser.
  *
  * @param mutation Native mutation object.
  */
  _isBogusBrMutation(t) {
    let i = null;
    return t.nextSibling === null && t.removedNodes.length === 0 && t.addedNodes.length == 1 && (i = this.domConverter.domToView(t.addedNodes[0], {
      withChildren: !1
    })), i && i.is("element", "br");
  }
};
function NO(e, n) {
  if (!Array.isArray(e))
    return e === n ? !0 : e.is("$text") && n.is("$text") ? e.data === n.data : !1;
}
class Tl extends Sr {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * Identifier of the timeout currently used by focus listener to delay rendering execution.
    */
    m(this, "_renderTimeoutId", null);
    /**
    * Set to `true` if the document is in the process of setting the focus.
    *
    * The flag is used to indicate that setting the focus is in progress.
    */
    m(this, "_isFocusChanging", !1);
    /**
    * @inheritDoc
    */
    m(this, "domEventType", [
      "focus",
      "blur"
    ]);
    this.useCapture = !0;
    const i = this.document;
    i.on("focus", () => this._handleFocus()), i.on("blur", (r, s) => this._handleBlur(s)), i.on("beforeinput", () => {
      i.isFocused || this._handleFocus();
    }, {
      priority: "highest"
    });
  }
  /**
  * Finishes setting the document focus state.
  */
  flush() {
    this._isFocusChanging && (this._isFocusChanging = !1, this.document.isFocused = !0);
  }
  /**
  * @inheritDoc
  */
  onDomEvent(t) {
    this.fire(t.type, t);
  }
  /**
  * @inheritDoc
  */
  destroy() {
    this._clearTimeout(), super.destroy();
  }
  /**
  * The `focus` event handler.
  */
  _handleFocus() {
    this._clearTimeout(), this._isFocusChanging = !0, this._renderTimeoutId = setTimeout(() => {
      this._renderTimeoutId = null, this.flush(), this.view.change(() => {
      });
    }, 50);
  }
  /**
  * The `blur` event handler.
  */
  _handleBlur(t) {
    const i = this.document.selection.editableElement;
    (i === null || i === t.target) && (this.document.isFocused = !1, this._isFocusChanging = !1, this.view.change(() => {
    }));
  }
  /**
  * Clears timeout.
  */
  _clearTimeout() {
    this._renderTimeoutId && (clearTimeout(this._renderTimeoutId), this._renderTimeoutId = null);
  }
}
class RO extends Xi {
  constructor(t) {
    super(t);
    /**
    * Instance of the mutation observer. Selection observer calls
    * {@link module:engine/view/observer/mutationobserver~MutationObserver#flush} to ensure that the mutations will be handled
    * before the {@link module:engine/view/document~Document#event:selectionChange} event is fired.
    */
    m(this, "mutationObserver");
    /**
    * Instance of the focus observer. Focus observer calls
    * {@link module:engine/view/observer/focusobserver~FocusObserver#flush} to mark the latest focus change as complete.
    */
    m(this, "focusObserver");
    /**
    * Reference to the view {@link module:engine/view/documentselection~DocumentSelection} object used to compare
    * new selection with it.
    */
    m(this, "selection");
    /**
    * Reference to the {@link module:engine/view/view~View#domConverter}.
    */
    m(this, "domConverter");
    /**
    * A set of documents which have added `selectionchange` listener to avoid adding a listener twice to the same
    * document.
    */
    m(this, "_documents");
    /**
    * Fires debounced event `selectionChangeDone`. It uses `lodash#debounce` method to delay function call.
    */
    m(this, "_fireSelectionChangeDoneDebounced");
    /**
    * When called, starts clearing the {@link #_loopbackCounter} counter in time intervals. When the number of selection
    * changes exceeds a certain limit within the interval of time, the observer will not fire `selectionChange` but warn about
    * possible infinite selection loop.
    */
    m(this, "_clearInfiniteLoopInterval");
    /**
    * Unlocks the `isSelecting` state of the view document in case the selection observer did not record this fact
    * correctly (for whatever reason). It is a safeguard (paranoid check), that returns document to the normal state
    * after a certain period of time (debounced, postponed by each selectionchange event).
    */
    m(this, "_documentIsSelectingInactivityTimeoutDebounced");
    /**
    * Private property to check if the code does not enter infinite loop.
    */
    m(this, "_loopbackCounter");
    this.mutationObserver = t.getObserver(tT), this.focusObserver = t.getObserver(Tl), this.selection = this.document.selection, this.domConverter = t.domConverter, this._documents = /* @__PURE__ */ new WeakSet(), this._fireSelectionChangeDoneDebounced = _r((i) => {
      this.document.fire("selectionChangeDone", i);
    }, 200), this._clearInfiniteLoopInterval = setInterval(() => this._clearInfiniteLoop(), 1e3), this._documentIsSelectingInactivityTimeoutDebounced = _r(() => this.document.isSelecting = !1, 5e3), this._loopbackCounter = 0;
  }
  /**
  * @inheritDoc
  */
  observe(t) {
    const i = t.ownerDocument, r = () => {
      this.document.isSelecting = !0, this._documentIsSelectingInactivityTimeoutDebounced();
    }, s = () => {
      this.document.isSelecting && (this._handleSelectionChange(i), this.document.isSelecting = !1, this._documentIsSelectingInactivityTimeoutDebounced.cancel());
    };
    this.listenTo(t, "selectstart", r, {
      priority: "highest"
    }), this.listenTo(t, "keydown", s, {
      priority: "highest",
      useCapture: !0
    }), this.listenTo(t, "keyup", s, {
      priority: "highest",
      useCapture: !0
    }), !this._documents.has(i) && (this.listenTo(i, "mouseup", s, {
      priority: "highest",
      useCapture: !0
    }), this.listenTo(i, "selectionchange", () => {
      this.document.isComposing && !he.isAndroid || (this._handleSelectionChange(i), this._documentIsSelectingInactivityTimeoutDebounced());
    }), this.listenTo(this.view.document, "compositionstart", () => {
      this._handleSelectionChange(i);
    }, {
      priority: "lowest"
    }), this._documents.add(i));
  }
  /**
  * @inheritDoc
  */
  stopObserving(t) {
    this.stopListening(t);
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy(), clearInterval(this._clearInfiniteLoopInterval), this._fireSelectionChangeDoneDebounced.cancel(), this._documentIsSelectingInactivityTimeoutDebounced.cancel();
  }
  /* istanbul ignore next -- @preserve */
  _reportInfiniteLoop() {
  }
  /**
  * Selection change listener. {@link module:engine/view/observer/mutationobserver~MutationObserver#flush Flush} mutations, check if
  * a selection changes and fires {@link module:engine/view/document~Document#event:selectionChange} event on every change
  * and {@link module:engine/view/document~Document#event:selectionChangeDone} when a selection stop changing.
  *
  * @param domDocument DOM document.
  */
  _handleSelectionChange(t) {
    if (!this.isEnabled)
      return;
    const i = t.defaultView.getSelection();
    if (this.checkShouldIgnoreEventFromTarget(i.anchorNode))
      return;
    this.mutationObserver.flush();
    const r = this.domConverter.domSelectionToView(i);
    if (r.rangeCount == 0) {
      this.view.hasDomSelection = !1;
      return;
    }
    if (this.view.hasDomSelection = !0, this.focusObserver.flush(), !(this.selection.isEqual(r) && this.domConverter.isDomSelectionCorrect(i))) {
      if (++this._loopbackCounter > 60) {
        this._reportInfiniteLoop();
        return;
      }
      if (this.selection.isSimilar(r))
        this.view.forceRender();
      else {
        const s = {
          oldSelection: this.selection,
          newSelection: r,
          domSelection: i
        };
        this.document.fire("selectionChange", s), this._fireSelectionChangeDoneDebounced(s);
      }
    }
  }
  /**
  * Clears `SelectionObserver` internal properties connected with preventing infinite loop.
  */
  _clearInfiniteLoop() {
    this._loopbackCounter = 0;
  }
}
class LO extends Sr {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * @inheritDoc
    */
    m(this, "domEventType", [
      "compositionstart",
      "compositionupdate",
      "compositionend"
    ]);
    const i = this.document;
    i.on("compositionstart", () => {
      i.isComposing = !0;
    }, {
      priority: "low"
    }), i.on("compositionend", () => {
      i.isComposing = !1;
    }, {
      priority: "low"
    });
  }
  /**
  * @inheritDoc
  */
  onDomEvent(t) {
    this.fire(t.type, t, {
      data: t.data
    });
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class nT {
  /**
  * @param nativeDataTransfer The native [`DataTransfer`](https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer) object.
  * @param options.cacheFiles Whether `files` list should be initialized in the constructor.
  */
  constructor(n, t = {}) {
    /**
    * The array of files created from the native `DataTransfer#files` or `DataTransfer#items`.
    */
    m(this, "_files");
    /**
    * The native DataTransfer object.
    */
    m(this, "_native");
    this._files = t.cacheFiles ? Sp(n) : null, this._native = n;
  }
  /**
  * The array of files created from the native `DataTransfer#files` or `DataTransfer#items`.
  */
  get files() {
    return this._files || (this._files = Sp(this._native)), this._files;
  }
  /**
  * Returns an array of available native content types.
  */
  get types() {
    return this._native.types;
  }
  /**
  * Gets the data from the data transfer by its MIME type.
  *
  * ```ts
  * dataTransfer.getData( 'text/plain' );
  * ```
  *
  * @param type The MIME type. E.g. `text/html` or `text/plain`.
  */
  getData(n) {
    return this._native.getData(n);
  }
  /**
  * Sets the data in the data transfer.
  *
  * @param type The MIME type. E.g. `text/html` or `text/plain`.
  */
  setData(n, t) {
    this._native.setData(n, t);
  }
  /**
  * The effect that is allowed for a drag operation.
  */
  set effectAllowed(n) {
    this._native.effectAllowed = n;
  }
  get effectAllowed() {
    return this._native.effectAllowed;
  }
  /**
  * The actual drop effect.
  */
  set dropEffect(n) {
    this._native.dropEffect = n;
  }
  get dropEffect() {
    return this._native.dropEffect;
  }
  /**
  * Set a preview image of the dragged content.
  */
  setDragImage(n, t, i) {
    this._native.setDragImage(n, t, i);
  }
  /**
  * Whether the dragging operation was canceled.
  */
  get isCanceled() {
    return this._native.dropEffect == "none" || !!this._native.mozUserCancelled;
  }
}
function Sp(e) {
  const n = Array.from(e.files || []), t = Array.from(e.items || []);
  return n.length ? n : t.filter((i) => i.kind === "file").map((i) => i.getAsFile());
}
class DO extends Sr {
  constructor() {
    super(...arguments);
    /**
    * @inheritDoc
    */
    m(this, "domEventType", "beforeinput");
  }
  /**
  * @inheritDoc
  */
  onDomEvent(t) {
    const i = t.getTargetRanges(), r = this.view, s = r.document;
    let o = null, a = null, u = [];
    if (t.dataTransfer && (o = new nT(t.dataTransfer)), t.data !== null ? a = t.data : o && (a = o.getData("text/plain")), s.selection.isFake)
      u = Array.from(s.selection.getRanges());
    else if (i.length)
      u = i.map((l) => {
        const c = r.domConverter.domPositionToView(l.startContainer, l.startOffset), d = r.domConverter.domPositionToView(l.endContainer, l.endOffset);
        if (c)
          return r.createRange(c, d);
        if (d)
          return r.createRange(d);
      }).filter((l) => !!l);
    else if (he.isAndroid) {
      const l = t.target.ownerDocument.defaultView.getSelection();
      u = Array.from(r.domConverter.domSelectionToView(l).getRanges());
    }
    if (he.isAndroid && t.inputType == "insertCompositionText" && a && a.endsWith(`
`)) {
      this.fire(t.type, t, {
        inputType: "insertParagraph",
        targetRanges: [
          r.createRange(u[0].end)
        ]
      });
      return;
    }
    if (t.inputType == "insertText" && a && a.includes(`
`)) {
      const l = a.split(/\n{1,2}/g);
      let c = u;
      for (let d = 0; d < l.length; d++) {
        const p = l[d];
        p != "" && (this.fire(t.type, t, {
          data: p,
          dataTransfer: o,
          targetRanges: c,
          inputType: t.inputType,
          isComposing: t.isComposing
        }), c = [
          s.selection.getFirstRange()
        ]), d + 1 < l.length && (this.fire(t.type, t, {
          inputType: "insertParagraph",
          targetRanges: c
        }), c = [
          s.selection.getFirstRange()
        ]);
      }
      return;
    }
    this.fire(t.type, t, {
      data: a,
      dataTransfer: o,
      targetRanges: u,
      inputType: t.inputType,
      isComposing: t.isComposing
    });
  }
}
class MO extends Xi {
  /**
  * @inheritDoc
  */
  constructor(n) {
    super(n), this.document.on("keydown", (t, i) => {
      if (this.isEnabled && _P(i.keyCode)) {
        const r = new fo(this.document, "arrowKey", this.document.selection.getFirstRange());
        this.document.fire(r, i), r.stop.called && t.stop();
      }
    });
  }
  /**
  * @inheritDoc
  */
  observe() {
  }
  /**
  * @inheritDoc
  */
  stopObserving() {
  }
}
class BO extends Xi {
  /**
  * @inheritDoc
  */
  constructor(n) {
    super(n);
    const t = this.document;
    t.on("keydown", (i, r) => {
      if (!this.isEnabled || r.keyCode != ye.tab || r.ctrlKey)
        return;
      const s = new fo(t, "tab", t.selection.getFirstRange());
      t.fire(s, r), s.stop.called && i.stop();
    });
  }
  /**
  * @inheritDoc
  */
  observe() {
  }
  /**
  * @inheritDoc
  */
  stopObserving() {
  }
}
let FO = class extends (/* @__PURE__ */ pt()) {
  /**
  * @param stylesProcessor The styles processor instance.
  */
  constructor(t) {
    super();
    /**
    * Instance of the {@link module:engine/view/document~Document} associated with this view controller.
    */
    m(this, "document");
    /**
    * Instance of the {@link module:engine/view/domconverter~DomConverter domConverter} used by
    * {@link module:engine/view/view~View#_renderer renderer}
    * and {@link module:engine/view/observer/observer~Observer observers}.
    */
    m(this, "domConverter");
    /**
    * Roots of the DOM tree. Map on the `HTMLElement`s with roots names as keys.
    */
    m(this, "domRoots", /* @__PURE__ */ new Map());
    /**
    * Instance of the {@link module:engine/view/renderer~Renderer renderer}.
    */
    m(this, "_renderer");
    /**
    * A DOM root attributes cache. It saves the initial values of DOM root attributes before the DOM element
    * is {@link module:engine/view/view~View#attachDomRoot attached} to the view so later on, when
    * the view is destroyed ({@link module:engine/view/view~View#detachDomRoot}), they can be easily restored.
    * This way, the DOM element can go back to the (clean) state as if the editing view never used it.
    */
    m(this, "_initialDomRootAttributes", /* @__PURE__ */ new WeakMap());
    /**
    * Map of registered {@link module:engine/view/observer/observer~Observer observers}.
    */
    m(this, "_observers", /* @__PURE__ */ new Map());
    /**
    * DowncastWriter instance used in {@link #change change method} callbacks.
    */
    m(this, "_writer");
    /**
    * Is set to `true` when {@link #change view changes} are currently in progress.
    */
    m(this, "_ongoingChange", !1);
    /**
    * Used to prevent calling {@link #forceRender} and {@link #change} during rendering view to the DOM.
    */
    m(this, "_postFixersInProgress", !1);
    /**
    * Internal flag to temporary disable rendering. See the usage in the {@link #_disableRendering}.
    */
    m(this, "_renderingDisabled", !1);
    /**
    * Internal flag that disables rendering when there are no changes since the last rendering.
    * It stores information about changed selection and changed elements from attached document roots.
    */
    m(this, "_hasChangedSinceTheLastRendering", !1);
    this.document = new jE(t), this.domConverter = new ZE(this.document), this.set("isRenderingInProgress", !1), this.set("hasDomSelection", !1), this._renderer = new mO(this.domConverter, this.document.selection), this._renderer.bind("isFocused", "isSelecting", "isComposing").to(this.document, "isFocused", "isSelecting", "isComposing"), this._writer = new KE(this.document), this.addObserver(tT), this.addObserver(Tl), this.addObserver(RO), this.addObserver(PO), this.addObserver(OO), this.addObserver(LO), this.addObserver(MO), this.addObserver(DO), this.addObserver(BO), hO(this), rO(this), this.on("render", () => {
      this._render(), this.document.fire("layoutChanged"), this._hasChangedSinceTheLastRendering = !1;
    }), this.listenTo(this.document.selection, "change", () => {
      this._hasChangedSinceTheLastRendering = !0;
    }), this.listenTo(this.document, "change:isFocused", () => {
      this._hasChangedSinceTheLastRendering = !0;
    }), he.isiOS && this.listenTo(this.document, "blur", (i, r) => {
      this.domConverter.mapDomToView(r.domEvent.relatedTarget) || this.domConverter._clearDomSelection();
    }), this.listenTo(this.document, "mutations", (i, { mutations: r }) => {
      r.forEach((s) => this._renderer.markToSync(s.type, s.node));
    }, {
      priority: "low"
    }), this.listenTo(this.document, "mutations", () => {
      this.forceRender();
    }, {
      priority: "lowest"
    });
  }
  /**
  * Attaches a DOM root element to the view element and enable all observers on that element.
  * Also {@link module:engine/view/renderer~Renderer#markToSync mark element} to be synchronized
  * with the view what means that all child nodes will be removed and replaced with content of the view root.
  *
  * This method also will change view element name as the same as tag name of given dom root.
  * Name is always transformed to lower case.
  *
  * **Note:** Use {@link #detachDomRoot `detachDomRoot()`} to revert this action.
  *
  * @param domRoot DOM root element.
  * @param name Name of the root.
  */
  attachDomRoot(t, i = "main") {
    const r = this.document.getRoot(i);
    r._name = t.tagName.toLowerCase();
    const s = {};
    for (const { name: a, value: u } of Array.from(t.attributes))
      s[a] = u, a === "class" ? this._writer.addClass(u.split(" "), r) : r.hasAttribute(a) || this._writer.setAttribute(a, u, r);
    this._initialDomRootAttributes.set(t, s);
    const o = () => {
      this._writer.setAttribute("contenteditable", (!r.isReadOnly).toString(), r), r.isReadOnly ? this._writer.addClass("ck-read-only", r) : this._writer.removeClass("ck-read-only", r);
    };
    o(), this.domRoots.set(i, t), this.domConverter.bindElements(t, r), this._renderer.markToSync("children", r), this._renderer.markToSync("attributes", r), this._renderer.domDocuments.add(t.ownerDocument), r.on("change:children", (a, u) => this._renderer.markToSync("children", u)), r.on("change:attributes", (a, u) => this._renderer.markToSync("attributes", u)), r.on("change:text", (a, u) => this._renderer.markToSync("text", u)), r.on("change:isReadOnly", () => this.change(o)), r.on("change", () => {
      this._hasChangedSinceTheLastRendering = !0;
    });
    for (const a of this._observers.values())
      a.observe(t, i);
  }
  /**
  * Detaches a DOM root element from the view element and restores its attributes to the state before
  * {@link #attachDomRoot `attachDomRoot()`}.
  *
  * @param name Name of the root to detach.
  */
  detachDomRoot(t) {
    const i = this.domRoots.get(t);
    Array.from(i.attributes).forEach(({ name: s }) => i.removeAttribute(s));
    const r = this._initialDomRootAttributes.get(i);
    for (const s in r)
      i.setAttribute(s, r[s]);
    this.domRoots.delete(t), this.domConverter.unbindDomElement(i);
    for (const s of this._observers.values())
      s.stopObserving(i);
  }
  /**
  * Gets DOM root element.
  *
  * @param name  Name of the root.
  * @returns DOM root element instance.
  */
  getDomRoot(t = "main") {
    return this.domRoots.get(t);
  }
  /**
  * Creates observer of the given type if not yet created, {@link module:engine/view/observer/observer~Observer#enable enables} it
  * and {@link module:engine/view/observer/observer~Observer#observe attaches} to all existing and future
  * {@link #domRoots DOM roots}.
  *
  * Note: Observers are recognized by their constructor (classes). A single observer will be instantiated and used only
  * when registered for the first time. This means that features and other components can register a single observer
  * multiple times without caring whether it has been already added or not.
  *
  * @param ObserverConstructor The constructor of an observer to add.
  * Should create an instance inheriting from {@link module:engine/view/observer/observer~Observer}.
  * @returns Added observer instance.
  */
  addObserver(t) {
    let i = this._observers.get(t);
    if (i)
      return i;
    i = new t(this), this._observers.set(t, i);
    for (const [r, s] of this.domRoots)
      i.observe(s, r);
    return i.enable(), i;
  }
  /**
  * Returns observer of the given type or `undefined` if such observer has not been added yet.
  *
  * @param ObserverConstructor The constructor of an observer to get.
  * @returns Observer instance or undefined.
  */
  getObserver(t) {
    return this._observers.get(t);
  }
  /**
  * Disables all added observers.
  */
  disableObservers() {
    for (const t of this._observers.values())
      t.disable();
  }
  /**
  * Enables all added observers.
  */
  enableObservers() {
    for (const t of this._observers.values())
      t.enable();
  }
  /**
  * Scrolls the page viewport and {@link #domRoots} with their ancestors to reveal the
  * caret, **if not already visible to the user**.
  *
  * **Note**: Calling this method fires the {@link module:engine/view/view~ViewScrollToTheSelectionEvent} event that
  * allows custom behaviors.
  *
  * @param options Additional configuration of the scrolling behavior.
  * @param options.viewportOffset A distance between the DOM selection and the viewport boundary to be maintained
  * while scrolling to the selection (default is 20px). Setting this value to `0` will reveal the selection precisely at
  * the viewport boundary.
  * @param options.ancestorOffset A distance between the DOM selection and scrollable DOM root ancestor(s) to be maintained
  * while scrolling to the selection (default is 20px). Setting this value to `0` will reveal the selection precisely at
  * the scrollable ancestor(s) boundary.
  * @param options.alignToTop When set `true`, the DOM selection will be aligned to the top of the viewport if not already visible
  * (see `forceScroll` to learn more).
  * @param options.forceScroll When set `true`, the DOM selection will be aligned to the top of the viewport and scrollable ancestors
  * whether it is already visible or not. This option will only work when `alignToTop` is `true`.
  */
  scrollToTheSelection({ alignToTop: t, forceScroll: i, viewportOffset: r = 20, ancestorOffset: s = 20 } = {}) {
    const o = this.document.selection.getFirstRange();
    if (!o)
      return;
    const a = ui({
      alignToTop: t,
      forceScroll: i,
      viewportOffset: r,
      ancestorOffset: s
    });
    typeof r == "number" && (r = {
      top: r,
      bottom: r,
      left: r,
      right: r
    });
    const u = {
      target: this.domConverter.viewRangeToDom(o),
      viewportOffset: r,
      ancestorOffset: s,
      alignToTop: t,
      forceScroll: i
    };
    this.fire("scrollToTheSelection", u, a), dP(u);
  }
  /**
  * It will focus DOM element representing {@link module:engine/view/editableelement~EditableElement EditableElement}
  * that is currently having selection inside.
  */
  focus() {
    if (!this.document.isFocused) {
      const t = this.document.selection.editableElement;
      t && (this.domConverter.focus(t), this.forceRender());
    }
  }
  /**
  * The `change()` method is the primary way of changing the view. You should use it to modify any node in the view tree.
  * It makes sure that after all changes are made the view is rendered to the DOM (assuming that the view will be changed
  * inside the callback). It prevents situations when the DOM is updated when the view state is not yet correct. It allows
  * to nest calls one inside another and still performs a single rendering after all those changes are made.
  * It also returns the return value of its callback.
  *
  * ```ts
  * const text = view.change( writer => {
  * 	const newText = writer.createText( 'foo' );
  * 	writer.insert( position1, newText );
  *
  * 	view.change( writer => {
  * 		writer.insert( position2, writer.createText( 'bar' ) );
  * 	} );
  *
  * 	writer.remove( range );
  *
  * 	return newText;
  * } );
  * ```
  *
  * When the outermost change block is done and rendering to the DOM is over the
  * {@link module:engine/view/view~View#event:render `View#render`} event is fired.
  *
  * This method throws a `applying-view-changes-on-rendering` error when
  * the change block is used after rendering to the DOM has started.
  *
  * @param callback Callback function which may modify the view.
  * @returns Value returned by the callback.
  */
  change(t) {
    if (this.isRenderingInProgress || this._postFixersInProgress)
      throw new v("cannot-change-view-tree", this);
    try {
      if (this._ongoingChange)
        return t(this._writer);
      this._ongoingChange = !0;
      const i = t(this._writer);
      return this._ongoingChange = !1, !this._renderingDisabled && this._hasChangedSinceTheLastRendering && (this._postFixersInProgress = !0, this.document._callPostFixers(this._writer), this._postFixersInProgress = !1, this.fire("render")), i;
    } catch (i) {
      /* istanbul ignore next -- @preserve */
      v.rethrowUnexpectedError(i, this);
    }
  }
  /**
  * Forces rendering {@link module:engine/view/document~Document view document} to DOM. If any view changes are
  * currently in progress, rendering will start after all {@link #change change blocks} are processed.
  *
  * Note that this method is dedicated for special cases. All view changes should be wrapped in the {@link #change}
  * block and the view will automatically check whether it needs to render DOM or not.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `applying-view-changes-on-rendering` when
  * trying to re-render when rendering to DOM has already started.
  */
  forceRender() {
    this._hasChangedSinceTheLastRendering = !0, this.getObserver(Tl).flush(), this.change(() => {
    });
  }
  /**
  * Destroys this instance. Makes sure that all observers are destroyed and listeners removed.
  */
  destroy() {
    for (const t of this._observers.values())
      t.destroy();
    this.document.destroy(), this.stopListening();
  }
  /**
  * Creates position at the given location. The location can be specified as:
  *
  * * a {@link module:engine/view/position~Position position},
  * * parent element and offset (offset defaults to `0`),
  * * parent element and `'end'` (sets position at the end of that element),
  * * {@link module:engine/view/item~Item view item} and `'before'` or `'after'` (sets position before or after given view item).
  *
  * This method is a shortcut to other constructors such as:
  *
  * * {@link #createPositionBefore},
  * * {@link #createPositionAfter},
  *
  * @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/view/item~Item view item}.
  */
  createPositionAt(t, i) {
    return ne._createAt(t, i);
  }
  /**
  * Creates a new position after given view item.
  *
  * @param item View item after which the position should be located.
  */
  createPositionAfter(t) {
    return ne._createAfter(t);
  }
  /**
  * Creates a new position before given view item.
  *
  * @param item View item before which the position should be located.
  */
  createPositionBefore(t) {
    return ne._createBefore(t);
  }
  /**
  * Creates a range spanning from `start` position to `end` position.
  *
  * **Note:** This factory method creates it's own {@link module:engine/view/position~Position} instances basing on passed values.
  *
  * @param start Start position.
  * @param end End position. If not set, range will be collapsed at `start` position.
  */
  createRange(t, i) {
    return new Re(t, i);
  }
  /**
  * Creates a range that starts before given {@link module:engine/view/item~Item view item} and ends after it.
  */
  createRangeOn(t) {
    return Re._createOn(t);
  }
  /**
  * Creates a range inside an {@link module:engine/view/element~Element element} which starts before the first child of
  * that element and ends after the last child of that element.
  *
  * @param element Element which is a parent for the range.
  */
  createRangeIn(t) {
    return Re._createIn(t);
  }
  createSelection(...t) {
    return new gr(...t);
  }
  /**
  * Disables or enables rendering. If the flag is set to `true` then the rendering will be disabled.
  * If the flag is set to `false` and if there was some change in the meantime, then the rendering action will be performed.
  *
  * @internal
  * @param flag A flag indicates whether the rendering should be disabled.
  */
  _disableRendering(t) {
    this._renderingDisabled = t, t == !1 && this.change(() => {
    });
  }
  /**
  * Renders all changes. In order to avoid triggering the observers (e.g. selection) all observers are disabled
  * before rendering and re-enabled after that.
  */
  _render() {
    this.isRenderingInProgress = !0, this.disableObservers(), this._renderer.render(), this.enableObservers(), this.isRenderingInProgress = !1;
  }
};
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class Ir {
  /* istanbul ignore next -- @preserve */
  is() {
    throw new Error("is() method is abstract");
  }
}
class ii extends Ir {
  /**
  * Creates a text proxy.
  *
  * @internal
  * @param textNode Text node which part is represented by this text proxy.
  * @param offsetInText Offset in {@link module:engine/model/textproxy~TextProxy#textNode text node} from which the text proxy
  * starts.
  * @param length Text proxy length, that is how many text node's characters, starting from `offsetInText` it represents.
  */
  constructor(t, i, r) {
    super();
    /**
    * Text node which part is represented by this text proxy.
    */
    m(this, "textNode");
    /**
    * Text data represented by this text proxy.
    */
    m(this, "data");
    /**
    * Offset in {@link module:engine/model/textproxy~TextProxy#textNode text node} from which the text proxy starts.
    */
    m(this, "offsetInText");
    if (this.textNode = t, i < 0 || i > t.offsetSize)
      throw new v("model-textproxy-wrong-offsetintext", this);
    if (r < 0 || i + r > t.offsetSize)
      throw new v("model-textproxy-wrong-length", this);
    this.data = t.data.substring(i, i + r), this.offsetInText = i;
  }
  /**
  * Offset at which this text proxy starts in it's parent.
  *
  * @see module:engine/model/node~Node#startOffset
  */
  get startOffset() {
    return this.textNode.startOffset !== null ? this.textNode.startOffset + this.offsetInText : null;
  }
  /**
  * Offset size of this text proxy. Equal to the number of characters represented by the text proxy.
  *
  * @see module:engine/model/node~Node#offsetSize
  */
  get offsetSize() {
    return this.data.length;
  }
  /**
  * Offset at which this text proxy ends in it's parent.
  *
  * @see module:engine/model/node~Node#endOffset
  */
  get endOffset() {
    return this.startOffset !== null ? this.startOffset + this.offsetSize : null;
  }
  /**
  * Flag indicating whether `TextProxy` instance covers only part of the original {@link module:engine/model/text~Text text node}
  * (`true`) or the whole text node (`false`).
  *
  * This is `false` when text proxy starts at the very beginning of {@link module:engine/model/textproxy~TextProxy#textNode textNode}
  * ({@link module:engine/model/textproxy~TextProxy#offsetInText offsetInText} equals `0`) and text proxy sizes is equal to
  * text node size.
  */
  get isPartial() {
    return this.offsetSize !== this.textNode.offsetSize;
  }
  /**
  * Parent of this text proxy, which is same as parent of text node represented by this text proxy.
  */
  get parent() {
    return this.textNode.parent;
  }
  /**
  * Root of this text proxy, which is same as root of text node represented by this text proxy.
  */
  get root() {
    return this.textNode.root;
  }
  /**
  * Gets path to this text proxy.
  *
  * @see module:engine/model/node~Node#getPath
  */
  getPath() {
    const t = this.textNode.getPath();
    return t.length > 0 && (t[t.length - 1] += this.offsetInText), t;
  }
  /**
  * Returns ancestors array of this text proxy.
  *
  * @param options Options object.
  * @param options.includeSelf When set to `true` this text proxy will be also included in parent's array.
  * @param options.parentFirst When set to `true`, array will be sorted from text proxy parent to root element,
  * otherwise root element will be the first item in the array.
  * @returns Array with ancestors.
  */
  getAncestors(t = {}) {
    const i = [];
    let r = t.includeSelf ? this : this.parent;
    for (; r; )
      i[t.parentFirst ? "push" : "unshift"](r), r = r.parent;
    return i;
  }
  /**
  * Checks if this text proxy has an attribute for given key.
  *
  * @param key Key of attribute to check.
  * @returns `true` if attribute with given key is set on text proxy, `false` otherwise.
  */
  hasAttribute(t) {
    return this.textNode.hasAttribute(t);
  }
  /**
  * Gets an attribute value for given key or `undefined` if that attribute is not set on text proxy.
  *
  * @param key Key of attribute to look for.
  * @returns Attribute value or `undefined`.
  */
  getAttribute(t) {
    return this.textNode.getAttribute(t);
  }
  /**
  * Returns iterator that iterates over this node's attributes. Attributes are returned as arrays containing two
  * items. First one is attribute key and second is attribute value.
  *
  * This format is accepted by native `Map` object and also can be passed in `Node` constructor.
  */
  getAttributes() {
    return this.textNode.getAttributes();
  }
  /**
  * Returns iterator that iterates over this node's attribute keys.
  */
  getAttributeKeys() {
    return this.textNode.getAttributeKeys();
  }
}
ii.prototype.is = function(e) {
  return e === "$textProxy" || e === "model:$textProxy" || // This are legacy values kept for backward compatibility.
  e === "textProxy" || e === "model:textProxy";
};
class Ui {
  /**
  * Creates a range iterator. All parameters are optional, but you have to specify either `boundaries` or `startPosition`.
  *
  * @param options Object with configuration.
  */
  constructor(n) {
    /**
    * Walking direction. Defaults `'forward'`.
    */
    m(this, "direction");
    /**
    * Iterator boundaries.
    *
    * When the iterator is walking `'forward'` on the end of boundary or is walking `'backward'`
    * on the start of boundary, then `{ done: true }` is returned.
    *
    * If boundaries are not defined they are set before first and after last child of the root node.
    */
    m(this, "boundaries");
    /**
    * Flag indicating whether all consecutive characters with the same attributes should be
    * returned as one {@link module:engine/model/textproxy~TextProxy} (`true`) or one by one (`false`).
    */
    m(this, "singleCharacters");
    /**
    * Flag indicating whether iterator should enter elements or not. If the iterator is shallow child nodes of any
    * iterated node will not be returned along with `elementEnd` tag.
    */
    m(this, "shallow");
    /**
    * Flag indicating whether iterator should ignore `elementEnd` tags. If the option is true walker will not
    * return a parent node of the start position. If this option is `true` each {@link module:engine/model/element~Element} will
    * be returned once, while if the option is `false` they might be returned twice:
    * for `'elementStart'` and `'elementEnd'`.
    */
    m(this, "ignoreElementEnd");
    /**
    * Iterator position. This is always static position, even if the initial position was a
    * {@link module:engine/model/liveposition~LivePosition live position}. If start position is not defined then position depends
    * on {@link #direction}. If direction is `'forward'` position starts form the beginning, when direction
    * is `'backward'` position starts from the end.
    */
    m(this, "_position");
    /**
    * Start boundary cached for optimization purposes.
    */
    m(this, "_boundaryStartParent");
    /**
    * End boundary cached for optimization purposes.
    */
    m(this, "_boundaryEndParent");
    /**
    * Parent of the most recently visited node. Cached for optimization purposes.
    */
    m(this, "_visitedParent");
    if (!n || !n.boundaries && !n.startPosition)
      throw new v("model-tree-walker-no-start-position", null);
    const t = n.direction || "forward";
    if (t != "forward" && t != "backward")
      throw new v("model-tree-walker-unknown-direction", n, {
        direction: t
      });
    this.direction = t, this.boundaries = n.boundaries || null, n.startPosition ? this._position = n.startPosition.clone() : this._position = z._createAt(this.boundaries[this.direction == "backward" ? "end" : "start"]), this.position.stickiness = "toNone", this.singleCharacters = !!n.singleCharacters, this.shallow = !!n.shallow, this.ignoreElementEnd = !!n.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null, this._visitedParent = this.position.parent;
  }
  /**
  * Iterable interface.
  *
  * @returns {Iterable.<module:engine/model/treewalker~TreeWalkerValue>}
  */
  [Symbol.iterator]() {
    return this;
  }
  /**
  * Iterator position. This is always static position, even if the initial position was a
  * {@link module:engine/model/liveposition~LivePosition live position}. If start position is not defined then position depends
  * on {@link #direction}. If direction is `'forward'` position starts form the beginning, when direction
  * is `'backward'` position starts from the end.
  */
  get position() {
    return this._position;
  }
  /**
  * Moves {@link #position} in the {@link #direction} skipping values as long as the callback function returns `true`.
  *
  * For example:
  *
  * ```ts
  * walker.skip( value => value.type == 'text' ); // <paragraph>[]foo</paragraph> -> <paragraph>foo[]</paragraph>
  * walker.skip( () => true ); // Move the position to the end: <paragraph>[]foo</paragraph> -> <paragraph>foo</paragraph>[]
  * walker.skip( () => false ); // Do not move the position.
  * ```
  *
  * @param skip Callback function. Gets {@link module:engine/model/treewalker~TreeWalkerValue} and should
  * return `true` if the value should be skipped or `false` if not.
  */
  skip(n) {
    let t, i, r, s;
    do
      r = this.position, s = this._visitedParent, { done: t, value: i } = this.next();
    while (!t && n(i));
    t || (this._position = r, this._visitedParent = s);
  }
  /**
  * Moves tree walker {@link #position} to provided `position`. Tree walker will
  * continue traversing from that position.
  *
  * Note: in contrary to {@link ~TreeWalker#skip}, this method does not iterate over the nodes along the way.
  * It simply sets the current tree walker position to a new one.
  * From the performance standpoint, it is better to use {@link ~TreeWalker#jumpTo} rather than {@link ~TreeWalker#skip}.
  *
  * If the provided position is before the start boundary, the position will be
  * set to the start boundary. If the provided position is after the end boundary,
  * the position will be set to the end boundary.
  * This is done to prevent the treewalker from traversing outside the boundaries.
  *
  * @param position Position to jump to.
  */
  jumpTo(n) {
    this._boundaryStartParent && n.isBefore(this.boundaries.start) ? n = this.boundaries.start : this._boundaryEndParent && n.isAfter(this.boundaries.end) && (n = this.boundaries.end), this._position = n.clone(), this._visitedParent = n.parent;
  }
  /**
  * Gets the next tree walker's value.
  */
  next() {
    return this.direction == "forward" ? this._next() : this._previous();
  }
  /**
  * Makes a step forward in model. Moves the {@link #position} to the next position and returns the encountered value.
  */
  _next() {
    const n = this.position, t = this.position.clone(), i = this._visitedParent;
    if (i.parent === null && t.offset === i.maxOffset)
      return {
        done: !0,
        value: void 0
      };
    if (i === this._boundaryEndParent && t.offset == this.boundaries.end.offset)
      return {
        done: !0,
        value: void 0
      };
    const r = aa(t, i), s = r || iT(t, i, r);
    if (s && s.is("model:element")) {
      if (!this.shallow)
        t.path.push(0), this._visitedParent = s;
      else {
        if (this.boundaries && this.boundaries.end.isBefore(t))
          return {
            done: !0,
            value: void 0
          };
        t.offset++;
      }
      return this._position = t, Fr("elementStart", s, n, t, 1);
    }
    if (s && s.is("model:$text")) {
      let o;
      if (this.singleCharacters)
        o = 1;
      else {
        let l = s.endOffset;
        this._boundaryEndParent == i && this.boundaries.end.offset < l && (l = this.boundaries.end.offset), o = l - t.offset;
      }
      const a = t.offset - s.startOffset, u = new ii(s, a, o);
      return t.offset += o, this._position = t, Fr("text", u, n, t, o);
    }
    return t.path.pop(), t.offset++, this._position = t, this._visitedParent = i.parent, this.ignoreElementEnd ? this._next() : Fr("elementEnd", i, n, t);
  }
  /**
  * Makes a step backward in model. Moves the {@link #position} to the previous position and returns the encountered value.
  */
  _previous() {
    const n = this.position, t = this.position.clone(), i = this._visitedParent;
    if (i.parent === null && t.offset === 0)
      return {
        done: !0,
        value: void 0
      };
    if (i == this._boundaryStartParent && t.offset == this.boundaries.start.offset)
      return {
        done: !0,
        value: void 0
      };
    const r = t.parent, s = aa(t, r), o = s || rT(t, r, s);
    if (o && o.is("model:element"))
      return t.offset--, this.shallow ? (this._position = t, Fr("elementStart", o, n, t, 1)) : (t.path.push(o.maxOffset), this._position = t, this._visitedParent = o, this.ignoreElementEnd ? this._previous() : Fr("elementEnd", o, n, t));
    if (o && o.is("model:$text")) {
      let a;
      if (this.singleCharacters)
        a = 1;
      else {
        let c = o.startOffset;
        this._boundaryStartParent == i && this.boundaries.start.offset > c && (c = this.boundaries.start.offset), a = t.offset - c;
      }
      const u = t.offset - o.startOffset, l = new ii(o, u - a, a);
      return t.offset -= a, this._position = t, Fr("text", l, n, t, a);
    }
    return t.path.pop(), this._position = t, this._visitedParent = i.parent, Fr("elementStart", i, n, t, 1);
  }
}
function Fr(e, n, t, i, r) {
  return {
    done: !1,
    value: {
      type: e,
      item: n,
      previousPosition: t,
      nextPosition: i,
      length: r
    }
  };
}
class z extends Ir {
  /**
  * Creates a position.
  *
  * @param root Root of the position.
  * @param path Position path. See {@link module:engine/model/position~Position#path}.
  * @param stickiness Position stickiness. See {@link module:engine/model/position~PositionStickiness}.
  */
  constructor(t, i, r = "toNone") {
    super();
    /**
    * Root of the position path.
    */
    m(this, "root");
    /**
    * Position of the node in the tree. **Path contains offsets, not indexes.**
    *
    * Position can be placed before, after or in a {@link module:engine/model/node~Node node} if that node has
    * {@link module:engine/model/node~Node#offsetSize} greater than `1`. Items in position path are
    * {@link module:engine/model/node~Node#startOffset starting offsets} of position ancestors, starting from direct root children,
    * down to the position offset in it's parent.
    *
    * ```
    * ROOT
    *  |- P            before: [ 0 ]         after: [ 1 ]
    *  |- UL           before: [ 1 ]         after: [ 2 ]
    *     |- LI        before: [ 1, 0 ]      after: [ 1, 1 ]
    *     |  |- foo    before: [ 1, 0, 0 ]   after: [ 1, 0, 3 ]
    *     |- LI        before: [ 1, 1 ]      after: [ 1, 2 ]
    *        |- bar    before: [ 1, 1, 0 ]   after: [ 1, 1, 3 ]
    * ```
    *
    * `foo` and `bar` are representing {@link module:engine/model/text~Text text nodes}. Since text nodes has offset size
    * greater than `1` you can place position offset between their start and end:
    *
    * ```
    * ROOT
    *  |- P
    *  |- UL
    *     |- LI
    *     |  |- f^o|o  ^ has path: [ 1, 0, 1 ]   | has path: [ 1, 0, 2 ]
    *     |- LI
    *        |- b^a|r  ^ has path: [ 1, 1, 1 ]   | has path: [ 1, 1, 2 ]
    * ```
    */
    m(this, "path");
    /**
    * Position stickiness. See {@link module:engine/model/position~PositionStickiness}.
    */
    m(this, "stickiness");
    if (!t.is("element") && !t.is("documentFragment"))
      throw new v("model-position-root-invalid", t);
    if (!Array.isArray(i) || i.length === 0)
      throw new v("model-position-path-incorrect-format", t, {
        path: i
      });
    t.is("rootElement") ? i = i.slice() : (i = [
      ...t.getPath(),
      ...i
    ], t = t.root), this.root = t, this.path = i, this.stickiness = r;
  }
  /**
  * Offset at which this position is located in its {@link module:engine/model/position~Position#parent parent}. It is equal
  * to the last item in position {@link module:engine/model/position~Position#path path}.
  *
  * @type {Number}
  */
  get offset() {
    return this.path[this.path.length - 1];
  }
  set offset(t) {
    this.path[this.path.length - 1] = t;
  }
  /**
  * Parent element of this position.
  *
  * Keep in mind that `parent` value is calculated when the property is accessed.
  * If {@link module:engine/model/position~Position#path position path}
  * leads to a non-existing element, `parent` property will throw error.
  *
  * Also it is a good idea to cache `parent` property if it is used frequently in an algorithm (i.e. in a long loop).
  */
  get parent() {
    let t = this.root;
    for (let i = 0; i < this.path.length - 1; i++)
      if (t = t.getChildAtOffset(this.path[i]), !t)
        throw new v("model-position-path-incorrect", this, {
          position: this
        });
    if (t.is("$text"))
      throw new v("model-position-path-incorrect", this, {
        position: this
      });
    return t;
  }
  /**
  * Position {@link module:engine/model/position~Position#offset offset} converted to an index in position's parent node. It is
  * equal to the {@link module:engine/model/node~Node#index index} of a node after this position. If position is placed
  * in text node, position index is equal to the index of that text node.
  */
  get index() {
    return this.parent.offsetToIndex(this.offset);
  }
  /**
  * Returns {@link module:engine/model/text~Text text node} instance in which this position is placed or `null` if this
  * position is not in a text node.
  */
  get textNode() {
    return aa(this, this.parent);
  }
  /**
  * Node directly after this position. Returns `null` if this position is at the end of its parent, or if it is in a text node.
  */
  get nodeAfter() {
    const t = this.parent;
    return iT(this, t, aa(this, t));
  }
  /**
  * Node directly before this position. Returns `null` if this position is at the start of its parent, or if it is in a text node.
  */
  get nodeBefore() {
    const t = this.parent;
    return rT(this, t, aa(this, t));
  }
  /**
  * Is `true` if position is at the beginning of its {@link module:engine/model/position~Position#parent parent}, `false` otherwise.
  */
  get isAtStart() {
    return this.offset === 0;
  }
  /**
  * Is `true` if position is at the end of its {@link module:engine/model/position~Position#parent parent}, `false` otherwise.
  */
  get isAtEnd() {
    return this.offset == this.parent.maxOffset;
  }
  /**
  * Checks whether the position is valid in current model tree, that is whether it points to an existing place in the model.
  */
  isValid() {
    if (this.offset < 0)
      return !1;
    let t = this.root;
    for (let i = 0; i < this.path.length - 1; i++)
      if (t = t.getChildAtOffset(this.path[i]), !t)
        return !1;
    return this.offset <= t.maxOffset;
  }
  /**
  * Checks whether this position is before or after given position.
  *
  * This method is safe to use it on non-existing positions (for example during operational transformation).
  */
  compareWith(t) {
    if (this.root != t.root)
      return "different";
    const i = sn(this.path, t.path);
    switch (i) {
      case "same":
        return "same";
      case "prefix":
        return "before";
      case "extension":
        return "after";
      default:
        return this.path[i] < t.path[i] ? "before" : "after";
    }
  }
  /**
  * Gets the farthest position which matches the callback using
  * {@link module:engine/model/treewalker~TreeWalker TreeWalker}.
  *
  * For example:
  *
  * ```ts
  * getLastMatchingPosition( value => value.type == 'text' );
  * // <paragraph>[]foo</paragraph> -> <paragraph>foo[]</paragraph>
  *
  * getLastMatchingPosition( value => value.type == 'text', { direction: 'backward' } );
  * // <paragraph>foo[]</paragraph> -> <paragraph>[]foo</paragraph>
  *
  * getLastMatchingPosition( value => false );
  * // Do not move the position.
  * ```
  *
  * @param skip Callback function. Gets {@link module:engine/model/treewalker~TreeWalkerValue} and should
  * return `true` if the value should be skipped or `false` if not.
  * @param options Object with configuration options. See {@link module:engine/model/treewalker~TreeWalker}.
  *
  * @returns The position after the last item which matches the `skip` callback test.
  */
  getLastMatchingPosition(t, i = {}) {
    i.startPosition = this;
    const r = new Ui(i);
    return r.skip(t), r.position;
  }
  /**
  * Returns a path to this position's parent. Parent path is equal to position {@link module:engine/model/position~Position#path path}
  * but without the last item.
  *
  * This method is safe to use it on non-existing positions (for example during operational transformation).
  *
  * @returns Path to the parent.
  */
  getParentPath() {
    return this.path.slice(0, -1);
  }
  /**
  * Returns ancestors array of this position, that is this position's parent and its ancestors.
  *
  * @returns Array with ancestors.
  */
  getAncestors() {
    const t = this.parent;
    return t.is("documentFragment") ? [
      t
    ] : t.getAncestors({
      includeSelf: !0
    });
  }
  /**
  * Returns the parent element of the given name. Returns null if the position is not inside the desired parent.
  *
  * @param parentName The name of the parent element to find.
  */
  findAncestor(t) {
    const i = this.parent;
    return i.is("element") ? i.findAncestor(t, {
      includeSelf: !0
    }) : null;
  }
  /**
  * Returns the slice of two position {@link #path paths} which is identical. The {@link #root roots}
  * of these two paths must be identical.
  *
  * This method is safe to use it on non-existing positions (for example during operational transformation).
  *
  * @param position The second position.
  * @returns The common path.
  */
  getCommonPath(t) {
    if (this.root != t.root)
      return [];
    const i = sn(this.path, t.path), r = typeof i == "string" ? Math.min(this.path.length, t.path.length) : i;
    return this.path.slice(0, r);
  }
  /**
  * Returns an {@link module:engine/model/element~Element} or {@link module:engine/model/documentfragment~DocumentFragment}
  * which is a common ancestor of both positions. The {@link #root roots} of these two positions must be identical.
  *
  * @param position The second position.
  */
  getCommonAncestor(t) {
    const i = this.getAncestors(), r = t.getAncestors();
    let s = 0;
    for (; i[s] == r[s] && i[s]; )
      s++;
    return s === 0 ? null : i[s - 1];
  }
  /**
  * Returns a new instance of `Position`, that has same {@link #parent parent} but it's offset
  * is shifted by `shift` value (can be a negative value).
  *
  * This method is safe to use it on non-existing positions (for example during operational transformation).
  *
  * @param shift Offset shift. Can be a negative value.
  * @returns Shifted position.
  */
  getShiftedBy(t) {
    const i = this.clone(), r = i.offset + t;
    return i.offset = r < 0 ? 0 : r, i;
  }
  /**
  * Checks whether this position is after given position.
  *
  * This method is safe to use it on non-existing positions (for example during operational transformation).
  *
  * @see module:engine/model/position~Position#isBefore
  * @param  otherPosition Position to compare with.
  * @returns True if this position is after given position.
  */
  isAfter(t) {
    return this.compareWith(t) == "after";
  }
  /**
  * Checks whether this position is before given position.
  *
  * **Note:** watch out when using negation of the value returned by this method, because the negation will also
  * be `true` if positions are in different roots and you might not expect this. You should probably use
  * `a.isAfter( b ) || a.isEqual( b )` or `!a.isBefore( p ) && a.root == b.root` in most scenarios. If your
  * condition uses multiple `isAfter` and `isBefore` checks, build them so they do not use negated values, i.e.:
  *
  * ```ts
  * if ( a.isBefore( b ) && c.isAfter( d ) ) {
  * 	// do A.
  * } else {
  * 	// do B.
  * }
  * ```
  *
  * or, if you have only one if-branch:
  *
  * ```ts
  * if ( !( a.isBefore( b ) && c.isAfter( d ) ) {
  * 	// do B.
  * }
  * ```
  *
  * rather than:
  *
  * ```ts
  * if ( !a.isBefore( b ) || && !c.isAfter( d ) ) {
  * 	// do B.
  * } else {
  * 	// do A.
  * }
  * ```
  *
  * This method is safe to use it on non-existing positions (for example during operational transformation).
  *
  * @param otherPosition Position to compare with.
  * @returns True if this position is before given position.
  */
  isBefore(t) {
    return this.compareWith(t) == "before";
  }
  /**
  * Checks whether this position is equal to given position.
  *
  * This method is safe to use it on non-existing positions (for example during operational transformation).
  *
  * @param otherPosition Position to compare with.
  * @returns True if positions are same.
  */
  isEqual(t) {
    return this.compareWith(t) == "same";
  }
  /**
  * Checks whether this position is touching given position. Positions touch when there are no text nodes
  * or empty nodes in a range between them. Technically, those positions are not equal but in many cases
  * they are very similar or even indistinguishable.
  *
  * @param otherPosition Position to compare with.
  * @returns True if positions touch.
  */
  isTouching(t) {
    if (this.root !== t.root)
      return !1;
    const i = Math.min(this.path.length, t.path.length);
    for (let r = 0; r < i; r++) {
      const s = this.path[r] - t.path[r];
      if (s < -1 || s > 1)
        return !1;
      if (s === 1)
        return Ip(t, this, r);
      if (s === -1)
        return Ip(this, t, r);
    }
    return this.path.length === t.path.length ? !0 : this.path.length > t.path.length ? Oh(this.path, i) : Oh(t.path, i);
  }
  /**
  * Checks if two positions are in the same parent.
  *
  * This method is safe to use it on non-existing positions (for example during operational transformation).
  *
  * @param position Position to compare with.
  * @returns `true` if positions have the same parent, `false` otherwise.
  */
  hasSameParentAs(t) {
    if (this.root !== t.root)
      return !1;
    const i = this.getParentPath(), r = t.getParentPath();
    return sn(i, r) == "same";
  }
  /**
  * Returns a copy of this position that is transformed by given `operation`.
  *
  * The new position's parameters are updated accordingly to the effect of the `operation`.
  *
  * For example, if `n` nodes are inserted before the position, the returned position {@link ~Position#offset} will be
  * increased by `n`. If the position was in a merged element, it will be accordingly moved to the new element, etc.
  *
  * This method is safe to use it on non-existing positions (for example during operational transformation).
  *
  * @param operation Operation to transform by.
  * @returns Transformed position.
  */
  getTransformedByOperation(t) {
    let i;
    switch (t.type) {
      case "insert":
        i = this._getTransformedByInsertOperation(t);
        break;
      case "move":
      case "remove":
      case "reinsert":
        i = this._getTransformedByMoveOperation(t);
        break;
      case "split":
        i = this._getTransformedBySplitOperation(t);
        break;
      case "merge":
        i = this._getTransformedByMergeOperation(t);
        break;
      default:
        i = z._createAt(this);
        break;
    }
    return i;
  }
  /**
  * Returns a copy of this position transformed by an insert operation.
  *
  * @internal
  */
  _getTransformedByInsertOperation(t) {
    return this._getTransformedByInsertion(t.position, t.howMany);
  }
  /**
  * Returns a copy of this position transformed by a move operation.
  *
  * @internal
  */
  _getTransformedByMoveOperation(t) {
    return this._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany);
  }
  /**
  * Returns a copy of this position transformed by a split operation.
  *
  * @internal
  */
  _getTransformedBySplitOperation(t) {
    const i = t.movedRange;
    return i.containsPosition(this) || i.start.isEqual(this) && this.stickiness == "toNext" ? this._getCombined(t.splitPosition, t.moveTargetPosition) : t.graveyardPosition ? this._getTransformedByMove(t.graveyardPosition, t.insertionPosition, 1) : this._getTransformedByInsertion(t.insertionPosition, 1);
  }
  /**
  * Returns a copy of this position transformed by merge operation.
  *
  * @internal
  */
  _getTransformedByMergeOperation(t) {
    const i = t.movedRange, r = i.containsPosition(this) || i.start.isEqual(this);
    let s;
    return r ? (s = this._getCombined(t.sourcePosition, t.targetPosition), t.sourcePosition.isBefore(t.targetPosition) && (s = s._getTransformedByDeletion(t.deletionPosition, 1))) : this.isEqual(t.deletionPosition) ? s = z._createAt(t.deletionPosition) : s = this._getTransformedByMove(t.deletionPosition, t.graveyardPosition, 1), s;
  }
  /**
  * Returns a copy of this position that is updated by removing `howMany` nodes starting from `deletePosition`.
  * It may happen that this position is in a removed node. If that is the case, `null` is returned instead.
  *
  * @internal
  * @param deletePosition Position before the first removed node.
  * @param howMany How many nodes are removed.
  * @returns Transformed position or `null`.
  */
  _getTransformedByDeletion(t, i) {
    const r = z._createAt(this);
    if (this.root != t.root)
      return r;
    if (sn(t.getParentPath(), this.getParentPath()) == "same") {
      if (t.offset < this.offset) {
        if (t.offset + i > this.offset)
          return null;
        r.offset -= i;
      }
    } else if (sn(t.getParentPath(), this.getParentPath()) == "prefix") {
      const s = t.path.length - 1;
      if (t.offset <= this.path[s]) {
        if (t.offset + i > this.path[s])
          return null;
        r.path[s] -= i;
      }
    }
    return r;
  }
  /**
  * Returns a copy of this position that is updated by inserting `howMany` nodes at `insertPosition`.
  *
  * @internal
  * @param insertPosition Position where nodes are inserted.
  * @param howMany How many nodes are inserted.
  * @returns Transformed position.
  */
  _getTransformedByInsertion(t, i) {
    const r = z._createAt(this);
    if (this.root != t.root)
      return r;
    if (sn(t.getParentPath(), this.getParentPath()) == "same")
      (t.offset < this.offset || t.offset == this.offset && this.stickiness != "toPrevious") && (r.offset += i);
    else if (sn(t.getParentPath(), this.getParentPath()) == "prefix") {
      const s = t.path.length - 1;
      t.offset <= this.path[s] && (r.path[s] += i);
    }
    return r;
  }
  /**
  * Returns a copy of this position that is updated by moving `howMany` nodes from `sourcePosition` to `targetPosition`.
  *
  * @internal
  * @param sourcePosition Position before the first element to move.
  * @param targetPosition Position where moved elements will be inserted.
  * @param howMany How many consecutive nodes to move, starting from `sourcePosition`.
  * @returns Transformed position.
  */
  _getTransformedByMove(t, i, r) {
    if (i = i._getTransformedByDeletion(t, r), t.isEqual(i))
      return z._createAt(this);
    const s = this._getTransformedByDeletion(t, r);
    return s === null || t.isEqual(this) && this.stickiness == "toNext" || t.getShiftedBy(r).isEqual(this) && this.stickiness == "toPrevious" ? this._getCombined(t, i) : s._getTransformedByInsertion(i, r);
  }
  /**
  * Returns a new position that is a combination of this position and given positions.
  *
  * The combined position is a copy of this position transformed by moving a range starting at `source` position
  * to the `target` position. It is expected that this position is inside the moved range.
  *
  * Example:
  *
  * ```ts
  * let original = model.createPositionFromPath( root, [ 2, 3, 1 ] );
  * let source = model.createPositionFromPath( root, [ 2, 2 ] );
  * let target = model.createPositionFromPath( otherRoot, [ 1, 1, 3 ] );
  * original._getCombined( source, target ); // path is [ 1, 1, 4, 1 ], root is `otherRoot`
  * ```
  *
  * Explanation:
  *
  * We have a position `[ 2, 3, 1 ]` and move some nodes from `[ 2, 2 ]` to `[ 1, 1, 3 ]`. The original position
  * was inside moved nodes and now should point to the new place. The moved nodes will be after
  * positions `[ 1, 1, 3 ]`, `[ 1, 1, 4 ]`, `[ 1, 1, 5 ]`. Since our position was in the second moved node,
  * the transformed position will be in a sub-tree of a node at `[ 1, 1, 4 ]`. Looking at original path, we
  * took care of `[ 2, 3 ]` part of it. Now we have to add the rest of the original path to the transformed path.
  * Finally, the transformed position will point to `[ 1, 1, 4, 1 ]`.
  *
  * @internal
  * @param source Beginning of the moved range.
  * @param target Position where the range is moved.
  * @returns Combined position.
  */
  _getCombined(t, i) {
    const r = t.path.length - 1, s = z._createAt(i);
    return s.stickiness = this.stickiness, s.offset = s.offset + this.path[r] - t.offset, s.path = [
      ...s.path,
      ...this.path.slice(r + 1)
    ], s;
  }
  /**
  * @inheritDoc
  */
  toJSON() {
    return {
      root: this.root.toJSON(),
      path: Array.from(this.path),
      stickiness: this.stickiness
    };
  }
  /**
  * Returns a new position that is equal to current position.
  */
  clone() {
    return new this.constructor(this.root, this.path, this.stickiness);
  }
  /**
  * Creates position at the given location. The location can be specified as:
  *
  * * a {@link module:engine/model/position~Position position},
  * * parent element and offset (offset defaults to `0`),
  * * parent element and `'end'` (sets position at the end of that element),
  * * {@link module:engine/model/item~Item model item} and `'before'` or `'after'` (sets position before or after given model item).
  *
  * This method is a shortcut to other factory methods such as:
  *
  * * {@link module:engine/model/position~Position._createBefore},
  * * {@link module:engine/model/position~Position._createAfter}.
  *
  * @internal
  * @param offset Offset or one of the flags. Used only when the first parameter is a {@link module:engine/model/item~Item model item}.
  * @param stickiness Position stickiness. Used only when the first parameter is a {@link module:engine/model/item~Item model item}.
  */
  static _createAt(t, i, r = "toNone") {
    if (t.is("model:position"))
      return new z(t.root, t.path, t.stickiness);
    {
      const s = t;
      if (i == "end")
        i = s.maxOffset;
      else {
        if (i == "before")
          return this._createBefore(s, r);
        if (i == "after")
          return this._createAfter(s, r);
        if (i !== 0 && !i)
          throw new v("model-createpositionat-offset-required", [
            this,
            t
          ]);
      }
      if (!s.is("element") && !s.is("documentFragment"))
        throw new v("model-position-parent-incorrect", [
          this,
          t
        ]);
      const o = s.getPath();
      return o.push(i), new this(s.root, o, r);
    }
  }
  /**
  * Creates a new position, after given {@link module:engine/model/item~Item model item}.
  *
  * @internal
  * @param item Item after which the position should be placed.
  * @param stickiness Position stickiness.
  */
  static _createAfter(t, i) {
    if (!t.parent)
      throw new v("model-position-after-root", [
        this,
        t
      ], {
        root: t
      });
    return this._createAt(t.parent, t.endOffset, i);
  }
  /**
  * Creates a new position, before the given {@link module:engine/model/item~Item model item}.
  *
  * @internal
  * @param item Item before which the position should be placed.
  * @param stickiness Position stickiness.
  */
  static _createBefore(t, i) {
    if (!t.parent)
      throw new v("model-position-before-root", t, {
        root: t
      });
    return this._createAt(t.parent, t.startOffset, i);
  }
  /**
  * Creates a `Position` instance from given plain object (i.e. parsed JSON string).
  *
  * @param json Plain object to be converted to `Position`.
  * @param doc Document object that will be position owner.
  * @returns `Position` instance created using given plain object.
  */
  static fromJSON(t, i) {
    if (t.root === "$graveyard") {
      const r = new z(i.graveyard, t.path);
      return r.stickiness = t.stickiness, r;
    }
    if (!i.getRoot(t.root))
      throw new v("model-position-fromjson-no-root", i, {
        rootName: t.root
      });
    return new z(i.getRoot(t.root), t.path, t.stickiness);
  }
}
z.prototype.is = function(e) {
  return e === "position" || e === "model:position";
};
function aa(e, n) {
  const t = n.getChildAtOffset(e.offset);
  return t && t.is("$text") && t.startOffset < e.offset ? t : null;
}
function iT(e, n, t) {
  return t !== null ? null : n.getChildAtOffset(e.offset);
}
function rT(e, n, t) {
  return t !== null ? null : n.getChild(n.offsetToIndex(e.offset) - 1);
}
function Ip(e, n, t) {
  return !(t + 1 === e.path.length || !Oh(n.path, t + 1) || !UO(e, t + 1));
}
function Oh(e, n) {
  for (; n < e.length; ) {
    if (e[n] !== 0)
      return !1;
    n++;
  }
  return !0;
}
function UO(e, n) {
  let t = e.parent, i = e.path.length - 1, r = 0;
  for (; i >= n; ) {
    if (e.path[i] + r !== t.maxOffset)
      return !1;
    r = 1, i--, t = t.parent;
  }
  return !0;
}
class B extends Ir {
  /**
  * Creates a range spanning from `start` position to `end` position.
  *
  * @param start The start position.
  * @param end The end position. If not set, the range will be collapsed at the `start` position.
  */
  constructor(t, i) {
    super();
    /**
    * Start position.
    */
    m(this, "start");
    /**
    * End position.
    */
    m(this, "end");
    this.start = z._createAt(t), this.end = i ? z._createAt(i) : z._createAt(t), this.start.stickiness = this.isCollapsed ? "toNone" : "toNext", this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
  }
  /**
  * Iterable interface.
  *
  * Iterates over all {@link module:engine/model/item~Item items} that are in this range and returns
  * them together with additional information like length or {@link module:engine/model/position~Position positions},
  * grouped as {@link module:engine/model/treewalker~TreeWalkerValue}.
  * It iterates over all {@link module:engine/model/textproxy~TextProxy text contents} that are inside the range
  * and all the {@link module:engine/model/element~Element}s that are entered into when iterating over this range.
  *
  * This iterator uses {@link module:engine/model/treewalker~TreeWalker} with `boundaries` set to this range
  * and `ignoreElementEnd` option set to `true`.
  */
  *[Symbol.iterator]() {
    yield* new Ui({
      boundaries: this,
      ignoreElementEnd: !0
    });
  }
  /**
  * Describes whether the range is collapsed, that is if {@link #start} and
  * {@link #end} positions are equal.
  */
  get isCollapsed() {
    return this.start.isEqual(this.end);
  }
  /**
  * Describes whether this range is flat, that is if {@link #start} position and
  * {@link #end} position are in the same {@link module:engine/model/position~Position#parent}.
  */
  get isFlat() {
    const t = this.start.getParentPath(), i = this.end.getParentPath();
    return sn(t, i) == "same";
  }
  /**
  * Range root element.
  */
  get root() {
    return this.start.root;
  }
  /**
  * Checks whether this range contains given {@link module:engine/model/position~Position position}.
  *
  * @param position Position to check.
  * @returns `true` if given {@link module:engine/model/position~Position position} is contained
  * in this range,`false` otherwise.
  */
  containsPosition(t) {
    return t.isAfter(this.start) && t.isBefore(this.end);
  }
  /**
  * Checks whether this range contains given {@link ~Range range}.
  *
  * @param otherRange Range to check.
  * @param loose Whether the check is loose or strict. If the check is strict (`false`), compared range cannot
  * start or end at the same position as this range boundaries. If the check is loose (`true`), compared range can start, end or
  * even be equal to this range. Note that collapsed ranges are always compared in strict mode.
  * @returns {Boolean} `true` if given {@link ~Range range} boundaries are contained by this range, `false` otherwise.
  */
  containsRange(t, i = !1) {
    t.isCollapsed && (i = !1);
    const r = this.containsPosition(t.start) || i && this.start.isEqual(t.start), s = this.containsPosition(t.end) || i && this.end.isEqual(t.end);
    return r && s;
  }
  /**
  * Checks whether given {@link module:engine/model/item~Item} is inside this range.
  */
  containsItem(t) {
    const i = z._createBefore(t);
    return this.containsPosition(i) || this.start.isEqual(i);
  }
  /**
  * Two ranges are equal if their {@link #start} and {@link #end} positions are equal.
  *
  * @param otherRange Range to compare with.
  * @returns `true` if ranges are equal, `false` otherwise.
  */
  isEqual(t) {
    return this.start.isEqual(t.start) && this.end.isEqual(t.end);
  }
  /**
  * Checks and returns whether this range intersects with given range.
  *
  * @param otherRange Range to compare with.
  * @returns `true` if ranges intersect, `false` otherwise.
  */
  isIntersecting(t) {
    return this.start.isBefore(t.end) && this.end.isAfter(t.start);
  }
  /**
  * Computes which part(s) of this {@link ~Range range} is not a part of given {@link ~Range range}.
  * Returned array contains zero, one or two {@link ~Range ranges}.
  *
  * Examples:
  *
  * ```ts
  * let range = model.createRange(
  * 	model.createPositionFromPath( root, [ 2, 7 ] ),
  * 	model.createPositionFromPath( root, [ 4, 0, 1 ] )
  * );
  * let otherRange = model.createRange( model.createPositionFromPath( root, [ 1 ] ), model.createPositionFromPath( root, [ 5 ] ) );
  * let transformed = range.getDifference( otherRange );
  * // transformed array has no ranges because `otherRange` contains `range`
  *
  * otherRange = model.createRange( model.createPositionFromPath( root, [ 1 ] ), model.createPositionFromPath( root, [ 3 ] ) );
  * transformed = range.getDifference( otherRange );
  * // transformed array has one range: from [ 3 ] to [ 4, 0, 1 ]
  *
  * otherRange = model.createRange( model.createPositionFromPath( root, [ 3 ] ), model.createPositionFromPath( root, [ 4 ] ) );
  * transformed = range.getDifference( otherRange );
  * // transformed array has two ranges: from [ 2, 7 ] to [ 3 ] and from [ 4 ] to [ 4, 0, 1 ]
  * ```
  *
  * @param otherRange Range to differentiate against.
  * @returns The difference between ranges.
  */
  getDifference(t) {
    const i = [];
    return this.isIntersecting(t) ? (this.containsPosition(t.start) && i.push(new B(this.start, t.start)), this.containsPosition(t.end) && i.push(new B(t.end, this.end))) : i.push(new B(this.start, this.end)), i;
  }
  /**
  * Returns an intersection of this {@link ~Range range} and given {@link ~Range range}.
  * Intersection is a common part of both of those ranges. If ranges has no common part, returns `null`.
  *
  * Examples:
  *
  * ```ts
  * let range = model.createRange(
  * 	model.createPositionFromPath( root, [ 2, 7 ] ),
  * 	model.createPositionFromPath( root, [ 4, 0, 1 ] )
  * );
  * let otherRange = model.createRange( model.createPositionFromPath( root, [ 1 ] ), model.createPositionFromPath( root, [ 2 ] ) );
  * let transformed = range.getIntersection( otherRange ); // null - ranges have no common part
  *
  * otherRange = model.createRange( model.createPositionFromPath( root, [ 3 ] ), model.createPositionFromPath( root, [ 5 ] ) );
  * transformed = range.getIntersection( otherRange ); // range from [ 3 ] to [ 4, 0, 1 ]
  * ```
  *
  * @param otherRange Range to check for intersection.
  * @returns A common part of given ranges or `null` if ranges have no common part.
  */
  getIntersection(t) {
    if (this.isIntersecting(t)) {
      let i = this.start, r = this.end;
      return this.containsPosition(t.start) && (i = t.start), this.containsPosition(t.end) && (r = t.end), new B(i, r);
    }
    return null;
  }
  /**
  * Returns a range created by joining this {@link ~Range range} with the given {@link ~Range range}.
  * If ranges have no common part, returns `null`.
  *
  * Examples:
  *
  * ```ts
  * let range = model.createRange(
  * 	model.createPositionFromPath( root, [ 2, 7 ] ),
  * 	model.createPositionFromPath( root, [ 4, 0, 1 ] )
  * );
  * let otherRange = model.createRange(
  * 	model.createPositionFromPath( root, [ 1 ] ),
  * 	model.createPositionFromPath( root, [ 2 ] )
   * );
  * let transformed = range.getJoined( otherRange ); // null - ranges have no common part
  *
  * otherRange = model.createRange(
  * 	model.createPositionFromPath( root, [ 3 ] ),
  * 	model.createPositionFromPath( root, [ 5 ] )
  * );
  * transformed = range.getJoined( otherRange ); // range from [ 2, 7 ] to [ 5 ]
  * ```
  *
  * @param otherRange Range to be joined.
  * @param loose Whether the intersection check is loose or strict. If the check is strict (`false`),
  * ranges are tested for intersection or whether start/end positions are equal. If the check is loose (`true`),
  * compared range is also checked if it's {@link module:engine/model/position~Position#isTouching touching} current range.
  * @returns A sum of given ranges or `null` if ranges have no common part.
  */
  getJoined(t, i = !1) {
    let r = this.isIntersecting(t);
    if (r || (this.start.isBefore(t.start) ? r = i ? this.end.isTouching(t.start) : this.end.isEqual(t.start) : r = i ? t.end.isTouching(this.start) : t.end.isEqual(this.start)), !r)
      return null;
    let s = this.start, o = this.end;
    return t.start.isBefore(s) && (s = t.start), t.end.isAfter(o) && (o = t.end), new B(s, o);
  }
  /**
  * Computes and returns the smallest set of {@link #isFlat flat} ranges, that covers this range in whole.
  *
  * See an example of a model structure (`[` and `]` are range boundaries):
  *
  * ```
  * root                                                            root
  *  |- element DIV                         DIV             P2              P3             DIV
  *  |   |- element H                   H        P1        f o o           b a r       H         P4
  *  |   |   |- "fir[st"             fir[st     lorem                               se]cond     ipsum
  *  |   |- element P1
  *  |   |   |- "lorem"                                              ||
  *  |- element P2                                                   ||
  *  |   |- "foo"                                                    VV
  *  |- element P3
  *  |   |- "bar"                                                   root
  *  |- element DIV                         DIV             [P2             P3]             DIV
  *  |   |- element H                   H       [P1]       f o o           b a r        H         P4
  *  |   |   |- "se]cond"            fir[st]    lorem                               [se]cond     ipsum
  *  |   |- element P4
  *  |   |   |- "ipsum"
  * ```
  *
  * As it can be seen, letters contained in the range are: `stloremfoobarse`, spread across different parents.
  * We are looking for minimal set of flat ranges that contains the same nodes.
  *
  * Minimal flat ranges for above range `( [ 0, 0, 3 ], [ 3, 0, 2 ] )` will be:
  *
  * ```
  * ( [ 0, 0, 3 ], [ 0, 0, 5 ] ) = "st"
  * ( [ 0, 1 ], [ 0, 2 ] ) = element P1 ("lorem")
  * ( [ 1 ], [ 3 ] ) = element P2, element P3 ("foobar")
  * ( [ 3, 0, 0 ], [ 3, 0, 2 ] ) = "se"
  * ```
  *
  * **Note:** if an {@link module:engine/model/element~Element element} is not wholly contained in this range, it won't be returned
  * in any of the returned flat ranges. See in the example how `H` elements at the beginning and at the end of the range
  * were omitted. Only their parts that were wholly in the range were returned.
  *
  * **Note:** this method is not returning flat ranges that contain no nodes.
  *
  * @returns Array of flat ranges covering this range.
  */
  getMinimalFlatRanges() {
    const t = [], i = this.start.getCommonPath(this.end).length, r = z._createAt(this.start);
    let s = r.parent;
    for (; r.path.length > i + 1; ) {
      const o = s.maxOffset - r.offset;
      o !== 0 && t.push(new B(r, r.getShiftedBy(o))), r.path = r.path.slice(0, -1), r.offset++, s = s.parent;
    }
    for (; r.path.length <= this.end.path.length; ) {
      const o = this.end.path[r.path.length - 1], a = o - r.offset;
      a !== 0 && t.push(new B(r, r.getShiftedBy(a))), r.offset = o, r.path.push(0);
    }
    return t;
  }
  /**
  * Creates a {@link module:engine/model/treewalker~TreeWalker TreeWalker} instance with this range as a boundary.
  *
  * For example, to iterate over all items in the entire document root:
  *
  * ```ts
  * // Create a range spanning over the entire root content:
  * const range = editor.model.createRangeIn( editor.model.document.getRoot() );
  *
  * // Iterate over all items in this range:
  * for ( const value of range.getWalker() ) {
  * 	console.log( value.item );
  * }
  * ```
  *
  * @param options Object with configuration options. See {@link module:engine/model/treewalker~TreeWalker}.
  */
  getWalker(t = {}) {
    return t.boundaries = this, new Ui(t);
  }
  /**
  * Returns an iterator that iterates over all {@link module:engine/model/item~Item items} that are in this range and returns
  * them.
  *
  * This method uses {@link module:engine/model/treewalker~TreeWalker} with `boundaries` set to this range and `ignoreElementEnd` option
  * set to `true`. However it returns only {@link module:engine/model/item~Item model items},
  * not {@link module:engine/model/treewalker~TreeWalkerValue}.
  *
  * You may specify additional options for the tree walker. See {@link module:engine/model/treewalker~TreeWalker} for
  * a full list of available options.
  *
  * @param options Object with configuration options. See {@link module:engine/model/treewalker~TreeWalker}.
  */
  *getItems(t = {}) {
    t.boundaries = this, t.ignoreElementEnd = !0;
    const i = new Ui(t);
    for (const r of i)
      yield r.item;
  }
  /**
  * Returns an iterator that iterates over all {@link module:engine/model/position~Position positions} that are boundaries or
  * contained in this range.
  *
  * This method uses {@link module:engine/model/treewalker~TreeWalker} with `boundaries` set to this range. However it returns only
  * {@link module:engine/model/position~Position positions}, not {@link module:engine/model/treewalker~TreeWalkerValue}.
  *
  * You may specify additional options for the tree walker. See {@link module:engine/model/treewalker~TreeWalker} for
  * a full list of available options.
  *
  * @param options Object with configuration options. See {@link module:engine/model/treewalker~TreeWalker}.
  */
  *getPositions(t = {}) {
    t.boundaries = this;
    const i = new Ui(t);
    yield i.position;
    for (const r of i)
      yield r.nextPosition;
  }
  /**
  * Returns a range that is a result of transforming this range by given `operation`.
  *
  * **Note:** transformation may break one range into multiple ranges (for example, when a part of the range is
  * moved to a different part of document tree). For this reason, an array is returned by this method and it
  * may contain one or more `Range` instances.
  *
  * @param operation Operation to transform range by.
  * @returns Range which is the result of transformation.
  */
  getTransformedByOperation(t) {
    switch (t.type) {
      case "insert":
        return this._getTransformedByInsertOperation(t);
      case "move":
      case "remove":
      case "reinsert":
        return this._getTransformedByMoveOperation(t);
      case "split":
        return [
          this._getTransformedBySplitOperation(t)
        ];
      case "merge":
        return [
          this._getTransformedByMergeOperation(t)
        ];
    }
    return [
      new B(this.start, this.end)
    ];
  }
  /**
  * Returns a range that is a result of transforming this range by multiple `operations`.
  *
  * @see ~Range#getTransformedByOperation
  * @param operations Operations to transform the range by.
  * @returns Range which is the result of transformation.
  */
  getTransformedByOperations(t) {
    const i = [
      new B(this.start, this.end)
    ];
    for (const r of t)
      for (let s = 0; s < i.length; s++) {
        const o = i[s].getTransformedByOperation(r);
        i.splice(s, 1, ...o), s += o.length - 1;
      }
    for (let r = 0; r < i.length; r++) {
      const s = i[r];
      for (let o = r + 1; o < i.length; o++) {
        const a = i[o];
        (s.containsRange(a) || a.containsRange(s) || s.isEqual(a)) && i.splice(o, 1);
      }
    }
    return i;
  }
  /**
  * Returns an {@link module:engine/model/element~Element} or {@link module:engine/model/documentfragment~DocumentFragment}
  * which is a common ancestor of the range's both ends (in which the entire range is contained).
  */
  getCommonAncestor() {
    return this.start.getCommonAncestor(this.end);
  }
  /**
  * Returns an {@link module:engine/model/element~Element Element} contained by the range.
  * The element will be returned when it is the **only** node within the range and **fully–contained**
  * at the same time.
  */
  getContainedElement() {
    if (this.isCollapsed)
      return null;
    const t = this.start.nodeAfter, i = this.end.nodeBefore;
    return t && t.is("element") && t === i ? t : null;
  }
  /**
  * Converts `Range` to plain object and returns it.
  *
  * @returns `Node` converted to plain object.
  */
  toJSON() {
    return {
      start: this.start.toJSON(),
      end: this.end.toJSON()
    };
  }
  /**
  * Returns a new range that is equal to current range.
  */
  clone() {
    return new this.constructor(this.start, this.end);
  }
  /**
  * Returns a result of transforming a copy of this range by insert operation.
  *
  * One or more ranges may be returned as a result of this transformation.
  *
  * @internal
  */
  _getTransformedByInsertOperation(t, i = !1) {
    return this._getTransformedByInsertion(t.position, t.howMany, i);
  }
  /**
  * Returns a result of transforming a copy of this range by move operation.
  *
  * One or more ranges may be returned as a result of this transformation.
  *
  * @internal
  */
  _getTransformedByMoveOperation(t, i = !1) {
    const r = t.sourcePosition, s = t.howMany, o = t.targetPosition;
    return this._getTransformedByMove(r, o, s, i);
  }
  /**
  * Returns a result of transforming a copy of this range by split operation.
  *
  * Always one range is returned. The transformation is done in a way to not break the range.
  *
  * @internal
  */
  _getTransformedBySplitOperation(t) {
    const i = this.start._getTransformedBySplitOperation(t);
    let r = this.end._getTransformedBySplitOperation(t);
    return this.end.isEqual(t.insertionPosition) && (r = this.end.getShiftedBy(1)), i.root != r.root && (r = this.end.getShiftedBy(-1)), new B(i, r);
  }
  /**
  * Returns a result of transforming a copy of this range by merge operation.
  *
  * Always one range is returned. The transformation is done in a way to not break the range.
  *
  * @internal
  */
  _getTransformedByMergeOperation(t) {
    if (this.start.isEqual(t.targetPosition) && this.end.isEqual(t.deletionPosition))
      return new B(this.start);
    let i = this.start._getTransformedByMergeOperation(t), r = this.end._getTransformedByMergeOperation(t);
    return i.root != r.root && (r = this.end.getShiftedBy(-1)), i.isAfter(r) ? (t.sourcePosition.isBefore(t.targetPosition) ? (i = z._createAt(r), i.offset = 0) : (t.deletionPosition.isEqual(i) || (r = t.deletionPosition), i = t.targetPosition), new B(i, r)) : new B(i, r);
  }
  /**
  * Returns an array containing one or two {@link ~Range ranges} that are a result of transforming this
  * {@link ~Range range} by inserting `howMany` nodes at `insertPosition`. Two {@link ~Range ranges} are
  * returned if the insertion was inside this {@link ~Range range} and `spread` is set to `true`.
  *
  * Examples:
  *
  * ```ts
  * let range = model.createRange(
  * 	model.createPositionFromPath( root, [ 2, 7 ] ),
  * 	model.createPositionFromPath( root, [ 4, 0, 1 ] )
  * );
  * let transformed = range._getTransformedByInsertion( model.createPositionFromPath( root, [ 1 ] ), 2 );
  * // transformed array has one range from [ 4, 7 ] to [ 6, 0, 1 ]
  *
  * transformed = range._getTransformedByInsertion( model.createPositionFromPath( root, [ 4, 0, 0 ] ), 4 );
  * // transformed array has one range from [ 2, 7 ] to [ 4, 0, 5 ]
  *
  * transformed = range._getTransformedByInsertion( model.createPositionFromPath( root, [ 3, 2 ] ), 4 );
  * // transformed array has one range, which is equal to original range
  *
  * transformed = range._getTransformedByInsertion( model.createPositionFromPath( root, [ 3, 2 ] ), 4, true );
  * // transformed array has two ranges: from [ 2, 7 ] to [ 3, 2 ] and from [ 3, 6 ] to [ 4, 0, 1 ]
  * ```
  *
  * @internal
  * @param insertPosition Position where nodes are inserted.
  * @param howMany How many nodes are inserted.
  * @param spread Flag indicating whether this range should be spread if insertion
  * was inside the range. Defaults to `false`.
  * @returns Result of the transformation.
  */
  _getTransformedByInsertion(t, i, r = !1) {
    if (r && this.containsPosition(t))
      return [
        new B(this.start, t),
        new B(t.getShiftedBy(i), this.end._getTransformedByInsertion(t, i))
      ];
    {
      const s = new B(this.start, this.end);
      return s.start = s.start._getTransformedByInsertion(t, i), s.end = s.end._getTransformedByInsertion(t, i), [
        s
      ];
    }
  }
  /**
  * Returns an array containing {@link ~Range ranges} that are a result of transforming this
  * {@link ~Range range} by moving `howMany` nodes from `sourcePosition` to `targetPosition`.
  *
  * @internal
  * @param sourcePosition Position from which nodes are moved.
  * @param targetPosition Position to where nodes are moved.
  * @param howMany How many nodes are moved.
  * @param spread Whether the range should be spread if the move points inside the range.
  * @returns  Result of the transformation.
  */
  _getTransformedByMove(t, i, r, s = !1) {
    if (this.isCollapsed) {
      const p = this.start._getTransformedByMove(t, i, r);
      return [
        new B(p)
      ];
    }
    const o = B._createFromPositionAndShift(t, r), a = i._getTransformedByDeletion(t, r);
    if (this.containsPosition(i) && !s && (o.containsPosition(this.start) || o.containsPosition(this.end))) {
      const p = this.start._getTransformedByMove(t, i, r), g = this.end._getTransformedByMove(t, i, r);
      return [
        new B(p, g)
      ];
    }
    let u;
    const l = this.getDifference(o);
    let c = null;
    const d = this.getIntersection(o);
    if (l.length == 1 ? c = new B(l[0].start._getTransformedByDeletion(t, r), l[0].end._getTransformedByDeletion(t, r)) : l.length == 2 && (c = new B(this.start, this.end._getTransformedByDeletion(t, r))), c ? u = c._getTransformedByInsertion(a, r, d !== null || s) : u = [], d) {
      const p = new B(d.start._getCombined(o.start, a), d.end._getCombined(o.start, a));
      u.length == 2 ? u.splice(1, 0, p) : u.push(p);
    }
    return u;
  }
  /**
  * Returns a copy of this range that is transformed by deletion of `howMany` nodes from `deletePosition`.
  *
  * If the deleted range is intersecting with the transformed range, the transformed range will be shrank.
  *
  * If the deleted range contains transformed range, `null` will be returned.
  *
  * @internal
  * @param deletionPosition Position from which nodes are removed.
  * @param howMany How many nodes are removed.
  * @returns Result of the transformation.
  */
  _getTransformedByDeletion(t, i) {
    let r = this.start._getTransformedByDeletion(t, i), s = this.end._getTransformedByDeletion(t, i);
    return r == null && s == null ? null : (r == null && (r = t), s == null && (s = t), new B(r, s));
  }
  /**
  * Creates a new range, spreading from specified {@link module:engine/model/position~Position position} to a position moved by
  * given `shift`. If `shift` is a negative value, shifted position is treated as the beginning of the range.
  *
  * @internal
  * @param position Beginning of the range.
  * @param shift How long the range should be.
  */
  static _createFromPositionAndShift(t, i) {
    const r = t, s = t.getShiftedBy(i);
    return i > 0 ? new this(r, s) : new this(s, r);
  }
  /**
  * Creates a range inside an {@link module:engine/model/element~Element element} which starts before the first child of
  * that element and ends after the last child of that element.
  *
  * @internal
  * @param element Element which is a parent for the range.
  */
  static _createIn(t) {
    return new this(z._createAt(t, 0), z._createAt(t, t.maxOffset));
  }
  /**
  * Creates a range that starts before given {@link module:engine/model/item~Item model item} and ends after it.
  *
  * @internal
  */
  static _createOn(t) {
    return this._createFromPositionAndShift(z._createBefore(t), t.offsetSize);
  }
  /**
  * Combines all ranges from the passed array into a one range. At least one range has to be passed.
  * Passed ranges must not have common parts.
  *
  * The first range from the array is a reference range. If other ranges start or end on the exactly same position where
  * the reference range, they get combined into one range.
  *
  * ```
  * [  ][]  [    ][ ][             ][ ][]  [  ]  // Passed ranges, shown sorted
  * [    ]                                       // The result of the function if the first range was a reference range.
  *         [                           ]        // The result of the function if the third-to-seventh range was a reference range.
  *                                        [  ]  // The result of the function if the last range was a reference range.
  * ```
  *
  * @internal
  * @param ranges Ranges to combine.
  * @returns Combined range.
  */
  static _createFromRanges(t) {
    if (t.length === 0)
      throw new v("range-create-from-ranges-empty-array", null);
    if (t.length == 1)
      return t[0].clone();
    const i = t[0];
    t.sort((o, a) => o.start.isAfter(a.start) ? 1 : -1);
    const r = t.indexOf(i), s = new this(i.start, i.end);
    for (let o = r - 1; o >= 0 && t[o].end.isEqual(s.start); o--)
      s.start = z._createAt(t[o].start);
    for (let o = r + 1; o < t.length && t[o].start.isEqual(s.end); o++)
      s.end = z._createAt(t[o].end);
    return s;
  }
  /**
  * Creates a `Range` instance from given plain object (i.e. parsed JSON string).
  *
  * @param json Plain object to be converted to `Range`.
  * @param doc Document object that will be range owner.
  * @returns `Range` instance created using given plain object.
  */
  static fromJSON(t, i) {
    return new this(z.fromJSON(t.start, i), z.fromJSON(t.end, i));
  }
}
B.prototype.is = function(e) {
  return e === "range" || e === "model:range";
};
class sT extends (/* @__PURE__ */ Je()) {
  /**
  * Creates an instance of the mapper.
  */
  constructor() {
    super();
    /**
    * Model element to view element mapping.
    */
    m(this, "_modelToViewMapping", /* @__PURE__ */ new WeakMap());
    /**
    * View element to model element mapping.
    */
    m(this, "_viewToModelMapping", /* @__PURE__ */ new WeakMap());
    /**
    * A map containing callbacks between view element names and functions evaluating length of view elements
    * in model.
    */
    m(this, "_viewToModelLengthCallbacks", /* @__PURE__ */ new Map());
    /**
    * Model marker name to view elements mapping.
    *
    * Keys are `String`s while values are `Set`s with {@link module:engine/view/element~Element view elements}.
    * One marker (name) can be mapped to multiple elements.
    */
    m(this, "_markerNameToElements", /* @__PURE__ */ new Map());
    /**
    * View element to model marker names mapping.
    *
    * This is reverse to {@link ~Mapper#_markerNameToElements} map.
    */
    m(this, "_elementToMarkerNames", /* @__PURE__ */ new Map());
    /**
    * The map of removed view elements with their current root (used for deferred unbinding).
    */
    m(this, "_deferredBindingRemovals", /* @__PURE__ */ new Map());
    /**
    * Stores marker names of markers which have changed due to unbinding a view element (so it is assumed that the view element
    * has been removed, moved or renamed).
    */
    m(this, "_unboundMarkerNames", /* @__PURE__ */ new Set());
    /**
    * Manages dynamic cache for the `Mapper` to improve the performance.
    */
    m(this, "_cache", new HO());
    this.on("modelToViewPosition", (t, i) => {
      if (i.viewPosition)
        return;
      const r = this._modelToViewMapping.get(i.modelPosition.parent);
      if (!r)
        throw new v("mapping-model-position-view-parent-not-found", this, {
          modelPosition: i.modelPosition
        });
      i.viewPosition = this.findPositionIn(r, i.modelPosition.offset);
    }, {
      priority: "low"
    }), this.on("viewToModelPosition", (t, i) => {
      if (i.modelPosition)
        return;
      const r = this.findMappedViewAncestor(i.viewPosition), s = this._viewToModelMapping.get(r), o = this._toModelOffset(i.viewPosition.parent, i.viewPosition.offset, r);
      i.modelPosition = z._createAt(s, o);
    }, {
      priority: "low"
    });
  }
  /**
  * Marks model and view elements as corresponding. Corresponding elements can be retrieved by using
  * the {@link module:engine/conversion/mapper~Mapper#toModelElement toModelElement} and
  * {@link module:engine/conversion/mapper~Mapper#toViewElement toViewElement} methods.
  * The information that elements are bound is also used to translate positions.
  *
  * @param modelElement Model element.
  * @param viewElement View element.
  */
  bindElements(t, i) {
    this._modelToViewMapping.set(t, i), this._viewToModelMapping.set(i, t);
  }
  /**
  * Unbinds the given {@link module:engine/view/element~Element view element} from the map.
  *
  * **Note:** view-to-model binding will be removed, if it existed. However, corresponding model-to-view binding
  * will be removed only if model element is still bound to the passed `viewElement`.
  *
  * This behavior allows for re-binding model element to another view element without fear of losing the new binding
  * when the previously bound view element is unbound.
  *
  * @param viewElement View element to unbind.
  * @param options The options object.
  * @param options.defer Controls whether the binding should be removed immediately or deferred until a
  * {@link #flushDeferredBindings `flushDeferredBindings()`} call.
  */
  unbindViewElement(t, i = {}) {
    const r = this.toModelElement(t);
    if (this._elementToMarkerNames.has(t))
      for (const s of this._elementToMarkerNames.get(t))
        this._unboundMarkerNames.add(s);
    i.defer ? this._deferredBindingRemovals.set(t, t.root) : (this._viewToModelMapping.delete(t) && this._cache.stopTracking(t), this._modelToViewMapping.get(r) == t && this._modelToViewMapping.delete(r));
  }
  /**
  * Unbinds the given {@link module:engine/model/element~Element model element} from the map.
  *
  * **Note:** the model-to-view binding will be removed, if it existed. However, the corresponding view-to-model binding
  * will be removed only if the view element is still bound to the passed `modelElement`.
  *
  * This behavior lets for re-binding view element to another model element without fear of losing the new binding
  * when the previously bound model element is unbound.
  *
  * @param modelElement Model element to unbind.
  */
  unbindModelElement(t) {
    const i = this.toViewElement(t);
    this._modelToViewMapping.delete(t), this._viewToModelMapping.get(i) == t && this._viewToModelMapping.delete(i) && this._cache.stopTracking(i);
  }
  /**
  * Binds the given marker name with the given {@link module:engine/view/element~Element view element}. The element
  * will be added to the current set of elements bound with the given marker name.
  *
  * @param element Element to bind.
  * @param name Marker name.
  */
  bindElementToMarker(t, i) {
    const r = this._markerNameToElements.get(i) || /* @__PURE__ */ new Set();
    r.add(t);
    const s = this._elementToMarkerNames.get(t) || /* @__PURE__ */ new Set();
    s.add(i), this._markerNameToElements.set(i, r), this._elementToMarkerNames.set(t, s);
  }
  /**
  * Unbinds an element from given marker name.
  *
  * @param element Element to unbind.
  * @param name Marker name.
  */
  unbindElementFromMarkerName(t, i) {
    const r = this._markerNameToElements.get(i);
    r && (r.delete(t), r.size == 0 && this._markerNameToElements.delete(i));
    const s = this._elementToMarkerNames.get(t);
    s && (s.delete(i), s.size == 0 && this._elementToMarkerNames.delete(t));
  }
  /**
  * Returns all marker names of markers which have changed due to unbinding a view element (so it is assumed that the view element
  * has been removed, moved or renamed) since the last flush. After returning, the marker names list is cleared.
  */
  flushUnboundMarkerNames() {
    const t = Array.from(this._unboundMarkerNames);
    return this._unboundMarkerNames.clear(), t;
  }
  /**
  * Unbinds all deferred binding removals of view elements that in the meantime were not re-attached to some root or document fragment.
  *
  * See: {@link #unbindViewElement `unbindViewElement()`}.
  */
  flushDeferredBindings() {
    for (const [t, i] of this._deferredBindingRemovals)
      t.root == i && this.unbindViewElement(t);
    this._deferredBindingRemovals = /* @__PURE__ */ new Map();
  }
  /**
  * Removes all model to view and view to model bindings.
  */
  clearBindings() {
    this._modelToViewMapping = /* @__PURE__ */ new WeakMap(), this._viewToModelMapping = /* @__PURE__ */ new WeakMap(), this._markerNameToElements = /* @__PURE__ */ new Map(), this._elementToMarkerNames = /* @__PURE__ */ new Map(), this._unboundMarkerNames = /* @__PURE__ */ new Set(), this._deferredBindingRemovals = /* @__PURE__ */ new Map();
  }
  toModelElement(t) {
    return this._viewToModelMapping.get(t);
  }
  toViewElement(t) {
    return this._modelToViewMapping.get(t);
  }
  /**
  * Gets the corresponding model range.
  *
  * @param viewRange View range.
  * @returns Corresponding model range.
  */
  toModelRange(t) {
    return new B(this.toModelPosition(t.start), this.toModelPosition(t.end));
  }
  /**
  * Gets the corresponding view range.
  *
  * @param modelRange Model range.
  * @returns Corresponding view range.
  */
  toViewRange(t) {
    return new Re(this.toViewPosition(t.start), this.toViewPosition(t.end));
  }
  /**
  * Gets the corresponding model position.
  *
  * @fires viewToModelPosition
  * @param viewPosition View position.
  * @returns Corresponding model position.
  */
  toModelPosition(t) {
    const i = {
      viewPosition: t,
      mapper: this
    };
    return this.fire("viewToModelPosition", i), i.modelPosition;
  }
  /**
  * Gets the corresponding view position.
  *
  * @fires modelToViewPosition
  * @param modelPosition Model position.
  * @param options Additional options for position mapping process.
  * @param options.isPhantom Should be set to `true` if the model position to map is pointing to a place
  * in model tree which no longer exists. For example, it could be an end of a removed model range.
  * @returns Corresponding view position.
  */
  toViewPosition(t, i = {}) {
    const r = {
      modelPosition: t,
      mapper: this,
      isPhantom: i.isPhantom
    };
    return this.fire("modelToViewPosition", r), r.viewPosition;
  }
  /**
  * Gets all view elements bound to the given marker name.
  *
  * @param name Marker name.
  * @returns View elements bound with the given marker name or `null`
  * if no elements are bound to the given marker name.
  */
  markerNameToElements(t) {
    const i = this._markerNameToElements.get(t);
    if (!i)
      return null;
    const r = /* @__PURE__ */ new Set();
    for (const s of i)
      if (s.is("attributeElement"))
        for (const o of s.getElementsWithSameId())
          r.add(o);
      else
        r.add(s);
    return r;
  }
  /**
  * **This method is deprecated and will be removed in one of the future CKEditor 5 releases.**
  *
  * **Using this method will turn off `Mapper` caching system and may degrade performance when operating on bigger documents.**
  *
  * Registers a callback that evaluates the length in the model of a view element with the given name.
  *
  * The callback is fired with one argument, which is a view element instance. The callback is expected to return
  * a number representing the length of the view element in the model.
  *
  * ```ts
  * // List item in view may contain nested list, which have other list items. In model though,
  * // the lists are represented by flat structure. Because of those differences, length of list view element
  * // may be greater than one. In the callback it's checked how many nested list items are in evaluated list item.
  *
  * function getViewListItemLength( element ) {
  * 	let length = 1;
  *
  * 	for ( let child of element.getChildren() ) {
  * 		if ( child.name == 'ul' || child.name == 'ol' ) {
  * 			for ( let item of child.getChildren() ) {
  * 				length += getViewListItemLength( item );
  * 			}
  * 		}
  * 	}
  *
  * 	return length;
  * }
  *
  * mapper.registerViewToModelLength( 'li', getViewListItemLength );
  * ```
  *
  * @param viewElementName Name of view element for which callback is registered.
  * @param lengthCallback Function return a length of view element instance in model.
  * @deprecated
  */
  registerViewToModelLength(t, i) {
    this._viewToModelLengthCallbacks.set(t, i);
  }
  /**
  * For the given `viewPosition`, finds and returns the closest ancestor of this position that has a mapping to
  * the model.
  *
  * @param viewPosition Position for which a mapped ancestor should be found.
  */
  findMappedViewAncestor(t) {
    let i = t.parent;
    for (; !this._viewToModelMapping.has(i); )
      i = i.parent;
    return i;
  }
  /**
  * Calculates model offset based on the view position and the block element.
  *
  * Example:
  *
  * ```html
  * <p>foo<b>ba|r</b></p> // _toModelOffset( b, 2, p ) -> 5
  * ```
  *
  * Is a sum of:
  *
  * ```html
  * <p>foo|<b>bar</b></p> // _toModelOffset( p, 3, p ) -> 3
  * <p>foo<b>ba|r</b></p> // _toModelOffset( b, 2, b ) -> 2
  * ```
  *
  * @param viewParent Position parent.
  * @param viewOffset Position offset.
  * @param viewBlock Block used as a base to calculate offset.
  * @returns Offset in the model.
  */
  _toModelOffset(t, i, r) {
    if (r != t) {
      const o = this._toModelOffset(t.parent, t.index, r), a = this._toModelOffset(t, i, t);
      return o + a;
    }
    if (t.is("$text"))
      return i;
    let s = 0;
    for (let o = 0; o < i; o++)
      s += this.getModelLength(t.getChild(o));
    return s;
  }
  /**
  * Gets the length of the view element in the model.
  *
  * The length is calculated as follows:
  * * if a {@link #registerViewToModelLength length mapping callback} is provided for the given `viewNode`, it is used to
  * evaluate the model length (`viewNode` is used as first and only parameter passed to the callback),
  * * length of a {@link module:engine/view/text~Text text node} is equal to the length of its
  * {@link module:engine/view/text~Text#data data},
  * * length of a {@link module:engine/view/uielement~UIElement ui element} is equal to 0,
  * * length of a mapped {@link module:engine/view/element~Element element} is equal to 1,
  * * length of a non-mapped {@link module:engine/view/element~Element element} is equal to the length of its children.
  *
  * Examples:
  *
  * ```
  * foo                          -> 3 // Text length is equal to its data length.
  * <p>foo</p>                   -> 1 // Length of an element which is mapped is by default equal to 1.
  * <b>foo</b>                   -> 3 // Length of an element which is not mapped is a length of its children.
  * <div><p>x</p><p>y</p></div>  -> 2 // Assuming that <div> is not mapped and <p> are mapped.
  * ```
  *
  * @param viewNode View node.
  * @returns Length of the node in the tree model.
  */
  getModelLength(t) {
    const i = [
      t
    ];
    let r = 0;
    for (; i.length > 0; ) {
      const s = i.pop(), o = s.name && this._viewToModelLengthCallbacks.size > 0 && this._viewToModelLengthCallbacks.get(s.name);
      if (o)
        r += o(s);
      else if (this._viewToModelMapping.has(s))
        r += 1;
      else if (s.is("$text"))
        r += s.data.length;
      else {
        if (s.is("uiElement"))
          continue;
        for (const a of s.getChildren())
          i.push(a);
      }
    }
    return r;
  }
  /**
  * Finds the position in a view element or view document fragment node (or in its children) with the expected model offset.
  *
  * If the passed `viewContainer` is bound to model, `Mapper` will use caching mechanism to improve performance.
  *
  * @param viewContainer Tree view element in which we are looking for the position.
  * @param modelOffset Expected offset.
  * @returns Found position.
  */
  findPositionIn(t, i) {
    if (i === 0)
      return this._moveViewPositionToTextNode(new ne(t, 0));
    if (this._viewToModelLengthCallbacks.size == 0 && this._viewToModelMapping.has(t)) {
      const s = this._cache.getClosest(t, i);
      return this._findPositionStartingFrom(s.viewPosition, s.modelOffset, i, t, !0);
    } else
      return this._findPositionStartingFrom(new ne(t, 0), 0, i, t, !1);
  }
  /**
  * Performs most of the logic for `Mapper#findPositionIn()`.
  *
  * It allows to start looking for the requested model offset from a given starting position, to enable caching. Using the cache,
  * you can set the starting point and skip all the calculations that were already previously done.
  *
  * This method uses recursion to find positions inside deep structures. Example:
  *
  * ```
  * <p>fo<b>bar</b>bom</p>  -> target offset: 4
  * <p>|fo<b>bar</b>bom</p> -> target offset: 4, traversed offset: 0
  * <p>fo|<b>bar</b>bom</p> -> target offset: 4, traversed offset: 2
  * <p>fo<b>bar</b>|bom</p> -> target offset: 4, traversed offset: 5 -> we are too far, look recursively in <b>.
  *
  * <p>fo<b>|bar</b>bom</p> -> target offset: 4, traversed offset: 2
  * <p>fo<b>bar|</b>bom</p> -> target offset: 4, traversed offset: 5 -> we are too far, look inside "bar".
  *
  * <p>fo<b>ba|r</b>bom</p> -> target offset: 4, traversed offset: 2 -> position is inside text node at offset 4-2 = 2.
  * ```
  *
  * @param startViewPosition View position to start looking from.
  * @param startModelOffset Model offset related to `startViewPosition`.
  * @param targetModelOffset Target model offset to find.
  * @param viewContainer Mapped ancestor of `startViewPosition`. `startModelOffset` is the offset inside a model element or model
  * document fragment mapped to `viewContainer`.
  * @param useCache Whether `Mapper` should cache positions while traversing the view tree looking for `expectedModelOffset`.
  * @returns View position mapped to `targetModelOffset`.
  */
  _findPositionStartingFrom(t, i, r, s, o) {
    let a = t.parent, u = t.offset;
    if (a.is("$text"))
      return new ne(a, r - i);
    let l, c = i, d = 0;
    for (; c < r; ) {
      if (l = a.getChild(u), !l) {
        if (a == s)
          throw new v("mapping-model-offset-not-found", this, {
            modelOffset: r,
            viewContainer: s
          });
        u = a.parent.getChildIndex(a) + 1, a = a.parent;
        continue;
      }
      d = this.getModelLength(l), c += d, u++, o && this._cache.save(a, u, s, c);
    }
    return c == r ? this._moveViewPositionToTextNode(new ne(a, u)) : this._findPositionStartingFrom(new ne(l, 0), c - d, r, s, o);
  }
  /**
  * Because we prefer positions in the text nodes over positions next to text nodes, if the view position was next to a text node,
  * it moves it into the text node instead.
  *
  * ```
  * <p>[]<b>foo</b></p> -> <p>[]<b>foo</b></p> // do not touch if position is not directly next to text
  * <p>foo[]<b>foo</b></p> -> <p>foo{}<b>foo</b></p> // move to text node
  * <p><b>[]foo</b></p> -> <p><b>{}foo</b></p> // move to text node
  * ```
  *
  * @param viewPosition Position potentially next to the text node.
  * @returns Position in the text node if possible.
  */
  _moveViewPositionToTextNode(t) {
    const i = t.nodeBefore, r = t.nodeAfter;
    return i && i.is("view:$text") ? new ne(i, i.data.length) : r && r.is("view:$text") ? new ne(r, 0) : t;
  }
}
class HO extends (/* @__PURE__ */ Je()) {
  constructor() {
    super(...arguments);
    /**
    * For every view element or document fragment tracked by `MapperCache`, it holds currently cached data, or more precisely,
    * model offset to view position mappings. See also `MappingCache` and `CacheItem`.
    *
    * If an item is tracked by `MapperCache` it has an entry in this structure, so this structure can be used to check which items
    * are tracked by `MapperCache`. When an item is no longer tracked, it is removed from this structure.
    *
    * Although `MappingCache` and `CacheItem` structures allows for caching any model offsets and view positions, we only cache
    * values for model offsets that are after a view node. So, in essence, positions inside text nodes are not cached. However, it takes
    * from one to at most a few steps, to get from a cached position to a position that is inside a view text node.
    *
    * Additionally, only one item per `modelOffset` is cached. There can be several view nodes that "end" at the same `modelOffset`.
    * In this case, we favour positions that are closer to the mapped item. For example
    *
    * * for model: `<paragraph>Some <$text bold=true italic=true>formatted</$text> text.</paragraph>`,
    * * and view: `<p>Some <em><strong>formatted</strong></em> text.</p>`,
    *
    * for model offset `14` (after "d"), we store view position after `<em>` element (i.e. view position: at `<p>`, offset `2`).
    */
    m(this, "_cachedMapping", /* @__PURE__ */ new WeakMap());
    /**
    * When `MapperCache` {@link ~MapperCache#save saves} view position -> model offset mapping, a `CacheItem` is inserted into certain
    * `MappingCache#cacheList` at some index. Additionally, we store that index with the view node that is before the cached view position.
    *
    * This allows to quickly get a cache list item related to certain view node, and hence, for fast cache invalidation.
    *
    * For example, consider view: `<p>Some <strong>bold</strong> text.</p>`, where `<p>` is a view element tracked by `MapperCache`.
    * If all `<p>` children were visited by `MapperCache`, then `<p>` cache list would have four items, related to following model offsets:
    * `0`, `5`, `9`, `15`. Then, view node `"Some "` would have index `1`, `<strong>` index `2`, and `" text." index `3`.
    *
    * Note that the index related with a node is always greater than `0`. The first item in cache list is always for model offset `0`
    * (and view offset `0`), and it is not related to any node.
    */
    m(this, "_nodeToCacheListIndex", /* @__PURE__ */ new WeakMap());
    /**
    * Callback fired whenever there is a direct or indirect children change in tracked view element or tracked view document fragment.
    *
    * This is specified as a property to make it easier to set as an event callback and to later turn off that event.
    */
    m(this, "_invalidateOnChildrenChangeCallback", (t, i, r) => {
      this._clearCacheInsideParent(i, r.index);
    });
    /**
    * Callback fired whenever a view text node directly or indirectly inside a tracked view element or tracked view document fragment
    * changes its text data.
    *
    * This is specified as a property to make it easier to set as an event callback and to later turn off that event.
    */
    m(this, "_invalidateOnTextChangeCallback", (t, i) => {
      this._clearCacheStartingBefore(i);
    });
  }
  /**
  * Saves cache for given view position mapping <-> model offset mapping. The view position should be after a node (i.e. it cannot
  * be the first position inside its parent, or in other words, `viewOffset` must be greater than `0`).
  *
  * @param viewParent View position parent.
  * @param viewOffset View position offset. Must be greater than `0`.
  * @param viewContainer Tracked view position ascendant (it may be the direct parent of the view position).
  * @param modelOffset Model offset in the model element or document fragment which is mapped to `viewContainer`.
  */
  save(t, i, r, s) {
    const o = this._cachedMapping.get(r), a = o.cacheMap.get(s);
    if (a) {
      const d = t.getChild(i - 1), p = a.viewPosition.nodeBefore ? this._nodeToCacheListIndex.get(a.viewPosition.nodeBefore) : 0;
      this._nodeToCacheListIndex.set(d, p);
      return;
    }
    const l = {
      viewPosition: new ne(t, i),
      modelOffset: s
    };
    o.maxModelOffset = s > o.maxModelOffset ? s : o.maxModelOffset, o.cacheMap.set(s, l);
    let c = o.cacheList.length - 1;
    for (; c >= 0 && o.cacheList[c].modelOffset > s; )
      c--;
    if (o.cacheList.splice(c + 1, 0, l), i > 0) {
      const d = t.getChild(i - 1);
      this._nodeToCacheListIndex.set(d, c + 1);
    }
  }
  /**
  * For given `modelOffset` inside a model element mapped to given `viewContainer`, it returns the closest saved cache item
  * (view position and related model offset) to the requested one.
  *
  * It can be exactly the requested mapping, or it can be mapping that is the closest starting point to look for the requested mapping.
  *
  * `viewContainer` must be a view element or document fragment that is mapped by the {@link ~Mapper Mapper}.
  *
  * If `viewContainer` is not yet tracked by the `MapperCache`, it will be automatically tracked after calling this method.
  *
  * Note: this method will automatically "hoist" cached positions, i.e. it will return a position that is closest to the tracked element.
  *
  * For example, if `<p>` is tracked element, and `^` is cached position:
  *
  * ```
  * <p>This is <strong>some <em>heavily <u>formatted</u>^</em></strong> text.</p>
  * ```
  *
  * If this position would be returned, instead, a position directly in `<p>` would be returned:
  *
  * ```
  * <p>This is <strong>some <em>heavily <u>formatted</u></em></strong>^ text.</p>
  * ```
  *
  * Note, that `modelOffset` for both positions is the same.
  *
  * @param viewContainer Tracked view element or document fragment, which cache will be used.
  * @param modelOffset Model offset in a model element or document fragment, which is mapped to `viewContainer`.
  */
  getClosest(t, i) {
    const r = this._cachedMapping.get(t);
    let s;
    if (r)
      if (i > r.maxModelOffset)
        s = r.cacheList[r.cacheList.length - 1];
      else {
        const a = r.cacheMap.get(i);
        a ? s = a : s = this._findInCacheList(r.cacheList, i);
      }
    else
      s = this.startTracking(t);
    const o = this._hoistViewPosition(s.viewPosition);
    return {
      modelOffset: s.modelOffset,
      viewPosition: o
    };
  }
  /**
  * Moves a view position to a preferred location.
  *
  * The view position is moved up from a non-tracked view element as long as it remains at the end of its current parent.
  *
  * See example below to understand when it is important:
  *
  * Starting state:
  *
  * ```
  * <p>This is <strong>some <em>heavily <u>formatted</u>^ piece of</em></strong> text.</p>
  * ```
  *
  * Then we remove " piece of " and invalidate some cache:
  *
  * ```
  * <p>This is <strong>some <em>heavily <u>formatted</u>^</em></strong> text.</p>
  * ```
  *
  * Now, if we ask for model offset after letter "d" in "formatted", we should get a position in " text", but we will get in `<em>`.
  * For this scenario, we need to hoist the position.
  *
  * ```
  * <p>This is <strong>some <em>heavily <u>formatted</u></em></strong>^ text.</p>
  * ```
  */
  _hoistViewPosition(t) {
    for (; t.parent.parent && !this._cachedMapping.has(t.parent) && t.isAtEnd; ) {
      const i = t.parent.parent, r = i.getChildIndex(t.parent) + 1;
      t = new ne(i, r);
    }
    return t;
  }
  /**
  * Starts tracking given `viewContainer`, which must be mapped to a model element or model document fragment.
  *
  * Note, that this method is automatically called by
  * {@link module:engine/conversion/mapper~MapperCache#getClosest `MapperCache#getClosest()`} and there is no need to call it manually.
  *
  * This method initializes the cache for `viewContainer` and adds callbacks for
  * {@link module:engine/view/node~ViewNodeChangeEvent `change` event} fired by `viewContainer`. `MapperCache` listens to `change` event
  * on the tracked elements to invalidate the stored cache.
  */
  startTracking(t) {
    const r = {
      viewPosition: new ne(t, 0),
      modelOffset: 0
    }, s = {
      maxModelOffset: 0,
      cacheList: [
        r
      ],
      cacheMap: /* @__PURE__ */ new Map([
        [
          0,
          r
        ]
      ])
    };
    return this._cachedMapping.set(t, s), t.on("change:children", this._invalidateOnChildrenChangeCallback), t.on("change:text", this._invalidateOnTextChangeCallback), r;
  }
  /**
  * Stops tracking given `viewContainer`.
  *
  * It removes the cached data and stops listening to {@link module:engine/view/node~ViewNodeChangeEvent `change` event} on the
  * `viewContainer`.
  */
  stopTracking(t) {
    t.off("change:children", this._invalidateOnChildrenChangeCallback), t.off("change:text", this._invalidateOnTextChangeCallback), this._cachedMapping.delete(t);
  }
  /**
  * Invalidates cache inside `viewParent`, starting from given `index` in that parent.
  */
  _clearCacheInsideParent(t, i) {
    if (i == 0)
      this._cachedMapping.has(t) ? this._clearCacheAll(t) : this._clearCacheStartingBefore(t);
    else {
      const r = t.getChild(i - 1);
      this._clearCacheStartingBefore(r);
    }
  }
  /**
  * Clears all the cache for given tracked `viewContainer`.
  */
  _clearCacheAll(t) {
    const i = this._cachedMapping.get(t);
    i.maxModelOffset > 0 && (i.maxModelOffset = 0, i.cacheList.length = 1, i.cacheMap.clear(), i.cacheMap.set(0, i.cacheList[0]));
  }
  /**
  * Clears all the stored cache starting before given `viewNode`. The `viewNode` can be any node that is inside a tracked view element
  * or view document fragment.
  */
  _clearCacheStartingBefore(t) {
    const i = this._nodeToCacheListIndex.get(t);
    if (i === void 0) {
      const s = t.parent;
      this._cachedMapping.has(s) || this._clearCacheStartingBefore(s);
      return;
    }
    let r = t.parent;
    for (; !this._cachedMapping.has(r); )
      r = r.parent;
    this._clearCacheFromIndex(r, i);
  }
  /**
  * Clears all the cache in the cache list related to given `viewContainer`, starting from `index` (inclusive).
  */
  _clearCacheFromIndex(t, i) {
    i === 0 && (i = 1);
    const r = this._cachedMapping.get(t), s = r.cacheList[i - 1];
    if (!s)
      return;
    r.maxModelOffset = s.modelOffset;
    const o = r.cacheList.splice(i);
    for (const a of o) {
      r.cacheMap.delete(a.modelOffset);
      const u = a.viewPosition.nodeBefore;
      this._nodeToCacheListIndex.delete(u);
    }
  }
  /**
  * Finds a cache item in the given cache list, which `modelOffset` is closest (but smaller or equal) to given `offset`.
  *
  * Since `cacheList` is a sorted array, this uses binary search to retrieve the item quickly.
  */
  _findInCacheList(t, i) {
    let r = 0, s = t.length - 1, o = s - r >> 1, a = t[o];
    for (; r < s; )
      a.modelOffset < i ? r = o + 1 : s = o - 1, o = r + (s - r >> 1), a = t[o];
    return a.modelOffset <= i ? a : t[o - 1];
  }
}
class VO {
  constructor() {
    /**
    * Contains list of consumable values.
    */
    m(this, "_consumable", /* @__PURE__ */ new Map());
    /**
    * For each {@link module:engine/model/textproxy~TextProxy} added to `ModelConsumable`, this registry holds a parent
    * of that `TextProxy` and the start and end indices of that `TextProxy`. This allows identification of the `TextProxy`
    * instances that point to the same part of the model but are different instances. Each distinct `TextProxy`
    * is given a unique `Symbol` which is then registered as consumable. This process is transparent for the `ModelConsumable`
    * API user because whenever `TextProxy` is added, tested, consumed or reverted, the internal mechanisms of
    * `ModelConsumable` translate `TextProxy` to that unique `Symbol`.
    */
    m(this, "_textProxyRegistry", /* @__PURE__ */ new Map());
  }
  /**
  * Adds a consumable value to the consumables list and links it with a given model item.
  *
  * ```ts
  * modelConsumable.add( modelElement, 'insert' ); // Add `modelElement` insertion change to consumable values.
  * modelConsumable.add( modelElement, 'addAttribute:bold' ); // Add `bold` attribute insertion on `modelElement` change.
  * modelConsumable.add( modelElement, 'removeAttribute:bold' ); // Add `bold` attribute removal on `modelElement` change.
  * modelConsumable.add( modelSelection, 'selection' ); // Add `modelSelection` to consumable values.
  * modelConsumable.add( modelRange, 'range' ); // Add `modelRange` to consumable values.
  * ```
  *
  * @param item Model item, range or selection that has the consumable.
  * @param type Consumable type. Will be normalized to a proper form, that is either `<word>` or `<part>:<part>`.
  * Second colon and everything after will be cut. Passing event name is a safe and good practice.
  */
  add(n, t) {
    t = Iu(t), n instanceof ii && (n = this._getSymbolForTextProxy(n)), this._consumable.has(n) || this._consumable.set(n, /* @__PURE__ */ new Map()), this._consumable.get(n).set(t, !0);
  }
  /**
  * Removes a given consumable value from a given model item.
  *
  * ```ts
  * modelConsumable.consume( modelElement, 'insert' ); // Remove `modelElement` insertion change from consumable values.
  * modelConsumable.consume( modelElement, 'addAttribute:bold' ); // Remove `bold` attribute insertion on `modelElement` change.
  * modelConsumable.consume( modelElement, 'removeAttribute:bold' ); // Remove `bold` attribute removal on `modelElement` change.
  * modelConsumable.consume( modelSelection, 'selection' ); // Remove `modelSelection` from consumable values.
  * modelConsumable.consume( modelRange, 'range' ); // Remove 'modelRange' from consumable values.
  * ```
  *
  * @param item Model item, range or selection from which consumable will be consumed.
  * @param type Consumable type. Will be normalized to a proper form, that is either `<word>` or `<part>:<part>`.
  * Second colon and everything after will be cut. Passing event name is a safe and good practice.
  * @returns `true` if consumable value was available and was consumed, `false` otherwise.
  */
  consume(n, t) {
    return t = Iu(t), n instanceof ii && (n = this._getSymbolForTextProxy(n)), this.test(n, t) ? (this._consumable.get(n).set(t, !1), !0) : !1;
  }
  /**
  * Tests whether there is a consumable value of a given type connected with a given model item.
  *
  * ```ts
  * modelConsumable.test( modelElement, 'insert' ); // Check for `modelElement` insertion change.
  * modelConsumable.test( modelElement, 'addAttribute:bold' ); // Check for `bold` attribute insertion on `modelElement` change.
  * modelConsumable.test( modelElement, 'removeAttribute:bold' ); // Check for `bold` attribute removal on `modelElement` change.
  * modelConsumable.test( modelSelection, 'selection' ); // Check if `modelSelection` is consumable.
  * modelConsumable.test( modelRange, 'range' ); // Check if `modelRange` is consumable.
  * ```
  *
  * @param item Model item, range or selection to be tested.
  * @param type Consumable type. Will be normalized to a proper form, that is either `<word>` or `<part>:<part>`.
  * Second colon and everything after will be cut. Passing event name is a safe and good practice.
  * @returns `null` if such consumable was never added, `false` if the consumable values was
  * already consumed or `true` if it was added and not consumed yet.
  */
  test(n, t) {
    t = Iu(t), n instanceof ii && (n = this._getSymbolForTextProxy(n));
    const i = this._consumable.get(n);
    if (i === void 0)
      return null;
    const r = i.get(t);
    return r === void 0 ? null : r;
  }
  /**
  * Reverts consuming of a consumable value.
  *
  * ```ts
  * modelConsumable.revert( modelElement, 'insert' ); // Revert consuming `modelElement` insertion change.
  * modelConsumable.revert( modelElement, 'addAttribute:bold' ); // Revert consuming `bold` attribute insert from `modelElement`.
  * modelConsumable.revert( modelElement, 'removeAttribute:bold' ); // Revert consuming `bold` attribute remove from `modelElement`.
  * modelConsumable.revert( modelSelection, 'selection' ); // Revert consuming `modelSelection`.
  * modelConsumable.revert( modelRange, 'range' ); // Revert consuming `modelRange`.
  * ```
  *
  * @param item Model item, range or selection to be reverted.
  * @param type Consumable type.
  * @returns `true` if consumable has been reversed, `false` otherwise. `null` if the consumable has
  * never been added.
  */
  revert(n, t) {
    t = Iu(t), n instanceof ii && (n = this._getSymbolForTextProxy(n));
    const i = this.test(n, t);
    return i === !1 ? (this._consumable.get(n).set(t, !0), !0) : i === !0 ? !1 : null;
  }
  /**
  * Verifies if all events from the specified group were consumed.
  *
  * @param eventGroup The events group to verify.
  */
  verifyAllConsumed(n) {
    const t = [];
    for (const [i, r] of this._consumable)
      for (const [s, o] of r) {
        const a = s.split(":")[0];
        o && n == a && t.push({
          event: s,
          item: i.name || i.description
        });
      }
    if (t.length)
      throw new v("conversion-model-consumable-not-consumed", null, {
        items: t
      });
  }
  /**
  * Gets a unique symbol for the passed {@link module:engine/model/textproxy~TextProxy} instance. All `TextProxy` instances that
  * have same parent, same start index and same end index will get the same symbol.
  *
  * Used internally to correctly consume `TextProxy` instances.
  *
  * @internal
  * @param textProxy `TextProxy` instance to get a symbol for.
  * @returns Symbol representing all equal instances of `TextProxy`.
  */
  _getSymbolForTextProxy(n) {
    let t = null;
    const i = this._textProxyRegistry.get(n.startOffset);
    if (i) {
      const r = i.get(n.endOffset);
      r && (t = r.get(n.parent));
    }
    return t || (t = this._addSymbolForTextProxy(n)), t;
  }
  /**
  * Adds a symbol for the given {@link module:engine/model/textproxy~TextProxy} instance.
  *
  * Used internally to correctly consume `TextProxy` instances.
  *
  * @param textProxy Text proxy instance.
  * @returns Symbol generated for given `TextProxy`.
  */
  _addSymbolForTextProxy(n) {
    const t = n.startOffset, i = n.endOffset, r = n.parent, s = Symbol("$textProxy:" + n.data);
    let o, a;
    return o = this._textProxyRegistry.get(t), o || (o = /* @__PURE__ */ new Map(), this._textProxyRegistry.set(t, o)), a = o.get(i), a || (a = /* @__PURE__ */ new Map(), o.set(i, a)), a.set(r, s), s;
  }
}
function Iu(e) {
  const n = e.split(":");
  return n[0] == "insert" ? n[0] : n[0] == "addMarker" || n[0] == "removeMarker" ? e : n.length > 1 ? n[0] + ":" + n[1] : n[0];
}
class oT extends (/* @__PURE__ */ Je()) {
  /**
  * Creates a downcast dispatcher instance.
  *
  * @see module:engine/conversion/downcastdispatcher~DowncastConversionApi
  *
  * @param conversionApi Additional properties for an interface that will be passed to events fired
  * by the downcast dispatcher.
  */
  constructor(t) {
    super();
    /**
    * A template for an interface passed by the dispatcher to the event callbacks.
    *
    * @internal
    */
    m(this, "_conversionApi");
    /**
    * A map of already fired events for a given `ModelConsumable`.
    */
    m(this, "_firedEventsMap");
    this._conversionApi = {
      dispatcher: this,
      ...t
    }, this._firedEventsMap = /* @__PURE__ */ new WeakMap();
  }
  /**
  * Converts changes buffered in the given {@link module:engine/model/differ~Differ model differ}
  * and fires conversion events based on it.
  *
  * @fires insert
  * @fires remove
  * @fires attribute
  * @fires addMarker
  * @fires removeMarker
  * @fires reduceChanges
  * @param differ The differ object with buffered changes.
  * @param markers Markers related to the model fragment to convert.
  * @param writer The view writer that should be used to modify the view document.
  */
  convertChanges(t, i, r) {
    const s = this._createConversionApi(r, t.getRefreshedItems());
    for (const a of t.getMarkersToRemove())
      this._convertMarkerRemove(a.name, a.range, s);
    const o = this._reduceChanges(t.getChanges());
    for (const a of o)
      a.type === "insert" ? this._convertInsert(B._createFromPositionAndShift(a.position, a.length), s) : a.type === "reinsert" ? this._convertReinsert(B._createFromPositionAndShift(a.position, a.length), s) : a.type === "remove" ? this._convertRemove(a.position, a.length, a.name, s) : this._convertAttribute(a.range, a.attributeKey, a.attributeOldValue, a.attributeNewValue, s);
    s.mapper.flushDeferredBindings();
    for (const a of s.mapper.flushUnboundMarkerNames()) {
      const u = i.get(a).getRange();
      this._convertMarkerRemove(a, u, s), this._convertMarkerAdd(a, u, s);
    }
    for (const a of t.getMarkersToAdd())
      this._convertMarkerAdd(a.name, a.range, s);
    s.consumable.verifyAllConsumed("insert");
  }
  /**
  * Starts a conversion of a model range and the provided markers.
  *
  * @fires insert
  * @fires attribute
  * @fires addMarker
  * @param range The inserted range.
  * @param markers The map of markers that should be down-casted.
  * @param writer The view writer that should be used to modify the view document.
  * @param options Optional options object passed to `convertionApi.options`.
  */
  convert(t, i, r, s = {}) {
    const o = this._createConversionApi(r, void 0, s);
    this._convertInsert(t, o);
    for (const [a, u] of i)
      this._convertMarkerAdd(a, u, o);
    o.consumable.verifyAllConsumed("insert");
  }
  /**
  * Starts the model selection conversion.
  *
  * Fires events for a given {@link module:engine/model/selection~Selection selection} to start the selection conversion.
  *
  * @fires selection
  * @fires addMarker
  * @fires attribute
  * @param selection The selection to convert.
  * @param markers Markers connected with the converted model.
  * @param writer View writer that should be used to modify the view document.
  */
  convertSelection(t, i, r) {
    const s = this._createConversionApi(r);
    this.fire("cleanSelection", {
      selection: t
    }, s);
    const o = t.getFirstPosition().root;
    if (!s.mapper.toViewElement(o))
      return;
    const a = Array.from(i.getMarkersAtPosition(t.getFirstPosition()));
    if (this._addConsumablesForSelection(s.consumable, t, a), this.fire("selection", {
      selection: t
    }, s), !!t.isCollapsed) {
      for (const u of a)
        if (s.consumable.test(t, "addMarker:" + u.name)) {
          const l = u.getRange();
          if (!$O(t.getFirstPosition(), u, s.mapper))
            continue;
          const c = {
            item: t,
            markerName: u.name,
            markerRange: l
          };
          this.fire(`addMarker:${u.name}`, c, s);
        }
      for (const u of t.getAttributeKeys())
        if (s.consumable.test(t, "attribute:" + u)) {
          const l = {
            item: t,
            range: t.getFirstRange(),
            attributeKey: u,
            attributeOldValue: null,
            attributeNewValue: t.getAttribute(u)
          };
          this.fire(`attribute:${u}:$text`, l, s);
        }
    }
  }
  /**
  * Fires insertion conversion of a range of nodes.
  *
  * For each node in the range, {@link #event:insert `insert` event is fired}. For each attribute on each node,
  * {@link #event:attribute `attribute` event is fired}.
  *
  * @fires insert
  * @fires attribute
  * @param range The inserted range.
  * @param conversionApi The conversion API object.
  * @param options.doNotAddConsumables Whether the ModelConsumable should not get populated
  * for items in the provided range.
  */
  _convertInsert(t, i, r = {}) {
    r.doNotAddConsumables || this._addConsumablesForInsert(i.consumable, t);
    for (const s of t.getWalker({
      shallow: !0
    }))
      this._testAndFire("insert", xp(s), i);
  }
  /**
  * Fires conversion of a single node removal. Fires {@link #event:remove remove event} with provided data.
  *
  * @param position Position from which node was removed.
  * @param length Offset size of removed node.
  * @param name Name of removed node.
  * @param conversionApi The conversion API object.
  */
  _convertRemove(t, i, r, s) {
    this.fire(`remove:${r}`, {
      position: t,
      length: i
    }, s);
  }
  /**
  * Starts a conversion of an attribute change on a given `range`.
  *
  * For each node in the given `range`, {@link #event:attribute attribute event} is fired with the passed data.
  *
  * @fires attribute
  * @param range Changed range.
  * @param key Key of the attribute that has changed.
  * @param oldValue Attribute value before the change or `null` if the attribute has not been set before.
  * @param newValue New attribute value or `null` if the attribute has been removed.
  * @param conversionApi The conversion API object.
  */
  _convertAttribute(t, i, r, s, o) {
    this._addConsumablesForRange(o.consumable, t, `attribute:${i}`);
    for (const a of t) {
      const u = {
        item: a.item,
        range: B._createFromPositionAndShift(a.previousPosition, a.length),
        attributeKey: i,
        attributeOldValue: r,
        attributeNewValue: s
      };
      this._testAndFire(`attribute:${i}`, u, o);
    }
  }
  /**
  * Fires re-insertion conversion (with a `reconversion` flag passed to `insert` events)
  * of a range of elements (only elements on the range depth, without children).
  *
  * For each node in the range on its depth (without children), {@link #event:insert `insert` event} is fired.
  * For each attribute on each node, {@link #event:attribute `attribute` event} is fired.
  *
  * @fires insert
  * @fires attribute
  * @param range The range to reinsert.
  * @param conversionApi The conversion API object.
  */
  _convertReinsert(t, i) {
    const r = Array.from(t.getWalker({
      shallow: !0
    }));
    this._addConsumablesForInsert(i.consumable, r);
    for (const s of r.map(xp))
      this._testAndFire("insert", {
        ...s,
        reconversion: !0
      }, i);
  }
  /**
  * Converts the added marker. Fires the {@link #event:addMarker `addMarker`} event for each item
  * in the marker's range. If the range is collapsed, a single event is dispatched. See the event description for more details.
  *
  * @fires addMarker
  * @param markerName Marker name.
  * @param markerRange The marker range.
  * @param conversionApi The conversion API object.
  */
  _convertMarkerAdd(t, i, r) {
    if (i.root.rootName == "$graveyard")
      return;
    const s = `addMarker:${t}`;
    if (r.consumable.add(i, s), this.fire(s, {
      markerName: t,
      markerRange: i
    }, r), !!r.consumable.consume(i, s)) {
      this._addConsumablesForRange(r.consumable, i, s);
      for (const o of i.getItems()) {
        if (!r.consumable.test(o, s))
          continue;
        const a = {
          item: o,
          range: B._createOn(o),
          markerName: t,
          markerRange: i
        };
        this.fire(s, a, r);
      }
    }
  }
  /**
  * Fires the conversion of the marker removal. Fires the {@link #event:removeMarker `removeMarker`} event with the provided data.
  *
  * @fires removeMarker
  * @param markerName Marker name.
  * @param markerRange The marker range.
  * @param conversionApi The conversion API object.
  */
  _convertMarkerRemove(t, i, r) {
    i.root.rootName != "$graveyard" && this.fire(`removeMarker:${t}`, {
      markerName: t,
      markerRange: i
    }, r);
  }
  /**
  * Fires the reduction of changes buffered in the {@link module:engine/model/differ~Differ `Differ`}.
  *
  * Features can replace selected {@link module:engine/model/differ~DiffItem `DiffItem`}s with `reinsert` entries to trigger
  * reconversion. The {@link module:engine/conversion/downcasthelpers~DowncastHelpers#elementToStructure
  * `DowncastHelpers.elementToStructure()`} is using this event to trigger reconversion.
  *
  * @fires reduceChanges
  */
  _reduceChanges(t) {
    const i = {
      changes: t
    };
    return this.fire("reduceChanges", i), i.changes;
  }
  /**
  * Populates provided {@link module:engine/conversion/modelconsumable~ModelConsumable} with values to consume from a given range,
  * assuming that the range has just been inserted to the model.
  *
  * @param consumable The consumable.
  * @param walkerValues The walker values for the inserted range.
  * @returns The values to consume.
  */
  _addConsumablesForInsert(t, i) {
    for (const r of i) {
      const s = r.item;
      if (t.test(s, "insert") === null) {
        t.add(s, "insert");
        for (const o of s.getAttributeKeys())
          t.add(s, "attribute:" + o);
      }
    }
    return t;
  }
  /**
  * Populates provided {@link module:engine/conversion/modelconsumable~ModelConsumable} with values to consume for a given range.
  *
  * @param consumable The consumable.
  * @param range The affected range.
  * @param type Consumable type.
  * @returns The values to consume.
  */
  _addConsumablesForRange(t, i, r) {
    for (const s of i.getItems())
      t.add(s, r);
    return t;
  }
  /**
  * Populates provided {@link module:engine/conversion/modelconsumable~ModelConsumable} with selection consumable values.
  *
  * @param consumable The consumable.
  * @param selection The selection to create the consumable from.
  * @param markers Markers that contain the selection.
  * @returns The values to consume.
  */
  _addConsumablesForSelection(t, i, r) {
    t.add(i, "selection");
    for (const s of r)
      t.add(i, "addMarker:" + s.name);
    for (const s of i.getAttributeKeys())
      t.add(i, "attribute:" + s);
    return t;
  }
  /**
  * Tests whether given event wasn't already fired and if so, fires it.
  *
  * @fires insert
  * @fires attribute
  * @param type Event type.
  * @param data Event data.
  * @param conversionApi The conversion API object.
  */
  _testAndFire(t, i, r) {
    const s = WO(t, i), o = i.item.is("$textProxy") ? r.consumable._getSymbolForTextProxy(i.item) : i.item, a = this._firedEventsMap.get(r), u = a.get(o);
    if (!u)
      a.set(o, /* @__PURE__ */ new Set([
        s
      ]));
    else if (!u.has(s))
      u.add(s);
    else
      return;
    this.fire(s, i, r);
  }
  /**
  * Fires not already fired events for setting attributes on just inserted item.
  *
  * @param item The model item to convert attributes for.
  * @param conversionApi The conversion API object.
  */
  _testAndFireAddAttributes(t, i) {
    const r = {
      item: t,
      range: B._createOn(t)
    };
    for (const s of r.item.getAttributeKeys())
      r.attributeKey = s, r.attributeOldValue = null, r.attributeNewValue = r.item.getAttribute(s), this._testAndFire(`attribute:${s}`, r, i);
  }
  /**
  * Builds an instance of the {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi} from a template and a given
  * {@link module:engine/view/downcastwriter~DowncastWriter `DowncastWriter`} and options object.
  *
  * @param writer View writer that should be used to modify the view document.
  * @param refreshedItems A set of model elements that should not reuse their
  * previous view representations.
  * @param options Optional options passed to `convertionApi.options`.
  * @return The conversion API object.
  */
  _createConversionApi(t, i = /* @__PURE__ */ new Set(), r = {}) {
    const s = {
      ...this._conversionApi,
      consumable: new VO(),
      writer: t,
      options: r,
      convertItem: (o) => this._convertInsert(B._createOn(o), s),
      convertChildren: (o) => this._convertInsert(B._createIn(o), s, {
        doNotAddConsumables: !0
      }),
      convertAttributes: (o) => this._testAndFireAddAttributes(o, s),
      canReuseView: (o) => !i.has(s.mapper.toModelElement(o))
    };
    return this._firedEventsMap.set(s, /* @__PURE__ */ new Map()), s;
  }
}
function $O(e, n, t) {
  const i = n.getRange(), r = Array.from(e.getAncestors());
  return r.shift(), r.reverse(), !r.some((o) => {
    if (i.containsItem(o))
      return !!t.toViewElement(o).getCustomProperty("addHighlight");
  });
}
function WO(e, n) {
  const t = n.item.is("element") ? n.item.name : "$text";
  return `${e}:${t}`;
}
function xp(e) {
  return {
    item: e.item,
    range: B._createFromPositionAndShift(e.previousPosition, e.length)
  };
}
let ds = class extends Ir {
  /**
  * Creates a model node.
  *
  * This is an abstract class, so this constructor should not be used directly.
  *
  * @param attrs Node's attributes. See {@link module:utils/tomap~toMap} for a list of accepted values.
  */
  constructor(t) {
    super();
    /**
    * Parent of this node. It could be {@link module:engine/model/element~Element}
    * or {@link module:engine/model/documentfragment~DocumentFragment}.
    * Equals to `null` if the node has no parent.
    */
    m(this, "parent", null);
    /**
    * Attributes set on this node.
    */
    m(this, "_attrs");
    /**
    * Index of this node in its parent or `null` if the node has no parent.
    *
    * @internal
    */
    m(this, "_index", null);
    /**
    * Offset at which this node starts in its parent or `null` if the node has no parent.
    *
    * @internal
    */
    m(this, "_startOffset", null);
    this._attrs = Si(t);
  }
  /**
  * {@link module:engine/model/document~Document Document} that owns this root element.
  */
  get document() {
    return null;
  }
  /**
  * Index of this node in its parent or `null` if the node has no parent.
  */
  get index() {
    return this._index;
  }
  /**
  * Offset at which this node starts in its parent. It is equal to the sum of {@link #offsetSize offsetSize}
  * of all its previous siblings. Equals to `null` if node has no parent.
  */
  get startOffset() {
    return this._startOffset;
  }
  /**
  * Offset size of this node.
  *
  * Represents how much "offset space" is occupied by the node in its parent. It is important for
  * {@link module:engine/model/position~Position position}. When node has `offsetSize` greater than `1`, position can be placed between
  * that node start and end. `offsetSize` greater than `1` is for nodes that represents more than one entity, i.e.
  * a {@link module:engine/model/text~Text text node}.
  */
  get offsetSize() {
    return 1;
  }
  /**
  * Offset at which this node ends in its parent. It is equal to the sum of this node's
  * {@link module:engine/model/node~Node#startOffset start offset} and {@link #offsetSize offset size}.
  * Equals to `null` if the node has no parent.
  */
  get endOffset() {
    return this.startOffset === null ? null : this.startOffset + this.offsetSize;
  }
  /**
  * Node's next sibling or `null` if the node is a last child of it's parent or if the node has no parent.
  */
  get nextSibling() {
    const t = this.index;
    return t !== null && this.parent.getChild(t + 1) || null;
  }
  /**
  * Node's previous sibling or `null` if the node is a first child of it's parent or if the node has no parent.
  */
  get previousSibling() {
    const t = this.index;
    return t !== null && this.parent.getChild(t - 1) || null;
  }
  /**
  * The top-most ancestor of the node. If node has no parent it is the root itself. If the node is a part
  * of {@link module:engine/model/documentfragment~DocumentFragment}, it's `root` is equal to that `DocumentFragment`.
  */
  get root() {
    let t = this;
    for (; t.parent; )
      t = t.parent;
    return t;
  }
  /**
  * Returns `true` if the node is inside a document root that is attached to the document.
  */
  isAttached() {
    return this.parent === null ? !1 : this.root.isAttached();
  }
  /**
  * Gets path to the node. The path is an array containing starting offsets of consecutive ancestors of this node,
  * beginning from {@link module:engine/model/node~Node#root root}, down to this node's starting offset. The path can be used to
  * create {@link module:engine/model/position~Position Position} instance.
  *
  * ```ts
  * const abc = new Text( 'abc' );
  * const foo = new Text( 'foo' );
  * const h1 = new Element( 'h1', null, new Text( 'header' ) );
  * const p = new Element( 'p', null, [ abc, foo ] );
  * const div = new Element( 'div', null, [ h1, p ] );
  * foo.getPath(); // Returns [ 1, 3 ]. `foo` is in `p` which is in `div`. `p` starts at offset 1, while `foo` at 3.
  * h1.getPath(); // Returns [ 0 ].
  * div.getPath(); // Returns [].
  * ```
  */
  getPath() {
    const t = [];
    let i = this;
    for (; i.parent; )
      t.unshift(i.startOffset), i = i.parent;
    return t;
  }
  /**
  * Returns ancestors array of this node.
  *
  * @param options Options object.
  * @param options.includeSelf When set to `true` this node will be also included in parent's array.
  * @param options.parentFirst When set to `true`, array will be sorted from node's parent to root element,
  * otherwise root element will be the first item in the array.
  * @returns Array with ancestors.
  */
  getAncestors(t = {}) {
    const i = [];
    let r = t.includeSelf ? this : this.parent;
    for (; r; )
      i[t.parentFirst ? "push" : "unshift"](r), r = r.parent;
    return i;
  }
  /**
  * Returns a {@link module:engine/model/element~Element} or {@link module:engine/model/documentfragment~DocumentFragment}
  * which is a common ancestor of both nodes.
  *
  * @param node The second node.
  * @param options Options object.
  * @param options.includeSelf When set to `true` both nodes will be considered "ancestors" too.
  * Which means that if e.g. node A is inside B, then their common ancestor will be B.
  */
  getCommonAncestor(t, i = {}) {
    const r = this.getAncestors(i), s = t.getAncestors(i);
    let o = 0;
    for (; r[o] == s[o] && r[o]; )
      o++;
    return o === 0 ? null : r[o - 1];
  }
  /**
  * Returns whether this node is before given node. `false` is returned if nodes are in different trees (for example,
  * in different {@link module:engine/model/documentfragment~DocumentFragment}s).
  *
  * @param node Node to compare with.
  */
  isBefore(t) {
    if (this == t || this.root !== t.root)
      return !1;
    const i = this.getPath(), r = t.getPath(), s = sn(i, r);
    switch (s) {
      case "prefix":
        return !0;
      case "extension":
        return !1;
      default:
        return i[s] < r[s];
    }
  }
  /**
  * Returns whether this node is after given node. `false` is returned if nodes are in different trees (for example,
  * in different {@link module:engine/model/documentfragment~DocumentFragment}s).
  *
  * @param node Node to compare with.
  */
  isAfter(t) {
    return this == t || this.root !== t.root ? !1 : !this.isBefore(t);
  }
  /**
  * Checks if the node has an attribute with given key.
  *
  * @param key Key of attribute to check.
  * @returns `true` if attribute with given key is set on node, `false` otherwise.
  */
  hasAttribute(t) {
    return this._attrs.has(t);
  }
  /**
  * Gets an attribute value for given key or `undefined` if that attribute is not set on node.
  *
  * @param key Key of attribute to look for.
  * @returns Attribute value or `undefined`.
  */
  getAttribute(t) {
    return this._attrs.get(t);
  }
  /**
  * Returns iterator that iterates over this node's attributes.
  *
  * Attributes are returned as arrays containing two items. First one is attribute key and second is attribute value.
  * This format is accepted by native `Map` object and also can be passed in `Node` constructor.
  */
  getAttributes() {
    return this._attrs.entries();
  }
  /**
  * Returns iterator that iterates over this node's attribute keys.
  */
  getAttributeKeys() {
    return this._attrs.keys();
  }
  /**
  * Converts `Node` to plain object and returns it.
  *
  * @returns `Node` converted to plain object.
  */
  toJSON() {
    const t = {};
    return this._attrs.size && (t.attributes = Array.from(this._attrs).reduce((i, r) => (i[r[0]] = r[1], i), {})), t;
  }
  /**
  * Creates a copy of this node, that is a node with exactly same attributes, and returns it.
  *
  * @internal
  * @returns Node with same attributes as this node.
  */
  _clone(t) {
    return new this.constructor(this._attrs);
  }
  /**
  * Removes this node from its parent.
  *
  * @internal
  * @see module:engine/model/writer~Writer#remove
  */
  _remove() {
    this.parent._removeChildren(this.index);
  }
  /**
  * Sets attribute on the node. If attribute with the same key already is set, it's value is overwritten.
  *
  * @see module:engine/model/writer~Writer#setAttribute
  * @internal
  * @param key Key of attribute to set.
  * @param value Attribute value.
  */
  _setAttribute(t, i) {
    this._attrs.set(t, i);
  }
  /**
  * Removes all attributes from the node and sets given attributes.
  *
  * @see module:engine/model/writer~Writer#setAttributes
  * @internal
  * @param attrs Attributes to set. See {@link module:utils/tomap~toMap} for a list of accepted values.
  */
  _setAttributesTo(t) {
    this._attrs = Si(t);
  }
  /**
  * Removes an attribute with given key from the node.
  *
  * @see module:engine/model/writer~Writer#removeAttribute
  * @internal
  * @param key Key of attribute to remove.
  * @returns `true` if the attribute was set on the element, `false` otherwise.
  */
  _removeAttribute(t) {
    return this._attrs.delete(t);
  }
  /**
  * Removes all attributes from the node.
  *
  * @see module:engine/model/writer~Writer#clearAttributes
  * @internal
  */
  _clearAttributes() {
    this._attrs.clear();
  }
};
ds.prototype.is = function(e) {
  return e === "node" || e === "model:node";
};
class Sn extends (/* @__PURE__ */ Je(Ir)) {
  /**
  * Creates a new selection instance based on the given {@link module:engine/model/selection~Selectable selectable}
  * or creates an empty selection if no arguments were passed.
  *
  * ```ts
  * // Creates empty selection without ranges.
  * const selection = writer.createSelection();
  *
  * // Creates selection at the given range.
  * const range = writer.createRange( start, end );
  * const selection = writer.createSelection( range );
  *
  * // Creates selection at the given ranges
  * const ranges = [ writer.createRange( start1, end2 ), writer.createRange( star2, end2 ) ];
  * const selection = writer.createSelection( ranges );
  *
  * // Creates selection from the other selection.
  * // Note: It doesn't copy selection attributes.
  * const otherSelection = writer.createSelection();
  * const selection = writer.createSelection( otherSelection );
  *
  * // Creates selection from the given document selection.
  * // Note: It doesn't copy selection attributes.
  * const documentSelection = model.document.selection;
  * const selection = writer.createSelection( documentSelection );
  *
  * // Creates selection at the given position.
  * const position = writer.createPositionFromPath( root, path );
  * const selection = writer.createSelection( position );
  *
  * // Creates selection at the given offset in the given element.
  * const paragraph = writer.createElement( 'paragraph' );
  * const selection = writer.createSelection( paragraph, offset );
  *
  * // Creates a range inside an {@link module:engine/model/element~Element element} which starts before the
  * // first child of that element and ends after the last child of that element.
  * const selection = writer.createSelection( paragraph, 'in' );
  *
  * // Creates a range on an {@link module:engine/model/item~Item item} which starts before the item and ends
  * // just after the item.
  * const selection = writer.createSelection( paragraph, 'on' );
  * ```
  *
  * Selection's constructor allow passing additional options (`'backward'`) as the last argument.
  *
  * ```ts
  * // Creates backward selection.
  * const selection = writer.createSelection( range, { backward: true } );
  * ```
  *
  * @internal
  */
  constructor(...t) {
    super();
    /**
    * Specifies whether the last added range was added as a backward or forward range.
    */
    m(this, "_lastRangeBackward", !1);
    /**
    * List of attributes set on current selection.
    */
    m(this, "_attrs", /* @__PURE__ */ new Map());
    /** @internal */
    m(this, "_ranges", []);
    t.length && this.setTo(...t);
  }
  /**
  * Selection anchor. Anchor is the position from which the selection was started. If a user is making a selection
  * by dragging the mouse, the anchor is where the user pressed the mouse button (the beginning of the selection).
  *
  * Anchor and {@link #focus} define the direction of the selection, which is important
  * when expanding/shrinking selection. The focus moves, while the anchor should remain in the same place.
  *
  * Anchor is always set to the {@link module:engine/model/range~Range#start start} or
  * {@link module:engine/model/range~Range#end end} position of the last of selection's ranges. Whether it is
  * the `start` or `end` depends on the specified `options.backward`. See the {@link #setTo `setTo()`} method.
  *
  * May be set to `null` if there are no ranges in the selection.
  *
  * @see #focus
  */
  get anchor() {
    if (this._ranges.length > 0) {
      const t = this._ranges[this._ranges.length - 1];
      return this._lastRangeBackward ? t.end : t.start;
    }
    return null;
  }
  /**
  * Selection focus. Focus is the position where the selection ends. If a user is making a selection
  * by dragging the mouse, the focus is where the mouse cursor is.
  *
  * May be set to `null` if there are no ranges in the selection.
  *
  * @see #anchor
  */
  get focus() {
    if (this._ranges.length > 0) {
      const t = this._ranges[this._ranges.length - 1];
      return this._lastRangeBackward ? t.start : t.end;
    }
    return null;
  }
  /**
  * Whether the selection is collapsed. Selection is collapsed when there is exactly one range in it
  * and it is collapsed.
  */
  get isCollapsed() {
    return this._ranges.length === 1 ? this._ranges[0].isCollapsed : !1;
  }
  /**
  * Returns the number of ranges in the selection.
  */
  get rangeCount() {
    return this._ranges.length;
  }
  /**
  * Specifies whether the selection's {@link #focus} precedes the selection's {@link #anchor}.
  */
  get isBackward() {
    return !this.isCollapsed && this._lastRangeBackward;
  }
  /**
  * Checks whether this selection is equal to the given selection. Selections are equal if they have the same directions,
  * the same number of ranges and all ranges from one selection equal to ranges from the another selection.
  *
  * @param otherSelection Selection to compare with.
  * @returns `true` if selections are equal, `false` otherwise.
  */
  isEqual(t) {
    if (this.rangeCount != t.rangeCount)
      return !1;
    if (this.rangeCount === 0)
      return !0;
    if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus))
      return !1;
    for (const i of this._ranges) {
      let r = !1;
      for (const s of t._ranges)
        if (i.isEqual(s)) {
          r = !0;
          break;
        }
      if (!r)
        return !1;
    }
    return !0;
  }
  /**
  * Returns an iterable object that iterates over copies of selection ranges.
  */
  *getRanges() {
    for (const t of this._ranges)
      yield new B(t.start, t.end);
  }
  /**
  * Returns a copy of the first range in the selection.
  * First range is the one which {@link module:engine/model/range~Range#start start} position
  * {@link module:engine/model/position~Position#isBefore is before} start position of all other ranges
  * (not to confuse with the first range added to the selection).
  *
  * Returns `null` if there are no ranges in selection.
  */
  getFirstRange() {
    let t = null;
    for (const i of this._ranges)
      (!t || i.start.isBefore(t.start)) && (t = i);
    return t ? new B(t.start, t.end) : null;
  }
  /**
  * Returns a copy of the last range in the selection.
  * Last range is the one which {@link module:engine/model/range~Range#end end} position
  * {@link module:engine/model/position~Position#isAfter is after} end position of all other ranges (not to confuse with the range most
  * recently added to the selection).
  *
  * Returns `null` if there are no ranges in selection.
  */
  getLastRange() {
    let t = null;
    for (const i of this._ranges)
      (!t || i.end.isAfter(t.end)) && (t = i);
    return t ? new B(t.start, t.end) : null;
  }
  /**
  * Returns the first position in the selection.
  * First position is the position that {@link module:engine/model/position~Position#isBefore is before}
  * any other position in the selection.
  *
  * Returns `null` if there are no ranges in selection.
  */
  getFirstPosition() {
    const t = this.getFirstRange();
    return t ? t.start.clone() : null;
  }
  /**
  * Returns the last position in the selection.
  * Last position is the position that {@link module:engine/model/position~Position#isAfter is after}
  * any other position in the selection.
  *
  * Returns `null` if there are no ranges in selection.
  */
  getLastPosition() {
    const t = this.getLastRange();
    return t ? t.end.clone() : null;
  }
  /**
  * Sets this selection's ranges and direction to the specified location based on the given
  * {@link module:engine/model/selection~Selectable selectable}.
  *
  * ```ts
  * // Removes all selection's ranges.
  * selection.setTo( null );
  *
  * // Sets selection to the given range.
  * const range = writer.createRange( start, end );
  * selection.setTo( range );
  *
  * // Sets selection to given ranges.
  * const ranges = [ writer.createRange( start1, end2 ), writer.createRange( star2, end2 ) ];
  * selection.setTo( ranges );
  *
  * // Sets selection to other selection.
  * // Note: It doesn't copy selection attributes.
  * const otherSelection = writer.createSelection();
  * selection.setTo( otherSelection );
  *
  * // Sets selection to the given document selection.
  * // Note: It doesn't copy selection attributes.
  * const documentSelection = new DocumentSelection( doc );
  * selection.setTo( documentSelection );
  *
  * // Sets collapsed selection at the given position.
  * const position = writer.createPositionFromPath( root, path );
  * selection.setTo( position );
  *
  * // Sets collapsed selection at the position of the given node and an offset.
  * selection.setTo( paragraph, offset );
  * ```
  *
  * Creates a range inside an {@link module:engine/model/element~Element element} which starts before the first child of
   * that element and ends after the last child of that element.
  *
  * ```ts
  * selection.setTo( paragraph, 'in' );
  * ```
  *
  * Creates a range on an {@link module:engine/model/item~Item item} which starts before the item and ends just after the item.
  *
  * ```ts
  * selection.setTo( paragraph, 'on' );
  * ```
  *
  * `Selection#setTo()`' method allow passing additional options (`backward`) as the last argument.
  *
  * ```ts
  * // Sets backward selection.
  * const selection = writer.createSelection( range, { backward: true } );
  * ```
  */
  setTo(...t) {
    let [i, r, s] = t;
    if (typeof r == "object" && (s = r, r = void 0), i === null)
      this._setRanges([]);
    else if (i instanceof Sn)
      this._setRanges(i.getRanges(), i.isBackward);
    else if (i && typeof i.getRanges == "function")
      this._setRanges(i.getRanges(), i.isBackward);
    else if (i instanceof B)
      this._setRanges([
        i
      ], !!s && !!s.backward);
    else if (i instanceof z)
      this._setRanges([
        new B(i)
      ]);
    else if (i instanceof ds) {
      const o = !!s && !!s.backward;
      let a;
      if (r == "in")
        a = B._createIn(i);
      else if (r == "on")
        a = B._createOn(i);
      else if (r !== void 0)
        a = new B(z._createAt(i, r));
      else
        throw new v("model-selection-setto-required-second-parameter", [
          this,
          i
        ]);
      this._setRanges([
        a
      ], o);
    } else if (Nn(i))
      this._setRanges(i, s && !!s.backward);
    else
      throw new v("model-selection-setto-not-selectable", [
        this,
        i
      ]);
  }
  /**
  * Replaces all ranges that were added to the selection with given array of ranges. Last range of the array
  * is treated like the last added range and is used to set {@link module:engine/model/selection~Selection#anchor} and
  * {@link module:engine/model/selection~Selection#focus}. Accepts a flag describing in which direction the selection is made.
  *
  * @fires change:range
  * @param newRanges Ranges to set.
  * @param isLastBackward Flag describing if last added range was selected forward - from start to end (`false`)
  * or backward - from end to start (`true`).
  */
  _setRanges(t, i = !1) {
    const r = Array.from(t), s = r.some((o) => {
      if (!(o instanceof B))
        throw new v("model-selection-set-ranges-not-range", [
          this,
          t
        ]);
      return this._ranges.every((a) => !a.isEqual(o));
    });
    r.length === this._ranges.length && !s || (this._replaceAllRanges(r), this._lastRangeBackward = !!i, this.fire("change:range", {
      directChange: !0
    }));
  }
  /**
  * Moves {@link module:engine/model/selection~Selection#focus} to the specified location.
  *
  * The location can be specified in the same form as
  * {@link module:engine/model/writer~Writer#createPositionAt writer.createPositionAt()} parameters.
  *
  * @fires change:range
  * @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/model/item~Item model item}.
  */
  setFocus(t, i) {
    if (this.anchor === null)
      throw new v("model-selection-setfocus-no-ranges", [
        this,
        t
      ]);
    const r = z._createAt(t, i);
    if (r.compareWith(this.focus) == "same")
      return;
    const s = this.anchor;
    this._ranges.length && this._popRange(), r.compareWith(s) == "before" ? (this._pushRange(new B(r, s)), this._lastRangeBackward = !0) : (this._pushRange(new B(s, r)), this._lastRangeBackward = !1), this.fire("change:range", {
      directChange: !0
    });
  }
  /**
  * Gets an attribute value for given key or `undefined` if that attribute is not set on the selection.
  *
  * @param key Key of attribute to look for.
  * @returns Attribute value or `undefined`.
  */
  getAttribute(t) {
    return this._attrs.get(t);
  }
  /**
  * Returns iterable that iterates over this selection's attributes.
  *
  * Attributes are returned as arrays containing two items. First one is attribute key and second is attribute value.
  * This format is accepted by native `Map` object and also can be passed in `Node` constructor.
  */
  getAttributes() {
    return this._attrs.entries();
  }
  /**
  * Returns iterable that iterates over this selection's attribute keys.
  */
  getAttributeKeys() {
    return this._attrs.keys();
  }
  /**
  * Checks if the selection has an attribute for given key.
  *
  * @param key Key of attribute to check.
  * @returns `true` if attribute with given key is set on selection, `false` otherwise.
  */
  hasAttribute(t) {
    return this._attrs.has(t);
  }
  /**
  * Removes an attribute with given key from the selection.
  *
  * If given attribute was set on the selection, fires the {@link #event:change:range} event with
  * removed attribute key.
  *
  * @fires change:attribute
  * @param key Key of attribute to remove.
  */
  removeAttribute(t) {
    this.hasAttribute(t) && (this._attrs.delete(t), this.fire("change:attribute", {
      attributeKeys: [
        t
      ],
      directChange: !0
    }));
  }
  /**
  * Sets attribute on the selection. If attribute with the same key already is set, it's value is overwritten.
  *
  * If the attribute value has changed, fires the {@link #event:change:range} event with
  * the attribute key.
  *
  * @fires change:attribute
  * @param key Key of attribute to set.
  * @param value Attribute value.
  */
  setAttribute(t, i) {
    this.getAttribute(t) !== i && (this._attrs.set(t, i), this.fire("change:attribute", {
      attributeKeys: [
        t
      ],
      directChange: !0
    }));
  }
  /**
  * Returns the selected element. {@link module:engine/model/element~Element Element} is considered as selected if there is only
  * one range in the selection, and that range contains exactly one element.
  * Returns `null` if there is no selected element.
  */
  getSelectedElement() {
    return this.rangeCount !== 1 ? null : this.getFirstRange().getContainedElement();
  }
  /**
  * Gets elements of type {@link module:engine/model/schema~Schema#isBlock "block"} touched by the selection.
  *
  * This method's result can be used for example to apply block styling to all blocks covered by this selection.
  *
  * **Note:** `getSelectedBlocks()` returns blocks that are nested in other non-block elements
  * but will not return blocks nested in other blocks.
  *
  * In this case the function will return exactly all 3 paragraphs (note: `<blockQuote>` is not a block itself):
  *
  * ```xml
  * <paragraph>[a</paragraph>
  * <blockQuote>
  * 	<paragraph>b</paragraph>
  * </blockQuote>
  * <paragraph>c]d</paragraph>
  * ```
  *
  * In this case the paragraph will also be returned, despite the collapsed selection:
  *
  * ```xml
  * <paragraph>[]a</paragraph>
  * ```
  *
  * In such a scenario, however, only blocks A, B & E will be returned as blocks C & D are nested in block B:
  *
  * ```xml
  * [<blockA></blockA>
  * <blockB>
  * 	<blockC></blockC>
  * 	<blockD></blockD>
  * </blockB>
  * <blockE></blockE>]
  * ```
  *
  * If the selection is inside a block all the inner blocks (A & B) are returned:
  *
  * ```xml
  * <block>
  * 	<blockA>[a</blockA>
  * 	<blockB>b]</blockB>
  * </block>
  * ```
  *
  * **Special case**: Selection ignores first and/or last blocks if nothing (from user perspective) is selected in them.
  *
  * ```xml
  * // Selection ends and the beginning of the last block.
  * <paragraph>[a</paragraph>
  * <paragraph>b</paragraph>
  * <paragraph>]c</paragraph> // This block will not be returned
  *
  * // Selection begins at the end of the first block.
  * <paragraph>a[</paragraph> // This block will not be returned
  * <paragraph>b</paragraph>
  * <paragraph>c]</paragraph>
  *
  * // Selection begings at the end of the first block and ends at the beginning of the last block.
  * <paragraph>a[</paragraph> // This block will not be returned
  * <paragraph>b</paragraph>
  * <paragraph>]c</paragraph> // This block will not be returned
  * ```
  */
  *getSelectedBlocks() {
    const t = /* @__PURE__ */ new WeakSet();
    for (const i of this.getRanges()) {
      const r = vp(i.start, t);
      qO(r, i) && (yield r);
      const s = i.getWalker();
      for (const a of s) {
        const u = a.item;
        a.type == "elementEnd" && zO(u, t, i) ? yield u : a.type == "elementStart" && u.is("model:element") && u.root.document.model.schema.isBlock(u) && s.jumpTo(z._createAt(u, "end"));
      }
      const o = vp(i.end, t);
      YO(o, i) && (yield o);
    }
  }
  /**
  * Checks whether the selection contains the entire content of the given element. This means that selection must start
  * at a position {@link module:engine/model/position~Position#isTouching touching} the element's start and ends at position
  * touching the element's end.
  *
  * By default, this method will check whether the entire content of the selection's current root is selected.
  * Useful to check if e.g. the user has just pressed <kbd>Ctrl</kbd> + <kbd>A</kbd>.
  */
  containsEntireContent(t = this.anchor.root) {
    const i = z._createAt(t, 0), r = z._createAt(t, "end");
    return i.isTouching(this.getFirstPosition()) && r.isTouching(this.getLastPosition());
  }
  /**
  * Adds given range to internal {@link #_ranges ranges array}. Throws an error
  * if given range is intersecting with any range that is already stored in this selection.
  */
  _pushRange(t) {
    this._checkRange(t), this._ranges.push(new B(t.start, t.end));
  }
  /**
  * Checks if given range intersects with ranges that are already in the selection. Throws an error if it does.
  */
  _checkRange(t) {
    for (let i = 0; i < this._ranges.length; i++)
      if (t.isIntersecting(this._ranges[i]))
        throw new v("model-selection-range-intersects", [
          this,
          t
        ], {
          addedRange: t,
          intersectingRange: this._ranges[i]
        });
  }
  /**
  * Replaces all the ranges by the given ones.
  * Uses {@link #_popRange _popRange} and {@link #_pushRange _pushRange} to ensure proper ranges removal and addition.
  */
  _replaceAllRanges(t) {
    this._removeAllRanges();
    for (const i of t)
      this._pushRange(i);
  }
  /**
  * Deletes ranges from internal range array. Uses {@link #_popRange _popRange} to
  * ensure proper ranges removal.
  */
  _removeAllRanges() {
    for (; this._ranges.length > 0; )
      this._popRange();
  }
  /**
  * Removes most recently added range from the selection.
  */
  _popRange() {
    this._ranges.pop();
  }
}
Sn.prototype.is = function(e) {
  return e === "selection" || e === "model:selection";
};
function aT(e, n) {
  return n.has(e) ? !1 : (n.add(e), e.root.document.model.schema.isBlock(e) && !!e.parent);
}
function zO(e, n, t) {
  return aT(e, n) && Xf(e, t);
}
function vp(e, n) {
  const i = e.parent.root.document.model.schema, r = e.parent.getAncestors({
    parentFirst: !0,
    includeSelf: !0
  });
  let s = !1;
  const o = r.find((a) => s ? !1 : (s = i.isLimit(a), !s && aT(a, n)));
  return r.forEach((a) => n.add(a)), o;
}
function Xf(e, n) {
  const t = jO(e);
  return t ? !n.containsRange(B._createOn(t), !0) : !0;
}
function qO(e, n) {
  return e ? n.isCollapsed || e.isEmpty ? !0 : n.start.isTouching(z._createAt(e, e.maxOffset)) ? !1 : Xf(e, n) : !1;
}
function YO(e, n) {
  return e ? n.isCollapsed || e.isEmpty ? !0 : n.end.isTouching(z._createAt(e, 0)) ? !1 : Xf(e, n) : !1;
}
function jO(e) {
  const n = e.root.document.model.schema;
  let t = e.parent;
  for (; t; ) {
    if (n.isBlock(t))
      return t;
    t = t.parent;
  }
}
class xn extends (/* @__PURE__ */ Je(B)) {
  /**
  * Creates a live range.
  *
  * @see module:engine/model/range~Range
  */
  constructor(n, t) {
    super(n, t), KO.call(this);
  }
  /**
  * Unbinds all events previously bound by `LiveRange`. Use it whenever you don't need `LiveRange` instance
  * anymore (i.e. when leaving scope in which it was declared or before re-assigning variable that was
  * referring to it).
  */
  detach() {
    this.stopListening();
  }
  /**
  * Creates a {@link module:engine/model/range~Range range instance} that is equal to this live range.
  */
  toRange() {
    return new B(this.start, this.end);
  }
  /**
  * Creates a `LiveRange` instance that is equal to the given range.
  */
  static fromRange(n) {
    return new xn(n.start, n.end);
  }
}
xn.prototype.is = function(e) {
  return e === "liveRange" || e === "model:liveRange" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e == "range" || e === "model:range";
};
function KO() {
  this.listenTo(this.root.document.model, "applyOperation", (e, n) => {
    const t = n[0];
    t.isDocumentOperation && GO.call(this, t);
  }, {
    priority: "low"
  });
}
function GO(e) {
  const n = this.getTransformedByOperation(e), t = B._createFromRanges(n), i = !t.isEqual(this), r = QO(this, e);
  let s = null;
  if (i) {
    t.root.rootName == "$graveyard" && (e.type == "remove" ? s = e.sourcePosition : s = e.deletionPosition);
    const o = this.toRange();
    this.start = t.start, this.end = t.end, this.fire("change:range", o, {
      deletionPosition: s
    });
  } else r && this.fire("change:content", this.toRange(), {
    deletionPosition: s
  });
}
function QO(e, n) {
  switch (n.type) {
    case "insert":
      return e.containsPosition(n.position);
    case "move":
    case "remove":
    case "reinsert":
    case "merge":
      return e.containsPosition(n.sourcePosition) || e.start.isEqual(n.sourcePosition) || e.containsPosition(n.targetPosition);
    case "split":
      return e.containsPosition(n.splitPosition) || e.containsPosition(n.insertionPosition);
  }
  return !1;
}
class st extends ds {
  /**
  * Creates a text node.
  *
  * **Note:** Constructor of this class shouldn't be used directly in the code.
  * Use the {@link module:engine/model/writer~Writer#createText} method instead.
  *
  * @internal
  * @param data Node's text.
  * @param attrs Node's attributes. See {@link module:utils/tomap~toMap} for a list of accepted values.
  */
  constructor(t, i) {
    super(i);
    /**
    * Text data contained in this text node.
    *
    * @internal
    */
    m(this, "_data");
    this._data = t || "";
  }
  /**
  * @inheritDoc
  */
  get offsetSize() {
    return this.data.length;
  }
  /**
  * Returns a text data contained in the node.
  */
  get data() {
    return this._data;
  }
  /**
  * Converts `Text` instance to plain object and returns it.
  *
  * @returns`Text` instance converted to plain object.
  */
  toJSON() {
    const t = super.toJSON();
    return t.data = this.data, t;
  }
  /**
  * Creates a copy of this text node and returns it. Created text node has same text data and attributes as original text node.
  *
  * @internal
  * @returns `Text` instance created using given plain object.
  */
  _clone() {
    return new st(this.data, this.getAttributes());
  }
  /**
  * Creates a `Text` instance from given plain object (i.e. parsed JSON string).
  *
  * @param json Plain object to be converted to `Text`.
  * @returns `Text` instance created using given plain object.
  */
  static fromJSON(t) {
    return new st(t.data, t.attributes);
  }
}
st.prototype.is = function(e) {
  return e === "$text" || e === "model:$text" || // This are legacy values kept for backward compatibility.
  e === "text" || e === "model:text" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === "node" || e === "model:node";
};
const La = "selection:";
class oi extends (/* @__PURE__ */ Je(Ir)) {
  /**
  * Creates an empty live selection for given {@link module:engine/model/document~Document}.
  *
  * @param doc Document which owns this selection.
  */
  constructor(t) {
    super();
    /**
    * Selection used internally by that class (`DocumentSelection` is a proxy to that selection).
    */
    m(this, "_selection");
    this._selection = new XO(t), this._selection.delegate("change:range").to(this), this._selection.delegate("change:attribute").to(this), this._selection.delegate("change:marker").to(this);
  }
  /**
  * Describes whether the selection is collapsed. Selection is collapsed when there is exactly one range which is
  * collapsed.
  */
  get isCollapsed() {
    return this._selection.isCollapsed;
  }
  /**
  * Selection anchor. Anchor may be described as a position where the most recent part of the selection starts.
  * Together with {@link #focus} they define the direction of selection, which is important
  * when expanding/shrinking selection. Anchor is always {@link module:engine/model/range~Range#start start} or
  * {@link module:engine/model/range~Range#end end} position of the most recently added range.
  *
  * Is set to `null` if there are no ranges in selection.
  *
  * @see #focus
  */
  get anchor() {
    return this._selection.anchor;
  }
  /**
  * Selection focus. Focus is a position where the selection ends.
  *
  * Is set to `null` if there are no ranges in selection.
  *
  * @see #anchor
  */
  get focus() {
    return this._selection.focus;
  }
  /**
  * Number of ranges in selection.
  */
  get rangeCount() {
    return this._selection.rangeCount;
  }
  /**
  * Describes whether `Documentselection` has own range(s) set, or if it is defaulted to
  * {@link module:engine/model/document~Document#_getDefaultRange document's default range}.
  */
  get hasOwnRange() {
    return this._selection.hasOwnRange;
  }
  /**
  * Specifies whether the {@link #focus}
  * precedes {@link #anchor}.
  *
  * @readonly
  * @type {Boolean}
  */
  get isBackward() {
    return this._selection.isBackward;
  }
  /**
  * Describes whether the gravity is overridden (using {@link module:engine/model/writer~Writer#overrideSelectionGravity}) or not.
  *
  * Note that the gravity remains overridden as long as will not be restored the same number of times as it was overridden.
  */
  get isGravityOverridden() {
    return this._selection.isGravityOverridden;
  }
  /**
  * A collection of selection {@link module:engine/model/markercollection~Marker markers}.
  * Marker is a selection marker when selection range is inside the marker range.
  *
  * **Note**: Only markers from {@link ~DocumentSelection#observeMarkers observed markers groups} are collected.
  */
  get markers() {
    return this._selection.markers;
  }
  /**
  * Used for the compatibility with the {@link module:engine/model/selection~Selection#isEqual} method.
  *
  * @internal
  */
  get _ranges() {
    return this._selection._ranges;
  }
  /**
  * Returns an iterable that iterates over copies of selection ranges.
  */
  getRanges() {
    return this._selection.getRanges();
  }
  /**
  * Returns the first position in the selection.
  * First position is the position that {@link module:engine/model/position~Position#isBefore is before}
  * any other position in the selection.
  *
  * Returns `null` if there are no ranges in selection.
  */
  getFirstPosition() {
    return this._selection.getFirstPosition();
  }
  /**
  * Returns the last position in the selection.
  * Last position is the position that {@link module:engine/model/position~Position#isAfter is after}
  * any other position in the selection.
  *
  * Returns `null` if there are no ranges in selection.
  */
  getLastPosition() {
    return this._selection.getLastPosition();
  }
  /**
  * Returns a copy of the first range in the selection.
  * First range is the one which {@link module:engine/model/range~Range#start start} position
  * {@link module:engine/model/position~Position#isBefore is before} start position of all other ranges
  * (not to confuse with the first range added to the selection).
  *
  * Returns `null` if there are no ranges in selection.
  */
  getFirstRange() {
    return this._selection.getFirstRange();
  }
  /**
  * Returns a copy of the last range in the selection.
  * Last range is the one which {@link module:engine/model/range~Range#end end} position
  * {@link module:engine/model/position~Position#isAfter is after} end position of all other ranges (not to confuse with the range most
  * recently added to the selection).
  *
  * Returns `null` if there are no ranges in selection.
  */
  getLastRange() {
    return this._selection.getLastRange();
  }
  /**
  * Gets elements of type {@link module:engine/model/schema~Schema#isBlock "block"} touched by the selection.
  *
  * This method's result can be used for example to apply block styling to all blocks covered by this selection.
  *
  * **Note:** `getSelectedBlocks()` returns blocks that are nested in other non-block elements
  * but will not return blocks nested in other blocks.
  *
  * In this case the function will return exactly all 3 paragraphs (note: `<blockQuote>` is not a block itself):
  *
  * ```
  * <paragraph>[a</paragraph>
  * <blockQuote>
  * 	<paragraph>b</paragraph>
  * </blockQuote>
  * <paragraph>c]d</paragraph>
  * ```
  *
  * In this case the paragraph will also be returned, despite the collapsed selection:
  *
  * ```
  * <paragraph>[]a</paragraph>
  * ```
  *
  * In such a scenario, however, only blocks A, B & E will be returned as blocks C & D are nested in block B:
  *
  * ```
  * [<blockA></blockA>
  * <blockB>
  * 	<blockC></blockC>
  * 	<blockD></blockD>
  * </blockB>
  * <blockE></blockE>]
  * ```
  *
  * If the selection is inside a block all the inner blocks (A & B) are returned:
  *
  * ```
  * <block>
  * 	<blockA>[a</blockA>
  * 	<blockB>b]</blockB>
  * </block>
  * ```
  *
  * **Special case**: If a selection ends at the beginning of a block, that block is not returned as from user perspective
  * this block wasn't selected. See [#984](https://github.com/ckeditor/ckeditor5-engine/issues/984) for more details.
  *
  * ```
  * <paragraph>[a</paragraph>
  * <paragraph>b</paragraph>
  * <paragraph>]c</paragraph> // this block will not be returned
  * ```
  */
  getSelectedBlocks() {
    return this._selection.getSelectedBlocks();
  }
  /**
  * Returns the selected element. {@link module:engine/model/element~Element Element} is considered as selected if there is only
  * one range in the selection, and that range contains exactly one element.
  * Returns `null` if there is no selected element.
  */
  getSelectedElement() {
    return this._selection.getSelectedElement();
  }
  /**
  * Checks whether the selection contains the entire content of the given element. This means that selection must start
  * at a position {@link module:engine/model/position~Position#isTouching touching} the element's start and ends at position
  * touching the element's end.
  *
  * By default, this method will check whether the entire content of the selection's current root is selected.
  * Useful to check if e.g. the user has just pressed <kbd>Ctrl</kbd> + <kbd>A</kbd>.
  */
  containsEntireContent(t) {
    return this._selection.containsEntireContent(t);
  }
  /**
  * Unbinds all events previously bound by document selection.
  */
  destroy() {
    this._selection.destroy();
  }
  /**
  * Returns iterable that iterates over this selection's attribute keys.
  */
  getAttributeKeys() {
    return this._selection.getAttributeKeys();
  }
  /**
  * Returns iterable that iterates over this selection's attributes.
  *
  * Attributes are returned as arrays containing two items. First one is attribute key and second is attribute value.
  * This format is accepted by native `Map` object and also can be passed in `Node` constructor.
  */
  getAttributes() {
    return this._selection.getAttributes();
  }
  /**
  * Gets an attribute value for given key or `undefined` if that attribute is not set on the selection.
  *
  * @param key Key of attribute to look for.
  * @returns Attribute value or `undefined`.
  */
  getAttribute(t) {
    return this._selection.getAttribute(t);
  }
  /**
  * Checks if the selection has an attribute for given key.
  *
  * @param key Key of attribute to check.
  * @returns `true` if attribute with given key is set on selection, `false` otherwise.
  */
  hasAttribute(t) {
    return this._selection.hasAttribute(t);
  }
  /**
  * Refreshes selection attributes and markers according to the current position in the model.
  */
  refresh() {
    this._selection.updateMarkers(), this._selection._updateAttributes(!1);
  }
  /**
  * Registers a marker group prefix or a marker name to be collected in the
  * {@link ~DocumentSelection#markers selection markers collection}.
  *
  * See also {@link module:engine/model/markercollection~MarkerCollection#getMarkersGroup `MarkerCollection#getMarkersGroup()`}.
  *
  * @param prefixOrName The marker group prefix or marker name.
  */
  observeMarkers(t) {
    this._selection.observeMarkers(t);
  }
  /**
  * Moves {@link module:engine/model/documentselection~DocumentSelection#focus} to the specified location.
  * Should be used only within the {@link module:engine/model/writer~Writer#setSelectionFocus} method.
  *
  * The location can be specified in the same form as
  * {@link module:engine/model/writer~Writer#createPositionAt writer.createPositionAt()} parameters.
  *
  * @see module:engine/model/writer~Writer#setSelectionFocus
  * @internal
  * @param offset Offset or one of the flags. Used only when
  * first parameter is a {@link module:engine/model/item~Item model item}.
  */
  _setFocus(t, i) {
    this._selection.setFocus(t, i);
  }
  /**
  * Sets this selection's ranges and direction to the specified location based on the given
  * {@link module:engine/model/selection~Selectable selectable}.
  * Should be used only within the {@link module:engine/model/writer~Writer#setSelection} method.
  *
  * @see module:engine/model/writer~Writer#setSelection
  * @internal
  */
  _setTo(...t) {
    this._selection.setTo(...t);
  }
  /**
  * Sets attribute on the selection. If attribute with the same key already is set, it's value is overwritten.
  * Should be used only within the {@link module:engine/model/writer~Writer#setSelectionAttribute} method.
  *
  * @see module:engine/model/writer~Writer#setSelectionAttribute
  * @internal
  * @param key Key of the attribute to set.
  * @param value Attribute value.
  */
  _setAttribute(t, i) {
    this._selection.setAttribute(t, i);
  }
  /**
  * Removes an attribute with given key from the selection.
  * If the given attribute was set on the selection, fires the {@link module:engine/model/selection~Selection#event:change:range}
  * event with removed attribute key.
  * Should be used only within the {@link module:engine/model/writer~Writer#removeSelectionAttribute} method.
  *
  * @see module:engine/model/writer~Writer#removeSelectionAttribute
  * @internal
  * @param key Key of the attribute to remove.
  */
  _removeAttribute(t) {
    this._selection.removeAttribute(t);
  }
  /**
  * Returns an iterable that iterates through all selection attributes stored in current selection's parent.
  *
  * @internal
  */
  _getStoredAttributes() {
    return this._selection.getStoredAttributes();
  }
  /**
  * Temporarily changes the gravity of the selection from the left to the right.
  *
  * The gravity defines from which direction the selection inherits its attributes. If it's the default left
  * gravity, the selection (after being moved by the the user) inherits attributes from its left hand side.
  * This method allows to temporarily override this behavior by forcing the gravity to the right.
  *
  * It returns an unique identifier which is required to restore the gravity. It guarantees the symmetry
  * of the process.
  *
  * @see module:engine/model/writer~Writer#overrideSelectionGravity
  * @internal
  * @returns The unique id which allows restoring the gravity.
  */
  _overrideGravity() {
    return this._selection.overrideGravity();
  }
  /**
  * Restores the {@link ~DocumentSelection#_overrideGravity overridden gravity}.
  *
  * Restoring the gravity is only possible using the unique identifier returned by
  * {@link ~DocumentSelection#_overrideGravity}. Note that the gravity remains overridden as long as won't be restored
  * the same number of times it was overridden.
  *
  * @see module:engine/model/writer~Writer#restoreSelectionGravity
  * @internal
  * @param uid The unique id returned by {@link #_overrideGravity}.
  */
  _restoreGravity(t) {
    this._selection.restoreGravity(t);
  }
  /**
  * Generates and returns an attribute key for selection attributes store, basing on original attribute key.
  *
  * @internal
  * @param key Attribute key to convert.
  * @returns Converted attribute key, applicable for selection store.
  */
  static _getStoreAttributeKey(t) {
    return La + t;
  }
  /**
  * Checks whether the given attribute key is an attribute stored on an element.
  *
  * @internal
  */
  static _isStoreAttributeKey(t) {
    return t.startsWith(La);
  }
}
oi.prototype.is = function(e) {
  return e === "selection" || e == "model:selection" || e == "documentSelection" || e == "model:documentSelection";
};
class XO extends Sn {
  /**
  * Creates an empty live selection for given {@link module:engine/model/document~Document}.
  *
  * @param doc Document which owns this selection.
  */
  constructor(t) {
    super();
    /**
    * List of selection markers.
    * Marker is a selection marker when selection range is inside the marker range.
    */
    m(this, "markers", new Qi({
      idProperty: "name"
    }));
    /**
    * Document which owns this selection.
    */
    m(this, "_model");
    /**
    * Document which owns this selection.
    */
    m(this, "_document");
    /**
    * Keeps mapping of attribute name to priority with which the attribute got modified (added/changed/removed)
    * last time. Possible values of priority are: `'low'` and `'normal'`.
    *
    * Priorities are used by internal `LiveSelection` mechanisms. All attributes set using `LiveSelection`
    * attributes API are set with `'normal'` priority.
    */
    m(this, "_attributePriority", /* @__PURE__ */ new Map());
    /**
    * Position to which the selection should be set if the last selection range was moved to the graveyard.
    */
    m(this, "_selectionRestorePosition", null);
    /**
    * Flag that informs whether the selection ranges have changed. It is changed on true when `LiveRange#change:range` event is fired.
    */
    m(this, "_hasChangedRange", !1);
    /**
    * Each overriding gravity adds an UID to the set and each removal removes it.
    * Gravity is overridden when there's at least one UID in the set.
    * Gravity is restored when the set is empty.
    * This is to prevent conflicts when gravity is overridden by more than one feature at the same time.
    */
    m(this, "_overriddenGravityRegister", /* @__PURE__ */ new Set());
    /**
    * Prefixes of marker names that should affect `LiveSelection#markers` collection.
    */
    m(this, "_observedMarkers", /* @__PURE__ */ new Set());
    this._model = t.model, this._document = t, this.listenTo(this._model, "applyOperation", (i, r) => {
      const s = r[0];
      !s.isDocumentOperation || s.type == "marker" || s.type == "rename" || s.type == "noop" || (this._ranges.length == 0 && this._selectionRestorePosition && this._fixGraveyardSelection(this._selectionRestorePosition), this._selectionRestorePosition = null, this._hasChangedRange && (this._hasChangedRange = !1, this.fire("change:range", {
        directChange: !1
      })));
    }, {
      priority: "lowest"
    }), this.on("change:range", () => {
      this._validateSelectionRanges(this.getRanges());
    }), this.listenTo(this._model.markers, "update", (i, r, s, o) => {
      this._updateMarker(r, o);
    }), this.listenTo(this._document, "change", (i, r) => {
      JO(this._model, r);
    });
  }
  get isCollapsed() {
    return this._ranges.length === 0 ? this._document._getDefaultRange().isCollapsed : super.isCollapsed;
  }
  get anchor() {
    return super.anchor || this._document._getDefaultRange().start;
  }
  get focus() {
    return super.focus || this._document._getDefaultRange().end;
  }
  get rangeCount() {
    return this._ranges.length ? this._ranges.length : 1;
  }
  /**
  * Describes whether `LiveSelection` has own range(s) set, or if it is defaulted to
  * {@link module:engine/model/document~Document#_getDefaultRange document's default range}.
  */
  get hasOwnRange() {
    return this._ranges.length > 0;
  }
  /**
  * When set to `true` then selection attributes on node before the caret won't be taken
  * into consideration while updating selection attributes.
  */
  get isGravityOverridden() {
    return !!this._overriddenGravityRegister.size;
  }
  /**
  * Unbinds all events previously bound by live selection.
  */
  destroy() {
    for (let t = 0; t < this._ranges.length; t++)
      this._ranges[t].detach();
    this.stopListening();
  }
  *getRanges() {
    this._ranges.length ? yield* super.getRanges() : yield this._document._getDefaultRange();
  }
  getFirstRange() {
    return super.getFirstRange() || this._document._getDefaultRange();
  }
  getLastRange() {
    return super.getLastRange() || this._document._getDefaultRange();
  }
  setTo(...t) {
    super.setTo(...t), this._updateAttributes(!0), this.updateMarkers();
  }
  setFocus(t, i) {
    super.setFocus(t, i), this._updateAttributes(!0), this.updateMarkers();
  }
  setAttribute(t, i) {
    if (this._setAttribute(t, i)) {
      const r = [
        t
      ];
      this.fire("change:attribute", {
        attributeKeys: r,
        directChange: !0
      });
    }
  }
  removeAttribute(t) {
    if (this._removeAttribute(t)) {
      const i = [
        t
      ];
      this.fire("change:attribute", {
        attributeKeys: i,
        directChange: !0
      });
    }
  }
  overrideGravity() {
    const t = un();
    return this._overriddenGravityRegister.add(t), this._overriddenGravityRegister.size === 1 && this._updateAttributes(!0), t;
  }
  restoreGravity(t) {
    if (!this._overriddenGravityRegister.has(t))
      throw new v("document-selection-gravity-wrong-restore", this, {
        uid: t
      });
    this._overriddenGravityRegister.delete(t), this.isGravityOverridden || this._updateAttributes(!0);
  }
  observeMarkers(t) {
    this._observedMarkers.add(t), this.updateMarkers();
  }
  _replaceAllRanges(t) {
    this._validateSelectionRanges(t), super._replaceAllRanges(t);
  }
  _popRange() {
    this._ranges.pop().detach();
  }
  _pushRange(t) {
    const i = this._prepareRange(t);
    i && this._ranges.push(i);
  }
  _validateSelectionRanges(t) {
    for (const i of t)
      if (!this._document._validateSelectionRange(i))
        throw new v("document-selection-wrong-position", this, {
          range: i
        });
  }
  /**
  * Prepares given range to be added to selection. Checks if it is correct,
  * converts it to {@link module:engine/model/liverange~LiveRange LiveRange}
  * and sets listeners listening to the range's change event.
  */
  _prepareRange(t) {
    if (this._checkRange(t), t.root == this._document.graveyard)
      return;
    const i = xn.fromRange(t);
    return i.on("change:range", (r, s, o) => {
      if (this._hasChangedRange = !0, i.root == this._document.graveyard) {
        this._selectionRestorePosition = o.deletionPosition;
        const a = this._ranges.indexOf(i);
        this._ranges.splice(a, 1), i.detach();
      }
    }), i;
  }
  updateMarkers() {
    if (!this._observedMarkers.size)
      return;
    const t = [];
    let i = !1;
    for (const s of this._model.markers) {
      const o = s.name.split(":", 1)[0];
      if (!this._observedMarkers.has(o))
        continue;
      const a = s.getRange();
      for (const u of this.getRanges())
        a.containsRange(u, !u.isCollapsed) && t.push(s);
    }
    const r = Array.from(this.markers);
    for (const s of t)
      this.markers.has(s) || (this.markers.add(s), i = !0);
    for (const s of Array.from(this.markers))
      t.includes(s) || (this.markers.remove(s), i = !0);
    i && this.fire("change:marker", {
      oldMarkers: r,
      directChange: !1
    });
  }
  _updateMarker(t, i) {
    const r = t.name.split(":", 1)[0];
    if (!this._observedMarkers.has(r))
      return;
    let s = !1;
    const o = Array.from(this.markers), a = this.markers.has(t);
    if (!i)
      a && (this.markers.remove(t), s = !0);
    else {
      let u = !1;
      for (const l of this.getRanges())
        if (i.containsRange(l, !l.isCollapsed)) {
          u = !0;
          break;
        }
      u && !a ? (this.markers.add(t), s = !0) : !u && a && (this.markers.remove(t), s = !0);
    }
    s && this.fire("change:marker", {
      oldMarkers: o,
      directChange: !1
    });
  }
  /**
  * Updates this selection attributes according to its ranges and the {@link module:engine/model/document~Document model document}.
  */
  _updateAttributes(t) {
    const i = Si(this._getSurroundingAttributes()), r = Si(this.getAttributes());
    if (t)
      this._attributePriority = /* @__PURE__ */ new Map(), this._attrs = /* @__PURE__ */ new Map();
    else
      for (const [o, a] of this._attributePriority)
        a == "low" && (this._attrs.delete(o), this._attributePriority.delete(o));
    this._setAttributesTo(i);
    const s = [];
    for (const [o, a] of this.getAttributes())
      (!r.has(o) || r.get(o) !== a) && s.push(o);
    for (const [o] of r)
      this.hasAttribute(o) || s.push(o);
    s.length > 0 && this.fire("change:attribute", {
      attributeKeys: s,
      directChange: !1
    });
  }
  /**
  * Internal method for setting `LiveSelection` attribute. Supports attribute priorities (through `directChange`
  * parameter).
  */
  _setAttribute(t, i, r = !0) {
    const s = r ? "normal" : "low";
    return s == "low" && this._attributePriority.get(t) == "normal" || super.getAttribute(t) === i ? !1 : (this._attrs.set(t, i), this._attributePriority.set(t, s), !0);
  }
  /**
  * Internal method for removing `LiveSelection` attribute. Supports attribute priorities (through `directChange`
  * parameter).
  *
  * NOTE: Even if attribute is not present in the selection but is provided to this method, it's priority will
  * be changed according to `directChange` parameter.
  */
  _removeAttribute(t, i = !0) {
    const r = i ? "normal" : "low";
    return r == "low" && this._attributePriority.get(t) == "normal" || (this._attributePriority.set(t, r), !super.hasAttribute(t)) ? !1 : (this._attrs.delete(t), !0);
  }
  /**
  * Internal method for setting multiple `LiveSelection` attributes. Supports attribute priorities (through
  * `directChange` parameter).
  */
  _setAttributesTo(t) {
    const i = /* @__PURE__ */ new Set();
    for (const [r, s] of this.getAttributes())
      t.get(r) !== s && this._removeAttribute(r, !1);
    for (const [r, s] of t)
      this._setAttribute(r, s, !1) && i.add(r);
    return i;
  }
  /**
  * Returns an iterable that iterates through all selection attributes stored in current selection's parent.
  */
  *getStoredAttributes() {
    const t = this.getFirstPosition().parent;
    if (this.isCollapsed && t.isEmpty)
      for (const i of t.getAttributeKeys())
        i.startsWith(La) && (yield [
          i.substr(La.length),
          t.getAttribute(i)
        ]);
  }
  /**
  * Checks model text nodes that are closest to the selection's first position and returns attributes of first
  * found element. If there are no text nodes in selection's first position parent, it returns selection
  * attributes stored in that parent.
  */
  _getSurroundingAttributes() {
    const t = this.getFirstPosition(), i = this._model.schema;
    if (t.root.rootName == "$graveyard")
      return null;
    let r = null;
    if (this.isCollapsed) {
      const s = t.textNode ? t.textNode : t.nodeBefore, o = t.textNode ? t.textNode : t.nodeAfter;
      if (this.isGravityOverridden || (r = Lo(s, i)), r || (r = Lo(o, i)), !this.isGravityOverridden && !r) {
        let a = s;
        for (; a && !r; )
          a = a.previousSibling, r = Lo(a, i);
      }
      if (!r) {
        let a = o;
        for (; a && !r; )
          a = a.nextSibling, r = Lo(a, i);
      }
      r || (r = this.getStoredAttributes());
    } else {
      const s = this.getFirstRange();
      for (const o of s) {
        if (o.item.is("element") && i.isObject(o.item)) {
          r = Lo(o.item, i);
          break;
        }
        if (o.type == "text") {
          r = o.item.getAttributes();
          break;
        }
      }
    }
    return r;
  }
  /**
  * Fixes the selection after all its ranges got removed.
  * @param deletionPosition Position where the deletion happened.
  */
  _fixGraveyardSelection(t) {
    const i = this._model.schema.getNearestSelectionRange(t);
    i && this._pushRange(i);
  }
}
function Lo(e, n) {
  if (!e)
    return null;
  if (e instanceof ii || e instanceof st)
    return e.getAttributes();
  if (!n.isInline(e))
    return null;
  if (!n.isObject(e))
    return [];
  const t = [];
  for (const [i, r] of e.getAttributes())
    n.checkAttribute("$text", i) && n.getAttributeProperties(i).copyFromObject !== !1 && t.push([
      i,
      r
    ]);
  return t;
}
function JO(e, n) {
  const t = e.document.differ;
  for (const i of t.getChanges()) {
    if (i.type != "insert")
      continue;
    const r = i.position.parent;
    i.length === r.maxOffset && e.enqueueChange(n, (o) => {
      const a = Array.from(r.getAttributeKeys()).filter((u) => u.startsWith(La));
      for (const u of a)
        o.removeAttribute(u, r);
    });
  }
}
class ua {
  /**
  * Creates a node list.
  *
  * @internal
  * @param nodes Nodes contained in this node list.
  */
  constructor(n) {
    /**
    * Nodes contained in this node list.
    */
    m(this, "_nodes", []);
    /**
    * This array maps numbers (offsets) to node that is placed at that offset.
    *
    * This array is similar to `_nodes` with the difference that one node may occupy multiple consecutive items in the array.
    *
    * This array is needed to quickly retrieve a node that is placed at given offset.
    */
    m(this, "_offsetToNode", []);
    n && this._insertNodes(0, n);
  }
  /**
  * Iterable interface.
  *
  * Iterates over all nodes contained inside this node list.
  */
  [Symbol.iterator]() {
    return this._nodes[Symbol.iterator]();
  }
  /**
  * Number of nodes contained inside this node list.
  */
  get length() {
    return this._nodes.length;
  }
  /**
  * Sum of {@link module:engine/model/node~Node#offsetSize offset sizes} of all nodes contained inside this node list.
  */
  get maxOffset() {
    return this._offsetToNode.length;
  }
  /**
  * Gets the node at the given index. Returns `null` if incorrect index was passed.
  */
  getNode(n) {
    return this._nodes[n] || null;
  }
  /**
  * Gets the node at the given offset. Returns `null` if incorrect offset was passed.
  */
  getNodeAtOffset(n) {
    return this._offsetToNode[n] || null;
  }
  /**
  * Returns an index of the given node or `null` if given node does not have a parent.
  *
  * This is an alias to {@link module:engine/model/node~Node#index}.
  */
  getNodeIndex(n) {
    return n.index;
  }
  /**
  * Returns the offset at which given node is placed in its parent or `null` if given node does not have a parent.
  *
  * This is an alias to {@link module:engine/model/node~Node#startOffset}.
  */
  getNodeStartOffset(n) {
    return n.startOffset;
  }
  /**
  * Converts index to offset in node list.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `model-nodelist-index-out-of-bounds` if given index is less
  * than `0` or more than {@link #length}.
  */
  indexToOffset(n) {
    if (n == this._nodes.length)
      return this.maxOffset;
    const t = this._nodes[n];
    if (!t)
      throw new v("model-nodelist-index-out-of-bounds", this);
    return this.getNodeStartOffset(t);
  }
  /**
  * Converts offset in node list to index.
  *
  * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `model-nodelist-offset-out-of-bounds` if given offset is less
  * than `0` or more than {@link #maxOffset}.
  */
  offsetToIndex(n) {
    if (n == this._offsetToNode.length)
      return this._nodes.length;
    const t = this._offsetToNode[n];
    if (!t)
      throw new v("model-nodelist-offset-out-of-bounds", this, {
        offset: n,
        nodeList: this
      });
    return this.getNodeIndex(t);
  }
  /**
  * Inserts given nodes at given index.
  *
  * @internal
  * @param index Index at which nodes should be inserted.
  * @param nodes Nodes to be inserted.
  */
  _insertNodes(n, t) {
    const i = [];
    for (const s of t) {
      if (!(s instanceof ds))
        throw new v("model-nodelist-insertnodes-not-node", this);
      i.push(s);
    }
    let r = this.indexToOffset(n);
    hp(this._nodes, i, n), hp(this._offsetToNode, ZO(i), r);
    for (let s = n; s < this._nodes.length; s++)
      this._nodes[s]._index = s, this._nodes[s]._startOffset = r, r += this._nodes[s].offsetSize;
  }
  /**
  * Removes one or more nodes starting at the given index.
  *
  * @internal
  * @param indexStart Index of the first node to remove.
  * @param howMany Number of nodes to remove.
  * @returns Array containing removed nodes.
  */
  _removeNodes(n, t = 1) {
    if (t == 0)
      return [];
    let i = this.indexToOffset(n);
    const r = this._nodes.splice(n, t), s = r[r.length - 1], o = s.startOffset + s.offsetSize - i;
    this._offsetToNode.splice(i, o);
    for (const a of r)
      a._index = null, a._startOffset = null;
    for (let a = n; a < this._nodes.length; a++)
      this._nodes[a]._index = a, this._nodes[a]._startOffset = i, i += this._nodes[a].offsetSize;
    return r;
  }
  /**
  * Removes children nodes provided as an array. These nodes do not need to be direct siblings.
  *
  * This method is faster than removing nodes one by one, as it recalculates offsets only once.
  *
  * @internal
  * @param nodes Array of nodes.
  */
  _removeNodesArray(n) {
    if (n.length == 0)
      return;
    for (const i of n)
      i._index = null, i._startOffset = null;
    this._nodes = this._nodes.filter((i) => i.index !== null), this._offsetToNode = this._offsetToNode.filter((i) => i.index !== null);
    let t = 0;
    for (let i = 0; i < this._nodes.length; i++)
      this._nodes[i]._index = i, this._nodes[i]._startOffset = t, t += this._nodes[i].offsetSize;
  }
  /**
  * Converts `NodeList` instance to an array containing nodes that were inserted in the node list. Nodes
  * are also converted to their plain object representation.
  *
  * @returns `NodeList` instance converted to `Array`.
  */
  toJSON() {
    return this._nodes.map((n) => n.toJSON());
  }
}
function ZO(e) {
  const n = [];
  let t = 0;
  for (const i of e)
    for (let r = 0; r < i.offsetSize; r++)
      n[t++] = i;
  return n;
}
class rt extends ds {
  /**
  * Creates a model element.
  *
  * **Note:** Constructor of this class shouldn't be used directly in the code.
  * Use the {@link module:engine/model/writer~Writer#createElement} method instead.
  *
  * @internal
  * @param name Element's name.
  * @param attrs Element's attributes. See {@link module:utils/tomap~toMap} for a list of accepted values.
  * @param children One or more nodes to be inserted as children of created element.
  */
  constructor(t, i, r) {
    super(i);
    /**
    * Element name.
    */
    m(this, "name");
    /**
    * List of children nodes.
    */
    m(this, "_children", new ua());
    this.name = t, r && this._insertChild(0, r);
  }
  /**
  * Number of this element's children.
  */
  get childCount() {
    return this._children.length;
  }
  /**
  * Sum of {@link module:engine/model/node~Node#offsetSize offset sizes} of all of this element's children.
  */
  get maxOffset() {
    return this._children.maxOffset;
  }
  /**
  * Is `true` if there are no nodes inside this element, `false` otherwise.
  */
  get isEmpty() {
    return this.childCount === 0;
  }
  /**
  * Gets the child at the given index. Returns `null` if incorrect index was passed.
  *
  * @param index Index in this element.
  * @returns Child node.
  */
  getChild(t) {
    return this._children.getNode(t);
  }
  /**
  * Gets the child at the given offset. Returns `null` if incorrect index was passed.
  *
  * @param offset Offset in this element.
  * @returns Child node.
  */
  getChildAtOffset(t) {
    return this._children.getNodeAtOffset(t);
  }
  /**
  * Returns an iterator that iterates over all of this element's children.
  */
  getChildren() {
    return this._children[Symbol.iterator]();
  }
  /**
  * Returns an index of the given child node. Returns `null` if given node is not a child of this element.
  *
  * @param node Child node to look for.
  * @returns Child node's index in this element.
  */
  getChildIndex(t) {
    return this._children.getNodeIndex(t);
  }
  /**
  * Returns the starting offset of given child. Starting offset is equal to the sum of
  * {@link module:engine/model/node~Node#offsetSize offset sizes} of all node's siblings that are before it. Returns `null` if
  * given node is not a child of this element.
  *
  * @param node Child node to look for.
  * @returns Child node's starting offset.
  */
  getChildStartOffset(t) {
    return this._children.getNodeStartOffset(t);
  }
  /**
  * Returns index of a node that occupies given offset. If given offset is too low, returns `0`. If given offset is
  * too high, returns {@link module:engine/model/element~Element#getChildIndex index after last child}.
  *
  * ```ts
  * const textNode = new Text( 'foo' );
  * const pElement = new Element( 'p' );
  * const divElement = new Element( [ textNode, pElement ] );
  * divElement.offsetToIndex( -1 ); // Returns 0, because offset is too low.
  * divElement.offsetToIndex( 0 ); // Returns 0, because offset 0 is taken by `textNode` which is at index 0.
  * divElement.offsetToIndex( 1 ); // Returns 0, because `textNode` has `offsetSize` equal to 3, so it occupies offset 1 too.
  * divElement.offsetToIndex( 2 ); // Returns 0.
  * divElement.offsetToIndex( 3 ); // Returns 1.
  * divElement.offsetToIndex( 4 ); // Returns 2. There are no nodes at offset 4, so last available index is returned.
  * ```
  */
  offsetToIndex(t) {
    return this._children.offsetToIndex(t);
  }
  /**
  * Returns a descendant node by its path relative to this element.
  *
  * ```ts
  * // <this>a<b>c</b></this>
  * this.getNodeByPath( [ 0 ] );     // -> "a"
  * this.getNodeByPath( [ 1 ] );     // -> <b>
  * this.getNodeByPath( [ 1, 0 ] );  // -> "c"
  * ```
  *
  * @param relativePath Path of the node to find, relative to this element.
  */
  getNodeByPath(t) {
    let i = this;
    for (const r of t)
      i = i.getChildAtOffset(r);
    return i;
  }
  /**
  * Returns the parent element of the given name. Returns null if the element is not inside the desired parent.
  *
  * @param parentName The name of the parent element to find.
  * @param options Options object.
  * @param options.includeSelf When set to `true` this node will be also included while searching.
  */
  findAncestor(t, i = {}) {
    let r = i.includeSelf ? this : this.parent;
    for (; r; ) {
      if (r.name === t)
        return r;
      r = r.parent;
    }
    return null;
  }
  /**
  * Converts `Element` instance to plain object and returns it. Takes care of converting all of this element's children.
  *
  * @returns `Element` instance converted to plain object.
  */
  toJSON() {
    const t = super.toJSON();
    if (t.name = this.name, this._children.length > 0) {
      t.children = [];
      for (const i of this._children)
        t.children.push(i.toJSON());
    }
    return t;
  }
  /**
  * Creates a copy of this element and returns it. Created element has the same name and attributes as the original element.
  * If clone is deep, the original element's children are also cloned. If not, then empty element is returned.
  *
  * @internal
  * @param deep If set to `true` clones element and all its children recursively. When set to `false`,
  * element will be cloned without any child.
  */
  _clone(t = !1) {
    const i = t ? tN(this._children) : void 0;
    return new rt(this.name, this.getAttributes(), i);
  }
  /**
  * {@link module:engine/model/element~Element#_insertChild Inserts} one or more nodes at the end of this element.
  *
  * @see module:engine/model/writer~Writer#append
  * @internal
  * @param nodes Nodes to be inserted.
  */
  _appendChild(t) {
    this._insertChild(this.childCount, t);
  }
  /**
  * Inserts one or more nodes at the given index and sets {@link module:engine/model/node~Node#parent parent} of these nodes
  * to this element.
  *
  * @see module:engine/model/writer~Writer#insert
  * @internal
  * @param index Index at which nodes should be inserted.
  * @param items Items to be inserted.
  */
  _insertChild(t, i) {
    const r = eN(i);
    for (const s of r)
      s.parent !== null && s._remove(), s.parent = this;
    this._children._insertNodes(t, r);
  }
  /**
  * Removes one or more nodes starting at the given index and sets
  * {@link module:engine/model/node~Node#parent parent} of these nodes to `null`.
  *
  * @see module:engine/model/writer~Writer#remove
  * @internal
  * @param index Index of the first node to remove.
  * @param howMany Number of nodes to remove.
  * @returns Array containing removed nodes.
  */
  _removeChildren(t, i = 1) {
    const r = this._children._removeNodes(t, i);
    for (const s of r)
      s.parent = null;
    return r;
  }
  /**
  * Removes children nodes provided as an array and sets
  * the {@link module:engine/model/node~Node#parent parent} of these nodes to `null`.
  *
  * These nodes do not need to be direct siblings.
  *
  * This method is faster than removing nodes one by one, as it recalculates offsets only once.
  *
  * @internal
  * @param nodes Array of nodes.
  */
  _removeChildrenArray(t) {
    this._children._removeNodesArray(t);
    for (const i of t)
      i.parent = null;
  }
  /**
  * Creates an `Element` instance from given plain object (i.e. parsed JSON string).
  * Converts `Element` children to proper nodes.
  *
  * @param json Plain object to be converted to `Element`.
  * @returns `Element` instance created using given plain object.
  */
  static fromJSON(t) {
    let i;
    if (t.children) {
      i = [];
      for (const r of t.children)
        r.name ? i.push(rt.fromJSON(r)) : i.push(st.fromJSON(r));
    }
    return new rt(t.name, t.attributes, i);
  }
}
rt.prototype.is = function(e, n) {
  return n ? n === this.name && (e === "element" || e === "model:element") : e === "element" || e === "model:element" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === "node" || e === "model:node";
};
function eN(e) {
  if (typeof e == "string")
    return [
      new st(e)
    ];
  Nn(e) || (e = [
    e
  ]);
  const n = [];
  for (const t of e)
    typeof t == "string" ? n.push(new st(t)) : t instanceof ii ? n.push(new st(t.data, t.getAttributes())) : n.push(t);
  return n;
}
function tN(e) {
  const n = [];
  for (const t of e)
    n.push(t._clone(!0));
  return n;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class uT {
  /**
  * Creates a conversion helpers instance.
  */
  constructor(n) {
    m(this, "_dispatchers");
    this._dispatchers = n;
  }
  /**
  * Registers a conversion helper.
  *
  * **Note**: See full usage example in the `{@link module:engine/conversion/conversion~Conversion#for conversion.for()}`
  * method description.
  *
  * @param conversionHelper The function to be called on event.
  */
  add(n) {
    for (const t of this._dispatchers)
      n(t);
    return this;
  }
}
class nN extends uT {
  /**
  * Model element to view element conversion helper.
  *
  * This conversion results in creating a view element. For example, model `<paragraph>Foo</paragraph>` becomes `<p>Foo</p>` in the view.
  *
  * ```ts
  * editor.conversion.for( 'downcast' ).elementToElement( {
  * 	model: 'paragraph',
  * 	view: 'p'
  * } );
  *
  * editor.conversion.for( 'downcast' ).elementToElement( {
  * 	model: 'paragraph',
  * 	view: 'div',
  * 	converterPriority: 'high'
  * } );
  *
  * editor.conversion.for( 'downcast' ).elementToElement( {
  * 	model: 'fancyParagraph',
  * 	view: {
  * 		name: 'p',
  * 		classes: 'fancy'
  * 	}
  * } );
  *
  * editor.conversion.for( 'downcast' ).elementToElement( {
  * 	model: 'heading',
  * 	view: ( modelElement, conversionApi ) => {
  * 		const { writer } = conversionApi;
  *
  * 		return writer.createContainerElement( 'h' + modelElement.getAttribute( 'level' ) );
  * 	}
  * } );
  * ```
  *
  * The element-to-element conversion supports the reconversion mechanism. It can be enabled by using either the `attributes` or
  * the `children` props on a model description. You will find a couple examples below.
  *
  * In order to reconvert an element if any of its direct children have been added or removed, use the `children` property on a `model`
  * description. For example, this model:
  *
  * ```xml
  * <box>
  * 	<paragraph>Some text.</paragraph>
  * </box>
  * ```
  *
  * will be converted into this structure in the view:
  *
  * ```html
  * <div class="box" data-type="single">
  * 	<p>Some text.</p>
  * </div>
  * ```
  *
  * But if more items were inserted in the model:
  *
  * ```xml
  * <box>
  * 	<paragraph>Some text.</paragraph>
  * 	<paragraph>Other item.</paragraph>
  * </box>
  * ```
  *
  * it will be converted into this structure in the view (note the element `data-type` change):
  *
  * ```html
  * <div class="box" data-type="multiple">
  * 	<p>Some text.</p>
  * 	<p>Other item.</p>
  * </div>
  * ```
  *
  * Such a converter would look like this (note that the `paragraph` elements are converted separately):
  *
  * ```ts
  * editor.conversion.for( 'downcast' ).elementToElement( {
  * 	model: {
  * 		name: 'box',
  * 		children: true
  * 	},
  * 	view: ( modelElement, conversionApi ) => {
  * 		const { writer } = conversionApi;
  *
  * 		return writer.createContainerElement( 'div', {
  * 			class: 'box',
  * 			'data-type': modelElement.childCount == 1 ? 'single' : 'multiple'
  * 		} );
  * 	}
  * } );
  * ```
  *
  * In order to reconvert element if any of its attributes have been updated, use the `attributes` property on a `model`
  * description. For example, this model:
  *
  * ```xml
  * <heading level="2">Some text.</heading>
  * ```
  *
  * will be converted into this structure in the view:
  *
  * ```html
  * <h2>Some text.</h2>
  * ```
  *
  * But if the `heading` element's `level` attribute has been updated to `3` for example, then
  * it will be converted into this structure in the view:
  *
  * ```html
  * <h3>Some text.</h3>
  * ```
  *
  * Such a converter would look as follows:
  *
  * ```ts
  * editor.conversion.for( 'downcast' ).elementToElement( {
  * 	model: {
  * 		name: 'heading',
  * 		attributes: 'level'
  * 	},
  * 	view: ( modelElement, conversionApi ) => {
  * 		const { writer } = conversionApi;
  *
  * 		return writer.createContainerElement( 'h' + modelElement.getAttribute( 'level' ) );
  * 	}
  * } );
  * ```
  *
  * See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
  * to the conversion process.
  *
  * You can read more about the element-to-element conversion in the
  * {@glink framework/deep-dive/conversion/downcast downcast conversion} guide.
  *
  * @param config Conversion configuration.
  * @param config.model The description or a name of the model element to convert.
  * @param config.model.attributes The list of attribute names that should be consumed while creating
  * the view element. Note that the view will be reconverted if any of the listed attributes changes.
   * @param config.model.children Specifies whether the view element requires reconversion if the list
  * of the model child nodes changed.
  * @param config.view A view element definition or a function that takes the model element and
  * {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API}
  * as parameters and returns a view container element.
  */
  elementToElement(n) {
    return this.add(TN(n));
  }
  /**
  * The model element to view structure (several elements) conversion helper.
  *
  * This conversion results in creating a view structure with one or more slots defined for the child nodes.
  * For example, a model `<table>` may become this structure in the view:
  *
  * ```html
  * <figure class="table">
  * 	<table>
  * 		<tbody>${ slot for table rows }</tbody>
  * 	</table>
  * </figure>
  * ```
  *
  * The children of the model's `<table>` element will be inserted into the `<tbody>` element.
  * If the `elementToElement()` helper was used, the children would be inserted into the `<figure>`.
  *
  * Imagine a table feature where for this model structure:
  *
  * ```xml
  * <table headingRows="1">
  * 	<tableRow> ... table cells 1 ... </tableRow>
  * 	<tableRow> ... table cells 2 ... </tableRow>
  * 	<tableRow> ... table cells 3 ... </tableRow>
  * 	<caption>Caption text</caption>
  * </table>
  * ```
  *
  * we want to generate this view structure:
  *
  * ```html
  * <figure class="table">
  * 	<table>
  * 		<thead>
  * 			<tr> ... table cells 1 ... </tr>
  * 		</thead>
  * 		<tbody>
  * 			<tr> ... table cells 2 ... </tr>
  * 			<tr> ... table cells 3 ... </tr>
  * 		</tbody>
  * 	</table>
  * 	<figcaption>Caption text</figcaption>
  * </figure>
  * ```
  *
  * The converter has to take the `headingRows` attribute into consideration when allocating the `<tableRow>` elements
  * into the `<tbody>` and `<thead>` elements. Hence, we need two slots and need to define proper filter callbacks for them.
  *
  * Additionally, all elements other than `<tableRow>` should be placed outside the `<table>` tag.
  * In the example above, this will handle the table caption.
  *
  * Such a converter would look like this:
  *
  * ```ts
  * editor.conversion.for( 'downcast' ).elementToStructure( {
  * 	model: {
  * 		name: 'table',
  * 		attributes: [ 'headingRows' ]
  * 	},
  * 	view: ( modelElement, conversionApi ) => {
  * 		const { writer } = conversionApi;
  *
  * 		const figureElement = writer.createContainerElement( 'figure', { class: 'table' } );
  * 		const tableElement = writer.createContainerElement( 'table' );
  *
  * 		writer.insert( writer.createPositionAt( figureElement, 0 ), tableElement );
  *
  * 		const headingRows = modelElement.getAttribute( 'headingRows' ) || 0;
  *
  * 		if ( headingRows > 0 ) {
  * 			const tableHead = writer.createContainerElement( 'thead' );
  *
  * 			const headSlot = writer.createSlot( node => node.is( 'element', 'tableRow' ) && node.index < headingRows );
  *
  * 			writer.insert( writer.createPositionAt( tableElement, 'end' ), tableHead );
  * 			writer.insert( writer.createPositionAt( tableHead, 0 ), headSlot );
  * 		}
  *
  * 		if ( headingRows < tableUtils.getRows( table ) ) {
  * 			const tableBody = writer.createContainerElement( 'tbody' );
  *
  * 			const bodySlot = writer.createSlot( node => node.is( 'element', 'tableRow' ) && node.index >= headingRows );
  *
  * 			writer.insert( writer.createPositionAt( tableElement, 'end' ), tableBody );
  * 			writer.insert( writer.createPositionAt( tableBody, 0 ), bodySlot );
  * 		}
  *
  * 		const restSlot = writer.createSlot( node => !node.is( 'element', 'tableRow' ) );
  *
  * 		writer.insert( writer.createPositionAt( figureElement, 'end' ), restSlot );
  *
  * 		return figureElement;
  * 	}
  * } );
  * ```
  *
  * Note: The children of a model element that's being converted must be allocated in the same order in the view
  * in which they are placed in the model.
  *
  * See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
  * to the conversion process.
  *
  * @param config Conversion configuration.
   * @param config.model The description or a name of the model element to convert.
  * @param config.model.name The name of the model element to convert.
   * @param config.model.attributes The list of attribute names that should be consumed while creating
  * the view structure. Note that the view will be reconverted if any of the listed attributes will change.
  * @param config.view A function that takes the model element and
  * {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API} as parameters
  * and returns a view container element with slots for model child nodes to be converted into.
  */
  elementToStructure(n) {
    return this.add(yN(n));
  }
  /**
  * Model attribute to view element conversion helper.
  *
  * This conversion results in wrapping view nodes with a view attribute element. For example, a model text node with
  * `"Foo"` as data and the `bold` attribute becomes `<strong>Foo</strong>` in the view.
  *
  * ```ts
  * editor.conversion.for( 'downcast' ).attributeToElement( {
  * 	model: 'bold',
  * 	view: 'strong'
  * } );
  *
  * editor.conversion.for( 'downcast' ).attributeToElement( {
  * 	model: 'bold',
  * 	view: 'b',
  * 	converterPriority: 'high'
  * } );
  *
  * editor.conversion.for( 'downcast' ).attributeToElement( {
  * 	model: 'invert',
  * 	view: {
  * 		name: 'span',
  * 		classes: [ 'font-light', 'bg-dark' ]
  * 	}
  * } );
  *
  * editor.conversion.for( 'downcast' ).attributeToElement( {
  * 	model: {
  * 		key: 'fontSize',
  * 		values: [ 'big', 'small' ]
  * 	},
  * 	view: {
  * 		big: {
  * 			name: 'span',
  * 			styles: {
  * 				'font-size': '1.2em'
  * 			}
  * 		},
  * 		small: {
  * 			name: 'span',
  * 			styles: {
  * 				'font-size': '0.8em'
  * 			}
  * 		}
  * 	}
  * } );
  *
  * editor.conversion.for( 'downcast' ).attributeToElement( {
  * 	model: 'bold',
  * 	view: ( modelAttributeValue, conversionApi ) => {
  * 		const { writer } = conversionApi;
  *
  * 		return writer.createAttributeElement( 'span', {
  * 			style: 'font-weight:' + modelAttributeValue
  * 		} );
  * 	}
  * } );
  *
  * editor.conversion.for( 'downcast' ).attributeToElement( {
  * 	model: {
  * 		key: 'color',
  * 		name: '$text'
  * 	},
  * 	view: ( modelAttributeValue, conversionApi ) => {
  * 		const { writer } = conversionApi;
  *
  * 		return writer.createAttributeElement( 'span', {
  * 			style: 'color:' + modelAttributeValue
  * 		} );
  * 	}
  * } );
  * ```
  *
  * See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
  * to the conversion process.
  *
  * @param config Conversion configuration.
  * @param config.model The key of the attribute to convert from or a `{ key, values }` object. `values` is an array
  * of `String`s with possible values if the model attribute is an enumerable.
  * @param config.view A view element definition or a function
  * that takes the model attribute value and
  * {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API} as parameters and returns a view
  * attribute element. If `config.model.values` is given, `config.view` should be an object assigning values from `config.model.values`
  * to view element definitions or functions.
  * @param config.converterPriority Converter priority.
  */
  attributeToElement(n) {
    return this.add(wN(n));
  }
  /**
  * Model attribute to view attribute conversion helper.
  *
  * This conversion results in adding an attribute to a view node, basing on an attribute from a model node. For example,
  * `<imageInline src='foo.jpg'></imageInline>` is converted to `<img src='foo.jpg'></img>`.
  *
  * ```ts
  * editor.conversion.for( 'downcast' ).attributeToAttribute( {
  * 	model: 'source',
  * 	view: 'src'
  * } );
  *
  * editor.conversion.for( 'downcast' ).attributeToAttribute( {
  * 	model: 'source',
  * 	view: 'href',
  * 	converterPriority: 'high'
  * } );
  *
  * editor.conversion.for( 'downcast' ).attributeToAttribute( {
  * 	model: {
  * 		name: 'imageInline',
  * 		key: 'source'
  * 	},
  * 	view: 'src'
  * } );
  *
  * editor.conversion.for( 'downcast' ).attributeToAttribute( {
  * 	model: {
  * 		name: 'styled',
  * 		values: [ 'dark', 'light' ]
  * 	},
  * 	view: {
  * 		dark: {
  * 			key: 'class',
  * 			value: [ 'styled', 'styled-dark' ]
  * 		},
  * 		light: {
  * 			key: 'class',
  * 			value: [ 'styled', 'styled-light' ]
  * 		}
  * 	}
  * } );
  *
  * editor.conversion.for( 'downcast' ).attributeToAttribute( {
  * 	model: 'styled',
  * 	view: modelAttributeValue => ( {
  * 		key: 'class',
  * 		value: 'styled-' + modelAttributeValue
  * 	} )
  * } );
  * ```
  *
  * **Note**: Downcasting to a style property requires providing `value` as an object:
  *
  * ```ts
  * editor.conversion.for( 'downcast' ).attributeToAttribute( {
  * 	model: 'lineHeight',
  * 	view: modelAttributeValue => ( {
  * 		key: 'style',
  * 		value: {
  * 			'line-height': modelAttributeValue,
  * 			'border-bottom': '1px dotted #ba2'
  * 		}
  * 	} )
  * } );
  * ```
  *
  * See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
  * to the conversion process.
  *
  * @param config Conversion configuration.
  * @param config.model The key of the attribute to convert from or a `{ key, values, [ name ] }` object describing
  * the attribute key, possible values and, optionally, an element name to convert from.
  * @param config.view A view attribute key, or a `{ key, value }` object or a function that takes the model attribute value and
  * {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API}
  * as parameters and returns a `{ key, value }` object. If the `key` is `'class'`, the `value` can be a `String` or an
  * array of `String`s. If the `key` is `'style'`, the `value` is an object with key-value pairs. In other cases, `value` is a `String`.
  * If `config.model.values` is set, `config.view` should be an object assigning values from `config.model.values` to
  * `{ key, value }` objects or a functions.
  * @param config.converterPriority Converter priority.
  */
  attributeToAttribute(n) {
    return this.add(AN(n));
  }
  /**
  * Model marker to view element conversion helper.
  *
  * **Note**: This method should be used mainly for editing the downcast and it is recommended
  * to use the {@link #markerToData `#markerToData()`} helper instead.
  *
  * This helper may produce invalid HTML code (e.g. a span between table cells).
  * It should only be used when you are sure that the produced HTML will be semantically correct.
  *
  * This conversion results in creating a view element on the boundaries of the converted marker. If the converted marker
  * is collapsed, only one element is created. For example, a model marker set like this: `<paragraph>F[oo b]ar</paragraph>`
  * becomes `<p>F<span data-marker="search"></span>oo b<span data-marker="search"></span>ar</p>` in the view.
  *
  * ```ts
  * editor.conversion.for( 'editingDowncast' ).markerToElement( {
  * 	model: 'search',
  * 	view: 'marker-search'
  * } );
  *
  * editor.conversion.for( 'editingDowncast' ).markerToElement( {
  * 	model: 'search',
  * 	view: 'search-result',
  * 	converterPriority: 'high'
  * } );
  *
  * editor.conversion.for( 'editingDowncast' ).markerToElement( {
  * 	model: 'search',
  * 	view: {
  * 		name: 'span',
  * 		attributes: {
  * 			'data-marker': 'search'
  * 		}
  * 	}
  * } );
  *
  * editor.conversion.for( 'editingDowncast' ).markerToElement( {
  * 	model: 'search',
  * 	view: ( markerData, conversionApi ) => {
  * 		const { writer } = conversionApi;
  *
  * 		return writer.createUIElement( 'span', {
  * 			'data-marker': 'search',
  * 			'data-start': markerData.isOpening
  * 		} );
  * 	}
  * } );
  * ```
  *
  * If a function is passed as the `config.view` parameter, it will be used to generate both boundary elements. The function
  * receives the `data` object and {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API}
  * as a parameters and should return an instance of the
  * {@link module:engine/view/uielement~UIElement view UI element}. The `data` object and
  * {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi `conversionApi`} are passed from
  * {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:addMarker}. Additionally,
  * the `data.isOpening` parameter is passed, which is set to `true` for the marker start boundary element, and `false` for
  * the marker end boundary element.
  *
  * See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
  * to the conversion process.
  *
  * @param config Conversion configuration.
  * @param config.model The name of the model marker (or model marker group) to convert.
  * @param config.view A view element definition or a function that takes the model marker data and
  * {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API} as a parameters
  * and returns a view UI element.
  * @param config.converterPriority Converter priority.
  */
  markerToElement(n) {
    return this.add(CN(n));
  }
  /**
  * Model marker to highlight conversion helper.
  *
  * This conversion results in creating a highlight on view nodes. For this kind of conversion,
  * the {@link module:engine/conversion/downcasthelpers~HighlightDescriptor} should be provided.
  *
  * For text nodes, a `<span>` {@link module:engine/view/attributeelement~AttributeElement} is created and it wraps all text nodes
  * in the converted marker range. For example, a model marker set like this: `<paragraph>F[oo b]ar</paragraph>` becomes
  * `<p>F<span class="comment">oo b</span>ar</p>` in the view.
  *
  * {@link module:engine/view/containerelement~ContainerElement} may provide a custom way of handling highlight. Most often,
  * the element itself is given classes and attributes described in the highlight descriptor (instead of being wrapped in `<span>`).
  * For example, a model marker set like this:
  * `[<imageInline src="foo.jpg"></imageInline>]` becomes `<img src="foo.jpg" class="comment"></img>` in the view.
  *
  * For container elements, the conversion is two-step. While the converter processes the highlight descriptor and passes it
  * to a container element, it is the container element instance itself that applies values from the highlight descriptor.
  * So, in a sense, the converter takes care of stating what should be applied on what, while the element decides how to apply that.
  *
  * ```ts
  * editor.conversion.for( 'downcast' ).markerToHighlight( { model: 'comment', view: { classes: 'comment' } } );
  *
  * editor.conversion.for( 'downcast' ).markerToHighlight( {
  * 	model: 'comment',
  * 	view: { classes: 'comment' },
  * 	converterPriority: 'high'
  * } );
  *
  * editor.conversion.for( 'downcast' ).markerToHighlight( {
  * 	model: 'comment',
  * 	view: ( data, conversionApi ) => {
  * 		// Assuming that the marker name is in a form of comment:commentType:commentId.
  * 		const [ , commentType, commentId ] = data.markerName.split( ':' );
  *
  * 		return {
  * 			classes: [ 'comment', 'comment-' + commentType ],
  * 			attributes: { 'data-comment-id': commentId }
  * 		};
  * 	}
  * } );
  * ```
  *
  * If a function is passed as the `config.view` parameter, it will be used to generate the highlight descriptor. The function
  * receives the `data` object and {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API}
  * as the parameters and should return a
  * {@link module:engine/conversion/downcasthelpers~HighlightDescriptor highlight descriptor}.
  * The `data` object properties are passed from {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:addMarker}.
  *
  * See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
  * to the conversion process.
  *
  * @param config Conversion configuration.
  * @param config.model The name of the model marker (or model marker group) to convert.
  * @param config.view A highlight descriptor that will be used for highlighting or a function that takes the model marker data and
  * {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API} as a parameters
  * and returns a highlight descriptor.
  * @param config.converterPriority Converter priority.
  */
  markerToHighlight(n) {
    return this.add(SN(n));
  }
  /**
  * Model marker converter for data downcast.
  *
  * This conversion creates a representation for model marker boundaries in the view:
  *
  * * If the marker boundary is before or after a model element, a view attribute is set on a corresponding view element.
  * * In other cases, a view element with the specified tag name is inserted at the corresponding view position.
  *
  * Typically, the marker names use the `group:uniqueId:otherData` convention. For example: `comment:e34zfk9k2n459df53sjl34:zx32c`.
  * The default configuration for this conversion is that the first part is the `group` part and the rest of
  * the marker name becomes the `name` part.
  *
  * Tag and attribute names and values are generated from the marker name:
  *
  * * The templates for attributes are `data-[group]-start-before="[name]"`, `data-[group]-start-after="[name]"`,
  * `data-[group]-end-before="[name]"` and `data-[group]-end-after="[name]"`.
  * * The templates for view elements are `<[group]-start name="[name]">` and `<[group]-end name="[name]">`.
  *
  * Attributes mark whether the given marker's start or end boundary is before or after the given element.
  * The `data-[group]-start-before` and `data-[group]-end-after` attributes are favored.
  * The other two are used when the former two cannot be used.
  *
  * The conversion configuration can take a function that will generate different group and name parts.
  * If such a function is set as the `config.view` parameter, it is passed a marker name and it is expected to return an object with two
  * properties: `group` and `name`. If the function returns a falsy value, the conversion will not take place.
  *
  * Basic usage:
  *
  * ```ts
  * // Using the default conversion.
  * // In this case, all markers with names starting with 'comment:' will be converted.
  * // The `group` parameter will be set to `comment`.
  * // The `name` parameter will be the rest of the marker name (without the `:`).
  * editor.conversion.for( 'dataDowncast' ).markerToData( {
  * 	model: 'comment'
  * } );
  * ```
  *
  * An example of a view that may be generated by this conversion (assuming a marker with the name `comment:commentId:uid` marked
  * by `[]`):
  *
  * ```
  * // Model:
  * <paragraph>Foo[bar</paragraph>
  * <imageBlock src="abc.jpg"></imageBlock>]
  *
  * // View:
  * <p>Foo<comment-start name="commentId:uid"></comment-start>bar</p>
  * <figure data-comment-end-after="commentId:uid" class="image"><img src="abc.jpg" /></figure>
  * ```
  *
  * In the example above, the comment starts before "bar" and ends after the image.
  *
  * If the `name` part is empty, the following view may be generated:
  *
  * ```html
  * <p>Foo <myMarker-start></myMarker-start>bar</p>
  * <figure data-myMarker-end-after="" class="image"><img src="abc.jpg" /></figure>
  * ```
  *
  * **Note:** A situation where some markers have the `name` part and some do not, is incorrect and should be avoided.
  *
  * Examples where `data-group-start-after` and `data-group-end-before` are used:
  *
  * ```
  * // Model:
  * <blockQuote>[]<paragraph>Foo</paragraph></blockQuote>
  *
  * // View:
  * <blockquote><p data-group-end-before="name" data-group-start-before="name">Foo</p></blockquote>
  * ```
  *
  * Similarly, when a marker is collapsed after the last element:
  *
  * ```
  * // Model:
  * <blockQuote><paragraph>Foo</paragraph>[]</blockQuote>
  *
  * // View:
  * <blockquote><p data-group-end-after="name" data-group-start-after="name">Foo</p></blockquote>
  * ```
  *
  * When there are multiple markers from the same group stored in the same attribute of the same element, their
  * name parts are put together in the attribute value, for example: `data-group-start-before="name1,name2,name3"`.
  *
  * Other examples of usage:
  *
  * ```ts
  * // Using a custom function which is the same as the default conversion:
  * editor.conversion.for( 'dataDowncast' ).markerToData( {
  * 	model: 'comment',
  * 	view: markerName => ( {
  * 		group: 'comment',
  * 		name: markerName.substr( 8 ) // Removes 'comment:' part.
  * 	} )
  * } );
  *
  * // Using the converter priority:
  * editor.conversion.for( 'dataDowncast' ).markerToData( {
  * 	model: 'comment',
  * 	view: markerName => ( {
  * 		group: 'comment',
  * 		name: markerName.substr( 8 ) // Removes 'comment:' part.
  * 	} ),
  * 	converterPriority: 'high'
  * } );
  * ```
  *
  * This kind of conversion is useful for saving data into the database, so it should be used in the data conversion pipeline.
  *
  * See the {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} API guide to learn how to
  * add a converter to the conversion process.
  *
  * @param config Conversion configuration.
  * @param config.model The name of the model marker (or the model marker group) to convert.
  * @param config.view A function that takes the model marker name and
  * {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi downcast conversion API} as the parameters
  * and returns an object with the `group` and `name` properties.
  * @param config.converterPriority Converter priority.
  */
  markerToData(n) {
    return this.add(kN(n));
  }
}
function lT() {
  return (e, n, t) => {
    if (!t.consumable.consume(n.item, e.name))
      return;
    const i = t.writer, r = t.mapper.toViewPosition(n.range.start), s = i.createText(n.item.data);
    i.insert(r, s);
  };
}
function cT() {
  return (e, n, t) => {
    t.convertAttributes(n.item), !n.reconversion && n.item.is("element") && !n.item.isEmpty && t.convertChildren(n.item);
  };
}
function iN() {
  return (e, n, t) => {
    const i = t.mapper.toViewPosition(n.position), r = n.position.getShiftedBy(n.length), s = t.mapper.toViewPosition(r, {
      isPhantom: !0
    }), o = t.writer.createRange(i, s), a = t.writer.remove(o.getTrimmed());
    for (const u of t.writer.createRangeIn(a).getItems())
      t.mapper.unbindViewElement(u, {
        defer: !0
      });
  };
}
function dT(e, n) {
  const t = e.createAttributeElement("span", n.attributes);
  return n.classes && t._addClass(n.classes), typeof n.priority == "number" && (t._priority = n.priority), t._id = n.id, t;
}
function rN() {
  return (e, n, t) => {
    const i = n.selection;
    if (i.isCollapsed || !t.consumable.consume(i, "selection"))
      return;
    const r = [];
    for (const s of i.getRanges())
      r.push(t.mapper.toViewRange(s));
    t.writer.setSelection(r, {
      backward: i.isBackward
    });
  };
}
function sN() {
  return (e, n, t) => {
    const i = n.selection;
    if (!i.isCollapsed || !t.consumable.consume(i, "selection"))
      return;
    const r = t.writer, s = i.getFirstPosition(), o = t.mapper.toViewPosition(s), a = r.breakAttributes(o);
    r.setSelection(a);
  };
}
function oN() {
  return (e, n, t) => {
    const i = t.writer, r = i.document.selection;
    for (const s of r.getRanges())
      s.isCollapsed && s.end.parent.isAttached() && t.writer.mergeAttributes(s.start);
    i.setSelection(null);
  };
}
function aN(e) {
  return (n, t, i) => {
    if (!i.consumable.test(t.item, n.name))
      return;
    const r = e(t.attributeOldValue, i, t), s = e(t.attributeNewValue, i, t);
    if (!r && !s)
      return;
    i.consumable.consume(t.item, n.name);
    const o = i.writer, a = o.document.selection;
    if (t.item instanceof Sn || t.item instanceof oi)
      o.wrap(a.getFirstRange(), s);
    else {
      let u = i.mapper.toViewRange(t.range);
      t.attributeOldValue !== null && r && (u = o.unwrap(u, r)), t.attributeNewValue !== null && s && o.wrap(u, s);
    }
  };
}
function uN(e, n = RN) {
  return (t, i, r) => {
    if (!n(i.item, r.consumable, {
      preflight: !0
    }))
      return;
    const s = e(i.item, r, i);
    if (!s)
      return;
    n(i.item, r.consumable);
    const o = r.mapper.toViewPosition(i.range.start);
    r.mapper.bindElements(i.item, s), r.writer.insert(o, s), r.convertAttributes(i.item), gT(s, i.item.getChildren(), r, {
      reconversion: i.reconversion
    });
  };
}
function lN(e, n) {
  return (t, i, r) => {
    if (!n(i.item, r.consumable, {
      preflight: !0
    }))
      return;
    const s = /* @__PURE__ */ new Map();
    r.writer._registerSlotFactory(vN(i.item, s, r));
    const o = e(i.item, r, i);
    if (r.writer._clearSlotFactory(), !o)
      return;
    PN(i.item, s, r), n(i.item, r.consumable);
    const a = r.mapper.toViewPosition(i.range.start);
    r.mapper.bindElements(i.item, o), r.writer.insert(a, o), r.convertAttributes(i.item), ON(o, s, r, {
      reconversion: i.reconversion
    });
  };
}
function cN(e) {
  return (n, t, i) => {
    t.isOpening = !0;
    const r = e(t, i);
    t.isOpening = !1;
    const s = e(t, i);
    if (!r || !s)
      return;
    const o = t.markerRange;
    if (o.isCollapsed && !i.consumable.consume(o, n.name))
      return;
    for (const l of o)
      if (!i.consumable.consume(l.item, n.name))
        return;
    const a = i.mapper, u = i.writer;
    u.insert(a.toViewPosition(o.start), r), i.mapper.bindElementToMarker(r, t.markerName), o.isCollapsed || (u.insert(a.toViewPosition(o.end), s), i.mapper.bindElementToMarker(s, t.markerName)), n.stop();
  };
}
function dN() {
  return (e, n, t) => {
    const i = t.mapper.markerNameToElements(n.markerName);
    if (i) {
      for (const r of i)
        t.mapper.unbindElementFromMarkerName(r, n.markerName), t.writer.clear(t.writer.createRangeOn(r), r);
      t.writer.clearClonedElementsGroup(n.markerName), e.stop();
    }
  };
}
function hN(e) {
  return (n, t, i) => {
    const r = e(t.markerName, i);
    if (!r)
      return;
    const s = t.markerRange;
    i.consumable.consume(s, n.name) && (Pp(s, !1, i, t, r), Pp(s, !0, i, t, r), n.stop());
  };
}
function Pp(e, n, t, i, r) {
  const s = n ? e.start : e.end, o = s.nodeAfter && s.nodeAfter.is("element") ? s.nodeAfter : null, a = s.nodeBefore && s.nodeBefore.is("element") ? s.nodeBefore : null;
  if (o || a) {
    let l, c;
    n && o || !n && !a ? (l = o, c = !0) : (l = a, c = !1);
    const d = t.mapper.toViewElement(l);
    if (d) {
      fN(d, n, c, t, i, r);
      return;
    }
  }
  const u = t.mapper.toViewPosition(s);
  mN(u, n, t, i, r);
}
function fN(e, n, t, i, r, s) {
  const o = `data-${s.group}-${n ? "start" : "end"}-${t ? "before" : "after"}`, a = e.hasAttribute(o) ? e.getAttribute(o).split(",") : [];
  a.unshift(s.name), i.writer.setAttribute(o, a.join(","), e), i.mapper.bindElementToMarker(e, r.markerName);
}
function mN(e, n, t, i, r) {
  const s = `${r.group}-${n ? "start" : "end"}`, o = r.name ? {
    name: r.name
  } : null, a = t.writer.createUIElement(s, o);
  t.writer.insert(e, a), t.mapper.bindElementToMarker(a, i.markerName);
}
function pN(e) {
  return (n, t, i) => {
    const r = e(t.markerName, i);
    if (!r)
      return;
    const s = i.mapper.markerNameToElements(t.markerName);
    if (!s)
      return;
    for (const a of s)
      i.mapper.unbindElementFromMarkerName(a, t.markerName), a.is("containerElement") ? (o(`data-${r.group}-start-before`, a), o(`data-${r.group}-start-after`, a), o(`data-${r.group}-end-before`, a), o(`data-${r.group}-end-after`, a)) : i.writer.clear(i.writer.createRangeOn(a), a);
    i.writer.clearClonedElementsGroup(t.markerName), n.stop();
    function o(a, u) {
      if (u.hasAttribute(a)) {
        const l = new Set(u.getAttribute(a).split(","));
        l.delete(r.name), l.size == 0 ? i.writer.removeAttribute(a, u) : i.writer.setAttribute(a, Array.from(l).join(","), u);
      }
    }
  };
}
function gN(e) {
  return (n, t, i) => {
    if (!i.consumable.test(t.item, n.name))
      return;
    const r = e(t.attributeOldValue, i, t), s = e(t.attributeNewValue, i, t);
    if (!r && !s)
      return;
    i.consumable.consume(t.item, n.name);
    const o = i.mapper.toViewElement(t.item), a = i.writer;
    if (!o)
      throw new v("conversion-attribute-to-attribute-on-text", i.dispatcher, t);
    if (t.attributeOldValue !== null && r) {
      let u = r.value;
      r.key == "style" && (typeof r.value == "string" ? u = new oa(a.document.stylesProcessor).setTo(r.value).getStylesEntries().map(([l]) => l) : u = Object.keys(r.value)), a.removeAttribute(r.key, u, o);
    }
    if (t.attributeNewValue !== null && s) {
      let u = s.value;
      s.key == "style" && typeof s.value == "string" && (u = Object.fromEntries(new oa(a.document.stylesProcessor).setTo(s.value).getStylesEntries())), a.setAttribute(s.key, u, !1, o);
    }
  };
}
function bN(e) {
  return (n, t, i) => {
    if (!t.item || !(t.item instanceof Sn || t.item instanceof oi) && !t.item.is("$textProxy"))
      return;
    const r = Jf(e, t, i);
    if (!r || !i.consumable.consume(t.item, n.name))
      return;
    const s = i.writer, o = dT(s, r), a = s.document.selection;
    if (t.item instanceof Sn || t.item instanceof oi)
      s.wrap(a.getFirstRange(), o);
    else {
      const u = i.mapper.toViewRange(t.range), l = s.wrap(u, o);
      for (const c of l.getItems())
        if (c.is("attributeElement") && c.isSimilar(o)) {
          i.mapper.bindElementToMarker(c, t.markerName);
          break;
        }
    }
  };
}
function _N(e) {
  return (n, t, i) => {
    if (!t.item || !(t.item instanceof rt))
      return;
    const r = Jf(e, t, i);
    if (!r || !i.consumable.test(t.item, n.name))
      return;
    const s = i.mapper.toViewElement(t.item);
    if (s && s.getCustomProperty("addHighlight")) {
      i.consumable.consume(t.item, n.name);
      for (const a of B._createIn(t.item))
        i.consumable.consume(a.item, n.name);
      s.getCustomProperty("addHighlight")(s, r, i.writer), i.mapper.bindElementToMarker(s, t.markerName);
    }
  };
}
function EN(e) {
  return (n, t, i) => {
    if (t.markerRange.isCollapsed)
      return;
    const r = Jf(e, t, i);
    if (!r)
      return;
    const s = dT(i.writer, r), o = i.mapper.markerNameToElements(t.markerName);
    if (o) {
      for (const a of o)
        i.mapper.unbindElementFromMarkerName(a, t.markerName), a.is("attributeElement") ? i.writer.unwrap(i.writer.createRangeOn(a), s) : a.getCustomProperty("removeHighlight")(a, r.id, i.writer);
      i.writer.clearClonedElementsGroup(t.markerName), n.stop();
    }
  };
}
function TN(e) {
  const n = hT(e.model), t = Da(e.view, "container");
  return n.attributes.length && (n.children = !0), (i) => {
    i.on(`insert:${n.name}`, uN(t, pT(n)), {
      priority: e.converterPriority || "normal"
    }), (n.children || n.attributes.length) && i.on("reduceChanges", mT(n), {
      priority: "low"
    });
  };
}
function yN(e) {
  const n = hT(e.model), t = Da(e.view, "container");
  return n.children = !0, (i) => {
    if (i._conversionApi.schema.checkChild(n.name, "$text"))
      throw new v("conversion-element-to-structure-disallowed-text", i, {
        elementName: n.name
      });
    i.on(`insert:${n.name}`, lN(t, pT(n)), {
      priority: e.converterPriority || "normal"
    }), i.on("reduceChanges", mT(n), {
      priority: "low"
    });
  };
}
function wN(e) {
  e = ui(e);
  let n = e.model;
  typeof n == "string" && (n = {
    key: n
  });
  let t = `attribute:${n.key}`;
  if (n.name && (t += ":" + n.name), n.values)
    for (const r of n.values)
      e.view[r] = Da(e.view[r], "attribute");
  else
    e.view = Da(e.view, "attribute");
  const i = fT(e);
  return (r) => {
    r.on(t, aN(i), {
      priority: e.converterPriority || "normal"
    });
  };
}
function AN(e) {
  e = ui(e);
  let n = e.model;
  typeof n == "string" && (n = {
    key: n
  });
  let t = `attribute:${n.key}`;
  if (n.name && (t += ":" + n.name), n.values)
    for (const r of n.values)
      e.view[r] = Op(e.view[r]);
  else
    e.view = Op(e.view);
  const i = fT(e);
  return (r) => {
    r.on(t, gN(i), {
      priority: e.converterPriority || "normal"
    });
  };
}
function CN(e) {
  const n = Da(e.view, "ui");
  return (t) => {
    t.on(`addMarker:${e.model}`, cN(n), {
      priority: e.converterPriority || "normal"
    }), t.on(`removeMarker:${e.model}`, dN(), {
      priority: e.converterPriority || "normal"
    });
  };
}
function kN(e) {
  e = ui(e);
  const n = e.model;
  let t = e.view;
  return t || (t = (i) => ({
    group: n,
    name: i.substr(e.model.length + 1)
  })), (i) => {
    i.on(`addMarker:${n}`, hN(t), {
      priority: e.converterPriority || "normal"
    }), i.on(`removeMarker:${n}`, pN(t), {
      priority: e.converterPriority || "normal"
    });
  };
}
function SN(e) {
  return (n) => {
    n.on(`addMarker:${e.model}`, bN(e.view), {
      priority: e.converterPriority || "normal"
    }), n.on(`addMarker:${e.model}`, _N(e.view), {
      priority: e.converterPriority || "normal"
    }), n.on(`removeMarker:${e.model}`, EN(e.view), {
      priority: e.converterPriority || "normal"
    });
  };
}
function hT(e) {
  return typeof e == "string" && (e = {
    name: e
  }), {
    name: e.name,
    attributes: e.attributes ? Dt(e.attributes) : [],
    children: !!e.children
  };
}
function Da(e, n) {
  return typeof e == "function" ? e : (t, i) => IN(e, i, n);
}
function IN(e, n, t) {
  typeof e == "string" && (e = {
    name: e
  });
  let i;
  const r = n.writer, s = Object.assign({}, e.attributes);
  if (t == "container")
    i = r.createContainerElement(e.name, s);
  else if (t == "attribute") {
    const o = {
      priority: e.priority || Xr.DEFAULT_PRIORITY
    };
    i = r.createAttributeElement(e.name, s, o);
  } else
    i = r.createUIElement(e.name, s);
  if (e.styles) {
    const o = Object.keys(e.styles);
    for (const a of o)
      r.setStyle(a, e.styles[a], i);
  }
  if (e.classes) {
    const o = e.classes;
    if (typeof o == "string")
      r.addClass(o, i);
    else
      for (const a of o)
        r.addClass(a, i);
  }
  return i;
}
function fT(e) {
  return e.model.values ? (n, t, i) => {
    const r = e.view[n];
    return r ? r(n, t, i) : null;
  } : e.view;
}
function Op(e) {
  return typeof e == "string" ? (n) => ({
    key: e,
    value: n
  }) : typeof e == "object" ? e.value ? () => e : (n) => ({
    key: e.key,
    value: n
  }) : e;
}
function Jf(e, n, t) {
  const i = typeof e == "function" ? e(n, t) : e;
  return i ? (i.priority || (i.priority = 10), i.id || (i.id = n.markerName), i) : null;
}
function xN(e) {
  return (n, t) => {
    if (!n.is("element", e.name))
      return !1;
    if (t.type == "attribute") {
      if (e.attributes.includes(t.attributeKey))
        return !0;
    } else {
      /* istanbul ignore else: This is always true because otherwise it would not register a reducer callback. -- @preserve */
      if (e.children)
        return !0;
    }
    return !1;
  };
}
function mT(e) {
  const n = xN(e);
  return (t, i) => {
    const r = [];
    i.reconvertedElements || (i.reconvertedElements = /* @__PURE__ */ new Set());
    for (const s of i.changes) {
      const o = s.type == "attribute" ? s.range.start.nodeAfter : s.position.parent;
      if (!o || !n(o, s)) {
        r.push(s);
        continue;
      }
      if (!i.reconvertedElements.has(o)) {
        i.reconvertedElements.add(o);
        const a = z._createBefore(o);
        let u = r.length;
        for (let l = r.length - 1; l >= 0; l--) {
          const c = r[l], p = (c.type == "attribute" ? c.range.start : c.position).compareWith(a);
          if (p == "before" || c.type == "remove" && p == "same")
            break;
          u = l;
        }
        r.splice(u, 0, {
          type: "remove",
          name: o.name,
          position: a,
          length: 1
        }, {
          type: "reinsert",
          name: o.name,
          position: a,
          length: 1
        });
      }
    }
    i.changes = r;
  };
}
function pT(e) {
  return (n, t, i = {}) => {
    const r = [
      "insert"
    ];
    for (const s of e.attributes)
      n.hasAttribute(s) && r.push(`attribute:${s}`);
    return r.every((s) => t.test(n, s)) ? (i.preflight || r.forEach((s) => t.consume(n, s)), !0) : !1;
  };
}
function vN(e, n, t) {
  return (i, r) => {
    const s = i.createContainerElement("$slot");
    let o = null;
    if (r === "children")
      o = Array.from(e.getChildren());
    else if (typeof r == "function")
      o = Array.from(e.getChildren()).filter((a) => r(a));
    else
      throw new v("conversion-slot-mode-unknown", t.dispatcher, {
        modeOrFilter: r
      });
    return n.set(s, o), s;
  };
}
function PN(e, n, t) {
  const i = Array.from(n.values()).flat(), r = new Set(i);
  if (r.size != i.length)
    throw new v("conversion-slot-filter-overlap", t.dispatcher, {
      element: e
    });
  if (r.size != e.childCount)
    throw new v("conversion-slot-filter-incomplete", t.dispatcher, {
      element: e
    });
}
function ON(e, n, t, i) {
  t.mapper.on("modelToViewPosition", o, {
    priority: "highest"
  });
  let r = null, s = null;
  for ([r, s] of n)
    gT(e, s, t, i), t.writer.move(t.writer.createRangeIn(r), t.writer.createPositionBefore(r)), t.writer.remove(r);
  t.mapper.off("modelToViewPosition", o);
  function o(a, u) {
    const l = u.modelPosition.nodeAfter, c = s.indexOf(l);
    c < 0 || (u.viewPosition = u.mapper.findPositionIn(r, c));
  }
}
function gT(e, n, t, i) {
  for (const r of n)
    NN(e.root, r, t, i) || t.convertItem(r);
}
function NN(e, n, t, i) {
  const { writer: r, mapper: s } = t;
  if (!i.reconversion)
    return !1;
  const o = s.toViewElement(n);
  return !o || o.root == e || !t.canReuseView(o) ? !1 : (r.move(r.createRangeOn(o), s.toViewPosition(z._createBefore(n))), !0);
}
function RN(e, n, { preflight: t } = {}) {
  return t ? n.test(e, "insert") : n.consume(e, "insert");
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function bT(e) {
  const { schema: n, document: t } = e.model;
  for (const i of t.getRoots())
    if (i.isEmpty && !n.checkChild(i, "$text") && n.checkChild(i, "paragraph"))
      return e.insertElement("paragraph", i), !0;
  return !1;
}
function _T(e, n, t) {
  const i = t.createContext(e);
  return !(!t.checkChild(i, "paragraph") || !t.checkChild(i.push("paragraph"), n));
}
function ET(e, n) {
  const t = n.createElement("paragraph");
  return n.insert(t, e), n.createPositionAt(t, 0);
}
class LN extends uT {
  /**
  * View element to model element conversion helper.
  *
  * This conversion results in creating a model element. For example,
  * view `<p>Foo</p>` becomes `<paragraph>Foo</paragraph>` in the model.
  *
  * Keep in mind that the element will be inserted only if it is allowed
  * by {@link module:engine/model/schema~Schema schema} configuration.
  *
  * ```ts
  * editor.conversion.for( 'upcast' ).elementToElement( {
  * 	view: 'p',
  * 	model: 'paragraph'
  * } );
  *
  * editor.conversion.for( 'upcast' ).elementToElement( {
  * 	view: 'p',
  * 	model: 'paragraph',
  * 	converterPriority: 'high'
  * } );
  *
  * editor.conversion.for( 'upcast' ).elementToElement( {
  * 	view: {
  * 		name: 'p',
  * 		classes: 'fancy'
  * 	},
  * 	model: 'fancyParagraph'
  * } );
  *
  * editor.conversion.for( 'upcast' ).elementToElement( {
  * 	view: {
  * 		name: 'p',
  * 		classes: 'heading'
  * 	},
  * 	model: ( viewElement, conversionApi ) => {
  * 		const modelWriter = conversionApi.writer;
  *
  * 		return modelWriter.createElement( 'heading', { level: viewElement.getAttribute( 'data-level' ) } );
  * 	}
  * } );
  * ```
  *
  * See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
  * to the conversion process.
  *
  * @param config Conversion configuration.
  * @param config.view Pattern matching all view elements which should be converted. If not set, the converter
  * will fire for every view element.
  * @param config.model Name of the model element, a model element instance or a function that takes a view element
  * and {@link module:engine/conversion/upcastdispatcher~UpcastConversionApi upcast conversion API}
  * and returns a model element. The model element will be inserted in the model.
  * @param config.converterPriority Converter priority.
  */
  elementToElement(n) {
    return this.add(TT(n));
  }
  /**
  * View element to model attribute conversion helper.
  *
  * This conversion results in setting an attribute on a model node. For example, view `<strong>Foo</strong>` becomes
  * `Foo` {@link module:engine/model/text~Text model text node} with `bold` attribute set to `true`.
  *
  * This helper is meant to set a model attribute on all the elements that are inside the converted element:
  *
  * ```
  * <strong>Foo</strong>   -->   <strong><p>Foo</p></strong>   -->   <paragraph><$text bold="true">Foo</$text></paragraph>
  * ```
  *
  * Above is a sample of HTML code, that goes through autoparagraphing (first step) and then is converted (second step).
  * Even though `<strong>` is over `<p>` element, `bold="true"` was added to the text. See
  * {@link module:engine/conversion/upcasthelpers~UpcastHelpers#attributeToAttribute} for comparison.
  *
  * Keep in mind that the attribute will be set only if it is allowed by {@link module:engine/model/schema~Schema schema} configuration.
  *
  * ```ts
  * editor.conversion.for( 'upcast' ).elementToAttribute( {
  * 	view: 'strong',
  * 	model: 'bold'
  * } );
  *
  * editor.conversion.for( 'upcast' ).elementToAttribute( {
  * 	view: 'strong',
  * 	model: 'bold',
  * 	converterPriority: 'high'
  * } );
  *
  * editor.conversion.for( 'upcast' ).elementToAttribute( {
  * 	view: {
  * 		name: 'span',
  * 		classes: 'bold'
  * 	},
  * 	model: 'bold'
  * } );
  *
  * editor.conversion.for( 'upcast' ).elementToAttribute( {
  * 	view: {
  * 		name: 'span',
  * 		classes: [ 'styled', 'styled-dark' ]
  * 	},
  * 	model: {
  * 		key: 'styled',
  * 		value: 'dark'
  * 	}
  * } );
  *
  * editor.conversion.for( 'upcast' ).elementToAttribute( {
  * 	view: {
  * 		name: 'span',
  * 		styles: {
  * 			'font-size': /[\s\S]+/
  * 		}
  * 	},
  * 	model: {
  * 		key: 'fontSize',
  * 		value: ( viewElement, conversionApi ) => {
  * 			const fontSize = viewElement.getStyle( 'font-size' );
  * 			const value = fontSize.substr( 0, fontSize.length - 2 );
  *
  * 			if ( value <= 10 ) {
  * 				return 'small';
  * 			} else if ( value > 12 ) {
  * 				return 'big';
  * 			}
  *
  * 			return null;
  * 		}
  * 	}
  * } );
  * ```
  *
  * See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
  * to the conversion process.
  *
  * @param config Conversion configuration.
  * @param config.view Pattern matching all view elements which should be converted.
  * @param config.model Model attribute key or an object with `key` and `value` properties, describing
  * the model attribute. `value` property may be set as a function that takes a view element and
  * {@link module:engine/conversion/upcastdispatcher~UpcastConversionApi upcast conversion API} and returns the value.
  * If `String` is given, the model attribute value will be set to `true`.
  * @param config.converterPriority Converter priority. Defaults to `low`.
  */
  elementToAttribute(n) {
    return this.add(BN(n));
  }
  /**
  * View attribute to model attribute conversion helper.
  *
  * This conversion results in setting an attribute on a model node. For example, view `<img src="foo.jpg"></img>` becomes
  * `<imageBlock source="foo.jpg"></imageBlock>` in the model.
  *
  * This helper is meant to convert view attributes from view elements which got converted to the model, so the view attribute
  * is set only on the corresponding model node:
  *
  * ```
  * <div class="dark"><div>foo</div></div>    -->    <div dark="true"><div>foo</div></div>
  * ```
  *
  * Above, `class="dark"` attribute is added only to the `<div>` elements that has it. This is in contrast to
  * {@link module:engine/conversion/upcasthelpers~UpcastHelpers#elementToAttribute} which sets attributes for
  * all the children in the model:
  *
  * ```
  * <strong>Foo</strong>   -->   <strong><p>Foo</p></strong>   -->   <paragraph><$text bold="true">Foo</$text></paragraph>
  * ```
  *
  * Above is a sample of HTML code, that goes through autoparagraphing (first step) and then is converted (second step).
  * Even though `<strong>` is over `<p>` element, `bold="true"` was added to the text.
  *
  * Keep in mind that the attribute will be set only if it is allowed by {@link module:engine/model/schema~Schema schema} configuration.
  *
  * ```ts
  * editor.conversion.for( 'upcast' ).attributeToAttribute( {
  * 	view: 'src',
  * 	model: 'source'
  * } );
  *
  * editor.conversion.for( 'upcast' ).attributeToAttribute( {
  * 	view: { key: 'src' },
  * 	model: 'source'
  * } );
  *
  * editor.conversion.for( 'upcast' ).attributeToAttribute( {
  * 	view: { key: 'src' },
  * 	model: 'source',
  * 	converterPriority: 'normal'
  * } );
  *
  * editor.conversion.for( 'upcast' ).attributeToAttribute( {
  * 	view: {
  * 		key: 'data-style',
  * 		value: /[\s\S]+/
  * 	},
  * 	model: 'styled'
  * } );
  *
  * editor.conversion.for( 'upcast' ).attributeToAttribute( {
  * 	view: {
  * 		name: 'img',
  * 		key: 'class',
  * 		value: 'styled-dark'
  * 	},
  * 	model: {
  * 		key: 'styled',
  * 		value: 'dark'
  * 	}
  * } );
  *
  * editor.conversion.for( 'upcast' ).attributeToAttribute( {
  * 	view: {
  * 		key: 'class',
  * 		value: /styled-[\S]+/
  * 	},
  * 	model: {
  * 		key: 'styled'
  * 		value: ( viewElement, conversionApi ) => {
  * 			const regexp = /styled-([\S]+)/;
  * 			const match = viewElement.getAttribute( 'class' ).match( regexp );
  *
  * 			return match[ 1 ];
  * 		}
  * 	}
  * } );
  * ```
  *
  * Converting styles works a bit differently as it requires `view.styles` to be an object and by default
  * a model attribute will be set to `true` by such a converter. You can set the model attribute to any value by providing the `value`
  * callback that returns the desired value.
  *
  * ```ts
  * // Default conversion of font-weight style will result in setting bold attribute to true.
  * editor.conversion.for( 'upcast' ).attributeToAttribute( {
  * 	view: {
  * 		styles: {
  * 			'font-weight': 'bold'
  * 		}
  * 	},
  * 	model: 'bold'
  * } );
  *
  * // This converter will pass any style value to the `lineHeight` model attribute.
  * editor.conversion.for( 'upcast' ).attributeToAttribute( {
  * 	view: {
  * 		styles: {
  * 			'line-height': /[\s\S]+/
  * 		}
  * 	},
  * 	model: {
  * 		key: 'lineHeight',
  * 		value: ( viewElement, conversionApi ) => viewElement.getStyle( 'line-height' )
  * 	}
  * } );
  * ```
  *
  * See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
  * to the conversion process.
  *
  * @param config Conversion configuration.
  * @param config.view Specifies which view attribute will be converted. If a `String` is passed,
  * attributes with given key will be converted. If an `Object` is passed, it must have a required `key` property,
  * specifying view attribute key, and may have an optional `value` property, specifying view attribute value and optional `name`
  * property specifying a view element name from/on which the attribute should be converted. `value` can be given as a `String`,
  * a `RegExp` or a function callback, that takes view attribute value as the only parameter and returns `Boolean`.
  * @param config.model Model attribute key or an object with `key` and `value` properties, describing
  * the model attribute. `value` property may be set as a function that takes a view element and
  * {@link module:engine/conversion/upcastdispatcher~UpcastConversionApi upcast conversion API} and returns the value.
  * If `String` is given, the model attribute value will be same as view attribute value.
  * @param config.converterPriority Converter priority. Defaults to `low`.
  */
  attributeToAttribute(n) {
    return this.add(FN(n));
  }
  /**
  * View element to model marker conversion helper.
  *
  * This conversion results in creating a model marker. For example, if the marker was stored in a view as an element:
  * `<p>Fo<span data-marker="comment" data-comment-id="7"></span>o</p><p>B<span data-marker="comment" data-comment-id="7"></span>ar</p>`,
  * after the conversion is done, the marker will be available in
  * {@link module:engine/model/model~Model#markers model document markers}.
  *
  * **Note**: When this helper is used in the data upcast in combination with
  * {@link module:engine/conversion/downcasthelpers~DowncastHelpers#markerToData `#markerToData()`} in the data downcast,
  * then invalid HTML code (e.g. a span between table cells) may be produced by the latter converter.
  *
  * In most of the cases, the {@link #dataToMarker} should be used instead.
  *
  * ```ts
  * editor.conversion.for( 'upcast' ).elementToMarker( {
  * 	view: 'marker-search',
  * 	model: 'search'
  * } );
  *
  * editor.conversion.for( 'upcast' ).elementToMarker( {
  * 	view: 'marker-search',
  * 	model: 'search',
  * 	converterPriority: 'high'
  * } );
  *
  * editor.conversion.for( 'upcast' ).elementToMarker( {
  * 	view: 'marker-search',
  * 	model: ( viewElement, conversionApi ) => 'comment:' + viewElement.getAttribute( 'data-comment-id' )
  * } );
  *
  * editor.conversion.for( 'upcast' ).elementToMarker( {
  * 	view: {
  * 		name: 'span',
  * 		attributes: {
  * 			'data-marker': 'search'
  * 		}
  * 	},
  * 	model: 'search'
  * } );
  * ```
  *
  * See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
  * to the conversion process.
  *
  * @param config Conversion configuration.
  * @param config.view Pattern matching all view elements which should be converted.
  * @param config.model Name of the model marker, or a function that takes a view element and returns
  * a model marker name.
  * @param config.converterPriority Converter priority.
  */
  elementToMarker(n) {
    return this.add(UN(n));
  }
  /**
  * View-to-model marker conversion helper.
  *
  * Converts view data created by {@link module:engine/conversion/downcasthelpers~DowncastHelpers#markerToData `#markerToData()`}
  * back to a model marker.
  *
  * This converter looks for specific view elements and view attributes that mark marker boundaries. See
  * {@link module:engine/conversion/downcasthelpers~DowncastHelpers#markerToData `#markerToData()`} to learn what view data
  * is expected by this converter.
  *
  * The `config.view` property is equal to the marker group name to convert.
  *
  * By default, this converter creates markers with the `group:name` name convention (to match the default `markerToData` conversion).
  *
  * The conversion configuration can take a function that will generate a marker name.
  * If such function is set as the `config.model` parameter, it is passed the `name` part from the view element or attribute and it is
  * expected to return a string with the marker name.
  *
  * Basic usage:
  *
  * ```ts
  * // Using the default conversion.
  * // In this case, all markers from the `comment` group will be converted.
  * // The conversion will look for `<comment-start>` and `<comment-end>` tags and
  * // `data-comment-start-before`, `data-comment-start-after`,
  * // `data-comment-end-before` and `data-comment-end-after` attributes.
  * editor.conversion.for( 'upcast' ).dataToMarker( {
  * 	view: 'comment'
  * } );
  * ```
  *
  * An example of a model that may be generated by this conversion:
  *
  * ```
  * // View:
  * <p>Foo<comment-start name="commentId:uid"></comment-start>bar</p>
  * <figure data-comment-end-after="commentId:uid" class="image"><img src="abc.jpg" /></figure>
  *
  * // Model:
  * <paragraph>Foo[bar</paragraph>
  * <imageBlock src="abc.jpg"></imageBlock>]
  * ```
  *
  * Where `[]` are boundaries of a marker that will receive the `comment:commentId:uid` name.
  *
  * Other examples of usage:
  *
  * ```ts
  * // Using a custom function which is the same as the default conversion:
  * editor.conversion.for( 'upcast' ).dataToMarker( {
  * 	view: 'comment',
  * 	model: ( name, conversionApi ) => 'comment:' + name,
  * } );
  *
  * // Using the converter priority:
  * editor.conversion.for( 'upcast' ).dataToMarker( {
  * 	view: 'comment',
  * 	model: ( name, conversionApi ) => 'comment:' + name,
  * 	converterPriority: 'high'
  * } );
  * ```
  *
  * See {@link module:engine/conversion/conversion~Conversion#for `conversion.for()`} to learn how to add a converter
  * to the conversion process.
  *
  * @param config Conversion configuration.
  * @param config.view The marker group name to convert.
  * @param config.model A function that takes the `name` part from the view element or attribute and
  * {@link module:engine/conversion/upcastdispatcher~UpcastConversionApi upcast conversion API} and returns the marker name.
  * @param config.converterPriority Converter priority.
  */
  dataToMarker(n) {
    return this.add(HN(n));
  }
}
function Np() {
  return (e, n, t) => {
    if (!n.modelRange && t.consumable.consume(n.viewItem, {
      name: !0
    })) {
      const { modelRange: i, modelCursor: r } = t.convertChildren(n.viewItem, n.modelCursor);
      n.modelRange = i, n.modelCursor = r;
    }
  };
}
function DN() {
  return (e, n, { schema: t, consumable: i, writer: r }) => {
    let s = n.modelCursor;
    if (!i.test(n.viewItem))
      return;
    if (!t.checkChild(s, "$text")) {
      if (!_T(s, "$text", t) || n.viewItem.data.trim().length == 0)
        return;
      s = ET(s, r);
    }
    i.consume(n.viewItem);
    const o = r.createText(n.viewItem.data);
    r.insert(o, s), n.modelRange = r.createRange(s, s.getShiftedBy(o.offsetSize)), n.modelCursor = n.modelRange.end;
  };
}
function MN(e, n) {
  return (t, i) => {
    const r = i.newSelection, s = [];
    for (const a of r.getRanges())
      s.push(n.toModelRange(a));
    const o = e.createSelection(s, {
      backward: r.isBackward
    });
    o.isEqual(e.document.selection) || e.change((a) => {
      a.setSelection(o);
    });
  };
}
function TT(e) {
  e = ui(e);
  const n = Nh(e), t = Zf(e.view), i = t ? `element:${t}` : "element";
  return (r) => {
    r.on(i, n, {
      priority: e.converterPriority || "normal"
    });
  };
}
function BN(e) {
  e = ui(e), yT(e);
  const n = wT(e, !1), t = Zf(e.view), i = t ? `element:${t}` : "element";
  return (r) => {
    r.on(i, n, {
      priority: e.converterPriority || "low"
    });
  };
}
function FN(e) {
  e = ui(e);
  let n = null;
  (typeof e.view == "string" || e.view.key) && (n = WN(e)), yT(e, n);
  const t = wT(e, !0);
  return (i) => {
    i.on("element", t, {
      priority: e.converterPriority || "low"
    });
  };
}
function UN(e) {
  const n = YN(e.model);
  return TT({
    ...e,
    model: n
  });
}
function HN(e) {
  e = ui(e), e.model || (e.model = (r) => r ? e.view + ":" + r : e.view);
  const n = {
    view: e.view,
    model: e.model
  }, t = Nh(Rp(n, "start")), i = Nh(Rp(n, "end"));
  return (r) => {
    r.on(`element:${e.view}-start`, t, {
      priority: e.converterPriority || "normal"
    }), r.on(`element:${e.view}-end`, i, {
      priority: e.converterPriority || "normal"
    });
    const s = pr.low, o = pr.highest, a = pr.get(e.converterPriority) / o;
    r.on("element", VN(n), {
      priority: s + a
    });
  };
}
function VN(e) {
  return (n, t, i) => {
    const r = `data-${e.view}`;
    if (!i.consumable.test(t.viewItem, {
      attributes: r + "-end-after"
    }) && !i.consumable.test(t.viewItem, {
      attributes: r + "-start-after"
    }) && !i.consumable.test(t.viewItem, {
      attributes: r + "-end-before"
    }) && !i.consumable.test(t.viewItem, {
      attributes: r + "-start-before"
    }))
      return;
    t.modelRange || Object.assign(t, i.convertChildren(t.viewItem, t.modelCursor)), i.consumable.consume(t.viewItem, {
      attributes: r + "-end-after"
    }) && s(t.modelRange.end, t.viewItem.getAttribute(r + "-end-after").split(",")), i.consumable.consume(t.viewItem, {
      attributes: r + "-start-after"
    }) && s(t.modelRange.end, t.viewItem.getAttribute(r + "-start-after").split(",")), i.consumable.consume(t.viewItem, {
      attributes: r + "-end-before"
    }) && s(t.modelRange.start, t.viewItem.getAttribute(r + "-end-before").split(",")), i.consumable.consume(t.viewItem, {
      attributes: r + "-start-before"
    }) && s(t.modelRange.start, t.viewItem.getAttribute(r + "-start-before").split(","));
    function s(o, a) {
      for (const u of a) {
        const l = e.model(u, i), c = i.writer.createElement("$marker", {
          "data-name": l
        });
        i.writer.insert(c, o), t.modelCursor.isEqual(o) ? t.modelCursor = t.modelCursor.getShiftedBy(1) : t.modelCursor = t.modelCursor._getTransformedByInsertion(o, 1), t.modelRange = t.modelRange._getTransformedByInsertion(o, 1)[0];
      }
    }
  };
}
function Zf(e) {
  return typeof e == "string" ? e : typeof e == "object" && typeof e.name == "string" ? e.name : null;
}
function Nh(e) {
  const n = new Oa(e.view);
  return (t, i, r) => {
    const s = n.match(i.viewItem);
    if (!s)
      return;
    const o = s.match;
    if (o.name = !0, !r.consumable.test(i.viewItem, o))
      return;
    const a = $N(e.model, i.viewItem, r);
    a && r.safeInsert(a, i.modelCursor) && (r.consumable.consume(i.viewItem, o), r.convertChildren(i.viewItem, a), r.updateConversionResult(a, i));
  };
}
function $N(e, n, t) {
  return e instanceof Function ? e(n, t) : t.writer.createElement(e);
}
function WN(e) {
  typeof e.view == "string" && (e.view = {
    key: e.view
  });
  const n = e.view.key, t = typeof e.view.value > "u" ? /[\s\S]*/ : e.view.value;
  let i;
  return n == "class" || n == "style" ? i = {
    [n == "class" ? "classes" : "styles"]: t
  } : i = {
    attributes: {
      [n]: t
    }
  }, e.view.name && (i.name = e.view.name), e.view = i, n;
}
function yT(e, n = null) {
  const t = n === null ? !0 : (s) => s.getAttribute(n), i = typeof e.model != "object" ? e.model : e.model.key, r = typeof e.model != "object" || typeof e.model.value > "u" ? t : e.model.value;
  e.model = {
    key: i,
    value: r
  };
}
function wT(e, n) {
  const t = new Oa(e.view);
  return (i, r, s) => {
    if (!r.modelRange && n)
      return;
    const o = t.match(r.viewItem);
    if (!o || (zN(e.view, r.viewItem) ? o.match.name = !0 : delete o.match.name, !s.consumable.test(r.viewItem, o.match)))
      return;
    const a = e.model.key, u = typeof e.model.value == "function" ? e.model.value(r.viewItem, s) : e.model.value;
    if (u === null)
      return;
    r.modelRange || Object.assign(r, s.convertChildren(r.viewItem, r.modelCursor)), qN(r.modelRange, {
      key: a,
      value: u
    }, n, s) && (s.consumable.test(r.viewItem, {
      name: !0
    }) && (o.match.name = !0), s.consumable.consume(r.viewItem, o.match));
  };
}
function zN(e, n) {
  const t = typeof e == "function" ? e(n) : e;
  return typeof t == "object" && !Zf(t) ? !1 : !t.classes && !t.attributes && !t.styles;
}
function qN(e, n, t, i) {
  let r = !1;
  for (const s of Array.from(e.getItems({
    shallow: t
  })))
    i.schema.checkAttribute(s, n.key) && (r = !0, !s.hasAttribute(n.key) && i.writer.setAttribute(n.key, n.value, s));
  return r;
}
function YN(e) {
  return (n, t) => {
    const i = typeof e == "string" ? e : e(n, t);
    return t.writer.createElement("$marker", {
      "data-name": i
    });
  };
}
function Rp(e, n) {
  const t = (i, r) => {
    const s = i.getAttribute("name"), o = e.model(s, r);
    return r.writer.createElement("$marker", {
      "data-name": o
    });
  };
  return {
    // Upcast <markerGroup-start> and <markerGroup-end> elements.
    view: `${e.view}-${n}`,
    model: t
  };
}
function jN(e) {
  e.document.registerPostFixer((n) => KN(n, e));
}
function KN(e, n) {
  const t = n.document.selection, i = n.schema, r = [];
  let s = !1;
  for (const o of t.getRanges()) {
    const a = AT(o, i);
    a && !a.isEqual(o) ? (r.push(a), s = !0) : r.push(o);
  }
  return s && e.setSelection(JN(r), {
    backward: t.isBackward
  }), !1;
}
function AT(e, n) {
  return e.isCollapsed ? GN(e, n) : QN(e, n);
}
function GN(e, n) {
  const t = e.start, i = n.getNearestSelectionRange(t);
  if (!i) {
    const s = t.getAncestors().reverse().find((o) => n.isObject(o));
    return s ? B._createOn(s) : null;
  }
  if (!i.isCollapsed)
    return i;
  const r = i.start;
  return t.isEqual(r) ? null : new B(r);
}
function QN(e, n) {
  const { start: t, end: i } = e, r = n.checkChild(t, "$text"), s = n.checkChild(i, "$text"), o = n.getLimitElement(t), a = n.getLimitElement(i);
  if (o === a) {
    if (r && s)
      return null;
    if (XN(t, i, n)) {
      const d = t.nodeAfter && n.isSelectable(t.nodeAfter) ? null : n.getNearestSelectionRange(t, "forward"), g = i.nodeBefore && n.isSelectable(i.nodeBefore) ? null : n.getNearestSelectionRange(i, "backward"), b = d ? d.start : t, _ = g ? g.end : i;
      return new B(b, _);
    }
  }
  const u = o && !o.is("rootElement"), l = a && !a.is("rootElement");
  if (u || l) {
    const c = t.nodeAfter && i.nodeBefore && t.nodeAfter.parent === i.nodeBefore.parent, d = u && (!c || !Dp(t.nodeAfter, n)), p = l && (!c || !Dp(i.nodeBefore, n));
    let g = t, b = i;
    return d && (g = z._createBefore(Lp(o, n))), p && (b = z._createAfter(Lp(a, n))), new B(g, b);
  }
  return null;
}
function Lp(e, n) {
  let t = e, i = t;
  for (; n.isLimit(i) && i.parent; )
    t = i, i = i.parent;
  return t;
}
function XN(e, n, t) {
  const i = e.nodeAfter && !t.isLimit(e.nodeAfter) || t.checkChild(e, "$text"), r = n.nodeBefore && !t.isLimit(n.nodeBefore) || t.checkChild(n, "$text");
  return i || r;
}
function JN(e) {
  const n = [
    ...e
  ], t = /* @__PURE__ */ new Set();
  let i = 1;
  for (; i < n.length; ) {
    const s = n[i], o = n.slice(0, i);
    for (const [a, u] of o.entries())
      if (!t.has(a)) {
        if (s.isEqual(u))
          t.add(a);
        else if (s.isIntersecting(u)) {
          t.add(a), t.add(i);
          const l = s.getJoined(u);
          n.push(l);
        }
      }
    i++;
  }
  return n.filter((s, o) => !t.has(o));
}
function Dp(e, n) {
  return e && n.isSelectable(e);
}
class ZN extends (/* @__PURE__ */ pt()) {
  /**
  * Creates an editing controller instance.
  *
  * @param model Editing model.
  * @param stylesProcessor The styles processor instance.
  */
  constructor(t, i) {
    super();
    /**
    * Editor model.
    */
    m(this, "model");
    /**
    * Editing view controller.
    */
    m(this, "view");
    /**
    * A mapper that describes the model-view binding.
    */
    m(this, "mapper");
    /**
    * Downcast dispatcher that converts changes from the model to the {@link #view editing view}.
    */
    m(this, "downcastDispatcher");
    this.model = t, this.view = new FO(i), this.mapper = new sT(), this.downcastDispatcher = new oT({
      mapper: this.mapper,
      schema: t.schema
    });
    const r = this.model.document, s = r.selection, o = this.model.markers;
    this.listenTo(this.model, "_beforeChanges", () => {
      this.view._disableRendering(!0);
    }, {
      priority: "highest"
    }), this.listenTo(this.model, "_afterChanges", () => {
      this.view._disableRendering(!1);
    }, {
      priority: "lowest"
    }), this.listenTo(r, "change", () => {
      this.view.change((a) => {
        this.downcastDispatcher.convertChanges(r.differ, o, a), this.downcastDispatcher.convertSelection(s, o, a);
      });
    }, {
      priority: "low"
    }), this.listenTo(this.view.document, "selectionChange", MN(this.model, this.mapper)), this.listenTo(this.view.document, "beforeinput", e6(this.mapper, this.model.schema, this.view), {
      priority: "high"
    }), this.downcastDispatcher.on("insert:$text", lT(), {
      priority: "lowest"
    }), this.downcastDispatcher.on("insert", cT(), {
      priority: "lowest"
    }), this.downcastDispatcher.on("remove", iN(), {
      priority: "low"
    }), this.downcastDispatcher.on("cleanSelection", oN()), this.downcastDispatcher.on("selection", rN(), {
      priority: "low"
    }), this.downcastDispatcher.on("selection", sN(), {
      priority: "low"
    }), this.view.document.roots.bindTo(this.model.document.roots).using((a) => {
      if (a.rootName == "$graveyard")
        return null;
      const u = new zE(this.view.document, a.name);
      return u.rootName = a.rootName, this.mapper.bindElements(a, u), u;
    });
  }
  /**
  * Removes all event listeners attached to the `EditingController`. Destroys all objects created
  * by `EditingController` that need to be destroyed.
  */
  destroy() {
    this.view.destroy(), this.stopListening();
  }
  /**
  * Calling this method will refresh the marker by triggering the downcast conversion for it.
  *
  * Reconverting the marker is useful when you want to change its {@link module:engine/view/element~Element view element}
  * without changing any marker data. For instance:
  *
  * ```ts
  * let isCommentActive = false;
  *
  * model.conversion.markerToHighlight( {
  * 	model: 'comment',
  * 	view: data => {
  * 		const classes = [ 'comment-marker' ];
  *
  * 		if ( isCommentActive ) {
  * 			classes.push( 'comment-marker--active' );
  * 		}
  *
  * 		return { classes };
  * 	}
  * } );
  *
  * // ...
  *
  * // Change the property that indicates if marker is displayed as active or not.
  * isCommentActive = true;
  *
  * // Reconverting will downcast and synchronize the marker with the new isCommentActive state value.
  * editor.editing.reconvertMarker( 'comment' );
  * ```
  *
  * **Note**: If you want to reconvert a model item, use {@link #reconvertItem} instead.
  *
  * @param markerOrName Name of a marker to update, or a marker instance.
  */
  reconvertMarker(t) {
    const i = typeof t == "string" ? t : t.name, r = this.model.markers.get(i);
    if (!r)
      throw new v("editingcontroller-reconvertmarker-marker-not-exist", this, {
        markerName: i
      });
    this.model.change(() => {
      this.model.markers._refresh(r);
    });
  }
  /**
  * Calling this method will downcast a model item on demand (by requesting a refresh in the {@link module:engine/model/differ~Differ}).
  *
  * You can use it if you want the view representation of a specific item updated as a response to external modifications. For instance,
  * when the view structure depends not only on the associated model data but also on some external state.
  *
  * **Note**: If you want to reconvert a model marker, use {@link #reconvertMarker} instead.
  *
  * @param item Item to refresh.
  */
  reconvertItem(t) {
    this.model.change(() => {
      this.model.document.differ._refreshItem(t);
    });
  }
}
function e6(e, n, t) {
  return (i, r) => {
    if (!(t.document.isComposing && !he.isAndroid))
      for (let s = 0; s < r.targetRanges.length; s++) {
        const o = r.targetRanges[s], a = e.toModelRange(o), u = AT(a, n);
        !u || u.isEqual(a) || (r.targetRanges[s] = e.toViewRange(u));
      }
  };
}
let t6 = class extends (/* @__PURE__ */ pt()) {
  /**
  * Creates a schema instance.
  */
  constructor() {
    super();
    m(this, "_sourceDefinitions", {});
    /**
    * A dictionary containing attribute properties.
    */
    m(this, "_attributeProperties", /* @__PURE__ */ Object.create(null));
    /**
    * Stores additional callbacks registered for schema items, which are evaluated when {@link ~Schema#checkChild} is called.
    *
    * Keys are schema item names for which the callbacks are registered. Values are arrays with the callbacks.
    *
    * Some checks are added under {@link ~Schema#_genericCheckSymbol} key, these are evaluated for every {@link ~Schema#checkChild} call.
    */
    m(this, "_customChildChecks", /* @__PURE__ */ new Map());
    /**
    * Stores additional callbacks registered for attribute names, which are evaluated when {@link ~Schema#checkAttribute} is called.
    *
    * Keys are schema attribute names for which the callbacks are registered. Values are arrays with the callbacks.
    *
    * Some checks are added under {@link ~Schema#_genericCheckSymbol} key, these are evaluated for every
    * {@link ~Schema#checkAttribute} call.
    */
    m(this, "_customAttributeChecks", /* @__PURE__ */ new Map());
    m(this, "_genericCheckSymbol", Symbol("$generic"));
    m(this, "_compiledDefinitions");
    this.decorate("checkChild"), this.decorate("checkAttribute"), this.on("checkAttribute", (t, i) => {
      i[0] = new br(i[0]);
    }, {
      priority: "highest"
    }), this.on("checkChild", (t, i) => {
      i[0] = new br(i[0]), i[1] = this.getDefinition(i[1]);
    }, {
      priority: "highest"
    });
  }
  /**
  * Registers a schema item. Can only be called once for every item name.
  *
  * ```ts
  * schema.register( 'paragraph', {
  * 	inheritAllFrom: '$block'
  * } );
  * ```
  */
  register(t, i) {
    if (this._sourceDefinitions[t])
      throw new v("schema-cannot-register-item-twice", this, {
        itemName: t
      });
    this._sourceDefinitions[t] = [
      Object.assign({}, i)
    ], this._clearCache();
  }
  /**
  * Extends a {@link #register registered} item's definition.
  *
  * Extending properties such as `allowIn` will add more items to the existing properties,
  * while redefining properties such as `isBlock` will override the previously defined ones.
  *
  * ```ts
  * schema.register( 'foo', {
  * 	allowIn: '$root',
  * 	isBlock: true;
  * } );
  * schema.extend( 'foo', {
  * 	allowIn: 'blockQuote',
  * 	isBlock: false
  * } );
  *
  * schema.getDefinition( 'foo' );
  * //	{
  * //		allowIn: [ '$root', 'blockQuote' ],
  * // 		isBlock: false
  * //	}
  * ```
  */
  extend(t, i) {
    if (!this._sourceDefinitions[t])
      throw new v("schema-cannot-extend-missing-item", this, {
        itemName: t
      });
    this._sourceDefinitions[t].push(Object.assign({}, i)), this._clearCache();
  }
  /**
  * Returns data of all registered items.
  *
  * This method should normally be used for reflection purposes (e.g. defining a clone of a certain element,
  * checking a list of all block elements, etc).
  * Use specific methods (such as {@link #checkChild `checkChild()`} or {@link #isLimit `isLimit()`})
  * in other cases.
  */
  getDefinitions() {
    return this._compiledDefinitions || this._compile(), this._compiledDefinitions;
  }
  /**
  * Returns a definition of the given item or `undefined` if an item is not registered.
  *
  * This method should normally be used for reflection purposes (e.g. defining a clone of a certain element,
  * checking a list of all block elements, etc).
  * Use specific methods (such as {@link #checkChild `checkChild()`} or {@link #isLimit `isLimit()`})
  * in other cases.
  */
  getDefinition(t) {
    let i;
    return typeof t == "string" ? i = t : "is" in t && (t.is("$text") || t.is("$textProxy")) ? i = "$text" : i = t.name, this.getDefinitions()[i];
  }
  /**
  * Returns `true` if the given item is registered in the schema.
  *
  * ```ts
  * schema.isRegistered( 'paragraph' ); // -> true
  * schema.isRegistered( editor.model.document.getRoot() ); // -> true
  * schema.isRegistered( 'foo' ); // -> false
  * ```
  */
  isRegistered(t) {
    return !!this.getDefinition(t);
  }
  /**
  * Returns `true` if the given item is defined to be
  * a block by the {@link module:engine/model/schema~SchemaItemDefinition}'s `isBlock` property.
  *
  * ```ts
  * schema.isBlock( 'paragraph' ); // -> true
  * schema.isBlock( '$root' ); // -> false
  *
  * const paragraphElement = writer.createElement( 'paragraph' );
  * schema.isBlock( paragraphElement ); // -> true
  * ```
  *
  * See the {@glink framework/deep-dive/schema#block-elements Block elements} section of
  * the {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
  */
  isBlock(t) {
    const i = this.getDefinition(t);
    return !!(i && i.isBlock);
  }
  /**
  * Returns `true` if the given item should be treated as a limit element.
  *
  * It considers an item to be a limit element if its
  * {@link module:engine/model/schema~SchemaItemDefinition}'s
  * {@link module:engine/model/schema~SchemaItemDefinition#isLimit `isLimit`} or
  * {@link module:engine/model/schema~SchemaItemDefinition#isObject `isObject`} property
  * was set to `true`.
  *
  * ```ts
  * schema.isLimit( 'paragraph' ); // -> false
  * schema.isLimit( '$root' ); // -> true
  * schema.isLimit( editor.model.document.getRoot() ); // -> true
  * schema.isLimit( 'imageBlock' ); // -> true
  * ```
  *
  * See the {@glink framework/deep-dive/schema#limit-elements Limit elements} section of
  * the {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
  */
  isLimit(t) {
    const i = this.getDefinition(t);
    return i ? !!(i.isLimit || i.isObject) : !1;
  }
  /**
  * Returns `true` if the given item should be treated as an object element.
  *
  * It considers an item to be an object element if its
  * {@link module:engine/model/schema~SchemaItemDefinition}'s
  * {@link module:engine/model/schema~SchemaItemDefinition#isObject `isObject`} property
  * was set to `true`.
  *
  * ```ts
  * schema.isObject( 'paragraph' ); // -> false
  * schema.isObject( 'imageBlock' ); // -> true
  *
  * const imageElement = writer.createElement( 'imageBlock' );
  * schema.isObject( imageElement ); // -> true
  * ```
  *
  * See the {@glink framework/deep-dive/schema#object-elements Object elements} section of
  * the {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
  */
  isObject(t) {
    const i = this.getDefinition(t);
    return i ? !!(i.isObject || i.isLimit && i.isSelectable && i.isContent) : !1;
  }
  /**
  * Returns `true` if the given item is defined to be
  * an inline element by the {@link module:engine/model/schema~SchemaItemDefinition}'s `isInline` property.
  *
  * ```ts
  * schema.isInline( 'paragraph' ); // -> false
  * schema.isInline( 'softBreak' ); // -> true
  *
  * const text = writer.createText( 'foo' );
  * schema.isInline( text ); // -> true
  * ```
  *
  * See the {@glink framework/deep-dive/schema#inline-elements Inline elements} section of
  * the {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
  */
  isInline(t) {
    const i = this.getDefinition(t);
    return !!(i && i.isInline);
  }
  /**
  * Returns `true` if the given item is defined to be
  * a selectable element by the {@link module:engine/model/schema~SchemaItemDefinition}'s `isSelectable` property.
  *
  * ```ts
  * schema.isSelectable( 'paragraph' ); // -> false
  * schema.isSelectable( 'heading1' ); // -> false
  * schema.isSelectable( 'imageBlock' ); // -> true
  * schema.isSelectable( 'tableCell' ); // -> true
  *
  * const text = writer.createText( 'foo' );
  * schema.isSelectable( text ); // -> false
  * ```
  *
  * See the {@glink framework/deep-dive/schema#selectable-elements Selectable elements section} of
  * the {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
  */
  isSelectable(t) {
    const i = this.getDefinition(t);
    return i ? !!(i.isSelectable || i.isObject) : !1;
  }
  /**
  * Returns `true` if the given item is defined to be
  * a content by the {@link module:engine/model/schema~SchemaItemDefinition}'s `isContent` property.
  *
  * ```ts
  * schema.isContent( 'paragraph' ); // -> false
  * schema.isContent( 'heading1' ); // -> false
  * schema.isContent( 'imageBlock' ); // -> true
  * schema.isContent( 'horizontalLine' ); // -> true
  *
  * const text = writer.createText( 'foo' );
  * schema.isContent( text ); // -> true
  * ```
  *
  * See the {@glink framework/deep-dive/schema#content-elements Content elements section} of
  * the {@glink framework/deep-dive/schema Schema deep-dive} guide for more details.
  */
  isContent(t) {
    const i = this.getDefinition(t);
    return i ? !!(i.isContent || i.isObject) : !1;
  }
  /**
  * Checks whether the given node can be a child of the given context.
  *
  * ```ts
  * schema.checkChild( model.document.getRoot(), paragraph ); // -> false
  *
  * schema.register( 'paragraph', {
  * 	allowIn: '$root'
  * } );
  *
  * schema.checkChild( model.document.getRoot(), paragraph ); // -> true
  * ```
  *
  * Both {@link module:engine/model/schema~Schema#addChildCheck callback checks} and declarative rules (added when
  * {@link module:engine/model/schema~Schema#register registering} and {@link module:engine/model/schema~Schema#extend extending} items)
  * are evaluated when this method is called.
  *
  * Note that callback checks have bigger priority than declarative rules checks and may overwrite them.
  *
  * Note that when verifying whether the given node can be a child of the given context, the schema also verifies the entire
  * context &ndash; from its root to its last element. Therefore, it is possible for `checkChild()` to return `false` even though
  * the `context` last element can contain the checked child. It happens if one of the `context` elements does not allow its child.
  * When `context` is verified, {@link module:engine/model/schema~Schema#addChildCheck custom checks} are considered as well.
  *
  * @fires checkChild
  * @param context The context in which the child will be checked.
  * @param def The child to check.
  */
  checkChild(t, i) {
    return i ? this._checkContextMatch(t, i) : !1;
  }
  /**
  * Checks whether the given attribute can be applied in the given context (on the last item of the context).
  *
  * ```ts
  * schema.checkAttribute( textNode, 'bold' ); // -> false
  *
  * schema.extend( '$text', {
  * 	allowAttributes: 'bold'
  * } );
  *
  * schema.checkAttribute( textNode, 'bold' ); // -> true
  * ```
  *
  * Both {@link module:engine/model/schema~Schema#addAttributeCheck callback checks} and declarative rules (added when
  * {@link module:engine/model/schema~Schema#register registering} and {@link module:engine/model/schema~Schema#extend extending} items)
  * are evaluated when this method is called.
  *
  * Note that callback checks have bigger priority than declarative rules checks and may overwrite them.
  *
  * @fires checkAttribute
  * @param context The context in which the attribute will be checked.
  * @param attributeName Name of attribute to check in the given context.
  */
  checkAttribute(t, i) {
    const r = this.getDefinition(t.last);
    if (!r)
      return !1;
    const s = this._evaluateAttributeChecks(t, i);
    return s !== void 0 ? s : r.allowAttributes.includes(i);
  }
  /**
  * Checks whether the given element (`elementToMerge`) can be merged with the specified base element (`positionOrBaseElement`).
  *
  * In other words &ndash; both elements are not a limit elements and whether `elementToMerge`'s children
  * {@link #checkChild are allowed} in the `positionOrBaseElement`.
  *
  * This check ensures that elements merged with {@link module:engine/model/writer~Writer#merge `Writer#merge()`}
  * will be valid.
  *
  * Instead of elements, you can pass the instance of the {@link module:engine/model/position~Position} class as the
  * `positionOrBaseElement`. It means that the elements before and after the position will be checked whether they can be merged.
  *
  * @param positionOrBaseElement The position or base element to which the `elementToMerge` will be merged.
  * @param elementToMerge The element to merge. Required if `positionOrBaseElement` is an element.
  */
  checkMerge(t, i) {
    if (t instanceof z) {
      const r = t.nodeBefore, s = t.nodeAfter;
      if (!(r instanceof rt))
        throw new v("schema-check-merge-no-element-before", this);
      if (!(s instanceof rt))
        throw new v("schema-check-merge-no-element-after", this);
      return this.checkMerge(r, s);
    }
    if (this.isLimit(t) || this.isLimit(i))
      return !1;
    for (const r of i.getChildren())
      if (!this.checkChild(t, r))
        return !1;
    return !0;
  }
  /**
  * Allows registering a callback to the {@link #checkChild} method calls.
  *
  * Callbacks allow you to implement rules which are not otherwise possible to achieve
  * by using the declarative API of {@link module:engine/model/schema~SchemaItemDefinition}.
  *
  * Note that callback checks have bigger priority than declarative rules checks and may overwrite them.
  *
  * For example, by using this method you can disallow elements in specific contexts:
  *
  * ```ts
  * // Disallow `heading1` inside a `blockQuote` that is inside a table.
  * schema.addChildCheck( ( context, childDefinition ) => {
  * 	if ( context.endsWith( 'tableCell blockQuote' ) ) {
  * 		return false;
  * 	}
  * }, 'heading1' );
  * ```
  *
  * You can skip the optional `itemName` parameter to evaluate the callback for every `checkChild()` call.
  *
  * ```ts
  * // Inside specific custom element, allow only children, which allows for a specific attribute.
  * schema.addChildCheck( ( context, childDefinition ) => {
  * 	if ( context.endsWith( 'myElement' ) ) {
  * 		return childDefinition.allowAttributes.includes( 'myAttribute' );
  * 	}
  * } );
  * ```
  *
  * Please note that the generic callbacks may affect the editor performance and should be avoided if possible.
  *
  * When one of the callbacks makes a decision (returns `true` or `false`) the processing is finished and other callbacks are not fired.
  * Callbacks are fired in the order they were added, however generic callbacks are fired before callbacks added for a specified item.
  *
  * You can also use `checkChild` event, if you need even better control. The result from the example above could also be
  * achieved with following event callback:
  *
  * ```ts
  * schema.on( 'checkChild', ( evt, args ) => {
  * 	const context = args[ 0 ];
  * 	const childDefinition = args[ 1 ];
  *
  * 	if ( context.endsWith( 'myElement' ) ) {
  * 		// Prevent next listeners from being called.
  * 		evt.stop();
  * 		// Set the `checkChild()` return value.
  * 		evt.return = childDefinition.allowAttributes.includes( 'myAttribute' );
  * 	}
  * }, { priority: 'high' } );
  * ```
  *
  * Note that the callback checks and declarative rules checks are processed on `normal` priority.
  *
  * Adding callbacks this way can also negatively impact editor performance.
  *
  * @param callback The callback to be called. It is called with two parameters:
  * {@link module:engine/model/schema~SchemaContext} (context) instance and
  * {@link module:engine/model/schema~SchemaCompiledItemDefinition} (definition). The callback may return `true/false` to override
  * `checkChild()`'s return value. If it does not return a boolean value, the default algorithm (or other callbacks) will define
  * `checkChild()`'s return value.
  * @param itemName Name of the schema item for which the callback is registered. If specified, the callback will be run only for
  * `checkChild()` calls which `def` parameter matches the `itemName`. Otherwise, the callback will run for every `checkChild` call.
  */
  addChildCheck(t, i) {
    const r = i !== void 0 ? i : this._genericCheckSymbol, s = this._customChildChecks.get(r) || [];
    s.push(t), this._customChildChecks.set(r, s);
  }
  /**
  * Allows registering a callback to the {@link #checkAttribute} method calls.
  *
  * Callbacks allow you to implement rules which are not otherwise possible to achieve
  * by using the declarative API of {@link module:engine/model/schema~SchemaItemDefinition}.
  *
  * Note that callback checks have bigger priority than declarative rules checks and may overwrite them.
  *
  * For example, by using this method you can disallow setting attributes on nodes in specific contexts:
  *
  * ```ts
  * // Disallow setting `bold` on text inside `heading1` element:
  * schema.addAttributeCheck( context => {
  * 	if ( context.endsWith( 'heading1 $text' ) ) {
  * 		return false;
  * 	}
  * }, 'bold' );
  * ```
  *
  * You can skip the optional `attributeName` parameter to evaluate the callback for every `checkAttribute()` call.
  *
  * ```ts
  * // Disallow formatting attributes on text inside custom `myTitle` element:
  * schema.addAttributeCheck( ( context, attributeName ) => {
  * 	if ( context.endsWith( 'myTitle $text' ) && schema.getAttributeProperties( attributeName ).isFormatting ) {
  * 		return false;
  * 	}
  * } );
  * ```
  *
  * Please note that the generic callbacks may affect the editor performance and should be avoided if possible.
  *
  * When one of the callbacks makes a decision (returns `true` or `false`) the processing is finished and other callbacks are not fired.
  * Callbacks are fired in the order they were added, however generic callbacks are fired before callbacks added for a specified item.
  *
  * You can also use {@link #event:checkAttribute} event, if you need even better control. The result from the example above could also
  * be achieved with following event callback:
  *
  * ```ts
  * schema.on( 'checkAttribute', ( evt, args ) => {
  * 	const context = args[ 0 ];
  * 	const attributeName = args[ 1 ];
  *
  * 	if ( context.endsWith( 'myTitle $text' ) && schema.getAttributeProperties( attributeName ).isFormatting ) {
  * 		// Prevent next listeners from being called.
  * 		evt.stop();
  * 		// Set the `checkAttribute()` return value.
  * 		evt.return = false;
  * 	}
  * }, { priority: 'high' } );
  * ```
  *
  * Note that the callback checks and declarative rules checks are processed on `normal` priority.
  *
  * Adding callbacks this way can also negatively impact editor performance.
  *
  * @param callback The callback to be called. It is called with two parameters:
  * {@link module:engine/model/schema~SchemaContext `context`} and attribute name. The callback may return `true` or `false`, to
  * override `checkAttribute()`'s return value. If it does not return a boolean value, the default algorithm (or other callbacks)
  * will define `checkAttribute()`'s return value.
  * @param attributeName Name of the attribute for which the callback is registered. If specified, the callback will be run only for
  * `checkAttribute()` calls with matching `attributeName`. Otherwise, the callback will run for every `checkAttribute()` call.
  */
  addAttributeCheck(t, i) {
    const r = i !== void 0 ? i : this._genericCheckSymbol, s = this._customAttributeChecks.get(r) || [];
    s.push(t), this._customAttributeChecks.set(r, s);
  }
  /**
  * This method allows assigning additional metadata to the model attributes. For example,
  * {@link module:engine/model/schema~AttributeProperties `AttributeProperties#isFormatting` property} is
  * used to mark formatting attributes (like `bold` or `italic`).
  *
  * ```ts
  * // Mark bold as a formatting attribute.
  * schema.setAttributeProperties( 'bold', {
  * 	isFormatting: true
  * } );
  *
  * // Override code not to be considered a formatting markup.
  * schema.setAttributeProperties( 'code', {
  * 	isFormatting: false
  * } );
  * ```
  *
  * Properties are not limited to members defined in the
  * {@link module:engine/model/schema~AttributeProperties `AttributeProperties` type} and you can also use custom properties:
  *
  * ```ts
  * schema.setAttributeProperties( 'blockQuote', {
  * 	customProperty: 'value'
  * } );
  * ```
  *
  * Subsequent calls with the same attribute will extend its custom properties:
  *
  * ```ts
  * schema.setAttributeProperties( 'blockQuote', {
  * 	one: 1
  * } );
  *
  * schema.setAttributeProperties( 'blockQuote', {
  * 	two: 2
  * } );
  *
  * console.log( schema.getAttributeProperties( 'blockQuote' ) );
  * // Logs: { one: 1, two: 2 }
  * ```
  *
  * @param attributeName A name of the attribute to receive the properties.
  * @param properties A dictionary of properties.
  */
  setAttributeProperties(t, i) {
    this._attributeProperties[t] = Object.assign(this.getAttributeProperties(t), i);
  }
  /**
  * Returns properties associated with a given model attribute. See {@link #setAttributeProperties `setAttributeProperties()`}.
  *
  * @param attributeName A name of the attribute.
  */
  getAttributeProperties(t) {
    return this._attributeProperties[t] || /* @__PURE__ */ Object.create(null);
  }
  /**
  * Returns the lowest {@link module:engine/model/schema~Schema#isLimit limit element} containing the entire
  * selection/range/position or the root otherwise.
  *
  * @param selectionOrRangeOrPosition The selection/range/position to check.
  * @returns The lowest limit element containing the entire `selectionOrRangeOrPosition`.
  */
  getLimitElement(t) {
    let i;
    for (t instanceof z ? i = t.parent : i = (t instanceof B ? [
      t
    ] : Array.from(t.getRanges())).reduce((s, o) => {
      const a = o.getCommonAncestor();
      return s ? s.getCommonAncestor(a, {
        includeSelf: !0
      }) : a;
    }, null); !this.isLimit(i) && i.parent; )
      i = i.parent;
    return i;
  }
  /**
  * Checks whether the attribute is allowed in selection:
  *
  * * if the selection is not collapsed, then checks if the attribute is allowed on any of nodes in that range,
  * * if the selection is collapsed, then checks if on the selection position there's a text with the
  * specified attribute allowed.
  *
  * @param selection Selection which will be checked.
  * @param attribute The name of the attribute to check.
  */
  checkAttributeInSelection(t, i) {
    if (t.isCollapsed) {
      const s = [
        ...t.getFirstPosition().getAncestors(),
        new st("", t.getAttributes())
      ];
      return this.checkAttribute(s, i);
    } else {
      const r = t.getRanges();
      for (const s of r)
        for (const o of s)
          if (this.checkAttribute(o.item, i))
            return !0;
    }
    return !1;
  }
  /**
  * Transforms the given set of ranges into a set of ranges where the given attribute is allowed (and can be applied).
  *
  * @param ranges Ranges to be validated.
  * @param attribute The name of the attribute to check.
  * @returns Ranges in which the attribute is allowed.
  */
  *getValidRanges(t, i) {
    t = b6(t);
    for (const r of t)
      yield* this._getValidRangesForRange(r, i);
  }
  /**
  * Basing on given `position`, finds and returns a {@link module:engine/model/range~Range range} which is
  * nearest to that `position` and is a correct range for selection.
  *
  * The correct selection range might be collapsed when it is located in a position where the text node can be placed.
  * Non-collapsed range is returned when selection can be placed around element marked as an "object" in
  * the {@link module:engine/model/schema~Schema schema}.
  *
  * Direction of searching for the nearest correct selection range can be specified as:
  *
  * * `both` - searching will be performed in both ways,
  * * `forward` - searching will be performed only forward,
  * * `backward` - searching will be performed only backward.
  *
  * When valid selection range cannot be found, `null` is returned.
  *
  * @param position Reference position where new selection range should be looked for.
  * @param direction Search direction.
  * @returns Nearest selection range or `null` if one cannot be found.
  */
  getNearestSelectionRange(t, i = "both") {
    if (t.root.rootName == "$graveyard")
      return null;
    if (this.checkChild(t, "$text"))
      return new B(t);
    let r, s;
    const o = t.getAncestors().reverse().find((a) => this.isLimit(a)) || t.root;
    (i == "both" || i == "backward") && (r = new Ui({
      boundaries: B._createIn(o),
      startPosition: t,
      direction: "backward"
    })), (i == "both" || i == "forward") && (s = new Ui({
      boundaries: B._createIn(o),
      startPosition: t
    }));
    for (const a of g6(r, s)) {
      const u = a.walker == r ? "elementEnd" : "elementStart", l = a.value;
      if (l.type == u && this.isObject(l.item))
        return B._createOn(l.item);
      if (this.checkChild(l.nextPosition, "$text"))
        return new B(l.nextPosition);
    }
    return null;
  }
  /**
  * Tries to find position ancestors that allow to insert a given node.
  * It starts searching from the given position and goes node by node to the top of the model tree
  * as long as a {@link module:engine/model/schema~Schema#isLimit limit element}, an
  * {@link module:engine/model/schema~Schema#isObject object element} or a topmost ancestor is not reached.
  *
  * @param position The position that the search will start from.
  * @param node The node for which an allowed parent should be found or its name.
  * @returns Allowed parent or null if nothing was found.
  */
  findAllowedParent(t, i) {
    let r = t.parent;
    for (; r; ) {
      if (this.checkChild(r, i))
        return r;
      if (this.isLimit(r))
        return null;
      r = r.parent;
    }
    return null;
  }
  /**
  * Sets attributes allowed by the schema on a given node.
  *
  * @param node A node to set attributes on.
  * @param attributes Attributes keys and values.
  * @param writer An instance of the model writer.
  */
  setAllowedAttributes(t, i, r) {
    const s = r.model;
    for (const [o, a] of Object.entries(i))
      s.schema.checkAttribute(t, o) && r.setAttribute(o, a, t);
  }
  /**
  * Removes attributes disallowed by the schema.
  *
  * @param nodes Nodes that will be filtered.
  */
  removeDisallowedAttributes(t, i) {
    for (const r of t)
      if (r.is("$text"))
        Mp(this, r, i);
      else {
        const o = B._createIn(r).getPositions();
        for (const a of o) {
          const u = a.nodeBefore || a.parent;
          Mp(this, u, i);
        }
      }
  }
  /**
  * Gets attributes of a node that have a given property.
  *
  * @param node Node to get attributes from.
  * @param propertyName Name of the property that attribute must have to return it.
  * @param propertyValue Desired value of the property that we want to check.
  * When `undefined` attributes will be returned if they have set a given property no matter what the value is. If specified it will
  * return attributes which given property's value is equal to this parameter.
  * @returns Object with attributes' names as key and attributes' values as value.
  */
  getAttributesWithProperty(t, i, r) {
    const s = {};
    for (const [o, a] of t.getAttributes()) {
      const u = this.getAttributeProperties(o);
      u[i] !== void 0 && (r === void 0 || r === u[i]) && (s[o] = a);
    }
    return s;
  }
  /**
  * Creates an instance of the schema context.
  */
  createContext(t) {
    return new br(t);
  }
  _clearCache() {
    this._compiledDefinitions = null;
  }
  _compile() {
    const t = {}, i = this._sourceDefinitions, r = Object.keys(i);
    for (const o of r)
      t[o] = n6(i[o], o);
    const s = Object.values(t);
    for (const o of s)
      i6(t, o), r6(t, o), s6(t, o), o6(t, o);
    for (const o of s)
      a6(t, o);
    for (const o of s)
      u6(t, o);
    for (const o of s)
      l6(t, o);
    for (const o of s)
      d6(t, o);
    for (const o of s)
      h6(t, o);
    this._compiledDefinitions = c6(t);
  }
  _checkContextMatch(t, i) {
    const r = t.last;
    let s = this._evaluateChildChecks(t, i);
    if (s = s !== void 0 ? s : i.allowIn.includes(r.name), !s)
      return !1;
    const o = this.getDefinition(r), a = t.trimLast();
    return o ? a.length == 0 ? !0 : this._checkContextMatch(a, o) : !1;
  }
  /**
  * Calls child check callbacks to decide whether `def` is allowed in `context`. It uses both generic and specific (defined for `def`
  * item) callbacks. If neither callback makes a decision, `undefined` is returned.
  *
  * Note that the first callback that makes a decision "wins", i.e., if any callback returns `true` or `false`, then the processing
  * is over and that result is returned.
  */
  _evaluateChildChecks(t, i) {
    const r = this._customChildChecks.get(this._genericCheckSymbol) || [], s = this._customChildChecks.get(i.name) || [];
    for (const o of [
      ...r,
      ...s
    ]) {
      const a = o(t, i);
      if (a !== void 0)
        return a;
    }
  }
  /**
  * Calls attribute check callbacks to decide whether `attributeName` can be set on the last element of `context`. It uses both
  * generic and specific (defined for `attributeName`) callbacks. If neither callback makes a decision, `undefined` is returned.
  *
  * Note that the first callback that makes a decision "wins", i.e., if any callback returns `true` or `false`, then the processing
  * is over and that result is returned.
  */
  _evaluateAttributeChecks(t, i) {
    const r = this._customAttributeChecks.get(this._genericCheckSymbol) || [], s = this._customAttributeChecks.get(i) || [];
    for (const o of [
      ...r,
      ...s
    ]) {
      const a = o(t, i);
      if (a !== void 0)
        return a;
    }
  }
  /**
  * Takes a flat range and an attribute name. Traverses the range recursively and deeply to find and return all ranges
  * inside the given range on which the attribute can be applied.
  *
  * This is a helper function for {@link ~Schema#getValidRanges}.
  *
  * @param range The range to process.
  * @param attribute The name of the attribute to check.
  * @returns Ranges in which the attribute is allowed.
  */
  *_getValidRangesForRange(t, i) {
    let r = t.start, s = t.start;
    for (const o of t.getItems({
      shallow: !0
    }))
      o.is("element") && (yield* this._getValidRangesForRange(B._createIn(o), i)), this.checkAttribute(o, i) || (r.isEqual(s) || (yield new B(r, s)), r = z._createAfter(o)), s = z._createAfter(o);
    r.isEqual(s) || (yield new B(r, s));
  }
  /**
  * Returns a model range which is optimal (in terms of UX) for inserting a widget block.
  *
  * For instance, if a selection is in the middle of a paragraph, the collapsed range before this paragraph
  * will be returned so that it is not split. If the selection is at the end of a paragraph,
  * the collapsed range after this paragraph will be returned.
  *
  * Note: If the selection is placed in an empty block, the range in that block will be returned. If that range
  * is then passed to {@link module:engine/model/model~Model#insertContent}, the block will be fully replaced
  * by the inserted widget block.
  *
  * @internal
  * @param selection The selection based on which the insertion position should be calculated.
  * @param place The place where to look for optimal insertion range.
  * The `auto` value will determine itself the best position for insertion.
  * The `before` value will try to find a position before selection.
  * The `after` value will try to find a position after selection.
  * @returns The optimal range.
  */
  findOptimalInsertionRange(t, i) {
    const r = t.getSelectedElement();
    if (r && this.isObject(r) && !this.isInline(r))
      return i == "before" || i == "after" ? new B(z._createAt(r, i)) : B._createOn(r);
    const s = zn(t.getSelectedBlocks());
    if (!s)
      return new B(t.focus);
    if (s.isEmpty)
      return new B(z._createAt(s, 0));
    const o = z._createAfter(s);
    return t.focus.isTouching(o) ? new B(o) : new B(z._createBefore(s));
  }
};
class br {
  /**
  * Creates an instance of the context.
  */
  constructor(n) {
    m(this, "_items");
    if (n instanceof br)
      return n;
    let t;
    typeof n == "string" ? t = [
      n
    ] : Array.isArray(n) ? t = n : t = n.getAncestors({
      includeSelf: !0
    }), this._items = t.map(p6);
  }
  /**
  * The number of items.
  */
  get length() {
    return this._items.length;
  }
  /**
  * The last item (the lowest node).
  */
  get last() {
    return this._items[this._items.length - 1];
  }
  /**
  * Iterable interface.
  *
  * Iterates over all context items.
  */
  [Symbol.iterator]() {
    return this._items[Symbol.iterator]();
  }
  /**
  * Returns a new schema context instance with an additional item.
  *
  * Item can be added as:
  *
  * ```ts
  * const context = new SchemaContext( [ '$root' ] );
  *
  * // An element.
  * const fooElement = writer.createElement( 'fooElement' );
  * const newContext = context.push( fooElement ); // [ '$root', 'fooElement' ]
  *
  * // A text node.
  * const text = writer.createText( 'foobar' );
  * const newContext = context.push( text ); // [ '$root', '$text' ]
  *
  * // A string (element name).
  * const newContext = context.push( 'barElement' ); // [ '$root', 'barElement' ]
  * ```
  *
  * **Note** {@link module:engine/model/node~Node} that is already in the model tree will be added as the only item
  * (without ancestors).
  *
  * @param item An item that will be added to the current context.
  * @returns A new schema context instance with an additional item.
  */
  push(n) {
    const t = new br([
      n
    ]);
    return t._items = [
      ...this._items,
      ...t._items
    ], t;
  }
  /**
  * Returns a new schema context that is based on this context but has the last item removed.
  *
  * ```ts
  * const ctxParagraph = new SchemaContext( [ '$root', 'blockQuote', 'paragraph' ] );
  * const ctxBlockQuote = ctxParagraph.trimLast(); // Items in `ctxBlockQuote` are: `$root` an `blockQuote`.
  * const ctxRoot = ctxBlockQuote.trimLast(); // Items in `ctxRoot` are: `$root`.
  * ```
  *
  * @returns A new reduced schema context instance.
  */
  trimLast() {
    const n = new br([]);
    return n._items = this._items.slice(0, -1), n;
  }
  /**
  * Gets an item on the given index.
  */
  getItem(n) {
    return this._items[n];
  }
  /**
  * Returns the names of items.
  */
  *getNames() {
    yield* this._items.map((n) => n.name);
  }
  /**
  * Checks whether the context ends with the given nodes.
  *
  * ```ts
  * const ctx = new SchemaContext( [ rootElement, paragraphElement, textNode ] );
  *
  * ctx.endsWith( '$text' ); // -> true
  * ctx.endsWith( 'paragraph $text' ); // -> true
  * ctx.endsWith( '$root' ); // -> false
  * ctx.endsWith( 'paragraph' ); // -> false
  * ```
  */
  endsWith(n) {
    return Array.from(this.getNames()).join(" ").endsWith(n);
  }
  /**
  * Checks whether the context starts with the given nodes.
  *
  * ```ts
  * const ctx = new SchemaContext( [ rootElement, paragraphElement, textNode ] );
  *
  * ctx.endsWith( '$root' ); // -> true
  * ctx.endsWith( '$root paragraph' ); // -> true
  * ctx.endsWith( '$text' ); // -> false
  * ctx.endsWith( 'paragraph' ); // -> false
  * ```
  */
  startsWith(n) {
    return Array.from(this.getNames()).join(" ").startsWith(n);
  }
}
function n6(e, n) {
  const t = {
    name: n,
    allowIn: /* @__PURE__ */ new Set(),
    allowChildren: /* @__PURE__ */ new Set(),
    disallowIn: /* @__PURE__ */ new Set(),
    disallowChildren: /* @__PURE__ */ new Set(),
    allowContentOf: /* @__PURE__ */ new Set(),
    allowWhere: /* @__PURE__ */ new Set(),
    allowAttributes: /* @__PURE__ */ new Set(),
    disallowAttributes: /* @__PURE__ */ new Set(),
    allowAttributesOf: /* @__PURE__ */ new Set(),
    inheritTypesFrom: /* @__PURE__ */ new Set()
  };
  return f6(e, t), mi(e, t, "allowIn"), mi(e, t, "allowChildren"), mi(e, t, "disallowIn"), mi(e, t, "disallowChildren"), mi(e, t, "allowContentOf"), mi(e, t, "allowWhere"), mi(e, t, "allowAttributes"), mi(e, t, "disallowAttributes"), mi(e, t, "allowAttributesOf"), mi(e, t, "inheritTypesFrom"), m6(e, t), t;
}
function i6(e, n) {
  for (const t of n.allowIn) {
    const i = e[t];
    i ? i.allowChildren.add(n.name) : n.allowIn.delete(t);
  }
}
function r6(e, n) {
  for (const t of n.allowChildren) {
    const i = e[t];
    i ? i.allowIn.add(n.name) : n.allowChildren.delete(t);
  }
}
function s6(e, n) {
  for (const t of n.disallowIn) {
    const i = e[t];
    i ? i.disallowChildren.add(n.name) : n.disallowIn.delete(t);
  }
}
function o6(e, n) {
  for (const t of n.disallowChildren) {
    const i = e[t];
    i ? i.disallowIn.add(n.name) : n.disallowChildren.delete(t);
  }
}
function a6(e, n) {
  for (const t of n.disallowChildren)
    n.allowChildren.delete(t);
  for (const t of n.disallowIn)
    n.allowIn.delete(t);
  for (const t of n.disallowAttributes)
    n.allowAttributes.delete(t);
}
function u6(e, n) {
  for (const t of n.allowContentOf) {
    const i = e[t];
    i && (i.disallowChildren.forEach((r) => {
      n.allowChildren.has(r) || (n.disallowChildren.add(r), e[r].disallowIn.add(n.name));
    }), i.allowChildren.forEach((r) => {
      n.disallowChildren.has(r) || (n.allowChildren.add(r), e[r].allowIn.add(n.name));
    }));
  }
}
function l6(e, n) {
  for (const t of n.allowWhere) {
    const i = e[t];
    i && (i.disallowIn.forEach((r) => {
      n.allowIn.has(r) || (n.disallowIn.add(r), e[r].disallowChildren.add(n.name));
    }), i.allowIn.forEach((r) => {
      n.disallowIn.has(r) || (n.allowIn.add(r), e[r].allowChildren.add(n.name));
    }));
  }
}
function c6(e) {
  const n = {};
  for (const t of Object.values(e))
    n[t.name] = {
      name: t.name,
      // `is*` properties may not be set - convert `undefined` to `false`.
      isBlock: !!t.isBlock,
      isContent: !!t.isContent,
      isInline: !!t.isInline,
      isLimit: !!t.isLimit,
      isObject: !!t.isObject,
      isSelectable: !!t.isSelectable,
      // Filter out non-existing items.
      allowIn: Array.from(t.allowIn).filter((i) => !!e[i]),
      allowChildren: Array.from(t.allowChildren).filter((i) => !!e[i]),
      allowAttributes: Array.from(t.allowAttributes)
    };
  return n;
}
function d6(e, n) {
  for (const t of n.allowAttributesOf) {
    const i = e[t];
    if (!i)
      return;
    i.allowAttributes.forEach((r) => {
      n.disallowAttributes.has(r) || n.allowAttributes.add(r);
    });
  }
}
function h6(e, n) {
  for (const t of n.inheritTypesFrom) {
    const i = e[t];
    if (i) {
      const r = Object.keys(i).filter((s) => s.startsWith("is"));
      for (const s of r)
        s in n || (n[s] = i[s]);
    }
  }
}
function f6(e, n) {
  for (const t of e) {
    const i = Object.keys(t).filter((r) => r.startsWith("is"));
    for (const r of i)
      n[r] = !!t[r];
  }
}
function mi(e, n, t) {
  for (const i of e) {
    let r = i[t];
    typeof r == "string" && (r = [
      r
    ]), Array.isArray(r) && r.forEach((s) => n[t].add(s));
  }
}
function m6(e, n) {
  for (const t of e) {
    const i = t.inheritAllFrom;
    i && (n.allowContentOf.add(i), n.allowWhere.add(i), n.allowAttributesOf.add(i), n.inheritTypesFrom.add(i));
  }
}
function p6(e) {
  return typeof e == "string" || e.is("documentFragment") ? {
    name: typeof e == "string" ? e : "$documentFragment",
    *getAttributeKeys() {
    },
    getAttribute() {
    }
  } : {
    // '$text' means text nodes and text proxies.
    name: e.is("element") ? e.name : "$text",
    *getAttributeKeys() {
      yield* e.getAttributeKeys();
    },
    getAttribute(n) {
      return e.getAttribute(n);
    }
  };
}
function* g6(e, n) {
  let t = !1;
  for (; !t; ) {
    if (t = !0, e) {
      const i = e.next();
      i.done || (t = !1, yield {
        walker: e,
        value: i.value
      });
    }
    if (n) {
      const i = n.next();
      i.done || (t = !1, yield {
        walker: n,
        value: i.value
      });
    }
  }
}
function* b6(e) {
  for (const n of e)
    yield* n.getMinimalFlatRanges();
}
function Mp(e, n, t) {
  for (const i of n.getAttributeKeys())
    e.checkAttribute(n, i) || t.removeAttribute(i, n);
}
class _6 extends (/* @__PURE__ */ Je()) {
  /**
  * Creates an upcast dispatcher that operates using the passed API.
  *
  * @see module:engine/conversion/upcastdispatcher~UpcastConversionApi
  * @param conversionApi Additional properties for an interface that will be passed to events fired
  * by the upcast dispatcher.
  */
  constructor(t) {
    super();
    /**
    * An interface passed by the dispatcher to the event callbacks.
    */
    m(this, "conversionApi");
    /**
    * The list of elements that were created during splitting.
    *
    * After the conversion process, the list is cleared.
    */
    m(this, "_splitParts", /* @__PURE__ */ new Map());
    /**
    * The list of cursor parent elements that were created during splitting.
    *
    * After the conversion process the list is cleared.
    */
    m(this, "_cursorParents", /* @__PURE__ */ new Map());
    /**
    * The position in the temporary structure where the converted content is inserted. The structure reflects the context of
    * the target position where the content will be inserted. This property is built based on the context parameter of the
    * convert method.
    */
    m(this, "_modelCursor", null);
    /**
    * The list of elements that were created during the splitting but should not get removed on conversion end even if they are empty.
    *
    * The list is cleared after the conversion process.
    */
    m(this, "_emptyElementsToKeep", /* @__PURE__ */ new Set());
    this.conversionApi = {
      ...t,
      consumable: null,
      writer: null,
      store: null,
      convertItem: (i, r) => this._convertItem(i, r),
      convertChildren: (i, r) => this._convertChildren(i, r),
      safeInsert: (i, r) => this._safeInsert(i, r),
      updateConversionResult: (i, r) => this._updateConversionResult(i, r),
      // Advanced API - use only if custom position handling is needed.
      splitToAllowedParent: (i, r) => this._splitToAllowedParent(i, r),
      getSplitParts: (i) => this._getSplitParts(i),
      keepEmptyElement: (i) => this._keepEmptyElement(i)
    };
  }
  /**
  * Starts the conversion process. The entry point for the conversion.
  *
  * @fires element
  * @fires text
  * @fires documentFragment
  * @param viewElement The part of the view to be converted.
  * @param writer An instance of the model writer.
  * @param context Elements will be converted according to this context.
  * @returns Model data that is the result of the conversion process
  * wrapped in `DocumentFragment`. Converted marker elements will be set as the document fragment's
  * {@link module:engine/model/documentfragment~DocumentFragment#markers static markers map}.
  */
  convert(t, i, r = [
    "$root"
  ]) {
    this.fire("viewCleanup", t), this._modelCursor = T6(r, i), this.conversionApi.writer = i, this.conversionApi.consumable = _l.createFrom(t), this.conversionApi.store = {};
    const { modelRange: s } = this._convertItem(t, this._modelCursor), o = i.createDocumentFragment();
    if (s) {
      this._removeEmptyElements();
      const a = this._modelCursor.parent, u = a._removeChildren(0, a.childCount);
      o._insertChild(0, u), o.markers = E6(o, i);
    }
    return this._modelCursor = null, this._splitParts.clear(), this._cursorParents.clear(), this._emptyElementsToKeep.clear(), this.conversionApi.writer = null, this.conversionApi.store = null, o;
  }
  /**
  * @see module:engine/conversion/upcastdispatcher~UpcastConversionApi#convertItem
  */
  _convertItem(t, i) {
    const r = {
      viewItem: t,
      modelCursor: i,
      modelRange: null
    };
    if (t.is("element") ? this.fire(`element:${t.name}`, r, this.conversionApi) : t.is("$text") ? this.fire("text", r, this.conversionApi) : this.fire("documentFragment", r, this.conversionApi), r.modelRange && !(r.modelRange instanceof B))
      throw new v("view-conversion-dispatcher-incorrect-result", this);
    return {
      modelRange: r.modelRange,
      modelCursor: r.modelCursor
    };
  }
  /**
  * @see module:engine/conversion/upcastdispatcher~UpcastConversionApi#convertChildren
  */
  _convertChildren(t, i) {
    let r = i.is("position") ? i : z._createAt(i, 0);
    const s = new B(r);
    for (const o of Array.from(t.getChildren())) {
      const a = this._convertItem(o, r);
      a.modelRange instanceof B && (s.end = a.modelRange.end, r = a.modelCursor);
    }
    return {
      modelRange: s,
      modelCursor: r
    };
  }
  /**
  * @see module:engine/conversion/upcastdispatcher~UpcastConversionApi#safeInsert
  */
  _safeInsert(t, i) {
    const r = this._splitToAllowedParent(t, i);
    return r ? (this.conversionApi.writer.insert(t, r.position), !0) : !1;
  }
  /**
  * @see module:engine/conversion/upcastdispatcher~UpcastConversionApi#updateConversionResult
  */
  _updateConversionResult(t, i) {
    const r = this._getSplitParts(t), s = this.conversionApi.writer;
    i.modelRange || (i.modelRange = s.createRange(s.createPositionBefore(t), s.createPositionAfter(r[r.length - 1])));
    const o = this._cursorParents.get(t);
    o ? i.modelCursor = s.createPositionAt(o, 0) : i.modelCursor = i.modelRange.end;
  }
  /**
  * @see module:engine/conversion/upcastdispatcher~UpcastConversionApi#splitToAllowedParent
  */
  _splitToAllowedParent(t, i) {
    const { schema: r, writer: s } = this.conversionApi;
    let o = r.findAllowedParent(i, t);
    if (o) {
      if (o === i.parent)
        return {
          position: i
        };
      this._modelCursor.parent.getAncestors().includes(o) && (o = null);
    }
    if (!o)
      return _T(i, t, r) ? {
        position: ET(i, s)
      } : null;
    const a = this.conversionApi.writer.split(i, o), u = [];
    for (const c of a.range.getWalker())
      if (c.type == "elementEnd")
        u.push(c.item);
      else {
        const d = u.pop(), p = c.item;
        this._registerSplitPair(d, p);
      }
    const l = a.range.end.parent;
    return this._cursorParents.set(t, l), {
      position: a.position,
      cursorParent: l
    };
  }
  /**
  * Registers that a `splitPart` element is a split part of the `originalPart` element.
  *
  * The data set by this method is used by {@link #_getSplitParts} and {@link #_removeEmptyElements}.
  */
  _registerSplitPair(t, i) {
    this._splitParts.has(t) || this._splitParts.set(t, [
      t
    ]);
    const r = this._splitParts.get(t);
    this._splitParts.set(i, r), r.push(i);
  }
  /**
  * @see module:engine/conversion/upcastdispatcher~UpcastConversionApi#getSplitParts
  */
  _getSplitParts(t) {
    let i;
    return this._splitParts.has(t) ? i = this._splitParts.get(t) : i = [
      t
    ], i;
  }
  /**
  * Mark an element that were created during the splitting to not get removed on conversion end even if it is empty.
  */
  _keepEmptyElement(t) {
    this._emptyElementsToKeep.add(t);
  }
  /**
  * Checks if there are any empty elements created while splitting and removes them.
  *
  * This method works recursively to re-check empty elements again after at least one element was removed in the initial call,
  * as some elements might have become empty after other empty elements were removed from them.
  */
  _removeEmptyElements() {
    const t = /* @__PURE__ */ new Map();
    for (const i of this._splitParts.keys())
      if (i.isEmpty && !this._emptyElementsToKeep.has(i)) {
        const r = t.get(i.parent) || [];
        r.push(i), this._splitParts.delete(i), t.set(i.parent, r);
      }
    for (const [i, r] of t)
      i._removeChildrenArray(r);
    t.size && this._removeEmptyElements();
  }
}
function E6(e, n) {
  const t = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Map(), r = B._createIn(e).getItems();
  for (const s of r)
    s.is("element", "$marker") && t.add(s);
  for (const s of t) {
    const o = s.getAttribute("data-name"), a = n.createPositionBefore(s);
    i.has(o) ? i.get(o).end = a.clone() : i.set(o, new B(a.clone())), n.remove(s);
  }
  return i;
}
function T6(e, n) {
  let t;
  for (const i of new br(e)) {
    const r = {};
    for (const o of i.getAttributeKeys())
      r[o] = i.getAttribute(o);
    const s = n.createElement(i.name, r);
    t && n.insert(s, t), t = z._createAt(s, 0);
  }
  return t;
}
class y6 {
  /**
  * Returns an HTML string created from the document fragment.
  */
  getHtml(n) {
    const i = ue.document.implementation.createHTMLDocument("").createElement("div");
    return i.appendChild(n), i.innerHTML;
  }
}
class CT {
  /**
  * Creates a new instance of the HTML data processor class.
  *
  * @param document The view document instance.
  */
  constructor(n) {
    /**
    * A DOM parser instance used to parse an HTML string to an HTML document.
    */
    m(this, "domParser");
    /**
    * A DOM converter used to convert DOM elements to view elements.
    */
    m(this, "domConverter");
    /**
    * A basic HTML writer instance used to convert DOM elements to an HTML string.
    */
    m(this, "htmlWriter");
    m(this, "skipComments", !0);
    this.domParser = new DOMParser(), this.domConverter = new ZE(n, {
      renderingMode: "data"
    }), this.htmlWriter = new y6();
  }
  /**
  * Converts a provided {@link module:engine/view/documentfragment~DocumentFragment document fragment}
  * to data format &ndash; in this case to an HTML string.
  *
  * @returns HTML string.
  */
  toData(n) {
    const t = this.domConverter.viewToDom(n);
    return this.htmlWriter.getHtml(t);
  }
  /**
  * Converts the provided HTML string to a view tree.
  *
  * @param data An HTML string.
  * @returns A converted view element.
  */
  toView(n) {
    const t = this._toDom(n);
    return this.domConverter.domToView(t, {
      skipComments: this.skipComments
    });
  }
  /**
  * Registers a {@link module:engine/view/matcher~MatcherPattern} for view elements whose content should be treated as raw data
  * and not processed during the conversion from the DOM to the view elements.
  *
  * The raw data can be later accessed by a
  * {@link module:engine/view/element~Element#getCustomProperty custom property of a view element} called `"$rawContent"`.
  *
  * @param pattern Pattern matching all view elements whose content should be treated as raw data.
  */
  registerRawContentMatcher(n) {
    this.domConverter.registerRawContentMatcher(n);
  }
  /**
  * If the processor is set to use marked fillers, it will insert `&nbsp;` fillers wrapped in `<span>` elements
  * (`<span data-cke-filler="true">&nbsp;</span>`) instead of regular `&nbsp;` characters.
  *
  * This mode allows for a more precise handling of the block fillers (so they do not leak into the editor content) but
  * bloats the editor data with additional markup.
  *
  * This mode may be required by some features and will be turned on by them automatically.
  *
  * @param type Whether to use the default or the marked `&nbsp;` block fillers.
  */
  useFillerType(n) {
    this.domConverter.blockFillerMode = n == "marked" ? "markedNbsp" : "nbsp";
  }
  /**
  * Converts an HTML string to its DOM representation. Returns a document fragment containing nodes parsed from
  * the provided data.
  */
  _toDom(n) {
    /<(?:html|body|head|meta)(?:\s[^>]*)?>/i.test(n.trim().slice(0, 1e4)) || (n = `<body>${n}</body>`);
    const t = this.domParser.parseFromString(n, "text/html"), i = t.createDocumentFragment(), r = t.body.childNodes;
    for (; r.length > 0; )
      i.appendChild(r[0]);
    return i;
  }
}
class w6 extends (/* @__PURE__ */ Je()) {
  /**
  * Creates a data controller instance.
  *
  * @param model Data model.
  * @param stylesProcessor The styles processor instance.
  */
  constructor(t, i) {
    super();
    /**
    * Data model.
    */
    m(this, "model");
    /**
    * Mapper used for the conversion. It has no permanent bindings, because these are created while getting data and
    * are cleared directly after the data are converted. However, the mapper is defined as a class property, because
    * it needs to be passed to the `DowncastDispatcher` as a conversion API.
    */
    m(this, "mapper");
    /**
    * Downcast dispatcher used by the {@link #get get method}. Downcast converters should be attached to it.
    */
    m(this, "downcastDispatcher");
    /**
    * Upcast dispatcher used by the {@link #set set method}. Upcast converters should be attached to it.
    */
    m(this, "upcastDispatcher");
    /**
    * The view document used by the data controller.
    */
    m(this, "viewDocument");
    /**
    * Styles processor used during the conversion.
    */
    m(this, "stylesProcessor");
    /**
    * Data processor used specifically for HTML conversion.
    */
    m(this, "htmlProcessor");
    /**
    * Data processor used during the conversion.
    * Same instance as {@link #htmlProcessor} by default. Can be replaced at run time to handle different format, e.g. XML or Markdown.
    */
    m(this, "processor");
    /**
    * The view downcast writer just for data conversion purposes, i.e. to modify
    * the {@link #viewDocument}.
    */
    m(this, "_viewWriter");
    this.model = t, this.mapper = new sT(), this.downcastDispatcher = new oT({
      mapper: this.mapper,
      schema: t.schema
    }), this.downcastDispatcher.on("insert:$text", lT(), {
      priority: "lowest"
    }), this.downcastDispatcher.on("insert", cT(), {
      priority: "lowest"
    }), this.upcastDispatcher = new _6({
      schema: t.schema
    }), this.viewDocument = new jE(i), this.stylesProcessor = i, this.htmlProcessor = new CT(this.viewDocument), this.processor = this.htmlProcessor, this._viewWriter = new KE(this.viewDocument), this.upcastDispatcher.on("text", DN(), {
      priority: "lowest"
    }), this.upcastDispatcher.on("element", Np(), {
      priority: "lowest"
    }), this.upcastDispatcher.on("documentFragment", Np(), {
      priority: "lowest"
    }), pt().prototype.decorate.call(this, "init"), pt().prototype.decorate.call(this, "set"), pt().prototype.decorate.call(this, "get"), pt().prototype.decorate.call(this, "toView"), pt().prototype.decorate.call(this, "toModel"), this.on("init", () => {
      this.fire("ready");
    }, {
      priority: "lowest"
    }), this.on("ready", () => {
      this.model.enqueueChange({
        isUndoable: !1
      }, bT);
    }, {
      priority: "lowest"
    });
  }
  /**
  * Returns the model's data converted by downcast dispatchers attached to {@link #downcastDispatcher} and
  * formatted by the {@link #processor data processor}.
  *
  * A warning is logged when you try to retrieve data for a detached root, as most probably this is a mistake. A detached root should
  * be treated like it is removed, and you should not save its data. Note, that the detached root data is always an empty string.
  *
  * @fires get
  * @param options Additional configuration for the retrieved data. `DataController` provides two optional
  * properties: `rootName` and `trim`. Other properties of this object are specified by various editor features.
  * @param options.rootName Root name. Default 'main'.
  * @param options.trim Whether returned data should be trimmed. This option is set to `empty` by default,
  * which means whenever editor content is considered empty, an empty string will be returned. To turn off trimming completely
  * use `'none'`. In such cases the exact content will be returned (for example a `<p>&nbsp;</p>` for an empty editor).
  * @returns Output data.
  */
  get(t = {}) {
    const { rootName: i = "main", trim: r = "empty" } = t;
    if (!this._checkIfRootsExists([
      i
    ]))
      throw new v("datacontroller-get-non-existent-root", this);
    const s = this.model.document.getRoot(i);
    return s.isAttached() || at("datacontroller-get-detached-root", this), r === "empty" && !this.model.hasContent(s, {
      ignoreWhitespaces: !0
    }) ? "" : this.stringify(s, t);
  }
  /**
  * Returns the content of the given {@link module:engine/model/element~Element model's element} or
  * {@link module:engine/model/documentfragment~DocumentFragment model document fragment} converted by the downcast converters
  * attached to the {@link #downcastDispatcher} and formatted by the {@link #processor data processor}.
  *
  * @param modelElementOrFragment The element whose content will be stringified.
  * @param options Additional configuration passed to the conversion process.
  * @returns Output data.
  */
  stringify(t, i = {}) {
    const r = this.toView(t, i);
    return this.processor.toData(r);
  }
  /**
  * Returns the content of the given {@link module:engine/model/element~Element model element} or
  * {@link module:engine/model/documentfragment~DocumentFragment model document fragment} converted by the downcast
  * converters attached to {@link #downcastDispatcher} into a
  * {@link module:engine/view/documentfragment~DocumentFragment view document fragment}.
  *
  * @fires toView
  * @param modelElementOrFragment Element or document fragment whose content will be converted.
  * @param options Additional configuration that will be available through the
  * {@link module:engine/conversion/downcastdispatcher~DowncastConversionApi#options} during the conversion process.
  * @returns Output view DocumentFragment.
  */
  toView(t, i = {}) {
    const r = this.viewDocument, s = this._viewWriter;
    this.mapper.clearBindings();
    const o = B._createIn(t), a = new qs(r);
    this.mapper.bindElements(t, a);
    const u = t.is("documentFragment") ? t.markers : A6(t);
    return this.downcastDispatcher.convert(o, u, s, i), a;
  }
  /**
  * Sets the initial input data parsed by the {@link #processor data processor} and
  * converted by the {@link #upcastDispatcher view-to-model converters}.
  * Initial data can be only set to a document whose {@link module:engine/model/document~Document#version} is equal 0.
  *
  * **Note** This method is {@link module:utils/observablemixin~Observable#decorate decorated} which is
  * used by e.g. collaborative editing plugin that syncs remote data on init.
  *
  * When data is passed as a string, it is initialized on the default `main` root:
  *
  * ```ts
  * dataController.init( '<p>Foo</p>' ); // Initializes data on the `main` root only, as no other is specified.
  * ```
  *
  * To initialize data on a different root or multiple roots at once, an object containing `rootName` - `data` pairs should be passed:
  *
  * ```ts
  * dataController.init( { main: '<p>Foo</p>', title: '<h1>Bar</h1>' } ); // Initializes data on both the `main` and `title` roots.
  * ```
  *
  * @fires init
  * @param data Input data as a string or an object containing the `rootName` - `data`
  * pairs to initialize data on multiple roots at once.
  * @returns Promise that is resolved after the data is set on the editor.
  */
  init(t) {
    if (this.model.document.version)
      throw new v("datacontroller-init-document-not-empty", this);
    let i = {};
    if (typeof t == "string" ? i.main = t : i = t, !this._checkIfRootsExists(Object.keys(i)))
      throw new v("datacontroller-init-non-existent-root", this);
    return this.model.enqueueChange({
      isUndoable: !1
    }, (r) => {
      for (const s of Object.keys(i)) {
        const o = this.model.document.getRoot(s);
        r.insert(this.parse(i[s], o), o, 0);
      }
    }), Promise.resolve();
  }
  /**
  * Sets the input data parsed by the {@link #processor data processor} and
  * converted by the {@link #upcastDispatcher view-to-model converters}.
  * This method can be used any time to replace existing editor data with the new one without clearing the
  * {@link module:engine/model/document~Document#history document history}.
  *
  * This method also creates a batch with all the changes applied. If all you need is to parse data, use
  * the {@link #parse} method.
  *
  * When data is passed as a string it is set on the default `main` root:
  *
  * ```ts
  * dataController.set( '<p>Foo</p>' ); // Sets data on the `main` root, as no other is specified.
  * ```
  *
  * To set data on a different root or multiple roots at once, an object containing `rootName` - `data` pairs should be passed:
  *
  * ```ts
  * dataController.set( { main: '<p>Foo</p>', title: '<h1>Bar</h1>' } ); // Sets data on the `main` and `title` roots as specified.
  * ```
  *
  * To set the data with a preserved undo stack and add the change to the undo stack, set `{ isUndoable: true }` as a `batchType` option.
  *
  * ```ts
  * dataController.set( '<p>Foo</p>', { batchType: { isUndoable: true } } );
  * ```
  *
  * @fires set
  * @param data Input data as a string or an object containing the `rootName` - `data`
  * pairs to set data on multiple roots at once.
  * @param options Options for setting data.
  * @param options.batchType The batch type that will be used to create a batch for the changes applied by this method.
  * By default, the batch will be set as {@link module:engine/model/batch~Batch#isUndoable not undoable} and the undo stack will be
  * cleared after the new data is applied (all undo steps will be removed). If the batch type `isUndoable` flag is be set to `true`,
  * the undo stack will be preserved instead and not cleared when new data is applied.
  */
  set(t, i = {}) {
    let r = {};
    if (typeof t == "string" ? r.main = t : r = t, !this._checkIfRootsExists(Object.keys(r)))
      throw new v("datacontroller-set-non-existent-root", this);
    this.model.enqueueChange(i.batchType || {}, (s) => {
      s.setSelection(null), s.removeSelectionAttribute(this.model.document.selection.getAttributeKeys());
      for (const o of Object.keys(r)) {
        const a = this.model.document.getRoot(o);
        s.remove(s.createRangeIn(a)), s.insert(this.parse(r[o], a), a, 0);
      }
    });
  }
  /**
  * Returns the data parsed by the {@link #processor data processor} and then converted by upcast converters
  * attached to the {@link #upcastDispatcher}.
  *
  * @see #set
  * @param data Data to parse.
  * @param context Base context in which the view will be converted to the model.
  * See: {@link module:engine/conversion/upcastdispatcher~UpcastDispatcher#convert}.
  * @returns Parsed data.
  */
  parse(t, i = "$root") {
    const r = this.processor.toView(t);
    return this.toModel(r, i);
  }
  /**
  * Returns the result of the given {@link module:engine/view/element~Element view element} or
  * {@link module:engine/view/documentfragment~DocumentFragment view document fragment} converted by the
  * {@link #upcastDispatcher view-to-model converters}, wrapped by {@link module:engine/model/documentfragment~DocumentFragment}.
  *
  * When marker elements were converted during the conversion process, it will be set as a document fragment's
  * {@link module:engine/model/documentfragment~DocumentFragment#markers static markers map}.
  *
  * @fires toModel
  * @param viewElementOrFragment The element or document fragment whose content will be converted.
  * @param context Base context in which the view will be converted to the model.
  * See: {@link module:engine/conversion/upcastdispatcher~UpcastDispatcher#convert}.
  * @returns Output document fragment.
  */
  toModel(t, i = "$root") {
    return this.model.change((r) => this.upcastDispatcher.convert(t, r, i));
  }
  /**
  * Adds the style processor normalization rules.
  *
  * You can implement your own rules as well as use one of the available processor rules:
  *
  * * background: {@link module:engine/view/styles/background~addBackgroundRules}
  * * border: {@link module:engine/view/styles/border~addBorderRules}
  * * margin: {@link module:engine/view/styles/margin~addMarginRules}
  * * padding: {@link module:engine/view/styles/padding~addPaddingRules}
  */
  addStyleProcessorRules(t) {
    t(this.stylesProcessor);
  }
  /**
  * Registers a {@link module:engine/view/matcher~MatcherPattern} on an {@link #htmlProcessor htmlProcessor}
  * and a {@link #processor processor} for view elements whose content should be treated as raw data
  * and not processed during the conversion from DOM to view elements.
  *
  * The raw data can be later accessed by the {@link module:engine/view/element~Element#getCustomProperty view element custom property}
  * `"$rawContent"`.
  *
  * @param pattern Pattern matching all view elements whose content should be treated as a raw data.
  */
  registerRawContentMatcher(t) {
    this.processor && this.processor !== this.htmlProcessor && this.processor.registerRawContentMatcher(t), this.htmlProcessor.registerRawContentMatcher(t);
  }
  /**
  * Removes all event listeners set by the DataController.
  */
  destroy() {
    this.stopListening();
  }
  /**
  * Checks whether all provided root names are actually existing editor roots.
  *
  * @param rootNames Root names to check.
  * @returns Whether all provided root names are existing editor roots.
  */
  _checkIfRootsExists(t) {
    for (const i of t)
      if (!this.model.document.getRoot(i))
        return !1;
    return !0;
  }
}
function A6(e) {
  const n = [], t = e.root.document;
  if (!t)
    return /* @__PURE__ */ new Map();
  const i = B._createIn(e);
  for (const r of t.model.markers) {
    const s = r.getRange(), o = s.isCollapsed, a = s.start.isEqual(i.start) || s.end.isEqual(i.end);
    if (o && a)
      n.push([
        r.name,
        s
      ]);
    else {
      const u = i.getIntersection(s);
      u && n.push([
        r.name,
        u
      ]);
    }
  }
  return n.sort(([r, s], [o, a]) => {
    if (s.end.compareWith(a.start) !== "after")
      return 1;
    if (s.start.compareWith(a.end) !== "before")
      return -1;
    switch (s.start.compareWith(a.start)) {
      case "before":
        return 1;
      case "after":
        return -1;
      default:
        switch (s.end.compareWith(a.end)) {
          case "before":
            return 1;
          case "after":
            return -1;
          default:
            return o.localeCompare(r);
        }
    }
  }), new Map(n);
}
class C6 {
  /**
  * Creates a new conversion instance.
  */
  constructor(n, t) {
    /**
    * Maps dispatchers group name to ConversionHelpers instances.
    */
    m(this, "_helpers", /* @__PURE__ */ new Map());
    m(this, "_downcast");
    m(this, "_upcast");
    this._downcast = Dt(n), this._createConversionHelpers({
      name: "downcast",
      dispatchers: this._downcast,
      isDowncast: !0
    }), this._upcast = Dt(t), this._createConversionHelpers({
      name: "upcast",
      dispatchers: this._upcast,
      isDowncast: !1
    });
  }
  /**
  * Define an alias for registered dispatcher.
  *
  * ```ts
  * const conversion = new Conversion(
  * 	[ dataDowncastDispatcher, editingDowncastDispatcher ],
  * 	upcastDispatcher
  * );
  *
  * conversion.addAlias( 'dataDowncast', dataDowncastDispatcher );
  * ```
  *
  * @param alias An alias of a dispatcher.
  * @param dispatcher Dispatcher which should have an alias.
  */
  addAlias(n, t) {
    const i = this._downcast.includes(t);
    if (!this._upcast.includes(t) && !i)
      throw new v("conversion-add-alias-dispatcher-not-registered", this);
    this._createConversionHelpers({
      name: n,
      dispatchers: [
        t
      ],
      isDowncast: i
    });
  }
  /**
  * Provides a chainable API to assign converters to a conversion dispatchers group.
  *
  * If the given group name has not been registered, the
  * {@link module:utils/ckeditorerror~CKEditorError `conversion-for-unknown-group` error} is thrown.
  *
  * You can use conversion helpers available directly in the `for()` chain or your custom ones via
  * the {@link module:engine/conversion/conversionhelpers~ConversionHelpers#add `add()`} method.
  *
  * # Using built-in conversion helpers
  *
  * The `for()` chain comes with a set of conversion helpers which you can use like this:
  *
  * ```ts
  * editor.conversion.for( 'downcast' )
  * 	.elementToElement( config1 )        // Adds an element-to-element downcast converter.
  * 	.attributeToElement( config2 );     // Adds an attribute-to-element downcast converter.
  *
  * editor.conversion.for( 'upcast' )
  * 	.elementToAttribute( config3 );     // Adds an element-to-attribute upcast converter.
  * ```
  *
  * Refer to the documentation of built-in conversion helpers to learn about their configuration options.
  *
  * * downcast (model-to-view) conversion helpers:
  *
  *	* {@link module:engine/conversion/downcasthelpers~DowncastHelpers#elementToElement `elementToElement()`},
  *	* {@link module:engine/conversion/downcasthelpers~DowncastHelpers#attributeToElement `attributeToElement()`},
  *	* {@link module:engine/conversion/downcasthelpers~DowncastHelpers#attributeToAttribute `attributeToAttribute()`}.
  *	* {@link module:engine/conversion/downcasthelpers~DowncastHelpers#markerToElement `markerToElement()`}.
  *	* {@link module:engine/conversion/downcasthelpers~DowncastHelpers#markerToHighlight `markerToHighlight()`}.
  *
  * * upcast (view-to-model) conversion helpers:
  *
  *	* {@link module:engine/conversion/upcasthelpers~UpcastHelpers#elementToElement `elementToElement()`},
  *	* {@link module:engine/conversion/upcasthelpers~UpcastHelpers#elementToAttribute `elementToAttribute()`},
  *	* {@link module:engine/conversion/upcasthelpers~UpcastHelpers#attributeToAttribute `attributeToAttribute()`}.
  *	* {@link module:engine/conversion/upcasthelpers~UpcastHelpers#elementToMarker `elementToMarker()`}.
  *
  * # Using custom conversion helpers
  *
  * If you need to implement an atypical converter, you can do so by calling:
  *
  * ```ts
  * editor.conversion.for( direction ).add( customHelper );
  * ```
  *
  * The `.add()` method takes exactly one parameter, which is a function. This function should accept one parameter that
  * is a dispatcher instance. The function should add an actual converter to the passed dispatcher instance.
  *
  * Example:
  *
  * ```ts
  * editor.conversion.for( 'upcast' ).add( dispatcher => {
  * 	dispatcher.on( 'element:a',  ( evt, data, conversionApi ) => {
  * 		// Do something with a view <a> element.
  * 	} );
  * } );
  * ```
  *
  * Refer to the documentation of {@link module:engine/conversion/upcastdispatcher~UpcastDispatcher}
  * and {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher} to learn how to write
  * custom converters.
  *
  * @param groupName The name of dispatchers group to add the converters to.
  */
  for(n) {
    if (!this._helpers.has(n))
      throw new v("conversion-for-unknown-group", this);
    return this._helpers.get(n);
  }
  /**
  * Sets up converters between the model and the view that convert a model element to a view element (and vice versa).
  * For example, the model `<paragraph>Foo</paragraph>` is turned into `<p>Foo</p>` in the view.
  *
  * ```ts
  * // A simple conversion from the `paragraph` model element to the `<p>` view element (and vice versa).
  * editor.conversion.elementToElement( { model: 'paragraph', view: 'p' } );
  *
  * // Override other converters by specifying a converter definition with a higher priority.
  * editor.conversion.elementToElement( { model: 'paragraph', view: 'div', converterPriority: 'high' } );
  *
  * // View specified as an object instead of a string.
  * editor.conversion.elementToElement( {
  * 	model: 'fancyParagraph',
  * 	view: {
  * 		name: 'p',
  * 		classes: 'fancy'
  * 	}
  * } );
  *
  * // Use `upcastAlso` to define other view elements that should also be converted to a `paragraph` element.
  * editor.conversion.elementToElement( {
  * 	model: 'paragraph',
  * 	view: 'p',
  * 	upcastAlso: [
  * 		'div',
  * 		{
  * 			// Any element with the `display: block` style.
  * 			styles: {
  * 				display: 'block'
  * 			}
  * 		}
  * 	]
  * } );
  *
  * // `upcastAlso` set as callback enables a conversion of a wide range of different view elements.
  * editor.conversion.elementToElement( {
  * 	model: 'heading',
  * 	view: 'h2',
  * 	// Convert "heading-like" paragraphs to headings.
  * 	upcastAlso: viewElement => {
  * 		const fontSize = viewElement.getStyle( 'font-size' );
  *
  * 		if ( !fontSize ) {
  * 			return null;
  * 		}
  *
  * 		const match = fontSize.match( /(\d+)\s*px/ );
  *
  * 		if ( !match ) {
  * 			return null;
  * 		}
  *
  * 		const size = Number( match[ 1 ] );
  *
  * 		if ( size > 26 ) {
  * 			// Returned value can be an object with the matched properties.
  * 			// These properties will be "consumed" during the conversion.
  * 			// See `engine.view.Matcher~MatcherPattern` and `engine.view.Matcher#match` for more details.
  *
  * 			return { name: true, styles: [ 'font-size' ] };
  * 		}
  *
  * 		return null;
  * 	}
  * } );
  * ```
  *
  * `definition.model` is a `String` with a model element name to convert from or to.
  *
  * @param definition The converter definition.
  */
  elementToElement(n) {
    this.for("downcast").elementToElement(n);
    for (const { model: t, view: i } of hd(n))
      this.for("upcast").elementToElement({
        model: t,
        view: i,
        converterPriority: n.converterPriority
      });
  }
  /**
  * Sets up converters between the model and the view that convert a model attribute to a view element (and vice versa).
  * For example, a model text node with `"Foo"` as data and the `bold` attribute will be turned to `<strong>Foo</strong>` in the view.
  *
  * ```ts
  * // A simple conversion from the `bold=true` attribute to the `<strong>` view element (and vice versa).
  * editor.conversion.attributeToElement( { model: 'bold', view: 'strong' } );
  *
  * // Override other converters by specifying a converter definition with a higher priority.
  * editor.conversion.attributeToElement( { model: 'bold', view: 'b', converterPriority: 'high' } );
  *
  * // View specified as an object instead of a string.
  * editor.conversion.attributeToElement( {
  * 	model: 'bold',
  * 	view: {
  * 		name: 'span',
  * 		classes: 'bold'
  * 	}
  * } );
  *
  * // Use `config.model.name` to define the conversion only from a given node type, `$text` in this case.
  * // The same attribute on different elements may then be handled by a different converter.
  * editor.conversion.attributeToElement( {
  * 	model: {
  * 		key: 'textDecoration',
  * 		values: [ 'underline', 'lineThrough' ],
  * 		name: '$text'
  * 	},
  * 	view: {
  * 		underline: {
  * 			name: 'span',
  * 			styles: {
  * 				'text-decoration': 'underline'
  * 			}
  * 		},
  * 		lineThrough: {
  * 			name: 'span',
  * 			styles: {
  * 				'text-decoration': 'line-through'
  * 			}
  * 		}
  * 	}
  * } );
  *
  * // Use `upcastAlso` to define other view elements that should also be converted to the `bold` attribute.
  * editor.conversion.attributeToElement( {
  * 	model: 'bold',
  * 	view: 'strong',
  * 	upcastAlso: [
  * 		'b',
  * 		{
  * 			name: 'span',
  * 			classes: 'bold'
  * 		},
  * 		{
  * 			name: 'span',
  * 			styles: {
  * 				'font-weight': 'bold'
  * 			}
  * 		},
  * 		viewElement => {
  * 			const fontWeight = viewElement.getStyle( 'font-weight' );
  *
  * 			if ( viewElement.is( 'element', 'span' ) && fontWeight && /\d+/.test() && Number( fontWeight ) > 500 ) {
  * 				// Returned value can be an object with the matched properties.
  * 				// These properties will be "consumed" during the conversion.
  * 				// See `engine.view.Matcher~MatcherPattern` and `engine.view.Matcher#match` for more details.
  *
  * 				return {
  * 					name: true,
  * 					styles: [ 'font-weight' ]
  * 				};
  * 			}
  * 		}
  * 	]
  * } );
  *
  * // Conversion from and to a model attribute key whose value is an enum (`fontSize=big|small`).
  * // `upcastAlso` set as callback enables a conversion of a wide range of different view elements.
  * editor.conversion.attributeToElement( {
  * 	model: {
  * 		key: 'fontSize',
  * 		values: [ 'big', 'small' ]
  * 	},
  * 	view: {
  * 		big: {
  * 			name: 'span',
  * 			styles: {
  * 				'font-size': '1.2em'
  * 			}
  * 		},
  * 		small: {
  * 			name: 'span',
  * 			styles: {
  * 				'font-size': '0.8em'
  * 			}
  * 		}
  * 	},
  * 	upcastAlso: {
  * 		big: viewElement => {
  * 			const fontSize = viewElement.getStyle( 'font-size' );
  *
  * 			if ( !fontSize ) {
  * 				return null;
  * 			}
  *
  * 			const match = fontSize.match( /(\d+)\s*px/ );
  *
  * 			if ( !match ) {
  * 				return null;
  * 			}
  *
  * 			const size = Number( match[ 1 ] );
  *
  * 			if ( viewElement.is( 'element', 'span' ) && size > 10 ) {
  * 				// Returned value can be an object with the matched properties.
  * 				// These properties will be "consumed" during the conversion.
  * 				// See `engine.view.Matcher~MatcherPattern` and `engine.view.Matcher#match` for more details.
  *
  * 				return { name: true, styles: [ 'font-size' ] };
  * 			}
  *
  * 			return null;
  * 		},
  * 		small: viewElement => {
  * 			const fontSize = viewElement.getStyle( 'font-size' );
  *
  * 			if ( !fontSize ) {
  * 				return null;
  * 			}
  *
  * 			const match = fontSize.match( /(\d+)\s*px/ );
  *
  * 			if ( !match ) {
  * 				return null;
  * 			}
  *
  * 			const size = Number( match[ 1 ] );
  *
  * 			if ( viewElement.is( 'element', 'span' ) && size < 10 ) {
  * 				// Returned value can be an object with the matched properties.
  * 				// These properties will be "consumed" during the conversion.
  * 				// See `engine.view.Matcher~MatcherPattern` and `engine.view.Matcher#match` for more details.
  *
  * 				return { name: true, styles: [ 'font-size' ] };
  * 			}
  *
  * 			return null;
  * 		}
  * 	}
  * } );
  * ```
  *
  * The `definition.model` parameter specifies which model attribute should be converted from or to. It can be a `{ key, value }` object
  * describing the attribute key and value to convert or a `String` specifying just the attribute key (in such a case
  * `value` is set to `true`).
  *
  * @param definition The converter definition.
  */
  attributeToElement(n) {
    this.for("downcast").attributeToElement(n);
    for (const { model: t, view: i } of hd(n))
      this.for("upcast").elementToAttribute({
        view: i,
        model: t,
        converterPriority: n.converterPriority
      });
  }
  /**
  * Sets up converters between the model and the view that convert a model attribute to a view attribute (and vice versa). For example,
  * `<imageBlock src='foo.jpg'></imageBlock>` is converted to `<img src='foo.jpg'></img>` (the same attribute key and value).
  * This type of converters is intended to be used with {@link module:engine/model/element~Element model element} nodes.
  * To convert the text attributes,
  * the {@link module:engine/conversion/conversion~Conversion#attributeToElement `attributeToElement converter`}should be set up.
  *
  * ```ts
  * // A simple conversion from the `source` model attribute to the `src` view attribute (and vice versa).
  * editor.conversion.attributeToAttribute( { model: 'source', view: 'src' } );
  *
  * // Attribute values are strictly specified.
  * editor.conversion.attributeToAttribute( {
  * 	model: {
  * 		name: 'imageInline',
  * 		key: 'aside',
  * 		values: [ 'aside' ]
  * 	},
  * 	view: {
  * 		aside: {
  * 			name: 'img',
  * 			key: 'class',
  * 			value: [ 'aside', 'half-size' ]
  * 		}
  * 	}
  * } );
  *
  * // Set the style attribute.
  * editor.conversion.attributeToAttribute( {
  * 	model: {
  * 		name: 'imageInline',
  * 		key: 'aside',
  * 		values: [ 'aside' ]
  * 	},
  * 	view: {
  * 		aside: {
  * 			name: 'img',
  * 			key: 'style',
  * 			value: {
  * 				float: 'right',
  * 				width: '50%',
  * 				margin: '5px'
  * 			}
  * 		}
  * 	}
  * } );
  *
  * // Conversion from and to a model attribute key whose value is an enum (`align=right|center`).
  * // Use `upcastAlso` to define other view elements that should also be converted to the `align=right` attribute.
  * editor.conversion.attributeToAttribute( {
  * 	model: {
  * 		key: 'align',
  * 		values: [ 'right', 'center' ]
  * 	},
  * 	view: {
  * 		right: {
  * 			key: 'class',
  * 			value: 'align-right'
  * 		},
  * 		center: {
  * 			key: 'class',
  * 			value: 'align-center'
  * 		}
  * 	},
  * 	upcastAlso: {
  * 		right: {
  * 			styles: {
  * 				'text-align': 'right'
  * 			}
  * 		},
  * 		center: {
  * 			styles: {
  * 				'text-align': 'center'
  * 			}
  * 		}
  * 	}
  * } );
  * ```
  *
  * The `definition.model` parameter specifies which model attribute should be converted from and to.
  * It can be a `{ key, [ values ], [ name ] }` object or a `String`, which will be treated like `{ key: definition.model }`.
  * The `key` property is the model attribute key to convert from and to.
  * The `values` are the possible model attribute values. If the `values` parameter is not set, the model attribute value
  * will be the same as the view attribute value.
  * If `name` is set, the conversion will be set up only for model elements with the given name.
  *
  * The `definition.view` parameter specifies which view attribute should be converted from and to.
  * It can be a `{ key, value, [ name ] }` object or a `String`, which will be treated like `{ key: definition.view }`.
  * The `key` property is the view attribute key to convert from and to.
  * The `value` is the view attribute value to convert from and to. If `definition.value` is not set, the view attribute value will be
  * the same as the model attribute value.
  * If `key` is `'class'`, `value` can be a `String` or an array of `String`s.
  * If `key` is `'style'`, `value` is an object with key-value pairs.
  * In other cases, `value` is a `String`.
  * If `name` is set, the conversion will be set up only for model elements with the given name.
  * If `definition.model.values` is set, `definition.view` is an object that assigns values from `definition.model.values`
  * to `{ key, value, [ name ] }` objects.
  *
  * `definition.upcastAlso` specifies which other matching view elements should also be upcast to the given model configuration.
  * If `definition.model.values` is set, `definition.upcastAlso` should be an object assigning values from `definition.model.values`
  * to {@link module:engine/view/matcher~MatcherPattern}s or arrays of {@link module:engine/view/matcher~MatcherPattern}s.
  *
  * **Note:** `definition.model` and `definition.view` form should be mirrored, so the same types of parameters should
  * be given in both parameters.
  *
  * @param definition The converter definition.
  * @param definition.model The model attribute to convert from and to.
  * @param definition.view The view attribute to convert from and to.
  * @param definition.upcastAlso Any view element matching `definition.upcastAlso` will also be converted to the given model attribute.
  * `definition.upcastAlso` is used only if `config.model.values` is specified.
  */
  attributeToAttribute(n) {
    this.for("downcast").attributeToAttribute(n);
    for (const { model: t, view: i } of hd(n))
      this.for("upcast").attributeToAttribute({
        view: i,
        model: t
      });
  }
  /**
  * Creates and caches conversion helpers for given dispatchers group.
  *
  * @param options.name Group name.
  */
  _createConversionHelpers({ name: n, dispatchers: t, isDowncast: i }) {
    if (this._helpers.has(n))
      throw new v("conversion-group-exists", this);
    const r = i ? new nN(t) : new LN(t);
    this._helpers.set(n, r);
  }
}
function* hd(e) {
  if (e.model.values)
    for (const n of e.model.values) {
      const t = {
        key: e.model.key,
        value: n
      }, i = e.view[n], r = e.upcastAlso ? e.upcastAlso[n] : void 0;
      yield* Bp(t, i, r);
    }
  else
    yield* Bp(e.model, e.view, e.upcastAlso);
}
function* Bp(e, n, t) {
  if (yield {
    model: e,
    view: n
  }, t)
    for (const i of Dt(t))
      yield {
        model: e,
        view: i
      };
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class Rn {
  /**
  * Base operation constructor.
  *
  * @param baseVersion Document {@link module:engine/model/document~Document#version} on which operation
  * can be applied or `null` if the operation operates on detached (non-document) tree.
  */
  constructor(n) {
    /**
    * {@link module:engine/model/document~Document#version} on which operation can be applied. If you try to
    * {@link module:engine/model/model~Model#applyOperation apply} operation with different base version than the
    * {@link module:engine/model/document~Document#version document version} the
    * {@link module:utils/ckeditorerror~CKEditorError model-document-applyOperation-wrong-version} error is thrown.
    */
    m(this, "baseVersion");
    /**
    * Defines whether operation is executed on attached or detached {@link module:engine/model/item~Item items}.
    */
    m(this, "isDocumentOperation");
    /**
    * {@link module:engine/model/batch~Batch Batch} to which the operation is added or `null` if the operation is not
    * added to any batch yet.
    *
    * Note, that a {@link #isDocumentOperation non-document operation} has this property always set to `null`, and is never added
    * to any batch.
    */
    m(this, "batch");
    this.baseVersion = n, this.isDocumentOperation = this.baseVersion !== null, this.batch = null;
  }
  /**
  * Checks whether the operation's parameters are correct and the operation can be correctly executed. Throws
  * an error if operation is not valid.
  *
  * @internal
  */
  _validate() {
  }
  /**
  * Custom toJSON method to solve child-parent circular dependencies.
  *
  * @returns Clone of this object with the operation property replaced with string.
  */
  toJSON() {
    const n = Object.assign({}, this);
    return n.__className = this.constructor.className, delete n.batch, delete n.isDocumentOperation, n;
  }
  /**
  * Name of the operation class used for serialization.
  */
  static get className() {
    return "Operation";
  }
  /**
  * Creates `Operation` object from deserialized object, i.e. from parsed JSON string.
  *
  * @param json Deserialized JSON object.
  * @param doc Document on which this operation will be applied.
  */
  static fromJSON(n, t) {
    return new this(n.baseVersion);
  }
}
function em(e, n) {
  const t = ST(n), i = t.reduce((o, a) => o + a.offsetSize, 0), r = e.parent;
  Fa(e);
  const s = e.index;
  return r._insertChild(s, t), Ba(r, s + t.length), Ba(r, s), new B(e, e.getShiftedBy(i));
}
function kT(e) {
  if (!e.isFlat)
    throw new v("operation-utils-remove-range-not-flat", this);
  const n = e.start.parent;
  Fa(e.start), Fa(e.end);
  const t = n._removeChildren(e.start.index, e.end.index - e.start.index);
  return Ba(n, e.start.index), t;
}
function Ma(e, n) {
  if (!e.isFlat)
    throw new v("operation-utils-move-range-not-flat", this);
  const t = kT(e);
  return n = n._getTransformedByDeletion(e.start, e.end.offset - e.start.offset), em(n, t);
}
function k6(e, n, t) {
  Fa(e.start), Fa(e.end);
  for (const i of e.getItems({
    shallow: !0
  })) {
    const r = i.is("$textProxy") ? i.textNode : i;
    t !== null ? r._setAttribute(n, t) : r._removeAttribute(n), Ba(r.parent, r.index);
  }
  Ba(e.end.parent, e.end.index);
}
function ST(e) {
  const n = [];
  function t(i) {
    if (typeof i == "string")
      n.push(new st(i));
    else if (i instanceof ii)
      n.push(new st(i.data, i.getAttributes()));
    else if (i instanceof ds)
      n.push(i);
    else if (Nn(i))
      for (const r of i)
        t(r);
  }
  t(e);
  for (let i = 1; i < n.length; i++) {
    const r = n[i], s = n[i - 1];
    r instanceof st && s instanceof st && IT(r, s) && (n.splice(i - 1, 2, new st(s.data + r.data, s.getAttributes())), i--);
  }
  return n;
}
function Ba(e, n) {
  const t = e.getChild(n - 1), i = e.getChild(n);
  if (t && i && t.is("$text") && i.is("$text") && IT(t, i)) {
    const r = new st(t.data + i.data, t.getAttributes());
    e._removeChildren(n - 1, 2), e._insertChild(n - 1, r);
  }
}
function Fa(e) {
  const n = e.textNode, t = e.parent;
  if (n) {
    const i = e.offset - n.startOffset, r = n.index;
    t._removeChildren(r, 1);
    const s = new st(n.data.substr(0, i), n.getAttributes()), o = new st(n.data.substr(i), n.getAttributes());
    t._insertChild(r, [
      s,
      o
    ]);
  }
}
function IT(e, n) {
  const t = e.getAttributes(), i = n.getAttributes();
  for (const r of t) {
    if (r[1] !== n.getAttribute(r[0]))
      return !1;
    i.next();
  }
  return i.next().done;
}
class Ve extends Rn {
  /**
  * Creates a move operation.
  *
  * @param sourcePosition Position before the first {@link module:engine/model/item~Item model item} to move.
  * @param howMany Offset size of moved range. Moved range will start from `sourcePosition` and end at
  * `sourcePosition` with offset shifted by `howMany`.
  * @param targetPosition Position at which moved nodes will be inserted.
  * @param baseVersion Document {@link module:engine/model/document~Document#version} on which operation
  * can be applied or `null` if the operation operates on detached (non-document) tree.
  */
  constructor(t, i, r, s) {
    super(s);
    /**
    * Position before the first {@link module:engine/model/item~Item model item} to move.
    */
    m(this, "sourcePosition");
    /**
    * Offset size of moved range.
    */
    m(this, "howMany");
    /**
    * Position at which moved nodes will be inserted.
    */
    m(this, "targetPosition");
    this.sourcePosition = t.clone(), this.sourcePosition.stickiness = "toNext", this.howMany = i, this.targetPosition = r.clone(), this.targetPosition.stickiness = "toNone";
  }
  /**
  * @inheritDoc
  */
  get type() {
    return this.targetPosition.root.rootName == "$graveyard" ? "remove" : this.sourcePosition.root.rootName == "$graveyard" ? "reinsert" : "move";
  }
  /**
  * @inheritDoc
  */
  get affectedSelectable() {
    return [
      B._createFromPositionAndShift(this.sourcePosition, this.howMany),
      B._createFromPositionAndShift(this.targetPosition, 0)
    ];
  }
  /**
  * Creates and returns an operation that has the same parameters as this operation.
  */
  clone() {
    return new Ve(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
  }
  /**
  * Returns the start position of the moved range after it got moved. This may be different than
  * {@link module:engine/model/operation/moveoperation~MoveOperation#targetPosition} in some cases, i.e. when a range is moved
  * inside the same parent but {@link module:engine/model/operation/moveoperation~MoveOperation#targetPosition targetPosition}
  * is after {@link module:engine/model/operation/moveoperation~MoveOperation#sourcePosition sourcePosition}.
  *
  * ```
  *  vv              vv
  * abcdefg ===> adefbcg
  *      ^          ^
  *      targetPos  movedRangeStart
  *      offset 6   offset 4
  *```
  */
  getMovedRangeStart() {
    return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
  }
  /**
  * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
  */
  getReversed() {
    const t = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);
    return new Ve(this.getMovedRangeStart(), this.howMany, t, this.baseVersion + 1);
  }
  /**
  * @inheritDoc
  * @internal
  */
  _validate() {
    const t = this.sourcePosition.parent, i = this.targetPosition.parent, r = this.sourcePosition.offset, s = this.targetPosition.offset;
    if (r + this.howMany > t.maxOffset)
      throw new v("move-operation-nodes-do-not-exist", this);
    if (t === i && r < s && s < r + this.howMany)
      throw new v("move-operation-range-into-itself", this);
    if (this.sourcePosition.root == this.targetPosition.root && sn(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath()) == "prefix") {
      const o = this.sourcePosition.path.length - 1;
      if (this.targetPosition.path[o] >= r && this.targetPosition.path[o] < r + this.howMany)
        throw new v("move-operation-node-into-itself", this);
    }
  }
  /**
  * @inheritDoc
  * @internal
  */
  _execute() {
    Ma(B._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
  }
  /**
  * @inheritDoc
  */
  toJSON() {
    const t = super.toJSON();
    return t.sourcePosition = this.sourcePosition.toJSON(), t.targetPosition = this.targetPosition.toJSON(), t;
  }
  /**
  * @inheritDoc
  */
  static get className() {
    return "MoveOperation";
  }
  /**
  * Creates `MoveOperation` object from deserialized object, i.e. from parsed JSON string.
  *
  * @param json Deserialized JSON object.
  * @param document Document on which this operation will be applied.
  */
  static fromJSON(t, i) {
    const r = z.fromJSON(t.sourcePosition, i), s = z.fromJSON(t.targetPosition, i);
    return new this(r, t.howMany, s, t.baseVersion);
  }
}
class Wt extends Rn {
  /**
  * Creates an insert operation.
  *
  * @param position Position of insertion.
  * @param nodes The list of nodes to be inserted.
  * @param baseVersion Document {@link module:engine/model/document~Document#version} on which operation
  * can be applied or `null` if the operation operates on detached (non-document) tree.
  */
  constructor(t, i, r) {
    super(r);
    /**
    * Position of insertion.
    *
    * @readonly
    */
    m(this, "position");
    /**
    * List of nodes to insert.
    *
    * @readonly
    */
    m(this, "nodes");
    /**
    * Flag deciding how the operation should be transformed. If set to `true`, nodes might get additional attributes
    * during operational transformation. This happens when the operation insertion position is inside of a range
    * where attributes have changed.
    */
    m(this, "shouldReceiveAttributes");
    this.position = t.clone(), this.position.stickiness = "toNone", this.nodes = new ua(ST(i)), this.shouldReceiveAttributes = !1;
  }
  /**
  * @inheritDoc
  */
  get type() {
    return "insert";
  }
  /**
  * Total offset size of inserted nodes.
  */
  get howMany() {
    return this.nodes.maxOffset;
  }
  /**
  * @inheritDoc
  */
  get affectedSelectable() {
    return this.position.clone();
  }
  /**
  * Creates and returns an operation that has the same parameters as this operation.
  */
  clone() {
    const t = new ua([
      ...this.nodes
    ].map((r) => r._clone(!0))), i = new Wt(this.position, t, this.baseVersion);
    return i.shouldReceiveAttributes = this.shouldReceiveAttributes, i;
  }
  /**
  * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
  */
  getReversed() {
    const t = this.position.root.document.graveyard, i = new z(t, [
      0
    ]);
    return new Ve(this.position, this.nodes.maxOffset, i, this.baseVersion + 1);
  }
  /**
  * @inheritDoc
  * @internal
  */
  _validate() {
    const t = this.position.parent;
    if (!t || t.maxOffset < this.position.offset)
      throw new v("insert-operation-position-invalid", this);
  }
  /**
  * @inheritDoc
  * @internal
  */
  _execute() {
    const t = this.nodes;
    this.nodes = new ua([
      ...t
    ].map((i) => i._clone(!0))), em(this.position, t);
  }
  /**
  * @inheritDoc
  */
  toJSON() {
    const t = super.toJSON();
    return t.position = this.position.toJSON(), t.nodes = this.nodes.toJSON(), t;
  }
  /**
  * @inheritDoc
  */
  static get className() {
    return "InsertOperation";
  }
  /**
  * Creates `InsertOperation` object from deserialized object, i.e. from parsed JSON string.
  *
  * @param json Deserialized JSON object.
  * @param document Document on which this operation will be applied.
  */
  static fromJSON(t, i) {
    const r = [];
    for (const o of t.nodes)
      o.name ? r.push(rt.fromJSON(o)) : r.push(st.fromJSON(o));
    const s = new Wt(z.fromJSON(t.position, i), r, t.baseVersion);
    return s.shouldReceiveAttributes = t.shouldReceiveAttributes, s;
  }
}
class Xe extends Rn {
  /**
  * Creates a split operation.
  *
  * @param splitPosition Position at which an element should be split.
  * @param howMany Total offset size of elements that are in the split element after `position`.
  * @param insertionPosition Position at which the clone of split element (or element from graveyard) will be inserted.
  * @param graveyardPosition Position in the graveyard root before the element which
  * should be used as a parent of the nodes after `position`. If it is not set, a copy of the the `position` parent will be used.
  * @param baseVersion Document {@link module:engine/model/document~Document#version} on which operation
  * can be applied or `null` if the operation operates on detached (non-document) tree.
  */
  constructor(t, i, r, s, o) {
    super(o);
    /**
    * Position at which an element should be split.
    */
    m(this, "splitPosition");
    /**
    * Total offset size of elements that are in the split element after `position`.
    */
    m(this, "howMany");
    /**
    * Position at which the clone of split element (or element from graveyard) will be inserted.
    */
    m(this, "insertionPosition");
    /**
    * Position in the graveyard root before the element which should be used as a parent of the nodes after `position`.
    * If it is not set, a copy of the the `position` parent will be used.
    *
    * The default behavior is to clone the split element. Element from graveyard is used during undo.
    */
    m(this, "graveyardPosition");
    this.splitPosition = t.clone(), this.splitPosition.stickiness = "toNext", this.howMany = i, this.insertionPosition = r, this.graveyardPosition = s ? s.clone() : null, this.graveyardPosition && (this.graveyardPosition.stickiness = "toNext");
  }
  /**
  * @inheritDoc
  */
  get type() {
    return "split";
  }
  /**
  * Position inside the new clone of a split element.
  *
  * This is a position where nodes that are after the split position will be moved to.
  */
  get moveTargetPosition() {
    const t = this.insertionPosition.path.slice();
    return t.push(0), new z(this.insertionPosition.root, t);
  }
  /**
  * Artificial range that contains all the nodes from the split element that will be moved to the new element.
  * The range starts at {@link #splitPosition} and ends in the same parent, at `POSITIVE_INFINITY` offset.
  */
  get movedRange() {
    const t = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
    return new B(this.splitPosition, t);
  }
  /**
  * @inheritDoc
  */
  get affectedSelectable() {
    const t = [
      B._createFromPositionAndShift(this.splitPosition, 0),
      B._createFromPositionAndShift(this.insertionPosition, 0)
    ];
    return this.graveyardPosition && t.push(B._createFromPositionAndShift(this.graveyardPosition, 0)), t;
  }
  /**
  * Creates and returns an operation that has the same parameters as this operation.
  *
  * @returns Clone of this operation.
  */
  clone() {
    return new Xe(this.splitPosition, this.howMany, this.insertionPosition, this.graveyardPosition, this.baseVersion);
  }
  /**
  * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
  */
  getReversed() {
    const t = this.splitPosition.root.document.graveyard, i = new z(t, [
      0
    ]);
    return new Et(this.moveTargetPosition, this.howMany, this.splitPosition, i, this.baseVersion + 1);
  }
  /**
  * @inheritDoc
  * @internal
  */
  _validate() {
    const t = this.splitPosition.parent, i = this.splitPosition.offset;
    if (!t || t.maxOffset < i)
      throw new v("split-operation-position-invalid", this);
    if (t.parent) {
      if (this.howMany != t.maxOffset - this.splitPosition.offset)
        throw new v("split-operation-how-many-invalid", this);
      if (this.graveyardPosition && !this.graveyardPosition.nodeAfter)
        throw new v("split-operation-graveyard-position-invalid", this);
    } else throw new v("split-operation-split-in-root", this);
  }
  /**
  * @inheritDoc
  * @internal
  */
  _execute() {
    const t = this.splitPosition.parent;
    if (this.graveyardPosition)
      Ma(B._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);
    else {
      const r = t._clone();
      em(this.insertionPosition, r);
    }
    const i = new B(z._createAt(t, this.splitPosition.offset), z._createAt(t, t.maxOffset));
    Ma(i, this.moveTargetPosition);
  }
  /**
  * @inheritDoc
  */
  toJSON() {
    const t = super.toJSON();
    return t.splitPosition = this.splitPosition.toJSON(), t.insertionPosition = this.insertionPosition.toJSON(), this.graveyardPosition && (t.graveyardPosition = this.graveyardPosition.toJSON()), t;
  }
  /**
  * @inheritDoc
  */
  static get className() {
    return "SplitOperation";
  }
  /**
  * Helper function that returns a default insertion position basing on given `splitPosition`. The default insertion
  * position is after the split element.
  */
  static getInsertionPosition(t) {
    const i = t.path.slice(0, -1);
    return i[i.length - 1]++, new z(t.root, i, "toPrevious");
  }
  /**
  * Creates `SplitOperation` object from deserialized object, i.e. from parsed JSON string.
  *
  * @param json Deserialized JSON object.
  * @param document Document on which this operation will be applied.
  */
  static fromJSON(t, i) {
    const r = z.fromJSON(t.splitPosition, i), s = z.fromJSON(t.insertionPosition, i), o = t.graveyardPosition ? z.fromJSON(t.graveyardPosition, i) : null;
    return new this(r, t.howMany, s, o, t.baseVersion);
  }
}
class Et extends Rn {
  /**
  * Creates a merge operation.
  *
  * @param sourcePosition Position inside the merged element. All nodes from that
  * element after that position will be moved to {@link #targetPosition}.
  * @param howMany Summary offset size of nodes which will be moved from the merged element to the new parent.
  * @param targetPosition Position which the nodes from the merged elements will be moved to.
  * @param graveyardPosition Position in graveyard to which the merged element will be moved.
  * @param baseVersion Document {@link module:engine/model/document~Document#version} on which operation
  * can be applied or `null` if the operation operates on detached (non-document) tree.
  */
  constructor(t, i, r, s, o) {
    super(o);
    /**
    * Position inside the merged element. All nodes from that element after that position will be moved to {@link #targetPosition}.
    */
    m(this, "sourcePosition");
    /**
    * Summary offset size of nodes which will be moved from the merged element to the new parent.
    */
    m(this, "howMany");
    /**
    * Position which the nodes from the merged elements will be moved to.
    */
    m(this, "targetPosition");
    /**
    * Position in graveyard to which the merged element will be moved.
    */
    m(this, "graveyardPosition");
    this.sourcePosition = t.clone(), this.sourcePosition.stickiness = "toPrevious", this.howMany = i, this.targetPosition = r.clone(), this.targetPosition.stickiness = "toNext", this.graveyardPosition = s.clone();
  }
  /**
  * @inheritDoc
  */
  get type() {
    return "merge";
  }
  /**
  * Position before the merged element (which will be deleted).
  */
  get deletionPosition() {
    return new z(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
  }
  /**
  * Artificial range that contains all the nodes from the merged element that will be moved to {@link ~MergeOperation#sourcePosition}.
  * The range starts at {@link ~MergeOperation#sourcePosition} and ends in the same parent, at `POSITIVE_INFINITY` offset.
  */
  get movedRange() {
    const t = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
    return new B(this.sourcePosition, t);
  }
  /**
  * @inheritDoc
  */
  get affectedSelectable() {
    const t = this.sourcePosition.parent;
    return [
      B._createOn(t),
      // These could be positions but `Selectable` type only supports `Iterable<Range>`.
      B._createFromPositionAndShift(this.targetPosition, 0),
      B._createFromPositionAndShift(this.graveyardPosition, 0)
    ];
  }
  /**
  * Creates and returns an operation that has the same parameters as this operation.
  */
  clone() {
    return new Et(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
  }
  /**
  * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
  */
  getReversed() {
    const t = this.targetPosition._getTransformedByMergeOperation(this), i = this.sourcePosition.path.slice(0, -1), r = new z(this.sourcePosition.root, i)._getTransformedByMergeOperation(this);
    return new Xe(t, this.howMany, r, this.graveyardPosition, this.baseVersion + 1);
  }
  /**
  * @inheritDoc
  * @internal
  */
  _validate() {
    const t = this.sourcePosition.parent, i = this.targetPosition.parent;
    if (t.parent)
      if (i.parent) {
        if (this.howMany != t.maxOffset)
          throw new v("merge-operation-how-many-invalid", this);
      } else throw new v("merge-operation-target-position-invalid", this);
    else throw new v("merge-operation-source-position-invalid", this);
  }
  /**
  * @inheritDoc
  * @internal
  */
  _execute() {
    const t = this.sourcePosition.parent, i = B._createIn(t);
    Ma(i, this.targetPosition), Ma(B._createOn(t), this.graveyardPosition);
  }
  /**
  * @inheritDoc
  */
  toJSON() {
    const t = super.toJSON();
    return t.sourcePosition = t.sourcePosition.toJSON(), t.targetPosition = t.targetPosition.toJSON(), t.graveyardPosition = t.graveyardPosition.toJSON(), t;
  }
  /**
  * @inheritDoc
  */
  static get className() {
    return "MergeOperation";
  }
  /**
  * Creates `MergeOperation` object from deserialized object, i.e. from parsed JSON string.
  *
  * @param json Deserialized JSON object.
  * @param document Document on which this operation will be applied.
  */
  static fromJSON(t, i) {
    const r = z.fromJSON(t.sourcePosition, i), s = z.fromJSON(t.targetPosition, i), o = z.fromJSON(t.graveyardPosition, i);
    return new this(r, t.howMany, s, o, t.baseVersion);
  }
}
class an extends Rn {
  /**
  * @param name Marker name.
  * @param oldRange Marker range before the change.
  * @param newRange Marker range after the change.
  * @param markers Marker collection on which change should be executed.
  * @param affectsData Specifies whether the marker operation affects the data produced by the data pipeline
  * (is persisted in the editor's data).
  * @param baseVersion Document {@link module:engine/model/document~Document#version} on which operation
  * can be applied or `null` if the operation operates on detached (non-document) tree.
  */
  constructor(t, i, r, s, o, a) {
    super(a);
    /**
    * Marker name.
    *
    * @readonly
    */
    m(this, "name");
    /**
    * Marker range before the change.
    *
    * @readonly
    */
    m(this, "oldRange");
    /**
    * Marker range after the change.
    *
    * @readonly
    */
    m(this, "newRange");
    /**
    * Specifies whether the marker operation affects the data produced by the data pipeline
    * (is persisted in the editor's data).
    *
    * @readonly
    */
    m(this, "affectsData");
    /**
    * Marker collection on which change should be executed.
    */
    m(this, "_markers");
    this.name = t, this.oldRange = i ? i.clone() : null, this.newRange = r ? r.clone() : null, this.affectsData = o, this._markers = s;
  }
  /**
  * @inheritDoc
  */
  get type() {
    return "marker";
  }
  /**
  * @inheritDoc
  */
  get affectedSelectable() {
    const t = [];
    return this.oldRange && t.push(this.oldRange.clone()), this.newRange && (this.oldRange ? t.push(...this.newRange.getDifference(this.oldRange)) : t.push(this.newRange.clone())), t;
  }
  /**
  * Creates and returns an operation that has the same parameters as this operation.
  */
  clone() {
    return new an(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
  }
  /**
  * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
  */
  getReversed() {
    return new an(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
  }
  /**
  * @inheritDoc
  * @internal
  */
  _execute() {
    this.newRange ? this._markers._set(this.name, this.newRange, !0, this.affectsData) : this._markers._remove(this.name);
  }
  /**
  * @inheritDoc
  * @internal
  */
  toJSON() {
    const t = super.toJSON();
    return this.oldRange && (t.oldRange = this.oldRange.toJSON()), this.newRange && (t.newRange = this.newRange.toJSON()), delete t._markers, t;
  }
  /**
  * @inheritDoc
  */
  static get className() {
    return "MarkerOperation";
  }
  /**
  * Creates `MarkerOperation` object from deserialized object, i.e. from parsed JSON string.
  *
  * @param json Deserialized JSON object.
  * @param document Document on which this operation will be applied.
  */
  static fromJSON(t, i) {
    return new an(t.name, t.oldRange ? B.fromJSON(t.oldRange, i) : null, t.newRange ? B.fromJSON(t.newRange, i) : null, i.model.markers, t.affectsData, t.baseVersion);
  }
}
class At extends Rn {
  /**
  * Creates an operation that changes, removes or adds attributes.
  *
  * If only `newValue` is set, attribute will be added on a node. Note that all nodes in operation's range must not
  * have an attribute with the same key as the added attribute.
  *
  * If only `oldValue` is set, then attribute with given key will be removed. Note that all nodes in operation's range
  * must have an attribute with that key added.
  *
  * If both `newValue` and `oldValue` are set, then the operation will change the attribute value. Note that all nodes in
  * operation's ranges must already have an attribute with given key and `oldValue` as value
  *
  * @param range Range on which the operation should be applied. Must be a flat range.
  * @param key Key of an attribute to change or remove.
  * @param oldValue Old value of the attribute with given key or `null`, if attribute was not set before.
  * @param newValue New value of the attribute with given key or `null`, if operation should remove attribute.
  * @param baseVersion Document {@link module:engine/model/document~Document#version} on which operation
  * can be applied or `null` if the operation operates on detached (non-document) tree.
  */
  constructor(t, i, r, s, o) {
    super(o);
    /**
    * Range on which operation should be applied.
    *
    * @readonly
    */
    m(this, "range");
    /**
    * Key of an attribute to change or remove.
    *
    * @readonly
    */
    m(this, "key");
    /**
    * Old value of the attribute with given key or `null`, if attribute was not set before.
    *
    * @readonly
    */
    m(this, "oldValue");
    /**
    * New value of the attribute with given key or `null`, if operation should remove attribute.
    *
    * @readonly
    */
    m(this, "newValue");
    this.range = t.clone(), this.key = i, this.oldValue = r === void 0 ? null : r, this.newValue = s === void 0 ? null : s;
  }
  /**
  * @inheritDoc
  */
  get type() {
    return this.oldValue === null ? "addAttribute" : this.newValue === null ? "removeAttribute" : "changeAttribute";
  }
  /**
  * @inheritDoc
  */
  get affectedSelectable() {
    return this.range.clone();
  }
  /**
  * Creates and returns an operation that has the same parameters as this operation.
  */
  clone() {
    return new At(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
  }
  /**
  * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
  */
  getReversed() {
    return new At(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
  }
  /**
  * @inheritDoc
  */
  toJSON() {
    const t = super.toJSON();
    return t.range = this.range.toJSON(), t;
  }
  /**
  * @inheritDoc
  * @internal
  */
  _validate() {
    if (!this.range.isFlat)
      throw new v("attribute-operation-range-not-flat", this);
    for (const t of this.range.getItems({
      shallow: !0
    })) {
      if (this.oldValue !== null && !j0(t.getAttribute(this.key), this.oldValue))
        throw new v("attribute-operation-wrong-old-value", this, {
          item: t,
          key: this.key,
          value: this.oldValue
        });
      if (this.oldValue === null && this.newValue !== null && t.hasAttribute(this.key))
        throw new v("attribute-operation-attribute-exists", this, {
          node: t,
          key: this.key
        });
    }
  }
  /**
  * @inheritDoc
  * @internal
  */
  _execute() {
    j0(this.oldValue, this.newValue) || k6(this.range, this.key, this.newValue);
  }
  /**
  * @inheritDoc
  */
  static get className() {
    return "AttributeOperation";
  }
  /**
  * Creates `AttributeOperation` object from deserialized object, i.e. from parsed JSON string.
  *
  * @param json Deserialized JSON object.
  * @param document Document on which this operation will be applied.
  */
  static fromJSON(t, i) {
    return new At(B.fromJSON(t.range, i), t.key, t.oldValue, t.newValue, t.baseVersion);
  }
}
class Lt extends Rn {
  get type() {
    return "noop";
  }
  /**
  * @inheritDoc
  */
  get affectedSelectable() {
    return null;
  }
  /**
  * Creates and returns an operation that has the same parameters as this operation.
  */
  clone() {
    return new Lt(this.baseVersion);
  }
  /**
  * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
  */
  getReversed() {
    return new Lt(this.baseVersion + 1);
  }
  /** @internal */
  _execute() {
  }
  /**
  * @inheritDoc
  */
  static get className() {
    return "NoOperation";
  }
}
class bn extends Rn {
  /**
  * Creates an operation that changes element's name.
  *
  * @param position Position before an element to change.
  * @param oldName Current name of the element.
  * @param newName New name for the element.
  * @param baseVersion Document {@link module:engine/model/document~Document#version} on which operation
  * can be applied or `null` if the operation operates on detached (non-document) tree.
  */
  constructor(t, i, r, s) {
    super(s);
    /**
    * Position before an element to change.
    */
    m(this, "position");
    /**
    * Current name of the element.
    */
    m(this, "oldName");
    /**
    * New name for the element.
    */
    m(this, "newName");
    this.position = t, this.position.stickiness = "toNext", this.oldName = i, this.newName = r;
  }
  /**
  * @inheritDoc
  */
  get type() {
    return "rename";
  }
  /**
  * @inheritDoc
  */
  get affectedSelectable() {
    return this.position.nodeAfter;
  }
  /**
  * Creates and returns an operation that has the same parameters as this operation.
  *
  * @returns Clone of this operation.
  */
  clone() {
    return new bn(this.position.clone(), this.oldName, this.newName, this.baseVersion);
  }
  /**
  * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
  */
  getReversed() {
    return new bn(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
  }
  /**
  * @inheritDoc
  * @internal
  */
  _validate() {
    const t = this.position.nodeAfter;
    if (t instanceof rt) {
      if (t.name !== this.oldName)
        throw new v("rename-operation-wrong-name", this);
    } else throw new v("rename-operation-wrong-position", this);
  }
  /**
  * @inheritDoc
  * @internal
  */
  _execute() {
    const t = this.position.nodeAfter;
    t.name = this.newName;
  }
  /**
  * @inheritDoc
  */
  toJSON() {
    const t = super.toJSON();
    return t.position = this.position.toJSON(), t;
  }
  /**
  * @inheritDoc
  */
  static get className() {
    return "RenameOperation";
  }
  /**
  * Creates `RenameOperation` object from deserialized object, i.e. from parsed JSON string.
  *
  * @param json Deserialized JSON object.
  * @param document Document on which this operation will be applied.
  */
  static fromJSON(t, i) {
    return new bn(z.fromJSON(t.position, i), t.oldName, t.newName, t.baseVersion);
  }
}
class Vi extends Rn {
  /**
  * Creates an operation that changes, removes or adds attributes on root element.
  *
  * @see module:engine/model/operation/attributeoperation~AttributeOperation
  * @param root Root element to change.
  * @param key Key of an attribute to change or remove.
  * @param oldValue Old value of the attribute with given key or `null`, if attribute was not set before.
  * @param newValue New value of the attribute with given key or `null`, if operation should remove attribute.
  * @param baseVersion Document {@link module:engine/model/document~Document#version} on which operation
  * can be applied or `null` if the operation operates on detached (non-document) tree.
  */
  constructor(t, i, r, s, o) {
    super(o);
    /**
    * Root element to change.
    */
    m(this, "root");
    /**
    * Key of an attribute to change or remove.
    */
    m(this, "key");
    /**
    * Old value of the attribute with given key or `null`, if attribute was not set before.
    *
    * @readonly
    */
    m(this, "oldValue");
    /**
    * New value of the attribute with given key or `null`, if operation should remove attribute.
    *
    * @readonly
    */
    m(this, "newValue");
    this.root = t, this.key = i, this.oldValue = r === void 0 ? null : r, this.newValue = s === void 0 ? null : s;
  }
  /**
  * @inheritDoc
  */
  get type() {
    return this.oldValue === null ? "addRootAttribute" : this.newValue === null ? "removeRootAttribute" : "changeRootAttribute";
  }
  /**
  * @inheritDoc
  */
  get affectedSelectable() {
    return this.root;
  }
  /**
  * Creates and returns an operation that has the same parameters as this operation.
  *
  * @returns Clone of this operation.
  */
  clone() {
    return new Vi(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
  }
  /**
  * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
  */
  getReversed() {
    return new Vi(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
  }
  /**
  * @inheritDoc
  * @internal
  */
  _validate() {
    if (this.root != this.root.root || this.root.is("documentFragment"))
      throw new v("rootattribute-operation-not-a-root", this, {
        root: this.root,
        key: this.key
      });
    if (this.oldValue !== null && this.root.getAttribute(this.key) !== this.oldValue)
      throw new v("rootattribute-operation-wrong-old-value", this, {
        root: this.root,
        key: this.key
      });
    if (this.oldValue === null && this.newValue !== null && this.root.hasAttribute(this.key))
      throw new v("rootattribute-operation-attribute-exists", this, {
        root: this.root,
        key: this.key
      });
  }
  /**
  * @inheritDoc
  * @internal
  */
  _execute() {
    this.newValue !== null ? this.root._setAttribute(this.key, this.newValue) : this.root._removeAttribute(this.key);
  }
  /**
  * @inheritDoc
  */
  toJSON() {
    const t = super.toJSON();
    return t.root = this.root.toJSON(), t;
  }
  /**
  * @inheritDoc
  */
  static get className() {
    return "RootAttributeOperation";
  }
  /**
  * Creates `RootAttributeOperation` object from deserialized object, i.e. from parsed JSON string.
  *
  * @param json Deserialized JSON object.
  * @param document Document on which this operation will be applied.
  */
  static fromJSON(t, i) {
    if (!i.getRoot(t.root))
      throw new v("rootattribute-operation-fromjson-no-root", this, {
        rootName: t.root
      });
    return new Vi(i.getRoot(t.root), t.key, t.oldValue, t.newValue, t.baseVersion);
  }
}
class wi extends Rn {
  /**
  * Creates an operation that creates or removes a root element.
  *
  * @param rootName Root name to create or detach.
  * @param elementName Root element name.
  * @param isAdd Specifies whether the operation adds (`true`) or detaches the root (`false`).
  * @param document Document which owns the root.
  * @param baseVersion Document {@link module:engine/model/document~Document#version} on which operation can be applied.
  */
  constructor(t, i, r, s, o) {
    super(o);
    /**
    * Root name to create or detach.
    */
    m(this, "rootName");
    /**
    * Root element name.
    */
    m(this, "elementName");
    /**
    * Specifies whether the operation adds (`true`) or detaches the root (`false`).
    */
    m(this, "isAdd");
    /**
    * Document which owns the root.
    */
    m(this, "_document");
    if (this.rootName = t, this.elementName = i, this.isAdd = r, this._document = s, !this._document.getRoot(this.rootName)) {
      const a = this._document.createRoot(this.elementName, this.rootName);
      a._isAttached = !1;
    }
  }
  /**
  * @inheritDoc
  */
  get type() {
    return this.isAdd ? "addRoot" : "detachRoot";
  }
  /**
  * @inheritDoc
  */
  get affectedSelectable() {
    return this._document.getRoot(this.rootName);
  }
  /**
  * @inheritDoc
  */
  clone() {
    return new wi(this.rootName, this.elementName, this.isAdd, this._document, this.baseVersion);
  }
  /**
  * @inheritDoc
  */
  getReversed() {
    return new wi(this.rootName, this.elementName, !this.isAdd, this._document, this.baseVersion + 1);
  }
  /**
  * @inheritDoc
  */
  _execute() {
    this._document.getRoot(this.rootName)._isAttached = this.isAdd;
  }
  /**
  * @inheritDoc
  */
  toJSON() {
    const t = super.toJSON();
    return delete t._document, t;
  }
  /**
  * @inheritDoc
  */
  static get className() {
    return "RootOperation";
  }
  /**
  * Creates `RootOperation` object from deserialized object, i.e. from parsed JSON string.
  *
  * @param json Deserialized JSON object.
  * @param document Document on which this operation will be applied.
  */
  static fromJSON(t, i) {
    return new wi(t.rootName, t.elementName, t.isAdd, i, t.baseVersion);
  }
}
const jn = {};
jn[At.className] = At;
jn[Wt.className] = Wt;
jn[an.className] = an;
jn[Ve.className] = Ve;
jn[Lt.className] = Lt;
jn[Rn.className] = Rn;
jn[bn.className] = bn;
jn[Vi.className] = Vi;
jn[wi.className] = wi;
jn[Xe.className] = Xe;
jn[Et.className] = Et;
class S6 {
  /**
  * Creates an operation instance from a JSON object (parsed JSON string).
  *
  * @param json Deserialized JSON object.
  * @param document Document on which this operation will be applied.
  */
  static fromJSON(n, t) {
    return jn[n.__className].fromJSON(n, t);
  }
}
const Rh = /* @__PURE__ */ new Map();
function Ue(e, n, t) {
  let i = Rh.get(e);
  i || (i = /* @__PURE__ */ new Map(), Rh.set(e, i)), i.set(n, t);
}
function I6(e, n) {
  const t = Rh.get(e);
  return t && t.has(n) ? t.get(n) : x6;
}
function x6(e) {
  return [
    e
  ];
}
function Fp(e, n, t = {}) {
  const i = I6(e.constructor, n.constructor);
  try {
    return e = e.clone(), i(e, n, t);
  } catch (r) {
    throw r;
  }
}
function v6(e, n, t) {
  e = e.slice(), n = n.slice();
  const i = new P6(t.document, t.useRelations, t.forceWeakRemove);
  i.setOriginalOperations(e), i.setOriginalOperations(n);
  const r = i.originalOperations;
  if (e.length == 0 || n.length == 0)
    return {
      operationsA: e,
      operationsB: n,
      originalOperations: r
    };
  const s = /* @__PURE__ */ new WeakMap();
  for (const u of e)
    s.set(u, 0);
  const o = {
    nextBaseVersionA: e[e.length - 1].baseVersion + 1,
    nextBaseVersionB: n[n.length - 1].baseVersion + 1,
    originalOperationsACount: e.length,
    originalOperationsBCount: n.length
  };
  let a = 0;
  for (; a < e.length; ) {
    const u = e[a], l = s.get(u);
    if (l == n.length) {
      a++;
      continue;
    }
    const c = n[l], d = Fp(u, c, i.getContext(u, c, !0)), p = Fp(c, u, i.getContext(c, u, !1));
    i.updateRelation(u, c), i.setOriginalOperations(d, u), i.setOriginalOperations(p, c);
    for (const g of d)
      s.set(g, l + p.length);
    e.splice(a, 1, ...d), n.splice(l, 1, ...p);
  }
  return Hp(e), Hp(n), Up(e, o.nextBaseVersionB), Up(n, o.nextBaseVersionA), {
    operationsA: e,
    operationsB: n,
    originalOperations: r
  };
}
class P6 {
  /**
  * Creates `ContextFactory` instance.
  *
  * @param document Document which the operations change.
  * @param useRelations Whether during transformation relations should be used (used during undo for
  * better conflict resolution).
  * @param forceWeakRemove If set to `false`, remove operation will be always stronger than move operation,
  * so the removed nodes won't end up back in the document root. When set to `true`, context data will be used.
  */
  constructor(n, t, i = !1) {
    m(this, "originalOperations");
    m(this, "_history");
    m(this, "_useRelations");
    m(this, "_forceWeakRemove");
    m(this, "_relations");
    this.originalOperations = /* @__PURE__ */ new Map(), this._history = n.history, this._useRelations = t, this._forceWeakRemove = !!i, this._relations = /* @__PURE__ */ new Map();
  }
  /**
  * Sets "original operation" for given operations.
  *
  * During transformation process, operations are cloned, then changed, then processed again, sometimes broken into two
  * or multiple operations. When gathering additional data it is important that all operations can be somehow linked
  * so a cloned and transformed "version" still kept track of the data assigned earlier to it.
  *
  * The original operation object will be used as such an universal linking id. Throughout the transformation process
  * all cloned operations will refer to "the original operation" when storing and reading additional data.
  *
  * If `takeFrom` is not set, each operation from `operations` array will be assigned itself as "the original operation".
  * This should be used as an initialization step.
  *
  * If `takeFrom` is set, each operation from `operations` will be assigned the same original operation as assigned
  * for `takeFrom` operation. This should be used to update original operations. It should be used in a way that
  * `operations` are the result of `takeFrom` transformation to ensure proper "original operation propagation".
  */
  setOriginalOperations(n, t = null) {
    const i = t ? this.originalOperations.get(t) : null;
    for (const r of n)
      this.originalOperations.set(r, i || r);
  }
  /**
  * Saves a relation between operations `opA` and `opB`.
  *
  * Relations are then later used to help solve conflicts when operations are transformed.
  */
  updateRelation(n, t) {
    if (n instanceof Ve)
      t instanceof Et ? n.targetPosition.isEqual(t.sourcePosition) || t.movedRange.containsPosition(n.targetPosition) ? this._setRelation(n, t, "insertAtSource") : n.targetPosition.isEqual(t.deletionPosition) ? this._setRelation(n, t, "insertBetween") : n.targetPosition.isAfter(t.sourcePosition) && this._setRelation(n, t, "moveTargetAfter") : t instanceof Ve && (n.targetPosition.isEqual(t.sourcePosition) || n.targetPosition.isBefore(t.sourcePosition) ? this._setRelation(n, t, "insertBefore") : this._setRelation(n, t, "insertAfter"));
    else if (n instanceof Xe) {
      if (t instanceof Et)
        n.splitPosition.isBefore(t.sourcePosition) && this._setRelation(n, t, "splitBefore");
      else if (t instanceof Ve)
        if (n.splitPosition.isEqual(t.sourcePosition) || n.splitPosition.isBefore(t.sourcePosition))
          this._setRelation(n, t, "splitBefore");
        else {
          const i = B._createFromPositionAndShift(t.sourcePosition, t.howMany);
          if (n.splitPosition.hasSameParentAs(t.sourcePosition) && i.containsPosition(n.splitPosition)) {
            const r = i.end.offset - n.splitPosition.offset, s = n.splitPosition.offset - i.start.offset;
            this._setRelation(n, t, {
              howMany: r,
              offset: s
            });
          }
        }
    } else if (n instanceof Et)
      t instanceof Et ? (n.targetPosition.isEqual(t.sourcePosition) || this._setRelation(n, t, "mergeTargetNotMoved"), n.sourcePosition.isEqual(t.targetPosition) && this._setRelation(n, t, "mergeSourceNotMoved"), n.sourcePosition.isEqual(t.sourcePosition) && this._setRelation(n, t, "mergeSameElement")) : t instanceof Xe ? n.sourcePosition.isEqual(t.splitPosition) && this._setRelation(n, t, "splitAtSource") : t instanceof Ve && t.howMany > 0 && (n.sourcePosition.isEqual(t.sourcePosition.getShiftedBy(t.howMany)) && this._setRelation(n, t, "mergeSourceAffected"), n.targetPosition.isEqual(t.sourcePosition) && this._setRelation(n, t, "mergeTargetWasBefore"));
    else if (n instanceof an) {
      const i = n.newRange;
      if (!i)
        return;
      if (t instanceof Et) {
        const r = i.start.isEqual(t.targetPosition), s = i.start.isEqual(t.deletionPosition), o = i.end.isEqual(t.deletionPosition), a = i.end.isEqual(t.sourcePosition);
        (r || s || o || a) && this._setRelation(n, t, {
          wasInLeftElement: r,
          wasStartBeforeMergedElement: s,
          wasEndBeforeMergedElement: o,
          wasInRightElement: a
        });
      }
    }
  }
  /**
  * Evaluates and returns contextual information about two given operations `opA` and `opB` which are about to be transformed.
  */
  getContext(n, t, i) {
    return {
      aIsStrong: i,
      aWasUndone: this._wasUndone(n),
      bWasUndone: this._wasUndone(t),
      abRelation: this._useRelations ? this._getRelation(n, t) : null,
      baRelation: this._useRelations ? this._getRelation(t, n) : null,
      forceWeakRemove: this._forceWeakRemove
    };
  }
  /**
  * Returns whether given operation `op` has already been undone.
  *
  * Information whether an operation was undone gives more context when making a decision when two operations are in conflict.
  */
  _wasUndone(n) {
    const t = this.originalOperations.get(n);
    return t.wasUndone || this._history.isUndoneOperation(t);
  }
  /**
  * Returns a relation between `opA` and an operation which is undone by `opB`. This can be `String` value if a relation
  * was set earlier or `null` if there was no relation between those operations.
  *
  * This is a little tricky to understand, so let's compare it to `ContextFactory#_wasUndone`.
  *
  * When `wasUndone( opB )` is used, we check if the `opB` has already been undone. It is obvious, that the
  * undoing operation must happen after the undone operation. So, essentially, we have `opB`, we take document history,
  * we look forward in the future and ask if in that future `opB` was undone.
  *
  * Relations is a backward process to `wasUndone()`.
  *
  * Long story short - using relations is asking what happened in the past. Looking back. This time we have an undoing
  * operation `opB` which has undone some other operation. When there is a transformation `opA` x `opB` and there is
  * a conflict to solve and `opB` is an undoing operation, we can look back in the history and see what was a relation
  * between `opA` and the operation which `opB` undone. Basing on that relation from the past, we can now make
  * a better decision when resolving a conflict between two operations, because we know more about the context of
  * those two operations.
  *
  * This is why this function does not return a relation directly between `opA` and `opB` because we need to look
  * back to search for a meaningful contextual information.
  */
  _getRelation(n, t) {
    const i = this.originalOperations.get(t), r = this._history.getUndoneOperation(i);
    if (!r)
      return null;
    const s = this.originalOperations.get(n), o = this._relations.get(s);
    return o && o.get(r) || null;
  }
  /**
  * Helper function for `ContextFactory#updateRelations`.
  */
  _setRelation(n, t, i) {
    const r = this.originalOperations.get(n), s = this.originalOperations.get(t);
    let o = this._relations.get(r);
    o || (o = /* @__PURE__ */ new Map(), this._relations.set(r, o)), o.set(s, i);
  }
}
function Up(e, n) {
  for (const t of e)
    t.baseVersion = n++;
}
function Hp(e) {
  const n = /* @__PURE__ */ new Map();
  for (let t = 0; t < e.length; t++) {
    const i = e[t];
    i instanceof an && (i.baseVersion !== -1 ? n.set(i.name, {
      op: i,
      ranges: i.newRange ? [
        i.newRange
      ] : []
    }) : (i.newRange && n.get(i.name).ranges.push(i.newRange), e.splice(t, 1), t--));
  }
  for (const { op: t, ranges: i } of n.values())
    i.length ? t.newRange = B._createFromRanges(i) : t.newRange = null;
}
Ue(At, At, (e, n, t) => {
  if (e.key === n.key && e.range.start.hasSameParentAs(n.range.start)) {
    const i = e.range.getDifference(n.range).map((s) => new At(s, e.key, e.oldValue, e.newValue, 0)), r = e.range.getIntersection(n.range);
    return r && t.aIsStrong && i.push(new At(r, n.key, n.newValue, e.newValue, 0)), i.length == 0 ? [
      new Lt(0)
    ] : i;
  } else
    return [
      e
    ];
});
Ue(At, Wt, (e, n) => {
  if (e.range.start.hasSameParentAs(n.position) && e.range.containsPosition(n.position)) {
    const i = e.range._getTransformedByInsertion(n.position, n.howMany, !n.shouldReceiveAttributes).map((r) => new At(r, e.key, e.oldValue, e.newValue, e.baseVersion));
    if (n.shouldReceiveAttributes) {
      const r = xT(n, e.key, e.oldValue);
      r && i.unshift(r);
    }
    return i;
  }
  return e.range = e.range._getTransformedByInsertion(n.position, n.howMany, !1)[0], [
    e
  ];
});
function xT(e, n, t) {
  const r = e.nodes.getNode(0).getAttribute(n);
  if (r == t)
    return null;
  const s = new B(e.position, e.position.getShiftedBy(e.howMany));
  return new At(s, n, r, t, 0);
}
Ue(At, Et, (e, n) => {
  const t = [];
  e.range.start.hasSameParentAs(n.deletionPosition) && (e.range.containsPosition(n.deletionPosition) || e.range.start.isEqual(n.deletionPosition)) && t.push(B._createFromPositionAndShift(n.graveyardPosition, 1));
  const i = e.range._getTransformedByMergeOperation(n);
  return i.isCollapsed || t.push(i), t.map((r) => new At(r, e.key, e.oldValue, e.newValue, e.baseVersion));
});
Ue(At, Ve, (e, n) => O6(e.range, n).map((i) => new At(i, e.key, e.oldValue, e.newValue, e.baseVersion)));
function O6(e, n) {
  const t = B._createFromPositionAndShift(n.sourcePosition, n.howMany);
  let i = null, r = [];
  t.containsRange(e, !0) ? i = e : e.start.hasSameParentAs(t.start) ? (r = e.getDifference(t), i = e.getIntersection(t)) : r = [
    e
  ];
  const s = [];
  for (let o of r) {
    o = o._getTransformedByDeletion(n.sourcePosition, n.howMany);
    const a = n.getMovedRangeStart(), u = o.start.hasSameParentAs(a), l = o._getTransformedByInsertion(a, n.howMany, u);
    s.push(...l);
  }
  return i && s.push(i._getTransformedByMove(n.sourcePosition, n.targetPosition, n.howMany, !1)[0]), s;
}
Ue(At, Xe, (e, n) => {
  if (e.range.end.isEqual(n.insertionPosition))
    return n.graveyardPosition || e.range.end.offset++, [
      e
    ];
  if (e.range.start.hasSameParentAs(n.splitPosition) && e.range.containsPosition(n.splitPosition)) {
    const t = e.clone();
    return t.range = new B(n.moveTargetPosition.clone(), e.range.end._getCombined(n.splitPosition, n.moveTargetPosition)), e.range.end = n.splitPosition.clone(), e.range.end.stickiness = "toPrevious", [
      e,
      t
    ];
  }
  return e.range = e.range._getTransformedBySplitOperation(n), [
    e
  ];
});
Ue(Wt, At, (e, n) => {
  const t = [
    e
  ];
  if (e.shouldReceiveAttributes && e.position.hasSameParentAs(n.range.start) && n.range.containsPosition(e.position)) {
    const i = xT(e, n.key, n.newValue);
    i && t.push(i);
  }
  return t;
});
Ue(Wt, Wt, (e, n, t) => e.position.isEqual(n.position) && t.aIsStrong ? [
  e
] : (e.position = e.position._getTransformedByInsertOperation(n), [
  e
]));
Ue(Wt, Ve, (e, n) => (e.position = e.position._getTransformedByMoveOperation(n), [
  e
]));
Ue(Wt, Xe, (e, n) => (e.position = e.position._getTransformedBySplitOperation(n), [
  e
]));
Ue(Wt, Et, (e, n) => (e.position = e.position._getTransformedByMergeOperation(n), [
  e
]));
Ue(an, Wt, (e, n) => (e.oldRange && (e.oldRange = e.oldRange._getTransformedByInsertOperation(n)[0]), e.newRange && (e.newRange = e.newRange._getTransformedByInsertOperation(n)[0]), [
  e
]));
Ue(an, an, (e, n, t) => {
  if (e.name == n.name)
    if (t.aIsStrong)
      e.oldRange = n.newRange ? n.newRange.clone() : null;
    else
      return [
        new Lt(0)
      ];
  return [
    e
  ];
});
Ue(an, Et, (e, n) => (e.oldRange && (e.oldRange = e.oldRange._getTransformedByMergeOperation(n)), e.newRange && (e.newRange = e.newRange._getTransformedByMergeOperation(n)), [
  e
]));
Ue(an, Ve, (e, n) => {
  const t = [
    e
  ];
  if (e.oldRange && (e.oldRange = B._createFromRanges(e.oldRange._getTransformedByMoveOperation(n))), e.newRange) {
    const i = e.newRange._getTransformedByMoveOperation(n);
    e.newRange = i[0];
    for (let r = 1; r < i.length; r++) {
      const s = e.clone();
      s.oldRange = null, s.newRange = i[r], s.baseVersion = -1, t.push(s);
    }
  }
  return t;
});
Ue(an, Xe, (e, n, t) => {
  if (e.oldRange && (e.oldRange = e.oldRange._getTransformedBySplitOperation(n)), e.newRange) {
    if (t.abRelation) {
      const i = e.newRange._getTransformedBySplitOperation(n);
      return e.newRange.start.isEqual(n.splitPosition) && t.abRelation.wasStartBeforeMergedElement ? e.newRange.start = z._createAt(n.insertionPosition) : e.newRange.start.isEqual(n.splitPosition) && !t.abRelation.wasInLeftElement ? e.newRange.start = z._createAt(n.moveTargetPosition) : e.newRange.start = i.start, e.newRange.end.isEqual(n.splitPosition) && t.abRelation.wasInRightElement ? e.newRange.end = z._createAt(n.moveTargetPosition) : e.newRange.end.isEqual(n.splitPosition) && t.abRelation.wasEndBeforeMergedElement ? e.newRange.end = z._createAt(n.insertionPosition) : e.newRange.end = i.end, [
        e
      ];
    }
    e.newRange = e.newRange._getTransformedBySplitOperation(n);
  }
  return [
    e
  ];
});
Ue(Et, Wt, (e, n) => (e.sourcePosition.hasSameParentAs(n.position) && (e.howMany += n.howMany), e.sourcePosition = e.sourcePosition._getTransformedByInsertOperation(n), e.targetPosition = e.targetPosition._getTransformedByInsertOperation(n), [
  e
]));
Ue(Et, Et, (e, n, t) => {
  if (e.sourcePosition.isEqual(n.sourcePosition) && e.targetPosition.isEqual(n.targetPosition))
    if (t.bWasUndone) {
      const i = n.graveyardPosition.path.slice();
      return i.push(0), e.sourcePosition = new z(n.graveyardPosition.root, i), e.howMany = 0, [
        e
      ];
    } else
      return [
        new Lt(0)
      ];
  if (e.sourcePosition.isEqual(n.sourcePosition) && !e.targetPosition.isEqual(n.targetPosition) && !t.bWasUndone && t.abRelation != "splitAtSource") {
    const i = e.targetPosition.root.rootName == "$graveyard", r = n.targetPosition.root.rootName == "$graveyard";
    if (r && !i || !(i && !r) && t.aIsStrong) {
      const u = n.targetPosition._getTransformedByMergeOperation(n), l = e.targetPosition._getTransformedByMergeOperation(n);
      return [
        new Ve(u, e.howMany, l, 0)
      ];
    } else
      return [
        new Lt(0)
      ];
  }
  return e.sourcePosition.hasSameParentAs(n.targetPosition) && (e.howMany += n.howMany), e.sourcePosition = e.sourcePosition._getTransformedByMergeOperation(n), e.targetPosition = e.targetPosition._getTransformedByMergeOperation(n), (!e.graveyardPosition.isEqual(n.graveyardPosition) || !t.aIsStrong) && (e.graveyardPosition = e.graveyardPosition._getTransformedByMergeOperation(n)), [
    e
  ];
});
Ue(Et, Ve, (e, n, t) => {
  const i = B._createFromPositionAndShift(n.sourcePosition, n.howMany);
  return n.type == "remove" && !t.bWasUndone && e.deletionPosition.hasSameParentAs(n.sourcePosition) && i.containsPosition(e.sourcePosition) ? [
    new Lt(0)
  ] : (n.sourcePosition.getShiftedBy(n.howMany).isEqual(e.sourcePosition) ? e.sourcePosition.stickiness = "toNone" : n.targetPosition.isEqual(e.sourcePosition) && t.abRelation == "mergeSourceAffected" ? e.sourcePosition.stickiness = "toNext" : n.sourcePosition.isEqual(e.targetPosition) ? (e.targetPosition.stickiness = "toNone", e.howMany -= n.howMany) : n.targetPosition.isEqual(e.targetPosition) && t.abRelation == "mergeTargetWasBefore" ? (e.targetPosition.stickiness = "toPrevious", e.howMany += n.howMany) : (e.sourcePosition.hasSameParentAs(n.targetPosition) && (e.howMany += n.howMany), e.sourcePosition.hasSameParentAs(n.sourcePosition) && (e.howMany -= n.howMany)), e.sourcePosition = e.sourcePosition._getTransformedByMoveOperation(n), e.targetPosition = e.targetPosition._getTransformedByMoveOperation(n), e.sourcePosition.stickiness = "toPrevious", e.targetPosition.stickiness = "toNext", e.graveyardPosition.isEqual(n.targetPosition) || (e.graveyardPosition = e.graveyardPosition._getTransformedByMoveOperation(n)), [
    e
  ]);
});
Ue(Et, Xe, (e, n, t) => {
  if (n.graveyardPosition && (e.graveyardPosition = e.graveyardPosition._getTransformedByDeletion(n.graveyardPosition, 1), e.deletionPosition.isEqual(n.graveyardPosition) && (e.howMany = n.howMany)), e.targetPosition.isEqual(n.splitPosition) && (n.graveyardPosition && e.deletionPosition.isEqual(n.graveyardPosition) || t.abRelation == "mergeTargetNotMoved"))
    return e.sourcePosition = e.sourcePosition._getTransformedBySplitOperation(n), [
      e
    ];
  if (e.sourcePosition.isEqual(n.splitPosition)) {
    if (t.abRelation == "mergeSourceNotMoved")
      return e.howMany = 0, e.targetPosition = e.targetPosition._getTransformedBySplitOperation(n), [
        e
      ];
    if (t.abRelation == "mergeSameElement" || e.sourcePosition.offset > 0)
      return e.sourcePosition = n.moveTargetPosition.clone(), e.targetPosition = e.targetPosition._getTransformedBySplitOperation(n), [
        e
      ];
  }
  return e.sourcePosition.hasSameParentAs(n.splitPosition) && (e.howMany = n.splitPosition.offset), e.sourcePosition = e.sourcePosition._getTransformedBySplitOperation(n), e.targetPosition = e.targetPosition._getTransformedBySplitOperation(n), [
    e
  ];
});
Ue(Ve, Wt, (e, n) => {
  const i = B._createFromPositionAndShift(e.sourcePosition, e.howMany)._getTransformedByInsertOperation(n, !1)[0];
  return e.sourcePosition = i.start, e.howMany = i.end.offset - i.start.offset, e.targetPosition.isEqual(n.position) || (e.targetPosition = e.targetPosition._getTransformedByInsertOperation(n)), [
    e
  ];
});
Ue(Ve, Ve, (e, n, t) => {
  const i = B._createFromPositionAndShift(e.sourcePosition, e.howMany), r = B._createFromPositionAndShift(n.sourcePosition, n.howMany);
  let s = t.aIsStrong, o = !t.aIsStrong;
  t.abRelation == "insertBefore" || t.baRelation == "insertAfter" ? o = !0 : (t.abRelation == "insertAfter" || t.baRelation == "insertBefore") && (o = !1);
  let a;
  if (e.targetPosition.isEqual(n.targetPosition) && o ? a = e.targetPosition._getTransformedByDeletion(n.sourcePosition, n.howMany) : a = e.targetPosition._getTransformedByMove(n.sourcePosition, n.targetPosition, n.howMany), Vp(e, n) && Vp(n, e))
    return [
      n.getReversed()
    ];
  if (i.containsPosition(n.targetPosition) && i.containsRange(r, !0))
    return i.start = i.start._getTransformedByMove(n.sourcePosition, n.targetPosition, n.howMany), i.end = i.end._getTransformedByMove(n.sourcePosition, n.targetPosition, n.howMany), Vs([
      i
    ], a);
  if (r.containsPosition(e.targetPosition) && r.containsRange(i, !0))
    return i.start = i.start._getCombined(n.sourcePosition, n.getMovedRangeStart()), i.end = i.end._getCombined(n.sourcePosition, n.getMovedRangeStart()), Vs([
      i
    ], a);
  const c = sn(e.sourcePosition.getParentPath(), n.sourcePosition.getParentPath());
  if (c == "prefix" || c == "extension")
    return i.start = i.start._getTransformedByMove(n.sourcePosition, n.targetPosition, n.howMany), i.end = i.end._getTransformedByMove(n.sourcePosition, n.targetPosition, n.howMany), Vs([
      i
    ], a);
  e.type == "remove" && n.type != "remove" && !t.aWasUndone && !t.forceWeakRemove ? s = !0 : e.type != "remove" && n.type == "remove" && !t.bWasUndone && !t.forceWeakRemove && (s = !1);
  const d = [], p = i.getDifference(r);
  for (const b of p) {
    b.start = b.start._getTransformedByDeletion(n.sourcePosition, n.howMany), b.end = b.end._getTransformedByDeletion(n.sourcePosition, n.howMany);
    const _ = sn(b.start.getParentPath(), n.getMovedRangeStart().getParentPath()) == "same", k = b._getTransformedByInsertion(n.getMovedRangeStart(), n.howMany, _);
    d.push(...k);
  }
  const g = i.getIntersection(r);
  return g !== null && s && (g.start = g.start._getCombined(n.sourcePosition, n.getMovedRangeStart()), g.end = g.end._getCombined(n.sourcePosition, n.getMovedRangeStart()), d.length === 0 ? d.push(g) : d.length == 1 ? r.start.isBefore(i.start) || r.start.isEqual(i.start) ? d.unshift(g) : d.push(g) : d.splice(1, 0, g)), d.length === 0 ? [
    new Lt(e.baseVersion)
  ] : Vs(d, a);
});
Ue(Ve, Xe, (e, n, t) => {
  let i = e.targetPosition.clone();
  (!e.targetPosition.isEqual(n.insertionPosition) || !n.graveyardPosition || t.abRelation == "moveTargetAfter") && (i = e.targetPosition._getTransformedBySplitOperation(n));
  const r = B._createFromPositionAndShift(e.sourcePosition, e.howMany);
  if (r.end.isEqual(n.insertionPosition))
    return n.graveyardPosition || e.howMany++, e.targetPosition = i, [
      e
    ];
  if (r.start.hasSameParentAs(n.splitPosition) && r.containsPosition(n.splitPosition)) {
    let a = new B(n.splitPosition, r.end);
    a = a._getTransformedBySplitOperation(n);
    const u = [
      new B(r.start, n.splitPosition),
      a
    ];
    return Vs(u, i);
  }
  e.targetPosition.isEqual(n.splitPosition) && t.abRelation == "insertAtSource" && (i = n.moveTargetPosition), e.targetPosition.isEqual(n.insertionPosition) && t.abRelation == "insertBetween" && (i = e.targetPosition);
  const o = [
    r._getTransformedBySplitOperation(n)
  ];
  if (n.graveyardPosition) {
    const a = r.start.isEqual(n.graveyardPosition) || r.containsPosition(n.graveyardPosition);
    e.howMany > 1 && a && !t.aWasUndone && o.push(B._createFromPositionAndShift(n.insertionPosition, 1));
  }
  return Vs(o, i);
});
Ue(Ve, Et, (e, n, t) => {
  const i = B._createFromPositionAndShift(e.sourcePosition, e.howMany);
  if (n.deletionPosition.hasSameParentAs(e.sourcePosition) && i.containsPosition(n.sourcePosition)) {
    if (e.type == "remove" && !t.forceWeakRemove) {
      if (!t.aWasUndone) {
        const o = [];
        let a = n.graveyardPosition.clone(), u = n.targetPosition._getTransformedByMergeOperation(n);
        const l = e.targetPosition.getTransformedByOperation(n);
        e.howMany > 1 && (o.push(new Ve(e.sourcePosition, e.howMany - 1, l, 0)), a = a._getTransformedByMove(e.sourcePosition, l, e.howMany - 1), u = u._getTransformedByMove(e.sourcePosition, l, e.howMany - 1));
        const c = n.deletionPosition._getCombined(e.sourcePosition, l), d = new Ve(a, 1, c, 0), p = d.getMovedRangeStart().path.slice();
        p.push(0);
        const g = new z(d.targetPosition.root, p);
        u = u._getTransformedByMove(a, c, 1);
        const b = new Ve(u, n.howMany, g, 0);
        return o.push(d), o.push(b), o;
      }
    } else if (e.howMany == 1)
      return t.bWasUndone ? (e.sourcePosition = n.graveyardPosition.clone(), e.targetPosition = e.targetPosition._getTransformedByMergeOperation(n), [
        e
      ]) : [
        new Lt(0)
      ];
  }
  const s = B._createFromPositionAndShift(e.sourcePosition, e.howMany)._getTransformedByMergeOperation(n);
  return e.sourcePosition = s.start, e.howMany = s.end.offset - s.start.offset, e.targetPosition = e.targetPosition._getTransformedByMergeOperation(n), [
    e
  ];
});
Ue(bn, Wt, (e, n) => (e.position = e.position._getTransformedByInsertOperation(n), [
  e
]));
Ue(bn, Et, (e, n) => e.position.isEqual(n.deletionPosition) ? (e.position = n.graveyardPosition.clone(), e.position.stickiness = "toNext", [
  e
]) : (e.position = e.position._getTransformedByMergeOperation(n), [
  e
]));
Ue(bn, Ve, (e, n) => (e.position = e.position._getTransformedByMoveOperation(n), [
  e
]));
Ue(bn, bn, (e, n, t) => {
  if (e.position.isEqual(n.position))
    if (t.aIsStrong)
      e.oldName = n.newName;
    else
      return [
        new Lt(0)
      ];
  return [
    e
  ];
});
Ue(bn, Xe, (e, n) => {
  const t = e.position.path, i = n.splitPosition.getParentPath();
  if (sn(t, i) == "same" && !n.graveyardPosition) {
    const r = new bn(e.position.getShiftedBy(1), e.oldName, e.newName, 0);
    return [
      e,
      r
    ];
  }
  return e.position = e.position._getTransformedBySplitOperation(n), [
    e
  ];
});
Ue(Vi, Vi, (e, n, t) => {
  if (e.root === n.root && e.key === n.key) {
    if (!t.aIsStrong || e.newValue === n.newValue)
      return [
        new Lt(0)
      ];
    e.oldValue = n.newValue;
  }
  return [
    e
  ];
});
Ue(wi, wi, (e, n) => e.rootName === n.rootName && e.isAdd === n.isAdd ? [
  new Lt(0)
] : [
  e
]);
Ue(Xe, Wt, (e, n) => (e.splitPosition.hasSameParentAs(n.position) && e.splitPosition.offset < n.position.offset && (e.howMany += n.howMany), e.splitPosition = e.splitPosition._getTransformedByInsertOperation(n), e.insertionPosition = e.insertionPosition._getTransformedByInsertOperation(n), [
  e
]));
Ue(Xe, Et, (e, n, t) => {
  if (!e.graveyardPosition && !t.bWasUndone && e.splitPosition.hasSameParentAs(n.sourcePosition)) {
    const i = n.graveyardPosition.path.slice();
    i.push(0);
    const r = new z(n.graveyardPosition.root, i), s = Xe.getInsertionPosition(new z(n.graveyardPosition.root, i)), o = new Xe(r, 0, s, null, 0);
    return e.splitPosition = e.splitPosition._getTransformedByMergeOperation(n), e.insertionPosition = Xe.getInsertionPosition(e.splitPosition), e.graveyardPosition = o.insertionPosition.clone(), e.graveyardPosition.stickiness = "toNext", [
      o,
      e
    ];
  }
  return e.splitPosition.hasSameParentAs(n.deletionPosition) && !e.splitPosition.isAfter(n.deletionPosition) && e.howMany--, e.splitPosition.hasSameParentAs(n.targetPosition) && (e.howMany += n.howMany), e.splitPosition = e.splitPosition._getTransformedByMergeOperation(n), e.insertionPosition = Xe.getInsertionPosition(e.splitPosition), e.graveyardPosition && (e.graveyardPosition = e.graveyardPosition._getTransformedByMergeOperation(n)), [
    e
  ];
});
Ue(Xe, Ve, (e, n, t) => {
  const i = B._createFromPositionAndShift(n.sourcePosition, n.howMany);
  if (e.graveyardPosition) {
    const s = i.start.isEqual(e.graveyardPosition) || i.containsPosition(e.graveyardPosition);
    if (!t.bWasUndone && s) {
      const o = e.splitPosition._getTransformedByMoveOperation(n), a = e.graveyardPosition._getTransformedByMoveOperation(n), u = a.path.slice();
      u.push(0);
      const l = new z(a.root, u);
      return [
        new Ve(o, e.howMany, l, 0)
      ];
    }
    e.graveyardPosition = e.graveyardPosition._getTransformedByMoveOperation(n);
  }
  const r = e.splitPosition.isEqual(n.targetPosition);
  if (r && (t.baRelation == "insertAtSource" || t.abRelation == "splitBefore"))
    return e.howMany += n.howMany, e.splitPosition = e.splitPosition._getTransformedByDeletion(n.sourcePosition, n.howMany), e.insertionPosition = Xe.getInsertionPosition(e.splitPosition), [
      e
    ];
  if (r && t.abRelation && t.abRelation.howMany) {
    const { howMany: s, offset: o } = t.abRelation;
    return e.howMany += s, e.splitPosition = e.splitPosition.getShiftedBy(o), [
      e
    ];
  }
  if (e.splitPosition.hasSameParentAs(n.sourcePosition) && i.containsPosition(e.splitPosition)) {
    const s = n.howMany - (e.splitPosition.offset - n.sourcePosition.offset);
    return e.howMany -= s, e.splitPosition.hasSameParentAs(n.targetPosition) && e.splitPosition.offset < n.targetPosition.offset && (e.howMany += n.howMany), e.splitPosition = n.sourcePosition.clone(), e.insertionPosition = Xe.getInsertionPosition(e.splitPosition), [
      e
    ];
  }
  return n.sourcePosition.isEqual(n.targetPosition) || (e.splitPosition.hasSameParentAs(n.sourcePosition) && e.splitPosition.offset <= n.sourcePosition.offset && (e.howMany -= n.howMany), e.splitPosition.hasSameParentAs(n.targetPosition) && e.splitPosition.offset < n.targetPosition.offset && (e.howMany += n.howMany)), e.splitPosition.stickiness = "toNone", e.splitPosition = e.splitPosition._getTransformedByMoveOperation(n), e.splitPosition.stickiness = "toNext", e.graveyardPosition ? e.insertionPosition = e.insertionPosition._getTransformedByMoveOperation(n) : e.insertionPosition = Xe.getInsertionPosition(e.splitPosition), [
    e
  ];
});
Ue(Xe, Xe, (e, n, t) => {
  if (e.splitPosition.isEqual(n.splitPosition)) {
    if (!e.graveyardPosition && !n.graveyardPosition)
      return [
        new Lt(0)
      ];
    if (e.graveyardPosition && n.graveyardPosition && e.graveyardPosition.isEqual(n.graveyardPosition))
      return [
        new Lt(0)
      ];
    if (t.abRelation == "splitBefore")
      return e.howMany = 0, e.graveyardPosition = e.graveyardPosition._getTransformedBySplitOperation(n), [
        e
      ];
  }
  if (e.graveyardPosition && n.graveyardPosition && e.graveyardPosition.isEqual(n.graveyardPosition)) {
    const i = e.splitPosition.root.rootName == "$graveyard", r = n.splitPosition.root.rootName == "$graveyard";
    if (r && !i || !(i && !r) && t.aIsStrong) {
      const u = [];
      return n.howMany && u.push(new Ve(n.moveTargetPosition, n.howMany, n.splitPosition, 0)), e.howMany && u.push(new Ve(e.splitPosition, e.howMany, e.moveTargetPosition, 0)), u;
    } else
      return [
        new Lt(0)
      ];
  }
  if (e.graveyardPosition && (e.graveyardPosition = e.graveyardPosition._getTransformedBySplitOperation(n)), e.splitPosition.isEqual(n.insertionPosition) && t.abRelation == "splitBefore")
    return e.howMany++, [
      e
    ];
  if (n.splitPosition.isEqual(e.insertionPosition) && t.baRelation == "splitBefore") {
    const i = n.insertionPosition.path.slice();
    i.push(0);
    const r = new z(n.insertionPosition.root, i), s = new Ve(e.insertionPosition, 1, r, 0);
    return [
      e,
      s
    ];
  }
  return e.splitPosition.hasSameParentAs(n.splitPosition) && e.splitPosition.offset < n.splitPosition.offset && (e.howMany -= n.howMany), e.splitPosition = e.splitPosition._getTransformedBySplitOperation(n), e.insertionPosition = Xe.getInsertionPosition(e.splitPosition), [
    e
  ];
});
function Vp(e, n) {
  return e.targetPosition._getTransformedByDeletion(n.sourcePosition, n.howMany) === null;
}
function Vs(e, n) {
  const t = [];
  for (let i = 0; i < e.length; i++) {
    const r = e[i], s = new Ve(r.start, r.end.offset - r.start.offset, n, 0);
    t.push(s);
    for (let o = i + 1; o < e.length; o++)
      e[o] = e[o]._getTransformedByMove(s.sourcePosition, s.targetPosition, s.howMany)[0];
    n = n._getTransformedByMove(s.sourcePosition, s.targetPosition, s.howMany);
  }
  return t;
}
class mn extends (/* @__PURE__ */ Je(z)) {
  /**
  * Creates a live position.
  *
  * @see module:engine/model/position~Position
  */
  constructor(n, t, i = "toNone") {
    if (super(n, t, i), !this.root.is("rootElement"))
      throw new v("model-liveposition-root-not-rootelement", n);
    N6.call(this);
  }
  /**
  * Unbinds all events previously bound by `LivePosition`. Use it whenever you don't need `LivePosition` instance
  * anymore (i.e. when leaving scope in which it was declared or before re-assigning variable that was
  * referring to it).
  */
  detach() {
    this.stopListening();
  }
  /**
  * Creates a {@link module:engine/model/position~Position position instance}, which is equal to this live position.
  */
  toPosition() {
    return new z(this.root, this.path.slice(), this.stickiness);
  }
  /**
  * Creates a `LivePosition` instance that is equal to position.
  */
  static fromPosition(n, t) {
    return new this(n.root, n.path.slice(), t || n.stickiness);
  }
}
mn.prototype.is = function(e) {
  return e === "livePosition" || e === "model:livePosition" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e == "position" || e === "model:position";
};
function N6() {
  this.listenTo(this.root.document.model, "applyOperation", (e, n) => {
    const t = n[0];
    t.isDocumentOperation && R6.call(this, t);
  }, {
    priority: "low"
  });
}
function R6(e) {
  const n = this.getTransformedByOperation(e);
  if (!this.isEqual(n)) {
    const t = this.toPosition();
    this.path = n.path, this.root = n.root, this.fire("change", t);
  }
}
class As {
  /**
  * Creates a batch instance.
  *
  * @see module:engine/model/model~Model#enqueueChange
  * @see module:engine/model/model~Model#change
  * @param type A set of flags that specify the type of the batch. Batch type can alter how some of the features work
  * when encountering a given `Batch` instance (for example, when a feature listens to applied operations).
  */
  constructor(n = {}) {
    /**
    * An array of operations that compose this batch.
    */
    m(this, "operations");
    /**
    * Whether the batch can be undone through the undo feature.
    */
    m(this, "isUndoable");
    /**
    * Whether the batch includes operations created locally (`true`) or operations created on other, remote editors (`false`).
    */
    m(this, "isLocal");
    /**
    * Whether the batch was created by the undo feature and undoes other operations.
    */
    m(this, "isUndo");
    /**
    * Whether the batch includes operations connected with typing.
    */
    m(this, "isTyping");
    typeof n == "string" && (n = n === "transparent" ? {
      isUndoable: !1
    } : {}, at("batch-constructor-deprecated-string-type"));
    const { isUndoable: t = !0, isLocal: i = !0, isUndo: r = !1, isTyping: s = !1 } = n;
    this.operations = [], this.isUndoable = t, this.isLocal = i, this.isUndo = r, this.isTyping = s;
  }
  /**
  * The type of the batch.
  *
  * **This property has been deprecated and is always set to the `'default'` value.**
  *
  * It can be one of the following values:
  * * `'default'` &ndash; All "normal" batches. This is the most commonly used type.
  * * `'transparent'` &ndash; A batch that should be ignored by other features, i.e. an initial batch or collaborative editing
  * changes.
  *
  * @deprecated
  */
  get type() {
    return at("batch-type-deprecated"), "default";
  }
  /**
  * Returns the base version of this batch, which is equal to the base version of the first operation in the batch.
  * If there are no operations in the batch or neither operation has the base version set, it returns `null`.
  */
  get baseVersion() {
    for (const n of this.operations)
      if (n.baseVersion !== null)
        return n.baseVersion;
    return null;
  }
  /**
  * Adds an operation to the batch instance.
  *
  * @param operation An operation to add.
  * @returns The added operation.
  */
  addOperation(n) {
    return n.isDocumentOperation && (n.batch = this, this.operations.push(n)), n;
  }
}
const ka = class ka {
  /**
  * Creates a `Differ` instance.
  *
  * @param markerCollection Model's marker collection.
  */
  constructor(n) {
    /**
    * Reference to the model's marker collection.
    */
    m(this, "_markerCollection");
    /**
    * A map that stores changes that happened in a given element.
    *
    * The keys of the map are references to the model elements.
    * The values of the map are arrays with changes that were done on this element.
    */
    m(this, "_changesInElement", /* @__PURE__ */ new Map());
    /**
    * Stores a snapshot for these model nodes that might have changed.
    *
    * This complements {@link ~Differ#_elementChildrenSnapshots `_elementChildrenSnapshots`}.
    *
    * See also {@link ~DifferSnapshot}.
    */
    m(this, "_elementsSnapshots", /* @__PURE__ */ new Map());
    /**
    * For each element or document fragment inside which there was a change, it stores a snapshot of the child nodes list (an array
    * of children snapshots that represent the state in the element / fragment before any change has happened).
    *
    * This complements {@link ~Differ#_elementsSnapshots `_elementsSnapshots`}.
    *
    * See also {@link ~DifferSnapshot}.
    */
    m(this, "_elementChildrenSnapshots", /* @__PURE__ */ new Map());
    /**
    * Keeps the state for a given element, describing how the element was changed so far. It is used to evaluate the `action` property
    * of diff items returned by {@link ~Differ#getChanges}.
    *
    * Possible values, in the order from the lowest priority to the highest priority:
    *
    * * `'refresh'` - element was refreshed,
    * * `'rename'` - element was renamed,
    * * `'move'` - element was moved (or, usually, removed, that is moved to the graveyard).
    *
    * Element that was refreshed, may change its state to `'rename'` if it was later renamed, or to `'move'` if it was removed.
    * But the element cannot change its state from `'move'` to `'rename'`, or from `'rename'` to `'refresh'`.
    *
    * Only already existing elements are registered in `_elementState`. If a new element was inserted as a result of a buffered operation,
    * it is not be registered in `_elementState`.
    */
    m(this, "_elementState", /* @__PURE__ */ new Map());
    /**
    * A map that stores all changed markers.
    *
    * The keys of the map are marker names.
    *
    * The values of the map are objects with the following properties:
    *
    * * `oldMarkerData`,
    * * `newMarkerData`.
    */
    m(this, "_changedMarkers", /* @__PURE__ */ new Map());
    /**
    * A map that stores all roots that have been changed.
    *
    * The keys are the names of the roots while value represents the changes.
    */
    m(this, "_changedRoots", /* @__PURE__ */ new Map());
    /**
    * Stores the number of changes that were processed. Used to order the changes chronologically. It is important
    * when changes are sorted.
    */
    m(this, "_changeCount", 0);
    /**
    * For efficiency purposes, `Differ` stores the change set returned by the differ after {@link #getChanges} call.
    * Cache is reset each time a new operation is buffered. If the cache has not been reset, {@link #getChanges} will
    * return the cached value instead of calculating it again.
    *
    * This property stores those changes that did not take place in graveyard root.
    */
    m(this, "_cachedChanges", null);
    /**
    * For efficiency purposes, `Differ` stores the change set returned by the differ after the {@link #getChanges} call.
    * The cache is reset each time a new operation is buffered. If the cache has not been reset, {@link #getChanges} will
    * return the cached value instead of calculating it again.
    *
    * This property stores all changes evaluated by `Differ`, including those that took place in the graveyard.
    */
    m(this, "_cachedChangesWithGraveyard", null);
    /**
    * Set of model items that were marked to get refreshed in {@link #_refreshItem}.
    */
    m(this, "_refreshedItems", /* @__PURE__ */ new Set());
    this._markerCollection = n;
  }
  /**
  * Informs whether there are any changes buffered in `Differ`.
  */
  get isEmpty() {
    return this._changesInElement.size == 0 && this._changedMarkers.size == 0 && this._changedRoots.size == 0;
  }
  /**
  * Buffers the given operation. **An operation has to be buffered before it is executed.**
  *
  * @param operationToBuffer An operation to buffer.
  */
  bufferOperation(n) {
    const t = n;
    switch (t.type) {
      case "insert": {
        if (this._isInInsertedElement(t.position.parent))
          return;
        this._markInsert(t.position.parent, t.position.offset, t.nodes.maxOffset);
        break;
      }
      case "addAttribute":
      case "removeAttribute":
      case "changeAttribute": {
        for (const i of t.range.getItems({
          shallow: !0
        }))
          this._isInInsertedElement(i.parent) || this._markAttribute(i);
        break;
      }
      case "remove":
      case "move":
      case "reinsert": {
        if (t.sourcePosition.isEqual(t.targetPosition) || t.sourcePosition.getShiftedBy(t.howMany).isEqual(t.targetPosition))
          return;
        const i = this._isInInsertedElement(t.sourcePosition.parent), r = this._isInInsertedElement(t.targetPosition.parent);
        i || this._markRemove(t.sourcePosition.parent, t.sourcePosition.offset, t.howMany), r || this._markInsert(t.targetPosition.parent, t.getMovedRangeStart().offset, t.howMany);
        const s = B._createFromPositionAndShift(t.sourcePosition, t.howMany);
        for (const o of s.getItems({
          shallow: !0
        }))
          this._setElementState(o, "move");
        break;
      }
      case "rename": {
        if (this._isInInsertedElement(t.position.parent))
          return;
        this._markRemove(t.position.parent, t.position.offset, 1), this._markInsert(t.position.parent, t.position.offset, 1);
        const i = B._createFromPositionAndShift(t.position, 1);
        for (const r of this._markerCollection.getMarkersIntersectingRange(i)) {
          const s = r.getData();
          this.bufferMarkerChange(r.name, s, s);
        }
        this._setElementState(t.position.nodeAfter, "rename");
        break;
      }
      case "split": {
        const i = t.splitPosition.parent;
        if (!this._isInInsertedElement(i)) {
          this._markRemove(i, t.splitPosition.offset, t.howMany);
          const r = B._createFromPositionAndShift(t.splitPosition, t.howMany);
          for (const s of r.getItems({
            shallow: !0
          }))
            this._setElementState(s, "move");
        }
        this._isInInsertedElement(t.insertionPosition.parent) || this._markInsert(t.insertionPosition.parent, t.insertionPosition.offset, 1), t.graveyardPosition && (this._markRemove(t.graveyardPosition.parent, t.graveyardPosition.offset, 1), this._setElementState(t.graveyardPosition.nodeAfter, "move"));
        break;
      }
      case "merge": {
        const i = t.sourcePosition.parent;
        this._isInInsertedElement(i.parent) || this._markRemove(i.parent, i.startOffset, 1);
        const r = t.graveyardPosition.parent;
        this._markInsert(r, t.graveyardPosition.offset, 1), this._setElementState(i, "move");
        const s = t.targetPosition.parent;
        if (!this._isInInsertedElement(s)) {
          this._markInsert(s, t.targetPosition.offset, i.maxOffset);
          const o = B._createFromPositionAndShift(t.sourcePosition, t.howMany);
          for (const a of o.getItems({
            shallow: !0
          }))
            this._setElementState(a, "move");
        }
        break;
      }
      case "detachRoot":
      case "addRoot": {
        const i = t.affectedSelectable;
        if (!i._isLoaded || i.isAttached() == t.isAdd)
          return;
        this._bufferRootStateChange(t.rootName, t.isAdd);
        break;
      }
      case "addRootAttribute":
      case "removeRootAttribute":
      case "changeRootAttribute": {
        if (!t.root._isLoaded)
          return;
        const i = t.root.rootName;
        this._bufferRootAttributeChange(i, t.key, t.oldValue, t.newValue);
        break;
      }
    }
    this._cachedChanges = null;
  }
  /**
  * Buffers a marker change.
  *
  * @param markerName The name of the marker that changed.
  * @param oldMarkerData Marker data before the change.
  * @param newMarkerData Marker data after the change.
  */
  bufferMarkerChange(n, t, i) {
    t.range && t.range.root.is("rootElement") && !t.range.root._isLoaded && (t.range = null), i.range && i.range.root.is("rootElement") && !i.range.root._isLoaded && (i.range = null);
    let r = this._changedMarkers.get(n);
    r ? r.newMarkerData = i : (r = {
      newMarkerData: i,
      oldMarkerData: t
    }, this._changedMarkers.set(n, r)), r.oldMarkerData.range == null && i.range == null && this._changedMarkers.delete(n);
  }
  /**
  * Returns all markers that should be removed as a result of buffered changes.
  *
  * @returns Markers to remove. Each array item is an object containing the `name` and `range` properties.
  */
  getMarkersToRemove() {
    const n = [];
    for (const [t, i] of this._changedMarkers)
      i.oldMarkerData.range != null && n.push({
        name: t,
        range: i.oldMarkerData.range
      });
    return n;
  }
  /**
  * Returns all markers which should be added as a result of buffered changes.
  *
  * @returns Markers to add. Each array item is an object containing the `name` and `range` properties.
  */
  getMarkersToAdd() {
    const n = [];
    for (const [t, i] of this._changedMarkers)
      i.newMarkerData.range != null && n.push({
        name: t,
        range: i.newMarkerData.range
      });
    return n;
  }
  /**
  * Returns all markers which changed.
  */
  getChangedMarkers() {
    return Array.from(this._changedMarkers).map(([n, t]) => ({
      name: n,
      data: {
        oldRange: t.oldMarkerData.range,
        newRange: t.newMarkerData.range
      }
    }));
  }
  /**
  * Checks whether some of the buffered changes affect the editor data.
  *
  * Types of changes which affect the editor data:
  *
  * * model structure changes,
  * * attribute changes,
  * * a root is added or detached,
  * * changes of markers which were defined as `affectsData`,
  * * changes of markers' `affectsData` property.
  */
  hasDataChanges() {
    if (this.getChanges().length || this._changedRoots.size > 0)
      return !0;
    for (const { newMarkerData: n, oldMarkerData: t } of this._changedMarkers.values()) {
      if (n.affectsData !== t.affectsData)
        return !0;
      if (n.affectsData) {
        const i = n.range && !t.range, r = !n.range && t.range, s = n.range && t.range && !n.range.isEqual(t.range);
        if (i || r || s)
          return !0;
      }
    }
    return !1;
  }
  /**
  * Calculates the diff between the old model tree state (the state before the first buffered operations since the last {@link #reset}
  * call) and the new model tree state (actual one). It should be called after all buffered operations are executed.
  *
  * The diff set is returned as an array of {@link module:engine/model/differ~DiffItem diff items}, each describing a change done
  * on the model. The items are sorted by the position on which the change happened. If a position
  * {@link module:engine/model/position~Position#isBefore is before} another one, it will be on an earlier index in the diff set.
  *
  * **Note**: Elements inside inserted element will not have a separate diff item, only the top most element change will be reported.
  *
  * Because calculating the diff is a costly operation, the result is cached. If no new operation was buffered since the
  * previous {@link #getChanges} call, the next call will return the cached value.
  *
  * @param options Additional options.
  * @param options.includeChangesInGraveyard If set to `true`, also changes that happened
  * in the graveyard root will be returned. By default, changes in the graveyard root are not returned.
  * @returns Diff between the old and the new model tree state.
  */
  getChanges(n = {}) {
    if (this._cachedChanges)
      return n.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
    let t = [];
    for (const i of this._changesInElement.keys()) {
      const r = this._changesInElement.get(i).sort((c, d) => c.offset === d.offset ? c.type != d.type ? c.type == "remove" ? -1 : 1 : 0 : c.offset < d.offset ? -1 : 1), s = this._elementChildrenSnapshots.get(i), o = Wp(i.getChildren()), a = L6(s.length, r);
      let u = 0, l = 0;
      for (const c of a)
        if (c === "i") {
          const d = this._getDiffActionForNode(o[u].node, "insert"), p = this._elementsSnapshots.get(o[u].node), g = this._getInsertDiff(i, u, d, o[u], p);
          t.push(g), u++;
        } else if (c === "r") {
          const d = this._getDiffActionForNode(s[l].node, "remove"), p = this._getRemoveDiff(i, u, d, s[l]);
          t.push(p), l++;
        } else if (c === "a") {
          const d = s[l].attributes, p = o[u].attributes;
          let g;
          if (o[u].name == "$text")
            g = new B(z._createAt(i, u), z._createAt(i, u + 1));
          else {
            const _ = i.offsetToIndex(u);
            g = new B(z._createAt(i, u), z._createAt(i.getChild(_), 0));
          }
          const b = this._getAttributesDiff(g, d, p);
          t.push(...b), u++, l++;
        } else
          u++, l++;
    }
    t.sort((i, r) => i.position.root != r.position.root ? i.position.root.rootName < r.position.root.rootName ? -1 : 1 : i.position.isEqual(r.position) ? i.changeCount - r.changeCount : i.position.isBefore(r.position) ? -1 : 1);
    for (let i = 1, r = 0; i < t.length; i++) {
      const s = t[r], o = t[i], a = s.type == "remove" && o.type == "remove" && s.name == "$text" && o.name == "$text" && s.position.isEqual(o.position), u = s.type == "insert" && o.type == "insert" && s.name == "$text" && o.name == "$text" && s.position.parent == o.position.parent && s.position.offset + s.length == o.position.offset, l = s.type == "attribute" && o.type == "attribute" && s.position.parent == o.position.parent && s.range.isFlat && o.range.isFlat && s.position.offset + s.length == o.position.offset && s.attributeKey == o.attributeKey && s.attributeOldValue == o.attributeOldValue && s.attributeNewValue == o.attributeNewValue;
      a || u || l ? (s.length++, l && (s.range.end = s.range.end.getShiftedBy(1)), t[i] = null) : r = i;
    }
    t = t.filter((i) => i);
    for (const i of t)
      delete i.changeCount, i.type == "attribute" && (delete i.position, delete i.length);
    return this._changeCount = 0, this._cachedChangesWithGraveyard = t, this._cachedChanges = t.filter(D6), n.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
  }
  /**
  * Returns all roots that have changed (either were attached, or detached, or their attributes changed).
  *
  * @returns Diff between the old and the new roots state.
  */
  getChangedRoots() {
    return Array.from(this._changedRoots.values()).map((n) => {
      const t = {
        ...n
      };
      return t.state !== void 0 && delete t.attributes, t;
    });
  }
  /**
  * Returns a set of model items that were marked to get refreshed.
  */
  getRefreshedItems() {
    return new Set(this._refreshedItems);
  }
  /**
  * Resets `Differ`. Removes all buffered changes.
  */
  reset() {
    this._changesInElement.clear(), this._elementChildrenSnapshots.clear(), this._elementsSnapshots.clear(), this._elementState.clear(), this._changedMarkers.clear(), this._changedRoots.clear(), this._refreshedItems.clear(), this._cachedChanges = null;
  }
  /**
  * Marks the given `item` in differ to be "refreshed". It means that the item will be marked as removed and inserted
  * in the differ changes set, so it will be effectively re-converted when the differ changes are handled by a dispatcher.
  *
  * @internal
  * @param item Item to refresh.
  */
  _refreshItem(n) {
    if (this._isInInsertedElement(n.parent))
      return;
    this._markRemove(n.parent, n.startOffset, n.offsetSize), this._markInsert(n.parent, n.startOffset, n.offsetSize), this._refreshedItems.add(n), this._setElementState(n, "refresh");
    const t = B._createOn(n);
    for (const i of this._markerCollection.getMarkersIntersectingRange(t)) {
      const r = i.getData();
      this.bufferMarkerChange(i.name, r, r);
    }
    this._cachedChanges = null;
  }
  /**
  * Buffers all the data related to given root like it was all just added to the editor.
  *
  * Following changes are buffered:
  *
  * * root is attached,
  * * all root content is inserted,
  * * all root attributes are added,
  * * all markers inside the root are added.
  *
  * @internal
  */
  _bufferRootLoad(n) {
    if (n.isAttached()) {
      this._bufferRootStateChange(n.rootName, !0), this._markInsert(n, 0, n.maxOffset);
      for (const t of n.getAttributeKeys())
        this._bufferRootAttributeChange(n.rootName, t, null, n.getAttribute(t));
      for (const t of this._markerCollection)
        if (t.getRange().root == n) {
          const i = t.getData();
          this.bufferMarkerChange(t.name, {
            ...i,
            range: null
          }, i);
        }
    }
  }
  /**
  * Buffers the root state change after the root was attached or detached
  */
  _bufferRootStateChange(n, t) {
    if (!this._changedRoots.has(n)) {
      this._changedRoots.set(n, {
        name: n,
        state: t ? "attached" : "detached"
      });
      return;
    }
    const i = this._changedRoots.get(n);
    i.state !== void 0 ? (delete i.state, i.attributes === void 0 && this._changedRoots.delete(n)) : i.state = t ? "attached" : "detached";
  }
  /**
  * Buffers a root attribute change.
  */
  _bufferRootAttributeChange(n, t, i, r) {
    const s = this._changedRoots.get(n) || {
      name: n
    }, o = s.attributes || {};
    if (o[t]) {
      const a = o[t];
      r === a.oldValue ? delete o[t] : a.newValue = r;
    } else
      o[t] = {
        oldValue: i,
        newValue: r
      };
    Object.entries(o).length === 0 ? (delete s.attributes, s.state === void 0 && this._changedRoots.delete(n)) : (s.attributes = o, this._changedRoots.set(n, s));
  }
  /**
  * Saves and handles an insert change.
  */
  _markInsert(n, t, i) {
    if (n.root.is("rootElement") && !n.root._isLoaded)
      return;
    const r = {
      type: "insert",
      offset: t,
      howMany: i,
      count: this._changeCount++
    };
    this._markChange(n, r);
  }
  /**
  * Saves and handles a remove change.
  */
  _markRemove(n, t, i) {
    if (n.root.is("rootElement") && !n.root._isLoaded)
      return;
    const r = {
      type: "remove",
      offset: t,
      howMany: i,
      count: this._changeCount++
    };
    this._markChange(n, r), this._removeAllNestedChanges(n, t, i);
  }
  /**
  * Saves and handles an attribute change.
  */
  _markAttribute(n) {
    if (n.root.is("rootElement") && !n.root._isLoaded)
      return;
    const t = {
      type: "attribute",
      offset: n.startOffset,
      howMany: n.offsetSize,
      count: this._changeCount++
    };
    this._markChange(n.parent, t);
  }
  /**
  * Saves and handles a model change.
  */
  _markChange(n, t) {
    this._makeSnapshots(n);
    const i = this._getChangesForElement(n);
    this._handleChange(t, i), i.push(t);
    for (let r = 0; r < i.length; r++)
      i[r].howMany < 1 && (i.splice(r, 1), r--);
  }
  /**
  * Tries to set given state for given item.
  *
  * This method does simple validation (it sets the state only for model elements, not for text proxy nodes). It also follows state
  * setting rules, that is, `'refresh'` cannot overwrite `'rename'`, and `'rename'` cannot overwrite `'move'`.
  */
  _setElementState(n, t) {
    if (!n.is("element"))
      return;
    const i = ka._statesPriority.indexOf(this._elementState.get(n));
    ka._statesPriority.indexOf(t) > i && this._elementState.set(n, t);
  }
  /**
  * Returns a value for {@link ~DifferItemAction `action`} property for diff items returned by {@link ~Differ#getChanges}.
  * This method aims to return `'rename'` or `'refresh'` when it should, and `diffItemType` ("default action") in all other cases.
  *
  * It bases on a few factors:
  *
  * * for text nodes, the method always returns `diffItemType`,
  * * for newly inserted element, the method returns `diffItemType`,
  * * if {@link ~Differ#_elementState element state} was not recorded, the method returns `diffItemType`,
  * * if state was recorded, and it was `'move'` (default action), the method returns `diffItemType`,
  * * finally, if state was `'refresh'` or `'rename'`, the method returns the state value.
  */
  _getDiffActionForNode(n, t) {
    if (!n.is("element") || !this._elementsSnapshots.has(n))
      return t;
    const i = this._elementState.get(n);
    return !i || i == "move" ? t : i;
  }
  /**
  * Gets an array of changes that have already been saved for a given element.
  */
  _getChangesForElement(n) {
    let t;
    return this._changesInElement.has(n) ? t = this._changesInElement.get(n) : (t = [], this._changesInElement.set(n, t)), t;
  }
  /**
  * Creates and saves a snapshot for all children of the given element.
  */
  _makeSnapshots(n) {
    if (this._elementChildrenSnapshots.has(n))
      return;
    const t = Wp(n.getChildren());
    this._elementChildrenSnapshots.set(n, t);
    for (const i of t)
      this._elementsSnapshots.set(i.node, i);
  }
  /**
  * For a given newly saved change, compares it with a change already done on the element and modifies the incoming
  * change and/or the old change.
  *
  * @param inc Incoming (new) change.
  * @param changes An array containing all the changes done on that element.
  */
  _handleChange(n, t) {
    n.nodesToHandle = n.howMany;
    for (const i of t) {
      const r = n.offset + n.howMany, s = i.offset + i.howMany;
      if (n.type == "insert" && (i.type == "insert" && (n.offset <= i.offset ? i.offset += n.howMany : n.offset < s && (i.howMany += n.nodesToHandle, n.nodesToHandle = 0)), i.type == "remove" && n.offset < i.offset && (i.offset += n.howMany), i.type == "attribute")) {
        if (n.offset <= i.offset)
          i.offset += n.howMany;
        else if (n.offset < s) {
          const o = i.howMany;
          i.howMany = n.offset - i.offset, t.unshift({
            type: "attribute",
            offset: r,
            howMany: o - i.howMany,
            count: this._changeCount++
          });
        }
      }
      if (n.type == "remove") {
        if (i.type == "insert") {
          if (r <= i.offset)
            i.offset -= n.howMany;
          else if (r <= s)
            if (n.offset < i.offset) {
              const o = r - i.offset;
              i.offset = n.offset, i.howMany -= o, n.nodesToHandle -= o;
            } else
              i.howMany -= n.nodesToHandle, n.nodesToHandle = 0;
          else if (n.offset <= i.offset)
            n.nodesToHandle -= i.howMany, i.howMany = 0;
          else if (n.offset < s) {
            const o = s - n.offset;
            i.howMany -= o, n.nodesToHandle -= o;
          }
        }
        if (i.type == "remove" && (r <= i.offset ? i.offset -= n.howMany : n.offset < i.offset && (n.nodesToHandle += i.howMany, i.howMany = 0)), i.type == "attribute") {
          if (r <= i.offset)
            i.offset -= n.howMany;
          else if (n.offset < i.offset) {
            const o = r - i.offset;
            i.offset = n.offset, i.howMany -= o;
          } else if (n.offset < s)
            if (r <= s) {
              const o = i.howMany;
              i.howMany = n.offset - i.offset;
              const a = o - i.howMany - n.nodesToHandle;
              t.unshift({
                type: "attribute",
                offset: n.offset,
                howMany: a,
                count: this._changeCount++
              });
            } else
              i.howMany -= s - n.offset;
        }
      }
      if (n.type == "attribute") {
        if (i.type == "insert")
          if (n.offset < i.offset && r > i.offset) {
            if (r > s) {
              const o = {
                type: "attribute",
                offset: s,
                howMany: r - s,
                count: this._changeCount++
              };
              this._handleChange(o, t), t.push(o);
            }
            n.nodesToHandle = i.offset - n.offset, n.howMany = n.nodesToHandle;
          } else n.offset >= i.offset && n.offset < s && (r > s ? (n.nodesToHandle = r - s, n.offset = s) : n.nodesToHandle = 0);
        if (i.type == "remove" && n.offset < i.offset && r > i.offset) {
          const o = {
            type: "attribute",
            offset: i.offset,
            howMany: r - i.offset,
            count: this._changeCount++
          };
          this._handleChange(o, t), t.push(o), n.nodesToHandle = i.offset - n.offset, n.howMany = n.nodesToHandle;
        }
        i.type == "attribute" && (n.offset >= i.offset && r <= s ? (n.nodesToHandle = 0, n.howMany = 0, n.offset = 0) : n.offset <= i.offset && r >= s && (i.howMany = 0));
      }
    }
    n.howMany = n.nodesToHandle, delete n.nodesToHandle;
  }
  /**
  * Returns an object with a single insert change description.
  *
  * @param parent The element in which the change happened.
  * @param offset The offset at which change happened.
  * @param action Further specifies what kind of action led to generating this change.
  * @param elementSnapshot Snapshot of the inserted node after changes.
  * @param elementSnapshotBefore Snapshot of the inserted node before changes.
  * @returns The diff item.
  */
  _getInsertDiff(n, t, i, r, s) {
    const o = {
      type: "insert",
      position: z._createAt(n, t),
      name: r.name,
      attributes: new Map(r.attributes),
      length: 1,
      changeCount: this._changeCount++,
      action: i
    };
    return i != "insert" && s && (o.before = {
      name: s.name,
      attributes: new Map(s.attributes)
    }), o;
  }
  /**
  * Returns an object with a single remove change description.
  *
  * @param parent The element in which change happened.
  * @param offset The offset at which change happened.
  * @param action Further specifies what kind of action led to generating this change.
  * @param elementSnapshot The snapshot of the removed node before changes.
  * @returns The diff item.
  */
  _getRemoveDiff(n, t, i, r) {
    return {
      type: "remove",
      action: i,
      position: z._createAt(n, t),
      name: r.name,
      attributes: new Map(r.attributes),
      length: 1,
      changeCount: this._changeCount++
    };
  }
  /**
  * Returns an array of objects where each one is a single attribute change description.
  *
  * @param range The range where the change happened.
  * @param oldAttributes A map, map iterator or compatible object that contains attributes before the change.
  * @param newAttributes A map, map iterator or compatible object that contains attributes after the change.
  * @returns An array containing one or more diff items.
  */
  _getAttributesDiff(n, t, i) {
    const r = [];
    i = new Map(i);
    for (const [s, o] of t) {
      const a = i.has(s) ? i.get(s) : null;
      a !== o && r.push({
        type: "attribute",
        position: n.start,
        range: n.clone(),
        length: 1,
        attributeKey: s,
        attributeOldValue: o,
        attributeNewValue: a,
        changeCount: this._changeCount++
      }), i.delete(s);
    }
    for (const [s, o] of i)
      r.push({
        type: "attribute",
        position: n.start,
        range: n.clone(),
        length: 1,
        attributeKey: s,
        attributeOldValue: null,
        attributeNewValue: o,
        changeCount: this._changeCount++
      });
    return r;
  }
  /**
  * Checks whether given element or any of its parents is an element that is buffered as an inserted element.
  */
  _isInInsertedElement(n) {
    const t = n.parent;
    if (!t)
      return !1;
    const i = this._changesInElement.get(t), r = n.startOffset;
    if (i) {
      for (const s of i)
        if (s.type == "insert" && r >= s.offset && r < s.offset + s.howMany)
          return !0;
    }
    return this._isInInsertedElement(t);
  }
  /**
  * Removes deeply all buffered changes that are registered in elements from range specified by `parent`, `offset`
  * and `howMany`.
  */
  _removeAllNestedChanges(n, t, i) {
    const r = new B(z._createAt(n, t), z._createAt(n, t + i));
    for (const s of r.getItems({
      shallow: !0
    }))
      s.is("element") && (this._changesInElement.delete(s), this._removeAllNestedChanges(s, 0, s.maxOffset));
  }
};
/**
* Priority of the {@link ~Differ#_elementState element states}. States on higher indexes of the array can overwrite states on the lower
* indexes.
*/
m(ka, "_statesPriority", [
  void 0,
  "refresh",
  "rename",
  "move"
]);
let Lh = ka;
function $p(e) {
  return {
    node: e,
    name: e.is("$text") ? "$text" : e.name,
    attributes: new Map(e.getAttributes())
  };
}
function Wp(e) {
  const n = [];
  for (const t of e)
    if (t.is("$text"))
      for (let i = 0; i < t.data.length; ++i)
        n.push($p(t));
    else
      n.push($p(t));
  return n;
}
function L6(e, n) {
  const t = [];
  let i = 0, r = 0;
  for (const s of n) {
    if (s.offset > i) {
      for (let o = 0; o < s.offset - i; o++)
        t.push("e");
      r += s.offset - i;
    }
    if (s.type == "insert") {
      for (let o = 0; o < s.howMany; o++)
        t.push("i");
      i = s.offset + s.howMany;
    } else if (s.type == "remove") {
      for (let o = 0; o < s.howMany; o++)
        t.push("r");
      i = s.offset, r += s.howMany;
    } else {
      if (s.howMany > 1500)
        for (let o = 0; o < s.howMany; o++)
          t.push("a");
      else
        t.push(..."a".repeat(s.howMany).split(""));
      i = s.offset + s.howMany, r += s.howMany;
    }
  }
  if (r < e)
    for (let s = 0; s < e - r - i; s++)
      t.push("e");
  return t;
}
function D6(e) {
  const n = "position" in e && e.position.root.rootName == "$graveyard", t = "range" in e && e.range.root.rootName == "$graveyard";
  return !n && !t;
}
class M6 {
  constructor() {
    /**
    * Operations added to the history.
    */
    m(this, "_operations", []);
    /**
    * Holds an information which {@link module:engine/model/operation/operation~Operation operation} undoes which
    * {@link module:engine/model/operation/operation~Operation operation}.
    *
    * Keys of the map are "undoing operations", that is operations that undone some other operations. For each key, the
    * value is an operation that has been undone by the "undoing operation".
    */
    m(this, "_undoPairs", /* @__PURE__ */ new Map());
    /**
    * Holds all undone operations.
    */
    m(this, "_undoneOperations", /* @__PURE__ */ new Set());
    /**
    * A map that allows retrieving the operations fast based on the given base version.
    */
    m(this, "_baseVersionToOperationIndex", /* @__PURE__ */ new Map());
    /**
    * The history version.
    */
    m(this, "_version", 0);
    /**
    * The gap pairs kept in the <from,to> format.
    *
    * Anytime the `history.version` is set to a version larger than `history.version + 1`,
    * a new <lastHistoryVersion, newHistoryVersion> entry is added to the map.
    */
    m(this, "_gaps", /* @__PURE__ */ new Map());
  }
  /**
  * The version of the last operation in the history.
  *
  * The history version is incremented automatically when a new operation is added to the history.
  * Setting the version manually should be done only in rare circumstances when a gap is planned
  * between history versions. When doing so, a gap will be created and the history will accept adding
  * an operation with base version equal to the new history version.
  */
  get version() {
    return this._version;
  }
  set version(n) {
    this._operations.length && n > this._version + 1 && this._gaps.set(this._version, n), this._version = n;
  }
  /**
  * The last history operation.
  */
  get lastOperation() {
    return this._operations[this._operations.length - 1];
  }
  /**
  * Adds an operation to the history and increments the history version.
  *
  * The operation's base version should be equal to the history version. Otherwise an error is thrown.
  */
  addOperation(n) {
    if (n.baseVersion !== this.version)
      throw new v("model-document-history-addoperation-incorrect-version", this, {
        operation: n,
        historyVersion: this.version
      });
    this._operations.push(n), this._version++, this._baseVersionToOperationIndex.set(n.baseVersion, this._operations.length - 1);
  }
  /**
  * Returns operations from the given range of operation base versions that were added to the history.
  *
  * Note that there may be gaps in operations base versions.
  *
  * @param fromBaseVersion Base version from which operations should be returned (inclusive).
  * @param toBaseVersion Base version up to which operations should be returned (exclusive).
     * @returns History operations for the given range, in chronological order.
  */
  getOperations(n, t = this.version) {
    if (!this._operations.length)
      return [];
    const i = this._operations[0];
    n === void 0 && (n = i.baseVersion);
    let r = t - 1;
    for (const [a, u] of this._gaps)
      n > a && n < u && (n = u), r > a && r < u && (r = a - 1);
    if (r < i.baseVersion || n > this.lastOperation.baseVersion)
      return [];
    let s = this._baseVersionToOperationIndex.get(n);
    s === void 0 && (s = 0);
    let o = this._baseVersionToOperationIndex.get(r);
    return o === void 0 && (o = this._operations.length - 1), this._operations.slice(
      s,
      // The `toIndex` should be included in the returned operations, so add `1`.
      o + 1
    );
  }
  /**
  * Returns operation from the history that bases on given `baseVersion`.
  *
  * @param baseVersion Base version of the operation to get.
  * @returns Operation with given base version or `undefined` if there is no such operation in history.
  */
  getOperation(n) {
    const t = this._baseVersionToOperationIndex.get(n);
    if (t !== void 0)
      return this._operations[t];
  }
  /**
  * Marks in history that one operation is an operation that is undoing the other operation. By marking operation this way,
  * history is keeping more context information about operations, which helps in operational transformation.
  *
  * @param undoneOperation Operation which is undone by `undoingOperation`.
  * @param undoingOperation Operation which undoes `undoneOperation`.
  */
  setOperationAsUndone(n, t) {
    this._undoPairs.set(t, n), this._undoneOperations.add(n);
  }
  /**
  * Checks whether given `operation` is undoing any other operation.
  *
  * @param operation Operation to check.
  * @returns `true` if given `operation` is undoing any other operation, `false` otherwise.
  */
  isUndoingOperation(n) {
    return this._undoPairs.has(n);
  }
  /**
  * Checks whether given `operation` has been undone by any other operation.
  *
  * @param operation Operation to check.
  * @returns `true` if given `operation` has been undone any other operation, `false` otherwise.
  */
  isUndoneOperation(n) {
    return this._undoneOperations.has(n);
  }
  /**
  * For given `undoingOperation`, returns the operation which has been undone by it.
  *
  * @returns Operation that has been undone by given `undoingOperation` or `undefined`
  * if given `undoingOperation` is not undoing any other operation.
  */
  getUndoneOperation(n) {
    return this._undoPairs.get(n);
  }
  /**
  * Resets the history of operations.
  */
  reset() {
    this._version = 0, this._undoPairs = /* @__PURE__ */ new Map(), this._operations = [], this._undoneOperations = /* @__PURE__ */ new Set(), this._gaps = /* @__PURE__ */ new Map(), this._baseVersionToOperationIndex = /* @__PURE__ */ new Map();
  }
}
class yl extends rt {
  /**
  * Creates root element.
  *
  * @param document Document that is an owner of this root.
  * @param name Node name.
  * @param rootName Unique root name used to identify this root element by {@link module:engine/model/document~Document}.
  */
  constructor(t, i, r = "main") {
    super(i);
    /**
    * Unique root name used to identify this root element by {@link module:engine/model/document~Document}.
    */
    m(this, "rootName");
    /**
    * Document that is an owner of this root.
    */
    m(this, "_document");
    /**
    * @internal
    */
    m(this, "_isAttached", !0);
    /**
    * Informs if the root element is loaded (default).
    *
    * @internal
    */
    m(this, "_isLoaded", !0);
    this._document = t, this.rootName = r;
  }
  /**
  * {@link module:engine/model/document~Document Document} that owns this root element.
  */
  get document() {
    return this._document;
  }
  /**
  * Informs if the root element is currently attached to the document, or not.
  *
  * A detached root is equivalent to being removed and cannot contain any children or markers.
  *
  * By default, a newly added root is attached. It can be detached using
  * {@link module:engine/model/writer~Writer#detachRoot `Writer#detachRoot`}. A detached root can be re-attached again using
  * {@link module:engine/model/writer~Writer#addRoot `Writer#addRoot`}.
  */
  isAttached() {
    return this._isAttached;
  }
  /**
  * Converts `RootElement` instance to `string` containing its name.
  *
  * @returns `RootElement` instance converted to `string`.
  */
  toJSON() {
    return this.rootName;
  }
}
yl.prototype.is = function(e, n) {
  return n ? n === this.name && (e === "rootElement" || e === "model:rootElement" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === "element" || e === "model:element") : e === "rootElement" || e === "model:rootElement" || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
  e === "element" || e === "model:element" || e === "node" || e === "model:node";
};
const zp = "$graveyard";
class B6 extends (/* @__PURE__ */ Je()) {
  /**
  * Creates an empty document instance with no {@link #roots} (other than
  * the {@link #graveyard graveyard root}).
  */
  constructor(t) {
    super();
    /**
    * The {@link module:engine/model/model~Model model} that the document is a part of.
    */
    m(this, "model");
    /**
    * The document's history.
    */
    m(this, "history");
    /**
    * The selection in this document.
    */
    m(this, "selection");
    /**
    * A list of roots that are owned and managed by this document. Use {@link #createRoot}, {@link #getRoot} and
    * {@link #getRootNames} to manipulate it.
    */
    m(this, "roots");
    /**
    * The model differ object. Its role is to buffer changes done on the model document and then calculate a diff of those changes.
    */
    m(this, "differ");
    /**
    * Defines whether the document is in a read-only mode.
    *
    * The user should not be able to change the data of a document that is read-only.
    *
    * @readonly
    */
    m(this, "isReadOnly");
    /**
    * Post-fixer callbacks registered to the model document.
    */
    m(this, "_postFixers");
    /**
    * A flag that indicates whether the selection has changed since last change block.
    */
    m(this, "_hasSelectionChangedFromTheLastChangeBlock");
    this.model = t, this.history = new M6(), this.selection = new oi(this), this.roots = new Qi({
      idProperty: "rootName"
    }), this.differ = new Lh(t.markers), this.isReadOnly = !1, this._postFixers = /* @__PURE__ */ new Set(), this._hasSelectionChangedFromTheLastChangeBlock = !1, this.createRoot("$root", zp), this.listenTo(t, "applyOperation", (i, r) => {
      const s = r[0];
      s.isDocumentOperation && this.differ.bufferOperation(s);
    }, {
      priority: "high"
    }), this.listenTo(t, "applyOperation", (i, r) => {
      const s = r[0];
      s.isDocumentOperation && this.history.addOperation(s);
    }, {
      priority: "low"
    }), this.listenTo(this.selection, "change", () => {
      this._hasSelectionChangedFromTheLastChangeBlock = !0;
    }), this.listenTo(t.markers, "update", (i, r, s, o, a) => {
      const u = {
        ...r.getData(),
        range: o
      };
      this.differ.bufferMarkerChange(r.name, a, u), s === null && r.on("change", (l, c) => {
        const d = r.getData();
        this.differ.bufferMarkerChange(r.name, {
          ...d,
          range: c
        }, d);
      });
    }), this.registerPostFixer((i) => {
      let r = !1;
      for (const s of this.roots)
        !s.isAttached() && !s.isEmpty && (i.remove(i.createRangeIn(s)), r = !0);
      for (const s of this.model.markers)
        s.getRange().root.isAttached() || (i.removeMarker(s), r = !0);
      return r;
    });
  }
  /**
  * The document version. Every applied operation increases the version number. It is used to
  * ensure that operations are applied on a proper document version.
  *
  * This property is equal to {@link module:engine/model/history~History#version `model.Document#history#version`}.
  *
  * If the {@link module:engine/model/operation/operation~Operation#baseVersion base version} does not match the document version,
  * a {@link module:utils/ckeditorerror~CKEditorError model-document-applyoperation-wrong-version} error is thrown.
  */
  get version() {
    return this.history.version;
  }
  set version(t) {
    this.history.version = t;
  }
  /**
  * The graveyard tree root. A document always has a graveyard root that stores removed nodes.
  */
  get graveyard() {
    return this.getRoot(zp);
  }
  /**
  * Creates a new root.
  *
  * **Note:** do not use this method after the editor has been initialized! If you want to dynamically add a root, use
  * {@link module:engine/model/writer~Writer#addRoot `model.Writer#addRoot`} instead.
  *
  * @param elementName The element name. Defaults to `'$root'` which also has some basic schema defined
  * (e.g. `$block` elements are allowed inside the `$root`). Make sure to define a proper schema if you use a different name.
  * @param rootName A unique root name.
  * @returns The created root.
  */
  createRoot(t = "$root", i = "main") {
    if (this.roots.get(i))
      throw new v("model-document-createroot-name-exists", this, {
        name: i
      });
    const r = new yl(this, t, i);
    return this.roots.add(r), r;
  }
  /**
  * Removes all event listeners set by the document instance.
  */
  destroy() {
    this.selection.destroy(), this.stopListening();
  }
  /**
  * Returns a root by its name.
  *
  * Detached roots are returned by this method. This is to be able to operate on the detached root (for example, to be able to create
  * a position inside such a root for undo feature purposes).
  *
  * @param name The root name of the root to return.
  * @returns The root registered under a given name or `null` when there is no root with the given name.
  */
  getRoot(t = "main") {
    return this.roots.get(t);
  }
  /**
  * Returns an array with names of all roots added to the document (except the {@link #graveyard graveyard root}).
  *
  * Detached roots **are not** returned by this method by default. This is to make sure that all features or algorithms that operate
  * on the document data know which roots are still a part of the document and should be processed.
  *
  * @param includeDetached Specified whether detached roots should be returned as well.
  */
  getRootNames(t = !1) {
    return this.getRoots(t).map((i) => i.rootName);
  }
  /**
  * Returns an array with all roots added to the document (except the {@link #graveyard graveyard root}).
  *
  * Detached roots **are not** returned by this method by default. This is to make sure that all features or algorithms that operate
  * on the document data know which roots are still a part of the document and should be processed.
  *
  * @param includeDetached Specified whether detached roots should be returned as well.
  */
  getRoots(t = !1) {
    return this.roots.filter((i) => i != this.graveyard && (t || i.isAttached()) && i._isLoaded);
  }
  /**
  * Used to register a post-fixer callback. A post-fixer mechanism guarantees that the features
  * will operate on a correct model state.
  *
  * An execution of a feature may lead to an incorrect document tree state. The callbacks are used to fix the document tree after
  * it has changed. Post-fixers are fired just after all changes from the outermost change block were applied but
  * before the {@link module:engine/model/document~Document#event:change change event} is fired. If a post-fixer callback made
  * a change, it should return `true`. When this happens, all post-fixers are fired again to check if something else should
  * not be fixed in the new document tree state.
  *
  * As a parameter, a post-fixer callback receives a {@link module:engine/model/writer~Writer writer} instance connected with the
  * executed changes block. Thanks to that, all changes done by the callback will be added to the same
  * {@link module:engine/model/batch~Batch batch} (and undo step) as the original changes. This makes post-fixer changes transparent
  * for the user.
  *
  * An example of a post-fixer is a callback that checks if all the data were removed from the editor. If so, the
  * callback should add an empty paragraph so that the editor is never empty:
  *
  * ```ts
  * document.registerPostFixer( writer => {
  * 	const changes = document.differ.getChanges();
  *
  * 	// Check if the changes lead to an empty root in the editor.
  * 	for ( const entry of changes ) {
  * 		if ( entry.type == 'remove' && entry.position.root.isEmpty ) {
  * 			writer.insertElement( 'paragraph', entry.position.root, 0 );
  *
  * 			// It is fine to return early, even if multiple roots would need to be fixed.
  * 			// All post-fixers will be fired again, so if there are more empty roots, those will be fixed, too.
  * 			return true;
  * 		}
  * 	}
  *
  * 	return false;
  * } );
  * ```
  */
  registerPostFixer(t) {
    this._postFixers.add(t);
  }
  /**
  * A custom `toJSON()` method to solve child-parent circular dependencies.
  *
  * @returns A clone of this object with the document property changed to a string.
  */
  toJSON() {
    const t = hE(this);
    return t.selection = "[engine.model.DocumentSelection]", t.model = "[engine.model.Model]", t;
  }
  /**
  * Check if there were any changes done on document, and if so, call post-fixers,
  * fire `change` event for features and conversion and then reset the differ.
  * Fire `change:data` event when at least one operation or buffered marker changes the data.
  *
  * @internal
  * @fires change
  * @fires change:data
  * @param writer The writer on which post-fixers will be called.
  */
  _handleChangeBlock(t) {
    this._hasDocumentChangedFromTheLastChangeBlock() && (this._callPostFixers(t), this.selection.refresh(), this.differ.hasDataChanges() ? this.fire("change:data", t.batch) : this.fire("change", t.batch), this.selection.refresh(), this.differ.reset()), this._hasSelectionChangedFromTheLastChangeBlock = !1;
  }
  /**
  * Returns whether there is a buffered change or if the selection has changed from the last
  * {@link module:engine/model/model~Model#enqueueChange `enqueueChange()` block}
  * or {@link module:engine/model/model~Model#change `change()` block}.
  *
  * @returns Returns `true` if document has changed from the last `change()` or `enqueueChange()` block.
  */
  _hasDocumentChangedFromTheLastChangeBlock() {
    return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
  }
  /**
  * Returns the default root for this document which is either the first root that was added to the document using
  * {@link #createRoot} or the {@link #graveyard graveyard root} if no other roots were created.
  *
  * @returns The default root for this document.
  */
  _getDefaultRoot() {
    const t = this.getRoots();
    return t.length ? t[0] : this.graveyard;
  }
  /**
  * Returns the default range for this selection. The default range is a collapsed range that starts and ends
  * at the beginning of this selection's document {@link #_getDefaultRoot default root}.
  *
  * @internal
  */
  _getDefaultRange() {
    const t = this._getDefaultRoot(), i = this.model, r = i.schema, s = i.createPositionFromPath(t, [
      0
    ]);
    return r.getNearestSelectionRange(s) || i.createRange(s);
  }
  /**
  * Checks whether a given {@link module:engine/model/range~Range range} is a valid range for
  * the {@link #selection document's selection}.
  *
  * @internal
  * @param range A range to check.
  * @returns `true` if `range` is valid, `false` otherwise.
  */
  _validateSelectionRange(t) {
    return t.start.isValid() && t.end.isValid() && qp(t.start) && qp(t.end);
  }
  /**
  * Performs post-fixer loops. Executes post-fixer callbacks as long as none of them has done any changes to the model.
  *
  * @param writer The writer on which post-fixer callbacks will be called.
  */
  _callPostFixers(t) {
    let i = !1;
    do
      for (const r of this._postFixers)
        if (this.selection.refresh(), i = r(t), i)
          break;
    while (i);
  }
}
function qp(e) {
  const n = e.textNode;
  if (n) {
    const t = n.data, i = e.offset - n.startOffset;
    return !qf(t, i) && !Yf(t, i);
  }
  return !0;
}
class F6 extends (/* @__PURE__ */ Je()) {
  constructor() {
    super(...arguments);
    /**
    * Stores {@link ~Marker markers} added to the collection.
    */
    m(this, "_markers", /* @__PURE__ */ new Map());
  }
  /**
  * Iterable interface.
  *
  * Iterates over all {@link ~Marker markers} added to the collection.
  */
  [Symbol.iterator]() {
    return this._markers.values();
  }
  /**
  * Checks if given {@link ~Marker marker} or marker name is in the collection.
  *
  * @param markerOrName Name of marker or marker instance to check.
  * @returns `true` if marker is in the collection, `false` otherwise.
  */
  has(t) {
    const i = t instanceof Bs ? t.name : t;
    return this._markers.has(i);
  }
  /**
  * Returns {@link ~Marker marker} with given `markerName`.
  *
  * @param markerName Name of marker to get.
  * @returns Marker with given name or `null` if such marker was
  * not added to the collection.
  */
  get(t) {
    return this._markers.get(t) || null;
  }
  /**
  * Creates and adds a {@link ~Marker marker} to the `MarkerCollection` with given name on given
  * {@link module:engine/model/range~Range range}.
  *
  * If `MarkerCollection` already had a marker with given name (or {@link ~Marker marker} was passed), the marker in
  * collection is updated and {@link module:engine/model/markercollection~MarkerCollection#event:update} event is fired
  * but only if there was a change (marker range or {@link module:engine/model/markercollection~Marker#managedUsingOperations}
  * flag has changed.
  *
  * @internal
  * @fires update
  * @param markerOrName Name of marker to set or marker instance to update.
  * @param range Marker range.
  * @param managedUsingOperations Specifies whether the marker is managed using operations.
  * @param affectsData Specifies whether the marker affects the data produced by the data pipeline
  * (is persisted in the editor's data).
  * @returns `Marker` instance which was added or updated.
  */
  _set(t, i, r = !1, s = !1) {
    const o = t instanceof Bs ? t.name : t;
    if (o.includes(","))
      throw new v("markercollection-incorrect-marker-name", this);
    const a = this._markers.get(o);
    if (a) {
      const c = a.getData(), d = a.getRange();
      let p = !1;
      return d.isEqual(i) || (a._attachLiveRange(xn.fromRange(i)), p = !0), r != a.managedUsingOperations && (a._managedUsingOperations = r, p = !0), typeof s == "boolean" && s != a.affectsData && (a._affectsData = s, p = !0), p && this.fire(`update:${o}`, a, d, i, c), a;
    }
    const u = xn.fromRange(i), l = new Bs(o, u, r, s);
    return this._markers.set(o, l), this.fire(`update:${o}`, l, null, i, {
      ...l.getData(),
      range: null
    }), l;
  }
  /**
  * Removes given {@link ~Marker marker} or a marker with given name from the `MarkerCollection`.
  *
  * @internal
  * @fires update
  * @param markerOrName Marker or name of a marker to remove.
  * @returns `true` if marker was found and removed, `false` otherwise.
  */
  _remove(t) {
    const i = t instanceof Bs ? t.name : t, r = this._markers.get(i);
    return r ? (this._markers.delete(i), this.fire(`update:${i}`, r, r.getRange(), null, r.getData()), this._destroyMarker(r), !0) : !1;
  }
  /**
  * Fires an {@link module:engine/model/markercollection~MarkerCollection#event:update} event for the given {@link ~Marker marker}
  * but does not change the marker. Useful to force {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher downcast
  * conversion} for the marker.
  *
  * @internal
  * @fires update
  * @param markerOrName Marker or name of a marker to refresh.
  */
  _refresh(t) {
    const i = t instanceof Bs ? t.name : t, r = this._markers.get(i);
    if (!r)
      throw new v("markercollection-refresh-marker-not-exists", this);
    const s = r.getRange();
    this.fire(`update:${i}`, r, s, s, r.getData());
  }
  /**
  * Returns iterator that iterates over all markers, which ranges contain given {@link module:engine/model/position~Position position}.
  */
  *getMarkersAtPosition(t) {
    for (const i of this)
      i.getRange().containsPosition(t) && (yield i);
  }
  /**
  * Returns iterator that iterates over all markers, which intersects with given {@link module:engine/model/range~Range range}.
  */
  *getMarkersIntersectingRange(t) {
    for (const i of this)
      i.getRange().getIntersection(t) !== null && (yield i);
  }
  /**
  * Destroys marker collection and all markers inside it.
  */
  destroy() {
    for (const t of this._markers.values())
      this._destroyMarker(t);
    this._markers = null, this.stopListening();
  }
  /**
  * Iterates over all markers that starts with given `prefix`.
  *
  * ```ts
  * const markerFooA = markersCollection._set( 'foo:a', rangeFooA );
  * const markerFooB = markersCollection._set( 'foo:b', rangeFooB );
  * const markerBarA = markersCollection._set( 'bar:a', rangeBarA );
  * const markerFooBarA = markersCollection._set( 'foobar:a', rangeFooBarA );
  * Array.from( markersCollection.getMarkersGroup( 'foo' ) ); // [ markerFooA, markerFooB ]
  * Array.from( markersCollection.getMarkersGroup( 'a' ) ); // []
  * ```
  */
  *getMarkersGroup(t) {
    for (const i of this._markers.values())
      i.name.startsWith(t + ":") && (yield i);
  }
  /**
  * Destroys the marker.
  */
  _destroyMarker(t) {
    t.stopListening(), t._detachLiveRange();
  }
}
class Bs extends (/* @__PURE__ */ Je(Ir)) {
  /**
  * Creates a marker instance.
  *
  * @param name Marker name.
  * @param liveRange Range marked by the marker.
  * @param managedUsingOperations Specifies whether the marker is managed using operations.
  * @param affectsData Specifies whether the marker affects the data produced by the data pipeline (is persisted in the editor's data).
  */
  constructor(t, i, r, s) {
    super();
    /**
    * Marker's name.
    */
    m(this, "name");
    /**
    * Flag indicates if the marker is managed using operations or not.
    *
    * @internal
    */
    m(this, "_managedUsingOperations");
    /**
    * Specifies whether the marker affects the data produced by the data pipeline
    * (is persisted in the editor's data).
    *
    * @internal
    */
    m(this, "_affectsData");
    /**
    * Range marked by the marker.
    */
    m(this, "_liveRange");
    this.name = t, this._liveRange = this._attachLiveRange(i), this._managedUsingOperations = r, this._affectsData = s;
  }
  /**
  * A value indicating if the marker is managed using operations.
  * See {@link ~Marker marker class description} to learn more about marker types.
  * See {@link module:engine/model/writer~Writer#addMarker}.
  */
  get managedUsingOperations() {
    if (!this._liveRange)
      throw new v("marker-destroyed", this);
    return this._managedUsingOperations;
  }
  /**
  * A value indicating if the marker changes the data.
  */
  get affectsData() {
    if (!this._liveRange)
      throw new v("marker-destroyed", this);
    return this._affectsData;
  }
  /**
  * Returns the marker data (properties defining the marker).
  */
  getData() {
    return {
      range: this.getRange(),
      affectsData: this.affectsData,
      managedUsingOperations: this.managedUsingOperations
    };
  }
  /**
  * Returns current marker start position.
  */
  getStart() {
    if (!this._liveRange)
      throw new v("marker-destroyed", this);
    return this._liveRange.start.clone();
  }
  /**
  * Returns current marker end position.
  */
  getEnd() {
    if (!this._liveRange)
      throw new v("marker-destroyed", this);
    return this._liveRange.end.clone();
  }
  /**
  * Returns a range that represents the current state of the marker.
  *
  * Keep in mind that returned value is a {@link module:engine/model/range~Range Range}, not a
  * {@link module:engine/model/liverange~LiveRange LiveRange}. This means that it is up-to-date and relevant only
  * until next model document change. Do not store values returned by this method. Instead, store {@link ~Marker#name}
  * and get `Marker` instance from {@link module:engine/model/markercollection~MarkerCollection MarkerCollection} every
  * time there is a need to read marker properties. This will guarantee that the marker has not been removed and
  * that it's data is up-to-date.
  */
  getRange() {
    if (!this._liveRange)
      throw new v("marker-destroyed", this);
    return this._liveRange.toRange();
  }
  /**
  * Binds new live range to the marker and detach the old one if is attached.
  *
  * @internal
  * @param liveRange Live range to attach
  * @returns Attached live range.
  */
  _attachLiveRange(t) {
    return this._liveRange && this._detachLiveRange(), t.delegate("change:range").to(this), t.delegate("change:content").to(this), this._liveRange = t, t;
  }
  /**
  * Unbinds and destroys currently attached live range.
  *
  * @internal
  */
  _detachLiveRange() {
    this._liveRange.stopDelegating("change:range", this), this._liveRange.stopDelegating("change:content", this), this._liveRange.detach(), this._liveRange = null;
  }
}
Bs.prototype.is = function(e) {
  return e === "marker" || e === "model:marker";
};
class U6 extends Rn {
  /**
  * Creates an insert operation.
  *
  * @param sourcePosition Position before the first {@link module:engine/model/item~Item model item} to move.
  * @param howMany Offset size of moved range. Moved range will start from `sourcePosition` and end at
  * `sourcePosition` with offset shifted by `howMany`.
  */
  constructor(t, i) {
    super(null);
    /**
    * Position before the first {@link module:engine/model/item~Item model item} to detach.
    */
    m(this, "sourcePosition");
    /**
    * Offset size of moved range.
    */
    m(this, "howMany");
    this.sourcePosition = t.clone(), this.howMany = i;
  }
  /**
  * @inheritDoc
  */
  get type() {
    return "detach";
  }
  /**
  * @inheritDoc
  */
  get affectedSelectable() {
    return null;
  }
  /**
  * @inheritDoc
  */
  toJSON() {
    const t = super.toJSON();
    return t.sourcePosition = this.sourcePosition.toJSON(), t;
  }
  /**
  * @inheritDoc
  * @internal
  */
  _validate() {
    if (this.sourcePosition.root.document)
      throw new v("detach-operation-on-document-node", this);
  }
  /**
  * @inheritDoc
  * @internal
  */
  _execute() {
    kT(B._createFromPositionAndShift(this.sourcePosition, this.howMany));
  }
  /**
  * @inheritDoc
  */
  static get className() {
    return "DetachOperation";
  }
}
class bi extends Ir {
  /**
  * Creates an empty `DocumentFragment`.
  *
  * **Note:** Constructor of this class shouldn't be used directly in the code.
  * Use the {@link module:engine/model/writer~Writer#createDocumentFragment} method instead.
  *
  * @internal
  * @param children Nodes to be contained inside the `DocumentFragment`.
  */
  constructor(t) {
    super();
    /**
    * DocumentFragment static markers map. This is a list of names and {@link module:engine/model/range~Range ranges}
    * which will be set as Markers to {@link module:engine/model/model~Model#markers model markers collection}
    * when DocumentFragment will be inserted to the document.
    */
    m(this, "markers", /* @__PURE__ */ new Map());
    /**
    * List of nodes contained inside the document fragment.
    */
    m(this, "_children", new ua());
    t && this._insertChild(0, t);
  }
  /**
  * Returns an iterator that iterates over all nodes contained inside this document fragment.
  */
  [Symbol.iterator]() {
    return this.getChildren();
  }
  /**
  * Number of this document fragment's children.
  */
  get childCount() {
    return this._children.length;
  }
  /**
  * Sum of {@link module:engine/model/node~Node#offsetSize offset sizes} of all of this document fragment's children.
  */
  get maxOffset() {
    return this._children.maxOffset;
  }
  /**
  * Is `true` if there are no nodes inside this document fragment, `false` otherwise.
  */
  get isEmpty() {
    return this.childCount === 0;
  }
  /**
  * Artificial next sibling. Returns `null`. Added for compatibility reasons.
  */
  get nextSibling() {
    return null;
  }
  /**
  * Artificial previous sibling. Returns `null`. Added for compatibility reasons.
  */
  get previousSibling() {
    return null;
  }
  /**
  * Artificial root of `DocumentFragment`. Returns itself. Added for compatibility reasons.
  */
  get root() {
    return this;
  }
  /**
  * Artificial parent of `DocumentFragment`. Returns `null`. Added for compatibility reasons.
  */
  get parent() {
    return null;
  }
  /**
  * Artificial owner of `DocumentFragment`. Returns `null`. Added for compatibility reasons.
  */
  get document() {
    return null;
  }
  /**
  * Returns `false` as `DocumentFragment` by definition is not attached to a document. Added for compatibility reasons.
  */
  isAttached() {
    return !1;
  }
  /**
  * Returns empty array. Added for compatibility reasons.
  */
  getAncestors() {
    return [];
  }
  /**
  * Gets the child at the given index. Returns `null` if incorrect index was passed.
  *
  * @param index Index in this document fragment.
  * @returns Child node.
  */
  getChild(t) {
    return this._children.getNode(t);
  }
  /**
  * Gets the child at the given offset. Returns `null` if incorrect index was passed.
  *
  * @param offset Offset in this document fragment.
  * @returns Child node.
  */
  getChildAtOffset(t) {
    return this._children.getNodeAtOffset(t);
  }
  /**
  * Returns an iterator that iterates over all of this document fragment's children.
  */
  getChildren() {
    return this._children[Symbol.iterator]();
  }
  /**
  * Returns an index of the given child node. Returns `null` if given node is not a child of this document fragment.
  *
  * @param node Child node to look for.
  * @returns Child node's index.
  */
  getChildIndex(t) {
    return this._children.getNodeIndex(t);
  }
  /**
  * Returns the starting offset of given child. Starting offset is equal to the sum of
  * {@link module:engine/model/node~Node#offsetSize offset sizes} of all node's siblings that are before it. Returns `null` if
  * given node is not a child of this document fragment.
  *
  * @param node Child node to look for.
  * @returns Child node's starting offset.
  */
  getChildStartOffset(t) {
    return this._children.getNodeStartOffset(t);
  }
  /**
  * Returns path to a `DocumentFragment`, which is an empty array. Added for compatibility reasons.
  */
  getPath() {
    return [];
  }
  /**
  * Returns a descendant node by its path relative to this element.
  *
  * ```ts
  * // <this>a<b>c</b></this>
  * this.getNodeByPath( [ 0 ] );     // -> "a"
  * this.getNodeByPath( [ 1 ] );     // -> <b>
  * this.getNodeByPath( [ 1, 0 ] );  // -> "c"
  * ```
  *
  * @param relativePath Path of the node to find, relative to this element.
  */
  getNodeByPath(t) {
    let i = this;
    for (const r of t)
      i = i.getChildAtOffset(r);
    return i;
  }
  /**
  * Converts offset "position" to index "position".
  *
  * Returns index of a node that occupies given offset. If given offset is too low, returns `0`. If given offset is
  * too high, returns index after last child.
  *
  * ```ts
  * const textNode = new Text( 'foo' );
  * const pElement = new Element( 'p' );
  * const docFrag = new DocumentFragment( [ textNode, pElement ] );
  * docFrag.offsetToIndex( -1 ); // Returns 0, because offset is too low.
  * docFrag.offsetToIndex( 0 ); // Returns 0, because offset 0 is taken by `textNode` which is at index 0.
  * docFrag.offsetToIndex( 1 ); // Returns 0, because `textNode` has `offsetSize` equal to 3, so it occupies offset 1 too.
  * docFrag.offsetToIndex( 2 ); // Returns 0.
  * docFrag.offsetToIndex( 3 ); // Returns 1.
  * docFrag.offsetToIndex( 4 ); // Returns 2. There are no nodes at offset 4, so last available index is returned.
  * ```
  *
  * @param offset Offset to look for.
  * @returns Index of a node that occupies given offset.
  */
  offsetToIndex(t) {
    return this._children.offsetToIndex(t);
  }
  /**
  * Converts `DocumentFragment` instance to plain object and returns it.
  * Takes care of converting all of this document fragment's children.
  *
  * @returns `DocumentFragment` instance converted to plain object.
  */
  toJSON() {
    const t = [];
    for (const i of this._children)
      t.push(i.toJSON());
    return t;
  }
  /**
  * Creates a `DocumentFragment` instance from given plain object (i.e. parsed JSON string).
  * Converts `DocumentFragment` children to proper nodes.
  *
  * @param json Plain object to be converted to `DocumentFragment`.
  * @returns `DocumentFragment` instance created using given plain object.
  */
  static fromJSON(t) {
    const i = [];
    for (const r of t)
      r.name ? i.push(rt.fromJSON(r)) : i.push(st.fromJSON(r));
    return new bi(i);
  }
  /**
  * {@link #_insertChild Inserts} one or more nodes at the end of this document fragment.
  *
  * @internal
  * @param items Items to be inserted.
  */
  _appendChild(t) {
    this._insertChild(this.childCount, t);
  }
  /**
  * Inserts one or more nodes at the given index and sets {@link module:engine/model/node~Node#parent parent} of these nodes
  * to this document fragment.
  *
  * @internal
  * @param index Index at which nodes should be inserted.
  * @param items Items to be inserted.
  */
  _insertChild(t, i) {
    const r = H6(i);
    for (const s of r)
      s.parent !== null && s._remove(), s.parent = this;
    this._children._insertNodes(t, r);
  }
  /**
  * Removes one or more nodes starting at the given index
  * and sets {@link module:engine/model/node~Node#parent parent} of these nodes to `null`.
  *
  * @internal
  * @param index Index of the first node to remove.
  * @param howMany Number of nodes to remove.
  * @returns Array containing removed nodes.
  */
  _removeChildren(t, i = 1) {
    const r = this._children._removeNodes(t, i);
    for (const s of r)
      s.parent = null;
    return r;
  }
  /**
  * Removes children nodes provided as an array and sets
  * the {@link module:engine/model/node~Node#parent parent} of these nodes to `null`.
  *
  * These nodes do not need to be direct siblings.
  *
  * This method is faster than removing nodes one by one, as it recalculates offsets only once.
  *
  * @internal
  * @param nodes Array of nodes.
  */
  _removeChildrenArray(t) {
    this._children._removeNodesArray(t);
    for (const i of t)
      i.parent = null;
  }
}
bi.prototype.is = function(e) {
  return e === "documentFragment" || e === "model:documentFragment";
};
function H6(e) {
  return typeof e == "string" ? [
    new st(e)
  ] : (Nn(e) || (e = [
    e
  ]), Array.from(e).map((n) => typeof n == "string" ? new st(n) : n instanceof ii ? new st(n.data, n.getAttributes()) : n));
}
class V6 {
  /**
  * Creates a writer instance.
  *
  * **Note:** It is not recommended to use it directly. Use {@link module:engine/model/model~Model#change `Model#change()`} or
  * {@link module:engine/model/model~Model#enqueueChange `Model#enqueueChange()`} instead.
  *
  * @internal
  */
  constructor(n, t) {
    /**
    * Instance of the model on which this writer operates.
    */
    m(this, "model");
    /**
    * The batch to which this writer will add changes.
    */
    m(this, "batch");
    this.model = n, this.batch = t;
  }
  /**
  * Creates a new {@link module:engine/model/text~Text text node}.
  *
  * ```ts
  * writer.createText( 'foo' );
  * writer.createText( 'foo', { bold: true } );
  * ```
  *
  * @param data Text data.
  * @param attributes Text attributes.
  * @returns {module:engine/model/text~Text} Created text node.
  */
  createText(n, t) {
    return new st(n, t);
  }
  /**
  * Creates a new {@link module:engine/model/element~Element element}.
  *
  * ```ts
  * writer.createElement( 'paragraph' );
  * writer.createElement( 'paragraph', { alignment: 'center' } );
  * ```
  *
  * @param name Name of the element.
  * @param attributes Elements attributes.
  * @returns Created element.
  */
  createElement(n, t) {
    return new rt(n, t);
  }
  /**
  * Creates a new {@link module:engine/model/documentfragment~DocumentFragment document fragment}.
  *
  * @returns Created document fragment.
  */
  createDocumentFragment() {
    return new bi();
  }
  /**
  * Creates a copy of the element and returns it. Created element has the same name and attributes as the original element.
  * If clone is deep, the original element's children are also cloned. If not, then empty element is returned.
  *
  * @param element The element to clone.
  * @param deep If set to `true` clones element and all its children recursively. When set to `false`,
  * element will be cloned without any child.
  */
  cloneElement(n, t = !0) {
    return n._clone(t);
  }
  /**
  * Inserts item on given position.
  *
  * ```ts
  * const paragraph = writer.createElement( 'paragraph' );
  * writer.insert( paragraph, position );
  * ```
  *
  * Instead of using position you can use parent and offset:
  *
  * ```ts
  * const text = writer.createText( 'foo' );
  * writer.insert( text, paragraph, 5 );
  * ```
  *
  * You can also use `end` instead of the offset to insert at the end:
  *
  * ```ts
  * const text = writer.createText( 'foo' );
  * writer.insert( text, paragraph, 'end' );
  * ```
  *
  * Or insert before or after another element:
  *
  * ```ts
  * const paragraph = writer.createElement( 'paragraph' );
  * writer.insert( paragraph, anotherParagraph, 'after' );
  * ```
  *
  * These parameters works the same way as {@link #createPositionAt `writer.createPositionAt()`}.
  *
  * Note that if the item already has parent it will be removed from the previous parent.
  *
  * Note that you cannot re-insert a node from a document to a different document or a document fragment. In this case,
  * `model-writer-insert-forbidden-move` is thrown.
  *
  * If you want to move {@link module:engine/model/range~Range range} instead of an
  * {@link module:engine/model/item~Item item} use {@link module:engine/model/writer~Writer#move `Writer#move()`}.
  *
  * **Note:** For a paste-like content insertion mechanism see
  * {@link module:engine/model/model~Model#insertContent `model.insertContent()`}.
  *
  * @param item Item or document fragment to insert.
  * @param offset Offset or one of the flags. Used only when second parameter is a {@link module:engine/model/item~Item model item}.
  */
  insert(n, t, i = 0) {
    if (this._assertWriterUsedCorrectly(), n instanceof st && n.data == "")
      return;
    const r = z._createAt(t, i);
    if (n.parent)
      if (Kp(n.root, r.root)) {
        this.move(B._createOn(n), r);
        return;
      } else {
        if (n.root.document)
          throw new v("model-writer-insert-forbidden-move", this);
        this.remove(n);
      }
    const s = r.root.document ? r.root.document.version : null, o = n instanceof bi ? n._removeChildren(0, n.childCount) : n, a = new Wt(r, o, s);
    if (n instanceof st && (a.shouldReceiveAttributes = !0), this.batch.addOperation(a), this.model.applyOperation(a), n instanceof bi)
      for (const [u, l] of n.markers) {
        const c = z._createAt(l.root, 0), p = {
          range: new B(l.start._getCombined(c, r), l.end._getCombined(c, r)),
          usingOperation: !0,
          affectsData: !0
        };
        this.model.markers.has(u) ? this.updateMarker(u, p) : this.addMarker(u, p);
      }
  }
  insertText(n, t, i, r) {
    t instanceof bi || t instanceof rt || t instanceof z ? this.insert(this.createText(n), t, i) : this.insert(this.createText(n, t), i, r);
  }
  insertElement(n, t, i, r) {
    t instanceof bi || t instanceof rt || t instanceof z ? this.insert(this.createElement(n), t, i) : this.insert(this.createElement(n, t), i, r);
  }
  /**
  * Inserts item at the end of the given parent.
  *
  * ```ts
  * const paragraph = writer.createElement( 'paragraph' );
  * writer.append( paragraph, root );
  * ```
  *
  * Note that if the item already has parent it will be removed from the previous parent.
  *
  * If you want to move {@link module:engine/model/range~Range range} instead of an
  * {@link module:engine/model/item~Item item} use {@link module:engine/model/writer~Writer#move `Writer#move()`}.
  *
  * @param item Item or document fragment to insert.
  */
  append(n, t) {
    this.insert(n, t, "end");
  }
  appendText(n, t, i) {
    t instanceof bi || t instanceof rt ? this.insert(this.createText(n), t, "end") : this.insert(this.createText(n, t), i, "end");
  }
  appendElement(n, t, i) {
    t instanceof bi || t instanceof rt ? this.insert(this.createElement(n), t, "end") : this.insert(this.createElement(n, t), i, "end");
  }
  /**
  * Sets value of the attribute with given key on a {@link module:engine/model/item~Item model item}
  * or on a {@link module:engine/model/range~Range range}.
  *
  * @param key Attribute key.
  * @param value Attribute new value.
  * @param itemOrRange Model item or range on which the attribute will be set.
  */
  setAttribute(n, t, i) {
    if (this._assertWriterUsedCorrectly(), i instanceof B) {
      const r = i.getMinimalFlatRanges();
      for (const s of r)
        Yp(this, n, t, s);
    } else
      jp(this, n, t, i);
  }
  /**
  * Sets values of attributes on a {@link module:engine/model/item~Item model item}
  * or on a {@link module:engine/model/range~Range range}.
  *
  * ```ts
  * writer.setAttributes( {
  * 	bold: true,
  * 	italic: true
  * }, range );
  * ```
  *
  * @param attributes Attributes keys and values.
  * @param itemOrRange Model item or range on which the attributes will be set.
  */
  setAttributes(n, t) {
    for (const [i, r] of Si(n))
      this.setAttribute(i, r, t);
  }
  /**
  * Removes an attribute with given key from a {@link module:engine/model/item~Item model item}
  * or from a {@link module:engine/model/range~Range range}.
  *
  * @param key Attribute key.
  * @param itemOrRange Model item or range from which the attribute will be removed.
  */
  removeAttribute(n, t) {
    if (this._assertWriterUsedCorrectly(), t instanceof B) {
      const i = t.getMinimalFlatRanges();
      for (const r of i)
        Yp(this, n, null, r);
    } else
      jp(this, n, null, t);
  }
  /**
  * Removes all attributes from all elements in the range or from the given item.
  *
  * @param itemOrRange Model item or range from which all attributes will be removed.
  */
  clearAttributes(n) {
    this._assertWriterUsedCorrectly();
    const t = (i) => {
      for (const r of i.getAttributeKeys())
        this.removeAttribute(r, i);
    };
    if (!(n instanceof B))
      t(n);
    else
      for (const i of n.getItems())
        t(i);
  }
  /**
  * Moves all items in the source range to the target position.
  *
  * ```ts
  * writer.move( sourceRange, targetPosition );
  * ```
  *
  * Instead of the target position you can use parent and offset or define that range should be moved to the end
  * or before or after chosen item:
  *
  * ```ts
  * // Moves all items in the range to the paragraph at offset 5:
  * writer.move( sourceRange, paragraph, 5 );
  * // Moves all items in the range to the end of a blockquote:
  * writer.move( sourceRange, blockquote, 'end' );
  * // Moves all items in the range to a position after an image:
  * writer.move( sourceRange, image, 'after' );
  * ```
  *
  * These parameters work the same way as {@link #createPositionAt `writer.createPositionAt()`}.
  *
  * Note that items can be moved only within the same tree. It means that you can move items within the same root
  * (element or document fragment) or between {@link module:engine/model/document~Document#roots documents roots},
  * but you can not move items from document fragment to the document or from one detached element to another. Use
  * {@link module:engine/model/writer~Writer#insert} in such cases.
  *
  * @param range Source range.
  * @param offset Offset or one of the flags. Used only when second parameter is a {@link module:engine/model/item~Item model item}.
  */
  move(n, t, i) {
    if (this._assertWriterUsedCorrectly(), !(n instanceof B))
      throw new v("writer-move-invalid-range", this);
    if (!n.isFlat)
      throw new v("writer-move-range-not-flat", this);
    const r = z._createAt(t, i);
    if (r.isEqual(n.start))
      return;
    if (this._addOperationForAffectedMarkers("move", n), !Kp(n.root, r.root))
      throw new v("writer-move-different-document", this);
    const s = n.root.document ? n.root.document.version : null, o = new Ve(n.start, n.end.offset - n.start.offset, r, s);
    this.batch.addOperation(o), this.model.applyOperation(o);
  }
  /**
  * Removes given model {@link module:engine/model/item~Item item} or {@link module:engine/model/range~Range range}.
  *
  * @param itemOrRange Model item or range to remove.
  */
  remove(n) {
    this._assertWriterUsedCorrectly();
    const i = (n instanceof B ? n : B._createOn(n)).getMinimalFlatRanges().reverse();
    for (const r of i)
      this._addOperationForAffectedMarkers("move", r), $6(r.start, r.end.offset - r.start.offset, this.batch, this.model);
  }
  /**
  * Merges two siblings at the given position.
  *
  * Node before and after the position have to be an element. Otherwise `writer-merge-no-element-before` or
  * `writer-merge-no-element-after` error will be thrown.
  *
  * @param position Position between merged elements.
  */
  merge(n) {
    this._assertWriterUsedCorrectly();
    const t = n.nodeBefore, i = n.nodeAfter;
    if (this._addOperationForAffectedMarkers("merge", n), !(t instanceof rt))
      throw new v("writer-merge-no-element-before", this);
    if (!(i instanceof rt))
      throw new v("writer-merge-no-element-after", this);
    n.root.document ? this._merge(n) : this._mergeDetached(n);
  }
  /**
  * Shortcut for {@link module:engine/model/model~Model#createPositionFromPath `Model#createPositionFromPath()`}.
  *
  * @param root Root of the position.
  * @param path Position path. See {@link module:engine/model/position~Position#path}.
  * @param stickiness Position stickiness. See {@link module:engine/model/position~PositionStickiness}.
  */
  createPositionFromPath(n, t, i) {
    return this.model.createPositionFromPath(n, t, i);
  }
  /**
  * Shortcut for {@link module:engine/model/model~Model#createPositionAt `Model#createPositionAt()`}.
  *
  * @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/model/item~Item model item}.
  */
  createPositionAt(n, t) {
    return this.model.createPositionAt(n, t);
  }
  /**
  * Shortcut for {@link module:engine/model/model~Model#createPositionAfter `Model#createPositionAfter()`}.
  *
  * @param item Item after which the position should be placed.
  */
  createPositionAfter(n) {
    return this.model.createPositionAfter(n);
  }
  /**
  * Shortcut for {@link module:engine/model/model~Model#createPositionBefore `Model#createPositionBefore()`}.
  *
  * @param item Item after which the position should be placed.
  */
  createPositionBefore(n) {
    return this.model.createPositionBefore(n);
  }
  /**
  * Shortcut for {@link module:engine/model/model~Model#createRange `Model#createRange()`}.
  *
  * @param start Start position.
  * @param end End position. If not set, range will be collapsed at `start` position.
  */
  createRange(n, t) {
    return this.model.createRange(n, t);
  }
  /**
  * Shortcut for {@link module:engine/model/model~Model#createRangeIn `Model#createRangeIn()`}.
  *
  * @param element Element which is a parent for the range.
  */
  createRangeIn(n) {
    return this.model.createRangeIn(n);
  }
  /**
  * Shortcut for {@link module:engine/model/model~Model#createRangeOn `Model#createRangeOn()`}.
  *
  * @param element Element which is a parent for the range.
  */
  createRangeOn(n) {
    return this.model.createRangeOn(n);
  }
  createSelection(...n) {
    return this.model.createSelection(...n);
  }
  /**
  * Performs merge action in a detached tree.
  *
  * @param position Position between merged elements.
  */
  _mergeDetached(n) {
    const t = n.nodeBefore, i = n.nodeAfter;
    this.move(B._createIn(i), z._createAt(t, "end")), this.remove(i);
  }
  /**
  * Performs merge action in a non-detached tree.
  *
  * @param position Position between merged elements.
  */
  _merge(n) {
    const t = z._createAt(n.nodeBefore, "end"), i = z._createAt(n.nodeAfter, 0), r = n.root.document.graveyard, s = new z(r, [
      0
    ]), o = n.root.document.version, a = new Et(i, n.nodeAfter.maxOffset, t, s, o);
    this.batch.addOperation(a), this.model.applyOperation(a);
  }
  /**
  * Renames the given element.
  *
  * @param element The element to rename.
  * @param newName New element name.
  */
  rename(n, t) {
    if (this._assertWriterUsedCorrectly(), !(n instanceof rt))
      throw new v("writer-rename-not-element-instance", this);
    const i = n.root.document ? n.root.document.version : null, r = new bn(z._createBefore(n), n.name, t, i);
    this.batch.addOperation(r), this.model.applyOperation(r);
  }
  /**
  * Splits elements starting from the given position and going to the top of the model tree as long as given
  * `limitElement` is reached. When `limitElement` is not defined then only the parent of the given position will be split.
  *
  * The element needs to have a parent. It cannot be a root element nor a document fragment.
  * The `writer-split-element-no-parent` error will be thrown if you try to split an element with no parent.
  *
  * @param position Position of split.
  * @param limitElement Stop splitting when this element will be reached.
  * @returns Split result with properties:
  * * `position` - Position between split elements.
  * * `range` - Range that stars from the end of the first split element and ends at the beginning of the first copy element.
  */
  split(n, t) {
    this._assertWriterUsedCorrectly();
    let i = n.parent;
    if (!i.parent)
      throw new v("writer-split-element-no-parent", this);
    if (t || (t = i.parent), !n.parent.getAncestors({
      includeSelf: !0
    }).includes(t))
      throw new v("writer-split-invalid-limit-element", this);
    let r, s;
    do {
      const o = i.root.document ? i.root.document.version : null, a = i.maxOffset - n.offset, u = Xe.getInsertionPosition(n), l = new Xe(n, a, u, null, o);
      this.batch.addOperation(l), this.model.applyOperation(l), !r && !s && (r = i, s = n.parent.nextSibling), n = this.createPositionAfter(n.parent), i = n.parent;
    } while (i !== t);
    return {
      position: n,
      range: new B(z._createAt(r, "end"), z._createAt(s, 0))
    };
  }
  /**
  * Wraps the given range with the given element or with a new element (if a string was passed).
  *
  * **Note:** range to wrap should be a "flat range" (see {@link module:engine/model/range~Range#isFlat `Range#isFlat`}).
  * If not, an error will be thrown.
  *
  * @param range Range to wrap.
  * @param elementOrString Element or name of element to wrap the range with.
  */
  wrap(n, t) {
    if (this._assertWriterUsedCorrectly(), !n.isFlat)
      throw new v("writer-wrap-range-not-flat", this);
    const i = t instanceof rt ? t : new rt(t);
    if (i.childCount > 0)
      throw new v("writer-wrap-element-not-empty", this);
    if (i.parent !== null)
      throw new v("writer-wrap-element-attached", this);
    this.insert(i, n.start);
    const r = new B(n.start.getShiftedBy(1), n.end.getShiftedBy(1));
    this.move(r, z._createAt(i, 0));
  }
  /**
  * Unwraps children of the given element – all its children are moved before it and then the element is removed.
  * Throws error if you try to unwrap an element which does not have a parent.
  *
  * @param element Element to unwrap.
  */
  unwrap(n) {
    if (this._assertWriterUsedCorrectly(), n.parent === null)
      throw new v("writer-unwrap-element-no-parent", this);
    this.move(B._createIn(n), this.createPositionAfter(n)), this.remove(n);
  }
  /**
  * Adds a {@link module:engine/model/markercollection~Marker marker}. Marker is a named range, which tracks
  * changes in the document and updates its range automatically, when model tree changes.
  *
  * As the first parameter you can set marker name.
  *
  * The required `options.usingOperation` parameter lets you decide if the marker should be managed by operations or not. See
  * {@link module:engine/model/markercollection~Marker marker class description} to learn about the difference between
  * markers managed by operations and not-managed by operations.
  *
  * The `options.affectsData` parameter, which defaults to `false`, allows you to define if a marker affects the data. It should be
  * `true` when the marker change changes the data returned by the
  * {@link module:core/editor/editor~Editor#getData `editor.getData()`} method.
  * When set to `true` it fires the {@link module:engine/model/document~Document#event:change:data `change:data`} event.
  * When set to `false` it fires the {@link module:engine/model/document~Document#event:change `change`} event.
  *
  * Create marker directly base on marker's name:
  *
  * ```ts
  * addMarker( markerName, { range, usingOperation: false } );
  * ```
  *
  * Create marker using operation:
  *
  * ```ts
  * addMarker( markerName, { range, usingOperation: true } );
  * ```
  *
  * Create marker that affects the editor data:
  *
  * ```ts
  * addMarker( markerName, { range, usingOperation: false, affectsData: true } );
  * ```
  *
  * Note: For efficiency reasons, it's best to create and keep as little markers as possible.
  *
  * @see module:engine/model/markercollection~Marker
  * @param name Name of a marker to create - must be unique.
  * @param options.usingOperation Flag indicating that the marker should be added by MarkerOperation.
  * See {@link module:engine/model/markercollection~Marker#managedUsingOperations}.
  * @param options.range Marker range.
  * @param options.affectsData Flag indicating that the marker changes the editor data.
  * @returns Marker that was set.
  */
  addMarker(n, t) {
    if (this._assertWriterUsedCorrectly(), !t || typeof t.usingOperation != "boolean")
      throw new v("writer-addmarker-no-usingoperation", this);
    const i = t.usingOperation, r = t.range, s = t.affectsData === void 0 ? !1 : t.affectsData;
    if (this.model.markers.has(n))
      throw new v("writer-addmarker-marker-exists", this);
    if (!r)
      throw new v("writer-addmarker-no-range", this);
    return i ? (Do(this, n, null, r, s), this.model.markers.get(n)) : this.model.markers._set(n, r, i, s);
  }
  /**
  * Adds, updates or refreshes a {@link module:engine/model/markercollection~Marker marker}. Marker is a named range, which tracks
  * changes in the document and updates its range automatically, when model tree changes. Still, it is possible to change the
  * marker's range directly using this method.
  *
  * As the first parameter you can set marker name or instance. If none of them is provided, new marker, with a unique
  * name is created and returned.
  *
  * **Note**: If you want to change the {@link module:engine/view/element~Element view element} of the marker while its data in the model
  * remains the same, use the dedicated {@link module:engine/controller/editingcontroller~EditingController#reconvertMarker} method.
  *
  * The `options.usingOperation` parameter lets you change if the marker should be managed by operations or not. See
  * {@link module:engine/model/markercollection~Marker marker class description} to learn about the difference between
  * markers managed by operations and not-managed by operations. It is possible to change this option for an existing marker.
  *
  * The `options.affectsData` parameter, which defaults to `false`, allows you to define if a marker affects the data. It should be
  * `true` when the marker change changes the data returned by
  * the {@link module:core/editor/editor~Editor#getData `editor.getData()`} method.
  * When set to `true` it fires the {@link module:engine/model/document~Document#event:change:data `change:data`} event.
  * When set to `false` it fires the {@link module:engine/model/document~Document#event:change `change`} event.
  *
  * Update marker directly base on marker's name:
  *
  * ```ts
  * updateMarker( markerName, { range } );
  * ```
  *
  * Update marker using operation:
  *
  * ```ts
  * updateMarker( marker, { range, usingOperation: true } );
  * updateMarker( markerName, { range, usingOperation: true } );
  * ```
  *
  * Change marker's option (start using operations to manage it):
  *
  * ```ts
  * updateMarker( marker, { usingOperation: true } );
  * ```
  *
  * Change marker's option (inform the engine, that the marker does not affect the data anymore):
  *
  * ```ts
  * updateMarker( markerName, { affectsData: false } );
  * ```
  *
  * @see module:engine/model/markercollection~Marker
  * @param markerOrName Name of a marker to update, or a marker instance.
  * @param options If options object is not defined then marker will be refreshed by triggering
  * downcast conversion for this marker with the same data.
  * @param options.range Marker range to update.
  * @param options.usingOperation Flag indicated whether the marker should be added by MarkerOperation.
  * See {@link module:engine/model/markercollection~Marker#managedUsingOperations}.
  * @param options.affectsData Flag indicating that the marker changes the editor data.
  */
  updateMarker(n, t) {
    this._assertWriterUsedCorrectly();
    const i = typeof n == "string" ? n : n.name, r = this.model.markers.get(i);
    if (!r)
      throw new v("writer-updatemarker-marker-not-exists", this);
    if (!t) {
      at("writer-updatemarker-reconvert-using-editingcontroller", {
        markerName: i
      }), this.model.markers._refresh(r);
      return;
    }
    const s = typeof t.usingOperation == "boolean", o = typeof t.affectsData == "boolean", a = o ? t.affectsData : r.affectsData;
    if (!s && !t.range && !o)
      throw new v("writer-updatemarker-wrong-options", this);
    const u = r.getRange(), l = t.range ? t.range : u;
    if (s && t.usingOperation !== r.managedUsingOperations) {
      t.usingOperation ? Do(this, i, null, l, a) : (Do(this, i, u, null, a), this.model.markers._set(i, l, void 0, a));
      return;
    }
    r.managedUsingOperations ? Do(this, i, u, l, a) : this.model.markers._set(i, l, void 0, a);
  }
  /**
  * Removes given {@link module:engine/model/markercollection~Marker marker} or marker with given name.
  * The marker is removed accordingly to how it has been created, so if the marker was created using operation,
  * it will be destroyed using operation.
  *
  * @param markerOrName Marker or marker name to remove.
  */
  removeMarker(n) {
    this._assertWriterUsedCorrectly();
    const t = typeof n == "string" ? n : n.name;
    if (!this.model.markers.has(t))
      throw new v("writer-removemarker-no-marker", this);
    const i = this.model.markers.get(t);
    if (!i.managedUsingOperations) {
      this.model.markers._remove(t);
      return;
    }
    const r = i.getRange();
    Do(this, t, r, null, i.affectsData);
  }
  /**
  * Adds a new root to the document (or re-attaches a {@link #detachRoot detached root}).
  *
  * Throws an error, if trying to add a root that is already added and attached.
  *
  * @param rootName Name of the added root.
  * @param elementName The element name. Defaults to `'$root'` which also has some basic schema defined
  * (e.g. `$block` elements are allowed inside the `$root`). Make sure to define a proper schema if you use a different name.
  * @returns The added root element.
  */
  addRoot(n, t = "$root") {
    this._assertWriterUsedCorrectly();
    const i = this.model.document.getRoot(n);
    if (i && i.isAttached())
      throw new v("writer-addroot-root-exists", this);
    const r = this.model.document, s = new wi(n, t, !0, r, r.version);
    return this.batch.addOperation(s), this.model.applyOperation(s), this.model.document.getRoot(n);
  }
  /**
  * Detaches the root from the document.
  *
  * All content and markers are removed from the root upon detaching. New content and new markers cannot be added to the root, as long
  * as it is detached.
  *
  * A root cannot be fully removed from the document, it can be only detached. A root is permanently removed only after you
  * re-initialize the editor and do not specify the root in the initial data.
  *
  * A detached root can be re-attached using {@link #addRoot}.
  *
  * Throws an error if the root does not exist or the root is already detached.
  *
  * @param rootOrName Name of the detached root.
  */
  detachRoot(n) {
    this._assertWriterUsedCorrectly();
    const t = typeof n == "string" ? this.model.document.getRoot(n) : n;
    if (!t || !t.isAttached())
      throw new v("writer-detachroot-no-root", this);
    for (const s of this.model.markers)
      s.getRange().root === t && this.removeMarker(s);
    for (const s of t.getAttributeKeys())
      this.removeAttribute(s, t);
    this.remove(this.createRangeIn(t));
    const i = this.model.document, r = new wi(t.rootName, t.name, !1, i, i.version);
    this.batch.addOperation(r), this.model.applyOperation(r);
  }
  setSelection(...n) {
    this._assertWriterUsedCorrectly(), this.model.document.selection._setTo(...n);
  }
  /**
  * Moves {@link module:engine/model/documentselection~DocumentSelection#focus} to the specified location.
  *
  * The location can be specified in the same form as
  * {@link #createPositionAt `writer.createPositionAt()`} parameters.
  *
  * @param itemOrPosition
  * @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/model/item~Item model item}.
  */
  setSelectionFocus(n, t) {
    this._assertWriterUsedCorrectly(), this.model.document.selection._setFocus(n, t);
  }
  setSelectionAttribute(n, t) {
    if (this._assertWriterUsedCorrectly(), typeof n == "string")
      this._setSelectionAttribute(n, t);
    else
      for (const [i, r] of Si(n))
        this._setSelectionAttribute(i, r);
  }
  /**
  * Removes attribute(s) with given key(s) from the selection.
  *
  * Remove one attribute:
  *
  * ```ts
  * writer.removeSelectionAttribute( 'italic' );
  * ```
  *
  * Remove multiple attributes:
  *
  * ```ts
  * writer.removeSelectionAttribute( [ 'italic', 'bold' ] );
  * ```
  *
  * @param keyOrIterableOfKeys Key of the attribute to remove or an iterable of attribute keys to remove.
  */
  removeSelectionAttribute(n) {
    if (this._assertWriterUsedCorrectly(), typeof n == "string")
      this._removeSelectionAttribute(n);
    else
      for (const t of n)
        this._removeSelectionAttribute(t);
  }
  /**
  * Temporarily changes the {@link module:engine/model/documentselection~DocumentSelection#isGravityOverridden gravity}
  * of the selection from left to right.
  *
  * The gravity defines from which direction the selection inherits its attributes. If it's the default left gravity,
  * then the selection (after being moved by the user) inherits attributes from its left-hand side.
  * This method allows to temporarily override this behavior by forcing the gravity to the right.
  *
  * For the following model fragment:
  *
  * ```xml
  * <$text bold="true" linkHref="url">bar[]</$text><$text bold="true">biz</$text>
  * ```
  *
  * * Default gravity: selection will have the `bold` and `linkHref` attributes.
  * * Overridden gravity: selection will have `bold` attribute.
  *
  * **Note**: It returns an unique identifier which is required to restore the gravity. It guarantees the symmetry
  * of the process.
  *
  * @returns The unique id which allows restoring the gravity.
  */
  overrideSelectionGravity() {
    return this.model.document.selection._overrideGravity();
  }
  /**
  * Restores {@link ~Writer#overrideSelectionGravity} gravity to default.
  *
  * Restoring the gravity is only possible using the unique identifier returned by
  * {@link ~Writer#overrideSelectionGravity}. Note that the gravity remains overridden as long as won't be restored
  * the same number of times it was overridden.
  *
  * @param uid The unique id returned by {@link ~Writer#overrideSelectionGravity}.
  */
  restoreSelectionGravity(n) {
    this.model.document.selection._restoreGravity(n);
  }
  /**
  * @param key Key of the attribute to remove.
  * @param value Attribute value.
  */
  _setSelectionAttribute(n, t) {
    const i = this.model.document.selection;
    if (i.isCollapsed && i.anchor.parent.isEmpty) {
      const r = oi._getStoreAttributeKey(n);
      this.setAttribute(r, t, i.anchor.parent);
    }
    i._setAttribute(n, t);
  }
  /**
  * @param key Key of the attribute to remove.
  */
  _removeSelectionAttribute(n) {
    const t = this.model.document.selection;
    if (t.isCollapsed && t.anchor.parent.isEmpty) {
      const i = oi._getStoreAttributeKey(n);
      this.removeAttribute(i, t.anchor.parent);
    }
    t._removeAttribute(n);
  }
  /**
  * Throws `writer-detached-writer-tries-to-modify-model` error when the writer is used outside of the `change()` block.
  */
  _assertWriterUsedCorrectly() {
    if (this.model._currentWriter !== this)
      throw new v("writer-incorrect-use", this);
  }
  /**
  * For given action `type` and `positionOrRange` where the action happens, this function finds all affected markers
  * and applies a marker operation with the new marker range equal to the current range. Thanks to this, the marker range
  * can be later correctly processed during undo.
  *
  * @param type Writer action type.
  * @param positionOrRange Position or range where the writer action happens.
  */
  _addOperationForAffectedMarkers(n, t) {
    for (const i of this.model.markers) {
      if (!i.managedUsingOperations)
        continue;
      const r = i.getRange();
      let s = !1;
      if (n === "move") {
        const o = t;
        s = o.containsPosition(r.start) || o.start.isEqual(r.start) || o.containsPosition(r.end) || o.end.isEqual(r.end);
      } else {
        const o = t, a = o.nodeBefore, u = o.nodeAfter, l = r.start.parent == a && r.start.isAtEnd, c = r.end.parent == u && r.end.offset == 0, d = r.end.nodeAfter == u, p = r.start.nodeAfter == u;
        s = l || c || d || p;
      }
      s && this.updateMarker(i.name, {
        range: r
      });
    }
  }
}
function Yp(e, n, t, i) {
  const r = e.model, s = r.document;
  let o = i.start, a, u, l;
  for (const d of i.getWalker({
    shallow: !0
  }))
    l = d.item.getAttribute(n), a && u != l && (u != t && c(), o = a), a = d.nextPosition, u = l;
  a instanceof z && a != o && u != t && c();
  function c() {
    const d = new B(o, a), p = d.root.document ? s.version : null, g = new At(d, n, u, t, p);
    e.batch.addOperation(g), r.applyOperation(g);
  }
}
function jp(e, n, t, i) {
  const r = e.model, s = r.document, o = i.getAttribute(n);
  let a, u;
  if (o != t) {
    if (i.root === i) {
      const c = i.document ? s.version : null;
      u = new Vi(i, n, o, t, c);
    } else {
      a = new B(z._createBefore(i), e.createPositionAfter(i));
      const c = a.root.document ? s.version : null;
      u = new At(a, n, o, t, c);
    }
    e.batch.addOperation(u), r.applyOperation(u);
  }
}
function Do(e, n, t, i, r) {
  const s = e.model, o = s.document, a = new an(n, t, i, s.markers, !!r, o.version);
  e.batch.addOperation(a), s.applyOperation(a);
}
function $6(e, n, t, i) {
  let r;
  if (e.root.document) {
    const s = i.document, o = new z(s.graveyard, [
      0
    ]);
    r = new Ve(e, n, o, s.version);
  } else
    r = new U6(e, n);
  t.addOperation(r), i.applyOperation(r);
}
function Kp(e, n) {
  return e === n || e instanceof yl && n instanceof yl;
}
function W6(e, n, t = {}) {
  if (n.isCollapsed)
    return;
  const i = n.getFirstRange();
  if (i.root.rootName == "$graveyard")
    return;
  const r = e.schema;
  e.change((s) => {
    if (!t.doNotResetEntireContent && J6(r, n)) {
      X6(s, n);
      return;
    }
    const o = {};
    if (!t.doNotAutoparagraph) {
      const l = n.getSelectedElement();
      l && Object.assign(o, r.getAttributesWithProperty(l, "copyOnReplace", !0));
    }
    const [a, u] = z6(i);
    a.isTouching(u) || s.remove(s.createRange(a, u)), t.leaveUnmerged || (Y6(s, a, u), r.removeDisallowedAttributes(a.parent.getChildren(), s)), NT(s, n, a), !t.doNotAutoparagraph && G6(r, a) && OT(s, a, n, o), a.detach(), u.detach();
  });
}
function z6(e) {
  const n = e.root.document.model, t = e.start;
  let i = e.end;
  if (n.hasContent(e, {
    ignoreMarkers: !0
  })) {
    const r = q6(i);
    if (r && i.isTouching(n.createPositionAt(r, 0))) {
      const s = n.createSelection(e);
      n.modifySelection(s, {
        direction: "backward"
      });
      const o = s.getLastPosition(), a = n.createRange(o, i);
      n.hasContent(a, {
        ignoreMarkers: !0
      }) || (i = o);
    }
  }
  return [
    mn.fromPosition(t, "toPrevious"),
    mn.fromPosition(i, "toNext")
  ];
}
function q6(e) {
  const n = e.parent, t = n.root.document.model.schema, i = n.getAncestors({
    parentFirst: !0,
    includeSelf: !0
  });
  for (const r of i) {
    if (t.isLimit(r))
      return null;
    if (t.isBlock(r))
      return r;
  }
}
function Y6(e, n, t) {
  const i = e.model;
  if (!tm(e.model.schema, n, t))
    return;
  const [r, s] = K6(n, t);
  !r || !s || (!i.hasContent(r, {
    ignoreMarkers: !0
  }) && i.hasContent(s, {
    ignoreMarkers: !0
  }) ? PT(e, n, t, r.parent) : vT(e, n, t, r.parent));
}
function vT(e, n, t, i) {
  const r = n.parent, s = t.parent;
  if (!(r == i || s == i)) {
    for (n = e.createPositionAfter(r), t = e.createPositionBefore(s), t.isEqual(n) || e.insert(s, n), e.merge(n); t.parent.isEmpty; ) {
      const o = t.parent;
      t = e.createPositionBefore(o), e.remove(o);
    }
    tm(e.model.schema, n, t) && vT(e, n, t, i);
  }
}
function PT(e, n, t, i) {
  const r = n.parent, s = t.parent;
  if (!(r == i || s == i)) {
    for (n = e.createPositionAfter(r), t = e.createPositionBefore(s), t.isEqual(n) || e.insert(r, t); n.parent.isEmpty; ) {
      const o = n.parent;
      n = e.createPositionBefore(o), e.remove(o);
    }
    t = e.createPositionBefore(s), j6(e, t), tm(e.model.schema, n, t) && PT(e, n, t, i);
  }
}
function j6(e, n) {
  const t = n.nodeBefore, i = n.nodeAfter;
  t.name != i.name && e.rename(t, i.name), e.clearAttributes(t), e.setAttributes(Object.fromEntries(i.getAttributes()), t), e.merge(n);
}
function tm(e, n, t) {
  const i = n.parent, r = t.parent;
  return i == r || e.isLimit(i) || e.isLimit(r) ? !1 : Q6(n, t, e);
}
function K6(e, n) {
  const t = e.getAncestors(), i = n.getAncestors();
  let r = 0;
  for (; t[r] && t[r] == i[r]; )
    r++;
  return [
    t[r],
    i[r]
  ];
}
function G6(e, n) {
  const t = e.checkChild(n, "$text"), i = e.checkChild(n, "paragraph");
  return !t && i;
}
function Q6(e, n, t) {
  const i = new B(e, n);
  for (const r of i.getWalker())
    if (t.isLimit(r.item))
      return !1;
  return !0;
}
function OT(e, n, t, i = {}) {
  const r = e.createElement("paragraph");
  e.model.schema.setAllowedAttributes(r, i, e), e.insert(r, n), NT(e, t, e.createPositionAt(r, 0));
}
function X6(e, n) {
  const t = e.model.schema.getLimitElement(n);
  e.remove(e.createRangeIn(t)), OT(e, e.createPositionAt(t, 0), n);
}
function J6(e, n) {
  const t = e.getLimitElement(n);
  if (!n.containsEntireContent(t))
    return !1;
  const i = n.getFirstRange();
  return i.start.parent == i.end.parent ? !1 : e.checkChild(t, "paragraph");
}
function NT(e, n, t) {
  n instanceof oi ? e.setSelection(t) : n.setTo(t);
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function Z6(e, n) {
  return e.change((t) => {
    const i = t.createDocumentFragment(), r = n.getFirstRange();
    if (!r || r.isCollapsed)
      return i;
    const s = r.start.root, o = r.start.getCommonPath(r.end), a = s.getNodeByPath(o);
    let u;
    r.start.parent == r.end.parent ? u = r : u = t.createRange(t.createPositionAt(a, r.start.path[o.length]), t.createPositionAt(a, r.end.path[o.length] + 1));
    const l = u.end.offset - u.start.offset;
    for (const c of u.getItems({
      shallow: !0
    }))
      c.is("$textProxy") ? t.appendText(c.data, c.getAttributes(), i) : t.append(t.cloneElement(c, !0), i);
    if (u != r) {
      const c = r._getTransformedByMove(u.start, t.createPositionAt(i, 0), l)[0], d = t.createRange(t.createPositionAt(i, 0), c.start), p = t.createRange(c.end, t.createPositionAt(i, "end"));
      Gp(p, t), Gp(d, t);
    }
    return i;
  });
}
function Gp(e, n) {
  const t = [];
  Array.from(e.getItems({
    direction: "backward"
  })).map((i) => n.createRangeOn(i)).filter((i) => (i.start.isAfter(e.start) || i.start.isEqual(e.start)) && (i.end.isBefore(e.end) || i.end.isEqual(e.end))).forEach((i) => {
    t.push(i.start.parent), n.remove(i);
  }), t.forEach((i) => {
    let r = i;
    for (; r.parent && r.isEmpty; ) {
      const s = n.createRangeOn(r);
      r = r.parent, n.remove(s);
    }
  });
}
function eR(e, n, t) {
  return e.change((i) => {
    const r = t || e.document.selection;
    r.isCollapsed || e.deleteContent(r, {
      doNotAutoparagraph: !0
    });
    const s = new tR(e, i, r.anchor), o = [];
    let a;
    if (n.is("documentFragment")) {
      if (n.markers.size) {
        const c = [];
        for (const [d, p] of n.markers) {
          const { start: g, end: b } = p, _ = g.isEqual(b);
          c.push({
            position: g,
            name: d,
            isCollapsed: _
          }, {
            position: b,
            name: d,
            isCollapsed: _
          });
        }
        c.sort(({ position: d }, { position: p }) => d.isBefore(p) ? 1 : -1);
        for (const { position: d, name: p, isCollapsed: g } of c) {
          let b = null, _ = null;
          const k = d.parent === n && d.isAtStart, C = d.parent === n && d.isAtEnd;
          !k && !C ? (b = i.createElement("$marker"), i.insert(b, d)) : g && (_ = k ? "start" : "end"), o.push({
            name: p,
            element: b,
            collapsed: _
          });
        }
      }
      a = n.getChildren();
    } else
      a = [
        n
      ];
    s.handleNodes(a);
    let u = s.getSelectionRange();
    if (n.is("documentFragment") && o.length) {
      const c = u ? xn.fromRange(u) : null, d = {};
      for (let p = o.length - 1; p >= 0; p--) {
        const { name: g, element: b, collapsed: _ } = o[p], k = !d[g];
        if (k && (d[g] = []), b) {
          const C = i.createPositionAt(b, "before");
          d[g].push(C), i.remove(b);
        } else {
          const C = s.getAffectedRange();
          if (!C) {
            _ && d[g].push(s.position);
            continue;
          }
          _ ? d[g].push(C[_]) : d[g].push(k ? C.start : C.end);
        }
      }
      for (const [p, [g, b]] of Object.entries(d))
        g && b && g.root === b.root && g.root.document && !i.model.markers.has(p) && i.addMarker(p, {
          usingOperation: !0,
          affectsData: !0,
          range: new B(g, b)
        });
      c && (u = c.toRange(), c.detach());
    }
    /* istanbul ignore else -- @preserve */
    u && (r instanceof oi ? i.setSelection(u) : r.setTo(u));
    const l = s.getAffectedRange() || e.createRange(r.anchor);
    return s.destroy(), l;
  });
}
let tR = class {
  constructor(n, t, i) {
    /**
    * The model in context of which the insertion should be performed.
    */
    m(this, "model");
    /**
    * Batch to which operations will be added.
    */
    m(this, "writer");
    /**
    * The position at which (or near which) the next node will be inserted.
    */
    m(this, "position");
    /**
    * Elements with which the inserted elements can be merged.
    *
    * ```html
    * <p>x^</p><p>y</p> + <p>z</p> (can merge to <p>x</p>)
    * <p>x</p><p>^y</p> + <p>z</p> (can merge to <p>y</p>)
    * <p>x^y</p> + <p>z</p> (can merge to <p>xy</p> which will be split during the action,
    * 						so both its pieces will be added to this set)
    * ```
    */
    m(this, "canMergeWith");
    /**
    * Schema of the model.
    */
    m(this, "schema");
    /**
    * The temporary DocumentFragment used for grouping multiple nodes for single insert operation.
    */
    m(this, "_documentFragment");
    /**
    * The current position in the temporary DocumentFragment.
    */
    m(this, "_documentFragmentPosition");
    /**
    * The reference to the first inserted node.
    */
    m(this, "_firstNode", null);
    /**
    * The reference to the last inserted node.
    */
    m(this, "_lastNode", null);
    /**
    * The reference to the last auto paragraph node.
    */
    m(this, "_lastAutoParagraph", null);
    /**
    * The array of nodes that should be cleaned of not allowed attributes.
    */
    m(this, "_filterAttributesOf", []);
    /**
    * Beginning of the affected range. See {@link module:engine/model/utils/insertcontent~Insertion#getAffectedRange}.
    */
    m(this, "_affectedStart", null);
    /**
    * End of the affected range. See {@link module:engine/model/utils/insertcontent~Insertion#getAffectedRange}.
    */
    m(this, "_affectedEnd", null);
    m(this, "_nodeToSelect", null);
    this.model = n, this.writer = t, this.position = i, this.canMergeWith = /* @__PURE__ */ new Set([
      this.position.parent
    ]), this.schema = n.schema, this._documentFragment = t.createDocumentFragment(), this._documentFragmentPosition = t.createPositionAt(this._documentFragment, 0);
  }
  /**
  * Handles insertion of a set of nodes.
  *
  * @param nodes Nodes to insert.
  */
  handleNodes(n) {
    for (const t of Array.from(n))
      this._handleNode(t);
    this._insertPartialFragment(), this._lastAutoParagraph && this._updateLastNodeFromAutoParagraph(this._lastAutoParagraph), this._mergeOnRight(), this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer), this._filterAttributesOf = [];
  }
  /**
  * Updates the last node after the auto paragraphing.
  *
  * @param node The last auto paragraphing node.
  */
  _updateLastNodeFromAutoParagraph(n) {
    const t = this.writer.createPositionAfter(this._lastNode), i = this.writer.createPositionAfter(n);
    if (i.isAfter(t)) {
      this._lastNode = n;
      /* istanbul ignore if -- @preserve */
      if (this.position.parent != n || !this.position.isAtEnd)
        throw new v("insertcontent-invalid-insertion-position", this);
      this.position = i, this._setAffectedBoundaries(this.position);
    }
  }
  /**
  * Returns range to be selected after insertion.
  * Returns `null` if there is no valid range to select after insertion.
  */
  getSelectionRange() {
    return this._nodeToSelect ? B._createOn(this._nodeToSelect) : this.model.schema.getNearestSelectionRange(this.position);
  }
  /**
  * Returns a range which contains all the performed changes. This is a range that, if removed, would return the model to the state
  * before the insertion. Returns `null` if no changes were done.
  */
  getAffectedRange() {
    return this._affectedStart ? new B(this._affectedStart, this._affectedEnd) : null;
  }
  /**
  * Destroys `Insertion` instance.
  */
  destroy() {
    this._affectedStart && this._affectedStart.detach(), this._affectedEnd && this._affectedEnd.detach();
  }
  /**
  * Handles insertion of a single node.
  */
  _handleNode(n) {
    if (!this._checkAndSplitToAllowedPosition(n)) {
      this.schema.isObject(n) || this._handleDisallowedNode(n);
      return;
    }
    this._appendToFragment(n), this._firstNode || (this._firstNode = n), this._lastNode = n;
  }
  /**
  * Inserts the temporary DocumentFragment into the model.
  */
  _insertPartialFragment() {
    if (this._documentFragment.isEmpty)
      return;
    const n = mn.fromPosition(this.position, "toNext");
    this._setAffectedBoundaries(this.position), this._documentFragment.getChild(0) == this._firstNode && (this.writer.insert(this._firstNode, this.position), this._mergeOnLeft(), this.position = n.toPosition()), this._documentFragment.isEmpty || this.writer.insert(this._documentFragment, this.position), this._documentFragmentPosition = this.writer.createPositionAt(this._documentFragment, 0), this.position = n.toPosition(), n.detach();
  }
  /**
  * @param node The disallowed node which needs to be handled.
  */
  _handleDisallowedNode(n) {
    n.is("element") && this.handleNodes(n.getChildren());
  }
  /**
  * Append a node to the temporary DocumentFragment.
  *
  * @param node The node to insert.
  */
  _appendToFragment(n) {
    /* istanbul ignore if -- @preserve */
    if (!this.schema.checkChild(this.position, n))
      throw new v("insertcontent-wrong-position", this, {
        node: n,
        position: this.position
      });
    this.writer.insert(n, this._documentFragmentPosition), this._documentFragmentPosition = this._documentFragmentPosition.getShiftedBy(n.offsetSize), this.schema.isObject(n) && !this.schema.checkChild(this.position, "$text") ? this._nodeToSelect = n : this._nodeToSelect = null, this._filterAttributesOf.push(n);
  }
  /**
  * Sets `_affectedStart` and `_affectedEnd` to the given `position`. Should be used before a change is done during insertion process to
  * mark the affected range.
  *
  * This method is used before inserting a node or splitting a parent node. `_affectedStart` and `_affectedEnd` are also changed
  * during merging, but the logic there is more complicated so it is left out of this function.
  */
  _setAffectedBoundaries(n) {
    this._affectedStart || (this._affectedStart = mn.fromPosition(n, "toPrevious")), (!this._affectedEnd || this._affectedEnd.isBefore(n)) && (this._affectedEnd && this._affectedEnd.detach(), this._affectedEnd = mn.fromPosition(n, "toNext"));
  }
  /**
  * Merges the previous sibling of the first node if it should be merged.
  *
  * After the content was inserted we may try to merge it with its siblings.
  * This should happen only if the selection was in those elements initially.
  */
  _mergeOnLeft() {
    const n = this._firstNode;
    if (!(n instanceof rt) || !this._canMergeLeft(n))
      return;
    const t = mn._createBefore(n);
    t.stickiness = "toNext";
    const i = mn.fromPosition(this.position, "toNext");
    this._affectedStart.isEqual(t) && (this._affectedStart.detach(), this._affectedStart = mn._createAt(t.nodeBefore, "end", "toPrevious")), this._firstNode === this._lastNode && (this._firstNode = t.nodeBefore, this._lastNode = t.nodeBefore), this.writer.merge(t), t.isEqual(this._affectedEnd) && this._firstNode === this._lastNode && (this._affectedEnd.detach(), this._affectedEnd = mn._createAt(t.nodeBefore, "end", "toNext")), this.position = i.toPosition(), i.detach(), this._filterAttributesOf.push(this.position.parent), t.detach();
  }
  /**
  * Merges the next sibling of the last node if it should be merged.
  *
  * After the content was inserted we may try to merge it with its siblings.
  * This should happen only if the selection was in those elements initially.
  */
  _mergeOnRight() {
    const n = this._lastNode;
    if (!(n instanceof rt) || !this._canMergeRight(n))
      return;
    const t = mn._createAfter(n);
    t.stickiness = "toNext";
    /* istanbul ignore if -- @preserve */
    if (!this.position.isEqual(t))
      throw new v("insertcontent-invalid-insertion-position", this);
    this.position = z._createAt(t.nodeBefore, "end");
    const i = mn.fromPosition(this.position, "toPrevious");
    this._affectedEnd.isEqual(t) && (this._affectedEnd.detach(), this._affectedEnd = mn._createAt(t.nodeBefore, "end", "toNext")), this._firstNode === this._lastNode && (this._firstNode = t.nodeBefore, this._lastNode = t.nodeBefore), this.writer.merge(t), t.getShiftedBy(-1).isEqual(this._affectedStart) && this._firstNode === this._lastNode && (this._affectedStart.detach(), this._affectedStart = mn._createAt(t.nodeBefore, 0, "toPrevious")), this.position = i.toPosition(), i.detach(), this._filterAttributesOf.push(this.position.parent), t.detach();
  }
  /**
  * Checks whether specified node can be merged with previous sibling element.
  *
  * @param node The node which could potentially be merged.
  */
  _canMergeLeft(n) {
    const t = n.previousSibling;
    return t instanceof rt && this.canMergeWith.has(t) && this.model.schema.checkMerge(t, n);
  }
  /**
  * Checks whether specified node can be merged with next sibling element.
  *
  * @param node The node which could potentially be merged.
  */
  _canMergeRight(n) {
    const t = n.nextSibling;
    return t instanceof rt && this.canMergeWith.has(t) && this.model.schema.checkMerge(n, t);
  }
  /**
  * Inserts a paragraph and moves the insertion position into it.
  */
  _insertAutoParagraph() {
    this._insertPartialFragment();
    const n = this.writer.createElement("paragraph");
    this.writer.insert(n, this.position), this._setAffectedBoundaries(this.position), this._lastAutoParagraph = n, this.position = this.writer.createPositionAt(n, 0);
  }
  /**
  * @returns Whether an allowed position was found.
  * `false` is returned if the node isn't allowed at any position up in the tree, `true` if was.
  */
  _checkAndSplitToAllowedPosition(n) {
    const t = this._getAllowedIn(this.position.parent, n);
    if (!t)
      return !1;
    for (t != this.position.parent && this._insertPartialFragment(); t != this.position.parent; )
      if (this.position.isAtStart) {
        const i = this.position.parent;
        this.position = this.writer.createPositionBefore(i), i.isEmpty && i.parent === t && this.writer.remove(i);
      } else if (this.position.isAtEnd)
        this.position = this.writer.createPositionAfter(this.position.parent);
      else {
        const i = this.writer.createPositionAfter(this.position.parent);
        this._setAffectedBoundaries(this.position), this.writer.split(this.position), this.position = i, this.canMergeWith.add(this.position.nodeAfter);
      }
    return this.schema.checkChild(this.position.parent, n) || this._insertAutoParagraph(), !0;
  }
  /**
  * Gets the element in which the given node is allowed. It checks the passed element and all its ancestors.
  *
  * It also verifies if auto-paragraphing could help.
  *
  * @param contextElement The element in which context the node should be checked.
  * @param childNode The node to check.
  */
  _getAllowedIn(n, t) {
    return this.schema.checkChild(n, t) || this.schema.checkChild(n, "paragraph") && this.schema.checkChild("paragraph", t) ? n : this.schema.isLimit(n) ? null : this._getAllowedIn(n.parent, t);
  }
};
function nR(e, n, t, i = {}) {
  if (!e.schema.isObject(n))
    throw new v("insertobject-element-not-an-object", e, {
      object: n
    });
  const r = t || e.document.selection;
  let s = r;
  i.findOptimalPosition && e.schema.isBlock(n) && (s = e.createSelection(e.schema.findOptimalInsertionRange(r, i.findOptimalPosition)));
  const o = zn(r.getSelectedBlocks()), a = {};
  return o && Object.assign(a, e.schema.getAttributesWithProperty(o, "copyOnReplace", !0)), e.change((u) => {
    s.isCollapsed || e.deleteContent(s, {
      doNotAutoparagraph: !0
    });
    let l = n;
    const c = s.anchor.parent;
    !e.schema.checkChild(c, n) && e.schema.checkChild(c, "paragraph") && e.schema.checkChild("paragraph", n) && (l = u.createElement("paragraph"), u.insert(n, l)), e.schema.setAllowedAttributes(l, a, u);
    const d = e.insertContent(l, s);
    return d.isCollapsed || i.setSelection && iR(u, n, i.setSelection, a), d;
  });
}
function iR(e, n, t, i) {
  const r = e.model;
  if (t == "on") {
    e.setSelection(n, "on");
    return;
  }
  if (t != "after")
    throw new v("insertobject-invalid-place-parameter-value", r);
  let s = n.nextSibling;
  if (r.schema.isInline(n)) {
    e.setSelection(n, "after");
    return;
  }
  !(s && r.schema.checkChild(s, "$text")) && r.schema.checkChild(n.parent, "paragraph") && (s = e.createElement("paragraph"), r.schema.setAllowedAttributes(s, i, e), r.insertContent(s, e.createPositionAfter(n))), s && e.setSelection(s, 0);
}
const rR = ' ,.?!:;"-()';
function sR(e, n, t = {}) {
  const i = e.schema, r = t.direction != "backward", s = t.unit ? t.unit : "character", o = !!t.treatEmojiAsSingleUnit, a = n.focus, u = new Ui({
    boundaries: lR(a, r),
    singleCharacters: !0,
    direction: r ? "forward" : "backward"
  }), l = {
    walker: u,
    schema: i,
    isForward: r,
    unit: s,
    treatEmojiAsSingleUnit: o
  };
  let c;
  for (; c = u.next(); ) {
    if (c.done)
      return;
    const d = oR(l, c.value);
    if (d) {
      n instanceof oi ? e.change((p) => {
        p.setSelectionFocus(d);
      }) : n.setFocus(d);
      return;
    }
  }
}
function oR(e, n) {
  const { isForward: t, walker: i, unit: r, schema: s, treatEmojiAsSingleUnit: o } = e, { type: a, item: u, nextPosition: l } = n;
  if (a == "text")
    return e.unit === "word" ? uR(i, t) : aR(i, r, o);
  if (a == (t ? "elementStart" : "elementEnd")) {
    if (s.isSelectable(u))
      return z._createAt(u, t ? "after" : "before");
    if (s.checkChild(l, "$text"))
      return l;
  } else {
    if (s.isLimit(u)) {
      i.skip(() => !0);
      return;
    }
    if (s.checkChild(l, "$text"))
      return l;
  }
}
function aR(e, n, t) {
  const i = e.position.textNode;
  if (i) {
    const r = i.data;
    let s = e.position.offset - i.startOffset;
    for (; qf(r, s) || n == "character" && Yf(r, s) || t && $E(r, s); )
      e.next(), s = e.position.offset - i.startOffset;
  }
  return e.position;
}
function uR(e, n) {
  let t = e.position.textNode;
  for (t || (t = n ? e.position.nodeAfter : e.position.nodeBefore); t && t.is("$text"); ) {
    const i = e.position.offset - t.startOffset;
    if (dR(t, i, n))
      t = n ? e.position.nodeAfter : e.position.nodeBefore;
    else {
      if (cR(t.data, i, n))
        break;
      e.next();
    }
  }
  return e.position;
}
function lR(e, n) {
  const t = e.root, i = z._createAt(t, n ? "end" : 0);
  return n ? new B(e, i) : new B(i, e);
}
function cR(e, n, t) {
  const i = n + (t ? 0 : -1);
  return rR.includes(e.charAt(i));
}
function dR(e, n, t) {
  return n === (t ? e.offsetSize : 0);
}
let hR = class extends (/* @__PURE__ */ pt()) {
  // @if CK_DEBUG_ENGINE // private _operationLogs: Array<string>;
  // @if CK_DEBUG_ENGINE // private _appliedOperations: Array<Operation>;
  constructor() {
    super();
    /**
    * Model's marker collection.
    */
    m(this, "markers");
    /**
    * Model's document.
    */
    m(this, "document");
    /**
    * Model's schema.
    */
    m(this, "schema");
    /**
    * All callbacks added by {@link module:engine/model/model~Model#change} or
    * {@link module:engine/model/model~Model#enqueueChange} methods waiting to be executed.
    */
    m(this, "_pendingChanges");
    /**
    * The last created and currently used writer instance.
    */
    m(this, "_currentWriter");
    this.markers = new F6(), this.document = new B6(this), this.schema = new t6(), this._pendingChanges = [], this._currentWriter = null, [
      "deleteContent",
      "modifySelection",
      "getSelectedContent",
      "applyOperation"
    ].forEach((t) => this.decorate(t)), this.on("applyOperation", (t, i) => {
      i[0]._validate();
    }, {
      priority: "highest"
    }), this.schema.register("$root", {
      isLimit: !0
    }), this.schema.register("$container", {
      allowIn: [
        "$root",
        "$container"
      ]
    }), this.schema.register("$block", {
      allowIn: [
        "$root",
        "$container"
      ],
      isBlock: !0
    }), this.schema.register("$blockObject", {
      allowWhere: "$block",
      isBlock: !0,
      isObject: !0
    }), this.schema.register("$inlineObject", {
      allowWhere: "$text",
      allowAttributesOf: "$text",
      isInline: !0,
      isObject: !0
    }), this.schema.register("$text", {
      allowIn: "$block",
      isInline: !0,
      isContent: !0
    }), this.schema.register("$clipboardHolder", {
      allowContentOf: "$root",
      allowChildren: "$text",
      isLimit: !0
    }), this.schema.register("$documentFragment", {
      allowContentOf: "$root",
      allowChildren: "$text",
      isLimit: !0
    }), this.schema.register("$marker"), this.schema.addChildCheck(() => !0, "$marker"), jN(this), this.document.registerPostFixer(bT), this.on("insertContent", (t, [i, r]) => {
      t.return = eR(this, i, r);
    }), this.on("insertObject", (t, [i, r, s]) => {
      t.return = nR(this, i, r, s);
    }), this.on("canEditAt", (t) => {
      const i = !this.document.isReadOnly;
      t.return = i, i || t.stop();
    });
  }
  /**
  * The `change()` method is the primary way of changing the model. You should use it to modify all document nodes
  * (including detached nodes – i.e. nodes not added to the {@link module:engine/model/model~Model#document model document}),
  * the {@link module:engine/model/document~Document#selection document's selection}, and
  * {@link module:engine/model/model~Model#markers model markers}.
  *
  * ```ts
  * model.change( writer => {
  * 	writer.insertText( 'foo', paragraph, 'end' );
  * } );
  * ```
  *
  * All changes inside the change block use the same {@link module:engine/model/batch~Batch} so they are combined
  * into a single undo step.
  *
  * ```ts
  * model.change( writer => {
  * 	writer.insertText( 'foo', paragraph, 'end' ); // foo.
  *
  * 	model.change( writer => {
  * 		writer.insertText( 'bar', paragraph, 'end' ); // foobar.
  * 	} );
  *
  * 	writer.insertText( 'bom', paragraph, 'end' ); // foobarbom.
  * } );
  * ```
  *
  * The callback of the `change()` block is executed synchronously.
  *
  * You can also return a value from the change block.
  *
  * ```ts
  * const img = model.change( writer => {
  * 	return writer.createElement( 'img' );
  * } );
  * ```
  *
  * @see #enqueueChange
  * @typeParam TReturn The return type of the provided callback.
  * @param callback Callback function which may modify the model.
  */
  change(t) {
    try {
      return this._pendingChanges.length === 0 ? (this._pendingChanges.push({
        batch: new As(),
        callback: t
      }), this._runPendingChanges()[0]) : t(this._currentWriter);
    } catch (i) {
      /* istanbul ignore next -- @preserve */
      v.rethrowUnexpectedError(i, this);
    }
  }
  enqueueChange(t, i) {
    try {
      t ? typeof t == "function" ? (i = t, t = new As()) : t instanceof As || (t = new As(t)) : t = new As(), this._pendingChanges.push({
        batch: t,
        callback: i
      }), this._pendingChanges.length == 1 && this._runPendingChanges();
    } catch (r) {
      /* istanbul ignore next -- @preserve */
      v.rethrowUnexpectedError(r, this);
    }
  }
  /**
  * {@link module:utils/observablemixin~Observable#decorate Decorated} function for applying
  * {@link module:engine/model/operation/operation~Operation operations} to the model.
  *
  * This is a low-level way of changing the model. It is exposed for very specific use cases (like the undo feature).
  * Normally, to modify the model, you will want to use {@link module:engine/model/writer~Writer `Writer`}.
  * See also {@glink framework/architecture/editing-engine#changing-the-model Changing the model} section
  * of the {@glink framework/architecture/editing-engine Editing architecture} guide.
  *
  * @param operation The operation to apply.
  */
  applyOperation(t) {
    t._execute();
  }
  // @if CK_DEBUG_ENGINE // public getAppliedOperation(): string {
  // @if CK_DEBUG_ENGINE // 	if ( !this._appliedOperations ) {
  // @if CK_DEBUG_ENGINE // 		return '';
  // @if CK_DEBUG_ENGINE // 	}
  // @if CK_DEBUG_ENGINE // 	return this._appliedOperations.map( operation => JSON.stringify( operation ) ).join( '-------' );
  // @if CK_DEBUG_ENGINE // }
  // @if CK_DEBUG_ENGINE // public createReplayer( stringifiedOperations: string ): typeof OperationReplayer {
  // @if CK_DEBUG_ENGINE // 	return new OperationReplayer( this, '-------', stringifiedOperations );
  // @if CK_DEBUG_ENGINE // }
  /**
  * Inserts content at the position in the editor specified by the selection, as one would expect the paste
  * functionality to work.
  *
  * **Note**: If you want to insert an {@glink framework/deep-dive/schema#object-elements object element}
  * (e.g. a {@link module:widget/utils~toWidget widget}), see {@link #insertObject} instead.
  *
  * This is a high-level method. It takes the {@link #schema schema} into consideration when inserting
  * the content, clears the given selection's content before inserting nodes and moves the selection
  * to its target position at the end of the process.
  * It can split elements, merge them, wrap bare text nodes with paragraphs, etc. &ndash; just like the
  * pasting feature should do.
  *
  * For lower-level methods see {@link module:engine/model/writer~Writer `Writer`}.
  *
  * This method, unlike {@link module:engine/model/writer~Writer `Writer`}'s methods, does not have to be used
  * inside a {@link #change `change()` block}.
  *
  * # Conversion and schema
  *
  * Inserting elements and text nodes into the model is not enough to make CKEditor 5 render that content
  * to the user. CKEditor 5 implements a model-view-controller architecture and what `model.insertContent()` does
  * is only adding nodes to the model. Additionally, you need to define
  * {@glink framework/architecture/editing-engine#conversion converters} between the model and view
  * and define those nodes in the {@glink framework/architecture/editing-engine#schema schema}.
  *
  * So, while this method may seem similar to CKEditor 4 `editor.insertHtml()` (in fact, both methods
  * are used for paste-like content insertion), the CKEditor 5 method cannot be use to insert arbitrary HTML
  * unless converters are defined for all elements and attributes in that HTML.
  *
  * # Examples
  *
  * Using `insertContent()` with a manually created model structure:
  *
  * ```ts
  * // Let's create a document fragment containing such content as:
  * //
  * // <paragraph>foo</paragraph>
  * // <blockQuote>
  * //    <paragraph>bar</paragraph>
  * // </blockQuote>
  * const docFrag = editor.model.change( writer => {
  * 	const p1 = writer.createElement( 'paragraph' );
  * 	const p2 = writer.createElement( 'paragraph' );
  * 	const blockQuote = writer.createElement( 'blockQuote' );
  * 	const docFrag = writer.createDocumentFragment();
  *
  * 	writer.append( p1, docFrag );
  * 	writer.append( blockQuote, docFrag );
  * 	writer.append( p2, blockQuote );
  * 	writer.insertText( 'foo', p1 );
  * 	writer.insertText( 'bar', p2 );
  *
  * 	return docFrag;
  * } );
  *
  * // insertContent() does not have to be used in a change() block. It can, though,
  * // so this code could be moved to the callback defined above.
  * editor.model.insertContent( docFrag );
  * ```
  *
  * Using `insertContent()` with an HTML string converted to a model document fragment (similar to the pasting mechanism):
  *
  * ```ts
  * // You can create your own HtmlDataProcessor instance or use editor.data.processor
  * // if you have not overridden the default one (which is the HtmlDataProcessor instance).
  * const htmlDP = new HtmlDataProcessor( viewDocument );
  *
  * // Convert an HTML string to a view document fragment:
  * const viewFragment = htmlDP.toView( htmlString );
  *
  * // Convert the view document fragment to a model document fragment
  * // in the context of $root. This conversion takes the schema into
  * // account so if, for example, the view document fragment contained a bare text node,
  * // this text node cannot be a child of $root, so it will be automatically
  * // wrapped with a <paragraph>. You can define the context yourself (in the second parameter),
  * // and e.g. convert the content like it would happen in a <paragraph>.
  * // Note: The clipboard feature uses a custom context called $clipboardHolder
  * // which has a loosened schema.
  * const modelFragment = editor.data.toModel( viewFragment );
  *
  * editor.model.insertContent( modelFragment );
  * ```
  *
  * By default this method will use the document selection but it can also be used with a position, range or selection instance.
  *
  * ```ts
  * // Insert text at the current document selection position.
  * editor.model.change( writer => {
  * 	editor.model.insertContent( writer.createText( 'x' ) );
  * } );
  *
  * // Insert text at a given position - the document selection will not be modified.
  * editor.model.change( writer => {
  * 	editor.model.insertContent( writer.createText( 'x' ), doc.getRoot(), 2 );
  *
  * 	// Which is a shorthand for:
  * 	editor.model.insertContent( writer.createText( 'x' ), writer.createPositionAt( doc.getRoot(), 2 ) );
  * } );
  * ```
  *
  * If you want the document selection to be moved to the inserted content, use the
  * {@link module:engine/model/writer~Writer#setSelection `setSelection()`} method of the writer after inserting
  * the content:
  *
  * ```ts
  * editor.model.change( writer => {
  * 	const paragraph = writer.createElement( 'paragraph' );
  *
  * 	// Insert an empty paragraph at the beginning of the root.
  * 	editor.model.insertContent( paragraph, writer.createPositionAt( editor.model.document.getRoot(), 0 ) );
  *
  * 	// Move the document selection to the inserted paragraph.
  * 	writer.setSelection( paragraph, 'in' );
  * } );
  * ```
  *
  * If an instance of the {@link module:engine/model/selection~Selection model selection} is passed as `selectable`,
  * the new content will be inserted at the passed selection (instead of document selection):
  *
  * ```ts
  * editor.model.change( writer => {
  * 	// Create a selection in a paragraph that will be used as a place of insertion.
  * 	const selection = writer.createSelection( paragraph, 'in' );
  *
  * 	// Insert the new text at the created selection.
  * 	editor.model.insertContent( writer.createText( 'x' ), selection );
  *
  * 	// insertContent() modifies the passed selection instance so it can be used to set the document selection.
  * 	// Note: This is not necessary when you passed the document selection to insertContent().
  * 	writer.setSelection( selection );
  * } );
  * ```
  *
  * @fires insertContent
  * @param content The content to insert.
  * @param selectable The selection into which the content should be inserted.
  * If not provided the current model document selection will be used.
  * @param placeOrOffset To be used when a model item was passed as `selectable`.
  * This param defines a position in relation to that item.
  * at the insertion position.
  */
  insertContent(t, i, r, ...s) {
    const o = fd(i, r);
    return this.fire("insertContent", [
      t,
      o,
      r,
      ...s
    ]);
  }
  /**
  * Inserts an {@glink framework/deep-dive/schema#object-elements object element} at a specific position in the editor content.
  *
  * This is a high-level API:
  * * It takes the {@link #schema schema} into consideration,
  * * It clears the content of passed `selectable` before inserting,
  * * It can move the selection at the end of the process,
  * * It will copy the selected block's attributes to preserve them upon insertion,
  * * It can split elements or wrap inline objects with paragraphs if they are not allowed in target position,
  * * etc.
  *
  * # Notes
  *
  * * If you want to insert a non-object content, see {@link #insertContent} instead.
  * * For lower-level API, see {@link module:engine/model/writer~Writer `Writer`}.
  * * Unlike {@link module:engine/model/writer~Writer `Writer`}, this method does not have to be used inside
  * a {@link #change `change()` block}.
  * * Inserting object into the model is not enough to make CKEditor 5 render that content to the user.
  * CKEditor 5 implements a model-view-controller architecture and what `model.insertObject()` does
  * is only adding nodes to the model. Additionally, you need to define
  * {@glink framework/architecture/editing-engine#conversion converters} between the model and view
  * and define those nodes in the {@glink framework/architecture/editing-engine#schema schema}.
  *
  * # Examples
  *
  * Use the following code to insert an object at the current selection and keep the selection on the inserted element:
  *
  * ```ts
  * const rawHtmlEmbedElement = writer.createElement( 'rawHtml' );
  *
  * model.insertObject( rawHtmlEmbedElement, null, null, {
  * 	setSelection: 'on'
  * } );
  * ```
  *
  * Use the following code to insert an object at the current selection and nudge the selection after the inserted object:
  *
  * ```ts
  * const pageBreakElement = writer.createElement( 'pageBreak' );
   *
  * model.insertObject( pageBreakElement, null, null, {
  * 	setSelection: 'after'
  * } );
  * ```
  *
  * Use the following code to insert an object at the current selection and avoid splitting the content (non-destructive insertion):
  *
  * ```ts
  * const tableElement = writer.createElement( 'table' );
   *
  * model.insertObject( tableElement, null, null, {
  * 	findOptimalPosition: 'auto'
  * } );
  * ```
  *
  * Use the following code to insert an object at the specific range (also: replace the content of the range):
  *
  * ```ts
  * const tableElement = writer.createElement( 'table' );
  * const range = model.createRangeOn( model.document.getRoot().getChild( 1 ) );
   *
  * model.insertObject( tableElement, range );
  * ```
  *
  * @param element An object to be inserted into the model document.
  * @param selectable A selectable where the content should be inserted. If not specified, the current
  * {@link module:engine/model/document~Document#selection document selection} will be used instead.
  * @param placeOrOffset Specifies the exact place or offset for the insertion to take place, relative to `selectable`.
  * @param options Additional options.
  * @param options.findOptimalPosition An option that, when set, adjusts the insertion position (relative to
  * `selectable` and `placeOrOffset`) so that the content of `selectable` is not split upon insertion (a.k.a. non-destructive insertion).
  * * When `'auto'`, the algorithm will decide whether to insert the object before or after `selectable` to avoid content splitting.
  * * When `'before'`, the closest position before `selectable` will be used that will not result in content splitting.
  * * When `'after'`, the closest position after `selectable` will be used that will not result in content splitting.
  *
  * Note that this option only works for block objects. Inline objects are inserted into text and do not split blocks.
  * @param options.setSelection An option that, when set, moves the
  * {@link module:engine/model/document~Document#selection document selection} after inserting the object.
  * * When `'on'`, the document selection will be set on the inserted object.
  * * When `'after'`, the document selection will move to the closest text node after the inserted object. If there is no
  * such text node, a paragraph will be created and the document selection will be moved inside it.
  * at the insertion position.
  */
  insertObject(t, i, r, s, ...o) {
    const a = fd(i, r);
    return this.fire("insertObject", [
      t,
      a,
      s,
      s,
      ...o
    ]);
  }
  /**
  * Deletes content of the selection and merge siblings. The resulting selection is always collapsed.
  *
  * **Note:** For the sake of predictability, the resulting selection should always be collapsed.
  * In cases where a feature wants to modify deleting behavior so selection isn't collapsed
  * (e.g. a table feature may want to keep row selection after pressing <kbd>Backspace</kbd>),
  * then that behavior should be implemented in the view's listener. At the same time, the table feature
  * will need to modify this method's behavior too, e.g. to "delete contents and then collapse
  * the selection inside the last selected cell" or "delete the row and collapse selection somewhere near".
  * That needs to be done in order to ensure that other features which use `deleteContent()` will work well with tables.
  *
  * @fires deleteContent
  * @param selection Selection of which the content should be deleted.
  * @param options.leaveUnmerged Whether to merge elements after removing the content of the selection.
  *
  * For example `<heading1>x[x</heading1><paragraph>y]y</paragraph>` will become:
  *
  * * `<heading1>x^y</heading1>` with the option disabled (`leaveUnmerged == false`)
  * * `<heading1>x^</heading1><paragraph>y</paragraph>` with enabled (`leaveUnmerged == true`).
  *
  * Note: {@link module:engine/model/schema~Schema#isObject object} and {@link module:engine/model/schema~Schema#isLimit limit}
  * elements will not be merged.
  *
  * @param options.doNotResetEntireContent Whether to skip replacing the entire content with a
  * paragraph when the entire content was selected.
  *
  * For example `<heading1>[x</heading1><paragraph>y]</paragraph>` will become:
  *
  * * `<paragraph>^</paragraph>` with the option disabled (`doNotResetEntireContent == false`)
  * * `<heading1>^</heading1>` with enabled (`doNotResetEntireContent == true`)
  *
  * @param options.doNotAutoparagraph Whether to create a paragraph if after content deletion selection is moved
  * to a place where text cannot be inserted.
  *
  * For example `<paragraph>x</paragraph>[<imageBlock src="foo.jpg"></imageBlock>]` will become:
  *
  * * `<paragraph>x</paragraph><paragraph>[]</paragraph>` with the option disabled (`doNotAutoparagraph == false`)
  * * `<paragraph>x[]</paragraph>` with the option enabled (`doNotAutoparagraph == true`).
  *
  * **Note:** if there is no valid position for the selection, the paragraph will always be created:
  *
  * `[<imageBlock src="foo.jpg"></imageBlock>]` -> `<paragraph>[]</paragraph>`.
  *
  * @param options.direction The direction in which the content is being consumed.
  * Deleting backward corresponds to using the <kbd>Backspace</kbd> key, while deleting content forward corresponds to
  * the <kbd>Shift</kbd>+<kbd>Backspace</kbd> keystroke.
  */
  deleteContent(t, i) {
    W6(this, t, i);
  }
  /**
  * Modifies the selection. Currently, the supported modifications are:
  *
  * * Extending. The selection focus is moved in the specified `options.direction` with a step specified in `options.unit`.
  * Possible values for `unit` are:
  *  * `'character'` (default) - moves selection by one user-perceived character. In most cases this means moving by one
  *  character in `String` sense. However, unicode also defines "combing marks". These are special symbols, that combines
  *  with a symbol before it ("base character") to create one user-perceived character. For example, `q̣̇` is a normal
  *  letter `q` with two "combining marks": upper dot (`Ux0307`) and lower dot (`Ux0323`). For most actions, i.e. extending
  *  selection by one position, it is correct to include both "base character" and all of it's "combining marks". That is
  *  why `'character'` value is most natural and common method of modifying selection.
  *  * `'codePoint'` - moves selection by one unicode code point. In contrary to, `'character'` unit, this will insert
  *  selection between "base character" and "combining mark", because "combining marks" have their own unicode code points.
  *  However, for technical reasons, unicode code points with values above `UxFFFF` are represented in native `String` by
  *  two characters, called "surrogate pairs". Halves of "surrogate pairs" have a meaning only when placed next to each other.
  *  For example `𨭎` is represented in `String` by `\uD862\uDF4E`. Both `\uD862` and `\uDF4E` do not have any meaning
  *  outside the pair (are rendered as ? when alone). Position between them would be incorrect. In this case, selection
  *  extension will include whole "surrogate pair".
  *  * `'word'` - moves selection by a whole word.
  *
  * **Note:** if you extend a forward selection in a backward direction you will in fact shrink it.
  *
  * @fires modifySelection
  * @param selection The selection to modify.
  * @param options.direction The direction in which the selection should be modified.
  * @param options.unit The unit by which selection should be modified.
  * @param options.treatEmojiAsSingleUnit Whether multi-characer emoji sequences should be handled as single unit.
  */
  modifySelection(t, i) {
    sR(this, t, i);
  }
  /**
  * Gets a clone of the selected content.
  *
  * For example, for the following selection:
  *
  * ```html
  * <paragraph>x</paragraph>
  * <blockQuote>
  * 	<paragraph>y</paragraph>
  * 	<heading1>fir[st</heading1>
  * </blockQuote>
  * <paragraph>se]cond</paragraph>
  * <paragraph>z</paragraph>
  * ```
  *
  * It will return a document fragment with such a content:
  *
  * ```html
  * <blockQuote>
  * 	<heading1>st</heading1>
  * </blockQuote>
  * <paragraph>se</paragraph>
  * ```
  *
  * @fires getSelectedContent
  * @param selection The selection of which content will be returned.
  */
  getSelectedContent(t) {
    return Z6(this, t);
  }
  /**
  * Checks whether the given {@link module:engine/model/range~Range range} or
  * {@link module:engine/model/element~Element element} has any meaningful content.
  *
  * Meaningful content is:
  *
  * * any text node (`options.ignoreWhitespaces` allows controlling whether this text node must also contain
  * any non-whitespace characters),
  * * or any {@link module:engine/model/schema~Schema#isContent content element},
  * * or any {@link module:engine/model/markercollection~Marker marker} which
  * {@link module:engine/model/markercollection~Marker#_affectsData affects data}.
  *
  * This means that a range containing an empty `<paragraph></paragraph>` is not considered to have a meaningful content.
  * However, a range containing an `<imageBlock></imageBlock>` (which would normally be marked in the schema as an object element)
  * is considered non-empty.
  *
  * @param rangeOrElement Range or element to check.
  * @param options.ignoreWhitespaces Whether text node with whitespaces only should be considered empty.
  * @param options.ignoreMarkers Whether markers should be ignored.
  */
  hasContent(t, i = {}) {
    const r = t instanceof B ? t : B._createIn(t);
    if (r.isCollapsed)
      return !1;
    const { ignoreWhitespaces: s = !1, ignoreMarkers: o = !1 } = i;
    if (!o) {
      for (const a of this.markers.getMarkersIntersectingRange(r))
        if (a.affectsData)
          return !0;
    }
    for (const a of r.getItems())
      if (this.schema.isContent(a))
        if (a.is("$textProxy"))
          if (s) {
            if (a.data.search(/\S/) !== -1)
              return !0;
          } else return !0;
        else
          return !0;
    return !1;
  }
  /**
  * Check whether given selectable is at a place in the model where it can be edited (returns `true`) or not (returns `false`).
  *
  * Should be used instead of {@link module:core/editor/editor~Editor#isReadOnly} to check whether a user action can happen at
  * given selectable. It may be decorated and used differently in different environment (e.g. multi-root editor can disable
  * a particular root).
  *
  * This method is decorated. Although this method accepts any parameter of `Selectable` type, the
  * {@link ~Model#event:canEditAt `canEditAt` event} is fired with `selectable` normalized to an instance of
  * {@link module:engine/model/selection~Selection} or {@link module:engine/model/documentselection~DocumentSelection}
  *
  * @fires canEditAt
  */
  canEditAt(t) {
    const i = fd(t);
    return this.fire("canEditAt", [
      i
    ]);
  }
  /**
  * Creates a position from the given root and path in that root.
  *
  * Note: This method is also available as
  * {@link module:engine/model/writer~Writer#createPositionFromPath `Writer#createPositionFromPath()`}.
  *
  * @param root Root of the position.
  * @param path Position path. See {@link module:engine/model/position~Position#path}.
  * @param stickiness Position stickiness. See {@link module:engine/model/position~PositionStickiness}.
  */
  createPositionFromPath(t, i, r) {
    return new z(t, i, r);
  }
  /**
  * Creates position at the given location. The location can be specified as:
  *
  * * a {@link module:engine/model/position~Position position},
  * * a parent element and offset in that element,
  * * a parent element and `'end'` (the position will be set at the end of that element),
  * * a {@link module:engine/model/item~Item model item} and `'before'` or `'after'`
  * (the position will be set before or after the given model item).
  *
  * This method is a shortcut to other factory methods such as:
  *
  * * {@link module:engine/model/model~Model#createPositionBefore `createPositionBefore()`},
  * * {@link module:engine/model/model~Model#createPositionAfter `createPositionAfter()`}.
  *
  * Note: This method is also available as
  * {@link module:engine/model/writer~Writer#createPositionAt `Writer#createPositionAt()`},
  *
  * @param itemOrPosition
  * @param offset Offset or one of the flags. Used only when first parameter is a {@link module:engine/model/item~Item model item}.
  */
  createPositionAt(t, i) {
    return z._createAt(t, i);
  }
  /**
  * Creates a new position after the given {@link module:engine/model/item~Item model item}.
  *
  * Note: This method is also available as
  * {@link module:engine/model/writer~Writer#createPositionAfter `Writer#createPositionAfter()`}.
  *
  * @param item Item after which the position should be placed.
  */
  createPositionAfter(t) {
    return z._createAfter(t);
  }
  /**
  * Creates a new position before the given {@link module:engine/model/item~Item model item}.
  *
  * Note: This method is also available as
  * {@link module:engine/model/writer~Writer#createPositionBefore `Writer#createPositionBefore()`}.
  *
  * @param item Item before which the position should be placed.
  */
  createPositionBefore(t) {
    return z._createBefore(t);
  }
  /**
  * Creates a range spanning from the `start` position to the `end` position.
  *
  * Note: This method is also available as
  * {@link module:engine/model/writer~Writer#createRange `Writer#createRange()`}:
  *
  * ```ts
  * model.change( writer => {
  * 	const range = writer.createRange( start, end );
  * } );
  * ```
  *
  * @param start Start position.
  * @param end End position. If not set, the range will be collapsed to the `start` position.
  */
  createRange(t, i) {
    return new B(t, i);
  }
  /**
  * Creates a range inside the given element which starts before the first child of
  * that element and ends after the last child of that element.
  *
  * Note: This method is also available as
  * {@link module:engine/model/writer~Writer#createRangeIn `Writer#createRangeIn()`}:
  *
  * ```ts
  * model.change( writer => {
  * 	const range = writer.createRangeIn( paragraph );
  * } );
  * ```
  *
  * @param element Element which is a parent for the range.
  */
  createRangeIn(t) {
    return B._createIn(t);
  }
  /**
  * Creates a range that starts before the given {@link module:engine/model/item~Item model item} and ends after it.
  *
  * Note: This method is also available on `writer` instance as
  * {@link module:engine/model/writer~Writer#createRangeOn `Writer.createRangeOn()`}:
  *
  * ```ts
  * model.change( writer => {
  * 	const range = writer.createRangeOn( paragraph );
  * } );
  * ```
  *
  * @param item
  */
  createRangeOn(t) {
    return B._createOn(t);
  }
  createSelection(...t) {
    return new Sn(...t);
  }
  /**
  * Creates a {@link module:engine/model/batch~Batch} instance.
  *
  * **Note:** In most cases creating a batch instance is not necessary as they are created when using:
  *
  * * {@link #change `change()`},
  * * {@link #enqueueChange `enqueueChange()`}.
  *
  * @param type {@link module:engine/model/batch~Batch#constructor The type} of the batch.
  */
  createBatch(t) {
    return new As(t);
  }
  /**
  * Creates an operation instance from a JSON object (parsed JSON string).
  *
  * This is an alias for {@link module:engine/model/operation/operationfactory~OperationFactory.fromJSON `OperationFactory.fromJSON()`}.
  *
  * @param json Deserialized JSON object.
  */
  createOperationFromJSON(t) {
    return S6.fromJSON(t, this.document);
  }
  /**
  * Removes all events listeners set by model instance and destroys {@link module:engine/model/document~Document}.
  */
  destroy() {
    this.document.destroy(), this.stopListening();
  }
  /**
  * Common part of {@link module:engine/model/model~Model#change} and {@link module:engine/model/model~Model#enqueueChange}
  * which calls callbacks and returns array of values returned by these callbacks.
  */
  _runPendingChanges() {
    const t = [];
    this.fire("_beforeChanges");
    try {
      for (; this._pendingChanges.length; ) {
        const i = this._pendingChanges[0].batch;
        this._currentWriter = new V6(this, i);
        const r = this._pendingChanges[0].callback(this._currentWriter);
        t.push(r), this.document._handleChangeBlock(this._currentWriter), this._pendingChanges.shift(), this._currentWriter = null;
      }
    } finally {
      this._pendingChanges.length = 0, this._currentWriter = null, this.fire("_afterChanges");
    }
    return t;
  }
};
function fd(e, n) {
  if (e)
    return e instanceof Sn || e instanceof oi ? e : e instanceof ds ? n || n === 0 ? new Sn(e, n) : e.is("rootElement") ? new Sn(e, "in") : new Sn(e, "on") : new Sn(e);
}
class fR extends Sr {
  constructor() {
    super(...arguments);
    /**
    * @inheritDoc
    */
    m(this, "domEventType", "click");
  }
  /**
  * @inheritDoc
  */
  onDomEvent(t) {
    this.fire(t.type, t);
  }
}
class nm extends Sr {
  constructor() {
    super(...arguments);
    /**
    * @inheritDoc
    */
    m(this, "domEventType", [
      "mousedown",
      "mouseup",
      "mouseover",
      "mouseout"
    ]);
  }
  /**
  * @inheritDoc
  */
  onDomEvent(t) {
    this.fire(t.type, t);
  }
}
class mR extends Sr {
  constructor() {
    super(...arguments);
    /**
    * @inheritDoc
    */
    m(this, "domEventType", [
      "touchstart",
      "touchend",
      "touchmove"
    ]);
  }
  /**
  * @inheritDoc
  */
  onDomEvent(t) {
    this.fire(t.type, t);
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class RT {
  /**
  * @param {module:watchdog/watchdog~WatchdogConfig} config The watchdog plugin configuration.
  */
  constructor(n) {
    /**
    * An array of crashes saved as an object with the following properties:
    *
    * * `message`: `String`,
    * * `stack`: `String`,
    * * `date`: `Number`,
    * * `filename`: `String | undefined`,
    * * `lineno`: `Number | undefined`,
    * * `colno`: `Number | undefined`,
    */
    m(this, "crashes", []);
    /**
    * Specifies the state of the item watched by the watchdog. The state can be one of the following values:
    *
    * * `initializing` &ndash; Before the first initialization, and after crashes, before the item is ready.
    * * `ready` &ndash; A state when the user can interact with the item.
    * * `crashed` &ndash; A state when an error occurs. It quickly changes to `initializing` or `crashedPermanently`
    * depending on how many and how frequent errors have been caught recently.
    * * `crashedPermanently` &ndash; A state when the watchdog stops reacting to errors and keeps the item it is watching crashed,
    * * `destroyed` &ndash; A state when the item is manually destroyed by the user after calling `watchdog.destroy()`.
    */
    m(this, "state", "initializing");
    /**
    * @see module:watchdog/watchdog~WatchdogConfig
    */
    m(this, "_crashNumberLimit");
    /**
    * Returns the result of the `Date.now()` call. It can be overridden in tests to mock time as some popular
    * approaches like `sinon.useFakeTimers()` do not work well with error handling.
    */
    m(this, "_now", Date.now);
    /**
    * @see module:watchdog/watchdog~WatchdogConfig
    */
    m(this, "_minimumNonErrorTimePeriod");
    /**
    * Checks if the event error comes from the underlying item and restarts the item.
    */
    m(this, "_boundErrorHandler");
    /**
    * A dictionary of event emitter listeners.
    */
    m(this, "_listeners");
    if (this.crashes = [], this._crashNumberLimit = typeof n.crashNumberLimit == "number" ? n.crashNumberLimit : 3, this._minimumNonErrorTimePeriod = typeof n.minimumNonErrorTimePeriod == "number" ? n.minimumNonErrorTimePeriod : 5e3, this._boundErrorHandler = (t) => {
      const i = "error" in t ? t.error : t.reason;
      i instanceof Error && this._handleError(i, t);
    }, this._listeners = {}, !this._restart)
      throw new Error("The Watchdog class was split into the abstract `Watchdog` class and the `EditorWatchdog` class. Please, use `EditorWatchdog` if you have used the `Watchdog` class previously.");
  }
  /**
  * Destroys the watchdog and releases the resources.
  */
  destroy() {
    this._stopErrorHandling(), this._listeners = {};
  }
  /**
  * Starts listening to a specific event name by registering a callback that will be executed
  * whenever an event with a given name fires.
  *
  * Note that this method differs from the CKEditor 5's default `EventEmitterMixin` implementation.
  *
  * @param eventName The event name.
  * @param callback A callback which will be added to event listeners.
  */
  on(n, t) {
    this._listeners[n] || (this._listeners[n] = []), this._listeners[n].push(t);
  }
  /**
  * Stops listening to the specified event name by removing the callback from event listeners.
  *
  * Note that this method differs from the CKEditor 5's default `EventEmitterMixin` implementation.
  *
  * @param eventName The event name.
  * @param callback A callback which will be removed from event listeners.
  */
  off(n, t) {
    this._listeners[n] = this._listeners[n].filter((i) => i !== t);
  }
  /**
  * Fires an event with a given event name and arguments.
  *
  * Note that this method differs from the CKEditor 5's default `EventEmitterMixin` implementation.
  */
  _fire(n, ...t) {
    const i = this._listeners[n] || [];
    for (const r of i)
      r.apply(this, [
        null,
        ...t
      ]);
  }
  /**
  * Starts error handling by attaching global error handlers.
  */
  _startErrorHandling() {
    window.addEventListener("error", this._boundErrorHandler), window.addEventListener("unhandledrejection", this._boundErrorHandler);
  }
  /**
  * Stops error handling by detaching global error handlers.
  */
  _stopErrorHandling() {
    window.removeEventListener("error", this._boundErrorHandler), window.removeEventListener("unhandledrejection", this._boundErrorHandler);
  }
  /**
  * Checks if an error comes from the watched item and restarts it.
  * It reacts to {@link module:utils/ckeditorerror~CKEditorError `CKEditorError` errors} only.
  *
  * @fires error
  * @param error Error.
  * @param evt An error event.
  */
  _handleError(n, t) {
    if (this._shouldReactToError(n)) {
      this.crashes.push({
        message: n.message,
        stack: n.stack,
        // `evt.filename`, `evt.lineno` and `evt.colno` are available only in ErrorEvent events
        filename: t instanceof ErrorEvent ? t.filename : void 0,
        lineno: t instanceof ErrorEvent ? t.lineno : void 0,
        colno: t instanceof ErrorEvent ? t.colno : void 0,
        date: this._now()
      });
      const i = this._shouldRestart();
      this.state = "crashed", this._fire("stateChange"), this._fire("error", {
        error: n,
        causesRestart: i
      }), i ? this._restart() : (this.state = "crashedPermanently", this._fire("stateChange"));
    }
  }
  /**
  * Checks whether an error should be handled by the watchdog.
  *
  * @param error An error that was caught by the error handling process.
  */
  _shouldReactToError(n) {
    return n.is && n.is("CKEditorError") && n.context !== void 0 && // In some cases the watched item should not be restarted - e.g. during the item initialization.
    // That's why the `null` was introduced as a correct error context which does cause restarting.
    n.context !== null && // Do not react to errors if the watchdog is in states other than `ready`.
    this.state === "ready" && this._isErrorComingFromThisItem(n);
  }
  /**
  * Checks if the watchdog should restart the underlying item.
  */
  _shouldRestart() {
    if (this.crashes.length <= this._crashNumberLimit)
      return !0;
    const n = this.crashes[this.crashes.length - 1].date, t = this.crashes[this.crashes.length - 1 - this._crashNumberLimit].date;
    return (n - t) / this._crashNumberLimit > this._minimumNonErrorTimePeriod;
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function Dh(e, n = /* @__PURE__ */ new Set()) {
  const t = [
    e
  ], i = /* @__PURE__ */ new Set();
  let r = 0;
  for (; t.length > r; ) {
    const s = t[r++];
    if (!(i.has(s) || !pR(s) || n.has(s)))
      if (i.add(s), Symbol.iterator in s)
        try {
          for (const o of s)
            t.push(o);
        } catch {
        }
      else
        for (const o in s)
          o !== "defaultValue" && t.push(s[o]);
  }
  return i;
}
function pR(e) {
  const n = Object.prototype.toString.call(e), t = typeof e;
  return !(t === "number" || t === "boolean" || t === "string" || t === "symbol" || t === "function" || n === "[object Date]" || n === "[object RegExp]" || n === "[object Module]" || e === void 0 || e === null || // This flag is meant to exclude singletons shared across editor instances. So when an error is thrown in one editor,
  // the other editors connected through the reference to the same singleton are not restarted. This is a temporary workaround
  // until a better solution is found.
  // More in https://github.com/ckeditor/ckeditor5/issues/12292.
  e._watchdogExcluded || // Skip native DOM objects, e.g. Window, nodes, events, etc.
  e instanceof EventTarget || e instanceof Event);
}
function LT(e, n, t = /* @__PURE__ */ new Set()) {
  if (e === n && gR(e))
    return !0;
  const i = Dh(e, t), r = Dh(n, t);
  for (const s of i)
    if (r.has(s))
      return !0;
  return !1;
}
function gR(e) {
  return typeof e == "object" && e !== null;
}
class DT extends RT {
  /**
  * @param Editor The editor class.
  * @param watchdogConfig The watchdog plugin configuration.
  */
  constructor(t, i = {}) {
    super(i);
    /**
    * The current editor instance.
    */
    m(this, "_editor", null);
    /**
    * A promise associated with the life cycle of the editor (creation or destruction processes).
    *
    * It is used to prevent the initialization of the editor if the previous instance has not been destroyed yet,
    * and conversely, to prevent the destruction of the editor if it has not been initialized.
    */
    m(this, "_lifecyclePromise", null);
    /**
    * Throttled save method. The `save()` method is called the specified `saveInterval` after `throttledSave()` is called,
    * unless a new action happens in the meantime.
    */
    m(this, "_throttledSave");
    /**
    * The latest saved editor data represented as a root name -> root data object.
    */
    m(this, "_data");
    /**
    * The last document version.
    */
    m(this, "_lastDocumentVersion");
    /**
    * The editor source element or data.
    */
    m(this, "_elementOrData");
    /**
    * Specifies whether the editor was initialized using document data (`true`) or HTML elements (`false`).
    */
    m(this, "_initUsingData", !0);
    /**
    * The latest record of the editor editable elements. Used to restart the editor.
    */
    m(this, "_editables", {});
    /**
    * The editor configuration.
    */
    m(this, "_config");
    m(this, "_excludedProps");
    this._throttledSave = pl(this._save.bind(this), typeof i.saveInterval == "number" ? i.saveInterval : 5e3), t && (this._creator = (r, s) => t.create(r, s)), this._destructor = (r) => r.destroy();
  }
  /**
  * The current editor instance.
  */
  get editor() {
    return this._editor;
  }
  /**
  * @internal
  */
  get _item() {
    return this._editor;
  }
  /**
  * Sets the function that is responsible for the editor creation.
  * It expects a function that should return a promise.
  *
  * ```ts
  * watchdog.setCreator( ( element, config ) => ClassicEditor.create( element, config ) );
  * ```
  */
  setCreator(t) {
    this._creator = t;
  }
  /**
  * Sets the function that is responsible for the editor destruction.
  * Overrides the default destruction function, which destroys only the editor instance.
  * It expects a function that should return a promise or `undefined`.
  *
  * ```ts
  * watchdog.setDestructor( editor => {
  * 	// Do something before the editor is destroyed.
  *
  * 	return editor
  * 		.destroy()
  * 		.then( () => {
  * 			// Do something after the editor is destroyed.
  * 		} );
  * } );
  * ```
  */
  setDestructor(t) {
    this._destructor = t;
  }
  /**
  * Restarts the editor instance. This method is called whenever an editor error occurs. It fires the `restart` event and changes
  * the state to `initializing`.
  *
  * @fires restart
  */
  _restart() {
    return Promise.resolve().then(() => (this.state = "initializing", this._fire("stateChange"), this._destroy())).catch((t) => {
      console.error("An error happened during the editor destroying.", t);
    }).then(() => {
      const t = {}, i = [], r = this._config.rootsAttributes || {}, s = {};
      for (const [a, u] of Object.entries(this._data.roots))
        u.isLoaded ? (t[a] = "", s[a] = r[a] || {}) : i.push(a);
      const o = {
        ...this._config,
        extraPlugins: this._config.extraPlugins || [],
        lazyRoots: i,
        rootsAttributes: s,
        _watchdogInitialData: this._data
      };
      return delete o.initialData, o.extraPlugins.push(bR), this._initUsingData ? this.create(t, o, o.context) : Er(this._elementOrData) ? this.create(this._elementOrData, o, o.context) : this.create(this._editables, o, o.context);
    }).then(() => {
      this._fire("restart");
    });
  }
  /**
  * Creates the editor instance and keeps it running, using the defined creator and destructor.
  *
  * @param elementOrData The editor source element or the editor data.
  * @param config The editor configuration.
  * @param context A context for the editor.
  */
  create(t = this._elementOrData, i = this._config, r) {
    return this._lifecyclePromise = Promise.resolve(this._lifecyclePromise).then(() => (super._startErrorHandling(), this._elementOrData = t, this._initUsingData = typeof t == "string" || Object.keys(t).length > 0 && typeof Object.values(t)[0] == "string", this._config = this._cloneEditorConfiguration(i) || {}, this._config.context = r, this._creator(t, this._config))).then((s) => {
      this._editor = s, s.model.document.on("change:data", this._throttledSave), this._lastDocumentVersion = s.model.document.version, this._data = this._getData(), this._initUsingData || (this._editables = this._getEditables()), this.state = "ready", this._fire("stateChange");
    }).finally(() => {
      this._lifecyclePromise = null;
    }), this._lifecyclePromise;
  }
  /**
  * Destroys the watchdog and the current editor instance. It fires the callback
  * registered in {@link #setDestructor `setDestructor()`} and uses it to destroy the editor instance.
  * It also sets the state to `destroyed`.
  */
  destroy() {
    return this._lifecyclePromise = Promise.resolve(this._lifecyclePromise).then(() => (this.state = "destroyed", this._fire("stateChange"), super.destroy(), this._destroy())).finally(() => {
      this._lifecyclePromise = null;
    }), this._lifecyclePromise;
  }
  _destroy() {
    return Promise.resolve().then(() => {
      this._stopErrorHandling(), this._throttledSave.cancel();
      const t = this._editor;
      return this._editor = null, t.model.document.off("change:data", this._throttledSave), this._destructor(t);
    });
  }
  /**
  * Saves the editor data, so it can be restored after the crash even if the data cannot be fetched at
  * the moment of the crash.
  */
  _save() {
    const t = this._editor.model.document.version;
    try {
      this._data = this._getData(), this._initUsingData || (this._editables = this._getEditables()), this._lastDocumentVersion = t;
    } catch (i) {
      console.error(i, "An error happened during restoring editor data. Editor will be restored from the previously saved data.");
    }
  }
  /**
  * @internal
  */
  _setExcludedProperties(t) {
    this._excludedProps = t;
  }
  /**
  * Gets all data that is required to reinitialize editor instance.
  */
  _getData() {
    const t = this._editor, i = t.model.document.roots.filter((u) => u.isAttached() && u.rootName != "$graveyard"), { plugins: r } = t, s = r.has("CommentsRepository") && r.get("CommentsRepository"), o = r.has("TrackChanges") && r.get("TrackChanges"), a = {
      roots: {},
      markers: {},
      commentThreads: JSON.stringify([]),
      suggestions: JSON.stringify([])
    };
    i.forEach((u) => {
      a.roots[u.rootName] = {
        content: JSON.stringify(Array.from(u.getChildren())),
        attributes: JSON.stringify(Array.from(u.getAttributes())),
        isLoaded: u._isLoaded
      };
    });
    for (const u of t.model.markers)
      u._affectsData && (a.markers[u.name] = {
        rangeJSON: u.getRange().toJSON(),
        usingOperation: u._managedUsingOperations,
        affectsData: u._affectsData
      });
    return s && (a.commentThreads = JSON.stringify(s.getCommentThreads({
      toJSON: !0,
      skipNotAttached: !0
    }))), o && (a.suggestions = JSON.stringify(o.getSuggestions({
      toJSON: !0,
      skipNotAttached: !0
    }))), a;
  }
  /**
  * For each attached model root, returns its HTML editable element (if available).
  */
  _getEditables() {
    const t = {};
    for (const i of this.editor.model.document.getRootNames()) {
      const r = this.editor.ui.getEditableElement(i);
      r && (t[i] = r);
    }
    return t;
  }
  /**
  * Traverses the error context and the current editor to find out whether these structures are connected
  * to each other via properties.
  *
  * @internal
  */
  _isErrorComingFromThisItem(t) {
    return LT(this._editor, t.context, this._excludedProps);
  }
  /**
  * Clones the editor configuration.
  */
  _cloneEditorConfiguration(t) {
    return Ff(t, (i, r) => {
      if (Er(i) || r === "context")
        return i;
    });
  }
}
class bR {
  constructor(n) {
    m(this, "editor");
    m(this, "_data");
    this.editor = n, this._data = n.config.get("_watchdogInitialData");
  }
  /**
  * @inheritDoc
  */
  init() {
    this.editor.data.on("init", (n) => {
      n.stop(), this.editor.model.enqueueChange({
        isUndoable: !1
      }, (t) => {
        this._restoreCollaborationData(), this._restoreEditorData(t);
      }), this.editor.data.fire("ready");
    }, {
      priority: 999
    });
  }
  /**
  * Creates a model node (element or text) based on provided JSON.
  */
  _createNode(n, t) {
    if ("name" in t) {
      const i = n.createElement(t.name, t.attributes);
      if (t.children)
        for (const r of t.children)
          i._appendChild(this._createNode(n, r));
      return i;
    } else
      return n.createText(t.data, t.attributes);
  }
  /**
  * Restores the editor by setting the document data, roots attributes and markers.
  */
  _restoreEditorData(n) {
    const t = this.editor;
    Object.entries(this._data.roots).forEach(([i, { content: r, attributes: s }]) => {
      const o = JSON.parse(r), a = JSON.parse(s), u = t.model.document.getRoot(i);
      for (const [l, c] of a)
        n.setAttribute(l, c, u);
      for (const l of o) {
        const c = this._createNode(n, l);
        n.insert(c, u, "end");
      }
    }), Object.entries(this._data.markers).forEach(([i, r]) => {
      const { document: s } = t.model, { rangeJSON: { start: o, end: a }, ...u } = r, l = s.getRoot(o.root), c = n.createPositionFromPath(l, o.path, o.stickiness), d = n.createPositionFromPath(l, a.path, a.stickiness), p = n.createRange(c, d);
      n.addMarker(i, {
        range: p,
        ...u
      });
    });
  }
  /**
  * Restores the editor collaboration data - comment threads and suggestions.
  */
  _restoreCollaborationData() {
    const n = JSON.parse(this._data.commentThreads), t = JSON.parse(this._data.suggestions);
    n.forEach((i) => {
      const r = this.editor.config.get("collaboration.channelId"), s = this.editor.plugins.get("CommentsRepository");
      s.hasCommentThread(i.threadId) && s.getCommentThread(i.threadId).remove(), s.addCommentThread({
        channelId: r,
        ...i
      });
    }), t.forEach((i) => {
      const r = this.editor.plugins.get("TrackChangesEditing");
      if (r.hasSuggestion(i.id)) {
        const s = r.getSuggestion(i.id);
        s.attributes = i.attributes;
      } else
        r.addSuggestionData(i);
    });
  }
}
const la = Symbol("MainQueueId");
class _R extends RT {
  /**
  * The context watchdog class constructor.
  *
  * ```ts
  * const watchdog = new ContextWatchdog( Context );
  *
  * await watchdog.create( contextConfiguration );
  *
  * await watchdog.add( item );
  * ```
  *
  * See the {@glink features/watchdog Watchdog feature guide} to learn more how to use this feature.
  *
  * @param Context The {@link module:core/context~Context} class.
  * @param watchdogConfig The watchdog configuration.
  */
  constructor(t, i = {}) {
    super(i);
    /**
    * A map of internal watchdogs for added items.
    */
    m(this, "_watchdogs", /* @__PURE__ */ new Map());
    /**
    * The watchdog configuration.
    */
    m(this, "_watchdogConfig");
    /**
    * The current context instance.
    */
    m(this, "_context", null);
    /**
    * Context properties (nodes/references) that are gathered during the initial context creation
    * and are used to distinguish the origin of an error.
    */
    m(this, "_contextProps", /* @__PURE__ */ new Set());
    /**
    * An action queue, which is used to handle async functions queuing.
    */
    m(this, "_actionQueues", new ER());
    /**
    * The configuration for the {@link module:core/context~Context}.
    */
    m(this, "_contextConfig");
    /**
    * The watched item.
    */
    m(this, "_item");
    this._watchdogConfig = i, this._creator = (r) => t.create(r), this._destructor = (r) => r.destroy(), this._actionQueues.onEmpty(() => {
      this.state === "initializing" && (this.state = "ready", this._fire("stateChange"));
    });
  }
  /**
  * Sets the function that is responsible for the context creation.
  * It expects a function that should return a promise (or `undefined`).
  *
  * ```ts
  * watchdog.setCreator( config => Context.create( config ) );
  * ```
  */
  setCreator(t) {
    this._creator = t;
  }
  /**
  * Sets the function that is responsible for the context destruction.
  * Overrides the default destruction function, which destroys only the context instance.
  * It expects a function that should return a promise (or `undefined`).
  *
  * ```ts
  * watchdog.setDestructor( context => {
  * 	// Do something before the context is destroyed.
  *
  * 	return context
  * 		.destroy()
  * 		.then( () => {
  * 			// Do something after the context is destroyed.
  * 		} );
  * } );
  * ```
  */
  setDestructor(t) {
    this._destructor = t;
  }
  /**
  * The context instance. Keep in mind that this property might be changed when the context watchdog restarts,
  * so do not keep this instance internally. Always operate on the `ContextWatchdog#context` property.
  */
  get context() {
    return this._context;
  }
  /**
  * Initializes the context watchdog. Once it is created, the watchdog takes care about
  * recreating the context and the provided items, and starts the error handling mechanism.
  *
  * ```ts
  * await watchdog.create( {
  * 	plugins: []
  * } );
  * ```
  *
  * @param contextConfig The context configuration. See {@link module:core/context~Context}.
  */
  create(t = {}) {
    return this._actionQueues.enqueue(la, () => (this._contextConfig = t, this._create()));
  }
  /**
  * Returns an item instance with the given `itemId`.
  *
  * ```ts
  * const editor1 = watchdog.getItem( 'editor1' );
  * ```
  *
  * @param itemId The item ID.
  * @returns The item instance or `undefined` if an item with a given ID has not been found.
  */
  getItem(t) {
    return this._getWatchdog(t)._item;
  }
  /**
  * Gets the state of the given item. See {@link #state} for a list of available states.
  *
  * ```ts
  * const editor1State = watchdog.getItemState( 'editor1' );
  * ```
  *
  * @param itemId Item ID.
  * @returns The state of the item.
  */
  getItemState(t) {
    return this._getWatchdog(t).state;
  }
  /**
  * Adds items to the watchdog. Once created, instances of these items will be available using the {@link #getItem} method.
  *
  * Items can be passed together as an array of objects:
  *
  * ```ts
  * await watchdog.add( [ {
  * 	id: 'editor1',
  * 	type: 'editor',
  * 	sourceElementOrData: document.querySelector( '#editor' ),
  * 	config: {
  * 		plugins: [ Essentials, Paragraph, Bold, Italic ],
  * 		toolbar: [ 'bold', 'italic', 'alignment' ]
  * 	},
  * 	creator: ( element, config ) => ClassicEditor.create( element, config )
  * } ] );
  * ```
  *
  * Or one by one as objects:
  *
  * ```ts
  * await watchdog.add( {
  * 	id: 'editor1',
  * 	type: 'editor',
  * 	sourceElementOrData: document.querySelector( '#editor' ),
  * 	config: {
  * 		plugins: [ Essentials, Paragraph, Bold, Italic ],
  * 		toolbar: [ 'bold', 'italic', 'alignment' ]
  * 	},
  * 	creator: ( element, config ) => ClassicEditor.create( element, config )
  * ] );
  * ```
  *
  * Then an instance can be retrieved using the {@link #getItem} method:
  *
  * ```ts
  * const editor1 = watchdog.getItem( 'editor1' );
  * ```
  *
  * Note that this method can be called multiple times, but for performance reasons it is better
  * to pass all items together.
  *
  * @param itemConfigurationOrItemConfigurations An item configuration object or an array of item configurations.
  */
  add(t) {
    const i = Qp(t);
    return Promise.all(i.map((r) => this._actionQueues.enqueue(r.id, () => {
      if (this.state === "destroyed")
        throw new Error("Cannot add items to destroyed watchdog.");
      if (!this._context)
        throw new Error("Context was not created yet. You should call the `ContextWatchdog#create()` method first.");
      let s;
      if (this._watchdogs.has(r.id))
        throw new Error(`Item with the given id is already added: '${r.id}'.`);
      if (r.type === "editor")
        return s = new DT(null, this._watchdogConfig), s.setCreator(r.creator), s._setExcludedProperties(this._contextProps), r.destructor && s.setDestructor(r.destructor), this._watchdogs.set(r.id, s), s.on("error", (o, { error: a, causesRestart: u }) => {
          this._fire("itemError", {
            itemId: r.id,
            error: a
          }), u && this._actionQueues.enqueue(r.id, () => new Promise((l) => {
            const c = () => {
              s.off("restart", c), this._fire("itemRestart", {
                itemId: r.id
              }), l();
            };
            s.on("restart", c);
          }));
        }), s.create(r.sourceElementOrData, r.config, this._context);
      throw new Error(`Not supported item type: '${r.type}'.`);
    })));
  }
  /**
  * Removes and destroys item(s) with given ID(s).
  *
  * ```ts
  * await watchdog.remove( 'editor1' );
  * ```
  *
  * Or
  *
  * ```ts
  * await watchdog.remove( [ 'editor1', 'editor2' ] );
  * ```
  *
  * @param itemIdOrItemIds Item ID or an array of item IDs.
  */
  remove(t) {
    const i = Qp(t);
    return Promise.all(i.map((r) => this._actionQueues.enqueue(r, () => {
      const s = this._getWatchdog(r);
      return this._watchdogs.delete(r), s.destroy();
    })));
  }
  /**
  * Destroys the context watchdog and all added items.
  * Once the context watchdog is destroyed, new items cannot be added.
  *
  * ```ts
  * await watchdog.destroy();
  * ```
  */
  destroy() {
    return this._actionQueues.enqueue(la, () => (this.state = "destroyed", this._fire("stateChange"), super.destroy(), this._destroy()));
  }
  /**
  * Restarts the context watchdog.
  */
  _restart() {
    return this._actionQueues.enqueue(la, () => (this.state = "initializing", this._fire("stateChange"), this._destroy().catch((t) => {
      console.error("An error happened during destroying the context or items.", t);
    }).then(() => this._create()).then(() => this._fire("restart"))));
  }
  /**
  * Initializes the context watchdog.
  */
  _create() {
    return Promise.resolve().then(() => (this._startErrorHandling(), this._creator(this._contextConfig))).then((t) => (this._context = t, this._contextProps = Dh(this._context), Promise.all(Array.from(this._watchdogs.values()).map((i) => (i._setExcludedProperties(this._contextProps), i.create(void 0, void 0, this._context))))));
  }
  /**
  * Destroys the context instance and all added items.
  */
  _destroy() {
    return Promise.resolve().then(() => {
      this._stopErrorHandling();
      const t = this._context;
      return this._context = null, this._contextProps = /* @__PURE__ */ new Set(), Promise.all(Array.from(this._watchdogs.values()).map((i) => i.destroy())).then(() => this._destructor(t));
    });
  }
  /**
  * Returns the watchdog for a given item ID.
  *
  * @param itemId Item ID.
  */
  _getWatchdog(t) {
    const i = this._watchdogs.get(t);
    if (!i)
      throw new Error(`Item with the given id was not registered: ${t}.`);
    return i;
  }
  /**
  * Checks whether an error comes from the context instance and not from the item instances.
  *
  * @internal
  */
  _isErrorComingFromThisItem(t) {
    for (const i of this._watchdogs.values())
      if (i._isErrorComingFromThisItem(t))
        return !1;
    return LT(this._context, t.context);
  }
}
class ER {
  constructor() {
    m(this, "_onEmptyCallbacks", []);
    m(this, "_queues", /* @__PURE__ */ new Map());
    m(this, "_activeActions", 0);
  }
  /**
  * Used to register callbacks that will be run when the queue becomes empty.
  *
  * @param onEmptyCallback A callback that will be run whenever the queue becomes empty.
  */
  onEmpty(n) {
    this._onEmptyCallbacks.push(n);
  }
  /**
  * It adds asynchronous actions (functions) to the proper queue and runs them one by one.
  *
  * @param queueId The action queue ID.
  * @param action A function that should be enqueued.
  */
  enqueue(n, t) {
    const i = n === la;
    this._activeActions++, this._queues.get(n) || this._queues.set(n, Promise.resolve());
    const s = (i ? Promise.all(this._queues.values()) : Promise.all([
      this._queues.get(la),
      this._queues.get(n)
    ])).then(t), o = s.catch(() => {
    });
    return this._queues.set(n, o), s.finally(() => {
      this._activeActions--, this._queues.get(n) === o && this._activeActions === 0 && this._onEmptyCallbacks.forEach((a) => a());
    });
  }
}
function Qp(e) {
  return Array.isArray(e) ? e : [
    e
  ];
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class ce extends (/* @__PURE__ */ pt()) {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super();
    /**
    * The editor instance.
    *
    * Note that most editors implement the {@link module:core/editor/editor~Editor#ui} property.
    * However, editors with an external UI (i.e. Bootstrap-based) or a headless editor may not have this property or
    * throw an error when accessing it.
    *
    * Because of above, to make plugins more universal, it is recommended to split features into:
    *  - The "editing" part that uses the {@link module:core/editor/editor~Editor} class without `ui` property.
    *  - The "UI" part that uses the {@link module:core/editor/editor~Editor} class and accesses `ui` property.
    */
    m(this, "editor");
    /**
    * Holds identifiers for {@link #forceDisabled} mechanism.
    */
    m(this, "_disableStack", /* @__PURE__ */ new Set());
    this.editor = t, this.set("isEnabled", !0);
  }
  /**
  * Disables the plugin.
  *
  * Plugin may be disabled by multiple features or algorithms (at once). When disabling a plugin, unique id should be passed
  * (e.g. feature name). The same identifier should be used when {@link #clearForceDisabled enabling back} the plugin.
  * The plugin becomes enabled only after all features {@link #clearForceDisabled enabled it back}.
  *
  * Disabling and enabling a plugin:
  *
  * ```ts
  * plugin.isEnabled; // -> true
  * plugin.forceDisabled( 'MyFeature' );
  * plugin.isEnabled; // -> false
  * plugin.clearForceDisabled( 'MyFeature' );
  * plugin.isEnabled; // -> true
  * ```
  *
  * Plugin disabled by multiple features:
  *
  * ```ts
  * plugin.forceDisabled( 'MyFeature' );
  * plugin.forceDisabled( 'OtherFeature' );
  * plugin.clearForceDisabled( 'MyFeature' );
  * plugin.isEnabled; // -> false
  * plugin.clearForceDisabled( 'OtherFeature' );
  * plugin.isEnabled; // -> true
  * ```
  *
  * Multiple disabling with the same identifier is redundant:
  *
  * ```ts
  * plugin.forceDisabled( 'MyFeature' );
  * plugin.forceDisabled( 'MyFeature' );
  * plugin.clearForceDisabled( 'MyFeature' );
  * plugin.isEnabled; // -> true
  * ```
  *
  * **Note:** some plugins or algorithms may have more complex logic when it comes to enabling or disabling certain plugins,
  * so the plugin might be still disabled after {@link #clearForceDisabled} was used.
  *
  * @param id Unique identifier for disabling. Use the same id when {@link #clearForceDisabled enabling back} the plugin.
  */
  forceDisabled(t) {
    this._disableStack.add(t), this._disableStack.size == 1 && (this.on("set:isEnabled", Xp, {
      priority: "highest"
    }), this.isEnabled = !1);
  }
  /**
  * Clears forced disable previously set through {@link #forceDisabled}. See {@link #forceDisabled}.
  *
  * @param id Unique identifier, equal to the one passed in {@link #forceDisabled} call.
  */
  clearForceDisabled(t) {
    this._disableStack.delete(t), this._disableStack.size == 0 && (this.off("set:isEnabled", Xp), this.isEnabled = !0);
  }
  /**
  * @inheritDoc
  */
  destroy() {
    this.stopListening();
  }
  /**
  * @inheritDoc
  */
  static get isContextPlugin() {
    return !1;
  }
  /**
  * @inheritDoc
  * @internal
  */
  static get isOfficialPlugin() {
    return !1;
  }
  /**
  * @inheritDoc
  * @internal
  */
  static get isPremiumPlugin() {
    return !1;
  }
}
function Xp(e) {
  e.return = !1, e.stop();
}
class Mt extends (/* @__PURE__ */ pt()) {
  /**
  * Creates a new `Command` instance.
  *
  * @param editor The editor on which this command will be used.
  */
  constructor(t) {
    super();
    /**
    * The editor on which this command will be used.
    */
    m(this, "editor");
    /**
    * A flag indicating whether a command's `isEnabled` state should be changed depending on where the document
    * selection is placed.
    *
    * By default, it is set to `true`. If the document selection is placed in a
    * {@link module:engine/model/model~Model#canEditAt non-editable} place (such as non-editable root), the command becomes disabled.
    *
    * The flag should be changed to `false` in a concrete command's constructor if the command should not change its `isEnabled`
    * accordingly to the document selection.
    */
    m(this, "_isEnabledBasedOnSelection");
    /**
    * A flag indicating whether a command execution changes the editor data or not.
    *
    * @see #affectsData
    */
    m(this, "_affectsData");
    /**
    * Holds identifiers for {@link #forceDisabled} mechanism.
    */
    m(this, "_disableStack");
    this.editor = t, this.set("value", void 0), this.set("isEnabled", !1), this._affectsData = !0, this._isEnabledBasedOnSelection = !0, this._disableStack = /* @__PURE__ */ new Set(), this.decorate("execute"), this.listenTo(this.editor.model.document, "change", () => {
      this.refresh();
    }), this.listenTo(t, "change:isReadOnly", () => {
      this.refresh();
    }), this.on("set:isEnabled", (i) => {
      if (!this.affectsData)
        return;
      const r = t.model.document.selection, o = !(r.getFirstPosition().root.rootName == "$graveyard") && t.model.canEditAt(r);
      (t.isReadOnly || this._isEnabledBasedOnSelection && !o) && (i.return = !1, i.stop());
    }, {
      priority: "highest"
    }), this.on("execute", (i) => {
      this.isEnabled || i.stop();
    }, {
      priority: "high"
    });
  }
  /**
  * A flag indicating whether a command execution changes the editor data or not.
  *
  * Commands with `affectsData` set to `false` will not be automatically disabled in
  * the {@link module:core/editor/editor~Editor#isReadOnly read-only mode} and
  * {@glink features/read-only#related-features other editor modes} with restricted user write permissions.
  *
  * **Note:** You do not have to set it for your every command. It is `true` by default.
  *
  * @default true
  */
  get affectsData() {
    return this._affectsData;
  }
  set affectsData(t) {
    this._affectsData = t;
  }
  /**
  * Refreshes the command. The command should update its {@link #isEnabled} and {@link #value} properties
  * in this method.
  *
  * This method is automatically called when
  * {@link module:engine/model/document~Document#event:change any changes are applied to the document}.
  */
  refresh() {
    this.isEnabled = !0;
  }
  /**
  * Disables the command.
  *
  * Command may be disabled by multiple features or algorithms (at once). When disabling a command, unique id should be passed
  * (e.g. the feature name). The same identifier should be used when {@link #clearForceDisabled enabling back} the command.
  * The command becomes enabled only after all features {@link #clearForceDisabled enabled it back}.
  *
  * Disabling and enabling a command:
  *
  * ```ts
  * command.isEnabled; // -> true
  * command.forceDisabled( 'MyFeature' );
  * command.isEnabled; // -> false
  * command.clearForceDisabled( 'MyFeature' );
  * command.isEnabled; // -> true
  * ```
  *
  * Command disabled by multiple features:
  *
  * ```ts
  * command.forceDisabled( 'MyFeature' );
  * command.forceDisabled( 'OtherFeature' );
  * command.clearForceDisabled( 'MyFeature' );
  * command.isEnabled; // -> false
  * command.clearForceDisabled( 'OtherFeature' );
  * command.isEnabled; // -> true
  * ```
  *
  * Multiple disabling with the same identifier is redundant:
  *
  * ```ts
  * command.forceDisabled( 'MyFeature' );
  * command.forceDisabled( 'MyFeature' );
  * command.clearForceDisabled( 'MyFeature' );
  * command.isEnabled; // -> true
  * ```
  *
  * **Note:** some commands or algorithms may have more complex logic when it comes to enabling or disabling certain commands,
  * so the command might be still disabled after {@link #clearForceDisabled} was used.
  *
  * @param id Unique identifier for disabling. Use the same id when {@link #clearForceDisabled enabling back} the command.
  */
  forceDisabled(t) {
    this._disableStack.add(t), this._disableStack.size == 1 && (this.on("set:isEnabled", Jp, {
      priority: "highest"
    }), this.isEnabled = !1);
  }
  /**
  * Clears forced disable previously set through {@link #forceDisabled}. See {@link #forceDisabled}.
  *
  * @param id Unique identifier, equal to the one passed in {@link #forceDisabled} call.
  */
  clearForceDisabled(t) {
    this._disableStack.delete(t), this._disableStack.size == 0 && (this.off("set:isEnabled", Jp), this.refresh());
  }
  /**
  * Executes the command.
  *
  * A command may accept parameters. They will be passed from {@link module:core/editor/editor~Editor#execute `editor.execute()`}
  * to the command.
  *
  * The `execute()` method will automatically abort when the command is disabled ({@link #isEnabled} is `false`).
  * This behavior is implemented by a high priority listener to the {@link #event:execute} event.
  *
  * In order to see how to disable a command from "outside" see the {@link #isEnabled} documentation.
  *
  * This method may return a value, which would be forwarded all the way down to the
  * {@link module:core/editor/editor~Editor#execute `editor.execute()`}.
  *
  * @fires execute
  */
  execute(...t) {
  }
  /**
  * Destroys the command.
  */
  destroy() {
    this.stopListening();
  }
}
function Jp(e) {
  e.return = !1, e.stop();
}
class MT extends (/* @__PURE__ */ Je()) {
  /**
  * Creates an instance of the plugin collection class.
  * Allows loading and initializing plugins and their dependencies.
  * Allows providing a list of already loaded plugins. These plugins will not be destroyed along with this collection.
  *
  * @param availablePlugins Plugins (constructors) which the collection will be able to use
  * when {@link module:core/plugincollection~PluginCollection#init} is used with the plugin names (strings, instead of constructors).
  * Usually, the editor will pass its built-in plugins to the collection so they can later be
  * used in `config.plugins` or `config.removePlugins` by names.
  * @param contextPlugins A list of already initialized plugins represented by a `[ PluginConstructor, pluginInstance ]` pair.
  */
  constructor(t, i = [], r = []) {
    super();
    m(this, "_context");
    m(this, "_plugins", /* @__PURE__ */ new Map());
    /**
    * A map of plugin constructors that can be retrieved by their names.
    */
    m(this, "_availablePlugins");
    /**
    * Map of {@link module:core/contextplugin~ContextPlugin context plugins} which can be retrieved by their constructors or instances.
    */
    m(this, "_contextPlugins");
    this._context = t, this._availablePlugins = /* @__PURE__ */ new Map();
    for (const s of i)
      s.pluginName && this._availablePlugins.set(s.pluginName, s);
    this._contextPlugins = /* @__PURE__ */ new Map();
    for (const [s, o] of r)
      this._contextPlugins.set(s, o), this._contextPlugins.set(o, s), s.pluginName && this._availablePlugins.set(s.pluginName, s);
  }
  /**
  * Iterable interface.
  *
  * Returns `[ PluginConstructor, pluginInstance ]` pairs.
  */
  *[Symbol.iterator]() {
    for (const t of this._plugins)
      typeof t[0] == "function" && (yield t);
  }
  /**
  * Gets the plugin instance by its constructor or name.
  *
  * ```ts
  * // Check if 'Clipboard' plugin was loaded.
  * if ( editor.plugins.has( 'ClipboardPipeline' ) ) {
  * 	// Get clipboard plugin instance
  * 	const clipboard = editor.plugins.get( 'ClipboardPipeline' );
  *
  * 	this.listenTo( clipboard, 'inputTransformation', ( evt, data ) => {
  * 		// Do something on clipboard input.
  * 	} );
  * }
  * ```
  *
  * **Note**: This method will throw an error if a plugin is not loaded. Use `{@link #has editor.plugins.has()}`
  * to check if a plugin is available.
  *
  * @param key The plugin constructor or {@link module:core/plugin~PluginStaticMembers#pluginName name}.
  */
  get(t) {
    const i = this._plugins.get(t);
    if (!i) {
      let r = t;
      throw typeof t == "function" && (r = t.pluginName || t.name), new v("plugincollection-plugin-not-loaded", this._context, {
        plugin: r
      });
    }
    return i;
  }
  /**
  * Checks if a plugin is loaded.
  *
  * ```ts
  * // Check if the 'Clipboard' plugin was loaded.
  * if ( editor.plugins.has( 'ClipboardPipeline' ) ) {
  * 	// Now use the clipboard plugin instance:
  * 	const clipboard = editor.plugins.get( 'ClipboardPipeline' );
  *
  * 	// ...
  * }
  * ```
  *
  * @param key The plugin constructor or {@link module:core/plugin~PluginStaticMembers#pluginName name}.
  */
  has(t) {
    return this._plugins.has(t);
  }
  /**
  * Initializes a set of plugins and adds them to the collection.
  *
  * @param plugins An array of {@link module:core/plugin~PluginInterface plugin constructors}
  * or {@link module:core/plugin~PluginStaticMembers#pluginName plugin names}.
  * @param pluginsToRemove Names of the plugins or plugin constructors
  * that should not be loaded (despite being specified in the `plugins` array).
  * @param pluginsSubstitutions An array of {@link module:core/plugin~PluginInterface plugin constructors}
  * that will be used to replace plugins of the same names that were passed in `plugins` or that are in their dependency tree.
  * A useful option for replacing built-in plugins while creating tests (for mocking their APIs). Plugins that will be replaced
  * must follow these rules:
  *   * The new plugin must be a class.
  *   * The new plugin must be named.
  *   * Both plugins must not depend on other plugins.
  * @returns A promise which gets resolved once all plugins are loaded and available in the collection.
  */
  init(t, i = [], r = []) {
    const s = this, o = this._context;
    b(t), k(t);
    const a = t.filter((V) => !p(V, i)), u = [
      ..._(a)
    ];
    O(u, r);
    const l = j(u);
    return F(l, "init").then(() => F(l, "afterInit")).then(() => l);
    function c(V) {
      return typeof V == "function";
    }
    function d(V) {
      return c(V) && !!V.isContextPlugin;
    }
    function p(V, ie) {
      return ie.some((W) => W === V || g(V) === W || g(W) === V);
    }
    function g(V) {
      return c(V) ? V.pluginName || V.name : V;
    }
    function b(V, ie = /* @__PURE__ */ new Set()) {
      V.forEach((W) => {
        c(W) && (ie.has(W) || (ie.add(W), W.pluginName && !s._availablePlugins.has(W.pluginName) && s._availablePlugins.set(W.pluginName, W), W.requires && b(W.requires, ie)));
      });
    }
    function _(V, ie = /* @__PURE__ */ new Set()) {
      return V.map((W) => c(W) ? W : s._availablePlugins.get(W)).reduce((W, N) => ie.has(N) ? W : (ie.add(N), N.requires && (k(N.requires, N), _(N.requires, ie).forEach((Z) => W.add(Z))), W.add(N)), /* @__PURE__ */ new Set());
    }
    function k(V, ie = null) {
      V.map((W) => c(W) ? W : s._availablePlugins.get(W) || W).forEach((W) => {
        C(W, ie), D(W, ie), M(W, ie);
      });
    }
    function C(V, ie) {
      if (!c(V))
        throw ie ? new v("plugincollection-soft-required", o, {
          missingPlugin: V,
          requiredBy: g(ie)
        }) : new v("plugincollection-plugin-not-found", o, {
          plugin: V
        });
    }
    function D(V, ie) {
      if (d(ie) && !d(V))
        throw new v("plugincollection-context-required", o, {
          plugin: g(V),
          requiredBy: g(ie)
        });
    }
    function M(V, ie) {
      if (ie && p(V, i))
        throw new v("plugincollection-required", o, {
          plugin: g(V),
          requiredBy: g(ie)
        });
    }
    function j(V) {
      return V.map((ie) => {
        let W = s._contextPlugins.get(ie);
        return W = W || new ie(o), s._add(ie, W), W;
      });
    }
    function F(V, ie) {
      return V.reduce((W, N) => !N[ie] || s._contextPlugins.has(N) ? W : W.then(N[ie].bind(N)), Promise.resolve());
    }
    function O(V, ie) {
      for (const W of ie) {
        if (typeof W != "function")
          throw new v("plugincollection-replace-plugin-invalid-type", null, {
            pluginItem: W
          });
        const N = W.pluginName;
        if (!N)
          throw new v("plugincollection-replace-plugin-missing-name", null, {
            pluginItem: W
          });
        if (W.requires && W.requires.length)
          throw new v("plugincollection-plugin-for-replacing-cannot-have-dependencies", null, {
            pluginName: N
          });
        const Z = s._availablePlugins.get(N);
        if (!Z)
          throw new v("plugincollection-plugin-for-replacing-not-exist", null, {
            pluginName: N
          });
        const ee = V.indexOf(Z);
        if (ee === -1) {
          if (s._contextPlugins.has(Z))
            return;
          throw new v("plugincollection-plugin-for-replacing-not-loaded", null, {
            pluginName: N
          });
        }
        if (Z.requires && Z.requires.length)
          throw new v("plugincollection-replaced-plugin-cannot-have-dependencies", null, {
            pluginName: N
          });
        V.splice(ee, 1, W), s._availablePlugins.set(N, W);
      }
    }
  }
  /**
  * Destroys all loaded plugins.
  */
  destroy() {
    const t = [];
    for (const [, i] of this)
      typeof i.destroy == "function" && !this._contextPlugins.has(i) && t.push(i.destroy());
    return Promise.all(t);
  }
  /**
  * Adds the plugin to the collection. Exposed mainly for testing purposes.
  *
  * @param PluginConstructor The plugin constructor.
  * @param plugin The instance of the plugin.
  */
  _add(t, i) {
    this._plugins.set(t, i);
    const r = t.pluginName;
    if (r) {
      if (this._plugins.has(r))
        throw new v("plugincollection-plugin-name-conflict", null, {
          pluginName: r,
          plugin1: this._plugins.get(r).constructor,
          plugin2: t
        });
      this._plugins.set(r, i);
    }
  }
}
class wl {
  /**
  * Creates a context instance with a given configuration.
  *
  * Usually not to be used directly. See the static {@link module:core/context~Context.create `create()`} method.
  *
  * @param config The context configuration.
  */
  constructor(n) {
    /**
    * Stores all the configurations specific to this context instance.
    */
    m(this, "config");
    /**
    * The plugins loaded and in use by this context instance.
    */
    m(this, "plugins");
    m(this, "locale");
    /**
    * Shorthand for {@link module:utils/locale~Locale#t}.
    */
    m(this, "t");
    /**
    * A list of editors that this context instance is injected to.
    */
    m(this, "editors");
    /**
    * Reference to the editor which created the context.
    * Null when the context was created outside of the editor.
    *
    * It is used to destroy the context when removing the editor that has created the context.
    */
    m(this, "_contextOwner", null);
    const { translations: t, ...i } = n || {};
    this.config = new xE(i, this.constructor.defaultConfig);
    const r = this.constructor.builtinPlugins;
    this.config.define("plugins", r), this.plugins = new MT(this, r);
    const s = this.config.get("language") || {};
    this.locale = new xP({
      uiLanguage: typeof s == "string" ? s : s.ui,
      contentLanguage: this.config.get("language.content"),
      translations: t
    }), this.t = this.locale.t, this.editors = new Qi();
  }
  /**
  * Loads and initializes plugins specified in the configuration.
  *
  * @returns A promise which resolves once the initialization is completed, providing an array of loaded plugins.
  */
  initPlugins() {
    const n = this.config.get("plugins") || [], t = this.config.get("substitutePlugins") || [];
    for (const i of n.concat(t)) {
      if (typeof i != "function")
        throw new v("context-initplugins-constructor-only", null, {
          Plugin: i
        });
      if (i.isContextPlugin !== !0)
        throw new v("context-initplugins-invalid-plugin", null, {
          Plugin: i
        });
    }
    return this.plugins.init(n, [], t);
  }
  /**
  * Destroys the context instance and all editors used with the context,
  * releasing all resources used by the context.
  *
  * @returns A promise that resolves once the context instance is fully destroyed.
  */
  destroy() {
    return Promise.all(Array.from(this.editors, (n) => n.destroy())).then(() => this.plugins.destroy());
  }
  /**
  * Adds a reference to the editor which is used with this context.
  *
  * When the given editor has created the context, the reference to this editor will be stored
  * as a {@link ~Context#_contextOwner}.
  *
  * This method should only be used by the editor.
  *
  * @internal
  * @param isContextOwner Stores the given editor as a context owner.
  */
  _addEditor(n, t) {
    if (this._contextOwner)
      throw new v("context-addeditor-private-context");
    this.editors.add(n), t && (this._contextOwner = n);
  }
  /**
  * Removes a reference to the editor which was used with this context.
  * When the context was created by the given editor, the context will be destroyed.
  *
  * This method should only be used by the editor.
  *
  * @internal
  * @return A promise that resolves once the editor is removed from the context or when the context was destroyed.
  */
  _removeEditor(n) {
    return this.editors.has(n) && this.editors.remove(n), this._contextOwner === n ? this.destroy() : Promise.resolve();
  }
  /**
  * Returns the context configuration which will be copied to the editors created using this context.
  *
  * The configuration returned by this method has the plugins configuration removed &ndash; plugins are shared with all editors
  * through another mechanism.
  *
  * This method should only be used by the editor.
  *
  * @internal
  * @returns Configuration as a plain object.
  */
  _getEditorConfig() {
    const n = {};
    for (const t of this.config.names())
      [
        "plugins",
        "removePlugins",
        "extraPlugins"
      ].includes(t) || (n[t] = this.config.get(t));
    return n;
  }
  /**
  * Creates and initializes a new context instance.
  *
  * ```ts
  * const commonConfig = { ... }; // Configuration for all the plugins and editors.
  * const editorPlugins = [ ... ]; // Regular plugins here.
  *
  * Context
  * 	.create( {
  * 		// Only context plugins here.
  * 		plugins: [ ... ],
  *
  * 		// Configure the language for all the editors (it cannot be overwritten).
  * 		language: { ... },
  *
  * 		// Configuration for context plugins.
  * 		comments: { ... },
  * 		...
  *
  * 		// Default configuration for editor plugins.
  * 		toolbar: { ... },
  * 		image: { ... },
  * 		...
  * 	} )
  * 	.then( context => {
  * 		const promises = [];
  *
  * 		promises.push( ClassicEditor.create(
  * 			document.getElementById( 'editor1' ),
  * 			{
  * 				editorPlugins,
  * 				context
  * 			}
  * 		) );
  *
  * 		promises.push( ClassicEditor.create(
  * 			document.getElementById( 'editor2' ),
  * 			{
  * 				editorPlugins,
  * 				context,
  * 				toolbar: { ... } // You can overwrite the configuration of the context.
  * 			}
  * 		) );
  *
  * 		return Promise.all( promises );
  * 	} );
  * ```
  *
  * @param config The context configuration.
  * @returns A promise resolved once the context is ready. The promise resolves with the created context instance.
  */
  static create(n) {
    return new Promise((t) => {
      const i = new this(n);
      t(i.initPlugins().then(() => i));
    });
  }
}
/**
* The default configuration which is built into the `Context` class.
*
* It is used in CKEditor 5 builds featuring `Context` to provide the default configuration options which are later used during the
* context initialization.
*
* ```ts
* Context.defaultConfig = {
* 	foo: 1,
* 	bar: 2
* };
*
* Context
* 	.create()
* 	.then( context => {
* 		context.config.get( 'foo' ); // -> 1
* 		context.config.get( 'bar' ); // -> 2
* 	} );
*
* // The default options can be overridden by the configuration passed to create().
* Context
* 	.create( { bar: 3 } )
* 	.then( context => {
* 		context.config.get( 'foo' ); // -> 1
* 		context.config.get( 'bar' ); // -> 3
* 	} );
* ```
*
* See also {@link module:core/context~Context.builtinPlugins `Context.builtinPlugins`}
* and {@link module:core/editor/editor~Editor.defaultConfig `Editor.defaultConfig`}.
*/
m(wl, "defaultConfig"), /**
* An array of plugins built into the `Context` class.
*
* It is used in CKEditor 5 builds featuring `Context` to provide a list of context plugins which are later automatically initialized
* during the context initialization.
*
* They will be automatically initialized by `Context` unless `config.plugins` is passed.
*
* ```ts
* // Build some context plugins into the Context class first.
* Context.builtinPlugins = [ FooPlugin, BarPlugin ];
*
* // Normally, you need to define config.plugins, but since Context.builtinPlugins was
* // defined, now you can call create() without any configuration.
* Context
* 	.create()
* 	.then( context => {
* 		context.plugins.get( FooPlugin ); // -> An instance of the Foo plugin.
* 		context.plugins.get( BarPlugin ); // -> An instance of the Bar plugin.
* 	} );
* ```
*
* See also {@link module:core/context~Context.defaultConfig `Context.defaultConfig`}
* and {@link module:core/editor/editor~Editor.builtinPlugins `Editor.builtinPlugins`}.
*/
m(wl, "builtinPlugins");
class TR {
  /**
  * Creates collection instance.
  */
  constructor() {
    /**
    * Command map.
    */
    m(this, "_commands");
    this._commands = /* @__PURE__ */ new Map();
  }
  /**
  * Registers a new command.
  *
  * @param commandName The name of the command.
  */
  add(n, t) {
    this._commands.set(n, t);
  }
  /**
  * Retrieves a command from the collection.
  *
  * @param commandName The name of the command.
  */
  get(n) {
    return this._commands.get(n);
  }
  /**
  * Executes a command.
  *
  * @param commandName The name of the command.
  * @param commandParams Command parameters.
  * @returns The value returned by the {@link module:core/command~Command#execute `command.execute()`}.
  */
  execute(n, ...t) {
    const i = this.get(n);
    if (!i)
      throw new v("commandcollection-command-not-found", this, {
        commandName: n
      });
    return i.execute(...t);
  }
  /**
  * Returns iterator of command names.
  */
  *names() {
    yield* this._commands.keys();
  }
  /**
  * Returns iterator of command instances.
  */
  *commands() {
    yield* this._commands.values();
  }
  /**
  * Iterable interface.
  *
  * Returns `[ commandName, commandInstance ]` pairs.
  */
  [Symbol.iterator]() {
    return this._commands[Symbol.iterator]();
  }
  /**
  * Destroys all collection commands.
  */
  destroy() {
    for (const n of this.commands())
      n.destroy();
  }
}
class yR extends Ii {
  /**
  * Creates an instance of the keystroke handler.
  */
  constructor(t) {
    super();
    /**
    * The editor instance.
    */
    m(this, "editor");
    this.editor = t;
  }
  /**
  * Registers a handler for the specified keystroke.
  *
  * The handler can be specified as a command name or a callback.
  *
  * @param keystroke Keystroke defined in a format accepted by
  * the {@link module:utils/keyboard~parseKeystroke} function.
  * @param callback If a string is passed, then the keystroke will
  * {@link module:core/editor/editor~Editor#execute execute a command}.
  * If a function, then it will be called with the
  * {@link module:engine/view/observer/keyobserver~KeyEventData key event data} object and
  * a `cancel()` helper to both `preventDefault()` and `stopPropagation()` of the event.
  * @param options Additional options.
  * @param options.priority The priority of the keystroke callback. The higher the priority value
  * the sooner the callback will be executed. Keystrokes having the same priority
  * are called in the order they were added.
  */
  set(t, i, r = {}) {
    if (typeof i == "string") {
      const s = i;
      i = (o, a) => {
        this.editor.execute(s), a();
      };
    }
    super.set(t, i, r);
  }
}
const md = "contentEditing", Zp = "common";
class wR {
  /**
  * @inheritDoc
  */
  constructor(n) {
    /**
    * Stores information about keystrokes brought by editor features for the users to interact with the editor, mainly
    * keystroke combinations and their accessible labels.
    *
    * This information is particularly useful for screen reader and other assistive technology users. It gets displayed
    * by the {@link module:ui/editorui/accessibilityhelp/accessibilityhelp~AccessibilityHelp Accessibility help} dialog.
    *
    * Keystrokes are organized in categories and groups. They can be added using ({@link #addKeystrokeInfoCategory},
    * {@link #addKeystrokeInfoGroup}, and {@link #addKeystrokeInfos}) methods.
    *
    * Please note that:
    * * two categories are always available:
    *   * `'contentEditing'` for keystrokes related to content creation,
    *   * `'navigation'` for keystrokes related to navigation in the UI and the content.
    * * unless specified otherwise, new keystrokes are added into the `'contentEditing'` category and the `'common'`
    * keystroke group within that category while using the {@link #addKeystrokeInfos} method.
    */
    m(this, "keystrokeInfos", /* @__PURE__ */ new Map());
    /**
    * The editor instance.
    */
    m(this, "_editor");
    this._editor = n;
    const t = n.config.get("menuBar.isVisible"), i = n.locale.t;
    this.addKeystrokeInfoCategory({
      id: md,
      label: i("Content editing keystrokes"),
      description: i("These keyboard shortcuts allow for quick access to content editing features.")
    });
    const r = [
      {
        label: i("Close contextual balloons, dropdowns, and dialogs"),
        keystroke: "Esc"
      },
      {
        label: i("Open the accessibility help dialog"),
        keystroke: "Alt+0"
      },
      {
        label: i("Move focus between form fields (inputs, buttons, etc.)"),
        keystroke: [
          [
            "Tab"
          ],
          [
            "Shift+Tab"
          ]
        ]
      },
      {
        label: i("Move focus to the toolbar, navigate between toolbars"),
        keystroke: "Alt+F10",
        mayRequireFn: !0
      },
      {
        label: i("Navigate through the toolbar or menu bar"),
        keystroke: [
          [
            "arrowup"
          ],
          [
            "arrowright"
          ],
          [
            "arrowdown"
          ],
          [
            "arrowleft"
          ]
        ]
      },
      {
        // eslint-disable-next-line max-len
        label: i("Execute the currently focused button. Executing buttons that interact with the editor content moves the focus back to the content."),
        keystroke: [
          [
            "Enter"
          ],
          [
            "Space"
          ]
        ]
      }
    ];
    t && r.push({
      label: i("Move focus to the menu bar, navigate between menu bars"),
      keystroke: "Alt+F9",
      mayRequireFn: !0
    }), this.addKeystrokeInfoCategory({
      id: "navigation",
      label: i("User interface and content navigation keystrokes"),
      description: i("Use the following keystrokes for more efficient navigation in the CKEditor 5 user interface."),
      groups: [
        {
          id: "common",
          keystrokes: r
        }
      ]
    });
  }
  /**
  * Adds a top-level category in the {@link #keystrokeInfos keystroke information database} with a label and optional description.
  *
  * Categories organize keystrokes and help users to find the right keystroke. Each category can have multiple groups
  * of keystrokes that narrow down the context in which the keystrokes are available. Every keystroke category comes
  * with a `'common'` group by default.
  *
  * By default, two categories are available:
  * * `'contentEditing'` for keystrokes related to content creation,
  * * `'navigation'` for keystrokes related to navigation in the UI and the content.
  *
  * To create a new keystroke category with new groups, use the following code:
  *
  * ```js
  * class MyPlugin extends Plugin {
  * 	// ...
  * 	init() {
  * 		const editor = this.editor;
  * 		const t = editor.t;
  *
  * 		// ...
  *
  * 		editor.accessibility.addKeystrokeInfoCategory( {
  * 			id: 'myCategory',
  * 			label: t( 'My category' ),
  * 			description: t( 'My category description.' ),
  * 			groups: [
  * 				{
  * 					id: 'myGroup',
  * 					label: t( 'My keystroke group' ),
  * 					keystrokes: [
  * 						{
  * 							label: t( 'Keystroke label 1' ),
  * 							keystroke: 'Ctrl+Shift+N'
  * 						},
  * 						{
  * 							label: t( 'Keystroke label 2' ),
  * 							keystroke: 'Ctrl+Shift+M'
  * 						}
  * 					]
  * 				}
  * 			]
  * 		};
  * 	}
  * }
  * ```
  *
  * See {@link #keystrokeInfos}, {@link #addKeystrokeInfoGroup}, and {@link #addKeystrokeInfos}.
  */
  addKeystrokeInfoCategory({ id: n, label: t, description: i, groups: r }) {
    this.keystrokeInfos.set(n, {
      id: n,
      label: t,
      description: i,
      groups: /* @__PURE__ */ new Map()
    }), this.addKeystrokeInfoGroup({
      categoryId: n,
      id: Zp
    }), r && r.forEach((s) => {
      this.addKeystrokeInfoGroup({
        categoryId: n,
        ...s
      });
    });
  }
  /**
  * Adds a group of keystrokes in a specific category to the {@link #keystrokeInfos keystroke information database}.
  *
  * Groups narrow down the context in which the keystrokes are available. When `categoryId` is not specified,
  * the group goes to the `'contentEditing'` category (default).
  *
  * To create a new group within an existing category, use the following code:
  *
  * ```js
  * class MyPlugin extends Plugin {
  * 	// ...
  * 	init() {
  * 		const editor = this.editor;
  * 		const t = editor.t;
  *
  * 		// ...
  *
  * 		editor.accessibility.addKeystrokeInfoGroup( {
  * 			id: 'myGroup',
  * 			categoryId: 'navigation',
  * 			label: t( 'My keystroke group' ),
  * 			keystrokes: [
  * 				{
  * 					label: t( 'Keystroke label 1' ),
  * 					keystroke: 'Ctrl+Shift+N'
  * 				},
  * 				{
  * 					label: t( 'Keystroke label 2' ),
  * 					keystroke: 'Ctrl+Shift+M'
  * 				}
  * 			]
  * 		} );
  * 	}
  * }
  * ```
  *
  * See {@link #keystrokeInfos}, {@link #addKeystrokeInfoCategory}, and {@link #addKeystrokeInfos}.
  */
  addKeystrokeInfoGroup({ categoryId: n = md, id: t, label: i, keystrokes: r }) {
    const s = this.keystrokeInfos.get(n);
    if (!s)
      throw new v("accessibility-unknown-keystroke-info-category", this._editor, {
        groupId: t,
        categoryId: n
      });
    s.groups.set(t, {
      id: t,
      label: i,
      keystrokes: r || []
    });
  }
  /**
  * Adds information about keystrokes to the {@link #keystrokeInfos keystroke information database}.
  *
  * Keystrokes without specified `groupId` or `categoryId` go to the `'common'` group in the `'contentEditing'` category (default).
  *
  * To add a keystroke brought by your plugin (using default group and category), use the following code:
  *
  * ```js
  * class MyPlugin extends Plugin {
  * 	// ...
  * 	init() {
  * 		const editor = this.editor;
  * 		const t = editor.t;
  *
  * 		// ...
  *
  * 		editor.accessibility.addKeystrokeInfos( {
  * 			keystrokes: [
  * 				{
  * 					label: t( 'Keystroke label' ),
  * 					keystroke: 'CTRL+B'
  * 				}
  * 			]
  * 		} );
  * 	}
  * }
  * ```
  * To add a keystroke in a specific existing `'widget'` group in the default `'contentEditing'` category:
  *
  * ```js
  * class MyPlugin extends Plugin {
  * 	// ...
  * 	init() {
  * 		const editor = this.editor;
  * 		const t = editor.t;
  *
  * 		// ...
  *
  * 		editor.accessibility.addKeystrokeInfos( {
  * 			// Add a keystroke to the existing "widget" group.
  * 			groupId: 'widget',
  * 			keystrokes: [
  * 				{
  * 					label: t( 'A an action on a selected widget' ),
  * 					keystroke: 'Ctrl+D',
  * 				}
  * 			]
  * 		} );
  * 	}
  * }
  * ```
  *
  * To add a keystroke to another existing category (using default group):
  *
  * ```js
  * class MyPlugin extends Plugin {
  * 	// ...
  * 	init() {
  * 		const editor = this.editor;
  * 		const t = editor.t;
  *
  * 		// ...
  *
  * 		editor.accessibility.addKeystrokeInfos( {
  * 			// Add keystrokes to the "navigation" category (one of defaults).
  * 			categoryId: 'navigation',
  * 			keystrokes: [
  * 				{
  * 					label: t( 'Keystroke label' ),
  * 					keystroke: 'CTRL+B'
  * 				}
  * 			]
  * 		} );
  * 	}
  * }
  * ```
  *
  * See {@link #keystrokeInfos}, {@link #addKeystrokeInfoGroup}, and {@link #addKeystrokeInfoCategory}.
  */
  addKeystrokeInfos({ categoryId: n = md, groupId: t = Zp, keystrokes: i }) {
    if (!this.keystrokeInfos.has(n))
      throw new v("accessibility-unknown-keystroke-info-category", this._editor, {
        categoryId: n,
        keystrokes: i
      });
    const r = this.keystrokeInfos.get(n);
    if (!r.groups.has(t))
      throw new v("accessibility-unknown-keystroke-info-group", this._editor, {
        groupId: t,
        categoryId: n,
        keystrokes: i
      });
    r.groups.get(t).keystrokes.push(...i);
  }
}
function AR(e) {
  return {
    sessionId: xR(),
    pageSessionId: vR(),
    hostname: window.location.hostname,
    version: globalThis.CKEDITOR_VERSION,
    type: CR(e),
    plugins: kR(e.plugins),
    distribution: SR(),
    env: IR(),
    integration: /* @__PURE__ */ Object.create(null),
    menuBar: {
      isVisible: !!e.config.get("menuBar.isVisible")
    },
    language: {
      ui: e.locale.uiLanguage,
      content: e.locale.contentLanguage
    },
    toolbar: {
      main: pd(e.config.get("toolbar")),
      block: pd(e.config.get("blockToolbar")),
      balloon: pd(e.config.get("balloonToolbar"))
    }
  };
}
function CR(e) {
  return Object.getPrototypeOf(e).constructor.editorName;
}
function kR(e) {
  return Array.from(e).filter(([n]) => !!n.pluginName).map(([n]) => {
    const { pluginName: t, isContextPlugin: i, isOfficialPlugin: r, isPremiumPlugin: s } = n;
    return {
      isContext: !!i,
      isOfficial: !!r,
      isPremium: !!s,
      name: t
    };
  });
}
function pd(e) {
  if (!e)
    return;
  const n = Array.isArray(e) ? {
    items: e
  } : e, t = s(n.items || []);
  return {
    isMultiline: t.includes("-"),
    shouldNotGroupWhenFull: !!n.shouldNotGroupWhenFull,
    items: r(t)
  };
  function r(o) {
    return o.filter((a) => a !== "|" && a !== "-");
  }
  function s(o) {
    return o.flatMap((a) => typeof a == "string" ? [
      a
    ] : s(a.items));
  }
}
function SR() {
  return {
    channel: window[Symbol.for("cke distribution")] || "sh"
  };
}
function IR() {
  let e = "unknown", n = "unknown";
  return he.isMac ? e = "mac" : he.isWindows ? e = "windows" : he.isiOS ? e = "ios" : he.isAndroid && (e = "android"), he.isGecko ? n = "gecko" : he.isBlink ? n = "blink" : he.isSafari && (n = "safari"), {
    os: e,
    browser: n
  };
}
function xR() {
  return localStorage.getItem("__ckeditor-session-id") || localStorage.setItem("__ckeditor-session-id", un()), localStorage.getItem("__ckeditor-session-id");
}
function vR() {
  return ue.window.CKEDITOR_PAGE_SESSION_ID = ue.window.CKEDITOR_PAGE_SESSION_ID || un(), ue.window.CKEDITOR_PAGE_SESSION_ID;
}
var qr;
let PR = (qr = class extends (/* @__PURE__ */ pt()) {
  /**
  * Creates a new instance of the editor class.
  *
  * Usually, not to be used directly. See the static {@link module:core/editor/editor~Editor.create `create()`} method.
  *
  * @param config The editor configuration.
  */
  constructor(t = {}) {
    super();
    /**
    * A namespace for the accessibility features of the editor.
    */
    m(this, "accessibility");
    /**
    * Commands registered to the editor.
    *
    * Use the shorthand {@link #execute `editor.execute()`} method to execute commands:
    *
    * ```ts
    * // Execute the bold command:
    * editor.execute( 'bold' );
    *
    * // Check the state of the bold command:
    * editor.commands.get( 'bold' ).value;
    * ```
    */
    m(this, "commands");
    /**
    * Stores all configurations specific to this editor instance.
    *
    * ```ts
    * editor.config.get( 'image.toolbar' );
    * // -> [ 'imageStyle:block', 'imageStyle:side', '|', 'toggleImageCaption', 'imageTextAlternative' ]
    * ```
    */
    m(this, "config");
    /**
    * Conversion manager through which you can register model-to-view and view-to-model converters.
    *
    * See the {@link module:engine/conversion/conversion~Conversion} documentation to learn how to add converters.
    */
    m(this, "conversion");
    /**
    * The {@link module:engine/controller/datacontroller~DataController data controller}.
    * Used e.g. for setting and retrieving the editor data.
    */
    m(this, "data");
    /**
    * The {@link module:engine/controller/editingcontroller~EditingController editing controller}.
    * Controls user input and rendering the content for editing.
    */
    m(this, "editing");
    /**
    * The locale instance.
    */
    m(this, "locale");
    /**
    * The editor's model.
    *
    * The central point of the editor's abstract data model.
    */
    m(this, "model");
    /**
    * The plugins loaded and in use by this editor instance.
    *
    * ```ts
    * editor.plugins.get( 'ClipboardPipeline' ); // -> An instance of the clipboard pipeline plugin.
    * ```
    */
    m(this, "plugins");
    /**
    * An instance of the {@link module:core/editingkeystrokehandler~EditingKeystrokeHandler}.
    *
    * It allows setting simple keystrokes:
    *
    * ```ts
    * // Execute the bold command on Ctrl+E:
    * editor.keystrokes.set( 'Ctrl+E', 'bold' );
    *
    * // Execute your own callback:
    * editor.keystrokes.set( 'Ctrl+E', ( data, cancel ) => {
    * 	console.log( data.keyCode );
    *
    * 	// Prevent the default (native) action and stop the underlying keydown event
    * 	// so no other editor feature will interfere.
    * 	cancel();
    * } );
    * ```
    *
    * Note: Certain typing-oriented keystrokes (like <kbd>Backspace</kbd> or <kbd>Enter</kbd>) are handled
    * by a low-level mechanism and trying to listen to them via the keystroke handler will not work reliably.
    * To handle these specific keystrokes, see the events fired by the
    * {@link module:engine/view/document~Document editing view document} (`editor.editing.view.document`).
    */
    m(this, "keystrokes");
    /**
    * Shorthand for {@link module:utils/locale~Locale#t}.
    *
    * @see module:utils/locale~Locale#t
    */
    m(this, "t");
    /**
    * The editor context.
    * When it is not provided through the configuration, the editor creates it.
    */
    m(this, "_context");
    /**
    * A set of lock IDs for the {@link #isReadOnly} getter.
    */
    m(this, "_readOnlyLocks");
    if ("sanitizeHtml" in t)
      throw new v("editor-config-sanitizehtml-not-supported");
    const i = this.constructor, { translations: r, ...s } = i.defaultConfig || {}, { translations: o = r, ...a } = t, u = t.language || s.language;
    this._context = t.context || new wl({
      language: u,
      translations: o
    }), this._context._addEditor(this, !t.context);
    const l = Array.from(i.builtinPlugins || []);
    this.config = new xE(a, s), this.config.define("plugins", l), this.config.define(this._context._getEditorConfig()), d(this.config), this.plugins = new MT(this, l, this._context.plugins), this.locale = this._context.locale, this.t = this.locale.t, this._readOnlyLocks = /* @__PURE__ */ new Set(), this.commands = new TR(), this.set("state", "initializing"), this.once("ready", () => this.state = "ready", {
      priority: "high"
    }), this.once("destroy", () => this.state = "destroyed", {
      priority: "high"
    }), this.model = new hR(), this.on("change:isReadOnly", () => {
      this.model.document.isReadOnly = this.isReadOnly;
    });
    const c = new XP();
    this.data = new w6(this.model, c), this.editing = new ZN(this.model, c), this.editing.view.document.bind("isReadOnly").to(this), this.conversion = new C6([
      this.editing.downcastDispatcher,
      this.data.downcastDispatcher
    ], this.data.upcastDispatcher), this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher), this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher), this.keystrokes = new yR(this), this.keystrokes.listenTo(this.editing.view.document), this.accessibility = new wR(this), p(this);
    function d(g) {
      let b = g.get("licenseKey");
      if (!b && window.CKEDITOR_GLOBAL_LICENSE_KEY && (b = window.CKEDITOR_GLOBAL_LICENSE_KEY, g.set("licenseKey", b)), !b)
        throw new v("license-key-missing");
    }
    function p(g) {
      const b = g.config.get("licenseKey"), _ = window[Symbol.for("cke distribution")] || "sh";
      function k(W) {
        g.enableReadOnlyMode(Symbol("invalidLicense")), g._showLicenseError(W);
      }
      function C(W) {
        const N = W.split(".");
        return N.length != 3 ? null : N[1];
      }
      function D(W) {
        return [
          "exp",
          "jti",
          "vc"
        ].every((Z) => Z in W);
      }
      function M(W) {
        return Object.getOwnPropertyNames(W).sort().filter((ee) => ee != "vc" && W[ee] != null).map((ee) => W[ee]);
      }
      function j(W) {
        const { hostname: N } = new URL(window.location.href);
        if (W.includes(N))
          return !0;
        const Z = N.split(".");
        return W.filter((ee) => ee.includes("*")).map((ee) => ee.split(".")).filter((ee) => ee.length <= Z.length).map((ee) => Array(Z.length - ee.length).fill(ee[0] === "*" ? "*" : "").concat(ee)).some((ee) => Z.every((Ae, Ie) => ee[Ie] === Ae || ee[Ie] === "*"));
      }
      if (b == "GPL") {
        _ == "cloud" && k("distributionChannel");
        return;
      }
      const F = C(b);
      if (!F) {
        k("invalid");
        return;
      }
      const O = zf(F);
      if (!O) {
        k("invalid");
        return;
      }
      if (!D(O)) {
        k("invalid");
        return;
      }
      if (O.distributionChannel && !Dt(O.distributionChannel).includes(_)) {
        k("distributionChannel");
        return;
      }
      if (RP(M(O)) != O.vc.toLowerCase()) {
        k("invalid");
        return;
      }
      if (new Date(O.exp * 1e3) < Vv) {
        k("expired");
        return;
      }
      const ie = O.licensedHosts;
      if (ie && ie.length > 0 && !j(ie)) {
        k("domainLimit");
        return;
      }
      if ([
        "evaluation",
        "trial"
      ].includes(O.licenseType) && O.exp * 1e3 < Date.now()) {
        k("expired");
        return;
      }
      if ([
        "development",
        "evaluation",
        "trial"
      ].includes(O.licenseType)) {
        const { licenseType: W } = O, N = W[0].toUpperCase() + W.slice(1), Z = W === "evaluation" ? "an" : "a";
        console.info(`%cCKEditor 5 ${N} License`, "color: #ffffff; background: #743CCD; font-size: 14px; padding: 4px 8px; border-radius: 4px;"), console.warn(`⚠️ You are using ${Z} ${W} license of CKEditor 5${W === "trial" ? " which is for evaluation purposes only" : ""}. For production usage, please obtain a production license at https://portal.ckeditor.com/`);
      }
      if ([
        "evaluation",
        "trial"
      ].includes(O.licenseType)) {
        const W = O.licenseType, N = setTimeout(() => {
          k(`${W}Limit`);
        }, 6e5);
        g.on("destroy", () => {
          clearTimeout(N);
        });
      }
      O.usageEndpoint && g.once("ready", () => {
        const W = {
          requestId: un(),
          requestTime: Math.round(Date.now() / 1e3),
          license: b,
          editor: OR(g)
        };
        g._sendUsageRequest(O.usageEndpoint, W).then((N) => {
          const { status: Z, message: ee } = N;
          ee && console.warn(ee), Z != "ok" && k("usageLimit");
        }, () => {
          Fv("license-key-validation-endpoint-not-reachable", {
            url: O.usageEndpoint
          });
        });
      }, {
        priority: "high"
      });
    }
  }
  /**
  * A required name of the editor class. The name should reflect the constructor name.
  */
  static get editorName() {
    return "Editor";
  }
  /**
  * Defines whether the editor is in the read-only mode.
  *
  * In read-only mode the editor {@link #commands commands} are disabled so it is not possible
  * to modify the document by using them. Also, the editable element(s) become non-editable.
  *
  * In order to make the editor read-only, you need to call the {@link #enableReadOnlyMode} method:
  *
  * ```ts
  * editor.enableReadOnlyMode( 'feature-id' );
  * ```
  *
     * Later, to turn off the read-only mode, call {@link #disableReadOnlyMode}:
  *
  * ```ts
  * editor.disableReadOnlyMode( 'feature-id' );
  * ```
  *
  * @readonly
  * @observable
  */
  get isReadOnly() {
    return this._readOnlyLocks.size > 0;
  }
  set isReadOnly(t) {
    throw new v("editor-isreadonly-has-no-setter");
  }
  /**
  * Turns on the read-only mode in the editor.
  *
  * Editor can be switched to or out of the read-only mode by many features, under various circumstances. The editor supports locking
  * mechanism for the read-only mode. It enables easy control over the read-only mode when many features wants to turn it on or off at
  * the same time, without conflicting with each other. It guarantees that you will not make the editor editable accidentally (which
  * could lead to errors).
  *
  * Each read-only mode request is identified by a unique id (also called "lock"). If multiple plugins requested to turn on the
  * read-only mode, then, the editor will become editable only after all these plugins turn the read-only mode off (using the same ids).
  *
  * Note, that you cannot force the editor to disable the read-only mode if other plugins set it.
  *
  * After the first `enableReadOnlyMode()` call, the {@link #isReadOnly `isReadOnly` property} will be set to `true`:
  *
  * ```ts
  * editor.isReadOnly; // `false`.
  * editor.enableReadOnlyMode( 'my-feature-id' );
  * editor.isReadOnly; // `true`.
  * ```
  *
  * You can turn off the read-only mode ("clear the lock") using the {@link #disableReadOnlyMode `disableReadOnlyMode()`} method:
  *
  * ```ts
  * editor.enableReadOnlyMode( 'my-feature-id' );
  * // ...
  * editor.disableReadOnlyMode( 'my-feature-id' );
  * editor.isReadOnly; // `false`.
  * ```
  *
  * All "locks" need to be removed to enable editing:
  *
  * ```ts
  * editor.enableReadOnlyMode( 'my-feature-id' );
  * editor.enableReadOnlyMode( 'my-other-feature-id' );
  * // ...
  * editor.disableReadOnlyMode( 'my-feature-id' );
  * editor.isReadOnly; // `true`.
  * editor.disableReadOnlyMode( 'my-other-feature-id' );
  * editor.isReadOnly; // `false`.
  * ```
  *
  * @param lockId A unique ID for setting the editor to the read-only state.
  */
  enableReadOnlyMode(t) {
    if (typeof t != "string" && typeof t != "symbol")
      throw new v("editor-read-only-lock-id-invalid", null, {
        lockId: t
      });
    this._readOnlyLocks.has(t) || (this._readOnlyLocks.add(t), this._readOnlyLocks.size === 1 && this.fire("change:isReadOnly", "isReadOnly", !0, !1));
  }
  /**
  * Removes the read-only lock from the editor with given lock ID.
  *
  * When no lock is present on the editor anymore, then the {@link #isReadOnly `isReadOnly` property} will be set to `false`.
  *
  * @param lockId The lock ID for setting the editor to the read-only state.
  */
  disableReadOnlyMode(t) {
    if (typeof t != "string" && typeof t != "symbol")
      throw new v("editor-read-only-lock-id-invalid", null, {
        lockId: t
      });
    this._readOnlyLocks.has(t) && (this._readOnlyLocks.delete(t), this._readOnlyLocks.size === 0 && this.fire("change:isReadOnly", "isReadOnly", !1, !0));
  }
  /**
  * Sets the data in the editor.
  *
  * ```ts
  * editor.setData( '<p>This is editor!</p>' );
  * ```
  *
  * If your editor implementation uses multiple roots, you should pass an object with keys corresponding
  * to the editor root names and values equal to the data that should be set in each root:
  *
  * ```ts
  * editor.setData( {
  *     header: '<p>Content for header part.</p>',
  *     content: '<p>Content for main part.</p>',
  *     footer: '<p>Content for footer part.</p>'
  * } );
  * ```
  *
  * By default the editor accepts HTML. This can be controlled by injecting a different data processor.
  * See the {@glink features/markdown Markdown output} guide for more details.
  *
  * @param data Input data.
  */
  setData(t) {
    this.data.set(t);
  }
  /**
  * Gets the data from the editor.
  *
  * ```ts
  * editor.getData(); // -> '<p>This is editor!</p>'
  * ```
  *
  * If your editor implementation uses multiple roots, you should pass root name as one of the options:
  *
  * ```ts
  * editor.getData( { rootName: 'header' } ); // -> '<p>Content for header part.</p>'
  * ```
  *
  * By default, the editor outputs HTML. This can be controlled by injecting a different data processor.
  * See the {@glink features/markdown Markdown output} guide for more details.
  *
  * A warning is logged when you try to retrieve data for a detached root, as most probably this is a mistake. A detached root should
  * be treated like it is removed, and you should not save its data. Note, that the detached root data is always an empty string.
  *
  * @param options Additional configuration for the retrieved data.
  * Editor features may introduce more configuration options that can be set through this parameter.
  * @param options.rootName Root name. Defaults to `'main'`.
  * @param options.trim Whether returned data should be trimmed. This option is set to `'empty'` by default,
  * which means that whenever editor content is considered empty, an empty string is returned. To turn off trimming
  * use `'none'`. In such cases exact content will be returned (for example `'<p>&nbsp;</p>'` for an empty editor).
  * @returns Output data.
  */
  getData(t) {
    return this.data.get(t);
  }
  /**
  * Loads and initializes plugins specified in the configuration.
  *
  * @returns A promise which resolves once the initialization is completed, providing an array of loaded plugins.
  */
  initPlugins() {
    const t = this.config, i = t.get("plugins"), r = t.get("removePlugins") || [], s = t.get("extraPlugins") || [], o = t.get("substitutePlugins") || [];
    return this.plugins.init(i.concat(s), r, o);
  }
  /**
  * Destroys the editor instance, releasing all resources used by it.
  *
  * **Note** The editor cannot be destroyed during the initialization phase so if it is called
  * while the editor {@link #state is being initialized}, it will wait for the editor initialization before destroying it.
  *
  * @fires destroy
  * @returns A promise that resolves once the editor instance is fully destroyed.
  */
  destroy() {
    let t = Promise.resolve();
    return this.state == "initializing" && (t = new Promise((i) => this.once("ready", i))), t.then(() => {
      this.fire("destroy"), this.stopListening(), this.commands.destroy();
    }).then(() => this.plugins.destroy()).then(() => {
      this.model.destroy(), this.data.destroy(), this.editing.destroy(), this.keystrokes.destroy();
    }).then(() => this._context._removeEditor(this));
  }
  /**
  * Executes the specified command with given parameters.
  *
  * Shorthand for:
  *
  * ```ts
  * editor.commands.get( commandName ).execute( ... );
  * ```
  *
  * @param commandName The name of the command to execute.
  * @param commandParams Command parameters.
  * @returns The value returned by the {@link module:core/commandcollection~CommandCollection#execute `commands.execute()`}.
  */
  execute(t, ...i) {
    try {
      return this.commands.execute(t, ...i);
    } catch (r) {
      /* istanbul ignore next -- @preserve */
      v.rethrowUnexpectedError(r, this);
    }
  }
  /**
  * Focuses the editor.
  *
  * **Note** To explicitly focus the editing area of the editor, use the
  * {@link module:engine/view/view~View#focus `editor.editing.view.focus()`} method of the editing view.
  *
  * Check out the {@glink framework/deep-dive/ui/focus-tracking#focus-in-the-editor-ui Focus in the editor UI} section
  * of the {@glink framework/deep-dive/ui/focus-tracking Deep dive into focus tracking} guide to learn more.
  */
  focus() {
    this.editing.view.focus();
  }
  /* istanbul ignore next -- @preserve */
  /**
  * Creates and initializes a new editor instance.
  *
  * This is an abstract method. Every editor type needs to implement its own initialization logic.
  *
  * See the `create()` methods of the existing editor types to learn how to use them:
  *
  * * {@link module:editor-classic/classiceditor~ClassicEditor.create `ClassicEditor.create()`}
  * * {@link module:editor-balloon/ballooneditor~BalloonEditor.create `BalloonEditor.create()`}
  * * {@link module:editor-decoupled/decouplededitor~DecoupledEditor.create `DecoupledEditor.create()`}
  * * {@link module:editor-inline/inlineeditor~InlineEditor.create `InlineEditor.create()`}
  */
  static create(...t) {
    throw new Error("This is an abstract method.");
  }
  _showLicenseError(t, i) {
    setTimeout(() => {
      if (t == "invalid")
        throw new v("invalid-license-key");
      if (t == "expired")
        throw new v("license-key-expired");
      if (t == "domainLimit")
        throw new v("license-key-domain-limit");
      if (t == "featureNotAllowed")
        throw new v("license-key-plugin-not-allowed", null, {
          pluginName: i
        });
      if (t == "evaluationLimit")
        throw new v("license-key-evaluation-limit");
      if (t == "trialLimit")
        throw new v("license-key-trial-limit");
      if (t == "developmentLimit")
        throw new v("license-key-development-limit");
      if (t == "usageLimit")
        throw new v("license-key-usage-limit");
      if (t == "distributionChannel")
        throw new v("license-key-invalid-distribution-channel");
    }, 0), this._showLicenseError = () => {
    };
  }
  /**
  * This part of the code is _not_ executed in installations under the GPL license (with `config.licenseKey = 'GPL'`).
     *
  * It is only executed when a specific license key is provided. If you are uncertain whether
  * this applies to your installation, please contact our support team.
  */
  async _sendUsageRequest(t, i) {
    const r = new Headers({
      "Content-Type": "application/json"
    }), s = await fetch(new URL(t), {
      method: "POST",
      headers: r,
      body: JSON.stringify(i)
    });
    if (!s.ok)
      throw new Error(`HTTP Response: ${s.status}`);
    return s.json();
  }
}, /**
* The default configuration which is built into the editor class.
*
* It is used in CKEditor 5 builds to provide the default configuration options which are later used during the editor initialization.
*
* ```ts
* ClassicEditor.defaultConfig = {
* 	foo: 1,
* 	bar: 2
* };
*
* ClassicEditor
* 	.create( sourceElement )
* 	.then( editor => {
* 		editor.config.get( 'foo' ); // -> 1
* 		editor.config.get( 'bar' ); // -> 2
* 	} );
*
* // The default options can be overridden by the configuration passed to create().
* ClassicEditor
* 	.create( sourceElement, { bar: 3 } )
* 	.then( editor => {
* 		editor.config.get( 'foo' ); // -> 1
* 		editor.config.get( 'bar' ); // -> 3
* 	} );
* ```
*
* See also {@link module:core/editor/editor~Editor.builtinPlugins}.
*/
m(qr, "defaultConfig"), /**
* An array of plugins built into this editor class.
*
* It is used in CKEditor 5 builds to provide a list of plugins which are later automatically initialized
* during the editor initialization.
*
* They will be automatically initialized by the editor, unless listed in `config.removePlugins` and
* unless `config.plugins` is passed.
*
* ```ts
* // Build some plugins into the editor class first.
* ClassicEditor.builtinPlugins = [ FooPlugin, BarPlugin ];
*
* // Normally, you need to define config.plugins, but since ClassicEditor.builtinPlugins was
* // defined, now you can call create() without any configuration.
* ClassicEditor
* 	.create( sourceElement )
* 	.then( editor => {
* 		editor.plugins.get( FooPlugin ); // -> An instance of the Foo plugin.
* 		editor.plugins.get( BarPlugin ); // -> An instance of the Bar plugin.
* 	} );
*
* ClassicEditor
* 	.create( sourceElement, {
* 		// Do not initialize these plugins (note: it is defined by a string):
* 		removePlugins: [ 'Foo' ]
* 	} )
* 	.then( editor => {
* 		editor.plugins.get( FooPlugin ); // -> Undefined.
* 		editor.config.get( BarPlugin ); // -> An instance of the Bar plugin.
* 	} );
*
* ClassicEditor
* 	.create( sourceElement, {
* 		// Load only this plugin. It can also be defined by a string if
* 		// this plugin was built into the editor class.
* 		plugins: [ FooPlugin ]
* 	} )
* 	.then( editor => {
* 		editor.plugins.get( FooPlugin ); // -> An instance of the Foo plugin.
* 		editor.config.get( BarPlugin ); // -> Undefined.
* 	} );
* ```
*
* See also {@link module:core/editor/editor~Editor.defaultConfig}.
*/
m(qr, "builtinPlugins"), /**
* The {@link module:core/context~Context} class.
*
* Exposed as static editor field for easier access in editor builds.
*/
m(qr, "Context", wl), /**
* The {@link module:watchdog/editorwatchdog~EditorWatchdog} class.
*
* Exposed as static editor field for easier access in editor builds.
*/
m(qr, "EditorWatchdog", DT), /**
* The {@link module:watchdog/contextwatchdog~ContextWatchdog} class.
*
* Exposed as static editor field for easier access in editor builds.
*/
m(qr, "ContextWatchdog", _R), qr);
function OR(e) {
  const n = AR(e);
  function t(i, r) {
    if (Js(n, i) !== void 0)
      throw new v("editor-usage-data-path-already-set", {
        path: i
      });
    _E(n, i, r);
  }
  return e.fire("collectUsageData", {
    setUsageData: t
  }), n;
}
function NR(e) {
  if (!ts(e.updateSourceElement))
    throw new v("attachtoform-missing-elementapi-interface", e);
  const n = e.sourceElement;
  if (RR(n) && n.form) {
    let t;
    const i = n.form, r = () => e.updateSourceElement();
    ts(i.submit) && (t = i.submit, i.submit = () => {
      r(), t.apply(i);
    }), i.addEventListener("submit", r), e.on("destroy", () => {
      i.removeEventListener("submit", r), t && (i.submit = t);
    });
  }
}
function RR(e) {
  return !!e && e.tagName.toLowerCase() === "textarea";
}
function Mh(e) {
  class n extends e {
    constructor() {
      super(...arguments);
      m(this, "sourceElement");
    }
    updateSourceElement(r) {
      if (!this.sourceElement)
        throw new v("editor-missing-sourceelement", this);
      const s = this.config.get("updateSourceElementOnDestroy"), o = this.sourceElement instanceof HTMLTextAreaElement;
      if (!s && !o) {
        ip(this.sourceElement, "");
        return;
      }
      const a = typeof r == "string" ? r : this.data.get();
      ip(this.sourceElement, a);
    }
  }
  return n;
}
Mh.updateSourceElement = Mh(Object).prototype.updateSourceElement;
var LR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.591 10.177 4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>', DR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>', MR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>', BR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>', FR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>', UR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>', HR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>', VR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>', $R = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.3 17.37-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5 9.375 17H19v1.5H8z"/></svg>', WR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.999 2H15a1 1 0 0 1 0 2h-1.004v13a1 1 0 1 1-2 0V4H8.999v13a1 1 0 1 1-2 0v-7A4 4 0 0 1 3 6a4 4 0 0 1 3.999-4z"/></svg>', zR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>', qR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>', YR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5 3.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 3.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M5 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M5 16.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 16.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/></svg>', jR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>', KR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 5.5H7v5h3.5a2.5 2.5 0 1 0 0-5zM5 3h6.5v.025a5 5 0 0 1 0 9.95V13H7v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/></svg>', GR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 2a1 1 0 0 0-1 1v6H3a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V3a1 1 0 0 0-1-1Z"/></svg>', QR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.816 11.5 7.038 4.785 4.261 11.5h5.555Zm.62 1.5H3.641l-1.666 4.028H.312l5.789-14h1.875l5.789 14h-1.663L10.436 13Z"/><path d="m12.09 17-.534-1.292.848-1.971.545 1.319L12.113 17h-.023Zm1.142-5.187.545 1.319L15.5 9.13l1.858 4.316h-3.45l.398.965h3.467L18.887 17H20l-3.873-9h-1.254l-1.641 3.813Z"/></svg>', XR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M19 4.5 14 0H3v12.673l.868-1.041c.185-.222.4-.402.632-.54V1.5h8v5h5v7.626a2.24 2.24 0 0 1 1.5.822V4.5ZM14 5V2l3.3 3H14Zm-3.692 12.5c.062.105.133.206.213.303L11.52 19H8v-.876a2.243 2.243 0 0 0 1.82-.624h.488Zm7.518-.657a.75.75 0 0 0-1.152-.96L15.5 17.29V12H14v5.29l-1.174-1.408a.75.75 0 0 0-1.152.96l2.346 2.816a.95.95 0 0 0 1.46 0l2.346-2.815Zm-15.056-.38a.75.75 0 0 1-.096-1.056l2.346-2.815a.95.95 0 0 1 1.46 0l2.346 2.815a.75.75 0 1 1-1.152.96L6.5 14.96V20H5v-5.04l-1.174 1.408a.75.75 0 0 1-1.056.096Z"/></svg>', JR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m14.958 9.367-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>', ZR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m5.042 9.367 2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>', e5 = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>', t5 = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>';
const Ge = {
  bold: jR,
  cancel: LR,
  check: DR,
  previousArrow: MR,
  nextArrow: BR,
  importExport: XR,
  paragraph: KR,
  plus: GR,
  text: QR,
  alignLeft: FR,
  alignCenter: UR,
  alignRight: HR,
  alignJustify: VR,
  pencil: $R,
  pilcrow: WR,
  quote: zR,
  threeVerticalDots: qR,
  dragIndicator: YR,
  redo: JR,
  undo: ZR,
  bulletedList: e5,
  numberedList: t5
};
var n5 = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
};
const Ua = n5, BT = {};
for (const e of Object.keys(Ua))
  BT[Ua[e]] = e;
const ae = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  lch: { channels: 3, labels: "lch" },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
};
var FT = ae;
for (const e of Object.keys(ae)) {
  if (!("channels" in ae[e]))
    throw new Error("missing channels property: " + e);
  if (!("labels" in ae[e]))
    throw new Error("missing channel labels property: " + e);
  if (ae[e].labels.length !== ae[e].channels)
    throw new Error("channel and label counts mismatch: " + e);
  const { channels: n, labels: t } = ae[e];
  delete ae[e].channels, delete ae[e].labels, Object.defineProperty(ae[e], "channels", { value: n }), Object.defineProperty(ae[e], "labels", { value: t });
}
ae.rgb.hsl = function(e) {
  const n = e[0] / 255, t = e[1] / 255, i = e[2] / 255, r = Math.min(n, t, i), s = Math.max(n, t, i), o = s - r;
  let a, u;
  s === r ? a = 0 : n === s ? a = (t - i) / o : t === s ? a = 2 + (i - n) / o : i === s && (a = 4 + (n - t) / o), a = Math.min(a * 60, 360), a < 0 && (a += 360);
  const l = (r + s) / 2;
  return s === r ? u = 0 : l <= 0.5 ? u = o / (s + r) : u = o / (2 - s - r), [a, u * 100, l * 100];
};
ae.rgb.hsv = function(e) {
  let n, t, i, r, s;
  const o = e[0] / 255, a = e[1] / 255, u = e[2] / 255, l = Math.max(o, a, u), c = l - Math.min(o, a, u), d = function(p) {
    return (l - p) / 6 / c + 1 / 2;
  };
  return c === 0 ? (r = 0, s = 0) : (s = c / l, n = d(o), t = d(a), i = d(u), o === l ? r = i - t : a === l ? r = 1 / 3 + n - i : u === l && (r = 2 / 3 + t - n), r < 0 ? r += 1 : r > 1 && (r -= 1)), [
    r * 360,
    s * 100,
    l * 100
  ];
};
ae.rgb.hwb = function(e) {
  const n = e[0], t = e[1];
  let i = e[2];
  const r = ae.rgb.hsl(e)[0], s = 1 / 255 * Math.min(n, Math.min(t, i));
  return i = 1 - 1 / 255 * Math.max(n, Math.max(t, i)), [r, s * 100, i * 100];
};
ae.rgb.cmyk = function(e) {
  const n = e[0] / 255, t = e[1] / 255, i = e[2] / 255, r = Math.min(1 - n, 1 - t, 1 - i), s = (1 - n - r) / (1 - r) || 0, o = (1 - t - r) / (1 - r) || 0, a = (1 - i - r) / (1 - r) || 0;
  return [s * 100, o * 100, a * 100, r * 100];
};
function i5(e, n) {
  return (e[0] - n[0]) ** 2 + (e[1] - n[1]) ** 2 + (e[2] - n[2]) ** 2;
}
ae.rgb.keyword = function(e) {
  const n = BT[e];
  if (n)
    return n;
  let t = 1 / 0, i;
  for (const r of Object.keys(Ua)) {
    const s = Ua[r], o = i5(e, s);
    o < t && (t = o, i = r);
  }
  return i;
};
ae.keyword.rgb = function(e) {
  return Ua[e];
};
ae.rgb.xyz = function(e) {
  let n = e[0] / 255, t = e[1] / 255, i = e[2] / 255;
  n = n > 0.04045 ? ((n + 0.055) / 1.055) ** 2.4 : n / 12.92, t = t > 0.04045 ? ((t + 0.055) / 1.055) ** 2.4 : t / 12.92, i = i > 0.04045 ? ((i + 0.055) / 1.055) ** 2.4 : i / 12.92;
  const r = n * 0.4124 + t * 0.3576 + i * 0.1805, s = n * 0.2126 + t * 0.7152 + i * 0.0722, o = n * 0.0193 + t * 0.1192 + i * 0.9505;
  return [r * 100, s * 100, o * 100];
};
ae.rgb.lab = function(e) {
  const n = ae.rgb.xyz(e);
  let t = n[0], i = n[1], r = n[2];
  t /= 95.047, i /= 100, r /= 108.883, t = t > 8856e-6 ? t ** (1 / 3) : 7.787 * t + 16 / 116, i = i > 8856e-6 ? i ** (1 / 3) : 7.787 * i + 16 / 116, r = r > 8856e-6 ? r ** (1 / 3) : 7.787 * r + 16 / 116;
  const s = 116 * i - 16, o = 500 * (t - i), a = 200 * (i - r);
  return [s, o, a];
};
ae.hsl.rgb = function(e) {
  const n = e[0] / 360, t = e[1] / 100, i = e[2] / 100;
  let r, s, o;
  if (t === 0)
    return o = i * 255, [o, o, o];
  i < 0.5 ? r = i * (1 + t) : r = i + t - i * t;
  const a = 2 * i - r, u = [0, 0, 0];
  for (let l = 0; l < 3; l++)
    s = n + 1 / 3 * -(l - 1), s < 0 && s++, s > 1 && s--, 6 * s < 1 ? o = a + (r - a) * 6 * s : 2 * s < 1 ? o = r : 3 * s < 2 ? o = a + (r - a) * (2 / 3 - s) * 6 : o = a, u[l] = o * 255;
  return u;
};
ae.hsl.hsv = function(e) {
  const n = e[0];
  let t = e[1] / 100, i = e[2] / 100, r = t;
  const s = Math.max(i, 0.01);
  i *= 2, t *= i <= 1 ? i : 2 - i, r *= s <= 1 ? s : 2 - s;
  const o = (i + t) / 2, a = i === 0 ? 2 * r / (s + r) : 2 * t / (i + t);
  return [n, a * 100, o * 100];
};
ae.hsv.rgb = function(e) {
  const n = e[0] / 60, t = e[1] / 100;
  let i = e[2] / 100;
  const r = Math.floor(n) % 6, s = n - Math.floor(n), o = 255 * i * (1 - t), a = 255 * i * (1 - t * s), u = 255 * i * (1 - t * (1 - s));
  switch (i *= 255, r) {
    case 0:
      return [i, u, o];
    case 1:
      return [a, i, o];
    case 2:
      return [o, i, u];
    case 3:
      return [o, a, i];
    case 4:
      return [u, o, i];
    case 5:
      return [i, o, a];
  }
};
ae.hsv.hsl = function(e) {
  const n = e[0], t = e[1] / 100, i = e[2] / 100, r = Math.max(i, 0.01);
  let s, o;
  o = (2 - t) * i;
  const a = (2 - t) * r;
  return s = t * r, s /= a <= 1 ? a : 2 - a, s = s || 0, o /= 2, [n, s * 100, o * 100];
};
ae.hwb.rgb = function(e) {
  const n = e[0] / 360;
  let t = e[1] / 100, i = e[2] / 100;
  const r = t + i;
  let s;
  r > 1 && (t /= r, i /= r);
  const o = Math.floor(6 * n), a = 1 - i;
  s = 6 * n - o, o & 1 && (s = 1 - s);
  const u = t + s * (a - t);
  let l, c, d;
  switch (o) {
    default:
    case 6:
    case 0:
      l = a, c = u, d = t;
      break;
    case 1:
      l = u, c = a, d = t;
      break;
    case 2:
      l = t, c = a, d = u;
      break;
    case 3:
      l = t, c = u, d = a;
      break;
    case 4:
      l = u, c = t, d = a;
      break;
    case 5:
      l = a, c = t, d = u;
      break;
  }
  return [l * 255, c * 255, d * 255];
};
ae.cmyk.rgb = function(e) {
  const n = e[0] / 100, t = e[1] / 100, i = e[2] / 100, r = e[3] / 100, s = 1 - Math.min(1, n * (1 - r) + r), o = 1 - Math.min(1, t * (1 - r) + r), a = 1 - Math.min(1, i * (1 - r) + r);
  return [s * 255, o * 255, a * 255];
};
ae.xyz.rgb = function(e) {
  const n = e[0] / 100, t = e[1] / 100, i = e[2] / 100;
  let r, s, o;
  return r = n * 3.2406 + t * -1.5372 + i * -0.4986, s = n * -0.9689 + t * 1.8758 + i * 0.0415, o = n * 0.0557 + t * -0.204 + i * 1.057, r = r > 31308e-7 ? 1.055 * r ** (1 / 2.4) - 0.055 : r * 12.92, s = s > 31308e-7 ? 1.055 * s ** (1 / 2.4) - 0.055 : s * 12.92, o = o > 31308e-7 ? 1.055 * o ** (1 / 2.4) - 0.055 : o * 12.92, r = Math.min(Math.max(0, r), 1), s = Math.min(Math.max(0, s), 1), o = Math.min(Math.max(0, o), 1), [r * 255, s * 255, o * 255];
};
ae.xyz.lab = function(e) {
  let n = e[0], t = e[1], i = e[2];
  n /= 95.047, t /= 100, i /= 108.883, n = n > 8856e-6 ? n ** (1 / 3) : 7.787 * n + 16 / 116, t = t > 8856e-6 ? t ** (1 / 3) : 7.787 * t + 16 / 116, i = i > 8856e-6 ? i ** (1 / 3) : 7.787 * i + 16 / 116;
  const r = 116 * t - 16, s = 500 * (n - t), o = 200 * (t - i);
  return [r, s, o];
};
ae.lab.xyz = function(e) {
  const n = e[0], t = e[1], i = e[2];
  let r, s, o;
  s = (n + 16) / 116, r = t / 500 + s, o = s - i / 200;
  const a = s ** 3, u = r ** 3, l = o ** 3;
  return s = a > 8856e-6 ? a : (s - 16 / 116) / 7.787, r = u > 8856e-6 ? u : (r - 16 / 116) / 7.787, o = l > 8856e-6 ? l : (o - 16 / 116) / 7.787, r *= 95.047, s *= 100, o *= 108.883, [r, s, o];
};
ae.lab.lch = function(e) {
  const n = e[0], t = e[1], i = e[2];
  let r;
  r = Math.atan2(i, t) * 360 / 2 / Math.PI, r < 0 && (r += 360);
  const o = Math.sqrt(t * t + i * i);
  return [n, o, r];
};
ae.lch.lab = function(e) {
  const n = e[0], t = e[1], r = e[2] / 360 * 2 * Math.PI, s = t * Math.cos(r), o = t * Math.sin(r);
  return [n, s, o];
};
ae.rgb.ansi16 = function(e, n = null) {
  const [t, i, r] = e;
  let s = n === null ? ae.rgb.hsv(e)[2] : n;
  if (s = Math.round(s / 50), s === 0)
    return 30;
  let o = 30 + (Math.round(r / 255) << 2 | Math.round(i / 255) << 1 | Math.round(t / 255));
  return s === 2 && (o += 60), o;
};
ae.hsv.ansi16 = function(e) {
  return ae.rgb.ansi16(ae.hsv.rgb(e), e[2]);
};
ae.rgb.ansi256 = function(e) {
  const n = e[0], t = e[1], i = e[2];
  return n === t && t === i ? n < 8 ? 16 : n > 248 ? 231 : Math.round((n - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(n / 255 * 5) + 6 * Math.round(t / 255 * 5) + Math.round(i / 255 * 5);
};
ae.ansi16.rgb = function(e) {
  let n = e % 10;
  if (n === 0 || n === 7)
    return e > 50 && (n += 3.5), n = n / 10.5 * 255, [n, n, n];
  const t = (~~(e > 50) + 1) * 0.5, i = (n & 1) * t * 255, r = (n >> 1 & 1) * t * 255, s = (n >> 2 & 1) * t * 255;
  return [i, r, s];
};
ae.ansi256.rgb = function(e) {
  if (e >= 232) {
    const s = (e - 232) * 10 + 8;
    return [s, s, s];
  }
  e -= 16;
  let n;
  const t = Math.floor(e / 36) / 5 * 255, i = Math.floor((n = e % 36) / 6) / 5 * 255, r = n % 6 / 5 * 255;
  return [t, i, r];
};
ae.rgb.hex = function(e) {
  const t = (((Math.round(e[0]) & 255) << 16) + ((Math.round(e[1]) & 255) << 8) + (Math.round(e[2]) & 255)).toString(16).toUpperCase();
  return "000000".substring(t.length) + t;
};
ae.hex.rgb = function(e) {
  const n = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!n)
    return [0, 0, 0];
  let t = n[0];
  n[0].length === 3 && (t = t.split("").map((a) => a + a).join(""));
  const i = parseInt(t, 16), r = i >> 16 & 255, s = i >> 8 & 255, o = i & 255;
  return [r, s, o];
};
ae.rgb.hcg = function(e) {
  const n = e[0] / 255, t = e[1] / 255, i = e[2] / 255, r = Math.max(Math.max(n, t), i), s = Math.min(Math.min(n, t), i), o = r - s;
  let a, u;
  return o < 1 ? a = s / (1 - o) : a = 0, o <= 0 ? u = 0 : r === n ? u = (t - i) / o % 6 : r === t ? u = 2 + (i - n) / o : u = 4 + (n - t) / o, u /= 6, u %= 1, [u * 360, o * 100, a * 100];
};
ae.hsl.hcg = function(e) {
  const n = e[1] / 100, t = e[2] / 100, i = t < 0.5 ? 2 * n * t : 2 * n * (1 - t);
  let r = 0;
  return i < 1 && (r = (t - 0.5 * i) / (1 - i)), [e[0], i * 100, r * 100];
};
ae.hsv.hcg = function(e) {
  const n = e[1] / 100, t = e[2] / 100, i = n * t;
  let r = 0;
  return i < 1 && (r = (t - i) / (1 - i)), [e[0], i * 100, r * 100];
};
ae.hcg.rgb = function(e) {
  const n = e[0] / 360, t = e[1] / 100, i = e[2] / 100;
  if (t === 0)
    return [i * 255, i * 255, i * 255];
  const r = [0, 0, 0], s = n % 1 * 6, o = s % 1, a = 1 - o;
  let u = 0;
  switch (Math.floor(s)) {
    case 0:
      r[0] = 1, r[1] = o, r[2] = 0;
      break;
    case 1:
      r[0] = a, r[1] = 1, r[2] = 0;
      break;
    case 2:
      r[0] = 0, r[1] = 1, r[2] = o;
      break;
    case 3:
      r[0] = 0, r[1] = a, r[2] = 1;
      break;
    case 4:
      r[0] = o, r[1] = 0, r[2] = 1;
      break;
    default:
      r[0] = 1, r[1] = 0, r[2] = a;
  }
  return u = (1 - t) * i, [
    (t * r[0] + u) * 255,
    (t * r[1] + u) * 255,
    (t * r[2] + u) * 255
  ];
};
ae.hcg.hsv = function(e) {
  const n = e[1] / 100, t = e[2] / 100, i = n + t * (1 - n);
  let r = 0;
  return i > 0 && (r = n / i), [e[0], r * 100, i * 100];
};
ae.hcg.hsl = function(e) {
  const n = e[1] / 100, i = e[2] / 100 * (1 - n) + 0.5 * n;
  let r = 0;
  return i > 0 && i < 0.5 ? r = n / (2 * i) : i >= 0.5 && i < 1 && (r = n / (2 * (1 - i))), [e[0], r * 100, i * 100];
};
ae.hcg.hwb = function(e) {
  const n = e[1] / 100, t = e[2] / 100, i = n + t * (1 - n);
  return [e[0], (i - n) * 100, (1 - i) * 100];
};
ae.hwb.hcg = function(e) {
  const n = e[1] / 100, i = 1 - e[2] / 100, r = i - n;
  let s = 0;
  return r < 1 && (s = (i - r) / (1 - r)), [e[0], r * 100, s * 100];
};
ae.apple.rgb = function(e) {
  return [e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255];
};
ae.rgb.apple = function(e) {
  return [e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535];
};
ae.gray.rgb = function(e) {
  return [e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255];
};
ae.gray.hsl = function(e) {
  return [0, 0, e[0]];
};
ae.gray.hsv = ae.gray.hsl;
ae.gray.hwb = function(e) {
  return [0, 100, e[0]];
};
ae.gray.cmyk = function(e) {
  return [0, 0, 0, e[0]];
};
ae.gray.lab = function(e) {
  return [e[0], 0, 0];
};
ae.gray.hex = function(e) {
  const n = Math.round(e[0] / 100 * 255) & 255, i = ((n << 16) + (n << 8) + n).toString(16).toUpperCase();
  return "000000".substring(i.length) + i;
};
ae.rgb.gray = function(e) {
  return [(e[0] + e[1] + e[2]) / 3 / 255 * 100];
};
const Al = FT;
function r5() {
  const e = {}, n = Object.keys(Al);
  for (let t = n.length, i = 0; i < t; i++)
    e[n[i]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  return e;
}
function s5(e) {
  const n = r5(), t = [e];
  for (n[e].distance = 0; t.length; ) {
    const i = t.pop(), r = Object.keys(Al[i]);
    for (let s = r.length, o = 0; o < s; o++) {
      const a = r[o], u = n[a];
      u.distance === -1 && (u.distance = n[i].distance + 1, u.parent = i, t.unshift(a));
    }
  }
  return n;
}
function o5(e, n) {
  return function(t) {
    return n(e(t));
  };
}
function a5(e, n) {
  const t = [n[e].parent, e];
  let i = Al[n[e].parent][e], r = n[e].parent;
  for (; n[r].parent; )
    t.unshift(n[r].parent), i = o5(Al[n[r].parent][r], i), r = n[r].parent;
  return i.conversion = t, i;
}
var u5 = function(e) {
  const n = s5(e), t = {}, i = Object.keys(n);
  for (let r = i.length, s = 0; s < r; s++) {
    const o = i[s];
    n[o].parent !== null && (t[o] = a5(o, n));
  }
  return t;
};
const Bh = FT, l5 = u5, Mo = {}, c5 = Object.keys(Bh);
function d5(e) {
  const n = function(...t) {
    const i = t[0];
    return i == null ? i : (i.length > 1 && (t = i), e(t));
  };
  return "conversion" in e && (n.conversion = e.conversion), n;
}
function h5(e) {
  const n = function(...t) {
    const i = t[0];
    if (i == null)
      return i;
    i.length > 1 && (t = i);
    const r = e(t);
    if (typeof r == "object")
      for (let s = r.length, o = 0; o < s; o++)
        r[o] = Math.round(r[o]);
    return r;
  };
  return "conversion" in e && (n.conversion = e.conversion), n;
}
c5.forEach((e) => {
  Mo[e] = {}, Object.defineProperty(Mo[e], "channels", { value: Bh[e].channels }), Object.defineProperty(Mo[e], "labels", { value: Bh[e].labels });
  const n = l5(e);
  Object.keys(n).forEach((i) => {
    const r = n[i];
    Mo[e][i] = h5(r), Mo[e][i].raw = d5(r);
  });
});
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class Ji extends Qi {
  /**
  * Creates a new instance of the {@link module:ui/viewcollection~ViewCollection}.
  *
  * @param initialItems The initial items of the collection.
  */
  constructor(t = []) {
    super(t, {
      // An #id Number attribute should be legal and not break the `ViewCollection` instance.
      // https://github.com/ckeditor/ckeditor5-ui/issues/93
      idProperty: "viewUid"
    });
    /**
    * A parent element within which child views are rendered and managed in DOM.
    */
    m(this, "_parentElement");
    this.on("add", (i, r, s) => {
      this._renderViewIntoCollectionParent(r, s);
    }), this.on("remove", (i, r) => {
      r.element && this._parentElement && r.element.remove();
    }), this._parentElement = null;
  }
  /**
  * Destroys the view collection along with child views.
  * See the view {@link module:ui/view~View#destroy} method.
  */
  destroy() {
    this.map((t) => t.destroy());
  }
  /**
  * Sets the parent HTML element of this collection. When parent is set, {@link #add adding} and
  * {@link #remove removing} views in the collection synchronizes their
  * {@link module:ui/view~View#element elements} in the parent element.
  *
  * @param element A new parent element.
  */
  setParent(t) {
    this._parentElement = t;
    for (const i of this)
      this._renderViewIntoCollectionParent(i);
  }
  /**
  * Delegates selected events coming from within views in the collection to any
  * {@link module:utils/emittermixin~Emitter}.
  *
  * For the following views and collection:
  *
  * ```ts
  * const viewA = new View();
  * const viewB = new View();
  * const viewC = new View();
  *
  * const views = parentView.createCollection();
  *
  * views.delegate( 'eventX' ).to( viewB );
  * views.delegate( 'eventX', 'eventY' ).to( viewC );
  *
  * views.add( viewA );
  * ```
  *
  * the `eventX` is delegated (fired by) `viewB` and `viewC` along with `customData`:
  *
  * ```ts
  * viewA.fire( 'eventX', customData );
  * ```
  *
  * and `eventY` is delegated (fired by) `viewC` along with `customData`:
  *
  * ```ts
  * viewA.fire( 'eventY', customData );
  * ```
  *
  * See {@link module:utils/emittermixin~Emitter#delegate}.
  *
  * @param events {@link module:ui/view~View} event names to be delegated to another
  * {@link module:utils/emittermixin~Emitter}.
  * @returns Object with `to` property, a function which accepts the destination
  * of {@link module:utils/emittermixin~Emitter#delegate delegated} events.
  */
  delegate(...t) {
    if (!t.length || !f5(t))
      throw new v("ui-viewcollection-delegate-wrong-events", this);
    return {
      to: (i) => {
        for (const r of this)
          for (const s of t)
            r.delegate(s).to(i);
        this.on("add", (r, s) => {
          for (const o of t)
            s.delegate(o).to(i);
        }), this.on("remove", (r, s) => {
          for (const o of t)
            s.stopDelegating(o, i);
        });
      }
    };
  }
  /**
  * This method {@link module:ui/view~View#render renders} a new view added to the collection.
  *
  * If the {@link #_parentElement parent element} of the collection is set, this method also adds
  * the view's {@link module:ui/view~View#element} as a child of the parent in DOM at a specified index.
  *
  * **Note**: If index is not specified, the view's element is pushed as the last child
  * of the parent element.
  *
  * @param view A new view added to the collection.
  * @param index An index the view holds in the collection. When not specified,
  * the view is added at the end.
  */
  _renderViewIntoCollectionParent(t, i) {
    t.isRendered || t.render(), t.element && this._parentElement && this._parentElement.insertBefore(t.element, this._parentElement.children[i]);
  }
  /**
  * Removes a child view from the collection. If the {@link #setParent parent element} of the
  * collection has been set, the {@link module:ui/view~View#element element} of the view is also removed
  * in DOM, reflecting the order of the collection.
  *
  * See the {@link #add} method.
  *
  * @param subject The view to remove, its id or index in the collection.
  * @returns The removed view.
  */
  remove(t) {
    return super.remove(t);
  }
}
function f5(e) {
  return e.every((n) => typeof n == "string");
}
const m5 = "http://www.w3.org/1999/xhtml";
class Ai extends (/* @__PURE__ */ Je()) {
  /**
  * Creates an instance of the {@link ~Template} class.
  *
  * @param def The definition of the template.
  */
  constructor(t) {
    super();
    m(this, "ns");
    /**
    * The tag (`tagName`) of this template, e.g. `div`. It also indicates that the template
    * renders to an HTML element.
    */
    m(this, "tag");
    /**
    * The text of the template. It also indicates that the template renders to a DOM text node.
    */
    m(this, "text");
    /**
    * The attributes of the template, e.g. `{ id: [ 'ck-id' ] }`, corresponding with
    * the attributes of an HTML element.
    *
    * **Note**: This property only makes sense when {@link #tag} is defined.
    */
    m(this, "attributes");
    /**
    * The children of the template. They can be either:
    * * independent instances of {@link ~Template} (sub–templates),
    * * native DOM Nodes.
    *
    * **Note**: This property only makes sense when {@link #tag} is defined.
    */
    m(this, "children");
    /**
    * The DOM event listeners of the template.
    */
    m(this, "eventListeners");
    /**
    * Indicates whether this particular Template instance has been
    * {@link #render rendered}.
    */
    m(this, "_isRendered");
    /**
    * The data used by the {@link #revert} method to restore a node to its original state.
    *
    * See: {@link #apply}.
    */
    m(this, "_revertData");
    Object.assign(this, tg(eg(t))), this._isRendered = !1, this._revertData = null;
  }
  /**
  * Renders a DOM Node (an HTML element or text) out of the template.
  *
  * ```ts
  * const domNode = new Template( { ... } ).render();
  * ```
  *
  * See: {@link #apply}.
  */
  render() {
    const t = this._renderNode({
      intoFragment: !0
    });
    return this._isRendered = !0, t;
  }
  /**
  * Applies the template to an existing DOM Node, either HTML element or text.
  *
  * **Note:** No new DOM nodes will be created. Applying extends:
  *
  * {@link module:ui/template~TemplateDefinition attributes},
  * {@link module:ui/template~TemplateDefinition event listeners}, and
  * `textContent` of {@link module:ui/template~TemplateDefinition children} only.
  *
  * **Note:** Existing `class` and `style` attributes are extended when a template
  * is applied to an HTML element, while other attributes and `textContent` are overridden.
  *
  * **Note:** The process of applying a template can be easily reverted using the
  * {@link module:ui/template~Template#revert} method.
  *
  * ```ts
  * const element = document.createElement( 'div' );
  * const observable = new Model( { divClass: 'my-div' } );
  * const emitter = Object.create( EmitterMixin );
  * const bind = Template.bind( observable, emitter );
  *
  * new Template( {
  * 	attributes: {
  * 		id: 'first-div',
  * 		class: bind.to( 'divClass' )
  * 	},
  * 	on: {
  * 		click: bind( 'elementClicked' ) // Will be fired by the observable.
  * 	},
  * 	children: [
  * 		'Div text.'
  * 	]
  * } ).apply( element );
  *
  * console.log( element.outerHTML ); // -> '<div id="first-div" class="my-div"></div>'
  * ```
  *
  * @see module:ui/template~Template#render
  * @see module:ui/template~Template#revert
  * @param node Root node for the template to apply.
  */
  apply(t) {
    return this._revertData = rg(), this._renderNode({
      node: t,
      intoFragment: !1,
      isApplying: !0,
      revertData: this._revertData
    }), t;
  }
  /**
  * Reverts a template {@link module:ui/template~Template#apply applied} to a DOM node.
  *
  * @param node The root node for the template to revert. In most of the cases, it is the
  * same node used by {@link module:ui/template~Template#apply}.
  */
  revert(t) {
    if (!this._revertData)
      throw new v("ui-template-revert-not-applied", [
        this,
        t
      ]);
    this._revertTemplateFromNode(t, this._revertData);
  }
  /**
  * Returns an iterator which traverses the template in search of {@link module:ui/view~View}
  * instances and returns them one by one.
  *
  * ```ts
  * const viewFoo = new View();
  * const viewBar = new View();
  * const viewBaz = new View();
  * const template = new Template( {
  * 	tag: 'div',
  * 	children: [
  * 		viewFoo,
  * 		{
  * 			tag: 'div',
  * 			children: [
  * 				viewBar
  * 			]
  * 		},
  * 		viewBaz
  * 	]
  * } );
  *
  * // Logs: viewFoo, viewBar, viewBaz
  * for ( const view of template.getViews() ) {
  * 	console.log( view );
  * }
  * ```
  */
  *getViews() {
    function* t(i) {
      if (i.children)
        for (const r of i.children)
          Cl(r) ? yield r : im(r) && (yield* t(r));
    }
    yield* t(this);
  }
  /**
  * An entry point to the interface which binds DOM nodes to
  * {@link module:utils/observablemixin~Observable observables}.
  * There are two types of bindings:
  *
  * * HTML element attributes or text `textContent` synchronized with attributes of an
  * {@link module:utils/observablemixin~Observable}. Learn more about {@link module:ui/template~BindChain#to}
  * and {@link module:ui/template~BindChain#if}.
  *
  * ```ts
  * const bind = Template.bind( observable, emitter );
  *
  * new Template( {
  * 	attributes: {
  * 		// Binds the element "class" attribute to observable#classAttribute.
  * 		class: bind.to( 'classAttribute' )
  * 	}
  * } ).render();
  * ```
  *
  * * DOM events fired on HTML element propagated through
  * {@link module:utils/observablemixin~Observable}. Learn more about {@link module:ui/template~BindChain#to}.
  *
  * ```ts
  * const bind = Template.bind( observable, emitter );
  *
  * new Template( {
  * 	on: {
  * 		// Will be fired by the observable.
  * 		click: bind( 'elementClicked' )
  * 	}
  * } ).render();
  * ```
  *
  * Also see {@link module:ui/view~View#bindTemplate}.
  *
  * @param observable An observable which provides boundable attributes.
  * @param emitter An emitter that listens to observable attribute
  * changes or DOM Events (depending on the kind of the binding). Usually, a {@link module:ui/view~View} instance.
  */
  static bind(t, i) {
    return {
      to(r, s) {
        return new p5({
          eventNameOrFunction: r,
          attribute: r,
          observable: t,
          emitter: i,
          callback: s
        });
      },
      if(r, s, o) {
        return new UT({
          observable: t,
          emitter: i,
          attribute: r,
          valueIfTrue: s,
          callback: o
        });
      }
    };
  }
  /**
  * Extends an existing {@link module:ui/template~Template} instance with some additional content
  * from another {@link module:ui/template~TemplateDefinition}.
  *
  * ```ts
  * const bind = Template.bind( observable, emitter );
  *
  * const template = new Template( {
  * 	tag: 'p',
  * 	attributes: {
  * 		class: 'a',
  * 		data-x: bind.to( 'foo' )
  * 	},
  * 	children: [
  * 		{
  * 			tag: 'span',
  * 			attributes: {
  * 				class: 'b'
  * 			},
  * 			children: [
  * 				'Span'
  * 			]
  * 		}
  * 	]
  *  } );
  *
  * // Instance-level extension.
  * Template.extend( template, {
  * 	attributes: {
  * 		class: 'b',
  * 		data-x: bind.to( 'bar' )
  * 	},
  * 	children: [
  * 		{
  * 			attributes: {
  * 				class: 'c'
  * 			}
  * 		}
  * 	]
  * } );
  *
  * // Child extension.
  * Template.extend( template.children[ 0 ], {
  * 	attributes: {
  * 		class: 'd'
  * 	}
  * } );
  * ```
  *
  * the `outerHTML` of `template.render()` is:
  *
  * ```html
  * <p class="a b" data-x="{ observable.foo } { observable.bar }">
  * 	<span class="b c d">Span</span>
  * </p>
  * ```
  *
  * @param template An existing template instance to be extended.
  * @param def Additional definition to be applied to a template.
  */
  static extend(t, i) {
    if (t._isRendered)
      throw new v("template-extend-render", [
        this,
        t
      ]);
    WT(t, tg(eg(i)));
  }
  /**
  * Renders a DOM Node (either an HTML element or text) out of the template.
  *
  * @param data Rendering data.
  */
  _renderNode(t) {
    let i;
    if (t.node ? i = this.tag && this.text : i = this.tag ? this.text : !this.text, i)
      throw new v("ui-template-wrong-syntax", this);
    return this.text ? this._renderText(t) : this._renderElement(t);
  }
  /**
  * Renders an HTML element out of the template.
  *
  * @param data Rendering data.
  */
  _renderElement(t) {
    let i = t.node;
    return i || (i = t.node = document.createElementNS(this.ns || m5, this.tag)), this._renderAttributes(t), this._renderElementChildren(t), this._setUpListeners(t), i;
  }
  /**
  * Renders a text node out of {@link module:ui/template~Template#text}.
  *
  * @param data Rendering data.
  */
  _renderText(t) {
    let i = t.node;
    return i ? t.revertData.text = i.textContent : i = t.node = document.createTextNode(""), Qu(this.text) ? this._bindToObservable({
      schema: this.text,
      updater: b5(i),
      data: t
    }) : i.textContent = this.text.join(""), i;
  }
  /**
  * Renders HTML element attributes out of {@link module:ui/template~Template#attributes}.
  *
  * @param data Rendering data.
  */
  _renderAttributes(t) {
    if (!this.attributes)
      return;
    const i = t.node, r = t.revertData;
    for (const s in this.attributes) {
      const o = i.getAttribute(s), a = this.attributes[s];
      r && (r.attributes[s] = o);
      const u = ig(a) ? a[0].ns : null;
      if (Qu(a)) {
        const l = ig(a) ? a[0].value : a;
        r && sg(s) && l.unshift(o), this._bindToObservable({
          schema: l,
          updater: _5(i, s, u),
          data: t
        });
      } else if (s == "style" && typeof a[0] != "string")
        this._renderStyleAttribute(a[0], t);
      else {
        r && o && sg(s) && a.unshift(o);
        const l = a.map((c) => c && (c.value || c)).reduce((c, d) => c.concat(d), []).reduce($T, "");
        to(l) || i.setAttributeNS(u, s, l);
      }
    }
  }
  /**
  * Renders the `style` attribute of an HTML element based on
  * {@link module:ui/template~Template#attributes}.
  *
  * A style attribute is an object with static values:
  *
  * ```ts
  * attributes: {
  * 	style: {
  * 		color: 'red'
  * 	}
  * }
  * ```
  *
  * or values bound to {@link module:ui/model~Model} properties:
  *
  * ```ts
  * attributes: {
  * 	style: {
  * 		color: bind.to( ... )
  * 	}
  * }
  * ```
  *
  * Note: The `style` attribute is rendered without setting the namespace. It does not seem to be
  * needed.
  *
  * @param styles Styles located in `attributes.style` of {@link module:ui/template~TemplateDefinition}.
  * @param data Rendering data.
  */
  _renderStyleAttribute(t, i) {
    const r = i.node;
    for (const s in t) {
      const o = t[s];
      Qu(o) ? this._bindToObservable({
        schema: [
          o
        ],
        updater: E5(r, s),
        data: i
      }) : r.style[s] = o;
    }
  }
  /**
  * Recursively renders HTML element's children from {@link module:ui/template~Template#children}.
  *
  * @param data Rendering data.
  */
  _renderElementChildren(t) {
    const i = t.node, r = t.intoFragment ? document.createDocumentFragment() : i, s = t.isApplying;
    let o = 0;
    for (const a of this.children)
      if (rm(a)) {
        if (!s) {
          a.setParent(i);
          for (const u of a)
            r.appendChild(u.element);
        }
      } else if (Cl(a))
        s || (a.isRendered || a.render(), r.appendChild(a.element));
      else if (Tr(a))
        r.appendChild(a);
      else if (s) {
        const u = t.revertData, l = rg();
        u.children.push(l), a._renderNode({
          intoFragment: !1,
          node: r.childNodes[o++],
          isApplying: !0,
          revertData: l
        });
      } else
        r.appendChild(a.render());
    t.intoFragment && i.appendChild(r);
  }
  /**
  * Activates `on` event listeners from the {@link module:ui/template~TemplateDefinition}
  * on an HTML element.
  *
  * @param data Rendering data.
  */
  _setUpListeners(t) {
    if (this.eventListeners)
      for (const i in this.eventListeners) {
        const r = this.eventListeners[i].map((s) => {
          const [o, a] = i.split("@");
          return s.activateDomEventListener(o, a, t);
        });
        t.revertData && t.revertData.bindings.push(r);
      }
  }
  /**
  * For a given {@link module:ui/template~TemplateValueSchema} containing {@link module:ui/template~TemplateBinding}
  * activates the binding and sets its initial value.
  *
  * Note: {@link module:ui/template~TemplateValueSchema} can be for HTML element attributes or
  * text node `textContent`.
  *
  * @param options Binding options.
  * @param options.updater A function which updates the DOM (like attribute or text).
  * @param options.data Rendering data.
  */
  _bindToObservable({ schema: t, updater: i, data: r }) {
    const s = r.revertData;
    HT(t, i, r);
    const o = t.filter((a) => !to(a)).filter((a) => a.observable).map((a) => a.activateAttributeListener(t, i, r));
    s && s.bindings.push(o);
  }
  /**
  * Reverts {@link module:ui/template~RenderData#revertData template data} from a node to
  * return it to the original state.
  *
  * @param node A node to be reverted.
  * @param revertData An object that stores information about what changes have been made by
  * {@link #apply} to the node. See {@link module:ui/template~RenderData#revertData} for more information.
  */
  _revertTemplateFromNode(t, i) {
    for (const s of i.bindings)
      for (const o of s)
        o();
    if (i.text) {
      t.textContent = i.text;
      return;
    }
    const r = t;
    for (const s in i.attributes) {
      const o = i.attributes[s];
      o === null ? r.removeAttribute(s) : r.setAttribute(s, o);
    }
    for (let s = 0; s < i.children.length; ++s)
      this._revertTemplateFromNode(r.childNodes[s], i.children[s]);
  }
}
class iu {
  /**
  * Creates an instance of the {@link module:ui/template~TemplateBinding} class.
  *
  * @param def The definition of the binding.
  */
  constructor(n) {
    /**
    * The name of the {@link module:ui/template~TemplateBinding#observable observed attribute}.
    */
    m(this, "attribute");
    /**
    * An observable instance of the binding. It either:
    *
    * * provides the attribute with the value,
    * * or passes the event when a corresponding DOM event is fired.
    */
    m(this, "observable");
    /**
    * An {@link module:utils/emittermixin~Emitter} used by the binding to:
    *
    * * listen to the attribute change in the {@link module:ui/template~TemplateBinding#observable},
    * * or listen to the event in the DOM.
    */
    m(this, "emitter");
    /**
    * A custom function to process the value of the {@link module:ui/template~TemplateBinding#attribute}.
    */
    m(this, "callback");
    this.attribute = n.attribute, this.observable = n.observable, this.emitter = n.emitter, this.callback = n.callback;
  }
  /**
  * Returns the value of the binding. It is the value of the {@link module:ui/template~TemplateBinding#attribute} in
  * {@link module:ui/template~TemplateBinding#observable}. The value may be processed by the
  * {@link module:ui/template~TemplateBinding#callback}, if such has been passed to the binding.
  *
  * @param node A native DOM node, passed to the custom {@link module:ui/template~TemplateBinding#callback}.
  * @returns The value of {@link module:ui/template~TemplateBinding#attribute} in
  * {@link module:ui/template~TemplateBinding#observable}.
  */
  getValue(n) {
    const t = this.observable[this.attribute];
    return this.callback ? this.callback(t, n) : t;
  }
  /**
  * Activates the listener which waits for changes of the {@link module:ui/template~TemplateBinding#attribute} in
  * {@link module:ui/template~TemplateBinding#observable}, then updates the DOM with the aggregated
  * value of {@link module:ui/template~TemplateValueSchema}.
  *
  * @param schema A full schema to generate an attribute or text in the DOM.
  * @param updater A DOM updater function used to update the native DOM attribute or text.
  * @param data Rendering data.
  * @returns A function to sever the listener binding.
  */
  activateAttributeListener(n, t, i) {
    const r = () => HT(n, t, i);
    return this.emitter.listenTo(this.observable, `change:${this.attribute}`, r), () => {
      this.emitter.stopListening(this.observable, `change:${this.attribute}`, r);
    };
  }
}
class p5 extends iu {
  constructor(t) {
    super(t);
    m(this, "eventNameOrFunction");
    this.eventNameOrFunction = t.eventNameOrFunction;
  }
  /**
  * Activates the listener for the native DOM event, which when fired, is propagated by
  * the {@link module:ui/template~TemplateBinding#emitter}.
  *
  * @param domEvtName The name of the native DOM event.
  * @param domSelector The selector in the DOM to filter delegated events.
  * @param data Rendering data.
  * @returns A function to sever the listener binding.
  */
  activateDomEventListener(t, i, r) {
    const s = (o, a) => {
      (!i || a.target.matches(i)) && (typeof this.eventNameOrFunction == "function" ? this.eventNameOrFunction(a) : this.observable.fire(this.eventNameOrFunction, a));
    };
    return this.emitter.listenTo(r.node, t, s), () => {
      this.emitter.stopListening(r.node, t, s);
    };
  }
}
class UT extends iu {
  constructor(t) {
    super(t);
    /**
    * The value of the DOM attribute or text to be set if the {@link module:ui/template~TemplateBinding#attribute} in
    * {@link module:ui/template~TemplateBinding#observable} is `true`.
    */
    m(this, "valueIfTrue");
    this.valueIfTrue = t.valueIfTrue;
  }
  /**
  * @inheritDoc
  */
  getValue(t) {
    const i = super.getValue(t);
    return to(i) ? !1 : this.valueIfTrue || !0;
  }
}
function Qu(e) {
  return e ? (e.value && (e = e.value), Array.isArray(e) ? e.some(Qu) : e instanceof iu) : !1;
}
function g5(e, n) {
  return e.map((t) => t instanceof iu ? t.getValue(n) : t);
}
function HT(e, n, { node: t }) {
  const i = g5(e, t);
  let r;
  e.length == 1 && e[0] instanceof UT ? r = i[0] : r = i.reduce($T, ""), to(r) ? n.remove() : n.set(r);
}
function b5(e) {
  return {
    set(n) {
      e.textContent = n;
    },
    remove() {
      e.textContent = "";
    }
  };
}
function _5(e, n, t) {
  return {
    set(i) {
      e.setAttributeNS(t, n, i);
    },
    remove() {
      e.removeAttributeNS(t, n);
    }
  };
}
function E5(e, n) {
  return {
    set(t) {
      e.style[n] = t;
    },
    remove() {
      e.style[n] = null;
    }
  };
}
function eg(e) {
  return Ff(e, (t) => {
    if (t && (t instanceof iu || im(t) || Cl(t) || rm(t)))
      return t;
  });
}
function tg(e) {
  if (typeof e == "string" ? e = w5(e) : e.text && A5(e), e.on && (e.eventListeners = y5(e.on), delete e.on), !e.text) {
    e.attributes && T5(e.attributes);
    const n = [];
    if (e.children)
      if (rm(e.children))
        n.push(e.children);
      else
        for (const t of e.children)
          im(t) || Cl(t) || Tr(t) ? n.push(t) : n.push(new Ai(t));
    e.children = n;
  }
  return e;
}
function T5(e) {
  for (const n in e)
    e[n].value && (e[n].value = Dt(e[n].value)), VT(e, n);
}
function y5(e) {
  for (const n in e)
    VT(e, n);
  return e;
}
function w5(e) {
  return {
    text: [
      e
    ]
  };
}
function A5(e) {
  e.text = Dt(e.text);
}
function VT(e, n) {
  e[n] = Dt(e[n]);
}
function $T(e, n) {
  return to(n) ? e : to(e) ? n : `${e} ${n}`;
}
function ng(e, n) {
  for (const t in n)
    e[t] ? e[t].push(...n[t]) : e[t] = n[t];
}
function WT(e, n) {
  if (n.attributes && (e.attributes || (e.attributes = {}), ng(e.attributes, n.attributes)), n.eventListeners && (e.eventListeners || (e.eventListeners = {}), ng(e.eventListeners, n.eventListeners)), n.text && e.text.push(...n.text), n.children && n.children.length) {
    if (e.children.length != n.children.length)
      throw new v("ui-template-extend-children-mismatch", e);
    let t = 0;
    for (const i of n.children)
      WT(e.children[t++], i);
  }
}
function to(e) {
  return !e && e !== 0;
}
function Cl(e) {
  return e instanceof me;
}
function im(e) {
  return e instanceof Ai;
}
function rm(e) {
  return e instanceof Ji;
}
function ig(e) {
  return ft(e[0]) && e[0].ns;
}
function rg() {
  return {
    children: [],
    bindings: [],
    attributes: {}
  };
}
function sg(e) {
  return e == "class" || e == "style";
}
class me extends (/* @__PURE__ */ li(/* @__PURE__ */ pt())) {
  /**
  * Creates an instance of the {@link module:ui/view~View} class.
  *
  * Also see {@link #render}.
  *
  * @param locale The localization services instance.
  */
  constructor(t) {
    super();
    /**
    * An HTML element of the view. `null` until {@link #render rendered}
    * from the {@link #template}.
    *
    * ```ts
    * class SampleView extends View {
    * 	constructor() {
    * 		super();
    *
    * 		// A template instance the #element will be created from.
    * 		this.setTemplate( {
    * 			tag: 'p'
    *
    * 			// ...
    * 		} );
    * 	}
    * }
    *
    * const view = new SampleView();
    *
    * // Renders the #template.
    * view.render();
    *
    * // Append the HTML element of the view to <body>.
    * document.body.appendChild( view.element );
    * ```
    *
    * **Note**: The element of the view can also be assigned directly:
    *
    * ```ts
    * view.element = document.querySelector( '#my-container' );
    * ```
    */
    m(this, "element");
    /**
    * Set `true` when the view has already been {@link module:ui/view~View#render rendered}.
    *
    * @readonly
    */
    m(this, "isRendered");
    /**
    * A set of tools to localize the user interface.
    *
    * Also see {@link module:core/editor/editor~Editor#locale}.
    *
    * @readonly
    */
    m(this, "locale");
    /**
    * Shorthand for {@link module:utils/locale~Locale#t}.
    *
    * Note: If {@link #locale} instance hasn't been passed to the view this method may not
    * be available.
    *
    * @see module:utils/locale~Locale#t
    */
    m(this, "t");
    /**
    * Template of this view. It provides the {@link #element} representing
    * the view in DOM, which is {@link #render rendered}.
    */
    m(this, "template");
    /**
    * Collections registered with {@link #createCollection}.
    */
    m(this, "_viewCollections");
    /**
    * A collection of view instances, which have been added directly
    * into the {@link module:ui/template~Template#children}.
    */
    m(this, "_unboundChildren");
    /**
    * Cached {@link module:ui/template~BindChain bind chain} object created by the
    * {@link #template}. See {@link #bindTemplate}.
    */
    m(this, "_bindTemplate");
    this.element = null, this.isRendered = !1, this.locale = t, this.t = t && t.t, this._viewCollections = new Qi(), this._unboundChildren = this.createCollection(), this._viewCollections.on("add", (i, r) => {
      r.locale = t, r.t = t && t.t;
    }), this.decorate("render");
  }
  /**
  * Shorthand for {@link module:ui/template~Template.bind}, a binding
  * {@link module:ui/template~BindChain interface} pre–configured for the view instance.
  *
  * It provides {@link module:ui/template~BindChain#to `to()`} and
  * {@link module:ui/template~BindChain#if `if()`} methods that initialize bindings with
  * observable attributes and attach DOM listeners.
  *
  * ```ts
  * class SampleView extends View {
  * 	constructor( locale ) {
  * 		super( locale );
  *
  * 		const bind = this.bindTemplate;
  *
  * 		// These {@link module:utils/observablemixin~Observable observable} attributes will control
  * 		// the state of the view in DOM.
  * 		this.set( {
  * 			elementClass: 'foo',
  * 		 	isEnabled: true
  * 		 } );
  *
  * 		this.setTemplate( {
  * 			tag: 'p',
  *
  * 			attributes: {
  * 				// The class HTML attribute will follow elementClass
  * 				// and isEnabled view attributes.
  * 				class: [
  * 					bind.to( 'elementClass' )
  * 					bind.if( 'isEnabled', 'present-when-enabled' )
  * 				]
  * 			},
  *
  * 			on: {
  * 				// The view will fire the "clicked" event upon clicking <p> in DOM.
  * 				click: bind.to( 'clicked' )
  * 			}
  * 		} );
  * 	}
  * }
  * ```
  */
  get bindTemplate() {
    return this._bindTemplate ? this._bindTemplate : this._bindTemplate = Ai.bind(this, this);
  }
  /**
  * Creates a new collection of views, which can be used as
  * {@link module:ui/template~Template#children} of this view.
  *
  * ```ts
  * class SampleView extends View {
  * 	constructor( locale ) {
  * 		super( locale );
  *
  * 		const child = new ChildView( locale );
  * 		this.items = this.createCollection( [ child ] );
   *
  * 		this.setTemplate( {
  * 			tag: 'p',
  *
  * 			// `items` collection will render here.
  * 			children: this.items
  * 		} );
  * 	}
  * }
  *
  * const view = new SampleView( locale );
  * view.render();
  *
  * // It will append <p><child#element></p> to the <body>.
  * document.body.appendChild( view.element );
  * ```
  *
  * @param views Initial views of the collection.
  * @returns A new collection of view instances.
  */
  createCollection(t) {
    const i = new Ji(t);
    return this._viewCollections.add(i), i;
  }
  /**
  * Registers a new child view under the view instance. Once registered, a child
  * view is managed by its parent, including {@link #render rendering}
  * and {@link #destroy destruction}.
  *
  * To revert this, use {@link #deregisterChild}.
  *
  * ```ts
  * class SampleView extends View {
  * 	constructor( locale ) {
  * 		super( locale );
  *
  * 		this.childA = new SomeChildView( locale );
  * 		this.childB = new SomeChildView( locale );
  *
  * 		this.setTemplate( { tag: 'p' } );
  *
  * 		// Register the children.
  * 		this.registerChild( [ this.childA, this.childB ] );
  * 	}
  *
  * 	render() {
  * 		super.render();
  *
  * 		this.element.appendChild( this.childA.element );
  * 		this.element.appendChild( this.childB.element );
  * 	}
  * }
  *
  * const view = new SampleView( locale );
  *
  * view.render();
  *
  * // Will append <p><childA#element><b></b><childB#element></p>.
  * document.body.appendChild( view.element );
  * ```
  *
  * **Note**: There's no need to add child views if they're already referenced in the
  * {@link #template}:
  *
  * ```ts
  * class SampleView extends View {
  * 	constructor( locale ) {
  * 		super( locale );
  *
  * 		this.childA = new SomeChildView( locale );
  * 		this.childB = new SomeChildView( locale );
  *
  * 		this.setTemplate( {
  * 			tag: 'p',
  *
   * 			// These children will be added automatically. There's no
   * 			// need to call {@link #registerChild} for any of them.
  * 			children: [ this.childA, this.childB ]
  * 		} );
  * 	}
  *
  * 	// ...
  * }
  * ```
  *
  * @param children Children views to be registered.
  */
  registerChild(t) {
    Nn(t) || (t = [
      t
    ]);
    for (const i of t)
      this._unboundChildren.add(i);
  }
  /**
  * The opposite of {@link #registerChild}. Removes a child view from this view instance.
  * Once removed, the child is no longer managed by its parent, e.g. it can safely
  * become a child of another parent view.
  *
  * @see #registerChild
  * @param children Child views to be removed.
  */
  deregisterChild(t) {
    Nn(t) || (t = [
      t
    ]);
    for (const i of t)
      this._unboundChildren.remove(i);
  }
  /**
  * Sets the {@link #template} of the view with with given definition.
  *
  * A shorthand for:
  *
  * ```ts
  * view.setTemplate( definition );
  * ```
  *
  * @param definition Definition of view's template.
  */
  setTemplate(t) {
    this.template = new Ai(t);
  }
  /**
  * {@link module:ui/template~Template.extend Extends} the {@link #template} of the view with
  * with given definition.
  *
  * A shorthand for:
  *
  * ```ts
  * Template.extend( view.template, definition );
  * ```
  *
  * **Note**: Is requires the {@link #template} to be already set. See {@link #setTemplate}.
  *
  * @param definition Definition which extends the {@link #template}.
  */
  extendTemplate(t) {
    Ai.extend(this.template, t);
  }
  /**
  * Recursively renders the view.
  *
  * Once the view is rendered:
  * * the {@link #element} becomes an HTML element out of {@link #template},
  * * the {@link #isRendered} flag is set `true`.
  *
  * **Note**: The children of the view:
  * * defined directly in the {@link #template}
  * * residing in collections created by the {@link #createCollection} method,
  * * and added by {@link #registerChild}
  * are also rendered in the process.
  *
  * In general, `render()` method is the right place to keep the code which refers to the
  * {@link #element} and should be executed at the very beginning of the view's life cycle.
  *
  * It is possible to {@link module:ui/template~Template.extend} the {@link #template} before
  * the view is rendered. To allow an early customization of the view (e.g. by its parent),
  * such references should be done in `render()`.
  *
  * ```ts
  * class SampleView extends View {
  * 	constructor() {
  * 		this.setTemplate( {
  * 			// ...
  * 		} );
  * 	},
  *
  * 	render() {
  * 		// View#element becomes available.
  * 		super.render();
  *
  * 		// The "scroll" listener depends on #element.
  * 		this.listenTo( window, 'scroll', () => {
  * 			// A reference to #element would render the #template and make it non-extendable.
  * 			if ( window.scrollY > 0 ) {
  * 				this.element.scrollLeft = 100;
  * 			} else {
  * 				this.element.scrollLeft = 0;
  * 			}
  * 		} );
  * 	}
  * }
  *
  * const view = new SampleView();
  *
  * // Let's customize the view before it gets rendered.
  * view.extendTemplate( {
  * 	attributes: {
  * 		class: [
  * 			'additional-class'
  * 		]
  * 	}
  * } );
  *
  * // Late rendering allows customization of the view.
  * view.render();
  * ```
  */
  render() {
    if (this.isRendered)
      throw new v("ui-view-render-already-rendered", this);
    this.template && (this.element = this.template.render(), this.registerChild(this.template.getViews())), this.isRendered = !0;
  }
  /**
  * Recursively destroys the view instance and child views added by {@link #registerChild} and
  * residing in collections created by the {@link #createCollection}.
  *
  * Destruction disables all event listeners:
  * * created on the view, e.g. `view.on( 'event', () => {} )`,
  * * defined in the {@link #template} for DOM events.
  */
  destroy() {
    this.stopListening(), this._viewCollections.map((t) => t.destroy()), this.template && this.template._revertData && this.template.revert(this.element);
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function rc({ emitter: e, activator: n, callback: t, contextElements: i, listenerOptions: r }) {
  e.listenTo(document, "mousedown", (s, o) => {
    if (!n())
      return;
    const a = typeof o.composedPath == "function" ? o.composedPath() : [], u = typeof i == "function" ? i() : i;
    for (const l of u)
      if (l.contains(o.target) || a.includes(l))
        return;
    t();
  }, r);
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function C5(e) {
  class n extends e {
    disableCssTransitions() {
      this._isCssTransitionsDisabled = !0;
    }
    enableCssTransitions() {
      this._isCssTransitionsDisabled = !1;
    }
    constructor(...i) {
      super(...i), this.set("_isCssTransitionsDisabled", !1), this.initializeCssTransitionDisablerMixin();
    }
    initializeCssTransitionDisablerMixin() {
      this.extendTemplate({
        attributes: {
          class: [
            this.bindTemplate.if("_isCssTransitionsDisabled", "ck-transitions-disabled")
          ]
        }
      });
    }
  }
  return n;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function k5({ view: e }) {
  e.listenTo(e.element, "submit", (n, t) => {
    t.preventDefault(), e.fire("submit");
  }, {
    useCapture: !0
  });
}
const zl = class zl extends me {
  /**
  * @inheritDoc
  */
  constructor() {
    super();
    const n = this.bindTemplate;
    this.set("content", ""), this.set("viewBox", "0 0 20 20"), this.set("fillColor", ""), this.set("isColorInherited", !0), this.set("isVisible", !0), this.setTemplate({
      tag: "svg",
      ns: "http://www.w3.org/2000/svg",
      attributes: {
        class: [
          "ck",
          "ck-icon",
          n.if("isVisible", "ck-hidden", (t) => !t),
          // Exclude icon internals from the CSS reset to allow rich (non-monochromatic) icons
          // (https://github.com/ckeditor/ckeditor5/issues/12599).
          "ck-reset_all-excluded",
          // The class to remove the dynamic color inheritance is toggleable
          // (https://github.com/ckeditor/ckeditor5/issues/12599).
          n.if("isColorInherited", "ck-icon_inherit-color")
        ],
        viewBox: n.to("viewBox"),
        "aria-hidden": !0
      }
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this._updateXMLContent(), this._colorFillPaths(), this.on("change:content", () => {
      this._updateXMLContent(), this._colorFillPaths();
    }), this.on("change:fillColor", () => {
      this._colorFillPaths();
    });
  }
  /**
  * Updates the {@link #element} with the value of {@link #content}.
  */
  _updateXMLContent() {
    if (this.content) {
      const t = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml").querySelector("svg"), i = t.getAttribute("viewBox");
      i && (this.viewBox = i);
      for (const { name: r, value: s } of Array.from(t.attributes))
        zl.presentationalAttributeNames.includes(r) && this.element.setAttribute(r, s);
      for (; this.element.firstChild; )
        this.element.removeChild(this.element.firstChild);
      for (; t.childNodes.length > 0; )
        this.element.appendChild(t.childNodes[0]);
    }
  }
  /**
  * Fills all child `path.ck-icon__fill` with the `#fillColor`.
  */
  _colorFillPaths() {
    this.fillColor && this.element.querySelectorAll(".ck-icon__fill").forEach((n) => {
      n.style.fill = this.fillColor;
    });
  }
};
/**
* A list of presentational attributes that can be set on the `<svg>` element and should be preserved
* when the icon {@link module:ui/icon/iconview~IconView#content content} is loaded.
*
* See the [specification](https://www.w3.org/TR/SVG/styling.html#TermPresentationAttribute) to learn more.
*/
m(zl, "presentationalAttributeNames", [
  "alignment-baseline",
  "baseline-shift",
  "clip-path",
  "clip-rule",
  "color",
  "color-interpolation",
  "color-interpolation-filters",
  "color-rendering",
  "cursor",
  "direction",
  "display",
  "dominant-baseline",
  "fill",
  "fill-opacity",
  "fill-rule",
  "filter",
  "flood-color",
  "flood-opacity",
  "font-family",
  "font-size",
  "font-size-adjust",
  "font-stretch",
  "font-style",
  "font-variant",
  "font-weight",
  "image-rendering",
  "letter-spacing",
  "lighting-color",
  "marker-end",
  "marker-mid",
  "marker-start",
  "mask",
  "opacity",
  "overflow",
  "paint-order",
  "pointer-events",
  "shape-rendering",
  "stop-color",
  "stop-opacity",
  "stroke",
  "stroke-dasharray",
  "stroke-dashoffset",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",
  "text-anchor",
  "text-decoration",
  "text-overflow",
  "text-rendering",
  "transform",
  "unicode-bidi",
  "vector-effect",
  "visibility",
  "white-space",
  "word-spacing",
  "writing-mode"
]);
let yr = zl;
class zT extends me {
  /**
  * @inheritDoc
  */
  constructor() {
    super(), this.set({
      style: void 0,
      text: void 0,
      id: void 0
    });
    const n = this.bindTemplate;
    this.setTemplate({
      tag: "span",
      attributes: {
        class: [
          "ck",
          "ck-button__label"
        ],
        style: n.to("style"),
        id: n.to("id")
      },
      children: [
        {
          text: n.to("text")
        }
      ]
    });
  }
}
class gt extends me {
  /**
  * Creates an instance of the button view class.
  *
  * @param locale The {@link module:core/editor/editor~Editor#locale} instance.
  * @param labelView The instance of the button's label. If not provided, an instance of
  * {@link module:ui/button/buttonlabelview~ButtonLabelView} is used.
  */
  constructor(t, i = new zT()) {
    super(t);
    /**
    * Collection of the child views inside of the button {@link #element}.
    */
    m(this, "children");
    /**
    * Label of the button view. Its text is configurable using the {@link #label label attribute}.
    *
    * If not configured otherwise in the `constructor()`, by default the label is an instance
    * of {@link module:ui/button/buttonlabelview~ButtonLabelView}.
    */
    m(this, "labelView");
    /**
    * The icon view of the button. Will be added to {@link #children} when the
    * {@link #icon icon attribute} is defined.
    */
    m(this, "iconView");
    /**
    * A view displaying the keystroke of the button next to the {@link #labelView label}.
    * Added to {@link #children} when the {@link #withKeystroke `withKeystroke` attribute}
    * is defined.
    */
    m(this, "keystrokeView");
    /**
    * Delayed focus function for focus handling in Safari.
    */
    m(this, "_focusDelayed", null);
    const r = this.bindTemplate, s = un();
    this.set("_ariaPressed", !1), this.set("_ariaChecked", !1), this.set("ariaLabel", void 0), this.set("ariaLabelledBy", `ck-editor__aria-label_${s}`), this.set("class", void 0), this.set("labelStyle", void 0), this.set("icon", void 0), this.set("isEnabled", !0), this.set("isOn", !1), this.set("isVisible", !0), this.set("isToggleable", !1), this.set("keystroke", void 0), this.set("label", void 0), this.set("role", void 0), this.set("tabindex", -1), this.set("tooltip", !1), this.set("tooltipPosition", "s"), this.set("type", "button"), this.set("withText", !1), this.set("withKeystroke", !1), this.children = this.createCollection(), this.labelView = this._setupLabelView(i), this.iconView = new yr(), this.iconView.extendTemplate({
      attributes: {
        class: "ck-button__icon"
      }
    }), this.keystrokeView = this._createKeystrokeView(), this.bind("_tooltipString").to(this, "tooltip", this, "label", this, "keystroke", this._getTooltipString.bind(this));
    const o = {
      tag: "button",
      attributes: {
        class: [
          "ck",
          "ck-button",
          r.to("class"),
          r.if("isEnabled", "ck-disabled", (a) => !a),
          r.if("isVisible", "ck-hidden", (a) => !a),
          r.to("isOn", (a) => a ? "ck-on" : "ck-off"),
          r.if("withText", "ck-button_with-text"),
          r.if("withKeystroke", "ck-button_with-keystroke")
        ],
        role: r.to("role"),
        type: r.to("type", (a) => a || "button"),
        tabindex: r.to("tabindex"),
        "aria-checked": r.to("_ariaChecked"),
        "aria-pressed": r.to("_ariaPressed"),
        "aria-label": r.to("ariaLabel"),
        "aria-labelledby": r.to("ariaLabelledBy"),
        "aria-disabled": r.if("isEnabled", !0, (a) => !a),
        "data-cke-tooltip-text": r.to("_tooltipString"),
        "data-cke-tooltip-position": r.to("tooltipPosition")
      },
      children: this.children,
      on: {
        click: r.to((a) => {
          this.isEnabled ? this.fire("execute") : a.preventDefault();
        })
      }
    };
    this.bind("_ariaPressed").to(this, "isOn", this, "isToggleable", this, "role", (a, u, l) => !u || og(l) ? !1 : String(!!a)), this.bind("_ariaChecked").to(this, "isOn", this, "isToggleable", this, "role", (a, u, l) => !u || !og(l) ? !1 : String(!!a)), he.isSafari && (this._focusDelayed || (this._focusDelayed = Wf(() => this.focus(), 0)), o.on.mousedown = r.to(() => {
      this._focusDelayed();
    }), o.on.mouseup = r.to(() => {
      this._focusDelayed.cancel();
    })), this.setTemplate(o);
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.icon && (this.iconView.bind("content").to(this, "icon"), this.children.add(this.iconView)), this.children.add(this.labelView), this.withKeystroke && this.keystroke && this.children.add(this.keystrokeView);
  }
  /**
  * Focuses the {@link #element} of the button.
  */
  focus() {
    this.element.focus();
  }
  /**
  * @inheritDoc
  */
  destroy() {
    this._focusDelayed && this._focusDelayed.cancel(), super.destroy();
  }
  /**
  * Binds the label view instance it with button attributes.
  */
  _setupLabelView(t) {
    return t.bind("text", "style", "id").to(this, "label", "labelStyle", "ariaLabelledBy"), t;
  }
  /**
  * Creates a view that displays a keystroke next to a {@link #labelView label }
  * and binds it with button attributes.
  */
  _createKeystrokeView() {
    const t = new me();
    return t.setTemplate({
      tag: "span",
      attributes: {
        class: [
          "ck",
          "ck-button__keystroke"
        ]
      },
      children: [
        {
          text: this.bindTemplate.to("keystroke", (i) => bl(i))
        }
      ]
    }), t;
  }
  /**
  * Gets the text for the tooltip from the combination of
  * {@link #tooltip}, {@link #label} and {@link #keystroke} attributes.
  *
  * @see #tooltip
  * @see #_tooltipString
  * @param tooltip Button tooltip.
  * @param label Button label.
  * @param keystroke Button keystroke.
  */
  _getTooltipString(t, i, r) {
    return t ? typeof t == "string" ? t : (r && (r = bl(r)), t instanceof Function ? t(i, r) : `${i}${r ? ` (${r})` : ""}`) : "";
  }
}
function og(e) {
  switch (e) {
    case "radio":
    case "checkbox":
    case "option":
    case "switch":
    case "menuitemcheckbox":
    case "menuitemradio":
      return !0;
    default:
      return !1;
  }
}
class S5 extends me {
  /**
  * Creates an instance of the form header class.
  *
  * @param locale The locale instance.
  * @param options.label A label.
  * @param options.class An additional class.
  */
  constructor(t, i = {}) {
    super(t);
    /**
    * A collection of header items.
    */
    m(this, "children");
    /**
    * The icon view instance. Defined only if icon was passed in the constructor's options.
    */
    m(this, "iconView");
    const r = this.bindTemplate;
    this.set("label", i.label || ""), this.set("class", i.class || null), this.children = this.createCollection(), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-form__header",
          r.to("class")
        ]
      },
      children: this.children
    }), i.icon && (this.iconView = new yr(), this.iconView.content = i.icon, this.children.add(this.iconView));
    const s = new me(t);
    s.setTemplate({
      tag: "h2",
      attributes: {
        class: [
          "ck",
          "ck-form__header__label"
        ],
        role: "presentation"
      },
      children: [
        {
          text: r.to("label")
        }
      ]
    }), this.children.add(s);
  }
}
class hs extends (/* @__PURE__ */ Je()) {
  /**
  * Creates an instance of the focus cycler utility.
  *
  * @param options Configuration options.
  */
  constructor(t) {
    super();
    /**
    * A {@link module:ui/focuscycler~FocusableView focusable views} collection that the cycler operates on.
    */
    m(this, "focusables");
    /**
    * A focus tracker instance that the cycler uses to determine the current focus
    * state in {@link #focusables}.
    */
    m(this, "focusTracker");
    /**
    * An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}
    * which can respond to certain keystrokes and cycle the focus.
    */
    m(this, "keystrokeHandler");
    /**
    * Actions that the cycler can take when a keystroke is pressed. Requires
    * `options.keystrokeHandler` to be passed and working. When an action is
    * performed, `preventDefault` and `stopPropagation` will be called on the event
    * the keystroke fired in the DOM.
    *
    * ```ts
    * actions: {
    * 	// Will call #focusPrevious() when arrowleft or arrowup is pressed.
    * 	focusPrevious: [ 'arrowleft', 'arrowup' ],
    *
    * 	// Will call #focusNext() when arrowdown is pressed.
    * 	focusNext: 'arrowdown'
    * }
    * ```
    */
    m(this, "actions");
    if (this.focusables = t.focusables, this.focusTracker = t.focusTracker, this.keystrokeHandler = t.keystrokeHandler, this.actions = t.actions, t.actions && t.keystrokeHandler)
      for (const i in t.actions) {
        let r = t.actions[i];
        typeof r == "string" && (r = [
          r
        ]);
        for (const s of r)
          t.keystrokeHandler.set(s, (o, a) => {
            this[i](), a();
          }, t.keystrokeHandlerOptions);
      }
    this.on("forwardCycle", () => this.focusFirst(), {
      priority: "low"
    }), this.on("backwardCycle", () => this.focusLast(), {
      priority: "low"
    });
  }
  /**
  * Returns the first focusable view in {@link #focusables}.
  * Returns `null` if there is none.
  *
  * **Note**: Hidden views (e.g. with `display: none`) are ignored.
  */
  get first() {
    return this.focusables.find(gd) || null;
  }
  /**
  * Returns the last focusable view in {@link #focusables}.
  * Returns `null` if there is none.
  *
  * **Note**: Hidden views (e.g. with `display: none`) are ignored.
  */
  get last() {
    return this.focusables.filter(gd).slice(-1)[0] || null;
  }
  /**
  * Returns the next focusable view in {@link #focusables} based on {@link #current}.
  * Returns `null` if there is none.
  *
  * **Note**: Hidden views (e.g. with `display: none`) are ignored.
  */
  get next() {
    return this._getDomFocusableItem(1);
  }
  /**
  * Returns the previous focusable view in {@link #focusables} based on {@link #current}.
  * Returns `null` if there is none.
  *
  * **Note**: Hidden views (e.g. with `display: none`) are ignored.
  */
  get previous() {
    return this._getDomFocusableItem(-1);
  }
  /**
  * An index of the view in the {@link #focusables} which is focused according
  * to {@link #focusTracker}. Returns `null` when there is no such view.
  */
  get current() {
    let t = null;
    return this.focusTracker.focusedElement === null ? null : (this.focusables.find((i, r) => {
      const s = i.element === this.focusTracker.focusedElement;
      return s && (t = r), s;
    }), t);
  }
  /**
  * Focuses the {@link #first} item in {@link #focusables}.
  *
  * **Note**: Hidden views (e.g. with `display: none`) are ignored.
  */
  focusFirst() {
    this._focus(this.first, 1);
  }
  /**
  * Focuses the {@link #last} item in {@link #focusables}.
  *
  * **Note**: Hidden views (e.g. with `display: none`) are ignored.
  */
  focusLast() {
    this._focus(this.last, -1);
  }
  /**
  * Focuses the {@link #next} item in {@link #focusables}.
  *
  * **Note**: Hidden views (e.g. with `display: none`) are ignored.
  */
  focusNext() {
    const t = this.next;
    if (t && this.focusables.getIndex(t) === this.current) {
      this.fire("forwardCycle");
      return;
    }
    t === this.first ? this.fire("forwardCycle") : this._focus(t, 1);
  }
  /**
  * Focuses the {@link #previous} item in {@link #focusables}.
  *
  * **Note**: Hidden views (e.g. with `display: none`) are ignored.
  */
  focusPrevious() {
    const t = this.previous;
    if (t && this.focusables.getIndex(t) === this.current) {
      this.fire("backwardCycle");
      return;
    }
    t === this.last ? this.fire("backwardCycle") : this._focus(t, -1);
  }
  /**
  * Allows for creating continuous focus cycling across multiple focus cyclers and their collections of {@link #focusables}.
  *
  * It starts listening to the {@link module:ui/focuscycler~FocusCyclerForwardCycleEvent} and
  * {@link module:ui/focuscycler~FocusCyclerBackwardCycleEvent} events of the chained focus cycler and engages,
  * whenever the user reaches the last (forwards navigation) or first (backwards navigation) focusable view
  * and would normally start over. Instead, the navigation continues on the higher level (flattens).
  *
  * For instance, for the following nested focus navigation structure, the focus would get stuck the moment
  * the AB gets focused and its focus cycler starts managing it:
  *
  *	   ┌────────────┐   ┌──────────────────────────────────┐   ┌────────────┐
  *	   │ AA         │   │ AB                               │   │ AC         │
  *	   │            │   │                                  │   │            │
  *	   │            │   │    ┌─────┐  ┌─────┐  ┌─────┐     │   │            │
  *	   │            │   │ ┌──► ABA ├──► ABB ├──► ABC ├───┐ │   │            │
  *	   │            ├───► │  └─────┘  └─────┘  └─────┘   │ │   │            │
  *	   │            │   │ │                              │ │   │            │
  *	   │            │   │ │                              │ │   │            │
  *	   │            │   │ └──────────────────────────────┘ │   │            │
  *	   │            │   │                                  │   │            │
  *	   └────────────┘   └──────────────────────────────────┘   └────────────┘
  *
  * Chaining a focus tracker that manages AA, AB, and AC with the focus tracker that manages ABA, ABB, and ABC
  * creates a seamless navigation experience instead:
  *
  *	   ┌────────────┐   ┌──────────────────────────────────┐   ┌────────────┐
  *	   │ AA         │   │ AB                               │   │ AC         │
  *	   │            │   │                                  │   │            │
  *	   │            │   │    ┌─────┐  ┌─────┐  ┌─────┐     │   │            │
  *	   │            │   │ ┌──► ABA ├──► ABB ├──► ABC ├──┐  │   │            │
  *	┌──►            ├───┼─┘  └─────┘  └─────┘  └─────┘  └──┼───►            ├──┐
  *	│  │            │   │                                  │   │            │  │
  *	│  │            │   │                                  │   │            │  │
  *	│  │            │   │                                  │   │            │  │
  *	│  │            │   │                                  │   │            │  │
  *	│  └────────────┘   └──────────────────────────────────┘   └────────────┘  │
  *	│                                                                          │
  *	│                                                                          │
  *	└──────────────────────────────────────────────────────────────────────────┘
  *
  * See {@link #unchain} to reverse the chaining.
  */
  chain(t) {
    const i = () => this.current === null ? null : this.focusables.get(this.current);
    this.listenTo(t, "forwardCycle", (r) => {
      const s = i();
      this.focusNext(), s !== i() && r.stop();
    }, {
      priority: "low"
    }), this.listenTo(t, "backwardCycle", (r) => {
      const s = i();
      this.focusPrevious(), s !== i() && r.stop();
    }, {
      priority: "low"
    });
  }
  /**
  * Reverses a chaining made by {@link #chain}.
  */
  unchain(t) {
    this.stopListening(t);
  }
  /**
  * Focuses the given view if it exists.
  *
  * @param view The view to be focused
  * @param direction The direction of the focus if the view has focusable children.
  * @returns
  */
  _focus(t, i) {
    t && this.focusTracker.focusedElement !== t.element && t.focus(i);
  }
  /**
  * Returns the next or previous focusable view in {@link #focusables} with respect
  * to {@link #current}.
  *
  * @param step Either `1` for checking forward from {@link #current} or `-1` for checking backwards.
  */
  _getDomFocusableItem(t) {
    const i = this.focusables.length;
    if (!i)
      return null;
    const r = this.current;
    if (r === null)
      return this[t === 1 ? "first" : "last"];
    let s = this.focusables.get(r), o = (r + i + t) % i;
    do {
      const a = this.focusables.get(o);
      if (gd(a)) {
        s = a;
        break;
      }
      o = (o + i + t) % i;
    } while (o !== r);
    return s;
  }
}
function gd(e) {
  return ru(e) && zi(e.element);
}
function ru(e) {
  return "focus" in e && typeof e.focus == "function";
}
function I5(e) {
  return ru(e) && "focusCycler" in e && e.focusCycler instanceof hs;
}
function x5(e) {
  class n extends e {
    /**
    * @inheritDoc
    */
    constructor(...r) {
      super(...r);
      /**
      * A bound version of {@link #_onDrag}.
      */
      m(this, "_onDragBound", this._onDrag.bind(this));
      /**
      * A bound version of {@link #_onDragEnd}.
      */
      m(this, "_onDragEndBound", this._onDragEnd.bind(this));
      /**
      * The last coordinates of the view. It is updated on every mouse move.
      */
      m(this, "_lastDraggingCoordinates", {
        x: 0,
        y: 0
      });
      this.on("render", () => {
        this._attachListeners();
      }), this.set("isDragging", !1);
    }
    /**
    * Attaches the listeners for the drag start.
    */
    _attachListeners() {
      this.listenTo(this.element, "mousedown", this._onDragStart.bind(this)), this.listenTo(this.element, "touchstart", this._onDragStart.bind(this));
    }
    /**
    * Attaches the listeners for the dragging and drag end.
    */
    _attachDragListeners() {
      this.listenTo(ue.document, "mouseup", this._onDragEndBound), this.listenTo(ue.document, "touchend", this._onDragEndBound), this.listenTo(ue.document, "mousemove", this._onDragBound), this.listenTo(ue.document, "touchmove", this._onDragBound);
    }
    /**
    * Detaches the listeners after the drag end.
    */
    _detachDragListeners() {
      this.stopListening(ue.document, "mouseup", this._onDragEndBound), this.stopListening(ue.document, "touchend", this._onDragEndBound), this.stopListening(ue.document, "mousemove", this._onDragBound), this.stopListening(ue.document, "touchmove", this._onDragBound);
    }
    /**
    * Starts the dragging listeners and sets the initial view coordinates.
    */
    _onDragStart(r, s) {
      if (!this._isHandleElementPressed(s))
        return;
      this._attachDragListeners();
      let o = 0, a = 0;
      s instanceof MouseEvent ? (o = s.clientX, a = s.clientY) : (o = s.touches[0].clientX, a = s.touches[0].clientY), this._lastDraggingCoordinates = {
        x: o,
        y: a
      }, this.isDragging = !0;
    }
    /**
    * Updates the view coordinates and fires the `drag` event.
    */
    _onDrag(r, s) {
      if (!this.isDragging) {
        this._detachDragListeners();
        return;
      }
      let o = 0, a = 0;
      s instanceof MouseEvent ? (o = s.clientX, a = s.clientY) : (o = s.touches[0].clientX, a = s.touches[0].clientY), s.preventDefault(), this.fire("drag", {
        deltaX: Math.round(o - this._lastDraggingCoordinates.x),
        deltaY: Math.round(a - this._lastDraggingCoordinates.y)
      }), this._lastDraggingCoordinates = {
        x: o,
        y: a
      };
    }
    /**
    * Stops the dragging and detaches the listeners.
    */
    _onDragEnd() {
      this._detachDragListeners(), this.isDragging = !1;
    }
    /**
    * Checks if the drag handle element was pressed.
    */
    _isHandleElementPressed(r) {
      return this.dragHandleElement ? this.dragHandleElement === r.target || r.target instanceof HTMLElement && this.dragHandleElement.contains(r.target) : !1;
    }
  }
  return n;
}
class v5 extends me {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * A collection of button views.
    */
    m(this, "children");
    /**
    * A keystroke handler instance.
    */
    m(this, "keystrokes");
    /**
    * A focus cycler instance.
    */
    m(this, "focusCycler");
    /**
    * A focus tracker instance.
    */
    m(this, "_focusTracker");
    /**
    * A collection of focusable views.
    */
    m(this, "_focusables");
    this.children = this.createCollection(), this.keystrokes = new Ii(), this._focusTracker = new Ln(), this._focusables = new Ji(), this.focusCycler = new hs({
      focusables: this._focusables,
      focusTracker: this._focusTracker,
      keystrokeHandler: this.keystrokes,
      actions: {
        // Navigate form fields backwards using the Shift + Tab keystroke.
        focusPrevious: "shift + tab",
        // Navigate form fields forwards using the Tab key.
        focusNext: "tab"
      }
    }), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-dialog__actions"
        ]
      },
      children: this.children
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.keystrokes.listenTo(this.element);
  }
  /**
  * Creates the button views based on the given definitions.
  * Then adds them to the {@link #children} collection and to the focus cycler.
  */
  setButtons(t) {
    for (const i of t) {
      const r = new gt(this.locale);
      let s;
      r.on("execute", () => i.onExecute()), i.onCreate && i.onCreate(r);
      for (s in i)
        s != "onExecute" && s != "onCreate" && r.set(s, i[s]);
      this.children.add(r);
    }
    this._updateFocusCyclableItems();
  }
  /**
  * @inheritDoc
  */
  focus(t) {
    t === -1 ? this.focusCycler.focusLast() : this.focusCycler.focusFirst();
  }
  /**
  * Adds all elements from the {@link #children} collection to the {@link #_focusables} collection
  * and to the {@link #_focusTracker} instance.
  */
  _updateFocusCyclableItems() {
    Array.from(this.children).forEach((t) => {
      this._focusables.add(t), this._focusTracker.add(t.element);
    });
  }
}
class P5 extends me {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * A collection of content items.
    */
    m(this, "children");
    this.children = this.createCollection(), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-dialog__content"
        ]
      },
      children: this.children
    });
  }
  /**
  * Removes all the child views.
  */
  reset() {
    for (; this.children.length; )
      this.children.remove(0);
  }
}
const Xn = {
  SCREEN_CENTER: "screen-center",
  EDITOR_CENTER: "editor-center",
  EDITOR_TOP_SIDE: "editor-top-side",
  EDITOR_TOP_CENTER: "editor-top-center",
  EDITOR_BOTTOM_CENTER: "editor-bottom-center",
  EDITOR_ABOVE_CENTER: "editor-above-center",
  EDITOR_BELOW_CENTER: "editor-below-center"
}, ag = /* @__PURE__ */ nu("px"), ql = class ql extends (/* @__PURE__ */ x5(me)) {
  /**
  * @inheritDoc
  */
  constructor(t, { getCurrentDomRoot: i, getViewportOffset: r, keystrokeHandlerOptions: s }) {
    super(t);
    /**
    * A collection of the child views inside of the dialog.
    * A dialog can have 3 optional parts: header, content, and actions.
    */
    m(this, "parts");
    /**
    * A header view of the dialog. It is also a drag handle of the dialog.
    */
    m(this, "headerView");
    /**
    * A close button view. It is automatically added to the header view if present.
    */
    m(this, "closeButtonView");
    /**
    * A view with the action buttons available to the user.
    */
    m(this, "actionsView");
    /**
    * A view with the dialog content.
    */
    m(this, "contentView");
    /**
    * A keystroke handler instance.
    */
    m(this, "keystrokes");
    /**
    * A focus tracker instance.
    */
    m(this, "focusTracker");
    /**
    * A flag indicating if the dialog was moved manually. If so, its position
    * will not be updated automatically upon window resize or document scroll.
    */
    m(this, "wasMoved", !1);
    /**
    * A callback returning the DOM root that requested the dialog.
    */
    m(this, "_getCurrentDomRoot");
    /**
    * A callback returning the configured editor viewport offset.
    */
    m(this, "_getViewportOffset");
    /**
    * The list of the focusable elements inside the dialog view.
    */
    m(this, "_focusables");
    /**
    * The focus cycler instance.
    */
    m(this, "_focusCycler");
    const o = this.bindTemplate, a = t.t;
    this.set("className", ""), this.set("ariaLabel", a("Editor dialog")), this.set("isModal", !1), this.set("position", Xn.SCREEN_CENTER), this.set("_isVisible", !1), this.set("_isTransparent", !1), this.set("_top", 0), this.set("_left", 0), this._getCurrentDomRoot = i, this._getViewportOffset = r, this.decorate("moveTo"), this.parts = this.createCollection(), this.keystrokes = new Ii(), this.focusTracker = new Ln(), this._focusables = new Ji(), this._focusCycler = new hs({
      focusables: this._focusables,
      focusTracker: this.focusTracker,
      keystrokeHandler: this.keystrokes,
      actions: {
        // Navigate form fields backwards using the Shift + Tab keystroke.
        focusPrevious: "shift + tab",
        // Navigate form fields forwards using the Tab key.
        focusNext: "tab"
      },
      keystrokeHandlerOptions: s
    }), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-dialog-overlay",
          o.if("isModal", "ck-dialog-overlay__transparent", (u) => !u),
          o.if("_isVisible", "ck-hidden", (u) => !u)
        ],
        // Prevent from editor losing focus when clicking on the modal overlay.
        tabindex: "-1"
      },
      children: [
        {
          tag: "div",
          attributes: {
            tabindex: "-1",
            class: [
              "ck",
              "ck-dialog",
              o.if("isModal", "ck-dialog_modal"),
              o.to("className")
            ],
            role: "dialog",
            "aria-label": o.to("ariaLabel"),
            style: {
              top: o.to("_top", (u) => ag(u)),
              left: o.to("_left", (u) => ag(u)),
              visibility: o.if("_isTransparent", "hidden")
            }
          },
          children: this.parts
        }
      ]
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.keystrokes.set("Esc", (t, i) => {
      t.defaultPrevented || (this.fire("close", {
        source: "escKeyPress"
      }), i());
    }), this.on("drag", (t, { deltaX: i, deltaY: r }) => {
      this.wasMoved = !0, this.moveBy(i, r);
    }), this.listenTo(ue.window, "resize", () => {
      this._isVisible && !this.wasMoved && this.updatePosition();
    }), this.listenTo(ue.document, "scroll", () => {
      this._isVisible && !this.wasMoved && this.updatePosition();
    }), this.on("change:_isVisible", (t, i, r) => {
      r && (this._isTransparent = !0, setTimeout(() => {
        this.updatePosition(), this._isTransparent = !1, this.focus();
      }, 10));
    }), this.keystrokes.listenTo(this.element);
  }
  /**
  * Returns the element that should be used as a drag handle.
  */
  get dragHandleElement() {
    return this.headerView && !this.isModal ? this.headerView.element : null;
  }
  /**
  * Creates the dialog parts. Which of them are created depends on the arguments passed to the method.
  * There are no rules regarding the dialog construction, that is, no part is mandatory.
  * Each part can only be created once.
  *
  * @internal
  */
  setupParts({ icon: t, title: i, hasCloseButton: r = !0, content: s, actionButtons: o }) {
    i && (this.headerView = new S5(this.locale, {
      icon: t
    }), r && (this.closeButtonView = this._createCloseButton(), this.headerView.children.add(this.closeButtonView)), this.headerView.label = i, this.ariaLabel = i, this.parts.add(this.headerView, 0)), s && (s instanceof me && (s = [
      s
    ]), this.contentView = new P5(this.locale), this.contentView.children.addMany(s), this.parts.add(this.contentView)), o && (this.actionsView = new v5(this.locale), this.actionsView.setButtons(o), this.parts.add(this.actionsView)), this._updateFocusCyclableItems();
  }
  /**
  * Focuses the first focusable element inside the dialog.
  */
  focus() {
    this._focusCycler.focusFirst();
  }
  /**
  * Normalizes the passed coordinates to make sure the dialog view
  * is displayed within the visible viewport and moves it there.
  *
  * @internal
  */
  moveTo(t, i) {
    const r = this._getViewportRect(), s = this._getDialogRect();
    t + s.width > r.right && (t = r.right - s.width), t < r.left && (t = r.left), i < r.top && (i = r.top), this._moveTo(t, i);
  }
  /**
  * Moves the dialog to the specified coordinates.
  */
  _moveTo(t, i) {
    this._left = t, this._top = i;
  }
  /**
  * Moves the dialog by the specified offset.
  *
  * @internal
  */
  moveBy(t, i) {
    this.moveTo(this._left + t, this._top + i);
  }
  /**
  * Moves the dialog view to the off-screen position.
  * Used when there is no space to display the dialog.
  */
  _moveOffScreen() {
    this._moveTo(-9999, -9999);
  }
  /**
  * Recalculates the dialog according to the set position and viewport,
  * and moves it to the new position.
  */
  updatePosition() {
    if (!this.element || !this.element.parentNode)
      return;
    const t = this._getViewportRect();
    let i = this.position, r;
    this._getCurrentDomRoot() ? r = this._getVisibleDomRootRect(t) : i = Xn.SCREEN_CENTER;
    const s = ql.defaultOffset, o = this._getDialogRect();
    switch (i) {
      case Xn.EDITOR_TOP_SIDE: {
        if (r) {
          const a = this.locale.contentLanguageDirection === "ltr" ? r.right - o.width - s : r.left + s;
          this.moveTo(a, r.top + s);
        } else
          this._moveOffScreen();
        break;
      }
      case Xn.EDITOR_CENTER: {
        r ? this.moveTo(Math.round(r.left + r.width / 2 - o.width / 2), Math.round(r.top + r.height / 2 - o.height / 2)) : this._moveOffScreen();
        break;
      }
      case Xn.SCREEN_CENTER: {
        this.moveTo(Math.round((t.width - o.width) / 2), Math.round((t.height - o.height) / 2));
        break;
      }
      case Xn.EDITOR_TOP_CENTER: {
        r ? this.moveTo(Math.round(r.left + r.width / 2 - o.width / 2), r.top + s) : this._moveOffScreen();
        break;
      }
      case Xn.EDITOR_BOTTOM_CENTER: {
        r ? this.moveTo(Math.round(r.left + r.width / 2 - o.width / 2), r.bottom - o.height - s) : this._moveOffScreen();
        break;
      }
      case Xn.EDITOR_ABOVE_CENTER: {
        r ? this.moveTo(Math.round(r.left + r.width / 2 - o.width / 2), r.top - o.height - s) : this._moveOffScreen();
        break;
      }
      case Xn.EDITOR_BELOW_CENTER: {
        r ? this.moveTo(Math.round(r.left + r.width / 2 - o.width / 2), r.bottom + s) : this._moveOffScreen();
        break;
      }
    }
  }
  /**
  * Calculates the visible DOM root part.
  */
  _getVisibleDomRootRect(t) {
    let i = new Se(this._getCurrentDomRoot()).getVisible();
    if (i) {
      if (i = t.getIntersection(i), !i)
        return null;
    } else
      return null;
    return i;
  }
  /**
  * Calculates the dialog element rect.
  */
  _getDialogRect() {
    return new Se(this.element.firstElementChild);
  }
  /**
  * Returns a viewport `Rect` shrunk by the viewport offset config from all sides.
  *
  * TODO: This is a duplicate from position.ts module. It should either be exported there or land somewhere in utils.
  */
  _getViewportRect() {
    const t = new Se(ue.window);
    if (this.isModal)
      return t;
    const i = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      ...this._getViewportOffset()
    };
    return t.top += i.top, t.height -= i.top, t.bottom -= i.bottom, t.height -= i.bottom, t.left += i.left, t.right -= i.right, t.width -= i.left + i.right, t;
  }
  /**
  * Collects all focusable elements inside the dialog parts
  * and adds them to the focus tracker and focus cycler.
  */
  _updateFocusCyclableItems() {
    const t = [];
    if (this.contentView)
      for (const i of this.contentView.children)
        ru(i) && t.push(i);
    this.actionsView && t.push(this.actionsView), this.closeButtonView && t.push(this.closeButtonView), t.forEach((i) => {
      this._focusables.add(i), this.focusTracker.add(i.element), I5(i) && this._focusCycler.chain(i.focusCycler);
    });
  }
  /**
  * Creates the close button view that is displayed in the header view corner.
  */
  _createCloseButton() {
    const t = new gt(this.locale), i = this.locale.t;
    return t.set({
      label: i("Close"),
      tooltip: !0,
      icon: Ge.cancel
    }), t.on("execute", () => this.fire("close", {
      source: "closeButton"
    })), t;
  }
};
/**
* A default dialog element offset from the reference element (e.g. editor editable area).
*/
m(ql, "defaultOffset", 15);
let Ha = ql;
const Jn = class Jn extends ce {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * The currently visible dialog view instance.
    */
    m(this, "view");
    /**
    * A configurable callback called when the dialog is hidden.
    */
    m(this, "_onHide");
    const i = t.t;
    this._initShowHideListeners(), this._initFocusToggler(), this._initMultiRootIntegration(), this.set({
      id: null,
      isOpen: !1
    }), t.accessibility.addKeystrokeInfos({
      categoryId: "navigation",
      keystrokes: [
        {
          label: i("Move focus in and out of an active dialog window"),
          keystroke: "Ctrl+F6",
          mayRequireFn: !0
        }
      ]
    });
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Dialog";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy(), Jn._visibleDialogPlugin === this && this._unlockBodyScroll();
  }
  /**
  * Initiates listeners for the `show` and `hide` events emitted by this plugin.
  *
  * We could not simply decorate the {@link #show} and {@link #hide} methods to fire events,
  * because they would be fired in the wrong order &ndash; first would be `show` and then `hide`
  * (because showing the dialog actually starts with hiding the previously visible one).
  * Hence, we added private methods {@link #_show} and {@link #_hide} which are called on events
  * in the desired sequence.
  */
  _initShowHideListeners() {
    this.on("show", (t, i) => {
      this._show(i);
    }), this.on("show", (t, i) => {
      i.onShow && i.onShow(this);
    }, {
      priority: "low"
    }), this.on("hide", () => {
      Jn._visibleDialogPlugin && Jn._visibleDialogPlugin._hide();
    }), this.on("hide", () => {
      this._onHide && (this._onHide(this), this._onHide = void 0);
    }, {
      priority: "low"
    });
  }
  /**
  * Initiates keystroke handler for toggling the focus between the editor and the dialog view.
  */
  _initFocusToggler() {
    const t = this.editor;
    t.keystrokes.set("Ctrl+F6", (i, r) => {
      !this.isOpen || this.view.isModal || (this.view.focusTracker.isFocused ? t.editing.view.focus() : this.view.focus(), r());
    });
  }
  /**
  * Provides an integration between the root attaching and detaching and positioning of the view.
  */
  _initMultiRootIntegration() {
    const t = this.editor.model;
    t.document.on("change:data", () => {
      if (!this.view)
        return;
      const i = t.document.differ.getChangedRoots();
      for (const r of i)
        r.state && this.view.updatePosition();
    });
  }
  /**
  * Displays a dialog window.
  *
  * This method requires a {@link ~DialogDefinition} that defines the dialog's content, title, icon, action buttons, etc.
  *
  * For example, the following definition will create a dialog with:
  * * A header consisting of an icon, a title, and a "Close" button (it is added by default).
  * * A content consisting of a view with a single paragraph.
  * * A footer consisting of two buttons: "Yes" and "No".
  *
  * ```js
  * // Create the view that will be used as the dialog's content.
  * const textView = new View( locale );
  *
  * textView.setTemplate( {
  * 	tag: 'div',
  * 	attributes: {
  * 		style: {
  * 			padding: 'var(--ck-spacing-large)',
  * 			whiteSpace: 'initial',
  * 			width: '100%',
  * 			maxWidth: '500px'
  * 		},
  * 		tabindex: -1
  * 	},
  * 	children: [
  * 		'Lorem ipsum dolor sit amet...'
  * 	]
  * } );
  *
  * // Show the dialog.
  * editor.plugins.get( 'Dialog' ).show( {
  *	id: 'myDialog',
  * 	icon: 'myIcon', // This should be an SVG string.
  * 	title: 'My dialog',
  * 	content: textView,
  * 	actionButtons: [
  *		{
  *			label: t( 'Yes' ),
  *			class: 'ck-button-action',
  *			withText: true,
  *			onExecute: () => dialog.hide()
  *		},
  *		{
  *			label: t( 'No' ),
  *			withText: true,
  *			onExecute: () => dialog.hide()
  *		}
  *	]
  * } );
  * ```
  *
  * By specifying the {@link ~DialogDefinition#onShow} and {@link ~DialogDefinition#onHide} callbacks
  * it is also possible to add callbacks that will be called when the dialog is shown or hidden.
  *
  * For example, the callbacks in the following definition:
  * * Disable the default behavior of the <kbd>Esc</kbd> key.
  * * Fire a custom event when the dialog gets hidden.
  *
  * ```js
  * editor.plugins.get( 'Dialog' ).show( {
  * 	// ...
  * 	onShow: dialog => {
  * 		dialog.view.on( 'close', ( evt, data ) => {
  * 			// Only prevent the event from the "Esc" key - do not affect the other ways of closing the dialog.
  * 			if ( data.source === 'escKeyPress' ) {
  * 				evt.stop();
  * 			}
  * 		} );
  * 	},
  * 	onHide: dialog => {
  * 		dialog.fire( 'dialogDestroyed' );
  * 	}
  * } );
  * ```
  *
  * Internally, calling this method:
  * 1. Hides the currently visible dialog (if any) calling the {@link #hide} method
  * (fires the {@link ~DialogHideEvent hide event}).
  * 2. Fires the {@link ~DialogShowEvent show event} which allows for adding callbacks that customize the
  * behavior of the dialog.
  * 3. Shows the dialog.
  */
  show(t) {
    this.hide(), this.fire(`show:${t.id}`, t);
  }
  /**
  * Handles creating the {@link module:ui/dialog/dialogview~DialogView} instance and making it visible.
  */
  _show({ id: t, icon: i, title: r, hasCloseButton: s = !0, content: o, actionButtons: a, className: u, isModal: l, position: c, onHide: d, keystrokeHandlerOptions: p }) {
    const g = this.editor;
    this.view = new Ha(g.locale, {
      getCurrentDomRoot: () => g.editing.view.getDomRoot(g.model.document.selection.anchor.root.rootName),
      getViewportOffset: () => g.ui.viewportOffset,
      keystrokeHandlerOptions: p
    });
    const b = this.view;
    b.on("close", () => {
      this.hide();
    }), g.ui.view.body.add(b), g.keystrokes.listenTo(b.element), c || (c = l ? Xn.SCREEN_CENTER : Xn.EDITOR_CENTER), l && this._lockBodyScroll(), b.set({
      position: c,
      _isVisible: !0,
      className: u,
      isModal: l
    }), b.setupParts({
      icon: i,
      title: r,
      hasCloseButton: s,
      content: o,
      actionButtons: a
    }), this.id = t, d && (this._onHide = d), this.isOpen = !0, Jn._visibleDialogPlugin = this;
  }
  /**
  * Hides the dialog. This method is decorated to enable interacting on the {@link ~DialogHideEvent hide event}.
  *
  * See {@link #show}.
  */
  hide() {
    Jn._visibleDialogPlugin && Jn._visibleDialogPlugin.fire(`hide:${Jn._visibleDialogPlugin.id}`);
  }
  /**
  * Destroys the {@link module:ui/dialog/dialogview~DialogView} and cleans up the stored dialog state.
  */
  _hide() {
    if (!this.view)
      return;
    const t = this.editor, i = this.view;
    i.isModal && this._unlockBodyScroll(), i.contentView && i.contentView.reset(), t.ui.view.body.remove(i), t.ui.focusTracker.remove(i.element), t.keystrokes.stopListening(i.element), i.destroy(), t.editing.view.focus(), this.id = null, this.isOpen = !1, Jn._visibleDialogPlugin = null;
  }
  /**
  * Makes the <body> unscrollable (e.g. when the modal shows up).
  */
  _lockBodyScroll() {
    document.documentElement.classList.add("ck-dialog-scroll-locked");
  }
  /**
  * Makes the <body> scrollable again (e.g. once the modal hides).
  */
  _unlockBodyScroll() {
    document.documentElement.classList.remove("ck-dialog-scroll-locked");
  }
};
/**
* The `Dialog` plugin instance which most recently showed the dialog.
*
* Only one dialog can be visible at once, even if there are many editor instances on the page.
* If an editor wants to show a dialog, it should first hide the dialog that is already opened.
* But only the `Dialog` instance that showed the dialog is able able to properly hide it.
* This is why we need to store it in a globally available space (static property).
* This way every `Dialog` plugin in every editor is able to correctly close any open dialog window.
*/
m(Jn, "_visibleDialogPlugin");
let Fh = Jn;
class no extends gt {
  /**
  * @inheritDoc
  */
  constructor(t, i = new zT()) {
    super(t, i);
    /**
    * Holds the view for the check icon of a button list item.
    */
    m(this, "_checkIconHolderView", new O5());
    this.set({
      hasCheckSpace: !1,
      _hasCheck: this.isToggleable
    });
    const r = this.bindTemplate;
    this.extendTemplate({
      attributes: {
        class: [
          "ck-list-item-button",
          r.if("isToggleable", "ck-list-item-button_toggleable")
        ]
      }
    }), this.bind("_hasCheck").to(this, "hasCheckSpace", this, "isToggleable", (s, o) => s || o);
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this._hasCheck && this.children.add(this._checkIconHolderView, 0), this._watchCheckIconHolderMount();
  }
  /**
  * Renders the check icon if the button is toggleable.
  */
  _watchCheckIconHolderMount() {
    this._checkIconHolderView.bind("isOn").to(this, "isOn", (t) => this.isToggleable && t), this.on("change:_hasCheck", (t, i, r) => {
      const { children: s, _checkIconHolderView: o } = this;
      r ? s.add(o, 0) : s.remove(o);
    });
  }
}
class O5 extends me {
  /**
  * @inheritDoc
  */
  constructor() {
    super();
    /**
    * Collection of child views.
    */
    m(this, "children");
    /**
    * The view for the check icon of the button list item.
    */
    m(this, "_checkIconView", this._createCheckIconView());
    const t = this.bindTemplate;
    this.children = this.createCollection(), this.set("isOn", !1), this.setTemplate({
      tag: "span",
      children: this.children,
      attributes: {
        class: [
          "ck",
          "ck-list-item-button__check-holder",
          t.to("isOn", (i) => i ? "ck-on" : "ck-off")
        ]
      }
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.isOn && this.children.add(this._checkIconView, 0), this._watchCheckIconMount();
  }
  /**
  * Renders the check icon if the button is toggleable.
  */
  _watchCheckIconMount() {
    this.on("change:isOn", (t, i, r) => {
      const { children: s, _checkIconView: o } = this;
      r && !s.has(o) ? s.add(o) : !r && s.has(o) && s.remove(o);
    });
  }
  /**
  * Creates a check icon view.
  */
  _createCheckIconView() {
    const t = new yr();
    return t.content = Ge.check, t.extendTemplate({
      attributes: {
        class: "ck-list-item-button__check-icon"
      }
    }), t;
  }
}
class Dn extends no {
  /**
  * Creates an instance of the menu bar list button view.
  *
  * @param locale The localization services instance.
  */
  constructor(n) {
    super(n), this.set({
      withText: !0,
      withKeystroke: !0,
      tooltip: !1,
      role: "menuitem"
    }), this.extendTemplate({
      attributes: {
        class: [
          "ck-menu-bar__menu__item__button"
        ]
      }
    });
  }
}
class sc extends me {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * An unique id of the label. It can be used by other UI components to reference
    * the label, for instance, using the `aria-describedby` DOM attribute.
    */
    m(this, "id");
    this.set("text", void 0), this.set("for", void 0), this.id = `ck-editor__label_${un()}`;
    const i = this.bindTemplate;
    this.setTemplate({
      tag: "label",
      attributes: {
        class: [
          "ck",
          "ck-label"
        ],
        id: this.id,
        for: i.to("for")
      },
      children: [
        {
          text: i.to("text")
        }
      ]
    });
  }
}
class N5 extends me {
  /**
  * @inheritDoc
  */
  constructor(n, t) {
    super(n);
    const i = n.t, r = new sc();
    r.text = i("Help Contents. To close this dialog press ESC."), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-accessibility-help-dialog__content"
        ],
        "aria-labelledby": r.id,
        role: "document",
        tabindex: -1
      },
      children: [
        Zn(document, "p", {}, i("Below, you can find a list of keyboard shortcuts that can be used in the editor.")),
        ...this._createCategories(Array.from(t.values())),
        r
      ]
    });
  }
  /**
  * @inheritDoc
  */
  focus() {
    this.element.focus();
  }
  /**
  * Creates `<section><h3>Category label</h3>...</section>` elements for each category of keystrokes.
  */
  _createCategories(n) {
    return n.map((t) => {
      const i = [
        // Category header.
        Zn(document, "h3", {}, t.label),
        // Category definitions (<dl>) and their optional headers (<h4>).
        ...Array.from(t.groups.values()).map((r) => this._createGroup(r)).flat()
      ];
      return t.description && i.splice(1, 0, Zn(document, "p", {}, t.description)), Zn(document, "section", {}, i);
    });
  }
  /**
  * Creates `[<h4>Optional label</h4>]<dl>...</dl>` elements for each group of keystrokes in a category.
  */
  _createGroup(n) {
    const t = n.keystrokes.sort((r, s) => r.label.localeCompare(s.label)).map((r) => this._createGroupRow(r)).flat(), i = [
      Zn(document, "dl", {}, t)
    ];
    return n.label && i.unshift(Zn(document, "h4", {}, n.label)), i;
  }
  /**
  * Creates `<dt>Keystroke label</dt><dd>Keystroke definition</dd>` elements for each keystroke in a group.
  */
  _createGroupRow(n) {
    const t = this.locale.t, i = Zn(document, "dt"), r = Zn(document, "dd"), s = L5(n.keystroke), o = [];
    for (const a of s)
      o.push(a.map(R5).join(""));
    return i.innerHTML = n.label, r.innerHTML = o.join(", ") + (n.mayRequireFn && he.isMac ? ` ${t("(may require <kbd>Fn</kbd>)")}` : ""), [
      i,
      r
    ];
  }
}
function R5(e) {
  return bl(e).split("+").map((n) => `<kbd>${n}</kbd>`).join("+");
}
function L5(e) {
  return typeof e == "string" ? [
    [
      e
    ]
  ] : typeof e[0] == "string" ? [
    e
  ] : e;
}
var ug = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 6.628a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/><path d="M8.5 9.125a.3.3 0 0 0-.253-.296L5.11 8.327a.75.75 0 1 1 .388-1.449l4.04.716c.267.072.624.08.893.009l4.066-.724a.75.75 0 1 1 .388 1.45l-3.132.5a.3.3 0 0 0-.253.296v1.357a.3.3 0 0 0 .018.102l1.615 4.438a.75.75 0 0 1-1.41.513l-1.35-3.71a.3.3 0 0 0-.281-.197h-.209a.3.3 0 0 0-.282.198l-1.35 3.711a.75.75 0 0 1-1.41-.513l1.64-4.509a.3.3 0 0 0 .019-.103V9.125Z"/><path clip-rule="evenodd" d="M10 18.5a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17Zm0 1.5c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z"/></svg>';
class D5 extends ce {
  constructor() {
    super(...arguments);
    /**
    * The view that displays the dialog content (list of keystrokes).
    * Created when the dialog is opened for the first time.
    */
    m(this, "contentView", null);
  }
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      Fh
    ];
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "AccessibilityHelp";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const t = this.editor, i = t.locale.t;
    t.ui.componentFactory.add("accessibilityHelp", () => {
      const r = this._createButton(gt);
      return r.set({
        tooltip: !0,
        withText: !1,
        label: i("Accessibility help")
      }), r;
    }), t.ui.componentFactory.add("menuBar:accessibilityHelp", () => {
      const r = this._createButton(Dn);
      return r.label = i("Accessibility"), r;
    }), t.keystrokes.set("Alt+0", (r, s) => {
      this._toggleDialog(), s();
    }), this._setupRootLabels();
  }
  /**
  * Creates a button to show accessibility help dialog, for use either in toolbar or in menu bar.
  */
  _createButton(t) {
    const i = this.editor, r = i.plugins.get("Dialog"), s = i.locale, o = new t(s);
    return o.set({
      keystroke: "Alt+0",
      icon: ug,
      isToggleable: !0
    }), o.on("execute", () => this._toggleDialog()), o.bind("isOn").to(r, "id", (a) => a === "accessibilityHelp"), o;
  }
  /**
  * Injects a help text into each editing root's `aria-label` attribute allowing assistive technology users
  * to discover the availability of the Accessibility help dialog.
  */
  _setupRootLabels() {
    const t = this.editor, i = t.editing.view, r = t.t;
    t.ui.on("ready", () => {
      i.change((o) => {
        for (const a of i.document.roots)
          s(o, a);
      }), t.on("addRoot", (o, a) => {
        const u = t.editing.view.document.getRoot(a.rootName);
        i.change((l) => s(l, u));
      }, {
        priority: "low"
      });
    });
    function s(o, a) {
      const l = [
        a.getAttribute("aria-label"),
        r("Press %0 for help.", [
          bl("Alt+0")
        ])
      ].filter((c) => c).join(". ");
      o.setAttribute("aria-label", l, a);
    }
  }
  /**
  * Shows the accessibility help dialog. Also, creates {@link #contentView} on demand.
  */
  _toggleDialog() {
    const t = this.editor, i = t.plugins.get("Dialog"), r = t.locale.t;
    this.contentView || (this.contentView = new N5(t.locale, t.accessibility.keystrokeInfos)), i.id === "accessibilityHelp" ? i.hide() : i.show({
      id: "accessibilityHelp",
      className: "ck-accessibility-help-dialog",
      title: r("Accessibility help"),
      icon: ug,
      hasCloseButton: !0,
      content: this.contentView
    });
  }
}
const Fn = class Fn extends Ji {
  /**
  * Creates a new instance of the {@link module:ui/editorui/bodycollection~BodyCollection}.
  *
  * @param locale The {@link module:core/editor/editor~Editor editor's locale} instance.
  * @param initialItems The initial items of the collection.
  */
  constructor(t, i = []) {
    super(i);
    /**
    * The {@link module:core/editor/editor~Editor#locale editor's locale} instance.
    * See the view {@link module:ui/view~View#locale locale} property.
    */
    m(this, "locale");
    /**
    * The element holding elements of the body collection.
    */
    m(this, "_bodyCollectionContainer");
    this.locale = t;
  }
  /**
  * The element holding elements of the body collection.
  */
  get bodyCollectionContainer() {
    return this._bodyCollectionContainer;
  }
  /**
  * Attaches the body collection to the DOM body element. You need to execute this method to render the content of
  * the body collection.
  */
  attachToDom() {
    this._bodyCollectionContainer = new Ai({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-reset_all",
          "ck-body",
          "ck-rounded-corners"
        ],
        dir: this.locale.uiLanguageDirection,
        role: "application"
      },
      children: this
    }).render(), (!Fn._bodyWrapper || !Fn._bodyWrapper.isConnected) && (Fn._bodyWrapper = Zn(document, "div", {
      class: "ck-body-wrapper"
    }), document.body.appendChild(Fn._bodyWrapper)), Fn._bodyWrapper.appendChild(this._bodyCollectionContainer);
  }
  /**
  * Detaches the collection from the DOM structure. Use this method when you do not need to use the body collection
  * anymore to clean-up the DOM structure.
  */
  detachFromDom() {
    super.destroy(), this._bodyCollectionContainer && this._bodyCollectionContainer.remove(), Fn._bodyWrapper && !Fn._bodyWrapper.childElementCount && (Fn._bodyWrapper.remove(), delete Fn._bodyWrapper);
  }
};
/**
* The wrapper element that holds all of the {@link #_bodyCollectionContainer} elements.
*/
m(Fn, "_bodyWrapper");
let Uh = Fn;
class sm extends gt {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * The toggle switch of the button.
    */
    m(this, "toggleSwitchView");
    this.isToggleable = !0, this.toggleSwitchView = this._createToggleView(), this.extendTemplate({
      attributes: {
        class: "ck-switchbutton"
      }
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.children.add(this.toggleSwitchView);
  }
  /**
  * Creates a toggle child view.
  */
  _createToggleView() {
    const t = new me();
    return t.setTemplate({
      tag: "span",
      attributes: {
        class: [
          "ck",
          "ck-button__toggle"
        ]
      },
      children: [
        {
          tag: "span",
          attributes: {
            class: [
              "ck",
              "ck-button__toggle__inner"
            ]
          }
        }
      ]
    }), t;
  }
}
class M5 extends (/* @__PURE__ */ B5(no)) {
}
function B5(e) {
  class n extends e {
    /**
    * @inheritDoc
    */
    constructor(...r) {
      super(...r);
      /**
      * The button view of the component.
      *
      * @deprecated
      */
      m(this, "buttonView");
      /**
      * A hidden `<input>` view used to execute file dialog.
      */
      m(this, "_fileInputView");
      this.buttonView = this, this._fileInputView = new F5(this.locale), this._fileInputView.bind("acceptedType").to(this), this._fileInputView.bind("allowMultipleFiles").to(this), this._fileInputView.delegate("done").to(this), this.on("execute", () => {
        this._fileInputView.open();
      }), this.extendTemplate({
        attributes: {
          class: "ck-file-dialog-button"
        }
      });
    }
    /**
    * @inheritDoc
    */
    render() {
      super.render(), this.children.add(this._fileInputView);
    }
  }
  return n;
}
class F5 extends me {
  /**
  * @inheritDoc
  */
  constructor(n) {
    super(n), this.set("acceptedType", void 0), this.set("allowMultipleFiles", !1);
    const t = this.bindTemplate;
    this.setTemplate({
      tag: "input",
      attributes: {
        class: [
          "ck-hidden"
        ],
        type: "file",
        tabindex: "-1",
        accept: t.to("acceptedType"),
        multiple: t.to("allowMultipleFiles")
      },
      on: {
        // Removing from code coverage since we cannot programmatically set input element files.
        change: t.to(
          /* istanbul ignore next -- @preserve */
          () => {
            this.element && this.element.files && this.element.files.length && this.fire("done", this.element.files), this.element.value = "";
          }
        )
      }
    });
  }
  /**
  * Opens file dialog.
  */
  open() {
    this.element.click();
  }
}
var om = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
class U5 extends me {
  /**
  * Creates an instance of the labeled field view class using a provided creator function
  * that provides the view to be labeled.
  *
  * @param locale The locale instance.
  * @param viewCreator A function that returns a {@link module:ui/view~View}
  * that will be labeled. The following arguments are passed to the creator function:
  *
  * * an instance of the `LabeledFieldView` to allow binding observable properties,
  * * an UID string that connects the {@link #labelView label} and the labeled field view in DOM,
  * * an UID string that connects the {@link #statusView status} and the labeled field view in DOM.
  */
  constructor(t, i) {
    super(t);
    /**
    * The field view that gets labeled.
    */
    m(this, "fieldView");
    /**
    * The label view instance that describes the entire view.
    */
    m(this, "labelView");
    /**
    * The status view for the {@link #fieldView}. It displays {@link #errorText} and
    * {@link #infoText}.
    */
    m(this, "statusView");
    /**
    * A collection of children of the internal wrapper element. Allows inserting additional DOM elements (views) next to
    * the {@link #fieldView} for easy styling (e.g. positioning).
    *
    * By default, the collection contains {@link #fieldView} and {@link #labelView}.
    */
    m(this, "fieldWrapperChildren");
    const r = `ck-labeled-field-view-${un()}`, s = `ck-labeled-field-view-status-${un()}`;
    this.fieldView = i(this, r, s), this.set("label", void 0), this.set("isEnabled", !0), this.set("isEmpty", !0), this.set("isFocused", !1), this.set("errorText", null), this.set("infoText", null), this.set("class", void 0), this.set("placeholder", void 0), this.labelView = this._createLabelView(r), this.statusView = this._createStatusView(s), this.fieldWrapperChildren = this.createCollection([
      this.fieldView,
      this.labelView
    ]), this.bind("_statusText").to(this, "errorText", this, "infoText", (a, u) => a || u);
    const o = this.bindTemplate;
    this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-labeled-field-view",
          o.to("class"),
          o.if("isEnabled", "ck-disabled", (a) => !a),
          o.if("isEmpty", "ck-labeled-field-view_empty"),
          o.if("isFocused", "ck-labeled-field-view_focused"),
          o.if("placeholder", "ck-labeled-field-view_placeholder"),
          o.if("errorText", "ck-error")
        ]
      },
      children: [
        {
          tag: "div",
          attributes: {
            class: [
              "ck",
              "ck-labeled-field-view__input-wrapper"
            ]
          },
          children: this.fieldWrapperChildren
        },
        this.statusView
      ]
    });
  }
  /**
  * Creates label view class instance and bind with view.
  *
  * @param id Unique id to set as labelView#for attribute.
  */
  _createLabelView(t) {
    const i = new sc(this.locale);
    return i.for = t, i.bind("text").to(this, "label"), i;
  }
  /**
  * Creates the status view instance. It displays {@link #errorText} and {@link #infoText}
  * next to the {@link #fieldView}. See {@link #_statusText}.
  *
  * @param statusUid Unique id of the status, shared with the {@link #fieldView view's}
  * `aria-describedby` attribute.
  */
  _createStatusView(t) {
    const i = new me(this.locale), r = this.bindTemplate;
    return i.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-labeled-field-view__status",
          r.if("errorText", "ck-labeled-field-view__status_error"),
          r.if("_statusText", "ck-hidden", (s) => !s)
        ],
        id: t,
        role: r.if("errorText", "alert")
      },
      children: [
        {
          text: r.to("_statusText")
        }
      ]
    }), i;
  }
  /**
  * Focuses the {@link #fieldView}.
  */
  focus(t) {
    this.fieldView.focus(t);
  }
}
class H5 extends me {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * Stores information about the editor UI focus and propagates it so various plugins and components
    * are unified as a focus group.
    */
    m(this, "focusTracker");
    this.set("value", void 0), this.set("id", void 0), this.set("placeholder", void 0), this.set("tabIndex", void 0), this.set("isReadOnly", !1), this.set("hasError", !1), this.set("ariaDescribedById", void 0), this.set("ariaLabel", void 0), this.focusTracker = new Ln(), this.bind("isFocused").to(this.focusTracker), this.set("isEmpty", !0);
    const i = this.bindTemplate;
    this.setTemplate({
      tag: "input",
      attributes: {
        class: [
          "ck",
          "ck-input",
          i.if("isFocused", "ck-input_focused"),
          i.if("isEmpty", "ck-input-text_empty"),
          i.if("hasError", "ck-error")
        ],
        id: i.to("id"),
        placeholder: i.to("placeholder"),
        tabindex: i.to("tabIndex"),
        readonly: i.to("isReadOnly"),
        "aria-invalid": i.if("hasError", !0),
        "aria-describedby": i.to("ariaDescribedById"),
        "aria-label": i.to("ariaLabel")
      },
      on: {
        input: i.to((...r) => {
          this.fire("input", ...r), this._updateIsEmpty();
        }),
        change: i.to(this._updateIsEmpty.bind(this))
      }
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.focusTracker.add(this.element), this._setDomElementValue(this.value), this._updateIsEmpty(), this.on("change:value", (t, i, r) => {
      this._setDomElementValue(r), this._updateIsEmpty();
    });
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy(), this.focusTracker.destroy();
  }
  /**
  * Moves the focus to the input and selects the value.
  */
  select() {
    this.element.select();
  }
  /**
  * Focuses the input.
  */
  focus() {
    this.element.focus();
  }
  /**
  * Resets the value of the input
  */
  reset() {
    this.value = this.element.value = "", this._updateIsEmpty();
  }
  /**
  * Updates the {@link #isEmpty} property value on demand.
  */
  _updateIsEmpty() {
    this.isEmpty = V5(this.element);
  }
  /**
  * Sets the `value` property of the {@link #element DOM element} on demand.
  */
  _setDomElementValue(t) {
    this.element.value = !t && t !== 0 ? "" : t;
  }
}
function V5(e) {
  return !e.value;
}
class $5 extends H5 {
  /**
  * @inheritDoc
  */
  constructor(n) {
    super(n), this.set("inputMode", "text");
    const t = this.bindTemplate;
    this.extendTemplate({
      attributes: {
        inputmode: t.to("inputMode")
      }
    });
  }
}
class W5 extends $5 {
  /**
  * @inheritDoc
  */
  constructor(n) {
    super(n), this.extendTemplate({
      attributes: {
        type: "text",
        class: [
          "ck-input-text"
        ]
      }
    });
  }
}
class z5 extends me {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * Collection of the child views in this panel.
    *
    * A common child type is the {@link module:ui/list/listview~ListView} and {@link module:ui/toolbar/toolbarview~ToolbarView}.
    * See {@link module:ui/dropdown/utils~addListToDropdown} and
    * {@link module:ui/dropdown/utils~addToolbarToDropdown} to learn more about child views of dropdowns.
    */
    m(this, "children");
    const i = this.bindTemplate;
    this.set("isVisible", !1), this.set("position", "se"), this.children = this.createCollection(), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-reset",
          "ck-dropdown__panel",
          i.to("position", (r) => `ck-dropdown__panel_${r}`),
          i.if("isVisible", "ck-dropdown__panel-visible")
        ],
        tabindex: "-1"
      },
      children: this.children,
      on: {
        // Drag and drop in the panel should not break the selection in the editor.
        // https://github.com/ckeditor/ckeditor5-ui/issues/228
        selectstart: i.to((r) => {
          r.target.tagName.toLocaleLowerCase() !== "input" && r.preventDefault();
        })
      }
    });
  }
  /**
  * Focuses the first view in the {@link #children} collection.
  *
  * See also {@link module:ui/dropdown/dropdownpanelfocusable~DropdownPanelFocusable}.
  */
  focus() {
    if (this.children.length) {
      const t = this.children.first;
      typeof t.focus == "function" ? t.focus() : at("ui-dropdown-panel-focus-child-missing-focus", {
        childView: this.children.first,
        dropdownPanel: this
      });
    }
  }
  /**
  * Focuses the view element or last item in view collection on opening dropdown's panel.
  *
  * See also {@link module:ui/dropdown/dropdownpanelfocusable~DropdownPanelFocusable}.
  */
  focusLast() {
    if (this.children.length) {
      const t = this.children.last;
      typeof t.focusLast == "function" ? t.focusLast() : t.focus();
    }
  }
}
const Ws = class Ws extends me {
  /**
  * Creates an instance of the dropdown.
  *
  * Also see {@link #render}.
  *
  * @param locale The localization services instance.
  */
  constructor(t, i, r) {
    super(t);
    /**
    * Button of the dropdown view. Clicking the button opens the {@link #panelView}.
    */
    m(this, "buttonView");
    /**
    * Panel of the dropdown. It opens when the {@link #buttonView} is
    * {@link module:ui/button/button~Button#event:execute executed} (i.e. clicked).
    *
    * Child views can be added to the panel's `children` collection:
    *
    * ```ts
    * dropdown.panelView.children.add( childView );
    * ```
    *
    * See {@link module:ui/dropdown/dropdownpanelview~DropdownPanelView#children} and
    * {@link module:ui/viewcollection~ViewCollection#add}.
    */
    m(this, "panelView");
    /**
    * Tracks information about the DOM focus in the dropdown.
    */
    m(this, "focusTracker");
    /**
    * Instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}. It manages
    * keystrokes of the dropdown:
    *
    * * <kbd>▼</kbd> opens the dropdown,
    * * <kbd>◀</kbd> and <kbd>Esc</kbd> closes the dropdown.
    */
    m(this, "keystrokes");
    /**
    * A child {@link module:ui/list/listview~ListView list view} of the dropdown located
    * in its {@link module:ui/dropdown/dropdownview~DropdownView#panelView panel}.
    *
    * **Note**: Only supported when dropdown has list view added using {@link module:ui/dropdown/utils~addListToDropdown}.
    */
    m(this, "listView");
    /**
    * A child toolbar of the dropdown located in the
    * {@link module:ui/dropdown/dropdownview~DropdownView#panelView panel}.
    *
    * **Note**: Only supported when dropdown has a toolbar added using {@link module:ui/dropdown/utils~addToolbarToDropdown}.
    */
    m(this, "toolbarView");
    /**
    * A child menu component of the dropdown located
    * in its {@link module:ui/dropdown/dropdownview~DropdownView#panelView panel}.
    *
    * **Note**: Only supported when dropdown has a menu added using {@link module:ui/dropdown/utils~addMenuToDropdown}.
    */
    m(this, "menuView");
    const s = this.bindTemplate;
    this.buttonView = i, this.panelView = r, this.set("isOpen", !1), this.set("isEnabled", !0), this.set("class", void 0), this.set("id", void 0), this.set("panelPosition", "auto"), this.panelView.bind("isVisible").to(this, "isOpen"), this.keystrokes = new Ii(), this.focusTracker = new Ln(), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-dropdown",
          s.to("class"),
          s.if("isEnabled", "ck-disabled", (o) => !o)
        ],
        id: s.to("id"),
        "aria-describedby": s.to("ariaDescribedById")
      },
      children: [
        i,
        r
      ]
    }), i.extendTemplate({
      attributes: {
        class: [
          "ck-dropdown__button"
        ],
        "data-cke-tooltip-disabled": s.to("isOpen")
      }
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.focusTracker.add(this.buttonView.element), this.focusTracker.add(this.panelView.element), this.listenTo(this.buttonView, "open", () => {
      this.isOpen = !this.isOpen;
    }), this.on("change:isOpen", (i, r, s) => {
      if (s)
        if (this.panelPosition === "auto") {
          const o = Ws._getOptimalPosition({
            element: this.panelView.element,
            target: this.buttonView.element,
            fitInViewport: !0,
            positions: this._panelPositions
          });
          this.panelView.position = o ? o.name : this._defaultPanelPositionName;
        } else
          this.panelView.position = this.panelPosition;
    }), this.keystrokes.listenTo(this.element);
    const t = (i, r) => {
      this.isOpen && (this.isOpen = !1, r());
    };
    this.keystrokes.set("arrowdown", (i, r) => {
      this.buttonView.isEnabled && !this.isOpen && (this.isOpen = !0, r());
    }), this.keystrokes.set("arrowright", (i, r) => {
      this.isOpen && r();
    }), this.keystrokes.set("arrowleft", t), this.keystrokes.set("esc", t);
  }
  /**
  * Focuses the {@link #buttonView}.
  */
  focus() {
    this.buttonView.focus();
  }
  /**
  * Returns {@link #panelView panel} positions to be used by the
  * {@link module:utils/dom/position~getOptimalPosition `getOptimalPosition()`}
  * utility considering the direction of the language the UI of the editor is displayed in.
  */
  get _panelPositions() {
    const { south: t, north: i, southEast: r, southWest: s, northEast: o, northWest: a, southMiddleEast: u, southMiddleWest: l, northMiddleEast: c, northMiddleWest: d } = Ws.defaultPanelPositions;
    return this.locale.uiLanguageDirection !== "rtl" ? [
      r,
      s,
      u,
      l,
      t,
      o,
      a,
      c,
      d,
      i
    ] : [
      s,
      r,
      l,
      u,
      t,
      a,
      o,
      d,
      c,
      i
    ];
  }
  /**
  * Returns the default position of the dropdown panel based on the direction of the UI language.
  * It is used when the {@link #panelPosition} is set to `'auto'` and the panel has not found a
  * suitable position to fit into the viewport.
  */
  get _defaultPanelPositionName() {
    return this.locale.uiLanguageDirection === "rtl" ? "sw" : "se";
  }
};
/**
* A set of positioning functions used by the dropdown view to determine
* the optimal position (i.e. fitting into the browser viewport) of its
* {@link module:ui/dropdown/dropdownview~DropdownView#panelView panel} when
* {@link module:ui/dropdown/dropdownview~DropdownView#panelPosition} is set to 'auto'`.
*
* The available positioning functions are as follow:
*
* **South**
*
* * `south`
*
* ```
*			[ Button ]
*		+-----------------+
*		|      Panel      |
*		+-----------------+
* ```
*
* * `southEast`
*
* ```
*		[ Button ]
*		+-----------------+
*		|      Panel      |
*		+-----------------+
* ```
*
* * `southWest`
*
* ```
*		         [ Button ]
*		+-----------------+
*		|      Panel      |
*		+-----------------+
* ```
*
* * `southMiddleEast`
*
* ```
*		  [ Button ]
*		+-----------------+
*		|      Panel      |
*		+-----------------+
* ```
*
* * `southMiddleWest`
*
* ```
*		       [ Button ]
*		+-----------------+
*		|      Panel      |
*		+-----------------+
* ```
*
* **North**
*
* * `north`
*
* ```
*		+-----------------+
*		|      Panel      |
*		+-----------------+
*		    [ Button ]
* ```
*
* * `northEast`
*
* ```
*		+-----------------+
*		|      Panel      |
*		+-----------------+
*		[ Button ]
* ```
*
* * `northWest`
*
* ```
*		+-----------------+
*		|      Panel      |
*		+-----------------+
*		         [ Button ]
* ```
*
* * `northMiddleEast`
*
* ```
*		+-----------------+
*		|      Panel      |
*		+-----------------+
*		  [ Button ]
* ```
*
* * `northMiddleWest`
*
* ```
*		+-----------------+
*		|      Panel      |
*		+-----------------+
*		       [ Button ]
* ```
*
* Positioning functions are compatible with {@link module:utils/dom/position~DomPoint}.
*
* The name that position function returns will be reflected in dropdown panel's class that
* controls its placement. See {@link module:ui/dropdown/dropdownview~DropdownView#panelPosition}
* to learn more.
*/
m(Ws, "defaultPanelPositions", {
  south: (t, i) => ({
    top: t.bottom,
    left: t.left - (i.width - t.width) / 2,
    name: "s"
  }),
  southEast: (t) => ({
    top: t.bottom,
    left: t.left,
    name: "se"
  }),
  southWest: (t, i) => ({
    top: t.bottom,
    left: t.left - i.width + t.width,
    name: "sw"
  }),
  southMiddleEast: (t, i) => ({
    top: t.bottom,
    left: t.left - (i.width - t.width) / 4,
    name: "sme"
  }),
  southMiddleWest: (t, i) => ({
    top: t.bottom,
    left: t.left - (i.width - t.width) * 3 / 4,
    name: "smw"
  }),
  north: (t, i) => ({
    top: t.top - i.height,
    left: t.left - (i.width - t.width) / 2,
    name: "n"
  }),
  northEast: (t, i) => ({
    top: t.top - i.height,
    left: t.left,
    name: "ne"
  }),
  northWest: (t, i) => ({
    top: t.top - i.height,
    left: t.left - i.width + t.width,
    name: "nw"
  }),
  northMiddleEast: (t, i) => ({
    top: t.top - i.height,
    left: t.left - (i.width - t.width) / 4,
    name: "nme"
  }),
  northMiddleWest: (t, i) => ({
    top: t.top - i.height,
    left: t.left - (i.width - t.width) * 3 / 4,
    name: "nmw"
  })
}), /**
* A function used to calculate the optimal position for the dropdown panel.
*/
m(Ws, "_getOptimalPosition", Hf);
let Hh = Ws;
class q5 extends gt {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * An icon that displays arrow to indicate a dropdown button.
    */
    m(this, "arrowView");
    this.arrowView = this._createArrowView(), this.extendTemplate({
      attributes: {
        "aria-haspopup": !0,
        "aria-expanded": this.bindTemplate.to("isOn", (i) => String(i))
      }
    }), this.delegate("execute").to(this, "open");
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.children.add(this.arrowView);
  }
  /**
  * Creates a {@link module:ui/icon/iconview~IconView} instance as {@link #arrowView}.
  */
  _createArrowView() {
    const t = new yr();
    return t.content = om, t.extendTemplate({
      attributes: {
        class: "ck-dropdown__arrow"
      }
    }), t;
  }
}
class qi extends me {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * Collection of the child views inside of the list item {@link #element}.
    */
    m(this, "children");
    const i = this.bindTemplate;
    this.set("isVisible", !0), this.children = this.createCollection(), this.setTemplate({
      tag: "li",
      attributes: {
        class: [
          "ck",
          "ck-list__item",
          i.if("isVisible", "ck-hidden", (r) => !r)
        ],
        role: "presentation"
      },
      children: this.children
    });
  }
  /**
  * Focuses the list item.
  */
  focus() {
    this.children.first && this.children.first.focus();
  }
}
class am extends me {
  /**
  * @inheritDoc
  */
  constructor(n) {
    super(n), this.setTemplate({
      tag: "li",
      attributes: {
        class: [
          "ck",
          "ck-list__separator"
        ]
      }
    });
  }
}
class Xu extends me {
  /**
  * Creates an instance of the list item group view class.
  *
  * @param locale The {@link module:core/editor/editor~Editor#locale} instance.
  * @param labelView The instance of the group's label. If not provided, an instance of
  * {@link module:ui/label/labelview~LabelView} is used.
  */
  constructor(t, i = new sc()) {
    super(t);
    /**
    * Label of the group view. Its text is configurable using the {@link #label label attribute}.
    *
    * If a custom label view is not passed in `ListItemGroupView` constructor, the label is an instance
    * of {@link module:ui/label/labelview~LabelView}.
    */
    m(this, "labelView");
    /**
    * Collection of the child list items inside this group.
    */
    m(this, "items");
    /**
    * Collection of the child elements of the group.
    */
    m(this, "children");
    const r = this.bindTemplate, s = new oc(t);
    this.set({
      label: "",
      isVisible: !0
    }), this.labelView = i, this.labelView.bind("text").to(this, "label"), this.children = this.createCollection(), this.children.addMany([
      this.labelView,
      s
    ]), s.set({
      role: "group",
      ariaLabelledBy: i.id
    }), s.focusTracker.destroy(), s.keystrokes.destroy(), this.items = s.items, this.setTemplate({
      tag: "li",
      attributes: {
        role: "presentation",
        class: [
          "ck",
          "ck-list__group",
          r.if("isVisible", "ck-hidden", (o) => !o)
        ]
      },
      children: this.children
    });
  }
  /**
  * Focuses the list item (which is not a separator).
  */
  focus() {
    if (this.items) {
      const t = this.items.find((i) => !(i instanceof am));
      t && t.focus();
    }
  }
}
class oc extends me {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * The collection of focusable views in the list. It is used to determine accessible navigation
    * between the {@link module:ui/list/listitemview~ListItemView list items} and
    * {@link module:ui/list/listitemgroupview~ListItemGroupView list groups}.
    */
    m(this, "focusables");
    /**
    * Collection of the child list views.
    */
    m(this, "items");
    /**
    * Tracks information about DOM focus in the list.
    */
    m(this, "focusTracker");
    /**
    * Instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
    */
    m(this, "keystrokes");
    /**
    * Helps cycling over focusable {@link #items} in the list.
    */
    m(this, "_focusCycler");
    /**
    * A cached map of {@link module:ui/list/listitemgroupview~ListItemGroupView} to `change` event listeners for their `items`.
    * Used for accessibility and keyboard navigation purposes.
    */
    m(this, "_listItemGroupToChangeListeners", /* @__PURE__ */ new WeakMap());
    const i = this.bindTemplate;
    this.focusables = new Ji(), this.items = this.createCollection(), this.focusTracker = new Ln(), this.keystrokes = new Ii(), this._focusCycler = new hs({
      focusables: this.focusables,
      focusTracker: this.focusTracker,
      keystrokeHandler: this.keystrokes,
      actions: {
        // Navigate list items backwards using the arrowup key.
        focusPrevious: "arrowup",
        // Navigate toolbar items forwards using the arrowdown key.
        focusNext: "arrowdown"
      }
    }), this.set("ariaLabel", void 0), this.set("ariaLabelledBy", void 0), this.set("role", void 0), this.setTemplate({
      tag: "ul",
      attributes: {
        class: [
          "ck",
          "ck-reset",
          "ck-list"
        ],
        role: i.to("role"),
        "aria-label": i.to("ariaLabel"),
        "aria-labelledby": i.to("ariaLabelledBy")
      },
      children: this.items
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render();
    for (const t of this.items)
      t instanceof Xu ? this._registerFocusableItemsGroup(t) : t instanceof qi && this._registerFocusableListItem(t);
    this.items.on("change", (t, i) => {
      for (const r of i.removed)
        r instanceof Xu ? this._deregisterFocusableItemsGroup(r) : r instanceof qi && this._deregisterFocusableListItem(r);
      for (const r of Array.from(i.added).reverse())
        r instanceof Xu ? this._registerFocusableItemsGroup(r, i.index) : this._registerFocusableListItem(r, i.index);
    }), this.keystrokes.listenTo(this.element);
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
  }
  /**
  * Focuses the first focusable in {@link #items}.
  */
  focus() {
    this._focusCycler.focusFirst();
  }
  /**
  * Focuses the first focusable in {@link #items}.
  */
  focusFirst() {
    this._focusCycler.focusFirst();
  }
  /**
  * Focuses the last focusable in {@link #items}.
  */
  focusLast() {
    this._focusCycler.focusLast();
  }
  /**
  * Registers a list item view in the focus tracker.
  *
  * @param item The list item view to be registered.
  * @param index Index of the list item view in the {@link #items} collection. If not specified, the item will be added at the end.
  */
  _registerFocusableListItem(t, i) {
    this.focusTracker.add(t.element), this.focusables.add(t, i);
  }
  /**
  * Removes a list item view from the focus tracker.
  *
  * @param item The list item view to be removed.
  */
  _deregisterFocusableListItem(t) {
    this.focusTracker.remove(t.element), this.focusables.remove(t);
  }
  /**
  * Gets a callback that will be called when the `items` collection of a {@link module:ui/list/listitemgroupview~ListItemGroupView}
  * change.
  *
  * @param groupView The group view for which the callback will be created.
  * @returns The callback function to be used for the items `change` event listener in a group.
  */
  _getOnGroupItemsChangeCallback(t) {
    return (i, r) => {
      for (const s of r.removed)
        this._deregisterFocusableListItem(s);
      for (const s of Array.from(r.added).reverse())
        this._registerFocusableListItem(s, this.items.getIndex(t) + r.index);
    };
  }
  /**
  * Registers a list item group view (and its children) in the focus tracker.
  *
  * @param groupView A group view to be registered.
  * @param groupIndex Index of the group view in the {@link #items} collection. If not specified, the group will be added at the end.
  */
  _registerFocusableItemsGroup(t, i) {
    Array.from(t.items).forEach((s, o) => {
      const a = typeof i < "u" ? i + o : void 0;
      this._registerFocusableListItem(s, a);
    });
    const r = this._getOnGroupItemsChangeCallback(t);
    this._listItemGroupToChangeListeners.set(t, r), t.items.on("change", r);
  }
  /**
  * Removes a list item group view (and its children) from the focus tracker.
  *
  * @param groupView The group view to be removed.
  */
  _deregisterFocusableItemsGroup(t) {
    for (const i of t.items)
      this._deregisterFocusableListItem(i);
    t.items.off("change", this._listItemGroupToChangeListeners.get(t)), this._listItemGroupToChangeListeners.delete(t);
  }
}
const lg = /* @__PURE__ */ nu("px"), Y5 = {
  top: -99999,
  left: -99999,
  name: "arrowless",
  config: {
    withArrow: !1
  }
}, Cn = class Cn extends me {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * A collection of the child views that creates the balloon panel contents.
    */
    m(this, "content");
    /**
    * A callback that starts pinning the panel when {@link #isVisible} gets
    * `true`. Used by {@link #pin}.
    *
    * @private
    */
    m(this, "_pinWhenIsVisibleCallback");
    /**
    * An instance of resize observer used to detect if target element is still visible.
    */
    m(this, "_resizeObserver");
    const i = this.bindTemplate;
    this.set("top", 0), this.set("left", 0), this.set("position", "arrow_nw"), this.set("isVisible", !1), this.set("withArrow", !0), this.set("class", void 0), this._pinWhenIsVisibleCallback = null, this._resizeObserver = null, this.content = this.createCollection(), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-balloon-panel",
          i.to("position", (r) => `ck-balloon-panel_${r}`),
          i.if("isVisible", "ck-balloon-panel_visible"),
          i.if("withArrow", "ck-balloon-panel_with-arrow"),
          i.to("class")
        ],
        style: {
          top: i.to("top", lg),
          left: i.to("left", lg)
        }
      },
      children: this.content
    });
  }
  /**
  * @inheritDoc
  */
  destroy() {
    this.hide(), super.destroy();
  }
  /**
  * Shows the panel.
  *
  * See {@link #isVisible}.
  */
  show() {
    this.isVisible = !0;
  }
  /**
  * Hides the panel.
  *
  * See {@link #isVisible}.
  */
  hide() {
    this.isVisible = !1;
  }
  /**
  * Attaches the panel to a specified {@link module:utils/dom/position~Options#target} with a
  * smart positioning heuristics that chooses from available positions to make sure the panel
  * is visible to the user i.e. within the limits of the viewport.
  *
  * This method accepts configuration {@link module:utils/dom/position~Options options}
  * to set the `target`, optional `limiter` and `positions` the balloon should choose from.
  *
  * ```ts
  * const panel = new BalloonPanelView( locale );
  * const positions = BalloonPanelView.defaultPositions;
  *
  * panel.render();
  *
  * // Attach the panel to an element with the "target" id DOM.
  * panel.attachTo( {
  * 	target: document.querySelector( '#target' ),
  * 	positions: [
  * 		positions.northArrowSouth,
  * 		positions.southArrowNorth
  * 	]
  * } );
  * ```
  *
  * **Note**: Attaching the panel will also automatically {@link #show} it.
  *
  * **Note**: An attached panel will not follow its target when the window is scrolled or resized.
  * See the {@link #pin} method for a more permanent positioning strategy.
  *
  * @param options Positioning options compatible with {@link module:utils/dom/position~getOptimalPosition}.
  * Default `positions` array is {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView.defaultPositions}.
  * @returns Whether the balloon was shown and successfully attached or not. Attaching can fail if the target
  * provided in the options is invisible (e.g. element detached from DOM).
  */
  attachTo(t) {
    const i = Ju(t.target);
    if (i && !zi(i))
      return !1;
    this.show();
    const r = Cn.defaultPositions, s = Object.assign({}, {
      element: this.element,
      positions: [
        r.southArrowNorth,
        r.southArrowNorthMiddleWest,
        r.southArrowNorthMiddleEast,
        r.southArrowNorthWest,
        r.southArrowNorthEast,
        r.northArrowSouth,
        r.northArrowSouthMiddleWest,
        r.northArrowSouthMiddleEast,
        r.northArrowSouthWest,
        r.northArrowSouthEast,
        r.viewportStickyNorth
      ],
      limiter: ue.document.body,
      fitInViewport: !0
    }, t), o = Cn._getOptimalPosition(s) || Y5, a = parseInt(o.left), u = parseInt(o.top), l = o.name, c = o.config || {}, { withArrow: d = !0 } = c;
    return this.top = u, this.left = a, this.position = l, this.withArrow = d, !0;
  }
  /**
  * Works the same way as the {@link #attachTo} method except that the position of the panel is
  * continuously updated when:
  *
  * * any ancestor of the {@link module:utils/dom/position~Options#target}
  * or {@link module:utils/dom/position~Options#limiter} is scrolled,
  * * the browser window gets resized or scrolled.
  *
  * Thanks to that, the panel always sticks to the {@link module:utils/dom/position~Options#target}
  * and is immune to the changing environment.
  *
  * ```ts
  * const panel = new BalloonPanelView( locale );
  * const positions = BalloonPanelView.defaultPositions;
  *
  * panel.render();
  *
  * // Pin the panel to an element with the "target" id DOM.
  * panel.pin( {
  * 	target: document.querySelector( '#target' ),
  * 	positions: [
  * 		positions.northArrowSouth,
  * 		positions.southArrowNorth
  * 	]
  * } );
  * ```
  *
  * To leave the pinned state, use the {@link #unpin} method.
  *
  * **Note**: Pinning the panel will also automatically {@link #show} it.
  *
  * @param options Positioning options compatible with {@link module:utils/dom/position~getOptimalPosition}.
  * Default `positions` array is {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView.defaultPositions}.
  */
  pin(t) {
    this.unpin(), this._startPinning(t) && (this._pinWhenIsVisibleCallback = () => {
      this.isVisible ? this._startPinning(t) : this._stopPinning();
    }, this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback));
  }
  /**
  * Stops pinning the panel, as set up by {@link #pin}.
  */
  unpin() {
    this._pinWhenIsVisibleCallback && (this._stopPinning(), this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback), this._pinWhenIsVisibleCallback = null, this.hide());
  }
  /**
  * Starts managing the pinned state of the panel. See {@link #pin}.
  *
  * @param options Positioning options compatible with {@link module:utils/dom/position~getOptimalPosition}.
  * @returns Whether the balloon was shown and successfully attached or not. Attaching can fail if the target
  * provided in the options is invisible (e.g. element detached from DOM).
  */
  _startPinning(t) {
    if (!this.attachTo(t))
      return !1;
    let i = Ju(t.target);
    const r = t.limiter ? Ju(t.limiter) : ue.document.body;
    if (this.listenTo(ue.document, "scroll", (s, o) => {
      const a = o.target, u = i && a.contains(i), l = r && a.contains(r);
      (u || l || !i || !r) && this.attachTo(t);
    }, {
      useCapture: !0
    }), this.listenTo(ue.window, "resize", () => {
      this.attachTo(t);
    }), !this._resizeObserver && (i && mt(i) && (i = i.parentElement), i)) {
      const s = () => {
        zi(i) || this.unpin();
      };
      this._resizeObserver = new Pa(i, s);
    }
    return !0;
  }
  /**
  * Stops managing the pinned state of the panel. See {@link #pin}.
  */
  _stopPinning() {
    this.stopListening(ue.document, "scroll"), this.stopListening(ue.window, "resize"), this._resizeObserver && (this._resizeObserver.destroy(), this._resizeObserver = null);
  }
  /**
  * Returns available {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView}
  * {@link module:utils/dom/position~PositioningFunction positioning functions} adjusted by the specific offsets.
  *
  * @internal
  * @param options Options to generate positions. If not specified, this helper will simply return
  * {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView.defaultPositions}.
  * @param options.sideOffset A custom side offset (in pixels) of each position. If
  * not specified, {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView.arrowSideOffset the default value}
  * will be used.
  * @param options.heightOffset A custom height offset (in pixels) of each position. If
  * not specified, {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView.arrowHeightOffset the default value}
  * will be used.
  * @param options.stickyVerticalOffset A custom offset (in pixels) of the `viewportStickyNorth` positioning function.
  * If not specified, {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView.stickyVerticalOffset the default value}
  * will be used.
  * @param options.config Additional configuration of the balloon balloon panel view.
  * Currently only {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView#withArrow} is supported. Learn more
  * about {@link module:utils/dom/position~PositioningFunction positioning functions}.
  */
  static generatePositions(t = {}) {
    const { sideOffset: i = Cn.arrowSideOffset, heightOffset: r = Cn.arrowHeightOffset, stickyVerticalOffset: s = Cn.stickyVerticalOffset, config: o } = t;
    return {
      // ------- North west
      northWestArrowSouthWest: (l, c) => ({
        top: a(l, c),
        left: l.left - i,
        name: "arrow_sw",
        ...o && {
          config: o
        }
      }),
      northWestArrowSouthMiddleWest: (l, c) => ({
        top: a(l, c),
        left: l.left - c.width * 0.25 - i,
        name: "arrow_smw",
        ...o && {
          config: o
        }
      }),
      northWestArrowSouth: (l, c) => ({
        top: a(l, c),
        left: l.left - c.width / 2,
        name: "arrow_s",
        ...o && {
          config: o
        }
      }),
      northWestArrowSouthMiddleEast: (l, c) => ({
        top: a(l, c),
        left: l.left - c.width * 0.75 + i,
        name: "arrow_sme",
        ...o && {
          config: o
        }
      }),
      northWestArrowSouthEast: (l, c) => ({
        top: a(l, c),
        left: l.left - c.width + i,
        name: "arrow_se",
        ...o && {
          config: o
        }
      }),
      // ------- North
      northArrowSouthWest: (l, c) => ({
        top: a(l, c),
        left: l.left + l.width / 2 - i,
        name: "arrow_sw",
        ...o && {
          config: o
        }
      }),
      northArrowSouthMiddleWest: (l, c) => ({
        top: a(l, c),
        left: l.left + l.width / 2 - c.width * 0.25 - i,
        name: "arrow_smw",
        ...o && {
          config: o
        }
      }),
      northArrowSouth: (l, c) => ({
        top: a(l, c),
        left: l.left + l.width / 2 - c.width / 2,
        name: "arrow_s",
        ...o && {
          config: o
        }
      }),
      northArrowSouthMiddleEast: (l, c) => ({
        top: a(l, c),
        left: l.left + l.width / 2 - c.width * 0.75 + i,
        name: "arrow_sme",
        ...o && {
          config: o
        }
      }),
      northArrowSouthEast: (l, c) => ({
        top: a(l, c),
        left: l.left + l.width / 2 - c.width + i,
        name: "arrow_se",
        ...o && {
          config: o
        }
      }),
      // ------- North east
      northEastArrowSouthWest: (l, c) => ({
        top: a(l, c),
        left: l.right - i,
        name: "arrow_sw",
        ...o && {
          config: o
        }
      }),
      northEastArrowSouthMiddleWest: (l, c) => ({
        top: a(l, c),
        left: l.right - c.width * 0.25 - i,
        name: "arrow_smw",
        ...o && {
          config: o
        }
      }),
      northEastArrowSouth: (l, c) => ({
        top: a(l, c),
        left: l.right - c.width / 2,
        name: "arrow_s",
        ...o && {
          config: o
        }
      }),
      northEastArrowSouthMiddleEast: (l, c) => ({
        top: a(l, c),
        left: l.right - c.width * 0.75 + i,
        name: "arrow_sme",
        ...o && {
          config: o
        }
      }),
      northEastArrowSouthEast: (l, c) => ({
        top: a(l, c),
        left: l.right - c.width + i,
        name: "arrow_se",
        ...o && {
          config: o
        }
      }),
      // ------- South west
      southWestArrowNorthWest: (l) => ({
        top: u(l),
        left: l.left - i,
        name: "arrow_nw",
        ...o && {
          config: o
        }
      }),
      southWestArrowNorthMiddleWest: (l, c) => ({
        top: u(l),
        left: l.left - c.width * 0.25 - i,
        name: "arrow_nmw",
        ...o && {
          config: o
        }
      }),
      southWestArrowNorth: (l, c) => ({
        top: u(l),
        left: l.left - c.width / 2,
        name: "arrow_n",
        ...o && {
          config: o
        }
      }),
      southWestArrowNorthMiddleEast: (l, c) => ({
        top: u(l),
        left: l.left - c.width * 0.75 + i,
        name: "arrow_nme",
        ...o && {
          config: o
        }
      }),
      southWestArrowNorthEast: (l, c) => ({
        top: u(l),
        left: l.left - c.width + i,
        name: "arrow_ne",
        ...o && {
          config: o
        }
      }),
      // ------- South
      southArrowNorthWest: (l) => ({
        top: u(l),
        left: l.left + l.width / 2 - i,
        name: "arrow_nw",
        ...o && {
          config: o
        }
      }),
      southArrowNorthMiddleWest: (l, c) => ({
        top: u(l),
        left: l.left + l.width / 2 - c.width * 0.25 - i,
        name: "arrow_nmw",
        ...o && {
          config: o
        }
      }),
      southArrowNorth: (l, c) => ({
        top: u(l),
        left: l.left + l.width / 2 - c.width / 2,
        name: "arrow_n",
        ...o && {
          config: o
        }
      }),
      southArrowNorthMiddleEast: (l, c) => ({
        top: u(l),
        left: l.left + l.width / 2 - c.width * 0.75 + i,
        name: "arrow_nme",
        ...o && {
          config: o
        }
      }),
      southArrowNorthEast: (l, c) => ({
        top: u(l),
        left: l.left + l.width / 2 - c.width + i,
        name: "arrow_ne",
        ...o && {
          config: o
        }
      }),
      // ------- South east
      southEastArrowNorthWest: (l) => ({
        top: u(l),
        left: l.right - i,
        name: "arrow_nw",
        ...o && {
          config: o
        }
      }),
      southEastArrowNorthMiddleWest: (l, c) => ({
        top: u(l),
        left: l.right - c.width * 0.25 - i,
        name: "arrow_nmw",
        ...o && {
          config: o
        }
      }),
      southEastArrowNorth: (l, c) => ({
        top: u(l),
        left: l.right - c.width / 2,
        name: "arrow_n",
        ...o && {
          config: o
        }
      }),
      southEastArrowNorthMiddleEast: (l, c) => ({
        top: u(l),
        left: l.right - c.width * 0.75 + i,
        name: "arrow_nme",
        ...o && {
          config: o
        }
      }),
      southEastArrowNorthEast: (l, c) => ({
        top: u(l),
        left: l.right - c.width + i,
        name: "arrow_ne",
        ...o && {
          config: o
        }
      }),
      // ------- West
      westArrowEast: (l, c) => ({
        top: l.top + l.height / 2 - c.height / 2,
        left: l.left - c.width - r,
        name: "arrow_e",
        ...o && {
          config: o
        }
      }),
      // ------- East
      eastArrowWest: (l, c) => ({
        top: l.top + l.height / 2 - c.height / 2,
        left: l.right + r,
        name: "arrow_w",
        ...o && {
          config: o
        }
      }),
      // ------- Sticky
      viewportStickyNorth: (l, c, d, p) => {
        const g = p || d;
        return !l.getIntersection(g) || g.height - l.height > s ? null : {
          top: g.top + s,
          left: l.left + l.width / 2 - c.width / 2,
          name: "arrowless",
          config: {
            withArrow: !1,
            ...o
          }
        };
      }
    };
    function a(l, c) {
      return l.top - c.height - r;
    }
    function u(l) {
      return l.bottom + r;
    }
  }
};
/**
* A side offset of the arrow tip from the edge of the balloon. Controlled by CSS.
*
* ```
*		 ┌───────────────────────┐
*		 │                       │
*		 │         Balloon       │
*		 │         Content       │
*		 │                       │
*		 └──+    +───────────────┘
*		 |   \  /
*		 |    \/
*		>┼─────┼< ─────────────────────── side offset
*
* ```
*
* @default 25
*/
m(Cn, "arrowSideOffset", 25), /**
 * A height offset of the arrow from the edge of the balloon. Controlled by CSS.
 *
 * ```
 *		 ┌───────────────────────┐
 *		 │                       │
 *		 │         Balloon       │
 *		 │         Content       │      ╱-- arrow height offset
 *		 │                       │      V
 *		 └──+    +───────────────┘ --- ─┼───────
 *		     \  /                       │
 *		      \/                        │
 *		────────────────────────────────┼───────
 *		                                ^
 *
 *
 *		>┼────┼<  arrow height offset
 *		 │    │
 *		 │    ┌────────────────────────┐
 *		 │    │                        │
 *		 │   ╱                         │
 *		 │ ╱            Balloon        │
 *		 │ ╲            Content        │
 *		 │   ╲                         │
 *		 │    │                        │
 *		 │    └────────────────────────┘
 * ```
 *
 * @default 10
*/
m(Cn, "arrowHeightOffset", 10), /**
* A vertical offset of the balloon panel from the edge of the viewport if sticky.
* It helps in accessing toolbar buttons underneath the balloon panel.
*
* ```
*		  ┌───────────────────────────────────────────────────┐
*		  │                      Target                       │
*		  │                                                   │
*		  │                            /── vertical offset    │
*		┌─────────────────────────────V─────────────────────────┐
*		│ Toolbar            ┌─────────────┐                    │
*		├────────────────────│   Balloon   │────────────────────┤
*		│ │                  └─────────────┘                  │ │
*		│ │                                                   │ │
*		│ │                                                   │ │
*		│ │                                                   │ │
*		│ └───────────────────────────────────────────────────┘ │
*		│                        Viewport                       │
*		└───────────────────────────────────────────────────────┘
* ```
*
* @default 20
*/
m(Cn, "stickyVerticalOffset", 20), /**
* Function used to calculate the optimal position for the balloon.
*/
m(Cn, "_getOptimalPosition", Hf), /**
* A default set of positioning functions used by the balloon panel view
* when attaching using the {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView#attachTo} method.
*
* The available positioning functions are as follows:
*
* **North west**
*
* * `northWestArrowSouthWest`
*
* ```
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
*		 V
*		 [ Target ]
* ```
*
* * `northWestArrowSouthMiddleWest`
*
* ```
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
*		    V
*		    [ Target ]
* ```
*
* * `northWestArrowSouth`
*
* ```
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
*		         V
*		         [ Target ]
* ```
*
* * `northWestArrowSouthMiddleEast`
*
* ```
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
*		             V
*		             [ Target ]
* ```
*
* * `northWestArrowSouthEast`
*
* ```
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
*		                 V
*		                 [ Target ]
* ```
*
* **North**
*
* * `northArrowSouthWest`
*
* ```
*		    +-----------------+
*		    |     Balloon     |
*		    +-----------------+
*		     V
*		[ Target ]
* ```
*
* * `northArrowSouthMiddleWest`
*
* ```
*		 +-----------------+
*		 |     Balloon     |
*		 +-----------------+
*		     V
*		[ Target ]
* ```
* * `northArrowSouth`
*
* ```
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
*		         V
*		    [ Target ]
* ```
*
* * `northArrowSouthMiddleEast`
*
* ```
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
*		             V
*		        [ Target ]
* ```
*
* * `northArrowSouthEast`
*
* ```
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
*		                V
*		           [ Target ]
* ```
*
* **North east**
*
* * `northEastArrowSouthWest`
*
* ```
*		        +-----------------+
*		        |     Balloon     |
*		        +-----------------+
*		         V
*		[ Target ]
* ```
*
* * `northEastArrowSouthMiddleWest`
*
* ```
*		     +-----------------+
*		     |     Balloon     |
*		     +-----------------+
*		         V
*		[ Target ]
* ```
*
* * `northEastArrowSouth`
*
* ```
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
*		         V
*		[ Target ]
* ```
*
* * `northEastArrowSouthMiddleEast`
*
* ```
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
*		             V
*		    [ Target ]
* ```
*
* * `northEastArrowSouthEast`
*
* ```
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
*		                 V
*		        [ Target ]
* ```
*
* **South**
*
* * `southArrowNorthWest`
*
* ```
*		[ Target ]
*		     ^
*		    +-----------------+
*		    |     Balloon     |
*		    +-----------------+
* ```
*
* * `southArrowNorthMiddleWest`
*
* ```
*		   [ Target ]
*		        ^
*		    +-----------------+
*		    |     Balloon     |
*		    +-----------------+
* ```
*
* * `southArrowNorth`
*
* ```
*		    [ Target ]
*		         ^
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
* ```
*
* * `southArrowNorthMiddleEast`
*
* ```
*		            [ Target ]
*		                 ^
*		   +-----------------+
*		   |     Balloon     |
*		   +-----------------+
* ```
*
* * `southArrowNorthEast`
*
* ```
*		            [ Target ]
*		                 ^
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
* ```
*
* **South west**
*
* * `southWestArrowNorthWest`
*
*
* ```
*		 [ Target ]
*		 ^
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
* ```
*
* * `southWestArrowNorthMiddleWest`
*
* ```
*		     [ Target ]
*		     ^
*		 +-----------------+
*		 |     Balloon     |
*		 +-----------------+
* ```
*
* * `southWestArrowNorth`
*
* ```
*		         [ Target ]
*		         ^
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
* ```
*
* * `southWestArrowNorthMiddleEast`
*
* ```
*		              [ Target ]
*		              ^
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
* ```
*
* * `southWestArrowNorthEast`
*
* ```
*		                 [ Target ]
*		                 ^
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
* ```
*
* **South east**
*
* * `southEastArrowNorthWest`
*
* ```
*		[ Target ]
*		         ^
*		        +-----------------+
*		        |     Balloon     |
*		        +-----------------+
* ```
*
* * `southEastArrowNorthMiddleWest`
*
* ```
*		   [ Target ]
*		            ^
*		        +-----------------+
*		        |     Balloon     |
*		        +-----------------+
* ```
*
* * `southEastArrowNorth`
*
* ```
*		[ Target ]
*		         ^
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
* ```
*
* * `southEastArrowNorthMiddleEast`
*
* ```
*		     [ Target ]
*		              ^
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
* ```
*
* * `southEastArrowNorthEast`
*
* ```
*		        [ Target ]
*		                 ^
*		+-----------------+
*		|     Balloon     |
*		+-----------------+
* ```
*
* **West**
*
* * `westArrowEast`
*
* ```
*		+-----------------+
*		|     Balloon     |>[ Target ]
*		+-----------------+
* ```
*
* **East**
*
* * `eastArrowWest`
*
* ```
*		           +-----------------+
*		[ Target ]<|     Balloon     |
*		           +-----------------+
* ```
*
* **Sticky**
*
* * `viewportStickyNorth`
*
* ```
*		    +---------------------------+
*		    |        [ Target ]         |
*		    |                           |
*		+-----------------------------------+
*		|   |    +-----------------+    |   |
*		|   |    |     Balloon     |    |   |
*		|   |    +-----------------+    |   |
*		|   |                           |   |
*		|   |                           |   |
*		|   |                           |   |
*		|   |                           |   |
*		|   +---------------------------+   |
*		|             Viewport              |
*		+-----------------------------------+
* ```
*
* See {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView#attachTo}.
*
* Positioning functions must be compatible with {@link module:utils/dom/position~DomPoint}.
*
* Default positioning functions with customized offsets can be generated using
* {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView.generatePositions}.
*
* The name that the position function returns will be reflected in the balloon panel's class that
* controls the placement of the "arrow". See {@link #position} to learn more.
*/
m(Cn, "defaultPositions", /* @__PURE__ */ Cn.generatePositions());
let io = Cn;
function Ju(e) {
  return Er(e) ? e : tc(e) ? e.commonAncestorContainer : typeof e == "function" ? Ju(e()) : null;
}
class qT extends me {
  /**
  * @inheritDoc
  */
  constructor(n) {
    super(n), this.setTemplate({
      tag: "span",
      attributes: {
        class: [
          "ck",
          "ck-toolbar__separator"
        ]
      }
    });
  }
}
class j5 extends me {
  /**
  * @inheritDoc
  */
  constructor(n) {
    super(n), this.setTemplate({
      tag: "span",
      attributes: {
        class: [
          "ck",
          "ck-toolbar__line-break"
        ]
      }
    });
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function K5(e) {
  return e.bindTemplate.to((n) => {
    n.target === e.element && n.preventDefault();
  });
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function YT(e) {
  if (Array.isArray(e))
    return {
      items: e,
      removeItems: []
    };
  const n = {
    items: [],
    removeItems: []
  };
  return e ? {
    ...n,
    ...e
  } : n;
}
const G5 = {
  alignLeft: Ge.alignLeft,
  bold: Ge.bold,
  importExport: Ge.importExport,
  paragraph: Ge.paragraph,
  plus: Ge.plus,
  text: Ge.text,
  threeVerticalDots: Ge.threeVerticalDots,
  pilcrow: Ge.pilcrow,
  dragIndicator: Ge.dragIndicator
};
class jT extends me {
  /**
  * Creates an instance of the {@link module:ui/toolbar/toolbarview~ToolbarView} class.
  *
  * Also see {@link #render}.
  *
  * @param locale The localization services instance.
  * @param options Configuration options of the toolbar.
  */
  constructor(t, i) {
    super(t);
    /**
    * A reference to the options object passed to the constructor.
    */
    m(this, "options");
    /**
    * A collection of toolbar items (buttons, dropdowns, etc.).
    */
    m(this, "items");
    /**
    * Tracks information about the DOM focus in the toolbar.
    */
    m(this, "focusTracker");
    /**
    * An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}
    * to handle keyboard navigation in the toolbar.
    */
    m(this, "keystrokes");
    /**
    * A (child) view containing {@link #items toolbar items}.
    */
    m(this, "itemsView");
    /**
    * A top–level collection aggregating building blocks of the toolbar.
    *
    *	┌───────────────── ToolbarView ─────────────────┐
    *	| ┌──────────────── #children ────────────────┐ |
    *	| |   ┌──────────── #itemsView ───────────┐   | |
    *	| |   | [ item1 ] [ item2 ] ... [ itemN ] |   | |
    *	| |   └──────────────────────────────────-┘   | |
    *	| └───────────────────────────────────────────┘ |
    *	└───────────────────────────────────────────────┘
    *
    * By default, it contains the {@link #itemsView} but it can be extended with additional
    * UI elements when necessary.
    */
    m(this, "children");
    /**
    * A collection of {@link #items} that take part in the focus cycling
    * (i.e. navigation using the keyboard). Usually, it contains a subset of {@link #items} with
    * some optional UI elements that also belong to the toolbar and should be focusable
    * by the user.
    */
    m(this, "focusables");
    /**
    * Helps cycling over {@link #focusables focusable items} in the toolbar.
    */
    m(this, "_focusCycler");
    /**
    * An instance of the active toolbar behavior that shapes its look and functionality.
    *
    * See {@link module:ui/toolbar/toolbarview~ToolbarBehavior} to learn more.
    */
    m(this, "_behavior");
    const r = this.bindTemplate, s = this.t;
    this.options = i || {}, this.set("ariaLabel", s("Editor toolbar")), this.set("maxWidth", "auto"), this.set("role", "toolbar"), this.items = this.createCollection(), this.focusTracker = new Ln(), this.keystrokes = new Ii(), this.set("class", void 0), this.set("isCompact", !1), this.itemsView = new Q5(t), this.children = this.createCollection(), this.children.add(this.itemsView), this.focusables = this.createCollection();
    const o = t.uiLanguageDirection === "rtl";
    this._focusCycler = new hs({
      focusables: this.focusables,
      focusTracker: this.focusTracker,
      keystrokeHandler: this.keystrokes,
      actions: {
        // Navigate toolbar items backwards using the arrow[left,up] keys.
        focusPrevious: [
          o ? "arrowright" : "arrowleft",
          "arrowup"
        ],
        // Navigate toolbar items forwards using the arrow[right,down] keys.
        focusNext: [
          o ? "arrowleft" : "arrowright",
          "arrowdown"
        ]
      }
    });
    const a = [
      "ck",
      "ck-toolbar",
      r.to("class"),
      r.if("isCompact", "ck-toolbar_compact")
    ];
    this.options.shouldGroupWhenFull && this.options.isFloating && a.push("ck-toolbar_floating"), this.setTemplate({
      tag: "div",
      attributes: {
        class: a,
        role: r.to("role"),
        "aria-label": r.to("ariaLabel"),
        style: {
          maxWidth: r.to("maxWidth")
        },
        tabindex: -1
      },
      children: this.children,
      on: {
        // https://github.com/ckeditor/ckeditor5-ui/issues/206
        mousedown: K5(this)
      }
    }), this._behavior = this.options.shouldGroupWhenFull ? new J5(this) : new X5(this);
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.focusTracker.add(this.element);
    for (const t of this.items)
      this.focusTracker.add(t);
    this.items.on("add", (t, i) => {
      this.focusTracker.add(i);
    }), this.items.on("remove", (t, i) => {
      this.focusTracker.remove(i);
    }), this.keystrokes.listenTo(this.element), this._behavior.render(this);
  }
  /**
  * @inheritDoc
  */
  destroy() {
    return this._behavior.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy(), super.destroy();
  }
  /**
  * Focuses the first focusable in {@link #focusables}.
  */
  focus() {
    this._focusCycler.focusFirst();
  }
  /**
  * Focuses the last focusable in {@link #focusables}.
  */
  focusLast() {
    this._focusCycler.focusLast();
  }
  /**
  * A utility that expands the plain toolbar configuration into
  * {@link module:ui/toolbar/toolbarview~ToolbarView#items} using a given component factory.
  *
  * @param itemsOrConfig The toolbar items or the entire toolbar configuration object.
  * @param factory A factory producing toolbar items.
  * @param removeItems An array of items names to be removed from the configuration. When present, applies
  * to this toolbar and all nested ones as well.
  */
  fillFromConfig(t, i, r) {
    this.items.addMany(this._buildItemsFromConfig(t, i, r));
  }
  /**
  * A utility that expands the plain toolbar configuration into a list of view items using a given component factory.
  *
  * @param itemsOrConfig The toolbar items or the entire toolbar configuration object.
  * @param factory A factory producing toolbar items.
  * @param removeItems An array of items names to be removed from the configuration. When present, applies
  * to this toolbar and all nested ones as well.
  */
  _buildItemsFromConfig(t, i, r) {
    const s = YT(t), o = r || s.removeItems;
    return this._cleanItemsConfiguration(s.items, i, o).map((u) => ft(u) ? this._createNestedToolbarDropdown(u, i, o) : u === "|" ? new qT() : u === "-" ? new j5() : i.create(u)).filter((u) => !!u);
  }
  /**
  * Cleans up the {@link module:ui/toolbar/toolbarview~ToolbarView#items} of the toolbar by removing unwanted items and
  * duplicated (obsolete) separators or line breaks.
  *
  * @param items The toolbar items configuration.
  * @param factory A factory producing toolbar items.
  * @param removeItems An array of items names to be removed from the configuration.
  * @returns Items after the clean-up.
  */
  _cleanItemsConfiguration(t, i, r) {
    const s = t.filter((o, a, u) => o === "|" ? !0 : r.indexOf(o) !== -1 ? !1 : o === "-" ? this.options.shouldGroupWhenFull ? (at("toolbarview-line-break-ignored-when-grouping-items", u), !1) : !0 : !ft(o) && !i.has(o) ? (at("toolbarview-item-unavailable", {
      item: o
    }), !1) : !0);
    return this._cleanSeparatorsAndLineBreaks(s);
  }
  /**
  * Remove leading, trailing, and duplicated separators (`-` and `|`).
  *
  * @returns Toolbar items after the separator and line break clean-up.
  */
  _cleanSeparatorsAndLineBreaks(t) {
    const i = (a) => a !== "-" && a !== "|", r = t.length, s = t.findIndex(i);
    if (s === -1)
      return [];
    const o = r - t.slice().reverse().findIndex(i);
    return t.slice(s, o).filter((a, u, l) => i(a) ? !0 : !(u > 0 && l[u - 1] === a));
  }
  /**
  * Creates a user-defined dropdown containing a toolbar with items.
  *
  * @param definition A definition of the nested toolbar dropdown.
  * @param definition.label A label of the dropdown.
  * @param definition.icon An icon of the drop-down. One of 'bold', 'plus', 'text', 'importExport', 'alignLeft',
  * 'paragraph' or an SVG string. When `false` is passed, no icon will be used.
  * @param definition.withText When set `true`, the label of the dropdown will be visible. See
  * {@link module:ui/button/buttonview~ButtonView#withText} to learn more.
  * @param definition.tooltip A tooltip of the dropdown button. See
  * {@link module:ui/button/buttonview~ButtonView#tooltip} to learn more. Defaults to `true`.
  * @param componentFactory Component factory used to create items
  * of the nested toolbar.
  */
  _createNestedToolbarDropdown(t, i, r) {
    let { label: s, icon: o, items: a, tooltip: u = !0, withText: l = !1 } = t;
    if (a = this._cleanItemsConfiguration(a, i, r), !a.length)
      return null;
    const c = this.locale, d = ac(c);
    return s || at("toolbarview-nested-toolbar-dropdown-missing-label", t), d.class = "ck-toolbar__nested-toolbar-dropdown", d.buttonView.set({
      label: s,
      tooltip: u,
      withText: !!l
    }), o !== !1 ? d.buttonView.icon = G5[o] || o || Ge.threeVerticalDots : d.buttonView.withText = !0, um(d, () => d.toolbarView._buildItemsFromConfig(a, i, r)), d;
  }
}
class Q5 extends me {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * A collection of items (buttons, dropdowns, etc.).
    */
    m(this, "children");
    this.children = this.createCollection(), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-toolbar__items"
        ]
      },
      children: this.children
    });
  }
}
class X5 {
  /**
  * Creates an instance of the {@link module:ui/toolbar/toolbarview~StaticLayout} toolbar
  * behavior.
  *
  * @param view An instance of the toolbar that this behavior is added to.
  */
  constructor(n) {
    const t = n.bindTemplate;
    n.set("isVertical", !1), n.itemsView.children.bindTo(n.items).using((i) => i), n.focusables.bindTo(n.items).using((i) => ru(i) ? i : null), n.extendTemplate({
      attributes: {
        class: [
          // When vertical, the toolbar has an additional CSS class.
          t.if("isVertical", "ck-toolbar_vertical")
        ]
      }
    });
  }
  /**
  * @inheritDoc
  */
  render() {
  }
  /**
  * @inheritDoc
  */
  destroy() {
  }
}
class J5 {
  /**
  * Creates an instance of the {@link module:ui/toolbar/toolbarview~DynamicGrouping} toolbar
  * behavior.
  *
  * @param view An instance of the toolbar that this behavior is added to.
  */
  constructor(n) {
    /**
    * A toolbar view this behavior belongs to.
    */
    m(this, "view");
    /**
    * A collection of toolbar children.
    */
    m(this, "viewChildren");
    /**
    * A collection of focusable toolbar elements.
    */
    m(this, "viewFocusables");
    /**
    * A view containing toolbar items.
    */
    m(this, "viewItemsView");
    /**
    * Toolbar focus tracker.
    */
    m(this, "viewFocusTracker");
    /**
    * Toolbar locale.
    */
    m(this, "viewLocale");
    /**
    * A subset of toolbar {@link module:ui/toolbar/toolbarview~ToolbarView#items}.
    * Aggregates items that fit into a single row of the toolbar and were not {@link #groupedItems grouped}
    * into a {@link #groupedItemsDropdown dropdown}. Items of this collection are displayed in the
    * {@link module:ui/toolbar/toolbarview~ToolbarView#itemsView}.
    *
    * When none of the {@link module:ui/toolbar/toolbarview~ToolbarView#items} were grouped, it
    * matches the {@link module:ui/toolbar/toolbarview~ToolbarView#items} collection in size and order.
    */
    m(this, "ungroupedItems");
    /**
    * A subset of toolbar {@link module:ui/toolbar/toolbarview~ToolbarView#items}.
    * A collection of the toolbar items that do not fit into a single row of the toolbar.
    * Grouped items are displayed in a dedicated {@link #groupedItemsDropdown dropdown}.
    *
    * When none of the {@link module:ui/toolbar/toolbarview~ToolbarView#items} were grouped,
    * this collection is empty.
    */
    m(this, "groupedItems");
    /**
    * The dropdown that aggregates {@link #groupedItems grouped items} that do not fit into a single
    * row of the toolbar. It is displayed on demand as the last of
    * {@link module:ui/toolbar/toolbarview~ToolbarView#children toolbar children} and offers another
    * (nested) toolbar which displays items that would normally overflow.
    */
    m(this, "groupedItemsDropdown");
    /**
    * An instance of the resize observer that helps dynamically determine the geometry of the toolbar
    * and manage items that do not fit into a single row.
    *
    * **Note:** Created in {@link #_enableGroupingOnResize}.
    *
    * @readonly
    */
    m(this, "resizeObserver", null);
    /**
    * A cached value of the horizontal padding style used by {@link #_updateGrouping}
    * to manage the {@link module:ui/toolbar/toolbarview~ToolbarView#items} that do not fit into
    * a single toolbar line. This value can be reused between updates because it is unlikely that
    * the padding will change and re–using `Window.getComputedStyle()` is expensive.
    *
    * @readonly
    */
    m(this, "cachedPadding", null);
    /**
    * A flag indicating that an items grouping update has been queued (e.g. due to the toolbar being visible)
    * and should be executed immediately the next time the toolbar shows up.
    *
    * @readonly
    */
    m(this, "shouldUpdateGroupingOnNextResize", !1);
    /**
    * Toolbar element.
    *
    * @readonly
    */
    m(this, "viewElement");
    this.view = n, this.viewChildren = n.children, this.viewFocusables = n.focusables, this.viewItemsView = n.itemsView, this.viewFocusTracker = n.focusTracker, this.viewLocale = n.locale, this.ungroupedItems = n.createCollection(), this.groupedItems = n.createCollection(), this.groupedItemsDropdown = this._createGroupedItemsDropdown(), n.itemsView.children.bindTo(this.ungroupedItems).using((t) => t), this.ungroupedItems.on("change", this._updateFocusCyclableItems.bind(this)), n.children.on("change", this._updateFocusCyclableItems.bind(this)), n.items.on("change", (t, i) => {
      const r = i.index, s = Array.from(i.added);
      for (const o of i.removed)
        r >= this.ungroupedItems.length ? this.groupedItems.remove(o) : this.ungroupedItems.remove(o);
      for (let o = r; o < r + s.length; o++) {
        const a = s[o - r];
        o > this.ungroupedItems.length ? this.groupedItems.add(a, o - this.ungroupedItems.length) : this.ungroupedItems.add(a, o);
      }
      this._updateGrouping();
    }), n.extendTemplate({
      attributes: {
        class: [
          // To group items dynamically, the toolbar needs a dedicated CSS class.
          "ck-toolbar_grouping"
        ]
      }
    });
  }
  /**
  * Enables dynamic items grouping based on the dimensions of the toolbar.
  *
  * @param view An instance of the toolbar that this behavior is added to.
  */
  render(n) {
    this.viewElement = n.element, this._enableGroupingOnResize(), this._enableGroupingOnMaxWidthChange(n);
  }
  /**
  * Cleans up the internals used by this behavior.
  */
  destroy() {
    this.groupedItemsDropdown.destroy(), this.resizeObserver.destroy();
  }
  /**
  * When called, it will check if any of the {@link #ungroupedItems} do not fit into a single row of the toolbar,
  * and it will move them to the {@link #groupedItems} when it happens.
  *
  * At the same time, it will also check if there is enough space in the toolbar for the first of the
  * {@link #groupedItems} to be returned back to {@link #ungroupedItems} and still fit into a single row
  * without the toolbar wrapping.
  */
  _updateGrouping() {
    if (!this.viewElement.ownerDocument.body.contains(this.viewElement))
      return;
    if (!zi(this.viewElement)) {
      this.shouldUpdateGroupingOnNextResize = !0;
      return;
    }
    const n = this.groupedItems.length;
    let t;
    for (; this._areItemsOverflowing; )
      this._groupLastItem(), t = !0;
    if (!t && this.groupedItems.length) {
      for (; this.groupedItems.length && !this._areItemsOverflowing; )
        this._ungroupFirstItem();
      this._areItemsOverflowing && this._groupLastItem();
    }
    this.groupedItems.length !== n && this.view.fire("groupedItemsUpdate");
  }
  /**
  * Returns `true` when {@link module:ui/toolbar/toolbarview~ToolbarView#element} children visually overflow,
  * for instance if the toolbar is narrower than its members. Returns `false` otherwise.
  */
  get _areItemsOverflowing() {
    if (!this.ungroupedItems.length)
      return !1;
    const n = this.viewElement, t = this.viewLocale.uiLanguageDirection, i = new Se(n.lastChild), r = new Se(n);
    if (!this.cachedPadding) {
      const s = ue.window.getComputedStyle(n), o = t === "ltr" ? "paddingRight" : "paddingLeft";
      this.cachedPadding = Number.parseInt(s[o]);
    }
    return t === "ltr" ? i.right > r.right - this.cachedPadding : i.left < r.left + this.cachedPadding;
  }
  /**
  * Enables the functionality that prevents {@link #ungroupedItems} from overflowing (wrapping to the next row)
  * upon resize when there is little space available. Instead, the toolbar items are moved to the
  * {@link #groupedItems} collection and displayed in a dropdown at the end of the row (which has its own nested toolbar).
  *
  * When called, the toolbar will automatically analyze the location of its {@link #ungroupedItems} and "group"
  * them in the dropdown if necessary. It will also observe the browser window for size changes in
  * the future and respond to them by grouping more items or reverting already grouped back, depending
  * on the visual space available.
  */
  _enableGroupingOnResize() {
    let n;
    this.resizeObserver = new Pa(this.viewElement, (t) => {
      (!n || n !== t.contentRect.width || this.shouldUpdateGroupingOnNextResize) && (this.shouldUpdateGroupingOnNextResize = !1, this._updateGrouping(), n = t.contentRect.width);
    }), this._updateGrouping();
  }
  /**
  * Enables the grouping functionality, just like {@link #_enableGroupingOnResize} but the difference is that
  * it listens to the changes of {@link module:ui/toolbar/toolbarview~ToolbarView#maxWidth} instead.
  */
  _enableGroupingOnMaxWidthChange(n) {
    n.on("change:maxWidth", () => {
      this._updateGrouping();
    });
  }
  /**
  * When called, it will remove the last item from {@link #ungroupedItems} and move it back
  * to the {@link #groupedItems} collection.
  *
  * The opposite of {@link #_ungroupFirstItem}.
  */
  _groupLastItem() {
    this.groupedItems.length || (this.viewChildren.add(new qT()), this.viewChildren.add(this.groupedItemsDropdown), this.viewFocusTracker.add(this.groupedItemsDropdown.element)), this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
  }
  /**
  * Moves the very first item belonging to {@link #groupedItems} back
  * to the {@link #ungroupedItems} collection.
  *
  * The opposite of {@link #_groupLastItem}.
  */
  _ungroupFirstItem() {
    this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first)), this.groupedItems.length || (this.viewChildren.remove(this.groupedItemsDropdown), this.viewChildren.remove(this.viewChildren.last), this.viewFocusTracker.remove(this.groupedItemsDropdown.element));
  }
  /**
  * Creates the {@link #groupedItemsDropdown} that hosts the members of the {@link #groupedItems}
  * collection when there is not enough space in the toolbar to display all items in a single row.
  */
  _createGroupedItemsDropdown() {
    const n = this.viewLocale, t = n.t, i = ac(n);
    return i.class = "ck-toolbar__grouped-dropdown", i.panelPosition = n.uiLanguageDirection === "ltr" ? "sw" : "se", um(i, this.groupedItems), i.buttonView.set({
      label: t("Show more items"),
      tooltip: !0,
      tooltipPosition: n.uiLanguageDirection === "rtl" ? "se" : "sw",
      icon: Ge.threeVerticalDots
    }), i;
  }
  /**
  * Updates the {@link module:ui/toolbar/toolbarview~ToolbarView#focusables focus–cyclable items}
  * collection so it represents the up–to–date state of the UI from the perspective of the user.
  *
  * For instance, the {@link #groupedItemsDropdown} can show up and hide but when it is visible,
  * it must be subject to focus cycling in the toolbar.
  *
  * See the {@link module:ui/toolbar/toolbarview~ToolbarView#focusables collection} documentation
  * to learn more about the purpose of this method.
  */
  _updateFocusCyclableItems() {
    this.viewFocusables.clear(), this.ungroupedItems.map((n) => {
      ru(n) && this.viewFocusables.add(n);
    }), this.groupedItems.length && this.viewFocusables.add(this.groupedItemsDropdown);
  }
}
class Z5 extends me {
  /**
  * @inheritDoc
  */
  constructor(t, i) {
    super(t);
    /**
    * Collection of the child views inside of the split button {@link #element}.
    */
    m(this, "children");
    /**
    * A main button of split button.
    */
    m(this, "actionView");
    /**
    * A secondary button of split button that opens dropdown.
    */
    m(this, "arrowView");
    /**
    * Instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}. It manages
    * keystrokes of the split button:
    *
    * * <kbd>▶</kbd> moves focus to arrow view when action view is focused,
    * * <kbd>◀</kbd> moves focus to action view when arrow view is focused.
    */
    m(this, "keystrokes");
    /**
    * Tracks information about DOM focus in the dropdown.
    */
    m(this, "focusTracker");
    const r = this.bindTemplate;
    this.set("class", void 0), this.set("labelStyle", void 0), this.set("icon", void 0), this.set("isEnabled", !0), this.set("isOn", !1), this.set("isToggleable", !1), this.set("isVisible", !0), this.set("keystroke", void 0), this.set("withKeystroke", !1), this.set("label", void 0), this.set("tabindex", -1), this.set("tooltip", !1), this.set("tooltipPosition", "s"), this.set("type", "button"), this.set("withText", !1), this.children = this.createCollection(), this.actionView = this._createActionView(i), this.arrowView = this._createArrowView(), this.keystrokes = new Ii(), this.focusTracker = new Ln(), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-splitbutton",
          r.to("class"),
          r.if("isVisible", "ck-hidden", (s) => !s),
          this.arrowView.bindTemplate.if("isOn", "ck-splitbutton_open")
        ]
      },
      children: this.children
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.children.add(this.actionView), this.children.add(this.arrowView), this.focusTracker.add(this.actionView.element), this.focusTracker.add(this.arrowView.element), this.keystrokes.listenTo(this.element), this.keystrokes.set("arrowright", (t, i) => {
      this.focusTracker.focusedElement === this.actionView.element && (this.arrowView.focus(), i());
    }), this.keystrokes.set("arrowleft", (t, i) => {
      this.focusTracker.focusedElement === this.arrowView.element && (this.actionView.focus(), i());
    });
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
  }
  /**
  * Focuses the {@link module:ui/button/buttonview~ButtonView#element} of the action part of split button.
  */
  focus() {
    this.actionView.focus();
  }
  /**
  * Creates a {@link module:ui/button/buttonview~ButtonView} instance as {@link #actionView} and binds it with main split button
  * attributes.
  */
  _createActionView(t) {
    const i = t || new gt();
    return t || i.bind("icon", "isEnabled", "isOn", "isToggleable", "keystroke", "label", "tabindex", "tooltip", "tooltipPosition", "type", "withText").to(this), i.extendTemplate({
      attributes: {
        class: "ck-splitbutton__action"
      }
    }), i.delegate("execute").to(this), i;
  }
  /**
  * Creates a {@link module:ui/button/buttonview~ButtonView} instance as {@link #arrowView} and binds it with main split button
  * attributes.
  */
  _createArrowView() {
    const t = new gt(), i = t.bindTemplate;
    return t.icon = om, t.extendTemplate({
      attributes: {
        class: [
          "ck-splitbutton__arrow"
        ],
        "data-cke-tooltip-disabled": i.to("isOn"),
        "aria-haspopup": !0,
        "aria-expanded": i.to("isOn", (r) => String(r))
      }
    }), t.bind("isEnabled").to(this), t.bind("label").to(this), t.bind("tooltip").to(this), t.delegate("execute").to(this, "open"), t;
  }
}
function ac(e, n = q5) {
  const t = typeof n == "function" ? new n(e) : n, i = new z5(e), r = new Hh(e, t, i);
  return t.bind("isEnabled").to(r), t instanceof Z5 ? t.arrowView.bind("isOn").to(r, "isOpen") : t.bind("isOn").to(r, "isOpen"), t4(r), r;
}
function um(e, n, t = {}) {
  e.extendTemplate({
    attributes: {
      class: [
        "ck-toolbar-dropdown"
      ]
    }
  }), e.isOpen ? cg(e, n, t) : e.once("change:isOpen", () => cg(e, n, t), {
    priority: "highest"
  }), t.enableActiveItemFocusOnDropdownOpen && KT(e, () => e.toolbarView.items.find((i) => i.isOn));
}
function cg(e, n, t) {
  const i = e.locale, r = i.t, s = e.toolbarView = new jT(i), o = typeof n == "function" ? n() : n;
  s.ariaLabel = t.ariaLabel || r("Dropdown toolbar"), t.maxWidth && (s.maxWidth = t.maxWidth), t.class && (s.class = t.class), t.isCompact && (s.isCompact = t.isCompact), t.isVertical && (s.isVertical = !0), o instanceof Ji ? s.items.bindTo(o).using((a) => a) : s.items.addMany(o), e.panelView.children.add(s), e.focusTracker.add(s), s.items.delegate("execute").to(e);
}
function e4(e, n, t = {}) {
  e.isOpen ? dg(e, n, t) : e.once("change:isOpen", () => dg(e, n, t), {
    priority: "highest"
  }), KT(e, () => e.listView.items.find((i) => i instanceof qi ? i.children.first.isOn : !1));
}
function dg(e, n, t) {
  const i = e.locale, r = e.listView = new oc(i), s = typeof n == "function" ? n() : n;
  r.ariaLabel = t.ariaLabel, r.role = t.role, QT(e, r.items, s, i), e.panelView.children.add(r), r.items.delegate("execute").to(e);
}
function KT(e, n) {
  e.on("change:isOpen", () => {
    if (!e.isOpen)
      return;
    const t = n();
    t && (typeof t.focus == "function" ? t.focus() : at("ui-dropdown-focus-child-on-open-child-missing-focus", {
      view: t
    }));
  }, {
    priority: pr.low - 10
  });
}
function t4(e) {
  n4(e), i4(e), r4(e), s4(e), o4(e), a4(e);
}
function n4(e) {
  rc({
    emitter: e,
    activator: () => e.isRendered && e.isOpen,
    callback: () => {
      e.isOpen = !1;
    },
    contextElements: () => [
      e.element,
      // Include all elements connected to the dropdown's focus tracker, but exclude those that are direct children
      // of DropdownView#element. They would be identified as descendants of #element anyway upon clicking and would
      // not contribute to the logic.
      ...GT(e.focusTracker).filter((n) => !e.element.contains(n))
    ]
  });
}
function GT(e) {
  return [
    ...e.elements,
    ...e.externalViews.flatMap((n) => GT(n.focusTracker))
  ];
}
function i4(e) {
  e.on("execute", (n) => {
    n.source instanceof sm || (e.isOpen = !1);
  });
}
function r4(e) {
  e.focusTracker.on("change:isFocused", (n, t, i) => {
    i || !e.isOpen || (e.isOpen = !1);
  });
}
function s4(e) {
  e.keystrokes.set("arrowdown", (n, t) => {
    e.isOpen && (e.panelView.focus(), t());
  }), e.keystrokes.set("arrowup", (n, t) => {
    e.isOpen && (e.panelView.focusLast(), t());
  });
}
function o4(e) {
  e.on("change:isOpen", (n, t, i) => {
    if (i)
      return;
    e.focusTracker.elements.some((s) => s.contains(ue.document.activeElement)) && e.buttonView.focus();
  });
}
function a4(e) {
  e.on("change:isOpen", (n, t, i) => {
    i && e.panelView.focus();
  }, {
    priority: "low"
  });
}
function QT(e, n, t, i) {
  n.on("change", () => {
    const r = [
      ...n
    ].reduce((o, a) => (a instanceof qi && a.children.first instanceof no && o.push(a.children.first), o), []), s = r.some((o) => o.isToggleable);
    r.forEach((o) => {
      o.hasCheckSpace = s;
    });
  }), n.bindTo(t).using((r) => {
    if (r.type === "separator")
      return new am(i);
    if (r.type === "group") {
      const s = new Xu(i);
      return s.set({
        label: r.label
      }), QT(e, s.items, r.items, i), s.items.delegate("execute").to(e), s;
    } else if (r.type === "button" || r.type === "switchbutton") {
      const s = r.model.role === "menuitemcheckbox" || r.model.role === "menuitemradio", o = new qi(i);
      let a;
      return r.type === "button" ? (a = new no(i), a.set({
        isToggleable: s
      })) : a = new sm(i), a.bind(...Object.keys(r.model)).to(r.model), a.delegate("execute").to(o), o.children.add(a), o;
    }
    return null;
  });
}
const u4 = (e, n, t) => {
  const i = new W5(e.locale);
  return i.set({
    id: n,
    ariaDescribedById: t
  }), i.bind("isReadOnly").to(e, "isEnabled", (r) => !r), i.bind("hasError").to(e, "errorText", (r) => !!r), i.on("input", () => {
    e.errorText = null;
  }), e.bind("isEmpty", "isFocused", "placeholder").to(i), i;
};
class l4 {
  /**
  * Creates an instance of the factory.
  *
  * @param editor The editor instance.
  */
  constructor(n) {
    /**
    * The editor instance that the factory belongs to.
    */
    m(this, "editor");
    /**
    * Registered component factories.
    */
    m(this, "_components", /* @__PURE__ */ new Map());
    this.editor = n;
  }
  /**
  * Returns an iterator of registered component names. Names are returned in lower case.
  */
  *names() {
    for (const n of this._components.values())
      yield n.originalName;
  }
  /**
  * Registers a component factory function that will be used by the
  * {@link #create create} method and called with the
  * {@link module:core/editor/editor~Editor#locale editor locale} as an argument,
  * allowing localization of the {@link module:ui/view~View view}.
  *
  * @param name The name of the component.
  * @param callback The callback that returns the component.
  */
  add(n, t) {
    this._components.set(bd(n), {
      callback: t,
      originalName: n
    });
  }
  /**
  * Creates an instance of a component registered in the factory under a specific name.
  *
  * When called, the {@link module:core/editor/editor~Editor#locale editor locale} is passed to
  * the previously {@link #add added} factory function, allowing localization of the
  * {@link module:ui/view~View view}.
  *
  * @param name The name of the component.
  * @returns The instantiated component view.
  */
  create(n) {
    if (!this.has(n))
      throw new v("componentfactory-item-missing", this, {
        name: n
      });
    return this._components.get(bd(n)).callback(this.editor.locale);
  }
  /**
  * Checks if a component of a given name is registered in the factory.
  *
  * @param name The name of the component.
  */
  has(n) {
    return this._components.has(bd(n));
  }
}
function bd(e) {
  return String(e).toLowerCase();
}
const hg = "ck-tooltip", Ht = class Ht extends (/* @__PURE__ */ li()) {
  /**
  * Creates an instance of the tooltip manager.
  */
  constructor(t) {
    super();
    /**
    * The view rendering text of the tooltip.
    */
    m(this, "tooltipTextView");
    /**
    * The instance of the balloon panel that renders and positions the tooltip.
    */
    m(this, "balloonPanelView");
    /**
    * Stores the reference to the DOM element the tooltip is attached to. `null` when there's no tooltip
    * in the UI.
    */
    m(this, "_currentElementWithTooltip", null);
    /**
    * Stores the current tooltip position. `null` when there's no tooltip in the UI.
    */
    m(this, "_currentTooltipPosition", null);
    /**
    * An instance of the mutation observer that keeps track on target element attributes changes.
    */
    m(this, "_mutationObserver", null);
    /**
    * A debounced version of {@link #_pinTooltip}. Tooltips show with a delay to avoid flashing and
    * to improve the UX.
    */
    m(this, "_pinTooltipDebounced");
    /**
    * A debounced version of {@link #_unpinTooltip}. Tooltips hide with a delay to allow hovering of their titles.
    */
    m(this, "_unpinTooltipDebounced");
    m(this, "_watchdogExcluded");
    if (Ht._editors.add(t), Ht._instance)
      return Ht._instance;
    Ht._instance = this, this.tooltipTextView = new me(t.locale), this.tooltipTextView.set("text", ""), this.tooltipTextView.setTemplate({
      tag: "span",
      attributes: {
        class: [
          "ck",
          "ck-tooltip__text"
        ]
      },
      children: [
        {
          text: this.tooltipTextView.bindTemplate.to("text")
        }
      ]
    }), this.balloonPanelView = new io(t.locale), this.balloonPanelView.class = hg, this.balloonPanelView.content.add(this.tooltipTextView), this._mutationObserver = c4(() => {
      this._updateTooltipPosition();
    }), this._pinTooltipDebounced = _r(this._pinTooltip, 600), this._unpinTooltipDebounced = _r(this._unpinTooltip, 400), this.listenTo(ue.document, "keydown", this._onKeyDown.bind(this), {
      useCapture: !0
    }), this.listenTo(ue.document, "mouseenter", this._onEnterOrFocus.bind(this), {
      useCapture: !0
    }), this.listenTo(ue.document, "mouseleave", this._onLeaveOrBlur.bind(this), {
      useCapture: !0
    }), this.listenTo(ue.document, "focus", this._onEnterOrFocus.bind(this), {
      useCapture: !0
    }), this.listenTo(ue.document, "blur", this._onLeaveOrBlur.bind(this), {
      useCapture: !0
    }), this.listenTo(ue.document, "scroll", this._onScroll.bind(this), {
      useCapture: !0
    }), this._watchdogExcluded = !0;
  }
  /**
  * Destroys the tooltip manager.
  *
  * **Note**: The manager singleton cannot be destroyed until all editors that use it are destroyed.
  *
  * @param editor The editor the manager was created for.
  */
  destroy(t) {
    const i = t.ui.view && t.ui.view.body;
    Ht._editors.delete(t), this.stopListening(t.ui), i && i.has(this.balloonPanelView) && i.remove(this.balloonPanelView), Ht._editors.size || (this._unpinTooltip(), this.balloonPanelView.destroy(), this.stopListening(), Ht._instance = null);
  }
  /**
  * Returns {@link #balloonPanelView} {@link module:utils/dom/position~PositioningFunction positioning functions} for a given position
  * name.
  *
  * @param position Name of the position (`s`, `se`, `sw`, `n`, `e`, or `w`).
  * @returns Positioning functions to be used by the {@link #balloonPanelView}.
  */
  static getPositioningFunctions(t) {
    const i = Ht.defaultBalloonPositions;
    return {
      // South is most popular. We can use positioning heuristics to avoid clipping by the viewport with the sane fallback.
      s: [
        i.southArrowNorth,
        i.southArrowNorthEast,
        i.southArrowNorthWest
      ],
      n: [
        i.northArrowSouth
      ],
      e: [
        i.eastArrowWest
      ],
      w: [
        i.westArrowEast
      ],
      sw: [
        i.southArrowNorthEast
      ],
      se: [
        i.southArrowNorthWest
      ]
    }[t];
  }
  /**
  * Handles hiding tooltips on `keydown` in DOM.
  *
  * @param evt An object containing information about the fired event.
  * @param domEvent The DOM event.
  */
  _onKeyDown(t, i) {
    i.key === "Escape" && this._currentElementWithTooltip && (this._unpinTooltip(), i.stopPropagation());
  }
  /**
  * Handles displaying tooltips on `mouseenter` and `focus` in DOM.
  *
  * @param evt An object containing information about the fired event.
  * @param domEvent The DOM event.
  */
  _onEnterOrFocus(t, { target: i }) {
    const r = _d(i);
    if (!r) {
      t.name === "focus" && this._unpinTooltip();
      return;
    }
    if (r === this._currentElementWithTooltip) {
      this._unpinTooltipDebounced.cancel();
      return;
    }
    this._unpinTooltip(), t.name === "focus" && !r.matches(":hover") || r.matches("[data-cke-tooltip-instant]") ? this._pinTooltip(r, Ed(r)) : this._pinTooltipDebounced(r, Ed(r));
  }
  /**
  * Handles hiding tooltips on `mouseleave` and `blur` in DOM.
  *
  * @param evt An object containing information about the fired event.
  * @param domEvent The DOM event.
  */
  _onLeaveOrBlur(t, { target: i, relatedTarget: r }) {
    if (t.name === "mouseleave") {
      if (!Er(i))
        return;
      const s = this.balloonPanelView.element, o = s && (s === r || s.contains(r)), a = !o && i === s;
      if (o) {
        this._unpinTooltipDebounced.cancel();
        return;
      }
      if (!a && this._currentElementWithTooltip && i !== this._currentElementWithTooltip)
        return;
      const u = _d(i), l = _d(r);
      (a || u && u !== l) && (this._pinTooltipDebounced.cancel(), this._currentElementWithTooltip && this._currentElementWithTooltip.matches("[data-cke-tooltip-instant]") || u && u.matches("[data-cke-tooltip-instant]") ? this._unpinTooltip() : this._unpinTooltipDebounced());
    } else {
      if (this._currentElementWithTooltip && i !== this._currentElementWithTooltip)
        return;
      this._pinTooltipDebounced.cancel(), this._unpinTooltipDebounced();
    }
  }
  /**
  * Handles hiding tooltips on `scroll` in DOM.
  *
  * @param evt An object containing information about the fired event.
  * @param domEvent The DOM event.
  */
  _onScroll(t, { target: i }) {
    this._currentElementWithTooltip && (i.contains(this.balloonPanelView.element) && i.contains(this._currentElementWithTooltip) || this._unpinTooltip());
  }
  /**
  * Pins the tooltip to a specific DOM element.
  *
  * @param options.text Text of the tooltip to display.
  * @param options.position The position of the tooltip.
  * @param options.cssClass Additional CSS class of the balloon with the tooltip.
  */
  _pinTooltip(t, { text: i, position: r, cssClass: s }) {
    this._unpinTooltip();
    const o = zn(Ht._editors.values()).ui.view.body;
    o.has(this.balloonPanelView) || o.add(this.balloonPanelView), this.tooltipTextView.text = i, this.balloonPanelView.class = [
      hg,
      s
    ].filter((a) => a).join(" "), this.balloonPanelView.pin({
      target: t,
      positions: Ht.getPositioningFunctions(r)
    }), this._mutationObserver.attach(t);
    for (const a of Ht._editors)
      this.listenTo(a.ui, "update", this._updateTooltipPosition.bind(this), {
        priority: "low"
      });
    this._currentElementWithTooltip = t, this._currentTooltipPosition = r;
  }
  /**
  * Unpins the tooltip and cancels all queued pinning.
  */
  _unpinTooltip() {
    this._unpinTooltipDebounced.cancel(), this._pinTooltipDebounced.cancel(), this.balloonPanelView.unpin();
    for (const t of Ht._editors)
      this.stopListening(t.ui, "update");
    this._currentElementWithTooltip = null, this._currentTooltipPosition = null, this.tooltipTextView.text = "", this._mutationObserver.detach();
  }
  /**
  * Updates the position of the tooltip so it stays in sync with the element it is pinned to.
  *
  * Hides the tooltip when the element is no longer visible in DOM or the tooltip text was removed.
  */
  _updateTooltipPosition() {
    if (!this._currentElementWithTooltip)
      return;
    const t = Ed(this._currentElementWithTooltip);
    if (!zi(this._currentElementWithTooltip) || !t.text) {
      this._unpinTooltip();
      return;
    }
    this.balloonPanelView.pin({
      target: this._currentElementWithTooltip,
      positions: Ht.getPositioningFunctions(t.position)
    });
  }
};
/**
* A set of default {@link module:utils/dom/position~PositioningFunction positioning functions} used by the `TooltipManager`
* to pin tooltips in different positions.
*/
m(Ht, "defaultBalloonPositions", /* @__PURE__ */ io.generatePositions({
  heightOffset: 5,
  sideOffset: 13
})), /**
* A set of editors the single tooltip manager instance must listen to.
* This is mostly to handle `EditorUI#update` listeners from individual editors.
*/
m(Ht, "_editors", /* @__PURE__ */ new Set()), /**
* A reference to the `TooltipManager` instance. The class is a singleton and as such,
* successive attempts at creating instances should return this instance.
*/
m(Ht, "_instance", null);
let Vh = Ht;
function _d(e) {
  return Er(e) ? e.closest("[data-cke-tooltip-text]:not([data-cke-tooltip-disabled])") : null;
}
function Ed(e) {
  return {
    text: e.dataset.ckeTooltipText,
    position: e.dataset.ckeTooltipPosition || "s",
    cssClass: e.dataset.ckeTooltipClass || ""
  };
}
function c4(e) {
  const n = new MutationObserver(() => {
    e();
  });
  return {
    attach(t) {
      n.observe(t, {
        attributes: !0,
        attributeFilter: [
          "data-cke-tooltip-text",
          "data-cke-tooltip-position"
        ]
      });
    },
    detach() {
      n.disconnect();
    }
  };
}
const d4 = 50, h4 = 350;
class XT extends (/* @__PURE__ */ li()) {
  /**
  * Creates a badge for a given editor. The feature is initialized on Editor#ready
  * event.
  */
  constructor(t, i = {}) {
    super();
    /**
    * Editor instance the helper was created for.
    */
    m(this, "editor");
    /**
    * A reference to the balloon panel hosting and positioning the badge content.
    */
    m(this, "_balloonView", null);
    /**
    * A throttled version of the {@link #_showBalloon} method meant for frequent use to avoid performance loss.
    */
    m(this, "_showBalloonThrottled", pl(() => this._showBalloon(), 50, {
      leading: !0
    }));
    /**
    * A reference to the last editable element (root, source editing area, etc.) focused by the user.
    * Since the focus can move to other focusable elements in the UI, this reference allows positioning the balloon over the
    * right element whether the user is typing or using the UI.
    */
    m(this, "_lastFocusedEditableElement", null);
    /**
    * An additional CSS class added to the `BalloonView`.
    */
    m(this, "_balloonClass");
    this.editor = t, this._balloonClass = i.balloonClass, t.on("ready", () => this._handleEditorReady());
  }
  /**
  * Destroys the badge along with its view.
  */
  destroy() {
    const t = this._balloonView;
    t && (t.unpin(), this._balloonView = null), this._showBalloonThrottled.cancel(), this.stopListening();
  }
  /**
  * Enables badge label once the editor (ui) is ready.
  */
  _handleEditorReady() {
    const t = this.editor;
    this._isEnabled() && t.ui.view && (t.ui.focusTracker.on("change:isFocused", (i, r, s) => {
      this._updateLastFocusedEditableElement(), s ? this._showBalloon() : this._hideBalloon();
    }), t.ui.focusTracker.on("change:focusedElement", (i, r, s) => {
      this._updateLastFocusedEditableElement(), s && this._showBalloon();
    }), t.ui.on("update", () => {
      this._showBalloonThrottled();
    }));
  }
  /**
  * Returns normalized configuration for the badge.
  */
  _getNormalizedConfig() {
    return {
      side: this.editor.locale.contentLanguageDirection === "ltr" ? "right" : "left",
      position: "border",
      verticalOffset: 0,
      horizontalOffset: 5
    };
  }
  /**
  * Attempts to display the balloon with the badge view.
  */
  _showBalloon() {
    const t = this._getBalloonAttachOptions();
    t && (this._balloonView || (this._balloonView = this._createBalloonView()), this._balloonView.pin(t));
  }
  /**
  * Hides the badge balloon if already visible.
  */
  _hideBalloon() {
    this._balloonView && this._balloonView.unpin();
  }
  /**
  * Creates an instance of the {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView balloon panel}
  * with the badge view inside ready for positioning.
  */
  _createBalloonView() {
    const t = this.editor, i = new io(), r = this._createBadgeContent();
    return i.content.add(r), this._balloonClass && (i.class = this._balloonClass), t.ui.view.body.add(i), i;
  }
  /**
  * Returns the options for attaching the balloon to the focused editable element.
  */
  _getBalloonAttachOptions() {
    if (!this._lastFocusedEditableElement)
      return null;
    const t = this._getNormalizedConfig(), i = t.side === "right" ? f4(this._lastFocusedEditableElement, t) : m4(this._lastFocusedEditableElement, t);
    return {
      target: this._lastFocusedEditableElement,
      positions: [
        i
      ]
    };
  }
  /**
  * Updates the {@link #_lastFocusedEditableElement} based on the state of the global focus tracker.
  */
  _updateLastFocusedEditableElement() {
    const t = this.editor, i = t.ui.focusTracker.isFocused, r = t.ui.focusTracker.focusedElement;
    if (!i || !r) {
      this._lastFocusedEditableElement = null;
      return;
    }
    const s = Array.from(t.ui.getEditableElementsNames()).map((o) => t.ui.getEditableElement(o));
    s.includes(r) ? this._lastFocusedEditableElement = r : this._lastFocusedEditableElement = s[0];
  }
}
function f4(e, n) {
  return JT(e, n, (t, i) => t.left + t.width - i.width - n.horizontalOffset);
}
function m4(e, n) {
  return JT(e, n, (t) => t.left + n.horizontalOffset);
}
function JT(e, n, t) {
  return (i, r) => {
    const s = new Se(e);
    if (s.width < h4 || s.height < d4)
      return null;
    let o;
    n.position === "inside" ? o = s.bottom - r.height : o = s.bottom - r.height / 2, o -= n.verticalOffset;
    const a = t(s, r), l = i.clone().moveTo(a, o).getIntersection(r.clone().moveTo(a, o)).getVisible();
    return !l || l.getArea() < r.getArea() ? null : {
      top: o,
      left: a,
      name: `position_${n.position}-side_${n.side}`,
      config: {
        withArrow: !1
      }
    };
  };
}
var p4 = `<svg xmlns="http://www.w3.org/2000/svg" width="53" height="10" viewBox="0 0 53 10"><path fill="#1C2331" d="M31.724 1.492a15.139 15.139 0 0 0 .045 1.16 2.434 2.434 0 0 0-.687-.34 3.68 3.68 0 0 0-1.103-.166 2.332 2.332 0 0 0-1.14.255 1.549 1.549 0 0 0-.686.87c-.15.41-.225.98-.225 1.712 0 .939.148 1.659.444 2.161.297.503.792.754 1.487.754.452.015.9-.094 1.294-.316.296-.174.557-.4.771-.669l.14.852h1.282V.007h-1.623v1.485ZM31 6.496a1.77 1.77 0 0 1-.494.061.964.964 0 0 1-.521-.127.758.758 0 0 1-.296-.466 3.984 3.984 0 0 1-.093-.992 4.208 4.208 0 0 1 .098-1.052.753.753 0 0 1 .307-.477 1.08 1.08 0 0 1 .55-.122c.233-.004.466.026.69.089l.483.144v2.553c-.11.076-.213.143-.307.2a1.73 1.73 0 0 1-.417.189ZM35.68 0l-.702.004c-.322.002-.482.168-.48.497l.004.581c.002.33.164.493.486.49l.702-.004c.322-.002.481-.167.48-.496L36.165.49c-.002-.33-.164-.493-.486-.491ZM36.145 2.313l-1.612.01.034 5.482 1.613-.01-.035-5.482ZM39.623.79 37.989.8 38 2.306l-.946.056.006 1.009.949-.006.024 2.983c.003.476.143.844.419 1.106.275.26.658.39 1.148.387.132 0 .293-.01.483-.03.19-.02.38-.046.57-.08.163-.028.324-.068.482-.119l-.183-1.095-.702.004a.664.664 0 0 1-.456-.123.553.553 0 0 1-.14-.422l-.016-2.621 1.513-.01-.006-1.064-1.514.01-.01-1.503ZM46.226 2.388c-.41-.184-.956-.274-1.636-.27-.673.004-1.215.101-1.627.29-.402.179-.72.505-.888.91-.18.419-.268.979-.264 1.68.004.688.1 1.24.285 1.655.172.404.495.724.9.894.414.18.957.268 1.63.264.68-.004 1.224-.099 1.632-.284.4-.176.714-.501.878-.905.176-.418.263-.971.258-1.658-.004-.702-.097-1.261-.28-1.677a1.696 1.696 0 0 0-.888-.9Zm-.613 3.607a.77.77 0 0 1-.337.501 1.649 1.649 0 0 1-1.317.009.776.776 0 0 1-.343-.497 4.066 4.066 0 0 1-.105-1.02 4.136 4.136 0 0 1 .092-1.03.786.786 0 0 1 .337-.507 1.59 1.59 0 0 1 1.316-.008.79.79 0 0 1 .344.502c.078.337.113.683.105 1.03.012.343-.019.685-.092 1.02ZM52.114 2.07a2.67 2.67 0 0 0-1.128.278c-.39.191-.752.437-1.072.73l-.157-.846-1.273.008.036 5.572 1.623-.01-.024-3.78c.35-.124.646-.22.887-.286.26-.075.53-.114.8-.118l.45-.003.144-1.546-.286.001ZM22.083 7.426l-1.576-2.532a2.137 2.137 0 0 0-.172-.253 1.95 1.95 0 0 0-.304-.29.138.138 0 0 1 .042-.04 1.7 1.7 0 0 0 .328-.374l1.75-2.71c.01-.015.025-.028.024-.048-.01-.01-.021-.007-.031-.007L20.49 1.17a.078.078 0 0 0-.075.045l-.868 1.384c-.23.366-.46.732-.688 1.099a.108.108 0 0 1-.112.06c-.098-.005-.196-.001-.294-.002-.018 0-.038.006-.055-.007.002-.02.002-.039.005-.058a4.6 4.6 0 0 0 .046-.701V1.203c0-.02-.009-.032-.03-.03h-.033L16.93 1.17c-.084 0-.073-.01-.073.076v6.491c-.001.018.006.028.025.027h1.494c.083 0 .072.007.072-.071v-2.19c0-.055-.003-.11-.004-.166a3.366 3.366 0 0 0-.05-.417h.06c.104 0 .209.002.313-.002a.082.082 0 0 1 .084.05c.535.913 1.07 1.824 1.607 2.736a.104.104 0 0 0 .103.062c.554-.003 1.107-.002 1.66-.002l.069-.003-.019-.032-.188-.304ZM27.112 6.555c-.005-.08-.004-.08-.082-.08h-2.414c-.053 0-.106-.003-.159-.011a.279.279 0 0 1-.246-.209.558.558 0 0 1-.022-.15c0-.382 0-.762-.002-1.143 0-.032.007-.049.042-.044h2.504c.029.003.037-.012.034-.038V3.814c0-.089.013-.078-.076-.078h-2.44c-.07 0-.062.003-.062-.06v-.837c0-.047.004-.093.013-.14a.283.283 0 0 1 .241-.246.717.717 0 0 1 .146-.011h2.484c.024.002.035-.009.036-.033l.003-.038.03-.496c.01-.183.024-.365.034-.548.005-.085.003-.087-.082-.094-.218-.018-.437-.038-.655-.05a17.845 17.845 0 0 0-.657-.026 72.994 72.994 0 0 0-1.756-.016 1.7 1.7 0 0 0-.471.064 1.286 1.286 0 0 0-.817.655c-.099.196-.149.413-.145.633v3.875c0 .072.003.144.011.216a1.27 1.27 0 0 0 .711 1.029c.228.113.48.167.734.158.757-.005 1.515.002 2.272-.042.274-.016.548-.034.82-.053.03-.002.043-.008.04-.041-.008-.104-.012-.208-.019-.312a69.964 69.964 0 0 1-.05-.768ZM16.14 7.415l-.127-1.075c-.004-.03-.014-.04-.044-.037a13.125 13.125 0 0 1-.998.073c-.336.01-.672.02-1.008.016-.116-.001-.233-.014-.347-.039a.746.746 0 0 1-.45-.262c-.075-.1-.132-.211-.167-.33a3.324 3.324 0 0 1-.126-.773 9.113 9.113 0 0 1-.015-.749c0-.285.022-.57.065-.852.023-.158.066-.312.127-.46a.728.728 0 0 1 .518-.443 1.64 1.64 0 0 1 .397-.048c.628-.001 1.255.003 1.882.05.022.001.033-.006.036-.026l.003-.031.06-.55c.019-.177.036-.355.057-.532.004-.034-.005-.046-.04-.056a5.595 5.595 0 0 0-1.213-.21 10.783 10.783 0 0 0-.708-.02c-.24-.003-.48.01-.719.041a3.477 3.477 0 0 0-.625.14 1.912 1.912 0 0 0-.807.497c-.185.2-.33.433-.424.688a4.311 4.311 0 0 0-.24 1.096c-.031.286-.045.572-.042.86-.006.43.024.86.091 1.286.04.25.104.497.193.734.098.279.26.53.473.734.214.205.473.358.756.446.344.11.702.17 1.063.177a8.505 8.505 0 0 0 1.578-.083 6.11 6.11 0 0 0 .766-.18c.03-.008.047-.023.037-.057a.157.157 0 0 1-.003-.025Z"/><path fill="#AFE229" d="M6.016 6.69a1.592 1.592 0 0 0-.614.21c-.23.132-.422.32-.56.546-.044.072-.287.539-.287.539l-.836 1.528.009.006c.038.025.08.046.123.063.127.046.26.07.395.073.505.023 1.011-.007 1.517-.003.29.009.58.002.869-.022a.886.886 0 0 0 .395-.116.962.962 0 0 0 .312-.286c.056-.083.114-.163.164-.249.24-.408.48-.816.718-1.226.075-.128.148-.257.222-.386l.112-.192a1.07 1.07 0 0 0 .153-.518l-1.304.023s-1.258-.005-1.388.01Z"/><path fill="#771BFF" d="m2.848 9.044.76-1.39.184-.352c-.124-.067-.245-.14-.367-.21-.346-.204-.706-.384-1.045-.6a.984.984 0 0 1-.244-.207c-.108-.134-.136-.294-.144-.46-.021-.409-.002-.818-.009-1.227-.003-.195 0-.39.003-.585.004-.322.153-.553.427-.713l.833-.488c.22-.13.44-.257.662-.385.05-.029.105-.052.158-.077.272-.128.519-.047.76.085l.044.028c.123.06.242.125.358.196.318.178.635.357.952.537.095.056.187.117.275.184.194.144.254.35.266.578.016.284.007.569.006.853-.001.28.004.558 0 .838.592-.003 1.259 0 1.259 0l.723-.013c-.003-.292-.007-.584-.007-.876 0-.524.015-1.048-.016-1.571-.024-.42-.135-.8-.492-1.067a5.02 5.02 0 0 0-.506-.339A400.52 400.52 0 0 0 5.94.787C5.722.664 5.513.524 5.282.423 5.255.406 5.228.388 5.2.373 4.758.126 4.305-.026 3.807.21c-.097.046-.197.087-.29.14A699.896 699.896 0 0 0 .783 1.948c-.501.294-.773.717-.778 1.31-.004.36-.009.718-.001 1.077.016.754-.017 1.508.024 2.261.016.304.07.6.269.848.127.15.279.28.448.382.622.4 1.283.734 1.92 1.11l.183.109Z"/></svg>
`;
const g4 = "Powered by";
class b4 extends XT {
  constructor(n) {
    super(n, {
      balloonClass: "ck-powered-by-balloon"
    });
  }
  /**
  * Enables "powered by" label.
  */
  _isEnabled() {
    const n = this.editor;
    if (n.config.get("ui.poweredBy.forceVisible"))
      return !0;
    const i = n.config.get("licenseKey");
    if (i == "GPL")
      return !0;
    const r = zf(i.split(".")[1]);
    return r ? !r.whiteLabel : !0;
  }
  /**
  * Creates a "powered by" badge content.
  */
  _createBadgeContent() {
    return new _4(this.editor.locale, this._getNormalizedConfig().label);
  }
  /**
  * Returns the normalized configuration for the "powered by" badge.
  * It takes the user configuration into account and falls back to the default one.
  */
  _getNormalizedConfig() {
    const n = super._getNormalizedConfig(), t = this.editor.config.get("ui.poweredBy") || {}, i = t.position || n.position, r = i === "inside" ? 5 : n.verticalOffset;
    return {
      position: i,
      side: t.side || n.side,
      label: t.label === void 0 ? g4 : t.label,
      verticalOffset: t.verticalOffset !== void 0 ? t.verticalOffset : r,
      horizontalOffset: t.horizontalOffset !== void 0 ? t.horizontalOffset : n.horizontalOffset,
      forceVisible: !!t.forceVisible
    };
  }
}
class _4 extends me {
  /**
  * Creates an instance of the "powered by" view.
  *
  * @param locale The localization services instance.
  * @param label The label text.
  */
  constructor(n, t) {
    super(n);
    const i = new yr(), r = this.bindTemplate;
    i.set({
      content: p4,
      isColorInherited: !1
    }), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-powered-by"
        ],
        "aria-hidden": !0
      },
      children: [
        {
          tag: "a",
          attributes: {
            href: "https://ckeditor.com/powered-by-ckeditor/?utm_source=ckeditor&utm_medium=referral&utm_campaign=701Dn000000hVgmIAE_powered_by_ckeditor_logo",
            target: "_blank",
            tabindex: "-1"
          },
          children: [
            ...t ? [
              {
                tag: "span",
                attributes: {
                  class: [
                    "ck",
                    "ck-powered-by__label"
                  ]
                },
                children: [
                  t
                ]
              }
            ] : [],
            i
          ],
          on: {
            dragstart: r.to((s) => s.preventDefault())
          }
        }
      ]
    });
  }
}
class E4 extends XT {
  constructor(t) {
    super(t, {
      balloonClass: "ck-evaluation-badge-balloon"
    });
    m(this, "licenseTypeMessage", {
      evaluation: "For evaluation purposes only",
      trial: "For evaluation purposes only",
      development: "For development purposes only"
    });
  }
  /**
  * Enables "evaluation badge" label.
  */
  _isEnabled() {
    const i = this.editor.config.get("licenseKey"), r = fg(i);
    return !!(r && this.licenseTypeMessage[r]);
  }
  /**
  * Creates the content of the "evaluation badge".
  */
  _createBadgeContent() {
    const t = this.editor.config.get("licenseKey"), i = fg(t);
    return new T4(this.editor.locale, this.licenseTypeMessage[i]);
  }
  /**
  * Returns the normalized configuration for the "evaluation badge".
  * It takes 'ui.poweredBy' configuration into account to determine the badge position and side.
  */
  _getNormalizedConfig() {
    const t = super._getNormalizedConfig(), i = this.editor.config.get("ui.poweredBy") || {}, r = i.position || t.position, s = i.side || t.side;
    return {
      position: r,
      side: s === "left" ? "right" : "left",
      verticalOffset: t.verticalOffset,
      horizontalOffset: t.horizontalOffset
    };
  }
}
class T4 extends me {
  /**
  * Creates an instance of the "evaluation badge" view.
  *
  * @param locale The localization services instance.
  * @param label The label text.
  */
  constructor(n, t) {
    super(n), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-evaluation-badge"
        ],
        "aria-hidden": !0
      },
      children: [
        {
          tag: "span",
          attributes: {
            class: [
              "ck",
              "ck-evaluation-badge__label"
            ]
          },
          children: [
            t
          ]
        }
      ]
    });
  }
}
function fg(e) {
  if (e == "GPL")
    return "GPL";
  const n = zf(e.split(".")[1]);
  return n ? n.licenseType || "production" : null;
}
const mg = {
  POLITE: "polite",
  ASSERTIVE: "assertive"
};
class y4 {
  /**
  * @inheritDoc
  */
  constructor(n) {
    /**
    * The editor instance.
    */
    m(this, "editor");
    /**
    * The view that aggregates all `aria-live` regions.
    */
    m(this, "view");
    this.editor = n, n.once("ready", () => {
      for (const t of Object.values(mg))
        this.announce("", t);
    });
  }
  /**
  * Sets an announcement text to an aria region that is then announced by a screen reader to the user.
  *
  * If the aria region of a specified politeness does not exist, it will be created and can be re-used later.
  *
  * The default announcement politeness level is `'polite'`.
  *
  * ```ts
  * // Most screen readers will queue announcements from multiple aria-live regions and read them out in the order they were emitted.
   * editor.ui.ariaLiveAnnouncer.announce( 'Image uploaded.' );
   * editor.ui.ariaLiveAnnouncer.announce( 'Connection lost. Reconnecting.' );
   * ```
  */
  announce(n, t = mg.POLITE) {
    const i = this.editor;
    if (!i.ui.view)
      return;
    this.view || (this.view = new w4(i.locale), i.ui.view.body.add(this.view));
    const { politeness: r, isUnsafeHTML: s } = typeof t == "string" ? {
      politeness: t
    } : t;
    let o = this.view.regionViews.find((a) => a.politeness === r);
    o || (o = new A4(i, r), this.view.regionViews.add(o)), o.announce({
      announcement: n,
      isUnsafeHTML: s
    });
  }
}
class w4 extends me {
  constructor(t) {
    super(t);
    /**
    * A collection of all views that represent individual `aria-live` regions.
    */
    m(this, "regionViews");
    this.regionViews = this.createCollection(), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-aria-live-announcer"
        ]
      },
      children: this.regionViews
    });
  }
}
class A4 extends me {
  constructor(t, i) {
    super(t.locale);
    /**
    * Current politeness level of the region.
    */
    m(this, "politeness");
    /**
    * DOM converter used to sanitize unsafe HTML passed to {@link #announce} method.
    */
    m(this, "_domConverter");
    /**
    * Interval used to remove additions. It prevents accumulation of added nodes in region.
    */
    m(this, "_pruneAnnouncementsInterval");
    this.setTemplate({
      tag: "div",
      attributes: {
        "aria-live": i,
        "aria-relevant": "additions"
      },
      children: [
        {
          tag: "ul",
          attributes: {
            class: [
              "ck",
              "ck-aria-live-region-list"
            ]
          }
        }
      ]
    }), t.on("destroy", () => {
      this._pruneAnnouncementsInterval !== null && (clearInterval(this._pruneAnnouncementsInterval), this._pruneAnnouncementsInterval = null);
    }), this.politeness = i, this._domConverter = t.data.htmlProcessor.domConverter, this._pruneAnnouncementsInterval = setInterval(() => {
      this.element && this._listElement.firstChild && this._listElement.firstChild.remove();
    }, 5e3);
  }
  /**
  * Appends new announcement to region.
  */
  announce({ announcement: t, isUnsafeHTML: i }) {
    if (!t.trim().length)
      return;
    const r = document.createElement("li");
    i ? this._domConverter.setContentOf(r, t) : r.innerText = t, this._listElement.appendChild(r);
  }
  /**
  * Return current announcements list HTML element.
  */
  get _listElement() {
    return this.element.querySelector("ul");
  }
}
class uc extends qi {
  /**
  * Creates an instance of the list item view.
  *
  * @param locale The localization services instance.
  */
  constructor(n, t) {
    super(n);
    const i = this.bindTemplate;
    this.extendTemplate({
      attributes: {
        class: [
          "ck-menu-bar__menu__item"
        ]
      },
      on: {
        mouseenter: i.to("mouseenter")
      }
    }), this.delegate("mouseenter").to(t);
  }
}
const xu = 5, Cs = {
  /**
  * When the bar is already open:
  * * Opens the menu when the user hovers over its button.
  * * Closes open menu when another menu's button gets hovered.
  */
  toggleMenusAndFocusItemsOnHover(e) {
    e.on("menu:mouseenter", (n) => {
      if (!(!e.isFocusBorderEnabled && !e.isOpen)) {
        if (e.isOpen)
          for (const t of e.menus) {
            const i = n.path[0], r = i instanceof uc && i.children.first === t;
            t.isOpen = (n.path.includes(t) || r) && t.isEnabled;
          }
        n.source.focus();
      }
    });
  },
  /**
  * Moves between top-level menus using the arrow left and right keys.
  *
  * If the menubar has already been open, the arrow keys move focus between top-level menu buttons and open them.
  * If the menubar is closed, the arrow keys only move focus between top-level menu buttons.
  */
  focusCycleMenusOnArrows(e) {
    const n = e.locale.uiLanguageDirection === "rtl";
    e.on("menu:arrowright", (i) => {
      t(i.source, n ? -1 : 1);
    }), e.on("menu:arrowleft", (i) => {
      t(i.source, n ? 1 : -1);
    });
    function t(i, r) {
      const s = e.children.getIndex(i), o = i.isOpen, a = e.children.length, u = e.children.get((s + a + r) % a);
      i.isOpen = !1, o && (u.isOpen = !0), u.buttonView.focus();
    }
  },
  /**
  * Closes the entire sub-menu structure when the bar is closed. This prevents sub-menus from being open if the user
  * closes the entire bar, and then re-opens some top-level menu.
  */
  closeMenusWhenTheBarCloses(e) {
    e.on("change:isOpen", () => {
      e.isOpen || e.menus.forEach((n) => {
        n.isOpen = !1;
      });
    });
  },
  /**
  * Handles the following case:
  * 1. Hover to open a sub-menu (A). The button has focus.
  * 2. Press arrow up/down to move focus to another sub-menu (B) button.
  * 3. Press arrow right to open the sub-menu (B).
  * 4. The sub-menu (A) should close as it would with `toggleMenusAndFocusItemsOnHover()`.
  */
  closeMenuWhenAnotherOnTheSameLevelOpens(e) {
    e.on("menu:change:isOpen", (n, t, i) => {
      i && e.menus.filter((r) => n.source.parentMenuView === r.parentMenuView && n.source !== r && r.isOpen).forEach((r) => {
        r.isOpen = !1;
      });
    });
  },
  /**
  * Closes the bar when the user clicked outside of it (page body, editor root, etc.).
  */
  closeOnClickOutside(e) {
    rc({
      emitter: e,
      activator: () => e.isOpen,
      callback: () => e.close(),
      contextElements: () => e.children.map((n) => n.element)
    });
  },
  /**
  * Tracks the keyboard focus interaction on the menu bar view. It is used to determine if the nested items
  * of the menu bar should render focus rings after first interaction with the keyboard.
  */
  enableFocusHighlightOnInteraction(e) {
    let n = !1;
    e.on("change:isOpen", (t, i, r) => {
      r || (n || (e.isFocusBorderEnabled = !1), n = !1);
    }), e.listenTo(e.element, "keydown", () => {
      n = !0;
    }, {
      useCapture: !0
    }), e.listenTo(e.element, "keyup", () => {
      n = !1;
    }, {
      useCapture: !0
    }), e.listenTo(e.element, "focus", () => {
      n && (e.isFocusBorderEnabled = !0);
    }, {
      useCapture: !0
    });
  }
}, ir = {
  /**
  * If the button of the menu is focused, pressing the arrow down key should open the panel and focus it.
  * This is analogous to the {@link module:ui/dropdown/dropdownview~DropdownView}.
  */
  openAndFocusPanelOnArrowDownKey(e) {
    e.keystrokes.set("arrowdown", (n, t) => {
      e.focusTracker.focusedElement === e.buttonView.element && (e.isOpen || (e.isOpen = !0), e.panelView.focus(), t());
    });
  },
  /**
  * Open the menu on the right arrow key press. This allows for navigating to sub-menus using the keyboard.
  */
  openOnArrowRightKey(e) {
    const n = e.locale.uiLanguageDirection === "rtl" ? "arrowleft" : "arrowright";
    e.keystrokes.set(n, (t, i) => {
      e.focusTracker.focusedElement !== e.buttonView.element || !e.isEnabled || (e.isOpen || (e.isOpen = !0), e.panelView.focus(), i());
    });
  },
  /**
  * Opens the menu on its button click. Note that this behavior only opens but never closes the menu (unlike
  * {@link module:ui/dropdown/dropdownview~DropdownView}).
  */
  openOnButtonClick(e) {
    e.buttonView.on("execute", () => {
      e.isOpen = !0;
    });
  },
  /**
  * Toggles the menu on its button click. This behavior is analogous to {@link module:ui/dropdown/dropdownview~DropdownView}.
  */
  toggleOnButtonClick(e) {
    e.buttonView.on("execute", () => {
      e.isOpen = !e.isOpen;
    });
  },
  /**
  * Opens the menu and focuses the panel content upon pressing the Enter key.
  */
  openAndFocusOnEnterKeyPress(e) {
    e.keystrokes.set("enter", (n, t) => {
      e.focusTracker.focusedElement === e.buttonView.element && (e.isOpen = !0, e.panelView.focus(), t());
    });
  },
  /**
  * Closes the menu on the right left key press. This allows for navigating to sub-menus using the keyboard.
  */
  closeOnArrowLeftKey(e) {
    const n = e.locale.uiLanguageDirection === "rtl" ? "arrowright" : "arrowleft";
    e.keystrokes.set(n, (t, i) => {
      e.isOpen && (e.isOpen = !1, e.focus(), i());
    });
  },
  /**
  * Closes the menu on the esc key press. This allows for navigating to sub-menus using the keyboard.
  */
  closeOnEscKey(e) {
    e.keystrokes.set("esc", (n, t) => {
      e.isOpen && (e.isOpen = !1, e.focus(), t());
    });
  },
  /**
  * Closes the menu when its parent menu also closed. This prevents from orphaned open menus when the parent menu re-opens.
  */
  closeOnParentClose(e) {
    e.parentMenuView.on("change:isOpen", (n, t, i) => {
      !i && n.source === e.parentMenuView && (e.isOpen = !1);
    });
  }
}, C4 = {
  southEast: (e) => ({
    top: e.bottom,
    left: e.left,
    name: "se"
  }),
  southWest: (e, n) => ({
    top: e.bottom,
    left: e.left - n.width + e.width,
    name: "sw"
  }),
  northEast: (e, n) => ({
    top: e.top - n.height,
    left: e.left,
    name: "ne"
  }),
  northWest: (e, n) => ({
    top: e.top - n.height,
    left: e.left - n.width + e.width,
    name: "nw"
  }),
  eastSouth: (e) => ({
    top: e.top,
    left: e.right - xu,
    name: "es"
  }),
  eastNorth: (e, n) => ({
    top: e.top - n.height,
    left: e.right - xu,
    name: "en"
  }),
  westSouth: (e, n) => ({
    top: e.top,
    left: e.left - n.width + xu,
    name: "ws"
  }),
  westNorth: (e, n) => ({
    top: e.top - n.height,
    left: e.left - n.width + xu,
    name: "wn"
  })
}, k4 = [
  {
    menuId: "file",
    label: "File",
    groups: [
      {
        groupId: "export",
        items: [
          "menuBar:exportPdf",
          "menuBar:exportWord"
        ]
      },
      {
        groupId: "import",
        items: [
          "menuBar:importWord"
        ]
      },
      {
        groupId: "revisionHistory",
        items: [
          "menuBar:revisionHistory"
        ]
      }
    ]
  },
  {
    menuId: "edit",
    label: "Edit",
    groups: [
      {
        groupId: "undo",
        items: [
          "menuBar:undo",
          "menuBar:redo"
        ]
      },
      {
        groupId: "selectAll",
        items: [
          "menuBar:selectAll"
        ]
      },
      {
        groupId: "findAndReplace",
        items: [
          "menuBar:findAndReplace"
        ]
      }
    ]
  },
  {
    menuId: "view",
    label: "View",
    groups: [
      {
        groupId: "sourceEditingEnhanced",
        items: [
          "menuBar:sourceEditingEnhanced"
        ]
      },
      {
        groupId: "sourceEditing",
        items: [
          "menuBar:sourceEditing"
        ]
      },
      {
        groupId: "showBlocks",
        items: [
          "menuBar:showBlocks"
        ]
      },
      {
        groupId: "previewMergeFields",
        items: [
          "menuBar:previewMergeFields"
        ]
      },
      {
        groupId: "restrictedEditing",
        items: [
          "menuBar:restrictedEditing"
        ]
      }
    ]
  },
  {
    menuId: "insert",
    label: "Insert",
    groups: [
      {
        groupId: "insertMainWidgets",
        items: [
          "menuBar:insertImage",
          "menuBar:ckbox",
          "menuBar:ckfinder",
          "menuBar:insertTable"
        ]
      },
      {
        groupId: "insertInline",
        items: [
          "menuBar:link",
          "menuBar:bookmark",
          "menuBar:comment",
          "menuBar:insertMergeField",
          "menuBar:emoji"
        ]
      },
      {
        groupId: "insertMinorWidgets",
        items: [
          "menuBar:mediaEmbed",
          "menuBar:insertTemplate",
          "menuBar:specialCharacters",
          "menuBar:blockQuote",
          "menuBar:codeBlock",
          "menuBar:htmlEmbed"
        ]
      },
      {
        groupId: "insertStructureWidgets",
        items: [
          "menuBar:horizontalLine",
          "menuBar:pageBreak",
          "menuBar:tableOfContents"
        ]
      },
      {
        groupId: "restrictedEditingException",
        items: [
          "menuBar:restrictedEditingException"
        ]
      }
    ]
  },
  {
    menuId: "format",
    label: "Format",
    groups: [
      {
        groupId: "textAndFont",
        items: [
          {
            menuId: "text",
            label: "Text",
            groups: [
              {
                groupId: "basicStyles",
                items: [
                  "menuBar:bold",
                  "menuBar:italic",
                  "menuBar:underline",
                  "menuBar:strikethrough",
                  "menuBar:superscript",
                  "menuBar:subscript",
                  "menuBar:code"
                ]
              },
              {
                groupId: "textPartLanguage",
                items: [
                  "menuBar:textPartLanguage"
                ]
              }
            ]
          },
          {
            menuId: "font",
            label: "Font",
            groups: [
              {
                groupId: "fontProperties",
                items: [
                  "menuBar:fontSize",
                  "menuBar:fontFamily"
                ]
              },
              {
                groupId: "fontColors",
                items: [
                  "menuBar:fontColor",
                  "menuBar:fontBackgroundColor"
                ]
              },
              {
                groupId: "highlight",
                items: [
                  "menuBar:highlight"
                ]
              }
            ]
          },
          "menuBar:heading"
        ]
      },
      {
        groupId: "list",
        items: [
          "menuBar:bulletedList",
          "menuBar:numberedList",
          "menuBar:multiLevelList",
          "menuBar:todoList"
        ]
      },
      {
        groupId: "indent",
        items: [
          "menuBar:alignment",
          "menuBar:indent",
          "menuBar:outdent"
        ]
      },
      {
        groupId: "caseChange",
        items: [
          "menuBar:caseChange"
        ]
      },
      {
        groupId: "removeFormat",
        items: [
          "menuBar:removeFormat"
        ]
      }
    ]
  },
  {
    menuId: "tools",
    label: "Tools",
    groups: [
      {
        groupId: "aiTools",
        items: [
          "menuBar:aiAssistant",
          "menuBar:aiCommands"
        ]
      },
      {
        groupId: "tools",
        items: [
          "menuBar:trackChanges",
          "menuBar:commentsArchive"
        ]
      }
    ]
  },
  {
    menuId: "help",
    label: "Help",
    groups: [
      {
        groupId: "help",
        items: [
          "menuBar:accessibilityHelp"
        ]
      }
    ]
  }
];
function S4(e) {
  let n;
  return !("items" in e) || !e.items ? n = {
    items: ui(k4),
    addItems: [],
    removeItems: [],
    isVisible: !0,
    isUsingDefaultConfig: !0,
    ...e
  } : n = {
    items: e.items,
    removeItems: [],
    addItems: [],
    isVisible: !0,
    isUsingDefaultConfig: !1,
    ...e
  }, n;
}
function I4({ normalizedConfig: e, locale: n, componentFactory: t, extraItems: i }) {
  const r = ui(e);
  return pg(e, r, i), x4(e, r), pg(e, r, r.addItems), v4(e, r, t), ZT(e, r), P4(r, n), r;
}
function x4(e, n) {
  const t = n.removeItems, i = [];
  n.items = n.items.filter(({ menuId: r }) => t.includes(r) ? (i.push(r), !1) : !0), mo(n.items, (r) => {
    r.groups = r.groups.filter(({ groupId: s }) => t.includes(s) ? (i.push(s), !1) : !0);
    for (const s of r.groups)
      s.items = s.items.filter((o) => {
        const a = ey(o);
        return t.includes(a) ? (i.push(a), !1) : !0;
      });
  });
  for (const r of t)
    i.includes(r) || at("menu-bar-item-could-not-be-removed", {
      menuBarConfig: e,
      itemName: r
    });
}
function pg(e, n, t) {
  const i = [];
  if (t.length != 0) {
    for (const r of t) {
      const s = R4(r.position), o = L4(r.position);
      if (O4(r))
        if (!o)
          s === "start" ? (n.items.unshift(r.menu), i.push(r)) : s === "end" && (n.items.push(r.menu), i.push(r));
        else {
          const a = n.items.findIndex((u) => u.menuId === o);
          a != -1 ? s === "before" ? (n.items.splice(a, 0, r.menu), i.push(r)) : s === "after" && (n.items.splice(a + 1, 0, r.menu), i.push(r)) : gg(n, r.menu, o, s) && i.push(r);
        }
      else N4(r) ? mo(n.items, (a) => {
        if (a.menuId === o)
          s === "start" ? (a.groups.unshift(r.group), i.push(r)) : s === "end" && (a.groups.push(r.group), i.push(r));
        else {
          const u = a.groups.findIndex((l) => l.groupId === o);
          u !== -1 && (s === "before" ? (a.groups.splice(u, 0, r.group), i.push(r)) : s === "after" && (a.groups.splice(u + 1, 0, r.group), i.push(r)));
        }
      }) : gg(n, r.item, o, s) && i.push(r);
    }
    for (const r of t)
      i.includes(r) || at("menu-bar-item-could-not-be-added", {
        menuBarConfig: e,
        addedItemConfig: r
      });
  }
}
function gg(e, n, t, i) {
  let r = !1;
  return mo(e.items, (s) => {
    for (const { groupId: o, items: a } of s.groups) {
      if (r)
        return;
      if (o === t)
        i === "start" ? (a.unshift(n), r = !0) : i === "end" && (a.push(n), r = !0);
      else {
        const u = a.findIndex((l) => ey(l) === t);
        u !== -1 && (i === "before" ? (a.splice(u, 0, n), r = !0) : i === "after" && (a.splice(u + 1, 0, n), r = !0));
      }
    }
  }), r;
}
function v4(e, n, t) {
  mo(n.items, (i) => {
    for (const r of i.groups)
      r.items = r.items.filter((s) => {
        const o = typeof s == "string" && !t.has(s);
        return o && !n.isUsingDefaultConfig && at("menu-bar-item-unavailable", {
          menuBarConfig: e,
          parentMenuConfig: ui(i),
          componentName: s
        }), !o;
      });
  });
}
function ZT(e, n) {
  const t = n.isUsingDefaultConfig;
  let i = !1;
  if (n.items = n.items.filter((r) => r.groups.length ? !0 : (Td(e, r, t), !1)), !n.items.length) {
    Td(e, e, t);
    return;
  }
  mo(n.items, (r) => {
    r.groups = r.groups.filter((s) => s.items.length ? !0 : (i = !0, !1));
    for (const s of r.groups)
      s.items = s.items.filter((o) => ty(o) && !o.groups.length ? (Td(e, o, t), i = !0, !1) : !0);
  }), i && ZT(e, n);
}
function Td(e, n, t) {
  t || at("menu-bar-menu-empty", {
    menuBarConfig: e,
    emptyMenuConfig: n
  });
}
function P4(e, n) {
  const t = n.t, i = {
    // Top-level categories.
    File: t({
      string: "File",
      id: "MENU_BAR_MENU_FILE"
    }),
    Edit: t({
      string: "Edit",
      id: "MENU_BAR_MENU_EDIT"
    }),
    View: t({
      string: "View",
      id: "MENU_BAR_MENU_VIEW"
    }),
    Insert: t({
      string: "Insert",
      id: "MENU_BAR_MENU_INSERT"
    }),
    Format: t({
      string: "Format",
      id: "MENU_BAR_MENU_FORMAT"
    }),
    Tools: t({
      string: "Tools",
      id: "MENU_BAR_MENU_TOOLS"
    }),
    Help: t({
      string: "Help",
      id: "MENU_BAR_MENU_HELP"
    }),
    // Sub-menus.
    Text: t({
      string: "Text",
      id: "MENU_BAR_MENU_TEXT"
    }),
    Font: t({
      string: "Font",
      id: "MENU_BAR_MENU_FONT"
    })
  };
  mo(e.items, (r) => {
    r.label in i && (r.label = i[r.label]);
  });
}
function mo(e, n) {
  if (Array.isArray(e))
    for (const i of e)
      t(i);
  function t(i) {
    n(i);
    for (const r of i.groups)
      for (const s of r.items)
        ty(s) && t(s);
  }
}
function O4(e) {
  return typeof e == "object" && "menu" in e;
}
function N4(e) {
  return typeof e == "object" && "group" in e;
}
function R4(e) {
  return e.startsWith("start") ? "start" : e.startsWith("end") ? "end" : e.startsWith("after") ? "after" : "before";
}
function L4(e) {
  const n = e.match(/^[^:]+:(.+)/);
  return n ? n[1] : null;
}
function ey(e) {
  return typeof e == "string" ? e : e.menuId;
}
function ty(e) {
  return typeof e == "object" && "menuId" in e;
}
class D4 extends (/* @__PURE__ */ pt()) {
  /**
  * Creates an instance of the editor UI class.
  *
  * @param editor The editor instance.
  */
  constructor(t) {
    super();
    /**
    * The editor that the UI belongs to.
    */
    m(this, "editor");
    /**
    * An instance of the {@link module:ui/componentfactory~ComponentFactory}, a registry used by plugins
    * to register factories of specific UI components.
    */
    m(this, "componentFactory");
    /**
    * Stores the information about the editor UI focus and propagates it so various plugins and components
    * are unified as a focus group.
    */
    m(this, "focusTracker");
    /**
    * Manages the tooltips displayed on mouseover and focus across the UI.
    */
    m(this, "tooltipManager");
    /**
    * A helper that enables the "powered by" feature in the editor and renders a link to the project's webpage.
    */
    m(this, "poweredBy");
    /**
    * A helper that enables the "evaluation badge" feature in the editor.
    */
    m(this, "evaluationBadge");
    /**
    * A helper that manages the content of an `aria-live` regions used by editor features to announce status changes
    * to screen readers.
    */
    m(this, "ariaLiveAnnouncer");
    /**
    * Indicates the UI is ready. Set `true` after {@link #event:ready} event is fired.
    *
    * @readonly
    * @default false
    */
    m(this, "isReady", !1);
    /**
    * Stores all editable elements used by the editor instance.
    */
    m(this, "_editableElementsMap", /* @__PURE__ */ new Map());
    /**
    * All available & focusable toolbars.
    */
    m(this, "_focusableToolbarDefinitions", []);
    /**
    * All additional menu bar items, groups or menus that have their default location defined.
    */
    m(this, "_extraMenuBarElements", []);
    /**
    * The last focused element to which focus should return on `Esc` press.
    */
    m(this, "_lastFocusedForeignElement", null);
    const i = t.editing.view;
    this.editor = t, this.componentFactory = new l4(t), this.focusTracker = new Ln(), this.tooltipManager = new Vh(t), this.poweredBy = new b4(t), this.evaluationBadge = new E4(t), this.ariaLiveAnnouncer = new y4(t), this.set("viewportOffset", this._readViewportOffsetFromConfig()), this.once("ready", () => {
      this._bindBodyCollectionWithFocusTracker(), this.isReady = !0;
    }), this.listenTo(i.document, "layoutChanged", this.update.bind(this)), this.listenTo(i, "scrollToTheSelection", this._handleScrollToTheSelection.bind(this)), this._initFocusTracking();
  }
  /**
  * The main (outermost) DOM element of the editor UI.
  *
  * For example, in {@link module:editor-classic/classiceditor~ClassicEditor} it is a `<div>` which
  * wraps the editable element and the toolbar. In {@link module:editor-inline/inlineeditor~InlineEditor}
  * it is the editable element itself (as there is no other wrapper). However, in
  * {@link module:editor-decoupled/decouplededitor~DecoupledEditor} it is set to `null` because this editor does not
  * come with a single "main" HTML element (its editable element and toolbar are separate).
  *
  * This property can be understood as a shorthand for retrieving the element that a specific editor integration
  * considers to be its main DOM element.
  */
  get element() {
    return null;
  }
  /**
  * Fires the {@link module:ui/editorui/editorui~EditorUI#event:update `update`} event.
  *
  * This method should be called when the editor UI (e.g. positions of its balloons) needs to be updated due to
  * some environmental change which CKEditor 5 is not aware of (e.g. resize of a container in which it is used).
  */
  update() {
    this.fire("update");
  }
  /**
  * Destroys the UI.
  */
  destroy() {
    this.stopListening(), this.focusTracker.destroy(), this.tooltipManager.destroy(this.editor), this.poweredBy.destroy(), this.evaluationBadge.destroy();
    for (const t of this._editableElementsMap.values())
      t.ckeditorInstance = null, this.editor.keystrokes.stopListening(t);
    this._editableElementsMap = /* @__PURE__ */ new Map(), this._focusableToolbarDefinitions = [];
  }
  /**
  * Stores the native DOM editable element used by the editor under a unique name.
  *
  * Also, registers the element in the editor to maintain the accessibility of the UI. When the user is editing text in a focusable
  * editable area, they can use the <kbd>Alt</kbd> + <kbd>F10</kbd> keystroke to navigate over editor toolbars. See {@link #addToolbar}.
  *
  * @param rootName The unique name of the editable element.
  * @param domElement The native DOM editable element.
  */
  setEditableElement(t, i) {
    this._editableElementsMap.set(t, i), i.ckeditorInstance || (i.ckeditorInstance = this.editor), this.focusTracker.add(i);
    const r = () => {
      this.editor.editing.view.getDomRoot(t) || this.editor.keystrokes.listenTo(i);
    };
    this.isReady ? r() : this.once("ready", r);
  }
  /**
  * Removes the editable from the editor UI. Removes all handlers added by {@link #setEditableElement}.
  *
  * @param rootName The name of the editable element to remove.
  */
  removeEditableElement(t) {
    const i = this._editableElementsMap.get(t);
    i && (this._editableElementsMap.delete(t), this.editor.keystrokes.stopListening(i), this.focusTracker.remove(i), i.ckeditorInstance = null);
  }
  /**
  * Returns the editable editor element with the given name or null if editable does not exist.
  *
  * @param rootName The editable name.
  */
  getEditableElement(t = "main") {
    return this._editableElementsMap.get(t);
  }
  /**
  * Returns array of names of all editor editable elements.
  */
  getEditableElementsNames() {
    return this._editableElementsMap.keys();
  }
  /**
  * Adds a toolbar to the editor UI. Used primarily to maintain the accessibility of the UI.
  *
  * Focusable toolbars can be accessed (focused) by users by pressing the <kbd>Alt</kbd> + <kbd>F10</kbd> keystroke.
  * Successive keystroke presses navigate over available toolbars.
  *
  * @param toolbarView A instance of the toolbar to be registered.
  */
  addToolbar(t, i = {}) {
    t.isRendered ? (this.focusTracker.add(t), this.editor.keystrokes.listenTo(t.element)) : t.once("render", () => {
      this.focusTracker.add(t), this.editor.keystrokes.listenTo(t.element);
    }), this._focusableToolbarDefinitions.push({
      toolbarView: t,
      options: i
    });
  }
  /**
  * Registers an extra menu bar element, which could be a single item, a group of items, or a menu containing groups.
  *
  * ```ts
  * // Register a new menu bar item.
  * editor.ui.extendMenuBar( {
  *   item: 'menuBar:customFunctionButton',
  *   position: 'after:menuBar:bold'
  * } );
  *
  * // Register a new menu bar group.
  * editor.ui.extendMenuBar( {
  *   group: {
  *     groupId: 'customGroup',
  *     items: [
  *       'menuBar:customFunctionButton'
  *     ]
  *   },
  *   position: 'start:help'
  * } );
  *
  * // Register a new menu bar menu.
  * editor.ui.extendMenuBar( {
  *   menu: {
  *     menuId: 'customMenu',
  *     label: 'customMenu',
  *     groups: [
  *       {
  *         groupId: 'customGroup',
  *         items: [
  *           'menuBar:customFunctionButton'
  *         ]
  *       }
  *     ]
  *   },
  *   position: 'after:help'
  * } );
  * ```
  */
  extendMenuBar(t) {
    this._extraMenuBarElements.push(t);
  }
  /**
  * Stores all editable elements used by the editor instance.
  *
  * @deprecated
  */
  get _editableElements() {
    return console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", {
      editorUI: this
    }), this._editableElementsMap;
  }
  /**
  * Initializes menu bar.
  */
  _initMenuBar(t) {
    const i = t.element;
    this.focusTracker.add(i), this.editor.keystrokes.listenTo(i);
    const r = S4(this.editor.config.get("menuBar") || {});
    t.fillFromConfig(r, this.componentFactory, this._extraMenuBarElements), this.editor.keystrokes.set("Esc", (s, o) => {
      i.contains(this.editor.ui.focusTracker.focusedElement) && (this._lastFocusedForeignElement ? (this._lastFocusedForeignElement.focus(), this._lastFocusedForeignElement = null) : this.editor.editing.view.focus(), o());
    }), this.editor.keystrokes.set("Alt+F9", (s, o) => {
      i.contains(this.editor.ui.focusTracker.focusedElement) || (this._saveLastFocusedForeignElement(), t.isFocusBorderEnabled = !0, t.focus(), o());
    });
  }
  /**
  * Returns viewport offsets object:
  *
  * ```js
  * {
  * 	top: Number,
  * 	right: Number,
  * 	bottom: Number,
  * 	left: Number
  * }
  * ```
  *
  * Only top property is currently supported.
  */
  _readViewportOffsetFromConfig() {
    const t = this.editor, i = t.config.get("ui.viewportOffset");
    if (i)
      return i;
    const r = t.config.get("toolbar.viewportTopOffset");
    return r ? (console.warn("editor-ui-deprecated-viewport-offset-config: The `toolbar.vieportTopOffset` configuration option is deprecated. It will be removed from future CKEditor versions. Use `ui.viewportOffset.top` instead."), {
      top: r
    }) : {
      top: 0
    };
  }
  /**
  * Starts listening for <kbd>Alt</kbd> + <kbd>F10</kbd> and <kbd>Esc</kbd> keystrokes in the context of focusable
  * {@link #setEditableElement editable elements} and {@link #addToolbar toolbars}
  * to allow users navigate across the UI.
  */
  _initFocusTracking() {
    const t = this.editor;
    let i;
    t.keystrokes.set("Alt+F10", (r, s) => {
      this._saveLastFocusedForeignElement();
      const o = this._getCurrentFocusedToolbarDefinition();
      (!o || !i) && (i = this._getFocusableCandidateToolbarDefinitions());
      for (let a = 0; a < i.length; a++) {
        const u = i.shift();
        if (i.push(u), u !== o && this._focusFocusableCandidateToolbar(u)) {
          o && o.options.afterBlur && o.options.afterBlur();
          break;
        }
      }
      s();
    }), t.keystrokes.set("Esc", (r, s) => {
      const o = this._getCurrentFocusedToolbarDefinition();
      o && (this._lastFocusedForeignElement ? (this._lastFocusedForeignElement.focus(), this._lastFocusedForeignElement = null) : t.editing.view.focus(), o.options.afterBlur && o.options.afterBlur(), s());
    });
  }
  /**
  * Saves last focused element that doen not belong to editing view to restore focus on `Esc`.
  */
  _saveLastFocusedForeignElement() {
    const t = this.focusTracker.focusedElement;
    Array.from(this._editableElementsMap.values()).includes(t) && !Array.from(this.editor.editing.view.domRoots.values()).includes(t) && (this._lastFocusedForeignElement = t);
  }
  /**
  * Returns definitions of toolbars that could potentially be focused, sorted by their importance for the user.
  *
  * Focusable toolbars candidates are either:
  * * already visible,
  * * have `beforeFocus()` set in their {@link module:ui/editorui/editorui~FocusableToolbarDefinition definition} that suggests that
  * they might show up when called. Keep in mind that determining whether a toolbar will show up (and become focusable) is impossible
  * at this stage because it depends on its implementation, that in turn depends on the editing context (selection).
  *
  * **Note**: Contextual toolbars take precedence over regular toolbars.
  */
  _getFocusableCandidateToolbarDefinitions() {
    const t = [];
    for (const i of this._focusableToolbarDefinitions) {
      const { toolbarView: r, options: s } = i;
      (zi(r.element) || s.beforeFocus) && t.push(i);
    }
    return t.sort((i, r) => bg(i) - bg(r)), t;
  }
  /**
  * Returns a definition of the toolbar that is currently visible and focused (one of its children has focus).
  *
  * `null` is returned when no toolbar is currently focused.
  */
  _getCurrentFocusedToolbarDefinition() {
    for (const t of this._focusableToolbarDefinitions)
      if (t.toolbarView.element && t.toolbarView.element.contains(this.focusTracker.focusedElement))
        return t;
    return null;
  }
  /**
  * Focuses a focusable toolbar candidate using its definition.
  *
  * @param candidateToolbarDefinition A definition of the toolbar to focus.
  * @returns `true` when the toolbar candidate was focused. `false` otherwise.
  */
  _focusFocusableCandidateToolbar(t) {
    const { toolbarView: i, options: { beforeFocus: r } } = t;
    return r && r(), zi(i.element) ? (i.focus(), !0) : !1;
  }
  /**
  * Provides an integration between {@link #viewportOffset} and {@link module:utils/dom/scroll~scrollViewportToShowTarget}.
  * It allows the UI-agnostic engine method to consider user-configured viewport offsets specific for the integration.
  *
  * @param evt The `scrollToTheSelection` event info.
  * @param data The payload carried by the `scrollToTheSelection` event.
  */
  _handleScrollToTheSelection(t, i) {
    const r = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      ...this.viewportOffset
    };
    i.viewportOffset.top += r.top, i.viewportOffset.bottom += r.bottom, i.viewportOffset.left += r.left, i.viewportOffset.right += r.right;
  }
  /**
  * Ensures that the focus tracker is aware of all views' DOM elements in the body collection.
  */
  _bindBodyCollectionWithFocusTracker() {
    const t = this.view.body;
    for (const i of t)
      this.focusTracker.add(i.element);
    t.on("add", (i, r) => {
      this.focusTracker.add(r.element);
    }), t.on("remove", (i, r) => {
      this.focusTracker.remove(r.element);
    });
  }
}
function bg(e) {
  const { toolbarView: n, options: t } = e;
  let i = 10;
  return zi(n.element) && i--, t.isContextual && i--, i;
}
class M4 extends me {
  /**
  * Creates an instance of the editor UI view class.
  *
  * @param locale The locale instance.
  */
  constructor(t) {
    super(t);
    /**
    * Collection of the child views, detached from the DOM
    * structure of the editor, like panels, icons etc.
    */
    m(this, "body");
    /**
    * Menu bar view instance. May not be initialized in some editor types.
    */
    m(this, "menuBarView");
    this.body = new Uh(t);
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.body.attachToDom();
  }
  /**
  * @inheritDoc
  */
  destroy() {
    return this.body.detachFromDom(), super.destroy();
  }
}
class B4 extends M4 {
  /**
  * Creates an instance of the boxed editor UI view class.
  *
  * @param locale The locale instance..
  */
  constructor(t) {
    super(t);
    /**
    * Collection of the child views located in the top (`.ck-editor__top`)
    * area of the UI.
    */
    m(this, "top");
    /**
    * Collection of the child views located in the main (`.ck-editor__main`)
    * area of the UI.
    */
    m(this, "main");
    /**
    * Voice label of the UI.
    */
    m(this, "_voiceLabelView");
    this.top = this.createCollection(), this.main = this.createCollection(), this._voiceLabelView = this._createVoiceLabel(), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-reset",
          "ck-editor",
          "ck-rounded-corners"
        ],
        role: "application",
        dir: t.uiLanguageDirection,
        lang: t.uiLanguage,
        "aria-labelledby": this._voiceLabelView.id
      },
      children: [
        this._voiceLabelView,
        {
          tag: "div",
          attributes: {
            class: [
              "ck",
              "ck-editor__top",
              "ck-reset_all"
            ],
            role: "presentation"
          },
          children: this.top
        },
        {
          tag: "div",
          attributes: {
            class: [
              "ck",
              "ck-editor__main"
            ],
            role: "presentation"
          },
          children: this.main
        }
      ]
    });
  }
  /**
  * Creates a voice label view instance.
  */
  _createVoiceLabel() {
    const t = this.t, i = new sc();
    return i.text = t("Rich Text Editor"), i.extendTemplate({
      attributes: {
        class: "ck-voice-label"
      }
    }), i;
  }
}
class F4 extends me {
  /**
  * Creates an instance of EditableUIView class.
  *
  * @param locale The locale instance.
  * @param editingView The editing view instance the editable is related to.
  * @param editableElement The editable element. If not specified, this view
  * should create it. Otherwise, the existing element should be used.
  */
  constructor(t, i, r) {
    super(t);
    /**
    * The name of the editable UI view.
    */
    m(this, "name", null);
    /**
    * The editing view instance the editable is related to. Editable uses the editing
    * view to dynamically modify its certain DOM attributes after {@link #render rendering}.
    *
    * **Note**: The DOM attributes are performed by the editing view and not UI
    * {@link module:ui/view~View#bindTemplate template bindings} because once rendered,
    * the editable DOM element must remain under the full control of the engine to work properly.
    */
    m(this, "_editingView");
    /**
    * The element which is the main editable element (usually the one with `contentEditable="true"`).
    */
    m(this, "_editableElement");
    /**
    * Whether an external {@link #_editableElement} was passed into the constructor, which also means
    * the view will not render its {@link #template}.
    */
    m(this, "_hasExternalElement");
    this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-content",
          "ck-editor__editable",
          "ck-rounded-corners"
        ],
        lang: t.contentLanguage,
        dir: t.contentLanguageDirection
      }
    }), this.set("isFocused", !1), this._editableElement = r, this._hasExternalElement = !!this._editableElement, this._editingView = i;
  }
  /**
  * Renders the view by either applying the {@link #template} to the existing
  * {@link module:ui/editableui/editableuiview~EditableUIView#_editableElement} or assigning {@link #element}
  * as {@link module:ui/editableui/editableuiview~EditableUIView#_editableElement}.
  */
  render() {
    super.render(), this._hasExternalElement ? this.template.apply(this.element = this._editableElement) : this._editableElement = this.element, this.on("change:isFocused", () => this._updateIsFocusedClasses()), this._updateIsFocusedClasses();
  }
  /**
  * @inheritDoc
  */
  destroy() {
    this._hasExternalElement && this.template.revert(this._editableElement), super.destroy();
  }
  /**
  * Whether an external {@link #_editableElement} was passed into the constructor, which also means
  * the view will not render its {@link #template}.
  */
  get hasExternalElement() {
    return this._hasExternalElement;
  }
  /**
  * Updates the `ck-focused` and `ck-blurred` CSS classes on the {@link #element} according to
  * the {@link #isFocused} property value using the {@link #_editingView editing view} API.
  */
  _updateIsFocusedClasses() {
    const t = this._editingView;
    t.isRenderingInProgress ? r(this) : i(this);
    function i(s) {
      t.change((o) => {
        const a = t.document.getRoot(s.name);
        o.addClass(s.isFocused ? "ck-focused" : "ck-blurred", a), o.removeClass(s.isFocused ? "ck-blurred" : "ck-focused", a);
      });
    }
    function r(s) {
      t.once("change:isRenderingInProgress", (o, a, u) => {
        u ? r(s) : i(s);
      });
    }
  }
}
class U4 extends F4 {
  /**
  * Creates an instance of the InlineEditableUIView class.
  *
  * @param locale The locale instance.
  * @param editingView The editing view instance the editable is related to.
  * @param editableElement The editable element. If not specified, the
  * {@link module:ui/editableui/editableuiview~EditableUIView}
  * will create it. Otherwise, the existing element will be used.
  * @param options Additional configuration of the view.
  * @param options.label The label of the editable for assistive technologies. If not provided, a default label is used or,
  * the existing `aria-label` attribute value from the specified `editableElement` is preserved.
  */
  constructor(t, i, r, s = {}) {
    super(t, i, r);
    /**
    * The cached options object passed to the constructor.
    */
    m(this, "_options");
    this._options = s, this.extendTemplate({
      attributes: {
        role: "textbox",
        class: "ck-editor__editable_inline"
      }
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render();
    const t = this._editingView;
    t.change((i) => {
      const r = t.document.getRoot(this.name);
      i.setAttribute("aria-label", this.getEditableAriaLabel(), r);
    });
  }
  /**
  * Returns a normalized label for the editable view based on the environment.
  */
  getEditableAriaLabel() {
    const t = this.locale.t, i = this._options.label, r = this._editableElement, s = this.name;
    if (typeof i == "string")
      return i;
    if (typeof i == "object")
      return i[s];
    if (typeof i == "function")
      return i(this);
    if (r) {
      const o = r.getAttribute("aria-label");
      if (o)
        return o;
    }
    return t("Rich Text Editor. Editing area: %0", s);
  }
}
class H4 extends (/* @__PURE__ */ pt()) {
  /**
  * Creates a new Model instance.
  *
  * @param attributes The model state attributes to be defined during the instance creation.
  * @param properties The (out of state) properties to be appended to the instance during creation.
  */
  constructor(n, t) {
    super(), t && z_(this, t), n && this.set(n);
  }
}
const vu = /* @__PURE__ */ nu("px");
class kl extends ce {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * The {@link module:utils/dom/position~Options#limiter position limiter}
    * for the {@link #view balloon}, used when no `limiter` has been passed into {@link #add}
    * or {@link #updatePosition}.
    *
    * By default, a function that obtains the farthest DOM
    * {@link module:engine/view/rooteditableelement~RootEditableElement}
    * of the {@link module:engine/view/document~Document#selection}.
    */
    m(this, "positionLimiter");
    m(this, "visibleStack");
    /**
    * The map of views and their stacks.
    */
    m(this, "_viewToStack", /* @__PURE__ */ new Map());
    /**
    * The map of IDs and stacks.
    */
    m(this, "_idToStack", /* @__PURE__ */ new Map());
    /**
    * The common balloon panel view.
    */
    m(this, "_view", null);
    /**
    * Rotator view embedded in the contextual balloon.
    * Displays the currently visible view in the balloon and provides navigation for switching stacks.
    */
    m(this, "_rotatorView", null);
    /**
    * Displays fake panels under the balloon panel view when multiple stacks are added to the balloon.
    */
    m(this, "_fakePanelsView", null);
    this.positionLimiter = () => {
      const i = this.editor.editing.view, s = i.document.selection.editableElement;
      return s ? i.domConverter.mapViewToDom(s.root) : null;
    }, this.decorate("getPositionOptions"), this.set("visibleView", null), this.set("_numberOfStacks", 0), this.set("_singleViewMode", !1);
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "ContextualBalloon";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy(), this._view && this._view.destroy(), this._rotatorView && this._rotatorView.destroy(), this._fakePanelsView && this._fakePanelsView.destroy();
  }
  /**
  * The common balloon panel view.
  */
  get view() {
    return this._view || this._createPanelView(), this._view;
  }
  /**
  * Returns `true` when the given view is in one of the stacks. Otherwise returns `false`.
  */
  hasView(t) {
    return Array.from(this._viewToStack.keys()).includes(t);
  }
  /**
  * Adds a new view to the stack and makes it visible if the current stack is visible
  * or it is the first view in the balloon.
  *
  * @param data The configuration of the view.
  * @param data.stackId The ID of the stack that the view is added to. Defaults to `'main'`.
  * @param data.view The content of the balloon.
  * @param data.position Positioning options.
  * @param data.balloonClassName An additional CSS class added to the {@link #view balloon} when visible.
  * @param data.withArrow Whether the {@link #view balloon} should be rendered with an arrow. Defaults to `true`.
  * @param data.singleViewMode Whether the view should be the only visible view even if other stacks were added. Defaults to `false`.
  */
  add(t) {
    if (this._view || this._createPanelView(), this.hasView(t.view))
      throw new v("contextualballoon-add-view-exist", [
        this,
        t
      ]);
    const i = t.stackId || "main";
    if (!this._idToStack.has(i)) {
      this._idToStack.set(i, /* @__PURE__ */ new Map([
        [
          t.view,
          t
        ]
      ])), this._viewToStack.set(t.view, this._idToStack.get(i)), this._numberOfStacks = this._idToStack.size, (!this._visibleStack || t.singleViewMode) && this.showStack(i);
      return;
    }
    const r = this._idToStack.get(i);
    t.singleViewMode && this.showStack(i), r.set(t.view, t), this._viewToStack.set(t.view, r), r === this._visibleStack && this._showView(t);
  }
  /**
  * Removes the given view from the stack. If the removed view was visible,
  * the view preceding it in the stack will become visible instead.
  * When there is no view in the stack, the next stack will be displayed.
  * When there are no more stacks, the balloon will hide.
  *
  * @param view A view to be removed from the balloon.
  */
  remove(t) {
    if (!this.hasView(t))
      throw new v("contextualballoon-remove-view-not-exist", [
        this,
        t
      ]);
    const i = this._viewToStack.get(t);
    this._singleViewMode && this.visibleView === t && (this._singleViewMode = !1), this.visibleView === t && (i.size === 1 ? this._idToStack.size > 1 ? this._showNextStack() : (this.view.hide(), this.visibleView = null, this._rotatorView.hideView()) : this._showView(Array.from(i.values())[i.size - 2])), i.size === 1 ? (this._idToStack.delete(this._getStackId(i)), this._numberOfStacks = this._idToStack.size) : i.delete(t), this._viewToStack.delete(t);
  }
  /**
  * Updates the position of the balloon using the position data of the first visible view in the stack.
  * When new position data is given, the position data of the currently visible view will be updated.
  *
  * @param position Position options.
  */
  updatePosition(t) {
    t && (this._visibleStack.get(this.visibleView).position = t), this.view.pin(this.getPositionOptions()), this._fakePanelsView.updatePosition();
  }
  /**
  * Returns position options of the last view in the stack.
  * This keeps the balloon in the same position when the view is changed.
  */
  getPositionOptions() {
    let t = Array.from(this._visibleStack.values()).pop().position;
    return t && (t.limiter || (t = Object.assign({}, t, {
      limiter: this.positionLimiter
    })), t = Object.assign({}, t, {
      viewportOffsetConfig: this.editor.ui.viewportOffset
    })), t;
  }
  /**
  * Shows the last view from the stack of a given ID.
  */
  showStack(t) {
    this.visibleStack = t;
    const i = this._idToStack.get(t);
    if (!i)
      throw new v("contextualballoon-showstack-stack-not-exist", this);
    this._visibleStack !== i && this._showView(Array.from(i.values()).pop());
  }
  /**
  * Initializes view instances.
  */
  _createPanelView() {
    this._view = new io(this.editor.locale), this.editor.ui.view.body.add(this._view), this._rotatorView = this._createRotatorView(), this._fakePanelsView = this._createFakePanelsView();
  }
  /**
  * Returns the stack of the currently visible view.
  */
  get _visibleStack() {
    return this._viewToStack.get(this.visibleView);
  }
  /**
  * Returns the ID of the given stack.
  */
  _getStackId(t) {
    return Array.from(this._idToStack.entries()).find((r) => r[1] === t)[0];
  }
  /**
  * Shows the last view from the next stack.
  */
  _showNextStack() {
    const t = Array.from(this._idToStack.values());
    let i = t.indexOf(this._visibleStack) + 1;
    t[i] || (i = 0), this.showStack(this._getStackId(t[i]));
  }
  /**
  * Shows the last view from the previous stack.
  */
  _showPrevStack() {
    const t = Array.from(this._idToStack.values());
    let i = t.indexOf(this._visibleStack) - 1;
    t[i] || (i = t.length - 1), this.showStack(this._getStackId(t[i]));
  }
  /**
  * Creates a rotator view.
  */
  _createRotatorView() {
    const t = new V4(this.editor.locale), i = this.editor.locale.t;
    return this.view.content.add(t), t.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", (r, s) => !s && r > 1), t.on("change:isNavigationVisible", () => this.updatePosition(), {
      priority: "low"
    }), t.bind("counter").to(this, "visibleView", this, "_numberOfStacks", (r, s) => {
      if (s < 2)
        return "";
      const o = Array.from(this._idToStack.values()).indexOf(this._visibleStack) + 1;
      return i("%0 of %1", [
        o,
        s
      ]);
    }), t.buttonNextView.on("execute", () => {
      t.focusTracker.isFocused && this.editor.editing.view.focus(), this._showNextStack();
    }), t.buttonPrevView.on("execute", () => {
      t.focusTracker.isFocused && this.editor.editing.view.focus(), this._showPrevStack();
    }), t;
  }
  /**
  * Creates a fake panels view.
  */
  _createFakePanelsView() {
    const t = new $4(this.editor.locale, this.view);
    return t.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", (i, r) => !r && i >= 2 ? Math.min(i - 1, 2) : 0), t.listenTo(this.view, "change:top", () => t.updatePosition()), t.listenTo(this.view, "change:left", () => t.updatePosition()), this.editor.ui.view.body.add(t), t;
  }
  /**
  * Sets the view as the content of the balloon and attaches the balloon using position
  * options of the first view.
  *
  * @param data Configuration.
  * @param data.view The view to show in the balloon.
  * @param data.balloonClassName Additional class name which will be added to the {@link #view balloon}.
  * @param data.withArrow Whether the {@link #view balloon} should be rendered with an arrow.
  */
  _showView({ view: t, balloonClassName: i = "", withArrow: r = !0, singleViewMode: s = !1 }) {
    this.view.class = i, this.view.withArrow = r, this._rotatorView.showView(t), this.visibleView = t, this.view.pin(this.getPositionOptions()), this._fakePanelsView.updatePosition(), s && (this._singleViewMode = !0);
  }
}
class V4 extends me {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * Used for checking if a view is focused or not.
    */
    m(this, "focusTracker");
    /**
    * Navigation button for switching the stack to the previous one.
    */
    m(this, "buttonPrevView");
    /**
    * Navigation button for switching the stack to the next one.
    */
    m(this, "buttonNextView");
    /**
    * A collection of the child views that creates the rotator content.
    */
    m(this, "content");
    const i = t.t, r = this.bindTemplate;
    this.set("isNavigationVisible", !0), this.focusTracker = new Ln(), this.buttonPrevView = this._createButtonView(i("Previous"), Ge.previousArrow), this.buttonNextView = this._createButtonView(i("Next"), Ge.nextArrow), this.content = this.createCollection(), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-balloon-rotator"
        ],
        "z-index": "-1"
      },
      children: [
        {
          tag: "div",
          attributes: {
            class: [
              "ck-balloon-rotator__navigation",
              r.to("isNavigationVisible", (s) => s ? "" : "ck-hidden")
            ]
          },
          children: [
            this.buttonPrevView,
            {
              tag: "span",
              attributes: {
                class: [
                  "ck-balloon-rotator__counter"
                ]
              },
              children: [
                {
                  text: r.to("counter")
                }
              ]
            },
            this.buttonNextView
          ]
        },
        {
          tag: "div",
          attributes: {
            class: "ck-balloon-rotator__content"
          },
          children: this.content
        }
      ]
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.focusTracker.add(this.element);
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy(), this.focusTracker.destroy();
  }
  /**
  * Shows a given view.
  *
  * @param view The view to show.
  */
  showView(t) {
    this.hideView(), this.content.add(t);
  }
  /**
  * Hides the currently displayed view.
  */
  hideView() {
    this.content.clear();
  }
  /**
  * Creates a navigation button view.
  *
  * @param label The button label.
  * @param icon The button icon.
  */
  _createButtonView(t, i) {
    const r = new gt(this.locale);
    return r.set({
      label: t,
      icon: i,
      tooltip: !0
    }), r;
  }
}
class $4 extends me {
  /**
  * @inheritDoc
  */
  constructor(t, i) {
    super(t);
    /**
    * Collection of the child views which creates fake panel content.
    */
    m(this, "content");
    /**
    * Context.
    */
    m(this, "_balloonPanelView");
    const r = this.bindTemplate;
    this.set("top", 0), this.set("left", 0), this.set("height", 0), this.set("width", 0), this.set("numberOfPanels", 0), this.content = this.createCollection(), this._balloonPanelView = i, this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck-fake-panel",
          r.to("numberOfPanels", (s) => s ? "" : "ck-hidden")
        ],
        style: {
          top: r.to("top", vu),
          left: r.to("left", vu),
          width: r.to("width", vu),
          height: r.to("height", vu)
        }
      },
      children: this.content
    }), this.on("change:numberOfPanels", (s, o, a, u) => {
      a > u ? this._addPanels(a - u) : this._removePanels(u - a), this.updatePosition();
    });
  }
  _addPanels(t) {
    for (; t--; ) {
      const i = new me();
      i.setTemplate({
        tag: "div"
      }), this.content.add(i), this.registerChild(i);
    }
  }
  _removePanels(t) {
    for (; t--; ) {
      const i = this.content.last;
      this.content.remove(i), this.deregisterChild(i), i.destroy();
    }
  }
  /**
  * Updates coordinates of fake panels.
  */
  updatePosition() {
    if (this.numberOfPanels) {
      const { top: t, left: i } = this._balloonPanelView, { width: r, height: s } = new Se(this._balloonPanelView.element);
      Object.assign(this, {
        top: t,
        left: i,
        width: r,
        height: s
      });
    }
  }
}
const ks = /* @__PURE__ */ nu("px");
class W4 extends me {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * Collection of the child views which creates balloon panel contents.
    */
    m(this, "content");
    /**
    * The panel which accepts children into {@link #content} collection.
    * Also an element which is positioned when {@link #isSticky}.
    */
    m(this, "contentPanelElement");
    /**
    * A dummy element which visually fills the space as long as the
    * actual panel is sticky. It prevents flickering of the UI.
    */
    m(this, "_contentPanelPlaceholder");
    const i = this.bindTemplate;
    this.set("isActive", !1), this.set("isSticky", !1), this.set("limiterElement", null), this.set("limiterBottomOffset", 50), this.set("viewportTopOffset", 0), this.set("_marginLeft", null), this.set("_isStickyToTheBottomOfLimiter", !1), this.set("_stickyTopOffset", null), this.set("_stickyBottomOffset", null), this.content = this.createCollection(), this._contentPanelPlaceholder = new Ai({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-sticky-panel__placeholder"
        ],
        style: {
          display: i.to("isSticky", (r) => r ? "block" : "none"),
          height: i.to("isSticky", (r) => r ? ks(this._contentPanelRect.height) : null)
        }
      }
    }).render(), this.contentPanelElement = new Ai({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-sticky-panel__content",
          // Toggle class of the panel when "sticky" state changes in the view.
          i.if("isSticky", "ck-sticky-panel__content_sticky"),
          i.if("_isStickyToTheBottomOfLimiter", "ck-sticky-panel__content_sticky_bottom-limit")
        ],
        style: {
          width: i.to("isSticky", (r) => r ? ks(this._contentPanelPlaceholder.getBoundingClientRect().width) : null),
          top: i.to("_stickyTopOffset", (r) => r && ks(r)),
          bottom: i.to("_stickyBottomOffset", (r) => r && ks(r)),
          marginLeft: i.to("_marginLeft")
        }
      },
      children: this.content
    }).render(), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-sticky-panel"
        ]
      },
      children: [
        this._contentPanelPlaceholder,
        this.contentPanelElement
      ]
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.checkIfShouldBeSticky(), this.listenTo(ue.document, "scroll", () => {
      this.checkIfShouldBeSticky();
    }, {
      useCapture: !0
    }), this.listenTo(this, "change:isActive", () => {
      this.checkIfShouldBeSticky();
    });
  }
  /**
  * Analyzes the environment to decide whether the panel should be sticky or not.
  * Then handles the positioning of the panel.
  */
  checkIfShouldBeSticky() {
    if (!this.limiterElement || !this.isActive) {
      this._unstick();
      return;
    }
    const t = new Se(this.limiterElement);
    let i = t.getVisible();
    if (i) {
      const r = new Se(ue.window);
      r.top += this.viewportTopOffset, r.height -= this.viewportTopOffset, i = i.getIntersection(r);
    }
    if (i && t.top < i.top) {
      const r = i.top;
      if (r + this._contentPanelRect.height + this.limiterBottomOffset > i.bottom) {
        const s = Math.max(t.bottom - i.bottom, 0) + this.limiterBottomOffset;
        t.bottom - s > t.top + this._contentPanelRect.height ? this._stickToBottomOfLimiter(s) : this._unstick();
      } else
        this._contentPanelRect.height + this.limiterBottomOffset < t.height ? this._stickToTopOfAncestors(r) : this._unstick();
    } else
      this._unstick();
  }
  /**
  * Sticks the panel at the given CSS `top` offset.
  *
  * @private
  * @param topOffset
  */
  _stickToTopOfAncestors(t) {
    this.isSticky = !0, this._isStickyToTheBottomOfLimiter = !1, this._stickyTopOffset = t, this._stickyBottomOffset = null, this._marginLeft = ks(-ue.window.scrollX);
  }
  /**
  * Sticks the panel at the bottom of the limiter with a given CSS `bottom` offset.
  *
  * @private
  * @param stickyBottomOffset
  */
  _stickToBottomOfLimiter(t) {
    this.isSticky = !0, this._isStickyToTheBottomOfLimiter = !0, this._stickyTopOffset = null, this._stickyBottomOffset = t, this._marginLeft = ks(-ue.window.scrollX);
  }
  /**
  * Unsticks the panel putting it back to its original position.
  *
  * @private
  */
  _unstick() {
    this.isSticky = !1, this._isStickyToTheBottomOfLimiter = !1, this._stickyTopOffset = null, this._stickyBottomOffset = null, this._marginLeft = null;
  }
  /**
  * Returns the bounding rect of the {@link #contentPanelElement}.
  *
  * @private
  */
  get _contentPanelRect() {
    return new Se(this.contentPanelElement);
  }
}
class z4 extends no {
  /**
  * Creates an instance of the menu bar button view.
  *
  * @param locale The localization services instance.
  */
  constructor(t) {
    super(t);
    /**
    * An icon that displays an arrow to indicate a direction of the menu.
    */
    m(this, "arrowView");
    const i = this.bindTemplate;
    this.set({
      withText: !0,
      role: "menuitem"
    }), this.arrowView = this._createArrowView(), this.extendTemplate({
      attributes: {
        class: [
          "ck-menu-bar__menu__button"
        ],
        "aria-haspopup": !0,
        "aria-expanded": this.bindTemplate.to("isOn", (r) => String(r)),
        "data-cke-tooltip-disabled": i.to("isOn")
      },
      on: {
        mouseenter: i.to("mouseenter")
      }
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.children.add(this.arrowView);
  }
  /**
  * Creates the {@link #arrowView} instance.
  */
  _createArrowView() {
    const t = new yr();
    return t.content = om, t.extendTemplate({
      attributes: {
        class: "ck-menu-bar__menu__button__arrow"
      }
    }), t;
  }
}
class q4 extends me {
  /**
  * Creates an instance of the menu panel view.
  *
  * @param locale The localization services instance.
  */
  constructor(t) {
    super(t);
    /**
    * Collection of the child views in this panel.
    */
    m(this, "children");
    const i = this.bindTemplate;
    this.set("isVisible", !1), this.set("position", "se"), this.children = this.createCollection(), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-reset",
          "ck-menu-bar__menu__panel",
          i.to("position", (r) => `ck-menu-bar__menu__panel_position_${r}`),
          i.if("isVisible", "ck-hidden", (r) => !r)
        ],
        tabindex: "-1"
      },
      children: this.children,
      on: {
        // Drag and drop in the panel should not break the selection in the editor.
        // https://github.com/ckeditor/ckeditor5-ui/issues/228
        selectstart: i.to((r) => {
          r.target.tagName.toLocaleLowerCase() !== "input" && r.preventDefault();
        })
      }
    });
  }
  /**
  * Focuses the first child of the panel (default) or the last one if the `direction` is `-1`.
  */
  focus(t = 1) {
    this.children.length && (t === 1 ? this.children.first.focus() : this.children.last.focus());
  }
}
const Yl = class Yl extends me {
  /**
  * Creates an instance of the menu view.
  *
  * @param locale The localization services instance.
  */
  constructor(t) {
    super(t);
    /**
    * Button of the menu view.
    */
    m(this, "buttonView");
    /**
    * Panel of the menu. It hosts children of the menu.
    */
    m(this, "panelView");
    /**
    * Tracks information about the DOM focus in the menu.
    */
    m(this, "focusTracker");
    /**
    * Instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}. It manages
    * keystrokes of the menu.
    */
    m(this, "keystrokes");
    const i = this.bindTemplate;
    this.buttonView = new z4(t), this.buttonView.delegate("mouseenter").to(this), this.buttonView.bind("isOn", "isEnabled").to(this, "isOpen", "isEnabled"), this.panelView = new q4(t), this.panelView.bind("isVisible").to(this, "isOpen"), this.keystrokes = new Ii(), this.focusTracker = new Ln(), this.set("isOpen", !1), this.set("isEnabled", !0), this.set("panelPosition", "w"), this.set("class", void 0), this.set("parentMenuView", null), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-menu-bar__menu",
          i.to("class"),
          i.if("isEnabled", "ck-disabled", (r) => !r),
          i.if("parentMenuView", "ck-menu-bar__menu_top-level", (r) => !r)
        ]
      },
      children: [
        this.buttonView,
        this.panelView
      ]
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.focusTracker.add(this.buttonView.element), this.focusTracker.add(this.panelView.element), this.keystrokes.listenTo(this.element), ir.closeOnEscKey(this), this._repositionPanelOnOpen();
  }
  // For now, this method cannot be called in the render process because the `parentMenuView` may be assigned
  // after the rendering process.
  //
  // TODO: We should reconsider the way we handle this logic.
  /**
  * Attach all keyboard behaviors for the menu bar view.
  *
  * @internal
  */
  _attachBehaviors() {
    this.parentMenuView ? (ir.openOnButtonClick(this), ir.openOnArrowRightKey(this), ir.closeOnArrowLeftKey(this), ir.openAndFocusOnEnterKeyPress(this), ir.closeOnParentClose(this)) : (this._propagateArrowKeystrokeEvents(), ir.openAndFocusPanelOnArrowDownKey(this), ir.toggleOnButtonClick(this));
  }
  /**
  * Fires `arrowright` and `arrowleft` events when the user pressed corresponding arrow keys.
  */
  _propagateArrowKeystrokeEvents() {
    this.keystrokes.set("arrowright", (t, i) => {
      this.fire("arrowright"), i();
    }), this.keystrokes.set("arrowleft", (t, i) => {
      this.fire("arrowleft"), i();
    });
  }
  /**
  * Sets the position of the panel when the menu opens. The panel is positioned
  * so that it optimally uses the available space in the viewport.
  */
  _repositionPanelOnOpen() {
    this.on("change:isOpen", (t, i, r) => {
      if (!r)
        return;
      const s = Yl._getOptimalPosition({
        element: this.panelView.element,
        target: this.buttonView.element,
        fitInViewport: !0,
        positions: this._panelPositions
      });
      this.panelView.position = s ? s.name : this._defaultMenuPositionName;
    });
  }
  /**
  * @inheritDoc
  */
  focus() {
    this.buttonView.focus();
  }
  /**
  * Positioning functions for the {@link #panelView} . They change depending on the role of the menu (top-level vs sub-menu) in
  * the {@link module:ui/menubar/menubarview~MenuBarView menu bar} and the UI language direction.
  */
  get _panelPositions() {
    const { southEast: t, southWest: i, northEast: r, northWest: s, westSouth: o, eastSouth: a, westNorth: u, eastNorth: l } = C4;
    return this.locale.uiLanguageDirection === "ltr" ? this.parentMenuView ? [
      a,
      l,
      o,
      u
    ] : [
      t,
      i,
      r,
      s
    ] : this.parentMenuView ? [
      o,
      u,
      a,
      l
    ] : [
      i,
      t,
      s,
      r
    ];
  }
  /**
  * The default position of the panel when the menu is opened.
  * It is used when the optimal position cannot be calculated.
  */
  get _defaultMenuPositionName() {
    return this.locale.uiLanguageDirection === "ltr" ? this.parentMenuView ? "es" : "se" : this.parentMenuView ? "ws" : "sw";
  }
};
/**
* A function used to calculate the optimal position for the dropdown panel.
*
* Referenced for unit testing purposes.
*/
m(Yl, "_getOptimalPosition", Hf);
let Jr = Yl;
class Sl extends oc {
  /**
  * Creates an instance of the list view.
  *
  * @param locale The localization services instance.
  */
  constructor(n) {
    super(n), this.role = "menu", this.items.on("change", this._setItemsCheckSpace.bind(this));
  }
  /**
  * This method adds empty space if there is any toggleable item in the list.
  * It makes the list properly aligned.
  */
  _setItemsCheckSpace() {
    const n = Array.from(this.items).some((t) => {
      const i = _g(t);
      return i && i.isToggleable;
    });
    this.items.forEach((t) => {
      const i = _g(t);
      i && (i.hasCheckSpace = n);
    });
  }
}
function _g(e) {
  return e instanceof qi ? e.children.map((n) => Y4(n) ? n.buttonView : n).find((n) => n instanceof no) : null;
}
function Y4(e) {
  return typeof e == "object" && "buttonView" in e && e.buttonView instanceof gt;
}
class j4 extends M5 {
  /**
  * Creates an instance of the menu bar list button view.
  *
  * @param locale The localization services instance.
  */
  constructor(n) {
    super(n), this.set({
      withText: !0,
      withKeystroke: !0,
      tooltip: !1,
      role: "menuitem"
    }), this.extendTemplate({
      attributes: {
        class: [
          "ck-menu-bar__menu__item__button"
        ]
      }
    });
  }
}
const Eg = [
  "mouseenter",
  "arrowleft",
  "arrowright",
  "change:isOpen"
];
class K4 extends me {
  /**
  * Creates an instance of the menu bar view.
  *
  * @param locale The localization services instance.
  */
  constructor(t) {
    super(t);
    /**
    * Collection of the child views inside the {@link #element}.
    */
    m(this, "children");
    /**
    * A list of {@link module:ui/menubar/menubarmenuview~MenuBarMenuView} instances registered in the menu bar.
    *
    * @observable
    */
    m(this, "menus", []);
    const i = t.t, r = this.bindTemplate;
    this.set({
      isOpen: !1,
      isFocusBorderEnabled: !1
    }), this._setupIsOpenUpdater(), this.children = this.createCollection(), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-menu-bar",
          r.if("isFocusBorderEnabled", "ck-menu-bar_focus-border-enabled")
        ],
        "aria-label": i("Editor menu bar"),
        role: "menubar"
      },
      children: this.children
    });
  }
  /**
  * A utility that expands a plain menu bar configuration into a structure of menus (also: sub-menus)
  * and items using a given {@link module:ui/componentfactory~ComponentFactory component factory}.
  *
  * See the {@link module:core/editor/editorconfig~EditorConfig#menuBar menu bar} in the editor
  * configuration reference to learn how to configure the menu bar.
  */
  fillFromConfig(t, i, r = []) {
    const s = this.locale, a = I4({
      normalizedConfig: t,
      locale: s,
      componentFactory: i,
      extraItems: r
    }).items.map((u) => this._createMenu({
      componentFactory: i,
      menuDefinition: u
    }));
    this.children.addMany(a);
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), Cs.toggleMenusAndFocusItemsOnHover(this), Cs.closeMenusWhenTheBarCloses(this), Cs.closeMenuWhenAnotherOnTheSameLevelOpens(this), Cs.focusCycleMenusOnArrows(this), Cs.closeOnClickOutside(this), Cs.enableFocusHighlightOnInteraction(this);
  }
  /**
  * Focuses the menu bar.
  */
  focus() {
    this.children.first && this.children.first.focus();
  }
  /**
  * Closes all menus in the bar.
  */
  close() {
    for (const t of this.children)
      t.isOpen = !1;
  }
  /**
  * Registers a menu view in the menu bar. Every {@link module:ui/menubar/menubarmenuview~MenuBarMenuView} instance must be registered
  * in the menu bar to be properly managed.
  */
  registerMenu(t, i = null) {
    i ? (t.delegate(...Eg).to(i), t.parentMenuView = i) : t.delegate(...Eg).to(this, (r) => "menu:" + r), t._attachBehaviors(), this.menus.push(t);
  }
  /**
  * Creates a {@link module:ui/menubar/menubarmenuview~MenuBarMenuView} based on the given definition.
  */
  _createMenu({ componentFactory: t, menuDefinition: i, parentMenuView: r }) {
    const s = this.locale, o = new Jr(s);
    return this.registerMenu(o, r), o.buttonView.set({
      label: i.label
    }), o.once("change:isOpen", () => {
      const a = new Sl(s);
      a.ariaLabel = i.label, o.panelView.children.add(a), a.items.addMany(this._createMenuItems({
        menuDefinition: i,
        parentMenuView: o,
        componentFactory: t
      }));
    }), o;
  }
  /**
  * Creates a {@link module:ui/menubar/menubarmenuview~MenuBarMenuView} items based on the given definition.
  */
  _createMenuItems({ menuDefinition: t, parentMenuView: i, componentFactory: r }) {
    const s = this.locale, o = [];
    for (const a of t.groups) {
      for (const u of a.items) {
        const l = new uc(s, i);
        if (ft(u))
          l.children.add(this._createMenu({
            componentFactory: r,
            menuDefinition: u,
            parentMenuView: i
          }));
        else {
          const c = this._createMenuItemContentFromFactory({
            componentName: u,
            componentFactory: r,
            parentMenuView: i
          });
          if (!c)
            continue;
          l.children.add(c);
        }
        o.push(l);
      }
      a !== t.groups[t.groups.length - 1] && o.push(new am(s));
    }
    return o;
  }
  /**
  * Uses the component factory to create a content of the menu item (a button or a sub-menu).
  */
  _createMenuItemContentFromFactory({ componentName: t, parentMenuView: i, componentFactory: r }) {
    const s = r.create(t);
    return s instanceof Jr || s instanceof Dn || s instanceof j4 ? (this._registerMenuTree(s, i), s.on("execute", () => {
      this.close();
    }), s) : (at("menu-bar-component-unsupported", {
      componentName: t,
      componentView: s
    }), null);
  }
  /**
  * Checks component and its children recursively and calls {@link #registerMenu}
  * for each item that is {@link module:ui/menubar/menubarmenuview~MenuBarMenuView}.
  *
  * @internal
  */
  _registerMenuTree(t, i) {
    if (!(t instanceof Jr)) {
      t.delegate("mouseenter").to(i);
      return;
    }
    this.registerMenu(t, i);
    const r = t.panelView.children.filter((o) => o instanceof Sl)[0];
    if (!r) {
      t.delegate("mouseenter").to(i);
      return;
    }
    const s = r.items.filter((o) => o instanceof qi);
    for (const o of s)
      this._registerMenuTree(o.children.get(0), t);
  }
  /**
  * Manages the state of the {@link #isOpen} property of the menu bar. Because the state is a sum of individual
  * top-level menus' states, it's necessary to listen to their changes and update the state accordingly.
  *
  * Additionally, it prevents from unnecessary changes of `isOpen` when one top-level menu opens and another closes
  * (regardless of in which order), maintaining a stable `isOpen === true` in that situation.
  */
  _setupIsOpenUpdater() {
    let t;
    this.on("menu:change:isOpen", (i, r, s) => {
      clearTimeout(t), s ? this.isOpen = !0 : t = setTimeout(() => {
        this.isOpen = Array.from(this.children).some((o) => o.isOpen);
      }, 0);
    });
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const lm = [
  "left",
  "right",
  "center",
  "justify"
];
function ny(e) {
  return lm.includes(e);
}
function iy(e, n) {
  return n.contentLanguageDirection == "rtl" ? e === "right" : e === "left";
}
function ry(e) {
  const n = e.map((i) => {
    let r;
    return typeof i == "string" ? r = {
      name: i
    } : r = i, r;
  }).filter((i) => {
    const r = lm.includes(i.name);
    return r || at("alignment-config-name-not-recognized", {
      option: i
    }), r;
  }), t = n.filter((i) => !!i.className).length;
  if (t && t < n.length)
    throw new v("alignment-config-classnames-are-missing", {
      configuredOptions: e
    });
  return n.forEach((i, r, s) => {
    const o = s.slice(r + 1);
    if (o.some((u) => u.name == i.name))
      throw new v("alignment-config-name-already-defined", {
        option: i,
        configuredOptions: e
      });
    if (i.className && o.some((l) => l.className == i.className))
      throw new v("alignment-config-classname-already-defined", {
        option: i,
        configuredOptions: e
      });
  }), n;
}
const cm = "alignment";
class G4 extends Mt {
  /**
  * @inheritDoc
  */
  refresh() {
    const t = this.editor.locale, i = zn(this.editor.model.document.selection.getSelectedBlocks());
    this.isEnabled = !!i && this._canBeAligned(i), this.isEnabled && i.hasAttribute("alignment") ? this.value = i.getAttribute("alignment") : this.value = t.contentLanguageDirection === "rtl" ? "right" : "left";
  }
  /**
  * Executes the command. Applies the alignment `value` to the selected blocks.
  * If no `value` is passed, the `value` is the default one or it is equal to the currently selected block's alignment attribute,
  * the command will remove the attribute from the selected blocks.
  *
  * @param options Options for the executed command.
  * @param options.value The value to apply.
  * @fires execute
  */
  execute(n = {}) {
    const t = this.editor, i = t.locale, r = t.model, s = r.document, o = n.value;
    r.change((a) => {
      const u = Array.from(s.selection.getSelectedBlocks()).filter((d) => this._canBeAligned(d)), l = u[0].getAttribute("alignment");
      iy(o, i) || l === o || !o ? Q4(u, a) : X4(u, a, o);
    });
  }
  /**
  * Checks whether a block can have alignment set.
  *
  * @param block The block to be checked.
  */
  _canBeAligned(n) {
    return this.editor.model.schema.checkAttribute(n, cm);
  }
}
function Q4(e, n) {
  for (const t of e)
    n.removeAttribute(cm, t);
}
function X4(e, n, t) {
  for (const i of e)
    n.setAttribute(cm, t, i);
}
class J4 extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "AlignmentEditing";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  constructor(n) {
    super(n), n.config.define("alignment", {
      options: lm.map((t) => ({
        name: t
      }))
    });
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = n.locale, i = n.model.schema, s = ry(n.config.get("alignment.options")).filter((l) => ny(l.name) && !iy(l.name, t)), o = s.some((l) => !!l.className);
    i.extend("$block", {
      allowAttributes: "alignment"
    }), n.model.schema.setAttributeProperties("alignment", {
      isFormatting: !0
    }), o ? n.conversion.attributeToAttribute(nL(s)) : n.conversion.for("downcast").attributeToAttribute(Z4(s));
    const a = eL(s);
    for (const l of a)
      n.conversion.for("upcast").attributeToAttribute(l);
    const u = tL(s);
    for (const l of u)
      n.conversion.for("upcast").attributeToAttribute(l);
    n.commands.add("alignment", new G4(n));
  }
}
function Z4(e) {
  const n = {};
  for (const { name: i } of e)
    n[i] = {
      key: "style",
      value: {
        "text-align": i
      }
    };
  return {
    model: {
      key: "alignment",
      values: e.map((i) => i.name)
    },
    view: n
  };
}
function eL(e) {
  const n = [];
  for (const { name: t } of e)
    n.push({
      view: {
        key: "style",
        value: {
          "text-align": t
        }
      },
      model: {
        key: "alignment",
        value: t
      }
    });
  return n;
}
function tL(e) {
  const n = [];
  for (const { name: t } of e)
    n.push({
      view: {
        key: "align",
        value: t
      },
      model: {
        key: "alignment",
        value: t
      }
    });
  return n;
}
function nL(e) {
  const n = {};
  for (const i of e)
    n[i.name] = {
      key: "class",
      value: i.className
    };
  return {
    model: {
      key: "alignment",
      values: e.map((i) => i.name)
    },
    view: n
  };
}
const Bo = /* @__PURE__ */ new Map([
  [
    "left",
    Ge.alignLeft
  ],
  [
    "right",
    Ge.alignRight
  ],
  [
    "center",
    Ge.alignCenter
  ],
  [
    "justify",
    Ge.alignJustify
  ]
]);
class iL extends ce {
  /**
  * Returns the localized option titles provided by the plugin.
  *
  * The following localized titles corresponding with
  * {@link module:alignment/alignmentconfig~AlignmentConfig#options} are available:
  *
  * * `'left'`,
  * * `'right'`,
  * * `'center'`,
  * * `'justify'`.
  *
  * @readonly
  */
  get localizedOptionTitles() {
    const n = this.editor.t;
    return {
      left: n("Align left"),
      right: n("Align right"),
      center: n("Align center"),
      justify: n("Justify")
    };
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "AlignmentUI";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = ry(n.config.get("alignment.options"));
    t.map((i) => i.name).filter(ny).forEach((i) => this._addButton(i)), this._addToolbarDropdown(t), this._addMenuBarMenu(t);
  }
  /**
  * Helper method for initializing the button and linking it with an appropriate command.
  *
  * @param option The name of the alignment option for which the button is added.
  */
  _addButton(n) {
    this.editor.ui.componentFactory.add(`alignment:${n}`, (i) => this._createButton(i, n));
  }
  /**
  * Helper method for creating the button view element.
  *
  * @param locale Editor locale.
  * @param option The name of the alignment option for which the button is added.
  * @param buttonAttrs Optional parameters passed to button view instance.
  */
  _createButton(n, t, i = {}) {
    const r = this.editor, s = r.commands.get("alignment"), o = new gt(n);
    return o.set({
      label: this.localizedOptionTitles[t],
      icon: Bo.get(t),
      tooltip: !0,
      isToggleable: !0,
      ...i
    }), o.bind("isEnabled").to(s), o.bind("isOn").to(s, "value", (a) => a === t), this.listenTo(o, "execute", () => {
      r.execute("alignment", {
        value: t
      }), r.editing.view.focus();
    }), o;
  }
  /**
  * Helper method for initializing the toolnar dropdown and linking it with an appropriate command.
  *
  * @param option The name of the alignment option for which the button is added.
  */
  _addToolbarDropdown(n) {
    const t = this.editor;
    t.ui.componentFactory.add("alignment", (r) => {
      const s = ac(r), o = r.uiLanguageDirection === "rtl" ? "w" : "e", a = r.t;
      um(s, () => n.map((c) => this._createButton(r, c.name, {
        tooltipPosition: o
      })), {
        enableActiveItemFocusOnDropdownOpen: !0,
        isVertical: !0,
        ariaLabel: a("Text alignment toolbar")
      }), s.buttonView.set({
        label: a("Text alignment"),
        tooltip: !0
      }), s.extendTemplate({
        attributes: {
          class: "ck-alignment-dropdown"
        }
      });
      const u = r.contentLanguageDirection === "rtl" ? Bo.get("right") : Bo.get("left"), l = t.commands.get("alignment");
      return s.buttonView.bind("icon").to(l, "value", (c) => Bo.get(c) || u), s.bind("isEnabled").to(l, "isEnabled"), this.listenTo(s, "execute", () => {
        t.editing.view.focus();
      }), s;
    });
  }
  /**
  * Creates a menu for all alignment options to use either in menu bar.
  *
  * @param options Normalized alignment options from config.
  */
  _addMenuBarMenu(n) {
    const t = this.editor;
    t.ui.componentFactory.add("menuBar:alignment", (i) => {
      const r = t.commands.get("alignment"), s = i.t, o = new Jr(i), a = new Sl(i);
      o.bind("isEnabled").to(r), a.set({
        ariaLabel: s("Text alignment"),
        role: "menu"
      }), o.buttonView.set({
        label: s("Text alignment")
      });
      for (const u of n) {
        const l = new uc(i, o), c = new Dn(i);
        c.delegate("execute").to(o), c.set({
          label: this.localizedOptionTitles[u.name],
          icon: Bo.get(u.name),
          role: "menuitemcheckbox",
          isToggleable: !0
        }), c.on("execute", () => {
          t.execute("alignment", {
            value: u.name
          }), t.editing.view.focus();
        }), c.bind("isOn").to(r, "value", (d) => d === u.name), c.bind("isEnabled").to(r, "isEnabled"), l.children.add(c), a.items.add(l);
      }
      return o.panelView.children.add(a), o;
    });
  }
}
class rL extends ce {
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      J4,
      iL
    ];
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Alignment";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class sy {
  /**
  * Creates a new instance of the change buffer.
  *
  * @param limit The maximum number of atomic changes which can be contained in one batch.
  */
  constructor(n, t = 20) {
    /**
    * The model instance.
    */
    m(this, "model");
    /**
    * The maximum number of atomic changes which can be contained in one batch.
    */
    m(this, "limit");
    /**
    * Whether the buffer is locked. A locked buffer cannot be reset unless it gets unlocked.
    */
    m(this, "_isLocked");
    /**
    * The number of atomic changes in the buffer. Once it exceeds the {@link #limit},
    * the {@link #batch batch} is set to a new one.
    */
    m(this, "_size");
    /**
    * The current batch instance.
    */
    m(this, "_batch", null);
    /**
    * The callback to document the change event which later needs to be removed.
    */
    m(this, "_changeCallback");
    /**
    * The callback to document selection `change:attribute` and `change:range` events which resets the buffer.
    */
    m(this, "_selectionChangeCallback");
    this.model = n, this._size = 0, this.limit = t, this._isLocked = !1, this._changeCallback = (i, r) => {
      r.isLocal && r.isUndoable && r !== this._batch && this._reset(!0);
    }, this._selectionChangeCallback = () => {
      this._reset();
    }, this.model.document.on("change", this._changeCallback), this.model.document.selection.on("change:range", this._selectionChangeCallback), this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
  }
  /**
  * The current batch to which a feature should add its operations. Once the {@link #size}
  * is reached or exceeds the {@link #limit}, the batch is set to a new instance and the size is reset.
  */
  get batch() {
    return this._batch || (this._batch = this.model.createBatch({
      isTyping: !0
    })), this._batch;
  }
  /**
  * The number of atomic changes in the buffer. Once it exceeds the {@link #limit},
  * the {@link #batch batch} is set to a new one.
  */
  get size() {
    return this._size;
  }
  /**
  * The input number of changes into the buffer. Once the {@link #size} is
  * reached or exceeds the {@link #limit}, the batch is set to a new instance and the size is reset.
  *
  * @param changeCount The number of atomic changes to input.
  */
  input(n) {
    this._size += n, this._size >= this.limit && this._reset(!0);
  }
  /**
  * Whether the buffer is locked. A locked buffer cannot be reset unless it gets unlocked.
  */
  get isLocked() {
    return this._isLocked;
  }
  /**
  * Locks the buffer.
  */
  lock() {
    this._isLocked = !0;
  }
  /**
  * Unlocks the buffer.
  */
  unlock() {
    this._isLocked = !1;
  }
  /**
  * Destroys the buffer.
  */
  destroy() {
    this.model.document.off("change", this._changeCallback), this.model.document.selection.off("change:range", this._selectionChangeCallback), this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
  }
  /**
  * Resets the change buffer.
  *
  * @param ignoreLock Whether internal lock {@link #isLocked} should be ignored.
  */
  _reset(n = !1) {
    (!this.isLocked || n) && (this._batch = null, this._size = 0);
  }
}
class sL extends Mt {
  /**
  * Creates an instance of the command.
  *
  * @param undoStepSize The maximum number of atomic changes
  * which can be contained in one batch in the command buffer.
  */
  constructor(t, i) {
    super(t);
    /**
    * Typing's change buffer used to group subsequent changes into batches.
    */
    m(this, "_buffer");
    this._buffer = new sy(t.model, i), this._isEnabledBasedOnSelection = !1;
  }
  /**
  * The current change buffer.
  */
  get buffer() {
    return this._buffer;
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy(), this._buffer.destroy();
  }
  /**
  * Executes the input command. It replaces the content within the given range with the given text.
  * Replacing is a two step process, first the content within the range is removed and then the new text is inserted
  * at the beginning of the range (which after the removal is a collapsed range).
  *
  * @fires execute
  * @param options The command options.
  */
  execute(t = {}) {
    const i = this.editor.model, r = i.document, s = t.text || "", o = s.length;
    let a = r.selection;
    if (t.selection ? a = t.selection : t.range && (a = i.createSelection(t.range)), !i.canEditAt(a))
      return;
    const u = t.resultRange;
    i.enqueueChange(this._buffer.batch, (l) => {
      this._buffer.lock();
      const c = Array.from(r.selection.getAttributes());
      i.deleteContent(a), s && i.insertContent(l.createText(s, c), a), u ? l.setSelection(u) : a.is("documentSelection") || l.setSelection(a), this._buffer.unlock(), this._buffer.input(o);
    });
  }
}
const oy = [
  // For collapsed range:
  //	- This one is a regular typing (all browsers, all systems).
  //	- This one is used by Chrome when typing accented letter – 2nd step when the user selects the accent (Mac).
  // For non-collapsed range:
  //	- This one is used by Chrome when typing accented letter – when the selection box first appears (Mac).
  //	- This one is used by Safari when accepting spell check suggestions from the context menu (Mac).
  "insertText",
  // This one is used by Safari when typing accented letter (Mac).
  // This one is used by Safari when accepting spell check suggestions from the autocorrection pop-up (Mac).
  "insertReplacementText"
], oL = [
  ...oy,
  "insertCompositionText"
];
class aL extends Xi {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * Instance of the focus observer. Insert text observer calls
    * {@link module:engine/view/observer/focusobserver~FocusObserver#flush} to mark the latest focus change as complete.
    */
    m(this, "focusObserver");
    this.focusObserver = t.getObserver(Tl);
    const i = he.isAndroid ? oL : oy, r = t.document;
    r.on("beforeinput", (s, o) => {
      if (!this.isEnabled)
        return;
      const { data: a, targetRanges: u, inputType: l, domEvent: c } = o;
      if (!i.includes(l))
        return;
      this.focusObserver.flush();
      const d = new Wi(r, "insertText");
      r.fire(d, new eo(t, c, {
        text: a,
        selection: t.createSelection(u)
      })), d.stop.called && s.stop();
    }), he.isAndroid || r.on("compositionend", (s, { data: o, domEvent: a }) => {
      this.isEnabled && o && r.fire("insertText", new eo(t, a, {
        text: o
      }));
    }, {
      priority: "lowest"
    });
  }
  /**
  * @inheritDoc
  */
  observe() {
  }
  /**
  * @inheritDoc
  */
  stopObserving() {
  }
}
class ay extends ce {
  constructor() {
    super(...arguments);
    /**
    * The queue of `insertText` command executions that are waiting for the DOM to get updated after beforeinput event.
    */
    m(this, "_compositionQueue");
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Input";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const t = this.editor, i = t.model, r = t.editing.view, s = t.editing.mapper, o = i.document.selection;
    this._compositionQueue = new uL(t), r.addObserver(aL);
    const a = new sL(t, t.config.get("typing.undoStep") || 20);
    t.commands.add("insertText", a), t.commands.add("input", a), this.listenTo(r.document, "insertText", (u, l) => {
      r.document.isComposing || l.preventDefault(), he.isAndroid && r.document.isComposing && this._compositionQueue.flush("next beforeinput");
      const { text: c, selection: d } = l;
      let p;
      d ? p = Array.from(d.getRanges()).map((_) => s.toModelRange(_)) : p = Array.from(o.getRanges());
      let g = c;
      if (he.isAndroid) {
        const _ = Array.from(p[0].getItems()).reduce((k, C) => k + (C.is("$textProxy") ? C.data : ""), "");
        if (_ && (_.length <= g.length ? g.startsWith(_) && (g = g.substring(_.length), p[0].start = p[0].start.getShiftedBy(_.length)) : _.startsWith(g) && (p[0].start = p[0].start.getShiftedBy(g.length), g = "")), g.length == 0 && p[0].isCollapsed)
          return;
      }
      const b = {
        text: g,
        selection: i.createSelection(p)
      };
      he.isAndroid && r.document.isComposing ? this._compositionQueue.push(b) : (t.execute("insertText", b), r.scrollToTheSelection());
    }), he.isAndroid ? this.listenTo(r.document, "keydown", (u, l) => {
      o.isCollapsed || l.keyCode != 229 || !r.document.isComposing || Tg(i, a);
    }) : this.listenTo(r.document, "compositionstart", () => {
      o.isCollapsed || Tg(i, a);
    }), he.isAndroid ? (this.listenTo(r.document, "mutations", (u, { mutations: l }) => {
      if (r.document.isComposing)
        for (const { node: c } of l) {
          const d = cL(c, s), p = s.toModelElement(d);
          if (this._compositionQueue.isComposedElement(p)) {
            this._compositionQueue.flush("mutations");
            return;
          }
        }
    }), this.listenTo(r.document, "compositionend", () => {
      this._compositionQueue.flush("composition end");
    }), this.listenTo(r.document, "compositionend", () => {
      const u = [];
      for (const l of this._compositionQueue.flushComposedElements()) {
        const c = s.toViewElement(l);
        c && u.push({
          type: "children",
          node: c
        });
      }
      u.length && r.document.fire("mutations", {
        mutations: u
      });
    }, {
      priority: "lowest"
    })) : this.listenTo(r.document, "compositionend", () => {
      r.document.fire("mutations", {
        mutations: []
      });
    }, {
      priority: "lowest"
    });
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy(), this._compositionQueue.destroy();
  }
}
class uL {
  /**
  * @inheritDoc
  */
  constructor(n) {
    /**
    * The editor instance.
    */
    m(this, "editor");
    /**
    * Debounced queue flush as a safety mechanism for cases of mutation observer not triggering.
    */
    m(this, "flushDebounced", _r(() => this.flush("timeout"), 50));
    /**
    * The queue of `insertText` command executions that are waiting for the DOM to get updated after beforeinput event.
    */
    m(this, "_queue", []);
    /**
    * A set of model elements. The composition happened in those elements. It's used for mutations check.
    */
    m(this, "_compositionElements", /* @__PURE__ */ new Set());
    this.editor = n;
  }
  /**
  * Destroys the helper object.
  */
  destroy() {
    for (this.flushDebounced.cancel(), this._compositionElements.clear(); this._queue.length; )
      this.shift();
  }
  /**
  * Returns the size of the queue.
  */
  get length() {
    return this._queue.length;
  }
  /**
  * Push next insertText command data to the queue.
  */
  push(n) {
    const t = {
      text: n.text
    };
    if (n.selection) {
      t.selectionRanges = [];
      for (const i of n.selection.getRanges())
        t.selectionRanges.push(xn.fromRange(i)), this._compositionElements.add(i.start.parent);
    }
    this._queue.push(t), this.flushDebounced();
  }
  /**
  * Shift the first item from the insertText command data queue.
  */
  shift() {
    const n = this._queue.shift(), t = {
      text: n.text
    };
    if (n.selectionRanges) {
      const i = n.selectionRanges.map((r) => lL(r)).filter((r) => !!r);
      i.length && (t.selection = this.editor.model.createSelection(i));
    }
    return t;
  }
  /**
  * Applies all queued insertText command executions.
  *
  * @param reason Used only for debugging.
  */
  flush(n) {
    const t = this.editor, i = t.model, r = t.editing.view;
    if (this.flushDebounced.cancel(), !this._queue.length)
      return;
    const o = t.commands.get("insertText").buffer;
    i.enqueueChange(o.batch, () => {
      for (o.lock(); this._queue.length; ) {
        const a = this.shift();
        t.execute("insertText", a);
      }
      o.unlock();
    }), r.scrollToTheSelection();
  }
  /**
  * Returns `true` if the given model element is related to recent composition.
  */
  isComposedElement(n) {
    return this._compositionElements.has(n);
  }
  /**
  * Returns an array of composition-related elements and clears the internal list.
  */
  flushComposedElements() {
    const n = Array.from(this._compositionElements);
    return this._compositionElements.clear(), n;
  }
}
function Tg(e, n) {
  if (!n.isEnabled)
    return;
  const t = n.buffer;
  t.lock(), e.enqueueChange(t.batch, () => {
    e.deleteContent(e.document.selection);
  }), t.unlock();
}
function lL(e) {
  const n = e.toRange();
  return e.detach(), n.root.rootName == "$graveyard" ? null : n;
}
function cL(e, n) {
  let t = e.is("$text") ? e.parent : e;
  for (; !n.toModelElement(t); )
    t = t.parent;
  return t;
}
class yg extends Mt {
  /**
  * Creates an instance of the command.
  *
  * @param direction The directionality of the delete describing in what direction it
  * should consume the content when the selection is collapsed.
  */
  constructor(t, i) {
    super(t);
    /**
    * The directionality of the delete describing in what direction it should
    * consume the content when the selection is collapsed.
    */
    m(this, "direction");
    /**
    * Delete's change buffer used to group subsequent changes into batches.
    */
    m(this, "_buffer");
    this.direction = i, this._buffer = new sy(t.model, t.config.get("typing.undoStep")), this._isEnabledBasedOnSelection = !1;
  }
  /**
  * The current change buffer.
  */
  get buffer() {
    return this._buffer;
  }
  /**
  * Executes the delete command. Depending on whether the selection is collapsed or not, deletes its content
  * or a piece of content in the {@link #direction defined direction}.
  *
  * @fires execute
  * @param options The command options.
  * @param options.unit See {@link module:engine/model/utils/modifyselection~modifySelection}'s options.
  * @param options.sequence A number describing which subsequent delete event it is without the key being released.
  * See the {@link module:engine/view/document~Document#event:delete} event data.
  * @param options.selection Selection to remove. If not set, current model selection will be used.
  */
  execute(t = {}) {
    const i = this.editor.model, r = i.document;
    i.enqueueChange(this._buffer.batch, (s) => {
      this._buffer.lock();
      const o = s.createSelection(t.selection || r.selection);
      if (!i.canEditAt(o))
        return;
      const a = t.sequence || 1, u = o.isCollapsed;
      if (o.isCollapsed && i.modifySelection(o, {
        direction: this.direction,
        unit: t.unit,
        treatEmojiAsSingleUnit: !0
      }), this._shouldEntireContentBeReplacedWithParagraph(a)) {
        this._replaceEntireContentWithParagraph(s);
        return;
      }
      if (this._shouldReplaceFirstBlockWithParagraph(o, a)) {
        this.editor.execute("paragraph", {
          selection: o
        });
        return;
      }
      if (o.isCollapsed)
        return;
      let l = 0;
      o.getFirstRange().getMinimalFlatRanges().forEach((c) => {
        l += Ch(c.getWalker({
          singleCharacters: !0,
          ignoreElementEnd: !0,
          shallow: !0
        }));
      }), i.deleteContent(o, {
        doNotResetEntireContent: u,
        direction: this.direction
      }), this._buffer.input(l), s.setSelection(o), this._buffer.unlock();
    });
  }
  /**
  * If the user keeps <kbd>Backspace</kbd> or <kbd>Delete</kbd> key pressed, the content of the current
  * editable will be cleared. However, this will not yet lead to resetting the remaining block to a paragraph
  * (which happens e.g. when the user does <kbd>Ctrl</kbd> + <kbd>A</kbd>, <kbd>Backspace</kbd>).
  *
  * But, if the user pressed the key in an empty editable for the first time,
  * we want to replace the entire content with a paragraph if:
  *
  * * the current limit element is empty,
  * * the paragraph is allowed in the limit element,
  * * the limit doesn't already have a paragraph inside.
  *
  * See https://github.com/ckeditor/ckeditor5-typing/issues/61.
  *
  * @param sequence A number describing which subsequent delete event it is without the key being released.
  */
  _shouldEntireContentBeReplacedWithParagraph(t) {
    if (t > 1)
      return !1;
    const i = this.editor.model, s = i.document.selection, o = i.schema.getLimitElement(s);
    if (!(s.isCollapsed && s.containsEntireContent(o)) || !i.schema.checkChild(o, "paragraph"))
      return !1;
    const u = o.getChild(0);
    return !(u && u.is("element", "paragraph"));
  }
  /**
  * The entire content is replaced with the paragraph. Selection is moved inside the paragraph.
  *
  * @param writer The model writer.
  */
  _replaceEntireContentWithParagraph(t) {
    const i = this.editor.model, s = i.document.selection, o = i.schema.getLimitElement(s), a = t.createElement("paragraph");
    t.remove(t.createRangeIn(o)), t.insert(a, o), t.setSelection(a, 0);
  }
  /**
  * Checks if the selection is inside an empty element that is the first child of the limit element
  * and should be replaced with a paragraph.
  *
  * @param selection The selection.
  * @param sequence A number describing which subsequent delete event it is without the key being released.
  */
  _shouldReplaceFirstBlockWithParagraph(t, i) {
    const r = this.editor.model;
    if (i > 1 || this.direction != "backward" || !t.isCollapsed)
      return !1;
    const s = t.getFirstPosition(), o = r.schema.getLimitElement(s), a = o.getChild(0);
    return !(s.parent != a || !t.containsEntireContent(a) || !r.schema.checkChild(o, "paragraph") || a.name == "paragraph");
  }
}
const dL = "character", wg = "word", hL = "codePoint", hr = "selection", Fs = "backward", Jo = "forward", uy = {
  // --------------------------------------- Backward delete types -----------------------------------------------------
  // This happens in Safari on Mac when some content is selected and Ctrl + K is pressed.
  deleteContent: {
    unit: hr,
    // According to the Input Events Level 2 spec, this delete type has no direction
    // but to keep things simple, let's default to backward.
    direction: Fs
  },
  // Chrome and Safari on Mac: Backspace or Ctrl + H
  deleteContentBackward: {
    // This kind of deletions must be done on the code point-level instead of target range provided by the DOM beforeinput event.
    // Take for instance "👨‍👩‍👧‍👧", it equals:
    //
    //	* [ "👨", "ZERO WIDTH JOINER", "👩", "ZERO WIDTH JOINER", "👧", "ZERO WIDTH JOINER", "👧" ]
    //	* or simply "\u{1F468}\u200D\u{1F469}\u200D\u{1F467}\u200D\u{1F467}"
    //
    // The range provided by the browser would cause the entire multi-byte grapheme to disappear while the user
    // intention when deleting backwards ("👨‍👩‍👧‍👧[]", then backspace) is gradual "decomposition" (first to "👨‍👩‍👧‍[]",
    // then to "👨‍👩‍[]", etc.).
    //
    //	* "👨‍👩‍👧‍👧[]" + backward delete (by code point)  -> results in "👨‍👩‍👧[]", removed the last "👧" 👍
    //	* "👨‍👩‍👧‍👧[]" + backward delete (by character)  -> results in "[]", removed the whole grapheme 👎
    //
    // Deleting by code-point is simply a better UX. See "deleteContentForward" to learn more.
    unit: hL,
    direction: Fs
  },
  // On Mac: Option + Backspace.
  // On iOS: Hold the backspace for a while and the whole words will start to disappear.
  deleteWordBackward: {
    unit: wg,
    direction: Fs
  },
  // Safari on Mac: Cmd + Backspace
  deleteHardLineBackward: {
    unit: hr,
    direction: Fs
  },
  // Chrome on Mac: Cmd + Backspace.
  deleteSoftLineBackward: {
    unit: hr,
    direction: Fs
  },
  // --------------------------------------- Forward delete types -----------------------------------------------------
  // Chrome on Mac: Fn + Backspace or Ctrl + D
  // Safari on Mac: Ctrl + K or Ctrl + D
  deleteContentForward: {
    // Unlike backward delete, this delete must be performed by character instead of by code point, which
    // provides the best UX for working with accented letters.
    // Take, for example "b̂" ("\u0062\u0302", or [ "LATIN SMALL LETTER B", "COMBINING CIRCUMFLEX ACCENT" ]):
    //
    //	* "b̂[]" + backward delete (by code point)  -> results in "b[]", removed the combining mark 👍
    //	* "[]b̂" + forward delete (by code point)   -> results in "[]^", a bare combining mark does that not make sense when alone 👎
    //	* "[]b̂" + forward delete (by character)    -> results in "[]", removed both "b" and the combining mark 👍
    //
    // See: "deleteContentBackward" to learn more.
    unit: dL,
    direction: Jo
  },
  // On Mac: Fn + Option + Backspace.
  deleteWordForward: {
    unit: wg,
    direction: Jo
  },
  // Chrome on Mac: Ctrl + K (you have to disable the Link plugin first, though, because it uses the same keystroke)
  // This is weird that it does not work in Safari on Mac despite being listed in the official shortcuts listing
  // on Apple's webpage.
  deleteHardLineForward: {
    unit: hr,
    direction: Jo
  },
  // At this moment there is no known way to trigger this event type but let's keep it for the symmetry with
  // deleteSoftLineBackward.
  deleteSoftLineForward: {
    unit: hr,
    direction: Jo
  }
};
class fL extends Xi {
  /**
  * @inheritDoc
  */
  constructor(n) {
    super(n);
    const t = n.document;
    let i = 0;
    t.on("keydown", () => {
      i++;
    }), t.on("keyup", () => {
      i = 0;
    }), t.on("beforeinput", (r, s) => {
      if (!this.isEnabled)
        return;
      const { targetRanges: o, domEvent: a, inputType: u } = s, l = uy[u];
      if (!l)
        return;
      const c = {
        direction: l.direction,
        unit: l.unit,
        sequence: i
      };
      c.unit == hr && (c.selectionToRemove = n.createSelection(o[0])), u === "deleteContentBackward" && (he.isAndroid && (c.sequence = 1), pL(o) && (c.unit = hr, c.selectionToRemove = n.createSelection(o)));
      const d = new fo(t, "delete", o[0]);
      t.fire(d, new eo(n, a, c)), d.stop.called && r.stop();
    }), he.isBlink && mL(this);
  }
  /**
  * @inheritDoc
  */
  observe() {
  }
  /**
  * @inheritDoc
  */
  stopObserving() {
  }
}
function mL(e) {
  const n = e.view, t = n.document;
  let i = null, r = !1;
  t.on("keydown", (a, { keyCode: u }) => {
    i = u, r = !1;
  }), t.on("keyup", (a, { keyCode: u, domEvent: l }) => {
    const c = t.selection, d = e.isEnabled && u == i && s(u) && !c.isCollapsed && !r;
    if (i = null, d) {
      const p = c.getFirstRange(), g = new fo(t, "delete", p), b = {
        unit: hr,
        direction: o(u),
        selectionToRemove: c
      };
      t.fire(g, new eo(n, l, b));
    }
  }), t.on("beforeinput", (a, { inputType: u }) => {
    const l = uy[u];
    s(i) && l && l.direction == o(i) && (r = !0);
  }, {
    priority: "high"
  }), t.on("beforeinput", (a, { inputType: u, data: l }) => {
    i == ye.delete && u == "insertText" && l == "" && a.stop();
  }, {
    priority: "high"
  });
  function s(a) {
    return a == ye.backspace || a == ye.delete;
  }
  function o(a) {
    return a == ye.backspace ? Fs : Jo;
  }
}
function pL(e) {
  if (e.length != 1 || e[0].isCollapsed)
    return !1;
  const n = e[0].getWalker({
    direction: "backward",
    singleCharacters: !0,
    ignoreElementEnd: !0
  });
  let t = 0;
  for (const { nextPosition: i, item: r } of n) {
    if (i.parent.is("$text")) {
      const s = i.parent.data, o = i.offset;
      if (qf(s, o) || Yf(s, o) || $E(s, o))
        continue;
      t++;
    } else (r.is("containerElement") || r.is("emptyElement")) && t++;
    if (t > 1)
      return !0;
  }
  return !1;
}
class fs extends ce {
  constructor() {
    super(...arguments);
    /**
    * Whether pressing backspace should trigger undo action
    */
    m(this, "_undoOnBackspace");
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Delete";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const t = this.editor, i = t.editing.view, r = i.document, s = t.model.document;
    i.addObserver(fL), this._undoOnBackspace = !1;
    const o = new yg(t, "forward");
    t.commands.add("deleteForward", o), t.commands.add("forwardDelete", o), t.commands.add("delete", new yg(t, "backward")), this.listenTo(r, "delete", (a, u) => {
      r.isComposing || u.preventDefault();
      const { direction: l, sequence: c, selectionToRemove: d, unit: p } = u, g = l === "forward" ? "deleteForward" : "delete", b = {
        sequence: c
      };
      if (p == "selection") {
        const _ = Array.from(d.getRanges()).map((k) => t.editing.mapper.toModelRange(k));
        b.selection = t.model.createSelection(_);
      } else
        b.unit = p;
      t.execute(g, b), i.scrollToTheSelection();
    }, {
      priority: "low"
    }), this.listenTo(r, "keydown", (a, u) => {
      if (r.isComposing || u.keyCode != ye.backspace || !s.selection.isCollapsed)
        return;
      const l = t.model.schema.getLimitElement(s.selection);
      t.model.createPositionAt(l, 0).isTouching(s.selection.getFirstPosition()) && u.preventDefault();
    }), this.editor.plugins.has("UndoEditing") && (this.listenTo(r, "delete", (a, u) => {
      this._undoOnBackspace && u.direction == "backward" && u.sequence == 1 && u.unit == "codePoint" && (this._undoOnBackspace = !1, t.execute("undo"), u.preventDefault(), a.stop());
    }, {
      context: "$capture"
    }), this.listenTo(s, "change", () => {
      this._undoOnBackspace = !1;
    }));
  }
  /**
  * If the next user action after calling this method is pressing backspace, it would undo the last change.
  *
  * Requires {@link module:undo/undoediting~UndoEditing} plugin. If not loaded, does nothing.
  */
  requestUndoOnBackspace() {
    this.editor.plugins.has("UndoEditing") && (this._undoOnBackspace = !0);
  }
}
class gL extends ce {
  static get requires() {
    return [
      ay,
      fs
    ];
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Typing";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function ly(e, n) {
  let t = e.start;
  return {
    text: Array.from(e.getWalker({
      ignoreElementEnd: !1
    })).reduce((r, { item: s }) => s.is("$text") || s.is("$textProxy") ? r + s.data : (t = n.createPositionAfter(s), ""), ""),
    range: n.createRange(t, e.end)
  };
}
class cy extends (/* @__PURE__ */ pt()) {
  /**
  * Creates a text watcher instance.
  *
  * @param testCallback See {@link module:typing/textwatcher~TextWatcher#testCallback}.
  */
  constructor(t, i) {
    super();
    /**
    * The editor's model.
    */
    m(this, "model");
    /**
    * The function used to match the text.
    *
    * The test callback can return 3 values:
    *
    * * `false` if there is no match,
    * * `true` if there is a match,
    * * an object if there is a match and we want to pass some additional information to the {@link #event:matched:data} event.
    */
    m(this, "testCallback");
    /**
    * Whether there is a match currently.
    */
    m(this, "_hasMatch");
    this.model = t, this.testCallback = i, this._hasMatch = !1, this.set("isEnabled", !0), this.on("change:isEnabled", () => {
      this.isEnabled ? this._startListening() : (this.stopListening(t.document.selection), this.stopListening(t.document));
    }), this._startListening();
  }
  /**
  * Flag indicating whether there is a match currently.
  */
  get hasMatch() {
    return this._hasMatch;
  }
  /**
  * Starts listening to the editor for typing and selection events.
  */
  _startListening() {
    const i = this.model.document;
    this.listenTo(i.selection, "change:range", (r, { directChange: s }) => {
      if (s) {
        if (!i.selection.isCollapsed) {
          this.hasMatch && (this.fire("unmatched"), this._hasMatch = !1);
          return;
        }
        this._evaluateTextBeforeSelection("selection");
      }
    }), this.listenTo(i, "change:data", (r, s) => {
      s.isUndo || !s.isLocal || this._evaluateTextBeforeSelection("data", {
        batch: s
      });
    });
  }
  /**
  * Checks the editor content for matched text.
  *
  * @fires matched:data
  * @fires matched:selection
  * @fires unmatched
  *
  * @param suffix A suffix used for generating the event name.
  * @param data Data object for event.
  */
  _evaluateTextBeforeSelection(t, i = {}) {
    const r = this.model, o = r.document.selection, a = r.createRange(r.createPositionAt(o.focus.parent, 0), o.focus), { text: u, range: l } = ly(a, r), c = this.testCallback(u);
    if (!c && this.hasMatch && this.fire("unmatched"), this._hasMatch = !!c, c) {
      const d = Object.assign(i, {
        text: u,
        range: l
      });
      typeof c == "object" && Object.assign(d, c), this.fire(`matched:${t}`, d);
    }
  }
}
class Ag extends ce {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * A set of attributes to handle.
    */
    m(this, "attributes");
    /**
    * The current UID of the overridden gravity, as returned by
    * {@link module:engine/model/writer~Writer#overrideSelectionGravity}.
    */
    m(this, "_overrideUid");
    /**
    * A flag indicating that the automatic gravity restoration should not happen upon the next
    * gravity restoration.
    * {@link module:engine/model/selection~Selection#event:change:range} event.
    */
    m(this, "_isNextGravityRestorationSkipped", !1);
    this.attributes = /* @__PURE__ */ new Set(), this._overrideUid = null;
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "TwoStepCaretMovement";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const t = this.editor, i = t.model, r = t.editing.view, s = t.locale, o = i.document.selection;
    this.listenTo(r.document, "arrowKey", (a, u) => {
      if (!o.isCollapsed || u.shiftKey || u.altKey || u.ctrlKey)
        return;
      const l = u.keyCode == ye.arrowright, c = u.keyCode == ye.arrowleft;
      if (!l && !c)
        return;
      const d = s.contentLanguageDirection;
      let p = !1;
      d === "ltr" && l || d === "rtl" && c ? p = this._handleForwardMovement(u) : p = this._handleBackwardMovement(u), p === !0 && a.stop();
    }, {
      context: "$text",
      priority: "highest"
    }), this.listenTo(o, "change:range", (a, u) => {
      if (this._isNextGravityRestorationSkipped) {
        this._isNextGravityRestorationSkipped = !1;
        return;
      }
      this._isGravityOverridden && (!u.directChange && Bn(o.getFirstPosition(), this.attributes) || this._restoreGravity());
    }), this._enableClickingAfterNode(), this._enableInsertContentSelectionAttributesFixer(), this._handleDeleteContentAfterNode();
  }
  /**
  * Registers a given attribute for the two-step caret movement.
  *
  * @param attribute Name of the attribute to handle.
  */
  registerAttribute(t) {
    this.attributes.add(t);
  }
  /**
  * Updates the document selection and the view according to the two–step caret movement state
  * when moving **forwards**. Executed upon `keypress` in the {@link module:engine/view/view~View}.
  *
  * @param data Data of the key press.
  * @returns `true` when the handler prevented caret movement.
  */
  _handleForwardMovement(t) {
    const i = this.attributes, r = this.editor.model, s = r.document.selection, o = s.getFirstPosition();
    return this._isGravityOverridden || o.isAtStart && Ni(s, i) ? !1 : Bn(o, i) ? (Uo(t), Ni(s, i) && Bn(o, i, !0) ? Fo(r, i) : this._overrideGravity(), !0) : !1;
  }
  /**
  * Updates the document selection and the view according to the two–step caret movement state
  * when moving **backwards**. Executed upon `keypress` in the {@link module:engine/view/view~View}.
  *
  * @param data Data of the key press.
  * @returns `true` when the handler prevented caret movement
  */
  _handleBackwardMovement(t) {
    const i = this.attributes, r = this.editor.model, s = r.document.selection, o = s.getFirstPosition();
    return this._isGravityOverridden ? (Uo(t), this._restoreGravity(), Bn(o, i, !0) ? Fo(r, i) : Pu(r, i, o), !0) : o.isAtStart ? Ni(s, i) ? (Uo(t), Pu(r, i, o), !0) : !1 : !Ni(s, i) && Bn(o, i, !0) ? (Uo(t), Pu(r, i, o), !0) : Cg(o, i) ? o.isAtEnd && !Ni(s, i) && Bn(o, i) ? (Uo(t), Pu(r, i, o), !0) : (this._isNextGravityRestorationSkipped = !0, this._overrideGravity(), !1) : !1;
  }
  /**
  * Starts listening to {@link module:engine/view/document~Document#event:mousedown} and
  * {@link module:engine/view/document~Document#event:selectionChange} and puts the selection before/after a 2-step node
  * if clicked at the beginning/ending of the 2-step node.
  *
  * The purpose of this action is to allow typing around the 2-step node directly after a click.
  *
  * See https://github.com/ckeditor/ckeditor5/issues/1016.
  */
  _enableClickingAfterNode() {
    const t = this.editor, i = t.model, r = i.document.selection, s = t.editing.view.document;
    t.editing.view.addObserver(nm), t.editing.view.addObserver(mR);
    let o = !1, a = !1;
    this.listenTo(s, "touchstart", () => {
      a = !1, o = !0;
    }), this.listenTo(s, "mousedown", () => {
      a = !0;
    }), this.listenTo(s, "selectionChange", () => {
      const u = this.attributes;
      if (!a && !o || (a = !1, o = !1, !r.isCollapsed) || !Ni(r, u))
        return;
      const l = r.getFirstPosition();
      Bn(l, u) && (l.isAtStart || Bn(l, u, !0) ? Fo(i, u) : this._isGravityOverridden || this._overrideGravity());
    });
  }
  /**
  * Starts listening to {@link module:engine/model/model~Model#event:insertContent} and corrects the model
  * selection attributes if the selection is at the end of a two-step node after inserting the content.
  *
  * The purpose of this action is to improve the overall UX because the user is no longer "trapped" by the
  * two-step attribute of the selection, and they can type a "clean" (`linkHref`–less) text right away.
  *
  * See https://github.com/ckeditor/ckeditor5/issues/6053.
  */
  _enableInsertContentSelectionAttributesFixer() {
    const i = this.editor.model, r = i.document.selection, s = this.attributes;
    this.listenTo(i, "insertContent", () => {
      const o = r.getFirstPosition();
      Ni(r, s) && Bn(o, s) && Fo(i, s);
    }, {
      priority: "low"
    });
  }
  /**
  * Starts listening to {@link module:engine/model/model~Model#deleteContent} and checks whether
  * removing a content right after the tow-step attribute.
  *
  * If so, the selection should not preserve the two-step attribute. However, if
  * the {@link module:typing/twostepcaretmovement~TwoStepCaretMovement} plugin is active and
  * the selection has the two-step attribute due to overridden gravity (at the end), the two-step attribute should stay untouched.
  *
  * The purpose of this action is to allow removing the link text and keep the selection outside the link.
  *
  * See https://github.com/ckeditor/ckeditor5/issues/7521.
  */
  _handleDeleteContentAfterNode() {
    const t = this.editor, i = t.model, r = i.document.selection, s = t.editing.view;
    let o = !1, a = !1;
    this.listenTo(s.document, "delete", (u, l) => {
      o = l.direction === "backward";
    }, {
      priority: "high"
    }), this.listenTo(i, "deleteContent", () => {
      if (!o)
        return;
      const u = r.getFirstPosition();
      a = Ni(r, this.attributes) && !Cg(u, this.attributes);
    }, {
      priority: "high"
    }), this.listenTo(i, "deleteContent", () => {
      o && (o = !1, !a && t.model.enqueueChange(() => {
        const u = r.getFirstPosition();
        Ni(r, this.attributes) && Bn(u, this.attributes) && (u.isAtStart || Bn(u, this.attributes, !0) ? Fo(i, this.attributes) : this._isGravityOverridden || this._overrideGravity());
      }));
    }, {
      priority: "low"
    });
  }
  /**
  * `true` when the gravity is overridden for the plugin.
  */
  get _isGravityOverridden() {
    return !!this._overrideUid;
  }
  /**
  * Overrides the gravity using the {@link module:engine/model/writer~Writer model writer}
  * and stores the information about this fact in the {@link #_overrideUid}.
  *
  * A shorthand for {@link module:engine/model/writer~Writer#overrideSelectionGravity}.
  */
  _overrideGravity() {
    this._overrideUid = this.editor.model.change((t) => t.overrideSelectionGravity());
  }
  /**
  * Restores the gravity using the {@link module:engine/model/writer~Writer model writer}.
  *
  * A shorthand for {@link module:engine/model/writer~Writer#restoreSelectionGravity}.
  */
  _restoreGravity() {
    this.editor.model.change((t) => {
      t.restoreSelectionGravity(this._overrideUid), this._overrideUid = null;
    });
  }
}
function Ni(e, n) {
  for (const t of n)
    if (e.hasAttribute(t))
      return !0;
  return !1;
}
function Pu(e, n, t) {
  const i = t.nodeBefore;
  e.change((r) => {
    if (i) {
      const s = [], o = e.schema.isObject(i) && e.schema.isInline(i);
      for (const [a, u] of i.getAttributes())
        e.schema.checkAttribute("$text", a) && (!o || e.schema.getAttributeProperties(a).copyFromObject !== !1) && s.push([
          a,
          u
        ]);
      r.setSelectionAttribute(s);
    } else
      r.removeSelectionAttribute(n);
  });
}
function Fo(e, n) {
  e.change((t) => {
    t.removeSelectionAttribute(n);
  });
}
function Uo(e) {
  e.preventDefault();
}
function Cg(e, n) {
  const t = e.getShiftedBy(-1);
  return Bn(t, n);
}
function Bn(e, n, t = !1) {
  const { nodeBefore: i, nodeAfter: r } = e;
  for (const s of n) {
    const o = i ? i.getAttribute(s) : void 0, a = r ? r.getAttribute(s) : void 0;
    if (!(t && (o === void 0 || a === void 0)) && a !== o)
      return !0;
  }
  return !1;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function lc(e, n, t, i) {
  return i.createRange(kg(e, n, t, !0, i), kg(e, n, t, !1, i));
}
function kg(e, n, t, i, r) {
  let s = e.textNode || (i ? e.nodeBefore : e.nodeAfter), o = null;
  for (; s && s.getAttribute(n) == t; )
    o = s, s = i ? s.previousSibling : s.nextSibling;
  return o ? r.createPositionAt(o, i ? "before" : "after") : e;
}
function bL(e, n, t, i) {
  const r = e.editing.view, s = /* @__PURE__ */ new Set();
  r.document.registerPostFixer((o) => {
    const a = e.model.document.selection;
    let u = !1;
    if (a.hasAttribute(n)) {
      const l = lc(a.getFirstPosition(), n, a.getAttribute(n), e.model), c = e.editing.mapper.toViewRange(l);
      for (const d of c.getItems())
        d.is("element", t) && !d.hasClass(i) && (o.addClass(i, d), s.add(d), u = !0);
    }
    return u;
  }), e.conversion.for("editingDowncast").add((o) => {
    o.on("insert", a, {
      priority: "highest"
    }), o.on("remove", a, {
      priority: "highest"
    }), o.on("attribute", a, {
      priority: "highest"
    }), o.on("selection", a, {
      priority: "highest"
    });
    function a() {
      r.change((u) => {
        for (const l of s.values())
          u.removeClass(i, l), s.delete(l);
      });
    }
  });
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function rr(e, n, t, i) {
  let r, s = null;
  typeof i == "function" ? r = i : (s = e.commands.get(i), r = () => {
    e.execute(i);
  }), e.model.document.on("change:data", (o, a) => {
    if (s && !s.isEnabled || !n.isEnabled)
      return;
    const u = zn(e.model.document.selection.getRanges());
    if (!u.isCollapsed || a.isUndo || !a.isLocal)
      return;
    const l = Array.from(e.model.document.differ.getChanges()), c = l[0];
    if (l.length != 1 || c.type !== "insert" || c.name != "$text" || c.length != 1)
      return;
    const d = c.position.parent;
    if (d.is("element", "codeBlock") || d.is("element", "listItem") && typeof i != "function" && ![
      "numberedList",
      "bulletedList",
      "todoList"
    ].includes(i) || s && s.value === !0)
      return;
    const p = d.getChild(0), g = e.model.createRangeOn(p);
    if (!g.containsRange(u) && !u.end.isEqual(g.end))
      return;
    const b = t.exec(p.data.substr(0, u.end.offset));
    b && e.model.enqueueChange((_) => {
      const k = _.createPositionAt(d, 0), C = _.createPositionAt(d, b[0].length), D = new xn(k, C);
      if (r({
        match: b
      }) !== !1) {
        _.remove(D);
        const j = e.model.document.selection.getFirstRange(), F = _.createRangeIn(d);
        d.isEmpty && !F.isEqual(j) && !F.containsRange(j, !0) && _.remove(d);
      }
      D.detach(), e.model.enqueueChange(() => {
        e.plugins.get("Delete").requestUndoOnBackspace();
      });
    });
  });
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function Ss(e, n, t, i) {
  let r, s;
  t instanceof RegExp ? r = t : s = t, s = s || ((o) => {
    let a;
    const u = [], l = [];
    for (; (a = r.exec(o)) !== null && !(a && a.length < 4); ) {
      let { index: c, "1": d, "2": p, "3": g } = a;
      const b = d + p + g;
      c += a[0].length - b.length;
      const _ = [
        c,
        c + d.length
      ], k = [
        c + d.length + p.length,
        c + d.length + p.length + g.length
      ];
      u.push(_), u.push(k), l.push([
        c + d.length,
        c + d.length + p.length
      ]);
    }
    return {
      remove: u,
      format: l
    };
  }), e.model.document.on("change:data", (o, a) => {
    if (a.isUndo || !a.isLocal || !n.isEnabled)
      return;
    const u = e.model, l = u.document.selection;
    if (!l.isCollapsed)
      return;
    const c = Array.from(u.document.differ.getChanges()), d = c[0];
    if (c.length != 1 || d.type !== "insert" || d.name != "$text" || d.length != 1)
      return;
    const p = l.focus, g = p.parent, { text: b, range: _ } = _L(u.createRange(u.createPositionAt(g, 0), p), u), k = s(b), C = Sg(_.start, k.format, u), D = Sg(_.start, k.remove, u);
    C.length && D.length && u.enqueueChange((M) => {
      if (i(M, C) !== !1) {
        for (const F of D.reverse())
          M.remove(F);
        u.enqueueChange(() => {
          e.plugins.get("Delete").requestUndoOnBackspace();
        });
      }
    });
  });
}
function Sg(e, n, t) {
  return n.filter((i) => i[0] !== void 0 && i[1] !== void 0).map((i) => t.createRange(e.getShiftedBy(i[0]), e.getShiftedBy(i[1])));
}
function _L(e, n) {
  let t = e.start;
  return {
    text: Array.from(e.getItems()).reduce((r, s) => !(s.is("$text") || s.is("$textProxy")) || s.getAttribute("code") ? (t = n.createPositionAfter(s), "") : r + s.data, ""),
    range: n.createRange(t, e.end)
  };
}
class EL extends ce {
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      fs
    ];
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Autoformat";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  afterInit() {
    const n = this.editor, t = this.editor.t;
    this._addListAutoformats(), this._addBasicStylesAutoformats(), this._addHeadingAutoformats(), this._addBlockQuoteAutoformats(), this._addCodeBlockAutoformats(), this._addHorizontalLineAutoformats(), n.accessibility.addKeystrokeInfos({
      keystrokes: [
        {
          label: t("Revert autoformatting action"),
          keystroke: "Backspace"
        }
      ]
    });
  }
  /**
  * Adds autoformatting related to the {@link module:list/list~List}.
  *
  * When typed:
  * - `* ` or `- ` &ndash; A paragraph will be changed into a bulleted list.
  * - `1. ` or `1) ` &ndash; A paragraph will be changed into a numbered list ("1" can be any digit or a list of digits).
  * - `[] ` or `[ ] ` &ndash; A paragraph will be changed into a to-do list.
  * - `[x] ` or `[ x ] ` &ndash; A paragraph will be changed into a checked to-do list.
  */
  _addListAutoformats() {
    const n = this.editor.commands;
    n.get("bulletedList") && rr(this.editor, this, /^[*-]\s$/, "bulletedList"), n.get("numberedList") && rr(this.editor, this, /^1[.|)]\s$/, "numberedList"), n.get("todoList") && rr(this.editor, this, /^\[\s?\]\s$/, "todoList"), n.get("checkTodoList") && rr(this.editor, this, /^\[\s?x\s?\]\s$/, () => {
      this.editor.execute("todoList"), this.editor.execute("checkTodoList");
    });
  }
  /**
  * Adds autoformatting related to the {@link module:basic-styles/bold~Bold},
  * {@link module:basic-styles/italic~Italic}, {@link module:basic-styles/code~Code}
  * and {@link module:basic-styles/strikethrough~Strikethrough}
  *
  * When typed:
  * - `**foobar**` &ndash; `**` characters are removed and `foobar` is set to bold,
  * - `__foobar__` &ndash; `__` characters are removed and `foobar` is set to bold,
  * - `*foobar*` &ndash; `*` characters are removed and `foobar` is set to italic,
  * - `_foobar_` &ndash; `_` characters are removed and `foobar` is set to italic,
  * - ``` `foobar` &ndash; ``` ` ``` characters are removed and `foobar` is set to code,
  * - `~~foobar~~` &ndash; `~~` characters are removed and `foobar` is set to strikethrough.
  */
  _addBasicStylesAutoformats() {
    const n = this.editor.commands;
    if (n.get("bold")) {
      const t = Ou(this.editor, "bold");
      Ss(this.editor, this, /(?:^|\s)(\*\*)([^*]+)(\*\*)$/g, t), Ss(this.editor, this, /(?:^|\s)(__)([^_]+)(__)$/g, t);
    }
    if (n.get("italic")) {
      const t = Ou(this.editor, "italic");
      Ss(this.editor, this, /(?:^|\s)(\*)([^*_]+)(\*)$/g, t), Ss(this.editor, this, /(?:^|\s)(_)([^_]+)(_)$/g, t);
    }
    if (n.get("code")) {
      const t = Ou(this.editor, "code");
      Ss(this.editor, this, /(`)([^`]+)(`)$/g, t);
    }
    if (n.get("strikethrough")) {
      const t = Ou(this.editor, "strikethrough");
      Ss(this.editor, this, /(~~)([^~]+)(~~)$/g, t);
    }
  }
  /**
  * Adds autoformatting related to {@link module:heading/heading~Heading}.
  *
  * It is using a number at the end of the command name to associate it with the proper trigger:
  *
  * * `heading` with a `heading1` value will be executed when typing `#`,
  * * `heading` with a `heading2` value will be executed when typing `##`,
  * * ... up to `heading6` for `######`.
  */
  _addHeadingAutoformats() {
    const n = this.editor.commands.get("heading");
    n && n.modelElements.filter((t) => t.match(/^heading[1-6]$/)).forEach((t) => {
      const i = t[7], r = new RegExp(`^(#{${i}})\\s$`);
      rr(this.editor, this, r, () => {
        if (!n.isEnabled || n.value === t)
          return !1;
        this.editor.execute("heading", {
          value: t
        });
      });
    });
  }
  /**
  * Adds autoformatting related to {@link module:block-quote/blockquote~BlockQuote}.
  *
  * When typed:
  * * `> ` &ndash; A paragraph will be changed to a block quote.
  */
  _addBlockQuoteAutoformats() {
    this.editor.commands.get("blockQuote") && rr(this.editor, this, /^>\s$/, "blockQuote");
  }
  /**
  * Adds autoformatting related to {@link module:code-block/codeblock~CodeBlock}.
  *
  * When typed:
  * - `` ``` `` &ndash; A paragraph will be changed to a code block.
  */
  _addCodeBlockAutoformats() {
    const n = this.editor, t = n.model.document.selection;
    n.commands.get("codeBlock") && rr(n, this, /^```$/, () => {
      if (t.getFirstPosition().parent.is("element", "listItem"))
        return !1;
      this.editor.execute("codeBlock", {
        usePreviousLanguageChoice: !0
      });
    });
  }
  /**
  * Adds autoformatting related to {@link module:horizontal-line/horizontalline~HorizontalLine}.
  *
  * When typed:
  * - `` --- `` &ndash; Will be replaced with a horizontal line.
  */
  _addHorizontalLineAutoformats() {
    this.editor.commands.get("horizontalLine") && rr(this.editor, this, /^---$/, "horizontalLine");
  }
}
function Ou(e, n) {
  return (t, i) => {
    if (!e.commands.get(n).isEnabled)
      return !1;
    const s = e.model.schema.getValidRanges(i, n);
    for (const o of s)
      t.setAttribute(n, !0, o);
    t.removeSelectionAttribute(n);
  };
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class dm extends Mt {
  /**
  * @param attributeKey Attribute that will be set by the command.
  */
  constructor(t, i) {
    super(t);
    /**
    * The attribute that will be set by the command.
    */
    m(this, "attributeKey");
    this.attributeKey = i;
  }
  /**
  * Updates the command's {@link #value} and {@link #isEnabled} based on the current selection.
  */
  refresh() {
    const t = this.editor.model, i = t.document;
    this.value = this._getValueFromFirstAllowedNode(), this.isEnabled = t.schema.checkAttributeInSelection(i.selection, this.attributeKey);
  }
  /**
  * Executes the command &ndash; applies the attribute to the selection or removes it from the selection.
  *
  * If the command is active (`value == true`), it will remove attributes. Otherwise, it will set attributes.
  *
  * The execution result differs, depending on the {@link module:engine/model/document~Document#selection}:
  *
  * * If the selection is on a range, the command applies the attribute to all nodes in that range
  * (if they are allowed to have this attribute by the {@link module:engine/model/schema~Schema schema}).
  * * If the selection is collapsed in a non-empty node, the command applies the attribute to the
  * {@link module:engine/model/document~Document#selection} itself (note that typed characters copy attributes from the selection).
  * * If the selection is collapsed in an empty node, the command applies the attribute to the parent node of the selection (note
  * that the selection inherits all attributes from a node if it is in an empty node).
  *
  * @fires execute
  * @param options Command options.
  * @param options.forceValue If set, it will force the command behavior. If `true`,
  * the command will apply the attribute, otherwise the command will remove the attribute.
  * If not set, the command will look for its current value to decide what it should do.
  */
  execute(t = {}) {
    const i = this.editor.model, s = i.document.selection, o = t.forceValue === void 0 ? !this.value : t.forceValue;
    i.change((a) => {
      if (s.isCollapsed)
        o ? a.setSelectionAttribute(this.attributeKey, !0) : a.removeSelectionAttribute(this.attributeKey);
      else {
        const u = i.schema.getValidRanges(s.getRanges(), this.attributeKey);
        for (const l of u)
          o ? a.setAttribute(this.attributeKey, o, l) : a.removeAttribute(this.attributeKey, l);
      }
    });
  }
  /**
  * Checks the attribute value of the first node in the selection that allows the attribute.
  * For the collapsed selection returns the selection attribute.
  *
  * @returns The attribute value.
  */
  _getValueFromFirstAllowedNode() {
    const t = this.editor.model, i = t.schema, r = t.document.selection;
    if (r.isCollapsed)
      return r.hasAttribute(this.attributeKey);
    for (const s of r.getRanges())
      for (const o of s.getItems())
        if (i.checkAttribute(o, this.attributeKey))
          return o.hasAttribute(this.attributeKey);
    return !1;
  }
}
const Is = "bold";
class TL extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "BoldEditing";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = this.editor.t;
    n.model.schema.extend("$text", {
      allowAttributes: Is
    }), n.model.schema.setAttributeProperties(Is, {
      isFormatting: !0,
      copyOnEnter: !0
    }), n.conversion.attributeToElement({
      model: Is,
      view: "strong",
      upcastAlso: [
        "b",
        (i) => {
          const r = i.getStyle("font-weight");
          return r && (r == "bold" || Number(r) >= 600) ? {
            name: !0,
            styles: [
              "font-weight"
            ]
          } : null;
        }
      ]
    }), n.commands.add(Is, new dm(n, Is)), n.keystrokes.set("CTRL+B", Is), n.accessibility.addKeystrokeInfos({
      keystrokes: [
        {
          label: t("Bold text"),
          keystroke: "CTRL+B"
        }
      ]
    });
  }
}
function hm({ editor: e, commandName: n, plugin: t, icon: i, label: r, keystroke: s }) {
  return (o) => {
    const a = e.commands.get(n), u = new o(e.locale);
    return u.set({
      label: r,
      icon: i,
      keystroke: s,
      isToggleable: !0
    }), u.bind("isEnabled").to(a, "isEnabled"), u.bind("isOn").to(a, "value"), u instanceof Dn ? u.set({
      role: "menuitemcheckbox"
    }) : u.set({
      tooltip: !0
    }), t.listenTo(u, "execute", () => {
      e.execute(n), e.editing.view.focus();
    }), u;
  };
}
const yd = "bold";
class yL extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "BoldUI";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = n.locale.t, i = hm({
      editor: n,
      commandName: yd,
      plugin: this,
      icon: Ge.bold,
      label: t("Bold"),
      keystroke: "CTRL+B"
    });
    n.ui.componentFactory.add(yd, () => i(gt)), n.ui.componentFactory.add("menuBar:" + yd, () => i(Dn));
  }
}
class wL extends ce {
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      TL,
      yL
    ];
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Bold";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
}
const xs = "italic";
class AL extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "ItalicEditing";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = this.editor.t;
    n.model.schema.extend("$text", {
      allowAttributes: xs
    }), n.model.schema.setAttributeProperties(xs, {
      isFormatting: !0,
      copyOnEnter: !0
    }), n.conversion.attributeToElement({
      model: xs,
      view: "i",
      upcastAlso: [
        "em",
        {
          styles: {
            "font-style": "italic"
          }
        }
      ]
    }), n.commands.add(xs, new dm(n, xs)), n.keystrokes.set("CTRL+I", xs), n.accessibility.addKeystrokeInfos({
      keystrokes: [
        {
          label: t("Italic text"),
          keystroke: "CTRL+I"
        }
      ]
    });
  }
}
var CL = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.586 14.633.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>';
const wd = "italic";
class kL extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "ItalicUI";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = n.locale.t, i = hm({
      editor: n,
      commandName: wd,
      plugin: this,
      icon: CL,
      keystroke: "CTRL+I",
      label: t("Italic")
    });
    n.ui.componentFactory.add(wd, () => i(gt)), n.ui.componentFactory.add("menuBar:" + wd, () => i(Dn));
  }
}
class SL extends ce {
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      AL,
      kL
    ];
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Italic";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
}
const Ho = "underline";
class IL extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "UnderlineEditing";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = this.editor.t;
    n.model.schema.extend("$text", {
      allowAttributes: Ho
    }), n.model.schema.setAttributeProperties(Ho, {
      isFormatting: !0,
      copyOnEnter: !0
    }), n.conversion.attributeToElement({
      model: Ho,
      view: "u",
      upcastAlso: {
        styles: {
          "text-decoration": "underline"
        }
      }
    }), n.commands.add(Ho, new dm(n, Ho)), n.keystrokes.set("CTRL+U", "underline"), n.accessibility.addKeystrokeInfos({
      keystrokes: [
        {
          label: t("Underline text"),
          keystroke: "CTRL+U"
        }
      ]
    });
  }
}
var xL = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 18v-1.5h14V18zm2.2-8V3.6c0-.4.4-.6.8-.6.3 0 .7.2.7.6v6.2c0 2 1.3 2.8 3.2 2.8 1.9 0 3.4-.9 3.4-2.9V3.6c0-.3.4-.5.8-.5.3 0 .7.2.7.5V10c0 2.7-2.2 4-4.9 4-2.6 0-4.7-1.2-4.7-4z"/></svg>';
const Ad = "underline";
class vL extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "UnderlineUI";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = n.locale.t, i = hm({
      editor: n,
      commandName: Ad,
      plugin: this,
      icon: xL,
      label: t("Underline"),
      keystroke: "CTRL+U"
    });
    n.ui.componentFactory.add(Ad, () => i(gt)), n.ui.componentFactory.add("menuBar:" + Ad, () => i(Dn));
  }
}
class PL extends ce {
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      IL,
      vL
    ];
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Underline";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function* dy(e, n) {
  for (const t of n)
    t && e.getAttributeProperties(t[0]).copyOnEnter && (yield t);
}
class OL extends Mt {
  /**
  * @inheritDoc
  */
  execute() {
    this.editor.model.change((n) => {
      this.enterBlock(n), this.fire("afterExecute", {
        writer: n
      });
    });
  }
  /**
  * Splits a block where the document selection is placed, in the way how the <kbd>Enter</kbd> key is expected to work:
  *
  * ```
  * <p>Foo[]bar</p>   ->   <p>Foo</p><p>[]bar</p>
  * <p>Foobar[]</p>   ->   <p>Foobar</p><p>[]</p>
  * <p>Fo[ob]ar</p>   ->   <p>Fo</p><p>[]ar</p>
  * ```
  *
  * In some cases, the split will not happen:
  *
  * ```
  * // The selection parent is a limit element:
  * <figcaption>A[bc]d</figcaption>   ->   <figcaption>A[]d</figcaption>
  *
  * // The selection spans over multiple elements:
  * <h>x[x</h><p>y]y<p>   ->   <h>x</h><p>[]y</p>
  * ```
  *
  * @param writer Writer to use when performing the enter action.
  * @returns Boolean indicating if the block was split.
  */
  enterBlock(n) {
    const t = this.editor.model, i = t.document.selection, r = t.schema, s = i.isCollapsed, o = i.getFirstRange(), a = o.start.parent, u = o.end.parent;
    if (r.isLimit(a) || r.isLimit(u))
      return !s && a == u && t.deleteContent(i), !1;
    if (s) {
      const l = dy(n.model.schema, i.getAttributes());
      return Ig(n, o.start), n.setSelectionAttribute(l), !0;
    } else {
      const l = !(o.start.isAtStart && o.end.isAtEnd), c = a == u;
      if (t.deleteContent(i, {
        leaveUnmerged: l
      }), l) {
        if (c)
          return Ig(n, i.focus), !0;
        n.setSelection(u, 0);
      }
    }
    return !1;
  }
}
function Ig(e, n) {
  e.split(n), e.setSelection(n.parent.nextSibling, 0);
}
const NL = {
  insertParagraph: {
    isSoft: !1
  },
  insertLineBreak: {
    isSoft: !0
  }
};
class hy extends Xi {
  /**
  * @inheritDoc
  */
  constructor(n) {
    super(n);
    const t = this.document;
    let i = !1;
    t.on("keydown", (r, s) => {
      i = s.shiftKey;
    }), t.on("beforeinput", (r, s) => {
      if (!this.isEnabled)
        return;
      let o = s.inputType;
      he.isSafari && i && o == "insertParagraph" && (o = "insertLineBreak");
      const a = s.domEvent, u = NL[o];
      if (!u)
        return;
      const l = new fo(t, "enter", s.targetRanges[0]);
      t.fire(l, new eo(n, a, {
        isSoft: u.isSoft
      })), l.stop.called && r.stop();
    });
  }
  /**
  * @inheritDoc
  */
  observe() {
  }
  /**
  * @inheritDoc
  */
  stopObserving() {
  }
}
class cc extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Enter";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  init() {
    const n = this.editor, t = n.editing.view, i = t.document, r = this.editor.t;
    t.addObserver(hy), n.commands.add("enter", new OL(n)), this.listenTo(i, "enter", (s, o) => {
      i.isComposing || o.preventDefault(), !o.isSoft && (n.execute("enter"), t.scrollToTheSelection());
    }, {
      priority: "low"
    }), n.accessibility.addKeystrokeInfos({
      keystrokes: [
        {
          label: r("Insert a hard break (a new paragraph)"),
          keystroke: "Enter"
        }
      ]
    });
  }
}
class RL extends Mt {
  /**
  * @inheritDoc
  */
  execute() {
    const n = this.editor.model, t = n.document;
    n.change((i) => {
      DL(n, i, t.selection), this.fire("afterExecute", {
        writer: i
      });
    });
  }
  /**
  * @inheritDoc
  */
  refresh() {
    const n = this.editor.model, t = n.document;
    this.isEnabled = LL(n.schema, t.selection);
  }
}
function LL(e, n) {
  if (n.rangeCount > 1)
    return !1;
  const t = n.anchor;
  if (!t || !e.checkChild(t, "softBreak"))
    return !1;
  const i = n.getFirstRange(), r = i.start.parent, s = i.end.parent;
  return !(($h(r, e) || $h(s, e)) && r !== s);
}
function DL(e, n, t) {
  const i = t.isCollapsed, r = t.getFirstRange(), s = r.start.parent, o = r.end.parent, a = s == o;
  if (i) {
    const u = dy(e.schema, t.getAttributes());
    xg(e, n, r.end), n.removeSelectionAttribute(t.getAttributeKeys()), n.setSelectionAttribute(u);
  } else {
    const u = !(r.start.isAtStart && r.end.isAtEnd);
    e.deleteContent(t, {
      leaveUnmerged: u
    }), a ? xg(e, n, t.focus) : u && n.setSelection(o, 0);
  }
}
function xg(e, n, t) {
  const i = n.createElement("softBreak");
  e.insertContent(i, t), n.setSelection(i, "after");
}
function $h(e, n) {
  return e.is("rootElement") ? !1 : n.isLimit(e) || $h(e.parent, n);
}
class ML extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "ShiftEnter";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  init() {
    const n = this.editor, t = n.model.schema, i = n.conversion, r = n.editing.view, s = r.document, o = this.editor.t;
    t.register("softBreak", {
      allowWhere: "$text",
      isInline: !0
    }), i.for("upcast").elementToElement({
      model: "softBreak",
      view: "br"
    }), i.for("downcast").elementToElement({
      model: "softBreak",
      view: (a, { writer: u }) => u.createEmptyElement("br")
    }), r.addObserver(hy), n.commands.add("shiftEnter", new RL(n)), this.listenTo(s, "enter", (a, u) => {
      s.isComposing || u.preventDefault(), u.isSoft && (n.execute("shiftEnter"), r.scrollToTheSelection());
    }, {
      priority: "low"
    }), n.accessibility.addKeystrokeInfos({
      keystrokes: [
        {
          label: o("Insert a soft break (a <code>&lt;br&gt;</code> element)"),
          keystroke: "Shift+Enter"
        }
      ]
    });
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class BL extends Mt {
  /**
  * @inheritDoc
  */
  refresh() {
    this.value = this._getValue(), this.isEnabled = this._checkEnabled();
  }
  /**
  * Executes the command. When the command {@link #value is on}, all top-most block quotes within
  * the selection will be removed. If it is off, all selected blocks will be wrapped with
  * a block quote.
  *
  * @fires execute
  * @param options Command options.
  * @param options.forceValue If set, it will force the command behavior. If `true`, the command will apply a block quote,
  * otherwise the command will remove the block quote. If not set, the command will act basing on its current value.
  */
  execute(n = {}) {
    const t = this.editor.model, i = t.schema, r = t.document.selection, s = Array.from(r.getSelectedBlocks()), o = n.forceValue === void 0 ? !this.value : n.forceValue;
    t.change((a) => {
      if (!o)
        this._removeQuote(a, s.filter(Nu));
      else {
        const u = s.filter((l) => Nu(l) || Pg(i, l));
        this._applyQuote(a, u);
      }
    });
  }
  /**
  * Checks the command's {@link #value}.
  */
  _getValue() {
    const n = this.editor.model.document.selection, t = zn(n.getSelectedBlocks());
    return !!(t && Nu(t));
  }
  /**
  * Checks whether the command can be enabled in the current context.
  *
  * @returns Whether the command should be enabled.
  */
  _checkEnabled() {
    if (this.value)
      return !0;
    const n = this.editor.model.document.selection, t = this.editor.model.schema, i = zn(n.getSelectedBlocks());
    return i ? Pg(t, i) : !1;
  }
  /**
  * Removes the quote from given blocks.
  *
  * If blocks which are supposed to be "unquoted" are in the middle of a quote,
  * start it or end it, then the quote will be split (if needed) and the blocks
  * will be moved out of it, so other quoted blocks remained quoted.
  */
  _removeQuote(n, t) {
    vg(n, t).reverse().forEach((i) => {
      if (i.start.isAtStart && i.end.isAtEnd) {
        n.unwrap(i.start.parent);
        return;
      }
      if (i.start.isAtStart) {
        const s = n.createPositionBefore(i.start.parent);
        n.move(i, s);
        return;
      }
      i.end.isAtEnd || n.split(i.end);
      const r = n.createPositionAfter(i.end.parent);
      n.move(i, r);
    });
  }
  /**
  * Applies the quote to given blocks.
  */
  _applyQuote(n, t) {
    const i = [];
    vg(n, t).reverse().forEach((r) => {
      let s = Nu(r.start);
      s || (s = n.createElement("blockQuote"), n.wrap(r, s)), i.push(s);
    }), i.reverse().reduce((r, s) => r.nextSibling == s ? (n.merge(n.createPositionAfter(r)), r) : s);
  }
}
function Nu(e) {
  return e.parent.name == "blockQuote" ? e.parent : null;
}
function vg(e, n) {
  let t, i = 0;
  const r = [];
  for (; i < n.length; ) {
    const s = n[i], o = n[i + 1];
    t || (t = e.createPositionBefore(s)), (!o || s.nextSibling != o) && (r.push(e.createRange(t, e.createPositionAfter(s))), t = null), i++;
  }
  return r;
}
function Pg(e, n) {
  const t = e.checkChild(n.parent, "blockQuote"), i = e.checkChild([
    "$root",
    "blockQuote"
  ], n);
  return t && i;
}
class FL extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "BlockQuoteEditing";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      cc,
      fs
    ];
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = n.model.schema;
    n.commands.add("blockQuote", new BL(n)), t.register("blockQuote", {
      inheritAllFrom: "$container"
    }), n.conversion.elementToElement({
      model: "blockQuote",
      view: "blockquote"
    }), n.model.document.registerPostFixer((o) => {
      const a = n.model.document.differ.getChanges();
      for (const u of a)
        if (u.type == "insert") {
          const l = u.position.nodeAfter;
          if (!l)
            continue;
          if (l.is("element", "blockQuote") && l.isEmpty)
            return o.remove(l), !0;
          if (l.is("element", "blockQuote") && !t.checkChild(u.position, l))
            return o.unwrap(l), !0;
          if (l.is("element")) {
            const c = o.createRangeIn(l);
            for (const d of c.getItems())
              if (d.is("element", "blockQuote") && !t.checkChild(o.createPositionBefore(d), d))
                return o.unwrap(d), !0;
          }
        } else if (u.type == "remove") {
          const l = u.position.parent;
          if (l.is("element", "blockQuote") && l.isEmpty)
            return o.remove(l), !0;
        }
      return !1;
    });
    const i = this.editor.editing.view.document, r = n.model.document.selection, s = n.commands.get("blockQuote");
    this.listenTo(i, "enter", (o, a) => {
      if (!r.isCollapsed || !s.value)
        return;
      r.getLastPosition().parent.isEmpty && (n.execute("blockQuote"), n.editing.view.scrollToTheSelection(), a.preventDefault(), o.stop());
    }, {
      context: "blockquote"
    }), this.listenTo(i, "delete", (o, a) => {
      if (a.direction != "backward" || !r.isCollapsed || !s.value)
        return;
      const u = r.getLastPosition().parent;
      u.isEmpty && !u.previousSibling && (n.execute("blockQuote"), n.editing.view.scrollToTheSelection(), a.preventDefault(), o.stop());
    }, {
      context: "blockquote"
    });
  }
}
class UL extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "BlockQuoteUI";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor;
    n.ui.componentFactory.add("blockQuote", () => {
      const t = this._createButton(gt);
      return t.set({
        tooltip: !0
      }), t;
    }), n.ui.componentFactory.add("menuBar:blockQuote", () => {
      const t = this._createButton(Dn);
      return t.set({
        role: "menuitemcheckbox"
      }), t;
    });
  }
  /**
  * Creates a button for block quote command to use either in toolbar or in menu bar.
  */
  _createButton(n) {
    const t = this.editor, i = t.locale, r = t.commands.get("blockQuote"), s = new n(t.locale), o = i.t;
    return s.set({
      label: o("Block quote"),
      icon: Ge.quote,
      isToggleable: !0
    }), s.bind("isEnabled").to(r, "isEnabled"), s.bind("isOn").to(r, "value"), this.listenTo(s, "execute", () => {
      t.execute("blockQuote"), t.editing.view.focus();
    }), s;
  }
}
class HL extends ce {
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      FL,
      UL
    ];
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "BlockQuote";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const Og = "ck-widget_selected";
function Rt(e) {
  return e.is("element") ? !!e.getCustomProperty("widget") : !1;
}
function VL(e) {
  return e.getCustomProperty("widgetLabel").reduce((t, i) => typeof i == "function" ? t ? t + ". " + i() : i() : t ? t + ". " + i : i, "");
}
const Li = "widget-type-around";
function Ur(e, n, t) {
  return !!e && Rt(e) && !t.isInline(n);
}
function $L(e) {
  return e.closest(".ck-widget__type-around__button");
}
function WL(e) {
  return e.classList.contains("ck-widget__type-around__button_before") ? "before" : "after";
}
function zL(e, n) {
  const t = e.closest(".ck-widget");
  return n.mapDomToView(t);
}
function Hr(e) {
  return e.getAttribute(Li);
}
var qL = '<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><path d="M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2 2 2.038"/></svg>';
const fy = [
  "before",
  "after"
], YL = new DOMParser().parseFromString(qL, "image/svg+xml").firstChild, Ng = "ck-widget__type-around_disabled";
class jL extends ce {
  constructor() {
    super(...arguments);
    /**
    * A reference to the model widget element that has the fake caret active
    * on either side of it. It is later used to remove CSS classes associated with the fake caret
    * when the widget no longer needs it.
    */
    m(this, "_currentFakeCaretModelElement", null);
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "WidgetTypeAround";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      cc,
      fs
    ];
  }
  /**
  * @inheritDoc
  */
  init() {
    const t = this.editor, i = t.editing.view;
    this.on("change:isEnabled", (r, s, o) => {
      i.change((a) => {
        for (const u of i.document.roots)
          o ? a.removeClass(Ng, u) : a.addClass(Ng, u);
      }), o || t.model.change((a) => {
        a.removeSelectionAttribute(Li);
      });
    }), this._enableTypeAroundUIInjection(), this._enableInsertingParagraphsOnButtonClick(), this._enableInsertingParagraphsOnEnterKeypress(), this._enableInsertingParagraphsOnTypingKeystroke(), this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows(), this._enableDeleteIntegration(), this._enableInsertContentIntegration(), this._enableInsertObjectIntegration(), this._enableDeleteContentIntegration();
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy(), this._currentFakeCaretModelElement = null;
  }
  /**
  * Inserts a new paragraph next to a widget element with the selection anchored in it.
  *
  * **Note**: This method is heavily user-oriented and will both focus the editing view and scroll
  * the viewport to the selection in the inserted paragraph.
  *
  * @param widgetModelElement The model widget element next to which a paragraph is inserted.
  * @param position The position where the paragraph is inserted. Either `'before'` or `'after'` the widget.
  */
  _insertParagraph(t, i) {
    const r = this.editor, s = r.editing.view, o = r.model.schema.getAttributesWithProperty(t, "copyOnReplace", !0);
    r.execute("insertParagraph", {
      position: r.model.createPositionAt(t, i),
      attributes: o
    }), s.focus(), s.scrollToTheSelection();
  }
  /**
  * A wrapper for the {@link module:utils/emittermixin~Emitter#listenTo} method that executes the callbacks only
  * when the plugin {@link #isEnabled is enabled}.
  *
  * @param emitter The object that fires the event.
  * @param event The name of the event.
  * @param callback The function to be called on event.
  * @param options Additional options.
  * @param options.priority The priority of this event callback. The higher the priority value the sooner
  * the callback will be fired. Events having the same priority are called in the order they were added.
  */
  _listenToIfEnabled(t, i, r, s) {
    this.listenTo(t, i, (...o) => {
      this.isEnabled && r(...o);
    }, s);
  }
  /**
  * Similar to {@link #_insertParagraph}, this method inserts a paragraph except that it
  * does not expect a position. Instead, it performs the insertion next to a selected widget
  * according to the `widget-type-around` model selection attribute value (fake caret position).
  *
  * Because this method requires the `widget-type-around` attribute to be set,
  * the insertion can only happen when the widget's fake caret is active (e.g. activated
  * using the keyboard).
  *
  * @returns Returns `true` when the paragraph was inserted (the attribute was present) and `false` otherwise.
  */
  _insertParagraphAccordingToFakeCaretPosition() {
    const r = this.editor.model.document.selection, s = Hr(r);
    if (!s)
      return !1;
    const o = r.getSelectedElement();
    return this._insertParagraph(o, s), !0;
  }
  /**
  * Creates a listener in the editing conversion pipeline that injects the widget type around
  * UI into every single widget instance created in the editor.
  *
  * The UI is delivered as a {@link module:engine/view/uielement~UIElement}
  * wrapper which renders DOM buttons that users can use to insert paragraphs.
  */
  _enableTypeAroundUIInjection() {
    const t = this.editor, i = t.model.schema, r = t.locale.t, s = {
      before: r("Insert paragraph before block"),
      after: r("Insert paragraph after block")
    };
    t.editing.downcastDispatcher.on("insert", (o, a, u) => {
      const l = u.mapper.toViewElement(a.item);
      l && Ur(l, a.item, i) && (KL(u.writer, s, l), l.getCustomProperty("widgetLabel").push(() => this.isEnabled ? r("Press Enter to type after or press Shift + Enter to type before the widget") : ""));
    }, {
      priority: "low"
    });
  }
  /**
  * Brings support for the fake caret that appears when either:
  *
  * * the selection moves to a widget from a position next to it using arrow keys,
  * * the arrow key is pressed when the widget is already selected.
  *
  * The fake caret lets the user know that they can start typing or just press
  * <kbd>Enter</kbd> to insert a paragraph at the position next to a widget as suggested by the fake caret.
  *
  * The fake caret disappears when the user changes the selection or the editor
  * gets blurred.
  *
  * The whole idea is as follows:
  *
  * 1. A user does one of the 2 scenarios described at the beginning.
  * 2. The "keydown" listener is executed and the decision is made whether to show or hide the fake caret.
  * 3. If it should show up, the `widget-type-around` model selection attribute is set indicating
  *    on which side of the widget it should appear.
  * 4. The selection dispatcher reacts to the selection attribute and sets CSS classes responsible for the
  *    fake caret on the view widget.
  * 5. If the fake caret should disappear, the selection attribute is removed and the dispatcher
  *    does the CSS class clean-up in the view.
  * 6. Additionally, `change:range` and `FocusTracker#isFocused` listeners also remove the selection
  *    attribute (the former also removes widget CSS classes).
  */
  _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
    const t = this.editor, i = t.model, r = i.document.selection, s = i.schema, o = t.editing.view;
    this._listenToIfEnabled(o.document, "arrowKey", (u, l) => {
      this._handleArrowKeyPress(u, l);
    }, {
      context: [
        Rt,
        "$text"
      ],
      priority: "high"
    }), this._listenToIfEnabled(r, "change:range", (u, l) => {
      l.directChange && t.model.change((c) => {
        c.removeSelectionAttribute(Li);
      });
    }), this._listenToIfEnabled(i.document, "change:data", () => {
      const u = r.getSelectedElement();
      if (u) {
        const l = t.editing.mapper.toViewElement(u);
        if (Ur(l, u, s))
          return;
      }
      t.model.change((l) => {
        l.removeSelectionAttribute(Li);
      });
    }), this._listenToIfEnabled(t.editing.downcastDispatcher, "selection", (u, l, c) => {
      const d = c.writer;
      if (this._currentFakeCaretModelElement) {
        const _ = c.mapper.toViewElement(this._currentFakeCaretModelElement);
        _ && (d.removeClass(fy.map(a), _), this._currentFakeCaretModelElement = null);
      }
      const p = l.selection.getSelectedElement();
      if (!p)
        return;
      const g = c.mapper.toViewElement(p);
      if (!Ur(g, p, s))
        return;
      const b = Hr(l.selection);
      b && (d.addClass(a(b), g), this._currentFakeCaretModelElement = p);
    }), this._listenToIfEnabled(t.ui.focusTracker, "change:isFocused", (u, l, c) => {
      c || t.model.change((d) => {
        d.removeSelectionAttribute(Li);
      });
    });
    function a(u) {
      return `ck-widget_type-around_show-fake-caret_${u}`;
    }
  }
  /**
  * A listener executed on each "keydown" in the view document, a part of
  * {@link #_enableTypeAroundFakeCaretActivationUsingKeyboardArrows}.
  *
  * It decides whether the arrow keypress should activate the fake caret or not (also whether it should
  * be deactivated).
  *
  * The fake caret activation is done by setting the `widget-type-around` model selection attribute
  * in this listener, and stopping and preventing the event that would normally be handled by the widget
  * plugin that is responsible for the regular keyboard navigation near/across all widgets (that
  * includes inline widgets, which are ignored by the widget type around plugin).
  */
  _handleArrowKeyPress(t, i) {
    const r = this.editor, s = r.model, o = s.document.selection, a = s.schema, u = r.editing.view, l = i.keyCode, c = TP(l, r.locale.contentLanguageDirection), d = u.document.selection.getSelectedElement(), p = r.editing.mapper.toModelElement(d);
    let g;
    Ur(d, p, a) ? g = this._handleArrowKeyPressOnSelectedWidget(c) : o.isCollapsed ? g = this._handleArrowKeyPressWhenSelectionNextToAWidget(c) : i.shiftKey || (g = this._handleArrowKeyPressWhenNonCollapsedSelection(c)), g && (i.preventDefault(), t.stop());
  }
  /**
  * Handles the keyboard navigation on "keydown" when a widget is currently selected and activates or deactivates
  * the fake caret for that widget, depending on the current value of the `widget-type-around` model
  * selection attribute and the direction of the pressed arrow key.
  *
  * @param isForward `true` when the pressed arrow key was responsible for the forward model selection movement
  * as in {@link module:utils/keyboard~isForwardArrowKeyCode}.
  * @returns Returns `true` when the keypress was handled and no other keydown listener of the editor should
  * process the event any further. Returns `false` otherwise.
  */
  _handleArrowKeyPressOnSelectedWidget(t) {
    const r = this.editor.model, s = r.document.selection, o = Hr(s);
    return r.change((a) => {
      if (o) {
        if (!(o === (t ? "after" : "before")))
          return a.removeSelectionAttribute(Li), !0;
      } else
        return a.setSelectionAttribute(Li, t ? "after" : "before"), !0;
      return !1;
    });
  }
  /**
  * Handles the keyboard navigation on "keydown" when **no** widget is selected but the selection is **directly** next
  * to one and upon the fake caret should become active for this widget upon arrow keypress
  * (AKA entering/selecting the widget).
  *
  * **Note**: This code mirrors the implementation from the widget plugin but also adds the selection attribute.
  * Unfortunately, there is no safe way to let the widget plugin do the selection part first and then just set the
  * selection attribute here in the widget type around plugin. This is why this code must duplicate some from the widget plugin.
  *
  * @param isForward `true` when the pressed arrow key was responsible for the forward model selection movement
  * as in {@link module:utils/keyboard~isForwardArrowKeyCode}.
  * @returns Returns `true` when the keypress was handled and no other keydown listener of the editor should
  * process the event any further. Returns `false` otherwise.
  */
  _handleArrowKeyPressWhenSelectionNextToAWidget(t) {
    const i = this.editor, r = i.model, s = r.schema, o = i.plugins.get("Widget"), a = o._getObjectElementNextToSelection(t), u = i.editing.mapper.toViewElement(a);
    return Ur(u, a, s) ? (r.change((l) => {
      o._setSelectionOverElement(a), l.setSelectionAttribute(Li, t ? "before" : "after");
    }), !0) : !1;
  }
  /**
  * Handles the keyboard navigation on "keydown" when a widget is currently selected (together with some other content)
  * and the widget is the first or last element in the selection. It activates or deactivates the fake caret for that widget.
  *
  * @param isForward `true` when the pressed arrow key was responsible for the forward model selection movement
  * as in {@link module:utils/keyboard~isForwardArrowKeyCode}.
  * @returns Returns `true` when the keypress was handled and no other keydown listener of the editor should
  * process the event any further. Returns `false` otherwise.
  */
  _handleArrowKeyPressWhenNonCollapsedSelection(t) {
    const i = this.editor, r = i.model, s = r.schema, o = i.editing.mapper, a = r.document.selection, u = t ? a.getLastPosition().nodeBefore : a.getFirstPosition().nodeAfter, l = o.toViewElement(u);
    return Ur(l, u, s) ? (r.change((c) => {
      c.setSelection(u, "on"), c.setSelectionAttribute(Li, t ? "after" : "before");
    }), !0) : !1;
  }
  /**
  * Registers a `mousedown` listener for the view document which intercepts events
  * coming from the widget type around UI, which happens when a user clicks one of the buttons
  * that insert a paragraph next to a widget.
  */
  _enableInsertingParagraphsOnButtonClick() {
    const t = this.editor, i = t.editing.view;
    this._listenToIfEnabled(i.document, "mousedown", (r, s) => {
      const o = $L(s.domTarget);
      if (!o)
        return;
      const a = WL(o), u = zL(o, i.domConverter), l = t.editing.mapper.toModelElement(u);
      this._insertParagraph(l, a), s.preventDefault(), r.stop();
    });
  }
  /**
  * Creates the <kbd>Enter</kbd> key listener on the view document that allows the user to insert a paragraph
  * near the widget when either:
  *
  * * The fake caret was first activated using the arrow keys,
  * * The entire widget is selected in the model.
  *
  * In the first case, the new paragraph is inserted according to the `widget-type-around` selection
  * attribute (see {@link #_handleArrowKeyPress}).
  *
  * In the second case, the new paragraph is inserted based on whether a soft (<kbd>Shift</kbd>+<kbd>Enter</kbd>) keystroke
  * was pressed or not.
  */
  _enableInsertingParagraphsOnEnterKeypress() {
    const t = this.editor, i = t.model.document.selection, r = t.editing.view;
    this._listenToIfEnabled(r.document, "enter", (s, o) => {
      if (s.eventPhase != "atTarget")
        return;
      const a = i.getSelectedElement(), u = t.editing.mapper.toViewElement(a), l = t.model.schema;
      let c;
      this._insertParagraphAccordingToFakeCaretPosition() ? c = !0 : Ur(u, a, l) && (this._insertParagraph(a, o.isSoft ? "before" : "after"), c = !0), c && (o.preventDefault(), s.stop());
    }, {
      context: Rt
    });
  }
  /**
  * Similar to the {@link #_enableInsertingParagraphsOnEnterKeypress}, it allows the user
  * to insert a paragraph next to a widget when the fake caret was activated using arrow
  * keys but it responds to typing instead of <kbd>Enter</kbd>.
  *
  * Listener enabled by this method will insert a new paragraph according to the `widget-type-around`
  * model selection attribute as the user simply starts typing, which creates the impression that the fake caret
  * behaves like a real one rendered by the browser (AKA your text appears where the caret was).
  *
  * **Note**: At the moment this listener creates 2 undo steps: one for the `insertParagraph` command
  * and another one for actual typing. It is not a disaster but this may need to be fixed
  * sooner or later.
  */
  _enableInsertingParagraphsOnTypingKeystroke() {
    const i = this.editor.editing.view.document;
    this._listenToIfEnabled(i, "insertText", (r, s) => {
      this._insertParagraphAccordingToFakeCaretPosition() && (s.selection = i.selection);
    }, {
      priority: "high"
    }), he.isAndroid ? this._listenToIfEnabled(i, "keydown", (r, s) => {
      s.keyCode == 229 && this._insertParagraphAccordingToFakeCaretPosition();
    }) : this._listenToIfEnabled(i, "compositionstart", () => {
      this._insertParagraphAccordingToFakeCaretPosition();
    }, {
      priority: "high"
    });
  }
  /**
  * It creates a "delete" event listener on the view document to handle cases when the <kbd>Delete</kbd> or <kbd>Backspace</kbd>
  * is pressed and the fake caret is currently active.
  *
  * The fake caret should create an illusion of a real browser caret so that when it appears before or after
  * a widget, pressing <kbd>Delete</kbd> or <kbd>Backspace</kbd> should remove a widget or delete the content
  * before or after a widget (depending on the content surrounding the widget).
  */
  _enableDeleteIntegration() {
    const t = this.editor, i = t.editing.view, r = t.model, s = r.schema;
    this._listenToIfEnabled(i.document, "delete", (o, a) => {
      if (o.eventPhase != "atTarget")
        return;
      const u = Hr(r.document.selection);
      if (!u)
        return;
      const l = a.direction, c = r.document.selection.getSelectedElement(), d = u === "before", p = l == "forward";
      if (d === p)
        t.execute("delete", {
          selection: r.createSelection(c, "on")
        });
      else {
        const b = s.getNearestSelectionRange(r.createPositionAt(c, u), l);
        if (b)
          if (!b.isCollapsed)
            r.change((_) => {
              _.setSelection(b), t.execute(p ? "deleteForward" : "delete");
            });
          else {
            const _ = r.createSelection(b.start);
            if (r.modifySelection(_, {
              direction: l
            }), !_.focus.isEqual(b.start))
              r.change((k) => {
                k.setSelection(b), t.execute(p ? "deleteForward" : "delete");
              });
            else {
              const k = XL(s, b.start.parent);
              r.deleteContent(r.createSelection(k, "on"), {
                doNotAutoparagraph: !0
              });
            }
          }
      }
      a.preventDefault(), o.stop();
    }, {
      context: Rt
    });
  }
  /**
  * Attaches the {@link module:engine/model/model~Model#event:insertContent} event listener that, for instance, allows the user to paste
  * content near a widget when the fake caret is first activated using the arrow keys.
  *
  * The content is inserted according to the `widget-type-around` selection attribute (see {@link #_handleArrowKeyPress}).
  */
  _enableInsertContentIntegration() {
    const t = this.editor, i = this.editor.model, r = i.document.selection;
    this._listenToIfEnabled(t.model, "insertContent", (s, [o, a]) => {
      if (a && !a.is("documentSelection"))
        return;
      const u = Hr(r);
      if (u)
        return s.stop(), i.change((l) => {
          const c = r.getSelectedElement(), d = i.createPositionAt(c, u), p = l.createSelection(d), g = i.insertContent(o, p);
          return l.setSelection(p), g;
        });
    }, {
      priority: "high"
    });
  }
  /**
  * Attaches the {@link module:engine/model/model~Model#event:insertObject} event listener that modifies the
  * `options.findOptimalPosition`parameter to position of fake caret in relation to selected element
  * to reflect user's intent of desired insertion position.
  *
  * The object is inserted according to the `widget-type-around` selection attribute (see {@link #_handleArrowKeyPress}).
  */
  _enableInsertObjectIntegration() {
    const t = this.editor, r = this.editor.model.document.selection;
    this._listenToIfEnabled(t.model, "insertObject", (s, o) => {
      const [, a, u = {}] = o;
      if (a && !a.is("documentSelection"))
        return;
      const l = Hr(r);
      l && (u.findOptimalPosition = l, o[3] = u);
    }, {
      priority: "high"
    });
  }
  /**
  * Attaches the {@link module:engine/model/model~Model#event:deleteContent} event listener to block the event when the fake
  * caret is active.
  *
  * This is required for cases that trigger {@link module:engine/model/model~Model#deleteContent `model.deleteContent()`}
  * before calling {@link module:engine/model/model~Model#insertContent `model.insertContent()`} like, for instance,
  * plain text pasting.
  */
  _enableDeleteContentIntegration() {
    const t = this.editor, r = this.editor.model.document.selection;
    this._listenToIfEnabled(t.model, "deleteContent", (s, [o]) => {
      if (o && !o.is("documentSelection"))
        return;
      Hr(r) && s.stop();
    }, {
      priority: "high"
    });
  }
}
function KL(e, n, t) {
  const i = e.createUIElement("div", {
    class: "ck ck-reset_all ck-widget__type-around"
  }, function(r) {
    const s = this.toDomElement(r);
    return GL(s, n), QL(s), s;
  });
  e.insert(e.createPositionAt(t, "end"), i);
}
function GL(e, n) {
  for (const t of fy) {
    const i = new Ai({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-widget__type-around__button",
          `ck-widget__type-around__button_${t}`
        ],
        title: n[t],
        "aria-hidden": "true"
      },
      children: [
        e.ownerDocument.importNode(YL, !0)
      ]
    });
    e.appendChild(i.render());
  }
}
function QL(e) {
  const n = new Ai({
    tag: "div",
    attributes: {
      class: [
        "ck",
        "ck-widget__type-around__fake-caret"
      ]
    }
  });
  e.appendChild(n.render());
}
function XL(e, n) {
  let t = n;
  for (const i of n.getAncestors({
    parentFirst: !0
  })) {
    if (i.childCount > 1 || e.isLimit(i))
      break;
    t = i;
  }
  return t;
}
function JL(e) {
  const n = e.model;
  return (t, i) => {
    const r = i.keyCode == ye.arrowup, s = i.keyCode == ye.arrowdown, o = i.shiftKey, a = n.document.selection;
    if (!r && !s)
      return;
    const u = s;
    if (o && tD(a, u))
      return;
    const l = ZL(e, a, u);
    if (l) {
      if (l.isCollapsed) {
        if (a.isCollapsed)
          return;
        if (o)
          return;
      }
      (l.isCollapsed || eD(e, l, u)) && (n.change((c) => {
        const d = u ? l.end : l.start;
        if (o) {
          const p = n.createSelection(a.anchor);
          p.setFocus(d), c.setSelection(p);
        } else
          c.setSelection(d);
      }), t.stop(), i.preventDefault(), i.stopPropagation());
    }
  };
}
function ZL(e, n, t) {
  const i = e.model;
  if (t) {
    const r = n.isCollapsed ? n.focus : n.getLastPosition(), s = Rg(i, r, "forward");
    if (!s)
      return null;
    const o = i.createRange(r, s), a = Lg(i.schema, o, "backward");
    return a ? i.createRange(r, a) : null;
  } else {
    const r = n.isCollapsed ? n.focus : n.getFirstPosition(), s = Rg(i, r, "backward");
    if (!s)
      return null;
    const o = i.createRange(s, r), a = Lg(i.schema, o, "forward");
    return a ? i.createRange(a, r) : null;
  }
}
function Rg(e, n, t) {
  const i = e.schema, r = e.createRangeIn(n.root), s = t == "forward" ? "elementStart" : "elementEnd";
  for (const { previousPosition: o, item: a, type: u } of r.getWalker({
    startPosition: n,
    direction: t
  })) {
    if (i.isLimit(a) && !i.isInline(a))
      return o;
    if (u == s && i.isBlock(a))
      return null;
  }
  return null;
}
function Lg(e, n, t) {
  const i = t == "backward" ? n.end : n.start;
  if (e.checkChild(i, "$text"))
    return i;
  for (const { nextPosition: r } of n.getWalker({
    direction: t
  }))
    if (e.checkChild(r, "$text"))
      return r;
  return null;
}
function eD(e, n, t) {
  const i = e.model, r = e.view.domConverter;
  if (t) {
    const l = i.createSelection(n.start);
    i.modifySelection(l), !l.focus.isAtEnd && !n.start.isEqual(l.focus) && (n = i.createRange(l.focus, n.end));
  }
  const s = e.mapper.toViewRange(n), o = r.viewRangeToDom(s), a = Se.getDomRangeRects(o);
  let u;
  for (const l of a) {
    if (u === void 0) {
      u = Math.round(l.bottom);
      continue;
    }
    if (Math.round(l.top) >= u)
      return !1;
    u = Math.max(u, Math.round(l.bottom));
  }
  return !0;
}
function tD(e, n) {
  return !e.isCollapsed && e.isBackward == n;
}
class nD extends ce {
  constructor() {
    super(...arguments);
    /**
    * Holds previously selected widgets.
    */
    m(this, "_previouslySelected", /* @__PURE__ */ new Set());
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Widget";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      jL,
      fs
    ];
  }
  /**
  * @inheritDoc
  */
  init() {
    const t = this.editor, i = t.editing.view, r = i.document, s = t.t;
    this.editor.editing.downcastDispatcher.on("selection", (o, a, u) => {
      const l = u.writer, c = a.selection;
      if (c.isCollapsed)
        return;
      const d = c.getSelectedElement();
      if (!d)
        return;
      const p = t.editing.mapper.toViewElement(d);
      Rt(p) && u.consumable.consume(c, "selection") && l.setSelection(l.createRangeOn(p), {
        fake: !0,
        label: VL(p)
      });
    }), this.editor.editing.downcastDispatcher.on("selection", (o, a, u) => {
      this._clearPreviouslySelectedWidgets(u.writer);
      const l = u.writer, c = l.document.selection;
      let d = null;
      for (const p of c.getRanges())
        for (const g of p) {
          const b = g.item;
          Rt(b) && !sD(b, d) && (l.addClass(Og, b), this._previouslySelected.add(b), d = b);
        }
    }, {
      priority: "low"
    }), i.addObserver(nm), this.listenTo(r, "mousedown", (...o) => this._onMousedown(...o)), this.listenTo(r, "arrowKey", (...o) => {
      this._handleSelectionChangeOnArrowKeyPress(...o);
    }, {
      context: [
        Rt,
        "$text"
      ]
    }), this.listenTo(r, "arrowKey", (...o) => {
      this._preventDefaultOnArrowKeyPress(...o);
    }, {
      context: "$root"
    }), this.listenTo(r, "arrowKey", JL(this.editor.editing), {
      context: "$text"
    }), this.listenTo(r, "delete", (o, a) => {
      this._handleDelete(a.direction == "forward") && (a.preventDefault(), o.stop());
    }, {
      context: "$root"
    }), this.listenTo(r, "tab", (o, a) => {
      o.eventPhase == "atTarget" && (a.shiftKey || this._selectFirstNestedEditable() && (a.preventDefault(), o.stop()));
    }, {
      context: Rt,
      priority: "low"
    }), this.listenTo(r, "tab", (o, a) => {
      a.shiftKey && this._selectAncestorWidget() && (a.preventDefault(), o.stop());
    }, {
      priority: "low"
    }), this.listenTo(r, "keydown", (o, a) => {
      a.keystroke == ye.esc && this._selectAncestorWidget() && (a.preventDefault(), o.stop());
    }, {
      priority: "low"
    }), t.accessibility.addKeystrokeInfoGroup({
      id: "widget",
      label: s("Keystrokes that can be used when a widget is selected (for example: image, table, etc.)"),
      keystrokes: [
        {
          label: s("Move focus from an editable area back to the parent widget"),
          keystroke: "Esc"
        },
        {
          label: s("Insert a new paragraph directly after a widget"),
          keystroke: "Enter"
        },
        {
          label: s("Insert a new paragraph directly before a widget"),
          keystroke: "Shift+Enter"
        },
        {
          label: s("Move the caret to allow typing directly before a widget"),
          keystroke: [
            [
              "arrowup"
            ],
            [
              "arrowleft"
            ]
          ]
        },
        {
          label: s("Move the caret to allow typing directly after a widget"),
          keystroke: [
            [
              "arrowdown"
            ],
            [
              "arrowright"
            ]
          ]
        }
      ]
    });
  }
  /**
  * Handles {@link module:engine/view/document~Document#event:mousedown mousedown} events on widget elements.
  */
  _onMousedown(t, i) {
    const r = this.editor, s = r.editing.view, o = s.document;
    let a = i.target;
    if (!a)
      return;
    if (i.domEvent.detail >= 3) {
      this._selectBlockContent(a) && i.preventDefault();
      return;
    }
    if (!Rt(a)) {
      const l = iD(a);
      if (!l)
        return;
      if (Rt(l))
        a = l;
      else {
        const c = rD(s, i);
        if (c && Rt(c))
          a = c;
        else
          return;
      }
    }
    he.isAndroid && i.preventDefault(), o.isFocused || s.focus();
    const u = r.editing.mapper.toModelElement(a);
    this._setSelectionOverElement(u);
  }
  /**
  * Selects entire block content, e.g. on triple click it selects entire paragraph.
  */
  _selectBlockContent(t) {
    const i = this.editor, r = i.model, s = i.editing.mapper, o = r.schema, a = s.findMappedViewAncestor(this.editor.editing.view.createPositionAt(t, 0)), u = oD(s.toModelElement(a), r.schema);
    return u ? (r.change((l) => {
      const c = o.isLimit(u) ? null : aD(l.createPositionAfter(u), o), d = l.createPositionAt(u, 0), p = c ? l.createPositionAt(c, 0) : l.createPositionAt(u, "end");
      l.setSelection(l.createRange(d, p));
    }), !0) : !1;
  }
  /**
  * Handles {@link module:engine/view/document~Document#event:keydown keydown} events and changes
  * the model selection when:
  *
  * * arrow key is pressed when the widget is selected,
  * * the selection is next to a widget and the widget should become selected upon the arrow key press.
  *
  * See {@link #_preventDefaultOnArrowKeyPress}.
  */
  _handleSelectionChangeOnArrowKeyPress(t, i) {
    const r = i.keyCode, s = this.editor.model, o = s.schema, a = s.document.selection, u = a.getSelectedElement(), l = VE(r, this.editor.locale.contentLanguageDirection), c = l == "down" || l == "right", d = l == "up" || l == "down";
    if (u && o.isObject(u)) {
      const g = c ? a.getLastPosition() : a.getFirstPosition(), b = o.getNearestSelectionRange(g, c ? "forward" : "backward");
      b && (s.change((_) => {
        _.setSelection(b);
      }), i.preventDefault(), t.stop());
      return;
    }
    if (!a.isCollapsed && !i.shiftKey) {
      const g = a.getFirstPosition(), b = a.getLastPosition(), _ = g.nodeAfter, k = b.nodeBefore;
      (_ && o.isObject(_) || k && o.isObject(k)) && (s.change((C) => {
        C.setSelection(c ? b : g);
      }), i.preventDefault(), t.stop());
      return;
    }
    if (!a.isCollapsed)
      return;
    const p = this._getObjectElementNextToSelection(c);
    if (p && o.isObject(p)) {
      if (o.isInline(p) && d)
        return;
      this._setSelectionOverElement(p), i.preventDefault(), t.stop();
    }
  }
  /**
  * Handles {@link module:engine/view/document~Document#event:keydown keydown} events and prevents
  * the default browser behavior to make sure the fake selection is not being moved from a fake selection
  * container.
  *
  * See {@link #_handleSelectionChangeOnArrowKeyPress}.
  */
  _preventDefaultOnArrowKeyPress(t, i) {
    const r = this.editor.model, s = r.schema, o = r.document.selection.getSelectedElement();
    o && s.isObject(o) && (i.preventDefault(), t.stop());
  }
  /**
  * Handles delete keys: backspace and delete.
  *
  * @param isForward Set to true if delete was performed in forward direction.
  * @returns Returns `true` if keys were handled correctly.
  */
  _handleDelete(t) {
    const r = this.editor.model.document.selection;
    if (!this.editor.model.canEditAt(r) || !r.isCollapsed)
      return;
    const s = this._getObjectElementNextToSelection(t);
    if (s)
      return this.editor.model.change((o) => {
        let a = r.anchor.parent;
        for (; a.isEmpty; ) {
          const u = a;
          a = u.parent, o.remove(u);
        }
        this._setSelectionOverElement(s);
      }), !0;
  }
  /**
  * Sets {@link module:engine/model/selection~Selection document's selection} over given element.
  *
  * @internal
  */
  _setSelectionOverElement(t) {
    this.editor.model.change((i) => {
      i.setSelection(i.createRangeOn(t));
    });
  }
  /**
  * Checks if {@link module:engine/model/element~Element element} placed next to the current
  * {@link module:engine/model/selection~Selection model selection} exists and is marked in
  * {@link module:engine/model/schema~Schema schema} as `object`.
  *
  * @internal
  * @param forward Direction of checking.
  */
  _getObjectElementNextToSelection(t) {
    const i = this.editor.model, r = i.schema, s = i.document.selection, o = i.createSelection(s);
    if (i.modifySelection(o, {
      direction: t ? "forward" : "backward"
    }), o.isEqual(s))
      return null;
    const a = t ? o.focus.nodeBefore : o.focus.nodeAfter;
    return a && r.isObject(a) ? a : null;
  }
  /**
  * Removes CSS class from previously selected widgets.
  */
  _clearPreviouslySelectedWidgets(t) {
    for (const i of this._previouslySelected)
      t.removeClass(Og, i);
    this._previouslySelected.clear();
  }
  /**
  * Moves the document selection into the first nested editable.
  */
  _selectFirstNestedEditable() {
    const t = this.editor, r = this.editor.editing.view.document;
    for (const s of r.selection.getFirstRange().getItems())
      if (s.is("editableElement")) {
        const o = t.editing.mapper.toModelElement(s);
        /* istanbul ignore next -- @preserve */
        if (!o)
          continue;
        const a = t.model.createPositionAt(o, 0), u = t.model.schema.getNearestSelectionRange(a, "forward");
        return t.model.change((l) => {
          l.setSelection(u);
        }), !0;
      }
    return !1;
  }
  /**
  * Updates the document selection so that it selects first ancestor widget.
  */
  _selectAncestorWidget() {
    const t = this.editor, i = t.editing.mapper, s = t.editing.view.document.selection.getFirstPosition().parent, a = (s.is("$text") ? s.parent : s).findAncestor(Rt);
    if (!a)
      return !1;
    const u = i.toModelElement(a);
    /* istanbul ignore next -- @preserve */
    return u ? (t.model.change((l) => {
      l.setSelection(u, "on");
    }), !0) : !1;
  }
}
function iD(e) {
  let n = e;
  for (; n; ) {
    if (n.is("editableElement") || Rt(n))
      return n;
    n = n.parent;
  }
  return null;
}
function rD(e, n) {
  const t = NE(n.domEvent);
  let i = null;
  if (t ? i = e.domConverter.domRangeToView(t) : i = e.createRange(e.createPositionAt(n.target, 0)), !i)
    return null;
  const r = i.start;
  if (!r.parent)
    return null;
  let s = r.parent;
  return r.parent.is("editableElement") && (r.isAtEnd && r.nodeBefore ? s = r.nodeBefore : r.isAtStart && r.nodeAfter && (s = r.nodeAfter)), s.is("$text") ? s.parent : s;
}
function sD(e, n) {
  return n ? Array.from(e.getAncestors()).includes(n) : !1;
}
function oD(e, n) {
  for (const t of e.getAncestors({
    includeSelf: !0,
    parentFirst: !0
  })) {
    if (n.checkChild(t, "$text"))
      return t;
    if (n.isLimit(t) && !n.isObject(t))
      break;
  }
  return null;
}
function aD(e, n) {
  const t = new Ui({
    startPosition: e
  });
  for (const { item: i } of t) {
    if (n.isLimit(i) || !i.is("element"))
      return null;
    if (n.checkChild(i, "$text"))
      return i;
  }
  return null;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class Va extends Sr {
  constructor(t) {
    super(t);
    m(this, "domEventType", [
      "paste",
      "copy",
      "cut",
      "drop",
      "dragover",
      "dragstart",
      "dragend",
      "dragenter",
      "dragleave"
    ]);
    const i = this.document;
    this.listenTo(i, "paste", r("clipboardInput"), {
      priority: "low"
    }), this.listenTo(i, "drop", r("clipboardInput"), {
      priority: "low"
    }), this.listenTo(i, "dragover", r("dragging"), {
      priority: "low"
    });
    function r(s) {
      return (o, a) => {
        a.preventDefault();
        const u = a.dropRange ? [
          a.dropRange
        ] : null, l = new Wi(i, s);
        i.fire(l, {
          dataTransfer: a.dataTransfer,
          method: o.name,
          targetRanges: u,
          target: a.target,
          domEvent: a.domEvent
        }), l.stop.called && a.stopPropagation();
      };
    }
  }
  onDomEvent(t) {
    const i = "clipboardData" in t ? t.clipboardData : t.dataTransfer, r = t.type == "drop" || t.type == "paste", s = {
      dataTransfer: new nT(i, {
        cacheFiles: r
      })
    };
    if (t.type == "drop" || t.type == "dragover") {
      const o = NE(t);
      s.dropRange = o && this.view.domConverter.domRangeToView(o);
    }
    this.fire(t.type, t, s);
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function uD(e) {
  return e = e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n\r?\n/g, "</p><p>").replace(/\r?\n/g, "<br>").replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;"), (e.includes("</p><p>") || e.includes("<br>")) && (e = `<p>${e}</p>`), e;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function lD(e) {
  return e.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (n, t) => t.length == 1 ? " " : t).replace(/<!--[\s\S]*?-->/g, "");
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const Dg = [
  "figcaption",
  "li"
], Mg = [
  "ol",
  "ul"
];
function my(e, n) {
  if (n.is("$text") || n.is("$textProxy"))
    return n.data;
  if (n.is("element", "img") && n.hasAttribute("alt"))
    return n.getAttribute("alt");
  if (n.is("element", "br"))
    return `
`;
  let t = "", i = null;
  for (const r of n.getChildren())
    t += cD(r, i) + my(e, r), i = r;
  if (n.is("rawElement")) {
    const r = document.createElement("div");
    n.render(r, e), t += py(r);
  }
  return t;
}
function py(e) {
  let n = "";
  if (e.nodeType === Node.TEXT_NODE)
    return e.textContent;
  if (e.tagName === "BR")
    return `
`;
  for (const t of e.childNodes)
    n += py(t);
  return n;
}
function cD(e, n) {
  return n ? e.is("element", "li") && !e.isEmpty && e.getChild(0).is("containerElement") || Mg.includes(e.name) && Mg.includes(n.name) ? `

` : !e.is("containerElement") && !n.is("containerElement") ? "" : Dg.includes(e.name) || Dg.includes(n.name) ? `
` : e.is("element") && e.getCustomProperty("dataPipeline:transparentRendering") || n.is("element") && n.getCustomProperty("dataPipeline:transparentRendering") ? "" : `

` : "";
}
class gy extends ce {
  constructor() {
    super(...arguments);
    /**
    * Map of marker names that can be copied.
    *
    * @internal
    */
    m(this, "_markersToCopy", /* @__PURE__ */ new Map());
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "ClipboardMarkersUtils";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * Registers marker name as copyable in clipboard pipeline.
  *
  * @param markerName Name of marker that can be copied.
  * @param config Configuration that describes what can be performed on specified marker.
  * @internal
  */
  _registerMarkerToCopy(t, i) {
    this._markersToCopy.set(t, i);
  }
  /**
  * Performs copy markers on provided selection and paste it to fragment returned from `getCopiedFragment`.
  *
  * 	1. Picks all markers in provided selection.
  * 	2. Inserts fake markers to document.
  * 	3. Gets copied selection fragment from document.
  * 	4. Removes fake elements from fragment and document.
  * 	5. Inserts markers in the place of removed fake markers.
  *
  * Due to selection modification, when inserting items, `getCopiedFragment` must *always* operate on `writer.model.document.selection'.
  * Do not use any other custom selection object within callback, as this will lead to out-of-bounds exceptions in rare scenarios.
  *
  * @param action Type of clipboard action.
  * @param writer An instance of the model writer.
  * @param selection Selection to be checked.
  * @param getCopiedFragment	Callback that performs copy of selection and returns it as fragment.
  * @internal
  */
  _copySelectedFragmentWithMarkers(t, i, r = (s) => s.model.getSelectedContent(s.model.document.selection)) {
    return this.editor.model.change((s) => {
      const o = s.model.document.selection;
      s.setSelection(i);
      const a = this._insertFakeMarkersIntoSelection(s, s.model.document.selection, t), u = r(s), l = this._removeFakeMarkersInsideElement(s, u);
      for (const [c, d] of Object.entries(a)) {
        l[c] || (l[c] = s.createRangeIn(u));
        for (const p of d)
          s.remove(p);
      }
      u.markers.clear();
      for (const [c, d] of Object.entries(l))
        u.markers.set(c, d);
      return s.setSelection(o), u;
    });
  }
  /**
  * Performs paste of markers on already pasted element.
  *
  * 	1. Inserts fake markers that are present in fragment element (such fragment will be processed in `getPastedDocumentElement`).
  * 	2. Calls `getPastedDocumentElement` and gets element that is inserted into root model.
  * 	3. Removes all fake markers present in transformed element.
  * 	4. Inserts new markers with removed fake markers ranges into pasted fragment.
  *
  * There are multiple edge cases that have to be considered before calling this function:
  *
  * 	* `markers` are inserted into the same element that must be later transformed inside `getPastedDocumentElement`.
  * 	* Fake marker elements inside `getPastedDocumentElement` can be cloned, but their ranges cannot overlap.
  * 	* If `duplicateOnPaste` is `true` in marker config then associated marker ID is regenerated before pasting.
  *
  * @param action Type of clipboard action.
  * @param markers Object that maps marker name to corresponding range.
  * @param getPastedDocumentElement Getter used to get target markers element.
  * @internal
  */
  _pasteMarkersIntoTransformedElement(t, i) {
    const r = this._getPasteMarkersFromRangeMap(t);
    return this.editor.model.change((s) => {
      const o = this._insertFakeMarkersElements(s, r), a = i(s), u = this._removeFakeMarkersInsideElement(s, a);
      for (const l of Object.values(o).flat())
        s.remove(l);
      for (const [l, c] of Object.entries(u))
        s.model.markers.has(l) || s.addMarker(l, {
          usingOperation: !0,
          affectsData: !0,
          range: c
        });
      return a;
    });
  }
  /**
  * Pastes document fragment with markers to document.
  * If `duplicateOnPaste` is `true` in marker config then associated markers IDs
  * are regenerated before pasting to avoid markers duplications in content.
  *
  * @param fragment Document fragment that should contain already processed by pipeline markers.
  * @internal
  */
  _pasteFragmentWithMarkers(t) {
    const i = this._getPasteMarkersFromRangeMap(t.markers);
    t.markers.clear();
    for (const r of i)
      t.markers.set(r.name, r.range);
    return this.editor.model.insertContent(t);
  }
  /**
  * In some situations we have to perform copy on selected fragment with certain markers. This function allows to temporarily bypass
  * restrictions on markers that we want to copy.
  *
  * This function executes `executor()` callback. For the duration of the callback, if the clipboard pipeline is used to copy
  * content, markers with the specified name will be copied to the clipboard as well.
  *
  * @param markerName Which markers should be copied.
  * @param executor Callback executed.
  * @param config Optional configuration flags used to copy (such like partial copy flag).
  * @internal
  */
  _forceMarkersCopy(t, i, r = {
    allowedActions: "all",
    copyPartiallySelected: !0,
    duplicateOnPaste: !0
  }) {
    const s = this._markersToCopy.get(t);
    this._markersToCopy.set(t, r), i(), s ? this._markersToCopy.set(t, s) : this._markersToCopy.delete(t);
  }
  /**
  * Checks if marker can be copied.
  *
  * @param markerName Name of checked marker.
  * @param action Type of clipboard action. If null then checks only if marker is registered as copyable.
  * @internal
  */
  _isMarkerCopyable(t, i) {
    const r = this._getMarkerClipboardConfig(t);
    if (!r)
      return !1;
    if (!i)
      return !0;
    const { allowedActions: s } = r;
    return s === "all" || s.includes(i);
  }
  /**
  * Checks if marker has any clipboard copy behavior configuration.
  *
  * @param markerName Name of checked marker.
  */
  _hasMarkerConfiguration(t) {
    return !!this._getMarkerClipboardConfig(t);
  }
  /**
  * Returns marker's configuration flags passed during registration.
  *
  * @param markerName Name of marker that should be returned.
  * @internal
  */
  _getMarkerClipboardConfig(t) {
    const [i] = t.split(":");
    return this._markersToCopy.get(i) || null;
  }
  /**
  * First step of copying markers. It looks for markers intersecting with given selection and inserts `$marker` elements
  * at positions where document markers start or end. This way `$marker` elements can be easily copied together with
  * the rest of the content of the selection.
  *
  * @param writer An instance of the model writer.
  * @param selection Selection to be checked.
  * @param action Type of clipboard action.
  */
  _insertFakeMarkersIntoSelection(t, i, r) {
    const s = this._getCopyableMarkersFromSelection(t, i, r);
    return this._insertFakeMarkersElements(t, s);
  }
  /**
  * Returns array of markers that can be copied in specified selection.
  *
  * If marker cannot be copied partially (according to `copyPartiallySelected` configuration flag) and
  * is not present entirely in any selection range then it will be skipped.
  *
  * @param writer An instance of the model writer.
  * @param selection  Selection which will be checked.
  * @param action Type of clipboard action. If null then checks only if marker is registered as copyable.
  */
  _getCopyableMarkersFromSelection(t, i, r) {
    const s = Array.from(i.getRanges()), o = new Set(s.flatMap((u) => Array.from(t.model.markers.getMarkersIntersectingRange(u)))), a = (u) => {
      if (!this._isMarkerCopyable(u.name, r))
        return !1;
      const { copyPartiallySelected: c } = this._getMarkerClipboardConfig(u.name);
      if (!c) {
        const d = u.getRange();
        return s.some((p) => p.containsRange(d, !0));
      }
      return !0;
    };
    return Array.from(o).filter(a).map((u) => ({
      name: r === "dragstart" ? this._getUniqueMarkerName(u.name) : u.name,
      range: u.getRange()
    }));
  }
  /**
  * Picks all markers from markers map that can be pasted.
  * If `duplicateOnPaste` is `true`, it regenerates their IDs to ensure uniqueness.
  * If marker is not registered, it will be kept in the array anyway.
  *
  * @param markers Object that maps marker name to corresponding range.
  * @param action Type of clipboard action. If null then checks only if marker is registered as copyable.
  */
  _getPasteMarkersFromRangeMap(t, i = null) {
    const { model: r } = this.editor;
    return (t instanceof Map ? Array.from(t.entries()) : Object.entries(t)).flatMap(([o, a]) => {
      if (!this._hasMarkerConfiguration(o))
        return [
          {
            name: o,
            range: a
          }
        ];
      if (this._isMarkerCopyable(o, i)) {
        const u = this._getMarkerClipboardConfig(o), l = r.markers.has(o) && r.markers.get(o).getRange().root.rootName === "$graveyard";
        return (u.duplicateOnPaste || l) && (o = this._getUniqueMarkerName(o)), [
          {
            name: o,
            range: a
          }
        ];
      }
      return [];
    });
  }
  /**
  * Inserts specified array of fake markers elements to document and assigns them `type` and `name` attributes.
  * Fake markers elements are used to calculate position of markers on pasted fragment that were transformed during
  * steps between copy and paste.
  *
  * @param writer An instance of the model writer.
  * @param markers Array of markers that will be inserted.
  */
  _insertFakeMarkersElements(t, i) {
    const r = {}, s = i.flatMap((o) => {
      const { start: a, end: u } = o.range;
      return [
        {
          position: a,
          marker: o,
          type: "start"
        },
        {
          position: u,
          marker: o,
          type: "end"
        }
      ];
    }).sort(({ position: o }, { position: a }) => o.isBefore(a) ? 1 : -1);
    for (const { position: o, marker: a, type: u } of s) {
      const l = t.createElement("$marker", {
        "data-name": a.name,
        "data-type": u
      });
      r[a.name] || (r[a.name] = []), r[a.name].push(l), t.insert(l, o);
    }
    return r;
  }
  /**
  * Removes all `$marker` elements from the given document fragment.
  *
  * Returns an object where keys are marker names, and values are ranges corresponding to positions
  * where `$marker` elements were inserted.
  *
  * If the document fragment had only one `$marker` element for given marker (start or end) the other boundary is set automatically
  * (to the end or start of the document fragment, respectively).
  *
  * @param writer An instance of the model writer.
  * @param rootElement The element to be checked.
  */
  _removeFakeMarkersInsideElement(t, i) {
    const s = this._getAllFakeMarkersFromElement(t, i).reduce((o, a) => {
      const u = a.markerElement && t.createPositionBefore(a.markerElement);
      let l = o[a.name], c = !1;
      return l && l.start && l.end && (this._getMarkerClipboardConfig(a.name).duplicateOnPaste ? o[this._getUniqueMarkerName(a.name)] = o[a.name] : c = !0, l = null), c || (o[a.name] = {
        ...l,
        [a.type]: u
      }), a.markerElement && t.remove(a.markerElement), o;
    }, {});
    return Tv(s, (o) => new B(o.start || t.createPositionFromPath(i, [
      0
    ]), o.end || t.createPositionAt(i, "end")));
  }
  /**
  * Returns array that contains list of fake markers with corresponding `$marker` elements.
  *
  * For each marker, there can be two `$marker` elements or only one (if the document fragment contained
  * only the beginning or only the end of a marker).
  *
  * @param writer An instance of the model writer.
  * @param rootElement The element to be checked.
  */
  _getAllFakeMarkersFromElement(t, i) {
    const r = Array.from(t.createRangeIn(i)).flatMap(({ item: a }) => {
      if (!a.is("element", "$marker"))
        return [];
      const u = a.getAttribute("data-name"), l = a.getAttribute("data-type");
      return [
        {
          markerElement: a,
          name: u,
          type: l
        }
      ];
    }), s = [], o = [];
    for (const a of r)
      a.type === "end" && (r.some((l) => l.name === a.name && l.type === "start") || s.push({
        markerElement: null,
        name: a.name,
        type: "start"
      })), a.type === "start" && (r.some((l) => l.name === a.name && l.type === "end") || o.unshift({
        markerElement: null,
        name: a.name,
        type: "end"
      }));
    return [
      ...s,
      ...r,
      ...o
    ];
  }
  /**
  * When copy of markers occurs we have to make sure that pasted markers have different names
  * than source markers. This functions helps with assigning unique part to marker name to
  * prevent duplicated markers error.
  *
  * @param name Name of marker
  */
  _getUniqueMarkerName(t) {
    const i = t.split(":"), r = un().substring(1, 6);
    return i.length === 3 ? `${i.slice(0, 2).join(":")}:${r}` : `${i.join(":")}:${r}`;
  }
}
class is extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "ClipboardPipeline";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      gy
    ];
  }
  /**
  * @inheritDoc
  */
  init() {
    this.editor.editing.view.addObserver(Va), this._setupPasteDrop(), this._setupCopyCut();
  }
  /**
  * Fires Clipboard `'outputTransformation'` event for given parameters.
  *
  * @internal
  */
  _fireOutputTransformationEvent(n, t, i) {
    const r = this.editor.plugins.get("ClipboardMarkersUtils");
    this.editor.model.enqueueChange({
      isUndoable: i === "cut"
    }, () => {
      const s = r._copySelectedFragmentWithMarkers(i, t);
      this.fire("outputTransformation", {
        dataTransfer: n,
        content: s,
        method: i
      });
    });
  }
  /**
  * The clipboard paste pipeline.
  */
  _setupPasteDrop() {
    const n = this.editor, t = n.model, i = n.editing.view, r = i.document, s = this.editor.plugins.get("ClipboardMarkersUtils");
    this.listenTo(r, "clipboardInput", (o, a) => {
      a.method == "paste" && !n.model.canEditAt(n.model.document.selection) && o.stop();
    }, {
      priority: "highest"
    }), this.listenTo(r, "clipboardInput", (o, a) => {
      const u = a.dataTransfer;
      let l;
      if (a.content)
        l = a.content;
      else {
        let p = "";
        u.getData("text/html") ? p = lD(u.getData("text/html")) : u.getData("text/plain") && (p = uD(u.getData("text/plain"))), l = this.editor.data.htmlProcessor.toView(p);
      }
      const c = new Wi(this, "inputTransformation"), d = u.getData("application/ckeditor5-editor-id") || null;
      this.fire(c, {
        content: l,
        dataTransfer: u,
        sourceEditorId: d,
        targetRanges: a.targetRanges,
        method: a.method
      }), c.stop.called && o.stop(), i.scrollToTheSelection();
    }, {
      priority: "low"
    }), this.listenTo(this, "inputTransformation", (o, a) => {
      if (a.content.isEmpty)
        return;
      const l = this.editor.data.toModel(a.content, "$clipboardHolder");
      l.childCount != 0 && (o.stop(), t.change(() => {
        this.fire("contentInsertion", {
          content: l,
          method: a.method,
          sourceEditorId: a.sourceEditorId,
          dataTransfer: a.dataTransfer,
          targetRanges: a.targetRanges
        });
      }));
    }, {
      priority: "low"
    }), this.listenTo(this, "contentInsertion", (o, a) => {
      a.resultRange = s._pasteFragmentWithMarkers(a.content);
    }, {
      priority: "low"
    });
  }
  /**
  * The clipboard copy/cut pipeline.
  */
  _setupCopyCut() {
    const n = this.editor, t = n.model.document, r = n.editing.view.document, s = (o, a) => {
      const u = a.dataTransfer;
      a.preventDefault(), this._fireOutputTransformationEvent(u, t.selection, o.name);
    };
    this.listenTo(r, "copy", s, {
      priority: "low"
    }), this.listenTo(r, "cut", (o, a) => {
      n.model.canEditAt(n.model.document.selection) ? s(o, a) : a.preventDefault();
    }, {
      priority: "low"
    }), this.listenTo(this, "outputTransformation", (o, a) => {
      const u = n.data.toView(a.content, {
        isClipboardPipeline: !0
      });
      r.fire("clipboardOutput", {
        dataTransfer: a.dataTransfer,
        content: u,
        method: a.method
      });
    }, {
      priority: "low"
    }), this.listenTo(r, "clipboardOutput", (o, a) => {
      a.content.isEmpty || (a.dataTransfer.setData("text/html", this.editor.data.htmlProcessor.toData(a.content)), a.dataTransfer.setData("text/plain", my(n.data.htmlProcessor.domConverter, a.content)), a.dataTransfer.setData("application/ckeditor5-editor-id", this.editor.id)), a.method == "cut" && n.model.deleteContent(t.selection);
    }, {
      priority: "low"
    });
  }
}
const Cd = /* @__PURE__ */ nu("px");
class dD extends me {
  /**
  * @inheritDoc
  */
  constructor() {
    super();
    const n = this.bindTemplate;
    this.set({
      isVisible: !1,
      left: null,
      top: null,
      width: null
    }), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-clipboard-drop-target-line",
          n.if("isVisible", "ck-hidden", (t) => !t)
        ],
        style: {
          left: n.to("left", (t) => Cd(t)),
          top: n.to("top", (t) => Cd(t)),
          width: n.to("width", (t) => Cd(t))
        }
      }
    });
  }
}
class Ru extends ce {
  constructor() {
    super(...arguments);
    /**
    * A delayed callback removing the drop marker.
    *
    * @internal
    */
    m(this, "removeDropMarkerDelayed", Wf(() => this.removeDropMarker(), 40));
    /**
    * A throttled callback updating the drop marker.
    */
    m(this, "_updateDropMarkerThrottled", pl((t) => this._updateDropMarker(t), 40));
    /**
    * A throttled callback reconverting the drop parker.
    */
    m(this, "_reconvertMarkerThrottled", pl(() => {
      this.editor.model.markers.has("drop-target") && this.editor.editing.reconvertMarker("drop-target");
    }, 0));
    /**
    * The horizontal drop target line view.
    */
    m(this, "_dropTargetLineView", new dD());
    /**
    * DOM Emitter.
    */
    m(this, "_domEmitter", new (li())());
    /**
    * Map of document scrollable elements.
    */
    m(this, "_scrollables", /* @__PURE__ */ new Map());
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "DragDropTarget";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    this._setupDropMarker();
  }
  /**
  * @inheritDoc
  */
  destroy() {
    this._domEmitter.stopListening();
    for (const { resizeObserver: t } of this._scrollables.values())
      t.destroy();
    return this._updateDropMarkerThrottled.cancel(), this.removeDropMarkerDelayed.cancel(), this._reconvertMarkerThrottled.cancel(), super.destroy();
  }
  /**
  * Finds the drop target range and updates the drop marker.
  *
  * @internal
  */
  updateDropMarker(t, i, r, s, o, a) {
    this.removeDropMarkerDelayed.cancel();
    const u = Bg(this.editor, t, i, r, s, o, a);
    /* istanbul ignore next -- @preserve */
    if (u) {
      if (a && a.containsRange(u))
        return this.removeDropMarker();
      this._updateDropMarkerThrottled(u);
    }
  }
  /**
  * Finds the final drop target range.
  *
  * @internal
  */
  getFinalDropRange(t, i, r, s, o, a) {
    const u = Bg(this.editor, t, i, r, s, o, a);
    return this.removeDropMarker(), u;
  }
  /**
  * Removes the drop target marker.
  *
  * @internal
  */
  removeDropMarker() {
    const t = this.editor.model;
    this.removeDropMarkerDelayed.cancel(), this._updateDropMarkerThrottled.cancel(), this._dropTargetLineView.isVisible = !1, t.markers.has("drop-target") && t.change((i) => {
      i.removeMarker("drop-target");
    });
  }
  /**
  * Creates downcast conversion for the drop target marker.
  */
  _setupDropMarker() {
    const t = this.editor;
    t.ui.view.body.add(this._dropTargetLineView), t.conversion.for("editingDowncast").markerToHighlight({
      model: "drop-target",
      view: {
        classes: [
          "ck-clipboard-drop-target-range"
        ]
      }
    }), t.conversion.for("editingDowncast").markerToElement({
      model: "drop-target",
      view: (i, { writer: r }) => {
        if (t.model.schema.checkChild(i.markerRange.start, "$text"))
          return this._dropTargetLineView.isVisible = !1, this._createDropTargetPosition(r);
        i.markerRange.isCollapsed ? this._updateDropTargetLine(i.markerRange) : this._dropTargetLineView.isVisible = !1;
      }
    });
  }
  /**
  * Updates the drop target marker to the provided range.
  *
  * @param targetRange The range to set the marker to.
  */
  _updateDropMarker(t) {
    const i = this.editor, r = i.model.markers;
    i.model.change((s) => {
      r.has("drop-target") ? r.get("drop-target").getRange().isEqual(t) || s.updateMarker("drop-target", {
        range: t
      }) : s.addMarker("drop-target", {
        range: t,
        usingOperation: !1,
        affectsData: !1
      });
    });
  }
  /**
  * Creates the UI element for vertical (in-line) drop target.
  */
  _createDropTargetPosition(t) {
    return t.createUIElement("span", {
      class: "ck ck-clipboard-drop-target-position"
    }, function(i) {
      const r = this.toDomElement(i);
      return r.append("⁠", i.createElement("span"), "⁠"), r;
    });
  }
  /**
  * Updates the horizontal drop target line.
  */
  _updateDropTargetLine(t) {
    const i = this.editor.editing, r = t.start.nodeBefore, s = t.start.nodeAfter, o = t.start.parent, a = r ? i.mapper.toViewElement(r) : null, u = a ? i.view.domConverter.mapViewToDom(a) : null, l = s ? i.mapper.toViewElement(s) : null, c = l ? i.view.domConverter.mapViewToDom(l) : null, d = i.mapper.toViewElement(o);
    if (!d)
      return;
    const p = i.view.domConverter.mapViewToDom(d), g = this._getScrollableRect(d), { scrollX: b, scrollY: _ } = ue.window, k = u ? new Se(u) : null, C = c ? new Se(c) : null, D = new Se(p).excludeScrollbarsAndBorders(), M = k ? k.bottom : D.top, j = C ? C.top : D.bottom, F = ue.window.getComputedStyle(p), O = M <= j ? (M + j) / 2 : j;
    if (g.top < O && O < g.bottom) {
      const V = D.left + parseFloat(F.paddingLeft), ie = D.right - parseFloat(F.paddingRight), W = Math.max(V + b, g.left), N = Math.min(ie + b, g.right);
      this._dropTargetLineView.set({
        isVisible: !0,
        left: W,
        top: O + _,
        width: N - W
      });
    } else
      this._dropTargetLineView.isVisible = !1;
  }
  /**
  * Finds the closest scrollable element rect for the given view element.
  */
  _getScrollableRect(t) {
    const i = t.root.rootName;
    let r;
    if (this._scrollables.has(i))
      r = this._scrollables.get(i).domElement;
    else {
      const s = this.editor.editing.view.domConverter.mapViewToDom(t);
      r = fD(s), this._domEmitter.listenTo(r, "scroll", this._reconvertMarkerThrottled, {
        usePassive: !0
      });
      const o = new Pa(r, this._reconvertMarkerThrottled);
      this._scrollables.set(i, {
        domElement: r,
        resizeObserver: o
      });
    }
    return new Se(r).excludeScrollbarsAndBorders();
  }
}
function Bg(e, n, t, i, r, s, o) {
  const a = e.model, u = e.editing.mapper;
  let c = Fg(e, n);
  for (; c; ) {
    if (!s) {
      if (a.schema.checkChild(c, "$text")) {
        if (t) {
          const d = t[0].start, p = u.toModelPosition(d);
          if (!o || Array.from(o.getItems({
            shallow: !0
          })).every((b) => a.schema.checkChild(p, b))) {
            if (a.schema.checkChild(p, "$text"))
              return a.createRange(p);
            if (d)
              return Lu(e, Fg(e, d.parent), i, r);
          }
        }
      } else if (a.schema.isInline(c))
        return Lu(e, c, i, r);
    }
    if (a.schema.isBlock(c))
      return Lu(e, c, i, r);
    if (a.schema.checkChild(c, "$block")) {
      const d = Array.from(c.getChildren()).filter((b) => b.is("element") && !hD(e, b));
      let p = 0, g = d.length;
      if (g == 0)
        return a.createRange(a.createPositionAt(c, "end"));
      for (; p < g - 1; ) {
        const b = Math.floor((p + g) / 2);
        by(e, d[b], i, r) == "before" ? g = b : p = b;
      }
      return Lu(e, d[p], i, r);
    }
    c = c.parent;
  }
  return null;
}
function hD(e, n) {
  const t = e.editing.mapper, i = e.editing.view.domConverter, r = t.toViewElement(n);
  if (!r)
    return !0;
  const s = i.mapViewToDom(r);
  return ue.window.getComputedStyle(s).float != "none";
}
function Lu(e, n, t, i) {
  const r = e.model;
  return r.createRange(r.createPositionAt(n, by(e, n, t, i)));
}
function by(e, n, t, i) {
  const r = e.editing.mapper, s = e.editing.view.domConverter, o = r.toViewElement(n), a = s.mapViewToDom(o), u = new Se(a);
  return e.model.schema.isInline(n) ? t < (u.left + u.right) / 2 ? "before" : "after" : i < (u.top + u.bottom) / 2 ? "before" : "after";
}
function Fg(e, n) {
  const t = e.editing.mapper, i = e.editing.view, r = t.toModelElement(n);
  if (r)
    return r;
  const s = i.createPositionBefore(n), o = t.findMappedViewAncestor(s);
  return t.toModelElement(o);
}
function fD(e) {
  let n = e;
  do {
    n = n.parentElement;
    const t = ue.window.getComputedStyle(n).overflowY;
    if (t == "auto" || t == "scroll")
      break;
  } while (n.tagName != "BODY");
  return n;
}
class mD extends ce {
  constructor() {
    super(...arguments);
    /**
    * Whether current dragging is started by block toolbar button dragging.
    */
    m(this, "_isBlockDragging", !1);
    /**
    * DOM Emitter.
    */
    m(this, "_domEmitter", new (li())());
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "DragDropBlockToolbar";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const t = this.editor;
    if (this.listenTo(t, "change:isReadOnly", (i, r, s) => {
      s ? (this.forceDisabled("readOnlyMode"), this._isBlockDragging = !1) : this.clearForceDisabled("readOnlyMode");
    }), he.isAndroid && this.forceDisabled("noAndroidSupport"), t.plugins.has("BlockToolbar")) {
      const r = t.plugins.get("BlockToolbar").buttonView.element;
      this._domEmitter.listenTo(r, "dragstart", (s, o) => this._handleBlockDragStart(o)), this._domEmitter.listenTo(ue.document, "dragover", (s, o) => this._handleBlockDragging(o)), this._domEmitter.listenTo(ue.document, "drop", (s, o) => this._handleBlockDragging(o)), this._domEmitter.listenTo(ue.document, "dragend", () => this._handleBlockDragEnd(), {
        useCapture: !0
      }), this.isEnabled && r.setAttribute("draggable", "true"), this.on("change:isEnabled", (s, o, a) => {
        r.setAttribute("draggable", a ? "true" : "false");
      });
    }
  }
  /**
  * @inheritDoc
  */
  destroy() {
    return this._domEmitter.stopListening(), super.destroy();
  }
  /**
  * The `dragstart` event handler.
  */
  _handleBlockDragStart(t) {
    if (!this.isEnabled)
      return;
    const i = this.editor.model, r = i.document.selection, s = this.editor.editing.view, o = Array.from(r.getSelectedBlocks()), a = i.createRange(i.createPositionBefore(o[0]), i.createPositionAfter(o[o.length - 1]));
    i.change((u) => u.setSelection(a)), this._isBlockDragging = !0, s.focus(), s.getObserver(Va).onDomEvent(t);
  }
  /**
  * The `dragover` and `drop` event handler.
  */
  _handleBlockDragging(t) {
    if (!this.isEnabled || !this._isBlockDragging)
      return;
    const i = t.clientX + (this.editor.locale.contentLanguageDirection == "ltr" ? 100 : -100), r = t.clientY, s = document.elementFromPoint(i, r), o = this.editor.editing.view;
    !s || !s.closest(".ck-editor__editable") || o.getObserver(Va).onDomEvent({
      ...t,
      type: t.type,
      dataTransfer: t.dataTransfer,
      target: s,
      clientX: i,
      clientY: r,
      preventDefault: () => t.preventDefault(),
      stopPropagation: () => t.stopPropagation()
    });
  }
  /**
  * The `dragend` event handler.
  */
  _handleBlockDragEnd() {
    this._isBlockDragging = !1;
  }
}
class pD extends ce {
  constructor() {
    super(...arguments);
    /**
    * The live range over the original content that is being dragged.
    */
    m(this, "_draggedRange");
    /**
    * The UID of current dragging that is used to verify if the drop started in the same editor as the drag start.
    *
    * **Note**: This is a workaround for broken 'dragend' events (they are not fired if the source text node got removed).
    */
    m(this, "_draggingUid");
    /**
    * The reference to the model element that currently has a `draggable` attribute set (it is set while dragging).
    */
    m(this, "_draggableElement");
    /**
    * A delayed callback removing draggable attributes.
    */
    m(this, "_clearDraggableAttributesDelayed", Wf(() => this._clearDraggableAttributes(), 40));
    /**
    * Whether the dragged content can be dropped only in block context.
    */
    // TODO handle drag from other editor instance
    // TODO configure to use block, inline or both
    m(this, "_blockMode", !1);
    /**
    * DOM Emitter.
    */
    m(this, "_domEmitter", new (li())());
    /**
    * The DOM element used to generate dragged preview image.
    */
    m(this, "_previewContainer");
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "DragDrop";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      is,
      nD,
      Ru,
      mD
    ];
  }
  /**
  * @inheritDoc
  */
  init() {
    const t = this.editor, i = t.editing.view;
    this._draggedRange = null, this._draggingUid = "", this._draggableElement = null, i.addObserver(Va), i.addObserver(nm), this._setupDragging(), this._setupContentInsertionIntegration(), this._setupClipboardInputIntegration(), this._setupDraggableAttributeHandling(), this.listenTo(t, "change:isReadOnly", (r, s, o) => {
      o ? this.forceDisabled("readOnlyMode") : this.clearForceDisabled("readOnlyMode");
    }), this.on("change:isEnabled", (r, s, o) => {
      o || this._finalizeDragging(!1);
    }), he.isAndroid && this.forceDisabled("noAndroidSupport");
  }
  /**
  * @inheritDoc
  */
  destroy() {
    return this._draggedRange && (this._draggedRange.detach(), this._draggedRange = null), this._previewContainer && this._previewContainer.remove(), this._domEmitter.stopListening(), this._clearDraggableAttributesDelayed.cancel(), super.destroy();
  }
  /**
  * Drag and drop events handling.
  */
  _setupDragging() {
    const t = this.editor, i = t.model, r = t.editing.view, s = r.document, o = t.plugins.get(Ru);
    this.listenTo(s, "dragstart", (a, u) => {
      if (u.target && u.target.is("editableElement")) {
        u.preventDefault();
        return;
      }
      if (this._prepareDraggedRange(u.target), !this._draggedRange) {
        u.preventDefault();
        return;
      }
      this._draggingUid = un(), u.dataTransfer.effectAllowed = this.isEnabled ? "copyMove" : "copy", u.dataTransfer.setData("application/ckeditor5-dragging-uid", this._draggingUid);
      const l = i.createSelection(this._draggedRange.toRange());
      this.editor.plugins.get("ClipboardPipeline")._fireOutputTransformationEvent(u.dataTransfer, l, "dragstart");
      const { dataTransfer: d, domTarget: p, domEvent: g } = u, { clientX: b } = g;
      this._updatePreview({
        dataTransfer: d,
        domTarget: p,
        clientX: b
      }), u.stopPropagation(), this.isEnabled || (this._draggedRange.detach(), this._draggedRange = null, this._draggingUid = "");
    }, {
      priority: "low"
    }), this.listenTo(s, "dragend", (a, u) => {
      this._finalizeDragging(!u.dataTransfer.isCanceled && u.dataTransfer.dropEffect == "move");
    }, {
      priority: "low"
    }), this._domEmitter.listenTo(ue.document, "dragend", () => {
      this._blockMode = !1;
    }, {
      useCapture: !0
    }), this.listenTo(s, "dragenter", () => {
      this.isEnabled && r.focus();
    }), this.listenTo(s, "dragleave", () => {
      o.removeDropMarkerDelayed();
    }), this.listenTo(s, "dragging", (a, u) => {
      if (!this.isEnabled) {
        u.dataTransfer.dropEffect = "none";
        return;
      }
      const { clientX: l, clientY: c } = u.domEvent;
      o.updateDropMarker(u.target, u.targetRanges, l, c, this._blockMode, this._draggedRange), this._draggedRange || (u.dataTransfer.dropEffect = "copy"), he.isGecko || (u.dataTransfer.effectAllowed == "copy" ? u.dataTransfer.dropEffect = "copy" : [
        "all",
        "copyMove"
      ].includes(u.dataTransfer.effectAllowed) && (u.dataTransfer.dropEffect = "move")), a.stop();
    }, {
      priority: "low"
    });
  }
  /**
  * Integration with the `clipboardInput` event.
  */
  _setupClipboardInputIntegration() {
    const t = this.editor, r = t.editing.view.document, s = t.plugins.get(Ru);
    this.listenTo(r, "clipboardInput", (o, a) => {
      if (a.method != "drop")
        return;
      const { clientX: u, clientY: l } = a.domEvent, c = s.getFinalDropRange(a.target, a.targetRanges, u, l, this._blockMode, this._draggedRange);
      if (!c) {
        this._finalizeDragging(!1), o.stop();
        return;
      }
      if (this._draggedRange && this._draggingUid != a.dataTransfer.getData("application/ckeditor5-dragging-uid") && (this._draggedRange.detach(), this._draggedRange = null, this._draggingUid = ""), Ug(a.dataTransfer) == "move" && this._draggedRange && this._draggedRange.containsRange(c, !0)) {
        this._finalizeDragging(!1), o.stop();
        return;
      }
      a.targetRanges = [
        t.editing.mapper.toViewRange(c)
      ];
    }, {
      priority: "high"
    });
  }
  /**
  * Integration with the `contentInsertion` event of the clipboard pipeline.
  */
  _setupContentInsertionIntegration() {
    const t = this.editor.plugins.get(is);
    t.on("contentInsertion", (i, r) => {
      if (!this.isEnabled || r.method !== "drop")
        return;
      const s = r.targetRanges.map((o) => this.editor.editing.mapper.toModelRange(o));
      this.editor.model.change((o) => o.setSelection(s));
    }, {
      priority: "high"
    }), t.on("contentInsertion", (i, r) => {
      if (!this.isEnabled || r.method !== "drop")
        return;
      const s = Ug(r.dataTransfer) == "move", o = !r.resultRange || !r.resultRange.isCollapsed;
      this._finalizeDragging(o && s);
    }, {
      priority: "lowest"
    });
  }
  /**
  * Adds listeners that add the `draggable` attribute to the elements while the mouse button is down so the dragging could start.
  */
  _setupDraggableAttributeHandling() {
    const t = this.editor, i = t.editing.view, r = i.document;
    this.listenTo(r, "mousedown", (s, o) => {
      if (he.isAndroid || !o)
        return;
      this._clearDraggableAttributesDelayed.cancel();
      let a = Hg(o.target);
      if (he.isBlink && !t.isReadOnly && !a && !r.selection.isCollapsed) {
        const u = r.selection.getSelectedElement();
        (!u || !Rt(u)) && (a = r.selection.editableElement);
      }
      a && (i.change((u) => {
        u.setAttribute("draggable", "true", a);
      }), this._draggableElement = t.editing.mapper.toModelElement(a));
    }), this.listenTo(r, "mouseup", () => {
      he.isAndroid || this._clearDraggableAttributesDelayed();
    });
  }
  /**
  * Removes the `draggable` attribute from the element that was used for dragging.
  */
  _clearDraggableAttributes() {
    const t = this.editor.editing;
    t.view.change((i) => {
      this._draggableElement && this._draggableElement.root.rootName != "$graveyard" && i.removeAttribute("draggable", t.mapper.toViewElement(this._draggableElement)), this._draggableElement = null;
    });
  }
  /**
  * Deletes the dragged content from its original range and clears the dragging state.
  *
  * @param moved Whether the move succeeded.
  */
  _finalizeDragging(t) {
    const i = this.editor, r = i.model;
    i.plugins.get(Ru).removeDropMarker(), this._clearDraggableAttributes(), i.plugins.has("WidgetToolbarRepository") && i.plugins.get("WidgetToolbarRepository").clearForceDisabled("dragDrop"), this._draggingUid = "", this._previewContainer && (this._previewContainer.remove(), this._previewContainer = void 0), this._draggedRange && (t && this.isEnabled && r.change((o) => {
      const a = r.createSelection(this._draggedRange);
      r.deleteContent(a, {
        doNotAutoparagraph: !0
      });
      const u = a.getFirstPosition().parent;
      u.isEmpty && !r.schema.checkChild(u, "$text") && r.schema.checkChild(u, "paragraph") && o.insertElement("paragraph", u, 0);
    }), this._draggedRange.detach(), this._draggedRange = null);
  }
  /**
  * Sets the dragged source range based on event target and document selection.
  */
  _prepareDraggedRange(t) {
    const i = this.editor, r = i.model, s = r.document.selection, o = t ? Hg(t) : null;
    if (o) {
      const c = i.editing.mapper.toModelElement(o);
      this._draggedRange = xn.fromRange(r.createRangeOn(c)), this._blockMode = r.schema.isBlock(c), i.plugins.has("WidgetToolbarRepository") && i.plugins.get("WidgetToolbarRepository").forceDisabled("dragDrop");
      return;
    }
    if (s.isCollapsed && !s.getFirstPosition().parent.isEmpty)
      return;
    const a = Array.from(s.getSelectedBlocks()), u = s.getFirstRange();
    if (a.length == 0) {
      this._draggedRange = xn.fromRange(u);
      return;
    }
    const l = _y(r, a);
    if (a.length > 1)
      this._draggedRange = xn.fromRange(l), this._blockMode = !0;
    else if (a.length == 1) {
      const c = u.start.isTouching(l.start) && u.end.isTouching(l.end);
      this._draggedRange = xn.fromRange(c ? l : u), this._blockMode = c;
    }
    r.change((c) => c.setSelection(this._draggedRange.toRange()));
  }
  /**
  * Updates the dragged preview image.
  */
  _updatePreview({ dataTransfer: t, domTarget: i, clientX: r }) {
    const s = this.editor.editing.view, o = s.document.selection.editableElement, a = s.domConverter.mapViewToDom(o), u = ue.window.getComputedStyle(a);
    this._previewContainer ? this._previewContainer.firstElementChild && this._previewContainer.removeChild(this._previewContainer.firstElementChild) : (this._previewContainer = Zn(ue.document, "div", {
      style: "position: fixed; left: -999999px;"
    }), ue.document.body.appendChild(this._previewContainer));
    const l = new Se(a);
    if (a.contains(i))
      return;
    const c = parseFloat(u.paddingLeft), d = Zn(ue.document, "div");
    d.className = "ck ck-content", d.style.width = u.width, d.style.paddingLeft = `${l.left - r + c}px`, he.isiOS && (d.style.backgroundColor = "white"), s.domConverter.setContentOf(d, t.getData("text/html")), t.setDragImage(d, 0, 0), this._previewContainer.appendChild(d);
  }
}
function Ug(e) {
  return he.isGecko ? e.dropEffect : [
    "all",
    "copyMove"
  ].includes(e.effectAllowed) ? "move" : "copy";
}
function Hg(e) {
  if (e.is("editableElement"))
    return null;
  if (e.hasClass("ck-widget__selection-handle"))
    return e.findAncestor(Rt);
  if (Rt(e))
    return e;
  const n = e.findAncestor((t) => Rt(t) || t.is("editableElement"));
  return Rt(n) ? n : null;
}
function _y(e, n) {
  const t = n[0], i = n[n.length - 1], r = t.getCommonAncestor(i), s = e.createPositionBefore(t), o = e.createPositionAfter(i);
  if (r && r.is("element") && !e.schema.isLimit(r)) {
    const a = e.createRangeOn(r), u = s.isTouching(a.start), l = o.isTouching(a.end);
    if (u && l)
      return _y(e, [
        r
      ]);
  }
  return e.createRange(s, o);
}
class gD extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "PastePlainText";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      is
    ];
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = n.model, i = n.editing.view, r = t.document.selection;
    i.addObserver(Va), n.plugins.get(is).on("contentInsertion", (s, o) => {
      bD(o.content, t) && t.change((a) => {
        const u = Array.from(r.getAttributes()).filter(([c]) => t.schema.getAttributeProperties(c).isFormatting);
        r.isCollapsed || t.deleteContent(r, {
          doNotAutoparagraph: !0
        }), u.push(...r.getAttributes());
        const l = a.createRangeIn(o.content);
        for (const c of l.getItems())
          for (const d of u)
            t.schema.checkAttribute(c, d[0]) && a.setAttribute(d[0], d[1], c);
      });
    });
  }
}
function bD(e, n) {
  let t = n.createRangeIn(e);
  if (e.childCount == 1) {
    const i = e.getChild(0);
    i.is("element") && n.schema.isBlock(i) && !n.schema.isObject(i) && !n.schema.isLimit(i) && (t = n.createRangeIn(i));
  }
  for (const i of t.getItems())
    if (!n.schema.isInline(i) || Array.from(i.getAttributeKeys()).find((s) => n.schema.getAttributeProperties(s).isFormatting))
      return !1;
  return !0;
}
class _D extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Clipboard";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      gy,
      is,
      pD,
      gD
    ];
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = this.editor.t;
    n.accessibility.addKeystrokeInfos({
      keystrokes: [
        {
          label: t("Copy selected content"),
          keystroke: "CTRL+C"
        },
        {
          label: t("Paste content"),
          keystroke: "CTRL+V"
        },
        {
          label: t("Paste content as plain text"),
          keystroke: "CTRL+SHIFT+V"
        }
      ]
    });
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class ED extends D4 {
  /**
  * Creates an instance of the classic editor UI class.
  *
  * @param editor The editor instance.
  * @param view The view of the UI.
  */
  constructor(t, i) {
    super(t);
    /**
    * The main (top–most) view of the editor UI.
    */
    m(this, "view");
    /**
    * A normalized `config.toolbar` object.
    */
    m(this, "_toolbarConfig");
    /**
    * The element replacer instance used to hide the editor's source element.
    */
    m(this, "_elementReplacer");
    this.view = i, this._toolbarConfig = YT(t.config.get("toolbar")), this._elementReplacer = new eP(), this.listenTo(t.editing.view, "scrollToTheSelection", this._handleScrollToTheSelectionWithStickyPanel.bind(this));
  }
  /**
  * @inheritDoc
  */
  get element() {
    return this.view.element;
  }
  /**
  * Initializes the UI.
  *
  * @param replacementElement The DOM element that will be the source for the created editor.
  */
  init(t) {
    const i = this.editor, r = this.view, s = i.editing.view, o = r.editable, a = s.document.getRoot();
    o.name = a.rootName, r.render();
    const u = o.element;
    this.setEditableElement(o.name, u), r.editable.bind("isFocused").to(this.focusTracker), s.attachDomRoot(u), t && this._elementReplacer.replace(t, this.element), this._initPlaceholder(), this._initToolbar(), r.menuBarView && this._initMenuBar(r.menuBarView), this._initDialogPluginIntegration(), this._initContextualBalloonIntegration(), this.fire("ready");
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy();
    const t = this.view, i = this.editor.editing.view;
    this._elementReplacer.restore(), i.getDomRoot(t.editable.name) && i.detachDomRoot(t.editable.name), t.destroy();
  }
  /**
  * Initializes the editor toolbar.
  */
  _initToolbar() {
    const t = this.view;
    t.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"), t.stickyPanel.limiterElement = t.element, t.stickyPanel.bind("viewportTopOffset").to(this, "viewportOffset", ({ top: i }) => i || 0), t.toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory), this.addToolbar(t.toolbar);
  }
  /**
  * Enable the placeholder text on the editing root.
  */
  _initPlaceholder() {
    const t = this.editor, i = t.editing.view, r = i.document.getRoot(), s = t.sourceElement;
    let o;
    const a = t.config.get("placeholder");
    a && (o = typeof a == "string" ? a : a[this.view.editable.name]), !o && s && s.tagName.toLowerCase() === "textarea" && (o = s.getAttribute("placeholder")), o && (r.placeholder = o), UP({
      view: i,
      element: r,
      isDirectHost: !1,
      keepOnFocus: !0
    });
  }
  /**
  * Provides an integration between the sticky toolbar and {@link module:ui/panel/balloon/contextualballoon contextual balloon plugin}.
  * It allows the contextual balloon to consider the height of the
  * {@link module:editor-classic/classiceditoruiview~ClassicEditorUIView#stickyPanel}. It prevents the balloon from overlapping
  * the sticky toolbar by adjusting the balloon's position using viewport offset configuration.
  */
  _initContextualBalloonIntegration() {
    if (!this.editor.plugins.has("ContextualBalloon"))
      return;
    const { stickyPanel: t } = this.view, i = this.editor.plugins.get("ContextualBalloon");
    i.on("getPositionOptions", (s) => {
      const o = s.return;
      if (!o || !t.isSticky || !t.element)
        return;
      const a = new Se(t.element).height, u = typeof o.target == "function" ? o.target() : o.target, l = typeof o.limiter == "function" ? o.limiter() : o.limiter;
      if (u && l && new Se(u).height >= new Se(l).height - a)
        return;
      const c = {
        ...o.viewportOffsetConfig
      }, d = (c.top || 0) + a;
      s.return = {
        ...o,
        viewportOffsetConfig: {
          ...c,
          top: d
        }
      };
    }, {
      priority: "low"
    });
    const r = () => {
      i.visibleView && i.updatePosition();
    };
    this.listenTo(t, "change:isSticky", r), this.listenTo(this.editor.ui, "change:viewportOffset", r);
  }
  /**
  * Provides an integration between the sticky toolbar and {@link module:utils/dom/scroll~scrollViewportToShowTarget}.
  * It allows the UI-agnostic engine method to consider the geometry of the
  * {@link module:editor-classic/classiceditoruiview~ClassicEditorUIView#stickyPanel} that pins to the
  * edge of the viewport and can obscure the user caret after scrolling the window.
  *
  * @param evt The `scrollToTheSelection` event info.
  * @param data The payload carried by the `scrollToTheSelection` event.
  * @param originalArgs The original arguments passed to `scrollViewportToShowTarget()` method (see implementation to learn more).
  */
  _handleScrollToTheSelectionWithStickyPanel(t, i, r) {
    const s = this.view.stickyPanel;
    if (s.isSticky) {
      const o = new Se(s.element).height;
      i.viewportOffset.top += o;
    } else {
      const o = () => {
        this.editor.editing.view.scrollToTheSelection(r);
      };
      this.listenTo(s, "change:isSticky", o), setTimeout(() => {
        this.stopListening(s, "change:isSticky", o);
      }, 20);
    }
  }
  /**
  * Provides an integration between the sticky toolbar and {@link module:ui/dialog/dialog the Dialog plugin}.
  *
  * It moves the dialog down to ensure that the
  * {@link module:editor-classic/classiceditoruiview~ClassicEditorUIView#stickyPanel sticky panel}
  * used by the editor UI will not get obscured by the dialog when the dialog uses one of its automatic positions.
  */
  _initDialogPluginIntegration() {
    if (!this.editor.plugins.has("Dialog"))
      return;
    const t = this.view.stickyPanel, i = this.editor.plugins.get("Dialog");
    i.on("show", () => {
      const r = i.view;
      r.on("moveTo", (s, o) => {
        if (!t.isSticky || r.wasMoved || r.isModal)
          return;
        const a = new Se(t.contentPanelElement);
        o[1] < a.bottom + Ha.defaultOffset && (o[1] = a.bottom + Ha.defaultOffset);
      }, {
        priority: "high"
      });
    }, {
      priority: "low"
    });
  }
}
class TD extends B4 {
  /**
  * Creates an instance of the classic editor UI view.
  *
  * @param locale The {@link module:core/editor/editor~Editor#locale} instance.
  * @param editingView The editing view instance this view is related to.
  * @param options Configuration options for the view instance.
  * @param options.shouldToolbarGroupWhenFull When set `true` enables automatic items grouping
  * in the main {@link module:editor-classic/classiceditoruiview~ClassicEditorUIView#toolbar toolbar}.
  * See {@link module:ui/toolbar/toolbarview~ToolbarOptions#shouldGroupWhenFull} to learn more.
  * @param options.label When set, this value will be used as an accessible `aria-label` of the
  * {@link module:ui/editableui/editableuiview~EditableUIView editable view}.
  */
  constructor(t, i, r = {}) {
    super(t);
    /**
    * Sticky panel view instance. This is a parent view of a {@link #toolbar}
    * that makes toolbar sticky.
    */
    m(this, "stickyPanel");
    /**
    * Toolbar view instance.
    */
    m(this, "toolbar");
    /**
    * Editable UI view.
    */
    m(this, "editable");
    this.stickyPanel = new W4(t), this.toolbar = new jT(t, {
      shouldGroupWhenFull: r.shouldToolbarGroupWhenFull
    }), r.useMenuBar && (this.menuBarView = new K4(t)), this.editable = new U4(t, i, void 0, {
      label: r.label
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.menuBarView ? this.stickyPanel.content.addMany([
      this.menuBarView,
      this.toolbar
    ]) : this.stickyPanel.content.add(this.toolbar), this.top.add(this.stickyPanel), this.main.add(this.editable);
  }
}
class yD extends (/* @__PURE__ */ Mh(PR)) {
  /**
  * Creates an instance of the classic editor.
  *
  * **Note:** do not use the constructor to create editor instances. Use the static
  * {@link module:editor-classic/classiceditor~ClassicEditor.create `ClassicEditor.create()`} method instead.
  *
  * @param sourceElementOrData The DOM element that will be the source for the created editor
  * or the editor's initial data. For more information see
  * {@link module:editor-classic/classiceditor~ClassicEditor.create `ClassicEditor.create()`}.
  * @param config The editor configuration.
  */
  constructor(t, i = {}) {
    if (!Zu(t) && i.initialData !== void 0)
      throw new v("editor-create-initial-data", null);
    super(i);
    /**
    * @inheritDoc
    */
    m(this, "ui");
    this.config.define("menuBar.isVisible", !1), this.config.get("initialData") === void 0 && this.config.set("initialData", wD(t)), Zu(t) && (this.sourceElement = t), this.model.document.createRoot();
    const r = !this.config.get("toolbar.shouldNotGroupWhenFull"), s = this.config.get("menuBar"), o = new TD(this.locale, this.editing.view, {
      shouldToolbarGroupWhenFull: r,
      useMenuBar: s.isVisible,
      label: this.config.get("label")
    });
    this.ui = new ED(this, o), NR(this);
  }
  /**
  * @inheritDoc
  */
  static get editorName() {
    return "ClassicEditor";
  }
  /**
  * Destroys the editor instance, releasing all resources used by it.
  *
  * Updates the original editor element with the data if the
  * {@link module:core/editor/editorconfig~EditorConfig#updateSourceElementOnDestroy `updateSourceElementOnDestroy`}
  * configuration option is set to `true`.
  */
  destroy() {
    return this.sourceElement && this.updateSourceElement(), this.ui.destroy(), super.destroy();
  }
  /**
  * Creates a new classic editor instance.
  *
  * There are three ways how the editor can be initialized.
  *
  * # Replacing a DOM element (and loading data from it)
  *
  * You can initialize the editor using an existing DOM element:
  *
  * ```ts
  * ClassicEditor
  * 	.create( document.querySelector( '#editor' ) )
  * 	.then( editor => {
  * 		console.log( 'Editor was initialized', editor );
  * 	} )
  * 	.catch( err => {
  * 		console.error( err.stack );
  * 	} );
  * ```
  *
  * The element's content will be used as the editor data and the element will be replaced by the editor UI.
  *
  * # Creating a detached editor
  *
  * Alternatively, you can initialize the editor by passing the initial data directly as a string.
  * In this case, the editor will render an element that must be inserted into the DOM:
  *
  * ```ts
  * ClassicEditor
  * 	.create( '<p>Hello world!</p>' )
  * 	.then( editor => {
  * 		console.log( 'Editor was initialized', editor );
  *
  * 		// Initial data was provided so the editor UI element needs to be added manually to the DOM.
  * 		document.body.appendChild( editor.ui.element );
  * 	} )
  * 	.catch( err => {
  * 		console.error( err.stack );
  * 	} );
  * ```
  *
  * This lets you dynamically append the editor to your web page whenever it is convenient for you. You may use this method if your
  * web page content is generated on the client side and the DOM structure is not ready at the moment when you initialize the editor.
  *
  * # Replacing a DOM element (and data provided in `config.initialData`)
  *
  * You can also mix these two ways by providing a DOM element to be used and passing the initial data through the configuration:
  *
  * ```ts
  * ClassicEditor
  * 	.create( document.querySelector( '#editor' ), {
  * 		initialData: '<h2>Initial data</h2><p>Foo bar.</p>'
  * 	} )
  * 	.then( editor => {
  * 		console.log( 'Editor was initialized', editor );
  * 	} )
  * 	.catch( err => {
  * 		console.error( err.stack );
  * 	} );
  * ```
  *
  * This method can be used to initialize the editor on an existing element with the specified content in case if your integration
  * makes it difficult to set the content of the source element.
  *
  * Note that an error will be thrown if you pass the initial data both as the first parameter and also in the configuration.
  *
  * # Configuring the editor
  *
  * See the {@link module:core/editor/editorconfig~EditorConfig editor configuration documentation} to learn more about
  * customizing plugins, toolbar and more.
  *
  * @param sourceElementOrData The DOM element that will be the source for the created editor
  * or the editor's initial data.
  *
  * If a DOM element is passed, its content will be automatically loaded to the editor upon initialization
  * and the {@link module:editor-classic/classiceditorui~ClassicEditorUI#element editor element} will replace the passed element
  * in the DOM (the original one will be hidden and the editor will be injected next to it).
  *
  * If the {@link module:core/editor/editorconfig~EditorConfig#updateSourceElementOnDestroy updateSourceElementOnDestroy}
  * option is set to `true`, the editor data will be set back to the original element once the editor is destroyed and when a form,
  * in which this element is contained, is submitted (if the original element is a `<textarea>`). This ensures seamless integration
  * with native web forms.
  *
  * If the initial data is passed, a detached editor will be created. In this case you need to insert it into the DOM manually.
  * It is available under the {@link module:editor-classic/classiceditorui~ClassicEditorUI#element `editor.ui.element`} property.
  *
  * @param config The editor configuration.
  * @returns A promise resolved once the editor is ready. The promise resolves with the created editor instance.
  */
  static create(t, i = {}) {
    return new Promise((r) => {
      const s = new this(t, i);
      r(s.initPlugins().then(() => s.ui.init(Zu(t) ? t : null)).then(() => s.data.init(s.config.get("initialData"))).then(() => s.fire("ready")).then(() => s));
    });
  }
}
function wD(e) {
  return Zu(e) ? sP(e) : e;
}
function Zu(e) {
  return Er(e);
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class AD extends Mt {
  /**
  * @inheritDoc
  */
  constructor(n) {
    super(n), this.affectsData = !1;
  }
  /**
  * @inheritDoc
  */
  execute() {
    const n = this.editor.model, t = n.document.selection;
    let i = n.schema.getLimitElement(t);
    if (t.containsEntireContent(i) || !Vg(n.schema, i))
      do
        if (i = i.parent, !i)
          return;
      while (!Vg(n.schema, i));
    n.change((r) => {
      r.setSelection(i, "in");
    });
  }
}
function Vg(e, n) {
  return e.isLimit(n) && (e.checkChild(n, "$text") || e.checkChild(n, "paragraph"));
}
const CD = /* @__PURE__ */ $f("Ctrl+A");
class kD extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "SelectAllEditing";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = n.t, r = n.editing.view.document;
    n.commands.add("selectAll", new AD(n)), this.listenTo(r, "keydown", (s, o) => {
      Zs(o) === CD && (n.execute("selectAll"), o.preventDefault());
    }), n.accessibility.addKeystrokeInfos({
      keystrokes: [
        {
          label: t("Select all"),
          keystroke: "CTRL+A"
        }
      ]
    });
  }
}
var SD = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>';
class ID extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "SelectAllUI";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor;
    n.ui.componentFactory.add("selectAll", () => {
      const t = this._createButton(gt);
      return t.set({
        tooltip: !0
      }), t;
    }), n.ui.componentFactory.add("menuBar:selectAll", () => this._createButton(Dn));
  }
  /**
  * Creates a button for select all command to use either in toolbar or in menu bar.
  */
  _createButton(n) {
    const t = this.editor, i = t.locale, r = t.commands.get("selectAll"), s = new n(t.locale), o = i.t;
    return s.set({
      label: o("Select all"),
      icon: SD,
      keystroke: "Ctrl+A"
    }), s.bind("isEnabled").to(r, "isEnabled"), this.listenTo(s, "execute", () => {
      t.execute("selectAll"), t.editing.view.focus();
    }), s;
  }
}
class xD extends ce {
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      kD,
      ID
    ];
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "SelectAll";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class Ey extends Mt {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * Stack of items stored by the command. These are pairs of:
    *
    * * {@link module:engine/model/batch~Batch batch} saved by the command,
    * * {@link module:engine/model/selection~Selection selection} state at the moment of saving the batch.
    */
    m(this, "_stack", []);
    /**
    * Stores all batches that were created by this command.
    *
    * @internal
    */
    m(this, "_createdBatches", /* @__PURE__ */ new WeakSet());
    this.refresh(), this._isEnabledBasedOnSelection = !1, this.listenTo(t.data, "set", (i, r) => {
      r[1] = {
        ...r[1]
      };
      const s = r[1];
      s.batchType || (s.batchType = {
        isUndoable: !1
      });
    }, {
      priority: "high"
    }), this.listenTo(t.data, "set", (i, r) => {
      r[1].batchType.isUndoable || this.clearStack();
    });
  }
  /**
  * @inheritDoc
  */
  refresh() {
    this.isEnabled = this._stack.length > 0;
  }
  /**
  * Returns all batches created by this command.
  */
  get createdBatches() {
    return this._createdBatches;
  }
  /**
  * Stores a batch in the command, together with the selection state of the {@link module:engine/model/document~Document document}
  * created by the editor which this command is registered to.
  *
  * @param batch The batch to add.
  */
  addBatch(t) {
    const i = this.editor.model.document.selection, r = {
      ranges: i.hasOwnRange ? Array.from(i.getRanges()) : [],
      isBackward: i.isBackward
    };
    this._stack.push({
      batch: t,
      selection: r
    }), this.refresh();
  }
  /**
  * Removes all items from the stack.
  */
  clearStack() {
    this._stack = [], this.refresh();
  }
  /**
  * Restores the {@link module:engine/model/document~Document#selection document selection} state after a batch was undone.
  *
  * @param ranges Ranges to be restored.
  * @param isBackward A flag describing whether the restored range was selected forward or backward.
  * @param operations Operations which has been applied since selection has been stored.
  */
  _restoreSelection(t, i, r) {
    const s = this.editor.model, o = s.document, a = [], u = t.map((c) => c.getTransformedByOperations(r)), l = u.flat();
    for (const c of u) {
      const d = c.filter((p) => p.root != o.graveyard).filter((p) => !PD(p, l));
      d.length && (vD(d), a.push(d[0]));
    }
    a.length && s.change((c) => {
      c.setSelection(a, {
        backward: i
      });
    });
  }
  /**
  * Undoes a batch by reversing that batch, transforming reversed batch and finally applying it.
  * This is a helper method for {@link #execute}.
  *
  * @param batchToUndo The batch to be undone.
  * @param undoingBatch The batch that will contain undoing changes.
  */
  _undo(t, i) {
    const r = this.editor.model, s = r.document;
    this._createdBatches.add(i);
    const o = t.operations.slice().filter((a) => a.isDocumentOperation);
    o.reverse();
    for (const a of o) {
      const u = a.baseVersion + 1, l = Array.from(s.history.getOperations(u)), d = v6([
        a.getReversed()
      ], l, {
        useRelations: !0,
        document: this.editor.model.document,
        forceWeakRemove: !0
      }).operationsA;
      for (let p of d) {
        const g = p.affectedSelectable;
        g && !r.canEditAt(g) && (p = new Lt(p.baseVersion)), i.addOperation(p), r.applyOperation(p), s.history.setOperationAsUndone(a, p);
      }
    }
  }
}
function vD(e) {
  e.sort((n, t) => n.start.isBefore(t.start) ? -1 : 1);
  for (let n = 1; n < e.length; n++) {
    const i = e[n - 1].getJoined(e[n], !0);
    i && (n--, e.splice(n, 2, i));
  }
}
function PD(e, n) {
  return n.some((t) => t !== e && t.containsRange(e, !0));
}
class OD extends Ey {
  /**
  * Executes the command. This method reverts a {@link module:engine/model/batch~Batch batch} added to the command's stack, transforms
  * and applies the reverted version on the {@link module:engine/model/document~Document document} and removes the batch from the stack.
  * Then, it restores the {@link module:engine/model/document~Document#selection document selection}.
  *
  * @fires execute
  * @fires revert
  * @param batch A batch that should be undone. If not set, the last added batch will be undone.
  */
  execute(n = null) {
    const t = n ? this._stack.findIndex((s) => s.batch == n) : this._stack.length - 1, i = this._stack.splice(t, 1)[0], r = this.editor.model.createBatch({
      isUndo: !0
    });
    this.editor.model.enqueueChange(r, () => {
      this._undo(i.batch, r);
      const s = this.editor.model.document.history.getOperations(i.batch.baseVersion);
      this._restoreSelection(i.selection.ranges, i.selection.isBackward, s);
    }), this.fire("revert", i.batch, r), this.refresh();
  }
}
class ND extends Ey {
  /**
  * Executes the command. This method reverts the last {@link module:engine/model/batch~Batch batch} added to
  * the command's stack, applies the reverted and transformed version on the
  * {@link module:engine/model/document~Document document} and removes the batch from the stack.
  * Then, it restores the {@link module:engine/model/document~Document#selection document selection}.
  *
  * @fires execute
  */
  execute() {
    const n = this._stack.pop(), t = this.editor.model.createBatch({
      isUndo: !0
    });
    this.editor.model.enqueueChange(t, () => {
      const r = n.batch.operations[n.batch.operations.length - 1].baseVersion + 1, s = this.editor.model.document.history.getOperations(r);
      this._restoreSelection(n.selection.ranges, n.selection.isBackward, s), this._undo(n.batch, t);
    }), this.refresh();
  }
}
class RD extends ce {
  constructor() {
    super(...arguments);
    /**
    * The command that manages the undo {@link module:engine/model/batch~Batch batches} stack (history).
    * Created and registered during the {@link #init feature initialization}.
    */
    m(this, "_undoCommand");
    /**
    * The command that manages the redo {@link module:engine/model/batch~Batch batches} stack (history).
    * Created and registered during the {@link #init feature initialization}.
    */
    m(this, "_redoCommand");
    /**
    * Keeps track of which batches were registered in undo.
    */
    m(this, "_batchRegistry", /* @__PURE__ */ new WeakSet());
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "UndoEditing";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const t = this.editor, i = t.t;
    this._undoCommand = new OD(t), this._redoCommand = new ND(t), t.commands.add("undo", this._undoCommand), t.commands.add("redo", this._redoCommand), this.listenTo(t.model, "applyOperation", (r, s) => {
      const o = s[0];
      if (!o.isDocumentOperation)
        return;
      const a = o.batch, u = this._redoCommand.createdBatches.has(a), l = this._undoCommand.createdBatches.has(a);
      this._batchRegistry.has(a) || (this._batchRegistry.add(a), a.isUndoable && (u ? this._undoCommand.addBatch(a) : l || (this._undoCommand.addBatch(a), this._redoCommand.clearStack())));
    }, {
      priority: "highest"
    }), this.listenTo(this._undoCommand, "revert", (r, s, o) => {
      this._redoCommand.addBatch(o);
    }), t.keystrokes.set("CTRL+Z", "undo"), t.keystrokes.set("CTRL+Y", "redo"), t.keystrokes.set("CTRL+SHIFT+Z", "redo"), t.accessibility.addKeystrokeInfos({
      keystrokes: [
        {
          label: i("Undo"),
          keystroke: "CTRL+Z"
        },
        {
          label: i("Redo"),
          keystroke: [
            [
              "CTRL+Y"
            ],
            [
              "CTRL+SHIFT+Z"
            ]
          ]
        }
      ]
    });
  }
}
class LD extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "UndoUI";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = n.locale, i = n.t, r = t.uiLanguageDirection == "ltr" ? Ge.undo : Ge.redo, s = t.uiLanguageDirection == "ltr" ? Ge.redo : Ge.undo;
    this._addButtonsToFactory("undo", i("Undo"), "CTRL+Z", r), this._addButtonsToFactory("redo", i("Redo"), "CTRL+Y", s);
  }
  /**
  * Creates a button for the specified command.
  *
  * @param name Command name.
  * @param label Button label.
  * @param keystroke Command keystroke.
  * @param Icon Source of the icon.
  */
  _addButtonsToFactory(n, t, i, r) {
    const s = this.editor;
    s.ui.componentFactory.add(n, () => {
      const o = this._createButton(gt, n, t, i, r);
      return o.set({
        tooltip: !0
      }), o;
    }), s.ui.componentFactory.add("menuBar:" + n, () => this._createButton(Dn, n, t, i, r));
  }
  /**
  * TODO
  */
  _createButton(n, t, i, r, s) {
    const o = this.editor, a = o.locale, u = o.commands.get(t), l = new n(a);
    return l.set({
      label: i,
      icon: s,
      keystroke: r
    }), l.bind("isEnabled").to(u, "isEnabled"), this.listenTo(l, "execute", () => {
      o.execute(t), o.editing.view.focus();
    }), l;
  }
}
class DD extends ce {
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      RD,
      LD
    ];
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Undo";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class MD extends ce {
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      D5,
      _D,
      cc,
      xD,
      ML,
      gL,
      DD
    ];
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Essentials";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class BD extends Mt {
  constructor(n) {
    super(n), this._isEnabledBasedOnSelection = !1;
  }
  /**
  * @inheritDoc
  */
  refresh() {
    const n = this.editor.model, t = n.document, i = zn(t.selection.getSelectedBlocks());
    this.value = !!i && i.is("element", "paragraph"), this.isEnabled = !!i && $g(i, n.schema);
  }
  /**
  * Executes the command. All the blocks (see {@link module:engine/model/schema~Schema}) in the selection
  * will be turned to paragraphs.
  *
  * @fires execute
  * @param options Options for the executed command.
  * @param options.selection The selection that the command should be applied to. By default,
  * if not provided, the command is applied to the {@link module:engine/model/document~Document#selection}.
  */
  execute(n = {}) {
    const t = this.editor.model, i = t.document, r = n.selection || i.selection;
    t.canEditAt(r) && t.change((s) => {
      const o = r.getSelectedBlocks();
      for (const a of o)
        !a.is("element", "paragraph") && $g(a, t.schema) && s.rename(a, "paragraph");
    });
  }
}
function $g(e, n) {
  return n.checkChild(e.parent, "paragraph") && !n.isObject(e);
}
class FD extends Mt {
  constructor(n) {
    super(n), this._isEnabledBasedOnSelection = !1;
  }
  /**
  * Executes the command.
  *
  * @param options Options for the executed command.
  * @param options.position The model position at which the new paragraph will be inserted.
  * @param options.attributes Attributes keys and values to set on a inserted paragraph.
  * @fires execute
  */
  execute(n) {
    const t = this.editor.model, i = n.attributes;
    let r = n.position;
    return t.canEditAt(r) ? t.change((s) => {
      if (r = this._findPositionToInsertParagraph(r, s), !r)
        return null;
      const o = s.createElement("paragraph");
      return i && t.schema.setAllowedAttributes(o, i, s), t.insertContent(o, r), s.setSelection(o, "in"), s.createPositionAt(o, 0);
    }) : null;
  }
  /**
  * Returns the best position to insert a new paragraph.
  */
  _findPositionToInsertParagraph(n, t) {
    const i = this.editor.model;
    if (i.schema.checkChild(n, "paragraph"))
      return n;
    const r = i.schema.findAllowedParent(n, "paragraph");
    if (!r)
      return null;
    const s = n.parent, o = i.schema.checkChild(s, "$text");
    return s.isEmpty || o && n.isAtEnd ? i.createPositionAfter(s) : !s.isEmpty && o && n.isAtStart ? i.createPositionBefore(s) : t.split(n, r).position;
  }
}
const jl = class jl extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Paragraph";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = n.model;
    n.commands.add("paragraph", new BD(n)), n.commands.add("insertParagraph", new FD(n)), t.schema.register("paragraph", {
      inheritAllFrom: "$block"
    }), n.conversion.elementToElement({
      model: "paragraph",
      view: "p"
    }), n.conversion.for("upcast").elementToElement({
      model: (i, { writer: r }) => !jl.paragraphLikeElements.has(i.name) || i.isEmpty ? null : r.createElement("paragraph"),
      view: /.+/,
      converterPriority: "low"
    });
  }
};
/**
* A list of element names which should be treated by the autoparagraphing algorithms as
* paragraph-like. This means that e.g. the following content:
*
* ```html
* <h1>Foo</h1>
* <table>
*   <tr>
*     <td>X</td>
*     <td>
*       <ul>
*         <li>Y</li>
*         <li>Z</li>
*       </ul>
*     </td>
*   </tr>
* </table>
* ```
*
* contains five paragraph-like elements: `<h1>`, two `<td>`s and two `<li>`s.
* Hence, if none of the features is going to convert those elements the above content will be automatically handled
* by the paragraph feature and converted to:
*
* ```html
* <p>Foo</p>
* <p>X</p>
* <p>Y</p>
* <p>Z</p>
* ```
*
* Note: The `<td>` containing two `<li>` elements was ignored as the innermost paragraph-like elements
* have a priority upon conversion.
*/
m(jl, "paragraphLikeElements", /* @__PURE__ */ new Set([
  "blockquote",
  "dd",
  "div",
  "dt",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "li",
  "p",
  "td",
  "th"
]));
let Il = jl;
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class UD extends Mt {
  /**
  * Creates an instance of the command.
  *
  * @param editor Editor instance.
  * @param modelElements Names of the element which this command can apply in the model.
  */
  constructor(t, i) {
    super(t);
    /**
    * Set of defined model's elements names that this command support.
    * See {@link module:heading/headingconfig~HeadingOption}.
    */
    m(this, "modelElements");
    this.modelElements = i;
  }
  /**
  * @inheritDoc
  */
  refresh() {
    const t = zn(this.editor.model.document.selection.getSelectedBlocks());
    this.value = !!t && this.modelElements.includes(t.name) && t.name, this.isEnabled = !!t && this.modelElements.some((i) => Wg(t, i, this.editor.model.schema));
  }
  /**
  * Executes the command. Applies the heading to the selected blocks or, if the first selected
  * block is a heading already, turns selected headings (of this level only) to paragraphs.
  *
  * @param options.value Name of the element which this command will apply in the model.
  * @fires execute
  */
  execute(t) {
    const i = this.editor.model, r = i.document, s = t.value;
    i.change((o) => {
      const a = Array.from(r.selection.getSelectedBlocks()).filter((u) => Wg(u, s, i.schema));
      for (const u of a)
        u.is("element", s) || o.rename(u, s);
    });
  }
}
function Wg(e, n, t) {
  return t.checkChild(e.parent, n) && !t.isObject(e);
}
const zg = "paragraph";
class HD extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "HeadingEditing";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  constructor(n) {
    super(n), n.config.define("heading", {
      options: [
        {
          model: "paragraph",
          title: "Paragraph",
          class: "ck-heading_paragraph"
        },
        {
          model: "heading1",
          view: "h2",
          title: "Heading 1",
          class: "ck-heading_heading1"
        },
        {
          model: "heading2",
          view: "h3",
          title: "Heading 2",
          class: "ck-heading_heading2"
        },
        {
          model: "heading3",
          view: "h4",
          title: "Heading 3",
          class: "ck-heading_heading3"
        }
      ]
    });
  }
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      Il
    ];
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = n.config.get("heading.options"), i = [];
    for (const r of t)
      r.model !== "paragraph" && (n.model.schema.register(r.model, {
        inheritAllFrom: "$block"
      }), n.conversion.elementToElement(r), i.push(r.model));
    this._addDefaultH1Conversion(n), n.commands.add("heading", new UD(n, i));
  }
  /**
  * @inheritDoc
  */
  afterInit() {
    const n = this.editor, t = n.commands.get("enter"), i = n.config.get("heading.options");
    t && this.listenTo(t, "afterExecute", (r, s) => {
      const o = n.model.document.selection.getFirstPosition().parent;
      i.some((u) => o.is("element", u.model)) && !o.is("element", zg) && o.childCount === 0 && s.writer.rename(o, zg);
    });
  }
  /**
  * Adds default conversion for `h1` -> `heading1` with a low priority.
  *
  * @param editor Editor instance on which to add the `h1` conversion.
  */
  _addDefaultH1Conversion(n) {
    n.conversion.for("upcast").elementToElement({
      model: "heading1",
      view: "h1",
      // With a `low` priority, `paragraph` plugin autoparagraphing mechanism is executed. Make sure
      // this listener is called before it. If not, `h1` will be transformed into a paragraph.
      converterPriority: pr.low + 1
    });
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function VD(e) {
  const n = e.t, t = {
    Paragraph: n("Paragraph"),
    "Heading 1": n("Heading 1"),
    "Heading 2": n("Heading 2"),
    "Heading 3": n("Heading 3"),
    "Heading 4": n("Heading 4"),
    "Heading 5": n("Heading 5"),
    "Heading 6": n("Heading 6")
  };
  return e.config.get("heading.options").map((i) => {
    const r = t[i.title];
    return r && r != i.title && (i.title = r), i;
  });
}
class $D extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "HeadingUI";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = n.t, i = VD(n), r = t("Choose heading"), s = t("Heading");
    n.ui.componentFactory.add("heading", (o) => {
      const a = {}, u = new Qi(), l = n.commands.get("heading"), c = n.commands.get("paragraph"), d = [
        l
      ];
      for (const g of i) {
        const b = {
          type: "button",
          model: new H4({
            label: g.title,
            class: g.class,
            role: "menuitemradio",
            withText: !0
          })
        };
        g.model === "paragraph" ? (b.model.bind("isOn").to(c, "value"), b.model.set("commandName", "paragraph"), d.push(c)) : (b.model.bind("isOn").to(l, "value", (_) => _ === g.model), b.model.set({
          commandName: "heading",
          commandValue: g.model
        })), u.add(b), a[g.model] = g.title;
      }
      const p = ac(o);
      return e4(p, u, {
        ariaLabel: s,
        role: "menu"
      }), p.buttonView.set({
        ariaLabel: s,
        ariaLabelledBy: void 0,
        isOn: !1,
        withText: !0,
        tooltip: s
      }), p.extendTemplate({
        attributes: {
          class: [
            "ck-heading-dropdown"
          ]
        }
      }), p.bind("isEnabled").toMany(d, "isEnabled", (...g) => g.some((b) => b)), p.buttonView.bind("label").to(l, "value", c, "value", (g, b) => {
        const _ = b ? "paragraph" : g;
        return typeof _ == "boolean" || !a[_] ? r : a[_];
      }), p.buttonView.bind("ariaLabel").to(l, "value", c, "value", (g, b) => {
        const _ = b ? "paragraph" : g;
        return typeof _ == "boolean" || !a[_] ? s : `${a[_]}, ${s}`;
      }), this.listenTo(p, "execute", (g) => {
        const { commandName: b, commandValue: _ } = g.source;
        n.execute(b, _ ? {
          value: _
        } : void 0), n.editing.view.focus();
      }), p;
    }), n.ui.componentFactory.add("menuBar:heading", (o) => {
      const a = new Jr(o), u = n.commands.get("heading"), l = n.commands.get("paragraph"), c = [
        u
      ], d = new Sl(o);
      a.set({
        class: "ck-heading-dropdown"
      }), d.set({
        ariaLabel: t("Heading"),
        role: "menu"
      }), a.buttonView.set({
        label: t("Heading")
      }), a.panelView.children.add(d);
      for (const p of i) {
        const g = new uc(o, a), b = new Dn(o);
        g.children.add(b), d.items.add(g), b.set({
          isToggleable: !0,
          label: p.title,
          role: "menuitemradio",
          class: p.class
        }), b.delegate("execute").to(a), b.on("execute", () => {
          const _ = p.model === "paragraph" ? "paragraph" : "heading";
          n.execute(_, {
            value: p.model
          }), n.editing.view.focus();
        }), p.model === "paragraph" ? (b.bind("isOn").to(l, "value"), c.push(l)) : b.bind("isOn").to(u, "value", (_) => _ === p.model);
      }
      return a.bind("isEnabled").toMany(c, "isEnabled", (...p) => p.some((g) => g)), a;
    });
  }
}
class WD extends ce {
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      HD,
      $D
    ];
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Heading";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class zD {
  constructor() {
    /**
    * Stores the definition of {@link module:link/linkconfig~LinkDecoratorAutomaticDefinition automatic decorators}.
    * This data is used as a source for a downcast dispatcher to create a proper conversion to output data.
    */
    m(this, "_definitions", /* @__PURE__ */ new Set());
  }
  /**
  * Gives information about the number of decorators stored in the {@link module:link/utils/automaticdecorators~AutomaticDecorators}
  * instance.
  */
  get length() {
    return this._definitions.size;
  }
  /**
  * Adds automatic decorator objects or an array with them to be used during downcasting.
  *
  * @param item A configuration object of automatic rules for decorating links. It might also be an array of such objects.
  */
  add(n) {
    Array.isArray(n) ? n.forEach((t) => this._definitions.add(t)) : this._definitions.add(n);
  }
  /**
  * Provides the conversion helper used in the {@link module:engine/conversion/downcasthelpers~DowncastHelpers#add} method.
  *
  * @returns A dispatcher function used as conversion helper in {@link module:engine/conversion/downcasthelpers~DowncastHelpers#add}.
  */
  getDispatcher() {
    return (n) => {
      n.on("attribute:linkHref", (t, i, r) => {
        if (!r.consumable.test(i.item, "attribute:linkHref") || !(i.item.is("selection") || r.schema.isInline(i.item)))
          return;
        const s = r.writer, o = s.document.selection;
        for (const a of this._definitions) {
          const u = s.createAttributeElement("a", a.attributes, {
            priority: 5
          });
          a.classes && s.addClass(a.classes, u);
          for (const l in a.styles)
            s.setStyle(l, a.styles[l], u);
          s.setCustomProperty("link", !0, u), a.callback(i.attributeNewValue) ? i.item.is("selection") ? s.wrap(o.getFirstRange(), u) : s.wrap(r.mapper.toViewRange(i.range), u) : s.unwrap(r.mapper.toViewRange(i.range), u);
        }
      }, {
        priority: "high"
      });
    };
  }
  /**
  * Provides the conversion helper used in the {@link module:engine/conversion/downcasthelpers~DowncastHelpers#add} method
  * when linking images.
  *
  * @returns A dispatcher function used as conversion helper in {@link module:engine/conversion/downcasthelpers~DowncastHelpers#add}.
  */
  getDispatcherForLinkedImage() {
    return (n) => {
      n.on("attribute:linkHref:imageBlock", (t, i, { writer: r, mapper: s }) => {
        const o = s.toViewElement(i.item), a = Array.from(o.getChildren()).find((u) => u.is("element", "a"));
        if (a)
          for (const u of this._definitions) {
            const l = Si(u.attributes);
            if (u.callback(i.attributeNewValue)) {
              for (const [c, d] of l)
                c === "class" ? r.addClass(d, a) : r.setAttribute(c, d, a);
              u.classes && r.addClass(u.classes, a);
              for (const c in u.styles)
                r.setStyle(c, u.styles[c], a);
            } else {
              for (const [c, d] of l)
                c === "class" ? r.removeClass(d, a) : r.removeAttribute(c, a);
              u.classes && r.removeClass(u.classes, a);
              for (const c in u.styles)
                r.removeStyle(c, a);
            }
          }
      });
    };
  }
}
const qD = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g, YD = "^(?:(?:<protocols>):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))", jD = /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i, KD = /^((\w+:(\/{2,})?)|(\W))/i, GD = [
  "https?",
  "ftps?",
  "mailto"
], Du = "Ctrl+K";
function QD(e) {
  return e.is("attributeElement") && !!e.getCustomProperty("link");
}
function qg(e, { writer: n }) {
  const t = n.createAttributeElement("a", {
    href: e
  }, {
    priority: 5
  });
  return n.setCustomProperty("link", !0, t), t;
}
function Ty(e, n = GD) {
  const t = String(e), i = n.join("|"), r = new RegExp(`${YD.replace("<protocols>", i)}`, "i");
  return XD(t, r) ? t : "#";
}
function XD(e, n) {
  return !!e.replace(qD, "").match(n);
}
function JD(e, n) {
  const t = {
    "Open in a new tab": e("Open in a new tab"),
    Downloadable: e("Downloadable")
  };
  return n.forEach((i) => ("label" in i && t[i.label] && (i.label = t[i.label]), i)), n;
}
function ZD(e) {
  const n = [];
  if (e)
    for (const [t, i] of Object.entries(e)) {
      const r = Object.assign({}, i, {
        id: `link${FI(t)}`
      });
      n.push(r);
    }
  return n;
}
function Wh(e, n) {
  return e ? n.checkAttribute(e.name, "linkHref") : !1;
}
function eM(e) {
  return jD.test(e);
}
function fm(e, n) {
  const t = eM(e) ? "mailto:" : n, i = !!t && !yy(e);
  return e && i ? t + e : e;
}
function yy(e) {
  return KD.test(e);
}
function wy(e) {
  window.open(e, "_blank", "noopener");
}
function Ay(e) {
  const n = e.plugins.has("BookmarkEditing") ? e.plugins.get("BookmarkEditing") : null;
  function t(r) {
    return !!r && r.startsWith("#") && !!n && !!n.getElementForBookmarkId(r.slice(1));
  }
  function i(r) {
    const s = r.slice(1), o = n.getElementForBookmarkId(s);
    e.model.change((a) => {
      a.setSelection(o, "on");
    }), e.editing.view.scrollToTheSelection({
      alignToTop: !0,
      forceScroll: !0
    });
  }
  return {
    isScrollableToTarget: t,
    scrollToTarget: i
  };
}
class tM extends Mt {
  constructor() {
    super(...arguments);
    /**
    * A collection of {@link module:link/utils/manualdecorator~ManualDecorator manual decorators}
    * corresponding to the {@link module:link/linkconfig~LinkConfig#decorators decorator configuration}.
    *
    * You can consider it a model with states of manual decorators added to the currently selected link.
    */
    m(this, "manualDecorators", new Qi());
    /**
    * An instance of the helper that ties together all {@link module:link/linkconfig~LinkDecoratorAutomaticDefinition}
    * that are used by the {@glink features/link link} and the {@glink features/images/images-linking linking images} features.
    */
    m(this, "automaticDecorators", new zD());
  }
  /**
  * Synchronizes the state of {@link #manualDecorators} with the currently present elements in the model.
  */
  restoreManualDecoratorStates() {
    for (const t of this.manualDecorators)
      t.value = this._getDecoratorStateFromModel(t.id);
  }
  /**
  * @inheritDoc
  */
  refresh() {
    const t = this.editor.model, i = t.document.selection, r = i.getSelectedElement() || zn(i.getSelectedBlocks());
    Wh(r, t.schema) ? (this.value = r.getAttribute("linkHref"), this.isEnabled = t.schema.checkAttribute(r, "linkHref")) : (this.value = i.getAttribute("linkHref"), this.isEnabled = t.schema.checkAttributeInSelection(i, "linkHref"));
    for (const s of this.manualDecorators)
      s.value = this._getDecoratorStateFromModel(s.id);
  }
  /**
  * Executes the command.
  *
  * When the selection is non-collapsed, the `linkHref` attribute will be applied to nodes inside the selection, but only to
  * those nodes where the `linkHref` attribute is allowed (disallowed nodes will be omitted).
  *
  * When the selection is collapsed and is not inside the text with the `linkHref` attribute, a
  * new {@link module:engine/model/text~Text text node} with the `linkHref` attribute will be inserted in place of the caret, but
  * only if such element is allowed in this place. The `_data` of the inserted text will equal the `href` parameter.
  * The selection will be updated to wrap the just inserted text node.
  *
  * When the selection is collapsed and inside the text with the `linkHref` attribute, the attribute value will be updated.
  *
  * # Decorators and model attribute management
  *
  * There is an optional argument to this command that applies or removes model
  * {@glink framework/architecture/editing-engine#text-attributes text attributes} brought by
  * {@link module:link/utils/manualdecorator~ManualDecorator manual link decorators}.
  *
  * Text attribute names in the model correspond to the entries in the {@link module:link/linkconfig~LinkConfig#decorators
  * configuration}.
  * For every decorator configured, a model text attribute exists with the "link" prefix. For example, a `'linkMyDecorator'` attribute
  * corresponds to `'myDecorator'` in the configuration.
  *
  * To learn more about link decorators, check out the {@link module:link/linkconfig~LinkConfig#decorators `config.link.decorators`}
  * documentation.
  *
  * Here is how to manage decorator attributes with the link command:
  *
  * ```ts
  * const linkCommand = editor.commands.get( 'link' );
  *
  * // Adding a new decorator attribute.
  * linkCommand.execute( 'http://example.com', {
  * 	linkIsExternal: true
  * } );
  *
  * // Removing a decorator attribute from the selection.
  * linkCommand.execute( 'http://example.com', {
  * 	linkIsExternal: false
  * } );
  *
  * // Adding multiple decorator attributes at the same time.
  * linkCommand.execute( 'http://example.com', {
  * 	linkIsExternal: true,
  * 	linkIsDownloadable: true,
  * } );
  *
  * // Removing and adding decorator attributes at the same time.
  * linkCommand.execute( 'http://example.com', {
  * 	linkIsExternal: false,
  * 	linkFoo: true,
  * 	linkIsDownloadable: false,
  * } );
  * ```
  *
  * **Note**: If the decorator attribute name is not specified, its state remains untouched.
  *
  * **Note**: {@link module:link/unlinkcommand~UnlinkCommand#execute `UnlinkCommand#execute()`} removes all
  * decorator attributes.
  *
  * @fires execute
  * @param href Link destination.
  * @param manualDecoratorIds The information about manual decorator attributes to be applied or removed upon execution.
  */
  execute(t, i = {}) {
    const r = this.editor.model, s = r.document.selection, o = [], a = [];
    for (const u in i)
      i[u] ? o.push(u) : a.push(u);
    r.change((u) => {
      if (s.isCollapsed) {
        const l = s.getFirstPosition();
        if (s.hasAttribute("linkHref")) {
          const c = Yg(s);
          let d = lc(l, "linkHref", s.getAttribute("linkHref"), r);
          s.getAttribute("linkHref") === c && (d = this._updateLinkContent(r, u, d, t)), u.setAttribute("linkHref", t, d), o.forEach((p) => {
            u.setAttribute(p, !0, d);
          }), a.forEach((p) => {
            u.removeAttribute(p, d);
          }), u.setSelection(u.createPositionAfter(d.end.nodeBefore));
        } else if (t !== "") {
          const c = Si(s.getAttributes());
          c.set("linkHref", t), o.forEach((p) => {
            c.set(p, !0);
          });
          const { end: d } = r.insertContent(u.createText(t, c), l);
          u.setSelection(d);
        }
        [
          "linkHref",
          ...o,
          ...a
        ].forEach((c) => {
          u.removeSelectionAttribute(c);
        });
      } else {
        const l = r.schema.getValidRanges(s.getRanges(), "linkHref"), c = [];
        for (const p of s.getSelectedBlocks())
          r.schema.checkAttribute(p, "linkHref") && c.push(u.createRangeOn(p));
        const d = c.slice();
        for (const p of l)
          this._isRangeToUpdate(p, c) && d.push(p);
        for (const p of d) {
          let g = p;
          if (d.length === 1) {
            const b = Yg(s);
            s.getAttribute("linkHref") === b && (g = this._updateLinkContent(r, u, p, t), u.setSelection(u.createSelection(g)));
          }
          u.setAttribute("linkHref", t, g), o.forEach((b) => {
            u.setAttribute(b, !0, g);
          }), a.forEach((b) => {
            u.removeAttribute(b, g);
          });
        }
      }
    });
  }
  /**
  * Provides information whether a decorator with a given name is present in the currently processed selection.
  *
  * @param decoratorName The name of the manual decorator used in the model
  * @returns The information whether a given decorator is currently present in the selection.
  */
  _getDecoratorStateFromModel(t) {
    const i = this.editor.model, r = i.document.selection, s = r.getSelectedElement();
    return Wh(s, i.schema) ? s.getAttribute(t) : r.getAttribute(t);
  }
  /**
  * Checks whether specified `range` is inside an element that accepts the `linkHref` attribute.
  *
  * @param range A range to check.
  * @param allowedRanges An array of ranges created on elements where the attribute is accepted.
  */
  _isRangeToUpdate(t, i) {
    for (const r of i)
      if (r.containsRange(t))
        return !1;
    return !0;
  }
  /**
  * Updates selected link with a new value as its content and as its href attribute.
  *
  * @param model Model is need to insert content.
  * @param writer Writer is need to create text element in model.
  * @param range A range where should be inserted content.
  * @param href A link value which should be in the href attribute and in the content.
  */
  _updateLinkContent(t, i, r, s) {
    const o = i.createText(s, {
      linkHref: s
    });
    return t.insertContent(o, r);
  }
}
function Yg(e) {
  if (e.isCollapsed) {
    const n = e.getFirstPosition();
    return n.textNode && n.textNode.data;
  } else {
    const n = Array.from(e.getFirstRange().getItems());
    if (n.length > 1)
      return null;
    const t = n[0];
    return t.is("$text") || t.is("$textProxy") ? t.data : null;
  }
}
class nM extends Mt {
  /**
  * @inheritDoc
  */
  refresh() {
    const n = this.editor.model, t = n.document.selection, i = t.getSelectedElement();
    Wh(i, n.schema) ? this.isEnabled = n.schema.checkAttribute(i, "linkHref") : this.isEnabled = n.schema.checkAttributeInSelection(t, "linkHref");
  }
  /**
  * Executes the command.
  *
  * When the selection is collapsed, it removes the `linkHref` attribute from each node with the same `linkHref` attribute value.
  * When the selection is non-collapsed, it removes the `linkHref` attribute from each node in selected ranges.
  *
  * # Decorators
  *
  * If {@link module:link/linkconfig~LinkConfig#decorators `config.link.decorators`} is specified,
  * all configured decorators are removed together with the `linkHref` attribute.
  *
  * @fires execute
  */
  execute() {
    const n = this.editor, t = this.editor.model, i = t.document.selection, r = n.commands.get("link");
    t.change((s) => {
      const o = i.isCollapsed ? [
        lc(i.getFirstPosition(), "linkHref", i.getAttribute("linkHref"), t)
      ] : t.schema.getValidRanges(i.getRanges(), "linkHref");
      for (const a of o)
        if (s.removeAttribute("linkHref", a), r)
          for (const u of r.manualDecorators)
            s.removeAttribute(u.id, a);
    });
  }
}
class iM extends (/* @__PURE__ */ pt()) {
  /**
  * Creates a new instance of {@link module:link/utils/manualdecorator~ManualDecorator}.
  *
  * @param config.id The name of the attribute used in the model that represents a given manual decorator.
  * For example: `'linkIsExternal'`.
  * @param config.label The label used in the user interface to toggle the manual decorator.
  * @param config.attributes A set of attributes added to output data when the decorator is active for a specific link.
  * Attributes should keep the format of attributes defined in {@link module:engine/view/elementdefinition~ElementDefinition}.
  * @param [config.defaultValue] Controls whether the decorator is "on" by default.
  */
  constructor({ id: t, label: i, attributes: r, classes: s, styles: o, defaultValue: a }) {
    super();
    /**
    * An ID of a manual decorator which is the name of the attribute in the model, for example: 'linkManualDecorator0'.
    */
    m(this, "id");
    /**
    * The default value of manual decorator.
    */
    m(this, "defaultValue");
    /**
    * The label used in the user interface to toggle the manual decorator.
    */
    m(this, "label");
    /**
    * A set of attributes added to downcasted data when the decorator is activated for a specific link.
    * Attributes should be added in a form of attributes defined in {@link module:engine/view/elementdefinition~ElementDefinition}.
    */
    m(this, "attributes");
    /**
    * A set of classes added to downcasted data when the decorator is activated for a specific link.
    * Classes should be added in a form of classes defined in {@link module:engine/view/elementdefinition~ElementDefinition}.
    */
    m(this, "classes");
    /**
    * A set of styles added to downcasted data when the decorator is activated for a specific link.
    * Styles should be added in a form of styles defined in {@link module:engine/view/elementdefinition~ElementDefinition}.
    */
    m(this, "styles");
    this.id = t, this.set("value", void 0), this.defaultValue = a, this.label = i, this.attributes = r, this.classes = s, this.styles = o;
  }
  /**
  * Returns {@link module:engine/view/matcher~MatcherPattern} with decorator attributes.
  *
  * @internal
  */
  _createPattern() {
    return {
      attributes: this.attributes,
      classes: this.classes,
      styles: this.styles
    };
  }
}
const rM = "ck-link_selected", jg = "automatic", sM = "manual", oM = /^(https?:)?\/\//;
class Cy extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "LinkEditing";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      Ag,
      ay,
      is
    ];
  }
  /**
  * @inheritDoc
  */
  constructor(n) {
    super(n), n.config.define("link", {
      allowCreatingEmptyLinks: !1,
      addTargetToExternalLinks: !1
    });
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = this.editor.config.get("link.allowedProtocols");
    n.model.schema.extend("$text", {
      allowAttributes: "linkHref"
    }), n.conversion.for("dataDowncast").attributeToElement({
      model: "linkHref",
      view: qg
    }), n.conversion.for("editingDowncast").attributeToElement({
      model: "linkHref",
      view: (s, o) => qg(Ty(s, t), o)
    }), n.conversion.for("upcast").elementToAttribute({
      view: {
        name: "a",
        attributes: {
          href: !0
        }
      },
      model: {
        key: "linkHref",
        value: (s) => s.getAttribute("href")
      }
    }), n.commands.add("link", new tM(n)), n.commands.add("unlink", new nM(n));
    const i = JD(n.t, ZD(n.config.get("link.decorators")));
    this._enableAutomaticDecorators(i.filter((s) => s.mode === jg)), this._enableManualDecorators(i.filter((s) => s.mode === sM)), n.plugins.get(Ag).registerAttribute("linkHref"), bL(n, "linkHref", "a", rM), this._enableLinkOpen(), this._enableSelectionAttributesFixer(), this._enableClipboardIntegration();
  }
  /**
  * Processes an array of configured {@link module:link/linkconfig~LinkDecoratorAutomaticDefinition automatic decorators}
  * and registers a {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher downcast dispatcher}
  * for each one of them. Downcast dispatchers are obtained using the
  * {@link module:link/utils/automaticdecorators~AutomaticDecorators#getDispatcher} method.
  *
  * **Note**: This method also activates the automatic external link decorator if enabled with
  * {@link module:link/linkconfig~LinkConfig#addTargetToExternalLinks `config.link.addTargetToExternalLinks`}.
  */
  _enableAutomaticDecorators(n) {
    const t = this.editor, r = t.commands.get("link").automaticDecorators;
    t.config.get("link.addTargetToExternalLinks") && r.add({
      id: "linkIsExternal",
      mode: jg,
      callback: (s) => !!s && oM.test(s),
      attributes: {
        target: "_blank",
        rel: "noopener noreferrer"
      }
    }), r.add(n), r.length && t.conversion.for("downcast").add(r.getDispatcher());
  }
  /**
  * Processes an array of configured {@link module:link/linkconfig~LinkDecoratorManualDefinition manual decorators},
  * transforms them into {@link module:link/utils/manualdecorator~ManualDecorator} instances and stores them in the
  * {@link module:link/linkcommand~LinkCommand#manualDecorators} collection (a model for manual decorators state).
  *
  * Also registers an {@link module:engine/conversion/downcasthelpers~DowncastHelpers#attributeToElement attribute-to-element}
  * converter for each manual decorator and extends the {@link module:engine/model/schema~Schema model's schema}
  * with adequate model attributes.
  */
  _enableManualDecorators(n) {
    if (!n.length)
      return;
    const t = this.editor, r = t.commands.get("link").manualDecorators;
    n.forEach((s) => {
      t.model.schema.extend("$text", {
        allowAttributes: s.id
      });
      const o = new iM(s);
      r.add(o), t.conversion.for("downcast").attributeToElement({
        model: o.id,
        view: (a, { writer: u, schema: l }, { item: c }) => {
          if ((c.is("selection") || l.isInline(c)) && a) {
            const d = u.createAttributeElement("a", o.attributes, {
              priority: 5
            });
            o.classes && u.addClass(o.classes, d);
            for (const p in o.styles)
              u.setStyle(p, o.styles[p], d);
            return u.setCustomProperty("link", !0, d), d;
          }
        }
      }), t.conversion.for("upcast").elementToAttribute({
        view: {
          name: "a",
          ...o._createPattern()
        },
        model: {
          key: o.id
        }
      });
    });
  }
  /**
  * Attaches handlers for {@link module:engine/view/document~Document#event:enter} and
  * {@link module:engine/view/document~Document#event:click} to enable link following.
  */
  _enableLinkOpen() {
    const n = this.editor, i = n.editing.view.document, r = Ay(n);
    function s(o) {
      r.isScrollableToTarget(o) ? r.scrollToTarget(o) : wy(o);
    }
    this.listenTo(i, "click", (o, a) => {
      if (!(he.isMac ? a.domEvent.metaKey : a.domEvent.ctrlKey))
        return;
      let l = a.domTarget;
      if (l.tagName.toLowerCase() != "a" && (l = l.closest("a")), !l)
        return;
      const c = l.getAttribute("href");
      c && (o.stop(), a.preventDefault(), s(c));
    }, {
      context: "$capture"
    }), this.listenTo(i, "keydown", (o, a) => {
      const l = n.commands.get("link").value;
      l && a.keyCode === ye.enter && a.altKey && (o.stop(), s(l));
    });
  }
  /**
  * Watches the DocumentSelection attribute changes and removes link decorator attributes when the linkHref attribute is removed.
  *
  * This is to ensure that there is no left-over link decorator attributes on the document selection that is no longer in a link.
  */
  _enableSelectionAttributesFixer() {
    const t = this.editor.model, i = t.document.selection;
    this.listenTo(i, "change:attribute", (r, { attributeKeys: s }) => {
      !s.includes("linkHref") || i.hasAttribute("linkHref") || t.change((o) => {
        aM(o, uM(t.schema));
      });
    });
  }
  /**
  * Enables URL fixing on pasting.
  */
  _enableClipboardIntegration() {
    const n = this.editor, t = n.model, i = this.editor.config.get("link.defaultProtocol");
    i && this.listenTo(n.plugins.get("ClipboardPipeline"), "contentInsertion", (r, s) => {
      t.change((o) => {
        const a = o.createRangeIn(s.content);
        for (const u of a.getItems())
          if (u.hasAttribute("linkHref")) {
            const l = fm(u.getAttribute("linkHref"), i);
            o.setAttribute("linkHref", l, u);
          }
      });
    });
  }
}
function aM(e, n) {
  e.removeSelectionAttribute("linkHref");
  for (const t of n)
    e.removeSelectionAttribute(t);
}
function uM(e) {
  return e.getDefinition("$text").allowAttributes.filter((t) => t.startsWith("link"));
}
class lM extends me {
  /**
  * Creates an instance of the {@link module:link/ui/linkformview~LinkFormView} class.
  *
  * Also see {@link #render}.
  *
  * @param locale The localization services instance.
  * @param linkCommand Reference to {@link module:link/linkcommand~LinkCommand}.
  * @param validators  Form validators used by {@link #isValid}.
  */
  constructor(t, i, r) {
    super(t);
    /**
    * Tracks information about DOM focus in the form.
    */
    m(this, "focusTracker", new Ln());
    /**
    * An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
    */
    m(this, "keystrokes", new Ii());
    /**
    * The URL input view.
    */
    m(this, "urlInputView");
    /**
    * The Save button view.
    */
    m(this, "saveButtonView");
    /**
    * The Cancel button view.
    */
    m(this, "cancelButtonView");
    /**
    * A collection of {@link module:ui/button/switchbuttonview~SwitchButtonView},
    * which corresponds to {@link module:link/linkcommand~LinkCommand#manualDecorators manual decorators}
    * configured in the editor.
    */
    m(this, "_manualDecoratorSwitches");
    /**
    * A collection of child views in the form.
    */
    m(this, "children");
    /**
    * An array of form validators used by {@link #isValid}.
    */
    m(this, "_validators");
    /**
    * A collection of views that can be focused in the form.
    */
    m(this, "_focusables", new Ji());
    /**
    * Helps cycling over {@link #_focusables} in the form.
    */
    m(this, "_focusCycler");
    const s = t.t;
    this._validators = r, this.urlInputView = this._createUrlInput(), this.saveButtonView = this._createButton(s("Save"), Ge.check, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(s("Cancel"), Ge.cancel, "ck-button-cancel", "cancel"), this._manualDecoratorSwitches = this._createManualDecoratorSwitches(i), this.children = this._createFormChildren(i.manualDecorators), this._focusCycler = new hs({
      focusables: this._focusables,
      focusTracker: this.focusTracker,
      keystrokeHandler: this.keystrokes,
      actions: {
        // Navigate form fields backwards using the Shift + Tab keystroke.
        focusPrevious: "shift + tab",
        // Navigate form fields forwards using the Tab key.
        focusNext: "tab"
      }
    });
    const o = [
      "ck",
      "ck-link-form",
      "ck-responsive-form"
    ];
    i.manualDecorators.length && o.push("ck-link-form_layout-vertical", "ck-vertical-form"), this.setTemplate({
      tag: "form",
      attributes: {
        class: o,
        // https://github.com/ckeditor/ckeditor5-link/issues/90
        tabindex: "-1"
      },
      children: this.children
    });
  }
  /**
  * Obtains the state of the {@link module:ui/button/switchbuttonview~SwitchButtonView switch buttons} representing
  * {@link module:link/linkcommand~LinkCommand#manualDecorators manual link decorators}
  * in the {@link module:link/ui/linkformview~LinkFormView}.
  *
  * @returns Key-value pairs, where the key is the name of the decorator and the value is its state.
  */
  getDecoratorSwitchesState() {
    return Array.from(this._manualDecoratorSwitches).reduce((t, i) => (t[i.name] = i.isOn, t), {});
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), k5({
      view: this
    }), [
      this.urlInputView,
      ...this._manualDecoratorSwitches,
      this.saveButtonView,
      this.cancelButtonView
    ].forEach((i) => {
      this._focusables.add(i), this.focusTracker.add(i.element);
    }), this.keystrokes.listenTo(this.element);
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
  }
  /**
  * Focuses the fist {@link #_focusables} in the form.
  */
  focus() {
    this._focusCycler.focusFirst();
  }
  /**
  * Validates the form and returns `false` when some fields are invalid.
  */
  isValid() {
    this.resetFormStatus();
    for (const t of this._validators) {
      const i = t(this);
      if (i)
        return this.urlInputView.errorText = i, !1;
    }
    return !0;
  }
  /**
  * Cleans up the supplementary error and information text of the {@link #urlInputView}
  * bringing them back to the state when the form has been displayed for the first time.
  *
  * See {@link #isValid}.
  */
  resetFormStatus() {
    this.urlInputView.errorText = null;
  }
  /**
  * Creates a labeled input view.
  *
  * @returns Labeled field view instance.
  */
  _createUrlInput() {
    const t = this.locale.t, i = new U5(this.locale, u4);
    return i.fieldView.inputMode = "url", i.label = t("Link URL"), i;
  }
  /**
  * Creates a button view.
  *
  * @param label The button label.
  * @param icon The button icon.
  * @param className The additional button CSS class name.
  * @param eventName An event name that the `ButtonView#execute` event will be delegated to.
  * @returns The button view instance.
  */
  _createButton(t, i, r, s) {
    const o = new gt(this.locale);
    return o.set({
      label: t,
      icon: i,
      tooltip: !0
    }), o.extendTemplate({
      attributes: {
        class: r
      }
    }), s && o.delegate("execute").to(this, s), o;
  }
  /**
  * Populates {@link module:ui/viewcollection~ViewCollection} of {@link module:ui/button/switchbuttonview~SwitchButtonView}
  * made based on {@link module:link/linkcommand~LinkCommand#manualDecorators}.
  *
  * @param linkCommand A reference to the link command.
  * @returns ViewCollection of switch buttons.
  */
  _createManualDecoratorSwitches(t) {
    const i = this.createCollection();
    for (const r of t.manualDecorators) {
      const s = new sm(this.locale);
      s.set({
        name: r.id,
        label: r.label,
        withText: !0
      }), s.bind("isOn").toMany([
        r,
        t
      ], "value", (o, a) => a === void 0 && o === void 0 ? !!r.defaultValue : !!o), s.on("execute", () => {
        r.set("value", !s.isOn);
      }), i.add(s);
    }
    return i;
  }
  /**
  * Populates the {@link #children} collection of the form.
  *
  * If {@link module:link/linkcommand~LinkCommand#manualDecorators manual decorators} are configured in the editor, it creates an
  * additional `View` wrapping all {@link #_manualDecoratorSwitches} switch buttons corresponding
  * to these decorators.
  *
  * @param manualDecorators A reference to
  * the collection of manual decorators stored in the link command.
  * @returns The children of link form view.
  */
  _createFormChildren(t) {
    const i = this.createCollection();
    if (i.add(this.urlInputView), t.length) {
      const r = new me();
      r.setTemplate({
        tag: "ul",
        children: this._manualDecoratorSwitches.map((s) => ({
          tag: "li",
          children: [
            s
          ],
          attributes: {
            class: [
              "ck",
              "ck-list__item"
            ]
          }
        })),
        attributes: {
          class: [
            "ck",
            "ck-reset",
            "ck-list"
          ]
        }
      }), i.add(r);
    }
    return i.add(this.saveButtonView), i.add(this.cancelButtonView), i;
  }
  /**
  * The native DOM `value` of the {@link #urlInputView} element.
  *
  * **Note**: Do not confuse it with the {@link module:ui/inputtext/inputtextview~InputTextView#value}
  * which works one way only and may not represent the actual state of the component in the DOM.
  */
  get url() {
    const { element: t } = this.urlInputView.fieldView;
    return t ? t.value.trim() : null;
  }
}
var cM = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>';
class dM extends me {
  /**
  * @inheritDoc
  */
  constructor(t, i = {}, r) {
    super(t);
    /**
    * Tracks information about DOM focus in the actions.
    */
    m(this, "focusTracker", new Ln());
    /**
    * An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
    */
    m(this, "keystrokes", new Ii());
    /**
    * The href preview view.
    */
    m(this, "previewButtonView");
    /**
    * The unlink button view.
    */
    m(this, "unlinkButtonView");
    /**
    * The edit link button view.
    */
    m(this, "editButtonView");
    /**
    * A collection of views that can be focused in the view.
    */
    m(this, "_focusables", new Ji());
    /**
    * Helps cycling over {@link #_focusables} in the view.
    */
    m(this, "_focusCycler");
    m(this, "_linkConfig");
    m(this, "_options");
    const s = t.t;
    this._options = r, this.previewButtonView = this._createPreviewButton(), this.unlinkButtonView = this._createButton(s("Unlink"), cM, "unlink"), this.editButtonView = this._createButton(s("Edit link"), Ge.pencil, "edit"), this.set("href", void 0), this._linkConfig = i, this._focusCycler = new hs({
      focusables: this._focusables,
      focusTracker: this.focusTracker,
      keystrokeHandler: this.keystrokes,
      actions: {
        // Navigate fields backwards using the Shift + Tab keystroke.
        focusPrevious: "shift + tab",
        // Navigate fields forwards using the Tab key.
        focusNext: "tab"
      }
    }), this.setTemplate({
      tag: "div",
      attributes: {
        class: [
          "ck",
          "ck-link-actions",
          "ck-responsive-form"
        ],
        // https://github.com/ckeditor/ckeditor5-link/issues/90
        tabindex: "-1"
      },
      children: [
        this.previewButtonView,
        this.editButtonView,
        this.unlinkButtonView
      ]
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), [
      this.previewButtonView,
      this.editButtonView,
      this.unlinkButtonView
    ].forEach((i) => {
      this._focusables.add(i), this.focusTracker.add(i.element);
    }), this.keystrokes.listenTo(this.element);
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
  }
  /**
  * Focuses the fist {@link #_focusables} in the actions.
  */
  focus() {
    this._focusCycler.focusFirst();
  }
  /**
  * Creates a button view.
  *
  * @param label The button label.
  * @param icon The button icon.
  * @param eventName An event name that the `ButtonView#execute` event will be delegated to.
  * @returns The button view instance.
  */
  _createButton(t, i, r) {
    const s = new gt(this.locale);
    return s.set({
      label: t,
      icon: i,
      tooltip: !0
    }), s.delegate("execute").to(this, r), s;
  }
  /**
  * Creates a link href preview button.
  *
  * @returns The button view instance.
  */
  _createPreviewButton() {
    const t = new gt(this.locale), i = this.bindTemplate, r = this.t;
    return t.set({
      withText: !0
    }), t.extendTemplate({
      attributes: {
        class: [
          "ck",
          "ck-link-actions__preview"
        ],
        href: i.to("href", (s) => s && Ty(s, this._linkConfig.allowedProtocols)),
        target: "_blank",
        rel: "noopener noreferrer"
      },
      on: {
        click: i.to((s) => {
          this._options && this._options.isScrollableToTarget(this.href) ? (s.preventDefault(), this._options.scrollToTarget(this.href)) : wy(this.href);
        })
      }
    }), t.bind("tooltip").to(this, "href", (s) => this._options && this._options.isScrollableToTarget(s) ? r("Scroll to target") : r("Open link in new tab")), t.bind("label").to(this, "href", (s) => s || r("This link has no URL")), t.bind("isEnabled").to(this, "href", (s) => !!s), t.template.tag = "a", t;
  }
}
var hM = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>';
const pi = "link-ui";
class fM extends ce {
  constructor() {
    super(...arguments);
    /**
    * The actions view displayed inside of the balloon.
    */
    m(this, "actionsView", null);
    /**
    * The form view displayed inside the balloon.
    */
    m(this, "formView", null);
    /**
    * The contextual balloon plugin instance.
    */
    m(this, "_balloon");
  }
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      kl
    ];
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "LinkUI";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const t = this.editor, i = this.editor.t;
    t.editing.view.addObserver(fR), this._balloon = t.plugins.get(kl), this._createToolbarLinkButton(), this._enableBalloonActivators(), t.conversion.for("editingDowncast").markerToHighlight({
      model: pi,
      view: {
        classes: [
          "ck-fake-link-selection"
        ]
      }
    }), t.conversion.for("editingDowncast").markerToElement({
      model: pi,
      view: (r, { writer: s }) => {
        if (!r.markerRange.isCollapsed)
          return null;
        const o = s.createUIElement("span");
        return s.addClass([
          "ck-fake-link-selection",
          "ck-fake-link-selection_collapsed"
        ], o), o;
      }
    }), t.accessibility.addKeystrokeInfos({
      keystrokes: [
        {
          label: i("Create link"),
          keystroke: Du
        },
        {
          label: i("Move out of a link"),
          keystroke: [
            [
              "arrowleft",
              "arrowleft"
            ],
            [
              "arrowright",
              "arrowright"
            ]
          ]
        }
      ]
    });
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy(), this.formView && this.formView.destroy(), this.actionsView && this.actionsView.destroy();
  }
  /**
  * Creates views.
  */
  _createViews() {
    this.actionsView = this._createActionsView(), this.formView = this._createFormView(), this._enableUserBalloonInteractions();
  }
  /**
  * Creates the {@link module:link/ui/linkactionsview~LinkActionsView} instance.
  */
  _createActionsView() {
    const t = this.editor, i = new dM(t.locale, t.config.get("link"), Ay(t)), r = t.commands.get("link"), s = t.commands.get("unlink");
    return i.bind("href").to(r, "value"), i.editButtonView.bind("isEnabled").to(r), i.unlinkButtonView.bind("isEnabled").to(s), this.listenTo(i, "edit", () => {
      this._addFormView();
    }), this.listenTo(i, "unlink", () => {
      t.execute("unlink"), this._hideUI();
    }), i.keystrokes.set("Esc", (o, a) => {
      this._hideUI(), a();
    }), i.keystrokes.set(Du, (o, a) => {
      this._addFormView(), a();
    }), i;
  }
  /**
  * Creates the {@link module:link/ui/linkformview~LinkFormView} instance.
  */
  _createFormView() {
    const t = this.editor, i = t.commands.get("link"), r = t.config.get("link.defaultProtocol"), s = new (C5(lM))(t.locale, i, mM(t));
    return s.urlInputView.fieldView.bind("value").to(i, "value"), s.urlInputView.bind("isEnabled").to(i, "isEnabled"), s.saveButtonView.bind("isEnabled").to(i, "isEnabled"), this.listenTo(s, "submit", () => {
      if (s.isValid()) {
        const { value: o } = s.urlInputView.fieldView.element, a = fm(o, r);
        t.execute("link", a, s.getDecoratorSwitchesState()), this._closeFormView();
      }
    }), this.listenTo(s.urlInputView, "change:errorText", () => {
      t.ui.update();
    }), this.listenTo(s, "cancel", () => {
      this._closeFormView();
    }), s.keystrokes.set("Esc", (o, a) => {
      this._closeFormView(), a();
    }), s;
  }
  /**
  * Creates a toolbar Link button. Clicking this button will show
  * a {@link #_balloon} attached to the selection.
  */
  _createToolbarLinkButton() {
    const t = this.editor;
    t.ui.componentFactory.add("link", () => {
      const i = this._createButton(gt);
      return i.set({
        tooltip: !0
      }), i;
    }), t.ui.componentFactory.add("menuBar:link", () => {
      const i = this._createButton(Dn);
      return i.set({
        role: "menuitemcheckbox"
      }), i;
    });
  }
  /**
  * Creates a button for link command to use either in toolbar or in menu bar.
  */
  _createButton(t) {
    const i = this.editor, r = i.locale, s = i.commands.get("link"), o = new t(i.locale), a = r.t;
    return o.set({
      label: a("Link"),
      icon: hM,
      keystroke: Du,
      isToggleable: !0
    }), o.bind("isEnabled").to(s, "isEnabled"), o.bind("isOn").to(s, "value", (u) => !!u), this.listenTo(o, "execute", () => this._showUI(!0)), o;
  }
  /**
  * Attaches actions that control whether the balloon panel containing the
  * {@link #formView} should be displayed.
  */
  _enableBalloonActivators() {
    const t = this.editor, i = t.editing.view.document;
    this.listenTo(i, "click", () => {
      this._getSelectedLinkElement() && this._showUI();
    }), t.keystrokes.set(Du, (r, s) => {
      s(), t.commands.get("link").isEnabled && this._showUI(!0);
    });
  }
  /**
  * Attaches actions that control whether the balloon panel containing the
  * {@link #formView} is visible or not.
  */
  _enableUserBalloonInteractions() {
    this.editor.keystrokes.set("Tab", (t, i) => {
      this._areActionsVisible && !this.actionsView.focusTracker.isFocused && (this.actionsView.focus(), i());
    }, {
      // Use the high priority because the link UI navigation is more important
      // than other feature's actions, e.g. list indentation.
      // https://github.com/ckeditor/ckeditor5-link/issues/146
      priority: "high"
    }), this.editor.keystrokes.set("Esc", (t, i) => {
      this._isUIVisible && (this._hideUI(), i());
    }), rc({
      emitter: this.formView,
      activator: () => this._isUIInPanel,
      contextElements: () => [
        this._balloon.view.element
      ],
      callback: () => this._hideUI()
    });
  }
  /**
  * Adds the {@link #actionsView} to the {@link #_balloon}.
  *
  * @internal
  */
  _addActionsView() {
    this.actionsView || this._createViews(), !this._areActionsInPanel && this._balloon.add({
      view: this.actionsView,
      position: this._getBalloonPositionData()
    });
  }
  /**
  * Adds the {@link #formView} to the {@link #_balloon}.
  */
  _addFormView() {
    if (this.formView || this._createViews(), this._isFormInPanel)
      return;
    const i = this.editor.commands.get("link");
    this.formView.disableCssTransitions(), this.formView.resetFormStatus(), this._balloon.add({
      view: this.formView,
      position: this._getBalloonPositionData()
    }), this.formView.urlInputView.fieldView.value = i.value || "", this._balloon.visibleView === this.formView && this.formView.urlInputView.fieldView.select(), this.formView.enableCssTransitions();
  }
  /**
  * Closes the form view. Decides whether the balloon should be hidden completely or if the action view should be shown. This is
  * decided upon the link command value (which has a value if the document selection is in the link).
  *
  * Additionally, if any {@link module:link/linkconfig~LinkConfig#decorators} are defined in the editor configuration, the state of
  * switch buttons responsible for manual decorator handling is restored.
  */
  _closeFormView() {
    const t = this.editor.commands.get("link");
    t.restoreManualDecoratorStates(), t.value !== void 0 ? this._removeFormView() : this._hideUI();
  }
  /**
  * Removes the {@link #formView} from the {@link #_balloon}.
  */
  _removeFormView() {
    this._isFormInPanel && (this.formView.saveButtonView.focus(), this.formView.urlInputView.fieldView.reset(), this._balloon.remove(this.formView), this.editor.editing.view.focus(), this._hideFakeVisualSelection());
  }
  /**
  * Shows the correct UI type. It is either {@link #formView} or {@link #actionsView}.
  *
  * @internal
  */
  _showUI(t = !1) {
    this.formView || this._createViews(), this._getSelectedLinkElement() ? (this._areActionsVisible ? this._addFormView() : this._addActionsView(), t && this._balloon.showStack("main")) : (this._showFakeVisualSelection(), this._addActionsView(), t && this._balloon.showStack("main"), this._addFormView()), this._startUpdatingUI();
  }
  /**
  * Removes the {@link #formView} from the {@link #_balloon}.
  *
  * See {@link #_addFormView}, {@link #_addActionsView}.
  */
  _hideUI() {
    if (!this._isUIInPanel)
      return;
    const t = this.editor;
    this.stopListening(t.ui, "update"), this.stopListening(this._balloon, "change:visibleView"), t.editing.view.focus(), this._removeFormView(), this._balloon.remove(this.actionsView), this._hideFakeVisualSelection();
  }
  /**
  * Makes the UI react to the {@link module:ui/editorui/editorui~EditorUI#event:update} event to
  * reposition itself when the editor UI should be refreshed.
  *
  * See: {@link #_hideUI} to learn when the UI stops reacting to the `update` event.
  */
  _startUpdatingUI() {
    const t = this.editor, i = t.editing.view.document;
    let r = this._getSelectedLinkElement(), s = a();
    const o = () => {
      const u = this._getSelectedLinkElement(), l = a();
      r && !u || !r && l !== s ? this._hideUI() : this._isUIVisible && this._balloon.updatePosition(this._getBalloonPositionData()), r = u, s = l;
    };
    function a() {
      return i.selection.focus.getAncestors().reverse().find((u) => u.is("element"));
    }
    this.listenTo(t.ui, "update", o), this.listenTo(this._balloon, "change:visibleView", o);
  }
  /**
  * Returns `true` when {@link #formView} is in the {@link #_balloon}.
  */
  get _isFormInPanel() {
    return !!this.formView && this._balloon.hasView(this.formView);
  }
  /**
  * Returns `true` when {@link #actionsView} is in the {@link #_balloon}.
  */
  get _areActionsInPanel() {
    return !!this.actionsView && this._balloon.hasView(this.actionsView);
  }
  /**
  * Returns `true` when {@link #actionsView} is in the {@link #_balloon} and it is
  * currently visible.
  */
  get _areActionsVisible() {
    return !!this.actionsView && this._balloon.visibleView === this.actionsView;
  }
  /**
  * Returns `true` when {@link #actionsView} or {@link #formView} is in the {@link #_balloon}.
  */
  get _isUIInPanel() {
    return this._isFormInPanel || this._areActionsInPanel;
  }
  /**
  * Returns `true` when {@link #actionsView} or {@link #formView} is in the {@link #_balloon} and it is
  * currently visible.
  */
  get _isUIVisible() {
    const t = this._balloon.visibleView;
    return !!this.formView && t == this.formView || this._areActionsVisible;
  }
  /**
  * Returns positioning options for the {@link #_balloon}. They control the way the balloon is attached
  * to the target element or selection.
  *
  * If the selection is collapsed and inside a link element, the panel will be attached to the
  * entire link element. Otherwise, it will be attached to the selection.
  */
  _getBalloonPositionData() {
    const t = this.editor.editing.view, i = this.editor.model, r = t.document;
    let s;
    if (i.markers.has(pi)) {
      const o = Array.from(this.editor.editing.mapper.markerNameToElements(pi)), a = t.createRange(t.createPositionBefore(o[0]), t.createPositionAfter(o[o.length - 1]));
      s = t.domConverter.viewRangeToDom(a);
    } else
      s = () => {
        const o = this._getSelectedLinkElement();
        return o ? (
          // When selection is inside link element, then attach panel to this element.
          t.domConverter.mapViewToDom(o)
        ) : (
          // Otherwise attach panel to the selection.
          t.domConverter.viewRangeToDom(r.selection.getFirstRange())
        );
      };
    return {
      target: s
    };
  }
  /**
  * Returns the link {@link module:engine/view/attributeelement~AttributeElement} under
  * the {@link module:engine/view/document~Document editing view's} selection or `null`
  * if there is none.
  *
  * **Note**: For a non–collapsed selection, the link element is returned when **fully**
  * selected and the **only** element within the selection boundaries, or when
  * a linked widget is selected.
  */
  _getSelectedLinkElement() {
    const t = this.editor.editing.view, i = t.document.selection, r = i.getSelectedElement();
    if (i.isCollapsed || r && Rt(r))
      return kd(i.getFirstPosition());
    {
      const s = i.getFirstRange().getTrimmed(), o = kd(s.start), a = kd(s.end);
      return !o || o != a ? null : t.createRangeIn(o).getTrimmed().isEqual(s) ? o : null;
    }
  }
  /**
  * Displays a fake visual selection when the contextual balloon is displayed.
  *
  * This adds a 'link-ui' marker into the document that is rendered as a highlight on selected text fragment.
  */
  _showFakeVisualSelection() {
    const t = this.editor.model;
    t.change((i) => {
      const r = t.document.selection.getFirstRange();
      if (t.markers.has(pi))
        i.updateMarker(pi, {
          range: r
        });
      else if (r.start.isAtEnd) {
        const s = r.start.getLastMatchingPosition(({ item: o }) => !t.schema.isContent(o), {
          boundaries: r
        });
        i.addMarker(pi, {
          usingOperation: !1,
          affectsData: !1,
          range: i.createRange(s, r.end)
        });
      } else
        i.addMarker(pi, {
          usingOperation: !1,
          affectsData: !1,
          range: r
        });
    });
  }
  /**
  * Hides the fake visual selection created in {@link #_showFakeVisualSelection}.
  */
  _hideFakeVisualSelection() {
    const t = this.editor.model;
    t.markers.has(pi) && t.change((i) => {
      i.removeMarker(pi);
    });
  }
}
function kd(e) {
  return e.getAncestors().find((n) => QD(n)) || null;
}
function mM(e) {
  const n = e.t, t = e.config.get("link.allowCreatingEmptyLinks");
  return [
    (i) => {
      if (!t && !i.url.length)
        return n("Link URL must not be empty.");
    }
  ];
}
const pM = 4, ky = new RegExp(
  // Group 1: Line start or after a space.
  "(^|\\s)(((?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(((?!www\\.)|(www\\.))(?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.)+(?:[a-z\\u00a1-\\uffff]{2,63})))(?::\\d{2,5})?(?:[/?#]\\S*)?)|((www.|(\\S+@))((?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.))+(?:[a-z\\u00a1-\\uffff]{2,63})))$",
  "i"
), gM = 2;
class bM extends ce {
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      fs,
      Cy
    ];
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "AutoLink";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const t = this.editor.model.document.selection;
    t.on("change:range", () => {
      this.isEnabled = !t.anchor.parent.is("element", "codeBlock");
    }), this._enableTypingHandling();
  }
  /**
  * @inheritDoc
  */
  afterInit() {
    this._enableEnterHandling(), this._enableShiftEnterHandling(), this._enablePasteLinking();
  }
  /**
  * For given position, returns a range that includes the whole link that contains the position.
  *
  * If position is not inside a link, returns `null`.
  */
  _expandLinkRange(n, t) {
    return t.textNode && t.textNode.hasAttribute("linkHref") ? lc(t, "linkHref", t.textNode.getAttribute("linkHref"), n) : null;
  }
  /**
  * Extends the document selection to includes all links that intersects with given `selectedRange`.
  */
  _selectEntireLinks(n, t) {
    const r = this.editor.model, s = r.document.selection, o = s.getFirstPosition(), a = s.getLastPosition();
    let u = t.getJoined(this._expandLinkRange(r, o) || t);
    u && (u = u.getJoined(this._expandLinkRange(r, a) || t)), u && (u.start.isBefore(o) || u.end.isAfter(a)) && n.setSelection(u);
  }
  /**
  * Enables autolinking on pasting a URL when some content is selected.
  */
  _enablePasteLinking() {
    const n = this.editor, t = n.model, i = t.document.selection, r = n.plugins.get("ClipboardPipeline"), s = n.commands.get("link");
    r.on("inputTransformation", (o, a) => {
      if (!this.isEnabled || !s.isEnabled || i.isCollapsed || a.method !== "paste" || i.rangeCount > 1)
        return;
      const u = i.getFirstRange(), l = a.dataTransfer.getData("text/plain");
      if (!l)
        return;
      const c = l.match(ky);
      c && c[2] === l && (t.change((d) => {
        this._selectEntireLinks(d, u), s.execute(l);
      }), o.stop());
    }, {
      priority: "high"
    });
  }
  /**
  * Enables autolinking on typing.
  */
  _enableTypingHandling() {
    const n = this.editor, t = new cy(n.model, (i) => {
      let r = i;
      if (!_M(r))
        return;
      r = r.slice(0, -1), "!.:,;?".includes(r[r.length - 1]) && (r = r.slice(0, -1));
      const s = Kg(r);
      if (s)
        return {
          url: s,
          removedTrailingCharacters: i.length - r.length
        };
    });
    t.on("matched:data", (i, r) => {
      const { batch: s, range: o, url: a, removedTrailingCharacters: u } = r;
      if (!s.isTyping)
        return;
      const l = o.end.getShiftedBy(-u), c = l.getShiftedBy(-a.length), d = n.model.createRange(c, l);
      this._applyAutoLink(a, d);
    }), t.bind("isEnabled").to(this);
  }
  /**
  * Enables autolinking on the <kbd>Enter</kbd> key.
  */
  _enableEnterHandling() {
    const n = this.editor, t = n.model, i = n.commands.get("enter");
    i && i.on("execute", () => {
      const r = t.document.selection.getFirstPosition();
      if (!r.parent.previousSibling)
        return;
      const s = t.createRangeIn(r.parent.previousSibling);
      this._checkAndApplyAutoLinkOnRange(s);
    });
  }
  /**
  * Enables autolinking on the <kbd>Shift</kbd>+<kbd>Enter</kbd> keyboard shortcut.
  */
  _enableShiftEnterHandling() {
    const n = this.editor, t = n.model, i = n.commands.get("shiftEnter");
    i && i.on("execute", () => {
      const r = t.document.selection.getFirstPosition(), s = t.createRange(t.createPositionAt(r.parent, 0), r.getShiftedBy(-1));
      this._checkAndApplyAutoLinkOnRange(s);
    });
  }
  /**
  * Checks if the passed range contains a linkable text.
  */
  _checkAndApplyAutoLinkOnRange(n) {
    const t = this.editor.model, { text: i, range: r } = ly(n, t), s = Kg(i);
    if (s) {
      const o = t.createRange(r.end.getShiftedBy(-s.length), r.end);
      this._applyAutoLink(s, o);
    }
  }
  /**
  * Applies a link on a given range if the link should be applied.
  *
  * @param url The URL to link.
  * @param range The text range to apply the link attribute to.
  */
  _applyAutoLink(n, t) {
    const i = this.editor.model, r = this.editor.config.get("link.defaultProtocol"), s = fm(n, r);
    !this.isEnabled || !EM(t, i) || !yy(s) || TM(t) || this._persistAutoLink(s, t);
  }
  /**
  * Enqueues autolink changes in the model.
  *
  * @param url The URL to link.
  * @param range The text range to apply the link attribute to.
  */
  _persistAutoLink(n, t) {
    const i = this.editor.model, r = this.editor.plugins.get("Delete");
    i.enqueueChange((s) => {
      s.setAttribute("linkHref", n, t), i.enqueueChange(() => {
        r.requestUndoOnBackspace();
      });
    });
  }
}
function _M(e) {
  return e.length > pM && e[e.length - 1] === " " && e[e.length - 2] !== " ";
}
function Kg(e) {
  const n = ky.exec(e);
  return n ? n[gM] : null;
}
function EM(e, n) {
  return n.schema.checkAttributeInSelection(n.createSelection(e), "linkHref");
}
function TM(e) {
  const n = e.start.nodeAfter;
  return !!n && n.hasAttribute("linkHref");
}
class yM extends ce {
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      Cy,
      fM,
      bM
    ];
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Link";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
class qn {
  /**
  * Creates a document list iterator.
  *
  * @param startElement The start list item block element.
  * @param options.direction The iterating direction.
  * @param options.includeSelf Whether start block should be included in the result (if it's matching other criteria).
  * @param options.sameAttributes Additional attributes that must be the same for each block.
  * @param options.sameIndent Whether blocks with the same indent level as the start block should be included
  * in the result.
  * @param options.lowerIndent Whether blocks with a lower indent level than the start block should be included
  * in the result.
  * @param options.higherIndent Whether blocks with a higher indent level than the start block should be included
  * in the result.
  */
  constructor(n, t) {
    /**
    * The start list item block element.
    */
    m(this, "_startElement");
    /**
    * The reference indent. Initialized by the indent of the start block.
    */
    m(this, "_referenceIndent");
    /**
    * The iterating direction.
    */
    m(this, "_isForward");
    /**
    * Whether start block should be included in the result (if it's matching other criteria).
    */
    m(this, "_includeSelf");
    /**
    * Additional attributes that must be the same for each block.
    */
    m(this, "_sameAttributes");
    /**
    * Whether blocks with the same indent level as the start block should be included in the result.
    */
    m(this, "_sameIndent");
    /**
    * Whether blocks with a lower indent level than the start block should be included in the result.
    */
    m(this, "_lowerIndent");
    /**
    * Whether blocks with a higher indent level than the start block should be included in the result.
    */
    m(this, "_higherIndent");
    this._startElement = n, this._referenceIndent = n.getAttribute("listIndent"), this._isForward = t.direction == "forward", this._includeSelf = !!t.includeSelf, this._sameAttributes = Dt(t.sameAttributes || []), this._sameIndent = !!t.sameIndent, this._lowerIndent = !!t.lowerIndent, this._higherIndent = !!t.higherIndent;
  }
  /**
  * Performs only first step of iteration and returns the result.
  *
  * @param startElement The start list item block element.
  * @param options.direction The iterating direction.
  * @param options.includeSelf Whether start block should be included in the result (if it's matching other criteria).
  * @param options.sameAttributes Additional attributes that must be the same for each block.
  * @param options.sameIndent Whether blocks with the same indent level as the start block should be included
  * in the result.
  * @param options.lowerIndent Whether blocks with a lower indent level than the start block should be included
  * in the result.
  * @param options.higherIndent Whether blocks with a higher indent level than the start block should be included
  * in the result.
  */
  static first(n, t) {
    const r = new this(n, t)[Symbol.iterator]();
    return zn(r);
  }
  /**
  * Iterable interface.
  */
  *[Symbol.iterator]() {
    const n = [];
    for (const { node: t } of new su(this._getStartNode(), this._isForward ? "forward" : "backward")) {
      const i = t.getAttribute("listIndent");
      if (i < this._referenceIndent) {
        if (!this._lowerIndent)
          break;
        this._referenceIndent = i;
      } else if (i > this._referenceIndent) {
        if (!this._higherIndent)
          continue;
        if (!this._isForward) {
          n.push(t);
          continue;
        }
      } else {
        if (!this._sameIndent) {
          if (this._higherIndent) {
            n.length && (yield* n, n.length = 0);
            break;
          }
          continue;
        }
        if (this._sameAttributes.some((r) => t.getAttribute(r) !== this._startElement.getAttribute(r)))
          break;
      }
      n.length && (yield* n, n.length = 0), yield t;
    }
  }
  /**
  * Returns the model element to start iterating.
  */
  _getStartNode() {
    return this._includeSelf ? this._startElement : this._isForward ? this._startElement.nextSibling : this._startElement.previousSibling;
  }
}
class su {
  /**
  * @param node The model node.
  * @param direction Iteration direction.
  */
  constructor(n, t = "forward") {
    m(this, "_node");
    m(this, "_isForward");
    m(this, "_previousNodesByIndent", []);
    m(this, "_previous", null);
    m(this, "_previousNodeIndent", null);
    this._node = n, this._isForward = t === "forward";
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    if (!Ot(this._node))
      return {
        done: !0,
        value: void 0
      };
    const n = this._node.getAttribute("listIndent");
    let t = null;
    if (this._previous) {
      const r = this._previousNodeIndent;
      n > r ? this._previousNodesByIndent[r] = this._previous : n < r ? (t = this._previousNodesByIndent[n] || null, this._previousNodesByIndent.length = n) : t = this._previous;
    }
    const i = {
      node: this._node,
      previous: this._previous,
      previousNodeInList: t
    };
    return this._previous = this._node, this._previousNodeIndent = n, this._node = this._isForward ? this._node.nextSibling : this._node.previousSibling, {
      value: i,
      done: !1
    };
  }
}
class wM {
  /**
  * @param listHead The head element of a list.
  */
  constructor(n) {
    m(this, "_listHead");
    this._listHead = n;
  }
  /**
  * List blocks iterator.
  *
  * Iterates over all blocks of a list.
  */
  [Symbol.iterator]() {
    return new su(this._listHead);
  }
}
class ro {
  /**
  * Returns the next ID.
  *
  * @internal
  */
  /* istanbul ignore next: static function definition -- @preserve */
  static next() {
    return un();
  }
}
function Ot(e) {
  return !!e && e.is("element") && e.hasAttribute("listItemId");
}
function mm(e, n = {}) {
  return [
    ...wr(e, {
      ...n,
      direction: "backward"
    }),
    ...wr(e, {
      ...n,
      direction: "forward"
    })
  ];
}
function wr(e, n = {}) {
  const t = n.direction == "forward", i = Array.from(new qn(e, {
    ...n,
    includeSelf: t,
    sameIndent: !0,
    sameAttributes: "listItemId"
  }));
  return t ? i : i.reverse();
}
function AM(e) {
  return Array.from(new qn(e, {
    direction: "forward",
    higherIndent: !0
  }));
}
function Sy(e, n) {
  const t = new qn(e, {
    sameIndent: !0,
    sameAttributes: "listType",
    ...n
  }), i = new qn(e, {
    sameIndent: !0,
    sameAttributes: "listType",
    includeSelf: !0,
    direction: "forward",
    ...n
  });
  return [
    ...Array.from(t).reverse(),
    ...i
  ];
}
function rs(e) {
  return !qn.first(e, {
    sameIndent: !0,
    sameAttributes: "listItemId"
  });
}
function Gg(e) {
  return !qn.first(e, {
    direction: "forward",
    sameIndent: !0,
    sameAttributes: "listItemId"
  });
}
function ou(e, n = {}) {
  e = Dt(e);
  const t = n.withNested !== !1, i = /* @__PURE__ */ new Set();
  for (const r of e)
    for (const s of mm(r, {
      higherIndent: t
    }))
      i.add(s);
  return ms(i);
}
function CM(e) {
  e = Dt(e);
  const n = /* @__PURE__ */ new Set();
  for (const t of e)
    for (const i of Sy(t))
      n.add(i);
  return ms(n);
}
function pm(e, n) {
  const t = wr(e, {
    direction: "forward"
  }), i = ro.next();
  for (const r of t)
    n.setAttribute("listItemId", i, r);
  return t;
}
function zh(e, n, t) {
  const i = {};
  for (const [s, o] of n.getAttributes())
    s.startsWith("list") && (i[s] = o);
  const r = wr(e, {
    direction: "forward"
  });
  for (const s of r)
    t.setAttributes(i, s);
  return r;
}
function qh(e, n, { expand: t, indentBy: i = 1 } = {}) {
  e = Dt(e);
  const r = t ? ou(e) : e;
  for (const s of r) {
    const o = s.getAttribute("listIndent") + i;
    o < 0 ? dc(s, n) : n.setAttribute("listIndent", o, s);
  }
  return r;
}
function kM(e, n) {
  e = Dt(e);
  const t = ou(e), i = /* @__PURE__ */ new Set(), r = Math.min(...t.map((o) => o.getAttribute("listIndent"))), s = /* @__PURE__ */ new Map();
  for (const o of t)
    s.set(o, qn.first(o, {
      lowerIndent: !0
    }));
  for (const o of t) {
    if (i.has(o))
      continue;
    i.add(o);
    const a = o.getAttribute("listIndent") - 1;
    if (a < 0) {
      dc(o, n);
      continue;
    }
    if (o.getAttribute("listIndent") == r) {
      const u = xM(o, s.get(o), n);
      for (const l of u)
        i.add(l);
      if (u.length)
        continue;
    }
    n.setAttribute("listIndent", a, o);
  }
  return ms(i);
}
function dc(e, n) {
  e = Dt(e);
  for (const t of e)
    t.is("element", "listItem") && n.rename(t, "paragraph");
  for (const t of e)
    for (const i of t.getAttributeKeys())
      i.startsWith("list") && n.removeAttribute(i, t);
  return e;
}
function $a(e) {
  if (!e.length)
    return !1;
  const n = e[0].getAttribute("listItemId");
  return n ? !e.some((t) => t.getAttribute("listItemId") != n) : !1;
}
function SM(e, n) {
  const t = [];
  let i = Number.POSITIVE_INFINITY;
  for (const { node: r } of new su(e.nextSibling)) {
    const s = r.getAttribute("listIndent");
    if (s == 0)
      break;
    s < i && (i = s);
    const o = s - i;
    n.setAttribute("listIndent", o, r), t.push(r);
  }
  return t;
}
function ms(e) {
  return Array.from(e).filter((n) => n.root.rootName !== "$graveyard").sort((n, t) => n.index - t.index);
}
function Wa(e) {
  const n = e.document.selection.getSelectedElement();
  return n && e.schema.isObject(n) && e.schema.isBlock(n) ? n : null;
}
function Sd(e, n) {
  return n.checkChild(e.parent, "listItem") && n.checkChild(e, "$text") && !n.isObject(e);
}
function IM(e) {
  return e == "numbered" || e == "customNumbered";
}
function xM(e, n, t) {
  return wr(n, {
    direction: "forward"
  }).pop().index > e.index ? zh(e, n, t) : [];
}
class Qg extends Mt {
  /**
  * Creates an instance of the command.
  *
  * @param editor The editor instance.
  * @param indentDirection The direction of indent. If it is equal to `backward`, the command
  * will outdent a list item.
  */
  constructor(t, i) {
    super(t);
    /**
    * Determines by how much the command will change the list item's indent attribute.
    */
    m(this, "_direction");
    this._direction = i;
  }
  /**
  * @inheritDoc
  */
  refresh() {
    this.isEnabled = this._checkEnabled();
  }
  /**
  * Indents or outdents (depending on the {@link #constructor}'s `indentDirection` parameter) selected list items.
  *
  * @fires execute
  * @fires afterExecute
  */
  execute() {
    const t = this.editor.model, i = Xg(t.document.selection);
    t.change((r) => {
      const s = [];
      $a(i) && !rs(i[0]) ? (this._direction == "forward" && s.push(...qh(i, r)), s.push(...pm(i[0], r))) : this._direction == "forward" ? s.push(...qh(i, r, {
        expand: !0
      })) : s.push(...kM(i, r));
      for (const o of s) {
        if (!o.hasAttribute("listType"))
          continue;
        const a = qn.first(o, {
          sameIndent: !0
        });
        a && r.setAttribute("listType", a.getAttribute("listType"), o);
      }
      this._fireAfterExecute(s);
    });
  }
  /**
  * Fires the `afterExecute` event.
  *
  * @param changedBlocks The changed list elements.
  */
  _fireAfterExecute(t) {
    this.fire("afterExecute", ms(new Set(t)));
  }
  /**
  * Checks whether the command can be enabled in the current context.
  *
  * @returns Whether the command should be enabled.
  */
  _checkEnabled() {
    let t = Xg(this.editor.model.document.selection), i = t[0];
    if (!i)
      return !1;
    if (this._direction == "backward" || $a(t) && !rs(t[0]))
      return !0;
    t = ou(t), i = t[0];
    const r = qn.first(i, {
      sameIndent: !0
    });
    return r ? r.getAttribute("listType") == i.getAttribute("listType") : !1;
  }
}
function Xg(e) {
  const n = Array.from(e.getSelectedBlocks()), t = n.findIndex((i) => !Ot(i));
  return t != -1 && (n.length = t), n;
}
class Mu extends Mt {
  /**
  * Creates an instance of the command.
  *
  * @param editor The editor instance.
  * @param type List type that will be handled by this command.
  */
  constructor(t, i, r = {}) {
    super(t);
    /**
    * The type of the list created by the command.
    */
    m(this, "type");
    /**
    * List Walker options that change the range of the list items to be changed when the selection is collapsed within a list item.
    *
    * In a multi-level list, when the selection is collapsed within a list item, instead of changing only the list items of the same list
    * type and current indent level, the entire list structure is changed (all list items at all indent levels of any list type).
    */
    m(this, "_listWalkerOptions");
    this.type = i, this._listWalkerOptions = r.multiLevel ? {
      higherIndent: !0,
      lowerIndent: !0,
      sameAttributes: []
    } : void 0;
  }
  /**
  * @inheritDoc
  */
  refresh() {
    this.value = this._getValue(), this.isEnabled = this._checkEnabled();
  }
  /**
  * Executes the list command.
  *
  * @fires execute
  * @fires afterExecute
  * @param options Command options.
  * @param options.forceValue If set, it will force the command behavior. If `true`, the command will try to convert the
  * selected items and potentially the neighbor elements to the proper list items. If set to `false` it will convert selected elements
  * to paragraphs. If not set, the command will toggle selected elements to list items or paragraphs, depending on the selection.
  * @param options.additionalAttributes Additional attributes that are set for list items when the command is executed.
  */
  execute(t = {}) {
    const i = this.editor.model, r = i.document, s = Wa(i), o = Array.from(r.selection.getSelectedBlocks()).filter((u) => i.schema.checkAttribute(u, "listType") || Sd(u, i.schema)), a = t.forceValue !== void 0 ? !t.forceValue : this.value;
    i.change((u) => {
      if (a) {
        const l = o[o.length - 1], c = wr(l, {
          direction: "forward"
        }), d = [];
        c.length > 1 && d.push(...pm(c[1], u)), d.push(...dc(o, u)), d.push(...SM(l, u)), this._fireAfterExecute(d);
      } else if ((s || r.selection.isCollapsed) && Ot(o[0])) {
        const l = Sy(s || o[0], this._listWalkerOptions);
        for (const c of l)
          u.setAttributes({
            ...t.additionalAttributes,
            listType: this.type
          }, c);
        this._fireAfterExecute(l);
      } else {
        const l = [];
        for (const c of o)
          if (!c.hasAttribute("listType"))
            !c.is("element", "listItem") && Sd(c, i.schema) && u.rename(c, "listItem"), u.setAttributes({
              ...t.additionalAttributes,
              listIndent: 0,
              listItemId: ro.next(),
              listType: this.type
            }, c), l.push(c);
          else
            for (const d of ou(c, {
              withNested: !1
            }))
              d.getAttribute("listType") != this.type && (u.setAttributes({
                ...t.additionalAttributes,
                listType: this.type
              }, d), l.push(d));
        this._fireAfterExecute(l);
      }
    });
  }
  /**
  * Fires the `afterExecute` event.
  *
  * @param changedBlocks The changed list elements.
  */
  _fireAfterExecute(t) {
    this.fire("afterExecute", ms(new Set(t)));
  }
  /**
  * Checks the command's {@link #value}.
  *
  * @returns The current value.
  */
  _getValue() {
    const t = this.editor.model.document.selection, i = Array.from(t.getSelectedBlocks());
    if (!i.length)
      return !1;
    for (const r of i)
      if (r.getAttribute("listType") != this.type)
        return !1;
    return !0;
  }
  /**
  * Checks whether the command can be enabled in the current context.
  *
  * @returns Whether the command should be enabled.
  */
  _checkEnabled() {
    const t = this.editor.model, i = t.schema, r = t.document.selection, s = Array.from(r.getSelectedBlocks());
    if (!s.length)
      return !1;
    if (this.value)
      return !0;
    for (const o of s)
      if (i.checkAttribute(o, "listType") || Sd(o, i))
        return !0;
    return !1;
  }
}
class Jg extends Mt {
  /**
  * Creates an instance of the command.
  *
  * @param editor The editor instance.
  * @param direction Whether list item should be merged before or after the selected block.
  */
  constructor(t, i) {
    super(t);
    /**
    * Whether list item should be merged before or after the selected block.
    */
    m(this, "_direction");
    this._direction = i;
  }
  /**
  * @inheritDoc
  */
  refresh() {
    this.isEnabled = this._checkEnabled();
  }
  /**
  * Merges list blocks together (depending on the {@link #constructor}'s `direction` parameter).
  *
  * @fires execute
  * @fires afterExecute
  * @param options Command options.
  * @param options.shouldMergeOnBlocksContentLevel When set `true`, merging will be performed together
  * with {@link module:engine/model/model~Model#deleteContent} to get rid of the inline content in the selection or take advantage
  * of the heuristics in `deleteContent()` that helps convert lists into paragraphs in certain cases.
  */
  execute({ shouldMergeOnBlocksContentLevel: t = !1 } = {}) {
    const i = this.editor.model, r = i.document.selection, s = [];
    i.change((o) => {
      const { firstElement: a, lastElement: u } = this._getMergeSubjectElements(r, t), l = a.getAttribute("listIndent") || 0, c = u.getAttribute("listIndent"), d = u.getAttribute("listItemId");
      if (l != c) {
        const p = AM(u);
        s.push(...qh([
          u,
          ...p
        ], o, {
          indentBy: l - c,
          // If outdenting, the entire sub-tree that follows must be included.
          expand: l < c
        }));
      }
      if (t) {
        let p = r;
        r.isCollapsed && (p = o.createSelection(o.createRange(o.createPositionAt(a, "end"), o.createPositionAt(u, 0)))), i.deleteContent(p, {
          doNotResetEntireContent: r.isCollapsed
        });
        const g = p.getLastPosition().parent, b = g.nextSibling;
        s.push(g), b && b !== u && b.getAttribute("listItemId") == d && s.push(...zh(b, g, o));
      } else
        s.push(...zh(u, a, o));
      this._fireAfterExecute(s);
    });
  }
  /**
  * Fires the `afterExecute` event.
  *
  * @param changedBlocks The changed list elements.
  */
  _fireAfterExecute(t) {
    this.fire("afterExecute", ms(new Set(t)));
  }
  /**
  * Checks whether the command can be enabled in the current context.
  *
  * @returns Whether the command should be enabled.
  */
  _checkEnabled() {
    const t = this.editor.model, i = t.document.selection, r = Wa(t);
    if (i.isCollapsed || r) {
      const s = r || i.getFirstPosition().parent;
      if (!Ot(s))
        return !1;
      const o = this._direction == "backward" ? s.previousSibling : s.nextSibling;
      if (!o || $a([
        s,
        o
      ]))
        return !1;
    } else {
      const s = i.getLastPosition(), o = i.getFirstPosition();
      if (s.parent === o.parent || !Ot(s.parent))
        return !1;
    }
    return !0;
  }
  /**
  * Returns the boundary elements the merge should be executed for. These are not necessarily selection's first
  * and last position parents but sometimes sibling or even further blocks depending on the context.
  *
  * @param selection The selection the merge is executed for.
  * @param shouldMergeOnBlocksContentLevel When `true`, merge is performed together with
  * {@link module:engine/model/model~Model#deleteContent} to remove the inline content within the selection.
  */
  _getMergeSubjectElements(t, i) {
    const r = this.editor.model, s = Wa(r);
    let o, a;
    if (t.isCollapsed || s) {
      const u = s || t.getFirstPosition().parent, l = rs(u);
      this._direction == "backward" ? (a = u, l && !i ? o = qn.first(u, {
        sameIndent: !0,
        lowerIndent: !0
      }) : o = u.previousSibling) : (o = u, a = u.nextSibling);
    } else
      o = t.getFirstPosition().parent, a = t.getLastPosition().parent;
    return {
      firstElement: o,
      lastElement: a
    };
  }
}
class Zg extends Mt {
  /**
  * Creates an instance of the command.
  *
  * @param editor The editor instance.
  * @param direction Whether list item should be split before or after the selected block.
  */
  constructor(t, i) {
    super(t);
    /**
    * Whether list item should be split before or after the selected block.
    */
    m(this, "_direction");
    this._direction = i;
  }
  /**
  * @inheritDoc
  */
  refresh() {
    this.isEnabled = this._checkEnabled();
  }
  /**
  * Splits the list item at the selection.
  *
  * @fires execute
  * @fires afterExecute
  */
  execute() {
    this.editor.model.change((i) => {
      const r = pm(this._getStartBlock(), i);
      this._fireAfterExecute(r);
    });
  }
  /**
  * Fires the `afterExecute` event.
  *
  * @param changedBlocks The changed list elements.
  */
  _fireAfterExecute(t) {
    this.fire("afterExecute", ms(new Set(t)));
  }
  /**
  * Checks whether the command can be enabled in the current context.
  *
  * @returns Whether the command should be enabled.
  */
  _checkEnabled() {
    const t = this.editor.model.document.selection, i = this._getStartBlock();
    return t.isCollapsed && Ot(i) && !rs(i);
  }
  /**
  * Returns the model element that is the main focus of the command (according to the current selection and command direction).
  */
  _getStartBlock() {
    const i = this.editor.model.document.selection.getFirstPosition().parent;
    return this._direction == "before" ? i : i.nextSibling;
  }
}
class vM extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "ListUtils";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * Expands the given list of selected blocks to include all the items of the lists they're in.
  *
  * @param blocks The list of selected blocks.
  */
  expandListBlocksToCompleteList(n) {
    return CM(n);
  }
  /**
  * Check if the given block is the first in the list item.
  *
  * @param listBlock The list block element.
  */
  isFirstBlockOfListItem(n) {
    return rs(n);
  }
  /**
  * Returns true if the given model node is a list item block.
  *
  * @param node A model node.
  */
  isListItemBlock(n) {
    return Ot(n);
  }
  /**
  * Expands the given list of selected blocks to include the leading and tailing blocks of partially selected list items.
  *
  * @param blocks The list of selected blocks.
  * @param options.withNested Whether should include nested list items.
  */
  expandListBlocksToCompleteItems(n, t = {}) {
    return ou(n, t);
  }
  /**
  * Returns true if listType is of type `numbered` or `customNumbered`.
  */
  isNumberedListType(n) {
    return IM(n);
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function PM(e) {
  return e.is("element", "ol") || e.is("element", "ul");
}
function Yh(e) {
  return e.is("element", "li");
}
function OM(e) {
  let n = 0, t = e.parent;
  for (; t; ) {
    if (Yh(t))
      n++;
    else {
      const i = t.previousSibling;
      i && Yh(i) && n++;
    }
    t = t.parent;
  }
  return n;
}
function NM(e, n, t, i = xy(t, n)) {
  return e.createAttributeElement(Iy(t), null, {
    priority: 2 * n / 100 - 100,
    id: i
  });
}
function RM(e, n, t) {
  return e.createAttributeElement("li", null, {
    priority: (2 * n + 1) / 100 - 100,
    id: t
  });
}
function Iy(e) {
  return e == "numbered" || e == "customNumbered" ? "ol" : "ul";
}
function xy(e, n) {
  return `list-${e}-${n}`;
}
function ti(e, n, t) {
  const i = e.nodeBefore;
  if (Ot(i)) {
    let r = i;
    for (const { node: s } of new su(r, "backward"))
      if (r = s, t.has(r) || (t.add(r), n.has(i)))
        return;
    n.add(r);
  } else {
    const r = e.nodeAfter;
    Ot(r) && n.add(r);
  }
}
function LM(e, n) {
  let t = 0, i = -1, r = null, s = !1;
  for (const { node: o } of e) {
    const a = o.getAttribute("listIndent");
    if (a > t) {
      let u;
      r === null ? (r = a - t, u = t) : (r > a && (r = a), u = a - r), u > i + 1 && (u = i + 1), n.setAttribute("listIndent", u, o), s = !0, i = u;
    } else
      r = null, t = a + 1, i = a;
  }
  return s;
}
function DM(e, n, t) {
  const i = /* @__PURE__ */ new Set();
  let r = !1;
  for (const { node: s } of e) {
    if (i.has(s))
      continue;
    let o = s.getAttribute("listType"), a = s.getAttribute("listItemId");
    if (n.has(a) && (a = ro.next()), n.add(a), s.is("element", "listItem")) {
      s.getAttribute("listItemId") != a && (t.setAttribute("listItemId", a, s), r = !0);
      continue;
    }
    for (const u of wr(s, {
      direction: "forward"
    }))
      i.add(u), u.getAttribute("listType") != o && (a = ro.next(), o = u.getAttribute("listType")), u.getAttribute("listItemId") != a && (t.setAttribute("listItemId", a, u), r = !0);
  }
  return r;
}
function MM() {
  return (e, n, t) => {
    const { writer: i, schema: r } = t;
    if (!n.modelRange)
      return;
    const s = Array.from(n.modelRange.getItems({
      shallow: !0
    })).filter((d) => r.checkAttribute(d, "listItemId"));
    if (!s.length)
      return;
    const o = ro.next(), a = OM(n.viewItem);
    let u = n.viewItem.parent && n.viewItem.parent.is("element", "ol") ? "numbered" : "bulleted";
    const l = s[0].getAttribute("listType");
    l && (u = l);
    const c = {
      listItemId: o,
      listIndent: a,
      listType: u
    };
    for (const d of s)
      d.hasAttribute("listItemId") || i.setAttributes(c, d);
    s.length > 1 && s[1].getAttribute("listItemId") != c.listItemId && t.keepEmptyElement(s[0]);
  };
}
function BM(e, n, t, i) {
  return () => {
    const a = e.document.differ.getChanges(), u = [], l = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Set();
    for (const p of a)
      if (p.type == "insert" && p.name != "$text")
        ti(p.position, l, d), p.attributes.has("listItemId") ? c.add(p.position.nodeAfter) : ti(p.position.getShiftedBy(p.length), l, d);
      else if (p.type == "remove" && p.attributes.has("listItemId"))
        ti(p.position, l, d);
      else if (p.type == "attribute") {
        const g = p.range.start.nodeAfter;
        t.includes(p.attributeKey) ? (ti(p.range.start, l, d), p.attributeNewValue === null ? (ti(p.range.start.getShiftedBy(1), l, d), s(g) && u.push(g)) : c.add(g)) : Ot(g) && s(g) && u.push(g);
      }
    for (const p of l.values())
      u.push(...r(p, c));
    for (const p of new Set(u))
      n.reconvertItem(p);
  };
  function r(a, u) {
    const l = [], c = /* @__PURE__ */ new Set(), d = [];
    for (const { node: p, previous: g } of new su(a)) {
      if (c.has(p))
        continue;
      const b = p.getAttribute("listIndent");
      g && b < g.getAttribute("listIndent") && (d.length = b + 1), d[b] = Object.fromEntries(Array.from(p.getAttributes()).filter(([k]) => t.includes(k)));
      const _ = wr(p, {
        direction: "forward"
      });
      for (const k of _)
        c.add(k), (s(k, _) || o(k, d, u)) && l.push(k);
    }
    return l;
  }
  function s(a, u) {
    const l = n.mapper.toViewElement(a);
    if (!l)
      return !1;
    if (i.fire("checkElement", {
      modelElement: a,
      viewElement: l
    }))
      return !0;
    if (!a.is("element", "paragraph") && !a.is("element", "listItem"))
      return !1;
    const d = Py(a, t, u);
    return d && l.is("element", "p") ? !0 : !!(!d && l.is("element", "span"));
  }
  function o(a, u, l) {
    if (l.has(a))
      return !1;
    const c = n.mapper.toViewElement(a);
    let d = u.length - 1;
    for (let p = c.parent; !p.is("editableElement"); p = p.parent) {
      const g = Yh(p), b = PM(p);
      if (!b && !g)
        continue;
      const _ = `checkAttributes:${g ? "item" : "list"}`;
      if (i.fire(_, {
        viewElement: p,
        modelAttributes: u[d]
      }))
        break;
      if (b && (d--, d < 0))
        return !1;
    }
    return !0;
  }
}
function eb(e, n, t, { dataPipeline: i } = {}) {
  const r = zM(e);
  return (s, o, a) => {
    const { writer: u, mapper: l, consumable: c } = a, d = o.item;
    if (!e.includes(o.attributeKey) || !r(d, c))
      return;
    const p = UM(d, l, t);
    vy(p, u, l), $M(p, u);
    const g = VM(d, p, n, u, {
      dataPipeline: i
    });
    WM(d, g, n, u);
  };
}
function FM(e) {
  return (n, t, i) => {
    const { writer: r, mapper: s } = i, o = n.name.split(":")[1];
    if (!e.checkAttribute(o, "listItemId"))
      return;
    const a = s.toViewPosition(t.position), u = t.position.getShiftedBy(t.length), l = s.toViewPosition(u, {
      isPhantom: !0
    }), d = r.createRange(a, l).getTrimmed().end.nodeBefore;
    /* istanbul ignore next -- @preserve */
    d && vy(d, r, s);
  };
}
function tb(e, { dataPipeline: n } = {}) {
  return (t, { writer: i }) => {
    if (!Py(t, e))
      return null;
    if (!n)
      return i.createContainerElement("span", {
        class: "ck-list-bogus-paragraph"
      });
    const r = i.createContainerElement("p");
    return i.setCustomProperty("dataPipeline:transparentRendering", !0, r), r;
  };
}
function UM(e, n, t) {
  const i = t.createRangeOn(e);
  return n.toViewRange(i).getTrimmed().end.nodeBefore;
}
function HM(e, n) {
  return (t, i) => {
    if (i.modelPosition.offset > 0)
      return;
    const r = i.modelPosition.parent;
    if (!Ot(r) || !e.some((l) => l.scope == "itemMarker" && l.canInjectMarkerIntoElement && l.canInjectMarkerIntoElement(r)))
      return;
    const s = i.mapper.toViewElement(r), o = n.createRangeIn(s), a = o.getWalker();
    let u = o.start;
    for (const { item: l } of a) {
      if (l.is("element") && i.mapper.toModelElement(l) || l.is("$textProxy"))
        break;
      l.is("element") && l.getCustomProperty("listItemMarker") && (u = n.createPositionAfter(l), a.skip(({ previousPosition: c }) => !c.isEqual(u)));
    }
    i.viewPosition = u;
  };
}
function vy(e, n, t) {
  for (; e.parent.is("attributeElement") && e.parent.getCustomProperty("listItemWrapper"); )
    n.unwrap(n.createRangeOn(e), e.parent);
  const i = [];
  r(n.createPositionBefore(e).getWalker({
    direction: "backward"
  })), r(n.createRangeIn(e).getWalker());
  for (const s of i)
    n.remove(s);
  function r(s) {
    for (const { item: o } of s) {
      if (o.is("element") && t.toModelElement(o))
        break;
      o.is("element") && o.getCustomProperty("listItemMarker") && i.push(o);
    }
  }
}
function VM(e, n, t, i, { dataPipeline: r }) {
  let s = i.createRangeOn(n);
  if (!rs(e))
    return s;
  for (const o of t) {
    if (o.scope != "itemMarker")
      continue;
    const a = o.createElement(i, e, {
      dataPipeline: r
    });
    if (!a || (i.setCustomProperty("listItemMarker", !0, a), o.canInjectMarkerIntoElement && o.canInjectMarkerIntoElement(e) ? i.insert(i.createPositionAt(n, 0), a) : (i.insert(s.start, a), s = i.createRange(i.createPositionBefore(a), i.createPositionAfter(n))), !o.createWrapperElement || !o.canWrapElement))
      continue;
    const u = o.createWrapperElement(i, e, {
      dataPipeline: r
    });
    i.setCustomProperty("listItemWrapper", !0, u), o.canWrapElement(e) ? s = i.wrap(s, u) : (s = i.wrap(i.createRangeOn(a), u), s = i.createRange(s.start, i.createPositionAfter(n)));
  }
  return s;
}
function $M(e, n) {
  let t = e.parent;
  for (; t.is("attributeElement") && [
    "ul",
    "ol",
    "li"
  ].includes(t.name); ) {
    const i = t.parent;
    n.unwrap(n.createRangeOn(e), t), t = i;
  }
}
function WM(e, n, t, i) {
  if (!e.hasAttribute("listIndent"))
    return;
  const r = e.getAttribute("listIndent");
  let s = e;
  for (let o = r; o >= 0; o--) {
    const a = RM(i, o, s.getAttribute("listItemId")), u = NM(i, o, s.getAttribute("listType"));
    for (const l of t)
      (l.scope == "list" || l.scope == "item") && s.hasAttribute(l.attributeName) && l.setAttributeOnDowncast(i, s.getAttribute(l.attributeName), l.scope == "list" ? u : a);
    if (n = i.wrap(n, a), n = i.wrap(n, u), o == 0 || (s = qn.first(s, {
      lowerIndent: !0
    }), !s))
      break;
  }
}
function zM(e) {
  return (n, t) => {
    const i = [];
    for (const r of e)
      n.hasAttribute(r) && i.push(`attribute:${r}`);
    return i.every((r) => t.test(n, r) !== !1) ? (i.forEach((r) => t.consume(n, r)), !0) : !1;
  };
}
function Py(e, n, t = mm(e)) {
  if (!Ot(e))
    return !1;
  for (const i of e.getAttributeKeys())
    if (!(i.startsWith("selection:") || i == "htmlEmptyBlock") && !n.includes(i))
      return !1;
  return t.length < 2;
}
const el = [
  "listType",
  "listIndent",
  "listItemId"
];
class qM extends ce {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * The list of registered downcast strategies.
    */
    m(this, "_downcastStrategies", []);
    t.config.define("list.multiBlock", !0);
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "ListEditing";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      cc,
      fs,
      vM,
      is
    ];
  }
  /**
  * @inheritDoc
  */
  init() {
    const t = this.editor, i = t.model, r = t.config.get("list.multiBlock");
    if (t.plugins.has("LegacyListEditing"))
      throw new v("list-feature-conflict", this, {
        conflictPlugin: "LegacyListEditing"
      });
    i.schema.register("$listItem", {
      allowAttributes: el
    }), r ? (i.schema.extend("$container", {
      allowAttributesOf: "$listItem"
    }), i.schema.extend("$block", {
      allowAttributesOf: "$listItem"
    }), i.schema.extend("$blockObject", {
      allowAttributesOf: "$listItem"
    })) : i.schema.register("listItem", {
      inheritAllFrom: "$block",
      allowAttributesOf: "$listItem"
    });
    for (const s of el)
      i.schema.setAttributeProperties(s, {
        copyOnReplace: !0
      });
    t.commands.add("numberedList", new Mu(t, "numbered")), t.commands.add("bulletedList", new Mu(t, "bulleted")), t.commands.add("customNumberedList", new Mu(t, "customNumbered", {
      multiLevel: !0
    })), t.commands.add("customBulletedList", new Mu(t, "customBulleted", {
      multiLevel: !0
    })), t.commands.add("indentList", new Qg(t, "forward")), t.commands.add("outdentList", new Qg(t, "backward")), t.commands.add("splitListItemBefore", new Zg(t, "before")), t.commands.add("splitListItemAfter", new Zg(t, "after")), r && (t.commands.add("mergeListItemBackward", new Jg(t, "backward")), t.commands.add("mergeListItemForward", new Jg(t, "forward"))), this._setupDeleteIntegration(), this._setupEnterIntegration(), this._setupTabIntegration(), this._setupClipboardIntegration(), this._setupAccessibilityIntegration();
  }
  /**
  * @inheritDoc
  */
  afterInit() {
    const i = this.editor.commands, r = i.get("indent"), s = i.get("outdent");
    r && r.registerChildCommand(i.get("indentList"), {
      priority: "high"
    }), s && s.registerChildCommand(i.get("outdentList"), {
      priority: "lowest"
    }), this._setupModelPostFixing(), this._setupConversion();
  }
  /**
  * Registers a downcast strategy.
  *
  * **Note**: Strategies must be registered in the `Plugin#init()` phase so that it can be applied
  * in the `ListEditing#afterInit()`.
  *
  * @param strategy The downcast strategy to register.
  */
  registerDowncastStrategy(t) {
    this._downcastStrategies.push(t);
  }
  /**
  * Returns list of model attribute names that should affect downcast conversion.
  */
  getListAttributeNames() {
    return [
      ...el,
      ...this._downcastStrategies.map((t) => t.attributeName)
    ];
  }
  /**
  * Attaches the listener to the {@link module:engine/view/document~Document#event:delete} event and handles backspace/delete
  * keys in and around document lists.
  */
  _setupDeleteIntegration() {
    const t = this.editor, i = t.commands.get("mergeListItemBackward"), r = t.commands.get("mergeListItemForward");
    this.listenTo(t.editing.view.document, "delete", (s, o) => {
      const a = t.model.document.selection;
      Wa(t.model) || t.model.change(() => {
        const u = a.getFirstPosition();
        if (a.isCollapsed && o.direction == "backward") {
          if (!u.isAtStart)
            return;
          const l = u.parent;
          if (!Ot(l))
            return;
          if (!qn.first(l, {
            sameAttributes: "listType",
            sameIndent: !0
          }) && l.getAttribute("listIndent") === 0)
            Gg(l) || t.execute("splitListItemAfter"), t.execute("outdentList");
          else {
            if (!i || !i.isEnabled)
              return;
            i.execute({
              shouldMergeOnBlocksContentLevel: nb(t.model, "backward")
            });
          }
          o.preventDefault(), s.stop();
        } else {
          if (a.isCollapsed && !a.getLastPosition().isAtEnd || !r || !r.isEnabled)
            return;
          r.execute({
            shouldMergeOnBlocksContentLevel: nb(t.model, "forward")
          }), o.preventDefault(), s.stop();
        }
      });
    }, {
      context: "li"
    });
  }
  /**
  * Attaches a listener to the {@link module:engine/view/document~Document#event:enter} event and handles enter key press
  * in document lists.
  */
  _setupEnterIntegration() {
    const t = this.editor, i = t.model, r = t.commands, s = r.get("enter");
    this.listenTo(t.editing.view.document, "enter", (o, a) => {
      const u = i.document, l = u.selection.getFirstPosition().parent;
      if (u.selection.isCollapsed && Ot(l) && l.isEmpty && !a.isSoft) {
        const c = rs(l), d = Gg(l);
        c && d ? (t.execute("outdentList"), a.preventDefault(), o.stop()) : c && !d ? (t.execute("splitListItemAfter"), a.preventDefault(), o.stop()) : d && (t.execute("splitListItemBefore"), a.preventDefault(), o.stop());
      }
    }, {
      context: "li"
    }), this.listenTo(s, "afterExecute", () => {
      const o = r.get("splitListItemBefore");
      if (o.refresh(), !o.isEnabled)
        return;
      const u = t.model.document.selection.getLastPosition().parent;
      mm(u).length === 2 && o.execute();
    });
  }
  /**
  * Attaches a listener to the {@link module:engine/view/document~Document#event:tab} event and handles tab key and tab+shift keys
  * presses in document lists.
  */
  _setupTabIntegration() {
    const t = this.editor;
    this.listenTo(t.editing.view.document, "tab", (i, r) => {
      const s = r.shiftKey ? "outdentList" : "indentList";
      this.editor.commands.get(s).isEnabled && (t.execute(s), r.stopPropagation(), r.preventDefault(), i.stop());
    }, {
      context: "li"
    });
  }
  /**
  * Registers the conversion helpers for the document-list feature.
  */
  _setupConversion() {
    const t = this.editor, i = t.model, r = this.getListAttributeNames(), s = t.config.get("list.multiBlock"), o = s ? "paragraph" : "listItem";
    t.conversion.for("upcast").elementToElement({
      view: "li",
      model: (u, { writer: l }) => l.createElement(o, {
        listType: ""
      })
    }).elementToElement({
      view: "p",
      model: (u, { writer: l }) => u.parent && u.parent.is("element", "li") ? l.createElement(o, {
        listType: ""
      }) : null,
      converterPriority: "high"
    }).add((u) => {
      u.on("element:li", MM());
    }), s || t.conversion.for("downcast").elementToElement({
      model: "listItem",
      view: "p"
    }), t.conversion.for("editingDowncast").elementToElement({
      model: o,
      view: tb(r),
      converterPriority: "high"
    }).add((u) => {
      u.on("attribute", eb(r, this._downcastStrategies, i)), u.on("remove", FM(i.schema));
    }), t.conversion.for("dataDowncast").elementToElement({
      model: o,
      view: tb(r, {
        dataPipeline: !0
      }),
      converterPriority: "high"
    }).add((u) => {
      u.on("attribute", eb(r, this._downcastStrategies, i, {
        dataPipeline: !0
      }));
    });
    const a = HM(this._downcastStrategies, t.editing.view);
    t.editing.mapper.on("modelToViewPosition", a), t.data.mapper.on("modelToViewPosition", a), this.listenTo(i.document, "change:data", BM(i, t.editing, r, this), {
      priority: "high"
    }), this.on("checkAttributes:item", (u, { viewElement: l, modelAttributes: c }) => {
      l.id != c.listItemId && (u.return = !0, u.stop());
    }), this.on("checkAttributes:list", (u, { viewElement: l, modelAttributes: c }) => {
      (l.name != Iy(c.listType) || l.id != xy(c.listType, c.listIndent)) && (u.return = !0, u.stop());
    });
  }
  /**
  * Registers model post-fixers.
  */
  _setupModelPostFixing() {
    const t = this.editor.model, i = this.getListAttributeNames();
    t.document.registerPostFixer((r) => YM(t, r, i, this)), this.on("postFixer", (r, { listNodes: s, writer: o }) => {
      r.return = LM(s, o) || r.return;
    }, {
      priority: "high"
    }), this.on("postFixer", (r, { listNodes: s, writer: o, seenIds: a }) => {
      r.return = DM(s, a, o) || r.return;
    }, {
      priority: "high"
    });
  }
  /**
  * Integrates the feature with the clipboard via {@link module:engine/model/model~Model#insertContent} and
  * {@link module:engine/model/model~Model#getSelectedContent}.
  */
  _setupClipboardIntegration() {
    const t = this.editor.model, i = this.editor.plugins.get("ClipboardPipeline");
    this.listenTo(t, "insertContent", jM(t), {
      priority: "high"
    }), this.listenTo(i, "outputTransformation", (r, s) => {
      t.change((o) => {
        const a = Array.from(s.content.getChildren()), u = a[a.length - 1];
        if (a.length > 1 && u.is("element") && u.isEmpty && a.slice(0, -1).every(Ot) && o.remove(u), s.method == "copy" || s.method == "cut") {
          const l = Array.from(s.content.getChildren());
          $a(l) && dc(l, o);
        }
      });
    });
  }
  /**
  * Informs editor accessibility features about keystrokes brought by the plugin.
  */
  _setupAccessibilityIntegration() {
    const t = this.editor, i = t.t;
    t.accessibility.addKeystrokeInfoGroup({
      id: "list",
      label: i("Keystrokes that can be used in a list"),
      keystrokes: [
        {
          label: i("Increase list item indent"),
          keystroke: "Tab"
        },
        {
          label: i("Decrease list item indent"),
          keystroke: "Shift+Tab"
        }
      ]
    });
  }
}
function YM(e, n, t, i) {
  const r = e.document.differ.getChanges(), s = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set(), a = i.editor.config.get("list.multiBlock");
  let u = !1;
  for (const c of r) {
    if (c.type == "insert" && c.name != "$text") {
      const d = c.position.nodeAfter;
      if (!e.schema.checkAttribute(d, "listItemId"))
        for (const p of Array.from(d.getAttributeKeys()))
          t.includes(p) && (n.removeAttribute(p, d), u = !0);
      ti(c.position, o, s), c.attributes.has("listItemId") || ti(c.position.getShiftedBy(c.length), o, s);
      for (const { item: p, previousPosition: g } of e.createRangeIn(d))
        Ot(p) && ti(g, o, s);
    } else c.type == "remove" ? ti(c.position, o, s) : c.type == "attribute" && t.includes(c.attributeKey) && (ti(c.range.start, o, s), c.attributeNewValue === null && ti(c.range.start.getShiftedBy(1), o, s));
    if (!a && c.type == "attribute" && el.includes(c.attributeKey)) {
      const d = c.range.start.nodeAfter;
      c.attributeNewValue === null && d && d.is("element", "listItem") ? (n.rename(d, "paragraph"), u = !0) : c.attributeOldValue === null && d && d.is("element") && d.name != "listItem" && (n.rename(d, "listItem"), u = !0);
    }
  }
  const l = /* @__PURE__ */ new Set();
  for (const c of o.values())
    u = i.fire("postFixer", {
      listNodes: new wM(c),
      listHead: c,
      writer: n,
      seenIds: l
    }) || u;
  return u;
}
function jM(e) {
  return (n, [t, i]) => {
    const r = t.is("documentFragment") ? Array.from(t.getChildren()) : [
      t
    ];
    if (!r.length)
      return;
    const o = (i ? e.createSelection(i) : e.document.selection).getFirstPosition();
    let a;
    if (Ot(o.parent))
      a = o.parent;
    else if (Ot(o.nodeBefore) && Ot(o.nodeAfter))
      a = o.nodeBefore;
    else
      return;
    e.change((u) => {
      const l = a.getAttribute("listType"), c = a.getAttribute("listIndent"), d = r[0].getAttribute("listIndent") || 0, p = Math.max(c - d, 0);
      for (const g of r) {
        const b = Ot(g);
        a.is("element", "listItem") && g.is("element", "paragraph") && u.rename(g, "listItem"), u.setAttributes({
          listIndent: (b ? g.getAttribute("listIndent") : 0) + p,
          listItemId: b ? g.getAttribute("listItemId") : ro.next(),
          listType: l
        }, g);
      }
    });
  };
}
function nb(e, n) {
  const t = e.document.selection;
  if (!t.isCollapsed)
    return !Wa(e);
  if (n === "forward")
    return !0;
  const r = t.getFirstPosition().parent, s = r.previousSibling;
  return e.schema.isObject(s) ? !1 : s.isEmpty ? !0 : $a([
    r,
    s
  ]);
}
function ib(e, n, t, i) {
  e.ui.componentFactory.add(n, () => {
    const r = rb(gt, e, n, t, i);
    return r.set({
      tooltip: !0,
      isToggleable: !0
    }), r;
  }), e.ui.componentFactory.add(`menuBar:${n}`, () => {
    const r = rb(Dn, e, n, t, i);
    return r.set({
      role: "menuitemcheckbox",
      isToggleable: !0
    }), r;
  });
}
function rb(e, n, t, i, r) {
  const s = n.commands.get(t), o = new e(n.locale);
  return o.set({
    label: i,
    icon: r
  }), o.bind("isOn", "isEnabled").to(s, "value", "isEnabled"), o.on("execute", () => {
    n.execute(t), n.editing.view.focus();
  }), o;
}
class KM extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "ListUI";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor.t;
    this.editor.ui.componentFactory.has("numberedList") || ib(this.editor, "numberedList", n("Numbered List"), Ge.numberedList), this.editor.ui.componentFactory.has("bulletedList") || ib(this.editor, "bulletedList", n("Bulleted List"), Ge.bulletedList);
  }
}
class GM extends ce {
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      qM,
      KM
    ];
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "List";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
}
const QM = [
  {
    listStyle: "disc",
    typeAttribute: "disc",
    listType: "bulleted"
  },
  {
    listStyle: "circle",
    typeAttribute: "circle",
    listType: "bulleted"
  },
  {
    listStyle: "square",
    typeAttribute: "square",
    listType: "bulleted"
  },
  {
    listStyle: "decimal",
    typeAttribute: "1",
    listType: "numbered"
  },
  {
    listStyle: "decimal-leading-zero",
    typeAttribute: null,
    listType: "numbered"
  },
  {
    listStyle: "lower-roman",
    typeAttribute: "i",
    listType: "numbered"
  },
  {
    listStyle: "upper-roman",
    typeAttribute: "I",
    listType: "numbered"
  },
  {
    listStyle: "lower-alpha",
    typeAttribute: "a",
    listType: "numbered"
  },
  {
    listStyle: "upper-alpha",
    typeAttribute: "A",
    listType: "numbered"
  },
  {
    listStyle: "lower-latin",
    typeAttribute: "a",
    listType: "numbered"
  },
  {
    listStyle: "upper-latin",
    typeAttribute: "A",
    listType: "numbered"
  }
];
for (const { listStyle: e, typeAttribute: n, listType: t } of QM)
  ;
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const sb = {
  "(": ")",
  "[": "]",
  "{": "}"
};
class XM extends Mt {
  /**
  * @inheritDoc
  */
  constructor(n) {
    super(n), this._isEnabledBasedOnSelection = !1;
  }
  /**
  * @inheritDoc
  */
  refresh() {
    const n = this.editor.model, t = n.document;
    this.isEnabled = n.schema.checkAttributeInSelection(t.selection, "mention");
  }
  /**
  * Executes the command.
  *
  * @param options Options for the executed command.
  * @param options.mention The mention object to insert. When a string is passed, it will be used to create a plain
  * object with the name attribute that equals the passed string.
  * @param options.marker The marker character (e.g. `'@'`).
  * @param options.text The text of the inserted mention. Defaults to the full mention string composed from `marker` and
  * `mention` string or `mention.id` if an object is passed.
  * @param options.range The range to replace.
  * Note that the replaced range might be shorter than the inserted text with the mention attribute.
  * @fires execute
  */
  execute(n) {
    const t = this.editor.model, r = t.document.selection, s = typeof n.mention == "string" ? {
      id: n.mention
    } : n.mention, o = s.id, a = n.range || r.getFirstRange();
    if (!t.canEditAt(a))
      return;
    const u = n.text || o, l = Oy({
      _text: u,
      id: o
    }, s);
    if (!o.startsWith(n.marker))
      throw new v("mentioncommand-incorrect-id", this);
    t.change((c) => {
      const d = Si(r.getAttributes()), p = new Map(d.entries());
      p.set("mention", l);
      const g = t.insertContent(c.createText(u, p), a), b = g.start.nodeBefore, _ = g.end.nodeAfter, k = _ && _.is("$text") && _.data.startsWith(" ");
      let C = !1;
      if (b && _ && b.is("$text") && _.is("$text")) {
        const D = b.data.slice(-1), M = D in sb, j = M && _.data.startsWith(sb[D]);
        C = M && j;
      }
      !C && !k && t.insertContent(c.createText(" ", d), a.start.getShiftedBy(u.length));
    });
  }
}
class JM extends ce {
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "MentionEditing";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  init() {
    const n = this.editor, t = n.model, i = t.document;
    t.schema.extend("$text", {
      allowAttributes: "mention"
    }), n.conversion.for("upcast").elementToAttribute({
      view: {
        name: "span",
        attributes: "data-mention",
        classes: "mention"
      },
      model: {
        key: "mention",
        value: (r) => Ny(r)
      }
    }), n.conversion.for("downcast").attributeToElement({
      model: "mention",
      view: e8
    }), n.conversion.for("downcast").add(ZM), i.registerPostFixer((r) => i8(r, i, t.schema)), i.registerPostFixer((r) => r8(r, i)), i.registerPostFixer((r) => t8(r, i)), n.commands.add("mention", new XM(n));
  }
}
function Oy(e, n) {
  return Object.assign({
    uid: un()
  }, e, n || {});
}
function Ny(e, n) {
  const t = e.getAttribute("data-mention"), i = e.getChild(0);
  if (!i)
    return;
  const r = {
    id: t,
    _text: i.data
  };
  return Oy(r, n);
}
function ZM(e) {
  e.on("attribute:mention", (n, t, i) => {
    const r = t.attributeNewValue;
    if (!t.item.is("$textProxy") || !r)
      return;
    const s = t.range.start;
    (s.textNode || s.nodeAfter).data != r._text && i.consumable.consume(t.item, n.name);
  }, {
    priority: "highest"
  });
}
function e8(e, { writer: n }) {
  if (!e)
    return;
  const t = {
    class: "mention",
    "data-mention": e.id
  }, i = {
    id: e.uid,
    priority: 20
  };
  return n.createAttributeElement("span", t, i);
}
function t8(e, n) {
  const t = n.selection, i = t.focus;
  return t.isCollapsed && t.hasAttribute("mention") && n8(i) ? (e.removeSelectionAttribute("mention"), !0) : !1;
}
function n8(e) {
  const n = e.isAtStart;
  return e.nodeBefore && e.nodeBefore.is("$text") || n;
}
function i8(e, n, t) {
  const i = n.differ.getChanges();
  let r = !1;
  for (const s of i) {
    if (s.type == "attribute")
      continue;
    const o = s.position;
    if (s.name == "$text") {
      const a = o.textNode && o.textNode.nextSibling;
      r = Vr(o.textNode, e) || r, r = Vr(a, e) || r, r = Vr(o.nodeBefore, e) || r, r = Vr(o.nodeAfter, e) || r;
    }
    if (s.name != "$text" && s.type == "insert") {
      const a = o.nodeAfter;
      for (const u of e.createRangeIn(a).getItems())
        r = Vr(u, e) || r;
    }
    if (s.type == "insert" && t.isInline(s.name)) {
      const a = o.nodeAfter && o.nodeAfter.nextSibling;
      r = Vr(o.nodeBefore, e) || r, r = Vr(a, e) || r;
    }
  }
  return r;
}
function r8(e, n) {
  const t = n.differ.getChanges();
  let i = !1;
  for (const r of t)
    if (r.type === "attribute" && r.attributeKey != "mention") {
      const s = r.range.start.nodeBefore, o = r.range.end.nodeAfter;
      for (const a of [
        s,
        o
      ])
        Ry(a) && a.getAttribute(r.attributeKey) != r.attributeNewValue && (e.setAttribute(r.attributeKey, r.attributeNewValue, a), i = !0);
    }
  return i;
}
function Ry(e) {
  if (!e || !(e.is("$text") || e.is("$textProxy")) || !e.hasAttribute("mention"))
    return !1;
  const n = e.data, i = e.getAttribute("mention")._text;
  return n != i;
}
function Vr(e, n) {
  return Ry(e) ? (n.removeAttribute("mention", e), !0) : !1;
}
class s8 extends oc {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    m(this, "selected");
    m(this, "position");
    this.extendTemplate({
      attributes: {
        class: [
          "ck-mentions"
        ],
        tabindex: "-1"
      }
    });
  }
  /**
  * {@link #select Selects} the first item.
  */
  selectFirst() {
    this.select(0);
  }
  /**
  * Selects next item to the currently {@link #select selected}.
  *
  * If the last item is already selected, it will select the first item.
  */
  selectNext() {
    const t = this.selected, i = this.items.getIndex(t);
    this.select(i + 1);
  }
  /**
  * Selects previous item to the currently {@link #select selected}.
  *
  * If the first item is already selected, it will select the last item.
  */
  selectPrevious() {
    const t = this.selected, i = this.items.getIndex(t);
    this.select(i - 1);
  }
  /**
  * Marks item at a given index as selected.
  *
  * Handles selection cycling when passed index is out of bounds:
  * - if the index is lower than 0, it will select the last item,
  * - if the index is higher than the last item index, it will select the first item.
  *
  * @param index Index of an item to be marked as selected.
  */
  select(t) {
    let i = 0;
    t > 0 && t < this.items.length ? i = t : t < 0 && (i = this.items.length - 1);
    const r = this.items.get(i);
    this.selected !== r && (this.selected && this.selected.removeHighlight(), r.highlight(), this.selected = r, this._isItemVisibleInScrolledArea(r) || (this.element.scrollTop = r.element.offsetTop));
  }
  /**
  * Triggers the `execute` event on the {@link #select selected} item.
  */
  executeSelected() {
    this.selected.fire("execute");
  }
  /**
  * Checks if an item is visible in the scrollable area.
  *
  * The item is considered visible when:
  * - its top boundary is inside the scrollable rect
  * - its bottom boundary is inside the scrollable rect (the whole item must be visible)
  */
  _isItemVisibleInScrolledArea(t) {
    return new Se(this.element).contains(new Se(t.element));
  }
}
class o8 extends me {
  /**
  * Creates an instance of {@link module:mention/ui/domwrapperview~DomWrapperView} class.
  *
  * Also see {@link #render}.
  */
  constructor(t, i) {
    super(t);
    /**
    * The DOM element for which wrapper was created.
    */
    m(this, "domElement");
    this.template = void 0, this.domElement = i, this.domElement.classList.add("ck-button"), this.set("isOn", !1), this.on("change:isOn", (r, s, o) => {
      o ? (this.domElement.classList.add("ck-on"), this.domElement.classList.remove("ck-off")) : (this.domElement.classList.add("ck-off"), this.domElement.classList.remove("ck-on"));
    }), this.listenTo(this.domElement, "click", () => {
      this.fire("execute");
    });
  }
  /**
  * @inheritDoc
  */
  render() {
    super.render(), this.element = this.domElement;
  }
  /**
  * Focuses the DOM element.
  */
  focus() {
    this.domElement.focus();
  }
}
class a8 extends qi {
  constructor() {
    super(...arguments);
    m(this, "item");
    m(this, "marker");
  }
  highlight() {
    const t = this.children.first;
    t.isOn = !0;
  }
  removeHighlight() {
    const t = this.children.first;
    t.isOn = !1;
  }
}
const Bu = 3, u8 = [
  ye.arrowup,
  ye.arrowdown,
  ye.esc
], l8 = [
  ye.enter,
  ye.tab
];
class c8 extends ce {
  /**
  * @inheritDoc
  */
  constructor(t) {
    super(t);
    /**
    * The mention view.
    */
    m(this, "_mentionsView");
    /**
    * Stores mention feeds configurations.
    */
    m(this, "_mentionsConfigurations");
    /**
    * The contextual balloon plugin instance.
    */
    m(this, "_balloon");
    m(this, "_items", new Qi());
    m(this, "_lastRequested");
    /**
    * Debounced feed requester. It uses `lodash#debounce` method to delay function call.
    */
    m(this, "_requestFeedDebounced");
    this._mentionsView = this._createMentionView(), this._mentionsConfigurations = /* @__PURE__ */ new Map(), this._requestFeedDebounced = _r(this._requestFeed, 100), t.config.define("mention", {
      feeds: []
    });
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "MentionUI";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      kl
    ];
  }
  /**
  * @inheritDoc
  */
  init() {
    const t = this.editor, i = t.config.get("mention.commitKeys") || l8, r = u8.concat(i);
    this._balloon = t.plugins.get(kl), t.editing.view.document.on("keydown", (a, u) => {
      o(u.keyCode) && this._isUIVisible && (u.preventDefault(), a.stop(), u.keyCode == ye.arrowdown && this._mentionsView.selectNext(), u.keyCode == ye.arrowup && this._mentionsView.selectPrevious(), i.includes(u.keyCode) && this._mentionsView.executeSelected(), u.keyCode == ye.esc && this._hideUIAndRemoveMarker());
    }, {
      priority: "highest"
    }), rc({
      emitter: this._mentionsView,
      activator: () => this._isUIVisible,
      contextElements: () => [
        this._balloon.view.element
      ],
      callback: () => this._hideUIAndRemoveMarker()
    });
    const s = t.config.get("mention.feeds");
    for (const a of s) {
      const { feed: u, marker: l, dropdownLimit: c } = a;
      if (!b8(l))
        throw new v("mentionconfig-incorrect-marker", null, {
          marker: l
        });
      const d = typeof u == "function" ? u.bind(this.editor) : m8(u), p = a.itemRenderer, g = {
        marker: l,
        feedCallback: d,
        itemRenderer: p,
        dropdownLimit: c
      };
      this._mentionsConfigurations.set(l, g);
    }
    this._setupTextWatcher(s), this.listenTo(t, "change:isReadOnly", () => {
      this._hideUIAndRemoveMarker();
    }), this.on("requestFeed:response", (a, u) => this._handleFeedResponse(u)), this.on("requestFeed:error", () => this._hideUIAndRemoveMarker());
    function o(a) {
      return r.includes(a);
    }
  }
  /**
  * @inheritDoc
  */
  destroy() {
    super.destroy(), this._mentionsView.destroy();
  }
  /**
  * Returns true when {@link #_mentionsView} is in the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon} and it is
  * currently visible.
  */
  get _isUIVisible() {
    return this._balloon.visibleView === this._mentionsView;
  }
  /**
  * Creates the {@link #_mentionsView}.
  */
  _createMentionView() {
    const t = this.editor.locale, i = new s8(t);
    return i.items.bindTo(this._items).using((r) => {
      const { item: s, marker: o } = r, { dropdownLimit: a } = this._mentionsConfigurations.get(o), u = a || this.editor.config.get("mention.dropdownLimit") || 10;
      if (i.items.length >= u)
        return null;
      const l = new a8(t), c = this._renderItem(s, o);
      return c.delegate("execute").to(l), l.children.add(c), l.item = s, l.marker = o, l.on("execute", () => {
        i.fire("execute", {
          item: s,
          marker: o
        });
      }), l;
    }), i.on("execute", (r, s) => {
      const o = this.editor, a = o.model, u = s.item, l = s.marker, c = o.model.markers.get("mention"), d = a.createPositionAt(a.document.selection.focus), p = a.createPositionAt(c.getStart()), g = a.createRange(p, d);
      this._hideUIAndRemoveMarker(), o.execute("mention", {
        mention: u,
        text: u.text,
        marker: l,
        range: g
      }), o.editing.view.focus();
    }), i;
  }
  /**
  * Returns item renderer for the marker.
  */
  _getItemRenderer(t) {
    const { itemRenderer: i } = this._mentionsConfigurations.get(t);
    return i;
  }
  /**
  * Requests a feed from a configured callbacks.
  */
  _requestFeed(t, i) {
    this._lastRequested = i;
    const { feedCallback: r } = this._mentionsConfigurations.get(t), s = r(i);
    if (!(s instanceof Promise)) {
      this.fire("requestFeed:response", {
        feed: s,
        marker: t,
        feedText: i
      });
      return;
    }
    s.then((a) => {
      this._lastRequested == i ? this.fire("requestFeed:response", {
        feed: a,
        marker: t,
        feedText: i
      }) : this.fire("requestFeed:discarded", {
        feed: a,
        marker: t,
        feedText: i
      });
    }).catch((a) => {
      this.fire("requestFeed:error", {
        error: a
      }), at("mention-feed-callback-error", {
        marker: t
      });
    });
  }
  /**
  * Registers a text watcher for the marker.
  */
  _setupTextWatcher(t) {
    const i = this.editor, r = t.map((a) => ({
      ...a,
      pattern: Dy(a.marker, a.minimumCharacters || 0)
    })), s = new cy(i.model, h8(r));
    s.on("matched", (a, u) => {
      const l = Ly(r, u.text), d = i.model.document.selection.focus, p = i.model.createPositionAt(d.parent, l.position);
      if (p8(d) || g8(p)) {
        this._hideUIAndRemoveMarker();
        return;
      }
      const g = f8(l, u.text), b = l.marker.length + g.length, _ = d.getShiftedBy(-b), k = d.getShiftedBy(-g.length), C = i.model.createRange(_, k);
      if (Id(i)) {
        const D = i.model.markers.get("mention");
        i.model.change((M) => {
          M.updateMarker(D, {
            range: C
          });
        });
      } else
        i.model.change((D) => {
          D.addMarker("mention", {
            range: C,
            usingOperation: !1,
            affectsData: !1
          });
        });
      this._requestFeedDebounced(l.marker, g);
    }), s.on("unmatched", () => {
      this._hideUIAndRemoveMarker();
    });
    const o = i.commands.get("mention");
    return s.bind("isEnabled").to(o), s;
  }
  /**
  * Handles the feed response event data.
  */
  _handleFeedResponse(t) {
    const { feed: i, marker: r } = t;
    if (!Id(this.editor))
      return;
    this._items.clear();
    for (const o of i) {
      const a = typeof o != "object" ? {
        id: o,
        text: o
      } : o;
      this._items.add({
        item: a,
        marker: r
      });
    }
    const s = this.editor.model.markers.get("mention");
    this._items.length ? this._showOrUpdateUI(s) : this._hideUIAndRemoveMarker();
  }
  /**
  * Shows the mentions balloon. If the panel is already visible, it will reposition it.
  */
  _showOrUpdateUI(t) {
    this._isUIVisible ? this._balloon.updatePosition(this._getBalloonPanelPositionData(t, this._mentionsView.position)) : this._balloon.add({
      view: this._mentionsView,
      position: this._getBalloonPanelPositionData(t, this._mentionsView.position),
      singleViewMode: !0
    }), this._mentionsView.position = this._balloon.view.position, this._mentionsView.selectFirst();
  }
  /**
  * Hides the mentions balloon and removes the 'mention' marker from the markers collection.
  */
  _hideUIAndRemoveMarker() {
    this._balloon.hasView(this._mentionsView) && this._balloon.remove(this._mentionsView), Id(this.editor) && this.editor.model.change((t) => t.removeMarker("mention")), this._mentionsView.position = void 0;
  }
  /**
  * Renders a single item in the autocomplete list.
  */
  _renderItem(t, i) {
    const r = this.editor;
    let s, o = t.id;
    const a = this._getItemRenderer(i);
    if (a) {
      const u = a(t);
      typeof u != "string" ? s = new o8(r.locale, u) : o = u;
    }
    if (!s) {
      const u = new gt(r.locale);
      u.label = o, u.withText = !0, s = u;
    }
    return s;
  }
  /**
  * Creates a position options object used to position the balloon panel.
  *
  * @param mentionMarker
  * @param preferredPosition The name of the last matched position name.
  */
  _getBalloonPanelPositionData(t, i) {
    const r = this.editor, s = r.editing, o = s.view.domConverter, a = s.mapper, u = r.locale.uiLanguageDirection;
    return {
      target: () => {
        let l = t.getRange();
        l.start.root.rootName == "$graveyard" && (l = r.model.document.selection.getFirstRange());
        const c = a.toViewRange(l);
        return Se.getDomRangeRects(o.viewRangeToDom(c)).pop();
      },
      limiter: () => {
        const l = this.editor.editing.view, d = l.document.selection.editableElement;
        return d ? l.domConverter.mapViewToDom(d.root) : null;
      },
      positions: d8(i, u)
    };
  }
}
function d8(e, n) {
  const t = {
    // Positions the panel to the southeast of the caret rectangle.
    caret_se: (i) => ({
      top: i.bottom + Bu,
      left: i.right,
      name: "caret_se",
      config: {
        withArrow: !1
      }
    }),
    // Positions the panel to the northeast of the caret rectangle.
    caret_ne: (i, r) => ({
      top: i.top - r.height - Bu,
      left: i.right,
      name: "caret_ne",
      config: {
        withArrow: !1
      }
    }),
    // Positions the panel to the southwest of the caret rectangle.
    caret_sw: (i, r) => ({
      top: i.bottom + Bu,
      left: i.right - r.width,
      name: "caret_sw",
      config: {
        withArrow: !1
      }
    }),
    // Positions the panel to the northwest of the caret rect.
    caret_nw: (i, r) => ({
      top: i.top - r.height - Bu,
      left: i.right - r.width,
      name: "caret_nw",
      config: {
        withArrow: !1
      }
    })
  };
  return Object.prototype.hasOwnProperty.call(t, e) ? [
    t[e]
  ] : n !== "rtl" ? [
    t.caret_se,
    t.caret_sw,
    t.caret_ne,
    t.caret_nw
  ] : [
    t.caret_sw,
    t.caret_se,
    t.caret_nw,
    t.caret_ne
  ];
}
function Ly(e, n) {
  let t;
  for (const i of e) {
    const r = n.lastIndexOf(i.marker);
    r > 0 && !n.substring(r - 1).match(i.pattern) || (!t || r >= t.position) && (t = {
      marker: i.marker,
      position: r,
      minimumCharacters: i.minimumCharacters,
      pattern: i.pattern
    });
  }
  return t;
}
function Dy(e, n) {
  const t = n == 0 ? "*" : `{${n},}`, i = he.features.isRegExpUnicodePropertySupported ? `\\p{Ps}\\p{Pi}"'` : `\\(\\[{"'`, r = ".";
  e = e.replace(/[.*+?^${}()\-|[\]\\]/g, "\\$&");
  const s = `(?:^|[ ${i}])(${e})(${r}${t})$`;
  return new RegExp(s, "u");
}
function h8(e) {
  return (t) => {
    const i = Ly(e, t);
    if (!i)
      return !1;
    let r = 0;
    i.position !== 0 && (r = i.position - 1);
    const s = t.substring(r);
    return i.pattern.test(s);
  };
}
function f8(e, n) {
  let t = 0;
  e.position !== 0 && (t = e.position - 1);
  const i = Dy(e.marker, 0);
  return n.substring(t).match(i)[2];
}
function m8(e) {
  return (n) => e.filter((i) => (typeof i == "string" ? i : String(i.id)).toLowerCase().includes(n.toLowerCase()));
}
function p8(e) {
  const n = e.textNode && e.textNode.hasAttribute("mention"), t = e.nodeBefore;
  return n || t && t.is("$text") && t.hasAttribute("mention");
}
function g8(e) {
  const n = e.nodeAfter;
  return n && n.is("$text") && n.hasAttribute("mention");
}
function b8(e) {
  return !!e;
}
function Id(e) {
  return e.model.markers.has("mention");
}
class _8 extends ce {
  toMentionAttribute(n, t) {
    return Ny(n, t);
  }
  /**
  * @inheritDoc
  */
  static get pluginName() {
    return "Mention";
  }
  /**
  * @inheritDoc
  */
  static get isOfficialPlugin() {
    return !0;
  }
  /**
  * @inheritDoc
  */
  static get requires() {
    return [
      JM,
      c8
    ];
  }
}
function ob(e) {
  if (e)
    throw e;
}
var tl = Object.prototype.hasOwnProperty, My = Object.prototype.toString, ab = Object.defineProperty, ub = Object.getOwnPropertyDescriptor, lb = function(n) {
  return typeof Array.isArray == "function" ? Array.isArray(n) : My.call(n) === "[object Array]";
}, cb = function(n) {
  if (!n || My.call(n) !== "[object Object]")
    return !1;
  var t = tl.call(n, "constructor"), i = n.constructor && n.constructor.prototype && tl.call(n.constructor.prototype, "isPrototypeOf");
  if (n.constructor && !t && !i)
    return !1;
  var r;
  for (r in n)
    ;
  return typeof r > "u" || tl.call(n, r);
}, db = function(n, t) {
  ab && t.name === "__proto__" ? ab(n, t.name, {
    enumerable: !0,
    configurable: !0,
    value: t.newValue,
    writable: !0
  }) : n[t.name] = t.newValue;
}, hb = function(n, t) {
  if (t === "__proto__")
    if (tl.call(n, t)) {
      if (ub)
        return ub(n, t).value;
    } else return;
  return n[t];
}, E8 = function e() {
  var n, t, i, r, s, o, a = arguments[0], u = 1, l = arguments.length, c = !1;
  for (typeof a == "boolean" && (c = a, a = arguments[1] || {}, u = 2), (a == null || typeof a != "object" && typeof a != "function") && (a = {}); u < l; ++u)
    if (n = arguments[u], n != null)
      for (t in n)
        i = hb(a, t), r = hb(n, t), a !== r && (c && r && (cb(r) || (s = lb(r))) ? (s ? (s = !1, o = i && lb(i) ? i : []) : o = i && cb(i) ? i : {}, db(a, { name: t, newValue: e(c, o, r) })) : typeof r < "u" && db(a, { name: t, newValue: r }));
  return a;
};
const xd = /* @__PURE__ */ kf(E8);
function jh(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function T8() {
  const e = [], n = { run: t, use: i };
  return n;
  function t(...r) {
    let s = -1;
    const o = r.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    a(null, ...r);
    function a(u, ...l) {
      const c = e[++s];
      let d = -1;
      if (u) {
        o(u);
        return;
      }
      for (; ++d < r.length; )
        (l[d] === null || l[d] === void 0) && (l[d] = r[d]);
      r = l, c ? y8(c, a)(...l) : o(null, ...l);
    }
  }
  function i(r) {
    if (typeof r != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + r
      );
    return e.push(r), n;
  }
}
function y8(e, n) {
  let t;
  return i;
  function i(...o) {
    const a = e.length > o.length;
    let u;
    a && o.push(r);
    try {
      u = e.apply(this, o);
    } catch (l) {
      const c = (
        /** @type {Error} */
        l
      );
      if (a && t)
        throw c;
      return r(c);
    }
    a || (u && u.then && typeof u.then == "function" ? u.then(s, r) : u instanceof Error ? r(u) : s(u));
  }
  function r(o, ...a) {
    t || (t = !0, n(o, ...a));
  }
  function s(o) {
    r(null, o);
  }
}
function ca(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? fb(e.position) : "start" in e || "end" in e ? fb(e) : "line" in e || "column" in e ? Kh(e) : "";
}
function Kh(e) {
  return mb(e && e.line) + ":" + mb(e && e.column);
}
function fb(e) {
  return Kh(e && e.start) + "-" + Kh(e && e.end);
}
function mb(e) {
  return e && typeof e == "number" ? e : 1;
}
class Yt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, t, i) {
    super(), typeof t == "string" && (i = t, t = void 0);
    let r = "", s = {}, o = !1;
    if (t && ("line" in t && "column" in t ? s = { place: t } : "start" in t && "end" in t ? s = { place: t } : "type" in t ? s = {
      ancestors: [t],
      place: t.position
    } : s = { ...t }), typeof n == "string" ? r = n : !s.cause && n && (o = !0, r = n.message, s.cause = n), !s.ruleId && !s.source && typeof i == "string") {
      const u = i.indexOf(":");
      u === -1 ? s.ruleId = i : (s.source = i.slice(0, u), s.ruleId = i.slice(u + 1));
    }
    if (!s.place && s.ancestors && s.ancestors) {
      const u = s.ancestors[s.ancestors.length - 1];
      u && (s.place = u.position);
    }
    const a = s.place && "start" in s.place ? s.place.start : s.place;
    this.ancestors = s.ancestors || void 0, this.cause = s.cause || void 0, this.column = a ? a.column : void 0, this.fatal = void 0, this.file, this.message = r, this.line = a ? a.line : void 0, this.name = ca(s.place) || "1:1", this.place = s.place || void 0, this.reason = this.message, this.ruleId = s.ruleId || void 0, this.source = s.source || void 0, this.stack = o && s.cause && typeof s.cause.stack == "string" ? s.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Yt.prototype.file = "";
Yt.prototype.name = "";
Yt.prototype.reason = "";
Yt.prototype.message = "";
Yt.prototype.stack = "";
Yt.prototype.column = void 0;
Yt.prototype.line = void 0;
Yt.prototype.ancestors = void 0;
Yt.prototype.cause = void 0;
Yt.prototype.fatal = void 0;
Yt.prototype.place = void 0;
Yt.prototype.ruleId = void 0;
Yt.prototype.source = void 0;
const gi = { basename: w8, dirname: A8, extname: C8, join: k8, sep: "/" };
function w8(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  au(e);
  let t = 0, i = -1, r = e.length, s;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; r--; )
      if (e.codePointAt(r) === 47) {
        if (s) {
          t = r + 1;
          break;
        }
      } else i < 0 && (s = !0, i = r + 1);
    return i < 0 ? "" : e.slice(t, i);
  }
  if (n === e)
    return "";
  let o = -1, a = n.length - 1;
  for (; r--; )
    if (e.codePointAt(r) === 47) {
      if (s) {
        t = r + 1;
        break;
      }
    } else
      o < 0 && (s = !0, o = r + 1), a > -1 && (e.codePointAt(r) === n.codePointAt(a--) ? a < 0 && (i = r) : (a = -1, i = o));
  return t === i ? i = o : i < 0 && (i = e.length), e.slice(t, i);
}
function A8(e) {
  if (au(e), e.length === 0)
    return ".";
  let n = -1, t = e.length, i;
  for (; --t; )
    if (e.codePointAt(t) === 47) {
      if (i) {
        n = t;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function C8(e) {
  au(e);
  let n = e.length, t = -1, i = 0, r = -1, s = 0, o;
  for (; n--; ) {
    const a = e.codePointAt(n);
    if (a === 47) {
      if (o) {
        i = n + 1;
        break;
      }
      continue;
    }
    t < 0 && (o = !0, t = n + 1), a === 46 ? r < 0 ? r = n : s !== 1 && (s = 1) : r > -1 && (s = -1);
  }
  return r < 0 || t < 0 || // We saw a non-dot character immediately before the dot.
  s === 0 || // The (right-most) trimmed path component is exactly `..`.
  s === 1 && r === t - 1 && r === i + 1 ? "" : e.slice(r, t);
}
function k8(...e) {
  let n = -1, t;
  for (; ++n < e.length; )
    au(e[n]), e[n] && (t = t === void 0 ? e[n] : t + "/" + e[n]);
  return t === void 0 ? "." : S8(t);
}
function S8(e) {
  au(e);
  const n = e.codePointAt(0) === 47;
  let t = I8(e, !n);
  return t.length === 0 && !n && (t = "."), t.length > 0 && e.codePointAt(e.length - 1) === 47 && (t += "/"), n ? "/" + t : t;
}
function I8(e, n) {
  let t = "", i = 0, r = -1, s = 0, o = -1, a, u;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      a = e.codePointAt(o);
    else {
      if (a === 47)
        break;
      a = 47;
    }
    if (a === 47) {
      if (!(r === o - 1 || s === 1)) if (r !== o - 1 && s === 2) {
        if (t.length < 2 || i !== 2 || t.codePointAt(t.length - 1) !== 46 || t.codePointAt(t.length - 2) !== 46) {
          if (t.length > 2) {
            if (u = t.lastIndexOf("/"), u !== t.length - 1) {
              u < 0 ? (t = "", i = 0) : (t = t.slice(0, u), i = t.length - 1 - t.lastIndexOf("/")), r = o, s = 0;
              continue;
            }
          } else if (t.length > 0) {
            t = "", i = 0, r = o, s = 0;
            continue;
          }
        }
        n && (t = t.length > 0 ? t + "/.." : "..", i = 2);
      } else
        t.length > 0 ? t += "/" + e.slice(r + 1, o) : t = e.slice(r + 1, o), i = o - r - 1;
      r = o, s = 0;
    } else a === 46 && s > -1 ? s++ : s = -1;
  }
  return t;
}
function au(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const x8 = { cwd: v8 };
function v8() {
  return "/";
}
function Gh(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function P8(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Gh(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return O8(e);
}
function O8(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let t = -1;
  for (; ++t < n.length; )
    if (n.codePointAt(t) === 37 && n.codePointAt(t + 1) === 50) {
      const i = n.codePointAt(t + 2);
      if (i === 70 || i === 102) {
        const r = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw r.code = "ERR_INVALID_FILE_URL_PATH", r;
      }
    }
  return decodeURIComponent(n);
}
const vd = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class xl {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let t;
    n ? Gh(n) ? t = { path: n } : typeof n == "string" || N8(n) ? t = { value: n } : t = n : t = {}, this.cwd = "cwd" in t ? "" : x8.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < vd.length; ) {
      const s = vd[i];
      s in t && t[s] !== void 0 && t[s] !== null && (this[s] = s === "history" ? [...t[s]] : t[s]);
    }
    let r;
    for (r in t)
      vd.includes(r) || (this[r] = t[r]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? gi.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    Od(n, "basename"), Pd(n, "basename"), this.path = gi.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? gi.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    pb(this.basename, "dirname"), this.path = gi.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? gi.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (Pd(n, "extname"), pb(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = gi.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    Gh(n) && (n = P8(n)), Od(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? gi.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    Od(n, "stem"), Pd(n, "stem"), this.path = gi.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, t, i) {
    const r = this.message(n, t, i);
    throw r.fatal = !0, r;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, t, i) {
    const r = this.message(n, t, i);
    return r.fatal = void 0, r;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, t, i) {
    const r = new Yt(
      // @ts-expect-error: the overloads are fine.
      n,
      t,
      i
    );
    return this.path && (r.name = this.path + ":" + r.name, r.file = this.path), r.fatal = !1, this.messages.push(r), r;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function Pd(e, n) {
  if (e && e.includes(gi.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + gi.sep + "`"
    );
}
function Od(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function pb(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function N8(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const R8 = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), r = i[e], s = function() {
      return r.apply(s, arguments);
    };
    return Object.setPrototypeOf(s, i), s;
  }
), L8 = {}.hasOwnProperty;
class gm extends R8 {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = T8();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new gm()
    );
    let t = -1;
    for (; ++t < this.attachers.length; ) {
      const i = this.attachers[t];
      n.use(...i);
    }
    return n.data(xd(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, t) {
    return typeof n == "string" ? arguments.length === 2 ? (Ld("data", this.frozen), this.namespace[n] = t, this) : L8.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (Ld("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [t, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const r = t.call(n, ...i);
      typeof r == "function" && this.transformers.use(r);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const t = Fu(n), i = this.parser || this.Parser;
    return Nd("parse", i), i(String(t), t);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, t) {
    const i = this;
    return this.freeze(), Nd("process", this.parser || this.Parser), Rd("process", this.compiler || this.Compiler), t ? r(void 0, t) : new Promise(r);
    function r(s, o) {
      const a = Fu(n), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(a)
      );
      i.run(u, a, function(c, d, p) {
        if (c || !d || !p)
          return l(c);
        const g = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          d
        ), b = i.stringify(g, p);
        M8(b) ? p.value = b : p.result = b, l(
          c,
          /** @type {VFileWithOutput<CompileResult>} */
          p
        );
      });
      function l(c, d) {
        c || !d ? o(c) : s ? s(d) : t(void 0, d);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let t = !1, i;
    return this.freeze(), Nd("processSync", this.parser || this.Parser), Rd("processSync", this.compiler || this.Compiler), this.process(n, r), bb("processSync", "process", t), i;
    function r(s, o) {
      t = !0, ob(s), i = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, t, i) {
    gb(n), this.freeze();
    const r = this.transformers;
    return !i && typeof t == "function" && (i = t, t = void 0), i ? s(void 0, i) : new Promise(s);
    function s(o, a) {
      const u = Fu(t);
      r.run(n, u, l);
      function l(c, d, p) {
        const g = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          d || n
        );
        c ? a(c) : o ? o(g) : i(void 0, g, p);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, t) {
    let i = !1, r;
    return this.run(n, t, s), bb("runSync", "run", i), r;
    function s(o, a) {
      ob(o), r = a, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, t) {
    this.freeze();
    const i = Fu(t), r = this.compiler || this.Compiler;
    return Rd("stringify", r), gb(n), r(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...t) {
    const i = this.attachers, r = this.namespace;
    if (Ld("use", this.frozen), n != null) if (typeof n == "function")
      u(n, t);
    else if (typeof n == "object")
      Array.isArray(n) ? a(n) : o(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function s(l) {
      if (typeof l == "function")
        u(l, []);
      else if (typeof l == "object")
        if (Array.isArray(l)) {
          const [c, ...d] = (
            /** @type {PluginTuple<Array<unknown>>} */
            l
          );
          u(c, d);
        } else
          o(l);
      else
        throw new TypeError("Expected usable value, not `" + l + "`");
    }
    function o(l) {
      if (!("plugins" in l) && !("settings" in l))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      a(l.plugins), l.settings && (r.settings = xd(!0, r.settings, l.settings));
    }
    function a(l) {
      let c = -1;
      if (l != null) if (Array.isArray(l))
        for (; ++c < l.length; ) {
          const d = l[c];
          s(d);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + l + "`");
    }
    function u(l, c) {
      let d = -1, p = -1;
      for (; ++d < i.length; )
        if (i[d][0] === l) {
          p = d;
          break;
        }
      if (p === -1)
        i.push([l, ...c]);
      else if (c.length > 0) {
        let [g, ...b] = c;
        const _ = i[p][1];
        jh(_) && jh(g) && (g = xd(!0, _, g)), i[p] = [l, g, ...b];
      }
    }
  }
}
const Qh = new gm().freeze();
function Nd(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Rd(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Ld(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function gb(e) {
  if (!jh(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function bb(e, n, t) {
  if (!t)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function Fu(e) {
  return D8(e) ? e : new xl(e);
}
function D8(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function M8(e) {
  return typeof e == "string" || B8(e);
}
function B8(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
function vl(e, n) {
  const t = String(e);
  if (typeof n != "string")
    throw new TypeError("Expected character");
  let i = 0, r = t.indexOf(n);
  for (; r !== -1; )
    i++, r = t.indexOf(n, r + n.length);
  return i;
}
const on = xr(/[A-Za-z]/), Xt = xr(/[\dA-Za-z]/), F8 = xr(/[#-'*+\--9=?A-Z^-~]/);
function Pl(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Xh = xr(/\d/), U8 = xr(/[\dA-Fa-f]/), H8 = xr(/[!-/:-@[-`{-~]/);
function fe(e) {
  return e !== null && e < -2;
}
function et(e) {
  return e !== null && (e < 0 || e === 32);
}
function De(e) {
  return e === -2 || e === -1 || e === 32;
}
const hc = xr(new RegExp("\\p{P}|\\p{S}", "u")), ss = xr(/\s/);
function xr(e) {
  return n;
  function n(t) {
    return t !== null && t > -1 && e.test(String.fromCharCode(t));
  }
}
function V8(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const po = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return q8;
    if (typeof e == "function")
      return fc(e);
    if (typeof e == "object")
      return Array.isArray(e) ? $8(e) : W8(e);
    if (typeof e == "string")
      return z8(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function $8(e) {
  const n = [];
  let t = -1;
  for (; ++t < e.length; )
    n[t] = po(e[t]);
  return fc(i);
  function i(...r) {
    let s = -1;
    for (; ++s < n.length; )
      if (n[s].apply(this, r)) return !0;
    return !1;
  }
}
function W8(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return fc(t);
  function t(i) {
    const r = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let s;
    for (s in e)
      if (r[s] !== n[s]) return !1;
    return !0;
  }
}
function z8(e) {
  return fc(n);
  function n(t) {
    return t && t.type === e;
  }
}
function fc(e) {
  return n;
  function n(t, i, r) {
    return !!(Y8(t) && e.call(
      this,
      t,
      typeof i == "number" ? i : void 0,
      r || void 0
    ));
  }
}
function q8() {
  return !0;
}
function Y8(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const By = [], j8 = !0, Ol = !1, Fy = "skip";
function Uy(e, n, t, i) {
  let r;
  typeof n == "function" && typeof t != "function" ? (i = t, t = n) : r = n;
  const s = po(r), o = i ? -1 : 1;
  a(e, void 0, [])();
  function a(u, l, c) {
    const d = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof d.type == "string") {
      const g = (
        // `hast`
        typeof d.tagName == "string" ? d.tagName : (
          // `xast`
          typeof d.name == "string" ? d.name : void 0
        )
      );
      Object.defineProperty(p, "name", {
        value: "node (" + (u.type + (g ? "<" + g + ">" : "")) + ")"
      });
    }
    return p;
    function p() {
      let g = By, b, _, k;
      if ((!n || s(u, l, c[c.length - 1] || void 0)) && (g = K8(t(u, c)), g[0] === Ol))
        return g;
      if ("children" in u && u.children) {
        const C = (
          /** @type {UnistParent} */
          u
        );
        if (C.children && g[0] !== Fy)
          for (_ = (i ? C.children.length : -1) + o, k = c.concat(C); _ > -1 && _ < C.children.length; ) {
            const D = C.children[_];
            if (b = a(D, _, k)(), b[0] === Ol)
              return b;
            _ = typeof b[1] == "number" ? b[1] : _ + o;
          }
      }
      return g;
    }
  }
}
function K8(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [j8, e] : e == null ? By : [e];
}
function G8(e, n, t) {
  const r = po((t || {}).ignore || []), s = Q8(n);
  let o = -1;
  for (; ++o < s.length; )
    Uy(e, "text", a);
  function a(l, c) {
    let d = -1, p;
    for (; ++d < c.length; ) {
      const g = c[d], b = p ? p.children : void 0;
      if (r(
        g,
        b ? b.indexOf(g) : void 0,
        p
      ))
        return;
      p = g;
    }
    if (p)
      return u(l, c);
  }
  function u(l, c) {
    const d = c[c.length - 1], p = s[o][0], g = s[o][1];
    let b = 0;
    const k = d.children.indexOf(l);
    let C = !1, D = [];
    p.lastIndex = 0;
    let M = p.exec(l.value);
    for (; M; ) {
      const j = M.index, F = {
        index: M.index,
        input: M.input,
        stack: [...c, l]
      };
      let O = g(...M, F);
      if (typeof O == "string" && (O = O.length > 0 ? { type: "text", value: O } : void 0), O === !1 ? p.lastIndex = j + 1 : (b !== j && D.push({
        type: "text",
        value: l.value.slice(b, j)
      }), Array.isArray(O) ? D.push(...O) : O && D.push(O), b = j + M[0].length, C = !0), !p.global)
        break;
      M = p.exec(l.value);
    }
    return C ? (b < l.value.length && D.push({ type: "text", value: l.value.slice(b) }), d.children.splice(k, 1, ...D)) : D = [l], k + D.length;
  }
}
function Q8(e) {
  const n = [];
  if (!Array.isArray(e))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const t = !e[0] || Array.isArray(e[0]) ? e : [e];
  let i = -1;
  for (; ++i < t.length; ) {
    const r = t[i];
    n.push([X8(r[0]), J8(r[1])]);
  }
  return n;
}
function X8(e) {
  return typeof e == "string" ? new RegExp(V8(e), "g") : e;
}
function J8(e) {
  return typeof e == "function" ? e : function() {
    return e;
  };
}
const Dd = "phrasing", Md = ["autolink", "link", "image", "label"];
function Z8() {
  return {
    transforms: [oB],
    enter: {
      literalAutolink: tB,
      literalAutolinkEmail: Bd,
      literalAutolinkHttp: Bd,
      literalAutolinkWww: Bd
    },
    exit: {
      literalAutolink: sB,
      literalAutolinkEmail: rB,
      literalAutolinkHttp: nB,
      literalAutolinkWww: iB
    }
  };
}
function eB() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: Dd,
        notInConstruct: Md
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: Dd,
        notInConstruct: Md
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: Dd,
        notInConstruct: Md
      }
    ]
  };
}
function tB(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function Bd(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function nB(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function iB(e) {
  this.config.exit.data.call(this, e);
  const n = this.stack[this.stack.length - 1];
  n.type, n.url = "http://" + this.sliceSerialize(e);
}
function rB(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function sB(e) {
  this.exit(e);
}
function oB(e) {
  G8(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, aB],
      [new RegExp("(?<=^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"), uB]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function aB(e, n, t, i, r) {
  let s = "";
  if (!Hy(r) || (/^w/i.test(n) && (t = n + t, n = "", s = "http://"), !lB(t)))
    return !1;
  const o = cB(t + i);
  if (!o[0]) return !1;
  const a = {
    type: "link",
    title: null,
    url: s + n + o[0],
    children: [{ type: "text", value: n + o[0] }]
  };
  return o[1] ? [a, { type: "text", value: o[1] }] : a;
}
function uB(e, n, t, i) {
  return (
    // Not an expected previous character.
    !Hy(i, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(t) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + n + "@" + t,
      children: [{ type: "text", value: n + "@" + t }]
    }
  );
}
function lB(e) {
  const n = e.split(".");
  return !(n.length < 2 || n[n.length - 1] && (/_/.test(n[n.length - 1]) || !/[a-zA-Z\d]/.test(n[n.length - 1])) || n[n.length - 2] && (/_/.test(n[n.length - 2]) || !/[a-zA-Z\d]/.test(n[n.length - 2])));
}
function cB(e) {
  const n = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!n)
    return [e, void 0];
  e = e.slice(0, n.index);
  let t = n[0], i = t.indexOf(")");
  const r = vl(e, "(");
  let s = vl(e, ")");
  for (; i !== -1 && r > s; )
    e += t.slice(0, i + 1), t = t.slice(i + 1), i = t.indexOf(")"), s++;
  return [e, t];
}
function Hy(e, n) {
  const t = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || ss(t) || hc(t)) && // If it’s an email, the previous character should not be a slash.
  (!n || t !== 47);
}
function si(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
Vy.peek = EB;
function dB() {
  this.buffer();
}
function hB(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function fB() {
  this.buffer();
}
function mB(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function pB(e) {
  const n = this.resume(), t = this.stack[this.stack.length - 1];
  t.type, t.identifier = si(
    this.sliceSerialize(e)
  ).toLowerCase(), t.label = n;
}
function gB(e) {
  this.exit(e);
}
function bB(e) {
  const n = this.resume(), t = this.stack[this.stack.length - 1];
  t.type, t.identifier = si(
    this.sliceSerialize(e)
  ).toLowerCase(), t.label = n;
}
function _B(e) {
  this.exit(e);
}
function EB() {
  return "[";
}
function Vy(e, n, t, i) {
  const r = t.createTracker(i);
  let s = r.move("[^");
  const o = t.enter("footnoteReference"), a = t.enter("reference");
  return s += r.move(
    t.safe(t.associationId(e), { after: "]", before: s })
  ), a(), o(), s += r.move("]"), s;
}
function TB() {
  return {
    enter: {
      gfmFootnoteCallString: dB,
      gfmFootnoteCall: hB,
      gfmFootnoteDefinitionLabelString: fB,
      gfmFootnoteDefinition: mB
    },
    exit: {
      gfmFootnoteCallString: pB,
      gfmFootnoteCall: gB,
      gfmFootnoteDefinitionLabelString: bB,
      gfmFootnoteDefinition: _B
    }
  };
}
function yB(e) {
  let n = !1;
  return e && e.firstLineBlank && (n = !0), {
    handlers: { footnoteDefinition: t, footnoteReference: Vy },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function t(i, r, s, o) {
    const a = s.createTracker(o);
    let u = a.move("[^");
    const l = s.enter("footnoteDefinition"), c = s.enter("label");
    return u += a.move(
      s.safe(s.associationId(i), { before: u, after: "]" })
    ), c(), u += a.move("]:"), i.children && i.children.length > 0 && (a.shift(4), u += a.move(
      (n ? `
` : " ") + s.indentLines(
        s.containerFlow(i, a.current()),
        n ? $y : wB
      )
    )), l(), u;
  }
}
function wB(e, n, t) {
  return n === 0 ? e : $y(e, n, t);
}
function $y(e, n, t) {
  return (t ? "" : "    ") + e;
}
const AB = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
Wy.peek = xB;
function CB() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: SB },
    exit: { strikethrough: IB }
  };
}
function kB() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: AB
      }
    ],
    handlers: { delete: Wy }
  };
}
function SB(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function IB(e) {
  this.exit(e);
}
function Wy(e, n, t, i) {
  const r = t.createTracker(i), s = t.enter("strikethrough");
  let o = r.move("~~");
  return o += t.containerPhrasing(e, {
    ...r.current(),
    before: o,
    after: "~"
  }), o += r.move("~~"), s(), o;
}
function xB() {
  return "~";
}
function vB(e) {
  return e.length;
}
function PB(e, n) {
  const t = n || {}, i = (t.align || []).concat(), r = t.stringLength || vB, s = [], o = [], a = [], u = [];
  let l = 0, c = -1;
  for (; ++c < e.length; ) {
    const _ = [], k = [];
    let C = -1;
    for (e[c].length > l && (l = e[c].length); ++C < e[c].length; ) {
      const D = OB(e[c][C]);
      if (t.alignDelimiters !== !1) {
        const M = r(D);
        k[C] = M, (u[C] === void 0 || M > u[C]) && (u[C] = M);
      }
      _.push(D);
    }
    o[c] = _, a[c] = k;
  }
  let d = -1;
  if (typeof i == "object" && "length" in i)
    for (; ++d < l; )
      s[d] = _b(i[d]);
  else {
    const _ = _b(i);
    for (; ++d < l; )
      s[d] = _;
  }
  d = -1;
  const p = [], g = [];
  for (; ++d < l; ) {
    const _ = s[d];
    let k = "", C = "";
    _ === 99 ? (k = ":", C = ":") : _ === 108 ? k = ":" : _ === 114 && (C = ":");
    let D = t.alignDelimiters === !1 ? 1 : Math.max(
      1,
      u[d] - k.length - C.length
    );
    const M = k + "-".repeat(D) + C;
    t.alignDelimiters !== !1 && (D = k.length + D + C.length, D > u[d] && (u[d] = D), g[d] = D), p[d] = M;
  }
  o.splice(1, 0, p), a.splice(1, 0, g), c = -1;
  const b = [];
  for (; ++c < o.length; ) {
    const _ = o[c], k = a[c];
    d = -1;
    const C = [];
    for (; ++d < l; ) {
      const D = _[d] || "";
      let M = "", j = "";
      if (t.alignDelimiters !== !1) {
        const F = u[d] - (k[d] || 0), O = s[d];
        O === 114 ? M = " ".repeat(F) : O === 99 ? F % 2 ? (M = " ".repeat(F / 2 + 0.5), j = " ".repeat(F / 2 - 0.5)) : (M = " ".repeat(F / 2), j = M) : j = " ".repeat(F);
      }
      t.delimiterStart !== !1 && !d && C.push("|"), t.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(t.alignDelimiters === !1 && D === "") && (t.delimiterStart !== !1 || d) && C.push(" "), t.alignDelimiters !== !1 && C.push(M), C.push(D), t.alignDelimiters !== !1 && C.push(j), t.padding !== !1 && C.push(" "), (t.delimiterEnd !== !1 || d !== l - 1) && C.push("|");
    }
    b.push(
      t.delimiterEnd === !1 ? C.join("").replace(/ +$/, "") : C.join("")
    );
  }
  return b.join(`
`);
}
function OB(e) {
  return e == null ? "" : String(e);
}
function _b(e) {
  const n = typeof e == "string" ? e.codePointAt(0) : 0;
  return n === 67 || n === 99 ? 99 : n === 76 || n === 108 ? 108 : n === 82 || n === 114 ? 114 : 0;
}
const Eb = {}.hasOwnProperty;
function mc(e, n) {
  const t = n || {};
  function i(r, ...s) {
    let o = i.invalid;
    const a = i.handlers;
    if (r && Eb.call(r, e)) {
      const u = String(r[e]);
      o = Eb.call(a, u) ? a[u] : i.unknown;
    }
    if (o)
      return o.call(this, r, ...s);
  }
  return i.handlers = t.handlers || {}, i.invalid = t.invalid, i.unknown = t.unknown, i;
}
const NB = {}.hasOwnProperty;
function zy(e, n) {
  let t = -1, i;
  if (n.extensions)
    for (; ++t < n.extensions.length; )
      zy(e, n.extensions[t]);
  for (i in n)
    if (NB.call(n, i))
      switch (i) {
        case "extensions":
          break;
        case "unsafe": {
          Tb(e[i], n[i]);
          break;
        }
        case "join": {
          Tb(e[i], n[i]);
          break;
        }
        case "handlers": {
          RB(e[i], n[i]);
          break;
        }
        default:
          e.options[i] = n[i];
      }
  return e;
}
function Tb(e, n) {
  n && e.push(...n);
}
function RB(e, n) {
  n && Object.assign(e, n);
}
function LB(e, n, t, i) {
  const r = t.enter("blockquote"), s = t.createTracker(i);
  s.move("> "), s.shift(2);
  const o = t.indentLines(
    t.containerFlow(e, s.current()),
    DB
  );
  return r(), o;
}
function DB(e, n, t) {
  return ">" + (t ? "" : " ") + e;
}
function qy(e, n) {
  return yb(e, n.inConstruct, !0) && !yb(e, n.notInConstruct, !1);
}
function yb(e, n, t) {
  if (typeof n == "string" && (n = [n]), !n || n.length === 0)
    return t;
  let i = -1;
  for (; ++i < n.length; )
    if (e.includes(n[i]))
      return !0;
  return !1;
}
function wb(e, n, t, i) {
  let r = -1;
  for (; ++r < t.unsafe.length; )
    if (t.unsafe[r].character === `
` && qy(t.stack, t.unsafe[r]))
      return /[ \t]/.test(i.before) ? "" : " ";
  return `\\
`;
}
function MB(e, n) {
  const t = String(e);
  let i = t.indexOf(n), r = i, s = 0, o = 0;
  if (typeof n != "string")
    throw new TypeError("Expected substring");
  for (; i !== -1; )
    i === r ? ++s > o && (o = s) : s = 1, r = i + n.length, i = t.indexOf(n, r);
  return o;
}
function Jh(e, n) {
  return !!(n.options.fences === !1 && e.value && // If there’s no info…
  !e.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(e.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(e.value));
}
function BB(e) {
  const n = e.options.fence || "`";
  if (n !== "`" && n !== "~")
    throw new Error(
      "Cannot serialize code with `" + n + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return n;
}
function FB(e, n, t, i) {
  const r = BB(t), s = e.value || "", o = r === "`" ? "GraveAccent" : "Tilde";
  if (Jh(e, t)) {
    const d = t.enter("codeIndented"), p = t.indentLines(s, UB);
    return d(), p;
  }
  const a = t.createTracker(i), u = r.repeat(Math.max(MB(s, r) + 1, 3)), l = t.enter("codeFenced");
  let c = a.move(u);
  if (e.lang) {
    const d = t.enter(`codeFencedLang${o}`);
    c += a.move(
      t.safe(e.lang, {
        before: c,
        after: " ",
        encode: ["`"],
        ...a.current()
      })
    ), d();
  }
  if (e.lang && e.meta) {
    const d = t.enter(`codeFencedMeta${o}`);
    c += a.move(" "), c += a.move(
      t.safe(e.meta, {
        before: c,
        after: `
`,
        encode: ["`"],
        ...a.current()
      })
    ), d();
  }
  return c += a.move(`
`), s && (c += a.move(s + `
`)), c += a.move(u), l(), c;
}
function UB(e, n, t) {
  return (t ? "" : "    ") + e;
}
function bm(e) {
  const n = e.options.quote || '"';
  if (n !== '"' && n !== "'")
    throw new Error(
      "Cannot serialize title with `" + n + "` for `options.quote`, expected `\"`, or `'`"
    );
  return n;
}
function HB(e, n, t, i) {
  const r = bm(t), s = r === '"' ? "Quote" : "Apostrophe", o = t.enter("definition");
  let a = t.enter("label");
  const u = t.createTracker(i);
  let l = u.move("[");
  return l += u.move(
    t.safe(t.associationId(e), {
      before: l,
      after: "]",
      ...u.current()
    })
  ), l += u.move("]: "), a(), // If there’s no url, or…
  !e.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (a = t.enter("destinationLiteral"), l += u.move("<"), l += u.move(
    t.safe(e.url, { before: l, after: ">", ...u.current() })
  ), l += u.move(">")) : (a = t.enter("destinationRaw"), l += u.move(
    t.safe(e.url, {
      before: l,
      after: e.title ? " " : `
`,
      ...u.current()
    })
  )), a(), e.title && (a = t.enter(`title${s}`), l += u.move(" " + r), l += u.move(
    t.safe(e.title, {
      before: l,
      after: r,
      ...u.current()
    })
  ), l += u.move(r), a()), o(), l;
}
function VB(e) {
  const n = e.options.emphasis || "*";
  if (n !== "*" && n !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + n + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return n;
}
function Ar(e) {
  return "&#x" + e.toString(16).toUpperCase() + ";";
}
function so(e) {
  if (e === null || et(e) || ss(e))
    return 1;
  if (hc(e))
    return 2;
}
function Nl(e, n, t) {
  const i = so(e), r = so(n);
  return i === void 0 ? r === void 0 ? (
    // Letter inside:
    // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    t === "_" ? { inside: !0, outside: !0 } : { inside: !1, outside: !1 }
  ) : r === 1 ? (
    // Whitespace inside: encode both (letter, whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: encode outer (letter)
    { inside: !1, outside: !0 }
  ) : i === 1 ? r === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : r === 1 ? (
    // Whitespace inside: encode both (whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  ) : r === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : r === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: !0, outside: !1 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  );
}
Yy.peek = $B;
function Yy(e, n, t, i) {
  const r = VB(t), s = t.enter("emphasis"), o = t.createTracker(i), a = o.move(r);
  let u = o.move(
    t.containerPhrasing(e, {
      after: r,
      before: a,
      ...o.current()
    })
  );
  const l = u.charCodeAt(0), c = Nl(
    i.before.charCodeAt(i.before.length - 1),
    l,
    r
  );
  c.inside && (u = Ar(l) + u.slice(1));
  const d = u.charCodeAt(u.length - 1), p = Nl(i.after.charCodeAt(0), d, r);
  p.inside && (u = u.slice(0, -1) + Ar(d));
  const g = o.move(r);
  return s(), t.attentionEncodeSurroundingInfo = {
    after: p.outside,
    before: c.outside
  }, a + u + g;
}
function $B(e, n, t) {
  return t.options.emphasis || "*";
}
function Cr(e, n, t, i) {
  let r, s, o;
  typeof n == "function" && typeof t != "function" ? (s = void 0, o = n, r = t) : (s = n, o = t, r = i), Uy(e, s, a, r);
  function a(u, l) {
    const c = l[l.length - 1], d = c ? c.children.indexOf(u) : void 0;
    return o(u, d, c);
  }
}
const WB = {};
function pc(e, n) {
  const t = WB, i = typeof t.includeImageAlt == "boolean" ? t.includeImageAlt : !0, r = typeof t.includeHtml == "boolean" ? t.includeHtml : !0;
  return jy(e, i, r);
}
function jy(e, n, t) {
  if (zB(e)) {
    if ("value" in e)
      return e.type === "html" && !t ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Ab(e.children, n, t);
  }
  return Array.isArray(e) ? Ab(e, n, t) : "";
}
function Ab(e, n, t) {
  const i = [];
  let r = -1;
  for (; ++r < e.length; )
    i[r] = jy(e[r], n, t);
  return i.join("");
}
function zB(e) {
  return !!(e && typeof e == "object");
}
function Ky(e, n) {
  let t = !1;
  return Cr(e, function(i) {
    if ("value" in i && /\r?\n|\r/.test(i.value) || i.type === "break")
      return t = !0, Ol;
  }), !!((!e.depth || e.depth < 3) && pc(e) && (n.options.setext || t));
}
function qB(e, n, t, i) {
  const r = Math.max(Math.min(6, e.depth || 1), 1), s = t.createTracker(i);
  if (Ky(e, t)) {
    const c = t.enter("headingSetext"), d = t.enter("phrasing"), p = t.containerPhrasing(e, {
      ...s.current(),
      before: `
`,
      after: `
`
    });
    return d(), c(), p + `
` + (r === 1 ? "=" : "-").repeat(
      // The whole size…
      p.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(p.lastIndexOf("\r"), p.lastIndexOf(`
`)) + 1)
    );
  }
  const o = "#".repeat(r), a = t.enter("headingAtx"), u = t.enter("phrasing");
  s.move(o + " ");
  let l = t.containerPhrasing(e, {
    before: "# ",
    after: `
`,
    ...s.current()
  });
  return /^[\t ]/.test(l) && (l = Ar(l.charCodeAt(0)) + l.slice(1)), l = l ? o + " " + l : o, t.options.closeAtx && (l += " " + o), u(), a(), l;
}
Gy.peek = YB;
function Gy(e) {
  return e.value || "";
}
function YB() {
  return "<";
}
Qy.peek = jB;
function Qy(e, n, t, i) {
  const r = bm(t), s = r === '"' ? "Quote" : "Apostrophe", o = t.enter("image");
  let a = t.enter("label");
  const u = t.createTracker(i);
  let l = u.move("![");
  return l += u.move(
    t.safe(e.alt, { before: l, after: "]", ...u.current() })
  ), l += u.move("]("), a(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (a = t.enter("destinationLiteral"), l += u.move("<"), l += u.move(
    t.safe(e.url, { before: l, after: ">", ...u.current() })
  ), l += u.move(">")) : (a = t.enter("destinationRaw"), l += u.move(
    t.safe(e.url, {
      before: l,
      after: e.title ? " " : ")",
      ...u.current()
    })
  )), a(), e.title && (a = t.enter(`title${s}`), l += u.move(" " + r), l += u.move(
    t.safe(e.title, {
      before: l,
      after: r,
      ...u.current()
    })
  ), l += u.move(r), a()), l += u.move(")"), o(), l;
}
function jB() {
  return "!";
}
Xy.peek = KB;
function Xy(e, n, t, i) {
  const r = e.referenceType, s = t.enter("imageReference");
  let o = t.enter("label");
  const a = t.createTracker(i);
  let u = a.move("![");
  const l = t.safe(e.alt, {
    before: u,
    after: "]",
    ...a.current()
  });
  u += a.move(l + "]["), o();
  const c = t.stack;
  t.stack = [], o = t.enter("reference");
  const d = t.safe(t.associationId(e), {
    before: u,
    after: "]",
    ...a.current()
  });
  return o(), t.stack = c, s(), r === "full" || !l || l !== d ? u += a.move(d + "]") : r === "shortcut" ? u = u.slice(0, -1) : u += a.move("]"), u;
}
function KB() {
  return "!";
}
Jy.peek = GB;
function Jy(e, n, t) {
  let i = e.value || "", r = "`", s = -1;
  for (; new RegExp("(^|[^`])" + r + "([^`]|$)").test(i); )
    r += "`";
  for (/[^ \r\n]/.test(i) && (/^[ \r\n]/.test(i) && /[ \r\n]$/.test(i) || /^`|`$/.test(i)) && (i = " " + i + " "); ++s < t.unsafe.length; ) {
    const o = t.unsafe[s], a = t.compilePattern(o);
    let u;
    if (o.atBreak)
      for (; u = a.exec(i); ) {
        let l = u.index;
        i.charCodeAt(l) === 10 && i.charCodeAt(l - 1) === 13 && l--, i = i.slice(0, l) + " " + i.slice(u.index + 1);
      }
  }
  return r + i + r;
}
function GB() {
  return "`";
}
function Zy(e, n) {
  const t = pc(e);
  return !!(!n.options.resourceLink && // If there’s a url…
  e.url && // And there’s a no title…
  !e.title && // And the content of `node` is a single text node…
  e.children && e.children.length === 1 && e.children[0].type === "text" && // And if the url is the same as the content…
  (t === e.url || "mailto:" + t === e.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(e.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(e.url));
}
ew.peek = QB;
function ew(e, n, t, i) {
  const r = bm(t), s = r === '"' ? "Quote" : "Apostrophe", o = t.createTracker(i);
  let a, u;
  if (Zy(e, t)) {
    const c = t.stack;
    t.stack = [], a = t.enter("autolink");
    let d = o.move("<");
    return d += o.move(
      t.containerPhrasing(e, {
        before: d,
        after: ">",
        ...o.current()
      })
    ), d += o.move(">"), a(), t.stack = c, d;
  }
  a = t.enter("link"), u = t.enter("label");
  let l = o.move("[");
  return l += o.move(
    t.containerPhrasing(e, {
      before: l,
      after: "](",
      ...o.current()
    })
  ), l += o.move("]("), u(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (u = t.enter("destinationLiteral"), l += o.move("<"), l += o.move(
    t.safe(e.url, { before: l, after: ">", ...o.current() })
  ), l += o.move(">")) : (u = t.enter("destinationRaw"), l += o.move(
    t.safe(e.url, {
      before: l,
      after: e.title ? " " : ")",
      ...o.current()
    })
  )), u(), e.title && (u = t.enter(`title${s}`), l += o.move(" " + r), l += o.move(
    t.safe(e.title, {
      before: l,
      after: r,
      ...o.current()
    })
  ), l += o.move(r), u()), l += o.move(")"), a(), l;
}
function QB(e, n, t) {
  return Zy(e, t) ? "<" : "[";
}
tw.peek = XB;
function tw(e, n, t, i) {
  const r = e.referenceType, s = t.enter("linkReference");
  let o = t.enter("label");
  const a = t.createTracker(i);
  let u = a.move("[");
  const l = t.containerPhrasing(e, {
    before: u,
    after: "]",
    ...a.current()
  });
  u += a.move(l + "]["), o();
  const c = t.stack;
  t.stack = [], o = t.enter("reference");
  const d = t.safe(t.associationId(e), {
    before: u,
    after: "]",
    ...a.current()
  });
  return o(), t.stack = c, s(), r === "full" || !l || l !== d ? u += a.move(d + "]") : r === "shortcut" ? u = u.slice(0, -1) : u += a.move("]"), u;
}
function XB() {
  return "[";
}
function _m(e) {
  const n = e.options.bullet || "*";
  if (n !== "*" && n !== "+" && n !== "-")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return n;
}
function JB(e) {
  const n = _m(e), t = e.options.bulletOther;
  if (!t)
    return n === "*" ? "-" : "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (t === n)
    throw new Error(
      "Expected `bullet` (`" + n + "`) and `bulletOther` (`" + t + "`) to be different"
    );
  return t;
}
function ZB(e) {
  const n = e.options.bulletOrdered || ".";
  if (n !== "." && n !== ")")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return n;
}
function nw(e) {
  const n = e.options.rule || "*";
  if (n !== "*" && n !== "-" && n !== "_")
    throw new Error(
      "Cannot serialize rules with `" + n + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return n;
}
function eF(e, n, t, i) {
  const r = t.enter("list"), s = t.bulletCurrent;
  let o = e.ordered ? ZB(t) : _m(t);
  const a = e.ordered ? o === "." ? ")" : "." : JB(t);
  let u = n && t.bulletLastUsed ? o === t.bulletLastUsed : !1;
  if (!e.ordered) {
    const c = e.children ? e.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (o === "*" || o === "-") && // Empty first list item:
      c && (!c.children || !c.children[0]) && // Directly in two other list items:
      t.stack[t.stack.length - 1] === "list" && t.stack[t.stack.length - 2] === "listItem" && t.stack[t.stack.length - 3] === "list" && t.stack[t.stack.length - 4] === "listItem" && // That are each the first child.
      t.indexStack[t.indexStack.length - 1] === 0 && t.indexStack[t.indexStack.length - 2] === 0 && t.indexStack[t.indexStack.length - 3] === 0 && (u = !0), nw(t) === o && c
    ) {
      let d = -1;
      for (; ++d < e.children.length; ) {
        const p = e.children[d];
        if (p && p.type === "listItem" && p.children && p.children[0] && p.children[0].type === "thematicBreak") {
          u = !0;
          break;
        }
      }
    }
  }
  u && (o = a), t.bulletCurrent = o;
  const l = t.containerFlow(e, i);
  return t.bulletLastUsed = o, t.bulletCurrent = s, r(), l;
}
function tF(e) {
  const n = e.options.listItemIndent || "one";
  if (n !== "tab" && n !== "one" && n !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return n;
}
function nF(e, n, t, i) {
  const r = tF(t);
  let s = t.bulletCurrent || _m(t);
  n && n.type === "list" && n.ordered && (s = (typeof n.start == "number" && n.start > -1 ? n.start : 1) + (t.options.incrementListMarker === !1 ? 0 : n.children.indexOf(e)) + s);
  let o = s.length + 1;
  (r === "tab" || r === "mixed" && (n && n.type === "list" && n.spread || e.spread)) && (o = Math.ceil(o / 4) * 4);
  const a = t.createTracker(i);
  a.move(s + " ".repeat(o - s.length)), a.shift(o);
  const u = t.enter("listItem"), l = t.indentLines(
    t.containerFlow(e, a.current()),
    c
  );
  return u(), l;
  function c(d, p, g) {
    return p ? (g ? "" : " ".repeat(o)) + d : (g ? s : s + " ".repeat(o - s.length)) + d;
  }
}
function iF(e, n, t, i) {
  const r = t.enter("paragraph"), s = t.enter("phrasing"), o = t.containerPhrasing(e, i);
  return s(), r(), o;
}
const iw = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  po([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function rF(e, n, t, i) {
  return (e.children.some(function(o) {
    return iw(o);
  }) ? t.containerPhrasing : t.containerFlow).call(t, e, i);
}
function sF(e) {
  const n = e.options.strong || "*";
  if (n !== "*" && n !== "_")
    throw new Error(
      "Cannot serialize strong with `" + n + "` for `options.strong`, expected `*`, or `_`"
    );
  return n;
}
rw.peek = oF;
function rw(e, n, t, i) {
  const r = sF(t), s = t.enter("strong"), o = t.createTracker(i), a = o.move(r + r);
  let u = o.move(
    t.containerPhrasing(e, {
      after: r,
      before: a,
      ...o.current()
    })
  );
  const l = u.charCodeAt(0), c = Nl(
    i.before.charCodeAt(i.before.length - 1),
    l,
    r
  );
  c.inside && (u = Ar(l) + u.slice(1));
  const d = u.charCodeAt(u.length - 1), p = Nl(i.after.charCodeAt(0), d, r);
  p.inside && (u = u.slice(0, -1) + Ar(d));
  const g = o.move(r + r);
  return s(), t.attentionEncodeSurroundingInfo = {
    after: p.outside,
    before: c.outside
  }, a + u + g;
}
function oF(e, n, t) {
  return t.options.strong || "*";
}
function aF(e, n, t, i) {
  return t.safe(e.value, i);
}
function uF(e) {
  const n = e.options.ruleRepetition || 3;
  if (n < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + n + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return n;
}
function lF(e, n, t) {
  const i = (nw(t) + (t.options.ruleSpaces ? " " : "")).repeat(uF(t));
  return t.options.ruleSpaces ? i.slice(0, -1) : i;
}
const Em = {
  blockquote: LB,
  break: wb,
  code: FB,
  definition: HB,
  emphasis: Yy,
  hardBreak: wb,
  heading: qB,
  html: Gy,
  image: Qy,
  imageReference: Xy,
  inlineCode: Jy,
  link: ew,
  linkReference: tw,
  list: eF,
  listItem: nF,
  paragraph: iF,
  root: rF,
  strong: rw,
  text: aF,
  thematicBreak: lF
}, cF = [dF];
function dF(e, n, t, i) {
  if (n.type === "code" && Jh(n, i) && (e.type === "list" || e.type === n.type && Jh(e, i)))
    return !1;
  if ("spread" in t && typeof t.spread == "boolean")
    return e.type === "paragraph" && // Two paragraphs.
    (e.type === n.type || n.type === "definition" || // Paragraph followed by a setext heading.
    n.type === "heading" && Ky(n, i)) ? void 0 : t.spread ? 1 : 0;
}
const $r = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
], hF = [
  { character: "	", after: "[\\r\\n]", inConstruct: "phrasing" },
  { character: "	", before: "[\\r\\n]", inConstruct: "phrasing" },
  {
    character: "	",
    inConstruct: ["codeFencedLangGraveAccent", "codeFencedLangTilde"]
  },
  {
    character: "\r",
    inConstruct: [
      "codeFencedLangGraveAccent",
      "codeFencedLangTilde",
      "codeFencedMetaGraveAccent",
      "codeFencedMetaTilde",
      "destinationLiteral",
      "headingAtx"
    ]
  },
  {
    character: `
`,
    inConstruct: [
      "codeFencedLangGraveAccent",
      "codeFencedLangTilde",
      "codeFencedMetaGraveAccent",
      "codeFencedMetaTilde",
      "destinationLiteral",
      "headingAtx"
    ]
  },
  { character: " ", after: "[\\r\\n]", inConstruct: "phrasing" },
  { character: " ", before: "[\\r\\n]", inConstruct: "phrasing" },
  {
    character: " ",
    inConstruct: ["codeFencedLangGraveAccent", "codeFencedLangTilde"]
  },
  // An exclamation mark can start an image, if it is followed by a link or
  // a link reference.
  {
    character: "!",
    after: "\\[",
    inConstruct: "phrasing",
    notInConstruct: $r
  },
  // A quote can break out of a title.
  { character: '"', inConstruct: "titleQuote" },
  // A number sign could start an ATX heading if it starts a line.
  { atBreak: !0, character: "#" },
  { character: "#", inConstruct: "headingAtx", after: `(?:[\r
]|$)` },
  // Dollar sign and percentage are not used in markdown.
  // An ampersand could start a character reference.
  { character: "&", after: "[#A-Za-z]", inConstruct: "phrasing" },
  // An apostrophe can break out of a title.
  { character: "'", inConstruct: "titleApostrophe" },
  // A left paren could break out of a destination raw.
  { character: "(", inConstruct: "destinationRaw" },
  // A left paren followed by `]` could make something into a link or image.
  {
    before: "\\]",
    character: "(",
    inConstruct: "phrasing",
    notInConstruct: $r
  },
  // A right paren could start a list item or break out of a destination
  // raw.
  { atBreak: !0, before: "\\d+", character: ")" },
  { character: ")", inConstruct: "destinationRaw" },
  // An asterisk can start thematic breaks, list items, emphasis, strong.
  { atBreak: !0, character: "*", after: `(?:[ 	\r
*])` },
  { character: "*", inConstruct: "phrasing", notInConstruct: $r },
  // A plus sign could start a list item.
  { atBreak: !0, character: "+", after: `(?:[ 	\r
])` },
  // A dash can start thematic breaks, list items, and setext heading
  // underlines.
  { atBreak: !0, character: "-", after: `(?:[ 	\r
-])` },
  // A dot could start a list item.
  { atBreak: !0, before: "\\d+", character: ".", after: `(?:[ 	\r
]|$)` },
  // Slash, colon, and semicolon are not used in markdown for constructs.
  // A less than can start html (flow or text) or an autolink.
  // HTML could start with an exclamation mark (declaration, cdata, comment),
  // slash (closing tag), question mark (instruction), or a letter (tag).
  // An autolink also starts with a letter.
  // Finally, it could break out of a destination literal.
  { atBreak: !0, character: "<", after: "[!/?A-Za-z]" },
  {
    character: "<",
    after: "[!/?A-Za-z]",
    inConstruct: "phrasing",
    notInConstruct: $r
  },
  { character: "<", inConstruct: "destinationLiteral" },
  // An equals to can start setext heading underlines.
  { atBreak: !0, character: "=" },
  // A greater than can start block quotes and it can break out of a
  // destination literal.
  { atBreak: !0, character: ">" },
  { character: ">", inConstruct: "destinationLiteral" },
  // Question mark and at sign are not used in markdown for constructs.
  // A left bracket can start definitions, references, labels,
  { atBreak: !0, character: "[" },
  { character: "[", inConstruct: "phrasing", notInConstruct: $r },
  { character: "[", inConstruct: ["label", "reference"] },
  // A backslash can start an escape (when followed by punctuation) or a
  // hard break (when followed by an eol).
  // Note: typical escapes are handled in `safe`!
  { character: "\\", after: "[\\r\\n]", inConstruct: "phrasing" },
  // A right bracket can exit labels.
  { character: "]", inConstruct: ["label", "reference"] },
  // Caret is not used in markdown for constructs.
  // An underscore can start emphasis, strong, or a thematic break.
  { atBreak: !0, character: "_" },
  { character: "_", inConstruct: "phrasing", notInConstruct: $r },
  // A grave accent can start code (fenced or text), or it can break out of
  // a grave accent code fence.
  { atBreak: !0, character: "`" },
  {
    character: "`",
    inConstruct: ["codeFencedLangGraveAccent", "codeFencedMetaGraveAccent"]
  },
  { character: "`", inConstruct: "phrasing", notInConstruct: $r },
  // Left brace, vertical bar, right brace are not used in markdown for
  // constructs.
  // A tilde can start code (fenced).
  { atBreak: !0, character: "~" }
], Cb = document.createElement("i");
function Tm(e) {
  const n = "&" + e + ";";
  Cb.innerHTML = n;
  const t = Cb.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    t.charCodeAt(t.length - 1) === 59 && e !== "semi" || t === n ? !1 : t
  );
}
function sw(e, n) {
  const t = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    t < 9 || t === 11 || t > 13 && t < 32 || // Control character (DEL) of C0, and C1 controls.
    t > 126 && t < 160 || // Lone high surrogates and low surrogates.
    t > 55295 && t < 57344 || // Noncharacters.
    t > 64975 && t < 65008 || /* eslint-disable no-bitwise */
    (t & 65535) === 65535 || (t & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    t > 1114111 ? "�" : String.fromCodePoint(t)
  );
}
const fF = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function ow(e) {
  return e.replace(fF, mF);
}
function mF(e, n, t) {
  if (n)
    return n;
  if (t.charCodeAt(0) === 35) {
    const r = t.charCodeAt(1), s = r === 120 || r === 88;
    return sw(t.slice(s ? 2 : 1), s ? 16 : 10);
  }
  return Tm(t) || e;
}
function pF(e) {
  return e.label || !e.identifier ? e.label || "" : ow(e.identifier);
}
function gF(e) {
  if (!e._compiled) {
    const n = (e.atBreak ? "[\\r\\n][\\t ]*" : "") + (e.before ? "(?:" + e.before + ")" : "");
    e._compiled = new RegExp(
      (n ? "(" + n + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(e.character) ? "\\" : "") + e.character + (e.after ? "(?:" + e.after + ")" : ""),
      "g"
    );
  }
  return e._compiled;
}
function bF(e, n, t) {
  const i = n.indexStack, r = e.children || [], s = [];
  let o = -1, a = t.before, u;
  i.push(-1);
  let l = n.createTracker(t);
  for (; ++o < r.length; ) {
    const c = r[o];
    let d;
    if (i[i.length - 1] = o, o + 1 < r.length) {
      let b = n.handle.handlers[r[o + 1].type];
      b && b.peek && (b = b.peek), d = b ? b(r[o + 1], e, n, {
        before: "",
        after: "",
        ...l.current()
      }).charAt(0) : "";
    } else
      d = t.after;
    s.length > 0 && (a === "\r" || a === `
`) && c.type === "html" && (s[s.length - 1] = s[s.length - 1].replace(
      /(\r?\n|\r)$/,
      " "
    ), a = " ", l = n.createTracker(t), l.move(s.join("")));
    let p = n.handle(c, e, n, {
      ...l.current(),
      after: d,
      before: a
    });
    u && u === p.slice(0, 1) && (p = Ar(u.charCodeAt(0)) + p.slice(1));
    const g = n.attentionEncodeSurroundingInfo;
    n.attentionEncodeSurroundingInfo = void 0, u = void 0, g && (s.length > 0 && g.before && a === s[s.length - 1].slice(-1) && (s[s.length - 1] = s[s.length - 1].slice(0, -1) + Ar(a.charCodeAt(0))), g.after && (u = d)), l.move(p), s.push(p), a = p.slice(-1);
  }
  return i.pop(), s.join("");
}
function _F(e, n, t) {
  const i = n.indexStack, r = e.children || [], s = n.createTracker(t), o = [];
  let a = -1;
  for (i.push(-1); ++a < r.length; ) {
    const u = r[a];
    i[i.length - 1] = a, o.push(
      s.move(
        n.handle(u, e, n, {
          before: `
`,
          after: `
`,
          ...s.current()
        })
      )
    ), u.type !== "list" && (n.bulletLastUsed = void 0), a < r.length - 1 && o.push(
      s.move(EF(u, r[a + 1], e, n))
    );
  }
  return i.pop(), o.join("");
}
function EF(e, n, t, i) {
  let r = i.join.length;
  for (; r--; ) {
    const s = i.join[r](e, n, t, i);
    if (s === !0 || s === 1)
      break;
    if (typeof s == "number")
      return `
`.repeat(1 + s);
    if (s === !1)
      return `

<!---->

`;
  }
  return `

`;
}
const TF = /\r?\n|\r/g;
function yF(e, n) {
  const t = [];
  let i = 0, r = 0, s;
  for (; s = TF.exec(e); )
    o(e.slice(i, s.index)), t.push(s[0]), i = s.index + s[0].length, r++;
  return o(e.slice(i)), t.join("");
  function o(a) {
    t.push(n(a, r, !a));
  }
}
function wF(e, n, t) {
  const i = (t.before || "") + (n || "") + (t.after || ""), r = [], s = [], o = {};
  let a = -1;
  for (; ++a < e.unsafe.length; ) {
    const c = e.unsafe[a];
    if (!qy(e.stack, c))
      continue;
    const d = e.compilePattern(c);
    let p;
    for (; p = d.exec(i); ) {
      const g = "before" in c || !!c.atBreak, b = "after" in c, _ = p.index + (g ? p[1].length : 0);
      r.includes(_) ? (o[_].before && !g && (o[_].before = !1), o[_].after && !b && (o[_].after = !1)) : (r.push(_), o[_] = { before: g, after: b });
    }
  }
  r.sort(AF);
  let u = t.before ? t.before.length : 0;
  const l = i.length - (t.after ? t.after.length : 0);
  for (a = -1; ++a < r.length; ) {
    const c = r[a];
    c < u || c >= l || c + 1 < l && r[a + 1] === c + 1 && o[c].after && !o[c + 1].before && !o[c + 1].after || r[a - 1] === c - 1 && o[c].before && !o[c - 1].before && !o[c - 1].after || (u !== c && s.push(kb(i.slice(u, c), "\\")), u = c, /[!-/:-@[-`{-~]/.test(i.charAt(c)) && (!t.encode || !t.encode.includes(i.charAt(c))) ? s.push("\\") : (s.push(Ar(i.charCodeAt(c))), u++));
  }
  return s.push(kb(i.slice(u, l), t.after)), s.join("");
}
function AF(e, n) {
  return e - n;
}
function kb(e, n) {
  const t = /\\(?=[!-/:-@[-`{-~])/g, i = [], r = [], s = e + n;
  let o = -1, a = 0, u;
  for (; u = t.exec(s); )
    i.push(u.index);
  for (; ++o < i.length; )
    a !== i[o] && r.push(e.slice(a, i[o])), r.push("\\"), a = i[o];
  return r.push(e.slice(a)), r.join("");
}
function CF(e) {
  const n = e || {}, t = n.now || {};
  let i = n.lineShift || 0, r = t.line || 1, s = t.column || 1;
  return { move: u, current: o, shift: a };
  function o() {
    return { now: { line: r, column: s }, lineShift: i };
  }
  function a(l) {
    i += l;
  }
  function u(l) {
    const c = l || "", d = c.split(/\r?\n|\r/g), p = d[d.length - 1];
    return r += d.length - 1, s = d.length === 1 ? s + p.length : 1 + p.length + i, c;
  }
}
function kF(e, n) {
  const t = n || {}, i = {
    associationId: pF,
    containerPhrasing: vF,
    containerFlow: PF,
    createTracker: CF,
    compilePattern: gF,
    enter: s,
    // @ts-expect-error: GFM / frontmatter are typed in `mdast` but not defined
    // here.
    handlers: { ...Em },
    // @ts-expect-error: add `handle` in a second.
    handle: void 0,
    indentLines: yF,
    indexStack: [],
    join: [...cF],
    options: {},
    safe: OF,
    stack: [],
    unsafe: [...hF]
  };
  zy(i, t), i.options.tightDefinitions && i.join.push(xF), i.handle = mc("type", {
    invalid: SF,
    unknown: IF,
    handlers: i.handlers
  });
  let r = i.handle(e, void 0, i, {
    before: `
`,
    after: `
`,
    now: { line: 1, column: 1 },
    lineShift: 0
  });
  return r && r.charCodeAt(r.length - 1) !== 10 && r.charCodeAt(r.length - 1) !== 13 && (r += `
`), r;
  function s(o) {
    return i.stack.push(o), a;
    function a() {
      i.stack.pop();
    }
  }
}
function SF(e) {
  throw new Error("Cannot handle value `" + e + "`, expected node");
}
function IF(e) {
  const n = (
    /** @type {Nodes} */
    e
  );
  throw new Error("Cannot handle unknown node `" + n.type + "`");
}
function xF(e, n) {
  if (e.type === "definition" && e.type === n.type)
    return 0;
}
function vF(e, n) {
  return bF(e, this, n);
}
function PF(e, n) {
  return _F(e, this, n);
}
function OF(e, n) {
  return wF(this, e, n);
}
function NF() {
  return {
    enter: {
      table: RF,
      tableData: Sb,
      tableHeader: Sb,
      tableRow: DF
    },
    exit: {
      codeText: MF,
      table: LF,
      tableData: Fd,
      tableHeader: Fd,
      tableRow: Fd
    }
  };
}
function RF(e) {
  const n = e._align;
  this.enter(
    {
      type: "table",
      align: n.map(function(t) {
        return t === "none" ? null : t;
      }),
      children: []
    },
    e
  ), this.data.inTable = !0;
}
function LF(e) {
  this.exit(e), this.data.inTable = void 0;
}
function DF(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function Fd(e) {
  this.exit(e);
}
function Sb(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function MF(e) {
  let n = this.resume();
  this.data.inTable && (n = n.replace(/\\([\\|])/g, BF));
  const t = this.stack[this.stack.length - 1];
  t.type, t.value = n, this.exit(e);
}
function BF(e, n) {
  return n === "|" ? n : e;
}
function FF(e) {
  const n = e || {}, t = n.tableCellPadding, i = n.tablePipeAlign, r = n.stringLength, s = t ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: p,
      table: o,
      tableCell: u,
      tableRow: a
    }
  };
  function o(g, b, _, k) {
    return l(c(g, _, k), g.align);
  }
  function a(g, b, _, k) {
    const C = d(g, _, k), D = l([C]);
    return D.slice(0, D.indexOf(`
`));
  }
  function u(g, b, _, k) {
    const C = _.enter("tableCell"), D = _.enter("phrasing"), M = _.containerPhrasing(g, {
      ...k,
      before: s,
      after: s
    });
    return D(), C(), M;
  }
  function l(g, b) {
    return PB(g, {
      align: b,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: i,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: t,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: r
    });
  }
  function c(g, b, _) {
    const k = g.children;
    let C = -1;
    const D = [], M = b.enter("table");
    for (; ++C < k.length; )
      D[C] = d(k[C], b, _);
    return M(), D;
  }
  function d(g, b, _) {
    const k = g.children;
    let C = -1;
    const D = [], M = b.enter("tableRow");
    for (; ++C < k.length; )
      D[C] = u(k[C], g, b, _);
    return M(), D;
  }
  function p(g, b, _) {
    let k = Em.inlineCode(g, b, _);
    return _.stack.includes("tableCell") && (k = k.replace(/\|/g, "\\$&")), k;
  }
}
function UF() {
  return {
    exit: {
      taskListCheckValueChecked: Ib,
      taskListCheckValueUnchecked: Ib,
      paragraph: VF
    }
  };
}
function HF() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: $F }
  };
}
function Ib(e) {
  const n = this.stack[this.stack.length - 2];
  n.type, n.checked = e.type === "taskListCheckValueChecked";
}
function VF(e) {
  const n = this.stack[this.stack.length - 2];
  if (n && n.type === "listItem" && typeof n.checked == "boolean") {
    const t = this.stack[this.stack.length - 1];
    t.type;
    const i = t.children[0];
    if (i && i.type === "text") {
      const r = n.children;
      let s = -1, o;
      for (; ++s < r.length; ) {
        const a = r[s];
        if (a.type === "paragraph") {
          o = a;
          break;
        }
      }
      o === t && (i.value = i.value.slice(1), i.value.length === 0 ? t.children.shift() : t.position && i.position && typeof i.position.start.offset == "number" && (i.position.start.column++, i.position.start.offset++, t.position.start = Object.assign({}, i.position.start)));
    }
  }
  this.exit(e);
}
function $F(e, n, t, i) {
  const r = e.children[0], s = typeof e.checked == "boolean" && r && r.type === "paragraph", o = "[" + (e.checked ? "x" : " ") + "] ", a = t.createTracker(i);
  s && a.move(o);
  let u = Em.listItem(e, n, t, {
    ...i,
    ...a.current()
  });
  return s && (u = u.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, l)), u;
  function l(c) {
    return c + o;
  }
}
function WF() {
  return [
    Z8(),
    TB(),
    CB(),
    NF(),
    UF()
  ];
}
function zF(e) {
  return {
    extensions: [
      eB(),
      yB(e),
      kB(),
      FF(e),
      HF()
    ]
  };
}
function vn(e, n, t, i) {
  const r = e.length;
  let s = 0, o;
  if (n < 0 ? n = -n > r ? 0 : r + n : n = n > r ? r : n, t = t > 0 ? t : 0, i.length < 1e4)
    o = Array.from(i), o.unshift(n, t), e.splice(...o);
  else
    for (t && e.splice(n, t); s < i.length; )
      o = i.slice(s, s + 1e4), o.unshift(n, 0), e.splice(...o), s += 1e4, n += 1e4;
}
function Un(e, n) {
  return e.length > 0 ? (vn(e, e.length, 0, n), e) : n;
}
const xb = {}.hasOwnProperty;
function aw(e) {
  const n = {};
  let t = -1;
  for (; ++t < e.length; )
    qF(n, e[t]);
  return n;
}
function qF(e, n) {
  let t;
  for (t in n) {
    const r = (xb.call(e, t) ? e[t] : void 0) || (e[t] = {}), s = n[t];
    let o;
    if (s)
      for (o in s) {
        xb.call(r, o) || (r[o] = []);
        const a = s[o];
        YF(
          // @ts-expect-error Looks like a list.
          r[o],
          Array.isArray(a) ? a : a ? [a] : []
        );
      }
  }
}
function YF(e, n) {
  let t = -1;
  const i = [];
  for (; ++t < n.length; )
    (n[t].add === "after" ? e : i).push(n[t]);
  vn(e, 0, 0, i);
}
const jF = {
  tokenize: ZF,
  partial: !0
}, uw = {
  tokenize: e7,
  partial: !0
}, lw = {
  tokenize: t7,
  partial: !0
}, cw = {
  tokenize: n7,
  partial: !0
}, KF = {
  tokenize: i7,
  partial: !0
}, dw = {
  name: "wwwAutolink",
  tokenize: XF,
  previous: fw
}, hw = {
  name: "protocolAutolink",
  tokenize: JF,
  previous: mw
}, Zi = {
  name: "emailAutolink",
  tokenize: QF,
  previous: pw
}, xi = {};
function GF() {
  return {
    text: xi
  };
}
let Wr = 48;
for (; Wr < 123; )
  xi[Wr] = Zi, Wr++, Wr === 58 ? Wr = 65 : Wr === 91 && (Wr = 97);
xi[43] = Zi;
xi[45] = Zi;
xi[46] = Zi;
xi[95] = Zi;
xi[72] = [Zi, hw];
xi[104] = [Zi, hw];
xi[87] = [Zi, dw];
xi[119] = [Zi, dw];
function QF(e, n, t) {
  const i = this;
  let r, s;
  return o;
  function o(d) {
    return !Zh(d) || !pw.call(i, i.previous) || ym(i.events) ? t(d) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), a(d));
  }
  function a(d) {
    return Zh(d) ? (e.consume(d), a) : d === 64 ? (e.consume(d), u) : t(d);
  }
  function u(d) {
    return d === 46 ? e.check(KF, c, l)(d) : d === 45 || d === 95 || Xt(d) ? (s = !0, e.consume(d), u) : c(d);
  }
  function l(d) {
    return e.consume(d), r = !0, u;
  }
  function c(d) {
    return s && r && on(i.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), n(d)) : t(d);
  }
}
function XF(e, n, t) {
  const i = this;
  return r;
  function r(o) {
    return o !== 87 && o !== 119 || !fw.call(i, i.previous) || ym(i.events) ? t(o) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(jF, e.attempt(uw, e.attempt(lw, s), t), t)(o));
  }
  function s(o) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), n(o);
  }
}
function JF(e, n, t) {
  const i = this;
  let r = "", s = !1;
  return o;
  function o(d) {
    return (d === 72 || d === 104) && mw.call(i, i.previous) && !ym(i.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), r += String.fromCodePoint(d), e.consume(d), a) : t(d);
  }
  function a(d) {
    if (on(d) && r.length < 5)
      return r += String.fromCodePoint(d), e.consume(d), a;
    if (d === 58) {
      const p = r.toLowerCase();
      if (p === "http" || p === "https")
        return e.consume(d), u;
    }
    return t(d);
  }
  function u(d) {
    return d === 47 ? (e.consume(d), s ? l : (s = !0, u)) : t(d);
  }
  function l(d) {
    return d === null || Pl(d) || et(d) || ss(d) || hc(d) ? t(d) : e.attempt(uw, e.attempt(lw, c), t)(d);
  }
  function c(d) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), n(d);
  }
}
function ZF(e, n, t) {
  let i = 0;
  return r;
  function r(o) {
    return (o === 87 || o === 119) && i < 3 ? (i++, e.consume(o), r) : o === 46 && i === 3 ? (e.consume(o), s) : t(o);
  }
  function s(o) {
    return o === null ? t(o) : n(o);
  }
}
function e7(e, n, t) {
  let i, r, s;
  return o;
  function o(l) {
    return l === 46 || l === 95 ? e.check(cw, u, a)(l) : l === null || et(l) || ss(l) || l !== 45 && hc(l) ? u(l) : (s = !0, e.consume(l), o);
  }
  function a(l) {
    return l === 95 ? i = !0 : (r = i, i = void 0), e.consume(l), o;
  }
  function u(l) {
    return r || i || !s ? t(l) : n(l);
  }
}
function t7(e, n) {
  let t = 0, i = 0;
  return r;
  function r(o) {
    return o === 40 ? (t++, e.consume(o), r) : o === 41 && i < t ? s(o) : o === 33 || o === 34 || o === 38 || o === 39 || o === 41 || o === 42 || o === 44 || o === 46 || o === 58 || o === 59 || o === 60 || o === 63 || o === 93 || o === 95 || o === 126 ? e.check(cw, n, s)(o) : o === null || et(o) || ss(o) ? n(o) : (e.consume(o), r);
  }
  function s(o) {
    return o === 41 && i++, e.consume(o), r;
  }
}
function n7(e, n, t) {
  return i;
  function i(a) {
    return a === 33 || a === 34 || a === 39 || a === 41 || a === 42 || a === 44 || a === 46 || a === 58 || a === 59 || a === 63 || a === 95 || a === 126 ? (e.consume(a), i) : a === 38 ? (e.consume(a), s) : a === 93 ? (e.consume(a), r) : (
      // `<` is an end.
      a === 60 || // So is whitespace.
      a === null || et(a) || ss(a) ? n(a) : t(a)
    );
  }
  function r(a) {
    return a === null || a === 40 || a === 91 || et(a) || ss(a) ? n(a) : i(a);
  }
  function s(a) {
    return on(a) ? o(a) : t(a);
  }
  function o(a) {
    return a === 59 ? (e.consume(a), i) : on(a) ? (e.consume(a), o) : t(a);
  }
}
function i7(e, n, t) {
  return i;
  function i(s) {
    return e.consume(s), r;
  }
  function r(s) {
    return Xt(s) ? t(s) : n(s);
  }
}
function fw(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || et(e);
}
function mw(e) {
  return !on(e);
}
function pw(e) {
  return !(e === 47 || Zh(e));
}
function Zh(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || Xt(e);
}
function ym(e) {
  let n = e.length, t = !1;
  for (; n--; ) {
    const i = e[n][1];
    if ((i.type === "labelLink" || i.type === "labelImage") && !i._balanced) {
      t = !0;
      break;
    }
    if (i._gfmAutolinkLiteralWalkedInto) {
      t = !1;
      break;
    }
  }
  return e.length > 0 && !t && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), t;
}
function go(e) {
  const n = [];
  let t = -1, i = 0, r = 0;
  for (; ++t < e.length; ) {
    const s = e.charCodeAt(t);
    let o = "";
    if (s === 37 && Xt(e.charCodeAt(t + 1)) && Xt(e.charCodeAt(t + 2)))
      r = 2;
    else if (s < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(s)) || (o = String.fromCharCode(s));
    else if (s > 55295 && s < 57344) {
      const a = e.charCodeAt(t + 1);
      s < 56320 && a > 56319 && a < 57344 ? (o = String.fromCharCode(s, a), r = 1) : o = "�";
    } else
      o = String.fromCharCode(s);
    o && (n.push(e.slice(i, t), encodeURIComponent(o)), i = t + r + 1, o = ""), r && (t += r, r = 0);
  }
  return n.join("") + e.slice(i);
}
function gc(e, n, t) {
  const i = [];
  let r = -1;
  for (; ++r < e.length; ) {
    const s = e[r].resolveAll;
    s && !i.includes(s) && (n = s(n, t), i.push(s));
  }
  return n;
}
const ef = {
  name: "attention",
  resolveAll: r7,
  tokenize: s7
};
function r7(e, n) {
  let t = -1, i, r, s, o, a, u, l, c;
  for (; ++t < e.length; )
    if (e[t][0] === "enter" && e[t][1].type === "attentionSequence" && e[t][1]._close) {
      for (i = t; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[t][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[t][1]._open) && (e[t][1].end.offset - e[t][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[t][1].end.offset - e[t][1].start.offset) % 3))
            continue;
          u = e[i][1].end.offset - e[i][1].start.offset > 1 && e[t][1].end.offset - e[t][1].start.offset > 1 ? 2 : 1;
          const d = {
            ...e[i][1].end
          }, p = {
            ...e[t][1].start
          };
          vb(d, -u), vb(p, u), o = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: d,
            end: {
              ...e[i][1].end
            }
          }, a = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[t][1].start
            },
            end: p
          }, s = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[t][1].start
            }
          }, r = {
            type: u > 1 ? "strong" : "emphasis",
            start: {
              ...o.start
            },
            end: {
              ...a.end
            }
          }, e[i][1].end = {
            ...o.start
          }, e[t][1].start = {
            ...a.end
          }, l = [], e[i][1].end.offset - e[i][1].start.offset && (l = Un(l, [["enter", e[i][1], n], ["exit", e[i][1], n]])), l = Un(l, [["enter", r, n], ["enter", o, n], ["exit", o, n], ["enter", s, n]]), l = Un(l, gc(n.parser.constructs.insideSpan.null, e.slice(i + 1, t), n)), l = Un(l, [["exit", s, n], ["enter", a, n], ["exit", a, n], ["exit", r, n]]), e[t][1].end.offset - e[t][1].start.offset ? (c = 2, l = Un(l, [["enter", e[t][1], n], ["exit", e[t][1], n]])) : c = 0, vn(e, i - 1, t - i + 3, l), t = i + l.length - c - 2;
          break;
        }
    }
  for (t = -1; ++t < e.length; )
    e[t][1].type === "attentionSequence" && (e[t][1].type = "data");
  return e;
}
function s7(e, n) {
  const t = this.parser.constructs.attentionMarkers.null, i = this.previous, r = so(i);
  let s;
  return o;
  function o(u) {
    return s = u, e.enter("attentionSequence"), a(u);
  }
  function a(u) {
    if (u === s)
      return e.consume(u), a;
    const l = e.exit("attentionSequence"), c = so(u), d = !c || c === 2 && r || t.includes(u), p = !r || r === 2 && c || t.includes(i);
    return l._open = !!(s === 42 ? d : d && (r || !p)), l._close = !!(s === 42 ? p : p && (c || !d)), n(u);
  }
}
function vb(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const o7 = {
  name: "autolink",
  tokenize: a7
};
function a7(e, n, t) {
  let i = 0;
  return r;
  function r(g) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), s;
  }
  function s(g) {
    return on(g) ? (e.consume(g), o) : g === 64 ? t(g) : l(g);
  }
  function o(g) {
    return g === 43 || g === 45 || g === 46 || Xt(g) ? (i = 1, a(g)) : l(g);
  }
  function a(g) {
    return g === 58 ? (e.consume(g), i = 0, u) : (g === 43 || g === 45 || g === 46 || Xt(g)) && i++ < 32 ? (e.consume(g), a) : (i = 0, l(g));
  }
  function u(g) {
    return g === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.exit("autolink"), n) : g === null || g === 32 || g === 60 || Pl(g) ? t(g) : (e.consume(g), u);
  }
  function l(g) {
    return g === 64 ? (e.consume(g), c) : F8(g) ? (e.consume(g), l) : t(g);
  }
  function c(g) {
    return Xt(g) ? d(g) : t(g);
  }
  function d(g) {
    return g === 46 ? (e.consume(g), i = 0, c) : g === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.exit("autolink"), n) : p(g);
  }
  function p(g) {
    if ((g === 45 || Xt(g)) && i++ < 63) {
      const b = g === 45 ? p : d;
      return e.consume(g), b;
    }
    return t(g);
  }
}
function Fe(e, n, t, i) {
  const r = i ? i - 1 : Number.POSITIVE_INFINITY;
  let s = 0;
  return o;
  function o(u) {
    return De(u) ? (e.enter(t), a(u)) : n(u);
  }
  function a(u) {
    return De(u) && s++ < r ? (e.consume(u), a) : (e.exit(t), n(u));
  }
}
const uu = {
  partial: !0,
  tokenize: u7
};
function u7(e, n, t) {
  return i;
  function i(s) {
    return De(s) ? Fe(e, r, "linePrefix")(s) : r(s);
  }
  function r(s) {
    return s === null || fe(s) ? n(s) : t(s);
  }
}
const gw = {
  continuation: {
    tokenize: c7
  },
  exit: d7,
  name: "blockQuote",
  tokenize: l7
};
function l7(e, n, t) {
  const i = this;
  return r;
  function r(o) {
    if (o === 62) {
      const a = i.containerState;
      return a.open || (e.enter("blockQuote", {
        _container: !0
      }), a.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), s;
    }
    return t(o);
  }
  function s(o) {
    return De(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(o));
  }
}
function c7(e, n, t) {
  const i = this;
  return r;
  function r(o) {
    return De(o) ? Fe(e, s, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : s(o);
  }
  function s(o) {
    return e.attempt(gw, n, t)(o);
  }
}
function d7(e) {
  e.exit("blockQuote");
}
const bw = {
  name: "characterEscape",
  tokenize: h7
};
function h7(e, n, t) {
  return i;
  function i(s) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(s), e.exit("escapeMarker"), r;
  }
  function r(s) {
    return H8(s) ? (e.enter("characterEscapeValue"), e.consume(s), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : t(s);
  }
}
const _w = {
  name: "characterReference",
  tokenize: f7
};
function f7(e, n, t) {
  const i = this;
  let r = 0, s, o;
  return a;
  function a(d) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), u;
  }
  function u(d) {
    return d === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(d), e.exit("characterReferenceMarkerNumeric"), l) : (e.enter("characterReferenceValue"), s = 31, o = Xt, c(d));
  }
  function l(d) {
    return d === 88 || d === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(d), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), s = 6, o = U8, c) : (e.enter("characterReferenceValue"), s = 7, o = Xh, c(d));
  }
  function c(d) {
    if (d === 59 && r) {
      const p = e.exit("characterReferenceValue");
      return o === Xt && !Tm(i.sliceSerialize(p)) ? t(d) : (e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return o(d) && r++ < s ? (e.consume(d), c) : t(d);
  }
}
const Pb = {
  partial: !0,
  tokenize: p7
}, Ob = {
  concrete: !0,
  name: "codeFenced",
  tokenize: m7
};
function m7(e, n, t) {
  const i = this, r = {
    partial: !0,
    tokenize: F
  };
  let s = 0, o = 0, a;
  return u;
  function u(O) {
    return l(O);
  }
  function l(O) {
    const V = i.events[i.events.length - 1];
    return s = V && V[1].type === "linePrefix" ? V[2].sliceSerialize(V[1], !0).length : 0, a = O, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), c(O);
  }
  function c(O) {
    return O === a ? (o++, e.consume(O), c) : o < 3 ? t(O) : (e.exit("codeFencedFenceSequence"), De(O) ? Fe(e, d, "whitespace")(O) : d(O));
  }
  function d(O) {
    return O === null || fe(O) ? (e.exit("codeFencedFence"), i.interrupt ? n(O) : e.check(Pb, _, j)(O)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), p(O));
  }
  function p(O) {
    return O === null || fe(O) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), d(O)) : De(O) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Fe(e, g, "whitespace")(O)) : O === 96 && O === a ? t(O) : (e.consume(O), p);
  }
  function g(O) {
    return O === null || fe(O) ? d(O) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), b(O));
  }
  function b(O) {
    return O === null || fe(O) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), d(O)) : O === 96 && O === a ? t(O) : (e.consume(O), b);
  }
  function _(O) {
    return e.attempt(r, j, k)(O);
  }
  function k(O) {
    return e.enter("lineEnding"), e.consume(O), e.exit("lineEnding"), C;
  }
  function C(O) {
    return s > 0 && De(O) ? Fe(e, D, "linePrefix", s + 1)(O) : D(O);
  }
  function D(O) {
    return O === null || fe(O) ? e.check(Pb, _, j)(O) : (e.enter("codeFlowValue"), M(O));
  }
  function M(O) {
    return O === null || fe(O) ? (e.exit("codeFlowValue"), D(O)) : (e.consume(O), M);
  }
  function j(O) {
    return e.exit("codeFenced"), n(O);
  }
  function F(O, V, ie) {
    let W = 0;
    return N;
    function N(we) {
      return O.enter("lineEnding"), O.consume(we), O.exit("lineEnding"), Z;
    }
    function Z(we) {
      return O.enter("codeFencedFence"), De(we) ? Fe(O, ee, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(we) : ee(we);
    }
    function ee(we) {
      return we === a ? (O.enter("codeFencedFenceSequence"), Ae(we)) : ie(we);
    }
    function Ae(we) {
      return we === a ? (W++, O.consume(we), Ae) : W >= o ? (O.exit("codeFencedFenceSequence"), De(we) ? Fe(O, Ie, "whitespace")(we) : Ie(we)) : ie(we);
    }
    function Ie(we) {
      return we === null || fe(we) ? (O.exit("codeFencedFence"), V(we)) : ie(we);
    }
  }
}
function p7(e, n, t) {
  const i = this;
  return r;
  function r(o) {
    return o === null ? t(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), s);
  }
  function s(o) {
    return i.parser.lazy[i.now().line] ? t(o) : n(o);
  }
}
const Ud = {
  name: "codeIndented",
  tokenize: b7
}, g7 = {
  partial: !0,
  tokenize: _7
};
function b7(e, n, t) {
  const i = this;
  return r;
  function r(l) {
    return e.enter("codeIndented"), Fe(e, s, "linePrefix", 5)(l);
  }
  function s(l) {
    const c = i.events[i.events.length - 1];
    return c && c[1].type === "linePrefix" && c[2].sliceSerialize(c[1], !0).length >= 4 ? o(l) : t(l);
  }
  function o(l) {
    return l === null ? u(l) : fe(l) ? e.attempt(g7, o, u)(l) : (e.enter("codeFlowValue"), a(l));
  }
  function a(l) {
    return l === null || fe(l) ? (e.exit("codeFlowValue"), o(l)) : (e.consume(l), a);
  }
  function u(l) {
    return e.exit("codeIndented"), n(l);
  }
}
function _7(e, n, t) {
  const i = this;
  return r;
  function r(o) {
    return i.parser.lazy[i.now().line] ? t(o) : fe(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), r) : Fe(e, s, "linePrefix", 5)(o);
  }
  function s(o) {
    const a = i.events[i.events.length - 1];
    return a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? n(o) : fe(o) ? r(o) : t(o);
  }
}
const E7 = {
  name: "codeText",
  previous: y7,
  resolve: T7,
  tokenize: w7
};
function T7(e) {
  let n = e.length - 4, t = 3, i, r;
  if ((e[t][1].type === "lineEnding" || e[t][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = t; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[t][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", t += 2, n -= 2;
        break;
      }
  }
  for (i = t - 1, n++; ++i <= n; )
    r === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (r = i) : (i === n || e[i][1].type === "lineEnding") && (e[r][1].type = "codeTextData", i !== r + 2 && (e[r][1].end = e[i - 1][1].end, e.splice(r + 2, i - r - 2), n -= i - r - 2, i = r + 2), r = void 0);
  return e;
}
function y7(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function w7(e, n, t) {
  let i = 0, r, s;
  return o;
  function o(d) {
    return e.enter("codeText"), e.enter("codeTextSequence"), a(d);
  }
  function a(d) {
    return d === 96 ? (e.consume(d), i++, a) : (e.exit("codeTextSequence"), u(d));
  }
  function u(d) {
    return d === null ? t(d) : d === 32 ? (e.enter("space"), e.consume(d), e.exit("space"), u) : d === 96 ? (s = e.enter("codeTextSequence"), r = 0, c(d)) : fe(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), u) : (e.enter("codeTextData"), l(d));
  }
  function l(d) {
    return d === null || d === 32 || d === 96 || fe(d) ? (e.exit("codeTextData"), u(d)) : (e.consume(d), l);
  }
  function c(d) {
    return d === 96 ? (e.consume(d), r++, c) : r === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(d)) : (s.type = "codeTextData", l(d));
  }
}
class A7 {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, t) {
    const i = t ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, t, i) {
    const r = t || 0;
    this.setCursor(Math.trunc(n));
    const s = this.right.splice(this.right.length - r, Number.POSITIVE_INFINITY);
    return i && Vo(this.left, i), s.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), Vo(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), Vo(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const t = this.left.splice(n, Number.POSITIVE_INFINITY);
        Vo(this.right, t.reverse());
      } else {
        const t = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        Vo(this.left, t.reverse());
      }
  }
}
function Vo(e, n) {
  let t = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; t < n.length; )
      e.push(...n.slice(t, t + 1e4)), t += 1e4;
}
function Ew(e) {
  const n = {};
  let t = -1, i, r, s, o, a, u, l;
  const c = new A7(e);
  for (; ++t < c.length; ) {
    for (; t in n; )
      t = n[t];
    if (i = c.get(t), t && i[1].type === "chunkFlow" && c.get(t - 1)[1].type === "listItemPrefix" && (u = i[1]._tokenizer.events, s = 0, s < u.length && u[s][1].type === "lineEndingBlank" && (s += 2), s < u.length && u[s][1].type === "content"))
      for (; ++s < u.length && u[s][1].type !== "content"; )
        u[s][1].type === "chunkText" && (u[s][1]._isInFirstContentOfListItem = !0, s++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, C7(c, t)), t = n[t], l = !0);
    else if (i[1]._container) {
      for (s = t, r = void 0; s--; )
        if (o = c.get(s), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank")
          o[0] === "enter" && (r && (c.get(r)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", r = s);
        else if (!(o[1].type === "linePrefix" || o[1].type === "listItemIndent")) break;
      r && (i[1].end = {
        ...c.get(r)[1].start
      }, a = c.slice(r, t), a.unshift(i), c.splice(r, t - r + 1, a));
    }
  }
  return vn(e, 0, Number.POSITIVE_INFINITY, c.slice(0)), !l;
}
function C7(e, n) {
  const t = e.get(n)[1], i = e.get(n)[2];
  let r = n - 1;
  const s = [];
  let o = t._tokenizer;
  o || (o = i.parser[t.contentType](t.start), t._contentTypeTextTrailing && (o._contentTypeTextTrailing = !0));
  const a = o.events, u = [], l = {};
  let c, d, p = -1, g = t, b = 0, _ = 0;
  const k = [_];
  for (; g; ) {
    for (; e.get(++r)[1] !== g; )
      ;
    s.push(r), g._tokenizer || (c = i.sliceStream(g), g.next || c.push(null), d && o.defineSkip(g.start), g._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(c), g._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), d = g, g = g.next;
  }
  for (g = t; ++p < a.length; )
    // Find a void token that includes a break.
    a[p][0] === "exit" && a[p - 1][0] === "enter" && a[p][1].type === a[p - 1][1].type && a[p][1].start.line !== a[p][1].end.line && (_ = p + 1, k.push(_), g._tokenizer = void 0, g.previous = void 0, g = g.next);
  for (o.events = [], g ? (g._tokenizer = void 0, g.previous = void 0) : k.pop(), p = k.length; p--; ) {
    const C = a.slice(k[p], k[p + 1]), D = s.pop();
    u.push([D, D + C.length - 1]), e.splice(D, 2, C);
  }
  for (u.reverse(), p = -1; ++p < u.length; )
    l[b + u[p][0]] = b + u[p][1], b += u[p][1] - u[p][0] - 1;
  return l;
}
const k7 = {
  resolve: I7,
  tokenize: x7
}, S7 = {
  partial: !0,
  tokenize: v7
};
function I7(e) {
  return Ew(e), e;
}
function x7(e, n) {
  let t;
  return i;
  function i(a) {
    return e.enter("content"), t = e.enter("chunkContent", {
      contentType: "content"
    }), r(a);
  }
  function r(a) {
    return a === null ? s(a) : fe(a) ? e.check(S7, o, s)(a) : (e.consume(a), r);
  }
  function s(a) {
    return e.exit("chunkContent"), e.exit("content"), n(a);
  }
  function o(a) {
    return e.consume(a), e.exit("chunkContent"), t.next = e.enter("chunkContent", {
      contentType: "content",
      previous: t
    }), t = t.next, r;
  }
}
function v7(e, n, t) {
  const i = this;
  return r;
  function r(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), Fe(e, s, "linePrefix");
  }
  function s(o) {
    if (o === null || fe(o))
      return t(o);
    const a = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? n(o) : e.interrupt(i.parser.constructs.flow, t, n)(o);
  }
}
function Tw(e, n, t, i, r, s, o, a, u) {
  const l = u || Number.POSITIVE_INFINITY;
  let c = 0;
  return d;
  function d(C) {
    return C === 60 ? (e.enter(i), e.enter(r), e.enter(s), e.consume(C), e.exit(s), p) : C === null || C === 32 || C === 41 || Pl(C) ? t(C) : (e.enter(i), e.enter(o), e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), _(C));
  }
  function p(C) {
    return C === 62 ? (e.enter(s), e.consume(C), e.exit(s), e.exit(r), e.exit(i), n) : (e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), g(C));
  }
  function g(C) {
    return C === 62 ? (e.exit("chunkString"), e.exit(a), p(C)) : C === null || C === 60 || fe(C) ? t(C) : (e.consume(C), C === 92 ? b : g);
  }
  function b(C) {
    return C === 60 || C === 62 || C === 92 ? (e.consume(C), g) : g(C);
  }
  function _(C) {
    return !c && (C === null || C === 41 || et(C)) ? (e.exit("chunkString"), e.exit(a), e.exit(o), e.exit(i), n(C)) : c < l && C === 40 ? (e.consume(C), c++, _) : C === 41 ? (e.consume(C), c--, _) : C === null || C === 32 || C === 40 || Pl(C) ? t(C) : (e.consume(C), C === 92 ? k : _);
  }
  function k(C) {
    return C === 40 || C === 41 || C === 92 ? (e.consume(C), _) : _(C);
  }
}
function yw(e, n, t, i, r, s) {
  const o = this;
  let a = 0, u;
  return l;
  function l(g) {
    return e.enter(i), e.enter(r), e.consume(g), e.exit(r), e.enter(s), c;
  }
  function c(g) {
    return a > 999 || g === null || g === 91 || g === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    g === 94 && !a && "_hiddenFootnoteSupport" in o.parser.constructs ? t(g) : g === 93 ? (e.exit(s), e.enter(r), e.consume(g), e.exit(r), e.exit(i), n) : fe(g) ? (e.enter("lineEnding"), e.consume(g), e.exit("lineEnding"), c) : (e.enter("chunkString", {
      contentType: "string"
    }), d(g));
  }
  function d(g) {
    return g === null || g === 91 || g === 93 || fe(g) || a++ > 999 ? (e.exit("chunkString"), c(g)) : (e.consume(g), u || (u = !De(g)), g === 92 ? p : d);
  }
  function p(g) {
    return g === 91 || g === 92 || g === 93 ? (e.consume(g), a++, d) : d(g);
  }
}
function ww(e, n, t, i, r, s) {
  let o;
  return a;
  function a(p) {
    return p === 34 || p === 39 || p === 40 ? (e.enter(i), e.enter(r), e.consume(p), e.exit(r), o = p === 40 ? 41 : p, u) : t(p);
  }
  function u(p) {
    return p === o ? (e.enter(r), e.consume(p), e.exit(r), e.exit(i), n) : (e.enter(s), l(p));
  }
  function l(p) {
    return p === o ? (e.exit(s), u(o)) : p === null ? t(p) : fe(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), Fe(e, l, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), c(p));
  }
  function c(p) {
    return p === o || p === null || fe(p) ? (e.exit("chunkString"), l(p)) : (e.consume(p), p === 92 ? d : c);
  }
  function d(p) {
    return p === o || p === 92 ? (e.consume(p), c) : c(p);
  }
}
function da(e, n) {
  let t;
  return i;
  function i(r) {
    return fe(r) ? (e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), t = !0, i) : De(r) ? Fe(e, i, t ? "linePrefix" : "lineSuffix")(r) : n(r);
  }
}
const P7 = {
  name: "definition",
  tokenize: N7
}, O7 = {
  partial: !0,
  tokenize: R7
};
function N7(e, n, t) {
  const i = this;
  let r;
  return s;
  function s(g) {
    return e.enter("definition"), o(g);
  }
  function o(g) {
    return yw.call(
      i,
      e,
      a,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(g);
  }
  function a(g) {
    return r = si(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), g === 58 ? (e.enter("definitionMarker"), e.consume(g), e.exit("definitionMarker"), u) : t(g);
  }
  function u(g) {
    return et(g) ? da(e, l)(g) : l(g);
  }
  function l(g) {
    return Tw(
      e,
      c,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(g);
  }
  function c(g) {
    return e.attempt(O7, d, d)(g);
  }
  function d(g) {
    return De(g) ? Fe(e, p, "whitespace")(g) : p(g);
  }
  function p(g) {
    return g === null || fe(g) ? (e.exit("definition"), i.parser.defined.push(r), n(g)) : t(g);
  }
}
function R7(e, n, t) {
  return i;
  function i(a) {
    return et(a) ? da(e, r)(a) : t(a);
  }
  function r(a) {
    return ww(e, s, t, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(a);
  }
  function s(a) {
    return De(a) ? Fe(e, o, "whitespace")(a) : o(a);
  }
  function o(a) {
    return a === null || fe(a) ? n(a) : t(a);
  }
}
const L7 = {
  name: "hardBreakEscape",
  tokenize: D7
};
function D7(e, n, t) {
  return i;
  function i(s) {
    return e.enter("hardBreakEscape"), e.consume(s), r;
  }
  function r(s) {
    return fe(s) ? (e.exit("hardBreakEscape"), n(s)) : t(s);
  }
}
const M7 = {
  name: "headingAtx",
  resolve: B7,
  tokenize: F7
};
function B7(e, n) {
  let t = e.length - 2, i = 3, r, s;
  return e[i][1].type === "whitespace" && (i += 2), t - 2 > i && e[t][1].type === "whitespace" && (t -= 2), e[t][1].type === "atxHeadingSequence" && (i === t - 1 || t - 4 > i && e[t - 2][1].type === "whitespace") && (t -= i + 1 === t ? 2 : 4), t > i && (r = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[t][1].end
  }, s = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[t][1].end,
    contentType: "text"
  }, vn(e, i, t - i + 1, [["enter", r, n], ["enter", s, n], ["exit", s, n], ["exit", r, n]])), e;
}
function F7(e, n, t) {
  let i = 0;
  return r;
  function r(c) {
    return e.enter("atxHeading"), s(c);
  }
  function s(c) {
    return e.enter("atxHeadingSequence"), o(c);
  }
  function o(c) {
    return c === 35 && i++ < 6 ? (e.consume(c), o) : c === null || et(c) ? (e.exit("atxHeadingSequence"), a(c)) : t(c);
  }
  function a(c) {
    return c === 35 ? (e.enter("atxHeadingSequence"), u(c)) : c === null || fe(c) ? (e.exit("atxHeading"), n(c)) : De(c) ? Fe(e, a, "whitespace")(c) : (e.enter("atxHeadingText"), l(c));
  }
  function u(c) {
    return c === 35 ? (e.consume(c), u) : (e.exit("atxHeadingSequence"), a(c));
  }
  function l(c) {
    return c === null || c === 35 || et(c) ? (e.exit("atxHeadingText"), a(c)) : (e.consume(c), l);
  }
}
const U7 = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Nb = ["pre", "script", "style", "textarea"], H7 = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: W7,
  tokenize: z7
}, V7 = {
  partial: !0,
  tokenize: Y7
}, $7 = {
  partial: !0,
  tokenize: q7
};
function W7(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function z7(e, n, t) {
  const i = this;
  let r, s, o, a, u;
  return l;
  function l(S) {
    return c(S);
  }
  function c(S) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(S), d;
  }
  function d(S) {
    return S === 33 ? (e.consume(S), p) : S === 47 ? (e.consume(S), s = !0, _) : S === 63 ? (e.consume(S), r = 3, i.interrupt ? n : y) : on(S) ? (e.consume(S), o = String.fromCharCode(S), k) : t(S);
  }
  function p(S) {
    return S === 45 ? (e.consume(S), r = 2, g) : S === 91 ? (e.consume(S), r = 5, a = 0, b) : on(S) ? (e.consume(S), r = 4, i.interrupt ? n : y) : t(S);
  }
  function g(S) {
    return S === 45 ? (e.consume(S), i.interrupt ? n : y) : t(S);
  }
  function b(S) {
    const de = "CDATA[";
    return S === de.charCodeAt(a++) ? (e.consume(S), a === de.length ? i.interrupt ? n : ee : b) : t(S);
  }
  function _(S) {
    return on(S) ? (e.consume(S), o = String.fromCharCode(S), k) : t(S);
  }
  function k(S) {
    if (S === null || S === 47 || S === 62 || et(S)) {
      const de = S === 47, Ce = o.toLowerCase();
      return !de && !s && Nb.includes(Ce) ? (r = 1, i.interrupt ? n(S) : ee(S)) : U7.includes(o.toLowerCase()) ? (r = 6, de ? (e.consume(S), C) : i.interrupt ? n(S) : ee(S)) : (r = 7, i.interrupt && !i.parser.lazy[i.now().line] ? t(S) : s ? D(S) : M(S));
    }
    return S === 45 || Xt(S) ? (e.consume(S), o += String.fromCharCode(S), k) : t(S);
  }
  function C(S) {
    return S === 62 ? (e.consume(S), i.interrupt ? n : ee) : t(S);
  }
  function D(S) {
    return De(S) ? (e.consume(S), D) : N(S);
  }
  function M(S) {
    return S === 47 ? (e.consume(S), N) : S === 58 || S === 95 || on(S) ? (e.consume(S), j) : De(S) ? (e.consume(S), M) : N(S);
  }
  function j(S) {
    return S === 45 || S === 46 || S === 58 || S === 95 || Xt(S) ? (e.consume(S), j) : F(S);
  }
  function F(S) {
    return S === 61 ? (e.consume(S), O) : De(S) ? (e.consume(S), F) : M(S);
  }
  function O(S) {
    return S === null || S === 60 || S === 61 || S === 62 || S === 96 ? t(S) : S === 34 || S === 39 ? (e.consume(S), u = S, V) : De(S) ? (e.consume(S), O) : ie(S);
  }
  function V(S) {
    return S === u ? (e.consume(S), u = null, W) : S === null || fe(S) ? t(S) : (e.consume(S), V);
  }
  function ie(S) {
    return S === null || S === 34 || S === 39 || S === 47 || S === 60 || S === 61 || S === 62 || S === 96 || et(S) ? F(S) : (e.consume(S), ie);
  }
  function W(S) {
    return S === 47 || S === 62 || De(S) ? M(S) : t(S);
  }
  function N(S) {
    return S === 62 ? (e.consume(S), Z) : t(S);
  }
  function Z(S) {
    return S === null || fe(S) ? ee(S) : De(S) ? (e.consume(S), Z) : t(S);
  }
  function ee(S) {
    return S === 45 && r === 2 ? (e.consume(S), ze) : S === 60 && r === 1 ? (e.consume(S), Qe) : S === 62 && r === 4 ? (e.consume(S), re) : S === 63 && r === 3 ? (e.consume(S), y) : S === 93 && r === 5 ? (e.consume(S), jt) : fe(S) && (r === 6 || r === 7) ? (e.exit("htmlFlowData"), e.check(V7, pe, Ae)(S)) : S === null || fe(S) ? (e.exit("htmlFlowData"), Ae(S)) : (e.consume(S), ee);
  }
  function Ae(S) {
    return e.check($7, Ie, pe)(S);
  }
  function Ie(S) {
    return e.enter("lineEnding"), e.consume(S), e.exit("lineEnding"), we;
  }
  function we(S) {
    return S === null || fe(S) ? Ae(S) : (e.enter("htmlFlowData"), ee(S));
  }
  function ze(S) {
    return S === 45 ? (e.consume(S), y) : ee(S);
  }
  function Qe(S) {
    return S === 47 ? (e.consume(S), o = "", Nt) : ee(S);
  }
  function Nt(S) {
    if (S === 62) {
      const de = o.toLowerCase();
      return Nb.includes(de) ? (e.consume(S), re) : ee(S);
    }
    return on(S) && o.length < 8 ? (e.consume(S), o += String.fromCharCode(S), Nt) : ee(S);
  }
  function jt(S) {
    return S === 93 ? (e.consume(S), y) : ee(S);
  }
  function y(S) {
    return S === 62 ? (e.consume(S), re) : S === 45 && r === 2 ? (e.consume(S), y) : ee(S);
  }
  function re(S) {
    return S === null || fe(S) ? (e.exit("htmlFlowData"), pe(S)) : (e.consume(S), re);
  }
  function pe(S) {
    return e.exit("htmlFlow"), n(S);
  }
}
function q7(e, n, t) {
  const i = this;
  return r;
  function r(o) {
    return fe(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), s) : t(o);
  }
  function s(o) {
    return i.parser.lazy[i.now().line] ? t(o) : n(o);
  }
}
function Y7(e, n, t) {
  return i;
  function i(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), e.attempt(uu, n, t);
  }
}
const j7 = {
  name: "htmlText",
  tokenize: K7
};
function K7(e, n, t) {
  const i = this;
  let r, s, o;
  return a;
  function a(y) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(y), u;
  }
  function u(y) {
    return y === 33 ? (e.consume(y), l) : y === 47 ? (e.consume(y), F) : y === 63 ? (e.consume(y), M) : on(y) ? (e.consume(y), ie) : t(y);
  }
  function l(y) {
    return y === 45 ? (e.consume(y), c) : y === 91 ? (e.consume(y), s = 0, b) : on(y) ? (e.consume(y), D) : t(y);
  }
  function c(y) {
    return y === 45 ? (e.consume(y), g) : t(y);
  }
  function d(y) {
    return y === null ? t(y) : y === 45 ? (e.consume(y), p) : fe(y) ? (o = d, Qe(y)) : (e.consume(y), d);
  }
  function p(y) {
    return y === 45 ? (e.consume(y), g) : d(y);
  }
  function g(y) {
    return y === 62 ? ze(y) : y === 45 ? p(y) : d(y);
  }
  function b(y) {
    const re = "CDATA[";
    return y === re.charCodeAt(s++) ? (e.consume(y), s === re.length ? _ : b) : t(y);
  }
  function _(y) {
    return y === null ? t(y) : y === 93 ? (e.consume(y), k) : fe(y) ? (o = _, Qe(y)) : (e.consume(y), _);
  }
  function k(y) {
    return y === 93 ? (e.consume(y), C) : _(y);
  }
  function C(y) {
    return y === 62 ? ze(y) : y === 93 ? (e.consume(y), C) : _(y);
  }
  function D(y) {
    return y === null || y === 62 ? ze(y) : fe(y) ? (o = D, Qe(y)) : (e.consume(y), D);
  }
  function M(y) {
    return y === null ? t(y) : y === 63 ? (e.consume(y), j) : fe(y) ? (o = M, Qe(y)) : (e.consume(y), M);
  }
  function j(y) {
    return y === 62 ? ze(y) : M(y);
  }
  function F(y) {
    return on(y) ? (e.consume(y), O) : t(y);
  }
  function O(y) {
    return y === 45 || Xt(y) ? (e.consume(y), O) : V(y);
  }
  function V(y) {
    return fe(y) ? (o = V, Qe(y)) : De(y) ? (e.consume(y), V) : ze(y);
  }
  function ie(y) {
    return y === 45 || Xt(y) ? (e.consume(y), ie) : y === 47 || y === 62 || et(y) ? W(y) : t(y);
  }
  function W(y) {
    return y === 47 ? (e.consume(y), ze) : y === 58 || y === 95 || on(y) ? (e.consume(y), N) : fe(y) ? (o = W, Qe(y)) : De(y) ? (e.consume(y), W) : ze(y);
  }
  function N(y) {
    return y === 45 || y === 46 || y === 58 || y === 95 || Xt(y) ? (e.consume(y), N) : Z(y);
  }
  function Z(y) {
    return y === 61 ? (e.consume(y), ee) : fe(y) ? (o = Z, Qe(y)) : De(y) ? (e.consume(y), Z) : W(y);
  }
  function ee(y) {
    return y === null || y === 60 || y === 61 || y === 62 || y === 96 ? t(y) : y === 34 || y === 39 ? (e.consume(y), r = y, Ae) : fe(y) ? (o = ee, Qe(y)) : De(y) ? (e.consume(y), ee) : (e.consume(y), Ie);
  }
  function Ae(y) {
    return y === r ? (e.consume(y), r = void 0, we) : y === null ? t(y) : fe(y) ? (o = Ae, Qe(y)) : (e.consume(y), Ae);
  }
  function Ie(y) {
    return y === null || y === 34 || y === 39 || y === 60 || y === 61 || y === 96 ? t(y) : y === 47 || y === 62 || et(y) ? W(y) : (e.consume(y), Ie);
  }
  function we(y) {
    return y === 47 || y === 62 || et(y) ? W(y) : t(y);
  }
  function ze(y) {
    return y === 62 ? (e.consume(y), e.exit("htmlTextData"), e.exit("htmlText"), n) : t(y);
  }
  function Qe(y) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(y), e.exit("lineEnding"), Nt;
  }
  function Nt(y) {
    return De(y) ? Fe(e, jt, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(y) : jt(y);
  }
  function jt(y) {
    return e.enter("htmlTextData"), o(y);
  }
}
const wm = {
  name: "labelEnd",
  resolveAll: J7,
  resolveTo: Z7,
  tokenize: e9
}, G7 = {
  tokenize: t9
}, Q7 = {
  tokenize: n9
}, X7 = {
  tokenize: i9
};
function J7(e) {
  let n = -1;
  const t = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (t.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const r = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += r;
    }
  }
  return e.length !== t.length && vn(e, 0, e.length, t), e;
}
function Z7(e, n) {
  let t = e.length, i = 0, r, s, o, a;
  for (; t--; )
    if (r = e[t][1], s) {
      if (r.type === "link" || r.type === "labelLink" && r._inactive)
        break;
      e[t][0] === "enter" && r.type === "labelLink" && (r._inactive = !0);
    } else if (o) {
      if (e[t][0] === "enter" && (r.type === "labelImage" || r.type === "labelLink") && !r._balanced && (s = t, r.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else r.type === "labelEnd" && (o = t);
  const u = {
    type: e[s][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[s][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, l = {
    type: "label",
    start: {
      ...e[s][1].start
    },
    end: {
      ...e[o][1].end
    }
  }, c = {
    type: "labelText",
    start: {
      ...e[s + i + 2][1].end
    },
    end: {
      ...e[o - 2][1].start
    }
  };
  return a = [["enter", u, n], ["enter", l, n]], a = Un(a, e.slice(s + 1, s + i + 3)), a = Un(a, [["enter", c, n]]), a = Un(a, gc(n.parser.constructs.insideSpan.null, e.slice(s + i + 4, o - 3), n)), a = Un(a, [["exit", c, n], e[o - 2], e[o - 1], ["exit", l, n]]), a = Un(a, e.slice(o + 1)), a = Un(a, [["exit", u, n]]), vn(e, s, e.length, a), e;
}
function e9(e, n, t) {
  const i = this;
  let r = i.events.length, s, o;
  for (; r--; )
    if ((i.events[r][1].type === "labelImage" || i.events[r][1].type === "labelLink") && !i.events[r][1]._balanced) {
      s = i.events[r][1];
      break;
    }
  return a;
  function a(p) {
    return s ? s._inactive ? d(p) : (o = i.parser.defined.includes(si(i.sliceSerialize({
      start: s.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(p), e.exit("labelMarker"), e.exit("labelEnd"), u) : t(p);
  }
  function u(p) {
    return p === 40 ? e.attempt(G7, c, o ? c : d)(p) : p === 91 ? e.attempt(Q7, c, o ? l : d)(p) : o ? c(p) : d(p);
  }
  function l(p) {
    return e.attempt(X7, c, d)(p);
  }
  function c(p) {
    return n(p);
  }
  function d(p) {
    return s._balanced = !0, t(p);
  }
}
function t9(e, n, t) {
  return i;
  function i(d) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), r;
  }
  function r(d) {
    return et(d) ? da(e, s)(d) : s(d);
  }
  function s(d) {
    return d === 41 ? c(d) : Tw(e, o, a, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(d);
  }
  function o(d) {
    return et(d) ? da(e, u)(d) : c(d);
  }
  function a(d) {
    return t(d);
  }
  function u(d) {
    return d === 34 || d === 39 || d === 40 ? ww(e, l, t, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(d) : c(d);
  }
  function l(d) {
    return et(d) ? da(e, c)(d) : c(d);
  }
  function c(d) {
    return d === 41 ? (e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), e.exit("resource"), n) : t(d);
  }
}
function n9(e, n, t) {
  const i = this;
  return r;
  function r(a) {
    return yw.call(i, e, s, o, "reference", "referenceMarker", "referenceString")(a);
  }
  function s(a) {
    return i.parser.defined.includes(si(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(a) : t(a);
  }
  function o(a) {
    return t(a);
  }
}
function i9(e, n, t) {
  return i;
  function i(s) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(s), e.exit("referenceMarker"), r;
  }
  function r(s) {
    return s === 93 ? (e.enter("referenceMarker"), e.consume(s), e.exit("referenceMarker"), e.exit("reference"), n) : t(s);
  }
}
const r9 = {
  name: "labelStartImage",
  resolveAll: wm.resolveAll,
  tokenize: s9
};
function s9(e, n, t) {
  const i = this;
  return r;
  function r(a) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(a), e.exit("labelImageMarker"), s;
  }
  function s(a) {
    return a === 91 ? (e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelImage"), o) : t(a);
  }
  function o(a) {
    return a === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? t(a) : n(a);
  }
}
const o9 = {
  name: "labelStartLink",
  resolveAll: wm.resolveAll,
  tokenize: a9
};
function a9(e, n, t) {
  const i = this;
  return r;
  function r(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), s;
  }
  function s(o) {
    return o === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? t(o) : n(o);
  }
}
const Hd = {
  name: "lineEnding",
  tokenize: u9
};
function u9(e, n) {
  return t;
  function t(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), Fe(e, n, "linePrefix");
  }
}
const nl = {
  name: "thematicBreak",
  tokenize: l9
};
function l9(e, n, t) {
  let i = 0, r;
  return s;
  function s(l) {
    return e.enter("thematicBreak"), o(l);
  }
  function o(l) {
    return r = l, a(l);
  }
  function a(l) {
    return l === r ? (e.enter("thematicBreakSequence"), u(l)) : i >= 3 && (l === null || fe(l)) ? (e.exit("thematicBreak"), n(l)) : t(l);
  }
  function u(l) {
    return l === r ? (e.consume(l), i++, u) : (e.exit("thematicBreakSequence"), De(l) ? Fe(e, a, "whitespace")(l) : a(l));
  }
}
const fn = {
  continuation: {
    tokenize: f9
  },
  exit: p9,
  name: "list",
  tokenize: h9
}, c9 = {
  partial: !0,
  tokenize: g9
}, d9 = {
  partial: !0,
  tokenize: m9
};
function h9(e, n, t) {
  const i = this, r = i.events[i.events.length - 1];
  let s = r && r[1].type === "linePrefix" ? r[2].sliceSerialize(r[1], !0).length : 0, o = 0;
  return a;
  function a(g) {
    const b = i.containerState.type || (g === 42 || g === 43 || g === 45 ? "listUnordered" : "listOrdered");
    if (b === "listUnordered" ? !i.containerState.marker || g === i.containerState.marker : Xh(g)) {
      if (i.containerState.type || (i.containerState.type = b, e.enter(b, {
        _container: !0
      })), b === "listUnordered")
        return e.enter("listItemPrefix"), g === 42 || g === 45 ? e.check(nl, t, l)(g) : l(g);
      if (!i.interrupt || g === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), u(g);
    }
    return t(g);
  }
  function u(g) {
    return Xh(g) && ++o < 10 ? (e.consume(g), u) : (!i.interrupt || o < 2) && (i.containerState.marker ? g === i.containerState.marker : g === 41 || g === 46) ? (e.exit("listItemValue"), l(g)) : t(g);
  }
  function l(g) {
    return e.enter("listItemMarker"), e.consume(g), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || g, e.check(
      uu,
      // Can’t be empty when interrupting.
      i.interrupt ? t : c,
      e.attempt(c9, p, d)
    );
  }
  function c(g) {
    return i.containerState.initialBlankLine = !0, s++, p(g);
  }
  function d(g) {
    return De(g) ? (e.enter("listItemPrefixWhitespace"), e.consume(g), e.exit("listItemPrefixWhitespace"), p) : t(g);
  }
  function p(g) {
    return i.containerState.size = s + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(g);
  }
}
function f9(e, n, t) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(uu, r, s);
  function r(a) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, Fe(e, n, "listItemIndent", i.containerState.size + 1)(a);
  }
  function s(a) {
    return i.containerState.furtherBlankLines || !De(a) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, o(a)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(d9, n, o)(a));
  }
  function o(a) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, Fe(e, e.attempt(fn, n, t), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(a);
  }
}
function m9(e, n, t) {
  const i = this;
  return Fe(e, r, "listItemIndent", i.containerState.size + 1);
  function r(s) {
    const o = i.events[i.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === i.containerState.size ? n(s) : t(s);
  }
}
function p9(e) {
  e.exit(this.containerState.type);
}
function g9(e, n, t) {
  const i = this;
  return Fe(e, r, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function r(s) {
    const o = i.events[i.events.length - 1];
    return !De(s) && o && o[1].type === "listItemPrefixWhitespace" ? n(s) : t(s);
  }
}
const Rb = {
  name: "setextUnderline",
  resolveTo: b9,
  tokenize: _9
};
function b9(e, n) {
  let t = e.length, i, r, s;
  for (; t--; )
    if (e[t][0] === "enter") {
      if (e[t][1].type === "content") {
        i = t;
        break;
      }
      e[t][1].type === "paragraph" && (r = t);
    } else
      e[t][1].type === "content" && e.splice(t, 1), !s && e[t][1].type === "definition" && (s = t);
  const o = {
    type: "setextHeading",
    start: {
      ...e[i][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[r][1].type = "setextHeadingText", s ? (e.splice(r, 0, ["enter", o, n]), e.splice(s + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[s][1].end
  }) : e[i][1] = o, e.push(["exit", o, n]), e;
}
function _9(e, n, t) {
  const i = this;
  let r;
  return s;
  function s(l) {
    let c = i.events.length, d;
    for (; c--; )
      if (i.events[c][1].type !== "lineEnding" && i.events[c][1].type !== "linePrefix" && i.events[c][1].type !== "content") {
        d = i.events[c][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || d) ? (e.enter("setextHeadingLine"), r = l, o(l)) : t(l);
  }
  function o(l) {
    return e.enter("setextHeadingLineSequence"), a(l);
  }
  function a(l) {
    return l === r ? (e.consume(l), a) : (e.exit("setextHeadingLineSequence"), De(l) ? Fe(e, u, "lineSuffix")(l) : u(l));
  }
  function u(l) {
    return l === null || fe(l) ? (e.exit("setextHeadingLine"), n(l)) : t(l);
  }
}
const E9 = {
  tokenize: I9,
  partial: !0
};
function T9() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: C9,
        continuation: {
          tokenize: k9
        },
        exit: S9
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: A9
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: y9,
        resolveTo: w9
      }
    }
  };
}
function y9(e, n, t) {
  const i = this;
  let r = i.events.length;
  const s = i.parser.gfmFootnotes || (i.parser.gfmFootnotes = []);
  let o;
  for (; r--; ) {
    const u = i.events[r][1];
    if (u.type === "labelImage") {
      o = u;
      break;
    }
    if (u.type === "gfmFootnoteCall" || u.type === "labelLink" || u.type === "label" || u.type === "image" || u.type === "link")
      break;
  }
  return a;
  function a(u) {
    if (!o || !o._balanced)
      return t(u);
    const l = si(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }));
    return l.codePointAt(0) !== 94 || !s.includes(l.slice(1)) ? t(u) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(u), e.exit("gfmFootnoteCallLabelMarker"), n(u));
  }
}
function w9(e, n) {
  let t = e.length;
  for (; t--; )
    if (e[t][1].type === "labelImage" && e[t][0] === "enter") {
      e[t][1];
      break;
    }
  e[t + 1][1].type = "data", e[t + 3][1].type = "gfmFootnoteCallLabelMarker";
  const i = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[t + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, r = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[t + 3][1].end),
    end: Object.assign({}, e[t + 3][1].end)
  };
  r.end.column++, r.end.offset++, r.end._bufferIndex++;
  const s = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, r.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, o = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, s.start),
    end: Object.assign({}, s.end)
  }, a = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    e[t + 1],
    e[t + 2],
    ["enter", i, n],
    // The `[`
    e[t + 3],
    e[t + 4],
    // The `^`.
    ["enter", r, n],
    ["exit", r, n],
    // Everything in between.
    ["enter", s, n],
    ["enter", o, n],
    ["exit", o, n],
    ["exit", s, n],
    // The ending (`]`, properly parsed and labelled).
    e[e.length - 2],
    e[e.length - 1],
    ["exit", i, n]
  ];
  return e.splice(t, e.length - t + 1, ...a), e;
}
function A9(e, n, t) {
  const i = this, r = i.parser.gfmFootnotes || (i.parser.gfmFootnotes = []);
  let s = 0, o;
  return a;
  function a(d) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(d), e.exit("gfmFootnoteCallLabelMarker"), u;
  }
  function u(d) {
    return d !== 94 ? t(d) : (e.enter("gfmFootnoteCallMarker"), e.consume(d), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", l);
  }
  function l(d) {
    if (
      // Too long.
      s > 999 || // Closing brace with nothing.
      d === 93 && !o || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      d === null || d === 91 || et(d)
    )
      return t(d);
    if (d === 93) {
      e.exit("chunkString");
      const p = e.exit("gfmFootnoteCallString");
      return r.includes(si(i.sliceSerialize(p))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(d), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), n) : t(d);
    }
    return et(d) || (o = !0), s++, e.consume(d), d === 92 ? c : l;
  }
  function c(d) {
    return d === 91 || d === 92 || d === 93 ? (e.consume(d), s++, l) : l(d);
  }
}
function C9(e, n, t) {
  const i = this, r = i.parser.gfmFootnotes || (i.parser.gfmFootnotes = []);
  let s, o = 0, a;
  return u;
  function u(b) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(b), e.exit("gfmFootnoteDefinitionLabelMarker"), l;
  }
  function l(b) {
    return b === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(b), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", c) : t(b);
  }
  function c(b) {
    if (
      // Too long.
      o > 999 || // Closing brace with nothing.
      b === 93 && !a || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      b === null || b === 91 || et(b)
    )
      return t(b);
    if (b === 93) {
      e.exit("chunkString");
      const _ = e.exit("gfmFootnoteDefinitionLabelString");
      return s = si(i.sliceSerialize(_)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(b), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), p;
    }
    return et(b) || (a = !0), o++, e.consume(b), b === 92 ? d : c;
  }
  function d(b) {
    return b === 91 || b === 92 || b === 93 ? (e.consume(b), o++, c) : c(b);
  }
  function p(b) {
    return b === 58 ? (e.enter("definitionMarker"), e.consume(b), e.exit("definitionMarker"), r.includes(s) || r.push(s), Fe(e, g, "gfmFootnoteDefinitionWhitespace")) : t(b);
  }
  function g(b) {
    return n(b);
  }
}
function k9(e, n, t) {
  return e.check(uu, n, e.attempt(E9, n, t));
}
function S9(e) {
  e.exit("gfmFootnoteDefinition");
}
function I9(e, n, t) {
  const i = this;
  return Fe(e, r, "gfmFootnoteDefinitionIndent", 5);
  function r(s) {
    const o = i.events[i.events.length - 1];
    return o && o[1].type === "gfmFootnoteDefinitionIndent" && o[2].sliceSerialize(o[1], !0).length === 4 ? n(s) : t(s);
  }
}
function x9(e) {
  let t = (e || {}).singleTilde;
  const i = {
    name: "strikethrough",
    tokenize: s,
    resolveAll: r
  };
  return t == null && (t = !0), {
    text: {
      126: i
    },
    insideSpan: {
      null: [i]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function r(o, a) {
    let u = -1;
    for (; ++u < o.length; )
      if (o[u][0] === "enter" && o[u][1].type === "strikethroughSequenceTemporary" && o[u][1]._close) {
        let l = u;
        for (; l--; )
          if (o[l][0] === "exit" && o[l][1].type === "strikethroughSequenceTemporary" && o[l][1]._open && // If the sizes are the same:
          o[u][1].end.offset - o[u][1].start.offset === o[l][1].end.offset - o[l][1].start.offset) {
            o[u][1].type = "strikethroughSequence", o[l][1].type = "strikethroughSequence";
            const c = {
              type: "strikethrough",
              start: Object.assign({}, o[l][1].start),
              end: Object.assign({}, o[u][1].end)
            }, d = {
              type: "strikethroughText",
              start: Object.assign({}, o[l][1].end),
              end: Object.assign({}, o[u][1].start)
            }, p = [["enter", c, a], ["enter", o[l][1], a], ["exit", o[l][1], a], ["enter", d, a]], g = a.parser.constructs.insideSpan.null;
            g && vn(p, p.length, 0, gc(g, o.slice(l + 1, u), a)), vn(p, p.length, 0, [["exit", d, a], ["enter", o[u][1], a], ["exit", o[u][1], a], ["exit", c, a]]), vn(o, l - 1, u - l + 3, p), u = l + p.length - 2;
            break;
          }
      }
    for (u = -1; ++u < o.length; )
      o[u][1].type === "strikethroughSequenceTemporary" && (o[u][1].type = "data");
    return o;
  }
  function s(o, a, u) {
    const l = this.previous, c = this.events;
    let d = 0;
    return p;
    function p(b) {
      return l === 126 && c[c.length - 1][1].type !== "characterEscape" ? u(b) : (o.enter("strikethroughSequenceTemporary"), g(b));
    }
    function g(b) {
      const _ = so(l);
      if (b === 126)
        return d > 1 ? u(b) : (o.consume(b), d++, g);
      if (d < 2 && !t) return u(b);
      const k = o.exit("strikethroughSequenceTemporary"), C = so(b);
      return k._open = !C || C === 2 && !!_, k._close = !_ || _ === 2 && !!C, a(b);
    }
  }
}
class v9 {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(n, t, i) {
    P9(this, n, t, i);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(n) {
    if (this.map.sort(function(s, o) {
      return s[0] - o[0];
    }), this.map.length === 0)
      return;
    let t = this.map.length;
    const i = [];
    for (; t > 0; )
      t -= 1, i.push(n.slice(this.map[t][0] + this.map[t][1]), this.map[t][2]), n.length = this.map[t][0];
    i.push(n.slice()), n.length = 0;
    let r = i.pop();
    for (; r; ) {
      for (const s of r)
        n.push(s);
      r = i.pop();
    }
    this.map.length = 0;
  }
}
function P9(e, n, t, i) {
  let r = 0;
  if (!(t === 0 && i.length === 0)) {
    for (; r < e.map.length; ) {
      if (e.map[r][0] === n) {
        e.map[r][1] += t, e.map[r][2].push(...i);
        return;
      }
      r += 1;
    }
    e.map.push([n, t, i]);
  }
}
function O9(e, n) {
  let t = !1;
  const i = [];
  for (; n < e.length; ) {
    const r = e[n];
    if (t) {
      if (r[0] === "enter")
        r[1].type === "tableContent" && i.push(e[n + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (r[1].type === "tableContent") {
        if (e[n - 1][1].type === "tableDelimiterMarker") {
          const s = i.length - 1;
          i[s] = i[s] === "left" ? "center" : "right";
        }
      } else if (r[1].type === "tableDelimiterRow")
        break;
    } else r[0] === "enter" && r[1].type === "tableDelimiterRow" && (t = !0);
    n += 1;
  }
  return i;
}
function N9() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: R9,
        resolveAll: L9
      }
    }
  };
}
function R9(e, n, t) {
  const i = this;
  let r = 0, s = 0, o;
  return a;
  function a(N) {
    let Z = i.events.length - 1;
    for (; Z > -1; ) {
      const Ie = i.events[Z][1].type;
      if (Ie === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      Ie === "linePrefix") Z--;
      else break;
    }
    const ee = Z > -1 ? i.events[Z][1].type : null, Ae = ee === "tableHead" || ee === "tableRow" ? O : u;
    return Ae === O && i.parser.lazy[i.now().line] ? t(N) : Ae(N);
  }
  function u(N) {
    return e.enter("tableHead"), e.enter("tableRow"), l(N);
  }
  function l(N) {
    return N === 124 || (o = !0, s += 1), c(N);
  }
  function c(N) {
    return N === null ? t(N) : fe(N) ? s > 1 ? (s = 0, i.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(N), e.exit("lineEnding"), g) : t(N) : De(N) ? Fe(e, c, "whitespace")(N) : (s += 1, o && (o = !1, r += 1), N === 124 ? (e.enter("tableCellDivider"), e.consume(N), e.exit("tableCellDivider"), o = !0, c) : (e.enter("data"), d(N)));
  }
  function d(N) {
    return N === null || N === 124 || et(N) ? (e.exit("data"), c(N)) : (e.consume(N), N === 92 ? p : d);
  }
  function p(N) {
    return N === 92 || N === 124 ? (e.consume(N), d) : d(N);
  }
  function g(N) {
    return i.interrupt = !1, i.parser.lazy[i.now().line] ? t(N) : (e.enter("tableDelimiterRow"), o = !1, De(N) ? Fe(e, b, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(N) : b(N));
  }
  function b(N) {
    return N === 45 || N === 58 ? k(N) : N === 124 ? (o = !0, e.enter("tableCellDivider"), e.consume(N), e.exit("tableCellDivider"), _) : F(N);
  }
  function _(N) {
    return De(N) ? Fe(e, k, "whitespace")(N) : k(N);
  }
  function k(N) {
    return N === 58 ? (s += 1, o = !0, e.enter("tableDelimiterMarker"), e.consume(N), e.exit("tableDelimiterMarker"), C) : N === 45 ? (s += 1, C(N)) : N === null || fe(N) ? j(N) : F(N);
  }
  function C(N) {
    return N === 45 ? (e.enter("tableDelimiterFiller"), D(N)) : F(N);
  }
  function D(N) {
    return N === 45 ? (e.consume(N), D) : N === 58 ? (o = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(N), e.exit("tableDelimiterMarker"), M) : (e.exit("tableDelimiterFiller"), M(N));
  }
  function M(N) {
    return De(N) ? Fe(e, j, "whitespace")(N) : j(N);
  }
  function j(N) {
    return N === 124 ? b(N) : N === null || fe(N) ? !o || r !== s ? F(N) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), n(N)) : F(N);
  }
  function F(N) {
    return t(N);
  }
  function O(N) {
    return e.enter("tableRow"), V(N);
  }
  function V(N) {
    return N === 124 ? (e.enter("tableCellDivider"), e.consume(N), e.exit("tableCellDivider"), V) : N === null || fe(N) ? (e.exit("tableRow"), n(N)) : De(N) ? Fe(e, V, "whitespace")(N) : (e.enter("data"), ie(N));
  }
  function ie(N) {
    return N === null || N === 124 || et(N) ? (e.exit("data"), V(N)) : (e.consume(N), N === 92 ? W : ie);
  }
  function W(N) {
    return N === 92 || N === 124 ? (e.consume(N), ie) : ie(N);
  }
}
function L9(e, n) {
  let t = -1, i = !0, r = 0, s = [0, 0, 0, 0], o = [0, 0, 0, 0], a = !1, u = 0, l, c, d;
  const p = new v9();
  for (; ++t < e.length; ) {
    const g = e[t], b = g[1];
    g[0] === "enter" ? b.type === "tableHead" ? (a = !1, u !== 0 && (Lb(p, n, u, l, c), c = void 0, u = 0), l = {
      type: "table",
      start: Object.assign({}, b.start),
      // Note: correct end is set later.
      end: Object.assign({}, b.end)
    }, p.add(t, 0, [["enter", l, n]])) : b.type === "tableRow" || b.type === "tableDelimiterRow" ? (i = !0, d = void 0, s = [0, 0, 0, 0], o = [0, t + 1, 0, 0], a && (a = !1, c = {
      type: "tableBody",
      start: Object.assign({}, b.start),
      // Note: correct end is set later.
      end: Object.assign({}, b.end)
    }, p.add(t, 0, [["enter", c, n]])), r = b.type === "tableDelimiterRow" ? 2 : c ? 3 : 1) : r && (b.type === "data" || b.type === "tableDelimiterMarker" || b.type === "tableDelimiterFiller") ? (i = !1, o[2] === 0 && (s[1] !== 0 && (o[0] = o[1], d = Uu(p, n, s, r, void 0, d), s = [0, 0, 0, 0]), o[2] = t)) : b.type === "tableCellDivider" && (i ? i = !1 : (s[1] !== 0 && (o[0] = o[1], d = Uu(p, n, s, r, void 0, d)), s = o, o = [s[1], t, 0, 0])) : b.type === "tableHead" ? (a = !0, u = t) : b.type === "tableRow" || b.type === "tableDelimiterRow" ? (u = t, s[1] !== 0 ? (o[0] = o[1], d = Uu(p, n, s, r, t, d)) : o[1] !== 0 && (d = Uu(p, n, o, r, t, d)), r = 0) : r && (b.type === "data" || b.type === "tableDelimiterMarker" || b.type === "tableDelimiterFiller") && (o[3] = t);
  }
  for (u !== 0 && Lb(p, n, u, l, c), p.consume(n.events), t = -1; ++t < n.events.length; ) {
    const g = n.events[t];
    g[0] === "enter" && g[1].type === "table" && (g[1]._align = O9(n.events, t));
  }
  return e;
}
function Uu(e, n, t, i, r, s) {
  const o = i === 1 ? "tableHeader" : i === 2 ? "tableDelimiter" : "tableData", a = "tableContent";
  t[0] !== 0 && (s.end = Object.assign({}, Us(n.events, t[0])), e.add(t[0], 0, [["exit", s, n]]));
  const u = Us(n.events, t[1]);
  if (s = {
    type: o,
    start: Object.assign({}, u),
    // Note: correct end is set later.
    end: Object.assign({}, u)
  }, e.add(t[1], 0, [["enter", s, n]]), t[2] !== 0) {
    const l = Us(n.events, t[2]), c = Us(n.events, t[3]), d = {
      type: a,
      start: Object.assign({}, l),
      end: Object.assign({}, c)
    };
    if (e.add(t[2], 0, [["enter", d, n]]), i !== 2) {
      const p = n.events[t[2]], g = n.events[t[3]];
      if (p[1].end = Object.assign({}, g[1].end), p[1].type = "chunkText", p[1].contentType = "text", t[3] > t[2] + 1) {
        const b = t[2] + 1, _ = t[3] - t[2] - 1;
        e.add(b, _, []);
      }
    }
    e.add(t[3] + 1, 0, [["exit", d, n]]);
  }
  return r !== void 0 && (s.end = Object.assign({}, Us(n.events, r)), e.add(r, 0, [["exit", s, n]]), s = void 0), s;
}
function Lb(e, n, t, i, r) {
  const s = [], o = Us(n.events, t);
  r && (r.end = Object.assign({}, o), s.push(["exit", r, n])), i.end = Object.assign({}, o), s.push(["exit", i, n]), e.add(t + 1, 0, s);
}
function Us(e, n) {
  const t = e[n], i = t[0] === "enter" ? "start" : "end";
  return t[1][i];
}
const D9 = {
  name: "tasklistCheck",
  tokenize: B9
};
function M9() {
  return {
    text: {
      91: D9
    }
  };
}
function B9(e, n, t) {
  const i = this;
  return r;
  function r(u) {
    return (
      // Exit if there’s stuff before.
      i.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !i._gfmTasklistFirstContentOfListItem ? t(u) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), s)
    );
  }
  function s(u) {
    return et(u) ? (e.enter("taskListCheckValueUnchecked"), e.consume(u), e.exit("taskListCheckValueUnchecked"), o) : u === 88 || u === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(u), e.exit("taskListCheckValueChecked"), o) : t(u);
  }
  function o(u) {
    return u === 93 ? (e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), a) : t(u);
  }
  function a(u) {
    return fe(u) ? n(u) : De(u) ? e.check({
      tokenize: F9
    }, n, t)(u) : t(u);
  }
}
function F9(e, n, t) {
  return Fe(e, i, "whitespace");
  function i(r) {
    return r === null ? t(r) : n(r);
  }
}
function U9(e) {
  return aw([
    GF(),
    T9(),
    x9(e),
    N9(),
    M9()
  ]);
}
const H9 = {};
function tf(e) {
  const n = (
    /** @type {Processor<Root>} */
    this
  ), t = e || H9, i = n.data(), r = i.micromarkExtensions || (i.micromarkExtensions = []), s = i.fromMarkdownExtensions || (i.fromMarkdownExtensions = []), o = i.toMarkdownExtensions || (i.toMarkdownExtensions = []);
  r.push(U9(t)), s.push(WF()), o.push(zF(t));
}
function V9(e, n) {
  const t = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function $9(e, n) {
  const t = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, t), [e.applyData(n, t), { type: "text", value: `
` }];
}
function W9(e, n) {
  const t = n.value ? n.value + `
` : "", i = {};
  n.lang && (i.className = ["language-" + n.lang]);
  let r = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: t }]
  };
  return n.meta && (r.data = { meta: n.meta }), e.patch(n, r), r = e.applyData(n, r), r = { type: "element", tagName: "pre", properties: {}, children: [r] }, e.patch(n, r), r;
}
function z9(e, n) {
  const t = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function q9(e, n) {
  const t = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function Y9(e, n) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), r = go(i.toLowerCase()), s = e.footnoteOrder.indexOf(i);
  let o, a = e.footnoteCounts.get(i);
  a === void 0 ? (a = 0, e.footnoteOrder.push(i), o = e.footnoteOrder.length) : o = s + 1, a += 1, e.footnoteCounts.set(i, a);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + t + "fn-" + r,
      id: t + "fnref-" + r + (a > 1 ? "-" + a : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(n, u);
  const l = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return e.patch(n, l), e.applyData(n, l);
}
function j9(e, n) {
  const t = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function K9(e, n) {
  if (e.options.allowDangerousHtml) {
    const t = { type: "raw", value: n.value };
    return e.patch(n, t), e.applyData(n, t);
  }
}
function Aw(e, n) {
  const t = n.referenceType;
  let i = "]";
  if (t === "collapsed" ? i += "[]" : t === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const r = e.all(n), s = r[0];
  s && s.type === "text" ? s.value = "[" + s.value : r.unshift({ type: "text", value: "[" });
  const o = r[r.length - 1];
  return o && o.type === "text" ? o.value += i : r.push({ type: "text", value: i }), r;
}
function G9(e, n) {
  const t = String(n.identifier).toUpperCase(), i = e.definitionById.get(t);
  if (!i)
    return Aw(e, n);
  const r = { src: go(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (r.title = i.title);
  const s = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, s), e.applyData(n, s);
}
function Q9(e, n) {
  const t = { src: go(n.url) };
  n.alt !== null && n.alt !== void 0 && (t.alt = n.alt), n.title !== null && n.title !== void 0 && (t.title = n.title);
  const i = { type: "element", tagName: "img", properties: t, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function X9(e, n) {
  const t = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, t);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [t]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function J9(e, n) {
  const t = String(n.identifier).toUpperCase(), i = e.definitionById.get(t);
  if (!i)
    return Aw(e, n);
  const r = { href: go(i.url || "") };
  i.title !== null && i.title !== void 0 && (r.title = i.title);
  const s = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, s), e.applyData(n, s);
}
function Z9(e, n) {
  const t = { href: go(n.url) };
  n.title !== null && n.title !== void 0 && (t.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: t,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function eU(e, n, t) {
  const i = e.all(n), r = t ? tU(t) : Cw(n), s = {}, o = [];
  if (typeof n.checked == "boolean") {
    const c = i[0];
    let d;
    c && c.type === "element" && c.tagName === "p" ? d = c : (d = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(d)), d.children.length > 0 && d.children.unshift({ type: "text", value: " " }), d.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), s.className = ["task-list-item"];
  }
  let a = -1;
  for (; ++a < i.length; ) {
    const c = i[a];
    (r || a !== 0 || c.type !== "element" || c.tagName !== "p") && o.push({ type: "text", value: `
` }), c.type === "element" && c.tagName === "p" && !r ? o.push(...c.children) : o.push(c);
  }
  const u = i[i.length - 1];
  u && (r || u.type !== "element" || u.tagName !== "p") && o.push({ type: "text", value: `
` });
  const l = { type: "element", tagName: "li", properties: s, children: o };
  return e.patch(n, l), e.applyData(n, l);
}
function tU(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const t = e.children;
    let i = -1;
    for (; !n && ++i < t.length; )
      n = Cw(t[i]);
  }
  return n;
}
function Cw(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function nU(e, n) {
  const t = {}, i = e.all(n);
  let r = -1;
  for (typeof n.start == "number" && n.start !== 1 && (t.start = n.start); ++r < i.length; ) {
    const o = i[r];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      t.className = ["contains-task-list"];
      break;
    }
  }
  const s = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: t,
    children: e.wrap(i, !0)
  };
  return e.patch(n, s), e.applyData(n, s);
}
function iU(e, n) {
  const t = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function rU(e, n) {
  const t = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, t), e.applyData(n, t);
}
function sU(e, n) {
  const t = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
const bc = kw("end"), vi = kw("start");
function kw(e) {
  return n;
  function n(t) {
    const i = t && t.position && t.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function Am(e) {
  const n = vi(e), t = bc(e);
  if (n && t)
    return { start: n, end: t };
}
function oU(e, n) {
  const t = e.all(n), i = t.shift(), r = [];
  if (i) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], o), r.push(o);
  }
  if (t.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(t, !0)
    }, a = vi(n.children[1]), u = bc(n.children[n.children.length - 1]);
    a && u && (o.position = { start: a, end: u }), r.push(o);
  }
  const s = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(r, !0)
  };
  return e.patch(n, s), e.applyData(n, s);
}
function aU(e, n, t) {
  const i = t ? t.children : void 0, s = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", o = t && t.type === "table" ? t.align : void 0, a = o ? o.length : n.children.length;
  let u = -1;
  const l = [];
  for (; ++u < a; ) {
    const d = n.children[u], p = {}, g = o ? o[u] : void 0;
    g && (p.align = g);
    let b = { type: "element", tagName: s, properties: p, children: [] };
    d && (b.children = e.all(d), e.patch(d, b), b = e.applyData(d, b)), l.push(b);
  }
  const c = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(l, !0)
  };
  return e.patch(n, c), e.applyData(n, c);
}
function uU(e, n) {
  const t = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
const Db = 9, Mb = 32;
function lU(e) {
  const n = String(e), t = /\r?\n|\r/g;
  let i = t.exec(n), r = 0;
  const s = [];
  for (; i; )
    s.push(
      Bb(n.slice(r, i.index), r > 0, !0),
      i[0]
    ), r = i.index + i[0].length, i = t.exec(n);
  return s.push(Bb(n.slice(r), r > 0, !1)), s.join("");
}
function Bb(e, n, t) {
  let i = 0, r = e.length;
  if (n) {
    let s = e.codePointAt(i);
    for (; s === Db || s === Mb; )
      i++, s = e.codePointAt(i);
  }
  if (t) {
    let s = e.codePointAt(r - 1);
    for (; s === Db || s === Mb; )
      r--, s = e.codePointAt(r - 1);
  }
  return r > i ? e.slice(i, r) : "";
}
function cU(e, n) {
  const t = { type: "text", value: lU(String(n.value)) };
  return e.patch(n, t), e.applyData(n, t);
}
function dU(e, n) {
  const t = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, t), e.applyData(n, t);
}
const hU = {
  blockquote: V9,
  break: $9,
  code: W9,
  delete: z9,
  emphasis: q9,
  footnoteReference: Y9,
  heading: j9,
  html: K9,
  imageReference: G9,
  image: Q9,
  inlineCode: X9,
  linkReference: J9,
  link: Z9,
  listItem: eU,
  list: nU,
  paragraph: iU,
  // @ts-expect-error: root is different, but hard to type.
  root: rU,
  strong: sU,
  table: oU,
  tableCell: uU,
  tableRow: aU,
  text: cU,
  thematicBreak: dU,
  toml: Hu,
  yaml: Hu,
  definition: Hu,
  footnoteDefinition: Hu
};
function Hu() {
}
const Sw = -1, _c = 0, ha = 1, Rl = 2, Cm = 3, km = 4, Sm = 5, Im = 6, Iw = 7, xw = 8, Fb = typeof self == "object" ? self : globalThis, fU = (e, n) => {
  const t = (r, s) => (e.set(s, r), r), i = (r) => {
    if (e.has(r))
      return e.get(r);
    const [s, o] = n[r];
    switch (s) {
      case _c:
      case Sw:
        return t(o, r);
      case ha: {
        const a = t([], r);
        for (const u of o)
          a.push(i(u));
        return a;
      }
      case Rl: {
        const a = t({}, r);
        for (const [u, l] of o)
          a[i(u)] = i(l);
        return a;
      }
      case Cm:
        return t(new Date(o), r);
      case km: {
        const { source: a, flags: u } = o;
        return t(new RegExp(a, u), r);
      }
      case Sm: {
        const a = t(/* @__PURE__ */ new Map(), r);
        for (const [u, l] of o)
          a.set(i(u), i(l));
        return a;
      }
      case Im: {
        const a = t(/* @__PURE__ */ new Set(), r);
        for (const u of o)
          a.add(i(u));
        return a;
      }
      case Iw: {
        const { name: a, message: u } = o;
        return t(new Fb[a](u), r);
      }
      case xw:
        return t(BigInt(o), r);
      case "BigInt":
        return t(Object(BigInt(o)), r);
      case "ArrayBuffer":
        return t(new Uint8Array(o).buffer, o);
      case "DataView": {
        const { buffer: a } = new Uint8Array(o);
        return t(new DataView(a), o);
      }
    }
    return t(new Fb[s](o), r);
  };
  return i;
}, Ub = (e) => fU(/* @__PURE__ */ new Map(), e)(0), vs = "", { toString: mU } = {}, { keys: pU } = Object, $o = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [_c, n];
  const t = mU.call(e).slice(8, -1);
  switch (t) {
    case "Array":
      return [ha, vs];
    case "Object":
      return [Rl, vs];
    case "Date":
      return [Cm, vs];
    case "RegExp":
      return [km, vs];
    case "Map":
      return [Sm, vs];
    case "Set":
      return [Im, vs];
    case "DataView":
      return [ha, t];
  }
  return t.includes("Array") ? [ha, t] : t.includes("Error") ? [Iw, t] : [Rl, t];
}, Vu = ([e, n]) => e === _c && (n === "function" || n === "symbol"), gU = (e, n, t, i) => {
  const r = (o, a) => {
    const u = i.push(o) - 1;
    return t.set(a, u), u;
  }, s = (o) => {
    if (t.has(o))
      return t.get(o);
    let [a, u] = $o(o);
    switch (a) {
      case _c: {
        let c = o;
        switch (u) {
          case "bigint":
            a = xw, c = o.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + u);
            c = null;
            break;
          case "undefined":
            return r([Sw], o);
        }
        return r([a, c], o);
      }
      case ha: {
        if (u) {
          let p = o;
          return u === "DataView" ? p = new Uint8Array(o.buffer) : u === "ArrayBuffer" && (p = new Uint8Array(o)), r([u, [...p]], o);
        }
        const c = [], d = r([a, c], o);
        for (const p of o)
          c.push(s(p));
        return d;
      }
      case Rl: {
        if (u)
          switch (u) {
            case "BigInt":
              return r([u, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return r([u, o.valueOf()], o);
          }
        if (n && "toJSON" in o)
          return s(o.toJSON());
        const c = [], d = r([a, c], o);
        for (const p of pU(o))
          (e || !Vu($o(o[p]))) && c.push([s(p), s(o[p])]);
        return d;
      }
      case Cm:
        return r([a, o.toISOString()], o);
      case km: {
        const { source: c, flags: d } = o;
        return r([a, { source: c, flags: d }], o);
      }
      case Sm: {
        const c = [], d = r([a, c], o);
        for (const [p, g] of o)
          (e || !(Vu($o(p)) || Vu($o(g)))) && c.push([s(p), s(g)]);
        return d;
      }
      case Im: {
        const c = [], d = r([a, c], o);
        for (const p of o)
          (e || !Vu($o(p))) && c.push(s(p));
        return d;
      }
    }
    const { message: l } = o;
    return r([a, { name: u, message: l }], o);
  };
  return s;
}, Hb = (e, { json: n, lossy: t } = {}) => {
  const i = [];
  return gU(!(n || t), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, Yi = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? Ub(Hb(e, n)) : structuredClone(e)
) : (e, n) => Ub(Hb(e, n));
function bU(e, n) {
  const t = [{ type: "text", value: "↩" }];
  return n > 1 && t.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), t;
}
function _U(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function EU(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", t = e.options.footnoteBackContent || bU, i = e.options.footnoteBackLabel || _U, r = e.options.footnoteLabel || "Footnotes", s = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, a = [];
  let u = -1;
  for (; ++u < e.footnoteOrder.length; ) {
    const l = e.footnoteById.get(
      e.footnoteOrder[u]
    );
    if (!l)
      continue;
    const c = e.all(l), d = String(l.identifier).toUpperCase(), p = go(d.toLowerCase());
    let g = 0;
    const b = [], _ = e.footnoteCounts.get(d);
    for (; _ !== void 0 && ++g <= _; ) {
      b.length > 0 && b.push({ type: "text", value: " " });
      let D = typeof t == "string" ? t : t(u, g);
      typeof D == "string" && (D = { type: "text", value: D }), b.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + p + (g > 1 ? "-" + g : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(u, g),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(D) ? D : [D]
      });
    }
    const k = c[c.length - 1];
    if (k && k.type === "element" && k.tagName === "p") {
      const D = k.children[k.children.length - 1];
      D && D.type === "text" ? D.value += " " : k.children.push({ type: "text", value: " " }), k.children.push(...b);
    } else
      c.push(...b);
    const C = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + p },
      children: e.wrap(c, !0)
    };
    e.patch(l, C), a.push(C);
  }
  if (a.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: s,
          properties: {
            ...Yi(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: r }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(a, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const nf = {}.hasOwnProperty, TU = {};
function yU(e, n) {
  const t = n || TU, i = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), o = { ...hU, ...t.handlers }, a = {
    all: l,
    applyData: AU,
    definitionById: i,
    footnoteById: r,
    footnoteCounts: s,
    footnoteOrder: [],
    handlers: o,
    one: u,
    options: t,
    patch: wU,
    wrap: kU
  };
  return Cr(e, function(c) {
    if (c.type === "definition" || c.type === "footnoteDefinition") {
      const d = c.type === "definition" ? i : r, p = String(c.identifier).toUpperCase();
      d.has(p) || d.set(p, c);
    }
  }), a;
  function u(c, d) {
    const p = c.type, g = a.handlers[p];
    if (nf.call(a.handlers, p) && g)
      return g(a, c, d);
    if (a.options.passThrough && a.options.passThrough.includes(p)) {
      if ("children" in c) {
        const { children: _, ...k } = c, C = Yi(k);
        return C.children = a.all(c), C;
      }
      return Yi(c);
    }
    return (a.options.unknownHandler || CU)(a, c, d);
  }
  function l(c) {
    const d = [];
    if ("children" in c) {
      const p = c.children;
      let g = -1;
      for (; ++g < p.length; ) {
        const b = a.one(p[g], c);
        if (b) {
          if (g && p[g - 1].type === "break" && (!Array.isArray(b) && b.type === "text" && (b.value = Vb(b.value)), !Array.isArray(b) && b.type === "element")) {
            const _ = b.children[0];
            _ && _.type === "text" && (_.value = Vb(_.value));
          }
          Array.isArray(b) ? d.push(...b) : d.push(b);
        }
      }
    }
    return d;
  }
}
function wU(e, n) {
  e.position && (n.position = Am(e));
}
function AU(e, n) {
  let t = n;
  if (e && e.data) {
    const i = e.data.hName, r = e.data.hChildren, s = e.data.hProperties;
    if (typeof i == "string")
      if (t.type === "element")
        t.tagName = i;
      else {
        const o = "children" in t ? t.children : [t];
        t = { type: "element", tagName: i, properties: {}, children: o };
      }
    t.type === "element" && s && Object.assign(t.properties, Yi(s)), "children" in t && t.children && r !== null && r !== void 0 && (t.children = r);
  }
  return t;
}
function CU(e, n) {
  const t = n.data || {}, i = "value" in n && !(nf.call(t, "hProperties") || nf.call(t, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function kU(e, n) {
  const t = [];
  let i = -1;
  for (n && t.push({ type: "text", value: `
` }); ++i < e.length; )
    i && t.push({ type: "text", value: `
` }), t.push(e[i]);
  return n && e.length > 0 && t.push({ type: "text", value: `
` }), t;
}
function Vb(e) {
  let n = 0, t = e.charCodeAt(n);
  for (; t === 9 || t === 32; )
    n++, t = e.charCodeAt(n);
  return e.slice(n);
}
function $b(e, n) {
  const t = yU(e, n), i = t.one(e, void 0), r = EU(t), s = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return r && s.children.push({ type: "text", value: `
` }, r), s;
}
function vw(e, n) {
  return e && "run" in e ? async function(t, i) {
    const r = (
      /** @type {HastRoot} */
      $b(t, { file: i, ...n })
    );
    await e.run(r, i);
  } : function(t, i) {
    return (
      /** @type {HastRoot} */
      $b(t, { file: i, ...e || n })
    );
  };
}
function SU(e) {
  const n = this;
  n.compiler = t;
  function t(i) {
    return kF(i, {
      ...n.data("settings"),
      ...e,
      // Note: this option is not in the readme.
      // The goal is for it to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("toMarkdownExtensions") || []
    });
  }
}
const IU = {
  tokenize: xU
};
function xU(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, r);
  let t;
  return n;
  function i(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), Fe(e, n, "linePrefix");
  }
  function r(a) {
    return e.enter("paragraph"), s(a);
  }
  function s(a) {
    const u = e.enter("chunkText", {
      contentType: "text",
      previous: t
    });
    return t && (t.next = u), t = u, o(a);
  }
  function o(a) {
    if (a === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(a);
      return;
    }
    return fe(a) ? (e.consume(a), e.exit("chunkText"), s) : (e.consume(a), o);
  }
}
const vU = {
  tokenize: PU
}, Wb = {
  tokenize: OU
};
function PU(e) {
  const n = this, t = [];
  let i = 0, r, s, o;
  return a;
  function a(M) {
    if (i < t.length) {
      const j = t[i];
      return n.containerState = j[1], e.attempt(j[0].continuation, u, l)(M);
    }
    return l(M);
  }
  function u(M) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, r && D();
      const j = n.events.length;
      let F = j, O;
      for (; F--; )
        if (n.events[F][0] === "exit" && n.events[F][1].type === "chunkFlow") {
          O = n.events[F][1].end;
          break;
        }
      C(i);
      let V = j;
      for (; V < n.events.length; )
        n.events[V][1].end = {
          ...O
        }, V++;
      return vn(n.events, F + 1, 0, n.events.slice(j)), n.events.length = V, l(M);
    }
    return a(M);
  }
  function l(M) {
    if (i === t.length) {
      if (!r)
        return p(M);
      if (r.currentConstruct && r.currentConstruct.concrete)
        return b(M);
      n.interrupt = !!(r.currentConstruct && !r._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(Wb, c, d)(M);
  }
  function c(M) {
    return r && D(), C(i), p(M);
  }
  function d(M) {
    return n.parser.lazy[n.now().line] = i !== t.length, o = n.now().offset, b(M);
  }
  function p(M) {
    return n.containerState = {}, e.attempt(Wb, g, b)(M);
  }
  function g(M) {
    return i++, t.push([n.currentConstruct, n.containerState]), p(M);
  }
  function b(M) {
    if (M === null) {
      r && D(), C(0), e.consume(M);
      return;
    }
    return r = r || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: r,
      contentType: "flow",
      previous: s
    }), _(M);
  }
  function _(M) {
    if (M === null) {
      k(e.exit("chunkFlow"), !0), C(0), e.consume(M);
      return;
    }
    return fe(M) ? (e.consume(M), k(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, a) : (e.consume(M), _);
  }
  function k(M, j) {
    const F = n.sliceStream(M);
    if (j && F.push(null), M.previous = s, s && (s.next = M), s = M, r.defineSkip(M.start), r.write(F), n.parser.lazy[M.start.line]) {
      let O = r.events.length;
      for (; O--; )
        if (
          // The token starts before the line ending…
          r.events[O][1].start.offset < o && // …and either is not ended yet…
          (!r.events[O][1].end || // …or ends after it.
          r.events[O][1].end.offset > o)
        )
          return;
      const V = n.events.length;
      let ie = V, W, N;
      for (; ie--; )
        if (n.events[ie][0] === "exit" && n.events[ie][1].type === "chunkFlow") {
          if (W) {
            N = n.events[ie][1].end;
            break;
          }
          W = !0;
        }
      for (C(i), O = V; O < n.events.length; )
        n.events[O][1].end = {
          ...N
        }, O++;
      vn(n.events, ie + 1, 0, n.events.slice(V)), n.events.length = O;
    }
  }
  function C(M) {
    let j = t.length;
    for (; j-- > M; ) {
      const F = t[j];
      n.containerState = F[1], F[0].exit.call(n, e);
    }
    t.length = M;
  }
  function D() {
    r.write([null]), s = void 0, r = void 0, n.containerState._closeFlow = void 0;
  }
}
function OU(e, n, t) {
  return Fe(e, e.attempt(this.parser.constructs.document, n, t), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
const NU = {
  tokenize: RU
};
function RU(e) {
  const n = this, t = e.attempt(
    // Try to parse a blank line.
    uu,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, r, Fe(e, e.attempt(this.parser.constructs.flow, r, e.attempt(k7, r)), "linePrefix"))
  );
  return t;
  function i(s) {
    if (s === null) {
      e.consume(s);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(s), e.exit("lineEndingBlank"), n.currentConstruct = void 0, t;
  }
  function r(s) {
    if (s === null) {
      e.consume(s);
      return;
    }
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), n.currentConstruct = void 0, t;
  }
}
const LU = {
  resolveAll: Ow()
}, DU = Pw("string"), MU = Pw("text");
function Pw(e) {
  return {
    resolveAll: Ow(e === "text" ? BU : void 0),
    tokenize: n
  };
  function n(t) {
    const i = this, r = this.parser.constructs[e], s = t.attempt(r, o, a);
    return o;
    function o(c) {
      return l(c) ? s(c) : a(c);
    }
    function a(c) {
      if (c === null) {
        t.consume(c);
        return;
      }
      return t.enter("data"), t.consume(c), u;
    }
    function u(c) {
      return l(c) ? (t.exit("data"), s(c)) : (t.consume(c), u);
    }
    function l(c) {
      if (c === null)
        return !0;
      const d = r[c];
      let p = -1;
      if (d)
        for (; ++p < d.length; ) {
          const g = d[p];
          if (!g.previous || g.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Ow(e) {
  return n;
  function n(t, i) {
    let r = -1, s;
    for (; ++r <= t.length; )
      s === void 0 ? t[r] && t[r][1].type === "data" && (s = r, r++) : (!t[r] || t[r][1].type !== "data") && (r !== s + 2 && (t[s][1].end = t[r - 1][1].end, t.splice(s + 2, r - s - 2), r = s + 2), s = void 0);
    return e ? e(t, i) : t;
  }
}
function BU(e, n) {
  let t = 0;
  for (; ++t <= e.length; )
    if ((t === e.length || e[t][1].type === "lineEnding") && e[t - 1][1].type === "data") {
      const i = e[t - 1][1], r = n.sliceStream(i);
      let s = r.length, o = -1, a = 0, u;
      for (; s--; ) {
        const l = r[s];
        if (typeof l == "string") {
          for (o = l.length; l.charCodeAt(o - 1) === 32; )
            a++, o--;
          if (o) break;
          o = -1;
        } else if (l === -2)
          u = !0, a++;
        else if (l !== -1) {
          s++;
          break;
        }
      }
      if (n._contentTypeTextTrailing && t === e.length && (a = 0), a) {
        const l = {
          type: t === e.length || u || a < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: s ? o : i.start._bufferIndex + o,
            _index: i.start._index + s,
            line: i.end.line,
            column: i.end.column - a,
            offset: i.end.offset - a
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...l.start
        }, i.start.offset === i.end.offset ? Object.assign(i, l) : (e.splice(t, 0, ["enter", l, n], ["exit", l, n]), t += 2);
      }
      t++;
    }
  return e;
}
const FU = {
  42: fn,
  43: fn,
  45: fn,
  48: fn,
  49: fn,
  50: fn,
  51: fn,
  52: fn,
  53: fn,
  54: fn,
  55: fn,
  56: fn,
  57: fn,
  62: gw
}, UU = {
  91: P7
}, HU = {
  [-2]: Ud,
  [-1]: Ud,
  32: Ud
}, VU = {
  35: M7,
  42: nl,
  45: [Rb, nl],
  60: H7,
  61: Rb,
  95: nl,
  96: Ob,
  126: Ob
}, $U = {
  38: _w,
  92: bw
}, WU = {
  [-5]: Hd,
  [-4]: Hd,
  [-3]: Hd,
  33: r9,
  38: _w,
  42: ef,
  60: [o7, j7],
  91: o9,
  92: [L7, bw],
  93: wm,
  95: ef,
  96: E7
}, zU = {
  null: [ef, LU]
}, qU = {
  null: [42, 95]
}, YU = {
  null: []
}, jU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: qU,
  contentInitial: UU,
  disable: YU,
  document: FU,
  flow: VU,
  flowInitial: HU,
  insideSpan: zU,
  string: $U,
  text: WU
}, Symbol.toStringTag, { value: "Module" }));
function KU(e, n, t) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: t && t.line || 1,
    column: t && t.column || 1,
    offset: t && t.offset || 0
  };
  const r = {}, s = [];
  let o = [], a = [];
  const u = {
    attempt: V(F),
    check: V(O),
    consume: D,
    enter: M,
    exit: j,
    interrupt: V(O, {
      interrupt: !0
    })
  }, l = {
    code: null,
    containerState: {},
    defineSkip: _,
    events: [],
    now: b,
    parser: e,
    previous: null,
    sliceSerialize: p,
    sliceStream: g,
    write: d
  };
  let c = n.tokenize.call(l, u);
  return n.resolveAll && s.push(n), l;
  function d(Z) {
    return o = Un(o, Z), k(), o[o.length - 1] !== null ? [] : (ie(n, 0), l.events = gc(s, l.events, l), l.events);
  }
  function p(Z, ee) {
    return QU(g(Z), ee);
  }
  function g(Z) {
    return GU(o, Z);
  }
  function b() {
    const {
      _bufferIndex: Z,
      _index: ee,
      line: Ae,
      column: Ie,
      offset: we
    } = i;
    return {
      _bufferIndex: Z,
      _index: ee,
      line: Ae,
      column: Ie,
      offset: we
    };
  }
  function _(Z) {
    r[Z.line] = Z.column, N();
  }
  function k() {
    let Z;
    for (; i._index < o.length; ) {
      const ee = o[i._index];
      if (typeof ee == "string")
        for (Z = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === Z && i._bufferIndex < ee.length; )
          C(ee.charCodeAt(i._bufferIndex));
      else
        C(ee);
    }
  }
  function C(Z) {
    c = c(Z);
  }
  function D(Z) {
    fe(Z) ? (i.line++, i.column = 1, i.offset += Z === -3 ? 2 : 1, N()) : Z !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    o[i._index].length && (i._bufferIndex = -1, i._index++)), l.previous = Z;
  }
  function M(Z, ee) {
    const Ae = ee || {};
    return Ae.type = Z, Ae.start = b(), l.events.push(["enter", Ae, l]), a.push(Ae), Ae;
  }
  function j(Z) {
    const ee = a.pop();
    return ee.end = b(), l.events.push(["exit", ee, l]), ee;
  }
  function F(Z, ee) {
    ie(Z, ee.from);
  }
  function O(Z, ee) {
    ee.restore();
  }
  function V(Z, ee) {
    return Ae;
    function Ae(Ie, we, ze) {
      let Qe, Nt, jt, y;
      return Array.isArray(Ie) ? (
        /* c8 ignore next 1 */
        pe(Ie)
      ) : "tokenize" in Ie ? (
        // Looks like a construct.
        pe([
          /** @type {Construct} */
          Ie
        ])
      ) : re(Ie);
      function re(le) {
        return ge;
        function ge(be) {
          const ve = be !== null && le[be], Te = be !== null && le.null, Tt = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(ve) ? ve : ve ? [ve] : [],
            ...Array.isArray(Te) ? Te : Te ? [Te] : []
          ];
          return pe(Tt)(be);
        }
      }
      function pe(le) {
        return Qe = le, Nt = 0, le.length === 0 ? ze : S(le[Nt]);
      }
      function S(le) {
        return ge;
        function ge(be) {
          return y = W(), jt = le, le.partial || (l.currentConstruct = le), le.name && l.parser.constructs.disable.null.includes(le.name) ? Ce() : le.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            ee ? Object.assign(Object.create(l), ee) : l,
            u,
            de,
            Ce
          )(be);
        }
      }
      function de(le) {
        return Z(jt, y), we;
      }
      function Ce(le) {
        return y.restore(), ++Nt < Qe.length ? S(Qe[Nt]) : ze;
      }
    }
  }
  function ie(Z, ee) {
    Z.resolveAll && !s.includes(Z) && s.push(Z), Z.resolve && vn(l.events, ee, l.events.length - ee, Z.resolve(l.events.slice(ee), l)), Z.resolveTo && (l.events = Z.resolveTo(l.events, l));
  }
  function W() {
    const Z = b(), ee = l.previous, Ae = l.currentConstruct, Ie = l.events.length, we = Array.from(a);
    return {
      from: Ie,
      restore: ze
    };
    function ze() {
      i = Z, l.previous = ee, l.currentConstruct = Ae, l.events.length = Ie, a = we, N();
    }
  }
  function N() {
    i.line in r && i.column < 2 && (i.column = r[i.line], i.offset += r[i.line] - 1);
  }
}
function GU(e, n) {
  const t = n.start._index, i = n.start._bufferIndex, r = n.end._index, s = n.end._bufferIndex;
  let o;
  if (t === r)
    o = [e[t].slice(i, s)];
  else {
    if (o = e.slice(t, r), i > -1) {
      const a = o[0];
      typeof a == "string" ? o[0] = a.slice(i) : o.shift();
    }
    s > 0 && o.push(e[r].slice(0, s));
  }
  return o;
}
function QU(e, n) {
  let t = -1;
  const i = [];
  let r;
  for (; ++t < e.length; ) {
    const s = e[t];
    let o;
    if (typeof s == "string")
      o = s;
    else switch (s) {
      case -5: {
        o = "\r";
        break;
      }
      case -4: {
        o = `
`;
        break;
      }
      case -3: {
        o = `\r
`;
        break;
      }
      case -2: {
        o = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && r) continue;
        o = " ";
        break;
      }
      default:
        o = String.fromCharCode(s);
    }
    r = s === -2, i.push(o);
  }
  return i.join("");
}
function XU(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      aw([jU, ...(e || {}).extensions || []])
    ),
    content: r(IU),
    defined: [],
    document: r(vU),
    flow: r(NU),
    lazy: {},
    string: r(DU),
    text: r(MU)
  };
  return i;
  function r(s) {
    return o;
    function o(a) {
      return KU(i, s, a);
    }
  }
}
function JU(e) {
  for (; !Ew(e); )
    ;
  return e;
}
const zb = /[\0\t\n\r]/g;
function ZU() {
  let e = 1, n = "", t = !0, i;
  return r;
  function r(s, o, a) {
    const u = [];
    let l, c, d, p, g;
    for (s = n + (typeof s == "string" ? s.toString() : new TextDecoder(o || void 0).decode(s)), d = 0, n = "", t && (s.charCodeAt(0) === 65279 && d++, t = void 0); d < s.length; ) {
      if (zb.lastIndex = d, l = zb.exec(s), p = l && l.index !== void 0 ? l.index : s.length, g = s.charCodeAt(p), !l) {
        n = s.slice(d);
        break;
      }
      if (g === 10 && d === p && i)
        u.push(-3), i = void 0;
      else
        switch (i && (u.push(-5), i = void 0), d < p && (u.push(s.slice(d, p)), e += p - d), g) {
          case 0: {
            u.push(65533), e++;
            break;
          }
          case 9: {
            for (c = Math.ceil(e / 4) * 4, u.push(-2); e++ < c; ) u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      d = p + 1;
    }
    return a && (i && u.push(-5), n && u.push(n), u.push(null)), u;
  }
}
const Nw = {}.hasOwnProperty;
function eH(e, n, t) {
  return typeof n != "string" && (t = n, n = void 0), tH(t)(JU(XU(t).document().write(ZU()(e, n, !0))));
}
function tH(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: s(Nr),
      autolinkProtocol: W,
      autolinkEmail: W,
      atxHeading: s(fi),
      blockQuote: s(Te),
      characterEscape: W,
      characterReference: W,
      codeFenced: s(Tt),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: s(Tt, o),
      codeText: s(se, o),
      codeTextData: W,
      data: W,
      codeFlowValue: W,
      definition: s(ln),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: s(er),
      hardBreakEscape: s(tr),
      hardBreakTrailing: s(tr),
      htmlFlow: s(ko, o),
      htmlFlowData: W,
      htmlText: s(ko, o),
      htmlTextData: W,
      image: s(Tu),
      label: o,
      link: s(Nr),
      listItem: s(zc),
      listItemValue: p,
      listOrdered: s(yu, d),
      listUnordered: s(yu),
      paragraph: s(So),
      reference: S,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: s(fi),
      strong: s(qc),
      thematicBreak: s(wu)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: F,
      autolink: u(),
      autolinkEmail: ve,
      autolinkProtocol: be,
      blockQuote: u(),
      characterEscapeValue: N,
      characterReferenceMarkerHexadecimal: Ce,
      characterReferenceMarkerNumeric: Ce,
      characterReferenceValue: le,
      characterReference: ge,
      codeFenced: u(k),
      codeFencedFence: _,
      codeFencedFenceInfo: g,
      codeFencedFenceMeta: b,
      codeFlowValue: N,
      codeIndented: u(C),
      codeText: u(we),
      codeTextData: N,
      data: N,
      definition: u(),
      definitionDestinationString: j,
      definitionLabelString: D,
      definitionTitleString: M,
      emphasis: u(),
      hardBreakEscape: u(ee),
      hardBreakTrailing: u(ee),
      htmlFlow: u(Ae),
      htmlFlowData: N,
      htmlText: u(Ie),
      htmlTextData: N,
      image: u(Qe),
      label: jt,
      labelText: Nt,
      lineEnding: Z,
      link: u(ze),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: de,
      resourceDestinationString: y,
      resourceTitleString: re,
      resource: pe,
      setextHeading: u(ie),
      setextHeadingLineSequence: V,
      setextHeadingText: O,
      strong: u(),
      thematicBreak: u()
    }
  };
  Rw(n, (e || {}).mdastExtensions || []);
  const t = {};
  return i;
  function i($) {
    let te = {
      type: "root",
      children: []
    };
    const Ee = {
      stack: [te],
      tokenStack: [],
      config: n,
      enter: a,
      exit: l,
      buffer: o,
      resume: c,
      data: t
    }, Pe = [];
    let qe = -1;
    for (; ++qe < $.length; )
      if ($[qe][1].type === "listOrdered" || $[qe][1].type === "listUnordered")
        if ($[qe][0] === "enter")
          Pe.push(qe);
        else {
          const Tn = Pe.pop();
          qe = r($, Tn, qe);
        }
    for (qe = -1; ++qe < $.length; ) {
      const Tn = n[$[qe][0]];
      Nw.call(Tn, $[qe][1].type) && Tn[$[qe][1].type].call(Object.assign({
        sliceSerialize: $[qe][2].sliceSerialize
      }, Ee), $[qe][1]);
    }
    if (Ee.tokenStack.length > 0) {
      const Tn = Ee.tokenStack[Ee.tokenStack.length - 1];
      (Tn[1] || qb).call(Ee, void 0, Tn[0]);
    }
    for (te.position = {
      start: sr($.length > 0 ? $[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: sr($.length > 0 ? $[$.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, qe = -1; ++qe < n.transforms.length; )
      te = n.transforms[qe](te) || te;
    return te;
  }
  function r($, te, Ee) {
    let Pe = te - 1, qe = -1, Tn = !1, Pi, Qn, Rr, Lr;
    for (; ++Pe <= Ee; ) {
      const tn = $[Pe];
      switch (tn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          tn[0] === "enter" ? qe++ : qe--, Lr = void 0;
          break;
        }
        case "lineEndingBlank": {
          tn[0] === "enter" && (Pi && !Lr && !qe && !Rr && (Rr = Pe), Lr = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Lr = void 0;
      }
      if (!qe && tn[0] === "enter" && tn[1].type === "listItemPrefix" || qe === -1 && tn[0] === "exit" && (tn[1].type === "listUnordered" || tn[1].type === "listOrdered")) {
        if (Pi) {
          let nr = Pe;
          for (Qn = void 0; nr--; ) {
            const yn = $[nr];
            if (yn[1].type === "lineEnding" || yn[1].type === "lineEndingBlank") {
              if (yn[0] === "exit") continue;
              Qn && ($[Qn][1].type = "lineEndingBlank", Tn = !0), yn[1].type = "lineEnding", Qn = nr;
            } else if (!(yn[1].type === "linePrefix" || yn[1].type === "blockQuotePrefix" || yn[1].type === "blockQuotePrefixWhitespace" || yn[1].type === "blockQuoteMarker" || yn[1].type === "listItemIndent")) break;
          }
          Rr && (!Qn || Rr < Qn) && (Pi._spread = !0), Pi.end = Object.assign({}, Qn ? $[Qn][1].start : tn[1].end), $.splice(Qn || Pe, 0, ["exit", Pi, tn[2]]), Pe++, Ee++;
        }
        if (tn[1].type === "listItemPrefix") {
          const nr = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, tn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          Pi = nr, $.splice(Pe, 0, ["enter", nr, tn[2]]), Pe++, Ee++, Rr = void 0, Lr = !0;
        }
      }
    }
    return $[te][1]._spread = Tn, Ee;
  }
  function s($, te) {
    return Ee;
    function Ee(Pe) {
      a.call(this, $(Pe), Pe), te && te.call(this, Pe);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function a($, te, Ee) {
    this.stack[this.stack.length - 1].children.push($), this.stack.push($), this.tokenStack.push([te, Ee || void 0]), $.position = {
      start: sr(te.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u($) {
    return te;
    function te(Ee) {
      $ && $.call(this, Ee), l.call(this, Ee);
    }
  }
  function l($, te) {
    const Ee = this.stack.pop(), Pe = this.tokenStack.pop();
    if (Pe)
      Pe[0].type !== $.type && (te ? te.call(this, $, Pe[0]) : (Pe[1] || qb).call(this, $, Pe[0]));
    else throw new Error("Cannot close `" + $.type + "` (" + ca({
      start: $.start,
      end: $.end
    }) + "): it’s not open");
    Ee.position.end = sr($.end);
  }
  function c() {
    return pc(this.stack.pop());
  }
  function d() {
    this.data.expectingFirstListItemValue = !0;
  }
  function p($) {
    if (this.data.expectingFirstListItemValue) {
      const te = this.stack[this.stack.length - 2];
      te.start = Number.parseInt(this.sliceSerialize($), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function g() {
    const $ = this.resume(), te = this.stack[this.stack.length - 1];
    te.lang = $;
  }
  function b() {
    const $ = this.resume(), te = this.stack[this.stack.length - 1];
    te.meta = $;
  }
  function _() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function k() {
    const $ = this.resume(), te = this.stack[this.stack.length - 1];
    te.value = $.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function C() {
    const $ = this.resume(), te = this.stack[this.stack.length - 1];
    te.value = $.replace(/(\r?\n|\r)$/g, "");
  }
  function D($) {
    const te = this.resume(), Ee = this.stack[this.stack.length - 1];
    Ee.label = te, Ee.identifier = si(this.sliceSerialize($)).toLowerCase();
  }
  function M() {
    const $ = this.resume(), te = this.stack[this.stack.length - 1];
    te.title = $;
  }
  function j() {
    const $ = this.resume(), te = this.stack[this.stack.length - 1];
    te.url = $;
  }
  function F($) {
    const te = this.stack[this.stack.length - 1];
    if (!te.depth) {
      const Ee = this.sliceSerialize($).length;
      te.depth = Ee;
    }
  }
  function O() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function V($) {
    const te = this.stack[this.stack.length - 1];
    te.depth = this.sliceSerialize($).codePointAt(0) === 61 ? 1 : 2;
  }
  function ie() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function W($) {
    const Ee = this.stack[this.stack.length - 1].children;
    let Pe = Ee[Ee.length - 1];
    (!Pe || Pe.type !== "text") && (Pe = Yc(), Pe.position = {
      start: sr($.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, Ee.push(Pe)), this.stack.push(Pe);
  }
  function N($) {
    const te = this.stack.pop();
    te.value += this.sliceSerialize($), te.position.end = sr($.end);
  }
  function Z($) {
    const te = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const Ee = te.children[te.children.length - 1];
      Ee.position.end = sr($.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(te.type) && (W.call(this, $), N.call(this, $));
  }
  function ee() {
    this.data.atHardBreak = !0;
  }
  function Ae() {
    const $ = this.resume(), te = this.stack[this.stack.length - 1];
    te.value = $;
  }
  function Ie() {
    const $ = this.resume(), te = this.stack[this.stack.length - 1];
    te.value = $;
  }
  function we() {
    const $ = this.resume(), te = this.stack[this.stack.length - 1];
    te.value = $;
  }
  function ze() {
    const $ = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const te = this.data.referenceType || "shortcut";
      $.type += "Reference", $.referenceType = te, delete $.url, delete $.title;
    } else
      delete $.identifier, delete $.label;
    this.data.referenceType = void 0;
  }
  function Qe() {
    const $ = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const te = this.data.referenceType || "shortcut";
      $.type += "Reference", $.referenceType = te, delete $.url, delete $.title;
    } else
      delete $.identifier, delete $.label;
    this.data.referenceType = void 0;
  }
  function Nt($) {
    const te = this.sliceSerialize($), Ee = this.stack[this.stack.length - 2];
    Ee.label = ow(te), Ee.identifier = si(te).toLowerCase();
  }
  function jt() {
    const $ = this.stack[this.stack.length - 1], te = this.resume(), Ee = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, Ee.type === "link") {
      const Pe = $.children;
      Ee.children = Pe;
    } else
      Ee.alt = te;
  }
  function y() {
    const $ = this.resume(), te = this.stack[this.stack.length - 1];
    te.url = $;
  }
  function re() {
    const $ = this.resume(), te = this.stack[this.stack.length - 1];
    te.title = $;
  }
  function pe() {
    this.data.inReference = void 0;
  }
  function S() {
    this.data.referenceType = "collapsed";
  }
  function de($) {
    const te = this.resume(), Ee = this.stack[this.stack.length - 1];
    Ee.label = te, Ee.identifier = si(this.sliceSerialize($)).toLowerCase(), this.data.referenceType = "full";
  }
  function Ce($) {
    this.data.characterReferenceType = $.type;
  }
  function le($) {
    const te = this.sliceSerialize($), Ee = this.data.characterReferenceType;
    let Pe;
    Ee ? (Pe = sw(te, Ee === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : Pe = Tm(te);
    const qe = this.stack[this.stack.length - 1];
    qe.value += Pe;
  }
  function ge($) {
    const te = this.stack.pop();
    te.position.end = sr($.end);
  }
  function be($) {
    N.call(this, $);
    const te = this.stack[this.stack.length - 1];
    te.url = this.sliceSerialize($);
  }
  function ve($) {
    N.call(this, $);
    const te = this.stack[this.stack.length - 1];
    te.url = "mailto:" + this.sliceSerialize($);
  }
  function Te() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Tt() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function se() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function ln() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function er() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function fi() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function tr() {
    return {
      type: "break"
    };
  }
  function ko() {
    return {
      type: "html",
      value: ""
    };
  }
  function Tu() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Nr() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function yu($) {
    return {
      type: "list",
      ordered: $.type === "listOrdered",
      start: null,
      spread: $._spread,
      children: []
    };
  }
  function zc($) {
    return {
      type: "listItem",
      spread: $._spread,
      checked: null,
      children: []
    };
  }
  function So() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function qc() {
    return {
      type: "strong",
      children: []
    };
  }
  function Yc() {
    return {
      type: "text",
      value: ""
    };
  }
  function wu() {
    return {
      type: "thematicBreak"
    };
  }
}
function sr(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Rw(e, n) {
  let t = -1;
  for (; ++t < n.length; ) {
    const i = n[t];
    Array.isArray(i) ? Rw(e, i) : nH(e, i);
  }
}
function nH(e, n) {
  let t;
  for (t in n)
    if (Nw.call(n, t))
      switch (t) {
        case "canContainEols": {
          const i = n[t];
          i && e[t].push(...i);
          break;
        }
        case "transforms": {
          const i = n[t];
          i && e[t].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[t];
          i && Object.assign(e[t], i);
          break;
        }
      }
}
function qb(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + ca({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + ca({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + ca({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function Lw(e) {
  const n = this;
  n.parser = t;
  function t(i) {
    return eH(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
const xm = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends TestFunction>(element: unknown, test: Condition, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & Predicate<Condition, Element>) &
   *   (<Condition extends string>(element: unknown, test: Condition, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & {tagName: Condition}) &
   *   ((element?: null | undefined) => false) &
   *   ((element: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element) &
   *   ((element: unknown, test?: Test, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => boolean)
   * )}
   */
  /**
   * @param {unknown} [element]
   * @param {Test | undefined} [test]
   * @param {number | null | undefined} [index]
   * @param {Parents | null | undefined} [parent]
   * @param {unknown} [context]
   * @returns {boolean}
   */
  // eslint-disable-next-line max-params
  function(e, n, t, i, r) {
    const s = ci(n);
    return Dw(e) ? s.call(r, e, t, i) : !1;
  }
), ci = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends TestFunction>(test: Condition) => (element: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & Predicate<Condition, Element>) &
   *   (<Condition extends string>(test: Condition) => (element: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & {tagName: Condition}) &
   *   ((test?: null | undefined) => (element?: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test | null | undefined} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return sH;
    if (typeof e == "string")
      return rH(e);
    if (typeof e == "object")
      return iH(e);
    if (typeof e == "function")
      return vm(e);
    throw new Error("Expected function, string, or array as `test`");
  }
);
function iH(e) {
  const n = [];
  let t = -1;
  for (; ++t < e.length; )
    n[t] = ci(e[t]);
  return vm(i);
  function i(...r) {
    let s = -1;
    for (; ++s < n.length; )
      if (n[s].apply(this, r)) return !0;
    return !1;
  }
}
function rH(e) {
  return vm(n);
  function n(t) {
    return t.tagName === e;
  }
}
function vm(e) {
  return n;
  function n(t, i, r) {
    return !!(Dw(t) && e.call(
      this,
      t,
      typeof i == "number" ? i : void 0,
      r || void 0
    ));
  }
}
function sH(e) {
  return !!(e && typeof e == "object" && "type" in e && e.type === "element" && "tagName" in e && typeof e.tagName == "string");
}
function Dw(e) {
  return e !== null && typeof e == "object" && "type" in e && "tagName" in e;
}
const Mw = ci(
  /**
   * @param element
   * @returns {element is {tagName: 'audio' | 'canvas' | 'embed' | 'iframe' | 'img' | 'math' | 'object' | 'picture' | 'svg' | 'video'}}
   */
  function(e) {
    return e.tagName === "audio" || e.tagName === "canvas" || e.tagName === "embed" || e.tagName === "iframe" || e.tagName === "img" || e.tagName === "math" || e.tagName === "object" || e.tagName === "picture" || e.tagName === "svg" || e.tagName === "video";
  }
), oH = /[ \t\n\f\r]/g;
function bo(e) {
  return typeof e == "object" ? e.type === "text" ? Yb(e.value) : !1 : Yb(e);
}
function Yb(e) {
  return e.replace(oH, "") === "";
}
const aH = [
  "address",
  // Flow content.
  "article",
  // Sections and headings.
  "aside",
  // Sections and headings.
  "blockquote",
  // Flow content.
  "body",
  // Page.
  "br",
  // Contribute whitespace intrinsically.
  "caption",
  // Similar to block.
  "center",
  // Flow content, legacy.
  "col",
  // Similar to block.
  "colgroup",
  // Similar to block.
  "dd",
  // Lists.
  "dialog",
  // Flow content.
  "dir",
  // Lists, legacy.
  "div",
  // Flow content.
  "dl",
  // Lists.
  "dt",
  // Lists.
  "figcaption",
  // Flow content.
  "figure",
  // Flow content.
  "footer",
  // Flow content.
  "form",
  // Flow content.
  "h1",
  // Sections and headings.
  "h2",
  // Sections and headings.
  "h3",
  // Sections and headings.
  "h4",
  // Sections and headings.
  "h5",
  // Sections and headings.
  "h6",
  // Sections and headings.
  "head",
  // Page.
  "header",
  // Flow content.
  "hgroup",
  // Sections and headings.
  "hr",
  // Flow content.
  "html",
  // Page.
  "legend",
  // Flow content.
  "li",
  // Block-like.
  "li",
  // Similar to block.
  "listing",
  // Flow content, legacy
  "main",
  // Flow content.
  "menu",
  // Lists.
  "nav",
  // Sections and headings.
  "ol",
  // Lists.
  "optgroup",
  // Similar to block.
  "option",
  // Similar to block.
  "p",
  // Flow content.
  "plaintext",
  // Flow content, legacy
  "pre",
  // Flow content.
  "section",
  // Sections and headings.
  "summary",
  // Similar to block.
  "table",
  // Similar to block.
  "tbody",
  // Similar to block.
  "td",
  // Block-like.
  "td",
  // Similar to block.
  "tfoot",
  // Similar to block.
  "th",
  // Block-like.
  "th",
  // Similar to block.
  "thead",
  // Similar to block.
  "tr",
  // Similar to block.
  "ul",
  // Lists.
  "wbr",
  // Contribute whitespace intrinsically.
  "xmp"
  // Flow content, legacy
], uH = [
  // Form.
  "button",
  "input",
  "select",
  "textarea"
], lH = [
  "area",
  "base",
  "basefont",
  "dialog",
  "datalist",
  "head",
  "link",
  "meta",
  "noembed",
  "noframes",
  "param",
  "rp",
  "script",
  "source",
  "style",
  "template",
  "track",
  "title"
], cH = {}, Pm = po(["comment", "doctype"]);
function dH(e, n) {
  Bw(e, {
    collapse: _H(
      (n || cH).newlines ? gH : bH
    ),
    whitespace: "normal"
  });
}
function Bw(e, n) {
  if ("children" in e) {
    const t = { ...n };
    return (e.type === "root" || Hw(e)) && (t.before = !0, t.after = !0), t.whitespace = EH(e, n), fH(e, t);
  }
  if (e.type === "text") {
    if (n.whitespace === "normal")
      return hH(e, n);
    n.whitespace === "nowrap" && (e.value = n.collapse(e.value));
  }
  return { ignore: Pm(e), stripAtStart: !1, remove: !1 };
}
function hH(e, n) {
  const t = n.collapse(e.value), i = { ignore: !1, stripAtStart: !1, remove: !1 };
  let r = 0, s = t.length;
  return n.before && jb(t.charAt(0)) && r++, r !== s && jb(t.charAt(s - 1)) && (n.after ? s-- : i.stripAtStart = !0), r === s ? i.remove = !0 : e.value = t.slice(r, s), i;
}
function fH(e, n) {
  let t = n.before;
  const i = n.after, r = e.children;
  let s = r.length, o = -1;
  for (; ++o < s; ) {
    const a = Bw(r[o], {
      ...n,
      after: Fw(r, o, i),
      before: t
    });
    a.remove ? (r.splice(o, 1), o--, s--) : a.ignore || (t = a.stripAtStart), Uw(r[o]) && (t = !1);
  }
  return { ignore: !1, stripAtStart: !!(t || i), remove: !1 };
}
function Fw(e, n, t) {
  for (; ++n < e.length; ) {
    const i = e[n];
    let r = mH(i);
    if (r === void 0 && "children" in i && !pH(i) && (r = Fw(i.children, -1)), typeof r == "boolean")
      return r;
  }
  return t;
}
function mH(e) {
  if (e.type === "element") {
    if (Uw(e))
      return !1;
    if (Hw(e))
      return !0;
  } else if (e.type === "text") {
    if (!bo(e))
      return !1;
  } else if (!Pm(e))
    return !1;
}
function Uw(e) {
  return Mw(e) || xm(e, uH);
}
function Hw(e) {
  return xm(e, aH);
}
function pH(e) {
  return !!(e.type === "element" && e.properties.hidden) || Pm(e) || xm(e, lH);
}
function jb(e) {
  return e === " " || e === `
`;
}
function gH(e) {
  const n = /\r?\n|\r/.exec(e);
  return n ? n[0] : " ";
}
function bH() {
  return " ";
}
function _H(e) {
  return n;
  function n(t) {
    return String(t).replace(/[\t\n\v\f\r ]+/g, e);
  }
}
function EH(e, n) {
  if ("tagName" in e && e.properties)
    switch (e.tagName) {
      case "listing":
      case "plaintext":
      case "script":
      case "style":
      case "xmp":
        return "pre";
      case "nobr":
        return "nowrap";
      case "pre":
        return e.properties.wrap ? "pre-wrap" : "pre";
      case "td":
      case "th":
        return e.properties.noWrap ? "nowrap" : n.whitespace;
      case "textarea":
        return "pre-wrap";
    }
  return n.whitespace;
}
function TH(e) {
  return function(n) {
    dH(n, e);
  };
}
function yH(e, n) {
  const t = n.properties || {}, i = (
    /** @type {Array<PhrasingContent>} */
    e.all(n)
  ), r = {
    type: "link",
    url: e.resolve(String(t.href || "") || null),
    title: t.title ? String(t.title) : null,
    children: i
  };
  return e.patch(n, r), r;
}
function wH(e, n) {
  e.baseFound || (e.frozenBaseUrl = String(n.properties && n.properties.href || "") || void 0, e.baseFound = !0);
}
function AH(e, n) {
  const t = { type: "blockquote", children: e.toFlow(e.all(n)) };
  return e.patch(n, t), t;
}
function CH(e, n) {
  const t = { type: "break" };
  return e.patch(n, t), t;
}
const Kb = (
  // Note: overloads like this are needed to support optional generics.
  /**
   * @type {(
   *   (<Kind extends UnistParent, Check extends Test>(parent: Kind, index: Child<Kind> | number, test: Check) => Matches<Child<Kind>, Check> | undefined) &
   *   (<Kind extends UnistParent>(parent: Kind, index: Child<Kind> | number, test?: null | undefined) => Child<Kind> | undefined)
   * )}
   */
  /**
   * @param {UnistParent} parent
   * @param {UnistNode | number} index
   * @param {Test} [test]
   * @returns {UnistNode | undefined}
   */
  function(e, n, t) {
    const i = po(t);
    if (!e || !e.type || !e.children)
      throw new Error("Expected parent node");
    if (typeof n == "number") {
      if (n < 0 || n === Number.POSITIVE_INFINITY)
        throw new Error("Expected positive finite number as index");
    } else if (n = e.children.indexOf(n), n < 0)
      throw new Error("Expected child node or index");
    for (; ++n < e.children.length; )
      if (i(e.children[n], n, e))
        return e.children[n];
  }
), Gb = /\n/g, Qb = /[\t ]+/g, rf = ci("br"), Xb = ci(OH), kH = ci("p"), Jb = ci("tr"), SH = ci([
  // List from: <https://html.spec.whatwg.org/multipage/rendering.html#hidden-elements>
  "datalist",
  "head",
  "noembed",
  "noframes",
  "noscript",
  // Act as if we support scripting.
  "rp",
  "script",
  "style",
  "template",
  "title",
  // Hidden attribute.
  PH,
  // From: <https://html.spec.whatwg.org/multipage/rendering.html#flow-content-3>
  NH
]), Vw = ci([
  "address",
  // Flow content
  "article",
  // Sections and headings
  "aside",
  // Sections and headings
  "blockquote",
  // Flow content
  "body",
  // Page
  "caption",
  // `table-caption`
  "center",
  // Flow content (legacy)
  "dd",
  // Lists
  "dialog",
  // Flow content
  "dir",
  // Lists (legacy)
  "dl",
  // Lists
  "dt",
  // Lists
  "div",
  // Flow content
  "figure",
  // Flow content
  "figcaption",
  // Flow content
  "footer",
  // Flow content
  "form,",
  // Flow content
  "h1",
  // Sections and headings
  "h2",
  // Sections and headings
  "h3",
  // Sections and headings
  "h4",
  // Sections and headings
  "h5",
  // Sections and headings
  "h6",
  // Sections and headings
  "header",
  // Flow content
  "hgroup",
  // Sections and headings
  "hr",
  // Flow content
  "html",
  // Page
  "legend",
  // Flow content
  "li",
  // Lists (as `display: list-item`)
  "listing",
  // Flow content (legacy)
  "main",
  // Flow content
  "menu",
  // Lists
  "nav",
  // Sections and headings
  "ol",
  // Lists
  "p",
  // Flow content
  "plaintext",
  // Flow content (legacy)
  "pre",
  // Flow content
  "section",
  // Sections and headings
  "ul",
  // Lists
  "xmp"
  // Flow content (legacy)
]);
function lu(e, n) {
  const t = {}, i = "children" in e ? e.children : [], r = Vw(e), s = zw(e, {
    whitespace: t.whitespace || "normal"
  }), o = [];
  (e.type === "text" || e.type === "comment") && o.push(
    ...Ww(e, {
      breakBefore: !0,
      breakAfter: !0
    })
  );
  let a = -1;
  for (; ++a < i.length; )
    o.push(
      ...$w(
        i[a],
        // @ts-expect-error: `tree` is a parent if we’re here.
        e,
        {
          whitespace: s,
          breakBefore: a ? void 0 : r,
          breakAfter: a < i.length - 1 ? rf(i[a + 1]) : r
        }
      )
    );
  const u = [];
  let l;
  for (a = -1; ++a < o.length; ) {
    const c = o[a];
    typeof c == "number" ? l !== void 0 && c > l && (l = c) : c && (l !== void 0 && l > -1 && u.push(`
`.repeat(l) || " "), l = -1, u.push(c));
  }
  return u.join("");
}
function $w(e, n, t) {
  return e.type === "element" ? IH(e, n, t) : e.type === "text" ? t.whitespace === "normal" ? Ww(e, t) : xH(e) : [];
}
function IH(e, n, t) {
  const i = zw(e, t), r = e.children || [];
  let s = -1, o = [];
  if (SH(e))
    return o;
  let a, u;
  for (rf(e) || Jb(e) && // @ts-expect-error: something up with types of parents.
  Kb(n, e, Jb) ? u = `
` : kH(e) ? (a = 2, u = 2) : Vw(e) && (a = 1, u = 1); ++s < r.length; )
    o = o.concat(
      $w(r[s], e, {
        whitespace: i,
        breakBefore: s ? void 0 : a,
        breakAfter: s < r.length - 1 ? rf(r[s + 1]) : u
      })
    );
  return Xb(e) && // @ts-expect-error: something up with types of parents.
  Kb(n, e, Xb) && o.push("	"), a && o.unshift(a), u && o.push(u), o;
}
function Ww(e, n) {
  const t = String(e.value), i = [], r = [];
  let s = 0;
  for (; s <= t.length; ) {
    Gb.lastIndex = s;
    const u = Gb.exec(t), l = u && "index" in u ? u.index : t.length;
    i.push(
      // Any sequence of collapsible spaces and tabs immediately preceding or
      // following a segment break is removed.
      vH(
        // […] ignoring bidi formatting characters (characters with the
        // Bidi_Control property [UAX9]: ALM, LTR, RTL, LRE-RLO, LRI-PDI) as if
        // they were not there.
        t.slice(s, l).replace(/[\u061C\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, ""),
        s === 0 ? n.breakBefore : !0,
        l === t.length ? n.breakAfter : !0
      )
    ), s = l + 1;
  }
  let o = -1, a;
  for (; ++o < i.length; )
    i[o].charCodeAt(i[o].length - 1) === 8203 || o < i.length - 1 && i[o + 1].charCodeAt(0) === 8203 ? (r.push(i[o]), a = void 0) : i[o] ? (typeof a == "number" && r.push(a), r.push(i[o]), a = 0) : (o === 0 || o === i.length - 1) && r.push(0);
  return r;
}
function xH(e) {
  return [String(e.value)];
}
function vH(e, n, t) {
  const i = [];
  let r = 0, s;
  for (; r < e.length; ) {
    Qb.lastIndex = r;
    const o = Qb.exec(e);
    s = o ? o.index : e.length, !r && !s && o && !n && i.push(""), r !== s && i.push(e.slice(r, s)), r = o ? s + o[0].length : s;
  }
  return r !== s && !t && i.push(""), i.join(" ");
}
function zw(e, n) {
  if (e.type === "element") {
    const t = e.properties || {};
    switch (e.tagName) {
      case "listing":
      case "plaintext":
      case "xmp":
        return "pre";
      case "nobr":
        return "nowrap";
      case "pre":
        return t.wrap ? "pre-wrap" : "pre";
      case "td":
      case "th":
        return t.noWrap ? "nowrap" : n.whitespace;
      case "textarea":
        return "pre-wrap";
    }
  }
  return n.whitespace;
}
function PH(e) {
  return !!(e.properties || {}).hidden;
}
function OH(e) {
  return e.tagName === "td" || e.tagName === "th";
}
function NH(e) {
  return e.tagName === "dialog" && !(e.properties || {}).open;
}
function RH(e) {
  const n = String(e);
  let t = n.length;
  for (; t > 0; ) {
    const i = n.codePointAt(t - 1);
    if (i !== void 0 && (i === 10 || i === 13))
      t--;
    else
      break;
  }
  return n.slice(0, t);
}
const Vd = "language-";
function $u(e, n) {
  const t = n.children;
  let i = -1, r, s;
  if (n.tagName === "pre")
    for (; ++i < t.length; ) {
      const a = t[i];
      if (a.type === "element" && a.tagName === "code" && a.properties && a.properties.className && Array.isArray(a.properties.className)) {
        r = a.properties.className;
        break;
      }
    }
  if (r) {
    for (i = -1; ++i < r.length; )
      if (String(r[i]).slice(0, Vd.length) === Vd) {
        s = String(r[i]).slice(Vd.length);
        break;
      }
  }
  const o = {
    type: "code",
    lang: s || null,
    meta: null,
    value: RH(lu(n))
  };
  return e.patch(n, o), o;
}
function LH(e, n) {
  const t = {
    type: "html",
    value: "<!--" + n.value + "-->"
  };
  return e.patch(n, t), t;
}
function $d(e, n) {
  const i = { type: "delete", children: (
    /** @type {Array<PhrasingContent>} */
    e.all(n)
  ) };
  return e.patch(n, i), i;
}
function Om(e) {
  let n = -1;
  if (e.length > 1) {
    for (; ++n < e.length; )
      if (e[n].spread)
        return !0;
  }
  return !1;
}
function DH(e, n) {
  const t = [], i = [];
  let r = -1;
  for (; ++r < n.children.length; ) {
    const a = n.children[r];
    a.type === "element" && a.tagName === "div" ? t.push(...a.children) : t.push(a);
  }
  let s = { definitions: [], titles: [] };
  for (r = -1; ++r < t.length; ) {
    const a = t[r];
    if (a.type === "element" && a.tagName === "dt") {
      const u = t[r - 1];
      u && u.type === "element" && u.tagName === "dd" && (i.push(s), s = { definitions: [], titles: [] }), s.titles.push(a);
    } else
      s.definitions.push(a);
  }
  i.push(s), r = -1;
  const o = [];
  for (; ++r < i.length; ) {
    const a = [
      ...Zb(e, i[r].titles),
      ...Zb(e, i[r].definitions)
    ];
    a.length > 0 && o.push({
      type: "listItem",
      spread: a.length > 1,
      checked: null,
      children: a
    });
  }
  if (o.length > 0) {
    const a = {
      type: "list",
      ordered: !1,
      start: null,
      spread: Om(o),
      children: o
    };
    return e.patch(n, a), a;
  }
}
function Zb(e, n) {
  const t = e.all({ type: "root", children: n }), i = e.toSpecificContent(t, MH);
  return i.length === 0 ? [] : i.length === 1 ? i[0].children : [
    {
      type: "list",
      ordered: !1,
      start: null,
      spread: Om(i),
      children: i
    }
  ];
}
function MH() {
  return { type: "listItem", spread: !1, checked: null, children: [] };
}
function Wu(e, n) {
  const i = { type: "emphasis", children: (
    /** @type {Array<PhrasingContent>} */
    e.all(n)
  ) };
  return e.patch(n, i), i;
}
function Nm(e) {
  let n = 0, t = e.length;
  for (; n < t && e[n].type === "break"; ) n++;
  for (; t > n && e[t - 1].type === "break"; ) t--;
  return n === 0 && t === e.length ? e : e.slice(n, t);
}
function Ps(e, n) {
  const t = (
    /** @type {Heading['depth']} */
    /* c8 ignore next */
    Number(n.tagName.charAt(1)) || 1
  ), i = Nm(
    /** @type {Array<PhrasingContent>} */
    e.all(n)
  ), r = { type: "heading", depth: t, children: i };
  return e.patch(n, r), r;
}
function BH(e, n) {
  const t = { type: "thematicBreak" };
  return e.patch(n, t), t;
}
function FH(e, n) {
  const t = n.properties || {}, i = String(t.src || ""), r = String(t.title || "");
  if (i && r) {
    const s = {
      type: "link",
      title: null,
      url: e.resolve(i),
      children: [{ type: "text", value: r }]
    };
    return e.patch(n, s), s;
  }
}
function e1(e, n) {
  const t = n.properties || {}, i = {
    type: "image",
    url: e.resolve(String(t.src || "") || null),
    title: t.title ? String(t.title) : null,
    alt: t.alt ? String(t.alt) : ""
  };
  return e.patch(n, i), i;
}
function Wo(e, n) {
  const t = { type: "inlineCode", value: lu(n) };
  return e.patch(n, t), t;
}
function qw(e, n) {
  const t = [], i = [], r = n || e.properties || {}, s = Yw(e), o = Math.min(Number.parseInt(String(r.size), 10), 0) || (r.multiple ? 4 : 1);
  let a = -1;
  for (; ++a < s.length; ) {
    const c = s[a];
    c && c.properties && c.properties.selected && t.push(c);
  }
  const u = t.length > 0 ? t : s, l = Math.min(u.length, o);
  for (a = -1; ++a < l; ) {
    const c = u[a], d = c.properties || {}, p = lu(c), g = p || String(d.label || ""), b = String(d.value || "") || p;
    i.push([b, g === b ? void 0 : g]);
  }
  return i;
}
function Yw(e) {
  const n = [];
  let t = -1;
  for (; ++t < e.children.length; ) {
    const i = e.children[t];
    "children" in i && Array.isArray(i.children) && n.push(...Yw(i)), i.type === "element" && i.tagName === "option" && (!i.properties || !i.properties.disabled) && n.push(i);
  }
  return n;
}
const UH = "[x]", HH = "[ ]";
function VH(e, n) {
  const t = n.properties || {}, i = String(t.value || t.placeholder || "");
  if (t.disabled || t.type === "hidden" || t.type === "file")
    return;
  if (t.type === "checkbox" || t.type === "radio") {
    const u = {
      type: "text",
      value: t.checked ? e.options.checked || UH : e.options.unchecked || HH
    };
    return e.patch(n, u), u;
  }
  if (t.type === "image") {
    const u = t.alt || i;
    if (u) {
      const l = {
        type: "image",
        url: e.resolve(String(t.src || "") || null),
        title: String(t.title || "") || null,
        alt: String(u)
      };
      return e.patch(n, l), l;
    }
    return;
  }
  let r = [];
  if (i)
    r = [[i, void 0]];
  else if (
    // `list` is not supported on these types:
    t.type !== "button" && t.type !== "file" && t.type !== "password" && t.type !== "reset" && t.type !== "submit" && t.list
  ) {
    const u = String(t.list), l = e.elementById.get(u);
    l && l.tagName === "datalist" && (r = qw(l, t));
  }
  if (r.length === 0)
    return;
  if (t.type === "password" && (r[0] = ["•".repeat(r[0][0].length), void 0]), t.type === "email" || t.type === "url") {
    const u = [];
    let l = -1;
    for (; ++l < r.length; ) {
      const c = e.resolve(r[l][0]), d = {
        type: "link",
        title: null,
        url: t.type === "email" ? "mailto:" + c : c,
        children: [{ type: "text", value: r[l][1] || c }]
      };
      u.push(d), l !== r.length - 1 && u.push({ type: "text", value: ", " });
    }
    return u;
  }
  const s = [];
  let o = -1;
  for (; ++o < r.length; )
    s.push(
      r[o][1] ? r[o][1] + " (" + r[o][0] + ")" : r[o][0]
    );
  const a = { type: "text", value: s.join(", ") };
  return e.patch(n, a), a;
}
const $H = {}.hasOwnProperty;
function WH(e, n) {
  const t = e.type === "element" && $H.call(e.properties, n) && e.properties[n];
  return t != null && t !== !1;
}
const zH = /* @__PURE__ */ new Set(["pingback", "prefetch", "stylesheet"]);
function qH(e) {
  if (e.type !== "element" || e.tagName !== "link")
    return !1;
  if (e.properties.itemProp)
    return !0;
  const n = e.properties.rel;
  let t = -1;
  if (!Array.isArray(n) || n.length === 0)
    return !1;
  for (; ++t < n.length; )
    if (!zH.has(String(n[t])))
      return !1;
  return !0;
}
const YH = ci([
  "a",
  "abbr",
  // `area` is in fact only phrasing if it is inside a `map` element.
  // However, since `area`s are required to be inside a `map` element, and it’s
  // a rather involved check, it’s ignored here for now.
  "area",
  "b",
  "bdi",
  "bdo",
  "br",
  "button",
  "cite",
  "code",
  "data",
  "datalist",
  "del",
  "dfn",
  "em",
  "i",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "map",
  "mark",
  "meter",
  "noscript",
  "output",
  "progress",
  "q",
  "ruby",
  "s",
  "samp",
  "script",
  "select",
  "small",
  "span",
  "strong",
  "sub",
  "sup",
  "template",
  "textarea",
  "time",
  "u",
  "var",
  "wbr"
]), jH = ci("meta");
function jw(e) {
  return !!(e.type === "text" || YH(e) || Mw(e) || qH(e) || jH(e) && WH(e, "itemProp"));
}
function Wd(e, n) {
  const { rest: t, checkbox: i } = Gw(n), r = i ? !!i.properties.checked : null, s = Kw(t), o = e.toFlow(e.all(t)), a = { type: "listItem", spread: s, checked: r, children: o };
  return e.patch(n, a), a;
}
function Kw(e) {
  let n = -1, t = !1;
  for (; ++n < e.children.length; ) {
    const i = e.children[n];
    if (i.type === "element") {
      if (jw(i)) continue;
      if (i.tagName === "p" || t || Kw(i))
        return !0;
      t = !0;
    }
  }
  return !1;
}
function Gw(e) {
  const n = e.children[0];
  if (n && n.type === "element" && n.tagName === "input" && n.properties && (n.properties.type === "checkbox" || n.properties.type === "radio")) {
    const t = { ...e, children: e.children.slice(1) };
    return { checkbox: n, rest: t };
  }
  if (n && n.type === "element" && n.tagName === "p") {
    const { checkbox: t, rest: i } = Gw(n);
    if (t) {
      const r = { ...e, children: [i, ...e.children.slice(1)] };
      return { checkbox: t, rest: r };
    }
  }
  return { checkbox: void 0, rest: e };
}
function zd(e, n) {
  const t = n.tagName === "ol", i = e.toSpecificContent(e.all(n), KH);
  let r = null;
  t && (r = n.properties && n.properties.start ? Number.parseInt(String(n.properties.start), 10) : 1);
  const s = {
    type: "list",
    ordered: t,
    start: r,
    spread: Om(i),
    children: i
  };
  return e.patch(n, s), s;
}
function KH() {
  return { type: "listItem", spread: !1, checked: null, children: [] };
}
function Ec(e) {
  let n = -1;
  for (; ++n < e.length; ) {
    const t = e[n];
    if (!Jw(t) || "children" in t && Ec(t.children))
      return !0;
  }
  return !1;
}
function Qw(e) {
  return Xw(e, n, function(t) {
    return t;
  });
  function n(t) {
    return t.every(function(i) {
      return i.type === "text" ? bo(i.value) : !1;
    }) ? [] : [{ type: "paragraph", children: Nm(t) }];
  }
}
function GH(e) {
  return Xw(e.children, n, t);
  function n(i) {
    const r = qd(e);
    return r.children = i, [r];
  }
  function t(i) {
    if ("children" in i && "children" in e) {
      const r = qd(e), s = qd(i);
      return r.children = i.children, s.children.push(r), s;
    }
    return { ...i };
  }
}
function Xw(e, n, t) {
  const i = QH(e), r = [];
  let s = [], o = -1;
  for (; ++o < i.length; ) {
    const a = i[o];
    Jw(a) ? s.push(a) : (s.length > 0 && (r.push(...n(s)), s = []), r.push(t(a)));
  }
  return s.length > 0 && (r.push(...n(s)), s = []), r;
}
function QH(e) {
  const n = [];
  let t = -1;
  for (; ++t < e.length; ) {
    const i = e[t];
    (i.type === "delete" || i.type === "link") && Ec(i.children) ? n.push(...GH(i)) : n.push(i);
  }
  return n;
}
function Jw(e) {
  const n = e.data && e.data.hName;
  return n ? jw({ type: "element", tagName: n, properties: {}, children: [] }) : iw(e);
}
function qd(e) {
  return Yi({ ...e, children: [] });
}
function t1(e, n) {
  const t = n.properties || {}, i = n.tagName === "video" ? String(t.poster || "") : "";
  let r = String(t.src || ""), s = -1, o = !1, a = e.all(n);
  if (Cr({ type: "root", children: a }, function(d) {
    if (d.type === "link")
      return o = !0, Ol;
  }), o || Ec(a))
    return a;
  for (; !r && ++s < n.children.length; ) {
    const d = n.children[s];
    d.type === "element" && d.tagName === "source" && d.properties && (r = String(d.properties.src || ""));
  }
  if (i) {
    const d = {
      type: "image",
      title: null,
      url: e.resolve(i),
      alt: pc(a)
    };
    e.patch(n, d), a = [d];
  }
  const l = (
    /** @type {Array<PhrasingContent>} */
    a
  ), c = {
    type: "link",
    title: t.title ? String(t.title) : null,
    url: e.resolve(r),
    children: l
  };
  return e.patch(n, c), c;
}
function n1(e, n) {
  const t = Nm(
    // Allow potentially “invalid” nodes, they might be unknown.
    // We also support straddling later.
    /** @type {Array<PhrasingContent>} */
    e.all(n)
  );
  if (t.length > 0) {
    const i = { type: "paragraph", children: t };
    return e.patch(n, i), i;
  }
}
const XH = ['"'];
function JH(e, n) {
  const t = e.options.quotes || XH;
  e.qNesting++;
  const i = e.all(n);
  e.qNesting--;
  const r = t[e.qNesting % t.length], s = i[0], o = i[i.length - 1], a = r.charAt(0), u = r.length > 1 ? r.charAt(1) : r;
  return s && s.type === "text" ? s.value = a + s.value : i.unshift({ type: "text", value: a }), o && o.type === "text" ? o.value += u : i.push({ type: "text", value: u }), i;
}
function ZH(e, n) {
  let t = e.all(n);
  (e.options.document || Ec(t)) && (t = Qw(t));
  const i = { type: "root", children: t };
  return e.patch(n, i), i;
}
function eV(e, n) {
  const t = qw(n);
  let i = -1;
  const r = [];
  for (; ++i < t.length; ) {
    const s = t[i];
    r.push(s[1] ? s[1] + " (" + s[0] + ")" : s[0]);
  }
  if (r.length > 0) {
    const s = { type: "text", value: r.join(", ") };
    return e.patch(n, s), s;
  }
}
function i1(e, n) {
  const i = { type: "strong", children: (
    /** @type {Array<PhrasingContent>} */
    e.all(n)
  ) };
  return e.patch(n, i), i;
}
function r1(e, n) {
  const i = { type: "tableCell", children: (
    /** @type {Array<PhrasingContent>} */
    e.all(n)
  ) };
  if (e.patch(n, i), n.properties) {
    const r = n.properties.rowSpan, s = n.properties.colSpan;
    if (r || s) {
      const o = (
        /** @type {Record<string, unknown>} */
        i.data || (i.data = {})
      );
      r && (o.hastUtilToMdastTemporaryRowSpan = r), s && (o.hastUtilToMdastTemporaryColSpan = s);
    }
  }
  return i;
}
function tV(e, n) {
  const i = { type: "tableRow", children: e.toSpecificContent(e.all(n), nV) };
  return e.patch(n, i), i;
}
function nV() {
  return { type: "tableCell", children: [] };
}
function iV(e, n) {
  if (e.inTable) {
    const l = { type: "text", value: lu(n) };
    return e.patch(n, l), l;
  }
  e.inTable = !0;
  const { align: t, headless: i } = rV(n), r = e.toSpecificContent(e.all(n), s1);
  i && r.unshift(s1());
  let s = -1;
  for (; ++s < r.length; ) {
    const l = r[s], c = e.toSpecificContent(l.children, sV);
    l.children = c;
  }
  let o = 1;
  for (s = -1; ++s < r.length; ) {
    const l = r[s].children;
    let c = -1;
    for (; ++c < l.length; ) {
      const d = l[c];
      if (d.data) {
        const p = (
          /** @type {Record<string, unknown>} */
          d.data
        ), g = Number.parseInt(String(p.hastUtilToMdastTemporaryColSpan), 10) || 1, b = Number.parseInt(String(p.hastUtilToMdastTemporaryRowSpan), 10) || 1;
        if (g > 1 || b > 1) {
          let _ = s - 1;
          for (; ++_ < s + b; ) {
            let k = c - 1;
            for (; ++k < c + g && r[_]; ) {
              const C = [];
              (_ !== s || k !== c) && C.push({ type: "tableCell", children: [] }), r[_].children.splice(k, 0, ...C);
            }
          }
        }
        "hastUtilToMdastTemporaryColSpan" in d.data && delete d.data.hastUtilToMdastTemporaryColSpan, "hastUtilToMdastTemporaryRowSpan" in d.data && delete d.data.hastUtilToMdastTemporaryRowSpan, Object.keys(d.data).length === 0 && delete d.data;
      }
    }
    l.length > o && (o = l.length);
  }
  for (s = -1; ++s < r.length; ) {
    const l = r[s].children;
    let c = l.length - 1;
    for (; ++c < o; )
      l.push({ type: "tableCell", children: [] });
  }
  let a = t.length - 1;
  for (; ++a < o; )
    t.push(null);
  e.inTable = !1;
  const u = { type: "table", align: t, children: r };
  return e.patch(n, u), u;
}
function rV(e) {
  const n = { align: [null], headless: !0 };
  let t = 0, i = 0;
  return Cr(e, function(r) {
    if (r.type === "element") {
      if (r.tagName === "table" && e !== r)
        return Fy;
      if ((r.tagName === "th" || r.tagName === "td") && r.properties) {
        if (!n.align[i]) {
          const s = String(r.properties.align || "") || null;
          (s === "center" || s === "left" || s === "right" || s === null) && (n.align[i] = s);
        }
        n.headless && t < 2 && r.tagName === "th" && (n.headless = !1), i++;
      } else r.tagName === "thead" ? n.headless = !1 : r.tagName === "tr" && (t++, i = 0);
    }
  }), n;
}
function sV() {
  return { type: "tableCell", children: [] };
}
function s1() {
  return { type: "tableRow", children: [] };
}
function oV(e, n) {
  const t = { type: "text", value: n.value };
  return e.patch(n, t), t;
}
function aV(e, n) {
  const t = { type: "text", value: lu(n) };
  return e.patch(n, t), t;
}
function uV(e, n) {
  const t = { type: "text", value: "​" };
  return e.patch(n, t), t;
}
const lV = {
  comment: LH,
  doctype: Ne,
  root: ZH,
  text: oV
}, cV = {
  // Ignore:
  applet: Ne,
  area: Ne,
  basefont: Ne,
  bgsound: Ne,
  caption: Ne,
  col: Ne,
  colgroup: Ne,
  command: Ne,
  content: Ne,
  datalist: Ne,
  dialog: Ne,
  element: Ne,
  embed: Ne,
  frame: Ne,
  frameset: Ne,
  isindex: Ne,
  keygen: Ne,
  link: Ne,
  math: Ne,
  menu: Ne,
  menuitem: Ne,
  meta: Ne,
  nextid: Ne,
  noembed: Ne,
  noframes: Ne,
  optgroup: Ne,
  option: Ne,
  param: Ne,
  script: Ne,
  shadow: Ne,
  source: Ne,
  spacer: Ne,
  style: Ne,
  svg: Ne,
  template: Ne,
  title: Ne,
  track: Ne,
  // Use children:
  abbr: Oe,
  acronym: Oe,
  bdi: Oe,
  bdo: Oe,
  big: Oe,
  blink: Oe,
  button: Oe,
  canvas: Oe,
  cite: Oe,
  data: Oe,
  details: Oe,
  dfn: Oe,
  font: Oe,
  ins: Oe,
  label: Oe,
  map: Oe,
  marquee: Oe,
  meter: Oe,
  nobr: Oe,
  noscript: Oe,
  object: Oe,
  output: Oe,
  progress: Oe,
  rb: Oe,
  rbc: Oe,
  rp: Oe,
  rt: Oe,
  rtc: Oe,
  ruby: Oe,
  slot: Oe,
  small: Oe,
  span: Oe,
  sup: Oe,
  sub: Oe,
  tbody: Oe,
  tfoot: Oe,
  thead: Oe,
  time: Oe,
  // Use children as flow.
  address: It,
  article: It,
  aside: It,
  body: It,
  center: It,
  div: It,
  fieldset: It,
  figcaption: It,
  figure: It,
  form: It,
  footer: It,
  header: It,
  hgroup: It,
  html: It,
  legend: It,
  main: It,
  multicol: It,
  nav: It,
  picture: It,
  section: It,
  // Handle.
  a: yH,
  audio: t1,
  b: i1,
  base: wH,
  blockquote: AH,
  br: CH,
  code: Wo,
  dir: zd,
  dl: DH,
  dt: Wd,
  dd: Wd,
  del: $d,
  em: Wu,
  h1: Ps,
  h2: Ps,
  h3: Ps,
  h4: Ps,
  h5: Ps,
  h6: Ps,
  hr: BH,
  i: Wu,
  iframe: FH,
  img: e1,
  image: e1,
  input: VH,
  kbd: Wo,
  li: Wd,
  listing: $u,
  mark: Wu,
  ol: zd,
  p: n1,
  plaintext: $u,
  pre: $u,
  q: JH,
  s: $d,
  samp: Wo,
  select: eV,
  strike: $d,
  strong: i1,
  summary: n1,
  table: iV,
  td: r1,
  textarea: aV,
  th: r1,
  tr: tV,
  tt: Wo,
  u: Wu,
  ul: zd,
  var: Wo,
  video: t1,
  wbr: uV,
  xmp: $u
};
function Oe(e, n) {
  return e.all(n);
}
function It(e, n) {
  return e.toFlow(e.all(n));
}
function Ne() {
}
const o1 = {}.hasOwnProperty;
function dV(e) {
  return {
    all: hV,
    baseFound: !1,
    elementById: /* @__PURE__ */ new Map(),
    frozenBaseUrl: void 0,
    handlers: { ...cV, ...e.handlers },
    inTable: !1,
    nodeHandlers: { ...lV, ...e.nodeHandlers },
    one: fV,
    options: e,
    patch: mV,
    qNesting: 0,
    resolve: pV,
    toFlow: gV,
    toSpecificContent: bV
  };
}
function hV(e) {
  const n = e.children || [], t = [];
  let i = -1;
  for (; ++i < n.length; ) {
    const r = n[i], s = (
      /** @type {Array<MdastRootContent> | MdastRootContent | undefined} */
      this.one(r, e)
    );
    Array.isArray(s) ? t.push(...s) : s && t.push(s);
  }
  return t;
}
function fV(e, n) {
  if (e.type === "element") {
    if (e.properties && e.properties.dataMdast === "ignore")
      return;
    if (o1.call(this.handlers, e.tagName))
      return this.handlers[e.tagName](this, e, n) || void 0;
  } else if (o1.call(this.nodeHandlers, e.type))
    return this.nodeHandlers[e.type](this, e, n) || void 0;
  if ("value" in e && typeof e.value == "string") {
    const t = { type: "text", value: e.value };
    return this.patch(e, t), t;
  }
  if ("children" in e)
    return this.all(e);
}
function mV(e, n) {
  e.position && (n.position = Am(e));
}
function pV(e) {
  const n = this.frozenBaseUrl;
  return e == null ? "" : n ? String(new URL(e, n)) : e;
}
function gV(e) {
  return Qw(e);
}
function bV(e, n) {
  const t = n(), i = [];
  let r = [], s = -1;
  for (; ++s < e.length; ) {
    const a = e[s];
    if (o(a))
      r.length > 0 && (a.children.unshift(...r), r = []), i.push(a);
    else {
      const u = (
        /** @type {ChildType} */
        a
      );
      r.push(u);
    }
  }
  if (r.length > 0) {
    let a = i[i.length - 1];
    a || (a = n(), i.push(a)), a.children.push(...r), r = [];
  }
  return i;
  function o(a) {
    return a.type === t.type;
  }
}
const _V = {};
function Ll(e, n) {
  const t = Yi(e), i = n || _V, r = TH({
    newlines: i.newlines === !0
  }), s = dV(i);
  let o;
  r(t), Cr(t, function(u) {
    if (u && u.type === "element" && u.properties) {
      const l = String(u.properties.id || "") || void 0;
      l && !s.elementById.has(l) && s.elementById.set(l, u);
    }
  });
  const a = s.one(t, void 0);
  return a ? Array.isArray(a) ? o = { type: "root", children: (
    /** @type {Array<MdastRootContent>} */
    a
  ) } : o = a : o = { type: "root", children: [] }, Cr(o, function(u, l, c) {
    if (u.type === "text" && l !== void 0 && c) {
      const d = c.children[l - 1];
      if (d && d.type === u.type)
        return d.value += u.value, c.children.splice(l, 1), d.position && u.position && (d.position.end = u.position.end), l - 1;
      if (u.value = u.value.replace(/[\t ]*(\r?\n|\r)[\t ]*/, "$1"), c && (c.type === "heading" || c.type === "paragraph" || c.type === "root") && (l || (u.value = u.value.replace(/^[\t ]+/, "")), l === c.children.length - 1 && (u.value = u.value.replace(/[\t ]+$/, ""))), !u.value)
        return c.children.splice(l, 1), l;
    }
  }), o;
}
const a1 = { document: !0 };
function EV(e, n) {
  return e && "run" in e ? async function(t, i) {
    const r = Ll(t, { ...a1, ...n });
    await e.run(r, i);
  } : function(t) {
    return (
      /** @type {MdastRoot} */
      Ll(t, { ...a1, ...e })
    );
  };
}
let cu = class {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(n, t, i) {
    this.normal = t, this.property = n, i && (this.space = i);
  }
};
cu.prototype.normal = {};
cu.prototype.property = {};
cu.prototype.space = void 0;
function Zw(e, n) {
  const t = {}, i = {};
  for (const r of e)
    Object.assign(t, r.property), Object.assign(i, r.normal);
  return new cu(t, i, n);
}
function za(e) {
  return e.toLowerCase();
}
let En = class {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(n, t) {
    this.attribute = t, this.property = n;
  }
};
En.prototype.attribute = "";
En.prototype.booleanish = !1;
En.prototype.boolean = !1;
En.prototype.commaOrSpaceSeparated = !1;
En.prototype.commaSeparated = !1;
En.prototype.defined = !1;
En.prototype.mustUseProperty = !1;
En.prototype.number = !1;
En.prototype.overloadedBoolean = !1;
En.prototype.property = "";
En.prototype.spaceSeparated = !1;
En.prototype.space = void 0;
let TV = 0;
const xe = ps(), xt = ps(), sf = ps(), X = ps(), nt = ps(), Ys = ps(), wn = ps();
function ps() {
  return 2 ** ++TV;
}
const of = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: xe,
  booleanish: xt,
  commaOrSpaceSeparated: wn,
  commaSeparated: Ys,
  number: X,
  overloadedBoolean: sf,
  spaceSeparated: nt
}, Symbol.toStringTag, { value: "Module" })), Yd = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(of)
);
let Rm = class extends En {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(n, t, i, r) {
    let s = -1;
    if (super(n, t), u1(this, "space", r), typeof i == "number")
      for (; ++s < Yd.length; ) {
        const o = Yd[s];
        u1(this, Yd[s], (i & of[o]) === of[o]);
      }
  }
};
Rm.prototype.defined = !0;
function u1(e, n, t) {
  t && (e[n] = t);
}
function _o(e) {
  const n = {}, t = {};
  for (const [i, r] of Object.entries(e.properties)) {
    const s = new Rm(
      i,
      e.transform(e.attributes || {}, i),
      r,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(i) && (s.mustUseProperty = !0), n[i] = s, t[za(i)] = i, t[za(s.attribute)] = i;
  }
  return new cu(n, t, e.space);
}
const e2 = _o({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: xt,
    ariaAutoComplete: null,
    ariaBusy: xt,
    ariaChecked: xt,
    ariaColCount: X,
    ariaColIndex: X,
    ariaColSpan: X,
    ariaControls: nt,
    ariaCurrent: null,
    ariaDescribedBy: nt,
    ariaDetails: null,
    ariaDisabled: xt,
    ariaDropEffect: nt,
    ariaErrorMessage: null,
    ariaExpanded: xt,
    ariaFlowTo: nt,
    ariaGrabbed: xt,
    ariaHasPopup: null,
    ariaHidden: xt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: nt,
    ariaLevel: X,
    ariaLive: null,
    ariaModal: xt,
    ariaMultiLine: xt,
    ariaMultiSelectable: xt,
    ariaOrientation: null,
    ariaOwns: nt,
    ariaPlaceholder: null,
    ariaPosInSet: X,
    ariaPressed: xt,
    ariaReadOnly: xt,
    ariaRelevant: null,
    ariaRequired: xt,
    ariaRoleDescription: nt,
    ariaRowCount: X,
    ariaRowIndex: X,
    ariaRowSpan: X,
    ariaSelected: xt,
    ariaSetSize: X,
    ariaSort: null,
    ariaValueMax: X,
    ariaValueMin: X,
    ariaValueNow: X,
    ariaValueText: null,
    role: null
  },
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  }
});
function t2(e, n) {
  return n in e ? e[n] : n;
}
function n2(e, n) {
  return t2(e, n.toLowerCase());
}
const yV = _o({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Ys,
    acceptCharset: nt,
    accessKey: nt,
    action: null,
    allow: null,
    allowFullScreen: xe,
    allowPaymentRequest: xe,
    allowUserMedia: xe,
    alt: null,
    as: null,
    async: xe,
    autoCapitalize: null,
    autoComplete: nt,
    autoFocus: xe,
    autoPlay: xe,
    blocking: nt,
    capture: null,
    charSet: null,
    checked: xe,
    cite: null,
    className: nt,
    cols: X,
    colSpan: null,
    content: null,
    contentEditable: xt,
    controls: xe,
    controlsList: nt,
    coords: X | Ys,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: xe,
    defer: xe,
    dir: null,
    dirName: null,
    disabled: xe,
    download: sf,
    draggable: xt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: xe,
    formTarget: null,
    headers: nt,
    height: X,
    hidden: sf,
    high: X,
    href: null,
    hrefLang: null,
    htmlFor: nt,
    httpEquiv: nt,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: xe,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: xe,
    itemId: null,
    itemProp: nt,
    itemRef: nt,
    itemScope: xe,
    itemType: nt,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: xe,
    low: X,
    manifest: null,
    max: null,
    maxLength: X,
    media: null,
    method: null,
    min: null,
    minLength: X,
    multiple: xe,
    muted: xe,
    name: null,
    nonce: null,
    noModule: xe,
    noValidate: xe,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: xe,
    optimum: X,
    pattern: null,
    ping: nt,
    placeholder: null,
    playsInline: xe,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: xe,
    referrerPolicy: null,
    rel: nt,
    required: xe,
    reversed: xe,
    rows: X,
    rowSpan: X,
    sandbox: nt,
    scope: null,
    scoped: xe,
    seamless: xe,
    selected: xe,
    shadowRootClonable: xe,
    shadowRootDelegatesFocus: xe,
    shadowRootMode: null,
    shape: null,
    size: X,
    sizes: null,
    slot: null,
    span: X,
    spellCheck: xt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: X,
    step: null,
    style: null,
    tabIndex: X,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: xe,
    useMap: null,
    value: xt,
    width: X,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: nt,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: X,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: X,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: xe,
    // Lists. Use CSS to reduce space between items instead
    declare: xe,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: X,
    // `<img>` and `<object>`
    leftMargin: X,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: X,
    // `<body>`
    marginWidth: X,
    // `<body>`
    noResize: xe,
    // `<frame>`
    noHref: xe,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: xe,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: xe,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: X,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: xt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: X,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: X,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: xe,
    disableRemotePlayback: xe,
    prefix: null,
    property: null,
    results: X,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: n2
}), wV = _o({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: wn,
    accentHeight: X,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: X,
    amplitude: X,
    arabicForm: null,
    ascent: X,
    attributeName: null,
    attributeType: null,
    azimuth: X,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: X,
    by: null,
    calcMode: null,
    capHeight: X,
    className: nt,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: X,
    diffuseConstant: X,
    direction: null,
    display: null,
    dur: null,
    divisor: X,
    dominantBaseline: null,
    download: xe,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: X,
    enableBackground: null,
    end: null,
    event: null,
    exponent: X,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: X,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Ys,
    g2: Ys,
    glyphName: Ys,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: X,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: X,
    horizOriginX: X,
    horizOriginY: X,
    id: null,
    ideographic: X,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: X,
    k: X,
    k1: X,
    k2: X,
    k3: X,
    k4: X,
    kernelMatrix: wn,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: X,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: X,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: X,
    overlineThickness: X,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: X,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: nt,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: X,
    pointsAtY: X,
    pointsAtZ: X,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: wn,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: wn,
    rev: wn,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: wn,
    requiredFeatures: wn,
    requiredFonts: wn,
    requiredFormats: wn,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: X,
    specularExponent: X,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: X,
    strikethroughThickness: X,
    string: null,
    stroke: null,
    strokeDashArray: wn,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: X,
    strokeOpacity: X,
    strokeWidth: null,
    style: null,
    surfaceScale: X,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: wn,
    tabIndex: X,
    tableValues: null,
    target: null,
    targetX: X,
    targetY: X,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: wn,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: X,
    underlineThickness: X,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: X,
    values: null,
    vAlphabetic: X,
    vMathematical: X,
    vectorEffect: null,
    vHanging: X,
    vIdeographic: X,
    version: null,
    vertAdvY: X,
    vertOriginX: X,
    vertOriginY: X,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: X,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: t2
}), i2 = _o({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  }
}), r2 = _o({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: n2
}), s2 = _o({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  }
}), AV = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, CV = /[A-Z]/g, l1 = /-[a-z]/g, kV = /^data[-\w.:]+$/i;
function Tc(e, n) {
  const t = za(n);
  let i = n, r = En;
  if (t in e.normal)
    return e.property[e.normal[t]];
  if (t.length > 4 && t.slice(0, 4) === "data" && kV.test(n)) {
    if (n.charAt(4) === "-") {
      const s = n.slice(5).replace(l1, IV);
      i = "data" + s.charAt(0).toUpperCase() + s.slice(1);
    } else {
      const s = n.slice(4);
      if (!l1.test(s)) {
        let o = s.replace(CV, SV);
        o.charAt(0) !== "-" && (o = "-" + o), n = "data" + o;
      }
    }
    r = Rm;
  }
  return new r(i, n);
}
function SV(e) {
  return "-" + e.toLowerCase();
}
function IV(e) {
  return e.charAt(1).toUpperCase();
}
const du = Zw([e2, yV, i2, r2, s2], "html"), vr = Zw([e2, wV, i2, r2, s2], "svg");
function c1(e) {
  const n = [], t = String(e || "");
  let i = t.indexOf(","), r = 0, s = !1;
  for (; !s; ) {
    i === -1 && (i = t.length, s = !0);
    const o = t.slice(r, i).trim();
    (o || !s) && n.push(o), r = i + 1, i = t.indexOf(",", r);
  }
  return n;
}
function Lm(e, n) {
  const t = n || {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (t.padRight ? " " : "") + "," + (t.padLeft === !1 ? "" : " ")
  ).trim();
}
const d1 = /[#.]/g;
function xV(e, n) {
  const t = e || "", i = {};
  let r = 0, s, o;
  for (; r < t.length; ) {
    d1.lastIndex = r;
    const a = d1.exec(t), u = t.slice(r, a ? a.index : t.length);
    u && (s ? s === "#" ? i.id = u : Array.isArray(i.className) ? i.className.push(u) : i.className = [u] : o = u, r += u.length), a && (s = a[0], r++);
  }
  return {
    type: "element",
    // @ts-expect-error: tag name is parsed.
    tagName: o || n || "div",
    properties: i,
    children: []
  };
}
function h1(e) {
  const n = String(e || "").trim();
  return n ? n.split(/[ \t\n\r\f]+/g) : [];
}
function Dm(e) {
  return e.join(" ").trim();
}
function o2(e, n, t) {
  const i = t ? NV(t) : void 0;
  function r(s, o, ...a) {
    let u;
    if (s == null) {
      u = { type: "root", children: [] };
      const l = (
        /** @type {Child} */
        o
      );
      a.unshift(l);
    } else {
      u = xV(s, n);
      const l = u.tagName.toLowerCase(), c = i ? i.get(l) : void 0;
      if (u.tagName = c || l, vV(o))
        a.unshift(o);
      else
        for (const [d, p] of Object.entries(o))
          PV(e, u.properties, d, p);
    }
    for (const l of a)
      af(u.children, l);
    return u.type === "element" && u.tagName === "template" && (u.content = { type: "root", children: u.children }, u.children = []), u;
  }
  return r;
}
function vV(e) {
  if (e === null || typeof e != "object" || Array.isArray(e))
    return !0;
  if (typeof e.type != "string") return !1;
  const n = (
    /** @type {Record<string, unknown>} */
    e
  ), t = Object.keys(e);
  for (const i of t) {
    const r = n[i];
    if (r && typeof r == "object") {
      if (!Array.isArray(r)) return !0;
      const s = (
        /** @type {ReadonlyArray<unknown>} */
        r
      );
      for (const o of s)
        if (typeof o != "number" && typeof o != "string")
          return !0;
    }
  }
  return !!("children" in e && Array.isArray(e.children));
}
function PV(e, n, t, i) {
  const r = Tc(e, t);
  let s;
  if (i != null) {
    if (typeof i == "number") {
      if (Number.isNaN(i)) return;
      s = i;
    } else typeof i == "boolean" ? s = i : typeof i == "string" ? r.spaceSeparated ? s = h1(i) : r.commaSeparated ? s = c1(i) : r.commaOrSpaceSeparated ? s = h1(c1(i).join(" ")) : s = f1(r, r.property, i) : Array.isArray(i) ? s = [...i] : s = r.property === "style" ? OV(i) : String(i);
    if (Array.isArray(s)) {
      const o = [];
      for (const a of s)
        o.push(
          /** @type {number | string} */
          f1(r, r.property, a)
        );
      s = o;
    }
    r.property === "className" && Array.isArray(n.className) && (s = n.className.concat(
      /** @type {Array<number | string> | number | string} */
      s
    )), n[r.property] = s;
  }
}
function af(e, n) {
  if (n != null) if (typeof n == "number" || typeof n == "string")
    e.push({ type: "text", value: String(n) });
  else if (Array.isArray(n))
    for (const t of n)
      af(e, t);
  else if (typeof n == "object" && "type" in n)
    n.type === "root" ? af(e, n.children) : e.push(n);
  else
    throw new Error("Expected node, nodes, or string, got `" + n + "`");
}
function f1(e, n, t) {
  if (typeof t == "string") {
    if (e.number && t && !Number.isNaN(Number(t)))
      return Number(t);
    if ((e.boolean || e.overloadedBoolean) && (t === "" || za(t) === za(n)))
      return !0;
  }
  return t;
}
function OV(e) {
  const n = [];
  for (const [t, i] of Object.entries(e))
    n.push([t, i].join(": "));
  return n.join("; ");
}
function NV(e) {
  const n = /* @__PURE__ */ new Map();
  for (const t of e)
    n.set(t.toLowerCase(), t);
  return n;
}
const RV = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], LV = o2(du, "div"), DV = o2(vr, "g", RV);
function MV(e) {
  const n = String(e), t = [];
  return { toOffset: r, toPoint: i };
  function i(s) {
    if (typeof s == "number" && s > -1 && s <= n.length) {
      let o = 0;
      for (; ; ) {
        let a = t[o];
        if (a === void 0) {
          const u = m1(n, t[o - 1]);
          a = u === -1 ? n.length + 1 : u + 1, t[o] = a;
        }
        if (a > s)
          return {
            line: o + 1,
            column: s - (o > 0 ? t[o - 1] : 0) + 1,
            offset: s
          };
        o++;
      }
    }
  }
  function r(s) {
    if (s && typeof s.line == "number" && typeof s.column == "number" && !Number.isNaN(s.line) && !Number.isNaN(s.column)) {
      for (; t.length < s.line; ) {
        const a = t[t.length - 1], u = m1(n, a), l = u === -1 ? n.length + 1 : u + 1;
        if (a === l) break;
        t.push(l);
      }
      const o = (s.line > 1 ? t[s.line - 2] : 0) + s.column - 1;
      if (o < t[s.line - 1]) return o;
    }
  }
}
function m1(e, n) {
  const t = e.indexOf("\r", n), i = e.indexOf(`
`, n);
  return i === -1 ? t : t === -1 || t + 1 === i ? i : t < i ? t : i;
}
const Gr = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, a2 = {}.hasOwnProperty, BV = Object.prototype;
function u2(e, n) {
  const t = n || {};
  return Mm(
    {
      file: t.file || void 0,
      location: !1,
      schema: t.space === "svg" ? vr : du,
      verbose: t.verbose || !1
    },
    e
  );
}
function Mm(e, n) {
  let t;
  switch (n.nodeName) {
    case "#comment": {
      const i = (
        /** @type {DefaultTreeAdapterMap['commentNode']} */
        n
      );
      return t = { type: "comment", value: i.data }, il(e, i, t), t;
    }
    case "#document":
    case "#document-fragment": {
      const i = (
        /** @type {DefaultTreeAdapterMap['document'] | DefaultTreeAdapterMap['documentFragment']} */
        n
      ), r = "mode" in i ? i.mode === "quirks" || i.mode === "limited-quirks" : !1;
      if (t = {
        type: "root",
        children: l2(e, n.childNodes),
        data: { quirksMode: r }
      }, e.file && e.location) {
        const s = String(e.file), o = MV(s), a = o.toPoint(0), u = o.toPoint(s.length);
        t.position = { start: a, end: u };
      }
      return t;
    }
    case "#documentType": {
      const i = (
        /** @type {DefaultTreeAdapterMap['documentType']} */
        n
      );
      return t = { type: "doctype" }, il(e, i, t), t;
    }
    case "#text": {
      const i = (
        /** @type {DefaultTreeAdapterMap['textNode']} */
        n
      );
      return t = { type: "text", value: i.value }, il(e, i, t), t;
    }
    default:
      return t = FV(
        e,
        /** @type {DefaultTreeAdapterMap['element']} */
        n
      ), t;
  }
}
function l2(e, n) {
  let t = -1;
  const i = [];
  for (; ++t < n.length; ) {
    const r = (
      /** @type {RootContent} */
      Mm(e, n[t])
    );
    i.push(r);
  }
  return i;
}
function FV(e, n) {
  const t = e.schema;
  e.schema = n.namespaceURI === Gr.svg ? vr : du;
  let i = -1;
  const r = {};
  for (; ++i < n.attrs.length; ) {
    const a = n.attrs[i], u = (a.prefix ? a.prefix + ":" : "") + a.name;
    a2.call(BV, u) || (r[u] = a.value);
  }
  const o = (e.schema.space === "svg" ? DV : LV)(n.tagName, r, l2(e, n.childNodes));
  if (il(e, n, o), o.tagName === "template") {
    const a = (
      /** @type {DefaultTreeAdapterMap['template']} */
      n
    ), u = a.sourceCodeLocation, l = u && u.startTag && $s(u.startTag), c = u && u.endTag && $s(u.endTag), d = (
      /** @type {Root} */
      Mm(e, a.content)
    );
    l && c && e.file && (d.position = { start: l.end, end: c.start }), o.content = d;
  }
  return e.schema = t, o;
}
function il(e, n, t) {
  if ("sourceCodeLocation" in n && n.sourceCodeLocation && e.file) {
    const i = UV(e, t, n.sourceCodeLocation);
    i && (e.location = !0, t.position = i);
  }
}
function UV(e, n, t) {
  const i = $s(t);
  if (n.type === "element") {
    const r = n.children[n.children.length - 1];
    if (i && !t.endTag && r && r.position && r.position.end && (i.end = Object.assign({}, r.position.end)), e.verbose) {
      const s = {};
      let o;
      if (t.attrs)
        for (o in t.attrs)
          a2.call(t.attrs, o) && (s[Tc(e.schema, o).property] = $s(
            t.attrs[o]
          ));
      t.startTag;
      const a = $s(t.startTag), u = t.endTag ? $s(t.endTag) : void 0, l = { opening: a };
      u && (l.closing = u), l.properties = s, n.data = { position: l };
    }
  }
  return i;
}
function $s(e) {
  const n = p1({
    line: e.startLine,
    column: e.startCol,
    offset: e.startOffset
  }), t = p1({
    line: e.endLine,
    column: e.endCol,
    offset: e.endOffset
  });
  return n || t ? { start: n, end: t } : void 0;
}
function p1(e) {
  return e.line && e.column ? e : void 0;
}
const HV = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]), lt = "�";
var E;
(function(e) {
  e[e.EOF = -1] = "EOF", e[e.NULL = 0] = "NULL", e[e.TABULATION = 9] = "TABULATION", e[e.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", e[e.LINE_FEED = 10] = "LINE_FEED", e[e.FORM_FEED = 12] = "FORM_FEED", e[e.SPACE = 32] = "SPACE", e[e.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", e[e.QUOTATION_MARK = 34] = "QUOTATION_MARK", e[e.AMPERSAND = 38] = "AMPERSAND", e[e.APOSTROPHE = 39] = "APOSTROPHE", e[e.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", e[e.SOLIDUS = 47] = "SOLIDUS", e[e.DIGIT_0 = 48] = "DIGIT_0", e[e.DIGIT_9 = 57] = "DIGIT_9", e[e.SEMICOLON = 59] = "SEMICOLON", e[e.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", e[e.EQUALS_SIGN = 61] = "EQUALS_SIGN", e[e.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", e[e.QUESTION_MARK = 63] = "QUESTION_MARK", e[e.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", e[e.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", e[e.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", e[e.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", e[e.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", e[e.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z";
})(E || (E = {}));
const dn = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function c2(e) {
  return e >= 55296 && e <= 57343;
}
function VV(e) {
  return e >= 56320 && e <= 57343;
}
function $V(e, n) {
  return (e - 55296) * 1024 + 9216 + n;
}
function d2(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
}
function h2(e) {
  return e >= 64976 && e <= 65007 || HV.has(e);
}
var U;
(function(e) {
  e.controlCharacterInInputStream = "control-character-in-input-stream", e.noncharacterInInputStream = "noncharacter-in-input-stream", e.surrogateInInputStream = "surrogate-in-input-stream", e.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", e.endTagWithAttributes = "end-tag-with-attributes", e.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", e.unexpectedSolidusInTag = "unexpected-solidus-in-tag", e.unexpectedNullCharacter = "unexpected-null-character", e.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", e.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", e.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", e.missingEndTagName = "missing-end-tag-name", e.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", e.unknownNamedCharacterReference = "unknown-named-character-reference", e.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", e.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", e.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", e.eofBeforeTagName = "eof-before-tag-name", e.eofInTag = "eof-in-tag", e.missingAttributeValue = "missing-attribute-value", e.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", e.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", e.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", e.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", e.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", e.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", e.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", e.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", e.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", e.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", e.cdataInHtmlContent = "cdata-in-html-content", e.incorrectlyOpenedComment = "incorrectly-opened-comment", e.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", e.eofInDoctype = "eof-in-doctype", e.nestedComment = "nested-comment", e.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", e.eofInComment = "eof-in-comment", e.incorrectlyClosedComment = "incorrectly-closed-comment", e.eofInCdata = "eof-in-cdata", e.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", e.nullCharacterReference = "null-character-reference", e.surrogateCharacterReference = "surrogate-character-reference", e.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", e.controlCharacterReference = "control-character-reference", e.noncharacterCharacterReference = "noncharacter-character-reference", e.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", e.missingDoctypeName = "missing-doctype-name", e.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", e.duplicateAttribute = "duplicate-attribute", e.nonConformingDoctype = "non-conforming-doctype", e.missingDoctype = "missing-doctype", e.misplacedDoctype = "misplaced-doctype", e.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", e.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", e.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", e.openElementsLeftAfterEof = "open-elements-left-after-eof", e.abandonedHeadElementChild = "abandoned-head-element-child", e.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", e.nestedNoscriptInHead = "nested-noscript-in-head", e.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(U || (U = {}));
const WV = 65536;
let zV = class {
  constructor(n) {
    this.handler = n, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = WV, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(n, t) {
    const { line: i, col: r, offset: s } = this, o = r + t, a = s + t;
    return {
      code: n,
      startLine: i,
      endLine: i,
      startCol: o,
      endCol: o,
      startOffset: a,
      endOffset: a
    };
  }
  _err(n) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(n, 0)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(n) {
    if (this.pos !== this.html.length - 1) {
      const t = this.html.charCodeAt(this.pos + 1);
      if (VV(t))
        return this.pos++, this._addGap(), $V(n, t);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, E.EOF;
    return this._err(U.surrogateInInputStream), n;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(n, t) {
    this.html.length > 0 ? this.html += n : this.html = n, this.endOfChunkHit = !1, this.lastChunkWritten = t;
  }
  insertHtmlAtCurrentPos(n) {
    this.html = this.html.substring(0, this.pos + 1) + n + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(n, t) {
    if (this.pos + n.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (t)
      return this.html.startsWith(n, this.pos);
    for (let i = 0; i < n.length; i++)
      if ((this.html.charCodeAt(this.pos + i) | 32) !== n.charCodeAt(i))
        return !1;
    return !0;
  }
  peek(n) {
    const t = this.pos + n;
    if (t >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, E.EOF;
    const i = this.html.charCodeAt(t);
    return i === E.CARRIAGE_RETURN ? E.LINE_FEED : i;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, E.EOF;
    let n = this.html.charCodeAt(this.pos);
    return n === E.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, E.LINE_FEED) : n === E.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, c2(n) && (n = this._processSurrogate(n)), this.handler.onParseError === null || n > 31 && n < 127 || n === E.LINE_FEED || n === E.CARRIAGE_RETURN || n > 159 && n < 64976 || this._checkForProblematicCharacters(n), n);
  }
  _checkForProblematicCharacters(n) {
    d2(n) ? this._err(U.controlCharacterInInputStream) : h2(n) && this._err(U.noncharacterInInputStream);
  }
  retreat(n) {
    for (this.pos -= n; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
};
var He;
(function(e) {
  e[e.CHARACTER = 0] = "CHARACTER", e[e.NULL_CHARACTER = 1] = "NULL_CHARACTER", e[e.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", e[e.START_TAG = 3] = "START_TAG", e[e.END_TAG = 4] = "END_TAG", e[e.COMMENT = 5] = "COMMENT", e[e.DOCTYPE = 6] = "DOCTYPE", e[e.EOF = 7] = "EOF", e[e.HIBERNATION = 8] = "HIBERNATION";
})(He || (He = {}));
function f2(e, n) {
  for (let t = e.attrs.length - 1; t >= 0; t--)
    if (e.attrs[t].name === n)
      return e.attrs[t].value;
  return null;
}
const qV = /* @__PURE__ */ new Uint16Array(
  // prettier-ignore
  /* @__PURE__ */ 'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), YV = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]);
function jV(e) {
  var n;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (n = YV.get(e)) !== null && n !== void 0 ? n : e;
}
var Vt;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(Vt || (Vt = {}));
const KV = 32;
var fr;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(fr || (fr = {}));
function uf(e) {
  return e >= Vt.ZERO && e <= Vt.NINE;
}
function GV(e) {
  return e >= Vt.UPPER_A && e <= Vt.UPPER_F || e >= Vt.LOWER_A && e <= Vt.LOWER_F;
}
function QV(e) {
  return e >= Vt.UPPER_A && e <= Vt.UPPER_Z || e >= Vt.LOWER_A && e <= Vt.LOWER_Z || uf(e);
}
function XV(e) {
  return e === Vt.EQUALS || QV(e);
}
var Ft;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(Ft || (Ft = {}));
var Bi;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(Bi || (Bi = {}));
let JV = class {
  constructor(n, t, i) {
    this.decodeTree = n, this.emitCodePoint = t, this.errors = i, this.state = Ft.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = Bi.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(n) {
    this.decodeMode = n, this.state = Ft.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(n, t) {
    switch (this.state) {
      case Ft.EntityStart:
        return n.charCodeAt(t) === Vt.NUM ? (this.state = Ft.NumericStart, this.consumed += 1, this.stateNumericStart(n, t + 1)) : (this.state = Ft.NamedEntity, this.stateNamedEntity(n, t));
      case Ft.NumericStart:
        return this.stateNumericStart(n, t);
      case Ft.NumericDecimal:
        return this.stateNumericDecimal(n, t);
      case Ft.NumericHex:
        return this.stateNumericHex(n, t);
      case Ft.NamedEntity:
        return this.stateNamedEntity(n, t);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(n, t) {
    return t >= n.length ? -1 : (n.charCodeAt(t) | KV) === Vt.LOWER_X ? (this.state = Ft.NumericHex, this.consumed += 1, this.stateNumericHex(n, t + 1)) : (this.state = Ft.NumericDecimal, this.stateNumericDecimal(n, t));
  }
  addToNumericResult(n, t, i, r) {
    if (t !== i) {
      const s = i - t;
      this.result = this.result * Math.pow(r, s) + Number.parseInt(n.substr(t, s), r), this.consumed += s;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(n, t) {
    const i = t;
    for (; t < n.length; ) {
      const r = n.charCodeAt(t);
      if (uf(r) || GV(r))
        t += 1;
      else
        return this.addToNumericResult(n, i, t, 16), this.emitNumericEntity(r, 3);
    }
    return this.addToNumericResult(n, i, t, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(n, t) {
    const i = t;
    for (; t < n.length; ) {
      const r = n.charCodeAt(t);
      if (uf(r))
        t += 1;
      else
        return this.addToNumericResult(n, i, t, 10), this.emitNumericEntity(r, 2);
    }
    return this.addToNumericResult(n, i, t, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(n, t) {
    var i;
    if (this.consumed <= t)
      return (i = this.errors) === null || i === void 0 || i.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (n === Vt.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === Bi.Strict)
      return 0;
    return this.emitCodePoint(jV(this.result), this.consumed), this.errors && (n !== Vt.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(n, t) {
    const { decodeTree: i } = this;
    let r = i[this.treeIndex], s = (r & fr.VALUE_LENGTH) >> 14;
    for (; t < n.length; t++, this.excess++) {
      const o = n.charCodeAt(t);
      if (this.treeIndex = ZV(i, r, this.treeIndex + Math.max(1, s), o), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === Bi.Attribute && // We shouldn't have consumed any characters after the entity,
        (s === 0 || // And there should be no invalid characters.
        XV(o)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (r = i[this.treeIndex], s = (r & fr.VALUE_LENGTH) >> 14, s !== 0) {
        if (o === Vt.SEMI)
          return this.emitNamedEntityData(this.treeIndex, s, this.consumed + this.excess);
        this.decodeMode !== Bi.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var n;
    const { result: t, decodeTree: i } = this, r = (i[t] & fr.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(t, r, this.consumed), (n = this.errors) === null || n === void 0 || n.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(n, t, i) {
    const { decodeTree: r } = this;
    return this.emitCodePoint(t === 1 ? r[n] & ~fr.VALUE_LENGTH : r[n + 1], i), t === 3 && this.emitCodePoint(r[n + 2], i), i;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var n;
    switch (this.state) {
      case Ft.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== Bi.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case Ft.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case Ft.NumericHex:
        return this.emitNumericEntity(0, 3);
      case Ft.NumericStart:
        return (n = this.errors) === null || n === void 0 || n.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case Ft.EntityStart:
        return 0;
    }
  }
};
function ZV(e, n, t, i) {
  const r = (n & fr.BRANCH_LENGTH) >> 7, s = n & fr.JUMP_TABLE;
  if (r === 0)
    return s !== 0 && i === s ? t : -1;
  if (s) {
    const u = i - s;
    return u < 0 || u >= r ? -1 : e[t + u] - 1;
  }
  let o = t, a = o + r - 1;
  for (; o <= a; ) {
    const u = o + a >>> 1, l = e[u];
    if (l < i)
      o = u + 1;
    else if (l > i)
      a = u - 1;
    else
      return e[u + r];
  }
  return -1;
}
var q;
(function(e) {
  e.HTML = "http://www.w3.org/1999/xhtml", e.MATHML = "http://www.w3.org/1998/Math/MathML", e.SVG = "http://www.w3.org/2000/svg", e.XLINK = "http://www.w3.org/1999/xlink", e.XML = "http://www.w3.org/XML/1998/namespace", e.XMLNS = "http://www.w3.org/2000/xmlns/";
})(q || (q = {}));
var Zr;
(function(e) {
  e.TYPE = "type", e.ACTION = "action", e.ENCODING = "encoding", e.PROMPT = "prompt", e.NAME = "name", e.COLOR = "color", e.FACE = "face", e.SIZE = "size";
})(Zr || (Zr = {}));
var Hn;
(function(e) {
  e.NO_QUIRKS = "no-quirks", e.QUIRKS = "quirks", e.LIMITED_QUIRKS = "limited-quirks";
})(Hn || (Hn = {}));
var R;
(function(e) {
  e.A = "a", e.ADDRESS = "address", e.ANNOTATION_XML = "annotation-xml", e.APPLET = "applet", e.AREA = "area", e.ARTICLE = "article", e.ASIDE = "aside", e.B = "b", e.BASE = "base", e.BASEFONT = "basefont", e.BGSOUND = "bgsound", e.BIG = "big", e.BLOCKQUOTE = "blockquote", e.BODY = "body", e.BR = "br", e.BUTTON = "button", e.CAPTION = "caption", e.CENTER = "center", e.CODE = "code", e.COL = "col", e.COLGROUP = "colgroup", e.DD = "dd", e.DESC = "desc", e.DETAILS = "details", e.DIALOG = "dialog", e.DIR = "dir", e.DIV = "div", e.DL = "dl", e.DT = "dt", e.EM = "em", e.EMBED = "embed", e.FIELDSET = "fieldset", e.FIGCAPTION = "figcaption", e.FIGURE = "figure", e.FONT = "font", e.FOOTER = "footer", e.FOREIGN_OBJECT = "foreignObject", e.FORM = "form", e.FRAME = "frame", e.FRAMESET = "frameset", e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e.HEAD = "head", e.HEADER = "header", e.HGROUP = "hgroup", e.HR = "hr", e.HTML = "html", e.I = "i", e.IMG = "img", e.IMAGE = "image", e.INPUT = "input", e.IFRAME = "iframe", e.KEYGEN = "keygen", e.LABEL = "label", e.LI = "li", e.LINK = "link", e.LISTING = "listing", e.MAIN = "main", e.MALIGNMARK = "malignmark", e.MARQUEE = "marquee", e.MATH = "math", e.MENU = "menu", e.META = "meta", e.MGLYPH = "mglyph", e.MI = "mi", e.MO = "mo", e.MN = "mn", e.MS = "ms", e.MTEXT = "mtext", e.NAV = "nav", e.NOBR = "nobr", e.NOFRAMES = "noframes", e.NOEMBED = "noembed", e.NOSCRIPT = "noscript", e.OBJECT = "object", e.OL = "ol", e.OPTGROUP = "optgroup", e.OPTION = "option", e.P = "p", e.PARAM = "param", e.PLAINTEXT = "plaintext", e.PRE = "pre", e.RB = "rb", e.RP = "rp", e.RT = "rt", e.RTC = "rtc", e.RUBY = "ruby", e.S = "s", e.SCRIPT = "script", e.SEARCH = "search", e.SECTION = "section", e.SELECT = "select", e.SOURCE = "source", e.SMALL = "small", e.SPAN = "span", e.STRIKE = "strike", e.STRONG = "strong", e.STYLE = "style", e.SUB = "sub", e.SUMMARY = "summary", e.SUP = "sup", e.TABLE = "table", e.TBODY = "tbody", e.TEMPLATE = "template", e.TEXTAREA = "textarea", e.TFOOT = "tfoot", e.TD = "td", e.TH = "th", e.THEAD = "thead", e.TITLE = "title", e.TR = "tr", e.TRACK = "track", e.TT = "tt", e.U = "u", e.UL = "ul", e.SVG = "svg", e.VAR = "var", e.WBR = "wbr", e.XMP = "xmp";
})(R || (R = {}));
var h;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.A = 1] = "A", e[e.ADDRESS = 2] = "ADDRESS", e[e.ANNOTATION_XML = 3] = "ANNOTATION_XML", e[e.APPLET = 4] = "APPLET", e[e.AREA = 5] = "AREA", e[e.ARTICLE = 6] = "ARTICLE", e[e.ASIDE = 7] = "ASIDE", e[e.B = 8] = "B", e[e.BASE = 9] = "BASE", e[e.BASEFONT = 10] = "BASEFONT", e[e.BGSOUND = 11] = "BGSOUND", e[e.BIG = 12] = "BIG", e[e.BLOCKQUOTE = 13] = "BLOCKQUOTE", e[e.BODY = 14] = "BODY", e[e.BR = 15] = "BR", e[e.BUTTON = 16] = "BUTTON", e[e.CAPTION = 17] = "CAPTION", e[e.CENTER = 18] = "CENTER", e[e.CODE = 19] = "CODE", e[e.COL = 20] = "COL", e[e.COLGROUP = 21] = "COLGROUP", e[e.DD = 22] = "DD", e[e.DESC = 23] = "DESC", e[e.DETAILS = 24] = "DETAILS", e[e.DIALOG = 25] = "DIALOG", e[e.DIR = 26] = "DIR", e[e.DIV = 27] = "DIV", e[e.DL = 28] = "DL", e[e.DT = 29] = "DT", e[e.EM = 30] = "EM", e[e.EMBED = 31] = "EMBED", e[e.FIELDSET = 32] = "FIELDSET", e[e.FIGCAPTION = 33] = "FIGCAPTION", e[e.FIGURE = 34] = "FIGURE", e[e.FONT = 35] = "FONT", e[e.FOOTER = 36] = "FOOTER", e[e.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", e[e.FORM = 38] = "FORM", e[e.FRAME = 39] = "FRAME", e[e.FRAMESET = 40] = "FRAMESET", e[e.H1 = 41] = "H1", e[e.H2 = 42] = "H2", e[e.H3 = 43] = "H3", e[e.H4 = 44] = "H4", e[e.H5 = 45] = "H5", e[e.H6 = 46] = "H6", e[e.HEAD = 47] = "HEAD", e[e.HEADER = 48] = "HEADER", e[e.HGROUP = 49] = "HGROUP", e[e.HR = 50] = "HR", e[e.HTML = 51] = "HTML", e[e.I = 52] = "I", e[e.IMG = 53] = "IMG", e[e.IMAGE = 54] = "IMAGE", e[e.INPUT = 55] = "INPUT", e[e.IFRAME = 56] = "IFRAME", e[e.KEYGEN = 57] = "KEYGEN", e[e.LABEL = 58] = "LABEL", e[e.LI = 59] = "LI", e[e.LINK = 60] = "LINK", e[e.LISTING = 61] = "LISTING", e[e.MAIN = 62] = "MAIN", e[e.MALIGNMARK = 63] = "MALIGNMARK", e[e.MARQUEE = 64] = "MARQUEE", e[e.MATH = 65] = "MATH", e[e.MENU = 66] = "MENU", e[e.META = 67] = "META", e[e.MGLYPH = 68] = "MGLYPH", e[e.MI = 69] = "MI", e[e.MO = 70] = "MO", e[e.MN = 71] = "MN", e[e.MS = 72] = "MS", e[e.MTEXT = 73] = "MTEXT", e[e.NAV = 74] = "NAV", e[e.NOBR = 75] = "NOBR", e[e.NOFRAMES = 76] = "NOFRAMES", e[e.NOEMBED = 77] = "NOEMBED", e[e.NOSCRIPT = 78] = "NOSCRIPT", e[e.OBJECT = 79] = "OBJECT", e[e.OL = 80] = "OL", e[e.OPTGROUP = 81] = "OPTGROUP", e[e.OPTION = 82] = "OPTION", e[e.P = 83] = "P", e[e.PARAM = 84] = "PARAM", e[e.PLAINTEXT = 85] = "PLAINTEXT", e[e.PRE = 86] = "PRE", e[e.RB = 87] = "RB", e[e.RP = 88] = "RP", e[e.RT = 89] = "RT", e[e.RTC = 90] = "RTC", e[e.RUBY = 91] = "RUBY", e[e.S = 92] = "S", e[e.SCRIPT = 93] = "SCRIPT", e[e.SEARCH = 94] = "SEARCH", e[e.SECTION = 95] = "SECTION", e[e.SELECT = 96] = "SELECT", e[e.SOURCE = 97] = "SOURCE", e[e.SMALL = 98] = "SMALL", e[e.SPAN = 99] = "SPAN", e[e.STRIKE = 100] = "STRIKE", e[e.STRONG = 101] = "STRONG", e[e.STYLE = 102] = "STYLE", e[e.SUB = 103] = "SUB", e[e.SUMMARY = 104] = "SUMMARY", e[e.SUP = 105] = "SUP", e[e.TABLE = 106] = "TABLE", e[e.TBODY = 107] = "TBODY", e[e.TEMPLATE = 108] = "TEMPLATE", e[e.TEXTAREA = 109] = "TEXTAREA", e[e.TFOOT = 110] = "TFOOT", e[e.TD = 111] = "TD", e[e.TH = 112] = "TH", e[e.THEAD = 113] = "THEAD", e[e.TITLE = 114] = "TITLE", e[e.TR = 115] = "TR", e[e.TRACK = 116] = "TRACK", e[e.TT = 117] = "TT", e[e.U = 118] = "U", e[e.UL = 119] = "UL", e[e.SVG = 120] = "SVG", e[e.VAR = 121] = "VAR", e[e.WBR = 122] = "WBR", e[e.XMP = 123] = "XMP";
})(h || (h = {}));
const e$ = /* @__PURE__ */ new Map([
  [R.A, h.A],
  [R.ADDRESS, h.ADDRESS],
  [R.ANNOTATION_XML, h.ANNOTATION_XML],
  [R.APPLET, h.APPLET],
  [R.AREA, h.AREA],
  [R.ARTICLE, h.ARTICLE],
  [R.ASIDE, h.ASIDE],
  [R.B, h.B],
  [R.BASE, h.BASE],
  [R.BASEFONT, h.BASEFONT],
  [R.BGSOUND, h.BGSOUND],
  [R.BIG, h.BIG],
  [R.BLOCKQUOTE, h.BLOCKQUOTE],
  [R.BODY, h.BODY],
  [R.BR, h.BR],
  [R.BUTTON, h.BUTTON],
  [R.CAPTION, h.CAPTION],
  [R.CENTER, h.CENTER],
  [R.CODE, h.CODE],
  [R.COL, h.COL],
  [R.COLGROUP, h.COLGROUP],
  [R.DD, h.DD],
  [R.DESC, h.DESC],
  [R.DETAILS, h.DETAILS],
  [R.DIALOG, h.DIALOG],
  [R.DIR, h.DIR],
  [R.DIV, h.DIV],
  [R.DL, h.DL],
  [R.DT, h.DT],
  [R.EM, h.EM],
  [R.EMBED, h.EMBED],
  [R.FIELDSET, h.FIELDSET],
  [R.FIGCAPTION, h.FIGCAPTION],
  [R.FIGURE, h.FIGURE],
  [R.FONT, h.FONT],
  [R.FOOTER, h.FOOTER],
  [R.FOREIGN_OBJECT, h.FOREIGN_OBJECT],
  [R.FORM, h.FORM],
  [R.FRAME, h.FRAME],
  [R.FRAMESET, h.FRAMESET],
  [R.H1, h.H1],
  [R.H2, h.H2],
  [R.H3, h.H3],
  [R.H4, h.H4],
  [R.H5, h.H5],
  [R.H6, h.H6],
  [R.HEAD, h.HEAD],
  [R.HEADER, h.HEADER],
  [R.HGROUP, h.HGROUP],
  [R.HR, h.HR],
  [R.HTML, h.HTML],
  [R.I, h.I],
  [R.IMG, h.IMG],
  [R.IMAGE, h.IMAGE],
  [R.INPUT, h.INPUT],
  [R.IFRAME, h.IFRAME],
  [R.KEYGEN, h.KEYGEN],
  [R.LABEL, h.LABEL],
  [R.LI, h.LI],
  [R.LINK, h.LINK],
  [R.LISTING, h.LISTING],
  [R.MAIN, h.MAIN],
  [R.MALIGNMARK, h.MALIGNMARK],
  [R.MARQUEE, h.MARQUEE],
  [R.MATH, h.MATH],
  [R.MENU, h.MENU],
  [R.META, h.META],
  [R.MGLYPH, h.MGLYPH],
  [R.MI, h.MI],
  [R.MO, h.MO],
  [R.MN, h.MN],
  [R.MS, h.MS],
  [R.MTEXT, h.MTEXT],
  [R.NAV, h.NAV],
  [R.NOBR, h.NOBR],
  [R.NOFRAMES, h.NOFRAMES],
  [R.NOEMBED, h.NOEMBED],
  [R.NOSCRIPT, h.NOSCRIPT],
  [R.OBJECT, h.OBJECT],
  [R.OL, h.OL],
  [R.OPTGROUP, h.OPTGROUP],
  [R.OPTION, h.OPTION],
  [R.P, h.P],
  [R.PARAM, h.PARAM],
  [R.PLAINTEXT, h.PLAINTEXT],
  [R.PRE, h.PRE],
  [R.RB, h.RB],
  [R.RP, h.RP],
  [R.RT, h.RT],
  [R.RTC, h.RTC],
  [R.RUBY, h.RUBY],
  [R.S, h.S],
  [R.SCRIPT, h.SCRIPT],
  [R.SEARCH, h.SEARCH],
  [R.SECTION, h.SECTION],
  [R.SELECT, h.SELECT],
  [R.SOURCE, h.SOURCE],
  [R.SMALL, h.SMALL],
  [R.SPAN, h.SPAN],
  [R.STRIKE, h.STRIKE],
  [R.STRONG, h.STRONG],
  [R.STYLE, h.STYLE],
  [R.SUB, h.SUB],
  [R.SUMMARY, h.SUMMARY],
  [R.SUP, h.SUP],
  [R.TABLE, h.TABLE],
  [R.TBODY, h.TBODY],
  [R.TEMPLATE, h.TEMPLATE],
  [R.TEXTAREA, h.TEXTAREA],
  [R.TFOOT, h.TFOOT],
  [R.TD, h.TD],
  [R.TH, h.TH],
  [R.THEAD, h.THEAD],
  [R.TITLE, h.TITLE],
  [R.TR, h.TR],
  [R.TRACK, h.TRACK],
  [R.TT, h.TT],
  [R.U, h.U],
  [R.UL, h.UL],
  [R.SVG, h.SVG],
  [R.VAR, h.VAR],
  [R.WBR, h.WBR],
  [R.XMP, h.XMP]
]);
function yc(e) {
  var n;
  return (n = e$.get(e)) !== null && n !== void 0 ? n : h.UNKNOWN;
}
const K = h, t$ = {
  [q.HTML]: /* @__PURE__ */ new Set([
    K.ADDRESS,
    K.APPLET,
    K.AREA,
    K.ARTICLE,
    K.ASIDE,
    K.BASE,
    K.BASEFONT,
    K.BGSOUND,
    K.BLOCKQUOTE,
    K.BODY,
    K.BR,
    K.BUTTON,
    K.CAPTION,
    K.CENTER,
    K.COL,
    K.COLGROUP,
    K.DD,
    K.DETAILS,
    K.DIR,
    K.DIV,
    K.DL,
    K.DT,
    K.EMBED,
    K.FIELDSET,
    K.FIGCAPTION,
    K.FIGURE,
    K.FOOTER,
    K.FORM,
    K.FRAME,
    K.FRAMESET,
    K.H1,
    K.H2,
    K.H3,
    K.H4,
    K.H5,
    K.H6,
    K.HEAD,
    K.HEADER,
    K.HGROUP,
    K.HR,
    K.HTML,
    K.IFRAME,
    K.IMG,
    K.INPUT,
    K.LI,
    K.LINK,
    K.LISTING,
    K.MAIN,
    K.MARQUEE,
    K.MENU,
    K.META,
    K.NAV,
    K.NOEMBED,
    K.NOFRAMES,
    K.NOSCRIPT,
    K.OBJECT,
    K.OL,
    K.P,
    K.PARAM,
    K.PLAINTEXT,
    K.PRE,
    K.SCRIPT,
    K.SECTION,
    K.SELECT,
    K.SOURCE,
    K.STYLE,
    K.SUMMARY,
    K.TABLE,
    K.TBODY,
    K.TD,
    K.TEMPLATE,
    K.TEXTAREA,
    K.TFOOT,
    K.TH,
    K.THEAD,
    K.TITLE,
    K.TR,
    K.TRACK,
    K.UL,
    K.WBR,
    K.XMP
  ]),
  [q.MATHML]: /* @__PURE__ */ new Set([K.MI, K.MO, K.MN, K.MS, K.MTEXT, K.ANNOTATION_XML]),
  [q.SVG]: /* @__PURE__ */ new Set([K.TITLE, K.FOREIGN_OBJECT, K.DESC]),
  [q.XLINK]: /* @__PURE__ */ new Set(),
  [q.XML]: /* @__PURE__ */ new Set(),
  [q.XMLNS]: /* @__PURE__ */ new Set()
}, lf = /* @__PURE__ */ new Set([K.H1, K.H2, K.H3, K.H4, K.H5, K.H6]);
R.STYLE, R.SCRIPT, R.XMP, R.IFRAME, R.NOEMBED, R.NOFRAMES, R.PLAINTEXT;
var w;
(function(e) {
  e[e.DATA = 0] = "DATA", e[e.RCDATA = 1] = "RCDATA", e[e.RAWTEXT = 2] = "RAWTEXT", e[e.SCRIPT_DATA = 3] = "SCRIPT_DATA", e[e.PLAINTEXT = 4] = "PLAINTEXT", e[e.TAG_OPEN = 5] = "TAG_OPEN", e[e.END_TAG_OPEN = 6] = "END_TAG_OPEN", e[e.TAG_NAME = 7] = "TAG_NAME", e[e.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", e[e.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", e[e.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", e[e.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", e[e.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", e[e.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", e[e.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", e[e.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", e[e.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", e[e.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", e[e.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", e[e.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", e[e.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", e[e.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", e[e.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", e[e.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", e[e.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", e[e.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", e[e.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", e[e.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", e[e.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", e[e.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", e[e.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", e[e.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", e[e.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", e[e.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", e[e.COMMENT_START = 42] = "COMMENT_START", e[e.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", e[e.COMMENT = 44] = "COMMENT", e[e.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", e[e.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", e[e.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", e[e.COMMENT_END = 50] = "COMMENT_END", e[e.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", e[e.DOCTYPE = 52] = "DOCTYPE", e[e.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", e[e.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", e[e.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", e[e.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", e[e.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", e[e.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", e[e.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", e[e.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", e[e.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", e[e.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", e[e.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", e[e.CDATA_SECTION = 68] = "CDATA_SECTION", e[e.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", e[e.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", e[e.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", e[e.AMBIGUOUS_AMPERSAND = 72] = "AMBIGUOUS_AMPERSAND";
})(w || (w = {}));
const gn = {
  DATA: w.DATA,
  RCDATA: w.RCDATA,
  RAWTEXT: w.RAWTEXT,
  SCRIPT_DATA: w.SCRIPT_DATA,
  PLAINTEXT: w.PLAINTEXT,
  CDATA_SECTION: w.CDATA_SECTION
};
function n$(e) {
  return e >= E.DIGIT_0 && e <= E.DIGIT_9;
}
function Zo(e) {
  return e >= E.LATIN_CAPITAL_A && e <= E.LATIN_CAPITAL_Z;
}
function i$(e) {
  return e >= E.LATIN_SMALL_A && e <= E.LATIN_SMALL_Z;
}
function ar(e) {
  return i$(e) || Zo(e);
}
function g1(e) {
  return ar(e) || n$(e);
}
function zu(e) {
  return e + 32;
}
function m2(e) {
  return e === E.SPACE || e === E.LINE_FEED || e === E.TABULATION || e === E.FORM_FEED;
}
function b1(e) {
  return m2(e) || e === E.SOLIDUS || e === E.GREATER_THAN_SIGN;
}
function r$(e) {
  return e === E.NULL ? U.nullCharacterReference : e > 1114111 ? U.characterReferenceOutsideUnicodeRange : c2(e) ? U.surrogateCharacterReference : h2(e) ? U.noncharacterCharacterReference : d2(e) || e === E.CARRIAGE_RETURN ? U.controlCharacterReference : null;
}
let s$ = class {
  constructor(n, t) {
    this.options = n, this.handler = t, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = w.DATA, this.returnState = w.DATA, this.entityStartPos = 0, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new zV(t), this.currentLocation = this.getCurrentLocation(-1), this.entityDecoder = new JV(qV, (i, r) => {
      this.preprocessor.pos = this.entityStartPos + r - 1, this._flushCodePointConsumedAsCharacterReference(i);
    }, t.onParseError ? {
      missingSemicolonAfterCharacterReference: () => {
        this._err(U.missingSemicolonAfterCharacterReference, 1);
      },
      absenceOfDigitsInNumericCharacterReference: (i) => {
        this._err(U.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + i);
      },
      validateNumericCharacterReference: (i) => {
        const r = r$(i);
        r && this._err(r, 1);
      }
    } : void 0);
  }
  //Errors
  _err(n, t = 0) {
    var i, r;
    (r = (i = this.handler).onParseError) === null || r === void 0 || r.call(i, this.preprocessor.getError(n, t));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(n) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - n,
      startOffset: this.preprocessor.offset - n,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const n = this._consume();
        this._ensureHibernation() || this._callState(n);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(n) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || n == null || n());
  }
  write(n, t, i) {
    this.active = !0, this.preprocessor.write(n, t), this._runParsingLoop(), this.paused || i == null || i();
  }
  insertHtmlAtCurrentPos(n) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(n), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this.preprocessor.retreat(this.consumedAfterSnapshot), this.consumedAfterSnapshot = 0, this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _advanceBy(n) {
    this.consumedAfterSnapshot += n;
    for (let t = 0; t < n; t++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(n, t) {
    return this.preprocessor.startsWith(n, t) ? (this._advanceBy(n.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: He.START_TAG,
      tagName: "",
      tagID: h.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: He.END_TAG,
      tagName: "",
      tagID: h.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(n) {
    this.currentToken = {
      type: He.COMMENT,
      data: "",
      location: this.getCurrentLocation(n)
    };
  }
  _createDoctypeToken(n) {
    this.currentToken = {
      type: He.DOCTYPE,
      name: n,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(n, t) {
    this.currentCharacterToken = {
      type: n,
      chars: t,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(n) {
    this.currentAttr = {
      name: n,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var n, t;
    const i = this.currentToken;
    if (f2(i, this.currentAttr.name) === null) {
      if (i.attrs.push(this.currentAttr), i.location && this.currentLocation) {
        const r = (n = (t = i.location).attrs) !== null && n !== void 0 ? n : t.attrs = /* @__PURE__ */ Object.create(null);
        r[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(U.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(n) {
    this._emitCurrentCharacterToken(n.location), this.currentToken = null, n.location && (n.location.endLine = this.preprocessor.line, n.location.endCol = this.preprocessor.col + 1, n.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const n = this.currentToken;
    this.prepareToken(n), n.tagID = yc(n.tagName), n.type === He.START_TAG ? (this.lastStartTagName = n.tagName, this.handler.onStartTag(n)) : (n.attrs.length > 0 && this._err(U.endTagWithAttributes), n.selfClosing && this._err(U.endTagWithTrailingSolidus), this.handler.onEndTag(n)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(n) {
    this.prepareToken(n), this.handler.onComment(n), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(n) {
    this.prepareToken(n), this.handler.onDoctype(n), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(n) {
    if (this.currentCharacterToken) {
      switch (n && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = n.startLine, this.currentCharacterToken.location.endCol = n.startCol, this.currentCharacterToken.location.endOffset = n.startOffset), this.currentCharacterToken.type) {
        case He.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case He.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case He.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const n = this.getCurrentLocation(0);
    n && (n.endLine = n.startLine, n.endCol = n.startCol, n.endOffset = n.startOffset), this._emitCurrentCharacterToken(n), this.handler.onEof({ type: He.EOF, location: n }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: The specification uses only one type of character token (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(n, t) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type === n) {
        this.currentCharacterToken.chars += t;
        return;
      } else
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
    this._createCharacterToken(n, t);
  }
  _emitCodePoint(n) {
    const t = m2(n) ? He.WHITESPACE_CHARACTER : n === E.NULL ? He.NULL_CHARACTER : He.CHARACTER;
    this._appendCharToCurrentCharacterToken(t, String.fromCodePoint(n));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(n) {
    this._appendCharToCurrentCharacterToken(He.CHARACTER, n);
  }
  // Character reference helpers
  _startCharacterReference() {
    this.returnState = this.state, this.state = w.CHARACTER_REFERENCE, this.entityStartPos = this.preprocessor.pos, this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? Bi.Attribute : Bi.Legacy);
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === w.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === w.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === w.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(n) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(n) : this._emitCodePoint(n);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(n) {
    switch (this.state) {
      case w.DATA: {
        this._stateData(n);
        break;
      }
      case w.RCDATA: {
        this._stateRcdata(n);
        break;
      }
      case w.RAWTEXT: {
        this._stateRawtext(n);
        break;
      }
      case w.SCRIPT_DATA: {
        this._stateScriptData(n);
        break;
      }
      case w.PLAINTEXT: {
        this._statePlaintext(n);
        break;
      }
      case w.TAG_OPEN: {
        this._stateTagOpen(n);
        break;
      }
      case w.END_TAG_OPEN: {
        this._stateEndTagOpen(n);
        break;
      }
      case w.TAG_NAME: {
        this._stateTagName(n);
        break;
      }
      case w.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(n);
        break;
      }
      case w.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(n);
        break;
      }
      case w.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(n);
        break;
      }
      case w.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(n);
        break;
      }
      case w.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(n);
        break;
      }
      case w.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(n);
        break;
      }
      case w.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(n);
        break;
      }
      case w.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(n);
        break;
      }
      case w.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(n);
        break;
      }
      case w.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(n);
        break;
      }
      case w.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(n);
        break;
      }
      case w.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(n);
        break;
      }
      case w.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(n);
        break;
      }
      case w.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(n);
        break;
      }
      case w.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(n);
        break;
      }
      case w.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(n);
        break;
      }
      case w.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(n);
        break;
      }
      case w.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(n);
        break;
      }
      case w.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(n);
        break;
      }
      case w.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(n);
        break;
      }
      case w.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(n);
        break;
      }
      case w.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(n);
        break;
      }
      case w.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(n);
        break;
      }
      case w.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(n);
        break;
      }
      case w.ATTRIBUTE_NAME: {
        this._stateAttributeName(n);
        break;
      }
      case w.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(n);
        break;
      }
      case w.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(n);
        break;
      }
      case w.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(n);
        break;
      }
      case w.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(n);
        break;
      }
      case w.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(n);
        break;
      }
      case w.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(n);
        break;
      }
      case w.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(n);
        break;
      }
      case w.BOGUS_COMMENT: {
        this._stateBogusComment(n);
        break;
      }
      case w.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(n);
        break;
      }
      case w.COMMENT_START: {
        this._stateCommentStart(n);
        break;
      }
      case w.COMMENT_START_DASH: {
        this._stateCommentStartDash(n);
        break;
      }
      case w.COMMENT: {
        this._stateComment(n);
        break;
      }
      case w.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(n);
        break;
      }
      case w.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(n);
        break;
      }
      case w.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(n);
        break;
      }
      case w.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(n);
        break;
      }
      case w.COMMENT_END_DASH: {
        this._stateCommentEndDash(n);
        break;
      }
      case w.COMMENT_END: {
        this._stateCommentEnd(n);
        break;
      }
      case w.COMMENT_END_BANG: {
        this._stateCommentEndBang(n);
        break;
      }
      case w.DOCTYPE: {
        this._stateDoctype(n);
        break;
      }
      case w.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(n);
        break;
      }
      case w.DOCTYPE_NAME: {
        this._stateDoctypeName(n);
        break;
      }
      case w.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(n);
        break;
      }
      case w.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(n);
        break;
      }
      case w.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(n);
        break;
      }
      case w.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(n);
        break;
      }
      case w.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(n);
        break;
      }
      case w.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(n);
        break;
      }
      case w.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(n);
        break;
      }
      case w.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(n);
        break;
      }
      case w.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(n);
        break;
      }
      case w.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(n);
        break;
      }
      case w.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(n);
        break;
      }
      case w.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(n);
        break;
      }
      case w.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(n);
        break;
      }
      case w.CDATA_SECTION: {
        this._stateCdataSection(n);
        break;
      }
      case w.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(n);
        break;
      }
      case w.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(n);
        break;
      }
      case w.CHARACTER_REFERENCE: {
        this._stateCharacterReference();
        break;
      }
      case w.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(n);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(n) {
    switch (n) {
      case E.LESS_THAN_SIGN: {
        this.state = w.TAG_OPEN;
        break;
      }
      case E.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), this._emitCodePoint(n);
        break;
      }
      case E.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(n);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(n) {
    switch (n) {
      case E.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case E.LESS_THAN_SIGN: {
        this.state = w.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), this._emitChars(lt);
        break;
      }
      case E.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(n);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(n) {
    switch (n) {
      case E.LESS_THAN_SIGN: {
        this.state = w.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), this._emitChars(lt);
        break;
      }
      case E.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(n);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(n) {
    switch (n) {
      case E.LESS_THAN_SIGN: {
        this.state = w.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), this._emitChars(lt);
        break;
      }
      case E.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(n);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(n) {
    switch (n) {
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), this._emitChars(lt);
        break;
      }
      case E.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(n);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(n) {
    if (ar(n))
      this._createStartTagToken(), this.state = w.TAG_NAME, this._stateTagName(n);
    else
      switch (n) {
        case E.EXCLAMATION_MARK: {
          this.state = w.MARKUP_DECLARATION_OPEN;
          break;
        }
        case E.SOLIDUS: {
          this.state = w.END_TAG_OPEN;
          break;
        }
        case E.QUESTION_MARK: {
          this._err(U.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = w.BOGUS_COMMENT, this._stateBogusComment(n);
          break;
        }
        case E.EOF: {
          this._err(U.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(U.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = w.DATA, this._stateData(n);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(n) {
    if (ar(n))
      this._createEndTagToken(), this.state = w.TAG_NAME, this._stateTagName(n);
    else
      switch (n) {
        case E.GREATER_THAN_SIGN: {
          this._err(U.missingEndTagName), this.state = w.DATA;
          break;
        }
        case E.EOF: {
          this._err(U.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(U.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = w.BOGUS_COMMENT, this._stateBogusComment(n);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(n) {
    const t = this.currentToken;
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED: {
        this.state = w.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case E.SOLIDUS: {
        this.state = w.SELF_CLOSING_START_TAG;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this.state = w.DATA, this.emitCurrentTagToken();
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), t.tagName += lt;
        break;
      }
      case E.EOF: {
        this._err(U.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        t.tagName += String.fromCodePoint(Zo(n) ? zu(n) : n);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(n) {
    n === E.SOLIDUS ? this.state = w.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = w.RCDATA, this._stateRcdata(n));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(n) {
    ar(n) ? (this.state = w.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(n)) : (this._emitChars("</"), this.state = w.RCDATA, this._stateRcdata(n));
  }
  handleSpecialEndTag(n) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const t = this.currentToken;
    switch (t.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = w.BEFORE_ATTRIBUTE_NAME, !1;
      case E.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = w.SELF_CLOSING_START_TAG, !1;
      case E.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = w.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(n) {
    this.handleSpecialEndTag(n) && (this._emitChars("</"), this.state = w.RCDATA, this._stateRcdata(n));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(n) {
    n === E.SOLIDUS ? this.state = w.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = w.RAWTEXT, this._stateRawtext(n));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(n) {
    ar(n) ? (this.state = w.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(n)) : (this._emitChars("</"), this.state = w.RAWTEXT, this._stateRawtext(n));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(n) {
    this.handleSpecialEndTag(n) && (this._emitChars("</"), this.state = w.RAWTEXT, this._stateRawtext(n));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(n) {
    switch (n) {
      case E.SOLIDUS: {
        this.state = w.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case E.EXCLAMATION_MARK: {
        this.state = w.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = w.SCRIPT_DATA, this._stateScriptData(n);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(n) {
    ar(n) ? (this.state = w.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(n)) : (this._emitChars("</"), this.state = w.SCRIPT_DATA, this._stateScriptData(n));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(n) {
    this.handleSpecialEndTag(n) && (this._emitChars("</"), this.state = w.SCRIPT_DATA, this._stateScriptData(n));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(n) {
    n === E.HYPHEN_MINUS ? (this.state = w.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = w.SCRIPT_DATA, this._stateScriptData(n));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(n) {
    n === E.HYPHEN_MINUS ? (this.state = w.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = w.SCRIPT_DATA, this._stateScriptData(n));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(n) {
    switch (n) {
      case E.HYPHEN_MINUS: {
        this.state = w.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case E.LESS_THAN_SIGN: {
        this.state = w.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), this._emitChars(lt);
        break;
      }
      case E.EOF: {
        this._err(U.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(n);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(n) {
    switch (n) {
      case E.HYPHEN_MINUS: {
        this.state = w.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case E.LESS_THAN_SIGN: {
        this.state = w.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), this.state = w.SCRIPT_DATA_ESCAPED, this._emitChars(lt);
        break;
      }
      case E.EOF: {
        this._err(U.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = w.SCRIPT_DATA_ESCAPED, this._emitCodePoint(n);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(n) {
    switch (n) {
      case E.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case E.LESS_THAN_SIGN: {
        this.state = w.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this.state = w.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), this.state = w.SCRIPT_DATA_ESCAPED, this._emitChars(lt);
        break;
      }
      case E.EOF: {
        this._err(U.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = w.SCRIPT_DATA_ESCAPED, this._emitCodePoint(n);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(n) {
    n === E.SOLIDUS ? this.state = w.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : ar(n) ? (this._emitChars("<"), this.state = w.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(n)) : (this._emitChars("<"), this.state = w.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(n));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(n) {
    ar(n) ? (this.state = w.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(n)) : (this._emitChars("</"), this.state = w.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(n));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(n) {
    this.handleSpecialEndTag(n) && (this._emitChars("</"), this.state = w.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(n));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(n) {
    if (this.preprocessor.startsWith(dn.SCRIPT, !1) && b1(this.preprocessor.peek(dn.SCRIPT.length))) {
      this._emitCodePoint(n);
      for (let t = 0; t < dn.SCRIPT.length; t++)
        this._emitCodePoint(this._consume());
      this.state = w.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else this._ensureHibernation() || (this.state = w.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(n));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(n) {
    switch (n) {
      case E.HYPHEN_MINUS: {
        this.state = w.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case E.LESS_THAN_SIGN: {
        this.state = w.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), this._emitChars(lt);
        break;
      }
      case E.EOF: {
        this._err(U.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(n);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(n) {
    switch (n) {
      case E.HYPHEN_MINUS: {
        this.state = w.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case E.LESS_THAN_SIGN: {
        this.state = w.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), this.state = w.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(lt);
        break;
      }
      case E.EOF: {
        this._err(U.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = w.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(n);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(n) {
    switch (n) {
      case E.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case E.LESS_THAN_SIGN: {
        this.state = w.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this.state = w.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), this.state = w.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(lt);
        break;
      }
      case E.EOF: {
        this._err(U.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = w.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(n);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(n) {
    n === E.SOLIDUS ? (this.state = w.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = w.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(n));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(n) {
    if (this.preprocessor.startsWith(dn.SCRIPT, !1) && b1(this.preprocessor.peek(dn.SCRIPT.length))) {
      this._emitCodePoint(n);
      for (let t = 0; t < dn.SCRIPT.length; t++)
        this._emitCodePoint(this._consume());
      this.state = w.SCRIPT_DATA_ESCAPED;
    } else this._ensureHibernation() || (this.state = w.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(n));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(n) {
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED:
        break;
      case E.SOLIDUS:
      case E.GREATER_THAN_SIGN:
      case E.EOF: {
        this.state = w.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(n);
        break;
      }
      case E.EQUALS_SIGN: {
        this._err(U.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = w.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = w.ATTRIBUTE_NAME, this._stateAttributeName(n);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(n) {
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED:
      case E.SOLIDUS:
      case E.GREATER_THAN_SIGN:
      case E.EOF: {
        this._leaveAttrName(), this.state = w.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(n);
        break;
      }
      case E.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = w.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case E.QUOTATION_MARK:
      case E.APOSTROPHE:
      case E.LESS_THAN_SIGN: {
        this._err(U.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(n);
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), this.currentAttr.name += lt;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(Zo(n) ? zu(n) : n);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(n) {
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED:
        break;
      case E.SOLIDUS: {
        this.state = w.SELF_CLOSING_START_TAG;
        break;
      }
      case E.EQUALS_SIGN: {
        this.state = w.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this.state = w.DATA, this.emitCurrentTagToken();
        break;
      }
      case E.EOF: {
        this._err(U.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = w.ATTRIBUTE_NAME, this._stateAttributeName(n);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(n) {
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED:
        break;
      case E.QUOTATION_MARK: {
        this.state = w.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case E.APOSTROPHE: {
        this.state = w.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this._err(U.missingAttributeValue), this.state = w.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = w.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(n);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(n) {
    switch (n) {
      case E.QUOTATION_MARK: {
        this.state = w.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case E.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), this.currentAttr.value += lt;
        break;
      }
      case E.EOF: {
        this._err(U.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(n);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(n) {
    switch (n) {
      case E.APOSTROPHE: {
        this.state = w.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case E.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), this.currentAttr.value += lt;
        break;
      }
      case E.EOF: {
        this._err(U.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(n);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(n) {
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED: {
        this._leaveAttrValue(), this.state = w.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case E.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = w.DATA, this.emitCurrentTagToken();
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), this.currentAttr.value += lt;
        break;
      }
      case E.QUOTATION_MARK:
      case E.APOSTROPHE:
      case E.LESS_THAN_SIGN:
      case E.EQUALS_SIGN:
      case E.GRAVE_ACCENT: {
        this._err(U.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(n);
        break;
      }
      case E.EOF: {
        this._err(U.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(n);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(n) {
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED: {
        this._leaveAttrValue(), this.state = w.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case E.SOLIDUS: {
        this._leaveAttrValue(), this.state = w.SELF_CLOSING_START_TAG;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = w.DATA, this.emitCurrentTagToken();
        break;
      }
      case E.EOF: {
        this._err(U.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.missingWhitespaceBetweenAttributes), this.state = w.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(n);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(n) {
    switch (n) {
      case E.GREATER_THAN_SIGN: {
        const t = this.currentToken;
        t.selfClosing = !0, this.state = w.DATA, this.emitCurrentTagToken();
        break;
      }
      case E.EOF: {
        this._err(U.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.unexpectedSolidusInTag), this.state = w.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(n);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(n) {
    const t = this.currentToken;
    switch (n) {
      case E.GREATER_THAN_SIGN: {
        this.state = w.DATA, this.emitCurrentComment(t);
        break;
      }
      case E.EOF: {
        this.emitCurrentComment(t), this._emitEOFToken();
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), t.data += lt;
        break;
      }
      default:
        t.data += String.fromCodePoint(n);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(n) {
    this._consumeSequenceIfMatch(dn.DASH_DASH, !0) ? (this._createCommentToken(dn.DASH_DASH.length + 1), this.state = w.COMMENT_START) : this._consumeSequenceIfMatch(dn.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(dn.DOCTYPE.length + 1), this.state = w.DOCTYPE) : this._consumeSequenceIfMatch(dn.CDATA_START, !0) ? this.inForeignNode ? this.state = w.CDATA_SECTION : (this._err(U.cdataInHtmlContent), this._createCommentToken(dn.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = w.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(U.incorrectlyOpenedComment), this._createCommentToken(2), this.state = w.BOGUS_COMMENT, this._stateBogusComment(n));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(n) {
    switch (n) {
      case E.HYPHEN_MINUS: {
        this.state = w.COMMENT_START_DASH;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this._err(U.abruptClosingOfEmptyComment), this.state = w.DATA;
        const t = this.currentToken;
        this.emitCurrentComment(t);
        break;
      }
      default:
        this.state = w.COMMENT, this._stateComment(n);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(n) {
    const t = this.currentToken;
    switch (n) {
      case E.HYPHEN_MINUS: {
        this.state = w.COMMENT_END;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this._err(U.abruptClosingOfEmptyComment), this.state = w.DATA, this.emitCurrentComment(t);
        break;
      }
      case E.EOF: {
        this._err(U.eofInComment), this.emitCurrentComment(t), this._emitEOFToken();
        break;
      }
      default:
        t.data += "-", this.state = w.COMMENT, this._stateComment(n);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(n) {
    const t = this.currentToken;
    switch (n) {
      case E.HYPHEN_MINUS: {
        this.state = w.COMMENT_END_DASH;
        break;
      }
      case E.LESS_THAN_SIGN: {
        t.data += "<", this.state = w.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), t.data += lt;
        break;
      }
      case E.EOF: {
        this._err(U.eofInComment), this.emitCurrentComment(t), this._emitEOFToken();
        break;
      }
      default:
        t.data += String.fromCodePoint(n);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(n) {
    const t = this.currentToken;
    switch (n) {
      case E.EXCLAMATION_MARK: {
        t.data += "!", this.state = w.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case E.LESS_THAN_SIGN: {
        t.data += "<";
        break;
      }
      default:
        this.state = w.COMMENT, this._stateComment(n);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(n) {
    n === E.HYPHEN_MINUS ? this.state = w.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = w.COMMENT, this._stateComment(n));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(n) {
    n === E.HYPHEN_MINUS ? this.state = w.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = w.COMMENT_END_DASH, this._stateCommentEndDash(n));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(n) {
    n !== E.GREATER_THAN_SIGN && n !== E.EOF && this._err(U.nestedComment), this.state = w.COMMENT_END, this._stateCommentEnd(n);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(n) {
    const t = this.currentToken;
    switch (n) {
      case E.HYPHEN_MINUS: {
        this.state = w.COMMENT_END;
        break;
      }
      case E.EOF: {
        this._err(U.eofInComment), this.emitCurrentComment(t), this._emitEOFToken();
        break;
      }
      default:
        t.data += "-", this.state = w.COMMENT, this._stateComment(n);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(n) {
    const t = this.currentToken;
    switch (n) {
      case E.GREATER_THAN_SIGN: {
        this.state = w.DATA, this.emitCurrentComment(t);
        break;
      }
      case E.EXCLAMATION_MARK: {
        this.state = w.COMMENT_END_BANG;
        break;
      }
      case E.HYPHEN_MINUS: {
        t.data += "-";
        break;
      }
      case E.EOF: {
        this._err(U.eofInComment), this.emitCurrentComment(t), this._emitEOFToken();
        break;
      }
      default:
        t.data += "--", this.state = w.COMMENT, this._stateComment(n);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(n) {
    const t = this.currentToken;
    switch (n) {
      case E.HYPHEN_MINUS: {
        t.data += "--!", this.state = w.COMMENT_END_DASH;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this._err(U.incorrectlyClosedComment), this.state = w.DATA, this.emitCurrentComment(t);
        break;
      }
      case E.EOF: {
        this._err(U.eofInComment), this.emitCurrentComment(t), this._emitEOFToken();
        break;
      }
      default:
        t.data += "--!", this.state = w.COMMENT, this._stateComment(n);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(n) {
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED: {
        this.state = w.BEFORE_DOCTYPE_NAME;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this.state = w.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(n);
        break;
      }
      case E.EOF: {
        this._err(U.eofInDoctype), this._createDoctypeToken(null);
        const t = this.currentToken;
        t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.missingWhitespaceBeforeDoctypeName), this.state = w.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(n);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(n) {
    if (Zo(n))
      this._createDoctypeToken(String.fromCharCode(zu(n))), this.state = w.DOCTYPE_NAME;
    else
      switch (n) {
        case E.SPACE:
        case E.LINE_FEED:
        case E.TABULATION:
        case E.FORM_FEED:
          break;
        case E.NULL: {
          this._err(U.unexpectedNullCharacter), this._createDoctypeToken(lt), this.state = w.DOCTYPE_NAME;
          break;
        }
        case E.GREATER_THAN_SIGN: {
          this._err(U.missingDoctypeName), this._createDoctypeToken(null);
          const t = this.currentToken;
          t.forceQuirks = !0, this.emitCurrentDoctype(t), this.state = w.DATA;
          break;
        }
        case E.EOF: {
          this._err(U.eofInDoctype), this._createDoctypeToken(null);
          const t = this.currentToken;
          t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(n)), this.state = w.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(n) {
    const t = this.currentToken;
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED: {
        this.state = w.AFTER_DOCTYPE_NAME;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this.state = w.DATA, this.emitCurrentDoctype(t);
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), t.name += lt;
        break;
      }
      case E.EOF: {
        this._err(U.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        t.name += String.fromCodePoint(Zo(n) ? zu(n) : n);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(n) {
    const t = this.currentToken;
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED:
        break;
      case E.GREATER_THAN_SIGN: {
        this.state = w.DATA, this.emitCurrentDoctype(t);
        break;
      }
      case E.EOF: {
        this._err(U.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(dn.PUBLIC, !1) ? this.state = w.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(dn.SYSTEM, !1) ? this.state = w.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(U.invalidCharacterSequenceAfterDoctypeName), t.forceQuirks = !0, this.state = w.BOGUS_DOCTYPE, this._stateBogusDoctype(n));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(n) {
    const t = this.currentToken;
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED: {
        this.state = w.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case E.QUOTATION_MARK: {
        this._err(U.missingWhitespaceAfterDoctypePublicKeyword), t.publicId = "", this.state = w.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case E.APOSTROPHE: {
        this._err(U.missingWhitespaceAfterDoctypePublicKeyword), t.publicId = "", this.state = w.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this._err(U.missingDoctypePublicIdentifier), t.forceQuirks = !0, this.state = w.DATA, this.emitCurrentDoctype(t);
        break;
      }
      case E.EOF: {
        this._err(U.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.missingQuoteBeforeDoctypePublicIdentifier), t.forceQuirks = !0, this.state = w.BOGUS_DOCTYPE, this._stateBogusDoctype(n);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(n) {
    const t = this.currentToken;
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED:
        break;
      case E.QUOTATION_MARK: {
        t.publicId = "", this.state = w.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case E.APOSTROPHE: {
        t.publicId = "", this.state = w.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this._err(U.missingDoctypePublicIdentifier), t.forceQuirks = !0, this.state = w.DATA, this.emitCurrentDoctype(t);
        break;
      }
      case E.EOF: {
        this._err(U.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.missingQuoteBeforeDoctypePublicIdentifier), t.forceQuirks = !0, this.state = w.BOGUS_DOCTYPE, this._stateBogusDoctype(n);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(n) {
    const t = this.currentToken;
    switch (n) {
      case E.QUOTATION_MARK: {
        this.state = w.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), t.publicId += lt;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this._err(U.abruptDoctypePublicIdentifier), t.forceQuirks = !0, this.emitCurrentDoctype(t), this.state = w.DATA;
        break;
      }
      case E.EOF: {
        this._err(U.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        t.publicId += String.fromCodePoint(n);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(n) {
    const t = this.currentToken;
    switch (n) {
      case E.APOSTROPHE: {
        this.state = w.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), t.publicId += lt;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this._err(U.abruptDoctypePublicIdentifier), t.forceQuirks = !0, this.emitCurrentDoctype(t), this.state = w.DATA;
        break;
      }
      case E.EOF: {
        this._err(U.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        t.publicId += String.fromCodePoint(n);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(n) {
    const t = this.currentToken;
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED: {
        this.state = w.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this.state = w.DATA, this.emitCurrentDoctype(t);
        break;
      }
      case E.QUOTATION_MARK: {
        this._err(U.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), t.systemId = "", this.state = w.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case E.APOSTROPHE: {
        this._err(U.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), t.systemId = "", this.state = w.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case E.EOF: {
        this._err(U.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.missingQuoteBeforeDoctypeSystemIdentifier), t.forceQuirks = !0, this.state = w.BOGUS_DOCTYPE, this._stateBogusDoctype(n);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(n) {
    const t = this.currentToken;
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED:
        break;
      case E.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(t), this.state = w.DATA;
        break;
      }
      case E.QUOTATION_MARK: {
        t.systemId = "", this.state = w.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case E.APOSTROPHE: {
        t.systemId = "", this.state = w.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case E.EOF: {
        this._err(U.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.missingQuoteBeforeDoctypeSystemIdentifier), t.forceQuirks = !0, this.state = w.BOGUS_DOCTYPE, this._stateBogusDoctype(n);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(n) {
    const t = this.currentToken;
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED: {
        this.state = w.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case E.QUOTATION_MARK: {
        this._err(U.missingWhitespaceAfterDoctypeSystemKeyword), t.systemId = "", this.state = w.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case E.APOSTROPHE: {
        this._err(U.missingWhitespaceAfterDoctypeSystemKeyword), t.systemId = "", this.state = w.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this._err(U.missingDoctypeSystemIdentifier), t.forceQuirks = !0, this.state = w.DATA, this.emitCurrentDoctype(t);
        break;
      }
      case E.EOF: {
        this._err(U.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.missingQuoteBeforeDoctypeSystemIdentifier), t.forceQuirks = !0, this.state = w.BOGUS_DOCTYPE, this._stateBogusDoctype(n);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(n) {
    const t = this.currentToken;
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED:
        break;
      case E.QUOTATION_MARK: {
        t.systemId = "", this.state = w.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case E.APOSTROPHE: {
        t.systemId = "", this.state = w.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this._err(U.missingDoctypeSystemIdentifier), t.forceQuirks = !0, this.state = w.DATA, this.emitCurrentDoctype(t);
        break;
      }
      case E.EOF: {
        this._err(U.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.missingQuoteBeforeDoctypeSystemIdentifier), t.forceQuirks = !0, this.state = w.BOGUS_DOCTYPE, this._stateBogusDoctype(n);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(n) {
    const t = this.currentToken;
    switch (n) {
      case E.QUOTATION_MARK: {
        this.state = w.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), t.systemId += lt;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this._err(U.abruptDoctypeSystemIdentifier), t.forceQuirks = !0, this.emitCurrentDoctype(t), this.state = w.DATA;
        break;
      }
      case E.EOF: {
        this._err(U.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        t.systemId += String.fromCodePoint(n);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(n) {
    const t = this.currentToken;
    switch (n) {
      case E.APOSTROPHE: {
        this.state = w.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter), t.systemId += lt;
        break;
      }
      case E.GREATER_THAN_SIGN: {
        this._err(U.abruptDoctypeSystemIdentifier), t.forceQuirks = !0, this.emitCurrentDoctype(t), this.state = w.DATA;
        break;
      }
      case E.EOF: {
        this._err(U.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        t.systemId += String.fromCodePoint(n);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(n) {
    const t = this.currentToken;
    switch (n) {
      case E.SPACE:
      case E.LINE_FEED:
      case E.TABULATION:
      case E.FORM_FEED:
        break;
      case E.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(t), this.state = w.DATA;
        break;
      }
      case E.EOF: {
        this._err(U.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = w.BOGUS_DOCTYPE, this._stateBogusDoctype(n);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(n) {
    const t = this.currentToken;
    switch (n) {
      case E.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(t), this.state = w.DATA;
        break;
      }
      case E.NULL: {
        this._err(U.unexpectedNullCharacter);
        break;
      }
      case E.EOF: {
        this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(n) {
    switch (n) {
      case E.RIGHT_SQUARE_BRACKET: {
        this.state = w.CDATA_SECTION_BRACKET;
        break;
      }
      case E.EOF: {
        this._err(U.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(n);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(n) {
    n === E.RIGHT_SQUARE_BRACKET ? this.state = w.CDATA_SECTION_END : (this._emitChars("]"), this.state = w.CDATA_SECTION, this._stateCdataSection(n));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(n) {
    switch (n) {
      case E.GREATER_THAN_SIGN: {
        this.state = w.DATA;
        break;
      }
      case E.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = w.CDATA_SECTION, this._stateCdataSection(n);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference() {
    let n = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
    if (n < 0)
      if (this.preprocessor.lastChunkWritten)
        n = this.entityDecoder.end();
      else {
        this.active = !1, this.preprocessor.pos = this.preprocessor.html.length - 1, this.consumedAfterSnapshot = 0, this.preprocessor.endOfChunkHit = !0;
        return;
      }
    n === 0 ? (this.preprocessor.pos = this.entityStartPos, this._flushCodePointConsumedAsCharacterReference(E.AMPERSAND), this.state = !this._isCharacterReferenceInAttribute() && g1(this.preprocessor.peek(1)) ? w.AMBIGUOUS_AMPERSAND : this.returnState) : this.state = this.returnState;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(n) {
    g1(n) ? this._flushCodePointConsumedAsCharacterReference(n) : (n === E.SEMICOLON && this._err(U.unknownNamedCharacterReference), this.state = this.returnState, this._callState(n));
  }
};
const p2 = /* @__PURE__ */ new Set([h.DD, h.DT, h.LI, h.OPTGROUP, h.OPTION, h.P, h.RB, h.RP, h.RT, h.RTC]), _1 = /* @__PURE__ */ new Set([
  ...p2,
  h.CAPTION,
  h.COLGROUP,
  h.TBODY,
  h.TD,
  h.TFOOT,
  h.TH,
  h.THEAD,
  h.TR
]), Dl = /* @__PURE__ */ new Set([
  h.APPLET,
  h.CAPTION,
  h.HTML,
  h.MARQUEE,
  h.OBJECT,
  h.TABLE,
  h.TD,
  h.TEMPLATE,
  h.TH
]), o$ = /* @__PURE__ */ new Set([...Dl, h.OL, h.UL]), a$ = /* @__PURE__ */ new Set([...Dl, h.BUTTON]), E1 = /* @__PURE__ */ new Set([h.ANNOTATION_XML, h.MI, h.MN, h.MO, h.MS, h.MTEXT]), T1 = /* @__PURE__ */ new Set([h.DESC, h.FOREIGN_OBJECT, h.TITLE]), u$ = /* @__PURE__ */ new Set([h.TR, h.TEMPLATE, h.HTML]), l$ = /* @__PURE__ */ new Set([h.TBODY, h.TFOOT, h.THEAD, h.TEMPLATE, h.HTML]), c$ = /* @__PURE__ */ new Set([h.TABLE, h.TEMPLATE, h.HTML]), d$ = /* @__PURE__ */ new Set([h.TD, h.TH]);
let h$ = class {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(n, t, i) {
    this.treeAdapter = t, this.handler = i, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = h.UNKNOWN, this.current = n;
  }
  //Index of element
  _indexOf(n) {
    return this.items.lastIndexOf(n, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === h.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === q.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(n, t) {
    this.stackTop++, this.items[this.stackTop] = n, this.current = n, this.tagIDs[this.stackTop] = t, this.currentTagId = t, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(n, t, !0);
  }
  pop() {
    const n = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(n, !0);
  }
  replace(n, t) {
    const i = this._indexOf(n);
    this.items[i] = t, i === this.stackTop && (this.current = t);
  }
  insertAfter(n, t, i) {
    const r = this._indexOf(n) + 1;
    this.items.splice(r, 0, t), this.tagIDs.splice(r, 0, i), this.stackTop++, r === this.stackTop && this._updateCurrentElement(), this.current && this.currentTagId !== void 0 && this.handler.onItemPush(this.current, this.currentTagId, r === this.stackTop);
  }
  popUntilTagNamePopped(n) {
    let t = this.stackTop + 1;
    do
      t = this.tagIDs.lastIndexOf(n, t - 1);
    while (t > 0 && this.treeAdapter.getNamespaceURI(this.items[t]) !== q.HTML);
    this.shortenToLength(Math.max(t, 0));
  }
  shortenToLength(n) {
    for (; this.stackTop >= n; ) {
      const t = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, this.stackTop < n);
    }
  }
  popUntilElementPopped(n) {
    const t = this._indexOf(n);
    this.shortenToLength(Math.max(t, 0));
  }
  popUntilPopped(n, t) {
    const i = this._indexOfTagNames(n, t);
    this.shortenToLength(Math.max(i, 0));
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(lf, q.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(d$, q.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(n, t) {
    for (let i = this.stackTop; i >= 0; i--)
      if (n.has(this.tagIDs[i]) && this.treeAdapter.getNamespaceURI(this.items[i]) === t)
        return i;
    return -1;
  }
  clearBackTo(n, t) {
    const i = this._indexOfTagNames(n, t);
    this.shortenToLength(i + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(c$, q.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(l$, q.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(u$, q.HTML);
  }
  remove(n) {
    const t = this._indexOf(n);
    t >= 0 && (t === this.stackTop ? this.pop() : (this.items.splice(t, 1), this.tagIDs.splice(t, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(n, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === h.BODY ? this.items[1] : null;
  }
  contains(n) {
    return this._indexOf(n) > -1;
  }
  getCommonAncestor(n) {
    const t = this._indexOf(n) - 1;
    return t >= 0 ? this.items[t] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === h.HTML;
  }
  //Element in scope
  hasInDynamicScope(n, t) {
    for (let i = this.stackTop; i >= 0; i--) {
      const r = this.tagIDs[i];
      switch (this.treeAdapter.getNamespaceURI(this.items[i])) {
        case q.HTML: {
          if (r === n)
            return !0;
          if (t.has(r))
            return !1;
          break;
        }
        case q.SVG: {
          if (T1.has(r))
            return !1;
          break;
        }
        case q.MATHML: {
          if (E1.has(r))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInScope(n) {
    return this.hasInDynamicScope(n, Dl);
  }
  hasInListItemScope(n) {
    return this.hasInDynamicScope(n, o$);
  }
  hasInButtonScope(n) {
    return this.hasInDynamicScope(n, a$);
  }
  hasNumberedHeaderInScope() {
    for (let n = this.stackTop; n >= 0; n--) {
      const t = this.tagIDs[n];
      switch (this.treeAdapter.getNamespaceURI(this.items[n])) {
        case q.HTML: {
          if (lf.has(t))
            return !0;
          if (Dl.has(t))
            return !1;
          break;
        }
        case q.SVG: {
          if (T1.has(t))
            return !1;
          break;
        }
        case q.MATHML: {
          if (E1.has(t))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInTableScope(n) {
    for (let t = this.stackTop; t >= 0; t--)
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === q.HTML)
        switch (this.tagIDs[t]) {
          case n:
            return !0;
          case h.TABLE:
          case h.HTML:
            return !1;
        }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === q.HTML)
        switch (this.tagIDs[n]) {
          case h.TBODY:
          case h.THEAD:
          case h.TFOOT:
            return !0;
          case h.TABLE:
          case h.HTML:
            return !1;
        }
    return !0;
  }
  hasInSelectScope(n) {
    for (let t = this.stackTop; t >= 0; t--)
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === q.HTML)
        switch (this.tagIDs[t]) {
          case n:
            return !0;
          case h.OPTION:
          case h.OPTGROUP:
            break;
          default:
            return !1;
        }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; this.currentTagId !== void 0 && p2.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; this.currentTagId !== void 0 && _1.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(n) {
    for (; this.currentTagId !== void 0 && this.currentTagId !== n && _1.has(this.currentTagId); )
      this.pop();
  }
};
const jd = 3;
var _i;
(function(e) {
  e[e.Marker = 0] = "Marker", e[e.Element = 1] = "Element";
})(_i || (_i = {}));
const y1 = { type: _i.Marker };
let f$ = class {
  constructor(n) {
    this.treeAdapter = n, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(n, t) {
    const i = [], r = t.length, s = this.treeAdapter.getTagName(n), o = this.treeAdapter.getNamespaceURI(n);
    for (let a = 0; a < this.entries.length; a++) {
      const u = this.entries[a];
      if (u.type === _i.Marker)
        break;
      const { element: l } = u;
      if (this.treeAdapter.getTagName(l) === s && this.treeAdapter.getNamespaceURI(l) === o) {
        const c = this.treeAdapter.getAttrList(l);
        c.length === r && i.push({ idx: a, attrs: c });
      }
    }
    return i;
  }
  _ensureNoahArkCondition(n) {
    if (this.entries.length < jd)
      return;
    const t = this.treeAdapter.getAttrList(n), i = this._getNoahArkConditionCandidates(n, t);
    if (i.length < jd)
      return;
    const r = new Map(t.map((o) => [o.name, o.value]));
    let s = 0;
    for (let o = 0; o < i.length; o++) {
      const a = i[o];
      a.attrs.every((u) => r.get(u.name) === u.value) && (s += 1, s >= jd && this.entries.splice(a.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(y1);
  }
  pushElement(n, t) {
    this._ensureNoahArkCondition(n), this.entries.unshift({
      type: _i.Element,
      element: n,
      token: t
    });
  }
  insertElementAfterBookmark(n, t) {
    const i = this.entries.indexOf(this.bookmark);
    this.entries.splice(i, 0, {
      type: _i.Element,
      element: n,
      token: t
    });
  }
  removeEntry(n) {
    const t = this.entries.indexOf(n);
    t !== -1 && this.entries.splice(t, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const n = this.entries.indexOf(y1);
    n === -1 ? this.entries.length = 0 : this.entries.splice(0, n + 1);
  }
  //Search
  getElementEntryInScopeWithTagName(n) {
    const t = this.entries.find((i) => i.type === _i.Marker || this.treeAdapter.getTagName(i.element) === n);
    return t && t.type === _i.Element ? t : null;
  }
  getElementEntry(n) {
    return this.entries.find((t) => t.type === _i.Element && t.element === n);
  }
};
const ur = {
  //Node construction
  createDocument() {
    return {
      nodeName: "#document",
      mode: Hn.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  },
  createElement(e, n, t) {
    return {
      nodeName: e,
      tagName: e,
      attrs: t,
      namespaceURI: n,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode(e) {
    return {
      nodeName: "#comment",
      data: e,
      parentNode: null
    };
  },
  createTextNode(e) {
    return {
      nodeName: "#text",
      value: e,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild(e, n) {
    e.childNodes.push(n), n.parentNode = e;
  },
  insertBefore(e, n, t) {
    const i = e.childNodes.indexOf(t);
    e.childNodes.splice(i, 0, n), n.parentNode = e;
  },
  setTemplateContent(e, n) {
    e.content = n;
  },
  getTemplateContent(e) {
    return e.content;
  },
  setDocumentType(e, n, t, i) {
    const r = e.childNodes.find((s) => s.nodeName === "#documentType");
    if (r)
      r.name = n, r.publicId = t, r.systemId = i;
    else {
      const s = {
        nodeName: "#documentType",
        name: n,
        publicId: t,
        systemId: i,
        parentNode: null
      };
      ur.appendChild(e, s);
    }
  },
  setDocumentMode(e, n) {
    e.mode = n;
  },
  getDocumentMode(e) {
    return e.mode;
  },
  detachNode(e) {
    if (e.parentNode) {
      const n = e.parentNode.childNodes.indexOf(e);
      e.parentNode.childNodes.splice(n, 1), e.parentNode = null;
    }
  },
  insertText(e, n) {
    if (e.childNodes.length > 0) {
      const t = e.childNodes[e.childNodes.length - 1];
      if (ur.isTextNode(t)) {
        t.value += n;
        return;
      }
    }
    ur.appendChild(e, ur.createTextNode(n));
  },
  insertTextBefore(e, n, t) {
    const i = e.childNodes[e.childNodes.indexOf(t) - 1];
    i && ur.isTextNode(i) ? i.value += n : ur.insertBefore(e, ur.createTextNode(n), t);
  },
  adoptAttributes(e, n) {
    const t = new Set(e.attrs.map((i) => i.name));
    for (let i = 0; i < n.length; i++)
      t.has(n[i].name) || e.attrs.push(n[i]);
  },
  //Tree traversing
  getFirstChild(e) {
    return e.childNodes[0];
  },
  getChildNodes(e) {
    return e.childNodes;
  },
  getParentNode(e) {
    return e.parentNode;
  },
  getAttrList(e) {
    return e.attrs;
  },
  //Node data
  getTagName(e) {
    return e.tagName;
  },
  getNamespaceURI(e) {
    return e.namespaceURI;
  },
  getTextNodeContent(e) {
    return e.value;
  },
  getCommentNodeContent(e) {
    return e.data;
  },
  getDocumentTypeNodeName(e) {
    return e.name;
  },
  getDocumentTypeNodePublicId(e) {
    return e.publicId;
  },
  getDocumentTypeNodeSystemId(e) {
    return e.systemId;
  },
  //Node types
  isTextNode(e) {
    return e.nodeName === "#text";
  },
  isCommentNode(e) {
    return e.nodeName === "#comment";
  },
  isDocumentTypeNode(e) {
    return e.nodeName === "#documentType";
  },
  isElementNode(e) {
    return Object.prototype.hasOwnProperty.call(e, "tagName");
  },
  // Source code location
  setNodeSourceCodeLocation(e, n) {
    e.sourceCodeLocation = n;
  },
  getNodeSourceCodeLocation(e) {
    return e.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(e, n) {
    e.sourceCodeLocation = { ...e.sourceCodeLocation, ...n };
  }
}, g2 = "html", m$ = "about:legacy-compat", p$ = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", b2 = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], g$ = [
  ...b2,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], b$ = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), _2 = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], _$ = [
  ..._2,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function w1(e, n) {
  return n.some((t) => e.startsWith(t));
}
function E$(e) {
  return e.name === g2 && e.publicId === null && (e.systemId === null || e.systemId === m$);
}
function T$(e) {
  if (e.name !== g2)
    return Hn.QUIRKS;
  const { systemId: n } = e;
  if (n && n.toLowerCase() === p$)
    return Hn.QUIRKS;
  let { publicId: t } = e;
  if (t !== null) {
    if (t = t.toLowerCase(), b$.has(t))
      return Hn.QUIRKS;
    let i = n === null ? g$ : b2;
    if (w1(t, i))
      return Hn.QUIRKS;
    if (i = n === null ? _2 : _$, w1(t, i))
      return Hn.LIMITED_QUIRKS;
  }
  return Hn.NO_QUIRKS;
}
const A1 = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, y$ = "definitionurl", w$ = "definitionURL", A$ = new Map([
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((e) => [e.toLowerCase(), e])), C$ = /* @__PURE__ */ new Map([
  ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: q.XLINK }],
  ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: q.XLINK }],
  ["xlink:href", { prefix: "xlink", name: "href", namespace: q.XLINK }],
  ["xlink:role", { prefix: "xlink", name: "role", namespace: q.XLINK }],
  ["xlink:show", { prefix: "xlink", name: "show", namespace: q.XLINK }],
  ["xlink:title", { prefix: "xlink", name: "title", namespace: q.XLINK }],
  ["xlink:type", { prefix: "xlink", name: "type", namespace: q.XLINK }],
  ["xml:lang", { prefix: "xml", name: "lang", namespace: q.XML }],
  ["xml:space", { prefix: "xml", name: "space", namespace: q.XML }],
  ["xmlns", { prefix: "", name: "xmlns", namespace: q.XMLNS }],
  ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: q.XMLNS }]
]), k$ = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((e) => [e.toLowerCase(), e])), S$ = /* @__PURE__ */ new Set([
  h.B,
  h.BIG,
  h.BLOCKQUOTE,
  h.BODY,
  h.BR,
  h.CENTER,
  h.CODE,
  h.DD,
  h.DIV,
  h.DL,
  h.DT,
  h.EM,
  h.EMBED,
  h.H1,
  h.H2,
  h.H3,
  h.H4,
  h.H5,
  h.H6,
  h.HEAD,
  h.HR,
  h.I,
  h.IMG,
  h.LI,
  h.LISTING,
  h.MENU,
  h.META,
  h.NOBR,
  h.OL,
  h.P,
  h.PRE,
  h.RUBY,
  h.S,
  h.SMALL,
  h.SPAN,
  h.STRONG,
  h.STRIKE,
  h.SUB,
  h.SUP,
  h.TABLE,
  h.TT,
  h.U,
  h.UL,
  h.VAR
]);
function I$(e) {
  const n = e.tagID;
  return n === h.FONT && e.attrs.some(({ name: i }) => i === Zr.COLOR || i === Zr.SIZE || i === Zr.FACE) || S$.has(n);
}
function E2(e) {
  for (let n = 0; n < e.attrs.length; n++)
    if (e.attrs[n].name === y$) {
      e.attrs[n].name = w$;
      break;
    }
}
function T2(e) {
  for (let n = 0; n < e.attrs.length; n++) {
    const t = A$.get(e.attrs[n].name);
    t != null && (e.attrs[n].name = t);
  }
}
function Bm(e) {
  for (let n = 0; n < e.attrs.length; n++) {
    const t = C$.get(e.attrs[n].name);
    t && (e.attrs[n].prefix = t.prefix, e.attrs[n].name = t.name, e.attrs[n].namespace = t.namespace);
  }
}
function x$(e) {
  const n = k$.get(e.tagName);
  n != null && (e.tagName = n, e.tagID = yc(e.tagName));
}
function v$(e, n) {
  return n === q.MATHML && (e === h.MI || e === h.MO || e === h.MN || e === h.MS || e === h.MTEXT);
}
function P$(e, n, t) {
  if (n === q.MATHML && e === h.ANNOTATION_XML) {
    for (let i = 0; i < t.length; i++)
      if (t[i].name === Zr.ENCODING) {
        const r = t[i].value.toLowerCase();
        return r === A1.TEXT_HTML || r === A1.APPLICATION_XML;
      }
  }
  return n === q.SVG && (e === h.FOREIGN_OBJECT || e === h.DESC || e === h.TITLE);
}
function O$(e, n, t, i) {
  return (!i || i === q.HTML) && P$(e, n, t) || (!i || i === q.MATHML) && v$(e, n);
}
const N$ = "hidden", R$ = 8, L$ = 3;
var I;
(function(e) {
  e[e.INITIAL = 0] = "INITIAL", e[e.BEFORE_HTML = 1] = "BEFORE_HTML", e[e.BEFORE_HEAD = 2] = "BEFORE_HEAD", e[e.IN_HEAD = 3] = "IN_HEAD", e[e.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", e[e.AFTER_HEAD = 5] = "AFTER_HEAD", e[e.IN_BODY = 6] = "IN_BODY", e[e.TEXT = 7] = "TEXT", e[e.IN_TABLE = 8] = "IN_TABLE", e[e.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", e[e.IN_CAPTION = 10] = "IN_CAPTION", e[e.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", e[e.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", e[e.IN_ROW = 13] = "IN_ROW", e[e.IN_CELL = 14] = "IN_CELL", e[e.IN_SELECT = 15] = "IN_SELECT", e[e.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", e[e.IN_TEMPLATE = 17] = "IN_TEMPLATE", e[e.AFTER_BODY = 18] = "AFTER_BODY", e[e.IN_FRAMESET = 19] = "IN_FRAMESET", e[e.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", e[e.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", e[e.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(I || (I = {}));
const D$ = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, y2 = /* @__PURE__ */ new Set([h.TABLE, h.TBODY, h.TFOOT, h.THEAD, h.TR]), C1 = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: ur,
  onParseError: null
};
let w2 = class {
  constructor(n, t, i = null, r = null) {
    this.fragmentContext = i, this.scriptHandler = r, this.currentToken = null, this.stopped = !1, this.insertionMode = I.INITIAL, this.originalInsertionMode = I.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {
      ...C1,
      ...n
    }, this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = t ?? this.treeAdapter.createDocument(), this.tokenizer = new s$(this.options, this), this.activeFormattingElements = new f$(this.treeAdapter), this.fragmentContextID = i ? yc(this.treeAdapter.getTagName(i)) : h.UNKNOWN, this._setContextModes(i ?? this.document, this.fragmentContextID), this.openElements = new h$(this.document, this.treeAdapter, this);
  }
  // API
  static parse(n, t) {
    const i = new this(t);
    return i.tokenizer.write(n, !0), i.document;
  }
  static getFragmentParser(n, t) {
    const i = {
      ...C1,
      ...t
    };
    n ?? (n = i.treeAdapter.createElement(R.TEMPLATE, q.HTML, []));
    const r = i.treeAdapter.createElement("documentmock", q.HTML, []), s = new this(i, r, n);
    return s.fragmentContextID === h.TEMPLATE && s.tmplInsertionModeStack.unshift(I.IN_TEMPLATE), s._initTokenizerForFragmentParsing(), s._insertFakeRootElement(), s._resetInsertionMode(), s._findFormInFragmentContext(), s;
  }
  getFragment() {
    const n = this.treeAdapter.getFirstChild(this.document), t = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(n, t), t;
  }
  //Errors
  /** @internal */
  _err(n, t, i) {
    var r;
    if (!this.onParseError)
      return;
    const s = (r = n.location) !== null && r !== void 0 ? r : D$, o = {
      code: t,
      startLine: s.startLine,
      startCol: s.startCol,
      startOffset: s.startOffset,
      endLine: i ? s.startLine : s.endLine,
      endCol: i ? s.startCol : s.endCol,
      endOffset: i ? s.startOffset : s.endOffset
    };
    this.onParseError(o);
  }
  //Stack events
  /** @internal */
  onItemPush(n, t, i) {
    var r, s;
    (s = (r = this.treeAdapter).onItemPush) === null || s === void 0 || s.call(r, n), i && this.openElements.stackTop > 0 && this._setContextModes(n, t);
  }
  /** @internal */
  onItemPop(n, t) {
    var i, r;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(n, this.currentToken), (r = (i = this.treeAdapter).onItemPop) === null || r === void 0 || r.call(i, n, this.openElements.current), t) {
      let s, o;
      this.openElements.stackTop === 0 && this.fragmentContext ? (s = this.fragmentContext, o = this.fragmentContextID) : { current: s, currentTagId: o } = this.openElements, this._setContextModes(s, o);
    }
  }
  _setContextModes(n, t) {
    const i = n === this.document || n && this.treeAdapter.getNamespaceURI(n) === q.HTML;
    this.currentNotInHTML = !i, this.tokenizer.inForeignNode = !i && n !== void 0 && t !== void 0 && !this._isIntegrationPoint(t, n);
  }
  /** @protected */
  _switchToTextParsing(n, t) {
    this._insertElement(n, q.HTML), this.tokenizer.state = t, this.originalInsertionMode = this.insertionMode, this.insertionMode = I.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = I.TEXT, this.originalInsertionMode = I.IN_BODY, this.tokenizer.state = gn.PLAINTEXT;
  }
  //Fragment parsing
  /** @protected */
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  /** @protected */
  _findFormInFragmentContext() {
    let n = this.fragmentContext;
    for (; n; ) {
      if (this.treeAdapter.getTagName(n) === R.FORM) {
        this.formElement = n;
        break;
      }
      n = this.treeAdapter.getParentNode(n);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== q.HTML))
      switch (this.fragmentContextID) {
        case h.TITLE:
        case h.TEXTAREA: {
          this.tokenizer.state = gn.RCDATA;
          break;
        }
        case h.STYLE:
        case h.XMP:
        case h.IFRAME:
        case h.NOEMBED:
        case h.NOFRAMES:
        case h.NOSCRIPT: {
          this.tokenizer.state = gn.RAWTEXT;
          break;
        }
        case h.SCRIPT: {
          this.tokenizer.state = gn.SCRIPT_DATA;
          break;
        }
        case h.PLAINTEXT: {
          this.tokenizer.state = gn.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  /** @protected */
  _setDocumentType(n) {
    const t = n.name || "", i = n.publicId || "", r = n.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, t, i, r), n.location) {
      const o = this.treeAdapter.getChildNodes(this.document).find((a) => this.treeAdapter.isDocumentTypeNode(a));
      o && this.treeAdapter.setNodeSourceCodeLocation(o, n.location);
    }
  }
  /** @protected */
  _attachElementToTree(n, t) {
    if (this.options.sourceCodeLocationInfo) {
      const i = t && {
        ...t,
        startTag: t
      };
      this.treeAdapter.setNodeSourceCodeLocation(n, i);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(n);
    else {
      const i = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(i ?? this.document, n);
    }
  }
  /**
   * For self-closing tags. Add an element to the tree, but skip adding it
   * to the stack.
   */
  /** @protected */
  _appendElement(n, t) {
    const i = this.treeAdapter.createElement(n.tagName, t, n.attrs);
    this._attachElementToTree(i, n.location);
  }
  /** @protected */
  _insertElement(n, t) {
    const i = this.treeAdapter.createElement(n.tagName, t, n.attrs);
    this._attachElementToTree(i, n.location), this.openElements.push(i, n.tagID);
  }
  /** @protected */
  _insertFakeElement(n, t) {
    const i = this.treeAdapter.createElement(n, q.HTML, []);
    this._attachElementToTree(i, null), this.openElements.push(i, t);
  }
  /** @protected */
  _insertTemplate(n) {
    const t = this.treeAdapter.createElement(n.tagName, q.HTML, n.attrs), i = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(t, i), this._attachElementToTree(t, n.location), this.openElements.push(t, n.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(i, null);
  }
  /** @protected */
  _insertFakeRootElement() {
    const n = this.treeAdapter.createElement(R.HTML, q.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(n, null), this.treeAdapter.appendChild(this.openElements.current, n), this.openElements.push(n, h.HTML);
  }
  /** @protected */
  _appendCommentNode(n, t) {
    const i = this.treeAdapter.createCommentNode(n.data);
    this.treeAdapter.appendChild(t, i), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(i, n.location);
  }
  /** @protected */
  _insertCharacters(n) {
    let t, i;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: t, beforeElement: i } = this._findFosterParentingLocation(), i ? this.treeAdapter.insertTextBefore(t, n.chars, i) : this.treeAdapter.insertText(t, n.chars)) : (t = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(t, n.chars)), !n.location)
      return;
    const r = this.treeAdapter.getChildNodes(t), s = i ? r.lastIndexOf(i) : r.length, o = r[s - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(o)) {
      const { endLine: u, endCol: l, endOffset: c } = n.location;
      this.treeAdapter.updateNodeSourceCodeLocation(o, { endLine: u, endCol: l, endOffset: c });
    } else this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(o, n.location);
  }
  /** @protected */
  _adoptNodes(n, t) {
    for (let i = this.treeAdapter.getFirstChild(n); i; i = this.treeAdapter.getFirstChild(n))
      this.treeAdapter.detachNode(i), this.treeAdapter.appendChild(t, i);
  }
  /** @protected */
  _setEndLocation(n, t) {
    if (this.treeAdapter.getNodeSourceCodeLocation(n) && t.location) {
      const i = t.location, r = this.treeAdapter.getTagName(n), s = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        t.type === He.END_TAG && r === t.tagName ? {
          endTag: { ...i },
          endLine: i.endLine,
          endCol: i.endCol,
          endOffset: i.endOffset
        } : {
          endLine: i.startLine,
          endCol: i.startCol,
          endOffset: i.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(n, s);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(n) {
    if (!this.currentNotInHTML)
      return !1;
    let t, i;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (t = this.fragmentContext, i = this.fragmentContextID) : { current: t, currentTagId: i } = this.openElements, n.tagID === h.SVG && this.treeAdapter.getTagName(t) === R.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(t) === q.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (n.tagID === h.MGLYPH || n.tagID === h.MALIGNMARK) && i !== void 0 && !this._isIntegrationPoint(i, t, q.HTML)
    );
  }
  /** @protected */
  _processToken(n) {
    switch (n.type) {
      case He.CHARACTER: {
        this.onCharacter(n);
        break;
      }
      case He.NULL_CHARACTER: {
        this.onNullCharacter(n);
        break;
      }
      case He.COMMENT: {
        this.onComment(n);
        break;
      }
      case He.DOCTYPE: {
        this.onDoctype(n);
        break;
      }
      case He.START_TAG: {
        this._processStartTag(n);
        break;
      }
      case He.END_TAG: {
        this.onEndTag(n);
        break;
      }
      case He.EOF: {
        this.onEof(n);
        break;
      }
      case He.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(n);
        break;
      }
    }
  }
  //Integration points
  /** @protected */
  _isIntegrationPoint(n, t, i) {
    const r = this.treeAdapter.getNamespaceURI(t), s = this.treeAdapter.getAttrList(t);
    return O$(n, r, s, i);
  }
  //Active formatting elements reconstruction
  /** @protected */
  _reconstructActiveFormattingElements() {
    const n = this.activeFormattingElements.entries.length;
    if (n) {
      const t = this.activeFormattingElements.entries.findIndex((r) => r.type === _i.Marker || this.openElements.contains(r.element)), i = t === -1 ? n - 1 : t - 1;
      for (let r = i; r >= 0; r--) {
        const s = this.activeFormattingElements.entries[r];
        this._insertElement(s.token, this.treeAdapter.getNamespaceURI(s.element)), s.element = this.openElements.current;
      }
    }
  }
  //Close elements
  /** @protected */
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = I.IN_ROW;
  }
  /** @protected */
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(h.P), this.openElements.popUntilTagNamePopped(h.P);
  }
  //Insertion modes
  /** @protected */
  _resetInsertionMode() {
    for (let n = this.openElements.stackTop; n >= 0; n--)
      switch (n === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[n]) {
        case h.TR: {
          this.insertionMode = I.IN_ROW;
          return;
        }
        case h.TBODY:
        case h.THEAD:
        case h.TFOOT: {
          this.insertionMode = I.IN_TABLE_BODY;
          return;
        }
        case h.CAPTION: {
          this.insertionMode = I.IN_CAPTION;
          return;
        }
        case h.COLGROUP: {
          this.insertionMode = I.IN_COLUMN_GROUP;
          return;
        }
        case h.TABLE: {
          this.insertionMode = I.IN_TABLE;
          return;
        }
        case h.BODY: {
          this.insertionMode = I.IN_BODY;
          return;
        }
        case h.FRAMESET: {
          this.insertionMode = I.IN_FRAMESET;
          return;
        }
        case h.SELECT: {
          this._resetInsertionModeForSelect(n);
          return;
        }
        case h.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case h.HTML: {
          this.insertionMode = this.headElement ? I.AFTER_HEAD : I.BEFORE_HEAD;
          return;
        }
        case h.TD:
        case h.TH: {
          if (n > 0) {
            this.insertionMode = I.IN_CELL;
            return;
          }
          break;
        }
        case h.HEAD: {
          if (n > 0) {
            this.insertionMode = I.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = I.IN_BODY;
  }
  /** @protected */
  _resetInsertionModeForSelect(n) {
    if (n > 0)
      for (let t = n - 1; t > 0; t--) {
        const i = this.openElements.tagIDs[t];
        if (i === h.TEMPLATE)
          break;
        if (i === h.TABLE) {
          this.insertionMode = I.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = I.IN_SELECT;
  }
  //Foster parenting
  /** @protected */
  _isElementCausesFosterParenting(n) {
    return y2.has(n);
  }
  /** @protected */
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this.openElements.currentTagId !== void 0 && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  /** @protected */
  _findFosterParentingLocation() {
    for (let n = this.openElements.stackTop; n >= 0; n--) {
      const t = this.openElements.items[n];
      switch (this.openElements.tagIDs[n]) {
        case h.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(t) === q.HTML)
            return { parent: this.treeAdapter.getTemplateContent(t), beforeElement: null };
          break;
        }
        case h.TABLE: {
          const i = this.treeAdapter.getParentNode(t);
          return i ? { parent: i, beforeElement: t } : { parent: this.openElements.items[n - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  /** @protected */
  _fosterParentElement(n) {
    const t = this._findFosterParentingLocation();
    t.beforeElement ? this.treeAdapter.insertBefore(t.parent, n, t.beforeElement) : this.treeAdapter.appendChild(t.parent, n);
  }
  //Special elements
  /** @protected */
  _isSpecialElement(n, t) {
    const i = this.treeAdapter.getNamespaceURI(n);
    return t$[i].has(t);
  }
  /** @internal */
  onCharacter(n) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      dz(this, n);
      return;
    }
    switch (this.insertionMode) {
      case I.INITIAL: {
        zo(this, n);
        break;
      }
      case I.BEFORE_HTML: {
        fa(this, n);
        break;
      }
      case I.BEFORE_HEAD: {
        ma(this, n);
        break;
      }
      case I.IN_HEAD: {
        pa(this, n);
        break;
      }
      case I.IN_HEAD_NO_SCRIPT: {
        ga(this, n);
        break;
      }
      case I.AFTER_HEAD: {
        ba(this, n);
        break;
      }
      case I.IN_BODY:
      case I.IN_CAPTION:
      case I.IN_CELL:
      case I.IN_TEMPLATE: {
        C2(this, n);
        break;
      }
      case I.TEXT:
      case I.IN_SELECT:
      case I.IN_SELECT_IN_TABLE: {
        this._insertCharacters(n);
        break;
      }
      case I.IN_TABLE:
      case I.IN_TABLE_BODY:
      case I.IN_ROW: {
        Kd(this, n);
        break;
      }
      case I.IN_TABLE_TEXT: {
        P2(this, n);
        break;
      }
      case I.IN_COLUMN_GROUP: {
        Ml(this, n);
        break;
      }
      case I.AFTER_BODY: {
        Bl(this, n);
        break;
      }
      case I.AFTER_AFTER_BODY: {
        rl(this, n);
        break;
      }
    }
  }
  /** @internal */
  onNullCharacter(n) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      cz(this, n);
      return;
    }
    switch (this.insertionMode) {
      case I.INITIAL: {
        zo(this, n);
        break;
      }
      case I.BEFORE_HTML: {
        fa(this, n);
        break;
      }
      case I.BEFORE_HEAD: {
        ma(this, n);
        break;
      }
      case I.IN_HEAD: {
        pa(this, n);
        break;
      }
      case I.IN_HEAD_NO_SCRIPT: {
        ga(this, n);
        break;
      }
      case I.AFTER_HEAD: {
        ba(this, n);
        break;
      }
      case I.TEXT: {
        this._insertCharacters(n);
        break;
      }
      case I.IN_TABLE:
      case I.IN_TABLE_BODY:
      case I.IN_ROW: {
        Kd(this, n);
        break;
      }
      case I.IN_COLUMN_GROUP: {
        Ml(this, n);
        break;
      }
      case I.AFTER_BODY: {
        Bl(this, n);
        break;
      }
      case I.AFTER_AFTER_BODY: {
        rl(this, n);
        break;
      }
    }
  }
  /** @internal */
  onComment(n) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      cf(this, n);
      return;
    }
    switch (this.insertionMode) {
      case I.INITIAL:
      case I.BEFORE_HTML:
      case I.BEFORE_HEAD:
      case I.IN_HEAD:
      case I.IN_HEAD_NO_SCRIPT:
      case I.AFTER_HEAD:
      case I.IN_BODY:
      case I.IN_TABLE:
      case I.IN_CAPTION:
      case I.IN_COLUMN_GROUP:
      case I.IN_TABLE_BODY:
      case I.IN_ROW:
      case I.IN_CELL:
      case I.IN_SELECT:
      case I.IN_SELECT_IN_TABLE:
      case I.IN_TEMPLATE:
      case I.IN_FRAMESET:
      case I.AFTER_FRAMESET: {
        cf(this, n);
        break;
      }
      case I.IN_TABLE_TEXT: {
        qo(this, n);
        break;
      }
      case I.AFTER_BODY: {
        $$(this, n);
        break;
      }
      case I.AFTER_AFTER_BODY:
      case I.AFTER_AFTER_FRAMESET: {
        W$(this, n);
        break;
      }
    }
  }
  /** @internal */
  onDoctype(n) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case I.INITIAL: {
        z$(this, n);
        break;
      }
      case I.BEFORE_HEAD:
      case I.IN_HEAD:
      case I.IN_HEAD_NO_SCRIPT:
      case I.AFTER_HEAD: {
        this._err(n, U.misplacedDoctype);
        break;
      }
      case I.IN_TABLE_TEXT: {
        qo(this, n);
        break;
      }
    }
  }
  /** @internal */
  onStartTag(n) {
    this.skipNextNewLine = !1, this.currentToken = n, this._processStartTag(n), n.selfClosing && !n.ackSelfClosing && this._err(n, U.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   * @protected
   */
  _processStartTag(n) {
    this.shouldProcessStartTagTokenInForeignContent(n) ? hz(this, n) : this._startTagOutsideForeignContent(n);
  }
  /** @protected */
  _startTagOutsideForeignContent(n) {
    switch (this.insertionMode) {
      case I.INITIAL: {
        zo(this, n);
        break;
      }
      case I.BEFORE_HTML: {
        q$(this, n);
        break;
      }
      case I.BEFORE_HEAD: {
        j$(this, n);
        break;
      }
      case I.IN_HEAD: {
        di(this, n);
        break;
      }
      case I.IN_HEAD_NO_SCRIPT: {
        Q$(this, n);
        break;
      }
      case I.AFTER_HEAD: {
        J$(this, n);
        break;
      }
      case I.IN_BODY: {
        Zt(this, n);
        break;
      }
      case I.IN_TABLE: {
        oo(this, n);
        break;
      }
      case I.IN_TABLE_TEXT: {
        qo(this, n);
        break;
      }
      case I.IN_CAPTION: {
        KW(this, n);
        break;
      }
      case I.IN_COLUMN_GROUP: {
        Hm(this, n);
        break;
      }
      case I.IN_TABLE_BODY: {
        Cc(this, n);
        break;
      }
      case I.IN_ROW: {
        kc(this, n);
        break;
      }
      case I.IN_CELL: {
        XW(this, n);
        break;
      }
      case I.IN_SELECT: {
        R2(this, n);
        break;
      }
      case I.IN_SELECT_IN_TABLE: {
        ZW(this, n);
        break;
      }
      case I.IN_TEMPLATE: {
        tz(this, n);
        break;
      }
      case I.AFTER_BODY: {
        iz(this, n);
        break;
      }
      case I.IN_FRAMESET: {
        rz(this, n);
        break;
      }
      case I.AFTER_FRAMESET: {
        oz(this, n);
        break;
      }
      case I.AFTER_AFTER_BODY: {
        uz(this, n);
        break;
      }
      case I.AFTER_AFTER_FRAMESET: {
        lz(this, n);
        break;
      }
    }
  }
  /** @internal */
  onEndTag(n) {
    this.skipNextNewLine = !1, this.currentToken = n, this.currentNotInHTML ? fz(this, n) : this._endTagOutsideForeignContent(n);
  }
  /** @protected */
  _endTagOutsideForeignContent(n) {
    switch (this.insertionMode) {
      case I.INITIAL: {
        zo(this, n);
        break;
      }
      case I.BEFORE_HTML: {
        Y$(this, n);
        break;
      }
      case I.BEFORE_HEAD: {
        K$(this, n);
        break;
      }
      case I.IN_HEAD: {
        G$(this, n);
        break;
      }
      case I.IN_HEAD_NO_SCRIPT: {
        X$(this, n);
        break;
      }
      case I.AFTER_HEAD: {
        Z$(this, n);
        break;
      }
      case I.IN_BODY: {
        Ac(this, n);
        break;
      }
      case I.TEXT: {
        FW(this, n);
        break;
      }
      case I.IN_TABLE: {
        qa(this, n);
        break;
      }
      case I.IN_TABLE_TEXT: {
        qo(this, n);
        break;
      }
      case I.IN_CAPTION: {
        GW(this, n);
        break;
      }
      case I.IN_COLUMN_GROUP: {
        QW(this, n);
        break;
      }
      case I.IN_TABLE_BODY: {
        df(this, n);
        break;
      }
      case I.IN_ROW: {
        N2(this, n);
        break;
      }
      case I.IN_CELL: {
        JW(this, n);
        break;
      }
      case I.IN_SELECT: {
        L2(this, n);
        break;
      }
      case I.IN_SELECT_IN_TABLE: {
        ez(this, n);
        break;
      }
      case I.IN_TEMPLATE: {
        nz(this, n);
        break;
      }
      case I.AFTER_BODY: {
        M2(this, n);
        break;
      }
      case I.IN_FRAMESET: {
        sz(this, n);
        break;
      }
      case I.AFTER_FRAMESET: {
        az(this, n);
        break;
      }
      case I.AFTER_AFTER_BODY: {
        rl(this, n);
        break;
      }
    }
  }
  /** @internal */
  onEof(n) {
    switch (this.insertionMode) {
      case I.INITIAL: {
        zo(this, n);
        break;
      }
      case I.BEFORE_HTML: {
        fa(this, n);
        break;
      }
      case I.BEFORE_HEAD: {
        ma(this, n);
        break;
      }
      case I.IN_HEAD: {
        pa(this, n);
        break;
      }
      case I.IN_HEAD_NO_SCRIPT: {
        ga(this, n);
        break;
      }
      case I.AFTER_HEAD: {
        ba(this, n);
        break;
      }
      case I.IN_BODY:
      case I.IN_TABLE:
      case I.IN_CAPTION:
      case I.IN_COLUMN_GROUP:
      case I.IN_TABLE_BODY:
      case I.IN_ROW:
      case I.IN_CELL:
      case I.IN_SELECT:
      case I.IN_SELECT_IN_TABLE: {
        x2(this, n);
        break;
      }
      case I.TEXT: {
        UW(this, n);
        break;
      }
      case I.IN_TABLE_TEXT: {
        qo(this, n);
        break;
      }
      case I.IN_TEMPLATE: {
        D2(this, n);
        break;
      }
      case I.AFTER_BODY:
      case I.IN_FRAMESET:
      case I.AFTER_FRAMESET:
      case I.AFTER_AFTER_BODY:
      case I.AFTER_AFTER_FRAMESET: {
        Um(this, n);
        break;
      }
    }
  }
  /** @internal */
  onWhitespaceCharacter(n) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, n.chars.charCodeAt(0) === E.LINE_FEED)) {
      if (n.chars.length === 1)
        return;
      n.chars = n.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(n);
      return;
    }
    switch (this.insertionMode) {
      case I.IN_HEAD:
      case I.IN_HEAD_NO_SCRIPT:
      case I.AFTER_HEAD:
      case I.TEXT:
      case I.IN_COLUMN_GROUP:
      case I.IN_SELECT:
      case I.IN_SELECT_IN_TABLE:
      case I.IN_FRAMESET:
      case I.AFTER_FRAMESET: {
        this._insertCharacters(n);
        break;
      }
      case I.IN_BODY:
      case I.IN_CAPTION:
      case I.IN_CELL:
      case I.IN_TEMPLATE:
      case I.AFTER_BODY:
      case I.AFTER_AFTER_BODY:
      case I.AFTER_AFTER_FRAMESET: {
        A2(this, n);
        break;
      }
      case I.IN_TABLE:
      case I.IN_TABLE_BODY:
      case I.IN_ROW: {
        Kd(this, n);
        break;
      }
      case I.IN_TABLE_TEXT: {
        v2(this, n);
        break;
      }
    }
  }
};
function M$(e, n) {
  let t = e.activeFormattingElements.getElementEntryInScopeWithTagName(n.tagName);
  return t ? e.openElements.contains(t.element) ? e.openElements.hasInScope(n.tagID) || (t = null) : (e.activeFormattingElements.removeEntry(t), t = null) : I2(e, n), t;
}
function B$(e, n) {
  let t = null, i = e.openElements.stackTop;
  for (; i >= 0; i--) {
    const r = e.openElements.items[i];
    if (r === n.element)
      break;
    e._isSpecialElement(r, e.openElements.tagIDs[i]) && (t = r);
  }
  return t || (e.openElements.shortenToLength(Math.max(i, 0)), e.activeFormattingElements.removeEntry(n)), t;
}
function F$(e, n, t) {
  let i = n, r = e.openElements.getCommonAncestor(n);
  for (let s = 0, o = r; o !== t; s++, o = r) {
    r = e.openElements.getCommonAncestor(o);
    const a = e.activeFormattingElements.getElementEntry(o), u = a && s >= L$;
    !a || u ? (u && e.activeFormattingElements.removeEntry(a), e.openElements.remove(o)) : (o = U$(e, a), i === n && (e.activeFormattingElements.bookmark = a), e.treeAdapter.detachNode(i), e.treeAdapter.appendChild(o, i), i = o);
  }
  return i;
}
function U$(e, n) {
  const t = e.treeAdapter.getNamespaceURI(n.element), i = e.treeAdapter.createElement(n.token.tagName, t, n.token.attrs);
  return e.openElements.replace(n.element, i), n.element = i, i;
}
function H$(e, n, t) {
  const i = e.treeAdapter.getTagName(n), r = yc(i);
  if (e._isElementCausesFosterParenting(r))
    e._fosterParentElement(t);
  else {
    const s = e.treeAdapter.getNamespaceURI(n);
    r === h.TEMPLATE && s === q.HTML && (n = e.treeAdapter.getTemplateContent(n)), e.treeAdapter.appendChild(n, t);
  }
}
function V$(e, n, t) {
  const i = e.treeAdapter.getNamespaceURI(t.element), { token: r } = t, s = e.treeAdapter.createElement(r.tagName, i, r.attrs);
  e._adoptNodes(n, s), e.treeAdapter.appendChild(n, s), e.activeFormattingElements.insertElementAfterBookmark(s, r), e.activeFormattingElements.removeEntry(t), e.openElements.remove(t.element), e.openElements.insertAfter(n, s, r.tagID);
}
function Fm(e, n) {
  for (let t = 0; t < R$; t++) {
    const i = M$(e, n);
    if (!i)
      break;
    const r = B$(e, i);
    if (!r)
      break;
    e.activeFormattingElements.bookmark = i;
    const s = F$(e, r, i.element), o = e.openElements.getCommonAncestor(i.element);
    e.treeAdapter.detachNode(s), o && H$(e, o, s), V$(e, r, i);
  }
}
function cf(e, n) {
  e._appendCommentNode(n, e.openElements.currentTmplContentOrNode);
}
function $$(e, n) {
  e._appendCommentNode(n, e.openElements.items[0]);
}
function W$(e, n) {
  e._appendCommentNode(n, e.document);
}
function Um(e, n) {
  if (e.stopped = !0, n.location) {
    const t = e.fragmentContext ? 0 : 2;
    for (let i = e.openElements.stackTop; i >= t; i--)
      e._setEndLocation(e.openElements.items[i], n);
    if (!e.fragmentContext && e.openElements.stackTop >= 0) {
      const i = e.openElements.items[0], r = e.treeAdapter.getNodeSourceCodeLocation(i);
      if (r && !r.endTag && (e._setEndLocation(i, n), e.openElements.stackTop >= 1)) {
        const s = e.openElements.items[1], o = e.treeAdapter.getNodeSourceCodeLocation(s);
        o && !o.endTag && e._setEndLocation(s, n);
      }
    }
  }
}
function z$(e, n) {
  e._setDocumentType(n);
  const t = n.forceQuirks ? Hn.QUIRKS : T$(n);
  E$(n) || e._err(n, U.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, t), e.insertionMode = I.BEFORE_HTML;
}
function zo(e, n) {
  e._err(n, U.missingDoctype, !0), e.treeAdapter.setDocumentMode(e.document, Hn.QUIRKS), e.insertionMode = I.BEFORE_HTML, e._processToken(n);
}
function q$(e, n) {
  n.tagID === h.HTML ? (e._insertElement(n, q.HTML), e.insertionMode = I.BEFORE_HEAD) : fa(e, n);
}
function Y$(e, n) {
  const t = n.tagID;
  (t === h.HTML || t === h.HEAD || t === h.BODY || t === h.BR) && fa(e, n);
}
function fa(e, n) {
  e._insertFakeRootElement(), e.insertionMode = I.BEFORE_HEAD, e._processToken(n);
}
function j$(e, n) {
  switch (n.tagID) {
    case h.HTML: {
      Zt(e, n);
      break;
    }
    case h.HEAD: {
      e._insertElement(n, q.HTML), e.headElement = e.openElements.current, e.insertionMode = I.IN_HEAD;
      break;
    }
    default:
      ma(e, n);
  }
}
function K$(e, n) {
  const t = n.tagID;
  t === h.HEAD || t === h.BODY || t === h.HTML || t === h.BR ? ma(e, n) : e._err(n, U.endTagWithoutMatchingOpenElement);
}
function ma(e, n) {
  e._insertFakeElement(R.HEAD, h.HEAD), e.headElement = e.openElements.current, e.insertionMode = I.IN_HEAD, e._processToken(n);
}
function di(e, n) {
  switch (n.tagID) {
    case h.HTML: {
      Zt(e, n);
      break;
    }
    case h.BASE:
    case h.BASEFONT:
    case h.BGSOUND:
    case h.LINK:
    case h.META: {
      e._appendElement(n, q.HTML), n.ackSelfClosing = !0;
      break;
    }
    case h.TITLE: {
      e._switchToTextParsing(n, gn.RCDATA);
      break;
    }
    case h.NOSCRIPT: {
      e.options.scriptingEnabled ? e._switchToTextParsing(n, gn.RAWTEXT) : (e._insertElement(n, q.HTML), e.insertionMode = I.IN_HEAD_NO_SCRIPT);
      break;
    }
    case h.NOFRAMES:
    case h.STYLE: {
      e._switchToTextParsing(n, gn.RAWTEXT);
      break;
    }
    case h.SCRIPT: {
      e._switchToTextParsing(n, gn.SCRIPT_DATA);
      break;
    }
    case h.TEMPLATE: {
      e._insertTemplate(n), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = I.IN_TEMPLATE, e.tmplInsertionModeStack.unshift(I.IN_TEMPLATE);
      break;
    }
    case h.HEAD: {
      e._err(n, U.misplacedStartTagForHeadElement);
      break;
    }
    default:
      pa(e, n);
  }
}
function G$(e, n) {
  switch (n.tagID) {
    case h.HEAD: {
      e.openElements.pop(), e.insertionMode = I.AFTER_HEAD;
      break;
    }
    case h.BODY:
    case h.BR:
    case h.HTML: {
      pa(e, n);
      break;
    }
    case h.TEMPLATE: {
      gs(e, n);
      break;
    }
    default:
      e._err(n, U.endTagWithoutMatchingOpenElement);
  }
}
function gs(e, n) {
  e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagId !== h.TEMPLATE && e._err(n, U.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(h.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode()) : e._err(n, U.endTagWithoutMatchingOpenElement);
}
function pa(e, n) {
  e.openElements.pop(), e.insertionMode = I.AFTER_HEAD, e._processToken(n);
}
function Q$(e, n) {
  switch (n.tagID) {
    case h.HTML: {
      Zt(e, n);
      break;
    }
    case h.BASEFONT:
    case h.BGSOUND:
    case h.HEAD:
    case h.LINK:
    case h.META:
    case h.NOFRAMES:
    case h.STYLE: {
      di(e, n);
      break;
    }
    case h.NOSCRIPT: {
      e._err(n, U.nestedNoscriptInHead);
      break;
    }
    default:
      ga(e, n);
  }
}
function X$(e, n) {
  switch (n.tagID) {
    case h.NOSCRIPT: {
      e.openElements.pop(), e.insertionMode = I.IN_HEAD;
      break;
    }
    case h.BR: {
      ga(e, n);
      break;
    }
    default:
      e._err(n, U.endTagWithoutMatchingOpenElement);
  }
}
function ga(e, n) {
  const t = n.type === He.EOF ? U.openElementsLeftAfterEof : U.disallowedContentInNoscriptInHead;
  e._err(n, t), e.openElements.pop(), e.insertionMode = I.IN_HEAD, e._processToken(n);
}
function J$(e, n) {
  switch (n.tagID) {
    case h.HTML: {
      Zt(e, n);
      break;
    }
    case h.BODY: {
      e._insertElement(n, q.HTML), e.framesetOk = !1, e.insertionMode = I.IN_BODY;
      break;
    }
    case h.FRAMESET: {
      e._insertElement(n, q.HTML), e.insertionMode = I.IN_FRAMESET;
      break;
    }
    case h.BASE:
    case h.BASEFONT:
    case h.BGSOUND:
    case h.LINK:
    case h.META:
    case h.NOFRAMES:
    case h.SCRIPT:
    case h.STYLE:
    case h.TEMPLATE:
    case h.TITLE: {
      e._err(n, U.abandonedHeadElementChild), e.openElements.push(e.headElement, h.HEAD), di(e, n), e.openElements.remove(e.headElement);
      break;
    }
    case h.HEAD: {
      e._err(n, U.misplacedStartTagForHeadElement);
      break;
    }
    default:
      ba(e, n);
  }
}
function Z$(e, n) {
  switch (n.tagID) {
    case h.BODY:
    case h.HTML:
    case h.BR: {
      ba(e, n);
      break;
    }
    case h.TEMPLATE: {
      gs(e, n);
      break;
    }
    default:
      e._err(n, U.endTagWithoutMatchingOpenElement);
  }
}
function ba(e, n) {
  e._insertFakeElement(R.BODY, h.BODY), e.insertionMode = I.IN_BODY, wc(e, n);
}
function wc(e, n) {
  switch (n.type) {
    case He.CHARACTER: {
      C2(e, n);
      break;
    }
    case He.WHITESPACE_CHARACTER: {
      A2(e, n);
      break;
    }
    case He.COMMENT: {
      cf(e, n);
      break;
    }
    case He.START_TAG: {
      Zt(e, n);
      break;
    }
    case He.END_TAG: {
      Ac(e, n);
      break;
    }
    case He.EOF: {
      x2(e, n);
      break;
    }
  }
}
function A2(e, n) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(n);
}
function C2(e, n) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(n), e.framesetOk = !1;
}
function eW(e, n) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], n.attrs);
}
function tW(e, n) {
  const t = e.openElements.tryPeekProperlyNestedBodyElement();
  t && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(t, n.attrs));
}
function nW(e, n) {
  const t = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && t && (e.treeAdapter.detachNode(t), e.openElements.popAllUpToHtmlElement(), e._insertElement(n, q.HTML), e.insertionMode = I.IN_FRAMESET);
}
function iW(e, n) {
  e.openElements.hasInButtonScope(h.P) && e._closePElement(), e._insertElement(n, q.HTML);
}
function rW(e, n) {
  e.openElements.hasInButtonScope(h.P) && e._closePElement(), e.openElements.currentTagId !== void 0 && lf.has(e.openElements.currentTagId) && e.openElements.pop(), e._insertElement(n, q.HTML);
}
function sW(e, n) {
  e.openElements.hasInButtonScope(h.P) && e._closePElement(), e._insertElement(n, q.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function oW(e, n) {
  const t = e.openElements.tmplCount > 0;
  (!e.formElement || t) && (e.openElements.hasInButtonScope(h.P) && e._closePElement(), e._insertElement(n, q.HTML), t || (e.formElement = e.openElements.current));
}
function aW(e, n) {
  e.framesetOk = !1;
  const t = n.tagID;
  for (let i = e.openElements.stackTop; i >= 0; i--) {
    const r = e.openElements.tagIDs[i];
    if (t === h.LI && r === h.LI || (t === h.DD || t === h.DT) && (r === h.DD || r === h.DT)) {
      e.openElements.generateImpliedEndTagsWithExclusion(r), e.openElements.popUntilTagNamePopped(r);
      break;
    }
    if (r !== h.ADDRESS && r !== h.DIV && r !== h.P && e._isSpecialElement(e.openElements.items[i], r))
      break;
  }
  e.openElements.hasInButtonScope(h.P) && e._closePElement(), e._insertElement(n, q.HTML);
}
function uW(e, n) {
  e.openElements.hasInButtonScope(h.P) && e._closePElement(), e._insertElement(n, q.HTML), e.tokenizer.state = gn.PLAINTEXT;
}
function lW(e, n) {
  e.openElements.hasInScope(h.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(h.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(n, q.HTML), e.framesetOk = !1;
}
function cW(e, n) {
  const t = e.activeFormattingElements.getElementEntryInScopeWithTagName(R.A);
  t && (Fm(e, n), e.openElements.remove(t.element), e.activeFormattingElements.removeEntry(t)), e._reconstructActiveFormattingElements(), e._insertElement(n, q.HTML), e.activeFormattingElements.pushElement(e.openElements.current, n);
}
function dW(e, n) {
  e._reconstructActiveFormattingElements(), e._insertElement(n, q.HTML), e.activeFormattingElements.pushElement(e.openElements.current, n);
}
function hW(e, n) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(h.NOBR) && (Fm(e, n), e._reconstructActiveFormattingElements()), e._insertElement(n, q.HTML), e.activeFormattingElements.pushElement(e.openElements.current, n);
}
function fW(e, n) {
  e._reconstructActiveFormattingElements(), e._insertElement(n, q.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function mW(e, n) {
  e.treeAdapter.getDocumentMode(e.document) !== Hn.QUIRKS && e.openElements.hasInButtonScope(h.P) && e._closePElement(), e._insertElement(n, q.HTML), e.framesetOk = !1, e.insertionMode = I.IN_TABLE;
}
function k2(e, n) {
  e._reconstructActiveFormattingElements(), e._appendElement(n, q.HTML), e.framesetOk = !1, n.ackSelfClosing = !0;
}
function S2(e) {
  const n = f2(e, Zr.TYPE);
  return n != null && n.toLowerCase() === N$;
}
function pW(e, n) {
  e._reconstructActiveFormattingElements(), e._appendElement(n, q.HTML), S2(n) || (e.framesetOk = !1), n.ackSelfClosing = !0;
}
function gW(e, n) {
  e._appendElement(n, q.HTML), n.ackSelfClosing = !0;
}
function bW(e, n) {
  e.openElements.hasInButtonScope(h.P) && e._closePElement(), e._appendElement(n, q.HTML), e.framesetOk = !1, n.ackSelfClosing = !0;
}
function _W(e, n) {
  n.tagName = R.IMG, n.tagID = h.IMG, k2(e, n);
}
function EW(e, n) {
  e._insertElement(n, q.HTML), e.skipNextNewLine = !0, e.tokenizer.state = gn.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = I.TEXT;
}
function TW(e, n) {
  e.openElements.hasInButtonScope(h.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(n, gn.RAWTEXT);
}
function yW(e, n) {
  e.framesetOk = !1, e._switchToTextParsing(n, gn.RAWTEXT);
}
function k1(e, n) {
  e._switchToTextParsing(n, gn.RAWTEXT);
}
function wW(e, n) {
  e._reconstructActiveFormattingElements(), e._insertElement(n, q.HTML), e.framesetOk = !1, e.insertionMode = e.insertionMode === I.IN_TABLE || e.insertionMode === I.IN_CAPTION || e.insertionMode === I.IN_TABLE_BODY || e.insertionMode === I.IN_ROW || e.insertionMode === I.IN_CELL ? I.IN_SELECT_IN_TABLE : I.IN_SELECT;
}
function AW(e, n) {
  e.openElements.currentTagId === h.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(n, q.HTML);
}
function CW(e, n) {
  e.openElements.hasInScope(h.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(n, q.HTML);
}
function kW(e, n) {
  e.openElements.hasInScope(h.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(h.RTC), e._insertElement(n, q.HTML);
}
function SW(e, n) {
  e._reconstructActiveFormattingElements(), E2(n), Bm(n), n.selfClosing ? e._appendElement(n, q.MATHML) : e._insertElement(n, q.MATHML), n.ackSelfClosing = !0;
}
function IW(e, n) {
  e._reconstructActiveFormattingElements(), T2(n), Bm(n), n.selfClosing ? e._appendElement(n, q.SVG) : e._insertElement(n, q.SVG), n.ackSelfClosing = !0;
}
function S1(e, n) {
  e._reconstructActiveFormattingElements(), e._insertElement(n, q.HTML);
}
function Zt(e, n) {
  switch (n.tagID) {
    case h.I:
    case h.S:
    case h.B:
    case h.U:
    case h.EM:
    case h.TT:
    case h.BIG:
    case h.CODE:
    case h.FONT:
    case h.SMALL:
    case h.STRIKE:
    case h.STRONG: {
      dW(e, n);
      break;
    }
    case h.A: {
      cW(e, n);
      break;
    }
    case h.H1:
    case h.H2:
    case h.H3:
    case h.H4:
    case h.H5:
    case h.H6: {
      rW(e, n);
      break;
    }
    case h.P:
    case h.DL:
    case h.OL:
    case h.UL:
    case h.DIV:
    case h.DIR:
    case h.NAV:
    case h.MAIN:
    case h.MENU:
    case h.ASIDE:
    case h.CENTER:
    case h.FIGURE:
    case h.FOOTER:
    case h.HEADER:
    case h.HGROUP:
    case h.DIALOG:
    case h.DETAILS:
    case h.ADDRESS:
    case h.ARTICLE:
    case h.SEARCH:
    case h.SECTION:
    case h.SUMMARY:
    case h.FIELDSET:
    case h.BLOCKQUOTE:
    case h.FIGCAPTION: {
      iW(e, n);
      break;
    }
    case h.LI:
    case h.DD:
    case h.DT: {
      aW(e, n);
      break;
    }
    case h.BR:
    case h.IMG:
    case h.WBR:
    case h.AREA:
    case h.EMBED:
    case h.KEYGEN: {
      k2(e, n);
      break;
    }
    case h.HR: {
      bW(e, n);
      break;
    }
    case h.RB:
    case h.RTC: {
      CW(e, n);
      break;
    }
    case h.RT:
    case h.RP: {
      kW(e, n);
      break;
    }
    case h.PRE:
    case h.LISTING: {
      sW(e, n);
      break;
    }
    case h.XMP: {
      TW(e, n);
      break;
    }
    case h.SVG: {
      IW(e, n);
      break;
    }
    case h.HTML: {
      eW(e, n);
      break;
    }
    case h.BASE:
    case h.LINK:
    case h.META:
    case h.STYLE:
    case h.TITLE:
    case h.SCRIPT:
    case h.BGSOUND:
    case h.BASEFONT:
    case h.TEMPLATE: {
      di(e, n);
      break;
    }
    case h.BODY: {
      tW(e, n);
      break;
    }
    case h.FORM: {
      oW(e, n);
      break;
    }
    case h.NOBR: {
      hW(e, n);
      break;
    }
    case h.MATH: {
      SW(e, n);
      break;
    }
    case h.TABLE: {
      mW(e, n);
      break;
    }
    case h.INPUT: {
      pW(e, n);
      break;
    }
    case h.PARAM:
    case h.TRACK:
    case h.SOURCE: {
      gW(e, n);
      break;
    }
    case h.IMAGE: {
      _W(e, n);
      break;
    }
    case h.BUTTON: {
      lW(e, n);
      break;
    }
    case h.APPLET:
    case h.OBJECT:
    case h.MARQUEE: {
      fW(e, n);
      break;
    }
    case h.IFRAME: {
      yW(e, n);
      break;
    }
    case h.SELECT: {
      wW(e, n);
      break;
    }
    case h.OPTION:
    case h.OPTGROUP: {
      AW(e, n);
      break;
    }
    case h.NOEMBED:
    case h.NOFRAMES: {
      k1(e, n);
      break;
    }
    case h.FRAMESET: {
      nW(e, n);
      break;
    }
    case h.TEXTAREA: {
      EW(e, n);
      break;
    }
    case h.NOSCRIPT: {
      e.options.scriptingEnabled ? k1(e, n) : S1(e, n);
      break;
    }
    case h.PLAINTEXT: {
      uW(e, n);
      break;
    }
    case h.COL:
    case h.TH:
    case h.TD:
    case h.TR:
    case h.HEAD:
    case h.FRAME:
    case h.TBODY:
    case h.TFOOT:
    case h.THEAD:
    case h.CAPTION:
    case h.COLGROUP:
      break;
    default:
      S1(e, n);
  }
}
function xW(e, n) {
  if (e.openElements.hasInScope(h.BODY) && (e.insertionMode = I.AFTER_BODY, e.options.sourceCodeLocationInfo)) {
    const t = e.openElements.tryPeekProperlyNestedBodyElement();
    t && e._setEndLocation(t, n);
  }
}
function vW(e, n) {
  e.openElements.hasInScope(h.BODY) && (e.insertionMode = I.AFTER_BODY, M2(e, n));
}
function PW(e, n) {
  const t = n.tagID;
  e.openElements.hasInScope(t) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(t));
}
function OW(e) {
  const n = e.openElements.tmplCount > 0, { formElement: t } = e;
  n || (e.formElement = null), (t || n) && e.openElements.hasInScope(h.FORM) && (e.openElements.generateImpliedEndTags(), n ? e.openElements.popUntilTagNamePopped(h.FORM) : t && e.openElements.remove(t));
}
function NW(e) {
  e.openElements.hasInButtonScope(h.P) || e._insertFakeElement(R.P, h.P), e._closePElement();
}
function RW(e) {
  e.openElements.hasInListItemScope(h.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(h.LI), e.openElements.popUntilTagNamePopped(h.LI));
}
function LW(e, n) {
  const t = n.tagID;
  e.openElements.hasInScope(t) && (e.openElements.generateImpliedEndTagsWithExclusion(t), e.openElements.popUntilTagNamePopped(t));
}
function DW(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function MW(e, n) {
  const t = n.tagID;
  e.openElements.hasInScope(t) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(t), e.activeFormattingElements.clearToLastMarker());
}
function BW(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(R.BR, h.BR), e.openElements.pop(), e.framesetOk = !1;
}
function I2(e, n) {
  const t = n.tagName, i = n.tagID;
  for (let r = e.openElements.stackTop; r > 0; r--) {
    const s = e.openElements.items[r], o = e.openElements.tagIDs[r];
    if (i === o && (i !== h.UNKNOWN || e.treeAdapter.getTagName(s) === t)) {
      e.openElements.generateImpliedEndTagsWithExclusion(i), e.openElements.stackTop >= r && e.openElements.shortenToLength(r);
      break;
    }
    if (e._isSpecialElement(s, o))
      break;
  }
}
function Ac(e, n) {
  switch (n.tagID) {
    case h.A:
    case h.B:
    case h.I:
    case h.S:
    case h.U:
    case h.EM:
    case h.TT:
    case h.BIG:
    case h.CODE:
    case h.FONT:
    case h.NOBR:
    case h.SMALL:
    case h.STRIKE:
    case h.STRONG: {
      Fm(e, n);
      break;
    }
    case h.P: {
      NW(e);
      break;
    }
    case h.DL:
    case h.UL:
    case h.OL:
    case h.DIR:
    case h.DIV:
    case h.NAV:
    case h.PRE:
    case h.MAIN:
    case h.MENU:
    case h.ASIDE:
    case h.BUTTON:
    case h.CENTER:
    case h.FIGURE:
    case h.FOOTER:
    case h.HEADER:
    case h.HGROUP:
    case h.DIALOG:
    case h.ADDRESS:
    case h.ARTICLE:
    case h.DETAILS:
    case h.SEARCH:
    case h.SECTION:
    case h.SUMMARY:
    case h.LISTING:
    case h.FIELDSET:
    case h.BLOCKQUOTE:
    case h.FIGCAPTION: {
      PW(e, n);
      break;
    }
    case h.LI: {
      RW(e);
      break;
    }
    case h.DD:
    case h.DT: {
      LW(e, n);
      break;
    }
    case h.H1:
    case h.H2:
    case h.H3:
    case h.H4:
    case h.H5:
    case h.H6: {
      DW(e);
      break;
    }
    case h.BR: {
      BW(e);
      break;
    }
    case h.BODY: {
      xW(e, n);
      break;
    }
    case h.HTML: {
      vW(e, n);
      break;
    }
    case h.FORM: {
      OW(e);
      break;
    }
    case h.APPLET:
    case h.OBJECT:
    case h.MARQUEE: {
      MW(e, n);
      break;
    }
    case h.TEMPLATE: {
      gs(e, n);
      break;
    }
    default:
      I2(e, n);
  }
}
function x2(e, n) {
  e.tmplInsertionModeStack.length > 0 ? D2(e, n) : Um(e, n);
}
function FW(e, n) {
  var t;
  n.tagID === h.SCRIPT && ((t = e.scriptHandler) === null || t === void 0 || t.call(e, e.openElements.current)), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function UW(e, n) {
  e._err(n, U.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e.onEof(n);
}
function Kd(e, n) {
  if (e.openElements.currentTagId !== void 0 && y2.has(e.openElements.currentTagId))
    switch (e.pendingCharacterTokens.length = 0, e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = I.IN_TABLE_TEXT, n.type) {
      case He.CHARACTER: {
        P2(e, n);
        break;
      }
      case He.WHITESPACE_CHARACTER: {
        v2(e, n);
        break;
      }
    }
  else
    hu(e, n);
}
function HW(e, n) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(n, q.HTML), e.insertionMode = I.IN_CAPTION;
}
function VW(e, n) {
  e.openElements.clearBackToTableContext(), e._insertElement(n, q.HTML), e.insertionMode = I.IN_COLUMN_GROUP;
}
function $W(e, n) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(R.COLGROUP, h.COLGROUP), e.insertionMode = I.IN_COLUMN_GROUP, Hm(e, n);
}
function WW(e, n) {
  e.openElements.clearBackToTableContext(), e._insertElement(n, q.HTML), e.insertionMode = I.IN_TABLE_BODY;
}
function zW(e, n) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(R.TBODY, h.TBODY), e.insertionMode = I.IN_TABLE_BODY, Cc(e, n);
}
function qW(e, n) {
  e.openElements.hasInTableScope(h.TABLE) && (e.openElements.popUntilTagNamePopped(h.TABLE), e._resetInsertionMode(), e._processStartTag(n));
}
function YW(e, n) {
  S2(n) ? e._appendElement(n, q.HTML) : hu(e, n), n.ackSelfClosing = !0;
}
function jW(e, n) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(n, q.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function oo(e, n) {
  switch (n.tagID) {
    case h.TD:
    case h.TH:
    case h.TR: {
      zW(e, n);
      break;
    }
    case h.STYLE:
    case h.SCRIPT:
    case h.TEMPLATE: {
      di(e, n);
      break;
    }
    case h.COL: {
      $W(e, n);
      break;
    }
    case h.FORM: {
      jW(e, n);
      break;
    }
    case h.TABLE: {
      qW(e, n);
      break;
    }
    case h.TBODY:
    case h.TFOOT:
    case h.THEAD: {
      WW(e, n);
      break;
    }
    case h.INPUT: {
      YW(e, n);
      break;
    }
    case h.CAPTION: {
      HW(e, n);
      break;
    }
    case h.COLGROUP: {
      VW(e, n);
      break;
    }
    default:
      hu(e, n);
  }
}
function qa(e, n) {
  switch (n.tagID) {
    case h.TABLE: {
      e.openElements.hasInTableScope(h.TABLE) && (e.openElements.popUntilTagNamePopped(h.TABLE), e._resetInsertionMode());
      break;
    }
    case h.TEMPLATE: {
      gs(e, n);
      break;
    }
    case h.BODY:
    case h.CAPTION:
    case h.COL:
    case h.COLGROUP:
    case h.HTML:
    case h.TBODY:
    case h.TD:
    case h.TFOOT:
    case h.TH:
    case h.THEAD:
    case h.TR:
      break;
    default:
      hu(e, n);
  }
}
function hu(e, n) {
  const t = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, wc(e, n), e.fosterParentingEnabled = t;
}
function v2(e, n) {
  e.pendingCharacterTokens.push(n);
}
function P2(e, n) {
  e.pendingCharacterTokens.push(n), e.hasNonWhitespacePendingCharacterToken = !0;
}
function qo(e, n) {
  let t = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; t < e.pendingCharacterTokens.length; t++)
      hu(e, e.pendingCharacterTokens[t]);
  else
    for (; t < e.pendingCharacterTokens.length; t++)
      e._insertCharacters(e.pendingCharacterTokens[t]);
  e.insertionMode = e.originalInsertionMode, e._processToken(n);
}
const O2 = /* @__PURE__ */ new Set([h.CAPTION, h.COL, h.COLGROUP, h.TBODY, h.TD, h.TFOOT, h.TH, h.THEAD, h.TR]);
function KW(e, n) {
  const t = n.tagID;
  O2.has(t) ? e.openElements.hasInTableScope(h.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(h.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = I.IN_TABLE, oo(e, n)) : Zt(e, n);
}
function GW(e, n) {
  const t = n.tagID;
  switch (t) {
    case h.CAPTION:
    case h.TABLE: {
      e.openElements.hasInTableScope(h.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(h.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = I.IN_TABLE, t === h.TABLE && qa(e, n));
      break;
    }
    case h.BODY:
    case h.COL:
    case h.COLGROUP:
    case h.HTML:
    case h.TBODY:
    case h.TD:
    case h.TFOOT:
    case h.TH:
    case h.THEAD:
    case h.TR:
      break;
    default:
      Ac(e, n);
  }
}
function Hm(e, n) {
  switch (n.tagID) {
    case h.HTML: {
      Zt(e, n);
      break;
    }
    case h.COL: {
      e._appendElement(n, q.HTML), n.ackSelfClosing = !0;
      break;
    }
    case h.TEMPLATE: {
      di(e, n);
      break;
    }
    default:
      Ml(e, n);
  }
}
function QW(e, n) {
  switch (n.tagID) {
    case h.COLGROUP: {
      e.openElements.currentTagId === h.COLGROUP && (e.openElements.pop(), e.insertionMode = I.IN_TABLE);
      break;
    }
    case h.TEMPLATE: {
      gs(e, n);
      break;
    }
    case h.COL:
      break;
    default:
      Ml(e, n);
  }
}
function Ml(e, n) {
  e.openElements.currentTagId === h.COLGROUP && (e.openElements.pop(), e.insertionMode = I.IN_TABLE, e._processToken(n));
}
function Cc(e, n) {
  switch (n.tagID) {
    case h.TR: {
      e.openElements.clearBackToTableBodyContext(), e._insertElement(n, q.HTML), e.insertionMode = I.IN_ROW;
      break;
    }
    case h.TH:
    case h.TD: {
      e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(R.TR, h.TR), e.insertionMode = I.IN_ROW, kc(e, n);
      break;
    }
    case h.CAPTION:
    case h.COL:
    case h.COLGROUP:
    case h.TBODY:
    case h.TFOOT:
    case h.THEAD: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = I.IN_TABLE, oo(e, n));
      break;
    }
    default:
      oo(e, n);
  }
}
function df(e, n) {
  const t = n.tagID;
  switch (n.tagID) {
    case h.TBODY:
    case h.TFOOT:
    case h.THEAD: {
      e.openElements.hasInTableScope(t) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = I.IN_TABLE);
      break;
    }
    case h.TABLE: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = I.IN_TABLE, qa(e, n));
      break;
    }
    case h.BODY:
    case h.CAPTION:
    case h.COL:
    case h.COLGROUP:
    case h.HTML:
    case h.TD:
    case h.TH:
    case h.TR:
      break;
    default:
      qa(e, n);
  }
}
function kc(e, n) {
  switch (n.tagID) {
    case h.TH:
    case h.TD: {
      e.openElements.clearBackToTableRowContext(), e._insertElement(n, q.HTML), e.insertionMode = I.IN_CELL, e.activeFormattingElements.insertMarker();
      break;
    }
    case h.CAPTION:
    case h.COL:
    case h.COLGROUP:
    case h.TBODY:
    case h.TFOOT:
    case h.THEAD:
    case h.TR: {
      e.openElements.hasInTableScope(h.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = I.IN_TABLE_BODY, Cc(e, n));
      break;
    }
    default:
      oo(e, n);
  }
}
function N2(e, n) {
  switch (n.tagID) {
    case h.TR: {
      e.openElements.hasInTableScope(h.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = I.IN_TABLE_BODY);
      break;
    }
    case h.TABLE: {
      e.openElements.hasInTableScope(h.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = I.IN_TABLE_BODY, df(e, n));
      break;
    }
    case h.TBODY:
    case h.TFOOT:
    case h.THEAD: {
      (e.openElements.hasInTableScope(n.tagID) || e.openElements.hasInTableScope(h.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = I.IN_TABLE_BODY, df(e, n));
      break;
    }
    case h.BODY:
    case h.CAPTION:
    case h.COL:
    case h.COLGROUP:
    case h.HTML:
    case h.TD:
    case h.TH:
      break;
    default:
      qa(e, n);
  }
}
function XW(e, n) {
  const t = n.tagID;
  O2.has(t) ? (e.openElements.hasInTableScope(h.TD) || e.openElements.hasInTableScope(h.TH)) && (e._closeTableCell(), kc(e, n)) : Zt(e, n);
}
function JW(e, n) {
  const t = n.tagID;
  switch (t) {
    case h.TD:
    case h.TH: {
      e.openElements.hasInTableScope(t) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(t), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = I.IN_ROW);
      break;
    }
    case h.TABLE:
    case h.TBODY:
    case h.TFOOT:
    case h.THEAD:
    case h.TR: {
      e.openElements.hasInTableScope(t) && (e._closeTableCell(), N2(e, n));
      break;
    }
    case h.BODY:
    case h.CAPTION:
    case h.COL:
    case h.COLGROUP:
    case h.HTML:
      break;
    default:
      Ac(e, n);
  }
}
function R2(e, n) {
  switch (n.tagID) {
    case h.HTML: {
      Zt(e, n);
      break;
    }
    case h.OPTION: {
      e.openElements.currentTagId === h.OPTION && e.openElements.pop(), e._insertElement(n, q.HTML);
      break;
    }
    case h.OPTGROUP: {
      e.openElements.currentTagId === h.OPTION && e.openElements.pop(), e.openElements.currentTagId === h.OPTGROUP && e.openElements.pop(), e._insertElement(n, q.HTML);
      break;
    }
    case h.HR: {
      e.openElements.currentTagId === h.OPTION && e.openElements.pop(), e.openElements.currentTagId === h.OPTGROUP && e.openElements.pop(), e._appendElement(n, q.HTML), n.ackSelfClosing = !0;
      break;
    }
    case h.INPUT:
    case h.KEYGEN:
    case h.TEXTAREA:
    case h.SELECT: {
      e.openElements.hasInSelectScope(h.SELECT) && (e.openElements.popUntilTagNamePopped(h.SELECT), e._resetInsertionMode(), n.tagID !== h.SELECT && e._processStartTag(n));
      break;
    }
    case h.SCRIPT:
    case h.TEMPLATE: {
      di(e, n);
      break;
    }
  }
}
function L2(e, n) {
  switch (n.tagID) {
    case h.OPTGROUP: {
      e.openElements.stackTop > 0 && e.openElements.currentTagId === h.OPTION && e.openElements.tagIDs[e.openElements.stackTop - 1] === h.OPTGROUP && e.openElements.pop(), e.openElements.currentTagId === h.OPTGROUP && e.openElements.pop();
      break;
    }
    case h.OPTION: {
      e.openElements.currentTagId === h.OPTION && e.openElements.pop();
      break;
    }
    case h.SELECT: {
      e.openElements.hasInSelectScope(h.SELECT) && (e.openElements.popUntilTagNamePopped(h.SELECT), e._resetInsertionMode());
      break;
    }
    case h.TEMPLATE: {
      gs(e, n);
      break;
    }
  }
}
function ZW(e, n) {
  const t = n.tagID;
  t === h.CAPTION || t === h.TABLE || t === h.TBODY || t === h.TFOOT || t === h.THEAD || t === h.TR || t === h.TD || t === h.TH ? (e.openElements.popUntilTagNamePopped(h.SELECT), e._resetInsertionMode(), e._processStartTag(n)) : R2(e, n);
}
function ez(e, n) {
  const t = n.tagID;
  t === h.CAPTION || t === h.TABLE || t === h.TBODY || t === h.TFOOT || t === h.THEAD || t === h.TR || t === h.TD || t === h.TH ? e.openElements.hasInTableScope(t) && (e.openElements.popUntilTagNamePopped(h.SELECT), e._resetInsertionMode(), e.onEndTag(n)) : L2(e, n);
}
function tz(e, n) {
  switch (n.tagID) {
    case h.BASE:
    case h.BASEFONT:
    case h.BGSOUND:
    case h.LINK:
    case h.META:
    case h.NOFRAMES:
    case h.SCRIPT:
    case h.STYLE:
    case h.TEMPLATE:
    case h.TITLE: {
      di(e, n);
      break;
    }
    case h.CAPTION:
    case h.COLGROUP:
    case h.TBODY:
    case h.TFOOT:
    case h.THEAD: {
      e.tmplInsertionModeStack[0] = I.IN_TABLE, e.insertionMode = I.IN_TABLE, oo(e, n);
      break;
    }
    case h.COL: {
      e.tmplInsertionModeStack[0] = I.IN_COLUMN_GROUP, e.insertionMode = I.IN_COLUMN_GROUP, Hm(e, n);
      break;
    }
    case h.TR: {
      e.tmplInsertionModeStack[0] = I.IN_TABLE_BODY, e.insertionMode = I.IN_TABLE_BODY, Cc(e, n);
      break;
    }
    case h.TD:
    case h.TH: {
      e.tmplInsertionModeStack[0] = I.IN_ROW, e.insertionMode = I.IN_ROW, kc(e, n);
      break;
    }
    default:
      e.tmplInsertionModeStack[0] = I.IN_BODY, e.insertionMode = I.IN_BODY, Zt(e, n);
  }
}
function nz(e, n) {
  n.tagID === h.TEMPLATE && gs(e, n);
}
function D2(e, n) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(h.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode(), e.onEof(n)) : Um(e, n);
}
function iz(e, n) {
  n.tagID === h.HTML ? Zt(e, n) : Bl(e, n);
}
function M2(e, n) {
  var t;
  if (n.tagID === h.HTML) {
    if (e.fragmentContext || (e.insertionMode = I.AFTER_AFTER_BODY), e.options.sourceCodeLocationInfo && e.openElements.tagIDs[0] === h.HTML) {
      e._setEndLocation(e.openElements.items[0], n);
      const i = e.openElements.items[1];
      i && !(!((t = e.treeAdapter.getNodeSourceCodeLocation(i)) === null || t === void 0) && t.endTag) && e._setEndLocation(i, n);
    }
  } else
    Bl(e, n);
}
function Bl(e, n) {
  e.insertionMode = I.IN_BODY, wc(e, n);
}
function rz(e, n) {
  switch (n.tagID) {
    case h.HTML: {
      Zt(e, n);
      break;
    }
    case h.FRAMESET: {
      e._insertElement(n, q.HTML);
      break;
    }
    case h.FRAME: {
      e._appendElement(n, q.HTML), n.ackSelfClosing = !0;
      break;
    }
    case h.NOFRAMES: {
      di(e, n);
      break;
    }
  }
}
function sz(e, n) {
  n.tagID === h.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagId !== h.FRAMESET && (e.insertionMode = I.AFTER_FRAMESET));
}
function oz(e, n) {
  switch (n.tagID) {
    case h.HTML: {
      Zt(e, n);
      break;
    }
    case h.NOFRAMES: {
      di(e, n);
      break;
    }
  }
}
function az(e, n) {
  n.tagID === h.HTML && (e.insertionMode = I.AFTER_AFTER_FRAMESET);
}
function uz(e, n) {
  n.tagID === h.HTML ? Zt(e, n) : rl(e, n);
}
function rl(e, n) {
  e.insertionMode = I.IN_BODY, wc(e, n);
}
function lz(e, n) {
  switch (n.tagID) {
    case h.HTML: {
      Zt(e, n);
      break;
    }
    case h.NOFRAMES: {
      di(e, n);
      break;
    }
  }
}
function cz(e, n) {
  n.chars = lt, e._insertCharacters(n);
}
function dz(e, n) {
  e._insertCharacters(n), e.framesetOk = !1;
}
function B2(e) {
  for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== q.HTML && e.openElements.currentTagId !== void 0 && !e._isIntegrationPoint(e.openElements.currentTagId, e.openElements.current); )
    e.openElements.pop();
}
function hz(e, n) {
  if (I$(n))
    B2(e), e._startTagOutsideForeignContent(n);
  else {
    const t = e._getAdjustedCurrentElement(), i = e.treeAdapter.getNamespaceURI(t);
    i === q.MATHML ? E2(n) : i === q.SVG && (x$(n), T2(n)), Bm(n), n.selfClosing ? e._appendElement(n, i) : e._insertElement(n, i), n.ackSelfClosing = !0;
  }
}
function fz(e, n) {
  if (n.tagID === h.P || n.tagID === h.BR) {
    B2(e), e._endTagOutsideForeignContent(n);
    return;
  }
  for (let t = e.openElements.stackTop; t > 0; t--) {
    const i = e.openElements.items[t];
    if (e.treeAdapter.getNamespaceURI(i) === q.HTML) {
      e._endTagOutsideForeignContent(n);
      break;
    }
    const r = e.treeAdapter.getTagName(i);
    if (r.toLowerCase() === n.tagName) {
      n.tagName = r, e.openElements.shortenToLength(t);
      break;
    }
  }
}
R.AREA, R.BASE, R.BASEFONT, R.BGSOUND, R.BR, R.COL, R.EMBED, R.FRAME, R.HR, R.IMG, R.INPUT, R.KEYGEN, R.LINK, R.META, R.PARAM, R.SOURCE, R.TRACK, R.WBR;
function mz(e, n) {
  return w2.parse(e, n);
}
function pz(e, n, t) {
  typeof e == "string" && (t = n, n = e, e = null);
  const i = w2.getFragmentParser(e, t);
  return i.tokenizer.write(n, !0), i.getFragment();
}
const gz = {
  /** @type {ErrorInfo} */
  abandonedHeadElementChild: {
    reason: "Unexpected metadata element after head",
    description: "Unexpected element after head. Expected the element before `</head>`",
    url: !1
  },
  /** @type {ErrorInfo} */
  abruptClosingOfEmptyComment: {
    reason: "Unexpected abruptly closed empty comment",
    description: "Unexpected `>` or `->`. Expected `-->` to close comments"
  },
  /** @type {ErrorInfo} */
  abruptDoctypePublicIdentifier: {
    reason: "Unexpected abruptly closed public identifier",
    description: "Unexpected `>`. Expected a closing `\"` or `'` after the public identifier"
  },
  /** @type {ErrorInfo} */
  abruptDoctypeSystemIdentifier: {
    reason: "Unexpected abruptly closed system identifier",
    description: "Unexpected `>`. Expected a closing `\"` or `'` after the identifier identifier"
  },
  /** @type {ErrorInfo} */
  absenceOfDigitsInNumericCharacterReference: {
    reason: "Unexpected non-digit at start of numeric character reference",
    description: "Unexpected `%c`. Expected `[0-9]` for decimal references or `[0-9a-fA-F]` for hexadecimal references"
  },
  /** @type {ErrorInfo} */
  cdataInHtmlContent: {
    reason: "Unexpected CDATA section in HTML",
    description: "Unexpected `<![CDATA[` in HTML. Remove it, use a comment, or encode special characters instead"
  },
  /** @type {ErrorInfo} */
  characterReferenceOutsideUnicodeRange: {
    reason: "Unexpected too big numeric character reference",
    description: "Unexpectedly high character reference. Expected character references to be at most hexadecimal 10ffff (or decimal 1114111)"
  },
  /** @type {ErrorInfo} */
  closingOfElementWithOpenChildElements: {
    reason: "Unexpected closing tag with open child elements",
    description: "Unexpectedly closing tag. Expected other tags to be closed first",
    url: !1
  },
  /** @type {ErrorInfo} */
  controlCharacterInInputStream: {
    reason: "Unexpected control character",
    description: "Unexpected control character `%x`. Expected a non-control code point, 0x00, or ASCII whitespace"
  },
  /** @type {ErrorInfo} */
  controlCharacterReference: {
    reason: "Unexpected control character reference",
    description: "Unexpectedly control character in reference. Expected a non-control code point, 0x00, or ASCII whitespace"
  },
  /** @type {ErrorInfo} */
  disallowedContentInNoscriptInHead: {
    reason: "Disallowed content inside `<noscript>` in `<head>`",
    description: "Unexpected text character `%c`. Only use text in `<noscript>`s in `<body>`",
    url: !1
  },
  /** @type {ErrorInfo} */
  duplicateAttribute: {
    reason: "Unexpected duplicate attribute",
    description: "Unexpectedly double attribute. Expected attributes to occur only once"
  },
  /** @type {ErrorInfo} */
  endTagWithAttributes: {
    reason: "Unexpected attribute on closing tag",
    description: "Unexpected attribute. Expected `>` instead"
  },
  /** @type {ErrorInfo} */
  endTagWithTrailingSolidus: {
    reason: "Unexpected slash at end of closing tag",
    description: "Unexpected `%c-1`. Expected `>` instead"
  },
  /** @type {ErrorInfo} */
  endTagWithoutMatchingOpenElement: {
    reason: "Unexpected unopened end tag",
    description: "Unexpected end tag. Expected no end tag or another end tag",
    url: !1
  },
  /** @type {ErrorInfo} */
  eofBeforeTagName: {
    reason: "Unexpected end of file",
    description: "Unexpected end of file. Expected tag name instead"
  },
  /** @type {ErrorInfo} */
  eofInCdata: {
    reason: "Unexpected end of file in CDATA",
    description: "Unexpected end of file. Expected `]]>` to close the CDATA"
  },
  /** @type {ErrorInfo} */
  eofInComment: {
    reason: "Unexpected end of file in comment",
    description: "Unexpected end of file. Expected `-->` to close the comment"
  },
  /** @type {ErrorInfo} */
  eofInDoctype: {
    reason: "Unexpected end of file in doctype",
    description: "Unexpected end of file. Expected a valid doctype (such as `<!doctype html>`)"
  },
  /** @type {ErrorInfo} */
  eofInElementThatCanContainOnlyText: {
    reason: "Unexpected end of file in element that can only contain text",
    description: "Unexpected end of file. Expected text or a closing tag",
    url: !1
  },
  /** @type {ErrorInfo} */
  eofInScriptHtmlCommentLikeText: {
    reason: "Unexpected end of file in comment inside script",
    description: "Unexpected end of file. Expected `-->` to close the comment"
  },
  /** @type {ErrorInfo} */
  eofInTag: {
    reason: "Unexpected end of file in tag",
    description: "Unexpected end of file. Expected `>` to close the tag"
  },
  /** @type {ErrorInfo} */
  incorrectlyClosedComment: {
    reason: "Incorrectly closed comment",
    description: "Unexpected `%c-1`. Expected `-->` to close the comment"
  },
  /** @type {ErrorInfo} */
  incorrectlyOpenedComment: {
    reason: "Incorrectly opened comment",
    description: "Unexpected `%c`. Expected `<!--` to open the comment"
  },
  /** @type {ErrorInfo} */
  invalidCharacterSequenceAfterDoctypeName: {
    reason: "Invalid sequence after doctype name",
    description: "Unexpected sequence at `%c`. Expected `public` or `system`"
  },
  /** @type {ErrorInfo} */
  invalidFirstCharacterOfTagName: {
    reason: "Invalid first character in tag name",
    description: "Unexpected `%c`. Expected an ASCII letter instead"
  },
  /** @type {ErrorInfo} */
  misplacedDoctype: {
    reason: "Misplaced doctype",
    description: "Unexpected doctype. Expected doctype before head",
    url: !1
  },
  /** @type {ErrorInfo} */
  misplacedStartTagForHeadElement: {
    reason: "Misplaced `<head>` start tag",
    description: "Unexpected start tag `<head>`. Expected `<head>` directly after doctype",
    url: !1
  },
  /** @type {ErrorInfo} */
  missingAttributeValue: {
    reason: "Missing attribute value",
    description: "Unexpected `%c-1`. Expected an attribute value or no `%c-1` instead"
  },
  /** @type {ErrorInfo} */
  missingDoctype: {
    reason: "Missing doctype before other content",
    description: "Expected a `<!doctype html>` before anything else",
    url: !1
  },
  /** @type {ErrorInfo} */
  missingDoctypeName: {
    reason: "Missing doctype name",
    description: "Unexpected doctype end at `%c`. Expected `html` instead"
  },
  /** @type {ErrorInfo} */
  missingDoctypePublicIdentifier: {
    reason: "Missing public identifier in doctype",
    description: "Unexpected `%c`. Expected identifier for `public` instead"
  },
  /** @type {ErrorInfo} */
  missingDoctypeSystemIdentifier: {
    reason: "Missing system identifier in doctype",
    description: 'Unexpected `%c`. Expected identifier for `system` instead (suggested: `"about:legacy-compat"`)'
  },
  /** @type {ErrorInfo} */
  missingEndTagName: {
    reason: "Missing name in end tag",
    description: "Unexpected `%c`. Expected an ASCII letter instead"
  },
  /** @type {ErrorInfo} */
  missingQuoteBeforeDoctypePublicIdentifier: {
    reason: "Missing quote before public identifier in doctype",
    description: "Unexpected `%c`. Expected `\"` or `'` instead"
  },
  /** @type {ErrorInfo} */
  missingQuoteBeforeDoctypeSystemIdentifier: {
    reason: "Missing quote before system identifier in doctype",
    description: "Unexpected `%c`. Expected `\"` or `'` instead"
  },
  /** @type {ErrorInfo} */
  missingSemicolonAfterCharacterReference: {
    reason: "Missing semicolon after character reference",
    description: "Unexpected `%c`. Expected `;` instead"
  },
  /** @type {ErrorInfo} */
  missingWhitespaceAfterDoctypePublicKeyword: {
    reason: "Missing whitespace after public identifier in doctype",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  /** @type {ErrorInfo} */
  missingWhitespaceAfterDoctypeSystemKeyword: {
    reason: "Missing whitespace after system identifier in doctype",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  /** @type {ErrorInfo} */
  missingWhitespaceBeforeDoctypeName: {
    reason: "Missing whitespace before doctype name",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  /** @type {ErrorInfo} */
  missingWhitespaceBetweenAttributes: {
    reason: "Missing whitespace between attributes",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  /** @type {ErrorInfo} */
  missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: {
    reason: "Missing whitespace between public and system identifiers in doctype",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  /** @type {ErrorInfo} */
  nestedComment: {
    reason: "Unexpected nested comment",
    description: "Unexpected `<!--`. Expected `-->`"
  },
  /** @type {ErrorInfo} */
  nestedNoscriptInHead: {
    reason: "Unexpected nested `<noscript>` in `<head>`",
    description: "Unexpected `<noscript>`. Expected a closing tag or a meta element",
    url: !1
  },
  /** @type {ErrorInfo} */
  nonConformingDoctype: {
    reason: "Unexpected non-conforming doctype declaration",
    description: 'Expected `<!doctype html>` or `<!doctype html system "about:legacy-compat">`',
    url: !1
  },
  /** @type {ErrorInfo} */
  nonVoidHtmlElementStartTagWithTrailingSolidus: {
    reason: "Unexpected trailing slash on start tag of non-void element",
    description: "Unexpected `/`. Expected `>` instead"
  },
  /** @type {ErrorInfo} */
  noncharacterCharacterReference: {
    reason: "Unexpected noncharacter code point referenced by character reference",
    description: "Unexpected code point. Do not use noncharacters in HTML"
  },
  /** @type {ErrorInfo} */
  noncharacterInInputStream: {
    reason: "Unexpected noncharacter character",
    description: "Unexpected code point `%x`. Do not use noncharacters in HTML"
  },
  /** @type {ErrorInfo} */
  nullCharacterReference: {
    reason: "Unexpected NULL character referenced by character reference",
    description: "Unexpected code point. Do not use NULL characters in HTML"
  },
  /** @type {ErrorInfo} */
  openElementsLeftAfterEof: {
    reason: "Unexpected end of file",
    description: "Unexpected end of file. Expected closing tag instead",
    url: !1
  },
  /** @type {ErrorInfo} */
  surrogateCharacterReference: {
    reason: "Unexpected surrogate character referenced by character reference",
    description: "Unexpected code point. Do not use lone surrogate characters in HTML"
  },
  /** @type {ErrorInfo} */
  surrogateInInputStream: {
    reason: "Unexpected surrogate character",
    description: "Unexpected code point `%x`. Do not use lone surrogate characters in HTML"
  },
  /** @type {ErrorInfo} */
  unexpectedCharacterAfterDoctypeSystemIdentifier: {
    reason: "Invalid character after system identifier in doctype",
    description: "Unexpected character at `%c`. Expected `>`"
  },
  /** @type {ErrorInfo} */
  unexpectedCharacterInAttributeName: {
    reason: "Unexpected character in attribute name",
    description: "Unexpected `%c`. Expected whitespace, `/`, `>`, `=`, or probably an ASCII letter"
  },
  /** @type {ErrorInfo} */
  unexpectedCharacterInUnquotedAttributeValue: {
    reason: "Unexpected character in unquoted attribute value",
    description: "Unexpected `%c`. Quote the attribute value to include it"
  },
  /** @type {ErrorInfo} */
  unexpectedEqualsSignBeforeAttributeName: {
    reason: "Unexpected equals sign before attribute name",
    description: "Unexpected `%c`. Add an attribute name before it"
  },
  /** @type {ErrorInfo} */
  unexpectedNullCharacter: {
    reason: "Unexpected NULL character",
    description: "Unexpected code point `%x`. Do not use NULL characters in HTML"
  },
  /** @type {ErrorInfo} */
  unexpectedQuestionMarkInsteadOfTagName: {
    reason: "Unexpected question mark instead of tag name",
    description: "Unexpected `%c`. Expected an ASCII letter instead"
  },
  /** @type {ErrorInfo} */
  unexpectedSolidusInTag: {
    reason: "Unexpected slash in tag",
    description: "Unexpected `%c-1`. Expected it followed by `>` or in a quoted attribute value"
  },
  /** @type {ErrorInfo} */
  unknownNamedCharacterReference: {
    reason: "Unexpected unknown named character reference",
    description: "Unexpected character reference. Expected known named character references"
  }
}, bz = "https://html.spec.whatwg.org/multipage/parsing.html#parse-error-", _z = /-[a-z]/g, Ez = /%c(?:([-+])(\d+))?/g, Tz = /%x/g, yz = { 2: !0, 1: !1, 0: null }, wz = {};
function Az(e, n) {
  const t = n || wz, i = t.onerror, r = e instanceof xl ? e : new xl(e), s = t.fragment ? pz : mz, o = String(r), a = s(o, {
    sourceCodeLocationInfo: !0,
    // Note `parse5` types currently do not allow `undefined`.
    onParseError: t.onerror ? u : null,
    scriptingEnabled: !1
  });
  return (
    /** @type {Root} */
    u2(a, {
      file: r,
      space: t.space,
      verbose: t.verbose
    })
  );
  function u(l) {
    const c = l.code, d = Cz(c), p = t[d], g = p ?? !0, b = typeof g == "number" ? g : g ? 1 : 0;
    if (b) {
      const k = gz[d], C = new Yt(_(k.reason), {
        place: {
          start: {
            line: l.startLine,
            column: l.startCol,
            offset: l.startOffset
          },
          end: {
            line: l.endLine,
            column: l.endCol,
            offset: l.endOffset
          }
        },
        ruleId: c,
        source: "hast-util-from-html"
      });
      r.path && (C.file = r.path, C.name = r.path + ":" + C.name), C.fatal = yz[b], C.note = _(k.description), C.url = k.url === !1 ? void 0 : bz + c, i(C);
    }
    function _(k) {
      return k.replace(Ez, C).replace(Tz, D);
      function C(M, j, F) {
        const O = (F ? Number.parseInt(F, 10) : 0) * (j === "-" ? -1 : 1), V = o.charAt(l.startOffset + O);
        return Sz(V);
      }
      function D() {
        return Iz(o.charCodeAt(l.startOffset));
      }
    }
  }
}
function Cz(e) {
  return (
    /** @type {ErrorCode} */
    e.replace(_z, kz)
  );
}
function kz(e) {
  return e.charAt(1).toUpperCase();
}
function Sz(e) {
  return e === "`" ? "` ` `" : e;
}
function Iz(e) {
  return "0x" + e.toString(16).toUpperCase();
}
function xz(e) {
  const n = this, { emitParseErrors: t, ...i } = { ...n.data("settings"), ...e };
  n.parser = r;
  function r(s, o) {
    return Az(s, {
      ...i,
      onerror: t ? function(a) {
        o.path && (a.name = o.path + ":" + a.name, a.file = o.path), o.messages.push(a);
      } : void 0
    });
  }
}
const F2 = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
], vz = /["&'<>`]/g, Pz = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, Oz = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), Nz = /[|\\{}()[\]^$+*?.]/g, I1 = /* @__PURE__ */ new WeakMap();
function Rz(e, n) {
  if (e = e.replace(
    n.subset ? Lz(n.subset) : vz,
    i
  ), n.subset || n.escapeOnly)
    return e;
  return e.replace(Pz, t).replace(Oz, i);
  function t(r, s, o) {
    return n.format(
      (r.charCodeAt(0) - 55296) * 1024 + r.charCodeAt(1) - 56320 + 65536,
      o.charCodeAt(s + 2),
      n
    );
  }
  function i(r, s, o) {
    return n.format(
      r.charCodeAt(0),
      o.charCodeAt(s + 1),
      n
    );
  }
}
function Lz(e) {
  let n = I1.get(e);
  return n || (n = Dz(e), I1.set(e, n)), n;
}
function Dz(e) {
  const n = [];
  let t = -1;
  for (; ++t < e.length; )
    n.push(e[t].replace(Nz, "\\$&"));
  return new RegExp("(?:" + n.join("|") + ")", "g");
}
const Mz = /[\dA-Fa-f]/;
function Bz(e, n, t) {
  const i = "&#x" + e.toString(16).toUpperCase();
  return t && n && !Mz.test(String.fromCharCode(n)) ? i : i + ";";
}
const Fz = /\d/;
function Uz(e, n, t) {
  const i = "&#" + String(e);
  return t && n && !Fz.test(String.fromCharCode(n)) ? i : i + ";";
}
const Hz = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], Gd = {
  nbsp: " ",
  iexcl: "¡",
  cent: "¢",
  pound: "£",
  curren: "¤",
  yen: "¥",
  brvbar: "¦",
  sect: "§",
  uml: "¨",
  copy: "©",
  ordf: "ª",
  laquo: "«",
  not: "¬",
  shy: "­",
  reg: "®",
  macr: "¯",
  deg: "°",
  plusmn: "±",
  sup2: "²",
  sup3: "³",
  acute: "´",
  micro: "µ",
  para: "¶",
  middot: "·",
  cedil: "¸",
  sup1: "¹",
  ordm: "º",
  raquo: "»",
  frac14: "¼",
  frac12: "½",
  frac34: "¾",
  iquest: "¿",
  Agrave: "À",
  Aacute: "Á",
  Acirc: "Â",
  Atilde: "Ã",
  Auml: "Ä",
  Aring: "Å",
  AElig: "Æ",
  Ccedil: "Ç",
  Egrave: "È",
  Eacute: "É",
  Ecirc: "Ê",
  Euml: "Ë",
  Igrave: "Ì",
  Iacute: "Í",
  Icirc: "Î",
  Iuml: "Ï",
  ETH: "Ð",
  Ntilde: "Ñ",
  Ograve: "Ò",
  Oacute: "Ó",
  Ocirc: "Ô",
  Otilde: "Õ",
  Ouml: "Ö",
  times: "×",
  Oslash: "Ø",
  Ugrave: "Ù",
  Uacute: "Ú",
  Ucirc: "Û",
  Uuml: "Ü",
  Yacute: "Ý",
  THORN: "Þ",
  szlig: "ß",
  agrave: "à",
  aacute: "á",
  acirc: "â",
  atilde: "ã",
  auml: "ä",
  aring: "å",
  aelig: "æ",
  ccedil: "ç",
  egrave: "è",
  eacute: "é",
  ecirc: "ê",
  euml: "ë",
  igrave: "ì",
  iacute: "í",
  icirc: "î",
  iuml: "ï",
  eth: "ð",
  ntilde: "ñ",
  ograve: "ò",
  oacute: "ó",
  ocirc: "ô",
  otilde: "õ",
  ouml: "ö",
  divide: "÷",
  oslash: "ø",
  ugrave: "ù",
  uacute: "ú",
  ucirc: "û",
  uuml: "ü",
  yacute: "ý",
  thorn: "þ",
  yuml: "ÿ",
  fnof: "ƒ",
  Alpha: "Α",
  Beta: "Β",
  Gamma: "Γ",
  Delta: "Δ",
  Epsilon: "Ε",
  Zeta: "Ζ",
  Eta: "Η",
  Theta: "Θ",
  Iota: "Ι",
  Kappa: "Κ",
  Lambda: "Λ",
  Mu: "Μ",
  Nu: "Ν",
  Xi: "Ξ",
  Omicron: "Ο",
  Pi: "Π",
  Rho: "Ρ",
  Sigma: "Σ",
  Tau: "Τ",
  Upsilon: "Υ",
  Phi: "Φ",
  Chi: "Χ",
  Psi: "Ψ",
  Omega: "Ω",
  alpha: "α",
  beta: "β",
  gamma: "γ",
  delta: "δ",
  epsilon: "ε",
  zeta: "ζ",
  eta: "η",
  theta: "θ",
  iota: "ι",
  kappa: "κ",
  lambda: "λ",
  mu: "μ",
  nu: "ν",
  xi: "ξ",
  omicron: "ο",
  pi: "π",
  rho: "ρ",
  sigmaf: "ς",
  sigma: "σ",
  tau: "τ",
  upsilon: "υ",
  phi: "φ",
  chi: "χ",
  psi: "ψ",
  omega: "ω",
  thetasym: "ϑ",
  upsih: "ϒ",
  piv: "ϖ",
  bull: "•",
  hellip: "…",
  prime: "′",
  Prime: "″",
  oline: "‾",
  frasl: "⁄",
  weierp: "℘",
  image: "ℑ",
  real: "ℜ",
  trade: "™",
  alefsym: "ℵ",
  larr: "←",
  uarr: "↑",
  rarr: "→",
  darr: "↓",
  harr: "↔",
  crarr: "↵",
  lArr: "⇐",
  uArr: "⇑",
  rArr: "⇒",
  dArr: "⇓",
  hArr: "⇔",
  forall: "∀",
  part: "∂",
  exist: "∃",
  empty: "∅",
  nabla: "∇",
  isin: "∈",
  notin: "∉",
  ni: "∋",
  prod: "∏",
  sum: "∑",
  minus: "−",
  lowast: "∗",
  radic: "√",
  prop: "∝",
  infin: "∞",
  ang: "∠",
  and: "∧",
  or: "∨",
  cap: "∩",
  cup: "∪",
  int: "∫",
  there4: "∴",
  sim: "∼",
  cong: "≅",
  asymp: "≈",
  ne: "≠",
  equiv: "≡",
  le: "≤",
  ge: "≥",
  sub: "⊂",
  sup: "⊃",
  nsub: "⊄",
  sube: "⊆",
  supe: "⊇",
  oplus: "⊕",
  otimes: "⊗",
  perp: "⊥",
  sdot: "⋅",
  lceil: "⌈",
  rceil: "⌉",
  lfloor: "⌊",
  rfloor: "⌋",
  lang: "〈",
  rang: "〉",
  loz: "◊",
  spades: "♠",
  clubs: "♣",
  hearts: "♥",
  diams: "♦",
  quot: '"',
  amp: "&",
  lt: "<",
  gt: ">",
  OElig: "Œ",
  oelig: "œ",
  Scaron: "Š",
  scaron: "š",
  Yuml: "Ÿ",
  circ: "ˆ",
  tilde: "˜",
  ensp: " ",
  emsp: " ",
  thinsp: " ",
  zwnj: "‌",
  zwj: "‍",
  lrm: "‎",
  rlm: "‏",
  ndash: "–",
  mdash: "—",
  lsquo: "‘",
  rsquo: "’",
  sbquo: "‚",
  ldquo: "“",
  rdquo: "”",
  bdquo: "„",
  dagger: "†",
  Dagger: "‡",
  permil: "‰",
  lsaquo: "‹",
  rsaquo: "›",
  euro: "€"
}, Vz = [
  "cent",
  "copy",
  "divide",
  "gt",
  "lt",
  "not",
  "para",
  "times"
], U2 = {}.hasOwnProperty, hf = {};
let qu;
for (qu in Gd)
  U2.call(Gd, qu) && (hf[Gd[qu]] = qu);
const $z = /[^\dA-Za-z]/;
function Wz(e, n, t, i) {
  const r = String.fromCharCode(e);
  if (U2.call(hf, r)) {
    const s = hf[r], o = "&" + s;
    return t && Hz.includes(s) && !Vz.includes(s) && (!i || n && n !== 61 && $z.test(String.fromCharCode(n))) ? o : o + ";";
  }
  return "";
}
function zz(e, n, t) {
  let i = Bz(e, n, t.omitOptionalSemicolons), r;
  if ((t.useNamedReferences || t.useShortestReferences) && (r = Wz(
    e,
    n,
    t.omitOptionalSemicolons,
    t.attribute
  )), (t.useShortestReferences || !r) && t.useShortestReferences) {
    const s = Uz(e, n, t.omitOptionalSemicolons);
    s.length < i.length && (i = s);
  }
  return r && (!t.useShortestReferences || r.length < i.length) ? r : i;
}
function js(e, n) {
  return Rz(e, Object.assign({ format: zz }, n));
}
const qz = /^>|^->|<!--|-->|--!>|<!-$/g, Yz = [">"], jz = ["<", ">"];
function Kz(e, n, t, i) {
  return i.settings.bogusComments ? "<?" + js(
    e.value,
    Object.assign({}, i.settings.characterReferences, {
      subset: Yz
    })
  ) + ">" : "<!--" + e.value.replace(qz, r) + "-->";
  function r(s) {
    return js(
      s,
      Object.assign({}, i.settings.characterReferences, {
        subset: jz
      })
    );
  }
}
function Gz(e, n, t, i) {
  return "<!" + (i.settings.upperDoctype ? "DOCTYPE" : "doctype") + (i.settings.tightDoctype ? "" : " ") + "html>";
}
const Bt = V2(1), H2 = V2(-1), Qz = [];
function V2(e) {
  return n;
  function n(t, i, r) {
    const s = t ? t.children : Qz;
    let o = (i || 0) + e, a = s[o];
    if (!r)
      for (; a && bo(a); )
        o += e, a = s[o];
    return a;
  }
}
const Xz = {}.hasOwnProperty;
function $2(e) {
  return n;
  function n(t, i, r) {
    return Xz.call(e, t.tagName) && e[t.tagName](t, i, r);
  }
}
const Vm = $2({
  body: Zz,
  caption: Qd,
  colgroup: Qd,
  dd: iq,
  dt: nq,
  head: Qd,
  html: Jz,
  li: tq,
  optgroup: rq,
  option: sq,
  p: eq,
  rp: x1,
  rt: x1,
  tbody: aq,
  td: v1,
  tfoot: uq,
  th: v1,
  thead: oq,
  tr: lq
});
function Qd(e, n, t) {
  const i = Bt(t, n, !0);
  return !i || i.type !== "comment" && !(i.type === "text" && bo(i.value.charAt(0)));
}
function Jz(e, n, t) {
  const i = Bt(t, n);
  return !i || i.type !== "comment";
}
function Zz(e, n, t) {
  const i = Bt(t, n);
  return !i || i.type !== "comment";
}
function eq(e, n, t) {
  const i = Bt(t, n);
  return i ? i.type === "element" && (i.tagName === "address" || i.tagName === "article" || i.tagName === "aside" || i.tagName === "blockquote" || i.tagName === "details" || i.tagName === "div" || i.tagName === "dl" || i.tagName === "fieldset" || i.tagName === "figcaption" || i.tagName === "figure" || i.tagName === "footer" || i.tagName === "form" || i.tagName === "h1" || i.tagName === "h2" || i.tagName === "h3" || i.tagName === "h4" || i.tagName === "h5" || i.tagName === "h6" || i.tagName === "header" || i.tagName === "hgroup" || i.tagName === "hr" || i.tagName === "main" || i.tagName === "menu" || i.tagName === "nav" || i.tagName === "ol" || i.tagName === "p" || i.tagName === "pre" || i.tagName === "section" || i.tagName === "table" || i.tagName === "ul") : !t || // Confusing parent.
  !(t.type === "element" && (t.tagName === "a" || t.tagName === "audio" || t.tagName === "del" || t.tagName === "ins" || t.tagName === "map" || t.tagName === "noscript" || t.tagName === "video"));
}
function tq(e, n, t) {
  const i = Bt(t, n);
  return !i || i.type === "element" && i.tagName === "li";
}
function nq(e, n, t) {
  const i = Bt(t, n);
  return !!(i && i.type === "element" && (i.tagName === "dt" || i.tagName === "dd"));
}
function iq(e, n, t) {
  const i = Bt(t, n);
  return !i || i.type === "element" && (i.tagName === "dt" || i.tagName === "dd");
}
function x1(e, n, t) {
  const i = Bt(t, n);
  return !i || i.type === "element" && (i.tagName === "rp" || i.tagName === "rt");
}
function rq(e, n, t) {
  const i = Bt(t, n);
  return !i || i.type === "element" && i.tagName === "optgroup";
}
function sq(e, n, t) {
  const i = Bt(t, n);
  return !i || i.type === "element" && (i.tagName === "option" || i.tagName === "optgroup");
}
function oq(e, n, t) {
  const i = Bt(t, n);
  return !!(i && i.type === "element" && (i.tagName === "tbody" || i.tagName === "tfoot"));
}
function aq(e, n, t) {
  const i = Bt(t, n);
  return !i || i.type === "element" && (i.tagName === "tbody" || i.tagName === "tfoot");
}
function uq(e, n, t) {
  return !Bt(t, n);
}
function lq(e, n, t) {
  const i = Bt(t, n);
  return !i || i.type === "element" && i.tagName === "tr";
}
function v1(e, n, t) {
  const i = Bt(t, n);
  return !i || i.type === "element" && (i.tagName === "td" || i.tagName === "th");
}
const cq = $2({
  body: fq,
  colgroup: mq,
  head: hq,
  html: dq,
  tbody: pq
});
function dq(e) {
  const n = Bt(e, -1);
  return !n || n.type !== "comment";
}
function hq(e) {
  const n = /* @__PURE__ */ new Set();
  for (const i of e.children)
    if (i.type === "element" && (i.tagName === "base" || i.tagName === "title")) {
      if (n.has(i.tagName)) return !1;
      n.add(i.tagName);
    }
  const t = e.children[0];
  return !t || t.type === "element";
}
function fq(e) {
  const n = Bt(e, -1, !0);
  return !n || n.type !== "comment" && !(n.type === "text" && bo(n.value.charAt(0))) && !(n.type === "element" && (n.tagName === "meta" || n.tagName === "link" || n.tagName === "script" || n.tagName === "style" || n.tagName === "template"));
}
function mq(e, n, t) {
  const i = H2(t, n), r = Bt(e, -1, !0);
  return t && i && i.type === "element" && i.tagName === "colgroup" && Vm(i, t.children.indexOf(i), t) ? !1 : !!(r && r.type === "element" && r.tagName === "col");
}
function pq(e, n, t) {
  const i = H2(t, n), r = Bt(e, -1);
  return t && i && i.type === "element" && (i.tagName === "thead" || i.tagName === "tbody") && Vm(i, t.children.indexOf(i), t) ? !1 : !!(r && r.type === "element" && r.tagName === "tr");
}
const Yu = {
  // See: <https://html.spec.whatwg.org/#attribute-name-state>.
  name: [
    [`	
\f\r &/=>`.split(""), `	
\f\r "&'/=>\``.split("")],
    [`\0	
\f\r "&'/<=>`.split(""), `\0	
\f\r "&'/<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(unquoted)-state>.
  unquoted: [
    [`	
\f\r &>`.split(""), `\0	
\f\r "&'<=>\``.split("")],
    [`\0	
\f\r "&'<=>\``.split(""), `\0	
\f\r "&'<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state>.
  single: [
    ["&'".split(""), "\"&'`".split("")],
    ["\0&'".split(""), "\0\"&'`".split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state>.
  double: [
    ['"&'.split(""), "\"&'`".split("")],
    ['\0"&'.split(""), "\0\"&'`".split("")]
  ]
};
function gq(e, n, t, i) {
  const r = i.schema, s = r.space === "svg" ? !1 : i.settings.omitOptionalTags;
  let o = r.space === "svg" ? i.settings.closeEmptyElements : i.settings.voids.includes(e.tagName.toLowerCase());
  const a = [];
  let u;
  r.space === "html" && e.tagName === "svg" && (i.schema = vr);
  const l = bq(i, e.properties), c = i.all(
    r.space === "html" && e.tagName === "template" ? e.content : e
  );
  return i.schema = r, c && (o = !1), (l || !s || !cq(e, n, t)) && (a.push("<", e.tagName, l ? " " + l : ""), o && (r.space === "svg" || i.settings.closeSelfClosing) && (u = l.charAt(l.length - 1), (!i.settings.tightSelfClosing || u === "/" || u && u !== '"' && u !== "'") && a.push(" "), a.push("/")), a.push(">")), a.push(c), !o && (!s || !Vm(e, n, t)) && a.push("</" + e.tagName + ">"), a.join("");
}
function bq(e, n) {
  const t = [];
  let i = -1, r;
  if (n) {
    for (r in n)
      if (n[r] !== null && n[r] !== void 0) {
        const s = _q(e, r, n[r]);
        s && t.push(s);
      }
  }
  for (; ++i < t.length; ) {
    const s = e.settings.tightAttributes ? t[i].charAt(t[i].length - 1) : void 0;
    i !== t.length - 1 && s !== '"' && s !== "'" && (t[i] += " ");
  }
  return t.join("");
}
function _q(e, n, t) {
  const i = Tc(e.schema, n), r = e.settings.allowParseErrors && e.schema.space === "html" ? 0 : 1, s = e.settings.allowDangerousCharacters ? 0 : 1;
  let o = e.quote, a;
  if (i.overloadedBoolean && (t === i.attribute || t === "") ? t = !0 : (i.boolean || i.overloadedBoolean) && (typeof t != "string" || t === i.attribute || t === "") && (t = !!t), t == null || t === !1 || typeof t == "number" && Number.isNaN(t))
    return "";
  const u = js(
    i.attribute,
    Object.assign({}, e.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: Yu.name[r][s]
    })
  );
  return t === !0 || (t = Array.isArray(t) ? (i.commaSeparated ? Lm : Dm)(t, {
    padLeft: !e.settings.tightCommaSeparatedLists
  }) : String(t), e.settings.collapseEmptyAttributes && !t) ? u : (e.settings.preferUnquoted && (a = js(
    t,
    Object.assign({}, e.settings.characterReferences, {
      attribute: !0,
      subset: Yu.unquoted[r][s]
    })
  )), a !== t && (e.settings.quoteSmart && vl(t, o) > vl(t, e.alternative) && (o = e.alternative), a = o + js(
    t,
    Object.assign({}, e.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: (o === "'" ? Yu.single : Yu.double)[r][s],
      attribute: !0
    })
  ) + o), u + (a && "=" + a));
}
const Eq = ["<", "&"];
function W2(e, n, t, i) {
  return t && t.type === "element" && (t.tagName === "script" || t.tagName === "style") ? e.value : js(
    e.value,
    Object.assign({}, i.settings.characterReferences, {
      subset: Eq
    })
  );
}
function Tq(e, n, t, i) {
  return i.settings.allowDangerousHtml ? e.value : W2(e, n, t, i);
}
function yq(e, n, t, i) {
  return i.all(e);
}
const wq = mc("type", {
  invalid: Aq,
  unknown: Cq,
  handlers: { comment: Kz, doctype: Gz, element: gq, raw: Tq, root: yq, text: W2 }
});
function Aq(e) {
  throw new Error("Expected node, not `" + e + "`");
}
function Cq(e) {
  const n = (
    /** @type {Nodes} */
    e
  );
  throw new Error("Cannot compile unknown node `" + n.type + "`");
}
const kq = {}, Sq = {}, Iq = [];
function sl(e, n) {
  const t = n || kq, i = t.quote || '"', r = i === '"' ? "'" : '"';
  if (i !== '"' && i !== "'")
    throw new Error("Invalid quote `" + i + "`, expected `'` or `\"`");
  return {
    one: xq,
    all: vq,
    settings: {
      omitOptionalTags: t.omitOptionalTags || !1,
      allowParseErrors: t.allowParseErrors || !1,
      allowDangerousCharacters: t.allowDangerousCharacters || !1,
      quoteSmart: t.quoteSmart || !1,
      preferUnquoted: t.preferUnquoted || !1,
      tightAttributes: t.tightAttributes || !1,
      upperDoctype: t.upperDoctype || !1,
      tightDoctype: t.tightDoctype || !1,
      bogusComments: t.bogusComments || !1,
      tightCommaSeparatedLists: t.tightCommaSeparatedLists || !1,
      tightSelfClosing: t.tightSelfClosing || !1,
      collapseEmptyAttributes: t.collapseEmptyAttributes || !1,
      allowDangerousHtml: t.allowDangerousHtml || !1,
      voids: t.voids || F2,
      characterReferences: t.characterReferences || Sq,
      closeSelfClosing: t.closeSelfClosing || !1,
      closeEmptyElements: t.closeEmptyElements || !1
    },
    schema: t.space === "svg" ? vr : du,
    quote: i,
    alternative: r
  }.one(
    Array.isArray(e) ? { type: "root", children: e } : e,
    void 0,
    void 0
  );
}
function xq(e, n, t) {
  return wq(e, n, t, this);
}
function vq(e) {
  const n = [], t = e && e.children || Iq;
  let i = -1;
  for (; ++i < t.length; )
    n[i] = this.one(t[i], i, e);
  return n.join("");
}
function Pq(e) {
  const n = this, t = { ...n.data("settings"), ...e };
  n.compiler = i;
  function i(r) {
    return sl(r, t);
  }
}
class fu {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, t, i) {
    this.property = n, this.normal = t, i && (this.space = i);
  }
}
fu.prototype.property = {};
fu.prototype.normal = {};
fu.prototype.space = null;
function z2(e, n) {
  const t = {}, i = {};
  let r = -1;
  for (; ++r < e.length; )
    Object.assign(t, e[r].property), Object.assign(i, e[r].normal);
  return new fu(t, i, n);
}
function ff(e) {
  return e.toLowerCase();
}
class Kn {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, t) {
    this.property = n, this.attribute = t;
  }
}
Kn.prototype.space = null;
Kn.prototype.boolean = !1;
Kn.prototype.booleanish = !1;
Kn.prototype.overloadedBoolean = !1;
Kn.prototype.number = !1;
Kn.prototype.commaSeparated = !1;
Kn.prototype.spaceSeparated = !1;
Kn.prototype.commaOrSpaceSeparated = !1;
Kn.prototype.mustUseProperty = !1;
Kn.prototype.defined = !1;
let Oq = 0;
const ke = bs(), vt = bs(), q2 = bs(), J = bs(), it = bs(), Ks = bs(), An = bs();
function bs() {
  return 2 ** ++Oq;
}
const mf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: ke,
  booleanish: vt,
  commaOrSpaceSeparated: An,
  commaSeparated: Ks,
  number: J,
  overloadedBoolean: q2,
  spaceSeparated: it
}, Symbol.toStringTag, { value: "Module" })), Xd = Object.keys(mf);
class $m extends Kn {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, t, i, r) {
    let s = -1;
    if (super(n, t), P1(this, "space", r), typeof i == "number")
      for (; ++s < Xd.length; ) {
        const o = Xd[s];
        P1(this, Xd[s], (i & mf[o]) === mf[o]);
      }
  }
}
$m.prototype.defined = !0;
function P1(e, n, t) {
  t && (e[n] = t);
}
const Nq = {}.hasOwnProperty;
function Eo(e) {
  const n = {}, t = {};
  let i;
  for (i in e.properties)
    if (Nq.call(e.properties, i)) {
      const r = e.properties[i], s = new $m(
        i,
        e.transform(e.attributes || {}, i),
        r,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (s.mustUseProperty = !0), n[i] = s, t[ff(i)] = i, t[ff(s.attribute)] = i;
    }
  return new fu(n, t, e.space);
}
const Y2 = Eo({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), j2 = Eo({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function K2(e, n) {
  return n in e ? e[n] : n;
}
function G2(e, n) {
  return K2(e, n.toLowerCase());
}
const Q2 = Eo({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: G2,
  properties: { xmlns: null, xmlnsXLink: null }
}), X2 = Eo({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: vt,
    ariaAutoComplete: null,
    ariaBusy: vt,
    ariaChecked: vt,
    ariaColCount: J,
    ariaColIndex: J,
    ariaColSpan: J,
    ariaControls: it,
    ariaCurrent: null,
    ariaDescribedBy: it,
    ariaDetails: null,
    ariaDisabled: vt,
    ariaDropEffect: it,
    ariaErrorMessage: null,
    ariaExpanded: vt,
    ariaFlowTo: it,
    ariaGrabbed: vt,
    ariaHasPopup: null,
    ariaHidden: vt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: it,
    ariaLevel: J,
    ariaLive: null,
    ariaModal: vt,
    ariaMultiLine: vt,
    ariaMultiSelectable: vt,
    ariaOrientation: null,
    ariaOwns: it,
    ariaPlaceholder: null,
    ariaPosInSet: J,
    ariaPressed: vt,
    ariaReadOnly: vt,
    ariaRelevant: null,
    ariaRequired: vt,
    ariaRoleDescription: it,
    ariaRowCount: J,
    ariaRowIndex: J,
    ariaRowSpan: J,
    ariaSelected: vt,
    ariaSetSize: J,
    ariaSort: null,
    ariaValueMax: J,
    ariaValueMin: J,
    ariaValueNow: J,
    ariaValueText: null,
    role: null
  }
}), Rq = Eo({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: G2,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Ks,
    acceptCharset: it,
    accessKey: it,
    action: null,
    allow: null,
    allowFullScreen: ke,
    allowPaymentRequest: ke,
    allowUserMedia: ke,
    alt: null,
    as: null,
    async: ke,
    autoCapitalize: null,
    autoComplete: it,
    autoFocus: ke,
    autoPlay: ke,
    blocking: it,
    capture: null,
    charSet: null,
    checked: ke,
    cite: null,
    className: it,
    cols: J,
    colSpan: null,
    content: null,
    contentEditable: vt,
    controls: ke,
    controlsList: it,
    coords: J | Ks,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: ke,
    defer: ke,
    dir: null,
    dirName: null,
    disabled: ke,
    download: q2,
    draggable: vt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: ke,
    formTarget: null,
    headers: it,
    height: J,
    hidden: ke,
    high: J,
    href: null,
    hrefLang: null,
    htmlFor: it,
    httpEquiv: it,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: ke,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: ke,
    itemId: null,
    itemProp: it,
    itemRef: it,
    itemScope: ke,
    itemType: it,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: ke,
    low: J,
    manifest: null,
    max: null,
    maxLength: J,
    media: null,
    method: null,
    min: null,
    minLength: J,
    multiple: ke,
    muted: ke,
    name: null,
    nonce: null,
    noModule: ke,
    noValidate: ke,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: ke,
    optimum: J,
    pattern: null,
    ping: it,
    placeholder: null,
    playsInline: ke,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: ke,
    referrerPolicy: null,
    rel: it,
    required: ke,
    reversed: ke,
    rows: J,
    rowSpan: J,
    sandbox: it,
    scope: null,
    scoped: ke,
    seamless: ke,
    selected: ke,
    shadowRootClonable: ke,
    shadowRootDelegatesFocus: ke,
    shadowRootMode: null,
    shape: null,
    size: J,
    sizes: null,
    slot: null,
    span: J,
    spellCheck: vt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: J,
    step: null,
    style: null,
    tabIndex: J,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: ke,
    useMap: null,
    value: vt,
    width: J,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: it,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: J,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: J,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: ke,
    // Lists. Use CSS to reduce space between items instead
    declare: ke,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: J,
    // `<img>` and `<object>`
    leftMargin: J,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: J,
    // `<body>`
    marginWidth: J,
    // `<body>`
    noResize: ke,
    // `<frame>`
    noHref: ke,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: ke,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: ke,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: J,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: vt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: J,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: J,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: ke,
    disableRemotePlayback: ke,
    prefix: null,
    property: null,
    results: J,
    security: null,
    unselectable: null
  }
}), Lq = Eo({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: K2,
  properties: {
    about: An,
    accentHeight: J,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: J,
    amplitude: J,
    arabicForm: null,
    ascent: J,
    attributeName: null,
    attributeType: null,
    azimuth: J,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: J,
    by: null,
    calcMode: null,
    capHeight: J,
    className: it,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: J,
    diffuseConstant: J,
    direction: null,
    display: null,
    dur: null,
    divisor: J,
    dominantBaseline: null,
    download: ke,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: J,
    enableBackground: null,
    end: null,
    event: null,
    exponent: J,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: J,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Ks,
    g2: Ks,
    glyphName: Ks,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: J,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: J,
    horizOriginX: J,
    horizOriginY: J,
    id: null,
    ideographic: J,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: J,
    k: J,
    k1: J,
    k2: J,
    k3: J,
    k4: J,
    kernelMatrix: An,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: J,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: J,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: J,
    overlineThickness: J,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: J,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: it,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: J,
    pointsAtY: J,
    pointsAtZ: J,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: An,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: An,
    rev: An,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: An,
    requiredFeatures: An,
    requiredFonts: An,
    requiredFormats: An,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: J,
    specularExponent: J,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: J,
    strikethroughThickness: J,
    string: null,
    stroke: null,
    strokeDashArray: An,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: J,
    strokeOpacity: J,
    strokeWidth: null,
    style: null,
    surfaceScale: J,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: An,
    tabIndex: J,
    tableValues: null,
    target: null,
    targetX: J,
    targetY: J,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: An,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: J,
    underlineThickness: J,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: J,
    values: null,
    vAlphabetic: J,
    vMathematical: J,
    vectorEffect: null,
    vHanging: J,
    vIdeographic: J,
    version: null,
    vertAdvY: J,
    vertOriginX: J,
    vertOriginY: J,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: J,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), Dq = /^data[-\w.:]+$/i, O1 = /-[a-z]/g, Mq = /[A-Z]/g;
function Bq(e, n) {
  const t = ff(n);
  let i = n, r = Kn;
  if (t in e.normal)
    return e.property[e.normal[t]];
  if (t.length > 4 && t.slice(0, 4) === "data" && Dq.test(n)) {
    if (n.charAt(4) === "-") {
      const s = n.slice(5).replace(O1, Uq);
      i = "data" + s.charAt(0).toUpperCase() + s.slice(1);
    } else {
      const s = n.slice(4);
      if (!O1.test(s)) {
        let o = s.replace(Mq, Fq);
        o.charAt(0) !== "-" && (o = "-" + o), n = "data" + o;
      }
    }
    r = $m;
  }
  return new r(i, n);
}
function Fq(e) {
  return "-" + e.toLowerCase();
}
function Uq(e) {
  return e.charAt(1).toUpperCase();
}
const Hq = z2([j2, Y2, Q2, X2, Rq], "html"), J2 = z2([j2, Y2, Q2, X2, Lq], "svg"), Vq = {}, $q = {}.hasOwnProperty, Z2 = mc("type", { handlers: { root: zq, element: Gq, text: jq, comment: Kq, doctype: Yq } });
function Wq(e, n) {
  const i = (n || Vq).space;
  return Z2(e, i === "svg" ? J2 : Hq);
}
function zq(e, n) {
  const t = {
    nodeName: "#document",
    // @ts-expect-error: `parse5` uses enums, which are actually strings.
    mode: (e.data || {}).quirksMode ? "quirks" : "no-quirks",
    childNodes: []
  };
  return t.childNodes = Wm(e.children, t, n), To(e, t), t;
}
function qq(e, n) {
  const t = { nodeName: "#document-fragment", childNodes: [] };
  return t.childNodes = Wm(e.children, t, n), To(e, t), t;
}
function Yq(e) {
  const n = {
    nodeName: "#documentType",
    name: "html",
    publicId: "",
    systemId: "",
    parentNode: null
  };
  return To(e, n), n;
}
function jq(e) {
  const n = {
    nodeName: "#text",
    value: e.value,
    parentNode: null
  };
  return To(e, n), n;
}
function Kq(e) {
  const n = {
    nodeName: "#comment",
    data: e.value,
    parentNode: null
  };
  return To(e, n), n;
}
function Gq(e, n) {
  const t = n;
  let i = t;
  e.type === "element" && e.tagName.toLowerCase() === "svg" && t.space === "html" && (i = J2);
  const r = [];
  let s;
  if (e.properties) {
    for (s in e.properties)
      if (s !== "children" && $q.call(e.properties, s)) {
        const u = Qq(
          i,
          s,
          e.properties[s]
        );
        u && r.push(u);
      }
  }
  const o = i.space, a = {
    nodeName: e.tagName,
    tagName: e.tagName,
    attrs: r,
    // @ts-expect-error: `parse5` types are wrong.
    namespaceURI: Gr[o],
    childNodes: [],
    parentNode: null
  };
  return a.childNodes = Wm(e.children, a, i), To(e, a), e.tagName === "template" && e.content && (a.content = qq(e.content, i)), a;
}
function Qq(e, n, t) {
  const i = Bq(e, n);
  if (t === !1 || t === null || t === void 0 || typeof t == "number" && Number.isNaN(t) || !t && i.boolean)
    return;
  Array.isArray(t) && (t = i.commaSeparated ? Lm(t) : Dm(t));
  const r = {
    name: i.attribute,
    value: t === !0 ? "" : String(t)
  };
  if (i.space && i.space !== "html" && i.space !== "svg") {
    const s = r.name.indexOf(":");
    s < 0 ? r.prefix = "" : (r.name = r.name.slice(s + 1), r.prefix = i.attribute.slice(0, s)), r.namespace = Gr[i.space];
  }
  return r;
}
function Wm(e, n, t) {
  let i = -1;
  const r = [];
  if (e)
    for (; ++i < e.length; ) {
      const s = Z2(e[i], t);
      s.parentNode = n, r.push(s);
    }
  return r;
}
function To(e, n) {
  const t = e.position;
  t && t.start && t.end && (t.start.offset, t.end.offset, n.sourceCodeLocation = {
    startLine: t.start.line,
    startCol: t.start.column,
    startOffset: t.start.offset,
    endLine: t.end.line,
    endCol: t.end.column,
    endOffset: t.end.offset
  });
}
const Xq = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]), ct = "�";
var T;
(function(e) {
  e[e.EOF = -1] = "EOF", e[e.NULL = 0] = "NULL", e[e.TABULATION = 9] = "TABULATION", e[e.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", e[e.LINE_FEED = 10] = "LINE_FEED", e[e.FORM_FEED = 12] = "FORM_FEED", e[e.SPACE = 32] = "SPACE", e[e.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", e[e.QUOTATION_MARK = 34] = "QUOTATION_MARK", e[e.AMPERSAND = 38] = "AMPERSAND", e[e.APOSTROPHE = 39] = "APOSTROPHE", e[e.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", e[e.SOLIDUS = 47] = "SOLIDUS", e[e.DIGIT_0 = 48] = "DIGIT_0", e[e.DIGIT_9 = 57] = "DIGIT_9", e[e.SEMICOLON = 59] = "SEMICOLON", e[e.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", e[e.EQUALS_SIGN = 61] = "EQUALS_SIGN", e[e.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", e[e.QUESTION_MARK = 63] = "QUESTION_MARK", e[e.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", e[e.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", e[e.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", e[e.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", e[e.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", e[e.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z";
})(T || (T = {}));
const hn = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function eA(e) {
  return e >= 55296 && e <= 57343;
}
function Jq(e) {
  return e >= 56320 && e <= 57343;
}
function Zq(e, n) {
  return (e - 55296) * 1024 + 9216 + n;
}
function tA(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
}
function nA(e) {
  return e >= 64976 && e <= 65007 || Xq.has(e);
}
var H;
(function(e) {
  e.controlCharacterInInputStream = "control-character-in-input-stream", e.noncharacterInInputStream = "noncharacter-in-input-stream", e.surrogateInInputStream = "surrogate-in-input-stream", e.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", e.endTagWithAttributes = "end-tag-with-attributes", e.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", e.unexpectedSolidusInTag = "unexpected-solidus-in-tag", e.unexpectedNullCharacter = "unexpected-null-character", e.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", e.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", e.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", e.missingEndTagName = "missing-end-tag-name", e.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", e.unknownNamedCharacterReference = "unknown-named-character-reference", e.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", e.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", e.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", e.eofBeforeTagName = "eof-before-tag-name", e.eofInTag = "eof-in-tag", e.missingAttributeValue = "missing-attribute-value", e.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", e.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", e.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", e.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", e.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", e.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", e.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", e.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", e.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", e.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", e.cdataInHtmlContent = "cdata-in-html-content", e.incorrectlyOpenedComment = "incorrectly-opened-comment", e.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", e.eofInDoctype = "eof-in-doctype", e.nestedComment = "nested-comment", e.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", e.eofInComment = "eof-in-comment", e.incorrectlyClosedComment = "incorrectly-closed-comment", e.eofInCdata = "eof-in-cdata", e.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", e.nullCharacterReference = "null-character-reference", e.surrogateCharacterReference = "surrogate-character-reference", e.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", e.controlCharacterReference = "control-character-reference", e.noncharacterCharacterReference = "noncharacter-character-reference", e.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", e.missingDoctypeName = "missing-doctype-name", e.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", e.duplicateAttribute = "duplicate-attribute", e.nonConformingDoctype = "non-conforming-doctype", e.missingDoctype = "missing-doctype", e.misplacedDoctype = "misplaced-doctype", e.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", e.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", e.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", e.openElementsLeftAfterEof = "open-elements-left-after-eof", e.abandonedHeadElementChild = "abandoned-head-element-child", e.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", e.nestedNoscriptInHead = "nested-noscript-in-head", e.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(H || (H = {}));
const eY = 65536;
class tY {
  constructor(n) {
    this.handler = n, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = eY, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(n, t) {
    const { line: i, col: r, offset: s } = this, o = r + t, a = s + t;
    return {
      code: n,
      startLine: i,
      endLine: i,
      startCol: o,
      endCol: o,
      startOffset: a,
      endOffset: a
    };
  }
  _err(n) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(n, 0)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(n) {
    if (this.pos !== this.html.length - 1) {
      const t = this.html.charCodeAt(this.pos + 1);
      if (Jq(t))
        return this.pos++, this._addGap(), Zq(n, t);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, T.EOF;
    return this._err(H.surrogateInInputStream), n;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(n, t) {
    this.html.length > 0 ? this.html += n : this.html = n, this.endOfChunkHit = !1, this.lastChunkWritten = t;
  }
  insertHtmlAtCurrentPos(n) {
    this.html = this.html.substring(0, this.pos + 1) + n + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(n, t) {
    if (this.pos + n.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (t)
      return this.html.startsWith(n, this.pos);
    for (let i = 0; i < n.length; i++)
      if ((this.html.charCodeAt(this.pos + i) | 32) !== n.charCodeAt(i))
        return !1;
    return !0;
  }
  peek(n) {
    const t = this.pos + n;
    if (t >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, T.EOF;
    const i = this.html.charCodeAt(t);
    return i === T.CARRIAGE_RETURN ? T.LINE_FEED : i;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, T.EOF;
    let n = this.html.charCodeAt(this.pos);
    return n === T.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, T.LINE_FEED) : n === T.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, eA(n) && (n = this._processSurrogate(n)), this.handler.onParseError === null || n > 31 && n < 127 || n === T.LINE_FEED || n === T.CARRIAGE_RETURN || n > 159 && n < 64976 || this._checkForProblematicCharacters(n), n);
  }
  _checkForProblematicCharacters(n) {
    tA(n) ? this._err(H.controlCharacterInInputStream) : nA(n) && this._err(H.noncharacterInInputStream);
  }
  retreat(n) {
    for (this.pos -= n; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
var Le;
(function(e) {
  e[e.CHARACTER = 0] = "CHARACTER", e[e.NULL_CHARACTER = 1] = "NULL_CHARACTER", e[e.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", e[e.START_TAG = 3] = "START_TAG", e[e.END_TAG = 4] = "END_TAG", e[e.COMMENT = 5] = "COMMENT", e[e.DOCTYPE = 6] = "DOCTYPE", e[e.EOF = 7] = "EOF", e[e.HIBERNATION = 8] = "HIBERNATION";
})(Le || (Le = {}));
function iA(e, n) {
  for (let t = e.attrs.length - 1; t >= 0; t--)
    if (e.attrs[t].name === n)
      return e.attrs[t].value;
  return null;
}
const nY = /* @__PURE__ */ new Uint16Array(
  // prettier-ignore
  /* @__PURE__ */ 'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), iY = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]);
function rY(e) {
  var n;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (n = iY.get(e)) !== null && n !== void 0 ? n : e;
}
var $t;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})($t || ($t = {}));
const sY = 32;
var mr;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(mr || (mr = {}));
function pf(e) {
  return e >= $t.ZERO && e <= $t.NINE;
}
function oY(e) {
  return e >= $t.UPPER_A && e <= $t.UPPER_F || e >= $t.LOWER_A && e <= $t.LOWER_F;
}
function aY(e) {
  return e >= $t.UPPER_A && e <= $t.UPPER_Z || e >= $t.LOWER_A && e <= $t.LOWER_Z || pf(e);
}
function uY(e) {
  return e === $t.EQUALS || aY(e);
}
var Ut;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(Ut || (Ut = {}));
var Fi;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(Fi || (Fi = {}));
class lY {
  constructor(n, t, i) {
    this.decodeTree = n, this.emitCodePoint = t, this.errors = i, this.state = Ut.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = Fi.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(n) {
    this.decodeMode = n, this.state = Ut.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(n, t) {
    switch (this.state) {
      case Ut.EntityStart:
        return n.charCodeAt(t) === $t.NUM ? (this.state = Ut.NumericStart, this.consumed += 1, this.stateNumericStart(n, t + 1)) : (this.state = Ut.NamedEntity, this.stateNamedEntity(n, t));
      case Ut.NumericStart:
        return this.stateNumericStart(n, t);
      case Ut.NumericDecimal:
        return this.stateNumericDecimal(n, t);
      case Ut.NumericHex:
        return this.stateNumericHex(n, t);
      case Ut.NamedEntity:
        return this.stateNamedEntity(n, t);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(n, t) {
    return t >= n.length ? -1 : (n.charCodeAt(t) | sY) === $t.LOWER_X ? (this.state = Ut.NumericHex, this.consumed += 1, this.stateNumericHex(n, t + 1)) : (this.state = Ut.NumericDecimal, this.stateNumericDecimal(n, t));
  }
  addToNumericResult(n, t, i, r) {
    if (t !== i) {
      const s = i - t;
      this.result = this.result * Math.pow(r, s) + Number.parseInt(n.substr(t, s), r), this.consumed += s;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(n, t) {
    const i = t;
    for (; t < n.length; ) {
      const r = n.charCodeAt(t);
      if (pf(r) || oY(r))
        t += 1;
      else
        return this.addToNumericResult(n, i, t, 16), this.emitNumericEntity(r, 3);
    }
    return this.addToNumericResult(n, i, t, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(n, t) {
    const i = t;
    for (; t < n.length; ) {
      const r = n.charCodeAt(t);
      if (pf(r))
        t += 1;
      else
        return this.addToNumericResult(n, i, t, 10), this.emitNumericEntity(r, 2);
    }
    return this.addToNumericResult(n, i, t, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(n, t) {
    var i;
    if (this.consumed <= t)
      return (i = this.errors) === null || i === void 0 || i.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (n === $t.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === Fi.Strict)
      return 0;
    return this.emitCodePoint(rY(this.result), this.consumed), this.errors && (n !== $t.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(n, t) {
    const { decodeTree: i } = this;
    let r = i[this.treeIndex], s = (r & mr.VALUE_LENGTH) >> 14;
    for (; t < n.length; t++, this.excess++) {
      const o = n.charCodeAt(t);
      if (this.treeIndex = cY(i, r, this.treeIndex + Math.max(1, s), o), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === Fi.Attribute && // We shouldn't have consumed any characters after the entity,
        (s === 0 || // And there should be no invalid characters.
        uY(o)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (r = i[this.treeIndex], s = (r & mr.VALUE_LENGTH) >> 14, s !== 0) {
        if (o === $t.SEMI)
          return this.emitNamedEntityData(this.treeIndex, s, this.consumed + this.excess);
        this.decodeMode !== Fi.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var n;
    const { result: t, decodeTree: i } = this, r = (i[t] & mr.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(t, r, this.consumed), (n = this.errors) === null || n === void 0 || n.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(n, t, i) {
    const { decodeTree: r } = this;
    return this.emitCodePoint(t === 1 ? r[n] & ~mr.VALUE_LENGTH : r[n + 1], i), t === 3 && this.emitCodePoint(r[n + 2], i), i;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var n;
    switch (this.state) {
      case Ut.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== Fi.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case Ut.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case Ut.NumericHex:
        return this.emitNumericEntity(0, 3);
      case Ut.NumericStart:
        return (n = this.errors) === null || n === void 0 || n.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case Ut.EntityStart:
        return 0;
    }
  }
}
function cY(e, n, t, i) {
  const r = (n & mr.BRANCH_LENGTH) >> 7, s = n & mr.JUMP_TABLE;
  if (r === 0)
    return s !== 0 && i === s ? t : -1;
  if (s) {
    const u = i - s;
    return u < 0 || u >= r ? -1 : e[t + u] - 1;
  }
  let o = t, a = o + r - 1;
  for (; o <= a; ) {
    const u = o + a >>> 1, l = e[u];
    if (l < i)
      o = u + 1;
    else if (l > i)
      a = u - 1;
    else
      return e[u + r];
  }
  return -1;
}
var Y;
(function(e) {
  e.HTML = "http://www.w3.org/1999/xhtml", e.MATHML = "http://www.w3.org/1998/Math/MathML", e.SVG = "http://www.w3.org/2000/svg", e.XLINK = "http://www.w3.org/1999/xlink", e.XML = "http://www.w3.org/XML/1998/namespace", e.XMLNS = "http://www.w3.org/2000/xmlns/";
})(Y || (Y = {}));
var es;
(function(e) {
  e.TYPE = "type", e.ACTION = "action", e.ENCODING = "encoding", e.PROMPT = "prompt", e.NAME = "name", e.COLOR = "color", e.FACE = "face", e.SIZE = "size";
})(es || (es = {}));
var Vn;
(function(e) {
  e.NO_QUIRKS = "no-quirks", e.QUIRKS = "quirks", e.LIMITED_QUIRKS = "limited-quirks";
})(Vn || (Vn = {}));
var L;
(function(e) {
  e.A = "a", e.ADDRESS = "address", e.ANNOTATION_XML = "annotation-xml", e.APPLET = "applet", e.AREA = "area", e.ARTICLE = "article", e.ASIDE = "aside", e.B = "b", e.BASE = "base", e.BASEFONT = "basefont", e.BGSOUND = "bgsound", e.BIG = "big", e.BLOCKQUOTE = "blockquote", e.BODY = "body", e.BR = "br", e.BUTTON = "button", e.CAPTION = "caption", e.CENTER = "center", e.CODE = "code", e.COL = "col", e.COLGROUP = "colgroup", e.DD = "dd", e.DESC = "desc", e.DETAILS = "details", e.DIALOG = "dialog", e.DIR = "dir", e.DIV = "div", e.DL = "dl", e.DT = "dt", e.EM = "em", e.EMBED = "embed", e.FIELDSET = "fieldset", e.FIGCAPTION = "figcaption", e.FIGURE = "figure", e.FONT = "font", e.FOOTER = "footer", e.FOREIGN_OBJECT = "foreignObject", e.FORM = "form", e.FRAME = "frame", e.FRAMESET = "frameset", e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e.HEAD = "head", e.HEADER = "header", e.HGROUP = "hgroup", e.HR = "hr", e.HTML = "html", e.I = "i", e.IMG = "img", e.IMAGE = "image", e.INPUT = "input", e.IFRAME = "iframe", e.KEYGEN = "keygen", e.LABEL = "label", e.LI = "li", e.LINK = "link", e.LISTING = "listing", e.MAIN = "main", e.MALIGNMARK = "malignmark", e.MARQUEE = "marquee", e.MATH = "math", e.MENU = "menu", e.META = "meta", e.MGLYPH = "mglyph", e.MI = "mi", e.MO = "mo", e.MN = "mn", e.MS = "ms", e.MTEXT = "mtext", e.NAV = "nav", e.NOBR = "nobr", e.NOFRAMES = "noframes", e.NOEMBED = "noembed", e.NOSCRIPT = "noscript", e.OBJECT = "object", e.OL = "ol", e.OPTGROUP = "optgroup", e.OPTION = "option", e.P = "p", e.PARAM = "param", e.PLAINTEXT = "plaintext", e.PRE = "pre", e.RB = "rb", e.RP = "rp", e.RT = "rt", e.RTC = "rtc", e.RUBY = "ruby", e.S = "s", e.SCRIPT = "script", e.SEARCH = "search", e.SECTION = "section", e.SELECT = "select", e.SOURCE = "source", e.SMALL = "small", e.SPAN = "span", e.STRIKE = "strike", e.STRONG = "strong", e.STYLE = "style", e.SUB = "sub", e.SUMMARY = "summary", e.SUP = "sup", e.TABLE = "table", e.TBODY = "tbody", e.TEMPLATE = "template", e.TEXTAREA = "textarea", e.TFOOT = "tfoot", e.TD = "td", e.TH = "th", e.THEAD = "thead", e.TITLE = "title", e.TR = "tr", e.TRACK = "track", e.TT = "tt", e.U = "u", e.UL = "ul", e.SVG = "svg", e.VAR = "var", e.WBR = "wbr", e.XMP = "xmp";
})(L || (L = {}));
var f;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.A = 1] = "A", e[e.ADDRESS = 2] = "ADDRESS", e[e.ANNOTATION_XML = 3] = "ANNOTATION_XML", e[e.APPLET = 4] = "APPLET", e[e.AREA = 5] = "AREA", e[e.ARTICLE = 6] = "ARTICLE", e[e.ASIDE = 7] = "ASIDE", e[e.B = 8] = "B", e[e.BASE = 9] = "BASE", e[e.BASEFONT = 10] = "BASEFONT", e[e.BGSOUND = 11] = "BGSOUND", e[e.BIG = 12] = "BIG", e[e.BLOCKQUOTE = 13] = "BLOCKQUOTE", e[e.BODY = 14] = "BODY", e[e.BR = 15] = "BR", e[e.BUTTON = 16] = "BUTTON", e[e.CAPTION = 17] = "CAPTION", e[e.CENTER = 18] = "CENTER", e[e.CODE = 19] = "CODE", e[e.COL = 20] = "COL", e[e.COLGROUP = 21] = "COLGROUP", e[e.DD = 22] = "DD", e[e.DESC = 23] = "DESC", e[e.DETAILS = 24] = "DETAILS", e[e.DIALOG = 25] = "DIALOG", e[e.DIR = 26] = "DIR", e[e.DIV = 27] = "DIV", e[e.DL = 28] = "DL", e[e.DT = 29] = "DT", e[e.EM = 30] = "EM", e[e.EMBED = 31] = "EMBED", e[e.FIELDSET = 32] = "FIELDSET", e[e.FIGCAPTION = 33] = "FIGCAPTION", e[e.FIGURE = 34] = "FIGURE", e[e.FONT = 35] = "FONT", e[e.FOOTER = 36] = "FOOTER", e[e.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", e[e.FORM = 38] = "FORM", e[e.FRAME = 39] = "FRAME", e[e.FRAMESET = 40] = "FRAMESET", e[e.H1 = 41] = "H1", e[e.H2 = 42] = "H2", e[e.H3 = 43] = "H3", e[e.H4 = 44] = "H4", e[e.H5 = 45] = "H5", e[e.H6 = 46] = "H6", e[e.HEAD = 47] = "HEAD", e[e.HEADER = 48] = "HEADER", e[e.HGROUP = 49] = "HGROUP", e[e.HR = 50] = "HR", e[e.HTML = 51] = "HTML", e[e.I = 52] = "I", e[e.IMG = 53] = "IMG", e[e.IMAGE = 54] = "IMAGE", e[e.INPUT = 55] = "INPUT", e[e.IFRAME = 56] = "IFRAME", e[e.KEYGEN = 57] = "KEYGEN", e[e.LABEL = 58] = "LABEL", e[e.LI = 59] = "LI", e[e.LINK = 60] = "LINK", e[e.LISTING = 61] = "LISTING", e[e.MAIN = 62] = "MAIN", e[e.MALIGNMARK = 63] = "MALIGNMARK", e[e.MARQUEE = 64] = "MARQUEE", e[e.MATH = 65] = "MATH", e[e.MENU = 66] = "MENU", e[e.META = 67] = "META", e[e.MGLYPH = 68] = "MGLYPH", e[e.MI = 69] = "MI", e[e.MO = 70] = "MO", e[e.MN = 71] = "MN", e[e.MS = 72] = "MS", e[e.MTEXT = 73] = "MTEXT", e[e.NAV = 74] = "NAV", e[e.NOBR = 75] = "NOBR", e[e.NOFRAMES = 76] = "NOFRAMES", e[e.NOEMBED = 77] = "NOEMBED", e[e.NOSCRIPT = 78] = "NOSCRIPT", e[e.OBJECT = 79] = "OBJECT", e[e.OL = 80] = "OL", e[e.OPTGROUP = 81] = "OPTGROUP", e[e.OPTION = 82] = "OPTION", e[e.P = 83] = "P", e[e.PARAM = 84] = "PARAM", e[e.PLAINTEXT = 85] = "PLAINTEXT", e[e.PRE = 86] = "PRE", e[e.RB = 87] = "RB", e[e.RP = 88] = "RP", e[e.RT = 89] = "RT", e[e.RTC = 90] = "RTC", e[e.RUBY = 91] = "RUBY", e[e.S = 92] = "S", e[e.SCRIPT = 93] = "SCRIPT", e[e.SEARCH = 94] = "SEARCH", e[e.SECTION = 95] = "SECTION", e[e.SELECT = 96] = "SELECT", e[e.SOURCE = 97] = "SOURCE", e[e.SMALL = 98] = "SMALL", e[e.SPAN = 99] = "SPAN", e[e.STRIKE = 100] = "STRIKE", e[e.STRONG = 101] = "STRONG", e[e.STYLE = 102] = "STYLE", e[e.SUB = 103] = "SUB", e[e.SUMMARY = 104] = "SUMMARY", e[e.SUP = 105] = "SUP", e[e.TABLE = 106] = "TABLE", e[e.TBODY = 107] = "TBODY", e[e.TEMPLATE = 108] = "TEMPLATE", e[e.TEXTAREA = 109] = "TEXTAREA", e[e.TFOOT = 110] = "TFOOT", e[e.TD = 111] = "TD", e[e.TH = 112] = "TH", e[e.THEAD = 113] = "THEAD", e[e.TITLE = 114] = "TITLE", e[e.TR = 115] = "TR", e[e.TRACK = 116] = "TRACK", e[e.TT = 117] = "TT", e[e.U = 118] = "U", e[e.UL = 119] = "UL", e[e.SVG = 120] = "SVG", e[e.VAR = 121] = "VAR", e[e.WBR = 122] = "WBR", e[e.XMP = 123] = "XMP";
})(f || (f = {}));
const dY = /* @__PURE__ */ new Map([
  [L.A, f.A],
  [L.ADDRESS, f.ADDRESS],
  [L.ANNOTATION_XML, f.ANNOTATION_XML],
  [L.APPLET, f.APPLET],
  [L.AREA, f.AREA],
  [L.ARTICLE, f.ARTICLE],
  [L.ASIDE, f.ASIDE],
  [L.B, f.B],
  [L.BASE, f.BASE],
  [L.BASEFONT, f.BASEFONT],
  [L.BGSOUND, f.BGSOUND],
  [L.BIG, f.BIG],
  [L.BLOCKQUOTE, f.BLOCKQUOTE],
  [L.BODY, f.BODY],
  [L.BR, f.BR],
  [L.BUTTON, f.BUTTON],
  [L.CAPTION, f.CAPTION],
  [L.CENTER, f.CENTER],
  [L.CODE, f.CODE],
  [L.COL, f.COL],
  [L.COLGROUP, f.COLGROUP],
  [L.DD, f.DD],
  [L.DESC, f.DESC],
  [L.DETAILS, f.DETAILS],
  [L.DIALOG, f.DIALOG],
  [L.DIR, f.DIR],
  [L.DIV, f.DIV],
  [L.DL, f.DL],
  [L.DT, f.DT],
  [L.EM, f.EM],
  [L.EMBED, f.EMBED],
  [L.FIELDSET, f.FIELDSET],
  [L.FIGCAPTION, f.FIGCAPTION],
  [L.FIGURE, f.FIGURE],
  [L.FONT, f.FONT],
  [L.FOOTER, f.FOOTER],
  [L.FOREIGN_OBJECT, f.FOREIGN_OBJECT],
  [L.FORM, f.FORM],
  [L.FRAME, f.FRAME],
  [L.FRAMESET, f.FRAMESET],
  [L.H1, f.H1],
  [L.H2, f.H2],
  [L.H3, f.H3],
  [L.H4, f.H4],
  [L.H5, f.H5],
  [L.H6, f.H6],
  [L.HEAD, f.HEAD],
  [L.HEADER, f.HEADER],
  [L.HGROUP, f.HGROUP],
  [L.HR, f.HR],
  [L.HTML, f.HTML],
  [L.I, f.I],
  [L.IMG, f.IMG],
  [L.IMAGE, f.IMAGE],
  [L.INPUT, f.INPUT],
  [L.IFRAME, f.IFRAME],
  [L.KEYGEN, f.KEYGEN],
  [L.LABEL, f.LABEL],
  [L.LI, f.LI],
  [L.LINK, f.LINK],
  [L.LISTING, f.LISTING],
  [L.MAIN, f.MAIN],
  [L.MALIGNMARK, f.MALIGNMARK],
  [L.MARQUEE, f.MARQUEE],
  [L.MATH, f.MATH],
  [L.MENU, f.MENU],
  [L.META, f.META],
  [L.MGLYPH, f.MGLYPH],
  [L.MI, f.MI],
  [L.MO, f.MO],
  [L.MN, f.MN],
  [L.MS, f.MS],
  [L.MTEXT, f.MTEXT],
  [L.NAV, f.NAV],
  [L.NOBR, f.NOBR],
  [L.NOFRAMES, f.NOFRAMES],
  [L.NOEMBED, f.NOEMBED],
  [L.NOSCRIPT, f.NOSCRIPT],
  [L.OBJECT, f.OBJECT],
  [L.OL, f.OL],
  [L.OPTGROUP, f.OPTGROUP],
  [L.OPTION, f.OPTION],
  [L.P, f.P],
  [L.PARAM, f.PARAM],
  [L.PLAINTEXT, f.PLAINTEXT],
  [L.PRE, f.PRE],
  [L.RB, f.RB],
  [L.RP, f.RP],
  [L.RT, f.RT],
  [L.RTC, f.RTC],
  [L.RUBY, f.RUBY],
  [L.S, f.S],
  [L.SCRIPT, f.SCRIPT],
  [L.SEARCH, f.SEARCH],
  [L.SECTION, f.SECTION],
  [L.SELECT, f.SELECT],
  [L.SOURCE, f.SOURCE],
  [L.SMALL, f.SMALL],
  [L.SPAN, f.SPAN],
  [L.STRIKE, f.STRIKE],
  [L.STRONG, f.STRONG],
  [L.STYLE, f.STYLE],
  [L.SUB, f.SUB],
  [L.SUMMARY, f.SUMMARY],
  [L.SUP, f.SUP],
  [L.TABLE, f.TABLE],
  [L.TBODY, f.TBODY],
  [L.TEMPLATE, f.TEMPLATE],
  [L.TEXTAREA, f.TEXTAREA],
  [L.TFOOT, f.TFOOT],
  [L.TD, f.TD],
  [L.TH, f.TH],
  [L.THEAD, f.THEAD],
  [L.TITLE, f.TITLE],
  [L.TR, f.TR],
  [L.TRACK, f.TRACK],
  [L.TT, f.TT],
  [L.U, f.U],
  [L.UL, f.UL],
  [L.SVG, f.SVG],
  [L.VAR, f.VAR],
  [L.WBR, f.WBR],
  [L.XMP, f.XMP]
]);
function yo(e) {
  var n;
  return (n = dY.get(e)) !== null && n !== void 0 ? n : f.UNKNOWN;
}
const G = f, hY = {
  [Y.HTML]: /* @__PURE__ */ new Set([
    G.ADDRESS,
    G.APPLET,
    G.AREA,
    G.ARTICLE,
    G.ASIDE,
    G.BASE,
    G.BASEFONT,
    G.BGSOUND,
    G.BLOCKQUOTE,
    G.BODY,
    G.BR,
    G.BUTTON,
    G.CAPTION,
    G.CENTER,
    G.COL,
    G.COLGROUP,
    G.DD,
    G.DETAILS,
    G.DIR,
    G.DIV,
    G.DL,
    G.DT,
    G.EMBED,
    G.FIELDSET,
    G.FIGCAPTION,
    G.FIGURE,
    G.FOOTER,
    G.FORM,
    G.FRAME,
    G.FRAMESET,
    G.H1,
    G.H2,
    G.H3,
    G.H4,
    G.H5,
    G.H6,
    G.HEAD,
    G.HEADER,
    G.HGROUP,
    G.HR,
    G.HTML,
    G.IFRAME,
    G.IMG,
    G.INPUT,
    G.LI,
    G.LINK,
    G.LISTING,
    G.MAIN,
    G.MARQUEE,
    G.MENU,
    G.META,
    G.NAV,
    G.NOEMBED,
    G.NOFRAMES,
    G.NOSCRIPT,
    G.OBJECT,
    G.OL,
    G.P,
    G.PARAM,
    G.PLAINTEXT,
    G.PRE,
    G.SCRIPT,
    G.SECTION,
    G.SELECT,
    G.SOURCE,
    G.STYLE,
    G.SUMMARY,
    G.TABLE,
    G.TBODY,
    G.TD,
    G.TEMPLATE,
    G.TEXTAREA,
    G.TFOOT,
    G.TH,
    G.THEAD,
    G.TITLE,
    G.TR,
    G.TRACK,
    G.UL,
    G.WBR,
    G.XMP
  ]),
  [Y.MATHML]: /* @__PURE__ */ new Set([G.MI, G.MO, G.MN, G.MS, G.MTEXT, G.ANNOTATION_XML]),
  [Y.SVG]: /* @__PURE__ */ new Set([G.TITLE, G.FOREIGN_OBJECT, G.DESC]),
  [Y.XLINK]: /* @__PURE__ */ new Set(),
  [Y.XML]: /* @__PURE__ */ new Set(),
  [Y.XMLNS]: /* @__PURE__ */ new Set()
}, gf = /* @__PURE__ */ new Set([G.H1, G.H2, G.H3, G.H4, G.H5, G.H6]);
L.STYLE, L.SCRIPT, L.XMP, L.IFRAME, L.NOEMBED, L.NOFRAMES, L.PLAINTEXT;
var A;
(function(e) {
  e[e.DATA = 0] = "DATA", e[e.RCDATA = 1] = "RCDATA", e[e.RAWTEXT = 2] = "RAWTEXT", e[e.SCRIPT_DATA = 3] = "SCRIPT_DATA", e[e.PLAINTEXT = 4] = "PLAINTEXT", e[e.TAG_OPEN = 5] = "TAG_OPEN", e[e.END_TAG_OPEN = 6] = "END_TAG_OPEN", e[e.TAG_NAME = 7] = "TAG_NAME", e[e.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", e[e.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", e[e.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", e[e.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", e[e.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", e[e.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", e[e.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", e[e.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", e[e.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", e[e.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", e[e.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", e[e.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", e[e.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", e[e.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", e[e.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", e[e.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", e[e.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", e[e.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", e[e.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", e[e.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", e[e.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", e[e.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", e[e.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", e[e.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", e[e.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", e[e.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", e[e.COMMENT_START = 42] = "COMMENT_START", e[e.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", e[e.COMMENT = 44] = "COMMENT", e[e.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", e[e.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", e[e.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", e[e.COMMENT_END = 50] = "COMMENT_END", e[e.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", e[e.DOCTYPE = 52] = "DOCTYPE", e[e.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", e[e.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", e[e.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", e[e.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", e[e.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", e[e.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", e[e.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", e[e.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", e[e.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", e[e.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", e[e.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", e[e.CDATA_SECTION = 68] = "CDATA_SECTION", e[e.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", e[e.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", e[e.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", e[e.AMBIGUOUS_AMPERSAND = 72] = "AMBIGUOUS_AMPERSAND";
})(A || (A = {}));
const wt = {
  DATA: A.DATA,
  RCDATA: A.RCDATA,
  RAWTEXT: A.RAWTEXT,
  SCRIPT_DATA: A.SCRIPT_DATA,
  PLAINTEXT: A.PLAINTEXT,
  CDATA_SECTION: A.CDATA_SECTION
};
function fY(e) {
  return e >= T.DIGIT_0 && e <= T.DIGIT_9;
}
function ea(e) {
  return e >= T.LATIN_CAPITAL_A && e <= T.LATIN_CAPITAL_Z;
}
function mY(e) {
  return e >= T.LATIN_SMALL_A && e <= T.LATIN_SMALL_Z;
}
function lr(e) {
  return mY(e) || ea(e);
}
function N1(e) {
  return lr(e) || fY(e);
}
function ju(e) {
  return e + 32;
}
function rA(e) {
  return e === T.SPACE || e === T.LINE_FEED || e === T.TABULATION || e === T.FORM_FEED;
}
function R1(e) {
  return rA(e) || e === T.SOLIDUS || e === T.GREATER_THAN_SIGN;
}
function pY(e) {
  return e === T.NULL ? H.nullCharacterReference : e > 1114111 ? H.characterReferenceOutsideUnicodeRange : eA(e) ? H.surrogateCharacterReference : nA(e) ? H.noncharacterCharacterReference : tA(e) || e === T.CARRIAGE_RETURN ? H.controlCharacterReference : null;
}
class gY {
  constructor(n, t) {
    this.options = n, this.handler = t, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = A.DATA, this.returnState = A.DATA, this.entityStartPos = 0, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new tY(t), this.currentLocation = this.getCurrentLocation(-1), this.entityDecoder = new lY(nY, (i, r) => {
      this.preprocessor.pos = this.entityStartPos + r - 1, this._flushCodePointConsumedAsCharacterReference(i);
    }, t.onParseError ? {
      missingSemicolonAfterCharacterReference: () => {
        this._err(H.missingSemicolonAfterCharacterReference, 1);
      },
      absenceOfDigitsInNumericCharacterReference: (i) => {
        this._err(H.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + i);
      },
      validateNumericCharacterReference: (i) => {
        const r = pY(i);
        r && this._err(r, 1);
      }
    } : void 0);
  }
  //Errors
  _err(n, t = 0) {
    var i, r;
    (r = (i = this.handler).onParseError) === null || r === void 0 || r.call(i, this.preprocessor.getError(n, t));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(n) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - n,
      startOffset: this.preprocessor.offset - n,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const n = this._consume();
        this._ensureHibernation() || this._callState(n);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(n) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || n == null || n());
  }
  write(n, t, i) {
    this.active = !0, this.preprocessor.write(n, t), this._runParsingLoop(), this.paused || i == null || i();
  }
  insertHtmlAtCurrentPos(n) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(n), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this.preprocessor.retreat(this.consumedAfterSnapshot), this.consumedAfterSnapshot = 0, this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _advanceBy(n) {
    this.consumedAfterSnapshot += n;
    for (let t = 0; t < n; t++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(n, t) {
    return this.preprocessor.startsWith(n, t) ? (this._advanceBy(n.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: Le.START_TAG,
      tagName: "",
      tagID: f.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: Le.END_TAG,
      tagName: "",
      tagID: f.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(n) {
    this.currentToken = {
      type: Le.COMMENT,
      data: "",
      location: this.getCurrentLocation(n)
    };
  }
  _createDoctypeToken(n) {
    this.currentToken = {
      type: Le.DOCTYPE,
      name: n,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(n, t) {
    this.currentCharacterToken = {
      type: n,
      chars: t,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(n) {
    this.currentAttr = {
      name: n,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var n, t;
    const i = this.currentToken;
    if (iA(i, this.currentAttr.name) === null) {
      if (i.attrs.push(this.currentAttr), i.location && this.currentLocation) {
        const r = (n = (t = i.location).attrs) !== null && n !== void 0 ? n : t.attrs = /* @__PURE__ */ Object.create(null);
        r[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(H.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(n) {
    this._emitCurrentCharacterToken(n.location), this.currentToken = null, n.location && (n.location.endLine = this.preprocessor.line, n.location.endCol = this.preprocessor.col + 1, n.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const n = this.currentToken;
    this.prepareToken(n), n.tagID = yo(n.tagName), n.type === Le.START_TAG ? (this.lastStartTagName = n.tagName, this.handler.onStartTag(n)) : (n.attrs.length > 0 && this._err(H.endTagWithAttributes), n.selfClosing && this._err(H.endTagWithTrailingSolidus), this.handler.onEndTag(n)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(n) {
    this.prepareToken(n), this.handler.onComment(n), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(n) {
    this.prepareToken(n), this.handler.onDoctype(n), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(n) {
    if (this.currentCharacterToken) {
      switch (n && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = n.startLine, this.currentCharacterToken.location.endCol = n.startCol, this.currentCharacterToken.location.endOffset = n.startOffset), this.currentCharacterToken.type) {
        case Le.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case Le.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case Le.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const n = this.getCurrentLocation(0);
    n && (n.endLine = n.startLine, n.endCol = n.startCol, n.endOffset = n.startOffset), this._emitCurrentCharacterToken(n), this.handler.onEof({ type: Le.EOF, location: n }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: The specification uses only one type of character token (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(n, t) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type === n) {
        this.currentCharacterToken.chars += t;
        return;
      } else
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
    this._createCharacterToken(n, t);
  }
  _emitCodePoint(n) {
    const t = rA(n) ? Le.WHITESPACE_CHARACTER : n === T.NULL ? Le.NULL_CHARACTER : Le.CHARACTER;
    this._appendCharToCurrentCharacterToken(t, String.fromCodePoint(n));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(n) {
    this._appendCharToCurrentCharacterToken(Le.CHARACTER, n);
  }
  // Character reference helpers
  _startCharacterReference() {
    this.returnState = this.state, this.state = A.CHARACTER_REFERENCE, this.entityStartPos = this.preprocessor.pos, this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? Fi.Attribute : Fi.Legacy);
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === A.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === A.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === A.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(n) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(n) : this._emitCodePoint(n);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(n) {
    switch (this.state) {
      case A.DATA: {
        this._stateData(n);
        break;
      }
      case A.RCDATA: {
        this._stateRcdata(n);
        break;
      }
      case A.RAWTEXT: {
        this._stateRawtext(n);
        break;
      }
      case A.SCRIPT_DATA: {
        this._stateScriptData(n);
        break;
      }
      case A.PLAINTEXT: {
        this._statePlaintext(n);
        break;
      }
      case A.TAG_OPEN: {
        this._stateTagOpen(n);
        break;
      }
      case A.END_TAG_OPEN: {
        this._stateEndTagOpen(n);
        break;
      }
      case A.TAG_NAME: {
        this._stateTagName(n);
        break;
      }
      case A.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(n);
        break;
      }
      case A.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(n);
        break;
      }
      case A.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(n);
        break;
      }
      case A.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(n);
        break;
      }
      case A.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(n);
        break;
      }
      case A.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(n);
        break;
      }
      case A.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(n);
        break;
      }
      case A.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(n);
        break;
      }
      case A.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(n);
        break;
      }
      case A.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(n);
        break;
      }
      case A.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(n);
        break;
      }
      case A.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(n);
        break;
      }
      case A.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(n);
        break;
      }
      case A.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(n);
        break;
      }
      case A.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(n);
        break;
      }
      case A.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(n);
        break;
      }
      case A.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(n);
        break;
      }
      case A.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(n);
        break;
      }
      case A.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(n);
        break;
      }
      case A.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(n);
        break;
      }
      case A.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(n);
        break;
      }
      case A.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(n);
        break;
      }
      case A.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(n);
        break;
      }
      case A.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(n);
        break;
      }
      case A.ATTRIBUTE_NAME: {
        this._stateAttributeName(n);
        break;
      }
      case A.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(n);
        break;
      }
      case A.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(n);
        break;
      }
      case A.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(n);
        break;
      }
      case A.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(n);
        break;
      }
      case A.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(n);
        break;
      }
      case A.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(n);
        break;
      }
      case A.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(n);
        break;
      }
      case A.BOGUS_COMMENT: {
        this._stateBogusComment(n);
        break;
      }
      case A.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(n);
        break;
      }
      case A.COMMENT_START: {
        this._stateCommentStart(n);
        break;
      }
      case A.COMMENT_START_DASH: {
        this._stateCommentStartDash(n);
        break;
      }
      case A.COMMENT: {
        this._stateComment(n);
        break;
      }
      case A.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(n);
        break;
      }
      case A.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(n);
        break;
      }
      case A.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(n);
        break;
      }
      case A.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(n);
        break;
      }
      case A.COMMENT_END_DASH: {
        this._stateCommentEndDash(n);
        break;
      }
      case A.COMMENT_END: {
        this._stateCommentEnd(n);
        break;
      }
      case A.COMMENT_END_BANG: {
        this._stateCommentEndBang(n);
        break;
      }
      case A.DOCTYPE: {
        this._stateDoctype(n);
        break;
      }
      case A.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(n);
        break;
      }
      case A.DOCTYPE_NAME: {
        this._stateDoctypeName(n);
        break;
      }
      case A.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(n);
        break;
      }
      case A.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(n);
        break;
      }
      case A.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(n);
        break;
      }
      case A.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(n);
        break;
      }
      case A.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(n);
        break;
      }
      case A.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(n);
        break;
      }
      case A.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(n);
        break;
      }
      case A.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(n);
        break;
      }
      case A.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(n);
        break;
      }
      case A.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(n);
        break;
      }
      case A.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(n);
        break;
      }
      case A.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(n);
        break;
      }
      case A.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(n);
        break;
      }
      case A.CDATA_SECTION: {
        this._stateCdataSection(n);
        break;
      }
      case A.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(n);
        break;
      }
      case A.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(n);
        break;
      }
      case A.CHARACTER_REFERENCE: {
        this._stateCharacterReference();
        break;
      }
      case A.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(n);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(n) {
    switch (n) {
      case T.LESS_THAN_SIGN: {
        this.state = A.TAG_OPEN;
        break;
      }
      case T.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), this._emitCodePoint(n);
        break;
      }
      case T.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(n);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(n) {
    switch (n) {
      case T.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case T.LESS_THAN_SIGN: {
        this.state = A.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), this._emitChars(ct);
        break;
      }
      case T.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(n);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(n) {
    switch (n) {
      case T.LESS_THAN_SIGN: {
        this.state = A.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), this._emitChars(ct);
        break;
      }
      case T.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(n);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(n) {
    switch (n) {
      case T.LESS_THAN_SIGN: {
        this.state = A.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), this._emitChars(ct);
        break;
      }
      case T.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(n);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(n) {
    switch (n) {
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), this._emitChars(ct);
        break;
      }
      case T.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(n);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(n) {
    if (lr(n))
      this._createStartTagToken(), this.state = A.TAG_NAME, this._stateTagName(n);
    else
      switch (n) {
        case T.EXCLAMATION_MARK: {
          this.state = A.MARKUP_DECLARATION_OPEN;
          break;
        }
        case T.SOLIDUS: {
          this.state = A.END_TAG_OPEN;
          break;
        }
        case T.QUESTION_MARK: {
          this._err(H.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = A.BOGUS_COMMENT, this._stateBogusComment(n);
          break;
        }
        case T.EOF: {
          this._err(H.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(H.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = A.DATA, this._stateData(n);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(n) {
    if (lr(n))
      this._createEndTagToken(), this.state = A.TAG_NAME, this._stateTagName(n);
    else
      switch (n) {
        case T.GREATER_THAN_SIGN: {
          this._err(H.missingEndTagName), this.state = A.DATA;
          break;
        }
        case T.EOF: {
          this._err(H.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(H.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = A.BOGUS_COMMENT, this._stateBogusComment(n);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(n) {
    const t = this.currentToken;
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED: {
        this.state = A.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case T.SOLIDUS: {
        this.state = A.SELF_CLOSING_START_TAG;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this.state = A.DATA, this.emitCurrentTagToken();
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), t.tagName += ct;
        break;
      }
      case T.EOF: {
        this._err(H.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        t.tagName += String.fromCodePoint(ea(n) ? ju(n) : n);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(n) {
    n === T.SOLIDUS ? this.state = A.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = A.RCDATA, this._stateRcdata(n));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(n) {
    lr(n) ? (this.state = A.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(n)) : (this._emitChars("</"), this.state = A.RCDATA, this._stateRcdata(n));
  }
  handleSpecialEndTag(n) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const t = this.currentToken;
    switch (t.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = A.BEFORE_ATTRIBUTE_NAME, !1;
      case T.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = A.SELF_CLOSING_START_TAG, !1;
      case T.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = A.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(n) {
    this.handleSpecialEndTag(n) && (this._emitChars("</"), this.state = A.RCDATA, this._stateRcdata(n));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(n) {
    n === T.SOLIDUS ? this.state = A.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = A.RAWTEXT, this._stateRawtext(n));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(n) {
    lr(n) ? (this.state = A.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(n)) : (this._emitChars("</"), this.state = A.RAWTEXT, this._stateRawtext(n));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(n) {
    this.handleSpecialEndTag(n) && (this._emitChars("</"), this.state = A.RAWTEXT, this._stateRawtext(n));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(n) {
    switch (n) {
      case T.SOLIDUS: {
        this.state = A.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case T.EXCLAMATION_MARK: {
        this.state = A.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = A.SCRIPT_DATA, this._stateScriptData(n);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(n) {
    lr(n) ? (this.state = A.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(n)) : (this._emitChars("</"), this.state = A.SCRIPT_DATA, this._stateScriptData(n));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(n) {
    this.handleSpecialEndTag(n) && (this._emitChars("</"), this.state = A.SCRIPT_DATA, this._stateScriptData(n));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(n) {
    n === T.HYPHEN_MINUS ? (this.state = A.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = A.SCRIPT_DATA, this._stateScriptData(n));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(n) {
    n === T.HYPHEN_MINUS ? (this.state = A.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = A.SCRIPT_DATA, this._stateScriptData(n));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(n) {
    switch (n) {
      case T.HYPHEN_MINUS: {
        this.state = A.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case T.LESS_THAN_SIGN: {
        this.state = A.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), this._emitChars(ct);
        break;
      }
      case T.EOF: {
        this._err(H.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(n);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(n) {
    switch (n) {
      case T.HYPHEN_MINUS: {
        this.state = A.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case T.LESS_THAN_SIGN: {
        this.state = A.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), this.state = A.SCRIPT_DATA_ESCAPED, this._emitChars(ct);
        break;
      }
      case T.EOF: {
        this._err(H.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = A.SCRIPT_DATA_ESCAPED, this._emitCodePoint(n);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(n) {
    switch (n) {
      case T.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case T.LESS_THAN_SIGN: {
        this.state = A.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this.state = A.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), this.state = A.SCRIPT_DATA_ESCAPED, this._emitChars(ct);
        break;
      }
      case T.EOF: {
        this._err(H.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = A.SCRIPT_DATA_ESCAPED, this._emitCodePoint(n);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(n) {
    n === T.SOLIDUS ? this.state = A.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : lr(n) ? (this._emitChars("<"), this.state = A.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(n)) : (this._emitChars("<"), this.state = A.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(n));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(n) {
    lr(n) ? (this.state = A.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(n)) : (this._emitChars("</"), this.state = A.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(n));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(n) {
    this.handleSpecialEndTag(n) && (this._emitChars("</"), this.state = A.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(n));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(n) {
    if (this.preprocessor.startsWith(hn.SCRIPT, !1) && R1(this.preprocessor.peek(hn.SCRIPT.length))) {
      this._emitCodePoint(n);
      for (let t = 0; t < hn.SCRIPT.length; t++)
        this._emitCodePoint(this._consume());
      this.state = A.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else this._ensureHibernation() || (this.state = A.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(n));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(n) {
    switch (n) {
      case T.HYPHEN_MINUS: {
        this.state = A.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case T.LESS_THAN_SIGN: {
        this.state = A.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), this._emitChars(ct);
        break;
      }
      case T.EOF: {
        this._err(H.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(n);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(n) {
    switch (n) {
      case T.HYPHEN_MINUS: {
        this.state = A.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case T.LESS_THAN_SIGN: {
        this.state = A.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), this.state = A.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(ct);
        break;
      }
      case T.EOF: {
        this._err(H.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = A.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(n);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(n) {
    switch (n) {
      case T.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case T.LESS_THAN_SIGN: {
        this.state = A.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this.state = A.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), this.state = A.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(ct);
        break;
      }
      case T.EOF: {
        this._err(H.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = A.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(n);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(n) {
    n === T.SOLIDUS ? (this.state = A.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = A.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(n));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(n) {
    if (this.preprocessor.startsWith(hn.SCRIPT, !1) && R1(this.preprocessor.peek(hn.SCRIPT.length))) {
      this._emitCodePoint(n);
      for (let t = 0; t < hn.SCRIPT.length; t++)
        this._emitCodePoint(this._consume());
      this.state = A.SCRIPT_DATA_ESCAPED;
    } else this._ensureHibernation() || (this.state = A.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(n));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(n) {
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        break;
      case T.SOLIDUS:
      case T.GREATER_THAN_SIGN:
      case T.EOF: {
        this.state = A.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(n);
        break;
      }
      case T.EQUALS_SIGN: {
        this._err(H.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = A.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = A.ATTRIBUTE_NAME, this._stateAttributeName(n);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(n) {
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
      case T.SOLIDUS:
      case T.GREATER_THAN_SIGN:
      case T.EOF: {
        this._leaveAttrName(), this.state = A.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(n);
        break;
      }
      case T.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = A.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case T.QUOTATION_MARK:
      case T.APOSTROPHE:
      case T.LESS_THAN_SIGN: {
        this._err(H.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(n);
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), this.currentAttr.name += ct;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(ea(n) ? ju(n) : n);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(n) {
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        break;
      case T.SOLIDUS: {
        this.state = A.SELF_CLOSING_START_TAG;
        break;
      }
      case T.EQUALS_SIGN: {
        this.state = A.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this.state = A.DATA, this.emitCurrentTagToken();
        break;
      }
      case T.EOF: {
        this._err(H.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = A.ATTRIBUTE_NAME, this._stateAttributeName(n);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(n) {
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        break;
      case T.QUOTATION_MARK: {
        this.state = A.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case T.APOSTROPHE: {
        this.state = A.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(H.missingAttributeValue), this.state = A.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = A.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(n);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(n) {
    switch (n) {
      case T.QUOTATION_MARK: {
        this.state = A.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case T.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), this.currentAttr.value += ct;
        break;
      }
      case T.EOF: {
        this._err(H.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(n);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(n) {
    switch (n) {
      case T.APOSTROPHE: {
        this.state = A.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case T.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), this.currentAttr.value += ct;
        break;
      }
      case T.EOF: {
        this._err(H.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(n);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(n) {
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED: {
        this._leaveAttrValue(), this.state = A.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case T.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = A.DATA, this.emitCurrentTagToken();
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), this.currentAttr.value += ct;
        break;
      }
      case T.QUOTATION_MARK:
      case T.APOSTROPHE:
      case T.LESS_THAN_SIGN:
      case T.EQUALS_SIGN:
      case T.GRAVE_ACCENT: {
        this._err(H.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(n);
        break;
      }
      case T.EOF: {
        this._err(H.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(n);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(n) {
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED: {
        this._leaveAttrValue(), this.state = A.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case T.SOLIDUS: {
        this._leaveAttrValue(), this.state = A.SELF_CLOSING_START_TAG;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = A.DATA, this.emitCurrentTagToken();
        break;
      }
      case T.EOF: {
        this._err(H.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(H.missingWhitespaceBetweenAttributes), this.state = A.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(n);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(n) {
    switch (n) {
      case T.GREATER_THAN_SIGN: {
        const t = this.currentToken;
        t.selfClosing = !0, this.state = A.DATA, this.emitCurrentTagToken();
        break;
      }
      case T.EOF: {
        this._err(H.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(H.unexpectedSolidusInTag), this.state = A.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(n);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(n) {
    const t = this.currentToken;
    switch (n) {
      case T.GREATER_THAN_SIGN: {
        this.state = A.DATA, this.emitCurrentComment(t);
        break;
      }
      case T.EOF: {
        this.emitCurrentComment(t), this._emitEOFToken();
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), t.data += ct;
        break;
      }
      default:
        t.data += String.fromCodePoint(n);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(n) {
    this._consumeSequenceIfMatch(hn.DASH_DASH, !0) ? (this._createCommentToken(hn.DASH_DASH.length + 1), this.state = A.COMMENT_START) : this._consumeSequenceIfMatch(hn.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(hn.DOCTYPE.length + 1), this.state = A.DOCTYPE) : this._consumeSequenceIfMatch(hn.CDATA_START, !0) ? this.inForeignNode ? this.state = A.CDATA_SECTION : (this._err(H.cdataInHtmlContent), this._createCommentToken(hn.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = A.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(H.incorrectlyOpenedComment), this._createCommentToken(2), this.state = A.BOGUS_COMMENT, this._stateBogusComment(n));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(n) {
    switch (n) {
      case T.HYPHEN_MINUS: {
        this.state = A.COMMENT_START_DASH;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(H.abruptClosingOfEmptyComment), this.state = A.DATA;
        const t = this.currentToken;
        this.emitCurrentComment(t);
        break;
      }
      default:
        this.state = A.COMMENT, this._stateComment(n);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(n) {
    const t = this.currentToken;
    switch (n) {
      case T.HYPHEN_MINUS: {
        this.state = A.COMMENT_END;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(H.abruptClosingOfEmptyComment), this.state = A.DATA, this.emitCurrentComment(t);
        break;
      }
      case T.EOF: {
        this._err(H.eofInComment), this.emitCurrentComment(t), this._emitEOFToken();
        break;
      }
      default:
        t.data += "-", this.state = A.COMMENT, this._stateComment(n);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(n) {
    const t = this.currentToken;
    switch (n) {
      case T.HYPHEN_MINUS: {
        this.state = A.COMMENT_END_DASH;
        break;
      }
      case T.LESS_THAN_SIGN: {
        t.data += "<", this.state = A.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), t.data += ct;
        break;
      }
      case T.EOF: {
        this._err(H.eofInComment), this.emitCurrentComment(t), this._emitEOFToken();
        break;
      }
      default:
        t.data += String.fromCodePoint(n);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(n) {
    const t = this.currentToken;
    switch (n) {
      case T.EXCLAMATION_MARK: {
        t.data += "!", this.state = A.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case T.LESS_THAN_SIGN: {
        t.data += "<";
        break;
      }
      default:
        this.state = A.COMMENT, this._stateComment(n);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(n) {
    n === T.HYPHEN_MINUS ? this.state = A.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = A.COMMENT, this._stateComment(n));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(n) {
    n === T.HYPHEN_MINUS ? this.state = A.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = A.COMMENT_END_DASH, this._stateCommentEndDash(n));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(n) {
    n !== T.GREATER_THAN_SIGN && n !== T.EOF && this._err(H.nestedComment), this.state = A.COMMENT_END, this._stateCommentEnd(n);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(n) {
    const t = this.currentToken;
    switch (n) {
      case T.HYPHEN_MINUS: {
        this.state = A.COMMENT_END;
        break;
      }
      case T.EOF: {
        this._err(H.eofInComment), this.emitCurrentComment(t), this._emitEOFToken();
        break;
      }
      default:
        t.data += "-", this.state = A.COMMENT, this._stateComment(n);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(n) {
    const t = this.currentToken;
    switch (n) {
      case T.GREATER_THAN_SIGN: {
        this.state = A.DATA, this.emitCurrentComment(t);
        break;
      }
      case T.EXCLAMATION_MARK: {
        this.state = A.COMMENT_END_BANG;
        break;
      }
      case T.HYPHEN_MINUS: {
        t.data += "-";
        break;
      }
      case T.EOF: {
        this._err(H.eofInComment), this.emitCurrentComment(t), this._emitEOFToken();
        break;
      }
      default:
        t.data += "--", this.state = A.COMMENT, this._stateComment(n);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(n) {
    const t = this.currentToken;
    switch (n) {
      case T.HYPHEN_MINUS: {
        t.data += "--!", this.state = A.COMMENT_END_DASH;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(H.incorrectlyClosedComment), this.state = A.DATA, this.emitCurrentComment(t);
        break;
      }
      case T.EOF: {
        this._err(H.eofInComment), this.emitCurrentComment(t), this._emitEOFToken();
        break;
      }
      default:
        t.data += "--!", this.state = A.COMMENT, this._stateComment(n);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(n) {
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED: {
        this.state = A.BEFORE_DOCTYPE_NAME;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this.state = A.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(n);
        break;
      }
      case T.EOF: {
        this._err(H.eofInDoctype), this._createDoctypeToken(null);
        const t = this.currentToken;
        t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._err(H.missingWhitespaceBeforeDoctypeName), this.state = A.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(n);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(n) {
    if (ea(n))
      this._createDoctypeToken(String.fromCharCode(ju(n))), this.state = A.DOCTYPE_NAME;
    else
      switch (n) {
        case T.SPACE:
        case T.LINE_FEED:
        case T.TABULATION:
        case T.FORM_FEED:
          break;
        case T.NULL: {
          this._err(H.unexpectedNullCharacter), this._createDoctypeToken(ct), this.state = A.DOCTYPE_NAME;
          break;
        }
        case T.GREATER_THAN_SIGN: {
          this._err(H.missingDoctypeName), this._createDoctypeToken(null);
          const t = this.currentToken;
          t.forceQuirks = !0, this.emitCurrentDoctype(t), this.state = A.DATA;
          break;
        }
        case T.EOF: {
          this._err(H.eofInDoctype), this._createDoctypeToken(null);
          const t = this.currentToken;
          t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(n)), this.state = A.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(n) {
    const t = this.currentToken;
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED: {
        this.state = A.AFTER_DOCTYPE_NAME;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this.state = A.DATA, this.emitCurrentDoctype(t);
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), t.name += ct;
        break;
      }
      case T.EOF: {
        this._err(H.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        t.name += String.fromCodePoint(ea(n) ? ju(n) : n);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(n) {
    const t = this.currentToken;
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        break;
      case T.GREATER_THAN_SIGN: {
        this.state = A.DATA, this.emitCurrentDoctype(t);
        break;
      }
      case T.EOF: {
        this._err(H.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(hn.PUBLIC, !1) ? this.state = A.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(hn.SYSTEM, !1) ? this.state = A.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(H.invalidCharacterSequenceAfterDoctypeName), t.forceQuirks = !0, this.state = A.BOGUS_DOCTYPE, this._stateBogusDoctype(n));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(n) {
    const t = this.currentToken;
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED: {
        this.state = A.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case T.QUOTATION_MARK: {
        this._err(H.missingWhitespaceAfterDoctypePublicKeyword), t.publicId = "", this.state = A.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case T.APOSTROPHE: {
        this._err(H.missingWhitespaceAfterDoctypePublicKeyword), t.publicId = "", this.state = A.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(H.missingDoctypePublicIdentifier), t.forceQuirks = !0, this.state = A.DATA, this.emitCurrentDoctype(t);
        break;
      }
      case T.EOF: {
        this._err(H.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._err(H.missingQuoteBeforeDoctypePublicIdentifier), t.forceQuirks = !0, this.state = A.BOGUS_DOCTYPE, this._stateBogusDoctype(n);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(n) {
    const t = this.currentToken;
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        break;
      case T.QUOTATION_MARK: {
        t.publicId = "", this.state = A.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case T.APOSTROPHE: {
        t.publicId = "", this.state = A.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(H.missingDoctypePublicIdentifier), t.forceQuirks = !0, this.state = A.DATA, this.emitCurrentDoctype(t);
        break;
      }
      case T.EOF: {
        this._err(H.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._err(H.missingQuoteBeforeDoctypePublicIdentifier), t.forceQuirks = !0, this.state = A.BOGUS_DOCTYPE, this._stateBogusDoctype(n);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(n) {
    const t = this.currentToken;
    switch (n) {
      case T.QUOTATION_MARK: {
        this.state = A.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), t.publicId += ct;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(H.abruptDoctypePublicIdentifier), t.forceQuirks = !0, this.emitCurrentDoctype(t), this.state = A.DATA;
        break;
      }
      case T.EOF: {
        this._err(H.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        t.publicId += String.fromCodePoint(n);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(n) {
    const t = this.currentToken;
    switch (n) {
      case T.APOSTROPHE: {
        this.state = A.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), t.publicId += ct;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(H.abruptDoctypePublicIdentifier), t.forceQuirks = !0, this.emitCurrentDoctype(t), this.state = A.DATA;
        break;
      }
      case T.EOF: {
        this._err(H.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        t.publicId += String.fromCodePoint(n);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(n) {
    const t = this.currentToken;
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED: {
        this.state = A.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this.state = A.DATA, this.emitCurrentDoctype(t);
        break;
      }
      case T.QUOTATION_MARK: {
        this._err(H.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), t.systemId = "", this.state = A.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case T.APOSTROPHE: {
        this._err(H.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), t.systemId = "", this.state = A.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case T.EOF: {
        this._err(H.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._err(H.missingQuoteBeforeDoctypeSystemIdentifier), t.forceQuirks = !0, this.state = A.BOGUS_DOCTYPE, this._stateBogusDoctype(n);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(n) {
    const t = this.currentToken;
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        break;
      case T.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(t), this.state = A.DATA;
        break;
      }
      case T.QUOTATION_MARK: {
        t.systemId = "", this.state = A.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case T.APOSTROPHE: {
        t.systemId = "", this.state = A.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case T.EOF: {
        this._err(H.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._err(H.missingQuoteBeforeDoctypeSystemIdentifier), t.forceQuirks = !0, this.state = A.BOGUS_DOCTYPE, this._stateBogusDoctype(n);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(n) {
    const t = this.currentToken;
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED: {
        this.state = A.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case T.QUOTATION_MARK: {
        this._err(H.missingWhitespaceAfterDoctypeSystemKeyword), t.systemId = "", this.state = A.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case T.APOSTROPHE: {
        this._err(H.missingWhitespaceAfterDoctypeSystemKeyword), t.systemId = "", this.state = A.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(H.missingDoctypeSystemIdentifier), t.forceQuirks = !0, this.state = A.DATA, this.emitCurrentDoctype(t);
        break;
      }
      case T.EOF: {
        this._err(H.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._err(H.missingQuoteBeforeDoctypeSystemIdentifier), t.forceQuirks = !0, this.state = A.BOGUS_DOCTYPE, this._stateBogusDoctype(n);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(n) {
    const t = this.currentToken;
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        break;
      case T.QUOTATION_MARK: {
        t.systemId = "", this.state = A.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case T.APOSTROPHE: {
        t.systemId = "", this.state = A.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(H.missingDoctypeSystemIdentifier), t.forceQuirks = !0, this.state = A.DATA, this.emitCurrentDoctype(t);
        break;
      }
      case T.EOF: {
        this._err(H.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._err(H.missingQuoteBeforeDoctypeSystemIdentifier), t.forceQuirks = !0, this.state = A.BOGUS_DOCTYPE, this._stateBogusDoctype(n);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(n) {
    const t = this.currentToken;
    switch (n) {
      case T.QUOTATION_MARK: {
        this.state = A.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), t.systemId += ct;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(H.abruptDoctypeSystemIdentifier), t.forceQuirks = !0, this.emitCurrentDoctype(t), this.state = A.DATA;
        break;
      }
      case T.EOF: {
        this._err(H.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        t.systemId += String.fromCodePoint(n);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(n) {
    const t = this.currentToken;
    switch (n) {
      case T.APOSTROPHE: {
        this.state = A.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter), t.systemId += ct;
        break;
      }
      case T.GREATER_THAN_SIGN: {
        this._err(H.abruptDoctypeSystemIdentifier), t.forceQuirks = !0, this.emitCurrentDoctype(t), this.state = A.DATA;
        break;
      }
      case T.EOF: {
        this._err(H.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        t.systemId += String.fromCodePoint(n);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(n) {
    const t = this.currentToken;
    switch (n) {
      case T.SPACE:
      case T.LINE_FEED:
      case T.TABULATION:
      case T.FORM_FEED:
        break;
      case T.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(t), this.state = A.DATA;
        break;
      }
      case T.EOF: {
        this._err(H.eofInDoctype), t.forceQuirks = !0, this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
      default:
        this._err(H.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = A.BOGUS_DOCTYPE, this._stateBogusDoctype(n);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(n) {
    const t = this.currentToken;
    switch (n) {
      case T.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(t), this.state = A.DATA;
        break;
      }
      case T.NULL: {
        this._err(H.unexpectedNullCharacter);
        break;
      }
      case T.EOF: {
        this.emitCurrentDoctype(t), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(n) {
    switch (n) {
      case T.RIGHT_SQUARE_BRACKET: {
        this.state = A.CDATA_SECTION_BRACKET;
        break;
      }
      case T.EOF: {
        this._err(H.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(n);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(n) {
    n === T.RIGHT_SQUARE_BRACKET ? this.state = A.CDATA_SECTION_END : (this._emitChars("]"), this.state = A.CDATA_SECTION, this._stateCdataSection(n));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(n) {
    switch (n) {
      case T.GREATER_THAN_SIGN: {
        this.state = A.DATA;
        break;
      }
      case T.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = A.CDATA_SECTION, this._stateCdataSection(n);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference() {
    let n = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
    if (n < 0)
      if (this.preprocessor.lastChunkWritten)
        n = this.entityDecoder.end();
      else {
        this.active = !1, this.preprocessor.pos = this.preprocessor.html.length - 1, this.consumedAfterSnapshot = 0, this.preprocessor.endOfChunkHit = !0;
        return;
      }
    n === 0 ? (this.preprocessor.pos = this.entityStartPos, this._flushCodePointConsumedAsCharacterReference(T.AMPERSAND), this.state = !this._isCharacterReferenceInAttribute() && N1(this.preprocessor.peek(1)) ? A.AMBIGUOUS_AMPERSAND : this.returnState) : this.state = this.returnState;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(n) {
    N1(n) ? this._flushCodePointConsumedAsCharacterReference(n) : (n === T.SEMICOLON && this._err(H.unknownNamedCharacterReference), this.state = this.returnState, this._callState(n));
  }
}
const sA = /* @__PURE__ */ new Set([f.DD, f.DT, f.LI, f.OPTGROUP, f.OPTION, f.P, f.RB, f.RP, f.RT, f.RTC]), L1 = /* @__PURE__ */ new Set([
  ...sA,
  f.CAPTION,
  f.COLGROUP,
  f.TBODY,
  f.TD,
  f.TFOOT,
  f.TH,
  f.THEAD,
  f.TR
]), Fl = /* @__PURE__ */ new Set([
  f.APPLET,
  f.CAPTION,
  f.HTML,
  f.MARQUEE,
  f.OBJECT,
  f.TABLE,
  f.TD,
  f.TEMPLATE,
  f.TH
]), bY = /* @__PURE__ */ new Set([...Fl, f.OL, f.UL]), _Y = /* @__PURE__ */ new Set([...Fl, f.BUTTON]), D1 = /* @__PURE__ */ new Set([f.ANNOTATION_XML, f.MI, f.MN, f.MO, f.MS, f.MTEXT]), M1 = /* @__PURE__ */ new Set([f.DESC, f.FOREIGN_OBJECT, f.TITLE]), EY = /* @__PURE__ */ new Set([f.TR, f.TEMPLATE, f.HTML]), TY = /* @__PURE__ */ new Set([f.TBODY, f.TFOOT, f.THEAD, f.TEMPLATE, f.HTML]), yY = /* @__PURE__ */ new Set([f.TABLE, f.TEMPLATE, f.HTML]), wY = /* @__PURE__ */ new Set([f.TD, f.TH]);
class AY {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(n, t, i) {
    this.treeAdapter = t, this.handler = i, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = f.UNKNOWN, this.current = n;
  }
  //Index of element
  _indexOf(n) {
    return this.items.lastIndexOf(n, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === f.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === Y.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(n, t) {
    this.stackTop++, this.items[this.stackTop] = n, this.current = n, this.tagIDs[this.stackTop] = t, this.currentTagId = t, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(n, t, !0);
  }
  pop() {
    const n = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(n, !0);
  }
  replace(n, t) {
    const i = this._indexOf(n);
    this.items[i] = t, i === this.stackTop && (this.current = t);
  }
  insertAfter(n, t, i) {
    const r = this._indexOf(n) + 1;
    this.items.splice(r, 0, t), this.tagIDs.splice(r, 0, i), this.stackTop++, r === this.stackTop && this._updateCurrentElement(), this.current && this.currentTagId !== void 0 && this.handler.onItemPush(this.current, this.currentTagId, r === this.stackTop);
  }
  popUntilTagNamePopped(n) {
    let t = this.stackTop + 1;
    do
      t = this.tagIDs.lastIndexOf(n, t - 1);
    while (t > 0 && this.treeAdapter.getNamespaceURI(this.items[t]) !== Y.HTML);
    this.shortenToLength(Math.max(t, 0));
  }
  shortenToLength(n) {
    for (; this.stackTop >= n; ) {
      const t = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, this.stackTop < n);
    }
  }
  popUntilElementPopped(n) {
    const t = this._indexOf(n);
    this.shortenToLength(Math.max(t, 0));
  }
  popUntilPopped(n, t) {
    const i = this._indexOfTagNames(n, t);
    this.shortenToLength(Math.max(i, 0));
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(gf, Y.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(wY, Y.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(n, t) {
    for (let i = this.stackTop; i >= 0; i--)
      if (n.has(this.tagIDs[i]) && this.treeAdapter.getNamespaceURI(this.items[i]) === t)
        return i;
    return -1;
  }
  clearBackTo(n, t) {
    const i = this._indexOfTagNames(n, t);
    this.shortenToLength(i + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(yY, Y.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(TY, Y.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(EY, Y.HTML);
  }
  remove(n) {
    const t = this._indexOf(n);
    t >= 0 && (t === this.stackTop ? this.pop() : (this.items.splice(t, 1), this.tagIDs.splice(t, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(n, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === f.BODY ? this.items[1] : null;
  }
  contains(n) {
    return this._indexOf(n) > -1;
  }
  getCommonAncestor(n) {
    const t = this._indexOf(n) - 1;
    return t >= 0 ? this.items[t] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === f.HTML;
  }
  //Element in scope
  hasInDynamicScope(n, t) {
    for (let i = this.stackTop; i >= 0; i--) {
      const r = this.tagIDs[i];
      switch (this.treeAdapter.getNamespaceURI(this.items[i])) {
        case Y.HTML: {
          if (r === n)
            return !0;
          if (t.has(r))
            return !1;
          break;
        }
        case Y.SVG: {
          if (M1.has(r))
            return !1;
          break;
        }
        case Y.MATHML: {
          if (D1.has(r))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInScope(n) {
    return this.hasInDynamicScope(n, Fl);
  }
  hasInListItemScope(n) {
    return this.hasInDynamicScope(n, bY);
  }
  hasInButtonScope(n) {
    return this.hasInDynamicScope(n, _Y);
  }
  hasNumberedHeaderInScope() {
    for (let n = this.stackTop; n >= 0; n--) {
      const t = this.tagIDs[n];
      switch (this.treeAdapter.getNamespaceURI(this.items[n])) {
        case Y.HTML: {
          if (gf.has(t))
            return !0;
          if (Fl.has(t))
            return !1;
          break;
        }
        case Y.SVG: {
          if (M1.has(t))
            return !1;
          break;
        }
        case Y.MATHML: {
          if (D1.has(t))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInTableScope(n) {
    for (let t = this.stackTop; t >= 0; t--)
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === Y.HTML)
        switch (this.tagIDs[t]) {
          case n:
            return !0;
          case f.TABLE:
          case f.HTML:
            return !1;
        }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === Y.HTML)
        switch (this.tagIDs[n]) {
          case f.TBODY:
          case f.THEAD:
          case f.TFOOT:
            return !0;
          case f.TABLE:
          case f.HTML:
            return !1;
        }
    return !0;
  }
  hasInSelectScope(n) {
    for (let t = this.stackTop; t >= 0; t--)
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === Y.HTML)
        switch (this.tagIDs[t]) {
          case n:
            return !0;
          case f.OPTION:
          case f.OPTGROUP:
            break;
          default:
            return !1;
        }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; this.currentTagId !== void 0 && sA.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; this.currentTagId !== void 0 && L1.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(n) {
    for (; this.currentTagId !== void 0 && this.currentTagId !== n && L1.has(this.currentTagId); )
      this.pop();
  }
}
const Jd = 3;
var Ei;
(function(e) {
  e[e.Marker = 0] = "Marker", e[e.Element = 1] = "Element";
})(Ei || (Ei = {}));
const B1 = { type: Ei.Marker };
class CY {
  constructor(n) {
    this.treeAdapter = n, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(n, t) {
    const i = [], r = t.length, s = this.treeAdapter.getTagName(n), o = this.treeAdapter.getNamespaceURI(n);
    for (let a = 0; a < this.entries.length; a++) {
      const u = this.entries[a];
      if (u.type === Ei.Marker)
        break;
      const { element: l } = u;
      if (this.treeAdapter.getTagName(l) === s && this.treeAdapter.getNamespaceURI(l) === o) {
        const c = this.treeAdapter.getAttrList(l);
        c.length === r && i.push({ idx: a, attrs: c });
      }
    }
    return i;
  }
  _ensureNoahArkCondition(n) {
    if (this.entries.length < Jd)
      return;
    const t = this.treeAdapter.getAttrList(n), i = this._getNoahArkConditionCandidates(n, t);
    if (i.length < Jd)
      return;
    const r = new Map(t.map((o) => [o.name, o.value]));
    let s = 0;
    for (let o = 0; o < i.length; o++) {
      const a = i[o];
      a.attrs.every((u) => r.get(u.name) === u.value) && (s += 1, s >= Jd && this.entries.splice(a.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(B1);
  }
  pushElement(n, t) {
    this._ensureNoahArkCondition(n), this.entries.unshift({
      type: Ei.Element,
      element: n,
      token: t
    });
  }
  insertElementAfterBookmark(n, t) {
    const i = this.entries.indexOf(this.bookmark);
    this.entries.splice(i, 0, {
      type: Ei.Element,
      element: n,
      token: t
    });
  }
  removeEntry(n) {
    const t = this.entries.indexOf(n);
    t !== -1 && this.entries.splice(t, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const n = this.entries.indexOf(B1);
    n === -1 ? this.entries.length = 0 : this.entries.splice(0, n + 1);
  }
  //Search
  getElementEntryInScopeWithTagName(n) {
    const t = this.entries.find((i) => i.type === Ei.Marker || this.treeAdapter.getTagName(i.element) === n);
    return t && t.type === Ei.Element ? t : null;
  }
  getElementEntry(n) {
    return this.entries.find((t) => t.type === Ei.Element && t.element === n);
  }
}
const cr = {
  //Node construction
  createDocument() {
    return {
      nodeName: "#document",
      mode: Vn.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  },
  createElement(e, n, t) {
    return {
      nodeName: e,
      tagName: e,
      attrs: t,
      namespaceURI: n,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode(e) {
    return {
      nodeName: "#comment",
      data: e,
      parentNode: null
    };
  },
  createTextNode(e) {
    return {
      nodeName: "#text",
      value: e,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild(e, n) {
    e.childNodes.push(n), n.parentNode = e;
  },
  insertBefore(e, n, t) {
    const i = e.childNodes.indexOf(t);
    e.childNodes.splice(i, 0, n), n.parentNode = e;
  },
  setTemplateContent(e, n) {
    e.content = n;
  },
  getTemplateContent(e) {
    return e.content;
  },
  setDocumentType(e, n, t, i) {
    const r = e.childNodes.find((s) => s.nodeName === "#documentType");
    if (r)
      r.name = n, r.publicId = t, r.systemId = i;
    else {
      const s = {
        nodeName: "#documentType",
        name: n,
        publicId: t,
        systemId: i,
        parentNode: null
      };
      cr.appendChild(e, s);
    }
  },
  setDocumentMode(e, n) {
    e.mode = n;
  },
  getDocumentMode(e) {
    return e.mode;
  },
  detachNode(e) {
    if (e.parentNode) {
      const n = e.parentNode.childNodes.indexOf(e);
      e.parentNode.childNodes.splice(n, 1), e.parentNode = null;
    }
  },
  insertText(e, n) {
    if (e.childNodes.length > 0) {
      const t = e.childNodes[e.childNodes.length - 1];
      if (cr.isTextNode(t)) {
        t.value += n;
        return;
      }
    }
    cr.appendChild(e, cr.createTextNode(n));
  },
  insertTextBefore(e, n, t) {
    const i = e.childNodes[e.childNodes.indexOf(t) - 1];
    i && cr.isTextNode(i) ? i.value += n : cr.insertBefore(e, cr.createTextNode(n), t);
  },
  adoptAttributes(e, n) {
    const t = new Set(e.attrs.map((i) => i.name));
    for (let i = 0; i < n.length; i++)
      t.has(n[i].name) || e.attrs.push(n[i]);
  },
  //Tree traversing
  getFirstChild(e) {
    return e.childNodes[0];
  },
  getChildNodes(e) {
    return e.childNodes;
  },
  getParentNode(e) {
    return e.parentNode;
  },
  getAttrList(e) {
    return e.attrs;
  },
  //Node data
  getTagName(e) {
    return e.tagName;
  },
  getNamespaceURI(e) {
    return e.namespaceURI;
  },
  getTextNodeContent(e) {
    return e.value;
  },
  getCommentNodeContent(e) {
    return e.data;
  },
  getDocumentTypeNodeName(e) {
    return e.name;
  },
  getDocumentTypeNodePublicId(e) {
    return e.publicId;
  },
  getDocumentTypeNodeSystemId(e) {
    return e.systemId;
  },
  //Node types
  isTextNode(e) {
    return e.nodeName === "#text";
  },
  isCommentNode(e) {
    return e.nodeName === "#comment";
  },
  isDocumentTypeNode(e) {
    return e.nodeName === "#documentType";
  },
  isElementNode(e) {
    return Object.prototype.hasOwnProperty.call(e, "tagName");
  },
  // Source code location
  setNodeSourceCodeLocation(e, n) {
    e.sourceCodeLocation = n;
  },
  getNodeSourceCodeLocation(e) {
    return e.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(e, n) {
    e.sourceCodeLocation = { ...e.sourceCodeLocation, ...n };
  }
}, oA = "html", kY = "about:legacy-compat", SY = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", aA = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], IY = [
  ...aA,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], xY = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), uA = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], vY = [
  ...uA,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function F1(e, n) {
  return n.some((t) => e.startsWith(t));
}
function PY(e) {
  return e.name === oA && e.publicId === null && (e.systemId === null || e.systemId === kY);
}
function OY(e) {
  if (e.name !== oA)
    return Vn.QUIRKS;
  const { systemId: n } = e;
  if (n && n.toLowerCase() === SY)
    return Vn.QUIRKS;
  let { publicId: t } = e;
  if (t !== null) {
    if (t = t.toLowerCase(), xY.has(t))
      return Vn.QUIRKS;
    let i = n === null ? IY : aA;
    if (F1(t, i))
      return Vn.QUIRKS;
    if (i = n === null ? uA : vY, F1(t, i))
      return Vn.LIMITED_QUIRKS;
  }
  return Vn.NO_QUIRKS;
}
const U1 = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, NY = "definitionurl", RY = "definitionURL", LY = new Map([
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((e) => [e.toLowerCase(), e])), DY = /* @__PURE__ */ new Map([
  ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: Y.XLINK }],
  ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: Y.XLINK }],
  ["xlink:href", { prefix: "xlink", name: "href", namespace: Y.XLINK }],
  ["xlink:role", { prefix: "xlink", name: "role", namespace: Y.XLINK }],
  ["xlink:show", { prefix: "xlink", name: "show", namespace: Y.XLINK }],
  ["xlink:title", { prefix: "xlink", name: "title", namespace: Y.XLINK }],
  ["xlink:type", { prefix: "xlink", name: "type", namespace: Y.XLINK }],
  ["xml:lang", { prefix: "xml", name: "lang", namespace: Y.XML }],
  ["xml:space", { prefix: "xml", name: "space", namespace: Y.XML }],
  ["xmlns", { prefix: "", name: "xmlns", namespace: Y.XMLNS }],
  ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: Y.XMLNS }]
]), MY = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((e) => [e.toLowerCase(), e])), BY = /* @__PURE__ */ new Set([
  f.B,
  f.BIG,
  f.BLOCKQUOTE,
  f.BODY,
  f.BR,
  f.CENTER,
  f.CODE,
  f.DD,
  f.DIV,
  f.DL,
  f.DT,
  f.EM,
  f.EMBED,
  f.H1,
  f.H2,
  f.H3,
  f.H4,
  f.H5,
  f.H6,
  f.HEAD,
  f.HR,
  f.I,
  f.IMG,
  f.LI,
  f.LISTING,
  f.MENU,
  f.META,
  f.NOBR,
  f.OL,
  f.P,
  f.PRE,
  f.RUBY,
  f.S,
  f.SMALL,
  f.SPAN,
  f.STRONG,
  f.STRIKE,
  f.SUB,
  f.SUP,
  f.TABLE,
  f.TT,
  f.U,
  f.UL,
  f.VAR
]);
function FY(e) {
  const n = e.tagID;
  return n === f.FONT && e.attrs.some(({ name: i }) => i === es.COLOR || i === es.SIZE || i === es.FACE) || BY.has(n);
}
function lA(e) {
  for (let n = 0; n < e.attrs.length; n++)
    if (e.attrs[n].name === NY) {
      e.attrs[n].name = RY;
      break;
    }
}
function cA(e) {
  for (let n = 0; n < e.attrs.length; n++) {
    const t = LY.get(e.attrs[n].name);
    t != null && (e.attrs[n].name = t);
  }
}
function zm(e) {
  for (let n = 0; n < e.attrs.length; n++) {
    const t = DY.get(e.attrs[n].name);
    t && (e.attrs[n].prefix = t.prefix, e.attrs[n].name = t.name, e.attrs[n].namespace = t.namespace);
  }
}
function UY(e) {
  const n = MY.get(e.tagName);
  n != null && (e.tagName = n, e.tagID = yo(e.tagName));
}
function HY(e, n) {
  return n === Y.MATHML && (e === f.MI || e === f.MO || e === f.MN || e === f.MS || e === f.MTEXT);
}
function VY(e, n, t) {
  if (n === Y.MATHML && e === f.ANNOTATION_XML) {
    for (let i = 0; i < t.length; i++)
      if (t[i].name === es.ENCODING) {
        const r = t[i].value.toLowerCase();
        return r === U1.TEXT_HTML || r === U1.APPLICATION_XML;
      }
  }
  return n === Y.SVG && (e === f.FOREIGN_OBJECT || e === f.DESC || e === f.TITLE);
}
function $Y(e, n, t, i) {
  return (!i || i === Y.HTML) && VY(e, n, t) || (!i || i === Y.MATHML) && HY(e, n);
}
const WY = "hidden", zY = 8, qY = 3;
var x;
(function(e) {
  e[e.INITIAL = 0] = "INITIAL", e[e.BEFORE_HTML = 1] = "BEFORE_HTML", e[e.BEFORE_HEAD = 2] = "BEFORE_HEAD", e[e.IN_HEAD = 3] = "IN_HEAD", e[e.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", e[e.AFTER_HEAD = 5] = "AFTER_HEAD", e[e.IN_BODY = 6] = "IN_BODY", e[e.TEXT = 7] = "TEXT", e[e.IN_TABLE = 8] = "IN_TABLE", e[e.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", e[e.IN_CAPTION = 10] = "IN_CAPTION", e[e.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", e[e.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", e[e.IN_ROW = 13] = "IN_ROW", e[e.IN_CELL = 14] = "IN_CELL", e[e.IN_SELECT = 15] = "IN_SELECT", e[e.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", e[e.IN_TEMPLATE = 17] = "IN_TEMPLATE", e[e.AFTER_BODY = 18] = "AFTER_BODY", e[e.IN_FRAMESET = 19] = "IN_FRAMESET", e[e.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", e[e.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", e[e.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(x || (x = {}));
const YY = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, dA = /* @__PURE__ */ new Set([f.TABLE, f.TBODY, f.TFOOT, f.THEAD, f.TR]), H1 = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: cr,
  onParseError: null
};
class V1 {
  constructor(n, t, i = null, r = null) {
    this.fragmentContext = i, this.scriptHandler = r, this.currentToken = null, this.stopped = !1, this.insertionMode = x.INITIAL, this.originalInsertionMode = x.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {
      ...H1,
      ...n
    }, this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = t ?? this.treeAdapter.createDocument(), this.tokenizer = new gY(this.options, this), this.activeFormattingElements = new CY(this.treeAdapter), this.fragmentContextID = i ? yo(this.treeAdapter.getTagName(i)) : f.UNKNOWN, this._setContextModes(i ?? this.document, this.fragmentContextID), this.openElements = new AY(this.document, this.treeAdapter, this);
  }
  // API
  static parse(n, t) {
    const i = new this(t);
    return i.tokenizer.write(n, !0), i.document;
  }
  static getFragmentParser(n, t) {
    const i = {
      ...H1,
      ...t
    };
    n ?? (n = i.treeAdapter.createElement(L.TEMPLATE, Y.HTML, []));
    const r = i.treeAdapter.createElement("documentmock", Y.HTML, []), s = new this(i, r, n);
    return s.fragmentContextID === f.TEMPLATE && s.tmplInsertionModeStack.unshift(x.IN_TEMPLATE), s._initTokenizerForFragmentParsing(), s._insertFakeRootElement(), s._resetInsertionMode(), s._findFormInFragmentContext(), s;
  }
  getFragment() {
    const n = this.treeAdapter.getFirstChild(this.document), t = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(n, t), t;
  }
  //Errors
  /** @internal */
  _err(n, t, i) {
    var r;
    if (!this.onParseError)
      return;
    const s = (r = n.location) !== null && r !== void 0 ? r : YY, o = {
      code: t,
      startLine: s.startLine,
      startCol: s.startCol,
      startOffset: s.startOffset,
      endLine: i ? s.startLine : s.endLine,
      endCol: i ? s.startCol : s.endCol,
      endOffset: i ? s.startOffset : s.endOffset
    };
    this.onParseError(o);
  }
  //Stack events
  /** @internal */
  onItemPush(n, t, i) {
    var r, s;
    (s = (r = this.treeAdapter).onItemPush) === null || s === void 0 || s.call(r, n), i && this.openElements.stackTop > 0 && this._setContextModes(n, t);
  }
  /** @internal */
  onItemPop(n, t) {
    var i, r;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(n, this.currentToken), (r = (i = this.treeAdapter).onItemPop) === null || r === void 0 || r.call(i, n, this.openElements.current), t) {
      let s, o;
      this.openElements.stackTop === 0 && this.fragmentContext ? (s = this.fragmentContext, o = this.fragmentContextID) : { current: s, currentTagId: o } = this.openElements, this._setContextModes(s, o);
    }
  }
  _setContextModes(n, t) {
    const i = n === this.document || n && this.treeAdapter.getNamespaceURI(n) === Y.HTML;
    this.currentNotInHTML = !i, this.tokenizer.inForeignNode = !i && n !== void 0 && t !== void 0 && !this._isIntegrationPoint(t, n);
  }
  /** @protected */
  _switchToTextParsing(n, t) {
    this._insertElement(n, Y.HTML), this.tokenizer.state = t, this.originalInsertionMode = this.insertionMode, this.insertionMode = x.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = x.TEXT, this.originalInsertionMode = x.IN_BODY, this.tokenizer.state = wt.PLAINTEXT;
  }
  //Fragment parsing
  /** @protected */
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  /** @protected */
  _findFormInFragmentContext() {
    let n = this.fragmentContext;
    for (; n; ) {
      if (this.treeAdapter.getTagName(n) === L.FORM) {
        this.formElement = n;
        break;
      }
      n = this.treeAdapter.getParentNode(n);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== Y.HTML))
      switch (this.fragmentContextID) {
        case f.TITLE:
        case f.TEXTAREA: {
          this.tokenizer.state = wt.RCDATA;
          break;
        }
        case f.STYLE:
        case f.XMP:
        case f.IFRAME:
        case f.NOEMBED:
        case f.NOFRAMES:
        case f.NOSCRIPT: {
          this.tokenizer.state = wt.RAWTEXT;
          break;
        }
        case f.SCRIPT: {
          this.tokenizer.state = wt.SCRIPT_DATA;
          break;
        }
        case f.PLAINTEXT: {
          this.tokenizer.state = wt.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  /** @protected */
  _setDocumentType(n) {
    const t = n.name || "", i = n.publicId || "", r = n.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, t, i, r), n.location) {
      const o = this.treeAdapter.getChildNodes(this.document).find((a) => this.treeAdapter.isDocumentTypeNode(a));
      o && this.treeAdapter.setNodeSourceCodeLocation(o, n.location);
    }
  }
  /** @protected */
  _attachElementToTree(n, t) {
    if (this.options.sourceCodeLocationInfo) {
      const i = t && {
        ...t,
        startTag: t
      };
      this.treeAdapter.setNodeSourceCodeLocation(n, i);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(n);
    else {
      const i = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(i ?? this.document, n);
    }
  }
  /**
   * For self-closing tags. Add an element to the tree, but skip adding it
   * to the stack.
   */
  /** @protected */
  _appendElement(n, t) {
    const i = this.treeAdapter.createElement(n.tagName, t, n.attrs);
    this._attachElementToTree(i, n.location);
  }
  /** @protected */
  _insertElement(n, t) {
    const i = this.treeAdapter.createElement(n.tagName, t, n.attrs);
    this._attachElementToTree(i, n.location), this.openElements.push(i, n.tagID);
  }
  /** @protected */
  _insertFakeElement(n, t) {
    const i = this.treeAdapter.createElement(n, Y.HTML, []);
    this._attachElementToTree(i, null), this.openElements.push(i, t);
  }
  /** @protected */
  _insertTemplate(n) {
    const t = this.treeAdapter.createElement(n.tagName, Y.HTML, n.attrs), i = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(t, i), this._attachElementToTree(t, n.location), this.openElements.push(t, n.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(i, null);
  }
  /** @protected */
  _insertFakeRootElement() {
    const n = this.treeAdapter.createElement(L.HTML, Y.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(n, null), this.treeAdapter.appendChild(this.openElements.current, n), this.openElements.push(n, f.HTML);
  }
  /** @protected */
  _appendCommentNode(n, t) {
    const i = this.treeAdapter.createCommentNode(n.data);
    this.treeAdapter.appendChild(t, i), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(i, n.location);
  }
  /** @protected */
  _insertCharacters(n) {
    let t, i;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: t, beforeElement: i } = this._findFosterParentingLocation(), i ? this.treeAdapter.insertTextBefore(t, n.chars, i) : this.treeAdapter.insertText(t, n.chars)) : (t = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(t, n.chars)), !n.location)
      return;
    const r = this.treeAdapter.getChildNodes(t), s = i ? r.lastIndexOf(i) : r.length, o = r[s - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(o)) {
      const { endLine: u, endCol: l, endOffset: c } = n.location;
      this.treeAdapter.updateNodeSourceCodeLocation(o, { endLine: u, endCol: l, endOffset: c });
    } else this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(o, n.location);
  }
  /** @protected */
  _adoptNodes(n, t) {
    for (let i = this.treeAdapter.getFirstChild(n); i; i = this.treeAdapter.getFirstChild(n))
      this.treeAdapter.detachNode(i), this.treeAdapter.appendChild(t, i);
  }
  /** @protected */
  _setEndLocation(n, t) {
    if (this.treeAdapter.getNodeSourceCodeLocation(n) && t.location) {
      const i = t.location, r = this.treeAdapter.getTagName(n), s = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        t.type === Le.END_TAG && r === t.tagName ? {
          endTag: { ...i },
          endLine: i.endLine,
          endCol: i.endCol,
          endOffset: i.endOffset
        } : {
          endLine: i.startLine,
          endCol: i.startCol,
          endOffset: i.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(n, s);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(n) {
    if (!this.currentNotInHTML)
      return !1;
    let t, i;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (t = this.fragmentContext, i = this.fragmentContextID) : { current: t, currentTagId: i } = this.openElements, n.tagID === f.SVG && this.treeAdapter.getTagName(t) === L.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(t) === Y.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (n.tagID === f.MGLYPH || n.tagID === f.MALIGNMARK) && i !== void 0 && !this._isIntegrationPoint(i, t, Y.HTML)
    );
  }
  /** @protected */
  _processToken(n) {
    switch (n.type) {
      case Le.CHARACTER: {
        this.onCharacter(n);
        break;
      }
      case Le.NULL_CHARACTER: {
        this.onNullCharacter(n);
        break;
      }
      case Le.COMMENT: {
        this.onComment(n);
        break;
      }
      case Le.DOCTYPE: {
        this.onDoctype(n);
        break;
      }
      case Le.START_TAG: {
        this._processStartTag(n);
        break;
      }
      case Le.END_TAG: {
        this.onEndTag(n);
        break;
      }
      case Le.EOF: {
        this.onEof(n);
        break;
      }
      case Le.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(n);
        break;
      }
    }
  }
  //Integration points
  /** @protected */
  _isIntegrationPoint(n, t, i) {
    const r = this.treeAdapter.getNamespaceURI(t), s = this.treeAdapter.getAttrList(t);
    return $Y(n, r, s, i);
  }
  //Active formatting elements reconstruction
  /** @protected */
  _reconstructActiveFormattingElements() {
    const n = this.activeFormattingElements.entries.length;
    if (n) {
      const t = this.activeFormattingElements.entries.findIndex((r) => r.type === Ei.Marker || this.openElements.contains(r.element)), i = t === -1 ? n - 1 : t - 1;
      for (let r = i; r >= 0; r--) {
        const s = this.activeFormattingElements.entries[r];
        this._insertElement(s.token, this.treeAdapter.getNamespaceURI(s.element)), s.element = this.openElements.current;
      }
    }
  }
  //Close elements
  /** @protected */
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = x.IN_ROW;
  }
  /** @protected */
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(f.P), this.openElements.popUntilTagNamePopped(f.P);
  }
  //Insertion modes
  /** @protected */
  _resetInsertionMode() {
    for (let n = this.openElements.stackTop; n >= 0; n--)
      switch (n === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[n]) {
        case f.TR: {
          this.insertionMode = x.IN_ROW;
          return;
        }
        case f.TBODY:
        case f.THEAD:
        case f.TFOOT: {
          this.insertionMode = x.IN_TABLE_BODY;
          return;
        }
        case f.CAPTION: {
          this.insertionMode = x.IN_CAPTION;
          return;
        }
        case f.COLGROUP: {
          this.insertionMode = x.IN_COLUMN_GROUP;
          return;
        }
        case f.TABLE: {
          this.insertionMode = x.IN_TABLE;
          return;
        }
        case f.BODY: {
          this.insertionMode = x.IN_BODY;
          return;
        }
        case f.FRAMESET: {
          this.insertionMode = x.IN_FRAMESET;
          return;
        }
        case f.SELECT: {
          this._resetInsertionModeForSelect(n);
          return;
        }
        case f.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case f.HTML: {
          this.insertionMode = this.headElement ? x.AFTER_HEAD : x.BEFORE_HEAD;
          return;
        }
        case f.TD:
        case f.TH: {
          if (n > 0) {
            this.insertionMode = x.IN_CELL;
            return;
          }
          break;
        }
        case f.HEAD: {
          if (n > 0) {
            this.insertionMode = x.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = x.IN_BODY;
  }
  /** @protected */
  _resetInsertionModeForSelect(n) {
    if (n > 0)
      for (let t = n - 1; t > 0; t--) {
        const i = this.openElements.tagIDs[t];
        if (i === f.TEMPLATE)
          break;
        if (i === f.TABLE) {
          this.insertionMode = x.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = x.IN_SELECT;
  }
  //Foster parenting
  /** @protected */
  _isElementCausesFosterParenting(n) {
    return dA.has(n);
  }
  /** @protected */
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this.openElements.currentTagId !== void 0 && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  /** @protected */
  _findFosterParentingLocation() {
    for (let n = this.openElements.stackTop; n >= 0; n--) {
      const t = this.openElements.items[n];
      switch (this.openElements.tagIDs[n]) {
        case f.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(t) === Y.HTML)
            return { parent: this.treeAdapter.getTemplateContent(t), beforeElement: null };
          break;
        }
        case f.TABLE: {
          const i = this.treeAdapter.getParentNode(t);
          return i ? { parent: i, beforeElement: t } : { parent: this.openElements.items[n - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  /** @protected */
  _fosterParentElement(n) {
    const t = this._findFosterParentingLocation();
    t.beforeElement ? this.treeAdapter.insertBefore(t.parent, n, t.beforeElement) : this.treeAdapter.appendChild(t.parent, n);
  }
  //Special elements
  /** @protected */
  _isSpecialElement(n, t) {
    const i = this.treeAdapter.getNamespaceURI(n);
    return hY[i].has(t);
  }
  /** @internal */
  onCharacter(n) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      wK(this, n);
      return;
    }
    switch (this.insertionMode) {
      case x.INITIAL: {
        Yo(this, n);
        break;
      }
      case x.BEFORE_HTML: {
        _a(this, n);
        break;
      }
      case x.BEFORE_HEAD: {
        Ea(this, n);
        break;
      }
      case x.IN_HEAD: {
        Ta(this, n);
        break;
      }
      case x.IN_HEAD_NO_SCRIPT: {
        ya(this, n);
        break;
      }
      case x.AFTER_HEAD: {
        wa(this, n);
        break;
      }
      case x.IN_BODY:
      case x.IN_CAPTION:
      case x.IN_CELL:
      case x.IN_TEMPLATE: {
        fA(this, n);
        break;
      }
      case x.TEXT:
      case x.IN_SELECT:
      case x.IN_SELECT_IN_TABLE: {
        this._insertCharacters(n);
        break;
      }
      case x.IN_TABLE:
      case x.IN_TABLE_BODY:
      case x.IN_ROW: {
        Zd(this, n);
        break;
      }
      case x.IN_TABLE_TEXT: {
        EA(this, n);
        break;
      }
      case x.IN_COLUMN_GROUP: {
        Ul(this, n);
        break;
      }
      case x.AFTER_BODY: {
        Hl(this, n);
        break;
      }
      case x.AFTER_AFTER_BODY: {
        ol(this, n);
        break;
      }
    }
  }
  /** @internal */
  onNullCharacter(n) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      yK(this, n);
      return;
    }
    switch (this.insertionMode) {
      case x.INITIAL: {
        Yo(this, n);
        break;
      }
      case x.BEFORE_HTML: {
        _a(this, n);
        break;
      }
      case x.BEFORE_HEAD: {
        Ea(this, n);
        break;
      }
      case x.IN_HEAD: {
        Ta(this, n);
        break;
      }
      case x.IN_HEAD_NO_SCRIPT: {
        ya(this, n);
        break;
      }
      case x.AFTER_HEAD: {
        wa(this, n);
        break;
      }
      case x.TEXT: {
        this._insertCharacters(n);
        break;
      }
      case x.IN_TABLE:
      case x.IN_TABLE_BODY:
      case x.IN_ROW: {
        Zd(this, n);
        break;
      }
      case x.IN_COLUMN_GROUP: {
        Ul(this, n);
        break;
      }
      case x.AFTER_BODY: {
        Hl(this, n);
        break;
      }
      case x.AFTER_AFTER_BODY: {
        ol(this, n);
        break;
      }
    }
  }
  /** @internal */
  onComment(n) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      bf(this, n);
      return;
    }
    switch (this.insertionMode) {
      case x.INITIAL:
      case x.BEFORE_HTML:
      case x.BEFORE_HEAD:
      case x.IN_HEAD:
      case x.IN_HEAD_NO_SCRIPT:
      case x.AFTER_HEAD:
      case x.IN_BODY:
      case x.IN_TABLE:
      case x.IN_CAPTION:
      case x.IN_COLUMN_GROUP:
      case x.IN_TABLE_BODY:
      case x.IN_ROW:
      case x.IN_CELL:
      case x.IN_SELECT:
      case x.IN_SELECT_IN_TABLE:
      case x.IN_TEMPLATE:
      case x.IN_FRAMESET:
      case x.AFTER_FRAMESET: {
        bf(this, n);
        break;
      }
      case x.IN_TABLE_TEXT: {
        jo(this, n);
        break;
      }
      case x.AFTER_BODY: {
        ZY(this, n);
        break;
      }
      case x.AFTER_AFTER_BODY:
      case x.AFTER_AFTER_FRAMESET: {
        ej(this, n);
        break;
      }
    }
  }
  /** @internal */
  onDoctype(n) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case x.INITIAL: {
        tj(this, n);
        break;
      }
      case x.BEFORE_HEAD:
      case x.IN_HEAD:
      case x.IN_HEAD_NO_SCRIPT:
      case x.AFTER_HEAD: {
        this._err(n, H.misplacedDoctype);
        break;
      }
      case x.IN_TABLE_TEXT: {
        jo(this, n);
        break;
      }
    }
  }
  /** @internal */
  onStartTag(n) {
    this.skipNextNewLine = !1, this.currentToken = n, this._processStartTag(n), n.selfClosing && !n.ackSelfClosing && this._err(n, H.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   * @protected
   */
  _processStartTag(n) {
    this.shouldProcessStartTagTokenInForeignContent(n) ? AK(this, n) : this._startTagOutsideForeignContent(n);
  }
  /** @protected */
  _startTagOutsideForeignContent(n) {
    switch (this.insertionMode) {
      case x.INITIAL: {
        Yo(this, n);
        break;
      }
      case x.BEFORE_HTML: {
        nj(this, n);
        break;
      }
      case x.BEFORE_HEAD: {
        rj(this, n);
        break;
      }
      case x.IN_HEAD: {
        hi(this, n);
        break;
      }
      case x.IN_HEAD_NO_SCRIPT: {
        aj(this, n);
        break;
      }
      case x.AFTER_HEAD: {
        lj(this, n);
        break;
      }
      case x.IN_BODY: {
        en(this, n);
        break;
      }
      case x.IN_TABLE: {
        ao(this, n);
        break;
      }
      case x.IN_TABLE_TEXT: {
        jo(this, n);
        break;
      }
      case x.IN_CAPTION: {
        sK(this, n);
        break;
      }
      case x.IN_COLUMN_GROUP: {
        jm(this, n);
        break;
      }
      case x.IN_TABLE_BODY: {
        xc(this, n);
        break;
      }
      case x.IN_ROW: {
        vc(this, n);
        break;
      }
      case x.IN_CELL: {
        uK(this, n);
        break;
      }
      case x.IN_SELECT: {
        wA(this, n);
        break;
      }
      case x.IN_SELECT_IN_TABLE: {
        cK(this, n);
        break;
      }
      case x.IN_TEMPLATE: {
        hK(this, n);
        break;
      }
      case x.AFTER_BODY: {
        mK(this, n);
        break;
      }
      case x.IN_FRAMESET: {
        pK(this, n);
        break;
      }
      case x.AFTER_FRAMESET: {
        bK(this, n);
        break;
      }
      case x.AFTER_AFTER_BODY: {
        EK(this, n);
        break;
      }
      case x.AFTER_AFTER_FRAMESET: {
        TK(this, n);
        break;
      }
    }
  }
  /** @internal */
  onEndTag(n) {
    this.skipNextNewLine = !1, this.currentToken = n, this.currentNotInHTML ? CK(this, n) : this._endTagOutsideForeignContent(n);
  }
  /** @protected */
  _endTagOutsideForeignContent(n) {
    switch (this.insertionMode) {
      case x.INITIAL: {
        Yo(this, n);
        break;
      }
      case x.BEFORE_HTML: {
        ij(this, n);
        break;
      }
      case x.BEFORE_HEAD: {
        sj(this, n);
        break;
      }
      case x.IN_HEAD: {
        oj(this, n);
        break;
      }
      case x.IN_HEAD_NO_SCRIPT: {
        uj(this, n);
        break;
      }
      case x.AFTER_HEAD: {
        cj(this, n);
        break;
      }
      case x.IN_BODY: {
        Ic(this, n);
        break;
      }
      case x.TEXT: {
        Gj(this, n);
        break;
      }
      case x.IN_TABLE: {
        Ya(this, n);
        break;
      }
      case x.IN_TABLE_TEXT: {
        jo(this, n);
        break;
      }
      case x.IN_CAPTION: {
        oK(this, n);
        break;
      }
      case x.IN_COLUMN_GROUP: {
        aK(this, n);
        break;
      }
      case x.IN_TABLE_BODY: {
        _f(this, n);
        break;
      }
      case x.IN_ROW: {
        yA(this, n);
        break;
      }
      case x.IN_CELL: {
        lK(this, n);
        break;
      }
      case x.IN_SELECT: {
        AA(this, n);
        break;
      }
      case x.IN_SELECT_IN_TABLE: {
        dK(this, n);
        break;
      }
      case x.IN_TEMPLATE: {
        fK(this, n);
        break;
      }
      case x.AFTER_BODY: {
        kA(this, n);
        break;
      }
      case x.IN_FRAMESET: {
        gK(this, n);
        break;
      }
      case x.AFTER_FRAMESET: {
        _K(this, n);
        break;
      }
      case x.AFTER_AFTER_BODY: {
        ol(this, n);
        break;
      }
    }
  }
  /** @internal */
  onEof(n) {
    switch (this.insertionMode) {
      case x.INITIAL: {
        Yo(this, n);
        break;
      }
      case x.BEFORE_HTML: {
        _a(this, n);
        break;
      }
      case x.BEFORE_HEAD: {
        Ea(this, n);
        break;
      }
      case x.IN_HEAD: {
        Ta(this, n);
        break;
      }
      case x.IN_HEAD_NO_SCRIPT: {
        ya(this, n);
        break;
      }
      case x.AFTER_HEAD: {
        wa(this, n);
        break;
      }
      case x.IN_BODY:
      case x.IN_TABLE:
      case x.IN_CAPTION:
      case x.IN_COLUMN_GROUP:
      case x.IN_TABLE_BODY:
      case x.IN_ROW:
      case x.IN_CELL:
      case x.IN_SELECT:
      case x.IN_SELECT_IN_TABLE: {
        bA(this, n);
        break;
      }
      case x.TEXT: {
        Qj(this, n);
        break;
      }
      case x.IN_TABLE_TEXT: {
        jo(this, n);
        break;
      }
      case x.IN_TEMPLATE: {
        CA(this, n);
        break;
      }
      case x.AFTER_BODY:
      case x.IN_FRAMESET:
      case x.AFTER_FRAMESET:
      case x.AFTER_AFTER_BODY:
      case x.AFTER_AFTER_FRAMESET: {
        Ym(this, n);
        break;
      }
    }
  }
  /** @internal */
  onWhitespaceCharacter(n) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, n.chars.charCodeAt(0) === T.LINE_FEED)) {
      if (n.chars.length === 1)
        return;
      n.chars = n.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(n);
      return;
    }
    switch (this.insertionMode) {
      case x.IN_HEAD:
      case x.IN_HEAD_NO_SCRIPT:
      case x.AFTER_HEAD:
      case x.TEXT:
      case x.IN_COLUMN_GROUP:
      case x.IN_SELECT:
      case x.IN_SELECT_IN_TABLE:
      case x.IN_FRAMESET:
      case x.AFTER_FRAMESET: {
        this._insertCharacters(n);
        break;
      }
      case x.IN_BODY:
      case x.IN_CAPTION:
      case x.IN_CELL:
      case x.IN_TEMPLATE:
      case x.AFTER_BODY:
      case x.AFTER_AFTER_BODY:
      case x.AFTER_AFTER_FRAMESET: {
        hA(this, n);
        break;
      }
      case x.IN_TABLE:
      case x.IN_TABLE_BODY:
      case x.IN_ROW: {
        Zd(this, n);
        break;
      }
      case x.IN_TABLE_TEXT: {
        _A(this, n);
        break;
      }
    }
  }
}
function jY(e, n) {
  let t = e.activeFormattingElements.getElementEntryInScopeWithTagName(n.tagName);
  return t ? e.openElements.contains(t.element) ? e.openElements.hasInScope(n.tagID) || (t = null) : (e.activeFormattingElements.removeEntry(t), t = null) : gA(e, n), t;
}
function KY(e, n) {
  let t = null, i = e.openElements.stackTop;
  for (; i >= 0; i--) {
    const r = e.openElements.items[i];
    if (r === n.element)
      break;
    e._isSpecialElement(r, e.openElements.tagIDs[i]) && (t = r);
  }
  return t || (e.openElements.shortenToLength(Math.max(i, 0)), e.activeFormattingElements.removeEntry(n)), t;
}
function GY(e, n, t) {
  let i = n, r = e.openElements.getCommonAncestor(n);
  for (let s = 0, o = r; o !== t; s++, o = r) {
    r = e.openElements.getCommonAncestor(o);
    const a = e.activeFormattingElements.getElementEntry(o), u = a && s >= qY;
    !a || u ? (u && e.activeFormattingElements.removeEntry(a), e.openElements.remove(o)) : (o = QY(e, a), i === n && (e.activeFormattingElements.bookmark = a), e.treeAdapter.detachNode(i), e.treeAdapter.appendChild(o, i), i = o);
  }
  return i;
}
function QY(e, n) {
  const t = e.treeAdapter.getNamespaceURI(n.element), i = e.treeAdapter.createElement(n.token.tagName, t, n.token.attrs);
  return e.openElements.replace(n.element, i), n.element = i, i;
}
function XY(e, n, t) {
  const i = e.treeAdapter.getTagName(n), r = yo(i);
  if (e._isElementCausesFosterParenting(r))
    e._fosterParentElement(t);
  else {
    const s = e.treeAdapter.getNamespaceURI(n);
    r === f.TEMPLATE && s === Y.HTML && (n = e.treeAdapter.getTemplateContent(n)), e.treeAdapter.appendChild(n, t);
  }
}
function JY(e, n, t) {
  const i = e.treeAdapter.getNamespaceURI(t.element), { token: r } = t, s = e.treeAdapter.createElement(r.tagName, i, r.attrs);
  e._adoptNodes(n, s), e.treeAdapter.appendChild(n, s), e.activeFormattingElements.insertElementAfterBookmark(s, r), e.activeFormattingElements.removeEntry(t), e.openElements.remove(t.element), e.openElements.insertAfter(n, s, r.tagID);
}
function qm(e, n) {
  for (let t = 0; t < zY; t++) {
    const i = jY(e, n);
    if (!i)
      break;
    const r = KY(e, i);
    if (!r)
      break;
    e.activeFormattingElements.bookmark = i;
    const s = GY(e, r, i.element), o = e.openElements.getCommonAncestor(i.element);
    e.treeAdapter.detachNode(s), o && XY(e, o, s), JY(e, r, i);
  }
}
function bf(e, n) {
  e._appendCommentNode(n, e.openElements.currentTmplContentOrNode);
}
function ZY(e, n) {
  e._appendCommentNode(n, e.openElements.items[0]);
}
function ej(e, n) {
  e._appendCommentNode(n, e.document);
}
function Ym(e, n) {
  if (e.stopped = !0, n.location) {
    const t = e.fragmentContext ? 0 : 2;
    for (let i = e.openElements.stackTop; i >= t; i--)
      e._setEndLocation(e.openElements.items[i], n);
    if (!e.fragmentContext && e.openElements.stackTop >= 0) {
      const i = e.openElements.items[0], r = e.treeAdapter.getNodeSourceCodeLocation(i);
      if (r && !r.endTag && (e._setEndLocation(i, n), e.openElements.stackTop >= 1)) {
        const s = e.openElements.items[1], o = e.treeAdapter.getNodeSourceCodeLocation(s);
        o && !o.endTag && e._setEndLocation(s, n);
      }
    }
  }
}
function tj(e, n) {
  e._setDocumentType(n);
  const t = n.forceQuirks ? Vn.QUIRKS : OY(n);
  PY(n) || e._err(n, H.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, t), e.insertionMode = x.BEFORE_HTML;
}
function Yo(e, n) {
  e._err(n, H.missingDoctype, !0), e.treeAdapter.setDocumentMode(e.document, Vn.QUIRKS), e.insertionMode = x.BEFORE_HTML, e._processToken(n);
}
function nj(e, n) {
  n.tagID === f.HTML ? (e._insertElement(n, Y.HTML), e.insertionMode = x.BEFORE_HEAD) : _a(e, n);
}
function ij(e, n) {
  const t = n.tagID;
  (t === f.HTML || t === f.HEAD || t === f.BODY || t === f.BR) && _a(e, n);
}
function _a(e, n) {
  e._insertFakeRootElement(), e.insertionMode = x.BEFORE_HEAD, e._processToken(n);
}
function rj(e, n) {
  switch (n.tagID) {
    case f.HTML: {
      en(e, n);
      break;
    }
    case f.HEAD: {
      e._insertElement(n, Y.HTML), e.headElement = e.openElements.current, e.insertionMode = x.IN_HEAD;
      break;
    }
    default:
      Ea(e, n);
  }
}
function sj(e, n) {
  const t = n.tagID;
  t === f.HEAD || t === f.BODY || t === f.HTML || t === f.BR ? Ea(e, n) : e._err(n, H.endTagWithoutMatchingOpenElement);
}
function Ea(e, n) {
  e._insertFakeElement(L.HEAD, f.HEAD), e.headElement = e.openElements.current, e.insertionMode = x.IN_HEAD, e._processToken(n);
}
function hi(e, n) {
  switch (n.tagID) {
    case f.HTML: {
      en(e, n);
      break;
    }
    case f.BASE:
    case f.BASEFONT:
    case f.BGSOUND:
    case f.LINK:
    case f.META: {
      e._appendElement(n, Y.HTML), n.ackSelfClosing = !0;
      break;
    }
    case f.TITLE: {
      e._switchToTextParsing(n, wt.RCDATA);
      break;
    }
    case f.NOSCRIPT: {
      e.options.scriptingEnabled ? e._switchToTextParsing(n, wt.RAWTEXT) : (e._insertElement(n, Y.HTML), e.insertionMode = x.IN_HEAD_NO_SCRIPT);
      break;
    }
    case f.NOFRAMES:
    case f.STYLE: {
      e._switchToTextParsing(n, wt.RAWTEXT);
      break;
    }
    case f.SCRIPT: {
      e._switchToTextParsing(n, wt.SCRIPT_DATA);
      break;
    }
    case f.TEMPLATE: {
      e._insertTemplate(n), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = x.IN_TEMPLATE, e.tmplInsertionModeStack.unshift(x.IN_TEMPLATE);
      break;
    }
    case f.HEAD: {
      e._err(n, H.misplacedStartTagForHeadElement);
      break;
    }
    default:
      Ta(e, n);
  }
}
function oj(e, n) {
  switch (n.tagID) {
    case f.HEAD: {
      e.openElements.pop(), e.insertionMode = x.AFTER_HEAD;
      break;
    }
    case f.BODY:
    case f.BR:
    case f.HTML: {
      Ta(e, n);
      break;
    }
    case f.TEMPLATE: {
      _s(e, n);
      break;
    }
    default:
      e._err(n, H.endTagWithoutMatchingOpenElement);
  }
}
function _s(e, n) {
  e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagId !== f.TEMPLATE && e._err(n, H.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(f.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode()) : e._err(n, H.endTagWithoutMatchingOpenElement);
}
function Ta(e, n) {
  e.openElements.pop(), e.insertionMode = x.AFTER_HEAD, e._processToken(n);
}
function aj(e, n) {
  switch (n.tagID) {
    case f.HTML: {
      en(e, n);
      break;
    }
    case f.BASEFONT:
    case f.BGSOUND:
    case f.HEAD:
    case f.LINK:
    case f.META:
    case f.NOFRAMES:
    case f.STYLE: {
      hi(e, n);
      break;
    }
    case f.NOSCRIPT: {
      e._err(n, H.nestedNoscriptInHead);
      break;
    }
    default:
      ya(e, n);
  }
}
function uj(e, n) {
  switch (n.tagID) {
    case f.NOSCRIPT: {
      e.openElements.pop(), e.insertionMode = x.IN_HEAD;
      break;
    }
    case f.BR: {
      ya(e, n);
      break;
    }
    default:
      e._err(n, H.endTagWithoutMatchingOpenElement);
  }
}
function ya(e, n) {
  const t = n.type === Le.EOF ? H.openElementsLeftAfterEof : H.disallowedContentInNoscriptInHead;
  e._err(n, t), e.openElements.pop(), e.insertionMode = x.IN_HEAD, e._processToken(n);
}
function lj(e, n) {
  switch (n.tagID) {
    case f.HTML: {
      en(e, n);
      break;
    }
    case f.BODY: {
      e._insertElement(n, Y.HTML), e.framesetOk = !1, e.insertionMode = x.IN_BODY;
      break;
    }
    case f.FRAMESET: {
      e._insertElement(n, Y.HTML), e.insertionMode = x.IN_FRAMESET;
      break;
    }
    case f.BASE:
    case f.BASEFONT:
    case f.BGSOUND:
    case f.LINK:
    case f.META:
    case f.NOFRAMES:
    case f.SCRIPT:
    case f.STYLE:
    case f.TEMPLATE:
    case f.TITLE: {
      e._err(n, H.abandonedHeadElementChild), e.openElements.push(e.headElement, f.HEAD), hi(e, n), e.openElements.remove(e.headElement);
      break;
    }
    case f.HEAD: {
      e._err(n, H.misplacedStartTagForHeadElement);
      break;
    }
    default:
      wa(e, n);
  }
}
function cj(e, n) {
  switch (n.tagID) {
    case f.BODY:
    case f.HTML:
    case f.BR: {
      wa(e, n);
      break;
    }
    case f.TEMPLATE: {
      _s(e, n);
      break;
    }
    default:
      e._err(n, H.endTagWithoutMatchingOpenElement);
  }
}
function wa(e, n) {
  e._insertFakeElement(L.BODY, f.BODY), e.insertionMode = x.IN_BODY, Sc(e, n);
}
function Sc(e, n) {
  switch (n.type) {
    case Le.CHARACTER: {
      fA(e, n);
      break;
    }
    case Le.WHITESPACE_CHARACTER: {
      hA(e, n);
      break;
    }
    case Le.COMMENT: {
      bf(e, n);
      break;
    }
    case Le.START_TAG: {
      en(e, n);
      break;
    }
    case Le.END_TAG: {
      Ic(e, n);
      break;
    }
    case Le.EOF: {
      bA(e, n);
      break;
    }
  }
}
function hA(e, n) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(n);
}
function fA(e, n) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(n), e.framesetOk = !1;
}
function dj(e, n) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], n.attrs);
}
function hj(e, n) {
  const t = e.openElements.tryPeekProperlyNestedBodyElement();
  t && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(t, n.attrs));
}
function fj(e, n) {
  const t = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && t && (e.treeAdapter.detachNode(t), e.openElements.popAllUpToHtmlElement(), e._insertElement(n, Y.HTML), e.insertionMode = x.IN_FRAMESET);
}
function mj(e, n) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(n, Y.HTML);
}
function pj(e, n) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e.openElements.currentTagId !== void 0 && gf.has(e.openElements.currentTagId) && e.openElements.pop(), e._insertElement(n, Y.HTML);
}
function gj(e, n) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(n, Y.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function bj(e, n) {
  const t = e.openElements.tmplCount > 0;
  (!e.formElement || t) && (e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(n, Y.HTML), t || (e.formElement = e.openElements.current));
}
function _j(e, n) {
  e.framesetOk = !1;
  const t = n.tagID;
  for (let i = e.openElements.stackTop; i >= 0; i--) {
    const r = e.openElements.tagIDs[i];
    if (t === f.LI && r === f.LI || (t === f.DD || t === f.DT) && (r === f.DD || r === f.DT)) {
      e.openElements.generateImpliedEndTagsWithExclusion(r), e.openElements.popUntilTagNamePopped(r);
      break;
    }
    if (r !== f.ADDRESS && r !== f.DIV && r !== f.P && e._isSpecialElement(e.openElements.items[i], r))
      break;
  }
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(n, Y.HTML);
}
function Ej(e, n) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(n, Y.HTML), e.tokenizer.state = wt.PLAINTEXT;
}
function Tj(e, n) {
  e.openElements.hasInScope(f.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(f.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(n, Y.HTML), e.framesetOk = !1;
}
function yj(e, n) {
  const t = e.activeFormattingElements.getElementEntryInScopeWithTagName(L.A);
  t && (qm(e, n), e.openElements.remove(t.element), e.activeFormattingElements.removeEntry(t)), e._reconstructActiveFormattingElements(), e._insertElement(n, Y.HTML), e.activeFormattingElements.pushElement(e.openElements.current, n);
}
function wj(e, n) {
  e._reconstructActiveFormattingElements(), e._insertElement(n, Y.HTML), e.activeFormattingElements.pushElement(e.openElements.current, n);
}
function Aj(e, n) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(f.NOBR) && (qm(e, n), e._reconstructActiveFormattingElements()), e._insertElement(n, Y.HTML), e.activeFormattingElements.pushElement(e.openElements.current, n);
}
function Cj(e, n) {
  e._reconstructActiveFormattingElements(), e._insertElement(n, Y.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function kj(e, n) {
  e.treeAdapter.getDocumentMode(e.document) !== Vn.QUIRKS && e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(n, Y.HTML), e.framesetOk = !1, e.insertionMode = x.IN_TABLE;
}
function mA(e, n) {
  e._reconstructActiveFormattingElements(), e._appendElement(n, Y.HTML), e.framesetOk = !1, n.ackSelfClosing = !0;
}
function pA(e) {
  const n = iA(e, es.TYPE);
  return n != null && n.toLowerCase() === WY;
}
function Sj(e, n) {
  e._reconstructActiveFormattingElements(), e._appendElement(n, Y.HTML), pA(n) || (e.framesetOk = !1), n.ackSelfClosing = !0;
}
function Ij(e, n) {
  e._appendElement(n, Y.HTML), n.ackSelfClosing = !0;
}
function xj(e, n) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._appendElement(n, Y.HTML), e.framesetOk = !1, n.ackSelfClosing = !0;
}
function vj(e, n) {
  n.tagName = L.IMG, n.tagID = f.IMG, mA(e, n);
}
function Pj(e, n) {
  e._insertElement(n, Y.HTML), e.skipNextNewLine = !0, e.tokenizer.state = wt.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = x.TEXT;
}
function Oj(e, n) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(n, wt.RAWTEXT);
}
function Nj(e, n) {
  e.framesetOk = !1, e._switchToTextParsing(n, wt.RAWTEXT);
}
function $1(e, n) {
  e._switchToTextParsing(n, wt.RAWTEXT);
}
function Rj(e, n) {
  e._reconstructActiveFormattingElements(), e._insertElement(n, Y.HTML), e.framesetOk = !1, e.insertionMode = e.insertionMode === x.IN_TABLE || e.insertionMode === x.IN_CAPTION || e.insertionMode === x.IN_TABLE_BODY || e.insertionMode === x.IN_ROW || e.insertionMode === x.IN_CELL ? x.IN_SELECT_IN_TABLE : x.IN_SELECT;
}
function Lj(e, n) {
  e.openElements.currentTagId === f.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(n, Y.HTML);
}
function Dj(e, n) {
  e.openElements.hasInScope(f.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(n, Y.HTML);
}
function Mj(e, n) {
  e.openElements.hasInScope(f.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(f.RTC), e._insertElement(n, Y.HTML);
}
function Bj(e, n) {
  e._reconstructActiveFormattingElements(), lA(n), zm(n), n.selfClosing ? e._appendElement(n, Y.MATHML) : e._insertElement(n, Y.MATHML), n.ackSelfClosing = !0;
}
function Fj(e, n) {
  e._reconstructActiveFormattingElements(), cA(n), zm(n), n.selfClosing ? e._appendElement(n, Y.SVG) : e._insertElement(n, Y.SVG), n.ackSelfClosing = !0;
}
function W1(e, n) {
  e._reconstructActiveFormattingElements(), e._insertElement(n, Y.HTML);
}
function en(e, n) {
  switch (n.tagID) {
    case f.I:
    case f.S:
    case f.B:
    case f.U:
    case f.EM:
    case f.TT:
    case f.BIG:
    case f.CODE:
    case f.FONT:
    case f.SMALL:
    case f.STRIKE:
    case f.STRONG: {
      wj(e, n);
      break;
    }
    case f.A: {
      yj(e, n);
      break;
    }
    case f.H1:
    case f.H2:
    case f.H3:
    case f.H4:
    case f.H5:
    case f.H6: {
      pj(e, n);
      break;
    }
    case f.P:
    case f.DL:
    case f.OL:
    case f.UL:
    case f.DIV:
    case f.DIR:
    case f.NAV:
    case f.MAIN:
    case f.MENU:
    case f.ASIDE:
    case f.CENTER:
    case f.FIGURE:
    case f.FOOTER:
    case f.HEADER:
    case f.HGROUP:
    case f.DIALOG:
    case f.DETAILS:
    case f.ADDRESS:
    case f.ARTICLE:
    case f.SEARCH:
    case f.SECTION:
    case f.SUMMARY:
    case f.FIELDSET:
    case f.BLOCKQUOTE:
    case f.FIGCAPTION: {
      mj(e, n);
      break;
    }
    case f.LI:
    case f.DD:
    case f.DT: {
      _j(e, n);
      break;
    }
    case f.BR:
    case f.IMG:
    case f.WBR:
    case f.AREA:
    case f.EMBED:
    case f.KEYGEN: {
      mA(e, n);
      break;
    }
    case f.HR: {
      xj(e, n);
      break;
    }
    case f.RB:
    case f.RTC: {
      Dj(e, n);
      break;
    }
    case f.RT:
    case f.RP: {
      Mj(e, n);
      break;
    }
    case f.PRE:
    case f.LISTING: {
      gj(e, n);
      break;
    }
    case f.XMP: {
      Oj(e, n);
      break;
    }
    case f.SVG: {
      Fj(e, n);
      break;
    }
    case f.HTML: {
      dj(e, n);
      break;
    }
    case f.BASE:
    case f.LINK:
    case f.META:
    case f.STYLE:
    case f.TITLE:
    case f.SCRIPT:
    case f.BGSOUND:
    case f.BASEFONT:
    case f.TEMPLATE: {
      hi(e, n);
      break;
    }
    case f.BODY: {
      hj(e, n);
      break;
    }
    case f.FORM: {
      bj(e, n);
      break;
    }
    case f.NOBR: {
      Aj(e, n);
      break;
    }
    case f.MATH: {
      Bj(e, n);
      break;
    }
    case f.TABLE: {
      kj(e, n);
      break;
    }
    case f.INPUT: {
      Sj(e, n);
      break;
    }
    case f.PARAM:
    case f.TRACK:
    case f.SOURCE: {
      Ij(e, n);
      break;
    }
    case f.IMAGE: {
      vj(e, n);
      break;
    }
    case f.BUTTON: {
      Tj(e, n);
      break;
    }
    case f.APPLET:
    case f.OBJECT:
    case f.MARQUEE: {
      Cj(e, n);
      break;
    }
    case f.IFRAME: {
      Nj(e, n);
      break;
    }
    case f.SELECT: {
      Rj(e, n);
      break;
    }
    case f.OPTION:
    case f.OPTGROUP: {
      Lj(e, n);
      break;
    }
    case f.NOEMBED:
    case f.NOFRAMES: {
      $1(e, n);
      break;
    }
    case f.FRAMESET: {
      fj(e, n);
      break;
    }
    case f.TEXTAREA: {
      Pj(e, n);
      break;
    }
    case f.NOSCRIPT: {
      e.options.scriptingEnabled ? $1(e, n) : W1(e, n);
      break;
    }
    case f.PLAINTEXT: {
      Ej(e, n);
      break;
    }
    case f.COL:
    case f.TH:
    case f.TD:
    case f.TR:
    case f.HEAD:
    case f.FRAME:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD:
    case f.CAPTION:
    case f.COLGROUP:
      break;
    default:
      W1(e, n);
  }
}
function Uj(e, n) {
  if (e.openElements.hasInScope(f.BODY) && (e.insertionMode = x.AFTER_BODY, e.options.sourceCodeLocationInfo)) {
    const t = e.openElements.tryPeekProperlyNestedBodyElement();
    t && e._setEndLocation(t, n);
  }
}
function Hj(e, n) {
  e.openElements.hasInScope(f.BODY) && (e.insertionMode = x.AFTER_BODY, kA(e, n));
}
function Vj(e, n) {
  const t = n.tagID;
  e.openElements.hasInScope(t) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(t));
}
function $j(e) {
  const n = e.openElements.tmplCount > 0, { formElement: t } = e;
  n || (e.formElement = null), (t || n) && e.openElements.hasInScope(f.FORM) && (e.openElements.generateImpliedEndTags(), n ? e.openElements.popUntilTagNamePopped(f.FORM) : t && e.openElements.remove(t));
}
function Wj(e) {
  e.openElements.hasInButtonScope(f.P) || e._insertFakeElement(L.P, f.P), e._closePElement();
}
function zj(e) {
  e.openElements.hasInListItemScope(f.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(f.LI), e.openElements.popUntilTagNamePopped(f.LI));
}
function qj(e, n) {
  const t = n.tagID;
  e.openElements.hasInScope(t) && (e.openElements.generateImpliedEndTagsWithExclusion(t), e.openElements.popUntilTagNamePopped(t));
}
function Yj(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function jj(e, n) {
  const t = n.tagID;
  e.openElements.hasInScope(t) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(t), e.activeFormattingElements.clearToLastMarker());
}
function Kj(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(L.BR, f.BR), e.openElements.pop(), e.framesetOk = !1;
}
function gA(e, n) {
  const t = n.tagName, i = n.tagID;
  for (let r = e.openElements.stackTop; r > 0; r--) {
    const s = e.openElements.items[r], o = e.openElements.tagIDs[r];
    if (i === o && (i !== f.UNKNOWN || e.treeAdapter.getTagName(s) === t)) {
      e.openElements.generateImpliedEndTagsWithExclusion(i), e.openElements.stackTop >= r && e.openElements.shortenToLength(r);
      break;
    }
    if (e._isSpecialElement(s, o))
      break;
  }
}
function Ic(e, n) {
  switch (n.tagID) {
    case f.A:
    case f.B:
    case f.I:
    case f.S:
    case f.U:
    case f.EM:
    case f.TT:
    case f.BIG:
    case f.CODE:
    case f.FONT:
    case f.NOBR:
    case f.SMALL:
    case f.STRIKE:
    case f.STRONG: {
      qm(e, n);
      break;
    }
    case f.P: {
      Wj(e);
      break;
    }
    case f.DL:
    case f.UL:
    case f.OL:
    case f.DIR:
    case f.DIV:
    case f.NAV:
    case f.PRE:
    case f.MAIN:
    case f.MENU:
    case f.ASIDE:
    case f.BUTTON:
    case f.CENTER:
    case f.FIGURE:
    case f.FOOTER:
    case f.HEADER:
    case f.HGROUP:
    case f.DIALOG:
    case f.ADDRESS:
    case f.ARTICLE:
    case f.DETAILS:
    case f.SEARCH:
    case f.SECTION:
    case f.SUMMARY:
    case f.LISTING:
    case f.FIELDSET:
    case f.BLOCKQUOTE:
    case f.FIGCAPTION: {
      Vj(e, n);
      break;
    }
    case f.LI: {
      zj(e);
      break;
    }
    case f.DD:
    case f.DT: {
      qj(e, n);
      break;
    }
    case f.H1:
    case f.H2:
    case f.H3:
    case f.H4:
    case f.H5:
    case f.H6: {
      Yj(e);
      break;
    }
    case f.BR: {
      Kj(e);
      break;
    }
    case f.BODY: {
      Uj(e, n);
      break;
    }
    case f.HTML: {
      Hj(e, n);
      break;
    }
    case f.FORM: {
      $j(e);
      break;
    }
    case f.APPLET:
    case f.OBJECT:
    case f.MARQUEE: {
      jj(e, n);
      break;
    }
    case f.TEMPLATE: {
      _s(e, n);
      break;
    }
    default:
      gA(e, n);
  }
}
function bA(e, n) {
  e.tmplInsertionModeStack.length > 0 ? CA(e, n) : Ym(e, n);
}
function Gj(e, n) {
  var t;
  n.tagID === f.SCRIPT && ((t = e.scriptHandler) === null || t === void 0 || t.call(e, e.openElements.current)), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function Qj(e, n) {
  e._err(n, H.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e.onEof(n);
}
function Zd(e, n) {
  if (e.openElements.currentTagId !== void 0 && dA.has(e.openElements.currentTagId))
    switch (e.pendingCharacterTokens.length = 0, e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = x.IN_TABLE_TEXT, n.type) {
      case Le.CHARACTER: {
        EA(e, n);
        break;
      }
      case Le.WHITESPACE_CHARACTER: {
        _A(e, n);
        break;
      }
    }
  else
    mu(e, n);
}
function Xj(e, n) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(n, Y.HTML), e.insertionMode = x.IN_CAPTION;
}
function Jj(e, n) {
  e.openElements.clearBackToTableContext(), e._insertElement(n, Y.HTML), e.insertionMode = x.IN_COLUMN_GROUP;
}
function Zj(e, n) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(L.COLGROUP, f.COLGROUP), e.insertionMode = x.IN_COLUMN_GROUP, jm(e, n);
}
function eK(e, n) {
  e.openElements.clearBackToTableContext(), e._insertElement(n, Y.HTML), e.insertionMode = x.IN_TABLE_BODY;
}
function tK(e, n) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(L.TBODY, f.TBODY), e.insertionMode = x.IN_TABLE_BODY, xc(e, n);
}
function nK(e, n) {
  e.openElements.hasInTableScope(f.TABLE) && (e.openElements.popUntilTagNamePopped(f.TABLE), e._resetInsertionMode(), e._processStartTag(n));
}
function iK(e, n) {
  pA(n) ? e._appendElement(n, Y.HTML) : mu(e, n), n.ackSelfClosing = !0;
}
function rK(e, n) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(n, Y.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function ao(e, n) {
  switch (n.tagID) {
    case f.TD:
    case f.TH:
    case f.TR: {
      tK(e, n);
      break;
    }
    case f.STYLE:
    case f.SCRIPT:
    case f.TEMPLATE: {
      hi(e, n);
      break;
    }
    case f.COL: {
      Zj(e, n);
      break;
    }
    case f.FORM: {
      rK(e, n);
      break;
    }
    case f.TABLE: {
      nK(e, n);
      break;
    }
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      eK(e, n);
      break;
    }
    case f.INPUT: {
      iK(e, n);
      break;
    }
    case f.CAPTION: {
      Xj(e, n);
      break;
    }
    case f.COLGROUP: {
      Jj(e, n);
      break;
    }
    default:
      mu(e, n);
  }
}
function Ya(e, n) {
  switch (n.tagID) {
    case f.TABLE: {
      e.openElements.hasInTableScope(f.TABLE) && (e.openElements.popUntilTagNamePopped(f.TABLE), e._resetInsertionMode());
      break;
    }
    case f.TEMPLATE: {
      _s(e, n);
      break;
    }
    case f.BODY:
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
    case f.TBODY:
    case f.TD:
    case f.TFOOT:
    case f.TH:
    case f.THEAD:
    case f.TR:
      break;
    default:
      mu(e, n);
  }
}
function mu(e, n) {
  const t = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, Sc(e, n), e.fosterParentingEnabled = t;
}
function _A(e, n) {
  e.pendingCharacterTokens.push(n);
}
function EA(e, n) {
  e.pendingCharacterTokens.push(n), e.hasNonWhitespacePendingCharacterToken = !0;
}
function jo(e, n) {
  let t = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; t < e.pendingCharacterTokens.length; t++)
      mu(e, e.pendingCharacterTokens[t]);
  else
    for (; t < e.pendingCharacterTokens.length; t++)
      e._insertCharacters(e.pendingCharacterTokens[t]);
  e.insertionMode = e.originalInsertionMode, e._processToken(n);
}
const TA = /* @__PURE__ */ new Set([f.CAPTION, f.COL, f.COLGROUP, f.TBODY, f.TD, f.TFOOT, f.TH, f.THEAD, f.TR]);
function sK(e, n) {
  const t = n.tagID;
  TA.has(t) ? e.openElements.hasInTableScope(f.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(f.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = x.IN_TABLE, ao(e, n)) : en(e, n);
}
function oK(e, n) {
  const t = n.tagID;
  switch (t) {
    case f.CAPTION:
    case f.TABLE: {
      e.openElements.hasInTableScope(f.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(f.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = x.IN_TABLE, t === f.TABLE && Ya(e, n));
      break;
    }
    case f.BODY:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
    case f.TBODY:
    case f.TD:
    case f.TFOOT:
    case f.TH:
    case f.THEAD:
    case f.TR:
      break;
    default:
      Ic(e, n);
  }
}
function jm(e, n) {
  switch (n.tagID) {
    case f.HTML: {
      en(e, n);
      break;
    }
    case f.COL: {
      e._appendElement(n, Y.HTML), n.ackSelfClosing = !0;
      break;
    }
    case f.TEMPLATE: {
      hi(e, n);
      break;
    }
    default:
      Ul(e, n);
  }
}
function aK(e, n) {
  switch (n.tagID) {
    case f.COLGROUP: {
      e.openElements.currentTagId === f.COLGROUP && (e.openElements.pop(), e.insertionMode = x.IN_TABLE);
      break;
    }
    case f.TEMPLATE: {
      _s(e, n);
      break;
    }
    case f.COL:
      break;
    default:
      Ul(e, n);
  }
}
function Ul(e, n) {
  e.openElements.currentTagId === f.COLGROUP && (e.openElements.pop(), e.insertionMode = x.IN_TABLE, e._processToken(n));
}
function xc(e, n) {
  switch (n.tagID) {
    case f.TR: {
      e.openElements.clearBackToTableBodyContext(), e._insertElement(n, Y.HTML), e.insertionMode = x.IN_ROW;
      break;
    }
    case f.TH:
    case f.TD: {
      e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(L.TR, f.TR), e.insertionMode = x.IN_ROW, vc(e, n);
      break;
    }
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = x.IN_TABLE, ao(e, n));
      break;
    }
    default:
      ao(e, n);
  }
}
function _f(e, n) {
  const t = n.tagID;
  switch (n.tagID) {
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      e.openElements.hasInTableScope(t) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = x.IN_TABLE);
      break;
    }
    case f.TABLE: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = x.IN_TABLE, Ya(e, n));
      break;
    }
    case f.BODY:
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
    case f.TD:
    case f.TH:
    case f.TR:
      break;
    default:
      Ya(e, n);
  }
}
function vc(e, n) {
  switch (n.tagID) {
    case f.TH:
    case f.TD: {
      e.openElements.clearBackToTableRowContext(), e._insertElement(n, Y.HTML), e.insertionMode = x.IN_CELL, e.activeFormattingElements.insertMarker();
      break;
    }
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD:
    case f.TR: {
      e.openElements.hasInTableScope(f.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = x.IN_TABLE_BODY, xc(e, n));
      break;
    }
    default:
      ao(e, n);
  }
}
function yA(e, n) {
  switch (n.tagID) {
    case f.TR: {
      e.openElements.hasInTableScope(f.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = x.IN_TABLE_BODY);
      break;
    }
    case f.TABLE: {
      e.openElements.hasInTableScope(f.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = x.IN_TABLE_BODY, _f(e, n));
      break;
    }
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      (e.openElements.hasInTableScope(n.tagID) || e.openElements.hasInTableScope(f.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = x.IN_TABLE_BODY, _f(e, n));
      break;
    }
    case f.BODY:
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
    case f.TD:
    case f.TH:
      break;
    default:
      Ya(e, n);
  }
}
function uK(e, n) {
  const t = n.tagID;
  TA.has(t) ? (e.openElements.hasInTableScope(f.TD) || e.openElements.hasInTableScope(f.TH)) && (e._closeTableCell(), vc(e, n)) : en(e, n);
}
function lK(e, n) {
  const t = n.tagID;
  switch (t) {
    case f.TD:
    case f.TH: {
      e.openElements.hasInTableScope(t) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(t), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = x.IN_ROW);
      break;
    }
    case f.TABLE:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD:
    case f.TR: {
      e.openElements.hasInTableScope(t) && (e._closeTableCell(), yA(e, n));
      break;
    }
    case f.BODY:
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
      break;
    default:
      Ic(e, n);
  }
}
function wA(e, n) {
  switch (n.tagID) {
    case f.HTML: {
      en(e, n);
      break;
    }
    case f.OPTION: {
      e.openElements.currentTagId === f.OPTION && e.openElements.pop(), e._insertElement(n, Y.HTML);
      break;
    }
    case f.OPTGROUP: {
      e.openElements.currentTagId === f.OPTION && e.openElements.pop(), e.openElements.currentTagId === f.OPTGROUP && e.openElements.pop(), e._insertElement(n, Y.HTML);
      break;
    }
    case f.HR: {
      e.openElements.currentTagId === f.OPTION && e.openElements.pop(), e.openElements.currentTagId === f.OPTGROUP && e.openElements.pop(), e._appendElement(n, Y.HTML), n.ackSelfClosing = !0;
      break;
    }
    case f.INPUT:
    case f.KEYGEN:
    case f.TEXTAREA:
    case f.SELECT: {
      e.openElements.hasInSelectScope(f.SELECT) && (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode(), n.tagID !== f.SELECT && e._processStartTag(n));
      break;
    }
    case f.SCRIPT:
    case f.TEMPLATE: {
      hi(e, n);
      break;
    }
  }
}
function AA(e, n) {
  switch (n.tagID) {
    case f.OPTGROUP: {
      e.openElements.stackTop > 0 && e.openElements.currentTagId === f.OPTION && e.openElements.tagIDs[e.openElements.stackTop - 1] === f.OPTGROUP && e.openElements.pop(), e.openElements.currentTagId === f.OPTGROUP && e.openElements.pop();
      break;
    }
    case f.OPTION: {
      e.openElements.currentTagId === f.OPTION && e.openElements.pop();
      break;
    }
    case f.SELECT: {
      e.openElements.hasInSelectScope(f.SELECT) && (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode());
      break;
    }
    case f.TEMPLATE: {
      _s(e, n);
      break;
    }
  }
}
function cK(e, n) {
  const t = n.tagID;
  t === f.CAPTION || t === f.TABLE || t === f.TBODY || t === f.TFOOT || t === f.THEAD || t === f.TR || t === f.TD || t === f.TH ? (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode(), e._processStartTag(n)) : wA(e, n);
}
function dK(e, n) {
  const t = n.tagID;
  t === f.CAPTION || t === f.TABLE || t === f.TBODY || t === f.TFOOT || t === f.THEAD || t === f.TR || t === f.TD || t === f.TH ? e.openElements.hasInTableScope(t) && (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode(), e.onEndTag(n)) : AA(e, n);
}
function hK(e, n) {
  switch (n.tagID) {
    case f.BASE:
    case f.BASEFONT:
    case f.BGSOUND:
    case f.LINK:
    case f.META:
    case f.NOFRAMES:
    case f.SCRIPT:
    case f.STYLE:
    case f.TEMPLATE:
    case f.TITLE: {
      hi(e, n);
      break;
    }
    case f.CAPTION:
    case f.COLGROUP:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      e.tmplInsertionModeStack[0] = x.IN_TABLE, e.insertionMode = x.IN_TABLE, ao(e, n);
      break;
    }
    case f.COL: {
      e.tmplInsertionModeStack[0] = x.IN_COLUMN_GROUP, e.insertionMode = x.IN_COLUMN_GROUP, jm(e, n);
      break;
    }
    case f.TR: {
      e.tmplInsertionModeStack[0] = x.IN_TABLE_BODY, e.insertionMode = x.IN_TABLE_BODY, xc(e, n);
      break;
    }
    case f.TD:
    case f.TH: {
      e.tmplInsertionModeStack[0] = x.IN_ROW, e.insertionMode = x.IN_ROW, vc(e, n);
      break;
    }
    default:
      e.tmplInsertionModeStack[0] = x.IN_BODY, e.insertionMode = x.IN_BODY, en(e, n);
  }
}
function fK(e, n) {
  n.tagID === f.TEMPLATE && _s(e, n);
}
function CA(e, n) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(f.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode(), e.onEof(n)) : Ym(e, n);
}
function mK(e, n) {
  n.tagID === f.HTML ? en(e, n) : Hl(e, n);
}
function kA(e, n) {
  var t;
  if (n.tagID === f.HTML) {
    if (e.fragmentContext || (e.insertionMode = x.AFTER_AFTER_BODY), e.options.sourceCodeLocationInfo && e.openElements.tagIDs[0] === f.HTML) {
      e._setEndLocation(e.openElements.items[0], n);
      const i = e.openElements.items[1];
      i && !(!((t = e.treeAdapter.getNodeSourceCodeLocation(i)) === null || t === void 0) && t.endTag) && e._setEndLocation(i, n);
    }
  } else
    Hl(e, n);
}
function Hl(e, n) {
  e.insertionMode = x.IN_BODY, Sc(e, n);
}
function pK(e, n) {
  switch (n.tagID) {
    case f.HTML: {
      en(e, n);
      break;
    }
    case f.FRAMESET: {
      e._insertElement(n, Y.HTML);
      break;
    }
    case f.FRAME: {
      e._appendElement(n, Y.HTML), n.ackSelfClosing = !0;
      break;
    }
    case f.NOFRAMES: {
      hi(e, n);
      break;
    }
  }
}
function gK(e, n) {
  n.tagID === f.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagId !== f.FRAMESET && (e.insertionMode = x.AFTER_FRAMESET));
}
function bK(e, n) {
  switch (n.tagID) {
    case f.HTML: {
      en(e, n);
      break;
    }
    case f.NOFRAMES: {
      hi(e, n);
      break;
    }
  }
}
function _K(e, n) {
  n.tagID === f.HTML && (e.insertionMode = x.AFTER_AFTER_FRAMESET);
}
function EK(e, n) {
  n.tagID === f.HTML ? en(e, n) : ol(e, n);
}
function ol(e, n) {
  e.insertionMode = x.IN_BODY, Sc(e, n);
}
function TK(e, n) {
  switch (n.tagID) {
    case f.HTML: {
      en(e, n);
      break;
    }
    case f.NOFRAMES: {
      hi(e, n);
      break;
    }
  }
}
function yK(e, n) {
  n.chars = ct, e._insertCharacters(n);
}
function wK(e, n) {
  e._insertCharacters(n), e.framesetOk = !1;
}
function SA(e) {
  for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== Y.HTML && e.openElements.currentTagId !== void 0 && !e._isIntegrationPoint(e.openElements.currentTagId, e.openElements.current); )
    e.openElements.pop();
}
function AK(e, n) {
  if (FY(n))
    SA(e), e._startTagOutsideForeignContent(n);
  else {
    const t = e._getAdjustedCurrentElement(), i = e.treeAdapter.getNamespaceURI(t);
    i === Y.MATHML ? lA(n) : i === Y.SVG && (UY(n), cA(n)), zm(n), n.selfClosing ? e._appendElement(n, i) : e._insertElement(n, i), n.ackSelfClosing = !0;
  }
}
function CK(e, n) {
  if (n.tagID === f.P || n.tagID === f.BR) {
    SA(e), e._endTagOutsideForeignContent(n);
    return;
  }
  for (let t = e.openElements.stackTop; t > 0; t--) {
    const i = e.openElements.items[t];
    if (e.treeAdapter.getNamespaceURI(i) === Y.HTML) {
      e._endTagOutsideForeignContent(n);
      break;
    }
    const r = e.treeAdapter.getTagName(i);
    if (r.toLowerCase() === n.tagName) {
      n.tagName = r, e.openElements.shortenToLength(t);
      break;
    }
  }
}
L.AREA, L.BASE, L.BASEFONT, L.BGSOUND, L.BR, L.COL, L.EMBED, L.FRAME, L.HR, L.IMG, L.INPUT, L.KEYGEN, L.LINK, L.META, L.PARAM, L.SOURCE, L.TRACK, L.WBR;
const kK = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|textarea|title|xmp)(?=[\t\n\f\r />])/gi, SK = /* @__PURE__ */ new Set([
  "mdxFlowExpression",
  "mdxJsxFlowElement",
  "mdxJsxTextElement",
  "mdxTextExpression",
  "mdxjsEsm"
]), z1 = { sourceCodeLocationInfo: !0, scriptingEnabled: !1 };
function IA(e, n) {
  const t = MK(e), i = mc("type", {
    handlers: { root: IK, element: xK, text: vK, comment: vA, doctype: PK, raw: NK },
    unknown: RK
  }), r = {
    parser: t ? new V1(z1) : V1.getFragmentParser(void 0, z1),
    handle(a) {
      i(a, r);
    },
    stitches: !1,
    options: n || {}
  };
  i(e, r), wo(r, vi());
  const s = t ? r.parser.document : r.parser.getFragment(), o = u2(s, {
    // To do: support `space`?
    file: r.options.file
  });
  return r.stitches && Cr(o, "comment", function(a, u, l) {
    const c = (
      /** @type {Stitch} */
      /** @type {unknown} */
      a
    );
    if (c.value.stitch && l && u !== void 0) {
      const d = l.children;
      return d[u] = c.value.stitch, u;
    }
  }), o.type === "root" && o.children.length === 1 && o.children[0].type === e.type ? o.children[0] : o;
}
function xA(e, n) {
  let t = -1;
  if (e)
    for (; ++t < e.length; )
      n.handle(e[t]);
}
function IK(e, n) {
  xA(e.children, n);
}
function xK(e, n) {
  LK(e, n), xA(e.children, n), DK(e, n);
}
function vK(e, n) {
  n.parser.tokenizer.state > 4 && (n.parser.tokenizer.state = 0);
  const t = {
    type: Le.CHARACTER,
    chars: e.value,
    location: pu(e)
  };
  wo(n, vi(e)), n.parser.currentToken = t, n.parser._processToken(n.parser.currentToken);
}
function PK(e, n) {
  const t = {
    type: Le.DOCTYPE,
    name: "html",
    forceQuirks: !1,
    publicId: "",
    systemId: "",
    location: pu(e)
  };
  wo(n, vi(e)), n.parser.currentToken = t, n.parser._processToken(n.parser.currentToken);
}
function OK(e, n) {
  n.stitches = !0;
  const t = BK(e);
  if ("children" in e && "children" in t) {
    const i = (
      /** @type {Root} */
      IA({ type: "root", children: e.children }, n.options)
    );
    t.children = i.children;
  }
  vA({ type: "comment", value: { stitch: t } }, n);
}
function vA(e, n) {
  const t = e.value, i = {
    type: Le.COMMENT,
    data: t,
    location: pu(e)
  };
  wo(n, vi(e)), n.parser.currentToken = i, n.parser._processToken(n.parser.currentToken);
}
function NK(e, n) {
  if (n.parser.tokenizer.preprocessor.html = "", n.parser.tokenizer.preprocessor.pos = -1, n.parser.tokenizer.preprocessor.lastGapPos = -2, n.parser.tokenizer.preprocessor.gapStack = [], n.parser.tokenizer.preprocessor.skipNextNewLine = !1, n.parser.tokenizer.preprocessor.lastChunkWritten = !1, n.parser.tokenizer.preprocessor.endOfChunkHit = !1, n.parser.tokenizer.preprocessor.isEol = !1, PA(n, vi(e)), n.parser.tokenizer.write(
    n.options.tagfilter ? e.value.replace(kK, "&lt;$1$2") : e.value,
    !1
  ), n.parser.tokenizer._runParsingLoop(), n.parser.tokenizer.state === 72 || // @ts-expect-error: removed.
  n.parser.tokenizer.state === 78) {
    n.parser.tokenizer.preprocessor.lastChunkWritten = !0;
    const t = n.parser.tokenizer._consume();
    n.parser.tokenizer._callState(t);
  }
}
function RK(e, n) {
  const t = (
    /** @type {Nodes} */
    e
  );
  if (n.options.passThrough && n.options.passThrough.includes(t.type))
    OK(t, n);
  else {
    let i = "";
    throw SK.has(t.type) && (i = ". It looks like you are using MDX nodes with `hast-util-raw` (or `rehype-raw`). If you use this because you are using remark or rehype plugins that inject `'html'` nodes, then please raise an issue with that plugin, as its a bad and slow idea. If you use this because you are using markdown syntax, then you have to configure this utility (or plugin) to pass through these nodes (see `passThrough` in docs), but you can also migrate to use the MDX syntax"), new Error("Cannot compile `" + t.type + "` node" + i);
  }
}
function wo(e, n) {
  PA(e, n);
  const t = e.parser.tokenizer.currentCharacterToken;
  t && t.location && (t.location.endLine = e.parser.tokenizer.preprocessor.line, t.location.endCol = e.parser.tokenizer.preprocessor.col + 1, t.location.endOffset = e.parser.tokenizer.preprocessor.offset + 1, e.parser.currentToken = t, e.parser._processToken(e.parser.currentToken)), e.parser.tokenizer.paused = !1, e.parser.tokenizer.inLoop = !1, e.parser.tokenizer.active = !1, e.parser.tokenizer.returnState = wt.DATA, e.parser.tokenizer.charRefCode = -1, e.parser.tokenizer.consumedAfterSnapshot = -1, e.parser.tokenizer.currentLocation = null, e.parser.tokenizer.currentCharacterToken = null, e.parser.tokenizer.currentToken = null, e.parser.tokenizer.currentAttr = { name: "", value: "" };
}
function PA(e, n) {
  if (n && n.offset !== void 0) {
    const t = {
      startLine: n.line,
      startCol: n.column,
      startOffset: n.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    e.parser.tokenizer.preprocessor.lineStartPos = -n.column + 1, e.parser.tokenizer.preprocessor.droppedBufferSize = n.offset, e.parser.tokenizer.preprocessor.line = n.line, e.parser.tokenizer.currentLocation = t;
  }
}
function LK(e, n) {
  const t = e.tagName.toLowerCase();
  if (n.parser.tokenizer.state === wt.PLAINTEXT) return;
  wo(n, vi(e));
  const i = n.parser.openElements.current;
  let r = "namespaceURI" in i ? i.namespaceURI : Gr.html;
  r === Gr.html && t === "svg" && (r = Gr.svg);
  const s = Wq(
    // Shallow clone to not delve into `children`: we only need the attributes.
    { ...e, children: [] },
    { space: r === Gr.svg ? "svg" : "html" }
  ), o = {
    type: Le.START_TAG,
    tagName: t,
    tagID: yo(t),
    // We always send start and end tags.
    selfClosing: !1,
    ackSelfClosing: !1,
    // Always element.
    /* c8 ignore next */
    attrs: "attrs" in s ? s.attrs : [],
    location: pu(e)
  };
  n.parser.currentToken = o, n.parser._processToken(n.parser.currentToken), n.parser.tokenizer.lastStartTagName = t;
}
function DK(e, n) {
  const t = e.tagName.toLowerCase();
  if (!n.parser.tokenizer.inForeignNode && F2.includes(t) || n.parser.tokenizer.state === wt.PLAINTEXT) return;
  wo(n, bc(e));
  const i = {
    type: Le.END_TAG,
    tagName: t,
    tagID: yo(t),
    selfClosing: !1,
    ackSelfClosing: !1,
    attrs: [],
    location: pu(e)
  };
  n.parser.currentToken = i, n.parser._processToken(n.parser.currentToken), // Current element is closed.
  t === n.parser.tokenizer.lastStartTagName && // `<textarea>` and `<title>`
  (n.parser.tokenizer.state === wt.RCDATA || // `<iframe>`, `<noembed>`, `<noframes>`, `<style>`, `<xmp>`
  n.parser.tokenizer.state === wt.RAWTEXT || // `<script>`
  n.parser.tokenizer.state === wt.SCRIPT_DATA) && (n.parser.tokenizer.state = wt.DATA);
}
function MK(e) {
  const n = e.type === "root" ? e.children[0] : e;
  return !!(n && (n.type === "doctype" || n.type === "element" && n.tagName.toLowerCase() === "html"));
}
function pu(e) {
  const n = vi(e) || {
    line: void 0,
    column: void 0,
    offset: void 0
  }, t = bc(e) || {
    line: void 0,
    column: void 0,
    offset: void 0
  };
  return {
    startLine: n.line,
    startCol: n.column,
    startOffset: n.offset,
    endLine: t.line,
    endCol: t.column,
    endOffset: t.offset
  };
}
function BK(e) {
  return "children" in e ? Yi({ ...e, children: [] }) : Yi(e);
}
function OA(e) {
  return function(n, t) {
    return (
      /** @type {Root} */
      IA(n, { ...e, file: t })
    );
  };
}
const zr = ["ariaDescribedBy", "ariaLabel", "ariaLabelledBy"], Aa = {
  ancestors: {
    tbody: ["table"],
    td: ["table"],
    th: ["table"],
    thead: ["table"],
    tfoot: ["table"],
    tr: ["table"]
  },
  attributes: {
    a: [
      ...zr,
      // Note: these 3 are used by GFM footnotes, they do work on all links.
      "dataFootnoteBackref",
      "dataFootnoteRef",
      ["className", "data-footnote-backref"],
      "href"
    ],
    blockquote: ["cite"],
    // Note: this class is not normally allowed by GH, when manually writing
    // `code` as HTML in markdown, they adds it some other way.
    // We can’t do that, so we have to allow it.
    code: [["className", /^language-./]],
    del: ["cite"],
    div: ["itemScope", "itemType"],
    dl: [...zr],
    // Note: this is used by GFM footnotes.
    h2: [["className", "sr-only"]],
    img: [...zr, "longDesc", "src"],
    // Note: `input` is not normally allowed by GH, when manually writing
    // it in markdown, they add it from tasklists some other way.
    // We can’t do that, so we have to allow it.
    input: [
      ["disabled", !0],
      ["type", "checkbox"]
    ],
    ins: ["cite"],
    // Note: this class is not normally allowed by GH, when manually writing
    // `li` as HTML in markdown, they adds it some other way.
    // We can’t do that, so we have to allow it.
    li: [["className", "task-list-item"]],
    // Note: this class is not normally allowed by GH, when manually writing
    // `ol` as HTML in markdown, they adds it some other way.
    // We can’t do that, so we have to allow it.
    ol: [...zr, ["className", "contains-task-list"]],
    q: ["cite"],
    section: ["dataFootnotes", ["className", "footnotes"]],
    source: ["srcSet"],
    summary: [...zr],
    table: [...zr],
    // Note: this class is not normally allowed by GH, when manually writing
    // `ol` as HTML in markdown, they adds it some other way.
    // We can’t do that, so we have to allow it.
    ul: [...zr, ["className", "contains-task-list"]],
    "*": [
      "abbr",
      "accept",
      "acceptCharset",
      "accessKey",
      "action",
      "align",
      "alt",
      "axis",
      "border",
      "cellPadding",
      "cellSpacing",
      "char",
      "charOff",
      "charSet",
      "checked",
      "clear",
      "colSpan",
      "color",
      "cols",
      "compact",
      "coords",
      "dateTime",
      "dir",
      // Note: `disabled` is technically allowed on all elements by GH.
      // But it is useless on everything except `input`.
      // Because `input`s are normally not allowed, but we allow them for
      // checkboxes due to tasklists, we allow `disabled` only there.
      "encType",
      "frame",
      "hSpace",
      "headers",
      "height",
      "hrefLang",
      "htmlFor",
      "id",
      "isMap",
      "itemProp",
      "label",
      "lang",
      "maxLength",
      "media",
      "method",
      "multiple",
      "name",
      "noHref",
      "noShade",
      "noWrap",
      "open",
      "prompt",
      "readOnly",
      "rev",
      "rowSpan",
      "rows",
      "rules",
      "scope",
      "selected",
      "shape",
      "size",
      "span",
      "start",
      "summary",
      "tabIndex",
      "title",
      "useMap",
      "vAlign",
      "value",
      "width"
    ]
  },
  clobber: ["ariaDescribedBy", "ariaLabelledBy", "id", "name"],
  clobberPrefix: "user-content-",
  protocols: {
    cite: ["http", "https"],
    href: ["http", "https", "irc", "ircs", "mailto", "xmpp"],
    longDesc: ["http", "https"],
    src: ["http", "https"]
  },
  required: {
    input: { disabled: !0, type: "checkbox" }
  },
  strip: ["script"],
  tagNames: [
    "a",
    "b",
    "blockquote",
    "br",
    "code",
    "dd",
    "del",
    "details",
    "div",
    "dl",
    "dt",
    "em",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr",
    "i",
    "img",
    // Note: `input` is not normally allowed by GH, when manually writing
    // it in markdown, they add it from tasklists some other way.
    // We can’t do that, so we have to allow it.
    "input",
    "ins",
    "kbd",
    "li",
    "ol",
    "p",
    "picture",
    "pre",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "section",
    "source",
    "span",
    "strike",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "tt",
    "ul",
    "var"
  ]
}, dr = {}.hasOwnProperty;
function FK(e, n) {
  let t = { type: "root", children: [] };
  const i = {
    schema: n ? { ...Aa, ...n } : Aa,
    stack: []
  }, r = NA(i, e);
  return r && (Array.isArray(r) ? r.length === 1 ? t = r[0] : t.children = r : t = r), t;
}
function NA(e, n) {
  if (n && typeof n == "object") {
    const t = (
      /** @type {Record<string, Readonly<unknown>>} */
      n
    );
    switch (typeof t.type == "string" ? t.type : "") {
      case "comment":
        return UK(e, t);
      case "doctype":
        return HK(e, t);
      case "element":
        return VK(e, t);
      case "root":
        return $K(e, t);
      case "text":
        return WK(e, t);
    }
  }
}
function UK(e, n) {
  if (e.schema.allowComments) {
    const t = typeof n.value == "string" ? n.value : "", i = t.indexOf("-->"), s = { type: "comment", value: i < 0 ? t : t.slice(0, i) };
    return gu(s, n), s;
  }
}
function HK(e, n) {
  if (e.schema.allowDoctypes) {
    const t = { type: "doctype" };
    return gu(t, n), t;
  }
}
function VK(e, n) {
  const t = typeof n.tagName == "string" ? n.tagName : "";
  e.stack.push(t);
  const i = (
    /** @type {Array<ElementContent>} */
    RA(e, n.children)
  ), r = zK(e, n.properties);
  e.stack.pop();
  let s = !1;
  if (t && t !== "*" && (!e.schema.tagNames || e.schema.tagNames.includes(t)) && (s = !0, e.schema.ancestors && dr.call(e.schema.ancestors, t))) {
    const a = e.schema.ancestors[t];
    let u = -1;
    for (s = !1; ++u < a.length; )
      e.stack.includes(a[u]) && (s = !0);
  }
  if (!s)
    return e.schema.strip && !e.schema.strip.includes(t) ? i : void 0;
  const o = {
    type: "element",
    tagName: t,
    properties: r,
    children: i
  };
  return gu(o, n), o;
}
function $K(e, n) {
  const i = { type: "root", children: (
    /** @type {Array<RootContent>} */
    RA(e, n.children)
  ) };
  return gu(i, n), i;
}
function WK(e, n) {
  const i = { type: "text", value: typeof n.value == "string" ? n.value : "" };
  return gu(i, n), i;
}
function RA(e, n) {
  const t = [];
  if (Array.isArray(n)) {
    const i = (
      /** @type {Array<Readonly<unknown>>} */
      n
    );
    let r = -1;
    for (; ++r < i.length; ) {
      const s = NA(e, i[r]);
      s && (Array.isArray(s) ? t.push(...s) : t.push(s));
    }
  }
  return t;
}
function zK(e, n) {
  const t = e.stack[e.stack.length - 1], i = e.schema.attributes, r = e.schema.required, s = i && dr.call(i, t) ? i[t] : void 0, o = i && dr.call(i, "*") ? i["*"] : void 0, a = (
    /** @type {Readonly<Record<string, Readonly<unknown>>>} */
    n && typeof n == "object" ? n : {}
  ), u = {};
  let l;
  for (l in a)
    if (dr.call(a, l)) {
      const c = a[l];
      let d = q1(
        e,
        Y1(s, l),
        l,
        c
      );
      d == null && (d = q1(e, Y1(o, l), l, c)), d != null && (u[l] = d);
    }
  if (r && dr.call(r, t)) {
    const c = r[t];
    for (l in c)
      dr.call(c, l) && !dr.call(u, l) && (u[l] = c[l]);
  }
  return u;
}
function q1(e, n, t, i) {
  return n ? Array.isArray(i) ? qK(e, n, t, i) : LA(e, n, t, i) : void 0;
}
function qK(e, n, t, i) {
  let r = -1;
  const s = [];
  for (; ++r < i.length; ) {
    const o = LA(e, n, t, i[r]);
    (typeof o == "number" || typeof o == "string") && s.push(o);
  }
  return s;
}
function LA(e, n, t, i) {
  if (!(typeof i != "boolean" && typeof i != "number" && typeof i != "string") && YK(e, t, i)) {
    if (typeof n == "object" && n.length > 1) {
      let r = !1, s = 0;
      for (; ++s < n.length; ) {
        const o = n[s];
        if (o && typeof o == "object" && "flags" in o) {
          if (o.test(String(i))) {
            r = !0;
            break;
          }
        } else if (o === i) {
          r = !0;
          break;
        }
      }
      if (!r) return;
    }
    return e.schema.clobber && e.schema.clobberPrefix && e.schema.clobber.includes(t) ? e.schema.clobberPrefix + i : i;
  }
}
function YK(e, n, t) {
  const i = e.schema.protocols && dr.call(e.schema.protocols, n) ? e.schema.protocols[n] : void 0;
  if (!i || i.length === 0)
    return !0;
  const r = String(t), s = r.indexOf(":"), o = r.indexOf("?"), a = r.indexOf("#"), u = r.indexOf("/");
  if (s < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
  u > -1 && s > u || o > -1 && s > o || a > -1 && s > a)
    return !0;
  let l = -1;
  for (; ++l < i.length; ) {
    const c = i[l];
    if (s === c.length && r.slice(0, c.length) === c)
      return !0;
  }
  return !1;
}
function gu(e, n) {
  const t = Am(
    // @ts-expect-error: looks like a node.
    n
  );
  n.data && (e.data = Yi(n.data)), t && (e.position = t);
}
function Y1(e, n) {
  let t, i = -1;
  if (e)
    for (; ++i < e.length; ) {
      const r = e[i], s = typeof r == "string" ? r : r[0];
      if (s === n)
        return r;
      s === "data*" && (t = r);
    }
  if (n.length > 4 && n.slice(0, 4).toLowerCase() === "data")
    return t;
}
function DA(e) {
  return function(n) {
    return (
      /** @type {Root} */
      FK(n, e)
    );
  };
}
const MA = {
  ...Aa,
  attributes: {
    ...Aa.attributes,
    span: [
      ["className", "mention"],
      ["dataMention", /.+/]
    ],
    p: [
      ["style", /text-align:.+?/]
    ]
  },
  tagNames: [
    ...Aa.tagNames,
    "u"
  ]
};
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
class jK {
  /**
   * Creates a new instance of the Markdown data processor class.
   */
  constructor(n) {
    /**
     * HTML data processor used to process HTML produced by the Markdown-to-HTML converter and the other way.
     */
    m(this, "_htmlDP");
    this._htmlDP = new CT(n);
  }
  /**
   * Keeps the specified element in the output as HTML. This is useful if the editor contains
   * features producing HTML that is not a part of the Markdown standard.
   *
   * By default, all HTML tags are removed.
   *
   * @param element The element name to be kept.
   */
  keepHtml(n) {
  }
  /**
   * Converts the provided Markdown string to a view tree.
   *
   * @param data A Markdown string.
   * @returns The converted view element.
   */
  toView(n) {
    const t = String(Qh().data("settings", { fragment: !0 }).use(Lw).use(tf).use(vw, { allowDangerousHtml: !0 }).use(OA).use(DA, MA).use(Pq).processSync(n));
    return this._htmlDP.toView(String(t));
  }
  /**
   * Converts the provided {@link module:engine/view/documentfragment~DocumentFragment} to data format &ndash; in this
   * case to a Markdown string.
   *
   * @returns Markdown string.
   */
  toData(n) {
    const t = /text-align:(justify|center|right);/, i = (a, u) => {
      var c;
      if (console.log("mentionHandler", u.tagName), u.tagName !== "span" && ((c = u.properties.className) == null ? void 0 : c[0]) !== "mention")
        return Ll(u);
      const l = {
        type: "html",
        value: sl(u)
      };
      return a.patch(u, l), l;
    }, r = (a, u, l) => {
      console.log("alginmentHandler", u.tagName);
      const c = () => {
        const b = {
          type: "paragraph",
          // @ts-ignore
          children: a.all(u)
        };
        return a.patch(u, b), b;
      };
      if (!u.properties.style || t.exec(u.properties.style).length === 0)
        return c();
      u.properties.style = t.exec(u.properties.style)[0];
      const p = {
        type: "html",
        value: sl(u)
      };
      return a.patch(u, p), p;
    }, s = this._htmlDP.toData(n);
    return String(Qh().data("settings", { fragment: !0 }).use(xz).use(EV, {
      handlers: {
        span: i,
        p: r,
        u: (a, u) => {
          u.properties = void 0;
          const l = {
            type: "html",
            value: sl(u)
          };
          return a.patch(u, l), l;
        }
      },
      nodeHandlers: {
        text: (a, u) => Ll(u)
      }
    }).use(tf).use(SU).processSync(s));
  }
  /**
   * Registers a {@link module:engine/view/matcher~MatcherPattern} for view elements whose content should be treated as raw data
   * and not processed during the conversion from Markdown to view elements.
   *
   * The raw data can be later accessed by a
   * {@link module:engine/view/element~Element#getCustomProperty custom property of a view element} called `"$rawContent"`.
   *
   * @param pattern The pattern matching all view elements whose content should
   * be treated as raw data.
   */
  registerRawContentMatcher(n) {
    this._htmlDP.registerRawContentMatcher(n);
  }
  /**
   * This method does not have any effect on the data processor result. It exists for compatibility with the
   * {@link module:engine/dataprocessor/dataprocessor~DataProcessor `DataProcessor` interface}.
   */
  useFillerType() {
  }
}
let KK = class extends ce {
  constructor(n) {
    super(n), n.data.processor = new jK(n.data.viewDocument);
  }
  static get pluginName() {
    return "Markdown";
  }
};
class Km extends yD {
}
Km.builtinPlugins = [
  rL,
  PL,
  MD,
  EL,
  wL,
  SL,
  HL,
  WD,
  yM,
  GM,
  Il,
  _8,
  KK
];
Km.defaultConfig = {
  toolbar: {
    items: [
      "bold",
      "underline",
      "italic",
      "bulletedList",
      "numberedList",
      "alignment"
    ]
  },
  language: "en",
  placeholder: "To tag a user, type the @ symbol and begin typing."
};
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function GK() {
  const e = {
    resolve: null,
    promise: null
  };
  return e.promise = new Promise((n) => {
    e.resolve = n;
  }), e;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function QK(e) {
  let n = null;
  return (...t) => (n || (n = {
    current: e(...t)
  }), n.current);
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const Gt = new Array(256).fill("").map((e, n) => ("0" + n.toString(16)).slice(-2));
function XK() {
  const [e, n, t, i] = crypto.getRandomValues(new Uint32Array(4));
  return "e" + Gt[e >> 0 & 255] + Gt[e >> 8 & 255] + Gt[e >> 16 & 255] + Gt[e >> 24 & 255] + Gt[n >> 0 & 255] + Gt[n >> 8 & 255] + Gt[n >> 16 & 255] + Gt[n >> 24 & 255] + Gt[t >> 0 & 255] + Gt[t >> 8 & 255] + Gt[t >> 16 & 255] + Gt[t >> 24 & 255] + Gt[i >> 0 & 255] + Gt[i >> 8 & 255] + Gt[i >> 16 & 255] + Gt[i >> 24 & 255];
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function JK(e, n) {
  const t = e.extraPlugins || [];
  return {
    ...e,
    extraPlugins: [
      ...t,
      ...n.filter((i) => !t.includes(i))
    ]
  };
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function BA(e) {
  return !!e && /^\d+\.\d+\.\d+/.test(e);
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function FA(e) {
  return e ? ["nightly", "alpha", "internal", "nightly-", "staging"].some((n) => e.includes(n)) : !1;
}
function ZK(e) {
  return BA(e) || FA(e);
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function eG(e) {
  if (!BA(e))
    throw new Error(`Invalid semantic version: ${e || "<blank>"}.`);
  const [n, t, i] = e.split(".");
  return {
    major: Number.parseInt(n, 10),
    minor: Number.parseInt(t, 10),
    patch: Number.parseInt(i, 10)
  };
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function tG(e) {
  if (FA(e))
    return 3;
  const { major: n } = eG(e);
  switch (!0) {
    case n >= 44:
      return 3;
    case n >= 38:
      return 2;
    default:
      return 1;
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function nG() {
  const { CKEDITOR_VERSION: e, CKEDITOR: n } = window;
  return ZK(e) ? {
    source: n ? "cdn" : "npm",
    version: e
  } : null;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function iG() {
  const e = nG();
  return e ? tG(e.version) : null;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function UA(e, n) {
  switch (n || (n = iG() || void 0), n) {
    case 1:
    case 2:
      return e === void 0;
    case 3:
      return e === "GPL";
    default:
      return !1;
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function rG(e, n) {
  return function(i) {
    UA(i.config.get("licenseKey")) || i.on("collectUsageData", (r, { setUsageData: s }) => {
      s(`integration.${e}`, n);
    });
  };
}
var sG = Object.defineProperty, oG = (e, n, t) => n in e ? sG(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, pn = (e, n, t) => oG(e, typeof n != "symbol" ? n + "" : n, t);
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const HA = class VA {
  constructor(n, t) {
    pn(this, "_lifecycle"), pn(this, "_element"), pn(this, "_releaseLock", null), pn(this, "_value", null), pn(this, "_afterMountCallbacks", []), pn(this, "_state", {
      destroyedBeforeInitialization: !1,
      mountingInProgress: null
    }), pn(this, "release", QK(() => {
      const { _releaseLock: i, _state: r, _element: s, _lifecycle: o } = this;
      r.mountingInProgress ? r.mountingInProgress.then(() => o.unmount({
        element: s,
        // Mount result might be overridden by watchdog during restart so use instance variable.
        mountResult: this.value
      })).catch((a) => {
        console.error("Semaphore unmounting error:", a);
      }).then(i.resolve).then(() => {
        this._value = null;
      }) : (r.destroyedBeforeInitialization = !0, i.resolve());
    })), this._element = n, this._lifecycle = t, this._lock();
  }
  /**
   * Getter for {@link #_value}.
   */
  get value() {
    return this._value;
  }
  /**
   * Occasionally, the Watchdog restarts the editor instance, resulting in a new instance being assigned to the semaphore.
   * In terms of race conditions, it's generally safer to simply override the semaphore value rather than recreating it
   * with a different one.
   */
  unsafeSetValue(n) {
    this._value = n, this._afterMountCallbacks.forEach((t) => t(n)), this._afterMountCallbacks = [];
  }
  /**
   * This registers a callback that will be triggered after the editor has been successfully mounted.
   *
   * 	* If the editor is already mounted, the callback will be executed immediately.
   *	* If the editor is in the process of mounting, the callback will be executed upon successful mounting.
  * 	* If the editor is never mounted, the passed callback will not be executed.
  * 	* If an exception is thrown within the callback, it will be re-thrown in the semaphore.
  */
  runAfterMount(n) {
    const { _value: t, _afterMountCallbacks: i } = this;
    t ? n(t) : i.push(n);
  }
  /**
   * This method is used to inform other components that the {@link #_element} will be used by the editor,
   * which is initialized by the {@link #_lifecycle} methods.
   *
   * 	* If an editor is already present on the provided element, the initialization of the current one
   * 	  will be postponed until the previous one is destroyed.
   *
   * 	* If the element is empty and does not have an editor attached to it, the currently locked editor will
   * 	  be mounted immediately.
   *
   * After the successful initialization of the editor and the assignment of the {@link #_value} member,
   * the `onReady` lifecycle method is called.
   *
   * *Important note:*
   *
   * It’s really important to keep this method *sync*. If we make this method *async*, it won’t work well because
   * it will cause problems when we’re trying to set up the {@link LifeCycleEditorElementSemaphore#_semaphores} map entries.
   */
  _lock() {
    const { _semaphores: n } = VA, { _state: t, _element: i, _lifecycle: r } = this, s = n.get(i) || Promise.resolve(null), o = GK();
    this._releaseLock = o;
    const a = s.then(() => t.destroyedBeforeInitialization ? Promise.resolve(void 0) : (t.mountingInProgress = r.mount().then((u) => (u && this.unsafeSetValue(u), u)), t.mountingInProgress)).then(async (u) => {
      u && r.afterMount && await r.afterMount({
        element: i,
        mountResult: u
      });
    }).then(() => o.promise).catch((u) => {
      console.error("Semaphore mounting error:", u);
    }).then(() => {
      n.get(i) === a && n.delete(i);
    });
    n.set(i, a);
  }
};
pn(HA, "_semaphores", /* @__PURE__ */ new Map());
let aG = HA;
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const uG = "$__CKEditorReactContextMetadata";
function lG(e, n) {
  return {
    ...n,
    [uG]: e
  };
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const cG = Hi.createContext(null), dG = (e) => !!e && typeof e == "object" && "status" in e && ["initializing", "initialized", "error"].includes(e.status), $A = (e) => (n) => dG(n) && n.status === e, j1 = $A("initializing"), hG = (e) => $A("initialized")(e) && e.watchdog.state === "ready";
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const fG = rG(
  "react",
  {
    version: "9.5.0",
    frameworkVersion: Hi.version
  }
);
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function mG(e) {
  return UA(e.licenseKey) ? e : JK(e, [
    /**
     * This part of the code is not executed in open-source implementations using a GPL key.
     * It only runs when a specific license key is provided. If you are uncertain whether
     * this applies to your installation, please contact our support team.
     */
    fG
  ]);
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const eh = "Lock from React integration (@ckeditor/ckeditor5-react)";
class WA extends Hi.Component {
  constructor(n) {
    super(n), pn(this, "domContainer", Hi.createRef()), pn(this, "editorSemaphore", null), this._checkVersion();
  }
  /**
   * Checks if the CKEditor version used in the application is compatible with the component.
   */
  _checkVersion() {
    const { CKEDITOR_VERSION: n } = window;
    if (!n)
      return console.warn('Cannot find the "CKEDITOR_VERSION" in the "window" scope.');
    const [t] = n.split(".").map(Number);
    t >= 42 || n.startsWith("0.0.0") || console.warn("The <CKEditor> component requires using CKEditor 5 in version 42+ or nightly build.");
  }
  get _semaphoreValue() {
    const { editorSemaphore: n } = this;
    return n ? n.value : null;
  }
  /**
   * An watchdog instance.
   */
  get watchdog() {
    const { _semaphoreValue: n } = this;
    return n ? n.watchdog : null;
  }
  /**
   * An editor instance.
   */
  get editor() {
    const { _semaphoreValue: n } = this;
    return n ? n.instance : null;
  }
  /**
   * The CKEditor component should not be updated by React itself.
   * However, if the component identifier changes, the whole structure should be created once again.
   */
  shouldComponentUpdate(n) {
    const { props: t, editorSemaphore: i } = this;
    return n.id !== t.id || n.disableWatchdog !== t.disableWatchdog ? !0 : (i && (i.runAfterMount(({ instance: r }) => {
      this._shouldUpdateEditorData(t, n, r) && r.data.set(n.data);
    }), "disabled" in n && i.runAfterMount(({ instance: r }) => {
      n.disabled ? r.enableReadOnlyMode(eh) : r.disableReadOnlyMode(eh);
    })), !1);
  }
  /**
   * Initialize the editor when the component is mounted.
   */
  componentDidMount() {
    j1(this.context) || this._initLifeCycleSemaphore();
  }
  /**
   * Re-render the entire component once again. The old editor will be destroyed and the new one will be created.
   */
  componentDidUpdate() {
    j1(this.context) || this._initLifeCycleSemaphore();
  }
  /**
   * Destroy the editor before unmounting the component.
   */
  componentWillUnmount() {
    this._unlockLifeCycleSemaphore();
  }
  /**
   * Async destroy attached editor and unlock element semaphore.
   */
  _unlockLifeCycleSemaphore() {
    this.editorSemaphore && (this.editorSemaphore.release(), this.editorSemaphore = null);
  }
  /**
   * Unlocks previous editor semaphore and creates new one..
   */
  _initLifeCycleSemaphore() {
    this._unlockLifeCycleSemaphore(), this.editorSemaphore = new aG(this.domContainer.current, {
      mount: async () => this._initializeEditor(),
      afterMount: ({ mountResult: n }) => {
        const { onReady: t } = this.props;
        t && this.domContainer.current !== null && t(n.instance);
      },
      unmount: async ({ element: n, mountResult: t }) => {
        const { onAfterDestroy: i } = this.props;
        try {
          await this._destroyEditor(t), n.innerHTML = "";
        } finally {
          i && i(t.instance);
        }
      }
    });
  }
  /**
   * Render a <div> element which will be replaced by CKEditor.
   */
  render() {
    return /* @__PURE__ */ Hi.createElement("div", { ref: this.domContainer });
  }
  /**
   * Initializes the editor by creating a proper watchdog and initializing it with the editor's configuration.
   */
  async _initializeEditor() {
    if (this.props.disableWatchdog)
      return {
        instance: await this._createEditor(this.domContainer.current, this._getConfig()),
        watchdog: null
      };
    const n = hG(this.context) ? new pG(this.context.watchdog) : new this.props.editor.EditorWatchdog(this.props.editor, this.props.watchdogConfig), t = {
      current: 0
    };
    return n.setCreator(async (i, r) => {
      var s;
      const { editorSemaphore: o } = this, { onAfterDestroy: a } = this.props;
      t.current > 0 && a && ((s = o == null ? void 0 : o.value) != null && s.instance) && a(o.value.instance);
      const u = await this._createEditor(i, r);
      return o && t.current > 0 && (o.unsafeSetValue({
        instance: u,
        watchdog: n
      }), setTimeout(() => {
        this.props.onReady && this.props.onReady(n.editor);
      })), t.current++, u;
    }), n.on("error", (i, { error: r, causesRestart: s }) => {
      (this.props.onError || console.error)(r, { phase: "runtime", willEditorRestart: s });
    }), await n.create(this.domContainer.current, this._getConfig()).catch((i) => {
      (this.props.onError || console.error)(i, { phase: "initialization", willEditorRestart: !1 });
    }), {
      watchdog: n,
      instance: n.editor
    };
  }
  /**
   * Creates an editor from the element and configuration.
   *
   * @param element The source element.
   * @param config CKEditor 5 editor configuration.
   */
  _createEditor(n, t) {
    const { contextItemMetadata: i } = this.props;
    return i && (t = lG(i, t)), this.props.editor.create(
      n,
      mG(t)
    ).then((r) => {
      if ("disabled" in this.props) {
        /* istanbul ignore else -- @preserve */
        this.props.disabled && r.enableReadOnlyMode(eh);
      }
      const s = r.model.document, o = r.editing.view.document;
      return s.on("change:data", (a) => {
        /* istanbul ignore else -- @preserve */
        this.props.onChange && this.props.onChange(a, r);
      }), o.on("focus", (a) => {
        /* istanbul ignore else -- @preserve */
        this.props.onFocus && this.props.onFocus(a, r);
      }), o.on("blur", (a) => {
        /* istanbul ignore else -- @preserve */
        this.props.onBlur && this.props.onBlur(a, r);
      }), r;
    });
  }
  /**
   * Destroys the editor by destroying the watchdog.
   */
  async _destroyEditor(n) {
    const { watchdog: t, instance: i } = n;
    return new Promise((r, s) => {
      /* istanbul ignore next -- @preserve */
      setTimeout(async () => {
        try {
          if (t)
            return await t.destroy(), r();
          if (i)
            return await i.destroy(), r();
          r();
        } catch (o) {
          console.error(o), s(o);
        }
      });
    });
  }
  /**
   * Returns true when the editor should be updated.
   *
   * @param prevProps Previous react's properties.
   * @param nextProps React's properties.
   * @param editor Current editor instance.
   */
  _shouldUpdateEditorData(n, t, i) {
    return !(n.data === t.data || i.data.get() === t.data);
  }
  /**
   * Returns the editor configuration.
   */
  _getConfig() {
    const n = this.props.config || {};
    return this.props.data && n.initialData && console.warn(
      "Editor data should be provided either using `config.initialData` or `content` property. The config value takes precedence over `content` property and will be used when both are specified."
    ), {
      ...n,
      initialData: n.initialData || this.props.data || ""
    };
  }
}
pn(WA, "contextType", cG);
class pG {
  /**
   * @param contextWatchdog The context watchdog instance that will be wrapped into editor watchdog API.
   */
  constructor(n) {
    pn(this, "_contextWatchdog"), pn(this, "_id"), pn(this, "_creator"), this._contextWatchdog = n, this._id = XK();
  }
  /**
   *  @param creator A watchdog's editor creator function.
   */
  setCreator(n) {
    this._creator = n;
  }
  /**
   * Adds an editor configuration to the context watchdog registry. Creates an instance of it.
   *
   * @param sourceElementOrData A source element or data for the new editor.
   * @param config CKEditor 5 editor config.
   */
  create(n, t) {
    return this._contextWatchdog.add({
      sourceElementOrData: n,
      config: t,
      creator: this._creator,
      id: this._id,
      type: "editor"
    });
  }
  /**
   * Creates a listener that is attached to context watchdog's item and run when the context watchdog fires.
   * Currently works only for the `error` event.
   */
  on(n, t) {
    this._contextWatchdog.on("itemError", (i, { itemId: r, error: s }) => {
      r === this._id && t(null, { error: s, causesRestart: void 0 });
    });
  }
  destroy() {
    return this._contextWatchdog.state === "ready" ? this._contextWatchdog.remove(this._id) : Promise.resolve();
  }
  /**
   * An editor instance.
   */
  get editor() {
    return this._contextWatchdog.getItem(this._id);
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function zA(...e) {
  return (n) => {
    e.forEach((t) => {
      typeof t == "function" ? t(n) : t != null && (t.current = n);
    });
  };
}
const gG = BC(Cf(({ id: e, semaphore: n, rootName: t }, i) => {
  const r = O_(null);
  return N_(() => {
    let s, o;
    return n.runAfterMount(({ instance: a }) => {
      if (!r.current)
        return;
      o = a;
      const { ui: u, model: l } = o, c = l.document.getRoot(t);
      c && o.ui.getEditableElement(t) && o.detachEditable(c), s = u.view.createEditable(t, r.current), u.addEditable(s), a.editing.view.forceRender();
    }), () => {
      if (o && o.state !== "destroyed" && r.current) {
        const a = o.model.document.getRoot(t);
        /* istanbul ignore else -- @preserve */
        a && o.detachEditable(a);
      }
    };
  }, [n.revision]), /* @__PURE__ */ Hi.createElement(
    "div",
    {
      key: n.revision,
      id: e,
      ref: zA(i, r)
    }
  );
}));
gG.displayName = "EditorEditable";
const bG = Cf(({ editor: e }, n) => {
  const t = O_(null);
  return N_(() => {
    const i = t.current;
    if (!e || !i)
      return;
    const r = e.ui.view.toolbar.element;
    return i.appendChild(r), () => {
      i.contains(r) && i.removeChild(r);
    };
  }, [e && e.id]), /* @__PURE__ */ Hi.createElement("div", { ref: zA(t, n) });
});
bG.displayName = "EditorToolbarWrapper";
const ZZ = (e) => {
  const {
    config: n,
    data: t,
    onReady: i,
    onChange: r,
    onBlur: s,
    onFocus: o,
    onEscape: a,
    autoFocus: u = !1
  } = e, l = qt.useRef(null), c = qt.useCallback((p) => {
    p.key === "Escape" && a && (p.preventDefault(), a());
  }, [a]), d = qt.useCallback((p) => {
    l.current = p;
    const g = p.ui.getEditableElement();
    g && g.addEventListener("keydown", c), u && p.editing.view.focus(), i && i(p);
  }, [u, c, i]);
  return qt.useEffect(() => () => {
    if (l.current) {
      const g = l.current.ui.getEditableElement();
      g && g.removeEventListener("keydown", c);
    }
  }, [c]), /* @__PURE__ */ Qr.jsx(
    WA,
    {
      editor: Km,
      config: {
        licenseKey: "GPL",
        ...n
      },
      data: t,
      onReady: d,
      onChange: r,
      onBlur: s,
      onFocus: o
    }
  );
}, ja = {
  black: "#000",
  white: "#fff"
}, Os = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, Ns = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, Rs = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, Ls = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, Ds = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
}, Ko = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, _G = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
function Ka(e) {
  let n = "https://mui.com/production-error/?code=" + e;
  for (let t = 1; t < arguments.length; t += 1)
    n += "&args[]=" + encodeURIComponent(arguments[t]);
  return "Minified MUI error #" + e + "; visit " + n + " for the full message.";
}
const EG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ka
}, Symbol.toStringTag, { value: "Module" })), TG = "$$material";
function ht() {
  return ht = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var i in t) ({}).hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, ht.apply(null, arguments);
}
function Pr(e, n) {
  if (e == null) return {};
  var t = {};
  for (var i in e) if ({}.hasOwnProperty.call(e, i)) {
    if (n.indexOf(i) !== -1) continue;
    t[i] = e[i];
  }
  return t;
}
function yG(e) {
  if (e.sheet)
    return e.sheet;
  for (var n = 0; n < document.styleSheets.length; n++)
    if (document.styleSheets[n].ownerNode === e)
      return document.styleSheets[n];
}
function wG(e) {
  var n = document.createElement("style");
  return n.setAttribute("data-emotion", e.key), e.nonce !== void 0 && n.setAttribute("nonce", e.nonce), n.appendChild(document.createTextNode("")), n.setAttribute("data-s", ""), n;
}
var AG = /* @__PURE__ */ function() {
  function e(t) {
    var i = this;
    this._insertTag = function(r) {
      var s;
      i.tags.length === 0 ? i.insertionPoint ? s = i.insertionPoint.nextSibling : i.prepend ? s = i.container.firstChild : s = i.before : s = i.tags[i.tags.length - 1].nextSibling, i.container.insertBefore(r, s), i.tags.push(r);
    }, this.isSpeedy = t.speedy === void 0 ? !0 : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var n = e.prototype;
  return n.hydrate = function(i) {
    i.forEach(this._insertTag);
  }, n.insert = function(i) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(wG(this));
    var r = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var s = yG(r);
      try {
        s.insertRule(i, s.cssRules.length);
      } catch {
      }
    } else
      r.appendChild(document.createTextNode(i));
    this.ctr++;
  }, n.flush = function() {
    this.tags.forEach(function(i) {
      var r;
      return (r = i.parentNode) == null ? void 0 : r.removeChild(i);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Qt = "-ms-", Vl = "-moz-", $e = "-webkit-", qA = "comm", Gm = "rule", Qm = "decl", CG = "@import", YA = "@keyframes", kG = "@layer", SG = Math.abs, Pc = String.fromCharCode, IG = Object.assign;
function xG(e, n) {
  return zt(e, 0) ^ 45 ? (((n << 2 ^ zt(e, 0)) << 2 ^ zt(e, 1)) << 2 ^ zt(e, 2)) << 2 ^ zt(e, 3) : 0;
}
function jA(e) {
  return e.trim();
}
function vG(e, n) {
  return (e = n.exec(e)) ? e[0] : e;
}
function We(e, n, t) {
  return e.replace(n, t);
}
function Ef(e, n) {
  return e.indexOf(n);
}
function zt(e, n) {
  return e.charCodeAt(n) | 0;
}
function Ga(e, n, t) {
  return e.slice(n, t);
}
function Ti(e) {
  return e.length;
}
function Xm(e) {
  return e.length;
}
function Ku(e, n) {
  return n.push(e), e;
}
function PG(e, n) {
  return e.map(n).join("");
}
var Oc = 1, uo = 1, KA = 0, _n = 0, Pt = 0, Ao = "";
function Nc(e, n, t, i, r, s, o) {
  return { value: e, root: n, parent: t, type: i, props: r, children: s, line: Oc, column: uo, length: o, return: "" };
}
function Go(e, n) {
  return IG(Nc("", null, null, "", null, null, 0), e, { length: -e.length }, n);
}
function OG() {
  return Pt;
}
function NG() {
  return Pt = _n > 0 ? zt(Ao, --_n) : 0, uo--, Pt === 10 && (uo = 1, Oc--), Pt;
}
function Pn() {
  return Pt = _n < KA ? zt(Ao, _n++) : 0, uo++, Pt === 10 && (uo = 1, Oc++), Pt;
}
function Ci() {
  return zt(Ao, _n);
}
function al() {
  return _n;
}
function bu(e, n) {
  return Ga(Ao, e, n);
}
function Qa(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function GA(e) {
  return Oc = uo = 1, KA = Ti(Ao = e), _n = 0, [];
}
function QA(e) {
  return Ao = "", e;
}
function ul(e) {
  return jA(bu(_n - 1, Tf(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function RG(e) {
  for (; (Pt = Ci()) && Pt < 33; )
    Pn();
  return Qa(e) > 2 || Qa(Pt) > 3 ? "" : " ";
}
function LG(e, n) {
  for (; --n && Pn() && !(Pt < 48 || Pt > 102 || Pt > 57 && Pt < 65 || Pt > 70 && Pt < 97); )
    ;
  return bu(e, al() + (n < 6 && Ci() == 32 && Pn() == 32));
}
function Tf(e) {
  for (; Pn(); )
    switch (Pt) {
      case e:
        return _n;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Tf(Pt);
        break;
      case 40:
        e === 41 && Tf(e);
        break;
      case 92:
        Pn();
        break;
    }
  return _n;
}
function DG(e, n) {
  for (; Pn() && e + Pt !== 57; )
    if (e + Pt === 84 && Ci() === 47)
      break;
  return "/*" + bu(n, _n - 1) + "*" + Pc(e === 47 ? e : Pn());
}
function MG(e) {
  for (; !Qa(Ci()); )
    Pn();
  return bu(e, _n);
}
function BG(e) {
  return QA(ll("", null, null, null, [""], e = GA(e), 0, [0], e));
}
function ll(e, n, t, i, r, s, o, a, u) {
  for (var l = 0, c = 0, d = o, p = 0, g = 0, b = 0, _ = 1, k = 1, C = 1, D = 0, M = "", j = r, F = s, O = i, V = M; k; )
    switch (b = D, D = Pn()) {
      case 40:
        if (b != 108 && zt(V, d - 1) == 58) {
          Ef(V += We(ul(D), "&", "&\f"), "&\f") != -1 && (C = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        V += ul(D);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        V += RG(b);
        break;
      case 92:
        V += LG(al() - 1, 7);
        continue;
      case 47:
        switch (Ci()) {
          case 42:
          case 47:
            Ku(FG(DG(Pn(), al()), n, t), u);
            break;
          default:
            V += "/";
        }
        break;
      case 123 * _:
        a[l++] = Ti(V) * C;
      case 125 * _:
      case 59:
      case 0:
        switch (D) {
          case 0:
          case 125:
            k = 0;
          case 59 + c:
            C == -1 && (V = We(V, /\f/g, "")), g > 0 && Ti(V) - d && Ku(g > 32 ? G1(V + ";", i, t, d - 1) : G1(We(V, " ", "") + ";", i, t, d - 2), u);
            break;
          case 59:
            V += ";";
          default:
            if (Ku(O = K1(V, n, t, l, c, r, a, M, j = [], F = [], d), s), D === 123)
              if (c === 0)
                ll(V, n, O, O, j, s, d, a, F);
              else
                switch (p === 99 && zt(V, 3) === 110 ? 100 : p) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    ll(e, O, O, i && Ku(K1(e, O, O, 0, 0, r, a, M, r, j = [], d), F), r, F, d, a, i ? j : F);
                    break;
                  default:
                    ll(V, O, O, O, [""], F, 0, a, F);
                }
        }
        l = c = g = 0, _ = C = 1, M = V = "", d = o;
        break;
      case 58:
        d = 1 + Ti(V), g = b;
      default:
        if (_ < 1) {
          if (D == 123)
            --_;
          else if (D == 125 && _++ == 0 && NG() == 125)
            continue;
        }
        switch (V += Pc(D), D * _) {
          case 38:
            C = c > 0 ? 1 : (V += "\f", -1);
            break;
          case 44:
            a[l++] = (Ti(V) - 1) * C, C = 1;
            break;
          case 64:
            Ci() === 45 && (V += ul(Pn())), p = Ci(), c = d = Ti(M = V += MG(al())), D++;
            break;
          case 45:
            b === 45 && Ti(V) == 2 && (_ = 0);
        }
    }
  return s;
}
function K1(e, n, t, i, r, s, o, a, u, l, c) {
  for (var d = r - 1, p = r === 0 ? s : [""], g = Xm(p), b = 0, _ = 0, k = 0; b < i; ++b)
    for (var C = 0, D = Ga(e, d + 1, d = SG(_ = o[b])), M = e; C < g; ++C)
      (M = jA(_ > 0 ? p[C] + " " + D : We(D, /&\f/g, p[C]))) && (u[k++] = M);
  return Nc(e, n, t, r === 0 ? Gm : a, u, l, c);
}
function FG(e, n, t) {
  return Nc(e, n, t, qA, Pc(OG()), Ga(e, 2, -2), 0);
}
function G1(e, n, t, i) {
  return Nc(e, n, t, Qm, Ga(e, 0, i), Ga(e, i + 1, -1), i);
}
function Gs(e, n) {
  for (var t = "", i = Xm(e), r = 0; r < i; r++)
    t += n(e[r], r, e, n) || "";
  return t;
}
function UG(e, n, t, i) {
  switch (e.type) {
    case kG:
      if (e.children.length) break;
    case CG:
    case Qm:
      return e.return = e.return || e.value;
    case qA:
      return "";
    case YA:
      return e.return = e.value + "{" + Gs(e.children, i) + "}";
    case Gm:
      e.value = e.props.join(",");
  }
  return Ti(t = Gs(e.children, i)) ? e.return = e.value + "{" + t + "}" : "";
}
function HG(e) {
  var n = Xm(e);
  return function(t, i, r, s) {
    for (var o = "", a = 0; a < n; a++)
      o += e[a](t, i, r, s) || "";
    return o;
  };
}
function VG(e) {
  return function(n) {
    n.root || (n = n.return) && e(n);
  };
}
function XA(e) {
  var n = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return n[t] === void 0 && (n[t] = e(t)), n[t];
  };
}
var $G = function(n, t, i) {
  for (var r = 0, s = 0; r = s, s = Ci(), r === 38 && s === 12 && (t[i] = 1), !Qa(s); )
    Pn();
  return bu(n, _n);
}, WG = function(n, t) {
  var i = -1, r = 44;
  do
    switch (Qa(r)) {
      case 0:
        r === 38 && Ci() === 12 && (t[i] = 1), n[i] += $G(_n - 1, t, i);
        break;
      case 2:
        n[i] += ul(r);
        break;
      case 4:
        if (r === 44) {
          n[++i] = Ci() === 58 ? "&\f" : "", t[i] = n[i].length;
          break;
        }
      default:
        n[i] += Pc(r);
    }
  while (r = Pn());
  return n;
}, zG = function(n, t) {
  return QA(WG(GA(n), t));
}, Q1 = /* @__PURE__ */ new WeakMap(), qG = function(n) {
  if (!(n.type !== "rule" || !n.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  n.length < 1)) {
    for (var t = n.value, i = n.parent, r = n.column === i.column && n.line === i.line; i.type !== "rule"; )
      if (i = i.parent, !i) return;
    if (!(n.props.length === 1 && t.charCodeAt(0) !== 58 && !Q1.get(i)) && !r) {
      Q1.set(n, !0);
      for (var s = [], o = zG(t, s), a = i.props, u = 0, l = 0; u < o.length; u++)
        for (var c = 0; c < a.length; c++, l++)
          n.props[l] = s[u] ? o[u].replace(/&\f/g, a[c]) : a[c] + " " + o[u];
    }
  }
}, YG = function(n) {
  if (n.type === "decl") {
    var t = n.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (n.return = "", n.value = "");
  }
};
function JA(e, n) {
  switch (xG(e, n)) {
    case 5103:
      return $e + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return $e + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return $e + e + Vl + e + Qt + e + e;
    case 6828:
    case 4268:
      return $e + e + Qt + e + e;
    case 6165:
      return $e + e + Qt + "flex-" + e + e;
    case 5187:
      return $e + e + We(e, /(\w+).+(:[^]+)/, $e + "box-$1$2" + Qt + "flex-$1$2") + e;
    case 5443:
      return $e + e + Qt + "flex-item-" + We(e, /flex-|-self/, "") + e;
    case 4675:
      return $e + e + Qt + "flex-line-pack" + We(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return $e + e + Qt + We(e, "shrink", "negative") + e;
    case 5292:
      return $e + e + Qt + We(e, "basis", "preferred-size") + e;
    case 6060:
      return $e + "box-" + We(e, "-grow", "") + $e + e + Qt + We(e, "grow", "positive") + e;
    case 4554:
      return $e + We(e, /([^-])(transform)/g, "$1" + $e + "$2") + e;
    case 6187:
      return We(We(We(e, /(zoom-|grab)/, $e + "$1"), /(image-set)/, $e + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return We(e, /(image-set\([^]*)/, $e + "$1$`$1");
    case 4968:
      return We(We(e, /(.+:)(flex-)?(.*)/, $e + "box-pack:$3" + Qt + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $e + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return We(e, /(.+)-inline(.+)/, $e + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Ti(e) - 1 - n > 6) switch (zt(e, n + 1)) {
        case 109:
          if (zt(e, n + 4) !== 45) break;
        case 102:
          return We(e, /(.+:)(.+)-([^]+)/, "$1" + $e + "$2-$3$1" + Vl + (zt(e, n + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~Ef(e, "stretch") ? JA(We(e, "stretch", "fill-available"), n) + e : e;
      }
      break;
    case 4949:
      if (zt(e, n + 1) !== 115) break;
    case 6444:
      switch (zt(e, Ti(e) - 3 - (~Ef(e, "!important") && 10))) {
        case 107:
          return We(e, ":", ":" + $e) + e;
        case 101:
          return We(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + $e + (zt(e, 14) === 45 ? "inline-" : "") + "box$3$1" + $e + "$2$3$1" + Qt + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (zt(e, n + 11)) {
        case 114:
          return $e + e + Qt + We(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return $e + e + Qt + We(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return $e + e + Qt + We(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return $e + e + Qt + e + e;
  }
  return e;
}
var jG = function(n, t, i, r) {
  if (n.length > -1 && !n.return) switch (n.type) {
    case Qm:
      n.return = JA(n.value, n.length);
      break;
    case YA:
      return Gs([Go(n, {
        value: We(n.value, "@", "@" + $e)
      })], r);
    case Gm:
      if (n.length) return PG(n.props, function(s) {
        switch (vG(s, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return Gs([Go(n, {
              props: [We(s, /:(read-\w+)/, ":" + Vl + "$1")]
            })], r);
          case "::placeholder":
            return Gs([Go(n, {
              props: [We(s, /:(plac\w+)/, ":" + $e + "input-$1")]
            }), Go(n, {
              props: [We(s, /:(plac\w+)/, ":" + Vl + "$1")]
            }), Go(n, {
              props: [We(s, /:(plac\w+)/, Qt + "input-$1")]
            })], r);
        }
        return "";
      });
  }
}, KG = [jG], GG = function(n) {
  var t = n.key;
  if (t === "css") {
    var i = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(i, function(_) {
      var k = _.getAttribute("data-emotion");
      k.indexOf(" ") !== -1 && (document.head.appendChild(_), _.setAttribute("data-s", ""));
    });
  }
  var r = n.stylisPlugins || KG, s = {}, o, a = [];
  o = n.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(_) {
      for (var k = _.getAttribute("data-emotion").split(" "), C = 1; C < k.length; C++)
        s[k[C]] = !0;
      a.push(_);
    }
  );
  var u, l = [qG, YG];
  {
    var c, d = [UG, VG(function(_) {
      c.insert(_);
    })], p = HG(l.concat(r, d)), g = function(k) {
      return Gs(BG(k), p);
    };
    u = function(k, C, D, M) {
      c = D, g(k ? k + "{" + C.styles + "}" : C.styles), M && (b.inserted[C.name] = !0);
    };
  }
  var b = {
    key: t,
    sheet: new AG({
      key: t,
      container: o,
      nonce: n.nonce,
      speedy: n.speedy,
      prepend: n.prepend,
      insertionPoint: n.insertionPoint
    }),
    nonce: n.nonce,
    inserted: s,
    registered: {},
    insert: u
  };
  return b.sheet.hydrate(a), b;
}, QG = !0;
function XG(e, n, t) {
  var i = "";
  return t.split(" ").forEach(function(r) {
    e[r] !== void 0 ? n.push(e[r] + ";") : r && (i += r + " ");
  }), i;
}
var ZA = function(n, t, i) {
  var r = n.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (i === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  QG === !1) && n.registered[r] === void 0 && (n.registered[r] = t.styles);
}, JG = function(n, t, i) {
  ZA(n, t, i);
  var r = n.key + "-" + t.name;
  if (n.inserted[t.name] === void 0) {
    var s = t;
    do
      n.insert(t === s ? "." + r : "", s, n.sheet, !0), s = s.next;
    while (s !== void 0);
  }
};
function ZG(e) {
  for (var n = 0, t, i = 0, r = e.length; r >= 4; ++i, r -= 4)
    t = e.charCodeAt(i) & 255 | (e.charCodeAt(++i) & 255) << 8 | (e.charCodeAt(++i) & 255) << 16 | (e.charCodeAt(++i) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, n = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16);
  switch (r) {
    case 3:
      n ^= (e.charCodeAt(i + 2) & 255) << 16;
    case 2:
      n ^= (e.charCodeAt(i + 1) & 255) << 8;
    case 1:
      n ^= e.charCodeAt(i) & 255, n = /* Math.imul(h, m): */
      (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16);
  }
  return n ^= n >>> 13, n = /* Math.imul(h, m): */
  (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), ((n ^ n >>> 15) >>> 0).toString(36);
}
var eQ = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, tQ = /[A-Z]|^ms/g, nQ = /_EMO_([^_]+?)_([^]*?)_EMO_/g, eC = function(n) {
  return n.charCodeAt(1) === 45;
}, X1 = function(n) {
  return n != null && typeof n != "boolean";
}, th = /* @__PURE__ */ XA(function(e) {
  return eC(e) ? e : e.replace(tQ, "-$&").toLowerCase();
}), J1 = function(n, t) {
  switch (n) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(nQ, function(i, r, s) {
          return yi = {
            name: r,
            styles: s,
            next: yi
          }, r;
        });
  }
  return eQ[n] !== 1 && !eC(n) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
function Xa(e, n, t) {
  if (t == null)
    return "";
  var i = t;
  if (i.__emotion_styles !== void 0)
    return i;
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      var r = t;
      if (r.anim === 1)
        return yi = {
          name: r.name,
          styles: r.styles,
          next: yi
        }, r.name;
      var s = t;
      if (s.styles !== void 0) {
        var o = s.next;
        if (o !== void 0)
          for (; o !== void 0; )
            yi = {
              name: o.name,
              styles: o.styles,
              next: yi
            }, o = o.next;
        var a = s.styles + ";";
        return a;
      }
      return iQ(e, n, t);
    }
    case "function": {
      if (e !== void 0) {
        var u = yi, l = t(e);
        return yi = u, Xa(e, n, l);
      }
      break;
    }
  }
  var c = t;
  if (n == null)
    return c;
  var d = n[c];
  return d !== void 0 ? d : c;
}
function iQ(e, n, t) {
  var i = "";
  if (Array.isArray(t))
    for (var r = 0; r < t.length; r++)
      i += Xa(e, n, t[r]) + ";";
  else
    for (var s in t) {
      var o = t[s];
      if (typeof o != "object") {
        var a = o;
        n != null && n[a] !== void 0 ? i += s + "{" + n[a] + "}" : X1(a) && (i += th(s) + ":" + J1(s, a) + ";");
      } else if (Array.isArray(o) && typeof o[0] == "string" && (n == null || n[o[0]] === void 0))
        for (var u = 0; u < o.length; u++)
          X1(o[u]) && (i += th(s) + ":" + J1(s, o[u]) + ";");
      else {
        var l = Xa(e, n, o);
        switch (s) {
          case "animation":
          case "animationName": {
            i += th(s) + ":" + l + ";";
            break;
          }
          default:
            i += s + "{" + l + "}";
        }
      }
    }
  return i;
}
var Z1 = /label:\s*([^\s;{]+)\s*(;|$)/g, yi;
function rQ(e, n, t) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var i = !0, r = "";
  yi = void 0;
  var s = e[0];
  if (s == null || s.raw === void 0)
    i = !1, r += Xa(t, n, s);
  else {
    var o = s;
    r += o[0];
  }
  for (var a = 1; a < e.length; a++)
    if (r += Xa(t, n, e[a]), i) {
      var u = s;
      r += u[a];
    }
  Z1.lastIndex = 0;
  for (var l = "", c; (c = Z1.exec(r)) !== null; )
    l += "-" + c[1];
  var d = ZG(r) + l;
  return {
    name: d,
    styles: r,
    next: yi
  };
}
var sQ = function(n) {
  return n();
}, oQ = qt.useInsertionEffect ? qt.useInsertionEffect : !1, aQ = oQ || sQ, tC = /* @__PURE__ */ qt.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ GG({
    key: "css"
  }) : null
);
tC.Provider;
var uQ = function(n) {
  return /* @__PURE__ */ Cf(function(t, i) {
    var r = FC(tC);
    return n(t, r, i);
  });
}, nC = /* @__PURE__ */ qt.createContext({}), nh = { exports: {} }, e_;
function lQ() {
  return e_ || (e_ = 1, function(e) {
    function n() {
      return e.exports = n = Object.assign ? Object.assign.bind() : function(t) {
        for (var i = 1; i < arguments.length; i++) {
          var r = arguments[i];
          for (var s in r) ({}).hasOwnProperty.call(r, s) && (t[s] = r[s]);
        }
        return t;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, n.apply(null, arguments);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(nh)), nh.exports;
}
lQ();
var cQ = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, dQ = /* @__PURE__ */ XA(
  function(e) {
    return cQ.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), hQ = dQ, fQ = function(n) {
  return n !== "theme";
}, t_ = function(n) {
  return typeof n == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  n.charCodeAt(0) > 96 ? hQ : fQ;
}, n_ = function(n, t, i) {
  var r;
  if (t) {
    var s = t.shouldForwardProp;
    r = n.__emotion_forwardProp && s ? function(o) {
      return n.__emotion_forwardProp(o) && s(o);
    } : s;
  }
  return typeof r != "function" && i && (r = n.__emotion_forwardProp), r;
}, mQ = function(n) {
  var t = n.cache, i = n.serialized, r = n.isStringTag;
  return ZA(t, i, r), aQ(function() {
    return JG(t, i, r);
  }), null;
}, pQ = function e(n, t) {
  var i = n.__emotion_real === n, r = i && n.__emotion_base || n, s, o;
  t !== void 0 && (s = t.label, o = t.target);
  var a = n_(n, t, i), u = a || t_(r), l = !u("as");
  return function() {
    var c = arguments, d = i && n.__emotion_styles !== void 0 ? n.__emotion_styles.slice(0) : [];
    if (s !== void 0 && d.push("label:" + s + ";"), c[0] == null || c[0].raw === void 0)
      d.push.apply(d, c);
    else {
      var p = c[0];
      d.push(p[0]);
      for (var g = c.length, b = 1; b < g; b++)
        d.push(c[b], p[b]);
    }
    var _ = uQ(function(k, C, D) {
      var M = l && k.as || r, j = "", F = [], O = k;
      if (k.theme == null) {
        O = {};
        for (var V in k)
          O[V] = k[V];
        O.theme = qt.useContext(nC);
      }
      typeof k.className == "string" ? j = XG(C.registered, F, k.className) : k.className != null && (j = k.className + " ");
      var ie = rQ(d.concat(F), C.registered, O);
      j += C.key + "-" + ie.name, o !== void 0 && (j += " " + o);
      var W = l && a === void 0 ? t_(M) : u, N = {};
      for (var Z in k)
        l && Z === "as" || W(Z) && (N[Z] = k[Z]);
      return N.className = j, D && (N.ref = D), /* @__PURE__ */ qt.createElement(qt.Fragment, null, /* @__PURE__ */ qt.createElement(mQ, {
        cache: C,
        serialized: ie,
        isStringTag: typeof M == "string"
      }), /* @__PURE__ */ qt.createElement(M, N));
    });
    return _.displayName = s !== void 0 ? s : "Styled(" + (typeof r == "string" ? r : r.displayName || r.name || "Component") + ")", _.defaultProps = n.defaultProps, _.__emotion_real = _, _.__emotion_base = r, _.__emotion_styles = d, _.__emotion_forwardProp = a, Object.defineProperty(_, "toString", {
      value: function() {
        return "." + o;
      }
    }), _.withComponent = function(k, C) {
      var D = e(k, ht({}, t, C, {
        shouldForwardProp: n_(_, C, !0)
      }));
      return D.apply(void 0, d);
    }, _;
  };
}, gQ = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], yf = pQ.bind(null);
gQ.forEach(function(e) {
  yf[e] = yf(e);
});
var wf = { exports: {} }, Gu = { exports: {} }, je = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var i_;
function bQ() {
  if (i_) return je;
  i_ = 1;
  var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, _ = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, D = e ? Symbol.for("react.scope") : 60119;
  function M(F) {
    if (typeof F == "object" && F !== null) {
      var O = F.$$typeof;
      switch (O) {
        case n:
          switch (F = F.type, F) {
            case u:
            case l:
            case i:
            case s:
            case r:
            case d:
              return F;
            default:
              switch (F = F && F.$$typeof, F) {
                case a:
                case c:
                case b:
                case g:
                case o:
                  return F;
                default:
                  return O;
              }
          }
        case t:
          return O;
      }
    }
  }
  function j(F) {
    return M(F) === l;
  }
  return je.AsyncMode = u, je.ConcurrentMode = l, je.ContextConsumer = a, je.ContextProvider = o, je.Element = n, je.ForwardRef = c, je.Fragment = i, je.Lazy = b, je.Memo = g, je.Portal = t, je.Profiler = s, je.StrictMode = r, je.Suspense = d, je.isAsyncMode = function(F) {
    return j(F) || M(F) === u;
  }, je.isConcurrentMode = j, je.isContextConsumer = function(F) {
    return M(F) === a;
  }, je.isContextProvider = function(F) {
    return M(F) === o;
  }, je.isElement = function(F) {
    return typeof F == "object" && F !== null && F.$$typeof === n;
  }, je.isForwardRef = function(F) {
    return M(F) === c;
  }, je.isFragment = function(F) {
    return M(F) === i;
  }, je.isLazy = function(F) {
    return M(F) === b;
  }, je.isMemo = function(F) {
    return M(F) === g;
  }, je.isPortal = function(F) {
    return M(F) === t;
  }, je.isProfiler = function(F) {
    return M(F) === s;
  }, je.isStrictMode = function(F) {
    return M(F) === r;
  }, je.isSuspense = function(F) {
    return M(F) === d;
  }, je.isValidElementType = function(F) {
    return typeof F == "string" || typeof F == "function" || F === i || F === l || F === s || F === r || F === d || F === p || typeof F == "object" && F !== null && (F.$$typeof === b || F.$$typeof === g || F.$$typeof === o || F.$$typeof === a || F.$$typeof === c || F.$$typeof === k || F.$$typeof === C || F.$$typeof === D || F.$$typeof === _);
  }, je.typeOf = M, je;
}
var Ke = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var r_;
function _Q() {
  return r_ || (r_ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, _ = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, D = e ? Symbol.for("react.scope") : 60119;
    function M(se) {
      return typeof se == "string" || typeof se == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      se === i || se === l || se === s || se === r || se === d || se === p || typeof se == "object" && se !== null && (se.$$typeof === b || se.$$typeof === g || se.$$typeof === o || se.$$typeof === a || se.$$typeof === c || se.$$typeof === k || se.$$typeof === C || se.$$typeof === D || se.$$typeof === _);
    }
    function j(se) {
      if (typeof se == "object" && se !== null) {
        var ln = se.$$typeof;
        switch (ln) {
          case n:
            var er = se.type;
            switch (er) {
              case u:
              case l:
              case i:
              case s:
              case r:
              case d:
                return er;
              default:
                var fi = er && er.$$typeof;
                switch (fi) {
                  case a:
                  case c:
                  case b:
                  case g:
                  case o:
                    return fi;
                  default:
                    return ln;
                }
            }
          case t:
            return ln;
        }
      }
    }
    var F = u, O = l, V = a, ie = o, W = n, N = c, Z = i, ee = b, Ae = g, Ie = t, we = s, ze = r, Qe = d, Nt = !1;
    function jt(se) {
      return Nt || (Nt = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), y(se) || j(se) === u;
    }
    function y(se) {
      return j(se) === l;
    }
    function re(se) {
      return j(se) === a;
    }
    function pe(se) {
      return j(se) === o;
    }
    function S(se) {
      return typeof se == "object" && se !== null && se.$$typeof === n;
    }
    function de(se) {
      return j(se) === c;
    }
    function Ce(se) {
      return j(se) === i;
    }
    function le(se) {
      return j(se) === b;
    }
    function ge(se) {
      return j(se) === g;
    }
    function be(se) {
      return j(se) === t;
    }
    function ve(se) {
      return j(se) === s;
    }
    function Te(se) {
      return j(se) === r;
    }
    function Tt(se) {
      return j(se) === d;
    }
    Ke.AsyncMode = F, Ke.ConcurrentMode = O, Ke.ContextConsumer = V, Ke.ContextProvider = ie, Ke.Element = W, Ke.ForwardRef = N, Ke.Fragment = Z, Ke.Lazy = ee, Ke.Memo = Ae, Ke.Portal = Ie, Ke.Profiler = we, Ke.StrictMode = ze, Ke.Suspense = Qe, Ke.isAsyncMode = jt, Ke.isConcurrentMode = y, Ke.isContextConsumer = re, Ke.isContextProvider = pe, Ke.isElement = S, Ke.isForwardRef = de, Ke.isFragment = Ce, Ke.isLazy = le, Ke.isMemo = ge, Ke.isPortal = be, Ke.isProfiler = ve, Ke.isStrictMode = Te, Ke.isSuspense = Tt, Ke.isValidElementType = M, Ke.typeOf = j;
  }()), Ke;
}
var s_;
function iC() {
  return s_ || (s_ = 1, process.env.NODE_ENV === "production" ? Gu.exports = bQ() : Gu.exports = _Q()), Gu.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ih, o_;
function EQ() {
  if (o_) return ih;
  o_ = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function i(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function r() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var o = {}, a = 0; a < 10; a++)
        o["_" + String.fromCharCode(a)] = a;
      var u = Object.getOwnPropertyNames(o).map(function(c) {
        return o[c];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        l[c] = c;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ih = r() ? Object.assign : function(s, o) {
    for (var a, u = i(s), l, c = 1; c < arguments.length; c++) {
      a = Object(arguments[c]);
      for (var d in a)
        n.call(a, d) && (u[d] = a[d]);
      if (e) {
        l = e(a);
        for (var p = 0; p < l.length; p++)
          t.call(a, l[p]) && (u[l[p]] = a[l[p]]);
      }
    }
    return u;
  }, ih;
}
var rh, a_;
function Jm() {
  if (a_) return rh;
  a_ = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return rh = e, rh;
}
var sh, u_;
function rC() {
  return u_ || (u_ = 1, sh = Function.call.bind(Object.prototype.hasOwnProperty)), sh;
}
var oh, l_;
function TQ() {
  if (l_) return oh;
  l_ = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = Jm(), t = {}, i = rC();
    e = function(s) {
      var o = "Warning: " + s;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function r(s, o, a, u, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in s)
        if (i(s, c)) {
          var d;
          try {
            if (typeof s[c] != "function") {
              var p = Error(
                (u || "React class") + ": " + a + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            d = s[c](o, c, u, a, null, n);
          } catch (b) {
            d = b;
          }
          if (d && !(d instanceof Error) && e(
            (u || "React class") + ": type specification of " + a + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in t)) {
            t[d.message] = !0;
            var g = l ? l() : "";
            e(
              "Failed " + a + " type: " + d.message + (g ?? "")
            );
          }
        }
    }
  }
  return r.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, oh = r, oh;
}
var ah, c_;
function yQ() {
  if (c_) return ah;
  c_ = 1;
  var e = iC(), n = EQ(), t = Jm(), i = rC(), r = TQ(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(a) {
    var u = "Warning: " + a;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return ah = function(a, u) {
    var l = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function d(y) {
      var re = y && (l && y[l] || y[c]);
      if (typeof re == "function")
        return re;
    }
    var p = "<<anonymous>>", g = {
      array: C("array"),
      bigint: C("bigint"),
      bool: C("boolean"),
      func: C("function"),
      number: C("number"),
      object: C("object"),
      string: C("string"),
      symbol: C("symbol"),
      any: D(),
      arrayOf: M,
      element: j(),
      elementType: F(),
      instanceOf: O,
      node: N(),
      objectOf: ie,
      oneOf: V,
      oneOfType: W,
      shape: ee,
      exact: Ae
    };
    function b(y, re) {
      return y === re ? y !== 0 || 1 / y === 1 / re : y !== y && re !== re;
    }
    function _(y, re) {
      this.message = y, this.data = re && typeof re == "object" ? re : {}, this.stack = "";
    }
    _.prototype = Error.prototype;
    function k(y) {
      if (process.env.NODE_ENV !== "production")
        var re = {}, pe = 0;
      function S(Ce, le, ge, be, ve, Te, Tt) {
        if (be = be || p, Te = Te || ge, Tt !== t) {
          if (u) {
            var se = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw se.name = "Invariant Violation", se;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ln = be + ":" + ge;
            !re[ln] && // Avoid spamming the console because they are often not actionable except for lib authors
            pe < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + Te + "` prop on `" + be + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), re[ln] = !0, pe++);
          }
        }
        return le[ge] == null ? Ce ? le[ge] === null ? new _("The " + ve + " `" + Te + "` is marked as required " + ("in `" + be + "`, but its value is `null`.")) : new _("The " + ve + " `" + Te + "` is marked as required in " + ("`" + be + "`, but its value is `undefined`.")) : null : y(le, ge, be, ve, Te);
      }
      var de = S.bind(null, !1);
      return de.isRequired = S.bind(null, !0), de;
    }
    function C(y) {
      function re(pe, S, de, Ce, le, ge) {
        var be = pe[S], ve = ze(be);
        if (ve !== y) {
          var Te = Qe(be);
          return new _(
            "Invalid " + Ce + " `" + le + "` of type " + ("`" + Te + "` supplied to `" + de + "`, expected ") + ("`" + y + "`."),
            { expectedType: y }
          );
        }
        return null;
      }
      return k(re);
    }
    function D() {
      return k(o);
    }
    function M(y) {
      function re(pe, S, de, Ce, le) {
        if (typeof y != "function")
          return new _("Property `" + le + "` of component `" + de + "` has invalid PropType notation inside arrayOf.");
        var ge = pe[S];
        if (!Array.isArray(ge)) {
          var be = ze(ge);
          return new _("Invalid " + Ce + " `" + le + "` of type " + ("`" + be + "` supplied to `" + de + "`, expected an array."));
        }
        for (var ve = 0; ve < ge.length; ve++) {
          var Te = y(ge, ve, de, Ce, le + "[" + ve + "]", t);
          if (Te instanceof Error)
            return Te;
        }
        return null;
      }
      return k(re);
    }
    function j() {
      function y(re, pe, S, de, Ce) {
        var le = re[pe];
        if (!a(le)) {
          var ge = ze(le);
          return new _("Invalid " + de + " `" + Ce + "` of type " + ("`" + ge + "` supplied to `" + S + "`, expected a single ReactElement."));
        }
        return null;
      }
      return k(y);
    }
    function F() {
      function y(re, pe, S, de, Ce) {
        var le = re[pe];
        if (!e.isValidElementType(le)) {
          var ge = ze(le);
          return new _("Invalid " + de + " `" + Ce + "` of type " + ("`" + ge + "` supplied to `" + S + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return k(y);
    }
    function O(y) {
      function re(pe, S, de, Ce, le) {
        if (!(pe[S] instanceof y)) {
          var ge = y.name || p, be = jt(pe[S]);
          return new _("Invalid " + Ce + " `" + le + "` of type " + ("`" + be + "` supplied to `" + de + "`, expected ") + ("instance of `" + ge + "`."));
        }
        return null;
      }
      return k(re);
    }
    function V(y) {
      if (!Array.isArray(y))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), o;
      function re(pe, S, de, Ce, le) {
        for (var ge = pe[S], be = 0; be < y.length; be++)
          if (b(ge, y[be]))
            return null;
        var ve = JSON.stringify(y, function(Tt, se) {
          var ln = Qe(se);
          return ln === "symbol" ? String(se) : se;
        });
        return new _("Invalid " + Ce + " `" + le + "` of value `" + String(ge) + "` " + ("supplied to `" + de + "`, expected one of " + ve + "."));
      }
      return k(re);
    }
    function ie(y) {
      function re(pe, S, de, Ce, le) {
        if (typeof y != "function")
          return new _("Property `" + le + "` of component `" + de + "` has invalid PropType notation inside objectOf.");
        var ge = pe[S], be = ze(ge);
        if (be !== "object")
          return new _("Invalid " + Ce + " `" + le + "` of type " + ("`" + be + "` supplied to `" + de + "`, expected an object."));
        for (var ve in ge)
          if (i(ge, ve)) {
            var Te = y(ge, ve, de, Ce, le + "." + ve, t);
            if (Te instanceof Error)
              return Te;
          }
        return null;
      }
      return k(re);
    }
    function W(y) {
      if (!Array.isArray(y))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var re = 0; re < y.length; re++) {
        var pe = y[re];
        if (typeof pe != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Nt(pe) + " at index " + re + "."
          ), o;
      }
      function S(de, Ce, le, ge, be) {
        for (var ve = [], Te = 0; Te < y.length; Te++) {
          var Tt = y[Te], se = Tt(de, Ce, le, ge, be, t);
          if (se == null)
            return null;
          se.data && i(se.data, "expectedType") && ve.push(se.data.expectedType);
        }
        var ln = ve.length > 0 ? ", expected one of type [" + ve.join(", ") + "]" : "";
        return new _("Invalid " + ge + " `" + be + "` supplied to " + ("`" + le + "`" + ln + "."));
      }
      return k(S);
    }
    function N() {
      function y(re, pe, S, de, Ce) {
        return Ie(re[pe]) ? null : new _("Invalid " + de + " `" + Ce + "` supplied to " + ("`" + S + "`, expected a ReactNode."));
      }
      return k(y);
    }
    function Z(y, re, pe, S, de) {
      return new _(
        (y || "React class") + ": " + re + " type `" + pe + "." + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + de + "`."
      );
    }
    function ee(y) {
      function re(pe, S, de, Ce, le) {
        var ge = pe[S], be = ze(ge);
        if (be !== "object")
          return new _("Invalid " + Ce + " `" + le + "` of type `" + be + "` " + ("supplied to `" + de + "`, expected `object`."));
        for (var ve in y) {
          var Te = y[ve];
          if (typeof Te != "function")
            return Z(de, Ce, le, ve, Qe(Te));
          var Tt = Te(ge, ve, de, Ce, le + "." + ve, t);
          if (Tt)
            return Tt;
        }
        return null;
      }
      return k(re);
    }
    function Ae(y) {
      function re(pe, S, de, Ce, le) {
        var ge = pe[S], be = ze(ge);
        if (be !== "object")
          return new _("Invalid " + Ce + " `" + le + "` of type `" + be + "` " + ("supplied to `" + de + "`, expected `object`."));
        var ve = n({}, pe[S], y);
        for (var Te in ve) {
          var Tt = y[Te];
          if (i(y, Te) && typeof Tt != "function")
            return Z(de, Ce, le, Te, Qe(Tt));
          if (!Tt)
            return new _(
              "Invalid " + Ce + " `" + le + "` key `" + Te + "` supplied to `" + de + "`.\nBad object: " + JSON.stringify(pe[S], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(y), null, "  ")
            );
          var se = Tt(ge, Te, de, Ce, le + "." + Te, t);
          if (se)
            return se;
        }
        return null;
      }
      return k(re);
    }
    function Ie(y) {
      switch (typeof y) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !y;
        case "object":
          if (Array.isArray(y))
            return y.every(Ie);
          if (y === null || a(y))
            return !0;
          var re = d(y);
          if (re) {
            var pe = re.call(y), S;
            if (re !== y.entries) {
              for (; !(S = pe.next()).done; )
                if (!Ie(S.value))
                  return !1;
            } else
              for (; !(S = pe.next()).done; ) {
                var de = S.value;
                if (de && !Ie(de[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function we(y, re) {
      return y === "symbol" ? !0 : re ? re["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && re instanceof Symbol : !1;
    }
    function ze(y) {
      var re = typeof y;
      return Array.isArray(y) ? "array" : y instanceof RegExp ? "object" : we(re, y) ? "symbol" : re;
    }
    function Qe(y) {
      if (typeof y > "u" || y === null)
        return "" + y;
      var re = ze(y);
      if (re === "object") {
        if (y instanceof Date)
          return "date";
        if (y instanceof RegExp)
          return "regexp";
      }
      return re;
    }
    function Nt(y) {
      var re = Qe(y);
      switch (re) {
        case "array":
        case "object":
          return "an " + re;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + re;
        default:
          return re;
      }
    }
    function jt(y) {
      return !y.constructor || !y.constructor.name ? p : y.constructor.name;
    }
    return g.checkPropTypes = r, g.resetWarningCache = r.resetWarningCache, g.PropTypes = g, g;
  }, ah;
}
var uh, d_;
function wQ() {
  if (d_) return uh;
  d_ = 1;
  var e = Jm();
  function n() {
  }
  function t() {
  }
  return t.resetWarningCache = n, uh = function() {
    function i(o, a, u, l, c, d) {
      if (d !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    i.isRequired = i;
    function r() {
      return i;
    }
    var s = {
      array: i,
      bigint: i,
      bool: i,
      func: i,
      number: i,
      object: i,
      string: i,
      symbol: i,
      any: i,
      arrayOf: r,
      element: i,
      elementType: i,
      instanceOf: r,
      node: i,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: t,
      resetWarningCache: n
    };
    return s.PropTypes = s, s;
  }, uh;
}
if (process.env.NODE_ENV !== "production") {
  var AQ = iC(), CQ = !0;
  wf.exports = yQ()(AQ.isElement, CQ);
} else
  wf.exports = wQ()();
var kQ = wf.exports;
const rn = /* @__PURE__ */ kf(kQ);
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function SQ(e, n) {
  const t = yf(e, n);
  return process.env.NODE_ENV !== "production" ? (...i) => {
    const r = `"${e}"`;
    return i.length === 0 ? console.error([`MUI: Seems like you called \`styled(${r})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : i.some((s) => s === void 0) && console.error(`MUI: the styled(${r})(...args) API requires all its args to be defined.`), t(...i);
  } : t;
}
function Yr(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function sC(e) {
  if (/* @__PURE__ */ qt.isValidElement(e) || !Yr(e))
    return e;
  const n = {};
  return Object.keys(e).forEach((t) => {
    n[t] = sC(e[t]);
  }), n;
}
function $i(e, n, t = {
  clone: !0
}) {
  const i = t.clone ? ht({}, e) : e;
  return Yr(e) && Yr(n) && Object.keys(n).forEach((r) => {
    /* @__PURE__ */ qt.isValidElement(n[r]) ? i[r] = n[r] : Yr(n[r]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, r) && Yr(e[r]) ? i[r] = $i(e[r], n[r], t) : t.clone ? i[r] = Yr(n[r]) ? sC(n[r]) : n[r] : i[r] = n[r];
  }), i;
}
const IQ = ["values", "unit", "step"], xQ = (e) => {
  const n = Object.keys(e).map((t) => ({
    key: t,
    val: e[t]
  })) || [];
  return n.sort((t, i) => t.val - i.val), n.reduce((t, i) => ht({}, t, {
    [i.key]: i.val
  }), {});
};
function vQ(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: n = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: t = "px",
    step: i = 5
  } = e, r = Pr(e, IQ), s = xQ(n), o = Object.keys(s);
  function a(p) {
    return `@media (min-width:${typeof n[p] == "number" ? n[p] : p}${t})`;
  }
  function u(p) {
    return `@media (max-width:${(typeof n[p] == "number" ? n[p] : p) - i / 100}${t})`;
  }
  function l(p, g) {
    const b = o.indexOf(g);
    return `@media (min-width:${typeof n[p] == "number" ? n[p] : p}${t}) and (max-width:${(b !== -1 && typeof n[o[b]] == "number" ? n[o[b]] : g) - i / 100}${t})`;
  }
  function c(p) {
    return o.indexOf(p) + 1 < o.length ? l(p, o[o.indexOf(p) + 1]) : a(p);
  }
  function d(p) {
    const g = o.indexOf(p);
    return g === 0 ? a(o[1]) : g === o.length - 1 ? u(o[g]) : l(p, o[o.indexOf(p) + 1]).replace("@media", "@media not all and");
  }
  return ht({
    keys: o,
    values: s,
    up: a,
    down: u,
    between: l,
    only: c,
    not: d,
    unit: t
  }, r);
}
const PQ = {
  borderRadius: 4
}, Or = process.env.NODE_ENV !== "production" ? rn.oneOfType([rn.number, rn.string, rn.object, rn.array]) : {};
function Ca(e, n) {
  return n ? $i(e, n, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Zm = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, h_ = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Zm[e]}px)`
};
function ji(e, n, t) {
  const i = e.theme || {};
  if (Array.isArray(n)) {
    const s = i.breakpoints || h_;
    return n.reduce((o, a, u) => (o[s.up(s.keys[u])] = t(n[u]), o), {});
  }
  if (typeof n == "object") {
    const s = i.breakpoints || h_;
    return Object.keys(n).reduce((o, a) => {
      if (Object.keys(s.values || Zm).indexOf(a) !== -1) {
        const u = s.up(a);
        o[u] = t(n[a], a);
      } else {
        const u = a;
        o[u] = n[u];
      }
      return o;
    }, {});
  }
  return t(n);
}
function OQ(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((i, r) => {
    const s = e.up(r);
    return i[s] = {}, i;
  }, {})) || {};
}
function f_(e, n) {
  return e.reduce((t, i) => {
    const r = t[i];
    return (!r || Object.keys(r).length === 0) && delete t[i], t;
  }, n);
}
function oC(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : Ka(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Rc(e, n, t = !0) {
  if (!n || typeof n != "string")
    return null;
  if (e && e.vars && t) {
    const i = `vars.${n}`.split(".").reduce((r, s) => r && r[s] ? r[s] : null, e);
    if (i != null)
      return i;
  }
  return n.split(".").reduce((i, r) => i && i[r] != null ? i[r] : null, e);
}
function $l(e, n, t, i = t) {
  let r;
  return typeof e == "function" ? r = e(t) : Array.isArray(e) ? r = e[t] || i : r = Rc(e, t) || i, n && (r = n(r, i, e)), r;
}
function Ct(e) {
  const {
    prop: n,
    cssProperty: t = e.prop,
    themeKey: i,
    transform: r
  } = e, s = (o) => {
    if (o[n] == null)
      return null;
    const a = o[n], u = o.theme, l = Rc(u, i) || {};
    return ji(o, a, (d) => {
      let p = $l(l, r, d);
      return d === p && typeof d == "string" && (p = $l(l, r, `${n}${d === "default" ? "" : oC(d)}`, d)), t === !1 ? p : {
        [t]: p
      };
    });
  };
  return s.propTypes = process.env.NODE_ENV !== "production" ? {
    [n]: Or
  } : {}, s.filterProps = [n], s;
}
function NQ(e) {
  const n = {};
  return (t) => (n[t] === void 0 && (n[t] = e(t)), n[t]);
}
const RQ = {
  m: "margin",
  p: "padding"
}, LQ = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, m_ = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, DQ = NQ((e) => {
  if (e.length > 2)
    if (m_[e])
      e = m_[e];
    else
      return [e];
  const [n, t] = e.split(""), i = RQ[n], r = LQ[t] || "";
  return Array.isArray(r) ? r.map((s) => i + s) : [i + r];
}), Lc = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Dc = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], MQ = [...Lc, ...Dc];
function _u(e, n, t, i) {
  var r;
  const s = (r = Rc(e, n, !1)) != null ? r : t;
  return typeof s == "number" ? (o) => typeof o == "string" ? o : (process.env.NODE_ENV !== "production" && typeof o != "number" && console.error(`MUI: Expected ${i} argument to be a number or a string, got ${o}.`), s * o) : Array.isArray(s) ? (o) => typeof o == "string" ? o : (process.env.NODE_ENV !== "production" && (Number.isInteger(o) ? o > s.length - 1 && console.error([`MUI: The value provided (${o}) overflows.`, `The supported values are: ${JSON.stringify(s)}.`, `${o} > ${s.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${n}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${n}\` as a number.`].join(`
`))), s[o]) : typeof s == "function" ? s : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${n}\` value (${s}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function aC(e) {
  return _u(e, "spacing", 8, "spacing");
}
function Eu(e, n) {
  if (typeof n == "string" || n == null)
    return n;
  const t = Math.abs(n), i = e(t);
  return n >= 0 ? i : typeof i == "number" ? -i : `-${i}`;
}
function BQ(e, n) {
  return (t) => e.reduce((i, r) => (i[r] = Eu(n, t), i), {});
}
function FQ(e, n, t, i) {
  if (n.indexOf(t) === -1)
    return null;
  const r = DQ(t), s = BQ(r, i), o = e[t];
  return ji(e, o, s);
}
function uC(e, n) {
  const t = aC(e.theme);
  return Object.keys(e).map((i) => FQ(e, n, i, t)).reduce(Ca, {});
}
function bt(e) {
  return uC(e, Lc);
}
bt.propTypes = process.env.NODE_ENV !== "production" ? Lc.reduce((e, n) => (e[n] = Or, e), {}) : {};
bt.filterProps = Lc;
function _t(e) {
  return uC(e, Dc);
}
_t.propTypes = process.env.NODE_ENV !== "production" ? Dc.reduce((e, n) => (e[n] = Or, e), {}) : {};
_t.filterProps = Dc;
process.env.NODE_ENV !== "production" && MQ.reduce((e, n) => (e[n] = Or, e), {});
function UQ(e = 8) {
  if (e.mui)
    return e;
  const n = aC({
    spacing: e
  }), t = (...i) => (process.env.NODE_ENV !== "production" && (i.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${i.length}`)), (i.length === 0 ? [1] : i).map((s) => {
    const o = n(s);
    return typeof o == "number" ? `${o}px` : o;
  }).join(" "));
  return t.mui = !0, t;
}
function Mc(...e) {
  const n = e.reduce((i, r) => (r.filterProps.forEach((s) => {
    i[s] = r;
  }), i), {}), t = (i) => Object.keys(i).reduce((r, s) => n[s] ? Ca(r, n[s](i)) : r, {});
  return t.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((i, r) => Object.assign(i, r.propTypes), {}) : {}, t.filterProps = e.reduce((i, r) => i.concat(r.filterProps), []), t;
}
function $n(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Gn(e, n) {
  return Ct({
    prop: e,
    themeKey: "borders",
    transform: n
  });
}
const HQ = Gn("border", $n), VQ = Gn("borderTop", $n), $Q = Gn("borderRight", $n), WQ = Gn("borderBottom", $n), zQ = Gn("borderLeft", $n), qQ = Gn("borderColor"), YQ = Gn("borderTopColor"), jQ = Gn("borderRightColor"), KQ = Gn("borderBottomColor"), GQ = Gn("borderLeftColor"), QQ = Gn("outline", $n), XQ = Gn("outlineColor"), Bc = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const n = _u(e.theme, "shape.borderRadius", 4, "borderRadius"), t = (i) => ({
      borderRadius: Eu(n, i)
    });
    return ji(e, e.borderRadius, t);
  }
  return null;
};
Bc.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Or
} : {};
Bc.filterProps = ["borderRadius"];
Mc(HQ, VQ, $Q, WQ, zQ, qQ, YQ, jQ, KQ, GQ, Bc, QQ, XQ);
const Fc = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const n = _u(e.theme, "spacing", 8, "gap"), t = (i) => ({
      gap: Eu(n, i)
    });
    return ji(e, e.gap, t);
  }
  return null;
};
Fc.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Or
} : {};
Fc.filterProps = ["gap"];
const Uc = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const n = _u(e.theme, "spacing", 8, "columnGap"), t = (i) => ({
      columnGap: Eu(n, i)
    });
    return ji(e, e.columnGap, t);
  }
  return null;
};
Uc.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Or
} : {};
Uc.filterProps = ["columnGap"];
const Hc = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const n = _u(e.theme, "spacing", 8, "rowGap"), t = (i) => ({
      rowGap: Eu(n, i)
    });
    return ji(e, e.rowGap, t);
  }
  return null;
};
Hc.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Or
} : {};
Hc.filterProps = ["rowGap"];
const JQ = Ct({
  prop: "gridColumn"
}), ZQ = Ct({
  prop: "gridRow"
}), eX = Ct({
  prop: "gridAutoFlow"
}), tX = Ct({
  prop: "gridAutoColumns"
}), nX = Ct({
  prop: "gridAutoRows"
}), iX = Ct({
  prop: "gridTemplateColumns"
}), rX = Ct({
  prop: "gridTemplateRows"
}), sX = Ct({
  prop: "gridTemplateAreas"
}), oX = Ct({
  prop: "gridArea"
});
Mc(Fc, Uc, Hc, JQ, ZQ, eX, tX, nX, iX, rX, sX, oX);
function Qs(e, n) {
  return n === "grey" ? n : e;
}
const aX = Ct({
  prop: "color",
  themeKey: "palette",
  transform: Qs
}), uX = Ct({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Qs
}), lX = Ct({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Qs
});
Mc(aX, uX, lX);
function In(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const cX = Ct({
  prop: "width",
  transform: In
}), e0 = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const n = (t) => {
      var i, r;
      const s = ((i = e.theme) == null || (i = i.breakpoints) == null || (i = i.values) == null ? void 0 : i[t]) || Zm[t];
      return s ? ((r = e.theme) == null || (r = r.breakpoints) == null ? void 0 : r.unit) !== "px" ? {
        maxWidth: `${s}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: s
      } : {
        maxWidth: In(t)
      };
    };
    return ji(e, e.maxWidth, n);
  }
  return null;
};
e0.filterProps = ["maxWidth"];
const dX = Ct({
  prop: "minWidth",
  transform: In
}), hX = Ct({
  prop: "height",
  transform: In
}), fX = Ct({
  prop: "maxHeight",
  transform: In
}), mX = Ct({
  prop: "minHeight",
  transform: In
});
Ct({
  prop: "size",
  cssProperty: "width",
  transform: In
});
Ct({
  prop: "size",
  cssProperty: "height",
  transform: In
});
const pX = Ct({
  prop: "boxSizing"
});
Mc(cX, e0, dX, hX, fX, mX, pX);
const Vc = {
  // borders
  border: {
    themeKey: "borders",
    transform: $n
  },
  borderTop: {
    themeKey: "borders",
    transform: $n
  },
  borderRight: {
    themeKey: "borders",
    transform: $n
  },
  borderBottom: {
    themeKey: "borders",
    transform: $n
  },
  borderLeft: {
    themeKey: "borders",
    transform: $n
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: $n
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Bc
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Qs
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Qs
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Qs
  },
  // spacing
  p: {
    style: _t
  },
  pt: {
    style: _t
  },
  pr: {
    style: _t
  },
  pb: {
    style: _t
  },
  pl: {
    style: _t
  },
  px: {
    style: _t
  },
  py: {
    style: _t
  },
  padding: {
    style: _t
  },
  paddingTop: {
    style: _t
  },
  paddingRight: {
    style: _t
  },
  paddingBottom: {
    style: _t
  },
  paddingLeft: {
    style: _t
  },
  paddingX: {
    style: _t
  },
  paddingY: {
    style: _t
  },
  paddingInline: {
    style: _t
  },
  paddingInlineStart: {
    style: _t
  },
  paddingInlineEnd: {
    style: _t
  },
  paddingBlock: {
    style: _t
  },
  paddingBlockStart: {
    style: _t
  },
  paddingBlockEnd: {
    style: _t
  },
  m: {
    style: bt
  },
  mt: {
    style: bt
  },
  mr: {
    style: bt
  },
  mb: {
    style: bt
  },
  ml: {
    style: bt
  },
  mx: {
    style: bt
  },
  my: {
    style: bt
  },
  margin: {
    style: bt
  },
  marginTop: {
    style: bt
  },
  marginRight: {
    style: bt
  },
  marginBottom: {
    style: bt
  },
  marginLeft: {
    style: bt
  },
  marginX: {
    style: bt
  },
  marginY: {
    style: bt
  },
  marginInline: {
    style: bt
  },
  marginInlineStart: {
    style: bt
  },
  marginInlineEnd: {
    style: bt
  },
  marginBlock: {
    style: bt
  },
  marginBlockStart: {
    style: bt
  },
  marginBlockEnd: {
    style: bt
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Fc
  },
  rowGap: {
    style: Hc
  },
  columnGap: {
    style: Uc
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: In
  },
  maxWidth: {
    style: e0
  },
  minWidth: {
    transform: In
  },
  height: {
    transform: In
  },
  maxHeight: {
    transform: In
  },
  minHeight: {
    transform: In
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function gX(...e) {
  const n = e.reduce((i, r) => i.concat(Object.keys(r)), []), t = new Set(n);
  return e.every((i) => t.size === Object.keys(i).length);
}
function bX(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function _X() {
  function e(t, i, r, s) {
    const o = {
      [t]: i,
      theme: r
    }, a = s[t];
    if (!a)
      return {
        [t]: i
      };
    const {
      cssProperty: u = t,
      themeKey: l,
      transform: c,
      style: d
    } = a;
    if (i == null)
      return null;
    if (l === "typography" && i === "inherit")
      return {
        [t]: i
      };
    const p = Rc(r, l) || {};
    return d ? d(o) : ji(o, i, (b) => {
      let _ = $l(p, c, b);
      return b === _ && typeof b == "string" && (_ = $l(p, c, `${t}${b === "default" ? "" : oC(b)}`, b)), u === !1 ? _ : {
        [u]: _
      };
    });
  }
  function n(t) {
    var i;
    const {
      sx: r,
      theme: s = {},
      nested: o
    } = t || {};
    if (!r)
      return null;
    const a = (i = s.unstable_sxConfig) != null ? i : Vc;
    function u(l) {
      let c = l;
      if (typeof l == "function")
        c = l(s);
      else if (typeof l != "object")
        return l;
      if (!c)
        return null;
      const d = OQ(s.breakpoints), p = Object.keys(d);
      let g = d;
      return Object.keys(c).forEach((b) => {
        const _ = bX(c[b], s);
        if (_ != null)
          if (typeof _ == "object")
            if (a[b])
              g = Ca(g, e(b, _, s, a));
            else {
              const k = ji({
                theme: s
              }, _, (C) => ({
                [b]: C
              }));
              gX(k, _) ? g[b] = n({
                sx: _,
                theme: s,
                nested: !0
              }) : g = Ca(g, k);
            }
          else
            g = Ca(g, e(b, _, s, a));
      }), !o && s.modularCssLayers ? {
        "@layer sx": f_(p, g)
      } : f_(p, g);
    }
    return Array.isArray(r) ? r.map(u) : u(r);
  }
  return n;
}
const $c = _X();
$c.filterProps = ["sx"];
function EX(e, n) {
  const t = this;
  return t.vars && typeof t.getColorSchemeSelector == "function" ? {
    [t.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: n
  } : t.palette.mode === e ? n : {};
}
const TX = ["breakpoints", "palette", "spacing", "shape"];
function lC(e = {}, ...n) {
  const {
    breakpoints: t = {},
    palette: i = {},
    spacing: r,
    shape: s = {}
  } = e, o = Pr(e, TX), a = vQ(t), u = UQ(r);
  let l = $i({
    breakpoints: a,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: ht({
      mode: "light"
    }, i),
    spacing: u,
    shape: ht({}, PQ, s)
  }, o);
  return l.applyStyles = EX, l = n.reduce((c, d) => $i(c, d), l), l.unstable_sxConfig = ht({}, Vc, o == null ? void 0 : o.unstable_sxConfig), l.unstable_sx = function(d) {
    return $c({
      sx: d,
      theme: this
    });
  }, l;
}
function yX(e) {
  return Object.keys(e).length === 0;
}
function wX(e = null) {
  const n = qt.useContext(nC);
  return !n || yX(n) ? e : n;
}
const AX = lC();
function CX(e = AX) {
  return wX(e);
}
const kX = ["sx"], SX = (e) => {
  var n, t;
  const i = {
    systemProps: {},
    otherProps: {}
  }, r = (n = e == null || (t = e.theme) == null ? void 0 : t.unstable_sxConfig) != null ? n : Vc;
  return Object.keys(e).forEach((s) => {
    r[s] ? i.systemProps[s] = e[s] : i.otherProps[s] = e[s];
  }), i;
};
function IX(e) {
  const {
    sx: n
  } = e, t = Pr(e, kX), {
    systemProps: i,
    otherProps: r
  } = SX(t);
  let s;
  return Array.isArray(n) ? s = [i, ...n] : typeof n == "function" ? s = (...o) => {
    const a = n(...o);
    return Yr(a) ? ht({}, i, a) : i;
  } : s = ht({}, i, n), ht({}, r, {
    sx: s
  });
}
const p_ = (e) => e, xX = () => {
  let e = p_;
  return {
    configure(n) {
      e = n;
    },
    generate(n) {
      return e(n);
    },
    reset() {
      e = p_;
    }
  };
}, cC = xX();
function dC(e) {
  var n, t, i = "";
  if (typeof e == "string" || typeof e == "number") i += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (n = 0; n < r; n++) e[n] && (t = dC(e[n])) && (i && (i += " "), i += t);
  } else for (t in e) e[t] && (i && (i += " "), i += t);
  return i;
}
function vX() {
  for (var e, n, t = 0, i = "", r = arguments.length; t < r; t++) (e = arguments[t]) && (n = dC(e)) && (i && (i += " "), i += n);
  return i;
}
const PX = ["className", "component"];
function OX(e = {}) {
  const {
    themeId: n,
    defaultTheme: t,
    defaultClassName: i = "MuiBox-root",
    generateClassName: r
  } = e, s = SQ("div", {
    shouldForwardProp: (a) => a !== "theme" && a !== "sx" && a !== "as"
  })($c);
  return /* @__PURE__ */ qt.forwardRef(function(u, l) {
    const c = CX(t), d = IX(u), {
      className: p,
      component: g = "div"
    } = d, b = Pr(d, PX);
    return /* @__PURE__ */ Qr.jsx(s, ht({
      as: g,
      ref: l,
      className: vX(p, r ? r(i) : i),
      theme: n && c[n] || c
    }, b));
  });
}
const NX = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function hC(e, n, t = "Mui") {
  const i = NX[n];
  return i ? `${t}-${i}` : `${cC.generate(e)}-${n}`;
}
function RX(e, n, t = "Mui") {
  const i = {};
  return n.forEach((r) => {
    i[r] = hC(e, r, t);
  }), i;
}
function LX(e, n = Number.MIN_SAFE_INTEGER, t = Number.MAX_SAFE_INTEGER) {
  return Math.max(n, Math.min(e, t));
}
const DX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: LX
}, Symbol.toStringTag, { value: "Module" }));
function MX(e, n) {
  return ht({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, n);
}
var kt = {}, fC = { exports: {} };
(function(e) {
  function n(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(fC);
var BX = fC.exports;
const FX = /* @__PURE__ */ R_(EG), UX = /* @__PURE__ */ R_(DX);
var mC = BX;
Object.defineProperty(kt, "__esModule", {
  value: !0
});
kt.alpha = _C;
kt.blend = XX;
kt.colorChannel = void 0;
var HX = kt.darken = n0;
kt.decomposeColor = Yn;
kt.emphasize = EC;
var g_ = kt.getContrastRatio = YX;
kt.getLuminance = Wl;
kt.hexToRgb = pC;
kt.hslToRgb = bC;
var VX = kt.lighten = i0;
kt.private_safeAlpha = jX;
kt.private_safeColorChannel = void 0;
kt.private_safeDarken = KX;
kt.private_safeEmphasize = QX;
kt.private_safeLighten = GX;
kt.recomposeColor = Co;
kt.rgbToHex = qX;
var b_ = mC(FX), $X = mC(UX);
function t0(e, n = 0, t = 1) {
  return process.env.NODE_ENV !== "production" && (e < n || e > t) && console.error(`MUI: The value provided ${e} is out of range [${n}, ${t}].`), (0, $X.default)(e, n, t);
}
function pC(e) {
  e = e.slice(1);
  const n = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let t = e.match(n);
  return t && t[0].length === 1 && (t = t.map((i) => i + i)), t ? `rgb${t.length === 4 ? "a" : ""}(${t.map((i, r) => r < 3 ? parseInt(i, 16) : Math.round(parseInt(i, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function WX(e) {
  const n = e.toString(16);
  return n.length === 1 ? `0${n}` : n;
}
function Yn(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Yn(pC(e));
  const n = e.indexOf("("), t = e.substring(0, n);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(t) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, b_.default)(9, e));
  let i = e.substring(n + 1, e.length - 1), r;
  if (t === "color") {
    if (i = i.split(" "), r = i.shift(), i.length === 4 && i[3].charAt(0) === "/" && (i[3] = i[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(r) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${r}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, b_.default)(10, r));
  } else
    i = i.split(",");
  return i = i.map((s) => parseFloat(s)), {
    type: t,
    values: i,
    colorSpace: r
  };
}
const gC = (e) => {
  const n = Yn(e);
  return n.values.slice(0, 3).map((t, i) => n.type.indexOf("hsl") !== -1 && i !== 0 ? `${t}%` : t).join(" ");
};
kt.colorChannel = gC;
const zX = (e, n) => {
  try {
    return gC(e);
  } catch {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
};
kt.private_safeColorChannel = zX;
function Co(e) {
  const {
    type: n,
    colorSpace: t
  } = e;
  let {
    values: i
  } = e;
  return n.indexOf("rgb") !== -1 ? i = i.map((r, s) => s < 3 ? parseInt(r, 10) : r) : n.indexOf("hsl") !== -1 && (i[1] = `${i[1]}%`, i[2] = `${i[2]}%`), n.indexOf("color") !== -1 ? i = `${t} ${i.join(" ")}` : i = `${i.join(", ")}`, `${n}(${i})`;
}
function qX(e) {
  if (e.indexOf("#") === 0)
    return e;
  const {
    values: n
  } = Yn(e);
  return `#${n.map((t, i) => WX(i === 3 ? Math.round(255 * t) : t)).join("")}`;
}
function bC(e) {
  e = Yn(e);
  const {
    values: n
  } = e, t = n[0], i = n[1] / 100, r = n[2] / 100, s = i * Math.min(r, 1 - r), o = (l, c = (l + t / 30) % 12) => r - s * Math.max(Math.min(c - 3, 9 - c, 1), -1);
  let a = "rgb";
  const u = [Math.round(o(0) * 255), Math.round(o(8) * 255), Math.round(o(4) * 255)];
  return e.type === "hsla" && (a += "a", u.push(n[3])), Co({
    type: a,
    values: u
  });
}
function Wl(e) {
  e = Yn(e);
  let n = e.type === "hsl" || e.type === "hsla" ? Yn(bC(e)).values : e.values;
  return n = n.map((t) => (e.type !== "color" && (t /= 255), t <= 0.03928 ? t / 12.92 : ((t + 0.055) / 1.055) ** 2.4)), Number((0.2126 * n[0] + 0.7152 * n[1] + 0.0722 * n[2]).toFixed(3));
}
function YX(e, n) {
  const t = Wl(e), i = Wl(n);
  return (Math.max(t, i) + 0.05) / (Math.min(t, i) + 0.05);
}
function _C(e, n) {
  return e = Yn(e), n = t0(n), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${n}` : e.values[3] = n, Co(e);
}
function jX(e, n, t) {
  try {
    return _C(e, n);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}
function n0(e, n) {
  if (e = Yn(e), n = t0(n), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - n;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let t = 0; t < 3; t += 1)
      e.values[t] *= 1 - n;
  return Co(e);
}
function KX(e, n, t) {
  try {
    return n0(e, n);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}
function i0(e, n) {
  if (e = Yn(e), n = t0(n), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * n;
  else if (e.type.indexOf("rgb") !== -1)
    for (let t = 0; t < 3; t += 1)
      e.values[t] += (255 - e.values[t]) * n;
  else if (e.type.indexOf("color") !== -1)
    for (let t = 0; t < 3; t += 1)
      e.values[t] += (1 - e.values[t]) * n;
  return Co(e);
}
function GX(e, n, t) {
  try {
    return i0(e, n);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}
function EC(e, n = 0.15) {
  return Wl(e) > 0.5 ? n0(e, n) : i0(e, n);
}
function QX(e, n, t) {
  try {
    return EC(e, n);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}
function XX(e, n, t, i = 1) {
  const r = (u, l) => Math.round((u ** (1 / i) * (1 - t) + l ** (1 / i) * t) ** i), s = Yn(e), o = Yn(n), a = [r(s.values[0], o.values[0]), r(s.values[1], o.values[1]), r(s.values[2], o.values[2])];
  return Co({
    type: "rgb",
    values: a
  });
}
const JX = ["mode", "contrastThreshold", "tonalOffset"], __ = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: ja.white,
    default: ja.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, lh = {
  text: {
    primary: ja.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: ja.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function E_(e, n, t, i) {
  const r = i.light || i, s = i.dark || i * 1.5;
  e[n] || (e.hasOwnProperty(t) ? e[n] = e[t] : n === "light" ? e.light = VX(e.main, r) : n === "dark" && (e.dark = HX(e.main, s)));
}
function ZX(e = "light") {
  return e === "dark" ? {
    main: Rs[200],
    light: Rs[50],
    dark: Rs[400]
  } : {
    main: Rs[700],
    light: Rs[400],
    dark: Rs[800]
  };
}
function eJ(e = "light") {
  return e === "dark" ? {
    main: Ns[200],
    light: Ns[50],
    dark: Ns[400]
  } : {
    main: Ns[500],
    light: Ns[300],
    dark: Ns[700]
  };
}
function tJ(e = "light") {
  return e === "dark" ? {
    main: Os[500],
    light: Os[300],
    dark: Os[700]
  } : {
    main: Os[700],
    light: Os[400],
    dark: Os[800]
  };
}
function nJ(e = "light") {
  return e === "dark" ? {
    main: Ls[400],
    light: Ls[300],
    dark: Ls[700]
  } : {
    main: Ls[700],
    light: Ls[500],
    dark: Ls[900]
  };
}
function iJ(e = "light") {
  return e === "dark" ? {
    main: Ds[400],
    light: Ds[300],
    dark: Ds[700]
  } : {
    main: Ds[800],
    light: Ds[500],
    dark: Ds[900]
  };
}
function rJ(e = "light") {
  return e === "dark" ? {
    main: Ko[400],
    light: Ko[300],
    dark: Ko[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Ko[500],
    dark: Ko[900]
  };
}
function sJ(e) {
  const {
    mode: n = "light",
    contrastThreshold: t = 3,
    tonalOffset: i = 0.2
  } = e, r = Pr(e, JX), s = e.primary || ZX(n), o = e.secondary || eJ(n), a = e.error || tJ(n), u = e.info || nJ(n), l = e.success || iJ(n), c = e.warning || rJ(n);
  function d(_) {
    const k = g_(_, lh.text.primary) >= t ? lh.text.primary : __.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const C = g_(_, k);
      C < 3 && console.error([`MUI: The contrast ratio of ${C}:1 for ${k} on ${_}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return k;
  }
  const p = ({
    color: _,
    name: k,
    mainShade: C = 500,
    lightShade: D = 300,
    darkShade: M = 700
  }) => {
    if (_ = ht({}, _), !_.main && _[C] && (_.main = _[C]), !_.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${k ? ` (${k})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${C}\` property.` : Ka(11, k ? ` (${k})` : "", C));
    if (typeof _.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${k ? ` (${k})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(_.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : Ka(12, k ? ` (${k})` : "", JSON.stringify(_.main)));
    return E_(_, "light", D, i), E_(_, "dark", M, i), _.contrastText || (_.contrastText = d(_.main)), _;
  }, g = {
    dark: lh,
    light: __
  };
  return process.env.NODE_ENV !== "production" && (g[n] || console.error(`MUI: The palette mode \`${n}\` is not supported.`)), $i(ht({
    // A collection of common colors.
    common: ht({}, ja),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: n,
    // The colors used to represent primary interface elements for a user.
    primary: p({
      color: s,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: p({
      color: o,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: p({
      color: a,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: p({
      color: c,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: p({
      color: u,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: p({
      color: l,
      name: "success"
    }),
    // The grey colors.
    grey: _G,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: t,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: d,
    // Generate a rich color object.
    augmentColor: p,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: i
  }, g[n]), r);
}
const oJ = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function aJ(e) {
  return Math.round(e * 1e5) / 1e5;
}
const T_ = {
  textTransform: "uppercase"
}, y_ = '"Roboto", "Helvetica", "Arial", sans-serif';
function uJ(e, n) {
  const t = typeof n == "function" ? n(e) : n, {
    fontFamily: i = y_,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: s = 300,
    fontWeightRegular: o = 400,
    fontWeightMedium: a = 500,
    fontWeightBold: u = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: l = 16,
    // Apply the CSS properties to all the variants.
    allVariants: c,
    pxToRem: d
  } = t, p = Pr(t, oJ);
  process.env.NODE_ENV !== "production" && (typeof r != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof l != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const g = r / 14, b = d || ((C) => `${C / l * g}rem`), _ = (C, D, M, j, F) => ht({
    fontFamily: i,
    fontWeight: C,
    fontSize: b(D),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: M
  }, i === y_ ? {
    letterSpacing: `${aJ(j / D)}em`
  } : {}, F, c), k = {
    h1: _(s, 96, 1.167, -1.5),
    h2: _(s, 60, 1.2, -0.5),
    h3: _(o, 48, 1.167, 0),
    h4: _(o, 34, 1.235, 0.25),
    h5: _(o, 24, 1.334, 0),
    h6: _(a, 20, 1.6, 0.15),
    subtitle1: _(o, 16, 1.75, 0.15),
    subtitle2: _(a, 14, 1.57, 0.1),
    body1: _(o, 16, 1.5, 0.15),
    body2: _(o, 14, 1.43, 0.15),
    button: _(a, 14, 1.75, 0.4, T_),
    caption: _(o, 12, 1.66, 0.4),
    overline: _(o, 12, 2.66, 1, T_),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return $i(ht({
    htmlFontSize: l,
    pxToRem: b,
    fontFamily: i,
    fontSize: r,
    fontWeightLight: s,
    fontWeightRegular: o,
    fontWeightMedium: a,
    fontWeightBold: u
  }, k), p, {
    clone: !1
    // No need to clone deep
  });
}
const lJ = 0.2, cJ = 0.14, dJ = 0.12;
function ut(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${lJ})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${cJ})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${dJ})`].join(",");
}
const hJ = ["none", ut(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), ut(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), ut(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), ut(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), ut(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), ut(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), ut(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), ut(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), ut(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), ut(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), ut(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), ut(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), ut(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), ut(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), ut(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), ut(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), ut(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), ut(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), ut(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), ut(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), ut(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), ut(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), ut(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), ut(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], fJ = ["duration", "easing", "delay"], mJ = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, pJ = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function w_(e) {
  return `${Math.round(e)}ms`;
}
function gJ(e) {
  if (!e)
    return 0;
  const n = e / 36;
  return Math.round((4 + 15 * n ** 0.25 + n / 5) * 10);
}
function bJ(e) {
  const n = ht({}, mJ, e.easing), t = ht({}, pJ, e.duration);
  return ht({
    getAutoHeightDuration: gJ,
    create: (r = ["all"], s = {}) => {
      const {
        duration: o = t.standard,
        easing: a = n.easeInOut,
        delay: u = 0
      } = s, l = Pr(s, fJ);
      if (process.env.NODE_ENV !== "production") {
        const c = (p) => typeof p == "string", d = (p) => !isNaN(parseFloat(p));
        !c(r) && !Array.isArray(r) && console.error('MUI: Argument "props" must be a string or Array.'), !d(o) && !c(o) && console.error(`MUI: Argument "duration" must be a number or a string but found ${o}.`), c(a) || console.error('MUI: Argument "easing" must be a string.'), !d(u) && !c(u) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof s != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(l).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(l).join(",")}].`);
      }
      return (Array.isArray(r) ? r : [r]).map((c) => `${c} ${typeof o == "string" ? o : w_(o)} ${a} ${typeof u == "string" ? u : w_(u)}`).join(",");
    }
  }, e, {
    easing: n,
    duration: t
  });
}
const _J = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, EJ = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function TJ(e = {}, ...n) {
  const {
    mixins: t = {},
    palette: i = {},
    transitions: r = {},
    typography: s = {}
  } = e, o = Pr(e, EJ);
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateCssVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : Ka(18));
  const a = sJ(i), u = lC(e);
  let l = $i(u, {
    mixins: MX(u.breakpoints, t),
    palette: a,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: hJ.slice(),
    typography: uJ(a, s),
    transitions: bJ(r),
    zIndex: ht({}, _J)
  });
  if (l = $i(l, o), l = n.reduce((c, d) => $i(c, d), l), process.env.NODE_ENV !== "production") {
    const c = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], d = (p, g) => {
      let b;
      for (b in p) {
        const _ = p[b];
        if (c.indexOf(b) !== -1 && Object.keys(_).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const k = hC("", b);
            console.error([`MUI: The \`${g}\` component increases the CSS specificity of the \`${b}\` internal state.`, "You can not override it like this: ", JSON.stringify(p, null, 2), "", `Instead, you need to use the '&.${k}' syntax:`, JSON.stringify({
              root: {
                [`&.${k}`]: _
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          p[b] = {};
        }
      }
    };
    Object.keys(l.components).forEach((p) => {
      const g = l.components[p].styleOverrides;
      g && p.indexOf("Mui") === 0 && d(g, p);
    });
  }
  return l.unstable_sxConfig = ht({}, Vc, o == null ? void 0 : o.unstable_sxConfig), l.unstable_sx = function(d) {
    return $c({
      sx: d,
      theme: this
    });
  }, l;
}
const yJ = RX("MuiBox", ["root"]), wJ = TJ(), TC = OX({
  themeId: TG,
  defaultTheme: wJ,
  defaultClassName: yJ.root,
  generateClassName: cC.generate
});
process.env.NODE_ENV !== "production" && (TC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: rn.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: rn.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: rn.oneOfType([rn.arrayOf(rn.oneOfType([rn.func, rn.object, rn.bool])), rn.func, rn.object])
});
const AJ = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, CJ = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, kJ = {};
function A_(e, n) {
  return (kJ.jsx ? CJ : AJ).test(e);
}
var r0 = {}, C_ = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, SJ = /\n/g, IJ = /^\s*/, xJ = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, vJ = /^:\s*/, PJ = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, OJ = /^[;\s]*/, NJ = /^\s+|\s+$/g, RJ = `
`, k_ = "/", S_ = "*", jr = "", LJ = "comment", DJ = "declaration", MJ = function(e, n) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  n = n || {};
  var t = 1, i = 1;
  function r(b) {
    var _ = b.match(SJ);
    _ && (t += _.length);
    var k = b.lastIndexOf(RJ);
    i = ~k ? b.length - k : i + b.length;
  }
  function s() {
    var b = { line: t, column: i };
    return function(_) {
      return _.position = new o(b), l(), _;
    };
  }
  function o(b) {
    this.start = b, this.end = { line: t, column: i }, this.source = n.source;
  }
  o.prototype.content = e;
  function a(b) {
    var _ = new Error(
      n.source + ":" + t + ":" + i + ": " + b
    );
    if (_.reason = b, _.filename = n.source, _.line = t, _.column = i, _.source = e, !n.silent) throw _;
  }
  function u(b) {
    var _ = b.exec(e);
    if (_) {
      var k = _[0];
      return r(k), e = e.slice(k.length), _;
    }
  }
  function l() {
    u(IJ);
  }
  function c(b) {
    var _;
    for (b = b || []; _ = d(); )
      _ !== !1 && b.push(_);
    return b;
  }
  function d() {
    var b = s();
    if (!(k_ != e.charAt(0) || S_ != e.charAt(1))) {
      for (var _ = 2; jr != e.charAt(_) && (S_ != e.charAt(_) || k_ != e.charAt(_ + 1)); )
        ++_;
      if (_ += 2, jr === e.charAt(_ - 1))
        return a("End of comment missing");
      var k = e.slice(2, _ - 2);
      return i += 2, r(k), e = e.slice(_), i += 2, b({
        type: LJ,
        comment: k
      });
    }
  }
  function p() {
    var b = s(), _ = u(xJ);
    if (_) {
      if (d(), !u(vJ)) return a("property missing ':'");
      var k = u(PJ), C = b({
        type: DJ,
        property: I_(_[0].replace(C_, jr)),
        value: k ? I_(k[0].replace(C_, jr)) : jr
      });
      return u(OJ), C;
    }
  }
  function g() {
    var b = [];
    c(b);
    for (var _; _ = p(); )
      _ !== !1 && (b.push(_), c(b));
    return b;
  }
  return l(), g();
};
function I_(e) {
  return e ? e.replace(NJ, jr) : jr;
}
var BJ = cl && cl.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(r0, "__esModule", { value: !0 });
r0.default = UJ;
var FJ = BJ(MJ);
function UJ(e, n) {
  var t = null;
  if (!e || typeof e != "string")
    return t;
  var i = (0, FJ.default)(e), r = typeof n == "function";
  return i.forEach(function(s) {
    if (s.type === "declaration") {
      var o = s.property, a = s.value;
      r ? n(o, a, s) : a && (t = t || {}, t[o] = a);
    }
  }), t;
}
var Wc = {};
Object.defineProperty(Wc, "__esModule", { value: !0 });
Wc.camelCase = void 0;
var HJ = /^--[a-zA-Z0-9_-]+$/, VJ = /-([a-z])/g, $J = /^[^-]+$/, WJ = /^-(webkit|moz|ms|o|khtml)-/, zJ = /^-(ms)-/, qJ = function(e) {
  return !e || $J.test(e) || HJ.test(e);
}, YJ = function(e, n) {
  return n.toUpperCase();
}, x_ = function(e, n) {
  return "".concat(n, "-");
}, jJ = function(e, n) {
  return n === void 0 && (n = {}), qJ(e) ? e : (e = e.toLowerCase(), n.reactCompat ? e = e.replace(zJ, x_) : e = e.replace(WJ, x_), e.replace(VJ, YJ));
};
Wc.camelCase = jJ;
var KJ = cl && cl.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
}, GJ = KJ(r0), QJ = Wc;
function Af(e, n) {
  var t = {};
  return !e || typeof e != "string" || (0, GJ.default)(e, function(i, r) {
    i && r && (t[(0, QJ.camelCase)(i, n)] = r);
  }), t;
}
Af.default = Af;
var XJ = Af;
const JJ = /* @__PURE__ */ kf(XJ), s0 = {}.hasOwnProperty, ZJ = /* @__PURE__ */ new Map(), eZ = /[A-Z]/g, tZ = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), nZ = /* @__PURE__ */ new Set(["td", "th"]), yC = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function iZ(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const t = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = dZ(t, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = cZ(t, n.jsx, n.jsxs);
  }
  const r = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: t,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? vr : du,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, s = wC(r, e, void 0);
  return s && typeof s != "string" ? s : r.create(
    e,
    r.Fragment,
    { children: s || void 0 },
    void 0
  );
}
function wC(e, n, t) {
  if (n.type === "element")
    return rZ(e, n, t);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return sZ(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return aZ(e, n, t);
  if (n.type === "mdxjsEsm")
    return oZ(e, n);
  if (n.type === "root")
    return uZ(e, n, t);
  if (n.type === "text")
    return lZ(e, n);
}
function rZ(e, n, t) {
  const i = e.schema;
  let r = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (r = vr, e.schema = r), e.ancestors.push(n);
  const s = CC(e, n.tagName, !1), o = hZ(e, n);
  let a = a0(e, n);
  return tZ.has(n.tagName) && (a = a.filter(function(u) {
    return typeof u == "string" ? !bo(u) : !0;
  })), AC(e, o, s, n), o0(o, a), e.ancestors.pop(), e.schema = i, e.create(n, s, o, t);
}
function sZ(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Ja(e, n.position);
}
function oZ(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Ja(e, n.position);
}
function aZ(e, n, t) {
  const i = e.schema;
  let r = i;
  n.name === "svg" && i.space === "html" && (r = vr, e.schema = r), e.ancestors.push(n);
  const s = n.name === null ? e.Fragment : CC(e, n.name, !0), o = fZ(e, n), a = a0(e, n);
  return AC(e, o, s, n), o0(o, a), e.ancestors.pop(), e.schema = i, e.create(n, s, o, t);
}
function uZ(e, n, t) {
  const i = {};
  return o0(i, a0(e, n)), e.create(n, e.Fragment, i, t);
}
function lZ(e, n) {
  return n.value;
}
function AC(e, n, t, i) {
  typeof t != "string" && t !== e.Fragment && e.passNode && (n.node = i);
}
function o0(e, n) {
  if (n.length > 0) {
    const t = n.length > 1 ? n : n[0];
    t && (e.children = t);
  }
}
function cZ(e, n, t) {
  return i;
  function i(r, s, o, a) {
    const l = Array.isArray(o.children) ? t : n;
    return a ? l(s, o, a) : l(s, o);
  }
}
function dZ(e, n) {
  return t;
  function t(i, r, s, o) {
    const a = Array.isArray(s.children), u = vi(i);
    return n(
      r,
      s,
      o,
      a,
      {
        columnNumber: u ? u.column - 1 : void 0,
        fileName: e,
        lineNumber: u ? u.line : void 0
      },
      void 0
    );
  }
}
function hZ(e, n) {
  const t = {};
  let i, r;
  for (r in n.properties)
    if (r !== "children" && s0.call(n.properties, r)) {
      const s = mZ(e, r, n.properties[r]);
      if (s) {
        const [o, a] = s;
        e.tableCellAlignToStyle && o === "align" && typeof a == "string" && nZ.has(n.tagName) ? i = a : t[o] = a;
      }
    }
  if (i) {
    const s = (
      /** @type {Style} */
      t.style || (t.style = {})
    );
    s[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return t;
}
function fZ(e, n) {
  const t = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const s = i.data.estree.body[0];
        s.type;
        const o = s.expression;
        o.type;
        const a = o.properties[0];
        a.type, Object.assign(
          t,
          e.evaluater.evaluateExpression(a.argument)
        );
      } else
        Ja(e, n.position);
    else {
      const r = i.name;
      let s;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const a = i.value.data.estree.body[0];
          a.type, s = e.evaluater.evaluateExpression(a.expression);
        } else
          Ja(e, n.position);
      else
        s = i.value === null ? !0 : i.value;
      t[r] = /** @type {Props[keyof Props]} */
      s;
    }
  return t;
}
function a0(e, n) {
  const t = [];
  let i = -1;
  const r = e.passKeys ? /* @__PURE__ */ new Map() : ZJ;
  for (; ++i < n.children.length; ) {
    const s = n.children[i];
    let o;
    if (e.passKeys) {
      const u = s.type === "element" ? s.tagName : s.type === "mdxJsxFlowElement" || s.type === "mdxJsxTextElement" ? s.name : void 0;
      if (u) {
        const l = r.get(u) || 0;
        o = u + "-" + l, r.set(u, l + 1);
      }
    }
    const a = wC(e, s, o);
    a !== void 0 && t.push(a);
  }
  return t;
}
function mZ(e, n, t) {
  const i = Tc(e.schema, n);
  if (!(t == null || typeof t == "number" && Number.isNaN(t))) {
    if (Array.isArray(t) && (t = i.commaSeparated ? Lm(t) : Dm(t)), i.property === "style") {
      let r = typeof t == "object" ? t : pZ(e, String(t));
      return e.stylePropertyNameCase === "css" && (r = gZ(r)), ["style", r];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? AV[i.property] || i.property : i.attribute,
      t
    ];
  }
}
function pZ(e, n) {
  try {
    return JJ(n, { reactCompat: !0 });
  } catch (t) {
    if (e.ignoreInvalidStyle)
      return {};
    const i = (
      /** @type {Error} */
      t
    ), r = new Yt("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: i,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw r.file = e.filePath || void 0, r.url = yC + "#cannot-parse-style-attribute", r;
  }
}
function CC(e, n, t) {
  let i;
  if (!t)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const r = n.split(".");
    let s = -1, o;
    for (; ++s < r.length; ) {
      const a = A_(r[s]) ? { type: "Identifier", name: r[s] } : { type: "Literal", value: r[s] };
      o = o ? {
        type: "MemberExpression",
        object: o,
        property: a,
        computed: !!(s && a.type === "Literal"),
        optional: !1
      } : a;
    }
    i = o;
  } else
    i = A_(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const r = (
      /** @type {string | number} */
      i.value
    );
    return s0.call(e.components, r) ? e.components[r] : r;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Ja(e);
}
function Ja(e, n) {
  const t = new Yt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw t.file = e.filePath || void 0, t.url = yC + "#cannot-handle-mdx-estrees-without-createevaluater", t;
}
function gZ(e) {
  const n = {};
  let t;
  for (t in e)
    s0.call(e, t) && (n[bZ(t)] = e[t]);
  return n;
}
function bZ(e) {
  let n = e.replace(eZ, _Z);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function _Z(e) {
  return "-" + e.toLowerCase();
}
const ch = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, EZ = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", v_ = [], P_ = { allowDangerousHtml: !0 }, TZ = /^(https?|ircs?|mailto|xmpp)$/i, yZ = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function wZ(e) {
  const n = AZ(e), t = CZ(e);
  return kZ(n.runSync(n.parse(t), t), e);
}
function AZ(e) {
  const n = e.rehypePlugins || v_, t = e.remarkPlugins || v_, i = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...P_ } : P_;
  return Qh().use(Lw).use(t).use(vw, i).use(n);
}
function CZ(e) {
  const n = e.children || "", t = new xl();
  return typeof n == "string" && (t.value = n), t;
}
function kZ(e, n) {
  const t = n.allowedElements, i = n.allowElement, r = n.components, s = n.disallowedElements, o = n.skipHtml, a = n.unwrapDisallowed, u = n.urlTransform || SZ;
  for (const c of yZ)
    Object.hasOwn(n, c.from) && ("" + c.from + (c.to ? "use `" + c.to + "` instead" : "remove it") + EZ + c.id, void 0);
  return n.className && (e = {
    type: "element",
    tagName: "div",
    properties: { className: n.className },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      e.type === "root" ? e.children : [e]
    )
  }), Cr(e, l), iZ(e, {
    Fragment: Qr.Fragment,
    // @ts-expect-error
    // React components are allowed to return numbers,
    // but not according to the types in hast-util-to-jsx-runtime
    components: r,
    ignoreInvalidStyle: !0,
    jsx: Qr.jsx,
    jsxs: Qr.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function l(c, d, p) {
    if (c.type === "raw" && p && typeof d == "number")
      return o ? p.children.splice(d, 1) : p.children[d] = { type: "text", value: c.value }, d;
    if (c.type === "element") {
      let g;
      for (g in ch)
        if (Object.hasOwn(ch, g) && Object.hasOwn(c.properties, g)) {
          const b = c.properties[g], _ = ch[g];
          (_ === null || _.includes(c.tagName)) && (c.properties[g] = u(String(b || ""), g, c));
        }
    }
    if (c.type === "element") {
      let g = t ? !t.includes(c.tagName) : s ? s.includes(c.tagName) : !1;
      if (!g && i && typeof d == "number" && (g = !i(c, d, p)), g && p && typeof d == "number")
        return a && c.children ? p.children.splice(d, 1, ...c.children) : p.children.splice(d, 1), d;
    }
  }
}
function SZ(e) {
  const n = e.indexOf(":"), t = e.indexOf("?"), i = e.indexOf("#"), r = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    r !== -1 && n > r || t !== -1 && n > t || i !== -1 && n > i || // It is a protocol, it should be allowed.
    TZ.test(e.slice(0, n)) ? e : ""
  );
}
const eee = (e) => {
  const { content: n } = e;
  return /* @__PURE__ */ Qr.jsx(TC, { className: "ck-content", sx: {
    "*:first-child": {
      marginTop: 0
    },
    "*:last-child": {
      marginBottom: 0
    },
    "li p:first-of-type": {
      marginBottom: 0
    }
  }, children: /* @__PURE__ */ Qr.jsx(
    wZ,
    {
      remarkPlugins: [tf],
      rehypePlugins: [
        OA,
        (t) => DA(MA)
      ],
      remarkRehypeOptions: {
        allowDangerousHtml: !0
      },
      children: n
    }
  ) });
};
export {
  Km as Editor,
  eee as RichContent,
  ZZ as RichEditor
};
